
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9ae9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9ae9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bDyTI", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $878e682ed7cb37be$export$ffb0004e005737fa, (v) => $878e682ed7cb37be$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $878e682ed7cb37be$export$34b9dba7ce09269b, (v) => $878e682ed7cb37be$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $878e682ed7cb37be$export$25062201e9e25d76, (v) => $878e682ed7cb37be$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $878e682ed7cb37be$export$ffb0004e005737fa;
var $878e682ed7cb37be$export$34b9dba7ce09269b;
var $878e682ed7cb37be$export$25062201e9e25d76;
'use strict';
parcelRequire("gZVC5");

var $3OyDL = parcelRequire("3OyDL");
var $878e682ed7cb37be$var$g = 60103;
$878e682ed7cb37be$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $878e682ed7cb37be$var$h = Symbol.for;
    $878e682ed7cb37be$var$g = $878e682ed7cb37be$var$h("react.element");
    $878e682ed7cb37be$export$ffb0004e005737fa = $878e682ed7cb37be$var$h("react.fragment");
}
var $878e682ed7cb37be$var$m = $3OyDL.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $878e682ed7cb37be$var$n = Object.prototype.hasOwnProperty, $878e682ed7cb37be$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $878e682ed7cb37be$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$878e682ed7cb37be$var$n.call(a, b) && !$878e682ed7cb37be$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $878e682ed7cb37be$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $878e682ed7cb37be$var$m.current
    };
}
$878e682ed7cb37be$export$34b9dba7ce09269b = $878e682ed7cb37be$var$q;
$878e682ed7cb37be$export$25062201e9e25d76 = $878e682ed7cb37be$var$q;

});
parcelRegister("gZVC5", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $c5ff08a1ec962aba$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c5ff08a1ec962aba$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $c5ff08a1ec962aba$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $c5ff08a1ec962aba$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $c5ff08a1ec962aba$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $c5ff08a1ec962aba$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $c5ff08a1ec962aba$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($c5ff08a1ec962aba$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($c5ff08a1ec962aba$var$getOwnPropertySymbols) {
            symbols = $c5ff08a1ec962aba$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($c5ff08a1ec962aba$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("3OyDL", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7TFsZ"));

});
parcelRegister("7TFsZ", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5bfdd5d7b2c0ffb9$export$ffb0004e005737fa, (v) => $5bfdd5d7b2c0ffb9$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $5bfdd5d7b2c0ffb9$export$5f8d39834fd61797, (v) => $5bfdd5d7b2c0ffb9$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $5bfdd5d7b2c0ffb9$export$e2c29f18771995cb, (v) => $5bfdd5d7b2c0ffb9$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $5bfdd5d7b2c0ffb9$export$74bf444e3cd11ea5, (v) => $5bfdd5d7b2c0ffb9$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $5bfdd5d7b2c0ffb9$export$dca3b0875bd9a954, (v) => $5bfdd5d7b2c0ffb9$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $5bfdd5d7b2c0ffb9$export$16fa2f45be04daa8, (v) => $5bfdd5d7b2c0ffb9$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $5bfdd5d7b2c0ffb9$export$221d75b3f55bb0bd, (v) => $5bfdd5d7b2c0ffb9$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $5bfdd5d7b2c0ffb9$export$ae55be85d98224ed, (v) => $5bfdd5d7b2c0ffb9$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $5bfdd5d7b2c0ffb9$export$e530037191fcd5d7, (v) => $5bfdd5d7b2c0ffb9$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $5bfdd5d7b2c0ffb9$export$fd42f52fd3ae1109, (v) => $5bfdd5d7b2c0ffb9$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $5bfdd5d7b2c0ffb9$export$c8a8987d4410bf2d, (v) => $5bfdd5d7b2c0ffb9$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $5bfdd5d7b2c0ffb9$export$d38cd72104c1f0e9, (v) => $5bfdd5d7b2c0ffb9$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $5bfdd5d7b2c0ffb9$export$7d1e3a5e95ceca43, (v) => $5bfdd5d7b2c0ffb9$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $5bfdd5d7b2c0ffb9$export$257a8862b851cb5b, (v) => $5bfdd5d7b2c0ffb9$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $5bfdd5d7b2c0ffb9$export$a8257692ac88316c, (v) => $5bfdd5d7b2c0ffb9$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $5bfdd5d7b2c0ffb9$export$488013bae63b21da, (v) => $5bfdd5d7b2c0ffb9$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $5bfdd5d7b2c0ffb9$export$7c73462e0d25e514, (v) => $5bfdd5d7b2c0ffb9$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $5bfdd5d7b2c0ffb9$export$35808ee640e87ca7, (v) => $5bfdd5d7b2c0ffb9$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $5bfdd5d7b2c0ffb9$export$fae74005e78b1a27, (v) => $5bfdd5d7b2c0ffb9$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $5bfdd5d7b2c0ffb9$export$dc8fbce3eb94dc1e, (v) => $5bfdd5d7b2c0ffb9$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $5bfdd5d7b2c0ffb9$export$6d9c69b0de29b591, (v) => $5bfdd5d7b2c0ffb9$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $5bfdd5d7b2c0ffb9$export$d5a552a76deda3c2, (v) => $5bfdd5d7b2c0ffb9$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $5bfdd5d7b2c0ffb9$export$e5c5a5f917a5871c, (v) => $5bfdd5d7b2c0ffb9$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $5bfdd5d7b2c0ffb9$export$1538c33de8887b59, (v) => $5bfdd5d7b2c0ffb9$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $5bfdd5d7b2c0ffb9$export$13e3392192263954, (v) => $5bfdd5d7b2c0ffb9$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $5bfdd5d7b2c0ffb9$export$b8f5890fc79d6aca, (v) => $5bfdd5d7b2c0ffb9$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $5bfdd5d7b2c0ffb9$export$60241385465d0a34, (v) => $5bfdd5d7b2c0ffb9$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $5bfdd5d7b2c0ffb9$export$83d89fbfd8236492, (v) => $5bfdd5d7b2c0ffb9$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5bfdd5d7b2c0ffb9$export$ffb0004e005737fa;
var $5bfdd5d7b2c0ffb9$export$5f8d39834fd61797;
var $5bfdd5d7b2c0ffb9$export$e2c29f18771995cb;
var $5bfdd5d7b2c0ffb9$export$74bf444e3cd11ea5;
var $5bfdd5d7b2c0ffb9$export$dca3b0875bd9a954;
var $5bfdd5d7b2c0ffb9$export$16fa2f45be04daa8;
var $5bfdd5d7b2c0ffb9$export$221d75b3f55bb0bd;
var $5bfdd5d7b2c0ffb9$export$ae55be85d98224ed;
var $5bfdd5d7b2c0ffb9$export$e530037191fcd5d7;
var $5bfdd5d7b2c0ffb9$export$fd42f52fd3ae1109;
var $5bfdd5d7b2c0ffb9$export$c8a8987d4410bf2d;
var $5bfdd5d7b2c0ffb9$export$d38cd72104c1f0e9;
var $5bfdd5d7b2c0ffb9$export$7d1e3a5e95ceca43;
var $5bfdd5d7b2c0ffb9$export$257a8862b851cb5b;
var $5bfdd5d7b2c0ffb9$export$a8257692ac88316c;
var $5bfdd5d7b2c0ffb9$export$488013bae63b21da;
var $5bfdd5d7b2c0ffb9$export$7c73462e0d25e514;
var $5bfdd5d7b2c0ffb9$export$35808ee640e87ca7;
var $5bfdd5d7b2c0ffb9$export$fae74005e78b1a27;
var $5bfdd5d7b2c0ffb9$export$dc8fbce3eb94dc1e;
var $5bfdd5d7b2c0ffb9$export$6d9c69b0de29b591;
var $5bfdd5d7b2c0ffb9$export$d5a552a76deda3c2;
var $5bfdd5d7b2c0ffb9$export$e5c5a5f917a5871c;
var $5bfdd5d7b2c0ffb9$export$1538c33de8887b59;
var $5bfdd5d7b2c0ffb9$export$13e3392192263954;
var $5bfdd5d7b2c0ffb9$export$b8f5890fc79d6aca;
var $5bfdd5d7b2c0ffb9$export$60241385465d0a34;
var $5bfdd5d7b2c0ffb9$export$83d89fbfd8236492;
'use strict';

var $gZVC5 = parcelRequire("gZVC5");
var $5bfdd5d7b2c0ffb9$var$n = 60103, $5bfdd5d7b2c0ffb9$var$p = 60106;
$5bfdd5d7b2c0ffb9$export$ffb0004e005737fa = 60107;
$5bfdd5d7b2c0ffb9$export$5f8d39834fd61797 = 60108;
$5bfdd5d7b2c0ffb9$export$e2c29f18771995cb = 60114;
var $5bfdd5d7b2c0ffb9$var$q = 60109, $5bfdd5d7b2c0ffb9$var$r = 60110, $5bfdd5d7b2c0ffb9$var$t = 60112;
$5bfdd5d7b2c0ffb9$export$74bf444e3cd11ea5 = 60113;
var $5bfdd5d7b2c0ffb9$var$u = 60115, $5bfdd5d7b2c0ffb9$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $5bfdd5d7b2c0ffb9$var$w = Symbol.for;
    $5bfdd5d7b2c0ffb9$var$n = $5bfdd5d7b2c0ffb9$var$w("react.element");
    $5bfdd5d7b2c0ffb9$var$p = $5bfdd5d7b2c0ffb9$var$w("react.portal");
    $5bfdd5d7b2c0ffb9$export$ffb0004e005737fa = $5bfdd5d7b2c0ffb9$var$w("react.fragment");
    $5bfdd5d7b2c0ffb9$export$5f8d39834fd61797 = $5bfdd5d7b2c0ffb9$var$w("react.strict_mode");
    $5bfdd5d7b2c0ffb9$export$e2c29f18771995cb = $5bfdd5d7b2c0ffb9$var$w("react.profiler");
    $5bfdd5d7b2c0ffb9$var$q = $5bfdd5d7b2c0ffb9$var$w("react.provider");
    $5bfdd5d7b2c0ffb9$var$r = $5bfdd5d7b2c0ffb9$var$w("react.context");
    $5bfdd5d7b2c0ffb9$var$t = $5bfdd5d7b2c0ffb9$var$w("react.forward_ref");
    $5bfdd5d7b2c0ffb9$export$74bf444e3cd11ea5 = $5bfdd5d7b2c0ffb9$var$w("react.suspense");
    $5bfdd5d7b2c0ffb9$var$u = $5bfdd5d7b2c0ffb9$var$w("react.memo");
    $5bfdd5d7b2c0ffb9$var$v = $5bfdd5d7b2c0ffb9$var$w("react.lazy");
}
var $5bfdd5d7b2c0ffb9$var$x = "function" === typeof Symbol && Symbol.iterator;
function $5bfdd5d7b2c0ffb9$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5bfdd5d7b2c0ffb9$var$x && a[$5bfdd5d7b2c0ffb9$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $5bfdd5d7b2c0ffb9$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $5bfdd5d7b2c0ffb9$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $5bfdd5d7b2c0ffb9$var$B = {};
function $5bfdd5d7b2c0ffb9$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $5bfdd5d7b2c0ffb9$var$B;
    this.updater = c || $5bfdd5d7b2c0ffb9$var$A;
}
$5bfdd5d7b2c0ffb9$var$C.prototype.isReactComponent = {};
$5bfdd5d7b2c0ffb9$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($5bfdd5d7b2c0ffb9$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$5bfdd5d7b2c0ffb9$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $5bfdd5d7b2c0ffb9$var$D() {}
$5bfdd5d7b2c0ffb9$var$D.prototype = $5bfdd5d7b2c0ffb9$var$C.prototype;
function $5bfdd5d7b2c0ffb9$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $5bfdd5d7b2c0ffb9$var$B;
    this.updater = c || $5bfdd5d7b2c0ffb9$var$A;
}
var $5bfdd5d7b2c0ffb9$var$F = $5bfdd5d7b2c0ffb9$var$E.prototype = new $5bfdd5d7b2c0ffb9$var$D;
$5bfdd5d7b2c0ffb9$var$F.constructor = $5bfdd5d7b2c0ffb9$var$E;
$gZVC5($5bfdd5d7b2c0ffb9$var$F, $5bfdd5d7b2c0ffb9$var$C.prototype);
$5bfdd5d7b2c0ffb9$var$F.isPureReactComponent = !0;
var $5bfdd5d7b2c0ffb9$var$G = {
    current: null
}, $5bfdd5d7b2c0ffb9$var$H = Object.prototype.hasOwnProperty, $5bfdd5d7b2c0ffb9$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5bfdd5d7b2c0ffb9$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$5bfdd5d7b2c0ffb9$var$H.call(b, e) && !$5bfdd5d7b2c0ffb9$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $5bfdd5d7b2c0ffb9$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $5bfdd5d7b2c0ffb9$var$G.current
    };
}
function $5bfdd5d7b2c0ffb9$var$K(a, b) {
    return {
        $$typeof: $5bfdd5d7b2c0ffb9$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $5bfdd5d7b2c0ffb9$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $5bfdd5d7b2c0ffb9$var$n;
}
function $5bfdd5d7b2c0ffb9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $5bfdd5d7b2c0ffb9$var$M = /\/+/g;
function $5bfdd5d7b2c0ffb9$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $5bfdd5d7b2c0ffb9$var$escape("" + a.key) : b.toString(36);
}
function $5bfdd5d7b2c0ffb9$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $5bfdd5d7b2c0ffb9$var$n:
                case $5bfdd5d7b2c0ffb9$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $5bfdd5d7b2c0ffb9$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($5bfdd5d7b2c0ffb9$var$M, "$&/") + "/"), $5bfdd5d7b2c0ffb9$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($5bfdd5d7b2c0ffb9$var$L(d) && (d = $5bfdd5d7b2c0ffb9$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($5bfdd5d7b2c0ffb9$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $5bfdd5d7b2c0ffb9$var$N(k, g);
        h += $5bfdd5d7b2c0ffb9$var$O(k, b, c, f, d);
    }
    else if (f = $5bfdd5d7b2c0ffb9$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $5bfdd5d7b2c0ffb9$var$N(k, g++), h += $5bfdd5d7b2c0ffb9$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($5bfdd5d7b2c0ffb9$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $5bfdd5d7b2c0ffb9$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $5bfdd5d7b2c0ffb9$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $5bfdd5d7b2c0ffb9$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $5bfdd5d7b2c0ffb9$var$R = {
    current: null
};
function $5bfdd5d7b2c0ffb9$var$S() {
    var a = $5bfdd5d7b2c0ffb9$var$R.current;
    if (null === a) throw Error($5bfdd5d7b2c0ffb9$var$z(321));
    return a;
}
var $5bfdd5d7b2c0ffb9$var$T = {
    ReactCurrentDispatcher: $5bfdd5d7b2c0ffb9$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $5bfdd5d7b2c0ffb9$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $gZVC5
};
$5bfdd5d7b2c0ffb9$export$dca3b0875bd9a954 = {
    map: $5bfdd5d7b2c0ffb9$var$P,
    forEach: function(a, b, c) {
        $5bfdd5d7b2c0ffb9$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $5bfdd5d7b2c0ffb9$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $5bfdd5d7b2c0ffb9$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$5bfdd5d7b2c0ffb9$var$L(a)) throw Error($5bfdd5d7b2c0ffb9$var$z(143));
        return a;
    }
};
$5bfdd5d7b2c0ffb9$export$16fa2f45be04daa8 = $5bfdd5d7b2c0ffb9$var$C;
$5bfdd5d7b2c0ffb9$export$221d75b3f55bb0bd = $5bfdd5d7b2c0ffb9$var$E;
$5bfdd5d7b2c0ffb9$export$ae55be85d98224ed = $5bfdd5d7b2c0ffb9$var$T;
$5bfdd5d7b2c0ffb9$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($5bfdd5d7b2c0ffb9$var$z(267, a));
    var e = $gZVC5({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $5bfdd5d7b2c0ffb9$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$5bfdd5d7b2c0ffb9$var$H.call(b, f) && !$5bfdd5d7b2c0ffb9$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $5bfdd5d7b2c0ffb9$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$5bfdd5d7b2c0ffb9$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $5bfdd5d7b2c0ffb9$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $5bfdd5d7b2c0ffb9$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$5bfdd5d7b2c0ffb9$export$c8a8987d4410bf2d = $5bfdd5d7b2c0ffb9$var$J;
$5bfdd5d7b2c0ffb9$export$d38cd72104c1f0e9 = function(a) {
    var b = $5bfdd5d7b2c0ffb9$var$J.bind(null, a);
    b.type = a;
    return b;
};
$5bfdd5d7b2c0ffb9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$5bfdd5d7b2c0ffb9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $5bfdd5d7b2c0ffb9$var$t,
        render: a
    };
};
$5bfdd5d7b2c0ffb9$export$a8257692ac88316c = $5bfdd5d7b2c0ffb9$var$L;
$5bfdd5d7b2c0ffb9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $5bfdd5d7b2c0ffb9$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $5bfdd5d7b2c0ffb9$var$Q
    };
};
$5bfdd5d7b2c0ffb9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $5bfdd5d7b2c0ffb9$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$5bfdd5d7b2c0ffb9$export$35808ee640e87ca7 = function(a, b) {
    return $5bfdd5d7b2c0ffb9$var$S().useCallback(a, b);
};
$5bfdd5d7b2c0ffb9$export$fae74005e78b1a27 = function(a, b) {
    return $5bfdd5d7b2c0ffb9$var$S().useContext(a, b);
};
$5bfdd5d7b2c0ffb9$export$dc8fbce3eb94dc1e = function() {};
$5bfdd5d7b2c0ffb9$export$6d9c69b0de29b591 = function(a, b) {
    return $5bfdd5d7b2c0ffb9$var$S().useEffect(a, b);
};
$5bfdd5d7b2c0ffb9$export$d5a552a76deda3c2 = function(a, b, c) {
    return $5bfdd5d7b2c0ffb9$var$S().useImperativeHandle(a, b, c);
};
$5bfdd5d7b2c0ffb9$export$e5c5a5f917a5871c = function(a, b) {
    return $5bfdd5d7b2c0ffb9$var$S().useLayoutEffect(a, b);
};
$5bfdd5d7b2c0ffb9$export$1538c33de8887b59 = function(a, b) {
    return $5bfdd5d7b2c0ffb9$var$S().useMemo(a, b);
};
$5bfdd5d7b2c0ffb9$export$13e3392192263954 = function(a, b, c) {
    return $5bfdd5d7b2c0ffb9$var$S().useReducer(a, b, c);
};
$5bfdd5d7b2c0ffb9$export$b8f5890fc79d6aca = function(a) {
    return $5bfdd5d7b2c0ffb9$var$S().useRef(a);
};
$5bfdd5d7b2c0ffb9$export$60241385465d0a34 = function(a) {
    return $5bfdd5d7b2c0ffb9$var$S().useState(a);
};
$5bfdd5d7b2c0ffb9$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("dy6Cj", function(module, exports) {
'use strict';
function $9dd39554da419af9$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9dd39554da419af9$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9dd39554da419af9$var$checkDCE();

module.exports = (parcelRequire("4b4Zm"));

});
parcelRegister("4b4Zm", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $3OyDL = parcelRequire("3OyDL");

var $gZVC5 = parcelRequire("gZVC5");

var $jztx6 = parcelRequire("jztx6");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$3OyDL) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $3OyDL.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $gZVC5({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $3OyDL.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $gZVC5({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $gZVC5({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $gZVC5({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $jztx6.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $jztx6.unstable_scheduleCallback($jztx6.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $jztx6.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $jztx6.unstable_UserBlockingPriority, ed = $jztx6.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $gZVC5(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $gZVC5({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $gZVC5({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $gZVC5({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $gZVC5({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $gZVC5({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $gZVC5({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $gZVC5({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $gZVC5({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $gZVC5({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $gZVC5({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $gZVC5({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $gZVC5({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $gZVC5({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $jztx6.unstable_runWithPriority, Of = $jztx6.unstable_scheduleCallback, Pf = $jztx6.unstable_cancelCallback, Qf = $jztx6.unstable_shouldYield, Rf = $jztx6.unstable_requestPaint, Sf = $jztx6.unstable_now, Tf = $jztx6.unstable_getCurrentPriorityLevel, Uf = $jztx6.unstable_ImmediatePriority, Vf = $jztx6.unstable_UserBlockingPriority, Wf = $jztx6.unstable_NormalPriority, Xf = $jztx6.unstable_LowPriority, Yf = $jztx6.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $gZVC5({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $gZVC5({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $3OyDL.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $gZVC5({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $gZVC5({}, e, {
                    value: void 0
                });
                d = $gZVC5({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $gZVC5({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("jztx6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4ovD4"));

});
parcelRegister("4ovD4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3331f036e4c5fdb5$export$c4744153514ff05d, (v) => $3331f036e4c5fdb5$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3331f036e4c5fdb5$export$b5836b71941fa3ed, (v) => $3331f036e4c5fdb5$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3331f036e4c5fdb5$export$d66a1c1c77bd778b, (v) => $3331f036e4c5fdb5$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3331f036e4c5fdb5$export$3e506c1ccc9cc1a7, (v) => $3331f036e4c5fdb5$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3331f036e4c5fdb5$export$e26fe2ed2fa76875, (v) => $3331f036e4c5fdb5$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3331f036e4c5fdb5$export$502329bbf4b505b1, (v) => $3331f036e4c5fdb5$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3331f036e4c5fdb5$export$6e3807111c4874c4, (v) => $3331f036e4c5fdb5$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3331f036e4c5fdb5$export$c27134553091fb3a, (v) => $3331f036e4c5fdb5$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3331f036e4c5fdb5$export$33ee1acdc04fd2a2, (v) => $3331f036e4c5fdb5$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3331f036e4c5fdb5$export$b00a404bbd5edef2, (v) => $3331f036e4c5fdb5$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3331f036e4c5fdb5$export$8352ce38b91d0c62, (v) => $3331f036e4c5fdb5$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3331f036e4c5fdb5$export$d3dfb8e4810cb555, (v) => $3331f036e4c5fdb5$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3331f036e4c5fdb5$export$839f9183b0465a69, (v) => $3331f036e4c5fdb5$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3331f036e4c5fdb5$export$72fdf0e06517287b, (v) => $3331f036e4c5fdb5$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3331f036e4c5fdb5$export$4b844e58a3e414b4, (v) => $3331f036e4c5fdb5$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3331f036e4c5fdb5$export$816d2913ae6b83b1, (v) => $3331f036e4c5fdb5$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3331f036e4c5fdb5$export$61bcfe829111a1d0, (v) => $3331f036e4c5fdb5$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3331f036e4c5fdb5$export$7ee8c9beb337bc3f, (v) => $3331f036e4c5fdb5$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3331f036e4c5fdb5$export$cf845f2c119da08a, (v) => $3331f036e4c5fdb5$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3331f036e4c5fdb5$export$c4744153514ff05d;
var $3331f036e4c5fdb5$export$b5836b71941fa3ed;
var $3331f036e4c5fdb5$export$d66a1c1c77bd778b;
var $3331f036e4c5fdb5$export$3e506c1ccc9cc1a7;
var $3331f036e4c5fdb5$export$e26fe2ed2fa76875;
var $3331f036e4c5fdb5$export$502329bbf4b505b1;
var $3331f036e4c5fdb5$export$6e3807111c4874c4;
var $3331f036e4c5fdb5$export$c27134553091fb3a;
var $3331f036e4c5fdb5$export$33ee1acdc04fd2a2;
var $3331f036e4c5fdb5$export$b00a404bbd5edef2;
var $3331f036e4c5fdb5$export$8352ce38b91d0c62;
var $3331f036e4c5fdb5$export$d3dfb8e4810cb555;
var $3331f036e4c5fdb5$export$839f9183b0465a69;
var $3331f036e4c5fdb5$export$72fdf0e06517287b;
var $3331f036e4c5fdb5$export$4b844e58a3e414b4;
var $3331f036e4c5fdb5$export$816d2913ae6b83b1;
var $3331f036e4c5fdb5$export$61bcfe829111a1d0;
var $3331f036e4c5fdb5$export$7ee8c9beb337bc3f;
var $3331f036e4c5fdb5$export$cf845f2c119da08a;
'use strict';
var $3331f036e4c5fdb5$var$f, $3331f036e4c5fdb5$var$g, $3331f036e4c5fdb5$var$h, $3331f036e4c5fdb5$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3331f036e4c5fdb5$var$l = performance;
    $3331f036e4c5fdb5$export$c4744153514ff05d = function() {
        return $3331f036e4c5fdb5$var$l.now();
    };
} else {
    var $3331f036e4c5fdb5$var$p = Date, $3331f036e4c5fdb5$var$q = $3331f036e4c5fdb5$var$p.now();
    $3331f036e4c5fdb5$export$c4744153514ff05d = function() {
        return $3331f036e4c5fdb5$var$p.now() - $3331f036e4c5fdb5$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $3331f036e4c5fdb5$var$t = null, $3331f036e4c5fdb5$var$u = null, $3331f036e4c5fdb5$var$w = function() {
        if (null !== $3331f036e4c5fdb5$var$t) try {
            var a = $3331f036e4c5fdb5$export$c4744153514ff05d();
            $3331f036e4c5fdb5$var$t(!0, a);
            $3331f036e4c5fdb5$var$t = null;
        } catch (b) {
            throw setTimeout($3331f036e4c5fdb5$var$w, 0), b;
        }
    };
    $3331f036e4c5fdb5$var$f = function(a) {
        null !== $3331f036e4c5fdb5$var$t ? setTimeout($3331f036e4c5fdb5$var$f, 0, a) : ($3331f036e4c5fdb5$var$t = a, setTimeout($3331f036e4c5fdb5$var$w, 0));
    };
    $3331f036e4c5fdb5$var$g = function(a, b) {
        $3331f036e4c5fdb5$var$u = setTimeout(a, b);
    };
    $3331f036e4c5fdb5$var$h = function() {
        clearTimeout($3331f036e4c5fdb5$var$u);
    };
    $3331f036e4c5fdb5$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $3331f036e4c5fdb5$var$k = $3331f036e4c5fdb5$export$d66a1c1c77bd778b = function() {};
} else {
    var $3331f036e4c5fdb5$var$x = window.setTimeout, $3331f036e4c5fdb5$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $3331f036e4c5fdb5$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $3331f036e4c5fdb5$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $3331f036e4c5fdb5$var$A = !1, $3331f036e4c5fdb5$var$B = null, $3331f036e4c5fdb5$var$C = -1, $3331f036e4c5fdb5$var$D = 5, $3331f036e4c5fdb5$var$E = 0;
    $3331f036e4c5fdb5$export$b5836b71941fa3ed = function() {
        return $3331f036e4c5fdb5$export$c4744153514ff05d() >= $3331f036e4c5fdb5$var$E;
    };
    $3331f036e4c5fdb5$var$k = function() {};
    $3331f036e4c5fdb5$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3331f036e4c5fdb5$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $3331f036e4c5fdb5$var$F = new MessageChannel, $3331f036e4c5fdb5$var$G = $3331f036e4c5fdb5$var$F.port2;
    $3331f036e4c5fdb5$var$F.port1.onmessage = function() {
        if (null !== $3331f036e4c5fdb5$var$B) {
            var a = $3331f036e4c5fdb5$export$c4744153514ff05d();
            $3331f036e4c5fdb5$var$E = a + $3331f036e4c5fdb5$var$D;
            try {
                $3331f036e4c5fdb5$var$B(!0, a) ? $3331f036e4c5fdb5$var$G.postMessage(null) : ($3331f036e4c5fdb5$var$A = !1, $3331f036e4c5fdb5$var$B = null);
            } catch (b) {
                throw $3331f036e4c5fdb5$var$G.postMessage(null), b;
            }
        } else $3331f036e4c5fdb5$var$A = !1;
    };
    $3331f036e4c5fdb5$var$f = function(a) {
        $3331f036e4c5fdb5$var$B = a;
        $3331f036e4c5fdb5$var$A || ($3331f036e4c5fdb5$var$A = !0, $3331f036e4c5fdb5$var$G.postMessage(null));
    };
    $3331f036e4c5fdb5$var$g = function(a, b) {
        $3331f036e4c5fdb5$var$C = $3331f036e4c5fdb5$var$x(function() {
            a($3331f036e4c5fdb5$export$c4744153514ff05d());
        }, b);
    };
    $3331f036e4c5fdb5$var$h = function() {
        $3331f036e4c5fdb5$var$y($3331f036e4c5fdb5$var$C);
        $3331f036e4c5fdb5$var$C = -1;
    };
}
function $3331f036e4c5fdb5$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $3331f036e4c5fdb5$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3331f036e4c5fdb5$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $3331f036e4c5fdb5$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $3331f036e4c5fdb5$var$I(n, c)) void 0 !== r && 0 > $3331f036e4c5fdb5$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $3331f036e4c5fdb5$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $3331f036e4c5fdb5$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $3331f036e4c5fdb5$var$L = [], $3331f036e4c5fdb5$var$M = [], $3331f036e4c5fdb5$var$N = 1, $3331f036e4c5fdb5$var$O = null, $3331f036e4c5fdb5$var$P = 3, $3331f036e4c5fdb5$var$Q = !1, $3331f036e4c5fdb5$var$R = !1, $3331f036e4c5fdb5$var$S = !1;
function $3331f036e4c5fdb5$var$T(a) {
    for(var b = $3331f036e4c5fdb5$var$J($3331f036e4c5fdb5$var$M); null !== b;){
        if (null === b.callback) $3331f036e4c5fdb5$var$K($3331f036e4c5fdb5$var$M);
        else if (b.startTime <= a) $3331f036e4c5fdb5$var$K($3331f036e4c5fdb5$var$M), b.sortIndex = b.expirationTime, $3331f036e4c5fdb5$var$H($3331f036e4c5fdb5$var$L, b);
        else break;
        b = $3331f036e4c5fdb5$var$J($3331f036e4c5fdb5$var$M);
    }
}
function $3331f036e4c5fdb5$var$U(a) {
    $3331f036e4c5fdb5$var$S = !1;
    $3331f036e4c5fdb5$var$T(a);
    if (!$3331f036e4c5fdb5$var$R) {
        if (null !== $3331f036e4c5fdb5$var$J($3331f036e4c5fdb5$var$L)) $3331f036e4c5fdb5$var$R = !0, $3331f036e4c5fdb5$var$f($3331f036e4c5fdb5$var$V);
        else {
            var b = $3331f036e4c5fdb5$var$J($3331f036e4c5fdb5$var$M);
            null !== b && $3331f036e4c5fdb5$var$g($3331f036e4c5fdb5$var$U, b.startTime - a);
        }
    }
}
function $3331f036e4c5fdb5$var$V(a, b) {
    $3331f036e4c5fdb5$var$R = !1;
    $3331f036e4c5fdb5$var$S && ($3331f036e4c5fdb5$var$S = !1, $3331f036e4c5fdb5$var$h());
    $3331f036e4c5fdb5$var$Q = !0;
    var c = $3331f036e4c5fdb5$var$P;
    try {
        $3331f036e4c5fdb5$var$T(b);
        for($3331f036e4c5fdb5$var$O = $3331f036e4c5fdb5$var$J($3331f036e4c5fdb5$var$L); null !== $3331f036e4c5fdb5$var$O && (!($3331f036e4c5fdb5$var$O.expirationTime > b) || a && !$3331f036e4c5fdb5$export$b5836b71941fa3ed());){
            var d = $3331f036e4c5fdb5$var$O.callback;
            if ("function" === typeof d) {
                $3331f036e4c5fdb5$var$O.callback = null;
                $3331f036e4c5fdb5$var$P = $3331f036e4c5fdb5$var$O.priorityLevel;
                var e = d($3331f036e4c5fdb5$var$O.expirationTime <= b);
                b = $3331f036e4c5fdb5$export$c4744153514ff05d();
                "function" === typeof e ? $3331f036e4c5fdb5$var$O.callback = e : $3331f036e4c5fdb5$var$O === $3331f036e4c5fdb5$var$J($3331f036e4c5fdb5$var$L) && $3331f036e4c5fdb5$var$K($3331f036e4c5fdb5$var$L);
                $3331f036e4c5fdb5$var$T(b);
            } else $3331f036e4c5fdb5$var$K($3331f036e4c5fdb5$var$L);
            $3331f036e4c5fdb5$var$O = $3331f036e4c5fdb5$var$J($3331f036e4c5fdb5$var$L);
        }
        if (null !== $3331f036e4c5fdb5$var$O) var m = !0;
        else {
            var n = $3331f036e4c5fdb5$var$J($3331f036e4c5fdb5$var$M);
            null !== n && $3331f036e4c5fdb5$var$g($3331f036e4c5fdb5$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $3331f036e4c5fdb5$var$O = null, $3331f036e4c5fdb5$var$P = c, $3331f036e4c5fdb5$var$Q = !1;
    }
}
var $3331f036e4c5fdb5$var$W = $3331f036e4c5fdb5$var$k;
$3331f036e4c5fdb5$export$3e506c1ccc9cc1a7 = 5;
$3331f036e4c5fdb5$export$e26fe2ed2fa76875 = 1;
$3331f036e4c5fdb5$export$502329bbf4b505b1 = 4;
$3331f036e4c5fdb5$export$6e3807111c4874c4 = 3;
$3331f036e4c5fdb5$export$c27134553091fb3a = null;
$3331f036e4c5fdb5$export$33ee1acdc04fd2a2 = 2;
$3331f036e4c5fdb5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3331f036e4c5fdb5$export$8352ce38b91d0c62 = function() {
    $3331f036e4c5fdb5$var$R || $3331f036e4c5fdb5$var$Q || ($3331f036e4c5fdb5$var$R = !0, $3331f036e4c5fdb5$var$f($3331f036e4c5fdb5$var$V));
};
$3331f036e4c5fdb5$export$d3dfb8e4810cb555 = function() {
    return $3331f036e4c5fdb5$var$P;
};
$3331f036e4c5fdb5$export$839f9183b0465a69 = function() {
    return $3331f036e4c5fdb5$var$J($3331f036e4c5fdb5$var$L);
};
$3331f036e4c5fdb5$export$72fdf0e06517287b = function(a) {
    switch($3331f036e4c5fdb5$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3331f036e4c5fdb5$var$P;
    }
    var c = $3331f036e4c5fdb5$var$P;
    $3331f036e4c5fdb5$var$P = b;
    try {
        return a();
    } finally{
        $3331f036e4c5fdb5$var$P = c;
    }
};
$3331f036e4c5fdb5$export$4b844e58a3e414b4 = function() {};
$3331f036e4c5fdb5$export$816d2913ae6b83b1 = $3331f036e4c5fdb5$var$W;
$3331f036e4c5fdb5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3331f036e4c5fdb5$var$P;
    $3331f036e4c5fdb5$var$P = a;
    try {
        return b();
    } finally{
        $3331f036e4c5fdb5$var$P = c;
    }
};
$3331f036e4c5fdb5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3331f036e4c5fdb5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3331f036e4c5fdb5$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3331f036e4c5fdb5$var$H($3331f036e4c5fdb5$var$M, a), null === $3331f036e4c5fdb5$var$J($3331f036e4c5fdb5$var$L) && a === $3331f036e4c5fdb5$var$J($3331f036e4c5fdb5$var$M) && ($3331f036e4c5fdb5$var$S ? $3331f036e4c5fdb5$var$h() : $3331f036e4c5fdb5$var$S = !0, $3331f036e4c5fdb5$var$g($3331f036e4c5fdb5$var$U, c - d))) : (a.sortIndex = e, $3331f036e4c5fdb5$var$H($3331f036e4c5fdb5$var$L, a), $3331f036e4c5fdb5$var$R || $3331f036e4c5fdb5$var$Q || ($3331f036e4c5fdb5$var$R = !0, $3331f036e4c5fdb5$var$f($3331f036e4c5fdb5$var$V)));
    return a;
};
$3331f036e4c5fdb5$export$cf845f2c119da08a = function(a) {
    var b = $3331f036e4c5fdb5$var$P;
    return function() {
        var c = $3331f036e4c5fdb5$var$P;
        $3331f036e4c5fdb5$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3331f036e4c5fdb5$var$P = c;
        }
    };
};

});




parcelRegister("2fAqF", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $2b08Q = parcelRequire("2b08Q");
function $1a393d88283a377c$var$emptyFunction() {}
function $1a393d88283a377c$var$emptyFunctionWithReset() {}
$1a393d88283a377c$var$emptyFunctionWithReset.resetWarningCache = $1a393d88283a377c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $2b08Q) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1a393d88283a377c$var$emptyFunctionWithReset,
        resetWarningCache: $1a393d88283a377c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("2b08Q", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $195cb7f97a76de3f$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $195cb7f97a76de3f$var$ReactPropTypesSecret;

});


parcelRegister("TbtLg", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $0a5e0aa9efe2171c$export$2b8d127b894957b9, (v) => $0a5e0aa9efe2171c$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $0a5e0aa9efe2171c$export$cea3a54a6425200c, (v) => $0a5e0aa9efe2171c$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $0a5e0aa9efe2171c$export$a7c73072b1a182ae, (v) => $0a5e0aa9efe2171c$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $0a5e0aa9efe2171c$export$9f27bc3417b4524d, (v) => $0a5e0aa9efe2171c$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $0a5e0aa9efe2171c$export$db77ccec0bb4ccac, (v) => $0a5e0aa9efe2171c$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $0a5e0aa9efe2171c$export$8392c0c9d3dcbd35, (v) => $0a5e0aa9efe2171c$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $0a5e0aa9efe2171c$export$ffb0004e005737fa, (v) => $0a5e0aa9efe2171c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $0a5e0aa9efe2171c$export$b624eff549462981, (v) => $0a5e0aa9efe2171c$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $0a5e0aa9efe2171c$export$7897aa7841a5380c, (v) => $0a5e0aa9efe2171c$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $0a5e0aa9efe2171c$export$602eac185826482c, (v) => $0a5e0aa9efe2171c$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $0a5e0aa9efe2171c$export$e2c29f18771995cb, (v) => $0a5e0aa9efe2171c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $0a5e0aa9efe2171c$export$5f8d39834fd61797, (v) => $0a5e0aa9efe2171c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0a5e0aa9efe2171c$export$74bf444e3cd11ea5, (v) => $0a5e0aa9efe2171c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $0a5e0aa9efe2171c$export$92387174baf9b227, (v) => $0a5e0aa9efe2171c$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $0a5e0aa9efe2171c$export$ec112efeb987d9c6, (v) => $0a5e0aa9efe2171c$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $0a5e0aa9efe2171c$export$b706b080d889d2c9, (v) => $0a5e0aa9efe2171c$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $0a5e0aa9efe2171c$export$5be5a87408f70ddc, (v) => $0a5e0aa9efe2171c$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $0a5e0aa9efe2171c$export$45a5e7f76e0caa8d, (v) => $0a5e0aa9efe2171c$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $0a5e0aa9efe2171c$export$455c2e768291efa6, (v) => $0a5e0aa9efe2171c$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $0a5e0aa9efe2171c$export$9522e17588c12572, (v) => $0a5e0aa9efe2171c$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $0a5e0aa9efe2171c$export$2110ac352bb060b9, (v) => $0a5e0aa9efe2171c$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $0a5e0aa9efe2171c$export$56885ab8b9c456ab, (v) => $0a5e0aa9efe2171c$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $0a5e0aa9efe2171c$export$d927fcb6adf8f9de, (v) => $0a5e0aa9efe2171c$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $0a5e0aa9efe2171c$export$b82d16f27459e05a, (v) => $0a5e0aa9efe2171c$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $0a5e0aa9efe2171c$export$522c17b4f5e123e8, (v) => $0a5e0aa9efe2171c$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $0a5e0aa9efe2171c$export$1aabd8a0274ecfd6, (v) => $0a5e0aa9efe2171c$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $0a5e0aa9efe2171c$export$9b621391a187a31a, (v) => $0a5e0aa9efe2171c$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $0a5e0aa9efe2171c$export$f5bbd400c2f4426f, (v) => $0a5e0aa9efe2171c$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0a5e0aa9efe2171c$export$2b8d127b894957b9;
var $0a5e0aa9efe2171c$export$cea3a54a6425200c;
var $0a5e0aa9efe2171c$export$a7c73072b1a182ae;
var $0a5e0aa9efe2171c$export$9f27bc3417b4524d;
var $0a5e0aa9efe2171c$export$db77ccec0bb4ccac;
var $0a5e0aa9efe2171c$export$8392c0c9d3dcbd35;
var $0a5e0aa9efe2171c$export$ffb0004e005737fa;
var $0a5e0aa9efe2171c$export$b624eff549462981;
var $0a5e0aa9efe2171c$export$7897aa7841a5380c;
var $0a5e0aa9efe2171c$export$602eac185826482c;
var $0a5e0aa9efe2171c$export$e2c29f18771995cb;
var $0a5e0aa9efe2171c$export$5f8d39834fd61797;
var $0a5e0aa9efe2171c$export$74bf444e3cd11ea5;
var $0a5e0aa9efe2171c$export$92387174baf9b227;
var $0a5e0aa9efe2171c$export$ec112efeb987d9c6;
var $0a5e0aa9efe2171c$export$b706b080d889d2c9;
var $0a5e0aa9efe2171c$export$5be5a87408f70ddc;
var $0a5e0aa9efe2171c$export$45a5e7f76e0caa8d;
var $0a5e0aa9efe2171c$export$455c2e768291efa6;
var $0a5e0aa9efe2171c$export$9522e17588c12572;
var $0a5e0aa9efe2171c$export$2110ac352bb060b9;
var $0a5e0aa9efe2171c$export$56885ab8b9c456ab;
var $0a5e0aa9efe2171c$export$d927fcb6adf8f9de;
var $0a5e0aa9efe2171c$export$b82d16f27459e05a;
var $0a5e0aa9efe2171c$export$522c17b4f5e123e8;
var $0a5e0aa9efe2171c$export$1aabd8a0274ecfd6;
var $0a5e0aa9efe2171c$export$9b621391a187a31a;
var $0a5e0aa9efe2171c$export$f5bbd400c2f4426f;
'use strict';
var $0a5e0aa9efe2171c$var$b = "function" === typeof Symbol && Symbol.for, $0a5e0aa9efe2171c$var$c = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.element") : 60103, $0a5e0aa9efe2171c$var$d = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.portal") : 60106, $0a5e0aa9efe2171c$var$e = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.fragment") : 60107, $0a5e0aa9efe2171c$var$f = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.strict_mode") : 60108, $0a5e0aa9efe2171c$var$g = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.profiler") : 60114, $0a5e0aa9efe2171c$var$h = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.provider") : 60109, $0a5e0aa9efe2171c$var$k = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.context") : 60110, $0a5e0aa9efe2171c$var$l = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.async_mode") : 60111, $0a5e0aa9efe2171c$var$m = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.concurrent_mode") : 60111, $0a5e0aa9efe2171c$var$n = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.forward_ref") : 60112, $0a5e0aa9efe2171c$var$p = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.suspense") : 60113, $0a5e0aa9efe2171c$var$q = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.suspense_list") : 60120, $0a5e0aa9efe2171c$var$r = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.memo") : 60115, $0a5e0aa9efe2171c$var$t = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.lazy") : 60116, $0a5e0aa9efe2171c$var$v = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.block") : 60121, $0a5e0aa9efe2171c$var$w = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.fundamental") : 60117, $0a5e0aa9efe2171c$var$x = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.responder") : 60118, $0a5e0aa9efe2171c$var$y = $0a5e0aa9efe2171c$var$b ? Symbol.for("react.scope") : 60119;
function $0a5e0aa9efe2171c$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $0a5e0aa9efe2171c$var$c:
                switch(a = a.type, a){
                    case $0a5e0aa9efe2171c$var$l:
                    case $0a5e0aa9efe2171c$var$m:
                    case $0a5e0aa9efe2171c$var$e:
                    case $0a5e0aa9efe2171c$var$g:
                    case $0a5e0aa9efe2171c$var$f:
                    case $0a5e0aa9efe2171c$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $0a5e0aa9efe2171c$var$k:
                            case $0a5e0aa9efe2171c$var$n:
                            case $0a5e0aa9efe2171c$var$t:
                            case $0a5e0aa9efe2171c$var$r:
                            case $0a5e0aa9efe2171c$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $0a5e0aa9efe2171c$var$d:
                return u;
        }
    }
}
function $0a5e0aa9efe2171c$var$A(a) {
    return $0a5e0aa9efe2171c$var$z(a) === $0a5e0aa9efe2171c$var$m;
}
$0a5e0aa9efe2171c$export$2b8d127b894957b9 = $0a5e0aa9efe2171c$var$l;
$0a5e0aa9efe2171c$export$cea3a54a6425200c = $0a5e0aa9efe2171c$var$m;
$0a5e0aa9efe2171c$export$a7c73072b1a182ae = $0a5e0aa9efe2171c$var$k;
$0a5e0aa9efe2171c$export$9f27bc3417b4524d = $0a5e0aa9efe2171c$var$h;
$0a5e0aa9efe2171c$export$db77ccec0bb4ccac = $0a5e0aa9efe2171c$var$c;
$0a5e0aa9efe2171c$export$8392c0c9d3dcbd35 = $0a5e0aa9efe2171c$var$n;
$0a5e0aa9efe2171c$export$ffb0004e005737fa = $0a5e0aa9efe2171c$var$e;
$0a5e0aa9efe2171c$export$b624eff549462981 = $0a5e0aa9efe2171c$var$t;
$0a5e0aa9efe2171c$export$7897aa7841a5380c = $0a5e0aa9efe2171c$var$r;
$0a5e0aa9efe2171c$export$602eac185826482c = $0a5e0aa9efe2171c$var$d;
$0a5e0aa9efe2171c$export$e2c29f18771995cb = $0a5e0aa9efe2171c$var$g;
$0a5e0aa9efe2171c$export$5f8d39834fd61797 = $0a5e0aa9efe2171c$var$f;
$0a5e0aa9efe2171c$export$74bf444e3cd11ea5 = $0a5e0aa9efe2171c$var$p;
$0a5e0aa9efe2171c$export$92387174baf9b227 = function(a) {
    return $0a5e0aa9efe2171c$var$A(a) || $0a5e0aa9efe2171c$var$z(a) === $0a5e0aa9efe2171c$var$l;
};
$0a5e0aa9efe2171c$export$ec112efeb987d9c6 = $0a5e0aa9efe2171c$var$A;
$0a5e0aa9efe2171c$export$b706b080d889d2c9 = function(a) {
    return $0a5e0aa9efe2171c$var$z(a) === $0a5e0aa9efe2171c$var$k;
};
$0a5e0aa9efe2171c$export$5be5a87408f70ddc = function(a) {
    return $0a5e0aa9efe2171c$var$z(a) === $0a5e0aa9efe2171c$var$h;
};
$0a5e0aa9efe2171c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0a5e0aa9efe2171c$var$c;
};
$0a5e0aa9efe2171c$export$455c2e768291efa6 = function(a) {
    return $0a5e0aa9efe2171c$var$z(a) === $0a5e0aa9efe2171c$var$n;
};
$0a5e0aa9efe2171c$export$9522e17588c12572 = function(a) {
    return $0a5e0aa9efe2171c$var$z(a) === $0a5e0aa9efe2171c$var$e;
};
$0a5e0aa9efe2171c$export$2110ac352bb060b9 = function(a) {
    return $0a5e0aa9efe2171c$var$z(a) === $0a5e0aa9efe2171c$var$t;
};
$0a5e0aa9efe2171c$export$56885ab8b9c456ab = function(a) {
    return $0a5e0aa9efe2171c$var$z(a) === $0a5e0aa9efe2171c$var$r;
};
$0a5e0aa9efe2171c$export$d927fcb6adf8f9de = function(a) {
    return $0a5e0aa9efe2171c$var$z(a) === $0a5e0aa9efe2171c$var$d;
};
$0a5e0aa9efe2171c$export$b82d16f27459e05a = function(a) {
    return $0a5e0aa9efe2171c$var$z(a) === $0a5e0aa9efe2171c$var$g;
};
$0a5e0aa9efe2171c$export$522c17b4f5e123e8 = function(a) {
    return $0a5e0aa9efe2171c$var$z(a) === $0a5e0aa9efe2171c$var$f;
};
$0a5e0aa9efe2171c$export$1aabd8a0274ecfd6 = function(a) {
    return $0a5e0aa9efe2171c$var$z(a) === $0a5e0aa9efe2171c$var$p;
};
$0a5e0aa9efe2171c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $0a5e0aa9efe2171c$var$e || a === $0a5e0aa9efe2171c$var$m || a === $0a5e0aa9efe2171c$var$g || a === $0a5e0aa9efe2171c$var$f || a === $0a5e0aa9efe2171c$var$p || a === $0a5e0aa9efe2171c$var$q || "object" === typeof a && null !== a && (a.$$typeof === $0a5e0aa9efe2171c$var$t || a.$$typeof === $0a5e0aa9efe2171c$var$r || a.$$typeof === $0a5e0aa9efe2171c$var$h || a.$$typeof === $0a5e0aa9efe2171c$var$k || a.$$typeof === $0a5e0aa9efe2171c$var$n || a.$$typeof === $0a5e0aa9efe2171c$var$w || a.$$typeof === $0a5e0aa9efe2171c$var$x || a.$$typeof === $0a5e0aa9efe2171c$var$y || a.$$typeof === $0a5e0aa9efe2171c$var$v);
};
$0a5e0aa9efe2171c$export$f5bbd400c2f4426f = $0a5e0aa9efe2171c$var$z;

});

parcelRegister("2NPO8", function(module, exports) {

$parcel$export(module.exports, "default", () => $20a858454bec6c82$export$2e2bcd8739ae039);
/* global window */ 
var $kod9A = parcelRequire("kod9A");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $kod9A.default)(root);
var $20a858454bec6c82$export$2e2bcd8739ae039 = result;

});
parcelRegister("kod9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed80408d0ab58dd7$export$2e2bcd8739ae039);
function $ed80408d0ab58dd7$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("kM9SO", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $f1fff4ef977ac919$export$a7c73072b1a182ae, (v) => $f1fff4ef977ac919$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $f1fff4ef977ac919$export$9f27bc3417b4524d, (v) => $f1fff4ef977ac919$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $f1fff4ef977ac919$export$db77ccec0bb4ccac, (v) => $f1fff4ef977ac919$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $f1fff4ef977ac919$export$8392c0c9d3dcbd35, (v) => $f1fff4ef977ac919$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $f1fff4ef977ac919$export$ffb0004e005737fa, (v) => $f1fff4ef977ac919$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $f1fff4ef977ac919$export$b624eff549462981, (v) => $f1fff4ef977ac919$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $f1fff4ef977ac919$export$7897aa7841a5380c, (v) => $f1fff4ef977ac919$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $f1fff4ef977ac919$export$602eac185826482c, (v) => $f1fff4ef977ac919$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $f1fff4ef977ac919$export$e2c29f18771995cb, (v) => $f1fff4ef977ac919$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $f1fff4ef977ac919$export$5f8d39834fd61797, (v) => $f1fff4ef977ac919$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $f1fff4ef977ac919$export$74bf444e3cd11ea5, (v) => $f1fff4ef977ac919$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $f1fff4ef977ac919$export$92387174baf9b227, (v) => $f1fff4ef977ac919$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $f1fff4ef977ac919$export$ec112efeb987d9c6, (v) => $f1fff4ef977ac919$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $f1fff4ef977ac919$export$b706b080d889d2c9, (v) => $f1fff4ef977ac919$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $f1fff4ef977ac919$export$5be5a87408f70ddc, (v) => $f1fff4ef977ac919$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $f1fff4ef977ac919$export$45a5e7f76e0caa8d, (v) => $f1fff4ef977ac919$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $f1fff4ef977ac919$export$455c2e768291efa6, (v) => $f1fff4ef977ac919$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $f1fff4ef977ac919$export$9522e17588c12572, (v) => $f1fff4ef977ac919$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $f1fff4ef977ac919$export$2110ac352bb060b9, (v) => $f1fff4ef977ac919$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $f1fff4ef977ac919$export$56885ab8b9c456ab, (v) => $f1fff4ef977ac919$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $f1fff4ef977ac919$export$d927fcb6adf8f9de, (v) => $f1fff4ef977ac919$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $f1fff4ef977ac919$export$b82d16f27459e05a, (v) => $f1fff4ef977ac919$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $f1fff4ef977ac919$export$522c17b4f5e123e8, (v) => $f1fff4ef977ac919$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $f1fff4ef977ac919$export$1aabd8a0274ecfd6, (v) => $f1fff4ef977ac919$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $f1fff4ef977ac919$export$9b621391a187a31a, (v) => $f1fff4ef977ac919$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $f1fff4ef977ac919$export$f5bbd400c2f4426f, (v) => $f1fff4ef977ac919$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f1fff4ef977ac919$export$a7c73072b1a182ae;
var $f1fff4ef977ac919$export$9f27bc3417b4524d;
var $f1fff4ef977ac919$export$db77ccec0bb4ccac;
var $f1fff4ef977ac919$export$8392c0c9d3dcbd35;
var $f1fff4ef977ac919$export$ffb0004e005737fa;
var $f1fff4ef977ac919$export$b624eff549462981;
var $f1fff4ef977ac919$export$7897aa7841a5380c;
var $f1fff4ef977ac919$export$602eac185826482c;
var $f1fff4ef977ac919$export$e2c29f18771995cb;
var $f1fff4ef977ac919$export$5f8d39834fd61797;
var $f1fff4ef977ac919$export$74bf444e3cd11ea5;
var $f1fff4ef977ac919$export$92387174baf9b227;
var $f1fff4ef977ac919$export$ec112efeb987d9c6;
var $f1fff4ef977ac919$export$b706b080d889d2c9;
var $f1fff4ef977ac919$export$5be5a87408f70ddc;
var $f1fff4ef977ac919$export$45a5e7f76e0caa8d;
var $f1fff4ef977ac919$export$455c2e768291efa6;
var $f1fff4ef977ac919$export$9522e17588c12572;
var $f1fff4ef977ac919$export$2110ac352bb060b9;
var $f1fff4ef977ac919$export$56885ab8b9c456ab;
var $f1fff4ef977ac919$export$d927fcb6adf8f9de;
var $f1fff4ef977ac919$export$b82d16f27459e05a;
var $f1fff4ef977ac919$export$522c17b4f5e123e8;
var $f1fff4ef977ac919$export$1aabd8a0274ecfd6;
var $f1fff4ef977ac919$export$9b621391a187a31a;
var $f1fff4ef977ac919$export$f5bbd400c2f4426f;
'use strict';
var $f1fff4ef977ac919$var$b = 60103, $f1fff4ef977ac919$var$c = 60106, $f1fff4ef977ac919$var$d = 60107, $f1fff4ef977ac919$var$e = 60108, $f1fff4ef977ac919$var$f = 60114, $f1fff4ef977ac919$var$g = 60109, $f1fff4ef977ac919$var$h = 60110, $f1fff4ef977ac919$var$k = 60112, $f1fff4ef977ac919$var$l = 60113, $f1fff4ef977ac919$var$m = 60120, $f1fff4ef977ac919$var$n = 60115, $f1fff4ef977ac919$var$p = 60116, $f1fff4ef977ac919$var$q = 60121, $f1fff4ef977ac919$var$r = 60122, $f1fff4ef977ac919$var$u = 60117, $f1fff4ef977ac919$var$v = 60129, $f1fff4ef977ac919$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $f1fff4ef977ac919$var$x = Symbol.for;
    $f1fff4ef977ac919$var$b = $f1fff4ef977ac919$var$x("react.element");
    $f1fff4ef977ac919$var$c = $f1fff4ef977ac919$var$x("react.portal");
    $f1fff4ef977ac919$var$d = $f1fff4ef977ac919$var$x("react.fragment");
    $f1fff4ef977ac919$var$e = $f1fff4ef977ac919$var$x("react.strict_mode");
    $f1fff4ef977ac919$var$f = $f1fff4ef977ac919$var$x("react.profiler");
    $f1fff4ef977ac919$var$g = $f1fff4ef977ac919$var$x("react.provider");
    $f1fff4ef977ac919$var$h = $f1fff4ef977ac919$var$x("react.context");
    $f1fff4ef977ac919$var$k = $f1fff4ef977ac919$var$x("react.forward_ref");
    $f1fff4ef977ac919$var$l = $f1fff4ef977ac919$var$x("react.suspense");
    $f1fff4ef977ac919$var$m = $f1fff4ef977ac919$var$x("react.suspense_list");
    $f1fff4ef977ac919$var$n = $f1fff4ef977ac919$var$x("react.memo");
    $f1fff4ef977ac919$var$p = $f1fff4ef977ac919$var$x("react.lazy");
    $f1fff4ef977ac919$var$q = $f1fff4ef977ac919$var$x("react.block");
    $f1fff4ef977ac919$var$r = $f1fff4ef977ac919$var$x("react.server.block");
    $f1fff4ef977ac919$var$u = $f1fff4ef977ac919$var$x("react.fundamental");
    $f1fff4ef977ac919$var$v = $f1fff4ef977ac919$var$x("react.debug_trace_mode");
    $f1fff4ef977ac919$var$w = $f1fff4ef977ac919$var$x("react.legacy_hidden");
}
function $f1fff4ef977ac919$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $f1fff4ef977ac919$var$b:
                switch(a = a.type, a){
                    case $f1fff4ef977ac919$var$d:
                    case $f1fff4ef977ac919$var$f:
                    case $f1fff4ef977ac919$var$e:
                    case $f1fff4ef977ac919$var$l:
                    case $f1fff4ef977ac919$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $f1fff4ef977ac919$var$h:
                            case $f1fff4ef977ac919$var$k:
                            case $f1fff4ef977ac919$var$p:
                            case $f1fff4ef977ac919$var$n:
                            case $f1fff4ef977ac919$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $f1fff4ef977ac919$var$c:
                return t;
        }
    }
}
var $f1fff4ef977ac919$var$z = $f1fff4ef977ac919$var$g, $f1fff4ef977ac919$var$A = $f1fff4ef977ac919$var$b, $f1fff4ef977ac919$var$B = $f1fff4ef977ac919$var$k, $f1fff4ef977ac919$var$C = $f1fff4ef977ac919$var$d, $f1fff4ef977ac919$var$D = $f1fff4ef977ac919$var$p, $f1fff4ef977ac919$var$E = $f1fff4ef977ac919$var$n, $f1fff4ef977ac919$var$F = $f1fff4ef977ac919$var$c, $f1fff4ef977ac919$var$G = $f1fff4ef977ac919$var$f, $f1fff4ef977ac919$var$H = $f1fff4ef977ac919$var$e, $f1fff4ef977ac919$var$I = $f1fff4ef977ac919$var$l;
$f1fff4ef977ac919$export$a7c73072b1a182ae = $f1fff4ef977ac919$var$h;
$f1fff4ef977ac919$export$9f27bc3417b4524d = $f1fff4ef977ac919$var$z;
$f1fff4ef977ac919$export$db77ccec0bb4ccac = $f1fff4ef977ac919$var$A;
$f1fff4ef977ac919$export$8392c0c9d3dcbd35 = $f1fff4ef977ac919$var$B;
$f1fff4ef977ac919$export$ffb0004e005737fa = $f1fff4ef977ac919$var$C;
$f1fff4ef977ac919$export$b624eff549462981 = $f1fff4ef977ac919$var$D;
$f1fff4ef977ac919$export$7897aa7841a5380c = $f1fff4ef977ac919$var$E;
$f1fff4ef977ac919$export$602eac185826482c = $f1fff4ef977ac919$var$F;
$f1fff4ef977ac919$export$e2c29f18771995cb = $f1fff4ef977ac919$var$G;
$f1fff4ef977ac919$export$5f8d39834fd61797 = $f1fff4ef977ac919$var$H;
$f1fff4ef977ac919$export$74bf444e3cd11ea5 = $f1fff4ef977ac919$var$I;
$f1fff4ef977ac919$export$92387174baf9b227 = function() {
    return !1;
};
$f1fff4ef977ac919$export$ec112efeb987d9c6 = function() {
    return !1;
};
$f1fff4ef977ac919$export$b706b080d889d2c9 = function(a) {
    return $f1fff4ef977ac919$var$y(a) === $f1fff4ef977ac919$var$h;
};
$f1fff4ef977ac919$export$5be5a87408f70ddc = function(a) {
    return $f1fff4ef977ac919$var$y(a) === $f1fff4ef977ac919$var$g;
};
$f1fff4ef977ac919$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f1fff4ef977ac919$var$b;
};
$f1fff4ef977ac919$export$455c2e768291efa6 = function(a) {
    return $f1fff4ef977ac919$var$y(a) === $f1fff4ef977ac919$var$k;
};
$f1fff4ef977ac919$export$9522e17588c12572 = function(a) {
    return $f1fff4ef977ac919$var$y(a) === $f1fff4ef977ac919$var$d;
};
$f1fff4ef977ac919$export$2110ac352bb060b9 = function(a) {
    return $f1fff4ef977ac919$var$y(a) === $f1fff4ef977ac919$var$p;
};
$f1fff4ef977ac919$export$56885ab8b9c456ab = function(a) {
    return $f1fff4ef977ac919$var$y(a) === $f1fff4ef977ac919$var$n;
};
$f1fff4ef977ac919$export$d927fcb6adf8f9de = function(a) {
    return $f1fff4ef977ac919$var$y(a) === $f1fff4ef977ac919$var$c;
};
$f1fff4ef977ac919$export$b82d16f27459e05a = function(a) {
    return $f1fff4ef977ac919$var$y(a) === $f1fff4ef977ac919$var$f;
};
$f1fff4ef977ac919$export$522c17b4f5e123e8 = function(a) {
    return $f1fff4ef977ac919$var$y(a) === $f1fff4ef977ac919$var$e;
};
$f1fff4ef977ac919$export$1aabd8a0274ecfd6 = function(a) {
    return $f1fff4ef977ac919$var$y(a) === $f1fff4ef977ac919$var$l;
};
$f1fff4ef977ac919$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $f1fff4ef977ac919$var$d || a === $f1fff4ef977ac919$var$f || a === $f1fff4ef977ac919$var$v || a === $f1fff4ef977ac919$var$e || a === $f1fff4ef977ac919$var$l || a === $f1fff4ef977ac919$var$m || a === $f1fff4ef977ac919$var$w || "object" === typeof a && null !== a && (a.$$typeof === $f1fff4ef977ac919$var$p || a.$$typeof === $f1fff4ef977ac919$var$n || a.$$typeof === $f1fff4ef977ac919$var$g || a.$$typeof === $f1fff4ef977ac919$var$h || a.$$typeof === $f1fff4ef977ac919$var$k || a.$$typeof === $f1fff4ef977ac919$var$u || a.$$typeof === $f1fff4ef977ac919$var$q || a[0] === $f1fff4ef977ac919$var$r) ? !0 : !1;
};
$f1fff4ef977ac919$export$f5bbd400c2f4426f = $f1fff4ef977ac919$var$y;

});

parcelRegister("6wK2u", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $4c0971a6fea4291c$export$a7c73072b1a182ae, (v) => $4c0971a6fea4291c$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $4c0971a6fea4291c$export$9f27bc3417b4524d, (v) => $4c0971a6fea4291c$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $4c0971a6fea4291c$export$db77ccec0bb4ccac, (v) => $4c0971a6fea4291c$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $4c0971a6fea4291c$export$8392c0c9d3dcbd35, (v) => $4c0971a6fea4291c$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $4c0971a6fea4291c$export$ffb0004e005737fa, (v) => $4c0971a6fea4291c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $4c0971a6fea4291c$export$b624eff549462981, (v) => $4c0971a6fea4291c$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $4c0971a6fea4291c$export$7897aa7841a5380c, (v) => $4c0971a6fea4291c$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $4c0971a6fea4291c$export$602eac185826482c, (v) => $4c0971a6fea4291c$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $4c0971a6fea4291c$export$e2c29f18771995cb, (v) => $4c0971a6fea4291c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $4c0971a6fea4291c$export$5f8d39834fd61797, (v) => $4c0971a6fea4291c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $4c0971a6fea4291c$export$74bf444e3cd11ea5, (v) => $4c0971a6fea4291c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $4c0971a6fea4291c$export$998bcd577473dd93, (v) => $4c0971a6fea4291c$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $4c0971a6fea4291c$export$92387174baf9b227, (v) => $4c0971a6fea4291c$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $4c0971a6fea4291c$export$ec112efeb987d9c6, (v) => $4c0971a6fea4291c$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $4c0971a6fea4291c$export$b706b080d889d2c9, (v) => $4c0971a6fea4291c$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $4c0971a6fea4291c$export$5be5a87408f70ddc, (v) => $4c0971a6fea4291c$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $4c0971a6fea4291c$export$45a5e7f76e0caa8d, (v) => $4c0971a6fea4291c$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $4c0971a6fea4291c$export$455c2e768291efa6, (v) => $4c0971a6fea4291c$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $4c0971a6fea4291c$export$9522e17588c12572, (v) => $4c0971a6fea4291c$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $4c0971a6fea4291c$export$2110ac352bb060b9, (v) => $4c0971a6fea4291c$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $4c0971a6fea4291c$export$56885ab8b9c456ab, (v) => $4c0971a6fea4291c$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $4c0971a6fea4291c$export$d927fcb6adf8f9de, (v) => $4c0971a6fea4291c$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $4c0971a6fea4291c$export$b82d16f27459e05a, (v) => $4c0971a6fea4291c$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $4c0971a6fea4291c$export$522c17b4f5e123e8, (v) => $4c0971a6fea4291c$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $4c0971a6fea4291c$export$1aabd8a0274ecfd6, (v) => $4c0971a6fea4291c$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $4c0971a6fea4291c$export$3d6c20d97e46b957, (v) => $4c0971a6fea4291c$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $4c0971a6fea4291c$export$9b621391a187a31a, (v) => $4c0971a6fea4291c$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $4c0971a6fea4291c$export$f5bbd400c2f4426f, (v) => $4c0971a6fea4291c$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4c0971a6fea4291c$export$a7c73072b1a182ae;
var $4c0971a6fea4291c$export$9f27bc3417b4524d;
var $4c0971a6fea4291c$export$db77ccec0bb4ccac;
var $4c0971a6fea4291c$export$8392c0c9d3dcbd35;
var $4c0971a6fea4291c$export$ffb0004e005737fa;
var $4c0971a6fea4291c$export$b624eff549462981;
var $4c0971a6fea4291c$export$7897aa7841a5380c;
var $4c0971a6fea4291c$export$602eac185826482c;
var $4c0971a6fea4291c$export$e2c29f18771995cb;
var $4c0971a6fea4291c$export$5f8d39834fd61797;
var $4c0971a6fea4291c$export$74bf444e3cd11ea5;
var $4c0971a6fea4291c$export$998bcd577473dd93;
var $4c0971a6fea4291c$export$92387174baf9b227;
var $4c0971a6fea4291c$export$ec112efeb987d9c6;
var $4c0971a6fea4291c$export$b706b080d889d2c9;
var $4c0971a6fea4291c$export$5be5a87408f70ddc;
var $4c0971a6fea4291c$export$45a5e7f76e0caa8d;
var $4c0971a6fea4291c$export$455c2e768291efa6;
var $4c0971a6fea4291c$export$9522e17588c12572;
var $4c0971a6fea4291c$export$2110ac352bb060b9;
var $4c0971a6fea4291c$export$56885ab8b9c456ab;
var $4c0971a6fea4291c$export$d927fcb6adf8f9de;
var $4c0971a6fea4291c$export$b82d16f27459e05a;
var $4c0971a6fea4291c$export$522c17b4f5e123e8;
var $4c0971a6fea4291c$export$1aabd8a0274ecfd6;
var $4c0971a6fea4291c$export$3d6c20d97e46b957;
var $4c0971a6fea4291c$export$9b621391a187a31a;
var $4c0971a6fea4291c$export$f5bbd400c2f4426f;
'use strict';
var $4c0971a6fea4291c$var$b = Symbol.for("react.element"), $4c0971a6fea4291c$var$c = Symbol.for("react.portal"), $4c0971a6fea4291c$var$d = Symbol.for("react.fragment"), $4c0971a6fea4291c$var$e = Symbol.for("react.strict_mode"), $4c0971a6fea4291c$var$f = Symbol.for("react.profiler"), $4c0971a6fea4291c$var$g = Symbol.for("react.provider"), $4c0971a6fea4291c$var$h = Symbol.for("react.context"), $4c0971a6fea4291c$var$k = Symbol.for("react.server_context"), $4c0971a6fea4291c$var$l = Symbol.for("react.forward_ref"), $4c0971a6fea4291c$var$m = Symbol.for("react.suspense"), $4c0971a6fea4291c$var$n = Symbol.for("react.suspense_list"), $4c0971a6fea4291c$var$p = Symbol.for("react.memo"), $4c0971a6fea4291c$var$q = Symbol.for("react.lazy"), $4c0971a6fea4291c$var$t = Symbol.for("react.offscreen"), $4c0971a6fea4291c$var$u;
$4c0971a6fea4291c$var$u = Symbol.for("react.module.reference");
function $4c0971a6fea4291c$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $4c0971a6fea4291c$var$b:
                switch(a = a.type, a){
                    case $4c0971a6fea4291c$var$d:
                    case $4c0971a6fea4291c$var$f:
                    case $4c0971a6fea4291c$var$e:
                    case $4c0971a6fea4291c$var$m:
                    case $4c0971a6fea4291c$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $4c0971a6fea4291c$var$k:
                            case $4c0971a6fea4291c$var$h:
                            case $4c0971a6fea4291c$var$l:
                            case $4c0971a6fea4291c$var$q:
                            case $4c0971a6fea4291c$var$p:
                            case $4c0971a6fea4291c$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $4c0971a6fea4291c$var$c:
                return r;
        }
    }
}
$4c0971a6fea4291c$export$a7c73072b1a182ae = $4c0971a6fea4291c$var$h;
$4c0971a6fea4291c$export$9f27bc3417b4524d = $4c0971a6fea4291c$var$g;
$4c0971a6fea4291c$export$db77ccec0bb4ccac = $4c0971a6fea4291c$var$b;
$4c0971a6fea4291c$export$8392c0c9d3dcbd35 = $4c0971a6fea4291c$var$l;
$4c0971a6fea4291c$export$ffb0004e005737fa = $4c0971a6fea4291c$var$d;
$4c0971a6fea4291c$export$b624eff549462981 = $4c0971a6fea4291c$var$q;
$4c0971a6fea4291c$export$7897aa7841a5380c = $4c0971a6fea4291c$var$p;
$4c0971a6fea4291c$export$602eac185826482c = $4c0971a6fea4291c$var$c;
$4c0971a6fea4291c$export$e2c29f18771995cb = $4c0971a6fea4291c$var$f;
$4c0971a6fea4291c$export$5f8d39834fd61797 = $4c0971a6fea4291c$var$e;
$4c0971a6fea4291c$export$74bf444e3cd11ea5 = $4c0971a6fea4291c$var$m;
$4c0971a6fea4291c$export$998bcd577473dd93 = $4c0971a6fea4291c$var$n;
$4c0971a6fea4291c$export$92387174baf9b227 = function() {
    return !1;
};
$4c0971a6fea4291c$export$ec112efeb987d9c6 = function() {
    return !1;
};
$4c0971a6fea4291c$export$b706b080d889d2c9 = function(a) {
    return $4c0971a6fea4291c$var$v(a) === $4c0971a6fea4291c$var$h;
};
$4c0971a6fea4291c$export$5be5a87408f70ddc = function(a) {
    return $4c0971a6fea4291c$var$v(a) === $4c0971a6fea4291c$var$g;
};
$4c0971a6fea4291c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4c0971a6fea4291c$var$b;
};
$4c0971a6fea4291c$export$455c2e768291efa6 = function(a) {
    return $4c0971a6fea4291c$var$v(a) === $4c0971a6fea4291c$var$l;
};
$4c0971a6fea4291c$export$9522e17588c12572 = function(a) {
    return $4c0971a6fea4291c$var$v(a) === $4c0971a6fea4291c$var$d;
};
$4c0971a6fea4291c$export$2110ac352bb060b9 = function(a) {
    return $4c0971a6fea4291c$var$v(a) === $4c0971a6fea4291c$var$q;
};
$4c0971a6fea4291c$export$56885ab8b9c456ab = function(a) {
    return $4c0971a6fea4291c$var$v(a) === $4c0971a6fea4291c$var$p;
};
$4c0971a6fea4291c$export$d927fcb6adf8f9de = function(a) {
    return $4c0971a6fea4291c$var$v(a) === $4c0971a6fea4291c$var$c;
};
$4c0971a6fea4291c$export$b82d16f27459e05a = function(a) {
    return $4c0971a6fea4291c$var$v(a) === $4c0971a6fea4291c$var$f;
};
$4c0971a6fea4291c$export$522c17b4f5e123e8 = function(a) {
    return $4c0971a6fea4291c$var$v(a) === $4c0971a6fea4291c$var$e;
};
$4c0971a6fea4291c$export$1aabd8a0274ecfd6 = function(a) {
    return $4c0971a6fea4291c$var$v(a) === $4c0971a6fea4291c$var$m;
};
$4c0971a6fea4291c$export$3d6c20d97e46b957 = function(a) {
    return $4c0971a6fea4291c$var$v(a) === $4c0971a6fea4291c$var$n;
};
$4c0971a6fea4291c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $4c0971a6fea4291c$var$d || a === $4c0971a6fea4291c$var$f || a === $4c0971a6fea4291c$var$e || a === $4c0971a6fea4291c$var$m || a === $4c0971a6fea4291c$var$n || a === $4c0971a6fea4291c$var$t || "object" === typeof a && null !== a && (a.$$typeof === $4c0971a6fea4291c$var$q || a.$$typeof === $4c0971a6fea4291c$var$p || a.$$typeof === $4c0971a6fea4291c$var$g || a.$$typeof === $4c0971a6fea4291c$var$h || a.$$typeof === $4c0971a6fea4291c$var$l || a.$$typeof === $4c0971a6fea4291c$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$4c0971a6fea4291c$export$f5bbd400c2f4426f = $4c0971a6fea4291c$var$v;

});

parcelRegister("5Vniy", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $agWwT.default;
    }
});

var $agWwT = parcelRequire("agWwT");

});
parcelRegister("agWwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $77a8ccbf92ea6f6a$export$2e2bcd8739ae039);

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $b2E1n = parcelRequire("b2E1n");

var $2M70Q = parcelRequire("2M70Q");
'use client';
function $77a8ccbf92ea6f6a$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b2E1n.default), (0, $gOPoC.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $b2E1n.default).muiName;
    return /*#__PURE__*/ $3OyDL.memo(/*#__PURE__*/ $3OyDL.forwardRef(Component));
}

});
parcelRegister("gOPoC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3e92f0e3b40d2a1$export$2e2bcd8739ae039);
function $c3e92f0e3b40d2a1$export$2e2bcd8739ae039() {
    return $c3e92f0e3b40d2a1$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c3e92f0e3b40d2a1$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("b2E1n", function(module, exports) {

$parcel$export(module.exports, "default", () => $809eecff32258950$export$2e2bcd8739ae039);

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $g4LX8 = parcelRequire("g4LX8");

var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $8yqfj = parcelRequire("8yqfj");

var $2M70Q = parcelRequire("2M70Q");
'use client';
const $809eecff32258950$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $809eecff32258950$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $g4LX8.default)(color)}`,
            `fontSize${(0, $g4LX8.default)(fontSize)}`
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $8yqfj.getSvgIconUtilityClass), classes);
};
const $809eecff32258950$var$SvgIconRoot = (0, $jH1k7.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $g4LX8.default)(ownerState.color)}`],
            styles[`fontSize${(0, $g4LX8.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $809eecff32258950$var$SvgIcon = /*#__PURE__*/ $3OyDL.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $aBenZ.default)(props, $809eecff32258950$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $3OyDL.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $gOPoC.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $809eecff32258950$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($809eecff32258950$var$SvgIconRoot, (0, $gOPoC.default)({
        as: component,
        className: (0, $3DmQB.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $2M70Q.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$809eecff32258950$var$SvgIcon.muiName = 'SvgIcon';
var $809eecff32258950$export$2e2bcd8739ae039 = $809eecff32258950$var$SvgIcon;

});
parcelRegister("aBenZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7884d1df40b4d4$export$2e2bcd8739ae039);
function $7b7884d1df40b4d4$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("3DmQB", function(module, exports) {

$parcel$export(module.exports, "default", () => $48b61d674f3fa3f7$export$2e2bcd8739ae039);
function $48b61d674f3fa3f7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $48b61d674f3fa3f7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $48b61d674f3fa3f7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $48b61d674f3fa3f7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $48b61d674f3fa3f7$export$2e2bcd8739ae039 = $48b61d674f3fa3f7$export$4f5d2d50c9deca37;

});

parcelRegister("5jsOu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3de513da1bae50ca$export$2e2bcd8739ae039);
function $3de513da1bae50ca$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("g4LX8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb42377b2207ea68$export$2e2bcd8739ae039);

var $1gGyh = parcelRequire("1gGyh");
var $bb42377b2207ea68$export$2e2bcd8739ae039 = (0, $1gGyh.default);

});
parcelRegister("1gGyh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ec84afe12fd2c6f$export$2e2bcd8739ae039);

var $caYvM = parcelRequire("caYvM");
function $0ec84afe12fd2c6f$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $caYvM.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("caYvM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dd55b8cc9837d75$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $8dd55b8cc9837d75$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});



parcelRegister("jFgmT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e50e8b0a76d8705f$export$2e2bcd8739ae039);

var $5M5yC = parcelRequire("5M5yC");

var $1M38U = parcelRequire("1M38U");

var $joa2L = parcelRequire("joa2L");
'use client';
function $e50e8b0a76d8705f$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $5M5yC.default)({
        props: props,
        name: name,
        defaultTheme: $1M38U.default,
        themeId: (0, $joa2L.default)
    });
}

});
parcelRegister("5M5yC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4345bf04420c172d$export$2e2bcd8739ae039);

var $9gZBl = parcelRequire("9gZBl");

var $9oaul = parcelRequire("9oaul");
'use client';
function $4345bf04420c172d$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $9oaul.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $9gZBl.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("9gZBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c05646605744bb4$export$2e2bcd8739ae039);

var $eeWAX = parcelRequire("eeWAX");
function $6c05646605744bb4$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $eeWAX.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("eeWAX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5dfd33d179544e5$export$2e2bcd8739ae039);

var $gOPoC = parcelRequire("gOPoC");
function $a5dfd33d179544e5$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $gOPoC.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $gOPoC.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $gOPoC.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $a5dfd33d179544e5$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("9oaul", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5e7dba864daec2$export$2e2bcd8739ae039);

var $jjyU4 = parcelRequire("jjyU4");

var $cZI7n = parcelRequire("cZI7n");
'use client';
const $6d5e7dba864daec2$export$35e57303dbd8a66 = (0, $jjyU4.default)();
function $6d5e7dba864daec2$var$useTheme(defaultTheme = $6d5e7dba864daec2$export$35e57303dbd8a66) {
    return (0, $cZI7n.default)(defaultTheme);
}
var $6d5e7dba864daec2$export$2e2bcd8739ae039 = $6d5e7dba864daec2$var$useTheme;

});
parcelRegister("jjyU4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0faddbb47df9f20$export$2e2bcd8739ae039);

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $798ep = parcelRequire("798ep");

var $GTzIw = parcelRequire("GTzIw");

var $7svyF = parcelRequire("7svyF");

var $lgkgP = parcelRequire("lgkgP");

var $ktnoN = parcelRequire("ktnoN");

var $a3DMF = parcelRequire("a3DMF");

var $hfVrd = parcelRequire("hfVrd");
const $e0faddbb47df9f20$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $e0faddbb47df9f20$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $aBenZ.default)(options, $e0faddbb47df9f20$var$_excluded);
    const breakpoints = (0, $GTzIw.default)(breakpointsInput);
    const spacing = (0, $lgkgP.default)(spacingInput);
    let muiTheme = (0, $798ep.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $gOPoC.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $gOPoC.default)({}, (0, $7svyF.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $hfVrd.default);
    muiTheme = args.reduce((acc, argument)=>(0, $798ep.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $gOPoC.default)({}, (0, $a3DMF.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $ktnoN.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $e0faddbb47df9f20$export$2e2bcd8739ae039 = $e0faddbb47df9f20$var$createTheme;

});
parcelRegister("798ep", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $533fc23a30d09398$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $533fc23a30d09398$export$2e2bcd8739ae039);

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");
function $533fc23a30d09398$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $533fc23a30d09398$var$deepClone(source) {
    if (/*#__PURE__*/ $3OyDL.isValidElement(source) || !$533fc23a30d09398$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $533fc23a30d09398$var$deepClone(source[key]);
    });
    return output;
}
function $533fc23a30d09398$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $gOPoC.default)({}, target) : target;
    if ($533fc23a30d09398$export$53b83ca8eaab0383(target) && $533fc23a30d09398$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $3OyDL.isValidElement(source[key])) output[key] = source[key];
        else if ($533fc23a30d09398$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $533fc23a30d09398$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $533fc23a30d09398$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $533fc23a30d09398$export$53b83ca8eaab0383(source[key]) ? $533fc23a30d09398$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("GTzIw", function(module, exports) {

$parcel$export(module.exports, "default", () => $080f086974635e1c$export$2e2bcd8739ae039);

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");
const $080f086974635e1c$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $080f086974635e1c$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $080f086974635e1c$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $gOPoC.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $080f086974635e1c$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $aBenZ.default)(breakpoints, $080f086974635e1c$var$_excluded);
    const sortedValues = $080f086974635e1c$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $gOPoC.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("7svyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $56e3a0b4582abb01$export$2e2bcd8739ae039);
const $56e3a0b4582abb01$var$shape = {
    borderRadius: 4
};
var $56e3a0b4582abb01$export$2e2bcd8739ae039 = $56e3a0b4582abb01$var$shape;

});

parcelRegister("lgkgP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7aad0e76e7bc454$export$2e2bcd8739ae039);

var $a4Gzm = parcelRequire("a4Gzm");
function $f7aad0e76e7bc454$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $a4Gzm.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("a4Gzm", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $755b4c811a33004e$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $755b4c811a33004e$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $755b4c811a33004e$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $755b4c811a33004e$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $755b4c811a33004e$export$6f98e8eaf0be1996);


var $eTtV3 = parcelRequire("eTtV3");

var $9rP4D = parcelRequire("9rP4D");

var $hbElE = parcelRequire("hbElE");

var $55MIq = parcelRequire("55MIq");
const $755b4c811a33004e$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $755b4c811a33004e$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $755b4c811a33004e$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $755b4c811a33004e$var$getCssProperties = (0, $55MIq.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($755b4c811a33004e$var$aliases[prop]) prop = $755b4c811a33004e$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $755b4c811a33004e$var$properties[a];
    const direction = $755b4c811a33004e$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $755b4c811a33004e$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $755b4c811a33004e$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $755b4c811a33004e$var$spacingKeys = [
    ...$755b4c811a33004e$export$aab52a0dde05ad8a,
    ...$755b4c811a33004e$export$f8397d44f03ab6ad
];
function $755b4c811a33004e$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $9rP4D.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $755b4c811a33004e$export$1def6f833384e3d1(theme) {
    return $755b4c811a33004e$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $755b4c811a33004e$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $755b4c811a33004e$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $755b4c811a33004e$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $755b4c811a33004e$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $755b4c811a33004e$var$getCssProperties(prop);
    const styleFromPropValue = $755b4c811a33004e$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $eTtV3.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $755b4c811a33004e$var$style(props, keys) {
    const transformer = $755b4c811a33004e$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$755b4c811a33004e$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $hbElE.default), {});
}
function $755b4c811a33004e$export$7ede87f9b603dd3c(props) {
    return $755b4c811a33004e$var$style(props, $755b4c811a33004e$export$aab52a0dde05ad8a);
}
$755b4c811a33004e$export$7ede87f9b603dd3c.propTypes = {};
$755b4c811a33004e$export$7ede87f9b603dd3c.filterProps = $755b4c811a33004e$export$aab52a0dde05ad8a;
function $755b4c811a33004e$export$6f98e8eaf0be1996(props) {
    return $755b4c811a33004e$var$style(props, $755b4c811a33004e$export$f8397d44f03ab6ad);
}
$755b4c811a33004e$export$6f98e8eaf0be1996.propTypes = {};
$755b4c811a33004e$export$6f98e8eaf0be1996.filterProps = $755b4c811a33004e$export$f8397d44f03ab6ad;
function $755b4c811a33004e$var$spacing(props) {
    return $755b4c811a33004e$var$style(props, $755b4c811a33004e$var$spacingKeys);
}
$755b4c811a33004e$var$spacing.propTypes = {};
$755b4c811a33004e$var$spacing.filterProps = $755b4c811a33004e$var$spacingKeys;
var $755b4c811a33004e$export$2e2bcd8739ae039 = $755b4c811a33004e$var$spacing;

});
parcelRegister("eTtV3", function(module, exports) {

$parcel$export(module.exports, "values", () => $ad7d690ffb6e5334$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $ad7d690ffb6e5334$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $ad7d690ffb6e5334$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $ad7d690ffb6e5334$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $ad7d690ffb6e5334$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $ad7d690ffb6e5334$export$980e6a259d807490);

var $gOPoC = parcelRequire("gOPoC");


var $798ep = parcelRequire("798ep");

var $hbElE = parcelRequire("hbElE");
const $ad7d690ffb6e5334$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $ad7d690ffb6e5334$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$ad7d690ffb6e5334$export$68c286be0e7e55b7[key]}px)`
};
function $ad7d690ffb6e5334$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $ad7d690ffb6e5334$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $ad7d690ffb6e5334$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $ad7d690ffb6e5334$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $ad7d690ffb6e5334$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $ad7d690ffb6e5334$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $gOPoC.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $hbElE.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $ad7d690ffb6e5334$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $ad7d690ffb6e5334$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $ad7d690ffb6e5334$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $ad7d690ffb6e5334$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $798ep.default)(prev, next), {});
    return $ad7d690ffb6e5334$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $ad7d690ffb6e5334$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $ad7d690ffb6e5334$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $ad7d690ffb6e5334$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $ad7d690ffb6e5334$export$2e2bcd8739ae039 = $ad7d690ffb6e5334$var$breakpoints;

});
parcelRegister("hbElE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c832c30e957b0ec0$export$2e2bcd8739ae039);

var $798ep = parcelRequire("798ep");
function $c832c30e957b0ec0$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $798ep.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $c832c30e957b0ec0$export$2e2bcd8739ae039 = $c832c30e957b0ec0$var$merge;

});


parcelRegister("9rP4D", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $6e0e40da649e8ce1$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $6e0e40da649e8ce1$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $6e0e40da649e8ce1$export$2e2bcd8739ae039);

var $1gGyh = parcelRequire("1gGyh");


var $eTtV3 = parcelRequire("eTtV3");
function $6e0e40da649e8ce1$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $6e0e40da649e8ce1$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $6e0e40da649e8ce1$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $6e0e40da649e8ce1$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $6e0e40da649e8ce1$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $6e0e40da649e8ce1$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $6e0e40da649e8ce1$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $1gGyh.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $eTtV3.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $6e0e40da649e8ce1$export$2e2bcd8739ae039 = $6e0e40da649e8ce1$var$style;

});

parcelRegister("55MIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b53353f4aad4a8e$export$2e2bcd8739ae039);
function $3b53353f4aad4a8e$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("ktnoN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee78aa9a53ad1be8$export$2e2bcd8739ae039);

var $1gGyh = parcelRequire("1gGyh");

var $hbElE = parcelRequire("hbElE");

var $9rP4D = parcelRequire("9rP4D");

var $eTtV3 = parcelRequire("eTtV3");

var $a3DMF = parcelRequire("a3DMF");
function $ee78aa9a53ad1be8$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $ee78aa9a53ad1be8$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $ee78aa9a53ad1be8$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $9rP4D.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $9rP4D.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $9rP4D.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $1gGyh.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $eTtV3.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $a3DMF.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $eTtV3.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $ee78aa9a53ad1be8$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $hbElE.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $eTtV3.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($ee78aa9a53ad1be8$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $hbElE.default)(css, breakpointsValues);
                        }
                    } else css = (0, $hbElE.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $eTtV3.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $ee78aa9a53ad1be8$var$styleFunctionSx = $ee78aa9a53ad1be8$export$7d53d8bf2911e013();
$ee78aa9a53ad1be8$var$styleFunctionSx.filterProps = [
    'sx'
];
var $ee78aa9a53ad1be8$export$2e2bcd8739ae039 = $ee78aa9a53ad1be8$var$styleFunctionSx;

});
parcelRegister("a3DMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $75290b780160bd38$export$2e2bcd8739ae039);

var $a4Gzm = parcelRequire("a4Gzm");

var $4OZSZ = parcelRequire("4OZSZ");

var $cgoyr = parcelRequire("cgoyr");

var $kIHkg = parcelRequire("kIHkg");

var $kKaca = parcelRequire("kKaca");
const $75290b780160bd38$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $4OZSZ.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $4OZSZ.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $4OZSZ.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $4OZSZ.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $4OZSZ.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $4OZSZ.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $4OZSZ.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $kIHkg.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $kIHkg.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $kIHkg.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $a4Gzm.padding)
    },
    pt: {
        style: (0, $a4Gzm.padding)
    },
    pr: {
        style: (0, $a4Gzm.padding)
    },
    pb: {
        style: (0, $a4Gzm.padding)
    },
    pl: {
        style: (0, $a4Gzm.padding)
    },
    px: {
        style: (0, $a4Gzm.padding)
    },
    py: {
        style: (0, $a4Gzm.padding)
    },
    padding: {
        style: (0, $a4Gzm.padding)
    },
    paddingTop: {
        style: (0, $a4Gzm.padding)
    },
    paddingRight: {
        style: (0, $a4Gzm.padding)
    },
    paddingBottom: {
        style: (0, $a4Gzm.padding)
    },
    paddingLeft: {
        style: (0, $a4Gzm.padding)
    },
    paddingX: {
        style: (0, $a4Gzm.padding)
    },
    paddingY: {
        style: (0, $a4Gzm.padding)
    },
    paddingInline: {
        style: (0, $a4Gzm.padding)
    },
    paddingInlineStart: {
        style: (0, $a4Gzm.padding)
    },
    paddingInlineEnd: {
        style: (0, $a4Gzm.padding)
    },
    paddingBlock: {
        style: (0, $a4Gzm.padding)
    },
    paddingBlockStart: {
        style: (0, $a4Gzm.padding)
    },
    paddingBlockEnd: {
        style: (0, $a4Gzm.padding)
    },
    m: {
        style: (0, $a4Gzm.margin)
    },
    mt: {
        style: (0, $a4Gzm.margin)
    },
    mr: {
        style: (0, $a4Gzm.margin)
    },
    mb: {
        style: (0, $a4Gzm.margin)
    },
    ml: {
        style: (0, $a4Gzm.margin)
    },
    mx: {
        style: (0, $a4Gzm.margin)
    },
    my: {
        style: (0, $a4Gzm.margin)
    },
    margin: {
        style: (0, $a4Gzm.margin)
    },
    marginTop: {
        style: (0, $a4Gzm.margin)
    },
    marginRight: {
        style: (0, $a4Gzm.margin)
    },
    marginBottom: {
        style: (0, $a4Gzm.margin)
    },
    marginLeft: {
        style: (0, $a4Gzm.margin)
    },
    marginX: {
        style: (0, $a4Gzm.margin)
    },
    marginY: {
        style: (0, $a4Gzm.margin)
    },
    marginInline: {
        style: (0, $a4Gzm.margin)
    },
    marginInlineStart: {
        style: (0, $a4Gzm.margin)
    },
    marginInlineEnd: {
        style: (0, $a4Gzm.margin)
    },
    marginBlock: {
        style: (0, $a4Gzm.margin)
    },
    marginBlockStart: {
        style: (0, $a4Gzm.margin)
    },
    marginBlockEnd: {
        style: (0, $a4Gzm.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $cgoyr.gap)
    },
    rowGap: {
        style: (0, $cgoyr.rowGap)
    },
    columnGap: {
        style: (0, $cgoyr.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $kKaca.sizingTransform)
    },
    maxWidth: {
        style: (0, $kKaca.maxWidth)
    },
    minWidth: {
        transform: (0, $kKaca.sizingTransform)
    },
    height: {
        transform: (0, $kKaca.sizingTransform)
    },
    maxHeight: {
        transform: (0, $kKaca.sizingTransform)
    },
    minHeight: {
        transform: (0, $kKaca.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $75290b780160bd38$export$2e2bcd8739ae039 = $75290b780160bd38$var$defaultSxConfig;

});
parcelRegister("4OZSZ", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $382bd62e5e968b2f$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $382bd62e5e968b2f$export$7a57f79000377ca2);


var $9rP4D = parcelRequire("9rP4D");

var $1jCZM = parcelRequire("1jCZM");

var $a4Gzm = parcelRequire("a4Gzm");

var $eTtV3 = parcelRequire("eTtV3");
function $382bd62e5e968b2f$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $382bd62e5e968b2f$var$createBorderStyle(prop, transform) {
    return (0, $9rP4D.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $382bd62e5e968b2f$export$1edee58a52776cd9 = $382bd62e5e968b2f$var$createBorderStyle('border', $382bd62e5e968b2f$export$34e2febe53ae29cc);
const $382bd62e5e968b2f$export$f9a7b6bd24892946 = $382bd62e5e968b2f$var$createBorderStyle('borderTop', $382bd62e5e968b2f$export$34e2febe53ae29cc);
const $382bd62e5e968b2f$export$5abca33e6be905d2 = $382bd62e5e968b2f$var$createBorderStyle('borderRight', $382bd62e5e968b2f$export$34e2febe53ae29cc);
const $382bd62e5e968b2f$export$e2ce9f12a980a822 = $382bd62e5e968b2f$var$createBorderStyle('borderBottom', $382bd62e5e968b2f$export$34e2febe53ae29cc);
const $382bd62e5e968b2f$export$47658cca1a909427 = $382bd62e5e968b2f$var$createBorderStyle('borderLeft', $382bd62e5e968b2f$export$34e2febe53ae29cc);
const $382bd62e5e968b2f$export$e7fb0694ba2404fc = $382bd62e5e968b2f$var$createBorderStyle('borderColor');
const $382bd62e5e968b2f$export$126a92c968acdb85 = $382bd62e5e968b2f$var$createBorderStyle('borderTopColor');
const $382bd62e5e968b2f$export$85cc51cb8fbb8c0e = $382bd62e5e968b2f$var$createBorderStyle('borderRightColor');
const $382bd62e5e968b2f$export$340b0327727f6d1a = $382bd62e5e968b2f$var$createBorderStyle('borderBottomColor');
const $382bd62e5e968b2f$export$60beef91a985b4bf = $382bd62e5e968b2f$var$createBorderStyle('borderLeftColor');
const $382bd62e5e968b2f$export$f9258c55612cbed7 = $382bd62e5e968b2f$var$createBorderStyle('outline', $382bd62e5e968b2f$export$34e2febe53ae29cc);
const $382bd62e5e968b2f$export$621fe586efeb64b9 = $382bd62e5e968b2f$var$createBorderStyle('outlineColor');
const $382bd62e5e968b2f$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $a4Gzm.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $a4Gzm.getValue)(transformer, propValue)
            });
        return (0, $eTtV3.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$382bd62e5e968b2f$export$7a57f79000377ca2.propTypes = {};
$382bd62e5e968b2f$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $382bd62e5e968b2f$var$borders = (0, $1jCZM.default)($382bd62e5e968b2f$export$1edee58a52776cd9, $382bd62e5e968b2f$export$f9a7b6bd24892946, $382bd62e5e968b2f$export$5abca33e6be905d2, $382bd62e5e968b2f$export$e2ce9f12a980a822, $382bd62e5e968b2f$export$47658cca1a909427, $382bd62e5e968b2f$export$e7fb0694ba2404fc, $382bd62e5e968b2f$export$126a92c968acdb85, $382bd62e5e968b2f$export$85cc51cb8fbb8c0e, $382bd62e5e968b2f$export$340b0327727f6d1a, $382bd62e5e968b2f$export$60beef91a985b4bf, $382bd62e5e968b2f$export$7a57f79000377ca2, $382bd62e5e968b2f$export$f9258c55612cbed7, $382bd62e5e968b2f$export$621fe586efeb64b9);
var $382bd62e5e968b2f$export$2e2bcd8739ae039 = $382bd62e5e968b2f$var$borders;

});
parcelRegister("1jCZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f55d0771263241e$export$2e2bcd8739ae039);

var $hbElE = parcelRequire("hbElE");
function $0f55d0771263241e$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $hbElE.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $0f55d0771263241e$export$2e2bcd8739ae039 = $0f55d0771263241e$var$compose;

});


parcelRegister("cgoyr", function(module, exports) {

$parcel$export(module.exports, "gap", () => $8eda06adaa899787$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $8eda06adaa899787$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $8eda06adaa899787$export$8a833ffa5f5dbeda);

var $9rP4D = parcelRequire("9rP4D");

var $1jCZM = parcelRequire("1jCZM");

var $a4Gzm = parcelRequire("a4Gzm");

var $eTtV3 = parcelRequire("eTtV3");

const $8eda06adaa899787$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $a4Gzm.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $a4Gzm.getValue)(transformer, propValue)
            });
        return (0, $eTtV3.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$8eda06adaa899787$export$5df9adcb0db95e1e.propTypes = {};
$8eda06adaa899787$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $8eda06adaa899787$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $a4Gzm.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $a4Gzm.getValue)(transformer, propValue)
            });
        return (0, $eTtV3.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$8eda06adaa899787$export$ec60d70ff941a580.propTypes = {};
$8eda06adaa899787$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $8eda06adaa899787$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $a4Gzm.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $a4Gzm.getValue)(transformer, propValue)
            });
        return (0, $eTtV3.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$8eda06adaa899787$export$8a833ffa5f5dbeda.propTypes = {};
$8eda06adaa899787$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $8eda06adaa899787$export$baf44164ca3a34e8 = (0, $9rP4D.default)({
    prop: 'gridColumn'
});
const $8eda06adaa899787$export$8f7213a1cd01e832 = (0, $9rP4D.default)({
    prop: 'gridRow'
});
const $8eda06adaa899787$export$b0e0abbc49ba668 = (0, $9rP4D.default)({
    prop: 'gridAutoFlow'
});
const $8eda06adaa899787$export$bcd8b929d4b4142 = (0, $9rP4D.default)({
    prop: 'gridAutoColumns'
});
const $8eda06adaa899787$export$e5039a674e14c828 = (0, $9rP4D.default)({
    prop: 'gridAutoRows'
});
const $8eda06adaa899787$export$42bd9088661ffb03 = (0, $9rP4D.default)({
    prop: 'gridTemplateColumns'
});
const $8eda06adaa899787$export$920682ae05b999bc = (0, $9rP4D.default)({
    prop: 'gridTemplateRows'
});
const $8eda06adaa899787$export$1b88fbdd482fd33a = (0, $9rP4D.default)({
    prop: 'gridTemplateAreas'
});
const $8eda06adaa899787$export$bdb486e40d52d26f = (0, $9rP4D.default)({
    prop: 'gridArea'
});
const $8eda06adaa899787$var$grid = (0, $1jCZM.default)($8eda06adaa899787$export$5df9adcb0db95e1e, $8eda06adaa899787$export$ec60d70ff941a580, $8eda06adaa899787$export$8a833ffa5f5dbeda, $8eda06adaa899787$export$baf44164ca3a34e8, $8eda06adaa899787$export$8f7213a1cd01e832, $8eda06adaa899787$export$b0e0abbc49ba668, $8eda06adaa899787$export$bcd8b929d4b4142, $8eda06adaa899787$export$e5039a674e14c828, $8eda06adaa899787$export$42bd9088661ffb03, $8eda06adaa899787$export$920682ae05b999bc, $8eda06adaa899787$export$1b88fbdd482fd33a, $8eda06adaa899787$export$bdb486e40d52d26f);
var $8eda06adaa899787$export$2e2bcd8739ae039 = $8eda06adaa899787$var$grid;

});

parcelRegister("kIHkg", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $f159865265624ede$export$dbaffd4420ea0ac6);

var $9rP4D = parcelRequire("9rP4D");

var $1jCZM = parcelRequire("1jCZM");
function $f159865265624ede$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $f159865265624ede$export$35e9368ef982300f = (0, $9rP4D.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $f159865265624ede$export$dbaffd4420ea0ac6
});
const $f159865265624ede$export$2506f56c10355b33 = (0, $9rP4D.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $f159865265624ede$export$dbaffd4420ea0ac6
});
const $f159865265624ede$export$8c5a050822fd698c = (0, $9rP4D.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $f159865265624ede$export$dbaffd4420ea0ac6
});
const $f159865265624ede$var$palette = (0, $1jCZM.default)($f159865265624ede$export$35e9368ef982300f, $f159865265624ede$export$2506f56c10355b33, $f159865265624ede$export$8c5a050822fd698c);
var $f159865265624ede$export$2e2bcd8739ae039 = $f159865265624ede$var$palette;

});

parcelRegister("kKaca", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $f1a00315a6c372a4$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $f1a00315a6c372a4$export$488fda99655ff65a);

var $9rP4D = parcelRequire("9rP4D");

var $1jCZM = parcelRequire("1jCZM");

var $eTtV3 = parcelRequire("eTtV3");
function $f1a00315a6c372a4$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $f1a00315a6c372a4$export$7e3df82ee760448c = (0, $9rP4D.default)({
    prop: 'width',
    transform: $f1a00315a6c372a4$export$8afece71750ec241
});
const $f1a00315a6c372a4$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $eTtV3.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $f1a00315a6c372a4$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $eTtV3.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$f1a00315a6c372a4$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $f1a00315a6c372a4$export$ee148fbbe8357dd2 = (0, $9rP4D.default)({
    prop: 'minWidth',
    transform: $f1a00315a6c372a4$export$8afece71750ec241
});
const $f1a00315a6c372a4$export$ac607276a8fe9f0a = (0, $9rP4D.default)({
    prop: 'height',
    transform: $f1a00315a6c372a4$export$8afece71750ec241
});
const $f1a00315a6c372a4$export$dc0d8bd0b94f8570 = (0, $9rP4D.default)({
    prop: 'maxHeight',
    transform: $f1a00315a6c372a4$export$8afece71750ec241
});
const $f1a00315a6c372a4$export$a43cf604e12f3b17 = (0, $9rP4D.default)({
    prop: 'minHeight',
    transform: $f1a00315a6c372a4$export$8afece71750ec241
});
const $f1a00315a6c372a4$export$ffed9f14fb65e276 = (0, $9rP4D.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $f1a00315a6c372a4$export$8afece71750ec241
});
const $f1a00315a6c372a4$export$905076ed6620e671 = (0, $9rP4D.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $f1a00315a6c372a4$export$8afece71750ec241
});
const $f1a00315a6c372a4$export$6ccc93f785106a58 = (0, $9rP4D.default)({
    prop: 'boxSizing'
});
const $f1a00315a6c372a4$var$sizing = (0, $1jCZM.default)($f1a00315a6c372a4$export$7e3df82ee760448c, $f1a00315a6c372a4$export$488fda99655ff65a, $f1a00315a6c372a4$export$ee148fbbe8357dd2, $f1a00315a6c372a4$export$ac607276a8fe9f0a, $f1a00315a6c372a4$export$dc0d8bd0b94f8570, $f1a00315a6c372a4$export$a43cf604e12f3b17, $f1a00315a6c372a4$export$6ccc93f785106a58);
var $f1a00315a6c372a4$export$2e2bcd8739ae039 = $f1a00315a6c372a4$var$sizing;

});



parcelRegister("hfVrd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c900645c0fdbac43$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $c900645c0fdbac43$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("cZI7n", function(module, exports) {

$parcel$export(module.exports, "default", () => $975d6777a8ec2fb9$export$2e2bcd8739ae039);

var $3OyDL = parcelRequire("3OyDL");
parcelRequire("hDCOm");
var $aTrHR = parcelRequire("aTrHR");
'use client';
function $975d6777a8ec2fb9$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $975d6777a8ec2fb9$var$useTheme(defaultTheme = null) {
    const contextTheme = $3OyDL.useContext((0, $aTrHR.T));
    return !contextTheme || $975d6777a8ec2fb9$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $975d6777a8ec2fb9$export$2e2bcd8739ae039 = $975d6777a8ec2fb9$var$useTheme;

});
parcelRegister("hDCOm", function(module, exports) {

$parcel$export(module.exports, "Global", () => $cd742f47f48ce29a$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $cd742f47f48ce29a$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $cd742f47f48ce29a$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("aTrHR")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("aTrHR")).w);

var $3OyDL = parcelRequire("3OyDL");
parcelRequire("3KNG1");

var $aTrHR = parcelRequire("aTrHR");
parcelRequire("4Qmwu");
parcelRequire("eprzM");
parcelRequire("9PRjv");


var $c8aYa = parcelRequire("c8aYa");

var $3muyR = parcelRequire("3muyR");

var $gbamz = parcelRequire("gbamz");
var $cd742f47f48ce29a$var$pkg = {
    name: "@emotion/react",
    version: "11.7.0",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.13.10",
        "@emotion/cache": "^11.6.0",
        "@emotion/serialize": "^1.0.2",
        "@emotion/sheet": "^1.1.0",
        "@emotion/utils": "^1.0.0",
        "@emotion/weak-memoize": "^0.2.5",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        "@babel/core": "^7.0.0",
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@babel/core": {
            optional: true
        },
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@babel/core": "^7.13.10",
        "@emotion/css": "11.5.0",
        "@emotion/css-prettifier": "1.0.0",
        "@emotion/server": "11.4.0",
        "@emotion/styled": "11.6.0",
        "@types/react": "^16.9.11",
        dtslint: "^0.3.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact"
    }
};
var $cd742f47f48ce29a$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $aTrHR.h).call(props, 'css')) // $FlowFixMe
    return (0, $3OyDL.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $aTrHR.E);
    createElementArgArray[1] = (0, $aTrHR.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $3OyDL.createElement).apply(null, createElementArgArray);
};
var $cd742f47f48ce29a$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $cd742f47f48ce29a$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $aTrHR.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $3muyR.serializeStyles)([
        styles
    ], undefined, (0, $3OyDL.useContext)((0, $aTrHR.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $3OyDL.useRef)();
    (0, $3OyDL.useLayoutEffect)(function() {
        var key = cache.key + "-global";
        var sheet = new (0, $gbamz.StyleSheet)({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $3OyDL.useLayoutEffect)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $c8aYa.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $cd742f47f48ce29a$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $3muyR.serializeStyles)(args);
}
var $cd742f47f48ce29a$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $cd742f47f48ce29a$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $cd742f47f48ce29a$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $cd742f47f48ce29a$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $c8aYa.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $cd742f47f48ce29a$var$Noop = function Noop() {
    return null;
};
var $cd742f47f48ce29a$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $aTrHR.w)(function(props, cache) {
    var hasRendered = false;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $3muyR.serializeStyles)(args, cache.registered);
        (0, $c8aYa.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $cd742f47f48ce29a$var$merge(cache.registered, css, $cd742f47f48ce29a$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $3OyDL.useContext)((0, $aTrHR.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    var possiblyStyleElement = /*#__PURE__*/ (0, $3OyDL.createElement)($cd742f47f48ce29a$var$Noop, null);
    return /*#__PURE__*/ (0, $3OyDL.createElement)((0, $3OyDL.Fragment), null, possiblyStyleElement, ele);
});
var $cd742f47f48ce29a$var$isBrowser, $cd742f47f48ce29a$var$isJest, $cd742f47f48ce29a$var$globalContext, $cd742f47f48ce29a$var$globalKey;

});
parcelRegister("3KNG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bbc33be8d646655$export$2e2bcd8739ae039);

var $gbamz = parcelRequire("gbamz");

var $2WYye = parcelRequire("2WYye");

var $hJ1h5 = parcelRequire("hJ1h5");

var $8Uacy = parcelRequire("8Uacy");
var $2bbc33be8d646655$var$isBrowser = typeof document !== 'undefined';
var $2bbc33be8d646655$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $2WYye.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $2WYye.token)(character)) break;
        (0, $2WYye.next)();
    }
    return (0, $2WYye.slice)(begin, (0, $2WYye.position));
};
var $2bbc33be8d646655$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $2WYye.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $2WYye.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $2bbc33be8d646655$var$identifierWithPointTracking((0, $2WYye.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $2WYye.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $2WYye.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $2WYye.from)(character);
    }
    while (character = (0, $2WYye.next)());
    return parsed;
};
var $2bbc33be8d646655$var$getRules = function getRules(value, points) {
    return (0, $2WYye.dealloc)($2bbc33be8d646655$var$toRules((0, $2WYye.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $2bbc33be8d646655$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $2bbc33be8d646655$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$2bbc33be8d646655$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $2bbc33be8d646655$var$fixedElements.set(element, true);
    var points = [];
    var rules = $2bbc33be8d646655$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $2bbc33be8d646655$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $2bbc33be8d646655$var$prefix(value, length) {
    switch((0, $2WYye.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $2WYye.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $2WYye.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $2WYye.WEBKIT) + value + (0, $2WYye.MOZ) + value + (0, $2WYye.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $2WYye.WEBKIT) + value + (0, $2WYye.MS) + value + value;
        // order
        case 6165:
            return (0, $2WYye.WEBKIT) + value + (0, $2WYye.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $2WYye.WEBKIT) + value + (0, $2WYye.replace)(value, /(\w+).+(:[^]+)/, (0, $2WYye.WEBKIT) + 'box-$1$2' + (0, $2WYye.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $2WYye.WEBKIT) + value + (0, $2WYye.MS) + 'flex-item-' + (0, $2WYye.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $2WYye.WEBKIT) + value + (0, $2WYye.MS) + 'flex-line-pack' + (0, $2WYye.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $2WYye.WEBKIT) + value + (0, $2WYye.MS) + (0, $2WYye.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $2WYye.WEBKIT) + value + (0, $2WYye.MS) + (0, $2WYye.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $2WYye.WEBKIT) + 'box-' + (0, $2WYye.replace)(value, '-grow', '') + (0, $2WYye.WEBKIT) + value + (0, $2WYye.MS) + (0, $2WYye.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $2WYye.WEBKIT) + (0, $2WYye.replace)(value, /([^-])(transform)/g, '$1' + (0, $2WYye.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $2WYye.replace)((0, $2WYye.replace)((0, $2WYye.replace)(value, /(zoom-|grab)/, (0, $2WYye.WEBKIT) + '$1'), /(image-set)/, (0, $2WYye.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $2WYye.replace)(value, /(image-set\([^]*)/, (0, $2WYye.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $2WYye.replace)((0, $2WYye.replace)(value, /(.+:)(flex-)?(.*)/, (0, $2WYye.WEBKIT) + 'box-pack:$3' + (0, $2WYye.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $2WYye.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $2WYye.replace)(value, /(.+)-inline(.+)/, (0, $2WYye.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $2WYye.strlen)(value) - 1 - length > 6) switch((0, $2WYye.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $2WYye.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $2WYye.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $2WYye.WEBKIT) + '$2-$3' + '$1' + (0, $2WYye.MOZ) + ((0, $2WYye.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $2WYye.indexof)(value, 'stretch') ? $2bbc33be8d646655$var$prefix((0, $2WYye.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $2WYye.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $2WYye.charat)(value, (0, $2WYye.strlen)(value) - 3 - (~(0, $2WYye.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $2WYye.replace)(value, ':', ':' + (0, $2WYye.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $2WYye.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $2WYye.WEBKIT) + ((0, $2WYye.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $2WYye.WEBKIT) + '$2$3' + '$1' + (0, $2WYye.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $2WYye.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $2WYye.WEBKIT) + value + (0, $2WYye.MS) + (0, $2WYye.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $2WYye.WEBKIT) + value + (0, $2WYye.MS) + (0, $2WYye.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $2WYye.WEBKIT) + value + (0, $2WYye.MS) + (0, $2WYye.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $2WYye.WEBKIT) + value + (0, $2WYye.MS) + value + value;
    }
    return value;
}
var $2bbc33be8d646655$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $2WYye.DECLARATION:
                element["return"] = $2bbc33be8d646655$var$prefix(element.value, element.length);
                break;
            case 0, $2WYye.KEYFRAMES:
                return (0, $2WYye.serialize)([
                    (0, $2WYye.copy)(element, {
                        value: (0, $2WYye.replace)(element.value, '@', '@' + (0, $2WYye.WEBKIT))
                    })
                ], callback);
            case 0, $2WYye.RULESET:
                if (element.length) return (0, $2WYye.combine)(element.props, function(value) {
                    switch((0, $2WYye.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $2WYye.serialize)([
                                (0, $2WYye.copy)(element, {
                                    props: [
                                        (0, $2WYye.replace)(value, /:(read-\w+)/, ':' + (0, $2WYye.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $2WYye.serialize)([
                                (0, $2WYye.copy)(element, {
                                    props: [
                                        (0, $2WYye.replace)(value, /:(plac\w+)/, ':' + (0, $2WYye.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $2WYye.copy)(element, {
                                    props: [
                                        (0, $2WYye.replace)(value, /:(plac\w+)/, ':' + (0, $2WYye.MOZ) + '$1')
                                    ]
                                }),
                                (0, $2WYye.copy)(element, {
                                    props: [
                                        (0, $2WYye.replace)(value, /:(plac\w+)/, (0, $2WYye.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $2bbc33be8d646655$var$getServerStylisCache = $2bbc33be8d646655$var$isBrowser ? undefined : (0, $hJ1h5.default)(function() {
    return (0, $8Uacy.default)(function() {
        return {};
    });
});
var $2bbc33be8d646655$var$defaultStylisPlugins = [
    $2bbc33be8d646655$var$prefixer
];
var $2bbc33be8d646655$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($2bbc33be8d646655$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $2bbc33be8d646655$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($2bbc33be8d646655$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $2bbc33be8d646655$var$compat,
        $2bbc33be8d646655$var$removeLabel
    ];
    if (!$2bbc33be8d646655$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $2WYye.stringify),
            (0, $2WYye.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $2WYye.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $2WYye.serialize)((0, $2WYye.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $2WYye.stringify)
        ];
        var _serializer = (0, $2WYye.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $2WYye.serialize)((0, $2WYye.compile)(styles), _serializer);
        };
        var serverStylisCache = $2bbc33be8d646655$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $gbamz.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("gbamz", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $bc75b652b6a596d8$export$9d753cd7ae895cce);
var $bc75b652b6a596d8$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $bc75b652b6a596d8$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $bc75b652b6a596d8$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $bc75b652b6a596d8$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$bc75b652b6a596d8$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($bc75b652b6a596d8$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $bc75b652b6a596d8$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("2WYye", function(module, exports) {

$parcel$export(module.exports, "MS", () => $ef641dea6b6ded92$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $ef641dea6b6ded92$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $ef641dea6b6ded92$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $ef641dea6b6ded92$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $ef641dea6b6ded92$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $ef641dea6b6ded92$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $ef641dea6b6ded92$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $ef641dea6b6ded92$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $ef641dea6b6ded92$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $ef641dea6b6ded92$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $ef641dea6b6ded92$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $ef641dea6b6ded92$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $ef641dea6b6ded92$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $ef641dea6b6ded92$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $ef641dea6b6ded92$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $ef641dea6b6ded92$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $ef641dea6b6ded92$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $ef641dea6b6ded92$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $ef641dea6b6ded92$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $ef641dea6b6ded92$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $ef641dea6b6ded92$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $ef641dea6b6ded92$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $ef641dea6b6ded92$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $ef641dea6b6ded92$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $ef641dea6b6ded92$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $ef641dea6b6ded92$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $ef641dea6b6ded92$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $ef641dea6b6ded92$export$38bcb760f1d4871c);
var $ef641dea6b6ded92$export$71ad59f2e432cfe8 = "-ms-";
var $ef641dea6b6ded92$export$2c0f367103c8d01c = "-moz-";
var $ef641dea6b6ded92$export$39dfd62a25e0fe93 = "-webkit-";
var $ef641dea6b6ded92$export$a29989082612d0d9 = "comm";
var $ef641dea6b6ded92$export$aa3a2e812ca8570d = "rule";
var $ef641dea6b6ded92$export$527d108ccf083c2b = "decl";
var $ef641dea6b6ded92$export$d3d35020fa5b54f0 = "@page";
var $ef641dea6b6ded92$export$500415a86c544f73 = "@media";
var $ef641dea6b6ded92$export$a763edbf796b780a = "@import";
var $ef641dea6b6ded92$export$2790aeb8b4e5c826 = "@charset";
var $ef641dea6b6ded92$export$1cc683e23b84b133 = "@viewport";
var $ef641dea6b6ded92$export$9447a5efea57e862 = "@supports";
var $ef641dea6b6ded92$export$ef011b4e114b1fba = "@document";
var $ef641dea6b6ded92$export$6aad947bda0f3f46 = "@namespace";
var $ef641dea6b6ded92$export$b44a8529a35fcb60 = "@keyframes";
var $ef641dea6b6ded92$export$2c16de31893252e6 = "@font-face";
var $ef641dea6b6ded92$export$3d846dd52e150c6f = "@counter-style";
var $ef641dea6b6ded92$export$22314bfbb57653fe = "@font-feature-values";
var $ef641dea6b6ded92$export$d773506282b3cfe6 = "@layer";
var $ef641dea6b6ded92$export$2335f513bbd82c6d = Math.abs;
var $ef641dea6b6ded92$export$6788812c4e6611e6 = String.fromCharCode;
var $ef641dea6b6ded92$export$e6e34fd1f2686227 = Object.assign;
function $ef641dea6b6ded92$export$d6af199866bfb566(e, r) {
    return $ef641dea6b6ded92$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $ef641dea6b6ded92$export$a9db5e087081082d(e, 0)) << 2 ^ $ef641dea6b6ded92$export$a9db5e087081082d(e, 1)) << 2 ^ $ef641dea6b6ded92$export$a9db5e087081082d(e, 2)) << 2 ^ $ef641dea6b6ded92$export$a9db5e087081082d(e, 3) : 0;
}
function $ef641dea6b6ded92$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $ef641dea6b6ded92$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $ef641dea6b6ded92$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $ef641dea6b6ded92$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $ef641dea6b6ded92$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $ef641dea6b6ded92$export$36776f635604f274(e) {
    return e.length;
}
function $ef641dea6b6ded92$export$f9084667e487ed46(e) {
    return e.length;
}
function $ef641dea6b6ded92$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $ef641dea6b6ded92$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $ef641dea6b6ded92$export$53f1d5ea8de3d7c = 1;
var $ef641dea6b6ded92$export$4e0c71f277ca26b3 = 1;
var $ef641dea6b6ded92$export$f24224f1c91d8156 = 0;
var $ef641dea6b6ded92$export$5880b8b5730aff45 = 0;
var $ef641dea6b6ded92$export$c0306caf338ac095 = 0;
var $ef641dea6b6ded92$export$30a86d91af8ff6e6 = "";
function $ef641dea6b6ded92$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $ef641dea6b6ded92$export$53f1d5ea8de3d7c,
        column: $ef641dea6b6ded92$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $ef641dea6b6ded92$export$784d13d8ee351f07(e, r) {
    return $ef641dea6b6ded92$export$e6e34fd1f2686227($ef641dea6b6ded92$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $ef641dea6b6ded92$export$eba6f6f03b0a92e7() {
    return $ef641dea6b6ded92$export$c0306caf338ac095;
}
function $ef641dea6b6ded92$export$232faf9add678146() {
    $ef641dea6b6ded92$export$c0306caf338ac095 = $ef641dea6b6ded92$export$5880b8b5730aff45 > 0 ? $ef641dea6b6ded92$export$a9db5e087081082d($ef641dea6b6ded92$export$30a86d91af8ff6e6, --$ef641dea6b6ded92$export$5880b8b5730aff45) : 0;
    if ($ef641dea6b6ded92$export$4e0c71f277ca26b3--, $ef641dea6b6ded92$export$c0306caf338ac095 === 10) $ef641dea6b6ded92$export$4e0c71f277ca26b3 = 1, $ef641dea6b6ded92$export$53f1d5ea8de3d7c--;
    return $ef641dea6b6ded92$export$c0306caf338ac095;
}
function $ef641dea6b6ded92$export$48cfd1e771a65c4f() {
    $ef641dea6b6ded92$export$c0306caf338ac095 = $ef641dea6b6ded92$export$5880b8b5730aff45 < $ef641dea6b6ded92$export$f24224f1c91d8156 ? $ef641dea6b6ded92$export$a9db5e087081082d($ef641dea6b6ded92$export$30a86d91af8ff6e6, $ef641dea6b6ded92$export$5880b8b5730aff45++) : 0;
    if ($ef641dea6b6ded92$export$4e0c71f277ca26b3++, $ef641dea6b6ded92$export$c0306caf338ac095 === 10) $ef641dea6b6ded92$export$4e0c71f277ca26b3 = 1, $ef641dea6b6ded92$export$53f1d5ea8de3d7c++;
    return $ef641dea6b6ded92$export$c0306caf338ac095;
}
function $ef641dea6b6ded92$export$4d3fb11e950abb9e() {
    return $ef641dea6b6ded92$export$a9db5e087081082d($ef641dea6b6ded92$export$30a86d91af8ff6e6, $ef641dea6b6ded92$export$5880b8b5730aff45);
}
function $ef641dea6b6ded92$export$e88cb2efb12ae807() {
    return $ef641dea6b6ded92$export$5880b8b5730aff45;
}
function $ef641dea6b6ded92$export$58adb3bec8346d0f(e, r) {
    return $ef641dea6b6ded92$export$2f35ab04d2335697($ef641dea6b6ded92$export$30a86d91af8ff6e6, e, r);
}
function $ef641dea6b6ded92$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $ef641dea6b6ded92$export$2de70f21292aac9e(e) {
    return $ef641dea6b6ded92$export$53f1d5ea8de3d7c = $ef641dea6b6ded92$export$4e0c71f277ca26b3 = 1, $ef641dea6b6ded92$export$f24224f1c91d8156 = $ef641dea6b6ded92$export$36776f635604f274($ef641dea6b6ded92$export$30a86d91af8ff6e6 = e), $ef641dea6b6ded92$export$5880b8b5730aff45 = 0, [];
}
function $ef641dea6b6ded92$export$45918ac1574455b1(e) {
    return $ef641dea6b6ded92$export$30a86d91af8ff6e6 = "", e;
}
function $ef641dea6b6ded92$export$410ac95b9ec204b8(e) {
    return $ef641dea6b6ded92$export$87c2784dc9fc4ab($ef641dea6b6ded92$export$58adb3bec8346d0f($ef641dea6b6ded92$export$5880b8b5730aff45 - 1, $ef641dea6b6ded92$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $ef641dea6b6ded92$export$660b2ee2d4fb4eff(e) {
    return $ef641dea6b6ded92$export$45918ac1574455b1($ef641dea6b6ded92$export$5f8c09e3ae6f64e1($ef641dea6b6ded92$export$2de70f21292aac9e(e)));
}
function $ef641dea6b6ded92$export$7af1228ff777d175(e) {
    while($ef641dea6b6ded92$export$c0306caf338ac095 = $ef641dea6b6ded92$export$4d3fb11e950abb9e())if ($ef641dea6b6ded92$export$c0306caf338ac095 < 33) $ef641dea6b6ded92$export$48cfd1e771a65c4f();
    else break;
    return $ef641dea6b6ded92$export$9e1725a4cfeada27(e) > 2 || $ef641dea6b6ded92$export$9e1725a4cfeada27($ef641dea6b6ded92$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $ef641dea6b6ded92$export$5f8c09e3ae6f64e1(e) {
    while($ef641dea6b6ded92$export$48cfd1e771a65c4f())switch($ef641dea6b6ded92$export$9e1725a4cfeada27($ef641dea6b6ded92$export$c0306caf338ac095)){
        case 0:
            $ef641dea6b6ded92$export$10d8903dec122b9d($ef641dea6b6ded92$export$c2ab62c7bf24634($ef641dea6b6ded92$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $ef641dea6b6ded92$export$10d8903dec122b9d($ef641dea6b6ded92$export$410ac95b9ec204b8($ef641dea6b6ded92$export$c0306caf338ac095), e);
            break;
        default:
            $ef641dea6b6ded92$export$10d8903dec122b9d($ef641dea6b6ded92$export$6788812c4e6611e6($ef641dea6b6ded92$export$c0306caf338ac095), e);
    }
    return e;
}
function $ef641dea6b6ded92$export$955ba06d119e085e(e, r) {
    while(--r && $ef641dea6b6ded92$export$48cfd1e771a65c4f())if ($ef641dea6b6ded92$export$c0306caf338ac095 < 48 || $ef641dea6b6ded92$export$c0306caf338ac095 > 102 || $ef641dea6b6ded92$export$c0306caf338ac095 > 57 && $ef641dea6b6ded92$export$c0306caf338ac095 < 65 || $ef641dea6b6ded92$export$c0306caf338ac095 > 70 && $ef641dea6b6ded92$export$c0306caf338ac095 < 97) break;
    return $ef641dea6b6ded92$export$58adb3bec8346d0f(e, $ef641dea6b6ded92$export$e88cb2efb12ae807() + (r < 6 && $ef641dea6b6ded92$export$4d3fb11e950abb9e() == 32 && $ef641dea6b6ded92$export$48cfd1e771a65c4f() == 32));
}
function $ef641dea6b6ded92$export$c889f2fcc19dbf12(e) {
    while($ef641dea6b6ded92$export$48cfd1e771a65c4f())switch($ef641dea6b6ded92$export$c0306caf338ac095){
        case e:
            return $ef641dea6b6ded92$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $ef641dea6b6ded92$export$c889f2fcc19dbf12($ef641dea6b6ded92$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $ef641dea6b6ded92$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $ef641dea6b6ded92$export$48cfd1e771a65c4f();
            break;
    }
    return $ef641dea6b6ded92$export$5880b8b5730aff45;
}
function $ef641dea6b6ded92$export$4254d4e2b3745c4c(e, r) {
    while($ef641dea6b6ded92$export$48cfd1e771a65c4f())if (e + $ef641dea6b6ded92$export$c0306caf338ac095 === 57) break;
    else if (e + $ef641dea6b6ded92$export$c0306caf338ac095 === 84 && $ef641dea6b6ded92$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $ef641dea6b6ded92$export$58adb3bec8346d0f(r, $ef641dea6b6ded92$export$5880b8b5730aff45 - 1) + "*" + $ef641dea6b6ded92$export$6788812c4e6611e6(e === 47 ? e : $ef641dea6b6ded92$export$48cfd1e771a65c4f());
}
function $ef641dea6b6ded92$export$c2ab62c7bf24634(e) {
    while(!$ef641dea6b6ded92$export$9e1725a4cfeada27($ef641dea6b6ded92$export$4d3fb11e950abb9e()))$ef641dea6b6ded92$export$48cfd1e771a65c4f();
    return $ef641dea6b6ded92$export$58adb3bec8346d0f(e, $ef641dea6b6ded92$export$5880b8b5730aff45);
}
function $ef641dea6b6ded92$export$ef7acd7185315e22(e) {
    return $ef641dea6b6ded92$export$45918ac1574455b1($ef641dea6b6ded92$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $ef641dea6b6ded92$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $ef641dea6b6ded92$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $ef641dea6b6ded92$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $ef641dea6b6ded92$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($ef641dea6b6ded92$export$f8e21b1e77979a08(j += $ef641dea6b6ded92$export$77ad94ebf1c2b9ed($ef641dea6b6ded92$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $ef641dea6b6ded92$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $ef641dea6b6ded92$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $ef641dea6b6ded92$export$955ba06d119e085e($ef641dea6b6ded92$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($ef641dea6b6ded92$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $ef641dea6b6ded92$export$10d8903dec122b9d($ef641dea6b6ded92$export$4a34f930e789283c($ef641dea6b6ded92$export$4254d4e2b3745c4c($ef641dea6b6ded92$export$48cfd1e771a65c4f(), $ef641dea6b6ded92$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $ef641dea6b6ded92$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $ef641dea6b6ded92$export$36776f635604f274(j) - l) $ef641dea6b6ded92$export$10d8903dec122b9d(p > 32 ? $ef641dea6b6ded92$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $ef641dea6b6ded92$export$f8483753829ec8f3($ef641dea6b6ded92$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $ef641dea6b6ded92$export$10d8903dec122b9d(y = $ef641dea6b6ded92$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $ef641dea6b6ded92$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $ef641dea6b6ded92$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $ef641dea6b6ded92$export$98e6a39c04603d36(e, y, y, n && $ef641dea6b6ded92$export$10d8903dec122b9d($ef641dea6b6ded92$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $ef641dea6b6ded92$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $ef641dea6b6ded92$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $ef641dea6b6ded92$export$232faf9add678146() == 125) continue;
            }
            switch(j += $ef641dea6b6ded92$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($ef641dea6b6ded92$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($ef641dea6b6ded92$export$4d3fb11e950abb9e() === 45) j += $ef641dea6b6ded92$export$410ac95b9ec204b8($ef641dea6b6ded92$export$48cfd1e771a65c4f());
                    v = $ef641dea6b6ded92$export$4d3fb11e950abb9e(), o = l = $ef641dea6b6ded92$export$36776f635604f274(g = j += $ef641dea6b6ded92$export$c2ab62c7bf24634($ef641dea6b6ded92$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $ef641dea6b6ded92$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $ef641dea6b6ded92$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $ef641dea6b6ded92$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $ef641dea6b6ded92$export$2f35ab04d2335697(e, v + 1, v = $ef641dea6b6ded92$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $ef641dea6b6ded92$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $ef641dea6b6ded92$export$35059013cd4a06db(e, r, a, s === 0 ? $ef641dea6b6ded92$export$aa3a2e812ca8570d : i, f, o, l);
}
function $ef641dea6b6ded92$export$4a34f930e789283c(e, r, a) {
    return $ef641dea6b6ded92$export$35059013cd4a06db(e, r, a, $ef641dea6b6ded92$export$a29989082612d0d9, $ef641dea6b6ded92$export$6788812c4e6611e6($ef641dea6b6ded92$export$eba6f6f03b0a92e7()), $ef641dea6b6ded92$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $ef641dea6b6ded92$export$f8483753829ec8f3(e, r, a, n) {
    return $ef641dea6b6ded92$export$35059013cd4a06db(e, r, a, $ef641dea6b6ded92$export$527d108ccf083c2b, $ef641dea6b6ded92$export$2f35ab04d2335697(e, 0, n), $ef641dea6b6ded92$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $ef641dea6b6ded92$export$82e9f45cca5ba907(n, c, s) {
    switch($ef641dea6b6ded92$export$d6af199866bfb566(n, c)){
        case 5103:
            return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $ef641dea6b6ded92$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + $ef641dea6b6ded92$export$2c0f367103c8d01c + n + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($ef641dea6b6ded92$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $ef641dea6b6ded92$export$39dfd62a25e0fe93 + "box-$1$2" + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + "flex-item-" + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$ef641dea6b6ded92$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $ef641dea6b6ded92$export$71ad59f2e432cfe8 + "grid-row-" + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + "flex-line-pack" + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + "box-" + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, "-grow", "") + $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $ef641dea6b6ded92$export$39dfd62a25e0fe93 + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $ef641dea6b6ded92$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $ef641dea6b6ded92$export$77ad94ebf1c2b9ed($ef641dea6b6ded92$export$77ad94ebf1c2b9ed($ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $ef641dea6b6ded92$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $ef641dea6b6ded92$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $ef641dea6b6ded92$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $ef641dea6b6ded92$export$77ad94ebf1c2b9ed($ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $ef641dea6b6ded92$export$39dfd62a25e0fe93 + "box-pack:$3" + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $ef641dea6b6ded92$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$ef641dea6b6ded92$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $ef641dea6b6ded92$export$71ad59f2e432cfe8 + "grid-column-align" + $ef641dea6b6ded92$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $ef641dea6b6ded92$export$71ad59f2e432cfe8 + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $ef641dea6b6ded92$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$ef641dea6b6ded92$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $ef641dea6b6ded92$export$71ad59f2e432cfe8 + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$ef641dea6b6ded92$export$f8e21b1e77979a08(s, "span") ? $ef641dea6b6ded92$export$4659b591c19bdf3d(s, /\d+/) : +$ef641dea6b6ded92$export$4659b591c19bdf3d(s, /\d+/) - +$ef641dea6b6ded92$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $ef641dea6b6ded92$export$71ad59f2e432cfe8 + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $ef641dea6b6ded92$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $ef641dea6b6ded92$export$71ad59f2e432cfe8 + $ef641dea6b6ded92$export$77ad94ebf1c2b9ed($ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $ef641dea6b6ded92$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($ef641dea6b6ded92$export$36776f635604f274(n) - 1 - c > 6) switch($ef641dea6b6ded92$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($ef641dea6b6ded92$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $ef641dea6b6ded92$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $ef641dea6b6ded92$export$2c0f367103c8d01c + ($ef641dea6b6ded92$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$ef641dea6b6ded92$export$f8e21b1e77979a08(n, "stretch") ? $ef641dea6b6ded92$export$82e9f45cca5ba907($ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $ef641dea6b6ded92$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $ef641dea6b6ded92$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($ef641dea6b6ded92$export$a9db5e087081082d(n, c + 6) === 121) return $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, ":", ":" + $ef641dea6b6ded92$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($ef641dea6b6ded92$export$a9db5e087081082d(n, $ef641dea6b6ded92$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $ef641dea6b6ded92$export$39dfd62a25e0fe93 + ($ef641dea6b6ded92$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $ef641dea6b6ded92$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $ef641dea6b6ded92$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, ":", ":" + $ef641dea6b6ded92$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $ef641dea6b6ded92$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $ef641dea6b6ded92$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $ef641dea6b6ded92$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $ef641dea6b6ded92$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $ef641dea6b6ded92$export$a763edbf796b780a:
        case $ef641dea6b6ded92$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $ef641dea6b6ded92$export$a29989082612d0d9:
            return "";
        case $ef641dea6b6ded92$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $ef641dea6b6ded92$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $ef641dea6b6ded92$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $ef641dea6b6ded92$export$36776f635604f274(a = $ef641dea6b6ded92$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $ef641dea6b6ded92$export$5a7767152ae0305f(e) {
    var r = $ef641dea6b6ded92$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $ef641dea6b6ded92$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $ef641dea6b6ded92$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $ef641dea6b6ded92$export$527d108ccf083c2b:
                n.return = $ef641dea6b6ded92$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $ef641dea6b6ded92$export$b44a8529a35fcb60:
                return $ef641dea6b6ded92$export$dfdc1655ccc5b9cb([
                    $ef641dea6b6ded92$export$784d13d8ee351f07(n, {
                        value: $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $ef641dea6b6ded92$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $ef641dea6b6ded92$export$aa3a2e812ca8570d:
                if (n.length) return $ef641dea6b6ded92$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($ef641dea6b6ded92$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $ef641dea6b6ded92$export$dfdc1655ccc5b9cb([
                                $ef641dea6b6ded92$export$784d13d8ee351f07(n, {
                                    props: [
                                        $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $ef641dea6b6ded92$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $ef641dea6b6ded92$export$dfdc1655ccc5b9cb([
                                $ef641dea6b6ded92$export$784d13d8ee351f07(n, {
                                    props: [
                                        $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $ef641dea6b6ded92$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $ef641dea6b6ded92$export$784d13d8ee351f07(n, {
                                    props: [
                                        $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $ef641dea6b6ded92$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $ef641dea6b6ded92$export$784d13d8ee351f07(n, {
                                    props: [
                                        $ef641dea6b6ded92$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $ef641dea6b6ded92$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $ef641dea6b6ded92$export$76a88f7de6507443(e) {
    switch(e.type){
        case $ef641dea6b6ded92$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $ef641dea6b6ded92$export$1be1fc439b849fdf($ef641dea6b6ded92$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($ef641dea6b6ded92$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $ef641dea6b6ded92$export$2f35ab04d2335697(r, 1, $ef641dea6b6ded92$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $ef641dea6b6ded92$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $ef641dea6b6ded92$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $ef641dea6b6ded92$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("hJ1h5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce77a0bd5a9b7da6$export$2e2bcd8739ae039);
var $ce77a0bd5a9b7da6$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("8Uacy", function(module, exports) {

$parcel$export(module.exports, "default", () => $67bb77807c144279$export$2e2bcd8739ae039);
function $67bb77807c144279$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("aTrHR", function(module, exports) {

$parcel$export(module.exports, "h", () => $7ee4885fba7b1e72$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "w", () => $7ee4885fba7b1e72$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $7ee4885fba7b1e72$export$971d5caa766a69d7);
$parcel$export(module.exports, "c", () => $7ee4885fba7b1e72$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $7ee4885fba7b1e72$export$a9c23c6ac3fc3eca);

var $3OyDL = parcelRequire("3OyDL");

var $3KNG1 = parcelRequire("3KNG1");

var $gOPoC = parcelRequire("gOPoC");

var $eprzM = parcelRequire("eprzM");

var $995ey = parcelRequire("995ey");

var $c8aYa = parcelRequire("c8aYa");

var $3muyR = parcelRequire("3muyR");
var $7ee4885fba7b1e72$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $7ee4885fba7b1e72$var$EmotionCacheContext = /* #__PURE__ */ (0, $3OyDL.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $3KNG1.default)({
    key: 'css'
}) : null);
var $7ee4885fba7b1e72$export$e7094788287c5e9b = $7ee4885fba7b1e72$var$EmotionCacheContext.Provider;
var $7ee4885fba7b1e72$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $3OyDL.useContext)($7ee4885fba7b1e72$var$EmotionCacheContext);
};
var $7ee4885fba7b1e72$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $3OyDL.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $3OyDL.useContext)($7ee4885fba7b1e72$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $7ee4885fba7b1e72$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $3OyDL.createContext)({});
var $7ee4885fba7b1e72$export$3b14a55fb2447963 = function useTheme() {
    return (0, $3OyDL.useContext)($7ee4885fba7b1e72$export$971d5caa766a69d7);
};
var $7ee4885fba7b1e72$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $gOPoC.default)({}, outerTheme, theme);
};
var $7ee4885fba7b1e72$var$createCacheWithTheme = /* #__PURE__ */ (0, $eprzM.default)(function(outerTheme) {
    return (0, $eprzM.default)(function(theme) {
        return $7ee4885fba7b1e72$var$getTheme(outerTheme, theme);
    });
});
var $7ee4885fba7b1e72$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = (0, $3OyDL.useContext)($7ee4885fba7b1e72$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $7ee4885fba7b1e72$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $3OyDL.createElement)($7ee4885fba7b1e72$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $7ee4885fba7b1e72$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = (0, $3OyDL.useContext)($7ee4885fba7b1e72$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $3OyDL.createElement)(Component, (0, $gOPoC.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $3OyDL.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $995ey.default)(WithTheme, Component);
}
var $7ee4885fba7b1e72$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) {
        // The match may be something like 'Object.createEmotionProps'
        var parts = match[1].split('.');
        return parts[parts.length - 1];
    } // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return match[1];
    return undefined;
};
var $7ee4885fba7b1e72$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $7ee4885fba7b1e72$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $7ee4885fba7b1e72$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $7ee4885fba7b1e72$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($7ee4885fba7b1e72$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $7ee4885fba7b1e72$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $7ee4885fba7b1e72$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $7ee4885fba7b1e72$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $7ee4885fba7b1e72$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($7ee4885fba7b1e72$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$7ee4885fba7b1e72$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $7ee4885fba7b1e72$var$Noop = function Noop() {
    return null;
};
var $7ee4885fba7b1e72$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $7ee4885fba7b1e72$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$7ee4885fba7b1e72$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $c8aYa.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $3muyR.serializeStyles)(registeredStyles, undefined, (0, $3OyDL.useContext)($7ee4885fba7b1e72$export$971d5caa766a69d7));
    var labelFromStack;
    var rules = (0, $c8aYa.insertStyles)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($7ee4885fba7b1e72$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $7ee4885fba7b1e72$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $3OyDL.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $3OyDL.createElement)($7ee4885fba7b1e72$var$Noop, null);
    return /*#__PURE__*/ (0, $3OyDL.createElement)((0, $3OyDL.Fragment), null, possiblyStyleElement, ele);
});

});
parcelRegister("eprzM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8ca846b9fc0c8$export$2e2bcd8739ae039);
var $a7d8ca846b9fc0c8$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $a7d8ca846b9fc0c8$export$2e2bcd8739ae039 = $a7d8ca846b9fc0c8$var$weakMemoize;

});

parcelRegister("995ey", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a8903a4d09a070a$export$2e2bcd8739ae039);

var $9PRjv = parcelRequire("9PRjv");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $6a8903a4d09a070a$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9PRjv)))(targetComponent, sourceComponent);
};
var $6a8903a4d09a070a$export$2e2bcd8739ae039 = $6a8903a4d09a070a$var$hoistNonReactStatics;

});
parcelRegister("9PRjv", function(module, exports) {
'use strict';

var $6ZBvu = parcelRequire("6ZBvu");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72923b7805b0512b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72923b7805b0512b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72923b7805b0512b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72923b7805b0512b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72923b7805b0512b$var$TYPE_STATICS = {};
$72923b7805b0512b$var$TYPE_STATICS[$6ZBvu.ForwardRef] = $72923b7805b0512b$var$FORWARD_REF_STATICS;
$72923b7805b0512b$var$TYPE_STATICS[$6ZBvu.Memo] = $72923b7805b0512b$var$MEMO_STATICS;
function $72923b7805b0512b$var$getStatics(component) {
    // React v16.11 and below
    if ($6ZBvu.isMemo(component)) return $72923b7805b0512b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72923b7805b0512b$var$TYPE_STATICS[component['$$typeof']] || $72923b7805b0512b$var$REACT_STATICS;
}
var $72923b7805b0512b$var$defineProperty = Object.defineProperty;
var $72923b7805b0512b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72923b7805b0512b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72923b7805b0512b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72923b7805b0512b$var$getPrototypeOf = Object.getPrototypeOf;
var $72923b7805b0512b$var$objectPrototype = Object.prototype;
function $72923b7805b0512b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72923b7805b0512b$var$objectPrototype) {
            var inheritedComponent = $72923b7805b0512b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72923b7805b0512b$var$objectPrototype) $72923b7805b0512b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72923b7805b0512b$var$getOwnPropertyNames(sourceComponent);
        if ($72923b7805b0512b$var$getOwnPropertySymbols) keys = keys.concat($72923b7805b0512b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72923b7805b0512b$var$getStatics(targetComponent);
        var sourceStatics = $72923b7805b0512b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72923b7805b0512b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72923b7805b0512b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72923b7805b0512b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72923b7805b0512b$var$hoistNonReactStatics;

});
parcelRegister("6ZBvu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("TbtLg"));

});



parcelRegister("c8aYa", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $8d4ebdb11ba7b710$export$95d99596f328fd52);
$parcel$export(module.exports, "insertStyles", () => $8d4ebdb11ba7b710$export$6f077d94b33a01aa);
var $8d4ebdb11ba7b710$var$isBrowser = typeof document !== 'undefined';
function $8d4ebdb11ba7b710$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $8d4ebdb11ba7b710$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $8d4ebdb11ba7b710$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $8d4ebdb11ba7b710$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $8d4ebdb11ba7b710$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$8d4ebdb11ba7b710$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$8d4ebdb11ba7b710$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("3muyR", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $272b220187fae6ff$export$6321afa313b251b5);

var $jdSLA = parcelRequire("jdSLA");

var $3QCZ2 = parcelRequire("3QCZ2");

var $8Uacy = parcelRequire("8Uacy");
var $272b220187fae6ff$var$isDevelopment = false;
var $272b220187fae6ff$var$hyphenateRegex = /[A-Z]|^ms/g;
var $272b220187fae6ff$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $272b220187fae6ff$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $272b220187fae6ff$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $272b220187fae6ff$var$processStyleName = /* #__PURE__ */ (0, $8Uacy.default)(function(styleName) {
    return $272b220187fae6ff$var$isCustomProperty(styleName) ? styleName : styleName.replace($272b220187fae6ff$var$hyphenateRegex, '-$&').toLowerCase();
});
var $272b220187fae6ff$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($272b220187fae6ff$var$animationRegex, function(match, p1, p2) {
                $272b220187fae6ff$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $272b220187fae6ff$var$cursor
                };
                return p1;
            });
    }
    if ((0, $3QCZ2.default)[key] !== 1 && !$272b220187fae6ff$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $272b220187fae6ff$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $272b220187fae6ff$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $272b220187fae6ff$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $272b220187fae6ff$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $272b220187fae6ff$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $272b220187fae6ff$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $272b220187fae6ff$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $272b220187fae6ff$var$cursor;
                var result = interpolation(mergedProps);
                $272b220187fae6ff$var$cursor = previousCursor;
                return $272b220187fae6ff$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $272b220187fae6ff$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $272b220187fae6ff$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($272b220187fae6ff$var$isProcessableValue(asString)) string += $272b220187fae6ff$var$processStyleName(key) + ":" + $272b220187fae6ff$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $272b220187fae6ff$var$isDevelopment) throw new Error($272b220187fae6ff$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($272b220187fae6ff$var$isProcessableValue(value[_i])) string += $272b220187fae6ff$var$processStyleName(key) + ":" + $272b220187fae6ff$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $272b220187fae6ff$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $272b220187fae6ff$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $272b220187fae6ff$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $272b220187fae6ff$var$cursor;
function $272b220187fae6ff$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $272b220187fae6ff$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $272b220187fae6ff$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $272b220187fae6ff$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $272b220187fae6ff$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $272b220187fae6ff$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $jdSLA.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $272b220187fae6ff$var$cursor
    };
}

});
parcelRegister("jdSLA", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfe9b6bb6069bb84$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $dfe9b6bb6069bb84$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("3QCZ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cd477ba95f8086b$export$2e2bcd8739ae039);
var $2cd477ba95f8086b$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});



parcelRegister("4Qmwu", function(module, exports) {
function $386d7d554c322cad$var$_extends() {
    return module.exports = $386d7d554c322cad$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $386d7d554c322cad$var$_extends.apply(null, arguments);
}
module.exports = $386d7d554c322cad$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("1M38U", function(module, exports) {

$parcel$export(module.exports, "default", () => $14acb6375b3a94c4$export$2e2bcd8739ae039);

var $hsK2b = parcelRequire("hsK2b");
'use client';
const $14acb6375b3a94c4$var$defaultTheme = (0, $hsK2b.default)();
var $14acb6375b3a94c4$export$2e2bcd8739ae039 = $14acb6375b3a94c4$var$defaultTheme;

});
parcelRegister("hsK2b", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb68c29ed4896271$export$2e2bcd8739ae039);

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $798ep = parcelRequire("798ep");
var $caYvM = parcelRequire("caYvM");

var $jjyU4 = parcelRequire("jjyU4");
var $a3DMF = parcelRequire("a3DMF");
var $ktnoN = parcelRequire("ktnoN");


var $gvBDJ = parcelRequire("gvBDJ");

var $khAlb = parcelRequire("khAlb");

var $lMov6 = parcelRequire("lMov6");

var $kHQ4P = parcelRequire("kHQ4P");

var $cICjK = parcelRequire("cICjK");

var $hqaTK = parcelRequire("hqaTK");
const $cb68c29ed4896271$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $cb68c29ed4896271$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $aBenZ.default)(options, $cb68c29ed4896271$var$_excluded);
    if (options.vars) throw new Error((0, $caYvM.default)(18));
    const palette = (0, $khAlb.default)(paletteInput);
    const systemTheme = (0, $jjyU4.default)(options);
    let muiTheme = (0, $798ep.default)(systemTheme, {
        mixins: (0, $gvBDJ.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $kHQ4P.default).slice(),
        typography: (0, $lMov6.default)(palette, typographyInput),
        transitions: (0, $cICjK.default)(transitionsInput),
        zIndex: (0, $gOPoC.default)({}, (0, $hqaTK.default))
    });
    muiTheme = (0, $798ep.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $798ep.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $gOPoC.default)({}, (0, $a3DMF.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $ktnoN.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $cb68c29ed4896271$var$warnedOnce = false;
function $cb68c29ed4896271$export$c469355549431d9b(...args) {
    return $cb68c29ed4896271$var$createTheme(...args);
}
var $cb68c29ed4896271$export$2e2bcd8739ae039 = $cb68c29ed4896271$var$createTheme;

});
parcelRegister("gvBDJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c04cbd12fd752e40$export$2e2bcd8739ae039);

var $gOPoC = parcelRequire("gOPoC");
function $c04cbd12fd752e40$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $gOPoC.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("khAlb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec4195b29690e2c1$export$2e2bcd8739ae039);

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $798ep = parcelRequire("798ep");
var $caYvM = parcelRequire("caYvM");

var $7m2iU = parcelRequire("7m2iU");

var $dvPUV = parcelRequire("dvPUV");

var $3mj1r = parcelRequire("3mj1r");

var $kTfAo = parcelRequire("kTfAo");

var $gzSaB = parcelRequire("gzSaB");

var $DF83s = parcelRequire("DF83s");

var $jx3tf = parcelRequire("jx3tf");

var $gZKPO = parcelRequire("gZKPO");

var $ipXpE = parcelRequire("ipXpE");
const $ec4195b29690e2c1$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $ec4195b29690e2c1$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $dvPUV.default).white,
        default: (0, $dvPUV.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $ec4195b29690e2c1$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $dvPUV.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $dvPUV.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $ec4195b29690e2c1$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $7m2iU.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $7m2iU.darken)(intent.main, tonalOffsetDark);
    }
}
function $ec4195b29690e2c1$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $jx3tf.default)[200],
        light: (0, $jx3tf.default)[50],
        dark: (0, $jx3tf.default)[400]
    };
    return {
        main: (0, $jx3tf.default)[700],
        light: (0, $jx3tf.default)[400],
        dark: (0, $jx3tf.default)[800]
    };
}
function $ec4195b29690e2c1$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $kTfAo.default)[200],
        light: (0, $kTfAo.default)[50],
        dark: (0, $kTfAo.default)[400]
    };
    return {
        main: (0, $kTfAo.default)[500],
        light: (0, $kTfAo.default)[300],
        dark: (0, $kTfAo.default)[700]
    };
}
function $ec4195b29690e2c1$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $gzSaB.default)[500],
        light: (0, $gzSaB.default)[300],
        dark: (0, $gzSaB.default)[700]
    };
    return {
        main: (0, $gzSaB.default)[700],
        light: (0, $gzSaB.default)[400],
        dark: (0, $gzSaB.default)[800]
    };
}
function $ec4195b29690e2c1$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $gZKPO.default)[400],
        light: (0, $gZKPO.default)[300],
        dark: (0, $gZKPO.default)[700]
    };
    return {
        main: (0, $gZKPO.default)[700],
        light: (0, $gZKPO.default)[500],
        dark: (0, $gZKPO.default)[900]
    };
}
function $ec4195b29690e2c1$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ipXpE.default)[400],
        light: (0, $ipXpE.default)[300],
        dark: (0, $ipXpE.default)[700]
    };
    return {
        main: (0, $ipXpE.default)[800],
        light: (0, $ipXpE.default)[500],
        dark: (0, $ipXpE.default)[900]
    };
}
function $ec4195b29690e2c1$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $DF83s.default)[400],
        light: (0, $DF83s.default)[300],
        dark: (0, $DF83s.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $DF83s.default)[500],
        dark: (0, $DF83s.default)[900]
    };
}
function $ec4195b29690e2c1$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $aBenZ.default)(palette, $ec4195b29690e2c1$var$_excluded);
    const primary = palette.primary || $ec4195b29690e2c1$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $ec4195b29690e2c1$var$getDefaultSecondary(mode);
    const error = palette.error || $ec4195b29690e2c1$var$getDefaultError(mode);
    const info = palette.info || $ec4195b29690e2c1$var$getDefaultInfo(mode);
    const success = palette.success || $ec4195b29690e2c1$var$getDefaultSuccess(mode);
    const warning = palette.warning || $ec4195b29690e2c1$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $7m2iU.getContrastRatio)(background, $ec4195b29690e2c1$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $ec4195b29690e2c1$export$55ce6f3a06c59543.text.primary : $ec4195b29690e2c1$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $gOPoC.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $caYvM.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $caYvM.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $ec4195b29690e2c1$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $ec4195b29690e2c1$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $ec4195b29690e2c1$export$55ce6f3a06c59543,
        light: $ec4195b29690e2c1$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $798ep.default)((0, $gOPoC.default)({
        // A collection of common colors.
        common: (0, $gOPoC.default)({}, (0, $dvPUV.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $3mj1r.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("7m2iU", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", () => $55ac6001fa385b57$export$d061e26956a60b0a);
$parcel$export(module.exports, "alpha", () => $55ac6001fa385b57$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "darken", () => $55ac6001fa385b57$export$4b073707ff63303);
$parcel$export(module.exports, "lighten", () => $55ac6001fa385b57$export$c0816ed86df316af);
$parcel$export(module.exports, "emphasize", () => $55ac6001fa385b57$export$e665714f76e581fd);

var $caYvM = parcelRequire("caYvM");

var $cX8UD = parcelRequire("cX8UD");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $55ac6001fa385b57$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $cX8UD.default)(value, min, max);
}
function $55ac6001fa385b57$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $55ac6001fa385b57$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $55ac6001fa385b57$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $55ac6001fa385b57$export$677b39864803984e($55ac6001fa385b57$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $caYvM.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $caYvM.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $55ac6001fa385b57$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $55ac6001fa385b57$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $55ac6001fa385b57$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $55ac6001fa385b57$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $55ac6001fa385b57$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $55ac6001fa385b57$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $55ac6001fa385b57$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$55ac6001fa385b57$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $55ac6001fa385b57$export$29fb7152bd3f781a(color) {
    color = $55ac6001fa385b57$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $55ac6001fa385b57$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $55ac6001fa385b57$export$c852d90bf7403b62(color) {
    color = $55ac6001fa385b57$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $55ac6001fa385b57$export$677b39864803984e($55ac6001fa385b57$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $55ac6001fa385b57$export$d061e26956a60b0a(foreground, background) {
    const lumA = $55ac6001fa385b57$export$c852d90bf7403b62(foreground);
    const lumB = $55ac6001fa385b57$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $55ac6001fa385b57$export$58f0f39f63f3cf42(color, value) {
    color = $55ac6001fa385b57$export$677b39864803984e(color);
    value = $55ac6001fa385b57$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $55ac6001fa385b57$export$211a73f2b8c10ce4(color);
}
function $55ac6001fa385b57$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $55ac6001fa385b57$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $55ac6001fa385b57$export$4b073707ff63303(color, coefficient) {
    color = $55ac6001fa385b57$export$677b39864803984e(color);
    coefficient = $55ac6001fa385b57$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $55ac6001fa385b57$export$211a73f2b8c10ce4(color);
}
function $55ac6001fa385b57$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $55ac6001fa385b57$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $55ac6001fa385b57$export$c0816ed86df316af(color, coefficient) {
    color = $55ac6001fa385b57$export$677b39864803984e(color);
    coefficient = $55ac6001fa385b57$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $55ac6001fa385b57$export$211a73f2b8c10ce4(color);
}
function $55ac6001fa385b57$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $55ac6001fa385b57$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $55ac6001fa385b57$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $55ac6001fa385b57$export$c852d90bf7403b62(color) > 0.5 ? $55ac6001fa385b57$export$4b073707ff63303(color, coefficient) : $55ac6001fa385b57$export$c0816ed86df316af(color, coefficient);
}
function $55ac6001fa385b57$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $55ac6001fa385b57$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $55ac6001fa385b57$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $55ac6001fa385b57$export$677b39864803984e(background);
    const overlayColor = $55ac6001fa385b57$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $55ac6001fa385b57$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("cX8UD", function(module, exports) {

$parcel$export(module.exports, "default", () => $96e1e88b9bc25c91$export$2e2bcd8739ae039);
function $96e1e88b9bc25c91$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $96e1e88b9bc25c91$export$2e2bcd8739ae039 = $96e1e88b9bc25c91$var$clamp;

});


parcelRegister("dvPUV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d667147b427e678$export$2e2bcd8739ae039);
const $9d667147b427e678$var$common = {
    black: '#000',
    white: '#fff'
};
var $9d667147b427e678$export$2e2bcd8739ae039 = $9d667147b427e678$var$common;

});

parcelRegister("3mj1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $27222e96b0583b7a$export$2e2bcd8739ae039);
const $27222e96b0583b7a$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $27222e96b0583b7a$export$2e2bcd8739ae039 = $27222e96b0583b7a$var$grey;

});

parcelRegister("kTfAo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f35508bfe500aa3f$export$2e2bcd8739ae039);
const $f35508bfe500aa3f$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $f35508bfe500aa3f$export$2e2bcd8739ae039 = $f35508bfe500aa3f$var$purple;

});

parcelRegister("gzSaB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c119ef48780de361$export$2e2bcd8739ae039);
const $c119ef48780de361$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $c119ef48780de361$export$2e2bcd8739ae039 = $c119ef48780de361$var$red;

});

parcelRegister("DF83s", function(module, exports) {

$parcel$export(module.exports, "default", () => $07738bfa9eaefc6a$export$2e2bcd8739ae039);
const $07738bfa9eaefc6a$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $07738bfa9eaefc6a$export$2e2bcd8739ae039 = $07738bfa9eaefc6a$var$orange;

});

parcelRegister("jx3tf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e383ca95698519aa$export$2e2bcd8739ae039);
const $e383ca95698519aa$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $e383ca95698519aa$export$2e2bcd8739ae039 = $e383ca95698519aa$var$blue;

});

parcelRegister("gZKPO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5f6ac3f04432ef4$export$2e2bcd8739ae039);
const $c5f6ac3f04432ef4$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $c5f6ac3f04432ef4$export$2e2bcd8739ae039 = $c5f6ac3f04432ef4$var$lightBlue;

});

parcelRegister("ipXpE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d688a5f26456e27e$export$2e2bcd8739ae039);
const $d688a5f26456e27e$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $d688a5f26456e27e$export$2e2bcd8739ae039 = $d688a5f26456e27e$var$green;

});


parcelRegister("lMov6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdb1160357576787$export$2e2bcd8739ae039);

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $798ep = parcelRequire("798ep");
const $fdb1160357576787$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $fdb1160357576787$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $fdb1160357576787$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $fdb1160357576787$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $fdb1160357576787$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $fdb1160357576787$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $aBenZ.default)(_ref, $fdb1160357576787$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $gOPoC.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $fdb1160357576787$var$defaultFontFamily ? {
            letterSpacing: `${$fdb1160357576787$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $fdb1160357576787$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $fdb1160357576787$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $798ep.default)((0, $gOPoC.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("kHQ4P", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1303831471f6937$export$2e2bcd8739ae039);
const $f1303831471f6937$var$shadowKeyUmbraOpacity = 0.2;
const $f1303831471f6937$var$shadowKeyPenumbraOpacity = 0.14;
const $f1303831471f6937$var$shadowAmbientShadowOpacity = 0.12;
function $f1303831471f6937$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$f1303831471f6937$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$f1303831471f6937$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$f1303831471f6937$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $f1303831471f6937$var$shadows = [
    'none',
    $f1303831471f6937$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $f1303831471f6937$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $f1303831471f6937$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $f1303831471f6937$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $f1303831471f6937$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $f1303831471f6937$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $f1303831471f6937$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $f1303831471f6937$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $f1303831471f6937$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $f1303831471f6937$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $f1303831471f6937$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $f1303831471f6937$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $f1303831471f6937$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $f1303831471f6937$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $f1303831471f6937$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $f1303831471f6937$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $f1303831471f6937$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $f1303831471f6937$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $f1303831471f6937$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $f1303831471f6937$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $f1303831471f6937$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $f1303831471f6937$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $f1303831471f6937$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $f1303831471f6937$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $f1303831471f6937$export$2e2bcd8739ae039 = $f1303831471f6937$var$shadows;

});

parcelRegister("cICjK", function(module, exports) {

$parcel$export(module.exports, "duration", () => $9427512be246891d$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $9427512be246891d$export$2e2bcd8739ae039);

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");
const $9427512be246891d$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $9427512be246891d$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $9427512be246891d$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $9427512be246891d$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $9427512be246891d$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $9427512be246891d$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $gOPoC.default)({}, $9427512be246891d$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $gOPoC.default)({}, $9427512be246891d$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $aBenZ.default)(options, $9427512be246891d$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $9427512be246891d$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $9427512be246891d$var$formatMs(delay)}`).join(',');
    };
    return (0, $gOPoC.default)({
        getAutoHeightDuration: $9427512be246891d$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("hqaTK", function(module, exports) {

$parcel$export(module.exports, "default", () => $caed51862767b1d5$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $caed51862767b1d5$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $caed51862767b1d5$export$2e2bcd8739ae039 = $caed51862767b1d5$var$zIndex;

});



parcelRegister("joa2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1d80ca873ac1bc4$export$2e2bcd8739ae039);
var $e1d80ca873ac1bc4$export$2e2bcd8739ae039 = '$$material';

});


parcelRegister("jH1k7", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", () => $e5630f51075e7479$export$effb20ecdbf4d6aa);
$parcel$export(module.exports, "slotShouldForwardProp", () => $e5630f51075e7479$export$f10c5a10d27438e5);
$parcel$export(module.exports, "default", () => $e5630f51075e7479$export$2e2bcd8739ae039);

var $aFUPg = parcelRequire("aFUPg");

var $1M38U = parcelRequire("1M38U");

var $joa2L = parcelRequire("joa2L");
'use client';
const $e5630f51075e7479$export$effb20ecdbf4d6aa = (prop)=>(0, $aFUPg.shouldForwardProp)(prop) && prop !== 'classes';
const $e5630f51075e7479$export$f10c5a10d27438e5 = (0, $aFUPg.shouldForwardProp);
const $e5630f51075e7479$var$styled = (0, $aFUPg.default)({
    themeId: (0, $joa2L.default),
    defaultTheme: $1M38U.default,
    rootShouldForwardProp: $e5630f51075e7479$export$effb20ecdbf4d6aa
});
var $e5630f51075e7479$export$2e2bcd8739ae039 = $e5630f51075e7479$var$styled;

});
parcelRegister("aFUPg", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", () => $7c59d023554ac9b3$export$3ba67b570e26eea0);
$parcel$export(module.exports, "default", () => $7c59d023554ac9b3$export$2e2bcd8739ae039);

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $2DySd = parcelRequire("2DySd");

var $798ep = parcelRequire("798ep");



var $jjyU4 = parcelRequire("jjyU4");

var $ktnoN = parcelRequire("ktnoN");
const $7c59d023554ac9b3$var$_excluded = [
    "ownerState"
], $7c59d023554ac9b3$var$_excluded2 = [
    "variants"
], $7c59d023554ac9b3$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $7c59d023554ac9b3$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $7c59d023554ac9b3$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $7c59d023554ac9b3$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $7c59d023554ac9b3$export$35e57303dbd8a66 = (0, $jjyU4.default)();
const $7c59d023554ac9b3$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $7c59d023554ac9b3$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $7c59d023554ac9b3$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $7c59d023554ac9b3$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $7c59d023554ac9b3$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $aBenZ.default)(_ref, $7c59d023554ac9b3$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $gOPoC.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$7c59d023554ac9b3$var$processStyleArg(resolvedStyle, (0, $gOPoC.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $aBenZ.default)(resolvedStylesArg, $7c59d023554ac9b3$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $gOPoC.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $gOPoC.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $7c59d023554ac9b3$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $7c59d023554ac9b3$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $7c59d023554ac9b3$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $7c59d023554ac9b3$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $ktnoN.default)((0, $gOPoC.default)({}, props, {
            theme: $7c59d023554ac9b3$var$resolveTheme((0, $gOPoC.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $2DySd.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $7c59d023554ac9b3$var$defaultOverridesResolver($7c59d023554ac9b3$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $aBenZ.default)(inputOptions, $7c59d023554ac9b3$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $7c59d023554ac9b3$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($7c59d023554ac9b3$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $2DySd.default)(tag, (0, $gOPoC.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $798ep.isPlainObject)(stylesArg)) return (props)=>$7c59d023554ac9b3$var$processStyleArg(stylesArg, (0, $gOPoC.default)({}, props, {
                    theme: $7c59d023554ac9b3$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $7c59d023554ac9b3$var$resolveTheme((0, $gOPoC.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $7c59d023554ac9b3$var$processStyleArg(slotStyle, (0, $gOPoC.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $7c59d023554ac9b3$var$resolveTheme((0, $gOPoC.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $7c59d023554ac9b3$var$processStyleArg({
                    variants: themeVariants
                }, (0, $gOPoC.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("2DySd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1eba466d9441038e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $1eba466d9441038e$export$e00380445f2b9e0c);
/**
 * @mui/styled-engine v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $dkhCc = parcelRequire("dkhCc");

var $hDCOm = parcelRequire("hDCOm");
var $aTrHR = parcelRequire("aTrHR");


var $b6qO8 = parcelRequire("b6qO8");
'use client';
function $1eba466d9441038e$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $dkhCc.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $1eba466d9441038e$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("dkhCc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3ace9eeed9e2ac$export$2e2bcd8739ae039);
parcelRequire("4Qmwu");
parcelRequire("3OyDL");
parcelRequire("iSL8t");

var $bFUfG = parcelRequire("bFUfG");

parcelRequire("c8aYa");
parcelRequire("3muyR");
var $9b3ace9eeed9e2ac$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $9b3ace9eeed9e2ac$var$newStyled = (0, $bFUfG.default).bind();
$9b3ace9eeed9e2ac$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $9b3ace9eeed9e2ac$var$newStyled[tagName] = $9b3ace9eeed9e2ac$var$newStyled(tagName);
});
var $9b3ace9eeed9e2ac$export$2e2bcd8739ae039 = $9b3ace9eeed9e2ac$var$newStyled;

});
parcelRegister("iSL8t", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbf1d54a71190cec$export$2e2bcd8739ae039);

var $8Uacy = parcelRequire("8Uacy");
// eslint-disable-next-line no-undef
var $dbf1d54a71190cec$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $dbf1d54a71190cec$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $8Uacy.default)(function(prop) {
    return $dbf1d54a71190cec$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});

parcelRegister("bFUfG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ff288458c7aba7$export$2e2bcd8739ae039);

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $iSL8t = parcelRequire("iSL8t");
parcelRequire("hDCOm");
var $aTrHR = parcelRequire("aTrHR");

var $c8aYa = parcelRequire("c8aYa");

var $3muyR = parcelRequire("3muyR");
var $87ff288458c7aba7$var$testOmitPropsOnStringTag = (0, $iSL8t.default);
var $87ff288458c7aba7$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $87ff288458c7aba7$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $87ff288458c7aba7$var$testOmitPropsOnStringTag : $87ff288458c7aba7$var$testOmitPropsOnComponent;
};
var $87ff288458c7aba7$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $87ff288458c7aba7$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $87ff288458c7aba7$var$Noop = function Noop() {
    return null;
};
var $87ff288458c7aba7$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $87ff288458c7aba7$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $87ff288458c7aba7$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $aTrHR.w)(function(props, cache, ref) {
            var finalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $3OyDL.useContext)((0, $aTrHR.T));
            }
            if (typeof props.className === 'string') className = (0, $c8aYa.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $3muyR.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            var rules = (0, $c8aYa.insertStyles)(cache, serialized, typeof finalTag === 'string');
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $87ff288458c7aba7$var$getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            var ele = /*#__PURE__*/ (0, $3OyDL.createElement)(finalTag, newProps);
            var possiblyStyleElement = /*#__PURE__*/ (0, $3OyDL.createElement)($87ff288458c7aba7$var$Noop, null);
            return /*#__PURE__*/ (0, $3OyDL.createElement)((0, $3OyDL.Fragment), null, possiblyStyleElement, ele);
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $gOPoC.default)({}, options, nextOptions, {
                shouldForwardProp: $87ff288458c7aba7$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $87ff288458c7aba7$export$2e2bcd8739ae039 = $87ff288458c7aba7$var$createStyled;

});


parcelRegister("b6qO8", function(module, exports) {

$parcel$export(module.exports, "default", () => $81550cb276878e24$export$2e2bcd8739ae039);
parcelRequire("3OyDL");


var $hDCOm = parcelRequire("hDCOm");

var $2M70Q = parcelRequire("2M70Q");
'use client';
function $81550cb276878e24$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $81550cb276878e24$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($81550cb276878e24$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $hDCOm.Global), {
        styles: globalStyles
    });
}

});
parcelRegister("2M70Q", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bDyTI"));

});





parcelRegister("8yqfj", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $63a5db975fae286f$export$c7c50641356bdfa5);

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $63a5db975fae286f$export$c7c50641356bdfa5(slot) {
    return (0, $6AMoU.default)('MuiSvgIcon', slot);
}
const $63a5db975fae286f$var$svgIconClasses = (0, $ithJf.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $63a5db975fae286f$export$2e2bcd8739ae039 = $63a5db975fae286f$var$svgIconClasses;

});
parcelRegister("ithJf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d728affbea70b3ae$export$2e2bcd8739ae039);

var $6AMoU = parcelRequire("6AMoU");
function $d728affbea70b3ae$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $6AMoU.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("6AMoU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ccba6405d31bd76$export$2e2bcd8739ae039);

var $jFRWu = parcelRequire("jFRWu");
const $4ccba6405d31bd76$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $4ccba6405d31bd76$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $4ccba6405d31bd76$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $jFRWu.default).generate(componentName)}-${slot}`;
}
function $4ccba6405d31bd76$export$34c0130b1f3e8ae3(slot) {
    return $4ccba6405d31bd76$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("jFRWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e52bb07ee0b39ca5$export$2e2bcd8739ae039);
const $e52bb07ee0b39ca5$var$defaultGenerator = (componentName)=>componentName;
const $e52bb07ee0b39ca5$var$createClassNameGenerator = ()=>{
    let generate = $e52bb07ee0b39ca5$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $e52bb07ee0b39ca5$var$defaultGenerator;
        }
    };
};
const $e52bb07ee0b39ca5$var$ClassNameGenerator = $e52bb07ee0b39ca5$var$createClassNameGenerator();
var $e52bb07ee0b39ca5$export$2e2bcd8739ae039 = $e52bb07ee0b39ca5$var$ClassNameGenerator;

});







parcelRegister("41GnX", function(module, exports) {

$parcel$export(module.exports, "createRule", () => createRule);
$parcel$export(module.exports, "toCssValue", () => toCssValue);
$parcel$export(module.exports, "RuleList", () => RuleList);
$parcel$export(module.exports, "create", () => createJss);
$parcel$export(module.exports, "hasCSSTOMSupport", () => hasCSSTOMSupport);
$parcel$export(module.exports, "getDynamicStyles", () => getDynamicStyles);

var $gOPoC = parcelRequire("gOPoC");

var $9DnwR = parcelRequire("9DnwR");

var $cyGxg = parcelRequire("cyGxg");

var $ct8ww = parcelRequire("ct8ww");

var $jNtCy = parcelRequire("jNtCy");

var $45Uts = parcelRequire("45Uts");

var $aBenZ = parcelRequire("aBenZ");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $jNtCy.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $45Uts.default)((0, $45Uts.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    };
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    };
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $gOPoC.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $ct8ww.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $gOPoC.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = 'noname';
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $gOPoC.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $gOPoC.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $jNtCy.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $gOPoC.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $gOPoC.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    };
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $gOPoC.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    };
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    };
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    };
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    };
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    };
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    };
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    };
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $gOPoC.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    };
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    };
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    };
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    };
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    };
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    };
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    };
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    };
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    };
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    };
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    };
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    };
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    };
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    };
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    };
    _proto.reset = function reset() {
        this.registry = [];
    };
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    };
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $aBenZ.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $ct8ww.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    };
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    };
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    };
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    };
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    };
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    };
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    };
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    };
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $9DnwR.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $gOPoC.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    };
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $gOPoC.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    };
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    };
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = (0, $gOPoC.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $cyGxg.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $cyGxg.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $ct8ww.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $2ee8224854de3909$export$2e2bcd8739ae039 = index;

});
parcelRegister("9DnwR", function(module, exports) {

$parcel$export(module.exports, "default", () => $703a01f11291e221$export$2e2bcd8739ae039);
var $703a01f11291e221$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $703a01f11291e221$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $703a01f11291e221$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $703a01f11291e221$var$_typeof(document)) === 'object' && document.nodeType === 9;
var $703a01f11291e221$export$2e2bcd8739ae039 = $703a01f11291e221$export$4e09c449d6c407f7;

});

parcelRegister("cyGxg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9249a7a90851aecf$export$2e2bcd8739ae039);
var $9249a7a90851aecf$var$isProduction = true;
function $9249a7a90851aecf$var$warning(condition, message) {
    if (!$9249a7a90851aecf$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $9249a7a90851aecf$export$2e2bcd8739ae039 = $9249a7a90851aecf$var$warning;

});

parcelRegister("ct8ww", function(module, exports) {

$parcel$export(module.exports, "default", () => $913ece109e98ed1d$export$2e2bcd8739ae039);

var $h2uGY = parcelRequire("h2uGY");
function $913ece109e98ed1d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $h2uGY.default)(o.key), o);
    }
}
function $913ece109e98ed1d$export$2e2bcd8739ae039(e, r, t) {
    return r && $913ece109e98ed1d$var$_defineProperties(e.prototype, r), t && $913ece109e98ed1d$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("h2uGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c67a6e63466ed303$export$2e2bcd8739ae039);

var $6vszX = parcelRequire("6vszX");

var $kvgXs = parcelRequire("kvgXs");
function $c67a6e63466ed303$export$2e2bcd8739ae039(t) {
    var i = (0, $kvgXs.default)(t, "string");
    return "symbol" == (0, $6vszX.default)(i) ? i : i + "";
}

});
parcelRegister("6vszX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bcbce884bb2e105$export$2e2bcd8739ae039);
function $4bcbce884bb2e105$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $4bcbce884bb2e105$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4bcbce884bb2e105$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kvgXs", function(module, exports) {

$parcel$export(module.exports, "default", () => $eed3db61674f6f45$export$2e2bcd8739ae039);

var $6vszX = parcelRequire("6vszX");
function $eed3db61674f6f45$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $6vszX.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $6vszX.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("jNtCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e69992054018756e$export$2e2bcd8739ae039);

var $4Cm2L = parcelRequire("4Cm2L");
function $e69992054018756e$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $4Cm2L.default)(t, o);
}

});
parcelRegister("4Cm2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cbcf67d2be7b3e$export$2e2bcd8739ae039);
function $35cbcf67d2be7b3e$export$2e2bcd8739ae039(t, e) {
    return $35cbcf67d2be7b3e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $35cbcf67d2be7b3e$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("45Uts", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fb36fa51c62dce1$export$2e2bcd8739ae039);
function $2fb36fa51c62dce1$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("e1GlX", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $1ScJX = parcelRequire("1ScJX");
function $a362031fb230b69d$var$emptyFunction() {}
function $a362031fb230b69d$var$emptyFunctionWithReset() {}
$a362031fb230b69d$var$emptyFunctionWithReset.resetWarningCache = $a362031fb230b69d$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $1ScJX) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a362031fb230b69d$var$emptyFunctionWithReset,
        resetWarningCache: $a362031fb230b69d$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("1ScJX", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $15d4b790302be854$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $15d4b790302be854$var$ReactPropTypesSecret;

});


parcelRegister("iaJl6", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $d3ac54a459011270$export$307591e98609eddd, (v) => $d3ac54a459011270$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $d3ac54a459011270$export$eb3a06aef9e6ee51, (v) => $d3ac54a459011270$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $d3ac54a459011270$export$b23711c915539651, (v) => $d3ac54a459011270$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $d3ac54a459011270$export$80e7718417253a51, (v) => $d3ac54a459011270$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $d3ac54a459011270$export$83d89fbfd8236492, (v) => $d3ac54a459011270$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d3ac54a459011270$export$307591e98609eddd;
var $d3ac54a459011270$export$eb3a06aef9e6ee51;
var $d3ac54a459011270$export$b23711c915539651;
var $d3ac54a459011270$export$80e7718417253a51;
var $d3ac54a459011270$export$83d89fbfd8236492;
'use strict';

var $gZVC5 = parcelRequire("gZVC5");

var $3OyDL = parcelRequire("3OyDL");
function $d3ac54a459011270$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $d3ac54a459011270$var$q = 60106, $d3ac54a459011270$var$r = 60107, $d3ac54a459011270$var$u = 60108, $d3ac54a459011270$var$z = 60114, $d3ac54a459011270$var$B = 60109, $d3ac54a459011270$var$aa = 60110, $d3ac54a459011270$var$ba = 60112, $d3ac54a459011270$var$D = 60113, $d3ac54a459011270$var$ca = 60120, $d3ac54a459011270$var$da = 60115, $d3ac54a459011270$var$ea = 60116, $d3ac54a459011270$var$fa = 60121, $d3ac54a459011270$var$ha = 60117, $d3ac54a459011270$var$ia = 60119, $d3ac54a459011270$var$ja = 60129, $d3ac54a459011270$var$ka = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $d3ac54a459011270$var$E = Symbol.for;
    $d3ac54a459011270$var$q = $d3ac54a459011270$var$E("react.portal");
    $d3ac54a459011270$var$r = $d3ac54a459011270$var$E("react.fragment");
    $d3ac54a459011270$var$u = $d3ac54a459011270$var$E("react.strict_mode");
    $d3ac54a459011270$var$z = $d3ac54a459011270$var$E("react.profiler");
    $d3ac54a459011270$var$B = $d3ac54a459011270$var$E("react.provider");
    $d3ac54a459011270$var$aa = $d3ac54a459011270$var$E("react.context");
    $d3ac54a459011270$var$ba = $d3ac54a459011270$var$E("react.forward_ref");
    $d3ac54a459011270$var$D = $d3ac54a459011270$var$E("react.suspense");
    $d3ac54a459011270$var$ca = $d3ac54a459011270$var$E("react.suspense_list");
    $d3ac54a459011270$var$da = $d3ac54a459011270$var$E("react.memo");
    $d3ac54a459011270$var$ea = $d3ac54a459011270$var$E("react.lazy");
    $d3ac54a459011270$var$fa = $d3ac54a459011270$var$E("react.block");
    $d3ac54a459011270$var$ha = $d3ac54a459011270$var$E("react.fundamental");
    $d3ac54a459011270$var$ia = $d3ac54a459011270$var$E("react.scope");
    $d3ac54a459011270$var$ja = $d3ac54a459011270$var$E("react.debug_trace_mode");
    $d3ac54a459011270$var$ka = $d3ac54a459011270$var$E("react.legacy_hidden");
}
function $d3ac54a459011270$var$F(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $d3ac54a459011270$var$r:
            return "Fragment";
        case $d3ac54a459011270$var$q:
            return "Portal";
        case $d3ac54a459011270$var$z:
            return "Profiler";
        case $d3ac54a459011270$var$u:
            return "StrictMode";
        case $d3ac54a459011270$var$D:
            return "Suspense";
        case $d3ac54a459011270$var$ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $d3ac54a459011270$var$aa:
            return (a.displayName || "Context") + ".Consumer";
        case $d3ac54a459011270$var$B:
            return (a._context.displayName || "Context") + ".Provider";
        case $d3ac54a459011270$var$ba:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $d3ac54a459011270$var$da:
            return $d3ac54a459011270$var$F(a.type);
        case $d3ac54a459011270$var$fa:
            return $d3ac54a459011270$var$F(a._render);
        case $d3ac54a459011270$var$ea:
            b = a._payload;
            a = a._init;
            try {
                return $d3ac54a459011270$var$F(a(b));
            } catch (c) {}
    }
    return null;
}
var $d3ac54a459011270$var$la = $3OyDL.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $d3ac54a459011270$var$ma = {};
function $d3ac54a459011270$var$I(a, b) {
    for(var c = a._threadCount | 0; c <= b; c++)a[c] = a._currentValue2, a._threadCount = c + 1;
}
function $d3ac54a459011270$var$na(a, b, c, d) {
    if (d && (d = a.contextType, "object" === typeof d && null !== d)) return $d3ac54a459011270$var$I(d, c), d[c];
    if (a = a.contextTypes) {
        c = {};
        for(var f in a)c[f] = b[f];
        b = c;
    } else b = $d3ac54a459011270$var$ma;
    return b;
}
for(var $d3ac54a459011270$var$J = new Uint16Array(16), $d3ac54a459011270$var$K = 0; 15 > $d3ac54a459011270$var$K; $d3ac54a459011270$var$K++)$d3ac54a459011270$var$J[$d3ac54a459011270$var$K] = $d3ac54a459011270$var$K + 1;
$d3ac54a459011270$var$J[15] = 0;
var $d3ac54a459011270$var$oa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $d3ac54a459011270$var$pa = Object.prototype.hasOwnProperty, $d3ac54a459011270$var$qa = {}, $d3ac54a459011270$var$ra = {};
function $d3ac54a459011270$var$sa(a) {
    if ($d3ac54a459011270$var$pa.call($d3ac54a459011270$var$ra, a)) return !0;
    if ($d3ac54a459011270$var$pa.call($d3ac54a459011270$var$qa, a)) return !1;
    if ($d3ac54a459011270$var$oa.test(a)) return $d3ac54a459011270$var$ra[a] = !0;
    $d3ac54a459011270$var$qa[a] = !0;
    return !1;
}
function $d3ac54a459011270$var$ta(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $d3ac54a459011270$var$ua(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $d3ac54a459011270$var$ta(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $d3ac54a459011270$var$M(a, b, c, d, f, h, t) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = h;
    this.removeEmptyString = t;
}
var $d3ac54a459011270$var$N = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $d3ac54a459011270$var$N[a] = new $d3ac54a459011270$var$M(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $d3ac54a459011270$var$N[b] = new $d3ac54a459011270$var$M(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $d3ac54a459011270$var$N[a] = new $d3ac54a459011270$var$M(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $d3ac54a459011270$var$N[a] = new $d3ac54a459011270$var$M(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $d3ac54a459011270$var$N[a] = new $d3ac54a459011270$var$M(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $d3ac54a459011270$var$N[a] = new $d3ac54a459011270$var$M(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $d3ac54a459011270$var$N[a] = new $d3ac54a459011270$var$M(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $d3ac54a459011270$var$N[a] = new $d3ac54a459011270$var$M(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $d3ac54a459011270$var$N[a] = new $d3ac54a459011270$var$M(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $d3ac54a459011270$var$va = /[\-:]([a-z])/g;
function $d3ac54a459011270$var$wa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($d3ac54a459011270$var$va, $d3ac54a459011270$var$wa);
    $d3ac54a459011270$var$N[b] = new $d3ac54a459011270$var$M(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($d3ac54a459011270$var$va, $d3ac54a459011270$var$wa);
    $d3ac54a459011270$var$N[b] = new $d3ac54a459011270$var$M(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($d3ac54a459011270$var$va, $d3ac54a459011270$var$wa);
    $d3ac54a459011270$var$N[b] = new $d3ac54a459011270$var$M(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $d3ac54a459011270$var$N[a] = new $d3ac54a459011270$var$M(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$d3ac54a459011270$var$N.xlinkHref = new $d3ac54a459011270$var$M("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $d3ac54a459011270$var$N[a] = new $d3ac54a459011270$var$M(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $d3ac54a459011270$var$xa = /["'&<>]/;
function $d3ac54a459011270$var$O(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $d3ac54a459011270$var$xa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
function $d3ac54a459011270$var$ya(a, b) {
    var c = $d3ac54a459011270$var$N.hasOwnProperty(a) ? $d3ac54a459011270$var$N[a] : null;
    var d;
    if (d = "style" !== a) d = null !== c ? 0 === c.type : !(2 < a.length) || "o" !== a[0] && "O" !== a[0] || "n" !== a[1] && "N" !== a[1] ? !1 : !0;
    if (d || $d3ac54a459011270$var$ua(a, b, c, !1)) return "";
    if (null !== c) {
        a = c.attributeName;
        d = c.type;
        if (3 === d || 4 === d && !0 === b) return a + '=""';
        c.sanitizeURL && (b = "" + b);
        return a + '="' + ($d3ac54a459011270$var$O(b) + '"');
    }
    return $d3ac54a459011270$var$sa(a) ? a + '="' + ($d3ac54a459011270$var$O(b) + '"') : "";
}
function $d3ac54a459011270$var$za(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d3ac54a459011270$var$Aa = "function" === typeof Object.is ? Object.is : $d3ac54a459011270$var$za, $d3ac54a459011270$var$P = null, $d3ac54a459011270$var$Q = null, $d3ac54a459011270$var$R = null, $d3ac54a459011270$var$S = !1, $d3ac54a459011270$var$T = !1, $d3ac54a459011270$var$U = null, $d3ac54a459011270$var$V = 0;
function $d3ac54a459011270$var$W() {
    if (null === $d3ac54a459011270$var$P) throw Error($d3ac54a459011270$var$p(321));
    return $d3ac54a459011270$var$P;
}
function $d3ac54a459011270$var$Ba() {
    if (0 < $d3ac54a459011270$var$V) throw Error($d3ac54a459011270$var$p(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $d3ac54a459011270$var$Ca() {
    null === $d3ac54a459011270$var$R ? null === $d3ac54a459011270$var$Q ? ($d3ac54a459011270$var$S = !1, $d3ac54a459011270$var$Q = $d3ac54a459011270$var$R = $d3ac54a459011270$var$Ba()) : ($d3ac54a459011270$var$S = !0, $d3ac54a459011270$var$R = $d3ac54a459011270$var$Q) : null === $d3ac54a459011270$var$R.next ? ($d3ac54a459011270$var$S = !1, $d3ac54a459011270$var$R = $d3ac54a459011270$var$R.next = $d3ac54a459011270$var$Ba()) : ($d3ac54a459011270$var$S = !0, $d3ac54a459011270$var$R = $d3ac54a459011270$var$R.next);
    return $d3ac54a459011270$var$R;
}
function $d3ac54a459011270$var$Da(a, b, c, d) {
    for(; $d3ac54a459011270$var$T;)$d3ac54a459011270$var$T = !1, $d3ac54a459011270$var$V += 1, $d3ac54a459011270$var$R = null, c = a(b, d);
    $d3ac54a459011270$var$Ea();
    return c;
}
function $d3ac54a459011270$var$Ea() {
    $d3ac54a459011270$var$P = null;
    $d3ac54a459011270$var$T = !1;
    $d3ac54a459011270$var$Q = null;
    $d3ac54a459011270$var$V = 0;
    $d3ac54a459011270$var$R = $d3ac54a459011270$var$U = null;
}
function $d3ac54a459011270$var$Fa(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $d3ac54a459011270$var$Ga(a, b, c) {
    $d3ac54a459011270$var$P = $d3ac54a459011270$var$W();
    $d3ac54a459011270$var$R = $d3ac54a459011270$var$Ca();
    if ($d3ac54a459011270$var$S) {
        var d = $d3ac54a459011270$var$R.queue;
        b = d.dispatch;
        if (null !== $d3ac54a459011270$var$U && (c = $d3ac54a459011270$var$U.get(d), void 0 !== c)) {
            $d3ac54a459011270$var$U.delete(d);
            d = $d3ac54a459011270$var$R.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $d3ac54a459011270$var$R.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $d3ac54a459011270$var$R.memoizedState,
            b
        ];
    }
    a = a === $d3ac54a459011270$var$Fa ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $d3ac54a459011270$var$R.memoizedState = a;
    a = $d3ac54a459011270$var$R.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $d3ac54a459011270$var$Ha.bind(null, $d3ac54a459011270$var$P, a);
    return [
        $d3ac54a459011270$var$R.memoizedState,
        a
    ];
}
function $d3ac54a459011270$var$Ia(a, b) {
    $d3ac54a459011270$var$P = $d3ac54a459011270$var$W();
    $d3ac54a459011270$var$R = $d3ac54a459011270$var$Ca();
    b = void 0 === b ? null : b;
    if (null !== $d3ac54a459011270$var$R) {
        var c = $d3ac54a459011270$var$R.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$d3ac54a459011270$var$Aa(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $d3ac54a459011270$var$R.memoizedState = [
        a,
        b
    ];
    return a;
}
function $d3ac54a459011270$var$Ha(a, b, c) {
    if (!(25 > $d3ac54a459011270$var$V)) throw Error($d3ac54a459011270$var$p(301));
    if (a === $d3ac54a459011270$var$P) {
        if ($d3ac54a459011270$var$T = !0, a = {
            action: c,
            next: null
        }, null === $d3ac54a459011270$var$U && ($d3ac54a459011270$var$U = new Map), c = $d3ac54a459011270$var$U.get(b), void 0 === c) $d3ac54a459011270$var$U.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $d3ac54a459011270$var$Ja() {}
var $d3ac54a459011270$var$X = null, $d3ac54a459011270$var$Ka = {
    readContext: function(a) {
        var b = $d3ac54a459011270$var$X.threadID;
        $d3ac54a459011270$var$I(a, b);
        return a[b];
    },
    useContext: function(a) {
        $d3ac54a459011270$var$W();
        var b = $d3ac54a459011270$var$X.threadID;
        $d3ac54a459011270$var$I(a, b);
        return a[b];
    },
    useMemo: $d3ac54a459011270$var$Ia,
    useReducer: $d3ac54a459011270$var$Ga,
    useRef: function(a) {
        $d3ac54a459011270$var$P = $d3ac54a459011270$var$W();
        $d3ac54a459011270$var$R = $d3ac54a459011270$var$Ca();
        var b = $d3ac54a459011270$var$R.memoizedState;
        return null === b ? (a = {
            current: a
        }, $d3ac54a459011270$var$R.memoizedState = a) : b;
    },
    useState: function(a) {
        return $d3ac54a459011270$var$Ga($d3ac54a459011270$var$Fa, a);
    },
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $d3ac54a459011270$var$Ia(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $d3ac54a459011270$var$Ja,
    useEffect: $d3ac54a459011270$var$Ja,
    useDebugValue: $d3ac54a459011270$var$Ja,
    useDeferredValue: function(a) {
        $d3ac54a459011270$var$W();
        return a;
    },
    useTransition: function() {
        $d3ac54a459011270$var$W();
        return [
            function(a) {
                a();
            },
            !1
        ];
    },
    useOpaqueIdentifier: function() {
        return ($d3ac54a459011270$var$X.identifierPrefix || "") + "R:" + ($d3ac54a459011270$var$X.uniqueID++).toString(36);
    },
    useMutableSource: function(a, b) {
        $d3ac54a459011270$var$W();
        return b(a._source);
    }
}, $d3ac54a459011270$var$La = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $d3ac54a459011270$var$Ma(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
var $d3ac54a459011270$var$Na = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
}, $d3ac54a459011270$var$Oa = $gZVC5({
    menuitem: !0
}, $d3ac54a459011270$var$Na), $d3ac54a459011270$var$Y = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $d3ac54a459011270$var$Pa = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($d3ac54a459011270$var$Y).forEach(function(a) {
    $d3ac54a459011270$var$Pa.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $d3ac54a459011270$var$Y[b] = $d3ac54a459011270$var$Y[a];
    });
});
var $d3ac54a459011270$var$Qa = /([A-Z])/g, $d3ac54a459011270$var$Ra = /^ms-/, $d3ac54a459011270$var$Z = $3OyDL.Children.toArray, $d3ac54a459011270$var$Sa = $d3ac54a459011270$var$la.ReactCurrentDispatcher, $d3ac54a459011270$var$Ta = {
    listing: !0,
    pre: !0,
    textarea: !0
}, $d3ac54a459011270$var$Ua = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $d3ac54a459011270$var$Va = {}, $d3ac54a459011270$var$Wa = {};
function $d3ac54a459011270$var$Xa(a) {
    if (void 0 === a || null === a) return a;
    var b = "";
    $3OyDL.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $d3ac54a459011270$var$Ya = Object.prototype.hasOwnProperty, $d3ac54a459011270$var$Za = {
    children: null,
    dangerouslySetInnerHTML: null,
    suppressContentEditableWarning: null,
    suppressHydrationWarning: null
};
function $d3ac54a459011270$var$$a(a, b) {
    if (void 0 === a) throw Error($d3ac54a459011270$var$p(152, $d3ac54a459011270$var$F(b) || "Component"));
}
function $d3ac54a459011270$var$ab(a, b, c) {
    function d(d, h) {
        var e = h.prototype && h.prototype.isReactComponent, f = $d3ac54a459011270$var$na(h, b, c, e), t = [], g = !1, n = {
            isMounted: function() {
                return !1;
            },
            enqueueForceUpdate: function() {
                if (null === t) return null;
            },
            enqueueReplaceState: function(a, c) {
                g = !0;
                t = [
                    c
                ];
            },
            enqueueSetState: function(a, c) {
                if (null === t) return null;
                t.push(c);
            }
        };
        if (e) {
            if (e = new h(d.props, f, n), "function" === typeof h.getDerivedStateFromProps) {
                var k = h.getDerivedStateFromProps.call(null, d.props, e.state);
                null != k && (e.state = $gZVC5({}, e.state, k));
            }
        } else if ($d3ac54a459011270$var$P = {}, e = h(d.props, f, n), e = $d3ac54a459011270$var$Da(h, d.props, e, f), null == e || null == e.render) {
            a = e;
            $d3ac54a459011270$var$$a(a, h);
            return;
        }
        e.props = d.props;
        e.context = f;
        e.updater = n;
        n = e.state;
        void 0 === n && (e.state = n = null);
        if ("function" === typeof e.UNSAFE_componentWillMount || "function" === typeof e.componentWillMount) {
            if ("function" === typeof e.componentWillMount && "function" !== typeof h.getDerivedStateFromProps && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && "function" !== typeof h.getDerivedStateFromProps && e.UNSAFE_componentWillMount(), t.length) {
                n = t;
                var v = g;
                t = null;
                g = !1;
                if (v && 1 === n.length) e.state = n[0];
                else {
                    k = v ? n[0] : e.state;
                    var H = !0;
                    for(v = v ? 1 : 0; v < n.length; v++){
                        var x = n[v];
                        x = "function" === typeof x ? x.call(e, k, d.props, f) : x;
                        null != x && (H ? (H = !1, k = $gZVC5({}, k, x)) : $gZVC5(k, x));
                    }
                    e.state = k;
                }
            } else t = null;
        }
        a = e.render();
        $d3ac54a459011270$var$$a(a, h);
        if ("function" === typeof e.getChildContext && (d = h.childContextTypes, "object" === typeof d)) {
            var y = e.getChildContext();
            for(var A in y)if (!(A in d)) throw Error($d3ac54a459011270$var$p(108, $d3ac54a459011270$var$F(h) || "Unknown", A));
        }
        y && (b = $gZVC5({}, b, y));
    }
    for(; $3OyDL.isValidElement(a);){
        var f = a, h = f.type;
        if ("function" !== typeof h) break;
        d(f, h);
    }
    return {
        child: a,
        context: b
    };
}
var $d3ac54a459011270$var$bb = function() {
    function a(a, b, f) {
        $3OyDL.isValidElement(a) ? a.type !== $d3ac54a459011270$var$r ? a = [
            a
        ] : (a = a.props.children, a = $3OyDL.isValidElement(a) ? [
            a
        ] : $d3ac54a459011270$var$Z(a)) : a = $d3ac54a459011270$var$Z(a);
        a = {
            type: null,
            domNamespace: $d3ac54a459011270$var$La.html,
            children: a,
            childIndex: 0,
            context: $d3ac54a459011270$var$ma,
            footer: ""
        };
        var c = $d3ac54a459011270$var$J[0];
        if (0 === c) {
            var d = $d3ac54a459011270$var$J;
            c = d.length;
            var g = 2 * c;
            if (!(65536 >= g)) throw Error($d3ac54a459011270$var$p(304));
            var e = new Uint16Array(g);
            e.set(d);
            $d3ac54a459011270$var$J = e;
            $d3ac54a459011270$var$J[0] = c + 1;
            for(d = c; d < g - 1; d++)$d3ac54a459011270$var$J[d] = d + 1;
            $d3ac54a459011270$var$J[g - 1] = 0;
        } else $d3ac54a459011270$var$J[0] = $d3ac54a459011270$var$J[c];
        this.threadID = c;
        this.stack = [
            a
        ];
        this.exhausted = !1;
        this.currentSelectValue = null;
        this.previousWasTextNode = !1;
        this.makeStaticMarkup = b;
        this.suspenseDepth = 0;
        this.contextIndex = -1;
        this.contextStack = [];
        this.contextValueStack = [];
        this.uniqueID = 0;
        this.identifierPrefix = f && f.identifierPrefix || "";
    }
    var b = a.prototype;
    b.destroy = function() {
        if (!this.exhausted) {
            this.exhausted = !0;
            this.clearProviders();
            var a = this.threadID;
            $d3ac54a459011270$var$J[a] = $d3ac54a459011270$var$J[0];
            $d3ac54a459011270$var$J[0] = a;
        }
    };
    b.pushProvider = function(a) {
        var b = ++this.contextIndex, c = a.type._context, h = this.threadID;
        $d3ac54a459011270$var$I(c, h);
        var t = c[h];
        this.contextStack[b] = c;
        this.contextValueStack[b] = t;
        c[h] = a.props.value;
    };
    b.popProvider = function() {
        var a = this.contextIndex, b = this.contextStack[a], f = this.contextValueStack[a];
        this.contextStack[a] = null;
        this.contextValueStack[a] = null;
        this.contextIndex--;
        b[this.threadID] = f;
    };
    b.clearProviders = function() {
        for(var a = this.contextIndex; 0 <= a; a--)this.contextStack[a][this.threadID] = this.contextValueStack[a];
    };
    b.read = function(a) {
        if (this.exhausted) return null;
        var b = $d3ac54a459011270$var$X;
        $d3ac54a459011270$var$X = this;
        var c = $d3ac54a459011270$var$Sa.current;
        $d3ac54a459011270$var$Sa.current = $d3ac54a459011270$var$Ka;
        try {
            for(var h = [
                ""
            ], t = !1; h[0].length < a;){
                if (0 === this.stack.length) {
                    this.exhausted = !0;
                    var g = this.threadID;
                    $d3ac54a459011270$var$J[g] = $d3ac54a459011270$var$J[0];
                    $d3ac54a459011270$var$J[0] = g;
                    break;
                }
                var e = this.stack[this.stack.length - 1];
                if (t || e.childIndex >= e.children.length) {
                    var L = e.footer;
                    "" !== L && (this.previousWasTextNode = !1);
                    this.stack.pop();
                    if ("select" === e.type) this.currentSelectValue = null;
                    else if (null != e.type && null != e.type.type && e.type.type.$$typeof === $d3ac54a459011270$var$B) this.popProvider(e.type);
                    else if (e.type === $d3ac54a459011270$var$D) {
                        this.suspenseDepth--;
                        var G = h.pop();
                        if (t) {
                            t = !1;
                            var C = e.fallbackFrame;
                            if (!C) throw Error($d3ac54a459011270$var$p(303));
                            this.stack.push(C);
                            h[this.suspenseDepth] += "\x3c!--$!--\x3e";
                            continue;
                        } else h[this.suspenseDepth] += G;
                    }
                    h[this.suspenseDepth] += L;
                } else {
                    var n = e.children[e.childIndex++], k = "";
                    try {
                        k += this.render(n, e.context, e.domNamespace);
                    } catch (v) {
                        if (null != v && "function" === typeof v.then) throw Error($d3ac54a459011270$var$p(294));
                        throw v;
                    } finally{}
                    h.length <= this.suspenseDepth && h.push("");
                    h[this.suspenseDepth] += k;
                }
            }
            return h[0];
        } finally{
            $d3ac54a459011270$var$Sa.current = c, $d3ac54a459011270$var$X = b, $d3ac54a459011270$var$Ea();
        }
    };
    b.render = function(a, b, f) {
        if ("string" === typeof a || "number" === typeof a) {
            f = "" + a;
            if ("" === f) return "";
            if (this.makeStaticMarkup) return $d3ac54a459011270$var$O(f);
            if (this.previousWasTextNode) return "\x3c!-- --\x3e" + $d3ac54a459011270$var$O(f);
            this.previousWasTextNode = !0;
            return $d3ac54a459011270$var$O(f);
        }
        b = $d3ac54a459011270$var$ab(a, b, this.threadID);
        a = b.child;
        b = b.context;
        if (null === a || !1 === a) return "";
        if (!$3OyDL.isValidElement(a)) {
            if (null != a && null != a.$$typeof) {
                f = a.$$typeof;
                if (f === $d3ac54a459011270$var$q) throw Error($d3ac54a459011270$var$p(257));
                throw Error($d3ac54a459011270$var$p(258, f.toString()));
            }
            a = $d3ac54a459011270$var$Z(a);
            this.stack.push({
                type: null,
                domNamespace: f,
                children: a,
                childIndex: 0,
                context: b,
                footer: ""
            });
            return "";
        }
        var c = a.type;
        if ("string" === typeof c) return this.renderDOM(a, b, f);
        switch(c){
            case $d3ac54a459011270$var$ka:
            case $d3ac54a459011270$var$ja:
            case $d3ac54a459011270$var$u:
            case $d3ac54a459011270$var$z:
            case $d3ac54a459011270$var$ca:
            case $d3ac54a459011270$var$r:
                return a = $d3ac54a459011270$var$Z(a.props.children), this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case $d3ac54a459011270$var$D:
                throw Error($d3ac54a459011270$var$p(294));
            case $d3ac54a459011270$var$ia:
                throw Error($d3ac54a459011270$var$p(343));
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $d3ac54a459011270$var$ba:
                $d3ac54a459011270$var$P = {};
                var d = c.render(a.props, a.ref);
                d = $d3ac54a459011270$var$Da(c.render, a.props, d, a.ref);
                d = $d3ac54a459011270$var$Z(d);
                this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: d,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case $d3ac54a459011270$var$da:
                return a = [
                    $3OyDL.createElement(c.type, $gZVC5({
                        ref: a.ref
                    }, a.props))
                ], this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case $d3ac54a459011270$var$B:
                return c = $d3ac54a459011270$var$Z(a.props.children), f = {
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }, this.pushProvider(a), this.stack.push(f), "";
            case $d3ac54a459011270$var$aa:
                c = a.type;
                d = a.props;
                var g = this.threadID;
                $d3ac54a459011270$var$I(c, g);
                c = $d3ac54a459011270$var$Z(d.children(c[g]));
                this.stack.push({
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case $d3ac54a459011270$var$ha:
                throw Error($d3ac54a459011270$var$p(338));
            case $d3ac54a459011270$var$ea:
                return c = a.type, d = c._init, c = d(c._payload), a = [
                    $3OyDL.createElement(c, $gZVC5({
                        ref: a.ref
                    }, a.props))
                ], this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
        }
        throw Error($d3ac54a459011270$var$p(130, null == c ? c : typeof c, ""));
    };
    b.renderDOM = function(a, b, f) {
        var c = a.type.toLowerCase();
        f === $d3ac54a459011270$var$La.html && $d3ac54a459011270$var$Ma(c);
        if (!$d3ac54a459011270$var$Va.hasOwnProperty(c)) {
            if (!$d3ac54a459011270$var$Ua.test(c)) throw Error($d3ac54a459011270$var$p(65, c));
            $d3ac54a459011270$var$Va[c] = !0;
        }
        var d = a.props;
        if ("input" === c) d = $gZVC5({
            type: void 0
        }, d, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: null != d.value ? d.value : d.defaultValue,
            checked: null != d.checked ? d.checked : d.defaultChecked
        });
        else if ("textarea" === c) {
            var g = d.value;
            if (null == g) {
                g = d.defaultValue;
                var e = d.children;
                if (null != e) {
                    if (null != g) throw Error($d3ac54a459011270$var$p(92));
                    if (Array.isArray(e)) {
                        if (!(1 >= e.length)) throw Error($d3ac54a459011270$var$p(93));
                        e = e[0];
                    }
                    g = "" + e;
                }
                null == g && (g = "");
            }
            d = $gZVC5({}, d, {
                value: void 0,
                children: "" + g
            });
        } else if ("select" === c) this.currentSelectValue = null != d.value ? d.value : d.defaultValue, d = $gZVC5({}, d, {
            value: void 0
        });
        else if ("option" === c) {
            e = this.currentSelectValue;
            var L = $d3ac54a459011270$var$Xa(d.children);
            if (null != e) {
                var G = null != d.value ? d.value + "" : L;
                g = !1;
                if (Array.isArray(e)) {
                    for(var C = 0; C < e.length; C++)if ("" + e[C] === G) {
                        g = !0;
                        break;
                    }
                } else g = "" + e === G;
                d = $gZVC5({
                    selected: void 0,
                    children: void 0
                }, d, {
                    selected: g,
                    children: L
                });
            }
        }
        if (g = d) {
            if ($d3ac54a459011270$var$Oa[c] && (null != g.children || null != g.dangerouslySetInnerHTML)) throw Error($d3ac54a459011270$var$p(137, c));
            if (null != g.dangerouslySetInnerHTML) {
                if (null != g.children) throw Error($d3ac54a459011270$var$p(60));
                if (!("object" === typeof g.dangerouslySetInnerHTML && "__html" in g.dangerouslySetInnerHTML)) throw Error($d3ac54a459011270$var$p(61));
            }
            if (null != g.style && "object" !== typeof g.style) throw Error($d3ac54a459011270$var$p(62));
        }
        g = d;
        e = this.makeStaticMarkup;
        L = 1 === this.stack.length;
        G = "<" + a.type;
        b: if (-1 === c.indexOf("-")) C = "string" === typeof g.is;
        else switch(c){
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                C = !1;
                break b;
            default:
                C = !0;
        }
        for(w in g)if ($d3ac54a459011270$var$Ya.call(g, w)) {
            var n = g[w];
            if (null != n) {
                if ("style" === w) {
                    var k = void 0, v = "", H = "";
                    for(k in n)if (n.hasOwnProperty(k)) {
                        var x = 0 === k.indexOf("--"), y = n[k];
                        if (null != y) {
                            if (x) var A = k;
                            else if (A = k, $d3ac54a459011270$var$Wa.hasOwnProperty(A)) A = $d3ac54a459011270$var$Wa[A];
                            else {
                                var cb = A.replace($d3ac54a459011270$var$Qa, "-$1").toLowerCase().replace($d3ac54a459011270$var$Ra, "-ms-");
                                A = $d3ac54a459011270$var$Wa[A] = cb;
                            }
                            v += H + A + ":";
                            H = k;
                            x = null == y || "boolean" === typeof y || "" === y ? "" : x || "number" !== typeof y || 0 === y || $d3ac54a459011270$var$Y.hasOwnProperty(H) && $d3ac54a459011270$var$Y[H] ? ("" + y).trim() : y + "px";
                            v += x;
                            H = ";";
                        }
                    }
                    n = v || null;
                }
                k = null;
                C ? $d3ac54a459011270$var$Za.hasOwnProperty(w) || (k = w, k = $d3ac54a459011270$var$sa(k) && null != n ? k + '="' + ($d3ac54a459011270$var$O(n) + '"') : "") : k = $d3ac54a459011270$var$ya(w, n);
                k && (G += " " + k);
            }
        }
        e || L && (G += ' data-reactroot=""');
        var w = G;
        g = "";
        $d3ac54a459011270$var$Na.hasOwnProperty(c) ? w += "/>" : (w += ">", g = "</" + a.type + ">");
        a: {
            e = d.dangerouslySetInnerHTML;
            if (null != e) {
                if (null != e.__html) {
                    e = e.__html;
                    break a;
                }
            } else if (e = d.children, "string" === typeof e || "number" === typeof e) {
                e = $d3ac54a459011270$var$O(e);
                break a;
            }
            e = null;
        }
        null != e ? (d = [], $d3ac54a459011270$var$Ta.hasOwnProperty(c) && "\n" === e.charAt(0) && (w += "\n"), w += e) : d = $d3ac54a459011270$var$Z(d.children);
        a = a.type;
        f = null == f || "http://www.w3.org/1999/xhtml" === f ? $d3ac54a459011270$var$Ma(a) : "http://www.w3.org/2000/svg" === f && "foreignObject" === a ? "http://www.w3.org/1999/xhtml" : f;
        this.stack.push({
            domNamespace: f,
            type: c,
            children: d,
            childIndex: 0,
            context: b,
            footer: g
        });
        this.previousWasTextNode = !1;
        return w;
    };
    return a;
}();
$d3ac54a459011270$export$307591e98609eddd = function() {
    throw Error($d3ac54a459011270$var$p(207));
};
$d3ac54a459011270$export$eb3a06aef9e6ee51 = function(a, b) {
    a = new $d3ac54a459011270$var$bb(a, !0, b);
    try {
        return a.read(Infinity);
    } finally{
        a.destroy();
    }
};
$d3ac54a459011270$export$b23711c915539651 = function() {
    throw Error($d3ac54a459011270$var$p(208));
};
$d3ac54a459011270$export$80e7718417253a51 = function(a, b) {
    a = new $d3ac54a459011270$var$bb(a, !1, b);
    try {
        return a.read(Infinity);
    } finally{
        a.destroy();
    }
};
$d3ac54a459011270$export$83d89fbfd8236492 = "17.0.2";

});

parcelRegister("6VLH2", function(module, exports) {

var $gUa2n = parcelRequire("gUa2n");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $50bd0fcb98ccd706$var$isEqual(value, other) {
    return $gUa2n(value, other);
}
module.exports = $50bd0fcb98ccd706$var$isEqual;

});
parcelRegister("gUa2n", function(module, exports) {

var $73Be0 = parcelRequire("73Be0");

var $lv5JF = parcelRequire("lv5JF");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $032d0f1ef100eaf3$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$lv5JF(value) && !$lv5JF(other)) return value !== value && other !== other;
    return $73Be0(value, other, bitmask, customizer, $032d0f1ef100eaf3$var$baseIsEqual, stack);
}
module.exports = $032d0f1ef100eaf3$var$baseIsEqual;

});
parcelRegister("73Be0", function(module, exports) {

var $cNHIM = parcelRequire("cNHIM");

var $4Edxv = parcelRequire("4Edxv");

var $ce0e8 = parcelRequire("ce0e8");

var $7bP7l = parcelRequire("7bP7l");

var $1eMrN = parcelRequire("1eMrN");

var $3LE2i = parcelRequire("3LE2i");

var $1FYHO = parcelRequire("1FYHO");

var $9OHLA = parcelRequire("9OHLA");
/** Used to compose bitmasks for value comparisons. */ var $5235b04c5a5b3bec$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $5235b04c5a5b3bec$var$argsTag = '[object Arguments]', $5235b04c5a5b3bec$var$arrayTag = '[object Array]', $5235b04c5a5b3bec$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $5235b04c5a5b3bec$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5235b04c5a5b3bec$var$hasOwnProperty = $5235b04c5a5b3bec$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $5235b04c5a5b3bec$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $3LE2i(object), othIsArr = $3LE2i(other), objTag = objIsArr ? $5235b04c5a5b3bec$var$arrayTag : $1eMrN(object), othTag = othIsArr ? $5235b04c5a5b3bec$var$arrayTag : $1eMrN(other);
    objTag = objTag == $5235b04c5a5b3bec$var$argsTag ? $5235b04c5a5b3bec$var$objectTag : objTag;
    othTag = othTag == $5235b04c5a5b3bec$var$argsTag ? $5235b04c5a5b3bec$var$objectTag : othTag;
    var objIsObj = objTag == $5235b04c5a5b3bec$var$objectTag, othIsObj = othTag == $5235b04c5a5b3bec$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $1FYHO(object)) {
        if (!$1FYHO(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $cNHIM);
        return objIsArr || $9OHLA(object) ? $4Edxv(object, other, bitmask, customizer, equalFunc, stack) : $ce0e8(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $5235b04c5a5b3bec$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $5235b04c5a5b3bec$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $5235b04c5a5b3bec$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $cNHIM);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $cNHIM);
    return $7bP7l(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $5235b04c5a5b3bec$var$baseIsEqualDeep;

});
parcelRegister("cNHIM", function(module, exports) {

var $4LyPA = parcelRequire("4LyPA");

var $5Bl8v = parcelRequire("5Bl8v");

var $2gKj8 = parcelRequire("2gKj8");

var $1Hy2a = parcelRequire("1Hy2a");

var $hPSmp = parcelRequire("hPSmp");

var $gSViB = parcelRequire("gSViB");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $951bf9c8f5216fab$var$Stack(entries) {
    var data = this.__data__ = new $4LyPA(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$951bf9c8f5216fab$var$Stack.prototype.clear = $5Bl8v;
$951bf9c8f5216fab$var$Stack.prototype['delete'] = $2gKj8;
$951bf9c8f5216fab$var$Stack.prototype.get = $1Hy2a;
$951bf9c8f5216fab$var$Stack.prototype.has = $hPSmp;
$951bf9c8f5216fab$var$Stack.prototype.set = $gSViB;
module.exports = $951bf9c8f5216fab$var$Stack;

});
parcelRegister("4LyPA", function(module, exports) {

var $3XsAu = parcelRequire("3XsAu");

var $7NEFP = parcelRequire("7NEFP");

var $dqWk9 = parcelRequire("dqWk9");

var $i8Tlj = parcelRequire("i8Tlj");

var $IfE6D = parcelRequire("IfE6D");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $378691ef17def520$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$378691ef17def520$var$ListCache.prototype.clear = $3XsAu;
$378691ef17def520$var$ListCache.prototype['delete'] = $7NEFP;
$378691ef17def520$var$ListCache.prototype.get = $dqWk9;
$378691ef17def520$var$ListCache.prototype.has = $i8Tlj;
$378691ef17def520$var$ListCache.prototype.set = $IfE6D;
module.exports = $378691ef17def520$var$ListCache;

});
parcelRegister("3XsAu", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $2e1d0eb3598db40c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $2e1d0eb3598db40c$var$listCacheClear;

});

parcelRegister("7NEFP", function(module, exports) {

var $ebgN1 = parcelRequire("ebgN1");
/** Used for built-in method references. */ var $5adca8f48af60e6b$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $5adca8f48af60e6b$var$splice = $5adca8f48af60e6b$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5adca8f48af60e6b$var$listCacheDelete(key) {
    var data = this.__data__, index = $ebgN1(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $5adca8f48af60e6b$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $5adca8f48af60e6b$var$listCacheDelete;

});
parcelRegister("ebgN1", function(module, exports) {

var $gUEY5 = parcelRequire("gUEY5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a52f1dd4051cdcf7$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($gUEY5(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $a52f1dd4051cdcf7$var$assocIndexOf;

});
parcelRegister("gUEY5", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $c501a7b54b74b6c4$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $c501a7b54b74b6c4$var$eq;

});



parcelRegister("dqWk9", function(module, exports) {

var $ebgN1 = parcelRequire("ebgN1");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9c7af1fe6f4f5674$var$listCacheGet(key) {
    var data = this.__data__, index = $ebgN1(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $9c7af1fe6f4f5674$var$listCacheGet;

});

parcelRegister("i8Tlj", function(module, exports) {

var $ebgN1 = parcelRequire("ebgN1");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d353e740650ffc4b$var$listCacheHas(key) {
    return $ebgN1(this.__data__, key) > -1;
}
module.exports = $d353e740650ffc4b$var$listCacheHas;

});

parcelRegister("IfE6D", function(module, exports) {

var $ebgN1 = parcelRequire("ebgN1");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $08503f1ead0c4e0d$var$listCacheSet(key, value) {
    var data = this.__data__, index = $ebgN1(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $08503f1ead0c4e0d$var$listCacheSet;

});


parcelRegister("5Bl8v", function(module, exports) {

var $4LyPA = parcelRequire("4LyPA");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $4140cda4043c9b51$var$stackClear() {
    this.__data__ = new $4LyPA;
    this.size = 0;
}
module.exports = $4140cda4043c9b51$var$stackClear;

});

parcelRegister("2gKj8", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1a70ff226b861ab5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $1a70ff226b861ab5$var$stackDelete;

});

parcelRegister("1Hy2a", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $13d4350a222658fa$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $13d4350a222658fa$var$stackGet;

});

parcelRegister("hPSmp", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cfc15df091c25e55$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $cfc15df091c25e55$var$stackHas;

});

parcelRegister("gSViB", function(module, exports) {

var $4LyPA = parcelRequire("4LyPA");

var $20WYK = parcelRequire("20WYK");

var $aEN8C = parcelRequire("aEN8C");
/** Used as the size to enable large array optimizations. */ var $c4ae22e144e1ab86$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $c4ae22e144e1ab86$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $4LyPA) {
        var pairs = data.__data__;
        if (!$20WYK || pairs.length < $c4ae22e144e1ab86$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $aEN8C(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $c4ae22e144e1ab86$var$stackSet;

});
parcelRegister("20WYK", function(module, exports) {

var $dEEMv = parcelRequire("dEEMv");

var $duPXL = parcelRequire("duPXL");
/* Built-in method references that are verified to be native. */ var $177954cdfffa81f3$var$Map = $dEEMv($duPXL, 'Map');
module.exports = $177954cdfffa81f3$var$Map;

});
parcelRegister("dEEMv", function(module, exports) {

var $7ocL6 = parcelRequire("7ocL6");

var $kDdsm = parcelRequire("kDdsm");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $9f0ea52091da572b$var$getNative(object, key) {
    var value = $kDdsm(object, key);
    return $7ocL6(value) ? value : undefined;
}
module.exports = $9f0ea52091da572b$var$getNative;

});
parcelRegister("7ocL6", function(module, exports) {

var $d2tz0 = parcelRequire("d2tz0");

var $cNpte = parcelRequire("cNpte");

var $gdWrU = parcelRequire("gdWrU");

var $bluv3 = parcelRequire("bluv3");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $5614abe6fb00c10d$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $5614abe6fb00c10d$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $5614abe6fb00c10d$var$funcProto = Function.prototype, $5614abe6fb00c10d$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $5614abe6fb00c10d$var$funcToString = $5614abe6fb00c10d$var$funcProto.toString;
/** Used to check objects for own properties. */ var $5614abe6fb00c10d$var$hasOwnProperty = $5614abe6fb00c10d$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $5614abe6fb00c10d$var$reIsNative = RegExp('^' + $5614abe6fb00c10d$var$funcToString.call($5614abe6fb00c10d$var$hasOwnProperty).replace($5614abe6fb00c10d$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $5614abe6fb00c10d$var$baseIsNative(value) {
    if (!$gdWrU(value) || $cNpte(value)) return false;
    var pattern = $d2tz0(value) ? $5614abe6fb00c10d$var$reIsNative : $5614abe6fb00c10d$var$reIsHostCtor;
    return pattern.test($bluv3(value));
}
module.exports = $5614abe6fb00c10d$var$baseIsNative;

});
parcelRegister("d2tz0", function(module, exports) {

var $17d17 = parcelRequire("17d17");

var $gdWrU = parcelRequire("gdWrU");
/** `Object#toString` result references. */ var $97e264f5fdbf280b$var$asyncTag = '[object AsyncFunction]', $97e264f5fdbf280b$var$funcTag = '[object Function]', $97e264f5fdbf280b$var$genTag = '[object GeneratorFunction]', $97e264f5fdbf280b$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $97e264f5fdbf280b$var$isFunction(value) {
    if (!$gdWrU(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $17d17(value);
    return tag == $97e264f5fdbf280b$var$funcTag || tag == $97e264f5fdbf280b$var$genTag || tag == $97e264f5fdbf280b$var$asyncTag || tag == $97e264f5fdbf280b$var$proxyTag;
}
module.exports = $97e264f5fdbf280b$var$isFunction;

});
parcelRegister("17d17", function(module, exports) {

var $3a0OG = parcelRequire("3a0OG");

var $ik2f8 = parcelRequire("ik2f8");

var $frhuD = parcelRequire("frhuD");
/** `Object#toString` result references. */ var $0d008ace215cabb2$var$nullTag = '[object Null]', $0d008ace215cabb2$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $0d008ace215cabb2$var$symToStringTag = $3a0OG ? $3a0OG.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $0d008ace215cabb2$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $0d008ace215cabb2$var$undefinedTag : $0d008ace215cabb2$var$nullTag;
    return $0d008ace215cabb2$var$symToStringTag && $0d008ace215cabb2$var$symToStringTag in Object(value) ? $ik2f8(value) : $frhuD(value);
}
module.exports = $0d008ace215cabb2$var$baseGetTag;

});
parcelRegister("3a0OG", function(module, exports) {

var $duPXL = parcelRequire("duPXL");
/** Built-in value references. */ var $24d2f06a5c9c9247$var$Symbol = $duPXL.Symbol;
module.exports = $24d2f06a5c9c9247$var$Symbol;

});
parcelRegister("duPXL", function(module, exports) {

var $gn1Bf = parcelRequire("gn1Bf");
/** Detect free variable `self`. */ var $9d36627232af9554$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $9d36627232af9554$var$root = $gn1Bf || $9d36627232af9554$var$freeSelf || Function('return this')();
module.exports = $9d36627232af9554$var$root;

});
parcelRegister("gn1Bf", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $beb008fc9339dbf5$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $beb008fc9339dbf5$var$freeGlobal;

});



parcelRegister("ik2f8", function(module, exports) {

var $3a0OG = parcelRequire("3a0OG");
/** Used for built-in method references. */ var $d56bd5b09a9d1fcd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d56bd5b09a9d1fcd$var$hasOwnProperty = $d56bd5b09a9d1fcd$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d56bd5b09a9d1fcd$var$nativeObjectToString = $d56bd5b09a9d1fcd$var$objectProto.toString;
/** Built-in value references. */ var $d56bd5b09a9d1fcd$var$symToStringTag = $3a0OG ? $3a0OG.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $d56bd5b09a9d1fcd$var$getRawTag(value) {
    var isOwn = $d56bd5b09a9d1fcd$var$hasOwnProperty.call(value, $d56bd5b09a9d1fcd$var$symToStringTag), tag = value[$d56bd5b09a9d1fcd$var$symToStringTag];
    try {
        value[$d56bd5b09a9d1fcd$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $d56bd5b09a9d1fcd$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$d56bd5b09a9d1fcd$var$symToStringTag] = tag;
        else delete value[$d56bd5b09a9d1fcd$var$symToStringTag];
    }
    return result;
}
module.exports = $d56bd5b09a9d1fcd$var$getRawTag;

});

parcelRegister("frhuD", function(module, exports) {
/** Used for built-in method references. */ var $b3d6f26878cd4a8e$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b3d6f26878cd4a8e$var$nativeObjectToString = $b3d6f26878cd4a8e$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $b3d6f26878cd4a8e$var$objectToString(value) {
    return $b3d6f26878cd4a8e$var$nativeObjectToString.call(value);
}
module.exports = $b3d6f26878cd4a8e$var$objectToString;

});


parcelRegister("gdWrU", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $bcfb3300d4fb66b4$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $bcfb3300d4fb66b4$var$isObject;

});


parcelRegister("cNpte", function(module, exports) {

var $1LvaM = parcelRequire("1LvaM");
/** Used to detect methods masquerading as native. */ var $950dd18c0775d4ef$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($1LvaM && $1LvaM.keys && $1LvaM.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $950dd18c0775d4ef$var$isMasked(func) {
    return !!$950dd18c0775d4ef$var$maskSrcKey && $950dd18c0775d4ef$var$maskSrcKey in func;
}
module.exports = $950dd18c0775d4ef$var$isMasked;

});
parcelRegister("1LvaM", function(module, exports) {

var $duPXL = parcelRequire("duPXL");
/** Used to detect overreaching core-js shims. */ var $14925c80b41e797c$var$coreJsData = $duPXL["__core-js_shared__"];
module.exports = $14925c80b41e797c$var$coreJsData;

});


parcelRegister("bluv3", function(module, exports) {
/** Used for built-in method references. */ var $0221b2d8c2999eba$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $0221b2d8c2999eba$var$funcToString = $0221b2d8c2999eba$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $0221b2d8c2999eba$var$toSource(func) {
    if (func != null) {
        try {
            return $0221b2d8c2999eba$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $0221b2d8c2999eba$var$toSource;

});


parcelRegister("kDdsm", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $f051e350e402419c$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $f051e350e402419c$var$getValue;

});



parcelRegister("aEN8C", function(module, exports) {

var $hnSHD = parcelRequire("hnSHD");

var $ky8Sh = parcelRequire("ky8Sh");

var $5ceCV = parcelRequire("5ceCV");

var $bwDxF = parcelRequire("bwDxF");

var $awCKg = parcelRequire("awCKg");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7c23c192d7889e60$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$7c23c192d7889e60$var$MapCache.prototype.clear = $hnSHD;
$7c23c192d7889e60$var$MapCache.prototype['delete'] = $ky8Sh;
$7c23c192d7889e60$var$MapCache.prototype.get = $5ceCV;
$7c23c192d7889e60$var$MapCache.prototype.has = $bwDxF;
$7c23c192d7889e60$var$MapCache.prototype.set = $awCKg;
module.exports = $7c23c192d7889e60$var$MapCache;

});
parcelRegister("hnSHD", function(module, exports) {

var $clYPY = parcelRequire("clYPY");

var $4LyPA = parcelRequire("4LyPA");

var $20WYK = parcelRequire("20WYK");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $ca7f0475b835528a$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $clYPY,
        'map': new ($20WYK || $4LyPA),
        'string': new $clYPY
    };
}
module.exports = $ca7f0475b835528a$var$mapCacheClear;

});
parcelRegister("clYPY", function(module, exports) {

var $b2aYo = parcelRequire("b2aYo");

var $h2GDy = parcelRequire("h2GDy");

var $aFfGy = parcelRequire("aFfGy");

var $d7NyL = parcelRequire("d7NyL");

var $gaTsN = parcelRequire("gaTsN");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8fe6a33e887888db$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8fe6a33e887888db$var$Hash.prototype.clear = $b2aYo;
$8fe6a33e887888db$var$Hash.prototype['delete'] = $h2GDy;
$8fe6a33e887888db$var$Hash.prototype.get = $aFfGy;
$8fe6a33e887888db$var$Hash.prototype.has = $d7NyL;
$8fe6a33e887888db$var$Hash.prototype.set = $gaTsN;
module.exports = $8fe6a33e887888db$var$Hash;

});
parcelRegister("b2aYo", function(module, exports) {

var $3edu7 = parcelRequire("3edu7");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $808864a2e6d95792$var$hashClear() {
    this.__data__ = $3edu7 ? $3edu7(null) : {};
    this.size = 0;
}
module.exports = $808864a2e6d95792$var$hashClear;

});
parcelRegister("3edu7", function(module, exports) {

var $dEEMv = parcelRequire("dEEMv");
/* Built-in method references that are verified to be native. */ var $259d23b5e201e373$var$nativeCreate = $dEEMv(Object, 'create');
module.exports = $259d23b5e201e373$var$nativeCreate;

});


parcelRegister("h2GDy", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c683b25fdddde947$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $c683b25fdddde947$var$hashDelete;

});

parcelRegister("aFfGy", function(module, exports) {

var $3edu7 = parcelRequire("3edu7");
/** Used to stand-in for `undefined` hash values. */ var $7c39e67c147b5df1$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $7c39e67c147b5df1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7c39e67c147b5df1$var$hasOwnProperty = $7c39e67c147b5df1$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7c39e67c147b5df1$var$hashGet(key) {
    var data = this.__data__;
    if ($3edu7) {
        var result = data[key];
        return result === $7c39e67c147b5df1$var$HASH_UNDEFINED ? undefined : result;
    }
    return $7c39e67c147b5df1$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $7c39e67c147b5df1$var$hashGet;

});

parcelRegister("d7NyL", function(module, exports) {

var $3edu7 = parcelRequire("3edu7");
/** Used for built-in method references. */ var $98e25f56034cf79a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $98e25f56034cf79a$var$hasOwnProperty = $98e25f56034cf79a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $98e25f56034cf79a$var$hashHas(key) {
    var data = this.__data__;
    return $3edu7 ? data[key] !== undefined : $98e25f56034cf79a$var$hasOwnProperty.call(data, key);
}
module.exports = $98e25f56034cf79a$var$hashHas;

});

parcelRegister("gaTsN", function(module, exports) {

var $3edu7 = parcelRequire("3edu7");
/** Used to stand-in for `undefined` hash values. */ var $bc689a6b02056045$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $bc689a6b02056045$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $3edu7 && value === undefined ? $bc689a6b02056045$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $bc689a6b02056045$var$hashSet;

});



parcelRegister("ky8Sh", function(module, exports) {

var $atZiQ = parcelRequire("atZiQ");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ef5ddde2d07bee62$var$mapCacheDelete(key) {
    var result = $atZiQ(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $ef5ddde2d07bee62$var$mapCacheDelete;

});
parcelRegister("atZiQ", function(module, exports) {

var $hIQl3 = parcelRequire("hIQl3");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $7a1c2a4de39bacd2$var$getMapData(map, key) {
    var data = map.__data__;
    return $hIQl3(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $7a1c2a4de39bacd2$var$getMapData;

});
parcelRegister("hIQl3", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $ce6f250ed6dbb793$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $ce6f250ed6dbb793$var$isKeyable;

});



parcelRegister("5ceCV", function(module, exports) {

var $atZiQ = parcelRequire("atZiQ");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3c896b5470e3accd$var$mapCacheGet(key) {
    return $atZiQ(this, key).get(key);
}
module.exports = $3c896b5470e3accd$var$mapCacheGet;

});

parcelRegister("bwDxF", function(module, exports) {

var $atZiQ = parcelRequire("atZiQ");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $86415b1cef454fa8$var$mapCacheHas(key) {
    return $atZiQ(this, key).has(key);
}
module.exports = $86415b1cef454fa8$var$mapCacheHas;

});

parcelRegister("awCKg", function(module, exports) {

var $atZiQ = parcelRequire("atZiQ");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $7a9af28c9c32e415$var$mapCacheSet(key, value) {
    var data = $atZiQ(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $7a9af28c9c32e415$var$mapCacheSet;

});




parcelRegister("4Edxv", function(module, exports) {

var $fc2he = parcelRequire("fc2he");

var $gDebk = parcelRequire("gDebk");

var $01TFC = parcelRequire("01TFC");
/** Used to compose bitmasks for value comparisons. */ var $3625667cb128faa6$var$COMPARE_PARTIAL_FLAG = 1, $3625667cb128faa6$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $3625667cb128faa6$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3625667cb128faa6$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $3625667cb128faa6$var$COMPARE_UNORDERED_FLAG ? new $fc2he : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$gDebk(other, function(othValue, othIndex) {
                if (!$01TFC(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $3625667cb128faa6$var$equalArrays;

});
parcelRegister("fc2he", function(module, exports) {

var $aEN8C = parcelRequire("aEN8C");

var $hgufl = parcelRequire("hgufl");

var $ba6dW = parcelRequire("ba6dW");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $b0f9be23039e4136$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $aEN8C;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$b0f9be23039e4136$var$SetCache.prototype.add = $b0f9be23039e4136$var$SetCache.prototype.push = $hgufl;
$b0f9be23039e4136$var$SetCache.prototype.has = $ba6dW;
module.exports = $b0f9be23039e4136$var$SetCache;

});
parcelRegister("hgufl", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $c91b6499fc8664a2$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $c91b6499fc8664a2$var$setCacheAdd(value) {
    this.__data__.set(value, $c91b6499fc8664a2$var$HASH_UNDEFINED);
    return this;
}
module.exports = $c91b6499fc8664a2$var$setCacheAdd;

});

parcelRegister("ba6dW", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $820574d240c743d4$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $820574d240c743d4$var$setCacheHas;

});


parcelRegister("gDebk", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c1bb4a085b5c1ee6$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $c1bb4a085b5c1ee6$var$arraySome;

});

parcelRegister("01TFC", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $005b47153fd55bd1$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $005b47153fd55bd1$var$cacheHas;

});


parcelRegister("ce0e8", function(module, exports) {

var $3a0OG = parcelRequire("3a0OG");

var $bLYUK = parcelRequire("bLYUK");

var $gUEY5 = parcelRequire("gUEY5");

var $4Edxv = parcelRequire("4Edxv");

var $bCUF2 = parcelRequire("bCUF2");

var $7iGbo = parcelRequire("7iGbo");
/** Used to compose bitmasks for value comparisons. */ var $8e66f7ee6dcb2f90$var$COMPARE_PARTIAL_FLAG = 1, $8e66f7ee6dcb2f90$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $8e66f7ee6dcb2f90$var$boolTag = '[object Boolean]', $8e66f7ee6dcb2f90$var$dateTag = '[object Date]', $8e66f7ee6dcb2f90$var$errorTag = '[object Error]', $8e66f7ee6dcb2f90$var$mapTag = '[object Map]', $8e66f7ee6dcb2f90$var$numberTag = '[object Number]', $8e66f7ee6dcb2f90$var$regexpTag = '[object RegExp]', $8e66f7ee6dcb2f90$var$setTag = '[object Set]', $8e66f7ee6dcb2f90$var$stringTag = '[object String]', $8e66f7ee6dcb2f90$var$symbolTag = '[object Symbol]';
var $8e66f7ee6dcb2f90$var$arrayBufferTag = '[object ArrayBuffer]', $8e66f7ee6dcb2f90$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $8e66f7ee6dcb2f90$var$symbolProto = $3a0OG ? $3a0OG.prototype : undefined, $8e66f7ee6dcb2f90$var$symbolValueOf = $8e66f7ee6dcb2f90$var$symbolProto ? $8e66f7ee6dcb2f90$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $8e66f7ee6dcb2f90$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $8e66f7ee6dcb2f90$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $8e66f7ee6dcb2f90$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $bLYUK(object), new $bLYUK(other))) return false;
            return true;
        case $8e66f7ee6dcb2f90$var$boolTag:
        case $8e66f7ee6dcb2f90$var$dateTag:
        case $8e66f7ee6dcb2f90$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $gUEY5(+object, +other);
        case $8e66f7ee6dcb2f90$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $8e66f7ee6dcb2f90$var$regexpTag:
        case $8e66f7ee6dcb2f90$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $8e66f7ee6dcb2f90$var$mapTag:
            var convert = $bCUF2;
        case $8e66f7ee6dcb2f90$var$setTag:
            var isPartial = bitmask & $8e66f7ee6dcb2f90$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $7iGbo);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $8e66f7ee6dcb2f90$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $4Edxv(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $8e66f7ee6dcb2f90$var$symbolTag:
            if ($8e66f7ee6dcb2f90$var$symbolValueOf) return $8e66f7ee6dcb2f90$var$symbolValueOf.call(object) == $8e66f7ee6dcb2f90$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $8e66f7ee6dcb2f90$var$equalByTag;

});
parcelRegister("bLYUK", function(module, exports) {

var $duPXL = parcelRequire("duPXL");
/** Built-in value references. */ var $892355ca199f75b0$var$Uint8Array = $duPXL.Uint8Array;
module.exports = $892355ca199f75b0$var$Uint8Array;

});

parcelRegister("bCUF2", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $876f31fa7516382d$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $876f31fa7516382d$var$mapToArray;

});

parcelRegister("7iGbo", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $550aef75c13330c6$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $550aef75c13330c6$var$setToArray;

});


parcelRegister("7bP7l", function(module, exports) {

var $jRSTg = parcelRequire("jRSTg");
/** Used to compose bitmasks for value comparisons. */ var $53c136587cb09b97$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $53c136587cb09b97$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $53c136587cb09b97$var$hasOwnProperty = $53c136587cb09b97$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $53c136587cb09b97$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $53c136587cb09b97$var$COMPARE_PARTIAL_FLAG, objProps = $jRSTg(object), objLength = objProps.length, othProps = $jRSTg(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $53c136587cb09b97$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $53c136587cb09b97$var$equalObjects;

});
parcelRegister("jRSTg", function(module, exports) {

var $aSvKg = parcelRequire("aSvKg");

var $a2G0E = parcelRequire("a2G0E");

var $3kq2Y = parcelRequire("3kq2Y");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e76d8b9e201fa4f6$var$getAllKeys(object) {
    return $aSvKg(object, $3kq2Y, $a2G0E);
}
module.exports = $e76d8b9e201fa4f6$var$getAllKeys;

});
parcelRegister("aSvKg", function(module, exports) {

var $feaaU = parcelRequire("feaaU");

var $3LE2i = parcelRequire("3LE2i");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7eb792784cd890e4$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $3LE2i(object) ? result : $feaaU(result, symbolsFunc(object));
}
module.exports = $7eb792784cd890e4$var$baseGetAllKeys;

});
parcelRegister("feaaU", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $b1600e60ea264dd8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $b1600e60ea264dd8$var$arrayPush;

});

parcelRegister("3LE2i", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $2be4d12f71039d9c$var$isArray = Array.isArray;
module.exports = $2be4d12f71039d9c$var$isArray;

});


parcelRegister("a2G0E", function(module, exports) {

var $28qls = parcelRequire("28qls");

var $aM2kj = parcelRequire("aM2kj");
/** Used for built-in method references. */ var $74faad7bf7efc434$var$objectProto = Object.prototype;
/** Built-in value references. */ var $74faad7bf7efc434$var$propertyIsEnumerable = $74faad7bf7efc434$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $74faad7bf7efc434$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $74faad7bf7efc434$var$getSymbols = !$74faad7bf7efc434$var$nativeGetSymbols ? $aM2kj : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $28qls($74faad7bf7efc434$var$nativeGetSymbols(object), function(symbol) {
        return $74faad7bf7efc434$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $74faad7bf7efc434$var$getSymbols;

});
parcelRegister("28qls", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $18e0c3b05fc3f724$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $18e0c3b05fc3f724$var$arrayFilter;

});

parcelRegister("aM2kj", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $7d80311c6204dede$var$stubArray() {
    return [];
}
module.exports = $7d80311c6204dede$var$stubArray;

});


parcelRegister("3kq2Y", function(module, exports) {

var $devK5 = parcelRequire("devK5");

var $cUtnK = parcelRequire("cUtnK");

var $9HC6N = parcelRequire("9HC6N");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $26c771bfaf77495e$var$keys(object) {
    return $9HC6N(object) ? $devK5(object) : $cUtnK(object);
}
module.exports = $26c771bfaf77495e$var$keys;

});
parcelRegister("devK5", function(module, exports) {

var $7YAE3 = parcelRequire("7YAE3");

var $lEElg = parcelRequire("lEElg");

var $3LE2i = parcelRequire("3LE2i");

var $1FYHO = parcelRequire("1FYHO");

var $5w6e5 = parcelRequire("5w6e5");

var $9OHLA = parcelRequire("9OHLA");
/** Used for built-in method references. */ var $9a25348742d964f0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9a25348742d964f0$var$hasOwnProperty = $9a25348742d964f0$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $9a25348742d964f0$var$arrayLikeKeys(value, inherited) {
    var isArr = $3LE2i(value), isArg = !isArr && $lEElg(value), isBuff = !isArr && !isArg && $1FYHO(value), isType = !isArr && !isArg && !isBuff && $9OHLA(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $7YAE3(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $9a25348742d964f0$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $5w6e5(key, length)))) result.push(key);
    return result;
}
module.exports = $9a25348742d964f0$var$arrayLikeKeys;

});
parcelRegister("7YAE3", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $5cea8feae839529d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $5cea8feae839529d$var$baseTimes;

});

parcelRegister("lEElg", function(module, exports) {

var $7agD9 = parcelRequire("7agD9");

var $lv5JF = parcelRequire("lv5JF");
/** Used for built-in method references. */ var $fc3ca077b9386cdf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fc3ca077b9386cdf$var$hasOwnProperty = $fc3ca077b9386cdf$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $fc3ca077b9386cdf$var$propertyIsEnumerable = $fc3ca077b9386cdf$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $fc3ca077b9386cdf$var$isArguments = $7agD9(function() {
    return arguments;
}()) ? $7agD9 : function(value) {
    return $lv5JF(value) && $fc3ca077b9386cdf$var$hasOwnProperty.call(value, 'callee') && !$fc3ca077b9386cdf$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $fc3ca077b9386cdf$var$isArguments;

});
parcelRegister("7agD9", function(module, exports) {

var $17d17 = parcelRequire("17d17");

var $lv5JF = parcelRequire("lv5JF");
/** `Object#toString` result references. */ var $53765e0e7efd4341$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $53765e0e7efd4341$var$baseIsArguments(value) {
    return $lv5JF(value) && $17d17(value) == $53765e0e7efd4341$var$argsTag;
}
module.exports = $53765e0e7efd4341$var$baseIsArguments;

});
parcelRegister("lv5JF", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $fa70f1328612dc5a$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $fa70f1328612dc5a$var$isObjectLike;

});



parcelRegister("1FYHO", function(module, exports) {

var $duPXL = parcelRequire("duPXL");

var $iV6DN = parcelRequire("iV6DN");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $duPXL.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $iV6DN;
module.exports = isBuffer;

});
parcelRegister("iV6DN", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $dc62b394ea743070$var$stubFalse() {
    return false;
}
module.exports = $dc62b394ea743070$var$stubFalse;

});


parcelRegister("5w6e5", function(module, exports) {
/** Used as references for various `Number` constants. */ var $4044c55397fdef15$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $4044c55397fdef15$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $4044c55397fdef15$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $4044c55397fdef15$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $4044c55397fdef15$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $4044c55397fdef15$var$isIndex;

});

parcelRegister("9OHLA", function(module, exports) {

var $7djVU = parcelRequire("7djVU");

var $bCUbM = parcelRequire("bCUbM");

var $lOo1a = parcelRequire("lOo1a");
/* Node.js helper references. */ var $725abbab3b763b98$var$nodeIsTypedArray = $lOo1a && $lOo1a.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $725abbab3b763b98$var$isTypedArray = $725abbab3b763b98$var$nodeIsTypedArray ? $bCUbM($725abbab3b763b98$var$nodeIsTypedArray) : $7djVU;
module.exports = $725abbab3b763b98$var$isTypedArray;

});
parcelRegister("7djVU", function(module, exports) {

var $17d17 = parcelRequire("17d17");

var $iZiGH = parcelRequire("iZiGH");

var $lv5JF = parcelRequire("lv5JF");
/** `Object#toString` result references. */ var $540935932d0bb939$var$argsTag = '[object Arguments]', $540935932d0bb939$var$arrayTag = '[object Array]', $540935932d0bb939$var$boolTag = '[object Boolean]', $540935932d0bb939$var$dateTag = '[object Date]', $540935932d0bb939$var$errorTag = '[object Error]', $540935932d0bb939$var$funcTag = '[object Function]', $540935932d0bb939$var$mapTag = '[object Map]', $540935932d0bb939$var$numberTag = '[object Number]', $540935932d0bb939$var$objectTag = '[object Object]', $540935932d0bb939$var$regexpTag = '[object RegExp]', $540935932d0bb939$var$setTag = '[object Set]', $540935932d0bb939$var$stringTag = '[object String]', $540935932d0bb939$var$weakMapTag = '[object WeakMap]';
var $540935932d0bb939$var$arrayBufferTag = '[object ArrayBuffer]', $540935932d0bb939$var$dataViewTag = '[object DataView]', $540935932d0bb939$var$float32Tag = '[object Float32Array]', $540935932d0bb939$var$float64Tag = '[object Float64Array]', $540935932d0bb939$var$int8Tag = '[object Int8Array]', $540935932d0bb939$var$int16Tag = '[object Int16Array]', $540935932d0bb939$var$int32Tag = '[object Int32Array]', $540935932d0bb939$var$uint8Tag = '[object Uint8Array]', $540935932d0bb939$var$uint8ClampedTag = '[object Uint8ClampedArray]', $540935932d0bb939$var$uint16Tag = '[object Uint16Array]', $540935932d0bb939$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $540935932d0bb939$var$typedArrayTags = {};
$540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$float32Tag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$float64Tag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$int8Tag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$int16Tag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$int32Tag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$uint8Tag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$uint8ClampedTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$uint16Tag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$uint32Tag] = true;
$540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$argsTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$arrayTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$arrayBufferTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$boolTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$dataViewTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$dateTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$errorTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$funcTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$mapTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$numberTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$objectTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$regexpTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$setTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$stringTag] = $540935932d0bb939$var$typedArrayTags[$540935932d0bb939$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $540935932d0bb939$var$baseIsTypedArray(value) {
    return $lv5JF(value) && $iZiGH(value.length) && !!$540935932d0bb939$var$typedArrayTags[$17d17(value)];
}
module.exports = $540935932d0bb939$var$baseIsTypedArray;

});
parcelRegister("iZiGH", function(module, exports) {
/** Used as references for various `Number` constants. */ var $dd2c6b7961026a96$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $dd2c6b7961026a96$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $dd2c6b7961026a96$var$MAX_SAFE_INTEGER;
}
module.exports = $dd2c6b7961026a96$var$isLength;

});


parcelRegister("bCUbM", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $876ed44ef48d7a80$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $876ed44ef48d7a80$var$baseUnary;

});

parcelRegister("lOo1a", function(module, exports) {

var $gn1Bf = parcelRequire("gn1Bf");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $gn1Bf.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("cUtnK", function(module, exports) {

var $c4CoD = parcelRequire("c4CoD");

var $6InZ4 = parcelRequire("6InZ4");
/** Used for built-in method references. */ var $966181a24de46a7d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $966181a24de46a7d$var$hasOwnProperty = $966181a24de46a7d$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $966181a24de46a7d$var$baseKeys(object) {
    if (!$c4CoD(object)) return $6InZ4(object);
    var result = [];
    for(var key in Object(object))if ($966181a24de46a7d$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $966181a24de46a7d$var$baseKeys;

});
parcelRegister("c4CoD", function(module, exports) {
/** Used for built-in method references. */ var $8ca3a4785b1029a0$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $8ca3a4785b1029a0$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $8ca3a4785b1029a0$var$objectProto;
    return value === proto;
}
module.exports = $8ca3a4785b1029a0$var$isPrototype;

});

parcelRegister("6InZ4", function(module, exports) {

var $6az9u = parcelRequire("6az9u");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4e3974df5242da54$var$nativeKeys = $6az9u(Object.keys, Object);
module.exports = $4e3974df5242da54$var$nativeKeys;

});
parcelRegister("6az9u", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $47def1b5d587227e$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $47def1b5d587227e$var$overArg;

});



parcelRegister("9HC6N", function(module, exports) {

var $d2tz0 = parcelRequire("d2tz0");

var $iZiGH = parcelRequire("iZiGH");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $7105b0c48c4bb3a9$var$isArrayLike(value) {
    return value != null && $iZiGH(value.length) && !$d2tz0(value);
}
module.exports = $7105b0c48c4bb3a9$var$isArrayLike;

});




parcelRegister("1eMrN", function(module, exports) {

var $5keO2 = parcelRequire("5keO2");

var $20WYK = parcelRequire("20WYK");

var $eoMOg = parcelRequire("eoMOg");

var $51tLe = parcelRequire("51tLe");

var $6vniZ = parcelRequire("6vniZ");

var $17d17 = parcelRequire("17d17");

var $bluv3 = parcelRequire("bluv3");
/** `Object#toString` result references. */ var $0e6cade728d17aaf$var$mapTag = '[object Map]', $0e6cade728d17aaf$var$objectTag = '[object Object]', $0e6cade728d17aaf$var$promiseTag = '[object Promise]', $0e6cade728d17aaf$var$setTag = '[object Set]', $0e6cade728d17aaf$var$weakMapTag = '[object WeakMap]';
var $0e6cade728d17aaf$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $0e6cade728d17aaf$var$dataViewCtorString = $bluv3($5keO2), $0e6cade728d17aaf$var$mapCtorString = $bluv3($20WYK), $0e6cade728d17aaf$var$promiseCtorString = $bluv3($eoMOg), $0e6cade728d17aaf$var$setCtorString = $bluv3($51tLe), $0e6cade728d17aaf$var$weakMapCtorString = $bluv3($6vniZ);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $0e6cade728d17aaf$var$getTag = $17d17;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5keO2 && $0e6cade728d17aaf$var$getTag(new $5keO2(new ArrayBuffer(1))) != $0e6cade728d17aaf$var$dataViewTag || $20WYK && $0e6cade728d17aaf$var$getTag(new $20WYK) != $0e6cade728d17aaf$var$mapTag || $eoMOg && $0e6cade728d17aaf$var$getTag($eoMOg.resolve()) != $0e6cade728d17aaf$var$promiseTag || $51tLe && $0e6cade728d17aaf$var$getTag(new $51tLe) != $0e6cade728d17aaf$var$setTag || $6vniZ && $0e6cade728d17aaf$var$getTag(new $6vniZ) != $0e6cade728d17aaf$var$weakMapTag) $0e6cade728d17aaf$var$getTag = function(value) {
    var result = $17d17(value), Ctor = result == $0e6cade728d17aaf$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $bluv3(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $0e6cade728d17aaf$var$dataViewCtorString:
            return $0e6cade728d17aaf$var$dataViewTag;
        case $0e6cade728d17aaf$var$mapCtorString:
            return $0e6cade728d17aaf$var$mapTag;
        case $0e6cade728d17aaf$var$promiseCtorString:
            return $0e6cade728d17aaf$var$promiseTag;
        case $0e6cade728d17aaf$var$setCtorString:
            return $0e6cade728d17aaf$var$setTag;
        case $0e6cade728d17aaf$var$weakMapCtorString:
            return $0e6cade728d17aaf$var$weakMapTag;
    }
    return result;
};
module.exports = $0e6cade728d17aaf$var$getTag;

});
parcelRegister("5keO2", function(module, exports) {

var $dEEMv = parcelRequire("dEEMv");

var $duPXL = parcelRequire("duPXL");
/* Built-in method references that are verified to be native. */ var $3e0a4e34b71b1d4c$var$DataView = $dEEMv($duPXL, 'DataView');
module.exports = $3e0a4e34b71b1d4c$var$DataView;

});

parcelRegister("eoMOg", function(module, exports) {

var $dEEMv = parcelRequire("dEEMv");

var $duPXL = parcelRequire("duPXL");
/* Built-in method references that are verified to be native. */ var $a7b92b25b8920292$var$Promise = $dEEMv($duPXL, 'Promise');
module.exports = $a7b92b25b8920292$var$Promise;

});

parcelRegister("51tLe", function(module, exports) {

var $dEEMv = parcelRequire("dEEMv");

var $duPXL = parcelRequire("duPXL");
/* Built-in method references that are verified to be native. */ var $3a8421a51d4842fb$var$Set = $dEEMv($duPXL, 'Set');
module.exports = $3a8421a51d4842fb$var$Set;

});

parcelRegister("6vniZ", function(module, exports) {

var $dEEMv = parcelRequire("dEEMv");

var $duPXL = parcelRequire("duPXL");
/* Built-in method references that are verified to be native. */ var $4bc7b74bde98c93f$var$WeakMap = $dEEMv($duPXL, 'WeakMap');
module.exports = $4bc7b74bde98c93f$var$WeakMap;

});





parcelRegister("kvsBE", function(module, exports) {

var $8C4PT = parcelRequire("8C4PT");
var $eedce4808a689638$require$Buffer = $8C4PT.Buffer;
/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 109);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var container_1 = __webpack_require__(17);
            var format_1 = __webpack_require__(18);
            var leaf_1 = __webpack_require__(19);
            var scroll_1 = __webpack_require__(45);
            var inline_1 = __webpack_require__(46);
            var block_1 = __webpack_require__(47);
            var embed_1 = __webpack_require__(48);
            var text_1 = __webpack_require__(49);
            var attributor_1 = __webpack_require__(12);
            var class_1 = __webpack_require__(32);
            var style_1 = __webpack_require__(33);
            var store_1 = __webpack_require__(31);
            var Registry = __webpack_require__(1);
            var Parchment = {
                Scope: Registry.Scope,
                create: Registry.create,
                find: Registry.find,
                query: Registry.query,
                register: Registry.register,
                Container: container_1.default,
                Format: format_1.default,
                Leaf: leaf_1.default,
                Embed: embed_1.default,
                Scroll: scroll_1.default,
                Block: block_1.default,
                Inline: inline_1.default,
                Text: text_1.default,
                Attributor: {
                    Attribute: attributor_1.default,
                    Class: class_1.default,
                    Style: style_1.default,
                    Store: store_1.default
                }
            };
            exports.default = Parchment;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var ParchmentError = /** @class */ function(_super) {
                __extends(ParchmentError, _super);
                function ParchmentError(message) {
                    var _this = this;
                    message = '[Parchment] ' + message;
                    _this = _super.call(this, message) || this;
                    _this.message = message;
                    _this.name = _this.constructor.name;
                    return _this;
                }
                return ParchmentError;
            }(Error);
            exports.ParchmentError = ParchmentError;
            var attributes = {};
            var classes = {};
            var tags = {};
            var types = {};
            exports.DATA_KEY = '__blot';
            var Scope;
            (function(Scope) {
                Scope[Scope["TYPE"] = 3] = "TYPE";
                Scope[Scope["LEVEL"] = 12] = "LEVEL";
                Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
                Scope[Scope["BLOT"] = 14] = "BLOT";
                Scope[Scope["INLINE"] = 7] = "INLINE";
                Scope[Scope["BLOCK"] = 11] = "BLOCK";
                Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
                Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
                Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
                Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
                Scope[Scope["ANY"] = 15] = "ANY";
            })(Scope = exports.Scope || (exports.Scope = {}));
            function create(input, value) {
                var match = query(input);
                if (match == null) throw new ParchmentError("Unable to create " + input + " blot");
                var BlotClass = match;
                var node = // @ts-ignore
                input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
                return new BlotClass(node, value);
            }
            exports.create = create;
            function find(node, bubble) {
                if (bubble === void 0) bubble = false;
                if (node == null) return null;
                // @ts-ignore
                if (node[exports.DATA_KEY] != null) return node[exports.DATA_KEY].blot;
                if (bubble) return find(node.parentNode, bubble);
                return null;
            }
            exports.find = find;
            function query(query, scope) {
                if (scope === void 0) scope = Scope.ANY;
                var match;
                if (typeof query === 'string') match = types[query] || attributes[query];
                else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) match = types['text'];
                else if (typeof query === 'number') {
                    if (query & Scope.LEVEL & Scope.BLOCK) match = types['block'];
                    else if (query & Scope.LEVEL & Scope.INLINE) match = types['inline'];
                } else if (query instanceof HTMLElement) {
                    var names = (query.getAttribute('class') || '').split(/\s+/);
                    for(var i in names){
                        match = classes[names[i]];
                        if (match) break;
                    }
                    match = match || tags[query.tagName];
                }
                if (match == null) return null;
                // @ts-ignore
                if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope) return match;
                return null;
            }
            exports.query = query;
            function register() {
                var Definitions = [];
                for(var _i = 0; _i < arguments.length; _i++)Definitions[_i] = arguments[_i];
                if (Definitions.length > 1) return Definitions.map(function(d) {
                    return register(d);
                });
                var Definition = Definitions[0];
                if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') throw new ParchmentError('Invalid definition');
                else if (Definition.blotName === 'abstract') throw new ParchmentError('Cannot register abstract class');
                types[Definition.blotName || Definition.attrName] = Definition;
                if (typeof Definition.keyName === 'string') attributes[Definition.keyName] = Definition;
                else {
                    if (Definition.className != null) classes[Definition.className] = Definition;
                    if (Definition.tagName != null) {
                        if (Array.isArray(Definition.tagName)) Definition.tagName = Definition.tagName.map(function(tagName) {
                            return tagName.toUpperCase();
                        });
                        else Definition.tagName = Definition.tagName.toUpperCase();
                        var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [
                            Definition.tagName
                        ];
                        tagNames.forEach(function(tag) {
                            if (tags[tag] == null || Definition.className == null) tags[tag] = Definition;
                        });
                    }
                }
                return Definition;
            }
            exports.register = register;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            var diff = __webpack_require__(51);
            var equal = __webpack_require__(11);
            var extend = __webpack_require__(3);
            var op = __webpack_require__(20);
            var NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
            var Delta = function(ops) {
                // Assume we are given a well formed ops
                if (Array.isArray(ops)) this.ops = ops;
                else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
                else this.ops = [];
            };
            Delta.prototype.insert = function(text, attributes) {
                var newOp = {};
                if (text.length === 0) return this;
                newOp.insert = text;
                if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
                return this.push(newOp);
            };
            Delta.prototype['delete'] = function(length) {
                if (length <= 0) return this;
                return this.push({
                    'delete': length
                });
            };
            Delta.prototype.retain = function(length, attributes) {
                if (length <= 0) return this;
                var newOp = {
                    retain: length
                };
                if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
                return this.push(newOp);
            };
            Delta.prototype.push = function(newOp) {
                var index = this.ops.length;
                var lastOp = this.ops[index - 1];
                newOp = extend(true, {}, newOp);
                if (typeof lastOp === 'object') {
                    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
                        this.ops[index - 1] = {
                            'delete': lastOp['delete'] + newOp['delete']
                        };
                        return this;
                    }
                    // Since it does not matter if we insert before or after deleting at the same index,
                    // always prefer to insert first
                    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
                        index -= 1;
                        lastOp = this.ops[index - 1];
                        if (typeof lastOp !== 'object') {
                            this.ops.unshift(newOp);
                            return this;
                        }
                    }
                    if (equal(newOp.attributes, lastOp.attributes)) {
                        if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
                            this.ops[index - 1] = {
                                insert: lastOp.insert + newOp.insert
                            };
                            if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                            return this;
                        } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
                            this.ops[index - 1] = {
                                retain: lastOp.retain + newOp.retain
                            };
                            if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                            return this;
                        }
                    }
                }
                if (index === this.ops.length) this.ops.push(newOp);
                else this.ops.splice(index, 0, newOp);
                return this;
            };
            Delta.prototype.chop = function() {
                var lastOp = this.ops[this.ops.length - 1];
                if (lastOp && lastOp.retain && !lastOp.attributes) this.ops.pop();
                return this;
            };
            Delta.prototype.filter = function(predicate) {
                return this.ops.filter(predicate);
            };
            Delta.prototype.forEach = function(predicate) {
                this.ops.forEach(predicate);
            };
            Delta.prototype.map = function(predicate) {
                return this.ops.map(predicate);
            };
            Delta.prototype.partition = function(predicate) {
                var passed = [], failed = [];
                this.forEach(function(op) {
                    var target = predicate(op) ? passed : failed;
                    target.push(op);
                });
                return [
                    passed,
                    failed
                ];
            };
            Delta.prototype.reduce = function(predicate, initial) {
                return this.ops.reduce(predicate, initial);
            };
            Delta.prototype.changeLength = function() {
                return this.reduce(function(length, elem) {
                    if (elem.insert) return length + op.length(elem);
                    else if (elem.delete) return length - elem.delete;
                    return length;
                }, 0);
            };
            Delta.prototype.length = function() {
                return this.reduce(function(length, elem) {
                    return length + op.length(elem);
                }, 0);
            };
            Delta.prototype.slice = function(start, end) {
                start = start || 0;
                if (typeof end !== 'number') end = Infinity;
                var ops = [];
                var iter = op.iterator(this.ops);
                var index = 0;
                while(index < end && iter.hasNext()){
                    var nextOp;
                    if (index < start) nextOp = iter.next(start - index);
                    else {
                        nextOp = iter.next(end - index);
                        ops.push(nextOp);
                    }
                    index += op.length(nextOp);
                }
                return new Delta(ops);
            };
            Delta.prototype.compose = function(other) {
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                var ops = [];
                var firstOther = otherIter.peek();
                if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
                    var firstLeft = firstOther.retain;
                    while(thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft){
                        firstLeft -= thisIter.peekLength();
                        ops.push(thisIter.next());
                    }
                    if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
                }
                var delta = new Delta(ops);
                while(thisIter.hasNext() || otherIter.hasNext()){
                    if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
                    else if (thisIter.peekType() === 'delete') delta.push(thisIter.next());
                    else {
                        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                        var thisOp = thisIter.next(length);
                        var otherOp = otherIter.next(length);
                        if (typeof otherOp.retain === 'number') {
                            var newOp = {};
                            if (typeof thisOp.retain === 'number') newOp.retain = length;
                            else newOp.insert = thisOp.insert;
                            // Preserve null when composing with a retain, otherwise remove it for inserts
                            var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                            if (attributes) newOp.attributes = attributes;
                            delta.push(newOp);
                            // Optimization if rest of other is just retain
                            if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
                                var rest = new Delta(thisIter.rest());
                                return delta.concat(rest).chop();
                            }
                        // Other op should be delete, we could be an insert or retain
                        // Insert + delete cancels out
                        } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') delta.push(otherOp);
                    }
                }
                return delta.chop();
            };
            Delta.prototype.concat = function(other) {
                var delta = new Delta(this.ops.slice());
                if (other.ops.length > 0) {
                    delta.push(other.ops[0]);
                    delta.ops = delta.ops.concat(other.ops.slice(1));
                }
                return delta;
            };
            Delta.prototype.diff = function(other, index) {
                if (this.ops === other.ops) return new Delta();
                var strings = [
                    this,
                    other
                ].map(function(delta) {
                    return delta.map(function(op) {
                        if (op.insert != null) return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
                        var prep = delta === other ? 'on' : 'with';
                        throw new Error('diff() called ' + prep + ' non-document');
                    }).join('');
                });
                var delta = new Delta();
                var diffResult = diff(strings[0], strings[1], index);
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                diffResult.forEach(function(component) {
                    var length = component[1].length;
                    while(length > 0){
                        var opLength = 0;
                        switch(component[0]){
                            case diff.INSERT:
                                opLength = Math.min(otherIter.peekLength(), length);
                                delta.push(otherIter.next(opLength));
                                break;
                            case diff.DELETE:
                                opLength = Math.min(length, thisIter.peekLength());
                                thisIter.next(opLength);
                                delta['delete'](opLength);
                                break;
                            case diff.EQUAL:
                                opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                                var thisOp = thisIter.next(opLength);
                                var otherOp = otherIter.next(opLength);
                                if (equal(thisOp.insert, otherOp.insert)) delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
                                else delta.push(otherOp)['delete'](opLength);
                                break;
                        }
                        length -= opLength;
                    }
                });
                return delta.chop();
            };
            Delta.prototype.eachLine = function(predicate, newline) {
                newline = newline || '\n';
                var iter = op.iterator(this.ops);
                var line = new Delta();
                var i = 0;
                while(iter.hasNext()){
                    if (iter.peekType() !== 'insert') return;
                    var thisOp = iter.peek();
                    var start = op.length(thisOp) - iter.peekLength();
                    var index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
                    if (index < 0) line.push(iter.next());
                    else if (index > 0) line.push(iter.next(index));
                    else {
                        if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                        i += 1;
                        line = new Delta();
                    }
                }
                if (line.length() > 0) predicate(line, {}, i);
            };
            Delta.prototype.transform = function(other, priority) {
                priority = !!priority;
                if (typeof other === 'number') return this.transformPosition(other, priority);
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                var delta = new Delta();
                while(thisIter.hasNext() || otherIter.hasNext()){
                    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) delta.retain(op.length(thisIter.next()));
                    else if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
                    else {
                        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                        var thisOp = thisIter.next(length);
                        var otherOp = otherIter.next(length);
                        if (thisOp['delete']) continue;
                        else if (otherOp['delete']) delta.push(otherOp);
                        else // We retain either their retain or insert
                        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
                    }
                }
                return delta.chop();
            };
            Delta.prototype.transformPosition = function(index, priority) {
                priority = !!priority;
                var thisIter = op.iterator(this.ops);
                var offset = 0;
                while(thisIter.hasNext() && offset <= index){
                    var length = thisIter.peekLength();
                    var nextType = thisIter.peekType();
                    thisIter.next();
                    if (nextType === 'delete') {
                        index -= Math.min(length, index - offset);
                        continue;
                    } else if (nextType === 'insert' && (offset < index || !priority)) index += length;
                    offset += length;
                }
                return index;
            };
            module1.exports = Delta;
        /***/ },
        /* 3 */ /***/ function(module1, exports) {
            'use strict';
            var hasOwn = Object.prototype.hasOwnProperty;
            var toStr = Object.prototype.toString;
            var defineProperty = Object.defineProperty;
            var gOPD = Object.getOwnPropertyDescriptor;
            var isArray = function isArray(arr) {
                if (typeof Array.isArray === 'function') return Array.isArray(arr);
                return toStr.call(arr) === '[object Array]';
            };
            var isPlainObject = function isPlainObject(obj) {
                if (!obj || toStr.call(obj) !== '[object Object]') return false;
                var hasOwnConstructor = hasOwn.call(obj, 'constructor');
                var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
                // Not own constructor property must be Object
                if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
                // Own properties are enumerated firstly, so to speed up,
                // if last one is own, then all properties are own.
                var key;
                for(key in obj);
                return typeof key === 'undefined' || hasOwn.call(obj, key);
            };
            // If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
            var setProperty = function setProperty(target, options) {
                if (defineProperty && options.name === '__proto__') defineProperty(target, options.name, {
                    enumerable: true,
                    configurable: true,
                    value: options.newValue,
                    writable: true
                });
                else target[options.name] = options.newValue;
            };
            // Return undefined instead of __proto__ if '__proto__' is not an own property
            var getProperty = function getProperty(obj, name) {
                if (name === '__proto__') {
                    if (!hasOwn.call(obj, name)) return void 0;
                    else if (gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
                    // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
                    return gOPD(obj, name).value;
                }
                return obj[name];
            };
            module1.exports = function extend() {
                var options, name, src, copy, copyIsArray, clone;
                var target = arguments[0];
                var i = 1;
                var length = arguments.length;
                var deep = false;
                // Handle a deep copy situation
                if (typeof target === 'boolean') {
                    deep = target;
                    target = arguments[1] || {};
                    // skip the boolean and the target
                    i = 2;
                }
                if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
                for(; i < length; ++i){
                    options = arguments[i];
                    // Only deal with non-null/undefined values
                    if (options != null) // Extend the base object
                    for(name in options){
                        src = getProperty(target, name);
                        copy = getProperty(options, name);
                        // Prevent never-ending loop
                        if (target !== copy) {
                            // Recurse if we're merging plain objects or arrays
                            if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                                if (copyIsArray) {
                                    copyIsArray = false;
                                    clone = src && isArray(src) ? src : [];
                                } else clone = src && isPlainObject(src) ? src : {};
                                // Never move original objects, clone them
                                setProperty(target, {
                                    name: name,
                                    newValue: extend(deep, clone, copy)
                                });
                            // Don't bring in undefined values
                            } else if (typeof copy !== 'undefined') setProperty(target, {
                                name: name,
                                newValue: copy
                            });
                        }
                    }
                }
                // Return the modified object
                return target;
            };
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var NEWLINE_LENGTH = 1;
            var BlockEmbed = function(_Parchment$Embed) {
                _inherits(BlockEmbed, _Parchment$Embed);
                function BlockEmbed() {
                    _classCallCheck(this, BlockEmbed);
                    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
                }
                _createClass(BlockEmbed, [
                    {
                        key: 'attach',
                        value: function attach() {
                            _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
                            this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
                        }
                    },
                    {
                        key: 'delta',
                        value: function delta() {
                            return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
                        }
                    },
                    {
                        key: 'format',
                        value: function format(name, value) {
                            var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
                            if (attribute != null) this.attributes.attribute(attribute, value);
                        }
                    },
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            this.format(name, value);
                        }
                    },
                    {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (typeof value === 'string' && value.endsWith('\n')) {
                                var block = _parchment2.default.create(Block.blotName);
                                this.parent.insertBefore(block, index === 0 ? this : this.next);
                                block.insertAt(0, value.slice(0, -1));
                            } else _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
                        }
                    }
                ]);
                return BlockEmbed;
            }(_parchment2.default.Embed);
            BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
            // It is important for cursor behavior BlockEmbeds use tags that are block level elements
            var Block = function(_Parchment$Block) {
                _inherits(Block, _Parchment$Block);
                function Block(domNode) {
                    _classCallCheck(this, Block);
                    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));
                    _this2.cache = {};
                    return _this2;
                }
                _createClass(Block, [
                    {
                        key: 'delta',
                        value: function delta() {
                            if (this.cache.delta == null) this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function(delta, leaf) {
                                if (leaf.length() === 0) return delta;
                                else return delta.insert(leaf.value(), bubbleFormats(leaf));
                            }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
                            return this.cache.delta;
                        }
                    },
                    {
                        key: 'deleteAt',
                        value: function deleteAt(index, length) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            if (length <= 0) return;
                            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
                                if (index + length === this.length()) this.format(name, value);
                            } else _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
                            if (value.length === 0) return;
                            var lines = value.split('\n');
                            var text = lines.shift();
                            if (text.length > 0) {
                                if (index < this.length() - 1 || this.children.tail == null) _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
                                else this.children.tail.insertAt(this.children.tail.length(), text);
                                this.cache = {};
                            }
                            var block = this;
                            lines.reduce(function(index, line) {
                                block = block.split(index, true);
                                block.insertAt(0, line);
                                return line.length;
                            }, index + text.length);
                        }
                    },
                    {
                        key: 'insertBefore',
                        value: function insertBefore(blot, ref) {
                            var head = this.children.head;
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
                            if (head instanceof _break2.default) head.remove();
                            this.cache = {};
                        }
                    },
                    {
                        key: 'length',
                        value: function length() {
                            if (this.cache.length == null) this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
                            return this.cache.length;
                        }
                    },
                    {
                        key: 'moveChildren',
                        value: function moveChildren(target, ref) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'path',
                        value: function path(index) {
                            return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
                        }
                    },
                    {
                        key: 'removeChild',
                        value: function removeChild(child) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'split',
                        value: function split(index) {
                            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
                                var clone = this.clone();
                                if (index === 0) {
                                    this.parent.insertBefore(clone, this);
                                    return this;
                                } else {
                                    this.parent.insertBefore(clone, this.next);
                                    return clone;
                                }
                            } else {
                                var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
                                this.cache = {};
                                return next;
                            }
                        }
                    }
                ]);
                return Block;
            }(_parchment2.default.Block);
            Block.blotName = 'block';
            Block.tagName = 'P';
            Block.defaultChild = 'break';
            Block.allowedChildren = [
                _inline2.default,
                _parchment2.default.Embed,
                _text2.default
            ];
            function bubbleFormats(blot) {
                var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (blot == null) return formats;
                if (typeof blot.formats === 'function') formats = (0, _extend2.default)(formats, blot.formats());
                if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) return formats;
                return bubbleFormats(blot.parent, formats);
            }
            exports.bubbleFormats = bubbleFormats;
            exports.BlockEmbed = BlockEmbed;
            exports.default = Block;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.overload = exports.expandConfig = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            __webpack_require__(50);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _editor = __webpack_require__(14);
            var _editor2 = _interopRequireDefault(_editor);
            var _emitter3 = __webpack_require__(8);
            var _emitter4 = _interopRequireDefault(_emitter3);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _selection = __webpack_require__(15);
            var _selection2 = _interopRequireDefault(_selection);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _theme = __webpack_require__(34);
            var _theme2 = _interopRequireDefault(_theme);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var debug = (0, _logger2.default)('quill');
            var Quill = function() {
                _createClass(Quill, null, [
                    {
                        key: 'debug',
                        value: function debug(limit) {
                            if (limit === true) limit = 'log';
                            _logger2.default.level(limit);
                        }
                    },
                    {
                        key: 'find',
                        value: function find(node) {
                            return node.__quill || _parchment2.default.find(node);
                        }
                    },
                    {
                        key: 'import',
                        value: function _import(name) {
                            if (this.imports[name] == null) debug.error('Cannot import ' + name + '. Are you sure it was registered?');
                            return this.imports[name];
                        }
                    },
                    {
                        key: 'register',
                        value: function register(path, target) {
                            var _this = this;
                            var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                            if (typeof path !== 'string') {
                                var name = path.attrName || path.blotName;
                                if (typeof name === 'string') // register(Blot | Attributor, overwrite)
                                this.register('formats/' + name, path, target);
                                else Object.keys(path).forEach(function(key) {
                                    _this.register(key, path[key], target);
                                });
                            } else {
                                if (this.imports[path] != null && !overwrite) debug.warn('Overwriting ' + path + ' with', target);
                                this.imports[path] = target;
                                if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') _parchment2.default.register(target);
                                else if (path.startsWith('modules') && typeof target.register === 'function') target.register();
                            }
                        }
                    }
                ]);
                function Quill(container) {
                    var _this2 = this;
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, Quill);
                    this.options = expandConfig(container, options);
                    this.container = this.options.container;
                    if (this.container == null) return debug.error('Invalid Quill container', container);
                    if (this.options.debug) Quill.debug(this.options.debug);
                    var html = this.container.innerHTML.trim();
                    this.container.classList.add('ql-container');
                    this.container.innerHTML = '';
                    this.container.__quill = this;
                    this.root = this.addContainer('ql-editor');
                    this.root.classList.add('ql-blank');
                    this.root.setAttribute('data-gramm', false);
                    this.scrollingContainer = this.options.scrollingContainer || this.root;
                    this.emitter = new _emitter4.default();
                    this.scroll = _parchment2.default.create(this.root, {
                        emitter: this.emitter,
                        whitelist: this.options.formats
                    });
                    this.editor = new _editor2.default(this.scroll);
                    this.selection = new _selection2.default(this.scroll, this.emitter);
                    this.theme = new this.options.theme(this, this.options);
                    this.keyboard = this.theme.addModule('keyboard');
                    this.clipboard = this.theme.addModule('clipboard');
                    this.history = this.theme.addModule('history');
                    this.theme.init();
                    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type) {
                        if (type === _emitter4.default.events.TEXT_CHANGE) _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function(source, mutations) {
                        var range = _this2.selection.lastRange;
                        var index = range && range.length === 0 ? range.index : undefined;
                        modify.call(_this2, function() {
                            return _this2.editor.update(null, mutations, index);
                        }, source);
                    });
                    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
                    this.setContents(contents);
                    this.history.clear();
                    if (this.options.placeholder) this.root.setAttribute('data-placeholder', this.options.placeholder);
                    if (this.options.readOnly) this.disable();
                }
                _createClass(Quill, [
                    {
                        key: 'addContainer',
                        value: function addContainer(container) {
                            var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                            if (typeof container === 'string') {
                                var className = container;
                                container = document.createElement('div');
                                container.classList.add(className);
                            }
                            this.container.insertBefore(container, refNode);
                            return container;
                        }
                    },
                    {
                        key: 'blur',
                        value: function blur() {
                            this.selection.setRange(null);
                        }
                    },
                    {
                        key: 'deleteText',
                        value: function deleteText(index, length, source) {
                            var _this3 = this;
                            var _overload = overload(index, length, source);
                            var _overload2 = _slicedToArray(_overload, 4);
                            index = _overload2[0];
                            length = _overload2[1];
                            source = _overload2[3];
                            return modify.call(this, function() {
                                return _this3.editor.deleteText(index, length);
                            }, source, index, -1 * length);
                        }
                    },
                    {
                        key: 'disable',
                        value: function disable() {
                            this.enable(false);
                        }
                    },
                    {
                        key: 'enable',
                        value: function enable() {
                            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                            this.scroll.enable(enabled);
                            this.container.classList.toggle('ql-disabled', !enabled);
                        }
                    },
                    {
                        key: 'focus',
                        value: function focus() {
                            var scrollTop = this.scrollingContainer.scrollTop;
                            this.selection.focus();
                            this.scrollingContainer.scrollTop = scrollTop;
                            this.scrollIntoView();
                        }
                    },
                    {
                        key: 'format',
                        value: function format(name, value) {
                            var _this4 = this;
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                var range = _this4.getSelection(true);
                                var change = new _quillDelta2.default();
                                if (range == null) return change;
                                else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
                                else if (range.length === 0) {
                                    _this4.selection.format(name, value);
                                    return change;
                                } else change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
                                _this4.setSelection(range, _emitter4.default.sources.SILENT);
                                return change;
                            }, source);
                        }
                    },
                    {
                        key: 'formatLine',
                        value: function formatLine(index, length, name, value, source) {
                            var _this5 = this;
                            var formats = void 0;
                            var _overload3 = overload(index, length, name, value, source);
                            var _overload4 = _slicedToArray(_overload3, 4);
                            index = _overload4[0];
                            length = _overload4[1];
                            formats = _overload4[2];
                            source = _overload4[3];
                            return modify.call(this, function() {
                                return _this5.editor.formatLine(index, length, formats);
                            }, source, index, 0);
                        }
                    },
                    {
                        key: 'formatText',
                        value: function formatText(index, length, name, value, source) {
                            var _this6 = this;
                            var formats = void 0;
                            var _overload5 = overload(index, length, name, value, source);
                            var _overload6 = _slicedToArray(_overload5, 4);
                            index = _overload6[0];
                            length = _overload6[1];
                            formats = _overload6[2];
                            source = _overload6[3];
                            return modify.call(this, function() {
                                return _this6.editor.formatText(index, length, formats);
                            }, source, index, 0);
                        }
                    },
                    {
                        key: 'getBounds',
                        value: function getBounds(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var bounds = void 0;
                            if (typeof index === 'number') bounds = this.selection.getBounds(index, length);
                            else bounds = this.selection.getBounds(index.index, index.length);
                            var containerBounds = this.container.getBoundingClientRect();
                            return {
                                bottom: bounds.bottom - containerBounds.top,
                                height: bounds.height,
                                left: bounds.left - containerBounds.left,
                                right: bounds.right - containerBounds.left,
                                top: bounds.top - containerBounds.top,
                                width: bounds.width
                            };
                        }
                    },
                    {
                        key: 'getContents',
                        value: function getContents() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
                            var _overload7 = overload(index, length);
                            var _overload8 = _slicedToArray(_overload7, 2);
                            index = _overload8[0];
                            length = _overload8[1];
                            return this.editor.getContents(index, length);
                        }
                    },
                    {
                        key: 'getFormat',
                        value: function getFormat() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            if (typeof index === 'number') return this.editor.getFormat(index, length);
                            else return this.editor.getFormat(index.index, index.length);
                        }
                    },
                    {
                        key: 'getIndex',
                        value: function getIndex(blot) {
                            return blot.offset(this.scroll);
                        }
                    },
                    {
                        key: 'getLength',
                        value: function getLength() {
                            return this.scroll.length();
                        }
                    },
                    {
                        key: 'getLeaf',
                        value: function getLeaf(index) {
                            return this.scroll.leaf(index);
                        }
                    },
                    {
                        key: 'getLine',
                        value: function getLine(index) {
                            return this.scroll.line(index);
                        }
                    },
                    {
                        key: 'getLines',
                        value: function getLines() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
                            if (typeof index !== 'number') return this.scroll.lines(index.index, index.length);
                            else return this.scroll.lines(index, length);
                        }
                    },
                    {
                        key: 'getModule',
                        value: function getModule(name) {
                            return this.theme.modules[name];
                        }
                    },
                    {
                        key: 'getSelection',
                        value: function getSelection() {
                            var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                            if (focus) this.focus();
                            this.update(); // Make sure we access getRange with editor in consistent state
                            return this.selection.getRange()[0];
                        }
                    },
                    {
                        key: 'getText',
                        value: function getText() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
                            var _overload9 = overload(index, length);
                            var _overload10 = _slicedToArray(_overload9, 2);
                            index = _overload10[0];
                            length = _overload10[1];
                            return this.editor.getText(index, length);
                        }
                    },
                    {
                        key: 'hasFocus',
                        value: function hasFocus() {
                            return this.selection.hasFocus();
                        }
                    },
                    {
                        key: 'insertEmbed',
                        value: function insertEmbed(index, embed, value) {
                            var _this7 = this;
                            var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
                            return modify.call(this, function() {
                                return _this7.editor.insertEmbed(index, embed, value);
                            }, source, index);
                        }
                    },
                    {
                        key: 'insertText',
                        value: function insertText(index, text, name, value, source) {
                            var _this8 = this;
                            var formats = void 0;
                            var _overload11 = overload(index, 0, name, value, source);
                            var _overload12 = _slicedToArray(_overload11, 4);
                            index = _overload12[0];
                            formats = _overload12[2];
                            source = _overload12[3];
                            return modify.call(this, function() {
                                return _this8.editor.insertText(index, text, formats);
                            }, source, index, text.length);
                        }
                    },
                    {
                        key: 'isEnabled',
                        value: function isEnabled() {
                            return !this.container.classList.contains('ql-disabled');
                        }
                    },
                    {
                        key: 'off',
                        value: function off() {
                            return this.emitter.off.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: 'on',
                        value: function on() {
                            return this.emitter.on.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: 'once',
                        value: function once() {
                            return this.emitter.once.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: 'pasteHTML',
                        value: function pasteHTML(index, html, source) {
                            this.clipboard.dangerouslyPasteHTML(index, html, source);
                        }
                    },
                    {
                        key: 'removeFormat',
                        value: function removeFormat(index, length, source) {
                            var _this9 = this;
                            var _overload13 = overload(index, length, source);
                            var _overload14 = _slicedToArray(_overload13, 4);
                            index = _overload14[0];
                            length = _overload14[1];
                            source = _overload14[3];
                            return modify.call(this, function() {
                                return _this9.editor.removeFormat(index, length);
                            }, source, index);
                        }
                    },
                    {
                        key: 'scrollIntoView',
                        value: function scrollIntoView() {
                            this.selection.scrollIntoView(this.scrollingContainer);
                        }
                    },
                    {
                        key: 'setContents',
                        value: function setContents(delta) {
                            var _this10 = this;
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                delta = new _quillDelta2.default(delta);
                                var length = _this10.getLength();
                                var deleted = _this10.editor.deleteText(0, length);
                                var applied = _this10.editor.applyDelta(delta);
                                var lastOp = applied.ops[applied.ops.length - 1];
                                if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
                                    _this10.editor.deleteText(_this10.getLength() - 1, 1);
                                    applied.delete(1);
                                }
                                var ret = deleted.compose(applied);
                                return ret;
                            }, source);
                        }
                    },
                    {
                        key: 'setSelection',
                        value: function setSelection(index, length, source) {
                            if (index == null) this.selection.setRange(null, length || Quill.sources.API);
                            else {
                                var _overload15 = overload(index, length, source);
                                var _overload16 = _slicedToArray(_overload15, 4);
                                index = _overload16[0];
                                length = _overload16[1];
                                source = _overload16[3];
                                this.selection.setRange(new _selection.Range(index, length), source);
                                if (source !== _emitter4.default.sources.SILENT) this.selection.scrollIntoView(this.scrollingContainer);
                            }
                        }
                    },
                    {
                        key: 'setText',
                        value: function setText(text) {
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            var delta = new _quillDelta2.default().insert(text);
                            return this.setContents(delta, source);
                        }
                    },
                    {
                        key: 'update',
                        value: function update() {
                            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
                            var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
                            this.selection.update(source);
                            return change;
                        }
                    },
                    {
                        key: 'updateContents',
                        value: function updateContents(delta) {
                            var _this11 = this;
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                delta = new _quillDelta2.default(delta);
                                return _this11.editor.applyDelta(delta, source);
                            }, source, true);
                        }
                    }
                ]);
                return Quill;
            }();
            Quill.DEFAULTS = {
                bounds: null,
                formats: null,
                modules: {},
                placeholder: '',
                readOnly: false,
                scrollingContainer: null,
                strict: true,
                theme: 'default'
            };
            Quill.events = _emitter4.default.events;
            Quill.sources = _emitter4.default.sources;
            // eslint-disable-next-line no-undef
            Quill.version = "1.3.7";
            Quill.imports = {
                'delta': _quillDelta2.default,
                'parchment': _parchment2.default,
                'core/module': _module2.default,
                'core/theme': _theme2.default
            };
            function expandConfig(container, userConfig) {
                userConfig = (0, _extend2.default)(true, {
                    container: container,
                    modules: {
                        clipboard: true,
                        keyboard: true,
                        history: true
                    }
                }, userConfig);
                if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) userConfig.theme = _theme2.default;
                else {
                    userConfig.theme = Quill.import('themes/' + userConfig.theme);
                    if (userConfig.theme == null) throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
                }
                var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
                [
                    themeConfig,
                    userConfig
                ].forEach(function(config) {
                    config.modules = config.modules || {};
                    Object.keys(config.modules).forEach(function(module1) {
                        if (config.modules[module1] === true) config.modules[module1] = {};
                    });
                });
                var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
                var moduleConfig = moduleNames.reduce(function(config, name) {
                    var moduleClass = Quill.import('modules/' + name);
                    if (moduleClass == null) debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
                    else config[name] = moduleClass.DEFAULTS || {};
                    return config;
                }, {});
                // Special case toolbar shorthand
                if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) userConfig.modules.toolbar = {
                    container: userConfig.modules.toolbar
                };
                userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, {
                    modules: moduleConfig
                }, themeConfig, userConfig);
                [
                    'bounds',
                    'container',
                    'scrollingContainer'
                ].forEach(function(key) {
                    if (typeof userConfig[key] === 'string') userConfig[key] = document.querySelector(userConfig[key]);
                });
                userConfig.modules = Object.keys(userConfig.modules).reduce(function(config, name) {
                    if (userConfig.modules[name]) config[name] = userConfig.modules[name];
                    return config;
                }, {});
                return userConfig;
            }
            // Handle selection preservation and TEXT_CHANGE emission
            // common to modification APIs
            function modify(modifier, source, index, shift) {
                if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) return new _quillDelta2.default();
                var range = index == null ? null : this.getSelection();
                var oldDelta = this.editor.delta;
                var change = modifier();
                if (range != null) {
                    if (index === true) index = range.index;
                    if (shift == null) range = shiftRange(range, change, source);
                    else if (shift !== 0) range = shiftRange(range, index, shift, source);
                    this.setSelection(range, _emitter4.default.sources.SILENT);
                }
                if (change.length() > 0) {
                    var _emitter;
                    var args = [
                        _emitter4.default.events.TEXT_CHANGE,
                        change,
                        oldDelta,
                        source
                    ];
                    (_emitter = this.emitter).emit.apply(_emitter, [
                        _emitter4.default.events.EDITOR_CHANGE
                    ].concat(args));
                    if (source !== _emitter4.default.sources.SILENT) {
                        var _emitter2;
                        (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                    }
                }
                return change;
            }
            function overload(index, length, name, value, source) {
                var formats = {};
                if (typeof index.index === 'number' && typeof index.length === 'number') {
                    // Allow for throwaway end (used by insertText/insertEmbed)
                    if (typeof length !== 'number') source = value, value = name, name = length, length = index.length, index = index.index;
                    else length = index.length, index = index.index;
                } else if (typeof length !== 'number') source = value, value = name, name = length, length = 0;
                // Handle format being object, two format name/value strings or excluded
                if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
                    formats = name;
                    source = value;
                } else if (typeof name === 'string') {
                    if (value != null) formats[name] = value;
                    else source = name;
                }
                // Handle optional source
                source = source || _emitter4.default.sources.API;
                return [
                    index,
                    length,
                    formats,
                    source
                ];
            }
            function shiftRange(range, index, length, source) {
                if (range == null) return null;
                var start = void 0, end = void 0;
                if (index instanceof _quillDelta2.default) {
                    var _map = [
                        range.index,
                        range.index + range.length
                    ].map(function(pos) {
                        return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
                    });
                    var _map2 = _slicedToArray(_map, 2);
                    start = _map2[0];
                    end = _map2[1];
                } else {
                    var _map3 = [
                        range.index,
                        range.index + range.length
                    ].map(function(pos) {
                        if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
                        if (length >= 0) return pos + length;
                        else return Math.max(index, pos + length);
                    });
                    var _map4 = _slicedToArray(_map3, 2);
                    start = _map4[0];
                    end = _map4[1];
                }
                return new _selection.Range(start, end - start);
            }
            exports.expandConfig = expandConfig;
            exports.overload = overload;
            exports.default = Quill;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Inline = function(_Parchment$Inline) {
                _inherits(Inline, _Parchment$Inline);
                function Inline() {
                    _classCallCheck(this, Inline);
                    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
                }
                _createClass(Inline, [
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
                                var blot = this.isolate(index, length);
                                if (value) blot.wrap(name, value);
                            } else _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
                            if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
                                var parent = this.parent.isolate(this.offset(), this.length());
                                this.moveChildren(parent);
                                parent.wrap(this);
                            }
                        }
                    }
                ], [
                    {
                        key: 'compare',
                        value: function compare(self1, other) {
                            var selfIndex = Inline.order.indexOf(self1);
                            var otherIndex = Inline.order.indexOf(other);
                            if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
                            else if (self1 === other) return 0;
                            else if (self1 < other) return -1;
                            else return 1;
                        }
                    }
                ]);
                return Inline;
            }(_parchment2.default.Inline);
            Inline.allowedChildren = [
                Inline,
                _parchment2.default.Embed,
                _text2.default
            ];
            // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
            Inline.order = [
                'cursor',
                'inline',
                'underline',
                'strike',
                'italic',
                'bold',
                'script',
                'link',
                'code' // Must be higher
            ];
            exports.default = Inline;
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TextBlot = function(_Parchment$Text) {
                _inherits(TextBlot, _Parchment$Text);
                function TextBlot() {
                    _classCallCheck(this, TextBlot);
                    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
                }
                return TextBlot;
            }(_parchment2.default.Text);
            exports.default = TextBlot;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _eventemitter = __webpack_require__(54);
            var _eventemitter2 = _interopRequireDefault(_eventemitter);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)('quill:events');
            var EVENTS = [
                'selectionchange',
                'mousedown',
                'mouseup',
                'click'
            ];
            EVENTS.forEach(function(eventName) {
                document.addEventListener(eventName, function() {
                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function(node) {
                        // TODO use WeakMap
                        if (node.__quill && node.__quill.emitter) {
                            var _node$__quill$emitter;
                            (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
                        }
                    });
                });
            });
            var Emitter = function(_EventEmitter) {
                _inherits(Emitter, _EventEmitter);
                function Emitter() {
                    _classCallCheck(this, Emitter);
                    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));
                    _this.listeners = {};
                    _this.on('error', debug.error);
                    return _this;
                }
                _createClass(Emitter, [
                    {
                        key: 'emit',
                        value: function emit() {
                            debug.log.apply(debug, arguments);
                            _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
                        }
                    },
                    {
                        key: 'handleDOM',
                        value: function handleDOM(event) {
                            for(var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                            (this.listeners[event.type] || []).forEach(function(_ref) {
                                var node = _ref.node, handler = _ref.handler;
                                if (event.target === node || node.contains(event.target)) handler.apply(undefined, [
                                    event
                                ].concat(args));
                            });
                        }
                    },
                    {
                        key: 'listenDOM',
                        value: function listenDOM(eventName, node, handler) {
                            if (!this.listeners[eventName]) this.listeners[eventName] = [];
                            this.listeners[eventName].push({
                                node: node,
                                handler: handler
                            });
                        }
                    }
                ]);
                return Emitter;
            }(_eventemitter2.default);
            Emitter.events = {
                EDITOR_CHANGE: 'editor-change',
                SCROLL_BEFORE_UPDATE: 'scroll-before-update',
                SCROLL_OPTIMIZE: 'scroll-optimize',
                SCROLL_UPDATE: 'scroll-update',
                SELECTION_CHANGE: 'selection-change',
                TEXT_CHANGE: 'text-change'
            };
            Emitter.sources = {
                API: 'api',
                SILENT: 'silent',
                USER: 'user'
            };
            exports.default = Emitter;
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Module = function Module(quill) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                _classCallCheck(this, Module);
                this.quill = quill;
                this.options = options;
            };
            Module.DEFAULTS = {};
            exports.default = Module;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var levels = [
                'error',
                'warn',
                'log',
                'info'
            ];
            var level = 'warn';
            function debug(method) {
                if (levels.indexOf(method) <= levels.indexOf(level)) {
                    var _console;
                    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
                }
            }
            function namespace(ns) {
                return levels.reduce(function(logger, method) {
                    logger[method] = debug.bind(console, method, ns);
                    return logger;
                }, {});
            }
            debug.level = namespace.level = function(newLevel) {
                level = newLevel;
            };
            exports.default = namespace;
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            var pSlice = Array.prototype.slice;
            var objectKeys = __webpack_require__(52);
            var isArguments = __webpack_require__(53);
            var deepEqual = module1.exports = function(actual, expected, opts) {
                if (!opts) opts = {};
                // 7.1. All identical values are equivalent, as determined by ===.
                if (actual === expected) return true;
                else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
                else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') return opts.strict ? actual === expected : actual == expected;
                else return objEquiv(actual, expected, opts);
            };
            function isUndefinedOrNull(value) {
                return value === null || value === undefined;
            }
            function isBuffer(x) {
                if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
                if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
                if (x.length > 0 && typeof x[0] !== 'number') return false;
                return true;
            }
            function objEquiv(a, b, opts) {
                var i, key;
                if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
                // an identical 'prototype' property.
                if (a.prototype !== b.prototype) return false;
                //~~~I've managed to break Object.keys through screwy arguments passing.
                //   Converting to array solves the problem.
                if (isArguments(a)) {
                    if (!isArguments(b)) return false;
                    a = pSlice.call(a);
                    b = pSlice.call(b);
                    return deepEqual(a, b, opts);
                }
                if (isBuffer(a)) {
                    if (!isBuffer(b)) return false;
                    if (a.length !== b.length) return false;
                    for(i = 0; i < a.length; i++){
                        if (a[i] !== b[i]) return false;
                    }
                    return true;
                }
                try {
                    var ka = objectKeys(a), kb = objectKeys(b);
                } catch (e) {
                    return false;
                }
                // having the same number of owned properties (keys incorporates
                // hasOwnProperty)
                if (ka.length != kb.length) return false;
                //the same set of keys (although not necessarily the same order),
                ka.sort();
                kb.sort();
                //~~~cheap key test
                for(i = ka.length - 1; i >= 0; i--){
                    if (ka[i] != kb[i]) return false;
                }
                //equivalent values for every corresponding key, and
                //~~~possibly expensive deep test
                for(i = ka.length - 1; i >= 0; i--){
                    key = ka[i];
                    if (!deepEqual(a[key], b[key], opts)) return false;
                }
                return typeof a === typeof b;
            }
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var Registry = __webpack_require__(1);
            var Attributor = /** @class */ function() {
                function Attributor(attrName, keyName, options) {
                    if (options === void 0) options = {};
                    this.attrName = attrName;
                    this.keyName = keyName;
                    var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
                    if (options.scope != null) // Ignore type bits, force attribute bit
                    this.scope = options.scope & Registry.Scope.LEVEL | attributeBit;
                    else this.scope = Registry.Scope.ATTRIBUTE;
                    if (options.whitelist != null) this.whitelist = options.whitelist;
                }
                Attributor.keys = function(node) {
                    return [].map.call(node.attributes, function(item) {
                        return item.name;
                    });
                };
                Attributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    node.setAttribute(this.keyName, value);
                    return true;
                };
                Attributor.prototype.canAdd = function(node, value) {
                    var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
                    if (match == null) return false;
                    if (this.whitelist == null) return true;
                    if (typeof value === 'string') return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
                    else return this.whitelist.indexOf(value) > -1;
                };
                Attributor.prototype.remove = function(node) {
                    node.removeAttribute(this.keyName);
                };
                Attributor.prototype.value = function(node) {
                    var value = node.getAttribute(this.keyName);
                    if (this.canAdd(node, value) && value) return value;
                    return '';
                };
                return Attributor;
            }();
            exports.default = Attributor;
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.Code = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Code = function(_Inline) {
                _inherits(Code, _Inline);
                function Code() {
                    _classCallCheck(this, Code);
                    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
                }
                return Code;
            }(_inline2.default);
            Code.blotName = 'code';
            Code.tagName = 'CODE';
            var CodeBlock = function(_Block) {
                _inherits(CodeBlock, _Block);
                function CodeBlock() {
                    _classCallCheck(this, CodeBlock);
                    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
                }
                _createClass(CodeBlock, [
                    {
                        key: 'delta',
                        value: function delta() {
                            var _this3 = this;
                            var text = this.domNode.textContent;
                            if (text.endsWith('\n')) // Should always be true
                            text = text.slice(0, -1);
                            return text.split('\n').reduce(function(delta, frag) {
                                return delta.insert(frag).insert('\n', _this3.formats());
                            }, new _quillDelta2.default());
                        }
                    },
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (name === this.statics.blotName && value) return;
                            var _descendant = this.descendant(_text2.default, this.length() - 1), _descendant2 = _slicedToArray(_descendant, 1), text = _descendant2[0];
                            if (text != null) text.deleteAt(text.length() - 1, 1);
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
                        }
                    },
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            if (length === 0) return;
                            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) return;
                            var nextNewline = this.newlineIndex(index);
                            if (nextNewline < 0 || nextNewline >= index + length) return;
                            var prevNewline = this.newlineIndex(index, true) + 1;
                            var isolateLength = nextNewline - prevNewline + 1;
                            var blot = this.isolate(prevNewline, isolateLength);
                            var next = blot.next;
                            blot.format(name, value);
                            if (next instanceof CodeBlock) next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
                        }
                    },
                    {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (def != null) return;
                            var _descendant3 = this.descendant(_text2.default, index), _descendant4 = _slicedToArray(_descendant3, 2), text = _descendant4[0], offset = _descendant4[1];
                            text.insertAt(offset, value);
                        }
                    },
                    {
                        key: 'length',
                        value: function length() {
                            var length = this.domNode.textContent.length;
                            if (!this.domNode.textContent.endsWith('\n')) return length + 1;
                            return length;
                        }
                    },
                    {
                        key: 'newlineIndex',
                        value: function newlineIndex(searchIndex) {
                            var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            if (!reverse) {
                                var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
                                return offset > -1 ? searchIndex + offset : -1;
                            } else return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            if (!this.domNode.textContent.endsWith('\n')) this.appendChild(_parchment2.default.create('text', '\n'));
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
                            var next = this.next;
                            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
                                next.optimize(context);
                                next.moveChildren(this);
                                next.remove();
                            }
                        }
                    },
                    {
                        key: 'replace',
                        value: function replace(target) {
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
                            [].slice.call(this.domNode.querySelectorAll('*')).forEach(function(node) {
                                var blot = _parchment2.default.find(node);
                                if (blot == null) node.parentNode.removeChild(node);
                                else if (blot instanceof _parchment2.default.Embed) blot.remove();
                                else blot.unwrap();
                            });
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create(value) {
                            var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
                            domNode.setAttribute('spellcheck', false);
                            return domNode;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats() {
                            return true;
                        }
                    }
                ]);
                return CodeBlock;
            }(_block2.default);
            CodeBlock.blotName = 'code-block';
            CodeBlock.tagName = 'PRE';
            CodeBlock.TAB = '  ';
            exports.Code = Code;
            exports.default = CodeBlock;
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _op = __webpack_require__(20);
            var _op2 = _interopRequireDefault(_op);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _cursor = __webpack_require__(24);
            var _cursor2 = _interopRequireDefault(_cursor);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var ASCII = /^[ -~]*$/;
            var Editor = function() {
                function Editor(scroll) {
                    _classCallCheck(this, Editor);
                    this.scroll = scroll;
                    this.delta = this.getDelta();
                }
                _createClass(Editor, [
                    {
                        key: 'applyDelta',
                        value: function applyDelta(delta) {
                            var _this = this;
                            var consumeNextNewline = false;
                            this.scroll.update();
                            var scrollLength = this.scroll.length();
                            this.scroll.batchStart();
                            delta = normalizeDelta(delta);
                            delta.reduce(function(index, op) {
                                var length = op.retain || op.delete || op.insert.length || 1;
                                var attributes = op.attributes || {};
                                if (op.insert != null) {
                                    if (typeof op.insert === 'string') {
                                        var text = op.insert;
                                        if (text.endsWith('\n') && consumeNextNewline) {
                                            consumeNextNewline = false;
                                            text = text.slice(0, -1);
                                        }
                                        if (index >= scrollLength && !text.endsWith('\n')) consumeNextNewline = true;
                                        _this.scroll.insertAt(index, text);
                                        var _scroll$line = _this.scroll.line(index), _scroll$line2 = _slicedToArray(_scroll$line, 2), line = _scroll$line2[0], offset = _scroll$line2[1];
                                        var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
                                        if (line instanceof _block2.default) {
                                            var _line$descendant = line.descendant(_parchment2.default.Leaf, offset), _line$descendant2 = _slicedToArray(_line$descendant, 1), leaf = _line$descendant2[0];
                                            formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
                                        }
                                        attributes = _op2.default.attributes.diff(formats, attributes) || {};
                                    } else if (_typeof(op.insert) === 'object') {
                                        var key = Object.keys(op.insert)[0]; // There should only be one key
                                        if (key == null) return index;
                                        _this.scroll.insertAt(index, key, op.insert[key]);
                                    }
                                    scrollLength += length;
                                }
                                Object.keys(attributes).forEach(function(name) {
                                    _this.scroll.formatAt(index, length, name, attributes[name]);
                                });
                                return index + length;
                            }, 0);
                            delta.reduce(function(index, op) {
                                if (typeof op.delete === 'number') {
                                    _this.scroll.deleteAt(index, op.delete);
                                    return index;
                                }
                                return index + (op.retain || op.insert.length || 1);
                            }, 0);
                            this.scroll.batchEnd();
                            return this.update(delta);
                        }
                    },
                    {
                        key: 'deleteText',
                        value: function deleteText(index, length) {
                            this.scroll.deleteAt(index, length);
                            return this.update(new _quillDelta2.default().retain(index).delete(length));
                        }
                    },
                    {
                        key: 'formatLine',
                        value: function formatLine(index, length) {
                            var _this2 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            this.scroll.update();
                            Object.keys(formats).forEach(function(format) {
                                if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
                                var lines = _this2.scroll.lines(index, Math.max(length, 1));
                                var lengthRemaining = length;
                                lines.forEach(function(line) {
                                    var lineLength = line.length();
                                    if (!(line instanceof _code2.default)) line.format(format, formats[format]);
                                    else {
                                        var codeIndex = index - line.offset(_this2.scroll);
                                        var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
                                        line.formatAt(codeIndex, codeLength, format, formats[format]);
                                    }
                                    lengthRemaining -= lineLength;
                                });
                            });
                            this.scroll.optimize();
                            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: 'formatText',
                        value: function formatText(index, length) {
                            var _this3 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            Object.keys(formats).forEach(function(format) {
                                _this3.scroll.formatAt(index, length, format, formats[format]);
                            });
                            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: 'getContents',
                        value: function getContents(index, length) {
                            return this.delta.slice(index, index + length);
                        }
                    },
                    {
                        key: 'getDelta',
                        value: function getDelta() {
                            return this.scroll.lines().reduce(function(delta, line) {
                                return delta.concat(line.delta());
                            }, new _quillDelta2.default());
                        }
                    },
                    {
                        key: 'getFormat',
                        value: function getFormat(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var lines = [], leaves = [];
                            if (length === 0) this.scroll.path(index).forEach(function(path) {
                                var _path = _slicedToArray(path, 1), blot = _path[0];
                                if (blot instanceof _block2.default) lines.push(blot);
                                else if (blot instanceof _parchment2.default.Leaf) leaves.push(blot);
                            });
                            else {
                                lines = this.scroll.lines(index, length);
                                leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
                            }
                            var formatsArr = [
                                lines,
                                leaves
                            ].map(function(blots) {
                                if (blots.length === 0) return {};
                                var formats = (0, _block.bubbleFormats)(blots.shift());
                                while(Object.keys(formats).length > 0){
                                    var blot = blots.shift();
                                    if (blot == null) return formats;
                                    formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
                                }
                                return formats;
                            });
                            return _extend2.default.apply(_extend2.default, formatsArr);
                        }
                    },
                    {
                        key: 'getText',
                        value: function getText(index, length) {
                            return this.getContents(index, length).filter(function(op) {
                                return typeof op.insert === 'string';
                            }).map(function(op) {
                                return op.insert;
                            }).join('');
                        }
                    },
                    {
                        key: 'insertEmbed',
                        value: function insertEmbed(index, embed, value) {
                            this.scroll.insertAt(index, embed, value);
                            return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
                        }
                    },
                    {
                        key: 'insertText',
                        value: function insertText(index, text) {
                            var _this4 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
                            this.scroll.insertAt(index, text);
                            Object.keys(formats).forEach(function(format) {
                                _this4.scroll.formatAt(index, text.length, format, formats[format]);
                            });
                            return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: 'isBlank',
                        value: function isBlank() {
                            if (this.scroll.children.length == 0) return true;
                            if (this.scroll.children.length > 1) return false;
                            var block = this.scroll.children.head;
                            if (block.statics.blotName !== _block2.default.blotName) return false;
                            if (block.children.length > 1) return false;
                            return block.children.head instanceof _break2.default;
                        }
                    },
                    {
                        key: 'removeFormat',
                        value: function removeFormat(index, length) {
                            var text = this.getText(index, length);
                            var _scroll$line3 = this.scroll.line(index + length), _scroll$line4 = _slicedToArray(_scroll$line3, 2), line = _scroll$line4[0], offset = _scroll$line4[1];
                            var suffixLength = 0, suffix = new _quillDelta2.default();
                            if (line != null) {
                                if (!(line instanceof _code2.default)) suffixLength = line.length() - offset;
                                else suffixLength = line.newlineIndex(offset) - offset + 1;
                                suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
                            }
                            var contents = this.getContents(index, length + suffixLength);
                            var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
                            var delta = new _quillDelta2.default().retain(index).concat(diff);
                            return this.applyDelta(delta);
                        }
                    },
                    {
                        key: 'update',
                        value: function update(change) {
                            var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                            var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                            var oldDelta = this.delta;
                            if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
                                // Optimization for character changes
                                var textBlot = _parchment2.default.find(mutations[0].target);
                                var formats = (0, _block.bubbleFormats)(textBlot);
                                var index = textBlot.offset(this.scroll);
                                var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
                                var oldText = new _quillDelta2.default().insert(oldValue);
                                var newText = new _quillDelta2.default().insert(textBlot.value());
                                var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
                                change = diffDelta.reduce(function(delta, op) {
                                    if (op.insert) return delta.insert(op.insert, formats);
                                    else return delta.push(op);
                                }, new _quillDelta2.default());
                                this.delta = oldDelta.compose(change);
                            } else {
                                this.delta = this.getDelta();
                                if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, cursorIndex);
                            }
                            return change;
                        }
                    }
                ]);
                return Editor;
            }();
            function combineFormats(formats, combined) {
                return Object.keys(combined).reduce(function(merged, name) {
                    if (formats[name] == null) return merged;
                    if (combined[name] === formats[name]) merged[name] = combined[name];
                    else if (Array.isArray(combined[name])) {
                        if (combined[name].indexOf(formats[name]) < 0) merged[name] = combined[name].concat([
                            formats[name]
                        ]);
                    } else merged[name] = [
                        combined[name],
                        formats[name]
                    ];
                    return merged;
                }, {});
            }
            function normalizeDelta(delta) {
                return delta.reduce(function(delta, op) {
                    if (op.insert === 1) {
                        var attributes = (0, _clone2.default)(op.attributes);
                        delete attributes['image'];
                        return delta.insert({
                            image: op.attributes.image
                        }, attributes);
                    }
                    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
                        op = (0, _clone2.default)(op);
                        if (op.attributes.list) op.attributes.list = 'ordered';
                        else {
                            op.attributes.list = 'bullet';
                            delete op.attributes.bullet;
                        }
                    }
                    if (typeof op.insert === 'string') {
                        var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
                        return delta.insert(text, op.attributes);
                    }
                    return delta.push(op);
                }, new _quillDelta2.default());
            }
            exports.default = Editor;
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.Range = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _emitter3 = __webpack_require__(8);
            var _emitter4 = _interopRequireDefault(_emitter3);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                    return arr2;
                } else return Array.from(arr);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var debug = (0, _logger2.default)('quill:selection');
            var Range = function Range(index) {
                var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                _classCallCheck(this, Range);
                this.index = index;
                this.length = length;
            };
            var Selection = function() {
                function Selection(scroll, emitter) {
                    var _this = this;
                    _classCallCheck(this, Selection);
                    this.emitter = emitter;
                    this.scroll = scroll;
                    this.composing = false;
                    this.mouseDown = false;
                    this.root = this.scroll.domNode;
                    this.cursor = _parchment2.default.create('cursor', this);
                    // savedRange is last non-null range
                    this.lastRange = this.savedRange = new Range(0, 0);
                    this.handleComposition();
                    this.handleDragging();
                    this.emitter.listenDOM('selectionchange', document, function() {
                        if (!_this.mouseDown) setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
                    });
                    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type, delta) {
                        if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) _this.update(_emitter4.default.sources.SILENT);
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function() {
                        if (!_this.hasFocus()) return;
                        var native = _this.getNativeRange();
                        if (native == null) return;
                        if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
                        // TODO unclear if this has negative side effects
                        _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function() {
                            try {
                                _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                            } catch (ignored) {}
                        });
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function(mutations, context) {
                        if (context.range) {
                            var _context$range = context.range, startNode = _context$range.startNode, startOffset = _context$range.startOffset, endNode = _context$range.endNode, endOffset = _context$range.endOffset;
                            _this.setNativeRange(startNode, startOffset, endNode, endOffset);
                        }
                    });
                    this.update(_emitter4.default.sources.SILENT);
                }
                _createClass(Selection, [
                    {
                        key: 'handleComposition',
                        value: function handleComposition() {
                            var _this2 = this;
                            this.root.addEventListener('compositionstart', function() {
                                _this2.composing = true;
                            });
                            this.root.addEventListener('compositionend', function() {
                                _this2.composing = false;
                                if (_this2.cursor.parent) {
                                    var range = _this2.cursor.restore();
                                    if (!range) return;
                                    setTimeout(function() {
                                        _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                                    }, 1);
                                }
                            });
                        }
                    },
                    {
                        key: 'handleDragging',
                        value: function handleDragging() {
                            var _this3 = this;
                            this.emitter.listenDOM('mousedown', document.body, function() {
                                _this3.mouseDown = true;
                            });
                            this.emitter.listenDOM('mouseup', document.body, function() {
                                _this3.mouseDown = false;
                                _this3.update(_emitter4.default.sources.USER);
                            });
                        }
                    },
                    {
                        key: 'focus',
                        value: function focus() {
                            if (this.hasFocus()) return;
                            this.root.focus();
                            this.setRange(this.savedRange);
                        }
                    },
                    {
                        key: 'format',
                        value: function format(_format, value) {
                            if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
                            this.scroll.update();
                            var nativeRange = this.getNativeRange();
                            if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
                            if (nativeRange.start.node !== this.cursor.textNode) {
                                var blot = _parchment2.default.find(nativeRange.start.node, false);
                                if (blot == null) return;
                                // TODO Give blot ability to not split
                                if (blot instanceof _parchment2.default.Leaf) {
                                    var after = blot.split(nativeRange.start.offset);
                                    blot.parent.insertBefore(this.cursor, after);
                                } else blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
                                this.cursor.attach();
                            }
                            this.cursor.format(_format, value);
                            this.scroll.optimize();
                            this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
                            this.update();
                        }
                    },
                    {
                        key: 'getBounds',
                        value: function getBounds(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var scrollLength = this.scroll.length();
                            index = Math.min(index, scrollLength - 1);
                            length = Math.min(index + length, scrollLength - 1) - index;
                            var node = void 0, _scroll$leaf = this.scroll.leaf(index), _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2), leaf = _scroll$leaf2[0], offset = _scroll$leaf2[1];
                            if (leaf == null) return null;
                            var _leaf$position = leaf.position(offset, true);
                            var _leaf$position2 = _slicedToArray(_leaf$position, 2);
                            node = _leaf$position2[0];
                            offset = _leaf$position2[1];
                            var range = document.createRange();
                            if (length > 0) {
                                range.setStart(node, offset);
                                var _scroll$leaf3 = this.scroll.leaf(index + length);
                                var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
                                leaf = _scroll$leaf4[0];
                                offset = _scroll$leaf4[1];
                                if (leaf == null) return null;
                                var _leaf$position3 = leaf.position(offset, true);
                                var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
                                node = _leaf$position4[0];
                                offset = _leaf$position4[1];
                                range.setEnd(node, offset);
                                return range.getBoundingClientRect();
                            } else {
                                var side = 'left';
                                var rect = void 0;
                                if (node instanceof Text) {
                                    if (offset < node.data.length) {
                                        range.setStart(node, offset);
                                        range.setEnd(node, offset + 1);
                                    } else {
                                        range.setStart(node, offset - 1);
                                        range.setEnd(node, offset);
                                        side = 'right';
                                    }
                                    rect = range.getBoundingClientRect();
                                } else {
                                    rect = leaf.domNode.getBoundingClientRect();
                                    if (offset > 0) side = 'right';
                                }
                                return {
                                    bottom: rect.top + rect.height,
                                    height: rect.height,
                                    left: rect[side],
                                    right: rect[side],
                                    top: rect.top,
                                    width: 0
                                };
                            }
                        }
                    },
                    {
                        key: 'getNativeRange',
                        value: function getNativeRange() {
                            var selection = document.getSelection();
                            if (selection == null || selection.rangeCount <= 0) return null;
                            var nativeRange = selection.getRangeAt(0);
                            if (nativeRange == null) return null;
                            var range = this.normalizeNative(nativeRange);
                            debug.info('getNativeRange', range);
                            return range;
                        }
                    },
                    {
                        key: 'getRange',
                        value: function getRange() {
                            var normalized = this.getNativeRange();
                            if (normalized == null) return [
                                null,
                                null
                            ];
                            var range = this.normalizedToRange(normalized);
                            return [
                                range,
                                normalized
                            ];
                        }
                    },
                    {
                        key: 'hasFocus',
                        value: function hasFocus() {
                            return document.activeElement === this.root;
                        }
                    },
                    {
                        key: 'normalizedToRange',
                        value: function normalizedToRange(range) {
                            var _this4 = this;
                            var positions = [
                                [
                                    range.start.node,
                                    range.start.offset
                                ]
                            ];
                            if (!range.native.collapsed) positions.push([
                                range.end.node,
                                range.end.offset
                            ]);
                            var indexes = positions.map(function(position) {
                                var _position = _slicedToArray(position, 2), node = _position[0], offset = _position[1];
                                var blot = _parchment2.default.find(node, true);
                                var index = blot.offset(_this4.scroll);
                                if (offset === 0) return index;
                                else if (blot instanceof _parchment2.default.Container) return index + blot.length();
                                else return index + blot.index(node, offset);
                            });
                            var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
                            var start = Math.min.apply(Math, [
                                end
                            ].concat(_toConsumableArray(indexes)));
                            return new Range(start, end - start);
                        }
                    },
                    {
                        key: 'normalizeNative',
                        value: function normalizeNative(nativeRange) {
                            if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) return null;
                            var range = {
                                start: {
                                    node: nativeRange.startContainer,
                                    offset: nativeRange.startOffset
                                },
                                end: {
                                    node: nativeRange.endContainer,
                                    offset: nativeRange.endOffset
                                },
                                native: nativeRange
                            };
                            [
                                range.start,
                                range.end
                            ].forEach(function(position) {
                                var node = position.node, offset = position.offset;
                                while(!(node instanceof Text) && node.childNodes.length > 0){
                                    if (node.childNodes.length > offset) {
                                        node = node.childNodes[offset];
                                        offset = 0;
                                    } else if (node.childNodes.length === offset) {
                                        node = node.lastChild;
                                        offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
                                    } else break;
                                }
                                position.node = node, position.offset = offset;
                            });
                            return range;
                        }
                    },
                    {
                        key: 'rangeToNative',
                        value: function rangeToNative(range) {
                            var _this5 = this;
                            var indexes = range.collapsed ? [
                                range.index
                            ] : [
                                range.index,
                                range.index + range.length
                            ];
                            var args = [];
                            var scrollLength = this.scroll.length();
                            indexes.forEach(function(index, i) {
                                index = Math.min(scrollLength - 1, index);
                                var node = void 0, _scroll$leaf5 = _this5.scroll.leaf(index), _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2), leaf = _scroll$leaf6[0], offset = _scroll$leaf6[1];
                                var _leaf$position5 = leaf.position(offset, i !== 0);
                                var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
                                node = _leaf$position6[0];
                                offset = _leaf$position6[1];
                                args.push(node, offset);
                            });
                            if (args.length < 2) args = args.concat(args);
                            return args;
                        }
                    },
                    {
                        key: 'scrollIntoView',
                        value: function scrollIntoView(scrollingContainer) {
                            var range = this.lastRange;
                            if (range == null) return;
                            var bounds = this.getBounds(range.index, range.length);
                            if (bounds == null) return;
                            var limit = this.scroll.length() - 1;
                            var _scroll$line = this.scroll.line(Math.min(range.index, limit)), _scroll$line2 = _slicedToArray(_scroll$line, 1), first = _scroll$line2[0];
                            var last = first;
                            if (range.length > 0) {
                                var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
                                var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
                                last = _scroll$line4[0];
                            }
                            if (first == null || last == null) return;
                            var scrollBounds = scrollingContainer.getBoundingClientRect();
                            if (bounds.top < scrollBounds.top) scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
                            else if (bounds.bottom > scrollBounds.bottom) scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
                        }
                    },
                    {
                        key: 'setNativeRange',
                        value: function setNativeRange(startNode, startOffset) {
                            var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
                            var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
                            var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                            debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
                            if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) return;
                            var selection = document.getSelection();
                            if (selection == null) return;
                            if (startNode != null) {
                                if (!this.hasFocus()) this.root.focus();
                                var native = (this.getNativeRange() || {}).native;
                                if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                                    if (startNode.tagName == "BR") {
                                        startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
                                        startNode = startNode.parentNode;
                                    }
                                    if (endNode.tagName == "BR") {
                                        endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
                                        endNode = endNode.parentNode;
                                    }
                                    var range = document.createRange();
                                    range.setStart(startNode, startOffset);
                                    range.setEnd(endNode, endOffset);
                                    selection.removeAllRanges();
                                    selection.addRange(range);
                                }
                            } else {
                                selection.removeAllRanges();
                                this.root.blur();
                                document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
                            }
                        }
                    },
                    {
                        key: 'setRange',
                        value: function setRange(range) {
                            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
                            if (typeof force === 'string') {
                                source = force;
                                force = false;
                            }
                            debug.info('setRange', range);
                            if (range != null) {
                                var args = this.rangeToNative(range);
                                this.setNativeRange.apply(this, _toConsumableArray(args).concat([
                                    force
                                ]));
                            } else this.setNativeRange(null);
                            this.update(source);
                        }
                    },
                    {
                        key: 'update',
                        value: function update() {
                            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
                            var oldRange = this.lastRange;
                            var _getRange = this.getRange(), _getRange2 = _slicedToArray(_getRange, 2), lastRange = _getRange2[0], nativeRange = _getRange2[1];
                            this.lastRange = lastRange;
                            if (this.lastRange != null) this.savedRange = this.lastRange;
                            if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
                                var _emitter;
                                if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) this.cursor.restore();
                                var args = [
                                    _emitter4.default.events.SELECTION_CHANGE,
                                    (0, _clone2.default)(this.lastRange),
                                    (0, _clone2.default)(oldRange),
                                    source
                                ];
                                (_emitter = this.emitter).emit.apply(_emitter, [
                                    _emitter4.default.events.EDITOR_CHANGE
                                ].concat(args));
                                if (source !== _emitter4.default.sources.SILENT) {
                                    var _emitter2;
                                    (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                                }
                            }
                        }
                    }
                ]);
                return Selection;
            }();
            function contains(parent, descendant) {
                try {
                    // Firefox inserts inaccessible nodes around video elements
                    descendant.parentNode;
                } catch (e) {
                    return false;
                }
                // IE11 has bug with Text nodes
                // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
                if (descendant instanceof Text) descendant = descendant.parentNode;
                return parent.contains(descendant);
            }
            exports.Range = Range;
            exports.default = Selection;
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Break = function(_Parchment$Embed) {
                _inherits(Break, _Parchment$Embed);
                function Break() {
                    _classCallCheck(this, Break);
                    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
                }
                _createClass(Break, [
                    {
                        key: 'insertInto',
                        value: function insertInto(parent, ref) {
                            if (parent.children.length === 0) _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
                            else this.remove();
                        }
                    },
                    {
                        key: 'length',
                        value: function length() {
                            return 0;
                        }
                    },
                    {
                        key: 'value',
                        value: function value() {
                            return '';
                        }
                    }
                ], [
                    {
                        key: 'value',
                        value: function value() {
                            return undefined;
                        }
                    }
                ]);
                return Break;
            }(_parchment2.default.Embed);
            Break.blotName = 'break';
            Break.tagName = 'BR';
            exports.default = Break;
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var linked_list_1 = __webpack_require__(44);
            var shadow_1 = __webpack_require__(30);
            var Registry = __webpack_require__(1);
            var ContainerBlot = /** @class */ function(_super) {
                __extends(ContainerBlot, _super);
                function ContainerBlot(domNode) {
                    var _this = _super.call(this, domNode) || this;
                    _this.build();
                    return _this;
                }
                ContainerBlot.prototype.appendChild = function(other) {
                    this.insertBefore(other);
                };
                ContainerBlot.prototype.attach = function() {
                    _super.prototype.attach.call(this);
                    this.children.forEach(function(child) {
                        child.attach();
                    });
                };
                ContainerBlot.prototype.build = function() {
                    var _this = this;
                    this.children = new linked_list_1.default();
                    // Need to be reversed for if DOM nodes already in order
                    [].slice.call(this.domNode.childNodes).reverse().forEach(function(node) {
                        try {
                            var child = makeBlot(node);
                            _this.insertBefore(child, _this.children.head || undefined);
                        } catch (err) {
                            if (err instanceof Registry.ParchmentError) return;
                            else throw err;
                        }
                    });
                };
                ContainerBlot.prototype.deleteAt = function(index, length) {
                    if (index === 0 && length === this.length()) return this.remove();
                    this.children.forEachAt(index, length, function(child, offset, length) {
                        child.deleteAt(offset, length);
                    });
                };
                ContainerBlot.prototype.descendant = function(criteria, index) {
                    var _a = this.children.find(index), child = _a[0], offset = _a[1];
                    if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) return [
                        child,
                        offset
                    ];
                    else if (child instanceof ContainerBlot) return child.descendant(criteria, offset);
                    else return [
                        null,
                        -1
                    ];
                };
                ContainerBlot.prototype.descendants = function(criteria, index, length) {
                    if (index === void 0) index = 0;
                    if (length === void 0) length = Number.MAX_VALUE;
                    var descendants = [];
                    var lengthLeft = length;
                    this.children.forEachAt(index, length, function(child, index, length) {
                        if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) descendants.push(child);
                        if (child instanceof ContainerBlot) descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
                        lengthLeft -= length;
                    });
                    return descendants;
                };
                ContainerBlot.prototype.detach = function() {
                    this.children.forEach(function(child) {
                        child.detach();
                    });
                    _super.prototype.detach.call(this);
                };
                ContainerBlot.prototype.formatAt = function(index, length, name, value) {
                    this.children.forEachAt(index, length, function(child, offset, length) {
                        child.formatAt(offset, length, name, value);
                    });
                };
                ContainerBlot.prototype.insertAt = function(index, value, def) {
                    var _a = this.children.find(index), child = _a[0], offset = _a[1];
                    if (child) child.insertAt(offset, value, def);
                    else {
                        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
                        this.appendChild(blot);
                    }
                };
                ContainerBlot.prototype.insertBefore = function(childBlot, refBlot) {
                    if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function(child) {
                        return childBlot instanceof child;
                    })) throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
                    childBlot.insertInto(this, refBlot);
                };
                ContainerBlot.prototype.length = function() {
                    return this.children.reduce(function(memo, child) {
                        return memo + child.length();
                    }, 0);
                };
                ContainerBlot.prototype.moveChildren = function(targetParent, refNode) {
                    this.children.forEach(function(child) {
                        targetParent.insertBefore(child, refNode);
                    });
                };
                ContainerBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    if (this.children.length === 0) {
                        if (this.statics.defaultChild != null) {
                            var child = Registry.create(this.statics.defaultChild);
                            this.appendChild(child);
                            child.optimize(context);
                        } else this.remove();
                    }
                };
                ContainerBlot.prototype.path = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
                    var position = [
                        [
                            this,
                            index
                        ]
                    ];
                    if (child instanceof ContainerBlot) return position.concat(child.path(offset, inclusive));
                    else if (child != null) position.push([
                        child,
                        offset
                    ]);
                    return position;
                };
                ContainerBlot.prototype.removeChild = function(child) {
                    this.children.remove(child);
                };
                ContainerBlot.prototype.replace = function(target) {
                    if (target instanceof ContainerBlot) target.moveChildren(this);
                    _super.prototype.replace.call(this, target);
                };
                ContainerBlot.prototype.split = function(index, force) {
                    if (force === void 0) force = false;
                    if (!force) {
                        if (index === 0) return this;
                        if (index === this.length()) return this.next;
                    }
                    var after = this.clone();
                    this.parent.insertBefore(after, this.next);
                    this.children.forEachAt(index, this.length(), function(child, offset, length) {
                        child = child.split(offset, force);
                        after.appendChild(child);
                    });
                    return after;
                };
                ContainerBlot.prototype.unwrap = function() {
                    this.moveChildren(this.parent, this.next);
                    this.remove();
                };
                ContainerBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    var addedNodes = [];
                    var removedNodes = [];
                    mutations.forEach(function(mutation) {
                        if (mutation.target === _this.domNode && mutation.type === 'childList') {
                            addedNodes.push.apply(addedNodes, mutation.addedNodes);
                            removedNodes.push.apply(removedNodes, mutation.removedNodes);
                        }
                    });
                    removedNodes.forEach(function(node) {
                        // Check node has actually been removed
                        // One exception is Chrome does not immediately remove IFRAMEs
                        // from DOM but MutationRecord is correct in its reported removal
                        if (node.parentNode != null && // @ts-ignore
                        node.tagName !== 'IFRAME' && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
                        var blot = Registry.find(node);
                        if (blot == null) return;
                        if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) blot.detach();
                    });
                    addedNodes.filter(function(node) {
                        return node.parentNode == _this.domNode;
                    }).sort(function(a, b) {
                        if (a === b) return 0;
                        if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) return 1;
                        return -1;
                    }).forEach(function(node) {
                        var refBlot = null;
                        if (node.nextSibling != null) refBlot = Registry.find(node.nextSibling);
                        var blot = makeBlot(node);
                        if (blot.next != refBlot || blot.next == null) {
                            if (blot.parent != null) blot.parent.removeChild(_this);
                            _this.insertBefore(blot, refBlot || undefined);
                        }
                    });
                };
                return ContainerBlot;
            }(shadow_1.default);
            function makeBlot(node) {
                var blot = Registry.find(node);
                if (blot == null) try {
                    blot = Registry.create(node);
                } catch (e) {
                    blot = Registry.create(Registry.Scope.INLINE);
                    [].slice.call(node.childNodes).forEach(function(child) {
                        // @ts-ignore
                        blot.domNode.appendChild(child);
                    });
                    if (node.parentNode) node.parentNode.replaceChild(blot.domNode, node);
                    blot.attach();
                }
                return blot;
            }
            exports.default = ContainerBlot;
        /***/ },
        /* 18 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            var store_1 = __webpack_require__(31);
            var container_1 = __webpack_require__(17);
            var Registry = __webpack_require__(1);
            var FormatBlot = /** @class */ function(_super) {
                __extends(FormatBlot, _super);
                function FormatBlot(domNode) {
                    var _this = _super.call(this, domNode) || this;
                    _this.attributes = new store_1.default(_this.domNode);
                    return _this;
                }
                FormatBlot.formats = function(domNode) {
                    if (typeof this.tagName === 'string') return true;
                    else if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
                    return undefined;
                };
                FormatBlot.prototype.format = function(name, value) {
                    var format = Registry.query(name);
                    if (format instanceof attributor_1.default) this.attributes.attribute(format, value);
                    else if (value) {
                        if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) this.replaceWith(name, value);
                    }
                };
                FormatBlot.prototype.formats = function() {
                    var formats = this.attributes.values();
                    var format = this.statics.formats(this.domNode);
                    if (format != null) formats[this.statics.blotName] = format;
                    return formats;
                };
                FormatBlot.prototype.replaceWith = function(name, value) {
                    var replacement = _super.prototype.replaceWith.call(this, name, value);
                    this.attributes.copy(replacement);
                    return replacement;
                };
                FormatBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    _super.prototype.update.call(this, mutations, context);
                    if (mutations.some(function(mutation) {
                        return mutation.target === _this.domNode && mutation.type === 'attributes';
                    })) this.attributes.build();
                };
                FormatBlot.prototype.wrap = function(name, value) {
                    var wrapper = _super.prototype.wrap.call(this, name, value);
                    if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) this.attributes.move(wrapper);
                    return wrapper;
                };
                return FormatBlot;
            }(container_1.default);
            exports.default = FormatBlot;
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var shadow_1 = __webpack_require__(30);
            var Registry = __webpack_require__(1);
            var LeafBlot = /** @class */ function(_super) {
                __extends(LeafBlot, _super);
                function LeafBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                LeafBlot.value = function(domNode) {
                    return true;
                };
                LeafBlot.prototype.index = function(node, offset) {
                    if (this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return Math.min(offset, 1);
                    return -1;
                };
                LeafBlot.prototype.position = function(index, inclusive) {
                    var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
                    if (index > 0) offset += 1;
                    return [
                        this.parent.domNode,
                        offset
                    ];
                };
                LeafBlot.prototype.value = function() {
                    var _a;
                    return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
                };
                LeafBlot.scope = Registry.Scope.INLINE_BLOT;
                return LeafBlot;
            }(shadow_1.default);
            exports.default = LeafBlot;
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            var equal = __webpack_require__(11);
            var extend = __webpack_require__(3);
            var lib = {
                attributes: {
                    compose: function(a, b, keepNull) {
                        if (typeof a !== 'object') a = {};
                        if (typeof b !== 'object') b = {};
                        var attributes = extend(true, {}, b);
                        if (!keepNull) attributes = Object.keys(attributes).reduce(function(copy, key) {
                            if (attributes[key] != null) copy[key] = attributes[key];
                            return copy;
                        }, {});
                        for(var key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    },
                    diff: function(a, b) {
                        if (typeof a !== 'object') a = {};
                        if (typeof b !== 'object') b = {};
                        var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function(attributes, key) {
                            if (!equal(a[key], b[key])) attributes[key] = b[key] === undefined ? null : b[key];
                            return attributes;
                        }, {});
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    },
                    transform: function(a, b, priority) {
                        if (typeof a !== 'object') return b;
                        if (typeof b !== 'object') return undefined;
                        if (!priority) return b; // b simply overwrites us without priority
                        var attributes = Object.keys(b).reduce(function(attributes, key) {
                            if (a[key] === undefined) attributes[key] = b[key]; // null is a valid value
                            return attributes;
                        }, {});
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    }
                },
                iterator: function(ops) {
                    return new Iterator(ops);
                },
                length: function(op) {
                    if (typeof op['delete'] === 'number') return op['delete'];
                    else if (typeof op.retain === 'number') return op.retain;
                    else return typeof op.insert === 'string' ? op.insert.length : 1;
                }
            };
            function Iterator(ops) {
                this.ops = ops;
                this.index = 0;
                this.offset = 0;
            }
            Iterator.prototype.hasNext = function() {
                return this.peekLength() < Infinity;
            };
            Iterator.prototype.next = function(length) {
                if (!length) length = Infinity;
                var nextOp = this.ops[this.index];
                if (nextOp) {
                    var offset = this.offset;
                    var opLength = lib.length(nextOp);
                    if (length >= opLength - offset) {
                        length = opLength - offset;
                        this.index += 1;
                        this.offset = 0;
                    } else this.offset += length;
                    if (typeof nextOp['delete'] === 'number') return {
                        'delete': length
                    };
                    else {
                        var retOp = {};
                        if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                        if (typeof nextOp.retain === 'number') retOp.retain = length;
                        else if (typeof nextOp.insert === 'string') retOp.insert = nextOp.insert.substr(offset, length);
                        else // offset should === 0, length should === 1
                        retOp.insert = nextOp.insert;
                        return retOp;
                    }
                } else return {
                    retain: Infinity
                };
            };
            Iterator.prototype.peek = function() {
                return this.ops[this.index];
            };
            Iterator.prototype.peekLength = function() {
                if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
                return lib.length(this.ops[this.index]) - this.offset;
                else return Infinity;
            };
            Iterator.prototype.peekType = function() {
                if (this.ops[this.index]) {
                    if (typeof this.ops[this.index]['delete'] === 'number') return 'delete';
                    else if (typeof this.ops[this.index].retain === 'number') return 'retain';
                    else return 'insert';
                }
                return 'retain';
            };
            Iterator.prototype.rest = function() {
                if (!this.hasNext()) return [];
                else if (this.offset === 0) return this.ops.slice(this.index);
                else {
                    var offset = this.offset;
                    var index = this.index;
                    var next = this.next();
                    var rest = this.ops.slice(this.index);
                    this.offset = offset;
                    this.index = index;
                    return [
                        next
                    ].concat(rest);
                }
            };
            module1.exports = lib;
        /***/ },
        /* 21 */ /***/ function(module1, exports) {
            var clone = function() {
                'use strict';
                function _instanceof(obj, type) {
                    return type != null && obj instanceof type;
                }
                var nativeMap;
                try {
                    nativeMap = Map;
                } catch (_) {
                    // maybe a reference error because no `Map`. Give it a dummy value that no
                    // value will ever be an instanceof.
                    nativeMap = function() {};
                }
                var nativeSet;
                try {
                    nativeSet = Set;
                } catch (_) {
                    nativeSet = function() {};
                }
                var nativePromise;
                try {
                    nativePromise = Promise;
                } catch (_) {
                    nativePromise = function() {};
                }
                /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
                    if (typeof circular === 'object') {
                        depth = circular.depth;
                        prototype = circular.prototype;
                        includeNonEnumerable = circular.includeNonEnumerable;
                        circular = circular.circular;
                    }
                    // maintain two arrays for circular references, where corresponding parents
                    // and children have the same index
                    var allParents = [];
                    var allChildren = [];
                    var useBuffer = typeof $eedce4808a689638$require$Buffer != 'undefined';
                    if (typeof circular == 'undefined') circular = true;
                    if (typeof depth == 'undefined') depth = Infinity;
                    // recurse this function so we don't reset allParents and allChildren
                    function _clone(parent, depth) {
                        // cloning null always returns null
                        if (parent === null) return null;
                        if (depth === 0) return parent;
                        var child;
                        var proto;
                        if (typeof parent != 'object') return parent;
                        if (_instanceof(parent, nativeMap)) child = new nativeMap();
                        else if (_instanceof(parent, nativeSet)) child = new nativeSet();
                        else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                            parent.then(function(value) {
                                resolve(_clone(value, depth - 1));
                            }, function(err) {
                                reject(_clone(err, depth - 1));
                            });
                        });
                        else if (clone.__isArray(parent)) child = [];
                        else if (clone.__isRegExp(parent)) {
                            child = new RegExp(parent.source, __getRegExpFlags(parent));
                            if (parent.lastIndex) child.lastIndex = parent.lastIndex;
                        } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
                        else if (useBuffer && $eedce4808a689638$require$Buffer.isBuffer(parent)) {
                            if ($eedce4808a689638$require$Buffer.allocUnsafe) // Node.js >= 4.5.0
                            child = $eedce4808a689638$require$Buffer.allocUnsafe(parent.length);
                            else // Older Node.js versions
                            child = new $eedce4808a689638$require$Buffer(parent.length);
                            parent.copy(child);
                            return child;
                        } else if (_instanceof(parent, Error)) child = Object.create(parent);
                        else if (typeof prototype == 'undefined') {
                            proto = Object.getPrototypeOf(parent);
                            child = Object.create(proto);
                        } else {
                            child = Object.create(prototype);
                            proto = prototype;
                        }
                        if (circular) {
                            var index = allParents.indexOf(parent);
                            if (index != -1) return allChildren[index];
                            allParents.push(parent);
                            allChildren.push(child);
                        }
                        if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                            var keyChild = _clone(key, depth - 1);
                            var valueChild = _clone(value, depth - 1);
                            child.set(keyChild, valueChild);
                        });
                        if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                            var entryChild = _clone(value, depth - 1);
                            child.add(entryChild);
                        });
                        for(var i in parent){
                            var attrs;
                            if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                            if (attrs && attrs.set == null) continue;
                            child[i] = _clone(parent[i], depth - 1);
                        }
                        if (Object.getOwnPropertySymbols) {
                            var symbols = Object.getOwnPropertySymbols(parent);
                            for(var i = 0; i < symbols.length; i++){
                                // Don't need to worry about cloning a symbol because it is a primitive,
                                // like a number or string.
                                var symbol = symbols[i];
                                var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                                if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                                child[symbol] = _clone(parent[symbol], depth - 1);
                                if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                                    enumerable: false
                                });
                            }
                        }
                        if (includeNonEnumerable) {
                            var allPropertyNames = Object.getOwnPropertyNames(parent);
                            for(var i = 0; i < allPropertyNames.length; i++){
                                var propertyName = allPropertyNames[i];
                                var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                                if (descriptor && descriptor.enumerable) continue;
                                child[propertyName] = _clone(parent[propertyName], depth - 1);
                                Object.defineProperty(child, propertyName, {
                                    enumerable: false
                                });
                            }
                        }
                        return child;
                    }
                    return _clone(parent, depth);
                }
                /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
                    if (parent === null) return null;
                    var c = function() {};
                    c.prototype = parent;
                    return new c();
                };
                // private utility functions
                function __objToStr(o) {
                    return Object.prototype.toString.call(o);
                }
                clone.__objToStr = __objToStr;
                function __isDate(o) {
                    return typeof o === 'object' && __objToStr(o) === '[object Date]';
                }
                clone.__isDate = __isDate;
                function __isArray(o) {
                    return typeof o === 'object' && __objToStr(o) === '[object Array]';
                }
                clone.__isArray = __isArray;
                function __isRegExp(o) {
                    return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
                }
                clone.__isRegExp = __isRegExp;
                function __getRegExpFlags(re) {
                    var flags = '';
                    if (re.global) flags += 'g';
                    if (re.ignoreCase) flags += 'i';
                    if (re.multiline) flags += 'm';
                    return flags;
                }
                clone.__getRegExpFlags = __getRegExpFlags;
                return clone;
            }();
            if (typeof module1 === 'object' && module1.exports) module1.exports = clone;
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            function isLine(blot) {
                return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
            }
            var Scroll = function(_Parchment$Scroll) {
                _inherits(Scroll, _Parchment$Scroll);
                function Scroll(domNode, config) {
                    _classCallCheck(this, Scroll);
                    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));
                    _this.emitter = config.emitter;
                    if (Array.isArray(config.whitelist)) _this.whitelist = config.whitelist.reduce(function(whitelist, format) {
                        whitelist[format] = true;
                        return whitelist;
                    }, {});
                    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
                    _this.domNode.addEventListener('DOMNodeInserted', function() {});
                    _this.optimize();
                    _this.enable();
                    return _this;
                }
                _createClass(Scroll, [
                    {
                        key: 'batchStart',
                        value: function batchStart() {
                            this.batch = true;
                        }
                    },
                    {
                        key: 'batchEnd',
                        value: function batchEnd() {
                            this.batch = false;
                            this.optimize();
                        }
                    },
                    {
                        key: 'deleteAt',
                        value: function deleteAt(index, length) {
                            var _line = this.line(index), _line2 = _slicedToArray(_line, 2), first = _line2[0], offset = _line2[1];
                            var _line3 = this.line(index + length), _line4 = _slicedToArray(_line3, 1), last = _line4[0];
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
                            if (last != null && first !== last && offset > 0) {
                                if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
                                    this.optimize();
                                    return;
                                }
                                if (first instanceof _code2.default) {
                                    var newlineIndex = first.newlineIndex(first.length(), true);
                                    if (newlineIndex > -1) {
                                        first = first.split(newlineIndex + 1);
                                        if (first === last) {
                                            this.optimize();
                                            return;
                                        }
                                    }
                                } else if (last instanceof _code2.default) {
                                    var _newlineIndex = last.newlineIndex(0);
                                    if (_newlineIndex > -1) last.split(_newlineIndex + 1);
                                }
                                var ref = last.children.head instanceof _break2.default ? null : last.children.head;
                                first.moveChildren(last, ref);
                                first.remove();
                            }
                            this.optimize();
                        }
                    },
                    {
                        key: 'enable',
                        value: function enable() {
                            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                            this.domNode.setAttribute('contenteditable', enabled);
                        }
                    },
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, format, value) {
                            if (this.whitelist != null && !this.whitelist[format]) return;
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
                            this.optimize();
                        }
                    },
                    {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (def != null && this.whitelist != null && !this.whitelist[value]) return;
                            if (index >= this.length()) {
                                if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
                                    var blot = _parchment2.default.create(this.statics.defaultChild);
                                    this.appendChild(blot);
                                    if (def == null && value.endsWith('\n')) value = value.slice(0, -1);
                                    blot.insertAt(0, value, def);
                                } else {
                                    var embed = _parchment2.default.create(value, def);
                                    this.appendChild(embed);
                                }
                            } else _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
                            this.optimize();
                        }
                    },
                    {
                        key: 'insertBefore',
                        value: function insertBefore(blot, ref) {
                            if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
                                var wrapper = _parchment2.default.create(this.statics.defaultChild);
                                wrapper.appendChild(blot);
                                blot = wrapper;
                            }
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
                        }
                    },
                    {
                        key: 'leaf',
                        value: function leaf(index) {
                            return this.path(index).pop() || [
                                null,
                                -1
                            ];
                        }
                    },
                    {
                        key: 'line',
                        value: function line(index) {
                            if (index === this.length()) return this.line(index - 1);
                            return this.descendant(isLine, index);
                        }
                    },
                    {
                        key: 'lines',
                        value: function lines() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
                            var getLines = function getLines(blot, index, length) {
                                var lines = [], lengthLeft = length;
                                blot.children.forEachAt(index, length, function(child, index, length) {
                                    if (isLine(child)) lines.push(child);
                                    else if (child instanceof _parchment2.default.Container) lines = lines.concat(getLines(child, index, lengthLeft));
                                    lengthLeft -= length;
                                });
                                return lines;
                            };
                            return getLines(this, index, length);
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize() {
                            var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            if (this.batch === true) return;
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
                        }
                    },
                    {
                        key: 'path',
                        value: function path(index) {
                            return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
                        }
                    },
                    {
                        key: 'update',
                        value: function update(mutations) {
                            if (this.batch === true) return;
                            var source = _emitter2.default.sources.USER;
                            if (typeof mutations === 'string') source = mutations;
                            if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
                        }
                    }
                ]);
                return Scroll;
            }(_parchment2.default.Scroll);
            Scroll.blotName = 'scroll';
            Scroll.className = 'ql-editor';
            Scroll.tagName = 'DIV';
            Scroll.defaultChild = 'block';
            Scroll.allowedChildren = [
                _block2.default,
                _block.BlockEmbed,
                _container2.default
            ];
            exports.default = Scroll;
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.SHORTKEY = exports.default = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _op = __webpack_require__(20);
            var _op2 = _interopRequireDefault(_op);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)('quill:keyboard');
            var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
            var Keyboard = function(_Module) {
                _inherits(Keyboard, _Module);
                _createClass(Keyboard, null, [
                    {
                        key: 'match',
                        value: function match(evt, binding) {
                            binding = normalize(binding);
                            if ([
                                'altKey',
                                'ctrlKey',
                                'metaKey',
                                'shiftKey'
                            ].some(function(key) {
                                return !!binding[key] !== evt[key] && binding[key] !== null;
                            })) return false;
                            return binding.key === (evt.which || evt.keyCode);
                        }
                    }
                ]);
                function Keyboard(quill, options) {
                    _classCallCheck(this, Keyboard);
                    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));
                    _this.bindings = {};
                    Object.keys(_this.options.bindings).forEach(function(name) {
                        if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) return;
                        if (_this.options.bindings[name]) _this.addBinding(_this.options.bindings[name]);
                    });
                    _this.addBinding({
                        key: Keyboard.keys.ENTER,
                        shiftKey: null
                    }, handleEnter);
                    _this.addBinding({
                        key: Keyboard.keys.ENTER,
                        metaKey: null,
                        ctrlKey: null,
                        altKey: null
                    }, function() {});
                    if (/Firefox/i.test(navigator.userAgent)) {
                        // Need to handle delete and backspace for Firefox in the general case #1171
                        _this.addBinding({
                            key: Keyboard.keys.BACKSPACE
                        }, {
                            collapsed: true
                        }, handleBackspace);
                        _this.addBinding({
                            key: Keyboard.keys.DELETE
                        }, {
                            collapsed: true
                        }, handleDelete);
                    } else {
                        _this.addBinding({
                            key: Keyboard.keys.BACKSPACE
                        }, {
                            collapsed: true,
                            prefix: /^.?$/
                        }, handleBackspace);
                        _this.addBinding({
                            key: Keyboard.keys.DELETE
                        }, {
                            collapsed: true,
                            suffix: /^.?$/
                        }, handleDelete);
                    }
                    _this.addBinding({
                        key: Keyboard.keys.BACKSPACE
                    }, {
                        collapsed: false
                    }, handleDeleteRange);
                    _this.addBinding({
                        key: Keyboard.keys.DELETE
                    }, {
                        collapsed: false
                    }, handleDeleteRange);
                    _this.addBinding({
                        key: Keyboard.keys.BACKSPACE,
                        altKey: null,
                        ctrlKey: null,
                        metaKey: null,
                        shiftKey: null
                    }, {
                        collapsed: true,
                        offset: 0
                    }, handleBackspace);
                    _this.listen();
                    return _this;
                }
                _createClass(Keyboard, [
                    {
                        key: 'addBinding',
                        value: function addBinding(key) {
                            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            var binding = normalize(key);
                            if (binding == null || binding.key == null) return debug.warn('Attempted to add invalid keyboard binding', binding);
                            if (typeof context === 'function') context = {
                                handler: context
                            };
                            if (typeof handler === 'function') handler = {
                                handler: handler
                            };
                            binding = (0, _extend2.default)(binding, context, handler);
                            this.bindings[binding.key] = this.bindings[binding.key] || [];
                            this.bindings[binding.key].push(binding);
                        }
                    },
                    {
                        key: 'listen',
                        value: function listen() {
                            var _this2 = this;
                            this.quill.root.addEventListener('keydown', function(evt) {
                                if (evt.defaultPrevented) return;
                                var which = evt.which || evt.keyCode;
                                var bindings = (_this2.bindings[which] || []).filter(function(binding) {
                                    return Keyboard.match(evt, binding);
                                });
                                if (bindings.length === 0) return;
                                var range = _this2.quill.getSelection();
                                if (range == null || !_this2.quill.hasFocus()) return;
                                var _quill$getLine = _this2.quill.getLine(range.index), _quill$getLine2 = _slicedToArray(_quill$getLine, 2), line = _quill$getLine2[0], offset = _quill$getLine2[1];
                                var _quill$getLeaf = _this2.quill.getLeaf(range.index), _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2), leafStart = _quill$getLeaf2[0], offsetStart = _quill$getLeaf2[1];
                                var _ref = range.length === 0 ? [
                                    leafStart,
                                    offsetStart
                                ] : _this2.quill.getLeaf(range.index + range.length), _ref2 = _slicedToArray(_ref, 2), leafEnd = _ref2[0], offsetEnd = _ref2[1];
                                var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
                                var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
                                var curContext = {
                                    collapsed: range.length === 0,
                                    empty: range.length === 0 && line.length() <= 1,
                                    format: _this2.quill.getFormat(range),
                                    offset: offset,
                                    prefix: prefixText,
                                    suffix: suffixText
                                };
                                var prevented = bindings.some(function(binding) {
                                    if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                                    if (binding.empty != null && binding.empty !== curContext.empty) return false;
                                    if (binding.offset != null && binding.offset !== curContext.offset) return false;
                                    if (Array.isArray(binding.format)) {
                                        // any format is present
                                        if (binding.format.every(function(name) {
                                            return curContext.format[name] == null;
                                        })) return false;
                                    } else if (_typeof(binding.format) === 'object') {
                                        // all formats must match
                                        if (!Object.keys(binding.format).every(function(name) {
                                            if (binding.format[name] === true) return curContext.format[name] != null;
                                            if (binding.format[name] === false) return curContext.format[name] == null;
                                            return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
                                        })) return false;
                                    }
                                    if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                                    if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                                    return binding.handler.call(_this2, range, curContext) !== true;
                                });
                                if (prevented) evt.preventDefault();
                            });
                        }
                    }
                ]);
                return Keyboard;
            }(_module2.default);
            Keyboard.keys = {
                BACKSPACE: 8,
                TAB: 9,
                ENTER: 13,
                ESCAPE: 27,
                LEFT: 37,
                UP: 38,
                RIGHT: 39,
                DOWN: 40,
                DELETE: 46
            };
            Keyboard.DEFAULTS = {
                bindings: {
                    'bold': makeFormatHandler('bold'),
                    'italic': makeFormatHandler('italic'),
                    'underline': makeFormatHandler('underline'),
                    'indent': {
                        // highlight tab or tab at beginning of list, indent or blockquote
                        key: Keyboard.keys.TAB,
                        format: [
                            'blockquote',
                            'indent',
                            'list'
                        ],
                        handler: function handler(range, context) {
                            if (context.collapsed && context.offset !== 0) return true;
                            this.quill.format('indent', '+1', _quill2.default.sources.USER);
                        }
                    },
                    'outdent': {
                        key: Keyboard.keys.TAB,
                        shiftKey: true,
                        format: [
                            'blockquote',
                            'indent',
                            'list'
                        ],
                        // highlight tab or tab at beginning of list, indent or blockquote
                        handler: function handler(range, context) {
                            if (context.collapsed && context.offset !== 0) return true;
                            this.quill.format('indent', '-1', _quill2.default.sources.USER);
                        }
                    },
                    'outdent backspace': {
                        key: Keyboard.keys.BACKSPACE,
                        collapsed: true,
                        shiftKey: null,
                        metaKey: null,
                        ctrlKey: null,
                        altKey: null,
                        format: [
                            'indent',
                            'list'
                        ],
                        offset: 0,
                        handler: function handler(range, context) {
                            if (context.format.indent != null) this.quill.format('indent', '-1', _quill2.default.sources.USER);
                            else if (context.format.list != null) this.quill.format('list', false, _quill2.default.sources.USER);
                        }
                    },
                    'indent code-block': makeCodeBlockHandler(true),
                    'outdent code-block': makeCodeBlockHandler(false),
                    'remove tab': {
                        key: Keyboard.keys.TAB,
                        shiftKey: true,
                        collapsed: true,
                        prefix: /\t$/,
                        handler: function handler(range) {
                            this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
                        }
                    },
                    'tab': {
                        key: Keyboard.keys.TAB,
                        handler: function handler(range) {
                            this.quill.history.cutoff();
                            var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                        }
                    },
                    'list empty enter': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            'list'
                        ],
                        empty: true,
                        handler: function handler(range, context) {
                            this.quill.format('list', false, _quill2.default.sources.USER);
                            if (context.format.indent) this.quill.format('indent', false, _quill2.default.sources.USER);
                        }
                    },
                    'checklist enter': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: {
                            list: 'checked'
                        },
                        handler: function handler(range) {
                            var _quill$getLine3 = this.quill.getLine(range.index), _quill$getLine4 = _slicedToArray(_quill$getLine3, 2), line = _quill$getLine4[0], offset = _quill$getLine4[1];
                            var formats = (0, _extend2.default)({}, line.formats(), {
                                list: 'checked'
                            });
                            var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, {
                                list: 'unchecked'
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                            this.quill.scrollIntoView();
                        }
                    },
                    'header enter': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            'header'
                        ],
                        suffix: /^$/,
                        handler: function handler(range, context) {
                            var _quill$getLine5 = this.quill.getLine(range.index), _quill$getLine6 = _slicedToArray(_quill$getLine5, 2), line = _quill$getLine6[0], offset = _quill$getLine6[1];
                            var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, {
                                header: null
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                            this.quill.scrollIntoView();
                        }
                    },
                    'list autofill': {
                        key: ' ',
                        collapsed: true,
                        format: {
                            list: false
                        },
                        prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
                        handler: function handler(range, context) {
                            var length = context.prefix.length;
                            var _quill$getLine7 = this.quill.getLine(range.index), _quill$getLine8 = _slicedToArray(_quill$getLine7, 2), line = _quill$getLine8[0], offset = _quill$getLine8[1];
                            if (offset > length) return true;
                            var value = void 0;
                            switch(context.prefix.trim()){
                                case '[]':
                                case '[ ]':
                                    value = 'unchecked';
                                    break;
                                case '[x]':
                                    value = 'checked';
                                    break;
                                case '-':
                                case '*':
                                    value = 'bullet';
                                    break;
                                default:
                                    value = 'ordered';
                            }
                            this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, {
                                list: value
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
                        }
                    },
                    'code exit': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            'code-block'
                        ],
                        prefix: /\n\n$/,
                        suffix: /^\s+$/,
                        handler: function handler(range) {
                            var _quill$getLine9 = this.quill.getLine(range.index), _quill$getLine10 = _slicedToArray(_quill$getLine9, 2), line = _quill$getLine10[0], offset = _quill$getLine10[1];
                            var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, {
                                'code-block': null
                            }).delete(1);
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                        }
                    },
                    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
                    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
                    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
                    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
                }
            };
            function makeEmbedArrowHandler(key, shiftKey) {
                var _ref3;
                var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
                return _ref3 = {
                    key: key,
                    shiftKey: shiftKey,
                    altKey: null
                }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
                    var index = range.index;
                    if (key === Keyboard.keys.RIGHT) index += range.length + 1;
                    var _quill$getLeaf3 = this.quill.getLeaf(index), _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1), leaf = _quill$getLeaf4[0];
                    if (!(leaf instanceof _parchment2.default.Embed)) return true;
                    if (key === Keyboard.keys.LEFT) {
                        if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
                        else this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
                    } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
                    else this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
                    return false;
                }), _ref3;
            }
            function handleBackspace(range, context) {
                if (range.index === 0 || this.quill.getLength() <= 1) return;
                var _quill$getLine11 = this.quill.getLine(range.index), _quill$getLine12 = _slicedToArray(_quill$getLine11, 1), line = _quill$getLine12[0];
                var formats = {};
                if (context.offset === 0) {
                    var _quill$getLine13 = this.quill.getLine(range.index - 1), _quill$getLine14 = _slicedToArray(_quill$getLine13, 1), prev = _quill$getLine14[0];
                    if (prev != null && prev.length() > 1) {
                        var curFormats = line.formats();
                        var prevFormats = this.quill.getFormat(range.index - 1, 1);
                        formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
                    }
                }
                // Check for astral symbols
                var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
                this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
                this.quill.focus();
            }
            function handleDelete(range, context) {
                // Check for astral symbols
                var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
                if (range.index >= this.quill.getLength() - length) return;
                var formats = {}, nextLength = 0;
                var _quill$getLine15 = this.quill.getLine(range.index), _quill$getLine16 = _slicedToArray(_quill$getLine15, 1), line = _quill$getLine16[0];
                if (context.offset >= line.length() - 1) {
                    var _quill$getLine17 = this.quill.getLine(range.index + 1), _quill$getLine18 = _slicedToArray(_quill$getLine17, 1), next = _quill$getLine18[0];
                    if (next) {
                        var curFormats = line.formats();
                        var nextFormats = this.quill.getFormat(range.index, 1);
                        formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
                        nextLength = next.length();
                    }
                }
                this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
            }
            function handleDeleteRange(range) {
                var lines = this.quill.getLines(range);
                var formats = {};
                if (lines.length > 1) {
                    var firstFormats = lines[0].formats();
                    var lastFormats = lines[lines.length - 1].formats();
                    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
                }
                this.quill.deleteText(range, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
                this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
                this.quill.focus();
            }
            function handleEnter(range, context) {
                var _this3 = this;
                if (range.length > 0) this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
                var lineFormats = Object.keys(context.format).reduce(function(lineFormats, format) {
                    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) lineFormats[format] = context.format[format];
                    return lineFormats;
                }, {});
                this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
                // Earlier scroll.deleteAt might have messed up our selection,
                // so insertText's built in selection preservation is not reliable
                this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                this.quill.focus();
                Object.keys(context.format).forEach(function(name) {
                    if (lineFormats[name] != null) return;
                    if (Array.isArray(context.format[name])) return;
                    if (name === 'link') return;
                    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
                });
            }
            function makeCodeBlockHandler(indent) {
                return {
                    key: Keyboard.keys.TAB,
                    shiftKey: !indent,
                    format: {
                        'code-block': true
                    },
                    handler: function handler(range) {
                        var CodeBlock = _parchment2.default.query('code-block');
                        var index = range.index, length = range.length;
                        var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), block = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                        if (block == null) return;
                        var scrollIndex = this.quill.getIndex(block);
                        var start = block.newlineIndex(offset, true) + 1;
                        var end = block.newlineIndex(scrollIndex + offset + length);
                        var lines = block.domNode.textContent.slice(start, end).split('\n');
                        offset = 0;
                        lines.forEach(function(line, i) {
                            if (indent) {
                                block.insertAt(start + offset, CodeBlock.TAB);
                                offset += CodeBlock.TAB.length;
                                if (i === 0) index += CodeBlock.TAB.length;
                                else length += CodeBlock.TAB.length;
                            } else if (line.startsWith(CodeBlock.TAB)) {
                                block.deleteAt(start + offset, CodeBlock.TAB.length);
                                offset -= CodeBlock.TAB.length;
                                if (i === 0) index -= CodeBlock.TAB.length;
                                else length -= CodeBlock.TAB.length;
                            }
                            offset += line.length + 1;
                        });
                        this.quill.update(_quill2.default.sources.USER);
                        this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
                    }
                };
            }
            function makeFormatHandler(format) {
                return {
                    key: format[0].toUpperCase(),
                    shortKey: true,
                    handler: function handler(range, context) {
                        this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
                    }
                };
            }
            function normalize(binding) {
                if (typeof binding === 'string' || typeof binding === 'number') return normalize({
                    key: binding
                });
                if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') binding = (0, _clone2.default)(binding, false);
                if (typeof binding.key === 'string') {
                    if (Keyboard.keys[binding.key.toUpperCase()] != null) binding.key = Keyboard.keys[binding.key.toUpperCase()];
                    else if (binding.key.length === 1) binding.key = binding.key.toUpperCase().charCodeAt(0);
                    else return null;
                }
                if (binding.shortKey) {
                    binding[SHORTKEY] = binding.shortKey;
                    delete binding.shortKey;
                }
                return binding;
            }
            exports.default = Keyboard;
            exports.SHORTKEY = SHORTKEY;
        /***/ },
        /* 24 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Cursor = function(_Parchment$Embed) {
                _inherits(Cursor, _Parchment$Embed);
                _createClass(Cursor, null, [
                    {
                        key: 'value',
                        value: function value() {
                            return undefined;
                        }
                    }
                ]);
                function Cursor(domNode, selection) {
                    _classCallCheck(this, Cursor);
                    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));
                    _this.selection = selection;
                    _this.textNode = document.createTextNode(Cursor.CONTENTS);
                    _this.domNode.appendChild(_this.textNode);
                    _this._length = 0;
                    return _this;
                }
                _createClass(Cursor, [
                    {
                        key: 'detach',
                        value: function detach() {
                            // super.detach() will also clear domNode.__blot
                            if (this.parent != null) this.parent.removeChild(this);
                        }
                    },
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (this._length !== 0) return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
                            var target = this, index = 0;
                            while(target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT){
                                index += target.offset(target.parent);
                                target = target.parent;
                            }
                            if (target != null) {
                                this._length = Cursor.CONTENTS.length;
                                target.optimize();
                                target.formatAt(index, Cursor.CONTENTS.length, name, value);
                                this._length = 0;
                            }
                        }
                    },
                    {
                        key: 'index',
                        value: function index(node, offset) {
                            if (node === this.textNode) return 0;
                            return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
                        }
                    },
                    {
                        key: 'length',
                        value: function length() {
                            return this._length;
                        }
                    },
                    {
                        key: 'position',
                        value: function position() {
                            return [
                                this.textNode,
                                this.textNode.data.length
                            ];
                        }
                    },
                    {
                        key: 'remove',
                        value: function remove() {
                            _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
                            this.parent = null;
                        }
                    },
                    {
                        key: 'restore',
                        value: function restore() {
                            if (this.selection.composing || this.parent == null) return;
                            var textNode = this.textNode;
                            var range = this.selection.getNativeRange();
                            var restoreText = void 0, start = void 0, end = void 0;
                            if (range != null && range.start.node === textNode && range.end.node === textNode) {
                                var _ref = [
                                    textNode,
                                    range.start.offset,
                                    range.end.offset
                                ];
                                restoreText = _ref[0];
                                start = _ref[1];
                                end = _ref[2];
                            }
                            // Link format will insert text outside of anchor tag
                            while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
                            if (this.textNode.data !== Cursor.CONTENTS) {
                                var text = this.textNode.data.split(Cursor.CONTENTS).join('');
                                if (this.next instanceof _text2.default) {
                                    restoreText = this.next.domNode;
                                    this.next.insertAt(0, text);
                                    this.textNode.data = Cursor.CONTENTS;
                                } else {
                                    this.textNode.data = text;
                                    this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
                                    this.textNode = document.createTextNode(Cursor.CONTENTS);
                                    this.domNode.appendChild(this.textNode);
                                }
                            }
                            this.remove();
                            if (start != null) {
                                var _map = [
                                    start,
                                    end
                                ].map(function(offset) {
                                    return Math.max(0, Math.min(restoreText.data.length, offset - 1));
                                });
                                var _map2 = _slicedToArray(_map, 2);
                                start = _map2[0];
                                end = _map2[1];
                                return {
                                    startNode: restoreText,
                                    startOffset: start,
                                    endNode: restoreText,
                                    endOffset: end
                                };
                            }
                        }
                    },
                    {
                        key: 'update',
                        value: function update(mutations, context) {
                            var _this2 = this;
                            if (mutations.some(function(mutation) {
                                return mutation.type === 'characterData' && mutation.target === _this2.textNode;
                            })) {
                                var range = this.restore();
                                if (range) context.range = range;
                            }
                        }
                    },
                    {
                        key: 'value',
                        value: function value() {
                            return '';
                        }
                    }
                ]);
                return Cursor;
            }(_parchment2.default.Embed);
            Cursor.blotName = 'cursor';
            Cursor.className = 'ql-cursor';
            Cursor.tagName = 'span';
            Cursor.CONTENTS = '\uFEFF'; // Zero width no break space
            exports.default = Cursor;
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Container = function(_Parchment$Container) {
                _inherits(Container, _Parchment$Container);
                function Container() {
                    _classCallCheck(this, Container);
                    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
                }
                return Container;
            }(_parchment2.default.Container);
            Container.allowedChildren = [
                _block2.default,
                _block.BlockEmbed,
                Container
            ];
            exports.default = Container;
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ColorAttributor = function(_Parchment$Attributor) {
                _inherits(ColorAttributor, _Parchment$Attributor);
                function ColorAttributor() {
                    _classCallCheck(this, ColorAttributor);
                    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
                }
                _createClass(ColorAttributor, [
                    {
                        key: 'value',
                        value: function value(domNode) {
                            var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
                            if (!value.startsWith('rgb(')) return value;
                            value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
                            return '#' + value.split(',').map(function(component) {
                                return ('00' + parseInt(component).toString(16)).slice(-2);
                            }).join('');
                        }
                    }
                ]);
                return ColorAttributor;
            }(_parchment2.default.Attributor.Style);
            var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
                scope: _parchment2.default.Scope.INLINE
            });
            var ColorStyle = new ColorAttributor('color', 'color', {
                scope: _parchment2.default.Scope.INLINE
            });
            exports.ColorAttributor = ColorAttributor;
            exports.ColorClass = ColorClass;
            exports.ColorStyle = ColorStyle;
        /***/ },
        /* 27 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.sanitize = exports.default = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Link = function(_Inline) {
                _inherits(Link, _Inline);
                function Link() {
                    _classCallCheck(this, Link);
                    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
                }
                _createClass(Link, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
                            value = this.constructor.sanitize(value);
                            this.domNode.setAttribute('href', value);
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create(value) {
                            var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
                            value = this.sanitize(value);
                            node.setAttribute('href', value);
                            node.setAttribute('rel', 'noopener noreferrer');
                            node.setAttribute('target', '_blank');
                            return node;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return domNode.getAttribute('href');
                        }
                    },
                    {
                        key: 'sanitize',
                        value: function sanitize(url) {
                            return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
                        }
                    }
                ]);
                return Link;
            }(_inline2.default);
            Link.blotName = 'link';
            Link.tagName = 'A';
            Link.SANITIZED_URL = 'about:blank';
            Link.PROTOCOL_WHITELIST = [
                'http',
                'https',
                'mailto',
                'tel'
            ];
            function _sanitize(url, protocols) {
                var anchor = document.createElement('a');
                anchor.href = url;
                var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
                return protocols.indexOf(protocol) > -1;
            }
            exports.default = Link;
            exports.sanitize = _sanitize;
        /***/ },
        /* 28 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            var _dropdown = __webpack_require__(107);
            var _dropdown2 = _interopRequireDefault(_dropdown);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var optionsCounter = 0;
            function toggleAriaAttribute(element, attribute) {
                element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
            }
            var Picker = function() {
                function Picker(select) {
                    var _this = this;
                    _classCallCheck(this, Picker);
                    this.select = select;
                    this.container = document.createElement('span');
                    this.buildPicker();
                    this.select.style.display = 'none';
                    this.select.parentNode.insertBefore(this.container, this.select);
                    this.label.addEventListener('mousedown', function() {
                        _this.togglePicker();
                    });
                    this.label.addEventListener('keydown', function(event) {
                        switch(event.keyCode){
                            // Allows the "Enter" key to open the picker
                            case _keyboard2.default.keys.ENTER:
                                _this.togglePicker();
                                break;
                            // Allows the "Escape" key to close the picker
                            case _keyboard2.default.keys.ESCAPE:
                                _this.escape();
                                event.preventDefault();
                                break;
                            default:
                        }
                    });
                    this.select.addEventListener('change', this.update.bind(this));
                }
                _createClass(Picker, [
                    {
                        key: 'togglePicker',
                        value: function togglePicker() {
                            this.container.classList.toggle('ql-expanded');
                            // Toggle aria-expanded and aria-hidden to make the picker accessible
                            toggleAriaAttribute(this.label, 'aria-expanded');
                            toggleAriaAttribute(this.options, 'aria-hidden');
                        }
                    },
                    {
                        key: 'buildItem',
                        value: function buildItem(option) {
                            var _this2 = this;
                            var item = document.createElement('span');
                            item.tabIndex = '0';
                            item.setAttribute('role', 'button');
                            item.classList.add('ql-picker-item');
                            if (option.hasAttribute('value')) item.setAttribute('data-value', option.getAttribute('value'));
                            if (option.textContent) item.setAttribute('data-label', option.textContent);
                            item.addEventListener('click', function() {
                                _this2.selectItem(item, true);
                            });
                            item.addEventListener('keydown', function(event) {
                                switch(event.keyCode){
                                    // Allows the "Enter" key to select an item
                                    case _keyboard2.default.keys.ENTER:
                                        _this2.selectItem(item, true);
                                        event.preventDefault();
                                        break;
                                    // Allows the "Escape" key to close the picker
                                    case _keyboard2.default.keys.ESCAPE:
                                        _this2.escape();
                                        event.preventDefault();
                                        break;
                                    default:
                                }
                            });
                            return item;
                        }
                    },
                    {
                        key: 'buildLabel',
                        value: function buildLabel() {
                            var label = document.createElement('span');
                            label.classList.add('ql-picker-label');
                            label.innerHTML = _dropdown2.default;
                            label.tabIndex = '0';
                            label.setAttribute('role', 'button');
                            label.setAttribute('aria-expanded', 'false');
                            this.container.appendChild(label);
                            return label;
                        }
                    },
                    {
                        key: 'buildOptions',
                        value: function buildOptions() {
                            var _this3 = this;
                            var options = document.createElement('span');
                            options.classList.add('ql-picker-options');
                            // Don't want screen readers to read this until options are visible
                            options.setAttribute('aria-hidden', 'true');
                            options.tabIndex = '-1';
                            // Need a unique id for aria-controls
                            options.id = 'ql-picker-options-' + optionsCounter;
                            optionsCounter += 1;
                            this.label.setAttribute('aria-controls', options.id);
                            this.options = options;
                            [].slice.call(this.select.options).forEach(function(option) {
                                var item = _this3.buildItem(option);
                                options.appendChild(item);
                                if (option.selected === true) _this3.selectItem(item);
                            });
                            this.container.appendChild(options);
                        }
                    },
                    {
                        key: 'buildPicker',
                        value: function buildPicker() {
                            var _this4 = this;
                            [].slice.call(this.select.attributes).forEach(function(item) {
                                _this4.container.setAttribute(item.name, item.value);
                            });
                            this.container.classList.add('ql-picker');
                            this.label = this.buildLabel();
                            this.buildOptions();
                        }
                    },
                    {
                        key: 'escape',
                        value: function escape() {
                            var _this5 = this;
                            // Close menu and return focus to trigger label
                            this.close();
                            // Need setTimeout for accessibility to ensure that the browser executes
                            // focus on the next process thread and after any DOM content changes
                            setTimeout(function() {
                                return _this5.label.focus();
                            }, 1);
                        }
                    },
                    {
                        key: 'close',
                        value: function close() {
                            this.container.classList.remove('ql-expanded');
                            this.label.setAttribute('aria-expanded', 'false');
                            this.options.setAttribute('aria-hidden', 'true');
                        }
                    },
                    {
                        key: 'selectItem',
                        value: function selectItem(item) {
                            var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var selected = this.container.querySelector('.ql-selected');
                            if (item === selected) return;
                            if (selected != null) selected.classList.remove('ql-selected');
                            if (item == null) return;
                            item.classList.add('ql-selected');
                            this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
                            if (item.hasAttribute('data-value')) this.label.setAttribute('data-value', item.getAttribute('data-value'));
                            else this.label.removeAttribute('data-value');
                            if (item.hasAttribute('data-label')) this.label.setAttribute('data-label', item.getAttribute('data-label'));
                            else this.label.removeAttribute('data-label');
                            if (trigger) {
                                if (typeof Event === 'function') this.select.dispatchEvent(new Event('change'));
                                else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
                                    // IE11
                                    var event = document.createEvent('Event');
                                    event.initEvent('change', true, true);
                                    this.select.dispatchEvent(event);
                                }
                                this.close();
                            }
                        }
                    },
                    {
                        key: 'update',
                        value: function update() {
                            var option = void 0;
                            if (this.select.selectedIndex > -1) {
                                var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
                                option = this.select.options[this.select.selectedIndex];
                                this.selectItem(item);
                            } else this.selectItem(null);
                            var isActive = option != null && option !== this.select.querySelector('option[selected]');
                            this.label.classList.toggle('ql-active', isActive);
                        }
                    }
                ]);
                return Picker;
            }();
            exports.default = Picker;
        /***/ },
        /* 29 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            var _cursor = __webpack_require__(24);
            var _cursor2 = _interopRequireDefault(_cursor);
            var _embed = __webpack_require__(35);
            var _embed2 = _interopRequireDefault(_embed);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _scroll = __webpack_require__(22);
            var _scroll2 = _interopRequireDefault(_scroll);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            var _clipboard = __webpack_require__(55);
            var _clipboard2 = _interopRequireDefault(_clipboard);
            var _history = __webpack_require__(42);
            var _history2 = _interopRequireDefault(_history);
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            _quill2.default.register({
                'blots/block': _block2.default,
                'blots/block/embed': _block.BlockEmbed,
                'blots/break': _break2.default,
                'blots/container': _container2.default,
                'blots/cursor': _cursor2.default,
                'blots/embed': _embed2.default,
                'blots/inline': _inline2.default,
                'blots/scroll': _scroll2.default,
                'blots/text': _text2.default,
                'modules/clipboard': _clipboard2.default,
                'modules/history': _history2.default,
                'modules/keyboard': _keyboard2.default
            });
            _parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
            exports.default = _quill2.default;
        /***/ },
        /* 30 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var Registry = __webpack_require__(1);
            var ShadowBlot = /** @class */ function() {
                function ShadowBlot(domNode) {
                    this.domNode = domNode;
                    // @ts-ignore
                    this.domNode[Registry.DATA_KEY] = {
                        blot: this
                    };
                }
                Object.defineProperty(ShadowBlot.prototype, "statics", {
                    // Hack for accessing inherited static methods
                    get: function() {
                        return this.constructor;
                    },
                    enumerable: true,
                    configurable: true
                });
                ShadowBlot.create = function(value) {
                    if (this.tagName == null) throw new Registry.ParchmentError('Blot definition missing tagName');
                    var node;
                    if (Array.isArray(this.tagName)) {
                        if (typeof value === 'string') {
                            value = value.toUpperCase();
                            if (parseInt(value).toString() === value) value = parseInt(value);
                        }
                        if (typeof value === 'number') node = document.createElement(this.tagName[value - 1]);
                        else if (this.tagName.indexOf(value) > -1) node = document.createElement(value);
                        else node = document.createElement(this.tagName[0]);
                    } else node = document.createElement(this.tagName);
                    if (this.className) node.classList.add(this.className);
                    return node;
                };
                ShadowBlot.prototype.attach = function() {
                    if (this.parent != null) this.scroll = this.parent.scroll;
                };
                ShadowBlot.prototype.clone = function() {
                    var domNode = this.domNode.cloneNode(false);
                    return Registry.create(domNode);
                };
                ShadowBlot.prototype.detach = function() {
                    if (this.parent != null) this.parent.removeChild(this);
                    // @ts-ignore
                    delete this.domNode[Registry.DATA_KEY];
                };
                ShadowBlot.prototype.deleteAt = function(index, length) {
                    var blot = this.isolate(index, length);
                    blot.remove();
                };
                ShadowBlot.prototype.formatAt = function(index, length, name, value) {
                    var blot = this.isolate(index, length);
                    if (Registry.query(name, Registry.Scope.BLOT) != null && value) blot.wrap(name, value);
                    else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
                        var parent = Registry.create(this.statics.scope);
                        blot.wrap(parent);
                        parent.format(name, value);
                    }
                };
                ShadowBlot.prototype.insertAt = function(index, value, def) {
                    var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
                    var ref = this.split(index);
                    this.parent.insertBefore(blot, ref);
                };
                ShadowBlot.prototype.insertInto = function(parentBlot, refBlot) {
                    if (refBlot === void 0) refBlot = null;
                    if (this.parent != null) this.parent.children.remove(this);
                    var refDomNode = null;
                    parentBlot.children.insertBefore(this, refBlot);
                    if (refBlot != null) refDomNode = refBlot.domNode;
                    if (this.domNode.parentNode != parentBlot.domNode || this.domNode.nextSibling != refDomNode) parentBlot.domNode.insertBefore(this.domNode, refDomNode);
                    this.parent = parentBlot;
                    this.attach();
                };
                ShadowBlot.prototype.isolate = function(index, length) {
                    var target = this.split(index);
                    target.split(length);
                    return target;
                };
                ShadowBlot.prototype.length = function() {
                    return 1;
                };
                ShadowBlot.prototype.offset = function(root) {
                    if (root === void 0) root = this.parent;
                    if (this.parent == null || this == root) return 0;
                    return this.parent.children.offset(this) + this.parent.offset(root);
                };
                ShadowBlot.prototype.optimize = function(context) {
                    // TODO clean up once we use WeakMap
                    // @ts-ignore
                    if (this.domNode[Registry.DATA_KEY] != null) // @ts-ignore
                    delete this.domNode[Registry.DATA_KEY].mutations;
                };
                ShadowBlot.prototype.remove = function() {
                    if (this.domNode.parentNode != null) this.domNode.parentNode.removeChild(this.domNode);
                    this.detach();
                };
                ShadowBlot.prototype.replace = function(target) {
                    if (target.parent == null) return;
                    target.parent.insertBefore(this, target.next);
                    target.remove();
                };
                ShadowBlot.prototype.replaceWith = function(name, value) {
                    var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
                    replacement.replace(this);
                    return replacement;
                };
                ShadowBlot.prototype.split = function(index, force) {
                    return index === 0 ? this : this.next;
                };
                ShadowBlot.prototype.update = function(mutations, context) {
                // Nothing to do by default
                };
                ShadowBlot.prototype.wrap = function(name, value) {
                    var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
                    if (this.parent != null) this.parent.insertBefore(wrapper, this.next);
                    wrapper.appendChild(this);
                    return wrapper;
                };
                ShadowBlot.blotName = 'abstract';
                return ShadowBlot;
            }();
            exports.default = ShadowBlot;
        /***/ },
        /* 31 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            var class_1 = __webpack_require__(32);
            var style_1 = __webpack_require__(33);
            var Registry = __webpack_require__(1);
            var AttributorStore = /** @class */ function() {
                function AttributorStore(domNode) {
                    this.attributes = {};
                    this.domNode = domNode;
                    this.build();
                }
                AttributorStore.prototype.attribute = function(attribute, value) {
                    // verb
                    if (value) {
                        if (attribute.add(this.domNode, value)) {
                            if (attribute.value(this.domNode) != null) this.attributes[attribute.attrName] = attribute;
                            else delete this.attributes[attribute.attrName];
                        }
                    } else {
                        attribute.remove(this.domNode);
                        delete this.attributes[attribute.attrName];
                    }
                };
                AttributorStore.prototype.build = function() {
                    var _this = this;
                    this.attributes = {};
                    var attributes = attributor_1.default.keys(this.domNode);
                    var classes = class_1.default.keys(this.domNode);
                    var styles = style_1.default.keys(this.domNode);
                    attributes.concat(classes).concat(styles).forEach(function(name) {
                        var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
                        if (attr instanceof attributor_1.default) _this.attributes[attr.attrName] = attr;
                    });
                };
                AttributorStore.prototype.copy = function(target) {
                    var _this = this;
                    Object.keys(this.attributes).forEach(function(key) {
                        var value = _this.attributes[key].value(_this.domNode);
                        target.format(key, value);
                    });
                };
                AttributorStore.prototype.move = function(target) {
                    var _this = this;
                    this.copy(target);
                    Object.keys(this.attributes).forEach(function(key) {
                        _this.attributes[key].remove(_this.domNode);
                    });
                    this.attributes = {};
                };
                AttributorStore.prototype.values = function() {
                    var _this = this;
                    return Object.keys(this.attributes).reduce(function(attributes, name) {
                        attributes[name] = _this.attributes[name].value(_this.domNode);
                        return attributes;
                    }, {});
                };
                return AttributorStore;
            }();
            exports.default = AttributorStore;
        /***/ },
        /* 32 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            function match(node, prefix) {
                var className = node.getAttribute('class') || '';
                return className.split(/\s+/).filter(function(name) {
                    return name.indexOf(prefix + "-") === 0;
                });
            }
            var ClassAttributor = /** @class */ function(_super) {
                __extends(ClassAttributor, _super);
                function ClassAttributor() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ClassAttributor.keys = function(node) {
                    return (node.getAttribute('class') || '').split(/\s+/).map(function(name) {
                        return name.split('-').slice(0, -1).join('-');
                    });
                };
                ClassAttributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    this.remove(node);
                    node.classList.add(this.keyName + "-" + value);
                    return true;
                };
                ClassAttributor.prototype.remove = function(node) {
                    var matches = match(node, this.keyName);
                    matches.forEach(function(name) {
                        node.classList.remove(name);
                    });
                    if (node.classList.length === 0) node.removeAttribute('class');
                };
                ClassAttributor.prototype.value = function(node) {
                    var result = match(node, this.keyName)[0] || '';
                    var value = result.slice(this.keyName.length + 1); // +1 for hyphen
                    return this.canAdd(node, value) ? value : '';
                };
                return ClassAttributor;
            }(attributor_1.default);
            exports.default = ClassAttributor;
        /***/ },
        /* 33 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            function camelize(name) {
                var parts = name.split('-');
                var rest = parts.slice(1).map(function(part) {
                    return part[0].toUpperCase() + part.slice(1);
                }).join('');
                return parts[0] + rest;
            }
            var StyleAttributor = /** @class */ function(_super) {
                __extends(StyleAttributor, _super);
                function StyleAttributor() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                StyleAttributor.keys = function(node) {
                    return (node.getAttribute('style') || '').split(';').map(function(value) {
                        var arr = value.split(':');
                        return arr[0].trim();
                    });
                };
                StyleAttributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    // @ts-ignore
                    node.style[camelize(this.keyName)] = value;
                    return true;
                };
                StyleAttributor.prototype.remove = function(node) {
                    // @ts-ignore
                    node.style[camelize(this.keyName)] = '';
                    if (!node.getAttribute('style')) node.removeAttribute('style');
                };
                StyleAttributor.prototype.value = function(node) {
                    // @ts-ignore
                    var value = node.style[camelize(this.keyName)];
                    return this.canAdd(node, value) ? value : '';
                };
                return StyleAttributor;
            }(attributor_1.default);
            exports.default = StyleAttributor;
        /***/ },
        /* 34 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Theme = function() {
                function Theme(quill, options) {
                    _classCallCheck(this, Theme);
                    this.quill = quill;
                    this.options = options;
                    this.modules = {};
                }
                _createClass(Theme, [
                    {
                        key: 'init',
                        value: function init() {
                            var _this = this;
                            Object.keys(this.options.modules).forEach(function(name) {
                                if (_this.modules[name] == null) _this.addModule(name);
                            });
                        }
                    },
                    {
                        key: 'addModule',
                        value: function addModule(name) {
                            var moduleClass = this.quill.constructor.import('modules/' + name);
                            this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
                            return this.modules[name];
                        }
                    }
                ]);
                return Theme;
            }();
            Theme.DEFAULTS = {
                modules: {}
            };
            Theme.themes = {
                'default': Theme
            };
            exports.default = Theme;
        /***/ },
        /* 35 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var GUARD_TEXT = '\uFEFF';
            var Embed = function(_Parchment$Embed) {
                _inherits(Embed, _Parchment$Embed);
                function Embed(node) {
                    _classCallCheck(this, Embed);
                    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));
                    _this.contentNode = document.createElement('span');
                    _this.contentNode.setAttribute('contenteditable', false);
                    [].slice.call(_this.domNode.childNodes).forEach(function(childNode) {
                        _this.contentNode.appendChild(childNode);
                    });
                    _this.leftGuard = document.createTextNode(GUARD_TEXT);
                    _this.rightGuard = document.createTextNode(GUARD_TEXT);
                    _this.domNode.appendChild(_this.leftGuard);
                    _this.domNode.appendChild(_this.contentNode);
                    _this.domNode.appendChild(_this.rightGuard);
                    return _this;
                }
                _createClass(Embed, [
                    {
                        key: 'index',
                        value: function index(node, offset) {
                            if (node === this.leftGuard) return 0;
                            if (node === this.rightGuard) return 1;
                            return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
                        }
                    },
                    {
                        key: 'restore',
                        value: function restore(node) {
                            var range = void 0, textNode = void 0;
                            var text = node.data.split(GUARD_TEXT).join('');
                            if (node === this.leftGuard) {
                                if (this.prev instanceof _text2.default) {
                                    var prevLength = this.prev.length();
                                    this.prev.insertAt(prevLength, text);
                                    range = {
                                        startNode: this.prev.domNode,
                                        startOffset: prevLength + text.length
                                    };
                                } else {
                                    textNode = document.createTextNode(text);
                                    this.parent.insertBefore(_parchment2.default.create(textNode), this);
                                    range = {
                                        startNode: textNode,
                                        startOffset: text.length
                                    };
                                }
                            } else if (node === this.rightGuard) {
                                if (this.next instanceof _text2.default) {
                                    this.next.insertAt(0, text);
                                    range = {
                                        startNode: this.next.domNode,
                                        startOffset: text.length
                                    };
                                } else {
                                    textNode = document.createTextNode(text);
                                    this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
                                    range = {
                                        startNode: textNode,
                                        startOffset: text.length
                                    };
                                }
                            }
                            node.data = GUARD_TEXT;
                            return range;
                        }
                    },
                    {
                        key: 'update',
                        value: function update(mutations, context) {
                            var _this2 = this;
                            mutations.forEach(function(mutation) {
                                if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
                                    var range = _this2.restore(mutation.target);
                                    if (range) context.range = range;
                                }
                            });
                        }
                    }
                ]);
                return Embed;
            }(_parchment2.default.Embed);
            exports.default = Embed;
        /***/ },
        /* 36 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var config = {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    'right',
                    'center',
                    'justify'
                ]
            };
            var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
            var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
            var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);
            exports.AlignAttribute = AlignAttribute;
            exports.AlignClass = AlignClass;
            exports.AlignStyle = AlignStyle;
        /***/ },
        /* 37 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.BackgroundStyle = exports.BackgroundClass = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _color = __webpack_require__(26);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
                scope: _parchment2.default.Scope.INLINE
            });
            var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
                scope: _parchment2.default.Scope.INLINE
            });
            exports.BackgroundClass = BackgroundClass;
            exports.BackgroundStyle = BackgroundStyle;
        /***/ },
        /* 38 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var config = {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    'rtl'
                ]
            };
            var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
            var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
            var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);
            exports.DirectionAttribute = DirectionAttribute;
            exports.DirectionClass = DirectionClass;
            exports.DirectionStyle = DirectionStyle;
        /***/ },
        /* 39 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.FontClass = exports.FontStyle = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var config = {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    'serif',
                    'monospace'
                ]
            };
            var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);
            var FontStyleAttributor = function(_Parchment$Attributor) {
                _inherits(FontStyleAttributor, _Parchment$Attributor);
                function FontStyleAttributor() {
                    _classCallCheck(this, FontStyleAttributor);
                    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
                }
                _createClass(FontStyleAttributor, [
                    {
                        key: 'value',
                        value: function value(node) {
                            return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
                        }
                    }
                ]);
                return FontStyleAttributor;
            }(_parchment2.default.Attributor.Style);
            var FontStyle = new FontStyleAttributor('font', 'font-family', config);
            exports.FontStyle = FontStyle;
            exports.FontClass = FontClass;
        /***/ },
        /* 40 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.SizeStyle = exports.SizeClass = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    'small',
                    'large',
                    'huge'
                ]
            });
            var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    '10px',
                    '18px',
                    '32px'
                ]
            });
            exports.SizeClass = SizeClass;
            exports.SizeStyle = SizeStyle;
        /***/ },
        /* 41 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = {
                'align': {
                    '': __webpack_require__(76),
                    'center': __webpack_require__(77),
                    'right': __webpack_require__(78),
                    'justify': __webpack_require__(79)
                },
                'background': __webpack_require__(80),
                'blockquote': __webpack_require__(81),
                'bold': __webpack_require__(82),
                'clean': __webpack_require__(83),
                'code': __webpack_require__(58),
                'code-block': __webpack_require__(58),
                'color': __webpack_require__(84),
                'direction': {
                    '': __webpack_require__(85),
                    'rtl': __webpack_require__(86)
                },
                'float': {
                    'center': __webpack_require__(87),
                    'full': __webpack_require__(88),
                    'left': __webpack_require__(89),
                    'right': __webpack_require__(90)
                },
                'formula': __webpack_require__(91),
                'header': {
                    '1': __webpack_require__(92),
                    '2': __webpack_require__(93)
                },
                'italic': __webpack_require__(94),
                'image': __webpack_require__(95),
                'indent': {
                    '+1': __webpack_require__(96),
                    '-1': __webpack_require__(97)
                },
                'link': __webpack_require__(98),
                'list': {
                    'ordered': __webpack_require__(99),
                    'bullet': __webpack_require__(100),
                    'check': __webpack_require__(101)
                },
                'script': {
                    'sub': __webpack_require__(102),
                    'super': __webpack_require__(103)
                },
                'strike': __webpack_require__(104),
                'underline': __webpack_require__(105),
                'video': __webpack_require__(106)
            };
        /***/ },
        /* 42 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.getLastChangeIndex = exports.default = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var History = function(_Module) {
                _inherits(History, _Module);
                function History(quill, options) {
                    _classCallCheck(this, History);
                    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));
                    _this.lastRecorded = 0;
                    _this.ignoreChange = false;
                    _this.clear();
                    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(eventName, delta, oldDelta, source) {
                        if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
                        if (!_this.options.userOnly || source === _quill2.default.sources.USER) _this.record(delta, oldDelta);
                        else _this.transform(delta);
                    });
                    _this.quill.keyboard.addBinding({
                        key: 'Z',
                        shortKey: true
                    }, _this.undo.bind(_this));
                    _this.quill.keyboard.addBinding({
                        key: 'Z',
                        shortKey: true,
                        shiftKey: true
                    }, _this.redo.bind(_this));
                    if (/Win/i.test(navigator.platform)) _this.quill.keyboard.addBinding({
                        key: 'Y',
                        shortKey: true
                    }, _this.redo.bind(_this));
                    return _this;
                }
                _createClass(History, [
                    {
                        key: 'change',
                        value: function change(source, dest) {
                            if (this.stack[source].length === 0) return;
                            var delta = this.stack[source].pop();
                            this.stack[dest].push(delta);
                            this.lastRecorded = 0;
                            this.ignoreChange = true;
                            this.quill.updateContents(delta[source], _quill2.default.sources.USER);
                            this.ignoreChange = false;
                            var index = getLastChangeIndex(delta[source]);
                            this.quill.setSelection(index);
                        }
                    },
                    {
                        key: 'clear',
                        value: function clear() {
                            this.stack = {
                                undo: [],
                                redo: []
                            };
                        }
                    },
                    {
                        key: 'cutoff',
                        value: function cutoff() {
                            this.lastRecorded = 0;
                        }
                    },
                    {
                        key: 'record',
                        value: function record(changeDelta, oldDelta) {
                            if (changeDelta.ops.length === 0) return;
                            this.stack.redo = [];
                            var undoDelta = this.quill.getContents().diff(oldDelta);
                            var timestamp = Date.now();
                            if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
                                var delta = this.stack.undo.pop();
                                undoDelta = undoDelta.compose(delta.undo);
                                changeDelta = delta.redo.compose(changeDelta);
                            } else this.lastRecorded = timestamp;
                            this.stack.undo.push({
                                redo: changeDelta,
                                undo: undoDelta
                            });
                            if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
                        }
                    },
                    {
                        key: 'redo',
                        value: function redo() {
                            this.change('redo', 'undo');
                        }
                    },
                    {
                        key: 'transform',
                        value: function transform(delta) {
                            this.stack.undo.forEach(function(change) {
                                change.undo = delta.transform(change.undo, true);
                                change.redo = delta.transform(change.redo, true);
                            });
                            this.stack.redo.forEach(function(change) {
                                change.undo = delta.transform(change.undo, true);
                                change.redo = delta.transform(change.redo, true);
                            });
                        }
                    },
                    {
                        key: 'undo',
                        value: function undo() {
                            this.change('undo', 'redo');
                        }
                    }
                ]);
                return History;
            }(_module2.default);
            History.DEFAULTS = {
                delay: 1000,
                maxStack: 100,
                userOnly: false
            };
            function endsWithNewlineChange(delta) {
                var lastOp = delta.ops[delta.ops.length - 1];
                if (lastOp == null) return false;
                if (lastOp.insert != null) return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
                if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some(function(attr) {
                    return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
                });
                return false;
            }
            function getLastChangeIndex(delta) {
                var deleteLength = delta.reduce(function(length, op) {
                    length += op.delete || 0;
                    return length;
                }, 0);
                var changeIndex = delta.length() - deleteLength;
                if (endsWithNewlineChange(delta)) changeIndex -= 1;
                return changeIndex;
            }
            exports.default = History;
            exports.getLastChangeIndex = getLastChangeIndex;
        /***/ },
        /* 43 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BaseTooltip = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            var _theme = __webpack_require__(34);
            var _theme2 = _interopRequireDefault(_theme);
            var _colorPicker = __webpack_require__(59);
            var _colorPicker2 = _interopRequireDefault(_colorPicker);
            var _iconPicker = __webpack_require__(60);
            var _iconPicker2 = _interopRequireDefault(_iconPicker);
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            var _tooltip = __webpack_require__(61);
            var _tooltip2 = _interopRequireDefault(_tooltip);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ALIGNS = [
                false,
                'center',
                'right',
                'justify'
            ];
            var COLORS = [
                "#000000",
                "#e60000",
                "#ff9900",
                "#ffff00",
                "#008a00",
                "#0066cc",
                "#9933ff",
                "#ffffff",
                "#facccc",
                "#ffebcc",
                "#ffffcc",
                "#cce8cc",
                "#cce0f5",
                "#ebd6ff",
                "#bbbbbb",
                "#f06666",
                "#ffc266",
                "#ffff66",
                "#66b966",
                "#66a3e0",
                "#c285ff",
                "#888888",
                "#a10000",
                "#b26b00",
                "#b2b200",
                "#006100",
                "#0047b2",
                "#6b24b2",
                "#444444",
                "#5c0000",
                "#663d00",
                "#666600",
                "#003700",
                "#002966",
                "#3d1466"
            ];
            var FONTS = [
                false,
                'serif',
                'monospace'
            ];
            var HEADERS = [
                '1',
                '2',
                '3',
                false
            ];
            var SIZES = [
                'small',
                false,
                'large',
                'huge'
            ];
            var BaseTheme = function(_Theme) {
                _inherits(BaseTheme, _Theme);
                function BaseTheme(quill, options) {
                    _classCallCheck(this, BaseTheme);
                    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));
                    var listener = function listener(e) {
                        if (!document.body.contains(quill.root)) return document.body.removeEventListener('click', listener);
                        if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) _this.tooltip.hide();
                        if (_this.pickers != null) _this.pickers.forEach(function(picker) {
                            if (!picker.container.contains(e.target)) picker.close();
                        });
                    };
                    quill.emitter.listenDOM('click', document.body, listener);
                    return _this;
                }
                _createClass(BaseTheme, [
                    {
                        key: 'addModule',
                        value: function addModule(name) {
                            var module1 = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
                            if (name === 'toolbar') this.extendToolbar(module1);
                            return module1;
                        }
                    },
                    {
                        key: 'buildButtons',
                        value: function buildButtons(buttons, icons) {
                            buttons.forEach(function(button) {
                                var className = button.getAttribute('class') || '';
                                className.split(/\s+/).forEach(function(name) {
                                    if (!name.startsWith('ql-')) return;
                                    name = name.slice(3);
                                    if (icons[name] == null) return;
                                    if (name === 'direction') button.innerHTML = icons[name][''] + icons[name]['rtl'];
                                    else if (typeof icons[name] === 'string') button.innerHTML = icons[name];
                                    else {
                                        var value = button.value || '';
                                        if (value != null && icons[name][value]) button.innerHTML = icons[name][value];
                                    }
                                });
                            });
                        }
                    },
                    {
                        key: 'buildPickers',
                        value: function buildPickers(selects, icons) {
                            var _this2 = this;
                            this.pickers = selects.map(function(select) {
                                if (select.classList.contains('ql-align')) {
                                    if (select.querySelector('option') == null) fillSelect(select, ALIGNS);
                                    return new _iconPicker2.default(select, icons.align);
                                } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                                    var format = select.classList.contains('ql-background') ? 'background' : 'color';
                                    if (select.querySelector('option') == null) fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
                                    return new _colorPicker2.default(select, icons[format]);
                                } else {
                                    if (select.querySelector('option') == null) {
                                        if (select.classList.contains('ql-font')) fillSelect(select, FONTS);
                                        else if (select.classList.contains('ql-header')) fillSelect(select, HEADERS);
                                        else if (select.classList.contains('ql-size')) fillSelect(select, SIZES);
                                    }
                                    return new _picker2.default(select);
                                }
                            });
                            var update = function update() {
                                _this2.pickers.forEach(function(picker) {
                                    picker.update();
                                });
                            };
                            this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
                        }
                    }
                ]);
                return BaseTheme;
            }(_theme2.default);
            BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            formula: function formula() {
                                this.quill.theme.tooltip.edit('formula');
                            },
                            image: function image() {
                                var _this3 = this;
                                var fileInput = this.container.querySelector('input.ql-image[type=file]');
                                if (fileInput == null) {
                                    fileInput = document.createElement('input');
                                    fileInput.setAttribute('type', 'file');
                                    fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
                                    fileInput.classList.add('ql-image');
                                    fileInput.addEventListener('change', function() {
                                        if (fileInput.files != null && fileInput.files[0] != null) {
                                            var reader = new FileReader();
                                            reader.onload = function(e) {
                                                var range = _this3.quill.getSelection(true);
                                                _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({
                                                    image: e.target.result
                                                }), _emitter2.default.sources.USER);
                                                _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                                                fileInput.value = "";
                                            };
                                            reader.readAsDataURL(fileInput.files[0]);
                                        }
                                    });
                                    this.container.appendChild(fileInput);
                                }
                                fileInput.click();
                            },
                            video: function video() {
                                this.quill.theme.tooltip.edit('video');
                            }
                        }
                    }
                }
            });
            var BaseTooltip = function(_Tooltip) {
                _inherits(BaseTooltip, _Tooltip);
                function BaseTooltip(quill, boundsContainer) {
                    _classCallCheck(this, BaseTooltip);
                    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));
                    _this4.textbox = _this4.root.querySelector('input[type="text"]');
                    _this4.listen();
                    return _this4;
                }
                _createClass(BaseTooltip, [
                    {
                        key: 'listen',
                        value: function listen() {
                            var _this5 = this;
                            this.textbox.addEventListener('keydown', function(event) {
                                if (_keyboard2.default.match(event, 'enter')) {
                                    _this5.save();
                                    event.preventDefault();
                                } else if (_keyboard2.default.match(event, 'escape')) {
                                    _this5.cancel();
                                    event.preventDefault();
                                }
                            });
                        }
                    },
                    {
                        key: 'cancel',
                        value: function cancel() {
                            this.hide();
                        }
                    },
                    {
                        key: 'edit',
                        value: function edit() {
                            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
                            var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                            this.root.classList.remove('ql-hidden');
                            this.root.classList.add('ql-editing');
                            if (preview != null) this.textbox.value = preview;
                            else if (mode !== this.root.getAttribute('data-mode')) this.textbox.value = '';
                            this.position(this.quill.getBounds(this.quill.selection.savedRange));
                            this.textbox.select();
                            this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
                            this.root.setAttribute('data-mode', mode);
                        }
                    },
                    {
                        key: 'restoreFocus',
                        value: function restoreFocus() {
                            var scrollTop = this.quill.scrollingContainer.scrollTop;
                            this.quill.focus();
                            this.quill.scrollingContainer.scrollTop = scrollTop;
                        }
                    },
                    {
                        key: 'save',
                        value: function save() {
                            var value = this.textbox.value;
                            switch(this.root.getAttribute('data-mode')){
                                case 'link':
                                    var scrollTop = this.quill.root.scrollTop;
                                    if (this.linkRange) {
                                        this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
                                        delete this.linkRange;
                                    } else {
                                        this.restoreFocus();
                                        this.quill.format('link', value, _emitter2.default.sources.USER);
                                    }
                                    this.quill.root.scrollTop = scrollTop;
                                    break;
                                case 'video':
                                    value = extractVideoUrl(value);
                                case 'formula':
                                    if (!value) break;
                                    var range = this.quill.getSelection(true);
                                    if (range != null) {
                                        var index = range.index + range.length;
                                        this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
                                        if (this.root.getAttribute('data-mode') === 'formula') this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
                                        this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
                                    }
                                    break;
                                default:
                            }
                            this.textbox.value = '';
                            this.hide();
                        }
                    }
                ]);
                return BaseTooltip;
            }(_tooltip2.default);
            function extractVideoUrl(url) {
                var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
                if (match) return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
                if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) // eslint-disable-line no-cond-assign
                return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
                return url;
            }
            function fillSelect(select, values) {
                var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                values.forEach(function(value) {
                    var option = document.createElement('option');
                    if (value === defaultValue) option.setAttribute('selected', 'selected');
                    else option.setAttribute('value', value);
                    select.appendChild(option);
                });
            }
            exports.BaseTooltip = BaseTooltip;
            exports.default = BaseTheme;
        /***/ },
        /* 44 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var LinkedList = /** @class */ function() {
                function LinkedList() {
                    this.head = this.tail = null;
                    this.length = 0;
                }
                LinkedList.prototype.append = function() {
                    var nodes = [];
                    for(var _i = 0; _i < arguments.length; _i++)nodes[_i] = arguments[_i];
                    this.insertBefore(nodes[0], null);
                    if (nodes.length > 1) this.append.apply(this, nodes.slice(1));
                };
                LinkedList.prototype.contains = function(node) {
                    var cur, next = this.iterator();
                    while(cur = next()){
                        if (cur === node) return true;
                    }
                    return false;
                };
                LinkedList.prototype.insertBefore = function(node, refNode) {
                    if (!node) return;
                    node.next = refNode;
                    if (refNode != null) {
                        node.prev = refNode.prev;
                        if (refNode.prev != null) refNode.prev.next = node;
                        refNode.prev = node;
                        if (refNode === this.head) this.head = node;
                    } else if (this.tail != null) {
                        this.tail.next = node;
                        node.prev = this.tail;
                        this.tail = node;
                    } else {
                        node.prev = null;
                        this.head = this.tail = node;
                    }
                    this.length += 1;
                };
                LinkedList.prototype.offset = function(target) {
                    var index = 0, cur = this.head;
                    while(cur != null){
                        if (cur === target) return index;
                        index += cur.length();
                        cur = cur.next;
                    }
                    return -1;
                };
                LinkedList.prototype.remove = function(node) {
                    if (!this.contains(node)) return;
                    if (node.prev != null) node.prev.next = node.next;
                    if (node.next != null) node.next.prev = node.prev;
                    if (node === this.head) this.head = node.next;
                    if (node === this.tail) this.tail = node.prev;
                    this.length -= 1;
                };
                LinkedList.prototype.iterator = function(curNode) {
                    if (curNode === void 0) curNode = this.head;
                    // TODO use yield when we can
                    return function() {
                        var ret = curNode;
                        if (curNode != null) curNode = curNode.next;
                        return ret;
                    };
                };
                LinkedList.prototype.find = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    var cur, next = this.iterator();
                    while(cur = next()){
                        var length = cur.length();
                        if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                            cur,
                            index
                        ];
                        index -= length;
                    }
                    return [
                        null,
                        0
                    ];
                };
                LinkedList.prototype.forEach = function(callback) {
                    var cur, next = this.iterator();
                    while(cur = next())callback(cur);
                };
                LinkedList.prototype.forEachAt = function(index, length, callback) {
                    if (length <= 0) return;
                    var _a = this.find(index), startNode = _a[0], offset = _a[1];
                    var cur, curIndex = index - offset, next = this.iterator(startNode);
                    while((cur = next()) && curIndex < index + length){
                        var curLength = cur.length();
                        if (index > curIndex) callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
                        else callback(cur, 0, Math.min(curLength, index + length - curIndex));
                        curIndex += curLength;
                    }
                };
                LinkedList.prototype.map = function(callback) {
                    return this.reduce(function(memo, cur) {
                        memo.push(callback(cur));
                        return memo;
                    }, []);
                };
                LinkedList.prototype.reduce = function(callback, memo) {
                    var cur, next = this.iterator();
                    while(cur = next())memo = callback(memo, cur);
                    return memo;
                };
                return LinkedList;
            }();
            exports.default = LinkedList;
        /***/ },
        /* 45 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var container_1 = __webpack_require__(17);
            var Registry = __webpack_require__(1);
            var OBSERVER_CONFIG = {
                attributes: true,
                characterData: true,
                characterDataOldValue: true,
                childList: true,
                subtree: true
            };
            var MAX_OPTIMIZE_ITERATIONS = 100;
            var ScrollBlot = /** @class */ function(_super) {
                __extends(ScrollBlot, _super);
                function ScrollBlot(node) {
                    var _this = _super.call(this, node) || this;
                    _this.scroll = _this;
                    _this.observer = new MutationObserver(function(mutations) {
                        _this.update(mutations);
                    });
                    _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
                    _this.attach();
                    return _this;
                }
                ScrollBlot.prototype.detach = function() {
                    _super.prototype.detach.call(this);
                    this.observer.disconnect();
                };
                ScrollBlot.prototype.deleteAt = function(index, length) {
                    this.update();
                    if (index === 0 && length === this.length()) this.children.forEach(function(child) {
                        child.remove();
                    });
                    else _super.prototype.deleteAt.call(this, index, length);
                };
                ScrollBlot.prototype.formatAt = function(index, length, name, value) {
                    this.update();
                    _super.prototype.formatAt.call(this, index, length, name, value);
                };
                ScrollBlot.prototype.insertAt = function(index, value, def) {
                    this.update();
                    _super.prototype.insertAt.call(this, index, value, def);
                };
                ScrollBlot.prototype.optimize = function(mutations, context) {
                    var _this = this;
                    if (mutations === void 0) mutations = [];
                    if (context === void 0) context = {};
                    _super.prototype.optimize.call(this, context);
                    // We must modify mutations directly, cannot make copy and then modify
                    var records = [].slice.call(this.observer.takeRecords());
                    // Array.push currently seems to be implemented by a non-tail recursive function
                    // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
                    while(records.length > 0)mutations.push(records.pop());
                    // TODO use WeakMap
                    var mark = function(blot, markParent) {
                        if (markParent === void 0) markParent = true;
                        if (blot == null || blot === _this) return;
                        if (blot.domNode.parentNode == null) return;
                        // @ts-ignore
                        if (blot.domNode[Registry.DATA_KEY].mutations == null) // @ts-ignore
                        blot.domNode[Registry.DATA_KEY].mutations = [];
                        if (markParent) mark(blot.parent);
                    };
                    var optimize = function(blot) {
                        // Post-order traversal
                        if (// @ts-ignore
                        blot.domNode[Registry.DATA_KEY] == null || // @ts-ignore
                        blot.domNode[Registry.DATA_KEY].mutations == null) return;
                        if (blot instanceof container_1.default) blot.children.forEach(optimize);
                        blot.optimize(context);
                    };
                    var remaining = mutations;
                    for(var i = 0; remaining.length > 0; i += 1){
                        if (i >= MAX_OPTIMIZE_ITERATIONS) throw new Error('[Parchment] Maximum optimize iterations reached');
                        remaining.forEach(function(mutation) {
                            var blot = Registry.find(mutation.target, true);
                            if (blot == null) return;
                            if (blot.domNode === mutation.target) {
                                if (mutation.type === 'childList') {
                                    mark(Registry.find(mutation.previousSibling, false));
                                    [].forEach.call(mutation.addedNodes, function(node) {
                                        var child = Registry.find(node, false);
                                        mark(child, false);
                                        if (child instanceof container_1.default) child.children.forEach(function(grandChild) {
                                            mark(grandChild, false);
                                        });
                                    });
                                } else if (mutation.type === 'attributes') mark(blot.prev);
                            }
                            mark(blot);
                        });
                        this.children.forEach(optimize);
                        remaining = [].slice.call(this.observer.takeRecords());
                        records = remaining.slice();
                        while(records.length > 0)mutations.push(records.pop());
                    }
                };
                ScrollBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    if (context === void 0) context = {};
                    mutations = mutations || this.observer.takeRecords();
                    // TODO use WeakMap
                    mutations.map(function(mutation) {
                        var blot = Registry.find(mutation.target, true);
                        if (blot == null) return null;
                        // @ts-ignore
                        if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                            // @ts-ignore
                            blot.domNode[Registry.DATA_KEY].mutations = [
                                mutation
                            ];
                            return blot;
                        } else {
                            // @ts-ignore
                            blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                            return null;
                        }
                    }).forEach(function(blot) {
                        if (blot == null || blot === _this || //@ts-ignore
                        blot.domNode[Registry.DATA_KEY] == null) return;
                        // @ts-ignore
                        blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
                    });
                    // @ts-ignore
                    if (this.domNode[Registry.DATA_KEY].mutations != null) // @ts-ignore
                    _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
                    this.optimize(mutations, context);
                };
                ScrollBlot.blotName = 'scroll';
                ScrollBlot.defaultChild = 'block';
                ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
                ScrollBlot.tagName = 'DIV';
                return ScrollBlot;
            }(container_1.default);
            exports.default = ScrollBlot;
        /***/ },
        /* 46 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var format_1 = __webpack_require__(18);
            var Registry = __webpack_require__(1);
            // Shallow object comparison
            function isEqual(obj1, obj2) {
                if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
                // @ts-ignore
                for(var prop in obj1){
                    // @ts-ignore
                    if (obj1[prop] !== obj2[prop]) return false;
                }
                return true;
            }
            var InlineBlot = /** @class */ function(_super) {
                __extends(InlineBlot, _super);
                function InlineBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                InlineBlot.formats = function(domNode) {
                    if (domNode.tagName === InlineBlot.tagName) return undefined;
                    return _super.formats.call(this, domNode);
                };
                InlineBlot.prototype.format = function(name, value) {
                    var _this = this;
                    if (name === this.statics.blotName && !value) {
                        this.children.forEach(function(child) {
                            if (!(child instanceof format_1.default)) child = child.wrap(InlineBlot.blotName, true);
                            _this.attributes.copy(child);
                        });
                        this.unwrap();
                    } else _super.prototype.format.call(this, name, value);
                };
                InlineBlot.prototype.formatAt = function(index, length, name, value) {
                    if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
                        var blot = this.isolate(index, length);
                        blot.format(name, value);
                    } else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                InlineBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    var formats = this.formats();
                    if (Object.keys(formats).length === 0) return this.unwrap(); // unformatted span
                    var next = this.next;
                    if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
                        next.moveChildren(this);
                        next.remove();
                    }
                };
                InlineBlot.blotName = 'inline';
                InlineBlot.scope = Registry.Scope.INLINE_BLOT;
                InlineBlot.tagName = 'SPAN';
                return InlineBlot;
            }(format_1.default);
            exports.default = InlineBlot;
        /***/ },
        /* 47 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var format_1 = __webpack_require__(18);
            var Registry = __webpack_require__(1);
            var BlockBlot = /** @class */ function(_super) {
                __extends(BlockBlot, _super);
                function BlockBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                BlockBlot.formats = function(domNode) {
                    var tagName = Registry.query(BlockBlot.blotName).tagName;
                    if (domNode.tagName === tagName) return undefined;
                    return _super.formats.call(this, domNode);
                };
                BlockBlot.prototype.format = function(name, value) {
                    if (Registry.query(name, Registry.Scope.BLOCK) == null) return;
                    else if (name === this.statics.blotName && !value) this.replaceWith(BlockBlot.blotName);
                    else _super.prototype.format.call(this, name, value);
                };
                BlockBlot.prototype.formatAt = function(index, length, name, value) {
                    if (Registry.query(name, Registry.Scope.BLOCK) != null) this.format(name, value);
                    else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                BlockBlot.prototype.insertAt = function(index, value, def) {
                    if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) // Insert text or inline
                    _super.prototype.insertAt.call(this, index, value, def);
                    else {
                        var after = this.split(index);
                        var blot = Registry.create(value, def);
                        after.parent.insertBefore(blot, after);
                    }
                };
                BlockBlot.prototype.update = function(mutations, context) {
                    if (navigator.userAgent.match(/Trident/)) this.build();
                    else _super.prototype.update.call(this, mutations, context);
                };
                BlockBlot.blotName = 'block';
                BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
                BlockBlot.tagName = 'P';
                return BlockBlot;
            }(format_1.default);
            exports.default = BlockBlot;
        /***/ },
        /* 48 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var leaf_1 = __webpack_require__(19);
            var EmbedBlot = /** @class */ function(_super) {
                __extends(EmbedBlot, _super);
                function EmbedBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                EmbedBlot.formats = function(domNode) {
                    return undefined;
                };
                EmbedBlot.prototype.format = function(name, value) {
                    // super.formatAt wraps, which is what we want in general,
                    // but this allows subclasses to overwrite for formats
                    // that just apply to particular embeds
                    _super.prototype.formatAt.call(this, 0, this.length(), name, value);
                };
                EmbedBlot.prototype.formatAt = function(index, length, name, value) {
                    if (index === 0 && length === this.length()) this.format(name, value);
                    else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                EmbedBlot.prototype.formats = function() {
                    return this.statics.formats(this.domNode);
                };
                return EmbedBlot;
            }(leaf_1.default);
            exports.default = EmbedBlot;
        /***/ },
        /* 49 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var leaf_1 = __webpack_require__(19);
            var Registry = __webpack_require__(1);
            var TextBlot = /** @class */ function(_super) {
                __extends(TextBlot, _super);
                function TextBlot(node) {
                    var _this = _super.call(this, node) || this;
                    _this.text = _this.statics.value(_this.domNode);
                    return _this;
                }
                TextBlot.create = function(value) {
                    return document.createTextNode(value);
                };
                TextBlot.value = function(domNode) {
                    var text = domNode.data;
                    // @ts-ignore
                    if (text['normalize']) text = text['normalize']();
                    return text;
                };
                TextBlot.prototype.deleteAt = function(index, length) {
                    this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
                };
                TextBlot.prototype.index = function(node, offset) {
                    if (this.domNode === node) return offset;
                    return -1;
                };
                TextBlot.prototype.insertAt = function(index, value, def) {
                    if (def == null) {
                        this.text = this.text.slice(0, index) + value + this.text.slice(index);
                        this.domNode.data = this.text;
                    } else _super.prototype.insertAt.call(this, index, value, def);
                };
                TextBlot.prototype.length = function() {
                    return this.text.length;
                };
                TextBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    this.text = this.statics.value(this.domNode);
                    if (this.text.length === 0) this.remove();
                    else if (this.next instanceof TextBlot && this.next.prev === this) {
                        this.insertAt(this.length(), this.next.value());
                        this.next.remove();
                    }
                };
                TextBlot.prototype.position = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    return [
                        this.domNode,
                        index
                    ];
                };
                TextBlot.prototype.split = function(index, force) {
                    if (force === void 0) force = false;
                    if (!force) {
                        if (index === 0) return this;
                        if (index === this.length()) return this.next;
                    }
                    var after = Registry.create(this.domNode.splitText(index));
                    this.parent.insertBefore(after, this.next);
                    this.text = this.statics.value(this.domNode);
                    return after;
                };
                TextBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    if (mutations.some(function(mutation) {
                        return mutation.type === 'characterData' && mutation.target === _this.domNode;
                    })) this.text = this.statics.value(this.domNode);
                };
                TextBlot.prototype.value = function() {
                    return this.text;
                };
                TextBlot.blotName = 'text';
                TextBlot.scope = Registry.Scope.INLINE_BLOT;
                return TextBlot;
            }(leaf_1.default);
            exports.default = TextBlot;
        /***/ },
        /* 50 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var elem = document.createElement('div');
            elem.classList.toggle('test-class', false);
            if (elem.classList.contains('test-class')) {
                var _toggle = DOMTokenList.prototype.toggle;
                DOMTokenList.prototype.toggle = function(token, force) {
                    if (arguments.length > 1 && !this.contains(token) === !force) return force;
                    else return _toggle.call(this, token);
                };
            }
            if (!String.prototype.startsWith) String.prototype.startsWith = function(searchString, position) {
                position = position || 0;
                return this.substr(position, searchString.length) === searchString;
            };
            if (!String.prototype.endsWith) String.prototype.endsWith = function(searchString, position) {
                var subjectString = this.toString();
                if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) position = subjectString.length;
                position -= searchString.length;
                var lastIndex = subjectString.indexOf(searchString, position);
                return lastIndex !== -1 && lastIndex === position;
            };
            if (!Array.prototype.find) Object.defineProperty(Array.prototype, "find", {
                value: function value(predicate) {
                    if (this === null) throw new TypeError('Array.prototype.find called on null or undefined');
                    if (typeof predicate !== 'function') throw new TypeError('predicate must be a function');
                    var list = Object(this);
                    var length = list.length >>> 0;
                    var thisArg = arguments[1];
                    var value;
                    for(var i = 0; i < length; i++){
                        value = list[i];
                        if (predicate.call(thisArg, value, i, list)) return value;
                    }
                    return undefined;
                }
            });
            document.addEventListener("DOMContentLoaded", function() {
                // Disable resizing in Firefox
                document.execCommand("enableObjectResizing", false, false);
                // Disable automatic linkifying in IE11
                document.execCommand("autoUrlDetect", false, false);
            });
        /***/ },
        /* 51 */ /***/ function(module1, exports) {
            /**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var DIFF_DELETE = -1;
            var DIFF_INSERT = 1;
            var DIFF_EQUAL = 0;
            /**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int} cursor_pos Expected edit position in text1 (optional)
 * @return {Array} Array of diff tuples.
 */ function diff_main(text1, text2, cursor_pos) {
                // Check for equality (speedup).
                if (text1 == text2) {
                    if (text1) return [
                        [
                            DIFF_EQUAL,
                            text1
                        ]
                    ];
                    return [];
                }
                // Check cursor_pos within bounds
                if (cursor_pos < 0 || text1.length < cursor_pos) cursor_pos = null;
                // Trim off common prefix (speedup).
                var commonlength = diff_commonPrefix(text1, text2);
                var commonprefix = text1.substring(0, commonlength);
                text1 = text1.substring(commonlength);
                text2 = text2.substring(commonlength);
                // Trim off common suffix (speedup).
                commonlength = diff_commonSuffix(text1, text2);
                var commonsuffix = text1.substring(text1.length - commonlength);
                text1 = text1.substring(0, text1.length - commonlength);
                text2 = text2.substring(0, text2.length - commonlength);
                // Compute the diff on the middle block.
                var diffs = diff_compute_(text1, text2);
                // Restore the prefix and suffix.
                if (commonprefix) diffs.unshift([
                    DIFF_EQUAL,
                    commonprefix
                ]);
                if (commonsuffix) diffs.push([
                    DIFF_EQUAL,
                    commonsuffix
                ]);
                diff_cleanupMerge(diffs);
                if (cursor_pos != null) diffs = fix_cursor(diffs, cursor_pos);
                diffs = fix_emoji(diffs);
                return diffs;
            }
            /**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function diff_compute_(text1, text2) {
                var diffs;
                if (!text1) // Just add some text (speedup).
                return [
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
                if (!text2) // Just delete some text (speedup).
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ]
                ];
                var longtext = text1.length > text2.length ? text1 : text2;
                var shorttext = text1.length > text2.length ? text2 : text1;
                var i = longtext.indexOf(shorttext);
                if (i != -1) {
                    // Shorter text is inside the longer text (speedup).
                    diffs = [
                        [
                            DIFF_INSERT,
                            longtext.substring(0, i)
                        ],
                        [
                            DIFF_EQUAL,
                            shorttext
                        ],
                        [
                            DIFF_INSERT,
                            longtext.substring(i + shorttext.length)
                        ]
                    ];
                    // Swap insertions for deletions if diff is reversed.
                    if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = DIFF_DELETE;
                    return diffs;
                }
                if (shorttext.length == 1) // Single character string.
                // After the previous speedup, the character can't be an equality.
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ],
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
                // Check to see if the problem can be split in two.
                var hm = diff_halfMatch_(text1, text2);
                if (hm) {
                    // A half-match was found, sort out the return data.
                    var text1_a = hm[0];
                    var text1_b = hm[1];
                    var text2_a = hm[2];
                    var text2_b = hm[3];
                    var mid_common = hm[4];
                    // Send both pairs off for separate processing.
                    var diffs_a = diff_main(text1_a, text2_a);
                    var diffs_b = diff_main(text1_b, text2_b);
                    // Merge the results.
                    return diffs_a.concat([
                        [
                            DIFF_EQUAL,
                            mid_common
                        ]
                    ], diffs_b);
                }
                return diff_bisect_(text1, text2);
            }
            /**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function diff_bisect_(text1, text2) {
                // Cache the text lengths to prevent multiple calls.
                var text1_length = text1.length;
                var text2_length = text2.length;
                var max_d = Math.ceil((text1_length + text2_length) / 2);
                var v_offset = max_d;
                var v_length = 2 * max_d;
                var v1 = new Array(v_length);
                var v2 = new Array(v_length);
                // Setting all elements to -1 is faster in Chrome & Firefox than mixing
                // integers and undefined.
                for(var x = 0; x < v_length; x++){
                    v1[x] = -1;
                    v2[x] = -1;
                }
                v1[v_offset + 1] = 0;
                v2[v_offset + 1] = 0;
                var delta = text1_length - text2_length;
                // If the total number of characters is odd, then the front path will collide
                // with the reverse path.
                var front = delta % 2 != 0;
                // Offsets for start and end of k loop.
                // Prevents mapping of space beyond the grid.
                var k1start = 0;
                var k1end = 0;
                var k2start = 0;
                var k2end = 0;
                for(var d = 0; d < max_d; d++){
                    // Walk the front path one step.
                    for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
                        var k1_offset = v_offset + k1;
                        var x1;
                        if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
                        else x1 = v1[k1_offset - 1] + 1;
                        var y1 = x1 - k1;
                        while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)){
                            x1++;
                            y1++;
                        }
                        v1[k1_offset] = x1;
                        if (x1 > text1_length) // Ran off the right of the graph.
                        k1end += 2;
                        else if (y1 > text2_length) // Ran off the bottom of the graph.
                        k1start += 2;
                        else if (front) {
                            var k2_offset = v_offset + delta - k1;
                            if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                                // Mirror x2 onto top-left coordinate system.
                                var x2 = text1_length - v2[k2_offset];
                                if (x1 >= x2) // Overlap detected.
                                return diff_bisectSplit_(text1, text2, x1, y1);
                            }
                        }
                    }
                    // Walk the reverse path one step.
                    for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
                        var k2_offset = v_offset + k2;
                        var x2;
                        if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
                        else x2 = v2[k2_offset - 1] + 1;
                        var y2 = x2 - k2;
                        while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)){
                            x2++;
                            y2++;
                        }
                        v2[k2_offset] = x2;
                        if (x2 > text1_length) // Ran off the left of the graph.
                        k2end += 2;
                        else if (y2 > text2_length) // Ran off the top of the graph.
                        k2start += 2;
                        else if (!front) {
                            var k1_offset = v_offset + delta - k2;
                            if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                                var x1 = v1[k1_offset];
                                var y1 = v_offset + x1 - k1_offset;
                                // Mirror x2 onto top-left coordinate system.
                                x2 = text1_length - x2;
                                if (x1 >= x2) // Overlap detected.
                                return diff_bisectSplit_(text1, text2, x1, y1);
                            }
                        }
                    }
                }
                // Diff took too long and hit the deadline or
                // number of diffs equals number of characters, no commonality at all.
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ],
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
            }
            /**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function diff_bisectSplit_(text1, text2, x, y) {
                var text1a = text1.substring(0, x);
                var text2a = text2.substring(0, y);
                var text1b = text1.substring(x);
                var text2b = text2.substring(y);
                // Compute both diffs serially.
                var diffs = diff_main(text1a, text2a);
                var diffsb = diff_main(text1b, text2b);
                return diffs.concat(diffsb);
            }
            /**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function diff_commonPrefix(text1, text2) {
                // Quick check for common null cases.
                if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) return 0;
                // Binary search.
                // Performance analysis: http://neil.fraser.name/news/2007/10/09/
                var pointermin = 0;
                var pointermax = Math.min(text1.length, text2.length);
                var pointermid = pointermax;
                var pointerstart = 0;
                while(pointermin < pointermid){
                    if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
                        pointermin = pointermid;
                        pointerstart = pointermin;
                    } else pointermax = pointermid;
                    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
                }
                return pointermid;
            }
            /**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function diff_commonSuffix(text1, text2) {
                // Quick check for common null cases.
                if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) return 0;
                // Binary search.
                // Performance analysis: http://neil.fraser.name/news/2007/10/09/
                var pointermin = 0;
                var pointermax = Math.min(text1.length, text2.length);
                var pointermid = pointermax;
                var pointerend = 0;
                while(pointermin < pointermid){
                    if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
                        pointermin = pointermid;
                        pointerend = pointermin;
                    } else pointermax = pointermid;
                    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
                }
                return pointermid;
            }
            /**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function diff_halfMatch_(text1, text2) {
                var longtext = text1.length > text2.length ? text1 : text2;
                var shorttext = text1.length > text2.length ? text2 : text1;
                if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
                /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
                    // Start with a 1/4 length substring at position i as a seed.
                    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
                    var j = -1;
                    var best_common = '';
                    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
                    while((j = shorttext.indexOf(seed, j + 1)) != -1){
                        var prefixLength = diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
                        var suffixLength = diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
                        if (best_common.length < suffixLength + prefixLength) {
                            best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                            best_longtext_a = longtext.substring(0, i - suffixLength);
                            best_longtext_b = longtext.substring(i + prefixLength);
                            best_shorttext_a = shorttext.substring(0, j - suffixLength);
                            best_shorttext_b = shorttext.substring(j + prefixLength);
                        }
                    }
                    if (best_common.length * 2 >= longtext.length) return [
                        best_longtext_a,
                        best_longtext_b,
                        best_shorttext_a,
                        best_shorttext_b,
                        best_common
                    ];
                    else return null;
                }
                // First check if the second quarter is the seed for a half-match.
                var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
                // Check again based on the third quarter.
                var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
                var hm;
                if (!hm1 && !hm2) return null;
                else if (!hm2) hm = hm1;
                else if (!hm1) hm = hm2;
                else // Both matched.  Select the longest.
                hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
                // A half-match was found, sort out the return data.
                var text1_a, text1_b, text2_a, text2_b;
                if (text1.length > text2.length) {
                    text1_a = hm[0];
                    text1_b = hm[1];
                    text2_a = hm[2];
                    text2_b = hm[3];
                } else {
                    text2_a = hm[0];
                    text2_b = hm[1];
                    text1_a = hm[2];
                    text1_b = hm[3];
                }
                var mid_common = hm[4];
                return [
                    text1_a,
                    text1_b,
                    text2_a,
                    text2_b,
                    mid_common
                ];
            }
            /**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 */ function diff_cleanupMerge(diffs) {
                diffs.push([
                    DIFF_EQUAL,
                    ''
                ]); // Add a dummy entry at the end.
                var pointer = 0;
                var count_delete = 0;
                var count_insert = 0;
                var text_delete = '';
                var text_insert = '';
                var commonlength;
                while(pointer < diffs.length)switch(diffs[pointer][0]){
                    case DIFF_INSERT:
                        count_insert++;
                        text_insert += diffs[pointer][1];
                        pointer++;
                        break;
                    case DIFF_DELETE:
                        count_delete++;
                        text_delete += diffs[pointer][1];
                        pointer++;
                        break;
                    case DIFF_EQUAL:
                        // Upon reaching an equality, check for prior redundancies.
                        if (count_delete + count_insert > 1) {
                            if (count_delete !== 0 && count_insert !== 0) {
                                // Factor out any common prefixies.
                                commonlength = diff_commonPrefix(text_insert, text_delete);
                                if (commonlength !== 0) {
                                    if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == DIFF_EQUAL) diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                                    else {
                                        diffs.splice(0, 0, [
                                            DIFF_EQUAL,
                                            text_insert.substring(0, commonlength)
                                        ]);
                                        pointer++;
                                    }
                                    text_insert = text_insert.substring(commonlength);
                                    text_delete = text_delete.substring(commonlength);
                                }
                                // Factor out any common suffixies.
                                commonlength = diff_commonSuffix(text_insert, text_delete);
                                if (commonlength !== 0) {
                                    diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                                    text_insert = text_insert.substring(0, text_insert.length - commonlength);
                                    text_delete = text_delete.substring(0, text_delete.length - commonlength);
                                }
                            }
                            // Delete the offending records and add the merged ones.
                            if (count_delete === 0) diffs.splice(pointer - count_insert, count_delete + count_insert, [
                                DIFF_INSERT,
                                text_insert
                            ]);
                            else if (count_insert === 0) diffs.splice(pointer - count_delete, count_delete + count_insert, [
                                DIFF_DELETE,
                                text_delete
                            ]);
                            else diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert, [
                                DIFF_DELETE,
                                text_delete
                            ], [
                                DIFF_INSERT,
                                text_insert
                            ]);
                            pointer = pointer - count_delete - count_insert + (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
                        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
                            // Merge this equality with the previous one.
                            diffs[pointer - 1][1] += diffs[pointer][1];
                            diffs.splice(pointer, 1);
                        } else pointer++;
                        count_insert = 0;
                        count_delete = 0;
                        text_delete = '';
                        text_insert = '';
                        break;
                }
                if (diffs[diffs.length - 1][1] === '') diffs.pop(); // Remove the dummy entry at the end.
                // Second pass: look for single edits surrounded on both sides by equalities
                // which can be shifted sideways to eliminate an equality.
                // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
                var changes = false;
                pointer = 1;
                // Intentionally ignore the first and last element (don't need checking).
                while(pointer < diffs.length - 1){
                    if (diffs[pointer - 1][0] == DIFF_EQUAL && diffs[pointer + 1][0] == DIFF_EQUAL) {
                        // This is a single edit surrounded by equalities.
                        if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                            // Shift the edit over the previous equality.
                            diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                            diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                            diffs.splice(pointer - 1, 1);
                            changes = true;
                        } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                            // Shift the edit over the next equality.
                            diffs[pointer - 1][1] += diffs[pointer + 1][1];
                            diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                            diffs.splice(pointer + 1, 1);
                            changes = true;
                        }
                    }
                    pointer++;
                }
                // If shifts were made, the diff needs reordering and another shift sweep.
                if (changes) diff_cleanupMerge(diffs);
            }
            var diff = diff_main;
            diff.INSERT = DIFF_INSERT;
            diff.DELETE = DIFF_DELETE;
            diff.EQUAL = DIFF_EQUAL;
            module1.exports = diff;
            /*
 * Modify a diff such that the cursor position points to the start of a change:
 * E.g.
 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
 */ function cursor_normalize_diff(diffs, cursor_pos) {
                if (cursor_pos === 0) return [
                    DIFF_EQUAL,
                    diffs
                ];
                for(var current_pos = 0, i = 0; i < diffs.length; i++){
                    var d = diffs[i];
                    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
                        var next_pos = current_pos + d[1].length;
                        if (cursor_pos === next_pos) return [
                            i + 1,
                            diffs
                        ];
                        else if (cursor_pos < next_pos) {
                            // copy to prevent side effects
                            diffs = diffs.slice();
                            // split d into two diff changes
                            var split_pos = cursor_pos - current_pos;
                            var d_left = [
                                d[0],
                                d[1].slice(0, split_pos)
                            ];
                            var d_right = [
                                d[0],
                                d[1].slice(split_pos)
                            ];
                            diffs.splice(i, 1, d_left, d_right);
                            return [
                                i + 1,
                                diffs
                            ];
                        } else current_pos = next_pos;
                    }
                }
                throw new Error('cursor_pos is out of bounds!');
            }
            /*
 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
 *
 * Case 1)
 *   Check if a naive shift is possible:
 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
 * Case 2)
 *   Check if the following shifts are possible:
 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
 *         ^            ^
 *         d          d_next
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} Array of diff tuples
 */ function fix_cursor(diffs, cursor_pos) {
                var norm = cursor_normalize_diff(diffs, cursor_pos);
                var ndiffs = norm[1];
                var cursor_pointer = norm[0];
                var d = ndiffs[cursor_pointer];
                var d_next = ndiffs[cursor_pointer + 1];
                if (d == null) // Text was deleted from end of original string,
                // cursor is now out of bounds in new string
                return diffs;
                else if (d[0] !== DIFF_EQUAL) // A modification happened at the cursor location.
                // This is the expected outcome, so we can return the original diff.
                return diffs;
                else {
                    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
                        // Case 1)
                        // It is possible to perform a naive shift
                        ndiffs.splice(cursor_pointer, 2, d_next, d);
                        return merge_tuples(ndiffs, cursor_pointer, 2);
                    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
                        // Case 2)
                        // d[1] is a prefix of d_next[1]
                        // We can assume that d_next[0] !== 0, since d[0] === 0
                        // Shift edit locations..
                        ndiffs.splice(cursor_pointer, 2, [
                            d_next[0],
                            d[1]
                        ], [
                            0,
                            d[1]
                        ]);
                        var suffix = d_next[1].slice(d[1].length);
                        if (suffix.length > 0) ndiffs.splice(cursor_pointer + 2, 0, [
                            d_next[0],
                            suffix
                        ]);
                        return merge_tuples(ndiffs, cursor_pointer, 3);
                    } else // Not possible to perform any modification
                    return diffs;
                }
            }
            /*
 * Check diff did not split surrogate pairs.
 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
 *
 * @param {Array} diffs Array of diff tuples
 * @return {Array} Array of diff tuples
 */ function fix_emoji(diffs) {
                var compact = false;
                var starts_with_pair_end = function(str) {
                    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
                };
                var ends_with_pair_start = function(str) {
                    return str.charCodeAt(str.length - 1) >= 0xD800 && str.charCodeAt(str.length - 1) <= 0xDBFF;
                };
                for(var i = 2; i < diffs.length; i += 1)if (diffs[i - 2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i - 2][1]) && diffs[i - 1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i - 1][1]) && diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
                    compact = true;
                    diffs[i - 1][1] = diffs[i - 2][1].slice(-1) + diffs[i - 1][1];
                    diffs[i][1] = diffs[i - 2][1].slice(-1) + diffs[i][1];
                    diffs[i - 2][1] = diffs[i - 2][1].slice(0, -1);
                }
                if (!compact) return diffs;
                var fixed_diffs = [];
                for(var i = 0; i < diffs.length; i += 1)if (diffs[i][1].length > 0) fixed_diffs.push(diffs[i]);
                return fixed_diffs;
            }
            /*
 * Try to merge tuples with their neigbors in a given range.
 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
 *
 * @param {Array} diffs Array of diff tuples.
 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
 * @param {Int} length Number of consecutive elements to check.
 * @return {Array} Array of merged diff tuples.
 */ function merge_tuples(diffs, start, length) {
                // Check from (start-1) to (start+length).
                for(var i = start + length - 1; i >= 0 && i >= start - 1; i--)if (i + 1 < diffs.length) {
                    var left_d = diffs[i];
                    var right_d = diffs[i + 1];
                    if (left_d[0] === right_d[1]) diffs.splice(i, 2, [
                        left_d[0],
                        left_d[1] + right_d[1]
                    ]);
                }
                return diffs;
            }
        /***/ },
        /* 52 */ /***/ function(module1, exports) {
            exports = module1.exports = typeof Object.keys === 'function' ? Object.keys : shim;
            exports.shim = shim;
            function shim(obj) {
                var keys = [];
                for(var key in obj)keys.push(key);
                return keys;
            }
        /***/ },
        /* 53 */ /***/ function(module1, exports) {
            var supportsArgumentsClass = function() {
                return Object.prototype.toString.call(arguments);
            }() == '[object Arguments]';
            exports = module1.exports = supportsArgumentsClass ? supported : unsupported;
            exports.supported = supported;
            function supported(object) {
                return Object.prototype.toString.call(object) == '[object Arguments]';
            }
            exports.unsupported = unsupported;
            function unsupported(object) {
                return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
            }
        /***/ },
        /* 54 */ /***/ function(module1, exports) {
            'use strict';
            var has = Object.prototype.hasOwnProperty, prefix = '~';
            /**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */ function Events() {}
            //
            // We try to not inherit from `Object.prototype`. In some engines creating an
            // instance in this way is faster than calling `Object.create(null)` directly.
            // If `Object.create(null)` is not supported we prefix the event names with a
            // character to make sure that the built-in object properties are not
            // overridden or used as an attack vector.
            //
            if (Object.create) {
                Events.prototype = Object.create(null);
                //
                // This hack is needed because the `__proto__` property is still inherited in
                // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
                //
                if (!new Events().__proto__) prefix = false;
            }
            /**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */ function EE(fn, context, once) {
                this.fn = fn;
                this.context = context;
                this.once = once || false;
            }
            /**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */ function EventEmitter() {
                this._events = new Events();
                this._eventsCount = 0;
            }
            /**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */ EventEmitter.prototype.eventNames = function eventNames() {
                var names = [], events, name;
                if (this._eventsCount === 0) return names;
                for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
                if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
                return names;
            };
            /**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */ EventEmitter.prototype.listeners = function listeners(event, exists) {
                var evt = prefix ? prefix + event : event, available = this._events[evt];
                if (exists) return !!available;
                if (!available) return [];
                if (available.fn) return [
                    available.fn
                ];
                for(var i = 0, l = available.length, ee = new Array(l); i < l; i++)ee[i] = available[i].fn;
                return ee;
            };
            /**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return false;
                var listeners = this._events[evt], len = arguments.length, args, i;
                if (listeners.fn) {
                    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                    switch(len){
                        case 1:
                            return listeners.fn.call(listeners.context), true;
                        case 2:
                            return listeners.fn.call(listeners.context, a1), true;
                        case 3:
                            return listeners.fn.call(listeners.context, a1, a2), true;
                        case 4:
                            return listeners.fn.call(listeners.context, a1, a2, a3), true;
                        case 5:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                        case 6:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                    }
                    for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                    listeners.fn.apply(listeners.context, args);
                } else {
                    var length = listeners.length, j;
                    for(i = 0; i < length; i++){
                        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                        switch(len){
                            case 1:
                                listeners[i].fn.call(listeners[i].context);
                                break;
                            case 2:
                                listeners[i].fn.call(listeners[i].context, a1);
                                break;
                            case 3:
                                listeners[i].fn.call(listeners[i].context, a1, a2);
                                break;
                            case 4:
                                listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                                break;
                            default:
                                if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                                listeners[i].fn.apply(listeners[i].context, args);
                        }
                    }
                }
                return true;
            };
            /**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
                var listener = new EE(fn, context || this), evt = prefix ? prefix + event : event;
                if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
                else if (!this._events[evt].fn) this._events[evt].push(listener);
                else this._events[evt] = [
                    this._events[evt],
                    listener
                ];
                return this;
            };
            /**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
                var listener = new EE(fn, context || this, true), evt = prefix ? prefix + event : event;
                if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
                else if (!this._events[evt].fn) this._events[evt].push(listener);
                else this._events[evt] = [
                    this._events[evt],
                    listener
                ];
                return this;
            };
            /**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return this;
                if (!fn) {
                    if (--this._eventsCount === 0) this._events = new Events();
                    else delete this._events[evt];
                    return this;
                }
                var listeners = this._events[evt];
                if (listeners.fn) {
                    if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
                        if (--this._eventsCount === 0) this._events = new Events();
                        else delete this._events[evt];
                    }
                } else {
                    for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                    //
                    // Reset the array, or remove it completely if we have no more listeners.
                    //
                    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                    else if (--this._eventsCount === 0) this._events = new Events();
                    else delete this._events[evt];
                }
                return this;
            };
            /**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
                var evt;
                if (event) {
                    evt = prefix ? prefix + event : event;
                    if (this._events[evt]) {
                        if (--this._eventsCount === 0) this._events = new Events();
                        else delete this._events[evt];
                    }
                } else {
                    this._events = new Events();
                    this._eventsCount = 0;
                }
                return this;
            };
            //
            // Alias methods names because people roll like that.
            //
            EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
            EventEmitter.prototype.addListener = EventEmitter.prototype.on;
            //
            // This function doesn't apply anymore.
            //
            EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
                return this;
            };
            //
            // Expose the prefix.
            //
            EventEmitter.prefixed = prefix;
            //
            // Allow `EventEmitter` to be imported as module namespace.
            //
            EventEmitter.EventEmitter = EventEmitter;
            //
            // Expose the module.
            //
            if ('undefined' !== typeof module1) module1.exports = EventEmitter;
        /***/ },
        /* 55 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend2 = __webpack_require__(3);
            var _extend3 = _interopRequireDefault(_extend2);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _align = __webpack_require__(36);
            var _background = __webpack_require__(37);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _color = __webpack_require__(26);
            var _direction = __webpack_require__(38);
            var _font = __webpack_require__(39);
            var _size = __webpack_require__(40);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)('quill:clipboard');
            var DOM_KEY = '__ql-matcher';
            var CLIPBOARD_CONFIG = [
                [
                    Node.TEXT_NODE,
                    matchText
                ],
                [
                    Node.TEXT_NODE,
                    matchNewline
                ],
                [
                    'br',
                    matchBreak
                ],
                [
                    Node.ELEMENT_NODE,
                    matchNewline
                ],
                [
                    Node.ELEMENT_NODE,
                    matchBlot
                ],
                [
                    Node.ELEMENT_NODE,
                    matchSpacing
                ],
                [
                    Node.ELEMENT_NODE,
                    matchAttributor
                ],
                [
                    Node.ELEMENT_NODE,
                    matchStyles
                ],
                [
                    'li',
                    matchIndent
                ],
                [
                    'b',
                    matchAlias.bind(matchAlias, 'bold')
                ],
                [
                    'i',
                    matchAlias.bind(matchAlias, 'italic')
                ],
                [
                    'style',
                    matchIgnore
                ]
            ];
            var ATTRIBUTE_ATTRIBUTORS = [
                _align.AlignAttribute,
                _direction.DirectionAttribute
            ].reduce(function(memo, attr) {
                memo[attr.keyName] = attr;
                return memo;
            }, {});
            var STYLE_ATTRIBUTORS = [
                _align.AlignStyle,
                _background.BackgroundStyle,
                _color.ColorStyle,
                _direction.DirectionStyle,
                _font.FontStyle,
                _size.SizeStyle
            ].reduce(function(memo, attr) {
                memo[attr.keyName] = attr;
                return memo;
            }, {});
            var Clipboard = function(_Module) {
                _inherits(Clipboard, _Module);
                function Clipboard(quill, options) {
                    _classCallCheck(this, Clipboard);
                    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));
                    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
                    _this.container = _this.quill.addContainer('ql-clipboard');
                    _this.container.setAttribute('contenteditable', true);
                    _this.container.setAttribute('tabindex', -1);
                    _this.matchers = [];
                    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function(_ref) {
                        var _ref2 = _slicedToArray(_ref, 2), selector = _ref2[0], matcher = _ref2[1];
                        if (!options.matchVisual && matcher === matchSpacing) return;
                        _this.addMatcher(selector, matcher);
                    });
                    return _this;
                }
                _createClass(Clipboard, [
                    {
                        key: 'addMatcher',
                        value: function addMatcher(selector, matcher) {
                            this.matchers.push([
                                selector,
                                matcher
                            ]);
                        }
                    },
                    {
                        key: 'convert',
                        value: function convert(html) {
                            if (typeof html === 'string') {
                                this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
                                return this.convert();
                            }
                            var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
                            if (formats[_code2.default.blotName]) {
                                var text = this.container.innerText;
                                this.container.innerHTML = '';
                                return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
                            }
                            var _prepareMatching = this.prepareMatching(), _prepareMatching2 = _slicedToArray(_prepareMatching, 2), elementMatchers = _prepareMatching2[0], textMatchers = _prepareMatching2[1];
                            var delta = traverse(this.container, elementMatchers, textMatchers);
                            // Remove trailing newline
                            if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
                            debug.log('convert', this.container.innerHTML, delta);
                            this.container.innerHTML = '';
                            return delta;
                        }
                    },
                    {
                        key: 'dangerouslyPasteHTML',
                        value: function dangerouslyPasteHTML(index, html) {
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;
                            if (typeof index === 'string') {
                                this.quill.setContents(this.convert(index), html);
                                this.quill.setSelection(0, _quill2.default.sources.SILENT);
                            } else {
                                var paste = this.convert(html);
                                this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
                                this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
                            }
                        }
                    },
                    {
                        key: 'onPaste',
                        value: function onPaste(e) {
                            var _this2 = this;
                            if (e.defaultPrevented || !this.quill.isEnabled()) return;
                            var range = this.quill.getSelection();
                            var delta = new _quillDelta2.default().retain(range.index);
                            var scrollTop = this.quill.scrollingContainer.scrollTop;
                            this.container.focus();
                            this.quill.selection.update(_quill2.default.sources.SILENT);
                            setTimeout(function() {
                                delta = delta.concat(_this2.convert()).delete(range.length);
                                _this2.quill.updateContents(delta, _quill2.default.sources.USER);
                                // range.length contributes to delta.length()
                                _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
                                _this2.quill.scrollingContainer.scrollTop = scrollTop;
                                _this2.quill.focus();
                            }, 1);
                        }
                    },
                    {
                        key: 'prepareMatching',
                        value: function prepareMatching() {
                            var _this3 = this;
                            var elementMatchers = [], textMatchers = [];
                            this.matchers.forEach(function(pair) {
                                var _pair = _slicedToArray(pair, 2), selector = _pair[0], matcher = _pair[1];
                                switch(selector){
                                    case Node.TEXT_NODE:
                                        textMatchers.push(matcher);
                                        break;
                                    case Node.ELEMENT_NODE:
                                        elementMatchers.push(matcher);
                                        break;
                                    default:
                                        [].forEach.call(_this3.container.querySelectorAll(selector), function(node) {
                                            // TODO use weakmap
                                            node[DOM_KEY] = node[DOM_KEY] || [];
                                            node[DOM_KEY].push(matcher);
                                        });
                                        break;
                                }
                            });
                            return [
                                elementMatchers,
                                textMatchers
                            ];
                        }
                    }
                ]);
                return Clipboard;
            }(_module2.default);
            Clipboard.DEFAULTS = {
                matchers: [],
                matchVisual: true
            };
            function applyFormat(delta, format, value) {
                if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') return Object.keys(format).reduce(function(delta, key) {
                    return applyFormat(delta, key, format[key]);
                }, delta);
                else return delta.reduce(function(delta, op) {
                    if (op.attributes && op.attributes[format]) return delta.push(op);
                    else return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
                }, new _quillDelta2.default());
            }
            function computeStyle(node) {
                if (node.nodeType !== Node.ELEMENT_NODE) return {};
                var DOM_KEY = '__ql-computed-style';
                return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
            }
            function deltaEndsWith(delta, text) {
                var endText = "";
                for(var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i){
                    var op = delta.ops[i];
                    if (typeof op.insert !== 'string') break;
                    endText = op.insert + endText;
                }
                return endText.slice(-1 * text.length) === text;
            }
            function isLine(node) {
                if (node.childNodes.length === 0) return false; // Exclude embed blocks
                var style = computeStyle(node);
                return [
                    'block',
                    'list-item'
                ].indexOf(style.display) > -1;
            }
            function traverse(node, elementMatchers, textMatchers) {
                // Post-order
                if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce(function(delta, matcher) {
                    return matcher(node, delta);
                }, new _quillDelta2.default());
                else if (node.nodeType === node.ELEMENT_NODE) return [].reduce.call(node.childNodes || [], function(delta, childNode) {
                    var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
                    if (childNode.nodeType === node.ELEMENT_NODE) {
                        childrenDelta = elementMatchers.reduce(function(childrenDelta, matcher) {
                            return matcher(childNode, childrenDelta);
                        }, childrenDelta);
                        childrenDelta = (childNode[DOM_KEY] || []).reduce(function(childrenDelta, matcher) {
                            return matcher(childNode, childrenDelta);
                        }, childrenDelta);
                    }
                    return delta.concat(childrenDelta);
                }, new _quillDelta2.default());
                else return new _quillDelta2.default();
            }
            function matchAlias(format, node, delta) {
                return applyFormat(delta, format, true);
            }
            function matchAttributor(node, delta) {
                var attributes = _parchment2.default.Attributor.Attribute.keys(node);
                var classes = _parchment2.default.Attributor.Class.keys(node);
                var styles = _parchment2.default.Attributor.Style.keys(node);
                var formats = {};
                attributes.concat(classes).concat(styles).forEach(function(name) {
                    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
                    if (attr != null) {
                        formats[attr.attrName] = attr.value(node);
                        if (formats[attr.attrName]) return;
                    }
                    attr = ATTRIBUTE_ATTRIBUTORS[name];
                    if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
                    attr = STYLE_ATTRIBUTORS[name];
                    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
                        attr = STYLE_ATTRIBUTORS[name];
                        formats[attr.attrName] = attr.value(node) || undefined;
                    }
                });
                if (Object.keys(formats).length > 0) delta = applyFormat(delta, formats);
                return delta;
            }
            function matchBlot(node, delta) {
                var match = _parchment2.default.query(node);
                if (match == null) return delta;
                if (match.prototype instanceof _parchment2.default.Embed) {
                    var embed = {};
                    var value = match.value(node);
                    if (value != null) {
                        embed[match.blotName] = value;
                        delta = new _quillDelta2.default().insert(embed, match.formats(node));
                    }
                } else if (typeof match.formats === 'function') delta = applyFormat(delta, match.blotName, match.formats(node));
                return delta;
            }
            function matchBreak(node, delta) {
                if (!deltaEndsWith(delta, '\n')) delta.insert('\n');
                return delta;
            }
            function matchIgnore() {
                return new _quillDelta2.default();
            }
            function matchIndent(node, delta) {
                var match = _parchment2.default.query(node);
                if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) return delta;
                var indent = -1, parent = node.parentNode;
                while(!parent.classList.contains('ql-clipboard')){
                    if ((_parchment2.default.query(parent) || {}).blotName === 'list') indent += 1;
                    parent = parent.parentNode;
                }
                if (indent <= 0) return delta;
                return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, {
                    indent: indent
                }));
            }
            function matchNewline(node, delta) {
                if (!deltaEndsWith(delta, '\n')) {
                    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) delta.insert('\n');
                }
                return delta;
            }
            function matchSpacing(node, delta) {
                if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
                    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
                    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) delta.insert('\n');
                }
                return delta;
            }
            function matchStyles(node, delta) {
                var formats = {};
                var style = node.style || {};
                if (style.fontStyle && computeStyle(node).fontStyle === 'italic') formats.italic = true;
                if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) formats.bold = true;
                if (Object.keys(formats).length > 0) delta = applyFormat(delta, formats);
                if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
                delta = new _quillDelta2.default().insert('\t').concat(delta);
                return delta;
            }
            function matchText(node, delta) {
                var text = node.data;
                // Word represents empty line with <o:p>&nbsp;</o:p>
                if (node.parentNode.tagName === 'O:P') return delta.insert(text.trim());
                if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) return delta;
                if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
                    // eslint-disable-next-line func-style
                    var replacer = function replacer(collapse, match) {
                        match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
                        return match.length < 1 && collapse ? ' ' : match;
                    };
                    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
                    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
                    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) text = text.replace(/^\s+/, replacer.bind(replacer, false));
                    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) text = text.replace(/\s+$/, replacer.bind(replacer, false));
                }
                return delta.insert(text);
            }
            exports.default = Clipboard;
            exports.matchAttributor = matchAttributor;
            exports.matchBlot = matchBlot;
            exports.matchNewline = matchNewline;
            exports.matchSpacing = matchSpacing;
            exports.matchText = matchText;
        /***/ },
        /* 56 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Bold = function(_Inline) {
                _inherits(Bold, _Inline);
                function Bold() {
                    _classCallCheck(this, Bold);
                    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
                }
                _createClass(Bold, [
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
                            if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create() {
                            return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats() {
                            return true;
                        }
                    }
                ]);
                return Bold;
            }(_inline2.default);
            Bold.blotName = 'bold';
            Bold.tagName = [
                'STRONG',
                'B'
            ];
            exports.default = Bold;
        /***/ },
        /* 57 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.addControls = exports.default = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)('quill:toolbar');
            var Toolbar = function(_Module) {
                _inherits(Toolbar, _Module);
                function Toolbar(quill, options) {
                    _classCallCheck(this, Toolbar);
                    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));
                    if (Array.isArray(_this.options.container)) {
                        var container = document.createElement('div');
                        addControls(container, _this.options.container);
                        quill.container.parentNode.insertBefore(container, quill.container);
                        _this.container = container;
                    } else if (typeof _this.options.container === 'string') _this.container = document.querySelector(_this.options.container);
                    else _this.container = _this.options.container;
                    if (!(_this.container instanceof HTMLElement)) {
                        var _ret;
                        return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
                    }
                    _this.container.classList.add('ql-toolbar');
                    _this.controls = [];
                    _this.handlers = {};
                    Object.keys(_this.options.handlers).forEach(function(format) {
                        _this.addHandler(format, _this.options.handlers[format]);
                    });
                    [].forEach.call(_this.container.querySelectorAll('button, select'), function(input) {
                        _this.attach(input);
                    });
                    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(type, range) {
                        if (type === _quill2.default.events.SELECTION_CHANGE) _this.update(range);
                    });
                    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                        var _this$quill$selection = _this.quill.selection.getRange(), _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1), range = _this$quill$selection2[0]; // quill.getSelection triggers update
                        _this.update(range);
                    });
                    return _this;
                }
                _createClass(Toolbar, [
                    {
                        key: 'addHandler',
                        value: function addHandler(format, handler) {
                            this.handlers[format] = handler;
                        }
                    },
                    {
                        key: 'attach',
                        value: function attach(input) {
                            var _this2 = this;
                            var format = [].find.call(input.classList, function(className) {
                                return className.indexOf('ql-') === 0;
                            });
                            if (!format) return;
                            format = format.slice(3);
                            if (input.tagName === 'BUTTON') input.setAttribute('type', 'button');
                            if (this.handlers[format] == null) {
                                if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
                                    debug.warn('ignoring attaching to disabled format', format, input);
                                    return;
                                }
                                if (_parchment2.default.query(format) == null) {
                                    debug.warn('ignoring attaching to nonexistent format', format, input);
                                    return;
                                }
                            }
                            var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
                            input.addEventListener(eventName, function(e) {
                                var value = void 0;
                                if (input.tagName === 'SELECT') {
                                    if (input.selectedIndex < 0) return;
                                    var selected = input.options[input.selectedIndex];
                                    if (selected.hasAttribute('selected')) value = false;
                                    else value = selected.value || false;
                                } else {
                                    if (input.classList.contains('ql-active')) value = false;
                                    else value = input.value || !input.hasAttribute('value');
                                    e.preventDefault();
                                }
                                _this2.quill.focus();
                                var _quill$selection$getR = _this2.quill.selection.getRange(), _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1), range = _quill$selection$getR2[0];
                                if (_this2.handlers[format] != null) _this2.handlers[format].call(_this2, value);
                                else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
                                    value = prompt('Enter ' + format);
                                    if (!value) return;
                                    _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
                                } else _this2.quill.format(format, value, _quill2.default.sources.USER);
                                _this2.update(range);
                            });
                            // TODO use weakmap
                            this.controls.push([
                                format,
                                input
                            ]);
                        }
                    },
                    {
                        key: 'update',
                        value: function update(range) {
                            var formats = range == null ? {} : this.quill.getFormat(range);
                            this.controls.forEach(function(pair) {
                                var _pair = _slicedToArray(pair, 2), format = _pair[0], input = _pair[1];
                                if (input.tagName === 'SELECT') {
                                    var option = void 0;
                                    if (range == null) option = null;
                                    else if (formats[format] == null) option = input.querySelector('option[selected]');
                                    else if (!Array.isArray(formats[format])) {
                                        var value = formats[format];
                                        if (typeof value === 'string') value = value.replace(/\"/g, '\\"');
                                        option = input.querySelector('option[value="' + value + '"]');
                                    }
                                    if (option == null) {
                                        input.value = ''; // TODO make configurable?
                                        input.selectedIndex = -1;
                                    } else option.selected = true;
                                } else {
                                    if (range == null) input.classList.remove('ql-active');
                                    else if (input.hasAttribute('value')) {
                                        // both being null should match (default values)
                                        // '1' should match with 1 (headers)
                                        var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
                                        input.classList.toggle('ql-active', isActive);
                                    } else input.classList.toggle('ql-active', formats[format] != null);
                                }
                            });
                        }
                    }
                ]);
                return Toolbar;
            }(_module2.default);
            Toolbar.DEFAULTS = {};
            function addButton(container, format, value) {
                var input = document.createElement('button');
                input.setAttribute('type', 'button');
                input.classList.add('ql-' + format);
                if (value != null) input.value = value;
                container.appendChild(input);
            }
            function addControls(container, groups) {
                if (!Array.isArray(groups[0])) groups = [
                    groups
                ];
                groups.forEach(function(controls) {
                    var group = document.createElement('span');
                    group.classList.add('ql-formats');
                    controls.forEach(function(control) {
                        if (typeof control === 'string') addButton(group, control);
                        else {
                            var format = Object.keys(control)[0];
                            var value = control[format];
                            if (Array.isArray(value)) addSelect(group, format, value);
                            else addButton(group, format, value);
                        }
                    });
                    container.appendChild(group);
                });
            }
            function addSelect(container, format, values) {
                var input = document.createElement('select');
                input.classList.add('ql-' + format);
                values.forEach(function(value) {
                    var option = document.createElement('option');
                    if (value !== false) option.setAttribute('value', value);
                    else option.setAttribute('selected', 'selected');
                    input.appendChild(option);
                });
                container.appendChild(input);
            }
            Toolbar.DEFAULTS = {
                container: null,
                handlers: {
                    clean: function clean() {
                        var _this3 = this;
                        var range = this.quill.getSelection();
                        if (range == null) return;
                        if (range.length == 0) {
                            var formats = this.quill.getFormat();
                            Object.keys(formats).forEach(function(name) {
                                // Clean functionality in existing apps only clean inline formats
                                if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) _this3.quill.format(name, false);
                            });
                        } else this.quill.removeFormat(range, _quill2.default.sources.USER);
                    },
                    direction: function direction(value) {
                        var align = this.quill.getFormat()['align'];
                        if (value === 'rtl' && align == null) this.quill.format('align', 'right', _quill2.default.sources.USER);
                        else if (!value && align === 'right') this.quill.format('align', false, _quill2.default.sources.USER);
                        this.quill.format('direction', value, _quill2.default.sources.USER);
                    },
                    indent: function indent(value) {
                        var range = this.quill.getSelection();
                        var formats = this.quill.getFormat(range);
                        var indent = parseInt(formats.indent || 0);
                        if (value === '+1' || value === '-1') {
                            var modifier = value === '+1' ? 1 : -1;
                            if (formats.direction === 'rtl') modifier *= -1;
                            this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
                        }
                    },
                    link: function link(value) {
                        if (value === true) value = prompt('Enter link URL:');
                        this.quill.format('link', value, _quill2.default.sources.USER);
                    },
                    list: function list(value) {
                        var range = this.quill.getSelection();
                        var formats = this.quill.getFormat(range);
                        if (value === 'check') {
                            if (formats['list'] === 'checked' || formats['list'] === 'unchecked') this.quill.format('list', false, _quill2.default.sources.USER);
                            else this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
                        } else this.quill.format('list', value, _quill2.default.sources.USER);
                    }
                }
            };
            exports.default = Toolbar;
            exports.addControls = addControls;
        /***/ },
        /* 58 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";
        /***/ },
        /* 59 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ColorPicker = function(_Picker) {
                _inherits(ColorPicker, _Picker);
                function ColorPicker(select, label) {
                    _classCallCheck(this, ColorPicker);
                    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));
                    _this.label.innerHTML = label;
                    _this.container.classList.add('ql-color-picker');
                    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function(item) {
                        item.classList.add('ql-primary');
                    });
                    return _this;
                }
                _createClass(ColorPicker, [
                    {
                        key: 'buildItem',
                        value: function buildItem(option) {
                            var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
                            item.style.backgroundColor = option.getAttribute('value') || '';
                            return item;
                        }
                    },
                    {
                        key: 'selectItem',
                        value: function selectItem(item, trigger) {
                            _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
                            var colorLabel = this.label.querySelector('.ql-color-label');
                            var value = item ? item.getAttribute('data-value') || '' : '';
                            if (colorLabel) {
                                if (colorLabel.tagName === 'line') colorLabel.style.stroke = value;
                                else colorLabel.style.fill = value;
                            }
                        }
                    }
                ]);
                return ColorPicker;
            }(_picker2.default);
            exports.default = ColorPicker;
        /***/ },
        /* 60 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var IconPicker = function(_Picker) {
                _inherits(IconPicker, _Picker);
                function IconPicker(select, icons) {
                    _classCallCheck(this, IconPicker);
                    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));
                    _this.container.classList.add('ql-icon-picker');
                    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function(item) {
                        item.innerHTML = icons[item.getAttribute('data-value') || ''];
                    });
                    _this.defaultItem = _this.container.querySelector('.ql-selected');
                    _this.selectItem(_this.defaultItem);
                    return _this;
                }
                _createClass(IconPicker, [
                    {
                        key: 'selectItem',
                        value: function selectItem(item, trigger) {
                            _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
                            item = item || this.defaultItem;
                            this.label.innerHTML = item.innerHTML;
                        }
                    }
                ]);
                return IconPicker;
            }(_picker2.default);
            exports.default = IconPicker;
        /***/ },
        /* 61 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Tooltip = function() {
                function Tooltip(quill, boundsContainer) {
                    var _this = this;
                    _classCallCheck(this, Tooltip);
                    this.quill = quill;
                    this.boundsContainer = boundsContainer || document.body;
                    this.root = quill.addContainer('ql-tooltip');
                    this.root.innerHTML = this.constructor.TEMPLATE;
                    if (this.quill.root === this.quill.scrollingContainer) this.quill.root.addEventListener('scroll', function() {
                        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
                    });
                    this.hide();
                }
                _createClass(Tooltip, [
                    {
                        key: 'hide',
                        value: function hide() {
                            this.root.classList.add('ql-hidden');
                        }
                    },
                    {
                        key: 'position',
                        value: function position(reference) {
                            var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
                            // root.scrollTop should be 0 if scrollContainer !== root
                            var top = reference.bottom + this.quill.root.scrollTop;
                            this.root.style.left = left + 'px';
                            this.root.style.top = top + 'px';
                            this.root.classList.remove('ql-flip');
                            var containerBounds = this.boundsContainer.getBoundingClientRect();
                            var rootBounds = this.root.getBoundingClientRect();
                            var shift = 0;
                            if (rootBounds.right > containerBounds.right) {
                                shift = containerBounds.right - rootBounds.right;
                                this.root.style.left = left + shift + 'px';
                            }
                            if (rootBounds.left < containerBounds.left) {
                                shift = containerBounds.left - rootBounds.left;
                                this.root.style.left = left + shift + 'px';
                            }
                            if (rootBounds.bottom > containerBounds.bottom) {
                                var height = rootBounds.bottom - rootBounds.top;
                                var verticalShift = reference.bottom - reference.top + height;
                                this.root.style.top = top - verticalShift + 'px';
                                this.root.classList.add('ql-flip');
                            }
                            return shift;
                        }
                    },
                    {
                        key: 'show',
                        value: function show() {
                            this.root.classList.remove('ql-editing');
                            this.root.classList.remove('ql-hidden');
                        }
                    }
                ]);
                return Tooltip;
            }();
            exports.default = Tooltip;
        /***/ },
        /* 62 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _base = __webpack_require__(43);
            var _base2 = _interopRequireDefault(_base);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            var _selection = __webpack_require__(15);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TOOLBAR_CONFIG = [
                [
                    {
                        header: [
                            '1',
                            '2',
                            '3',
                            false
                        ]
                    }
                ],
                [
                    'bold',
                    'italic',
                    'underline',
                    'link'
                ],
                [
                    {
                        list: 'ordered'
                    },
                    {
                        list: 'bullet'
                    }
                ],
                [
                    'clean'
                ]
            ];
            var SnowTheme = function(_BaseTheme) {
                _inherits(SnowTheme, _BaseTheme);
                function SnowTheme(quill, options) {
                    _classCallCheck(this, SnowTheme);
                    if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = TOOLBAR_CONFIG;
                    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));
                    _this.quill.container.classList.add('ql-snow');
                    return _this;
                }
                _createClass(SnowTheme, [
                    {
                        key: 'extendToolbar',
                        value: function extendToolbar(toolbar) {
                            toolbar.container.classList.add('ql-snow');
                            this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
                            this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
                            this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
                            if (toolbar.container.querySelector('.ql-link')) this.quill.keyboard.addBinding({
                                key: 'K',
                                shortKey: true
                            }, function(range, context) {
                                toolbar.handlers['link'].call(toolbar, !context.format.link);
                            });
                        }
                    }
                ]);
                return SnowTheme;
            }(_base2.default);
            SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            link: function link(value) {
                                if (value) {
                                    var range = this.quill.getSelection();
                                    if (range == null || range.length == 0) return;
                                    var preview = this.quill.getText(range);
                                    if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) preview = 'mailto:' + preview;
                                    var tooltip = this.quill.theme.tooltip;
                                    tooltip.edit('link', preview);
                                } else this.quill.format('link', false);
                            }
                        }
                    }
                }
            });
            var SnowTooltip = function(_BaseTooltip) {
                _inherits(SnowTooltip, _BaseTooltip);
                function SnowTooltip(quill, bounds) {
                    _classCallCheck(this, SnowTooltip);
                    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));
                    _this2.preview = _this2.root.querySelector('a.ql-preview');
                    return _this2;
                }
                _createClass(SnowTooltip, [
                    {
                        key: 'listen',
                        value: function listen() {
                            var _this3 = this;
                            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
                            this.root.querySelector('a.ql-action').addEventListener('click', function(event) {
                                if (_this3.root.classList.contains('ql-editing')) _this3.save();
                                else _this3.edit('link', _this3.preview.textContent);
                                event.preventDefault();
                            });
                            this.root.querySelector('a.ql-remove').addEventListener('click', function(event) {
                                if (_this3.linkRange != null) {
                                    var range = _this3.linkRange;
                                    _this3.restoreFocus();
                                    _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
                                    delete _this3.linkRange;
                                }
                                event.preventDefault();
                                _this3.hide();
                            });
                            this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function(range, oldRange, source) {
                                if (range == null) return;
                                if (range.length === 0 && source === _emitter2.default.sources.USER) {
                                    var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), link = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                                    if (link != null) {
                                        _this3.linkRange = new _selection.Range(range.index - offset, link.length());
                                        var preview = _link2.default.formats(link.domNode);
                                        _this3.preview.textContent = preview;
                                        _this3.preview.setAttribute('href', preview);
                                        _this3.show();
                                        _this3.position(_this3.quill.getBounds(_this3.linkRange));
                                        return;
                                    }
                                } else delete _this3.linkRange;
                                _this3.hide();
                            });
                        }
                    },
                    {
                        key: 'show',
                        value: function show() {
                            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
                            this.root.removeAttribute('data-mode');
                        }
                    }
                ]);
                return SnowTooltip;
            }(_base.BaseTooltip);
            SnowTooltip.TEMPLATE = [
                '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
                '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
                '<a class="ql-action"></a>',
                '<a class="ql-remove"></a>'
            ].join('');
            exports.default = SnowTheme;
        /***/ },
        /* 63 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _core = __webpack_require__(29);
            var _core2 = _interopRequireDefault(_core);
            var _align = __webpack_require__(36);
            var _direction = __webpack_require__(38);
            var _indent = __webpack_require__(64);
            var _blockquote = __webpack_require__(65);
            var _blockquote2 = _interopRequireDefault(_blockquote);
            var _header = __webpack_require__(66);
            var _header2 = _interopRequireDefault(_header);
            var _list = __webpack_require__(67);
            var _list2 = _interopRequireDefault(_list);
            var _background = __webpack_require__(37);
            var _color = __webpack_require__(26);
            var _font = __webpack_require__(39);
            var _size = __webpack_require__(40);
            var _bold = __webpack_require__(56);
            var _bold2 = _interopRequireDefault(_bold);
            var _italic = __webpack_require__(68);
            var _italic2 = _interopRequireDefault(_italic);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            var _script = __webpack_require__(69);
            var _script2 = _interopRequireDefault(_script);
            var _strike = __webpack_require__(70);
            var _strike2 = _interopRequireDefault(_strike);
            var _underline = __webpack_require__(71);
            var _underline2 = _interopRequireDefault(_underline);
            var _image = __webpack_require__(72);
            var _image2 = _interopRequireDefault(_image);
            var _video = __webpack_require__(73);
            var _video2 = _interopRequireDefault(_video);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _formula = __webpack_require__(74);
            var _formula2 = _interopRequireDefault(_formula);
            var _syntax = __webpack_require__(75);
            var _syntax2 = _interopRequireDefault(_syntax);
            var _toolbar = __webpack_require__(57);
            var _toolbar2 = _interopRequireDefault(_toolbar);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            var _colorPicker = __webpack_require__(59);
            var _colorPicker2 = _interopRequireDefault(_colorPicker);
            var _iconPicker = __webpack_require__(60);
            var _iconPicker2 = _interopRequireDefault(_iconPicker);
            var _tooltip = __webpack_require__(61);
            var _tooltip2 = _interopRequireDefault(_tooltip);
            var _bubble = __webpack_require__(108);
            var _bubble2 = _interopRequireDefault(_bubble);
            var _snow = __webpack_require__(62);
            var _snow2 = _interopRequireDefault(_snow);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            _core2.default.register({
                'attributors/attribute/direction': _direction.DirectionAttribute,
                'attributors/class/align': _align.AlignClass,
                'attributors/class/background': _background.BackgroundClass,
                'attributors/class/color': _color.ColorClass,
                'attributors/class/direction': _direction.DirectionClass,
                'attributors/class/font': _font.FontClass,
                'attributors/class/size': _size.SizeClass,
                'attributors/style/align': _align.AlignStyle,
                'attributors/style/background': _background.BackgroundStyle,
                'attributors/style/color': _color.ColorStyle,
                'attributors/style/direction': _direction.DirectionStyle,
                'attributors/style/font': _font.FontStyle,
                'attributors/style/size': _size.SizeStyle
            }, true);
            _core2.default.register({
                'formats/align': _align.AlignClass,
                'formats/direction': _direction.DirectionClass,
                'formats/indent': _indent.IndentClass,
                'formats/background': _background.BackgroundStyle,
                'formats/color': _color.ColorStyle,
                'formats/font': _font.FontClass,
                'formats/size': _size.SizeClass,
                'formats/blockquote': _blockquote2.default,
                'formats/code-block': _code2.default,
                'formats/header': _header2.default,
                'formats/list': _list2.default,
                'formats/bold': _bold2.default,
                'formats/code': _code.Code,
                'formats/italic': _italic2.default,
                'formats/link': _link2.default,
                'formats/script': _script2.default,
                'formats/strike': _strike2.default,
                'formats/underline': _underline2.default,
                'formats/image': _image2.default,
                'formats/video': _video2.default,
                'formats/list/item': _list.ListItem,
                'modules/formula': _formula2.default,
                'modules/syntax': _syntax2.default,
                'modules/toolbar': _toolbar2.default,
                'themes/bubble': _bubble2.default,
                'themes/snow': _snow2.default,
                'ui/icons': _icons2.default,
                'ui/picker': _picker2.default,
                'ui/icon-picker': _iconPicker2.default,
                'ui/color-picker': _colorPicker2.default,
                'ui/tooltip': _tooltip2.default
            }, true);
            exports.default = _core2.default;
        /***/ },
        /* 64 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.IndentClass = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var IdentAttributor = function(_Parchment$Attributor) {
                _inherits(IdentAttributor, _Parchment$Attributor);
                function IdentAttributor() {
                    _classCallCheck(this, IdentAttributor);
                    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
                }
                _createClass(IdentAttributor, [
                    {
                        key: 'add',
                        value: function add(node, value) {
                            if (value === '+1' || value === '-1') {
                                var indent = this.value(node) || 0;
                                value = value === '+1' ? indent + 1 : indent - 1;
                            }
                            if (value === 0) {
                                this.remove(node);
                                return true;
                            } else return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
                        }
                    },
                    {
                        key: 'canAdd',
                        value: function canAdd(node, value) {
                            return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
                        }
                    },
                    {
                        key: 'value',
                        value: function value(node) {
                            return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
                        }
                    }
                ]);
                return IdentAttributor;
            }(_parchment2.default.Attributor.Class);
            var IndentClass = new IdentAttributor('indent', 'ql-indent', {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8
                ]
            });
            exports.IndentClass = IndentClass;
        /***/ },
        /* 65 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Blockquote = function(_Block) {
                _inherits(Blockquote, _Block);
                function Blockquote() {
                    _classCallCheck(this, Blockquote);
                    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
                }
                return Blockquote;
            }(_block2.default);
            Blockquote.blotName = 'blockquote';
            Blockquote.tagName = 'blockquote';
            exports.default = Blockquote;
        /***/ },
        /* 66 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Header = function(_Block) {
                _inherits(Header, _Block);
                function Header() {
                    _classCallCheck(this, Header);
                    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
                }
                _createClass(Header, null, [
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return this.tagName.indexOf(domNode.tagName) + 1;
                        }
                    }
                ]);
                return Header;
            }(_block2.default);
            Header.blotName = 'header';
            Header.tagName = [
                'H1',
                'H2',
                'H3',
                'H4',
                'H5',
                'H6'
            ];
            exports.default = Header;
        /***/ },
        /* 67 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.ListItem = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ListItem = function(_Block) {
                _inherits(ListItem, _Block);
                function ListItem() {
                    _classCallCheck(this, ListItem);
                    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
                }
                _createClass(ListItem, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (name === List.blotName && !value) this.replaceWith(_parchment2.default.create(this.statics.scope));
                            else _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
                        }
                    },
                    {
                        key: 'remove',
                        value: function remove() {
                            if (this.prev == null && this.next == null) this.parent.remove();
                            else _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
                        }
                    },
                    {
                        key: 'replaceWith',
                        value: function replaceWith(name, value) {
                            this.parent.isolate(this.offset(this.parent), this.length());
                            if (name === this.parent.statics.blotName) {
                                this.parent.replaceWith(name, value);
                                return this;
                            } else {
                                this.parent.unwrap();
                                return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
                            }
                        }
                    }
                ], [
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
                        }
                    }
                ]);
                return ListItem;
            }(_block2.default);
            ListItem.blotName = 'list-item';
            ListItem.tagName = 'LI';
            var List = function(_Container) {
                _inherits(List, _Container);
                _createClass(List, null, [
                    {
                        key: 'create',
                        value: function create(value) {
                            var tagName = value === 'ordered' ? 'OL' : 'UL';
                            var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
                            if (value === 'checked' || value === 'unchecked') node.setAttribute('data-checked', value === 'checked');
                            return node;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            if (domNode.tagName === 'OL') return 'ordered';
                            if (domNode.tagName === 'UL') {
                                if (domNode.hasAttribute('data-checked')) return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
                                else return 'bullet';
                            }
                            return undefined;
                        }
                    }
                ]);
                function List(domNode) {
                    _classCallCheck(this, List);
                    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));
                    var listEventHandler = function listEventHandler(e) {
                        if (e.target.parentNode !== domNode) return;
                        var format = _this2.statics.formats(domNode);
                        var blot = _parchment2.default.find(e.target);
                        if (format === 'checked') blot.format('list', 'unchecked');
                        else if (format === 'unchecked') blot.format('list', 'checked');
                    };
                    domNode.addEventListener('touchstart', listEventHandler);
                    domNode.addEventListener('mousedown', listEventHandler);
                    return _this2;
                }
                _createClass(List, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (this.children.length > 0) this.children.tail.format(name, value);
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats() {
                            // We don't inherit from FormatBlot
                            return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
                        }
                    },
                    {
                        key: 'insertBefore',
                        value: function insertBefore(blot, ref) {
                            if (blot instanceof ListItem) _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
                            else {
                                var index = ref == null ? this.length() : ref.offset(this);
                                var after = this.split(index);
                                after.parent.insertBefore(blot, after);
                            }
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
                            var next = this.next;
                            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
                                next.moveChildren(this);
                                next.remove();
                            }
                        }
                    },
                    {
                        key: 'replace',
                        value: function replace(target) {
                            if (target.statics.blotName !== this.statics.blotName) {
                                var item = _parchment2.default.create(this.statics.defaultChild);
                                target.moveChildren(item);
                                this.appendChild(item);
                            }
                            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
                        }
                    }
                ]);
                return List;
            }(_container2.default);
            List.blotName = 'list';
            List.scope = _parchment2.default.Scope.BLOCK_BLOT;
            List.tagName = [
                'OL',
                'UL'
            ];
            List.defaultChild = 'list-item';
            List.allowedChildren = [
                ListItem
            ];
            exports.ListItem = ListItem;
            exports.default = List;
        /***/ },
        /* 68 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _bold = __webpack_require__(56);
            var _bold2 = _interopRequireDefault(_bold);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Italic = function(_Bold) {
                _inherits(Italic, _Bold);
                function Italic() {
                    _classCallCheck(this, Italic);
                    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
                }
                return Italic;
            }(_bold2.default);
            Italic.blotName = 'italic';
            Italic.tagName = [
                'EM',
                'I'
            ];
            exports.default = Italic;
        /***/ },
        /* 69 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Script = function(_Inline) {
                _inherits(Script, _Inline);
                function Script() {
                    _classCallCheck(this, Script);
                    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
                }
                _createClass(Script, null, [
                    {
                        key: 'create',
                        value: function create(value) {
                            if (value === 'super') return document.createElement('sup');
                            else if (value === 'sub') return document.createElement('sub');
                            else return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            if (domNode.tagName === 'SUB') return 'sub';
                            if (domNode.tagName === 'SUP') return 'super';
                            return undefined;
                        }
                    }
                ]);
                return Script;
            }(_inline2.default);
            Script.blotName = 'script';
            Script.tagName = [
                'SUB',
                'SUP'
            ];
            exports.default = Script;
        /***/ },
        /* 70 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Strike = function(_Inline) {
                _inherits(Strike, _Inline);
                function Strike() {
                    _classCallCheck(this, Strike);
                    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
                }
                return Strike;
            }(_inline2.default);
            Strike.blotName = 'strike';
            Strike.tagName = 'S';
            exports.default = Strike;
        /***/ },
        /* 71 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Underline = function(_Inline) {
                _inherits(Underline, _Inline);
                function Underline() {
                    _classCallCheck(this, Underline);
                    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
                }
                return Underline;
            }(_inline2.default);
            Underline.blotName = 'underline';
            Underline.tagName = 'U';
            exports.default = Underline;
        /***/ },
        /* 72 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _link = __webpack_require__(27);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ATTRIBUTES = [
                'alt',
                'height',
                'width'
            ];
            var Image = function(_Parchment$Embed) {
                _inherits(Image, _Parchment$Embed);
                function Image() {
                    _classCallCheck(this, Image);
                    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
                }
                _createClass(Image, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (ATTRIBUTES.indexOf(name) > -1) {
                                if (value) this.domNode.setAttribute(name, value);
                                else this.domNode.removeAttribute(name);
                            } else _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create(value) {
                            var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
                            if (typeof value === 'string') node.setAttribute('src', this.sanitize(value));
                            return node;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return ATTRIBUTES.reduce(function(formats, attribute) {
                                if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
                                return formats;
                            }, {});
                        }
                    },
                    {
                        key: 'match',
                        value: function match(url) {
                            return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
                        }
                    },
                    {
                        key: 'sanitize',
                        value: function sanitize(url) {
                            return (0, _link.sanitize)(url, [
                                'http',
                                'https',
                                'data'
                            ]) ? url : '//:0';
                        }
                    },
                    {
                        key: 'value',
                        value: function value(domNode) {
                            return domNode.getAttribute('src');
                        }
                    }
                ]);
                return Image;
            }(_parchment2.default.Embed);
            Image.blotName = 'image';
            Image.tagName = 'IMG';
            exports.default = Image;
        /***/ },
        /* 73 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _block = __webpack_require__(4);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ATTRIBUTES = [
                'height',
                'width'
            ];
            var Video = function(_BlockEmbed) {
                _inherits(Video, _BlockEmbed);
                function Video() {
                    _classCallCheck(this, Video);
                    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
                }
                _createClass(Video, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (ATTRIBUTES.indexOf(name) > -1) {
                                if (value) this.domNode.setAttribute(name, value);
                                else this.domNode.removeAttribute(name);
                            } else _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create(value) {
                            var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
                            node.setAttribute('frameborder', '0');
                            node.setAttribute('allowfullscreen', true);
                            node.setAttribute('src', this.sanitize(value));
                            return node;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return ATTRIBUTES.reduce(function(formats, attribute) {
                                if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
                                return formats;
                            }, {});
                        }
                    },
                    {
                        key: 'sanitize',
                        value: function sanitize(url) {
                            return _link2.default.sanitize(url);
                        }
                    },
                    {
                        key: 'value',
                        value: function value(domNode) {
                            return domNode.getAttribute('src');
                        }
                    }
                ]);
                return Video;
            }(_block.BlockEmbed);
            Video.blotName = 'video';
            Video.className = 'ql-video';
            Video.tagName = 'IFRAME';
            exports.default = Video;
        /***/ },
        /* 74 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.FormulaBlot = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _embed = __webpack_require__(35);
            var _embed2 = _interopRequireDefault(_embed);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var FormulaBlot = function(_Embed) {
                _inherits(FormulaBlot, _Embed);
                function FormulaBlot() {
                    _classCallCheck(this, FormulaBlot);
                    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
                }
                _createClass(FormulaBlot, null, [
                    {
                        key: 'create',
                        value: function create(value) {
                            var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
                            if (typeof value === 'string') {
                                window.katex.render(value, node, {
                                    throwOnError: false,
                                    errorColor: '#f00'
                                });
                                node.setAttribute('data-value', value);
                            }
                            return node;
                        }
                    },
                    {
                        key: 'value',
                        value: function value(domNode) {
                            return domNode.getAttribute('data-value');
                        }
                    }
                ]);
                return FormulaBlot;
            }(_embed2.default);
            FormulaBlot.blotName = 'formula';
            FormulaBlot.className = 'ql-formula';
            FormulaBlot.tagName = 'SPAN';
            var Formula = function(_Module) {
                _inherits(Formula, _Module);
                _createClass(Formula, null, [
                    {
                        key: 'register',
                        value: function register() {
                            _quill2.default.register(FormulaBlot, true);
                        }
                    }
                ]);
                function Formula() {
                    _classCallCheck(this, Formula);
                    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));
                    if (window.katex == null) throw new Error('Formula module requires KaTeX.');
                    return _this2;
                }
                return Formula;
            }(_module2.default);
            exports.FormulaBlot = FormulaBlot;
            exports.default = Formula;
        /***/ },
        /* 75 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.CodeToken = exports.CodeBlock = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var SyntaxCodeBlock = function(_CodeBlock) {
                _inherits(SyntaxCodeBlock, _CodeBlock);
                function SyntaxCodeBlock() {
                    _classCallCheck(this, SyntaxCodeBlock);
                    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
                }
                _createClass(SyntaxCodeBlock, [
                    {
                        key: 'replaceWith',
                        value: function replaceWith(block) {
                            this.domNode.textContent = this.domNode.textContent;
                            this.attach();
                            _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
                        }
                    },
                    {
                        key: 'highlight',
                        value: function highlight(_highlight) {
                            var text = this.domNode.textContent;
                            if (this.cachedText !== text) {
                                if (text.trim().length > 0 || this.cachedText == null) {
                                    this.domNode.innerHTML = _highlight(text);
                                    this.domNode.normalize();
                                    this.attach();
                                }
                                this.cachedText = text;
                            }
                        }
                    }
                ]);
                return SyntaxCodeBlock;
            }(_code2.default);
            SyntaxCodeBlock.className = 'ql-syntax';
            var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
                scope: _parchment2.default.Scope.INLINE
            });
            var Syntax = function(_Module) {
                _inherits(Syntax, _Module);
                _createClass(Syntax, null, [
                    {
                        key: 'register',
                        value: function register() {
                            _quill2.default.register(CodeToken, true);
                            _quill2.default.register(SyntaxCodeBlock, true);
                        }
                    }
                ]);
                function Syntax(quill, options) {
                    _classCallCheck(this, Syntax);
                    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));
                    if (typeof _this2.options.highlight !== 'function') throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
                    var timer = null;
                    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                        clearTimeout(timer);
                        timer = setTimeout(function() {
                            _this2.highlight();
                            timer = null;
                        }, _this2.options.interval);
                    });
                    _this2.highlight();
                    return _this2;
                }
                _createClass(Syntax, [
                    {
                        key: 'highlight',
                        value: function highlight() {
                            var _this3 = this;
                            if (this.quill.selection.composing) return;
                            this.quill.update(_quill2.default.sources.USER);
                            var range = this.quill.getSelection();
                            this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function(code) {
                                code.highlight(_this3.options.highlight);
                            });
                            this.quill.update(_quill2.default.sources.SILENT);
                            if (range != null) this.quill.setSelection(range, _quill2.default.sources.SILENT);
                        }
                    }
                ]);
                return Syntax;
            }(_module2.default);
            Syntax.DEFAULTS = {
                highlight: function() {
                    if (window.hljs == null) return null;
                    return function(text) {
                        var result = window.hljs.highlightAuto(text);
                        return result.value;
                    };
                }(),
                interval: 1000
            };
            exports.CodeBlock = SyntaxCodeBlock;
            exports.CodeToken = CodeToken;
            exports.default = Syntax;
        /***/ },
        /* 76 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";
        /***/ },
        /* 77 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";
        /***/ },
        /* 78 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";
        /***/ },
        /* 79 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";
        /***/ },
        /* 80 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";
        /***/ },
        /* 81 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";
        /***/ },
        /* 82 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";
        /***/ },
        /* 83 */ /***/ function(module1, exports) {
            module1.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";
        /***/ },
        /* 84 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";
        /***/ },
        /* 85 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";
        /***/ },
        /* 86 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";
        /***/ },
        /* 87 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";
        /***/ },
        /* 88 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";
        /***/ },
        /* 89 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";
        /***/ },
        /* 90 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";
        /***/ },
        /* 91 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";
        /***/ },
        /* 92 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";
        /***/ },
        /* 93 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";
        /***/ },
        /* 94 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";
        /***/ },
        /* 95 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";
        /***/ },
        /* 96 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";
        /***/ },
        /* 97 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";
        /***/ },
        /* 98 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";
        /***/ },
        /* 99 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";
        /***/ },
        /* 100 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";
        /***/ },
        /* 101 */ /***/ function(module1, exports) {
            module1.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";
        /***/ },
        /* 102 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";
        /***/ },
        /* 103 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";
        /***/ },
        /* 104 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";
        /***/ },
        /* 105 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";
        /***/ },
        /* 106 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";
        /***/ },
        /* 107 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";
        /***/ },
        /* 108 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BubbleTooltip = undefined;
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _base = __webpack_require__(43);
            var _base2 = _interopRequireDefault(_base);
            var _selection = __webpack_require__(15);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TOOLBAR_CONFIG = [
                [
                    'bold',
                    'italic',
                    'link'
                ],
                [
                    {
                        header: 1
                    },
                    {
                        header: 2
                    },
                    'blockquote'
                ]
            ];
            var BubbleTheme = function(_BaseTheme) {
                _inherits(BubbleTheme, _BaseTheme);
                function BubbleTheme(quill, options) {
                    _classCallCheck(this, BubbleTheme);
                    if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = TOOLBAR_CONFIG;
                    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));
                    _this.quill.container.classList.add('ql-bubble');
                    return _this;
                }
                _createClass(BubbleTheme, [
                    {
                        key: 'extendToolbar',
                        value: function extendToolbar(toolbar) {
                            this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
                            this.tooltip.root.appendChild(toolbar.container);
                            this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
                            this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
                        }
                    }
                ]);
                return BubbleTheme;
            }(_base2.default);
            BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            link: function link(value) {
                                if (!value) this.quill.format('link', false);
                                else this.quill.theme.tooltip.edit();
                            }
                        }
                    }
                }
            });
            var BubbleTooltip = function(_BaseTooltip) {
                _inherits(BubbleTooltip, _BaseTooltip);
                function BubbleTooltip(quill, bounds) {
                    _classCallCheck(this, BubbleTooltip);
                    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));
                    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function(type, range, oldRange, source) {
                        if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
                        if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
                            _this2.show();
                            // Lock our width so we will expand beyond our offsetParent boundaries
                            _this2.root.style.left = '0px';
                            _this2.root.style.width = '';
                            _this2.root.style.width = _this2.root.offsetWidth + 'px';
                            var lines = _this2.quill.getLines(range.index, range.length);
                            if (lines.length === 1) _this2.position(_this2.quill.getBounds(range));
                            else {
                                var lastLine = lines[lines.length - 1];
                                var index = _this2.quill.getIndex(lastLine);
                                var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                                var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
                                _this2.position(_bounds);
                            }
                        } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) _this2.hide();
                    });
                    return _this2;
                }
                _createClass(BubbleTooltip, [
                    {
                        key: 'listen',
                        value: function listen() {
                            var _this3 = this;
                            _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
                            this.root.querySelector('.ql-close').addEventListener('click', function() {
                                _this3.root.classList.remove('ql-editing');
                            });
                            this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function() {
                                // Let selection be restored by toolbar handlers before repositioning
                                setTimeout(function() {
                                    if (_this3.root.classList.contains('ql-hidden')) return;
                                    var range = _this3.quill.getSelection();
                                    if (range != null) _this3.position(_this3.quill.getBounds(range));
                                }, 1);
                            });
                        }
                    },
                    {
                        key: 'cancel',
                        value: function cancel() {
                            this.show();
                        }
                    },
                    {
                        key: 'position',
                        value: function position(reference) {
                            var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
                            var arrow = this.root.querySelector('.ql-tooltip-arrow');
                            arrow.style.marginLeft = '';
                            if (shift === 0) return shift;
                            arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
                        }
                    }
                ]);
                return BubbleTooltip;
            }(_base.BaseTooltip);
            BubbleTooltip.TEMPLATE = [
                '<span class="ql-tooltip-arrow"></span>',
                '<div class="ql-tooltip-editor">',
                '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
                '<a class="ql-close"></a>',
                '</div>'
            ].join('');
            exports.BubbleTooltip = BubbleTooltip;
            exports.default = BubbleTheme;
        /***/ },
        /* 109 */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = __webpack_require__(63);
        /***/ }
    ])["default"];
});

});
parcelRegister("8C4PT", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $64559fa3faab4b06$export$a143d493d941bafc, (v) => $64559fa3faab4b06$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $64559fa3faab4b06$export$f99ded8fe4b79145, (v) => $64559fa3faab4b06$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $64559fa3faab4b06$export$a143d493d941bafc;
var $64559fa3faab4b06$export$e4cf37d7f6fb9e0a;
var $64559fa3faab4b06$export$f99ded8fe4b79145;
var $64559fa3faab4b06$export$599f31c3813fae4d;
'use strict';

var $aBiUS = parcelRequire("aBiUS");

var $ktjyo = parcelRequire("ktjyo");
const $64559fa3faab4b06$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$64559fa3faab4b06$export$a143d493d941bafc = $64559fa3faab4b06$var$Buffer;
$64559fa3faab4b06$export$e4cf37d7f6fb9e0a = $64559fa3faab4b06$var$SlowBuffer;
$64559fa3faab4b06$export$f99ded8fe4b79145 = 50;
const $64559fa3faab4b06$var$K_MAX_LENGTH = 0x7fffffff;
$64559fa3faab4b06$export$599f31c3813fae4d = $64559fa3faab4b06$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $64559fa3faab4b06$var$Buffer.TYPED_ARRAY_SUPPORT = $64559fa3faab4b06$var$typedArraySupport();
if (!$64559fa3faab4b06$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $64559fa3faab4b06$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($64559fa3faab4b06$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$64559fa3faab4b06$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($64559fa3faab4b06$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$64559fa3faab4b06$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $64559fa3faab4b06$var$createBuffer(length) {
    if (length > $64559fa3faab4b06$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $64559fa3faab4b06$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $64559fa3faab4b06$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $64559fa3faab4b06$var$allocUnsafe(arg);
    }
    return $64559fa3faab4b06$var$from(arg, encodingOrOffset, length);
}
$64559fa3faab4b06$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $64559fa3faab4b06$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $64559fa3faab4b06$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $64559fa3faab4b06$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($64559fa3faab4b06$var$isInstance(value, ArrayBuffer) || value && $64559fa3faab4b06$var$isInstance(value.buffer, ArrayBuffer)) return $64559fa3faab4b06$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($64559fa3faab4b06$var$isInstance(value, SharedArrayBuffer) || value && $64559fa3faab4b06$var$isInstance(value.buffer, SharedArrayBuffer))) return $64559fa3faab4b06$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $64559fa3faab4b06$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $64559fa3faab4b06$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $64559fa3faab4b06$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $64559fa3faab4b06$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $64559fa3faab4b06$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($64559fa3faab4b06$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($64559fa3faab4b06$var$Buffer, Uint8Array);
function $64559fa3faab4b06$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $64559fa3faab4b06$var$alloc(size, fill, encoding) {
    $64559fa3faab4b06$var$assertSize(size);
    if (size <= 0) return $64559fa3faab4b06$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $64559fa3faab4b06$var$createBuffer(size).fill(fill, encoding) : $64559fa3faab4b06$var$createBuffer(size).fill(fill);
    return $64559fa3faab4b06$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $64559fa3faab4b06$var$Buffer.alloc = function(size, fill, encoding) {
    return $64559fa3faab4b06$var$alloc(size, fill, encoding);
};
function $64559fa3faab4b06$var$allocUnsafe(size) {
    $64559fa3faab4b06$var$assertSize(size);
    return $64559fa3faab4b06$var$createBuffer(size < 0 ? 0 : $64559fa3faab4b06$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $64559fa3faab4b06$var$Buffer.allocUnsafe = function(size) {
    return $64559fa3faab4b06$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $64559fa3faab4b06$var$Buffer.allocUnsafeSlow = function(size) {
    return $64559fa3faab4b06$var$allocUnsafe(size);
};
function $64559fa3faab4b06$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$64559fa3faab4b06$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $64559fa3faab4b06$var$byteLength(string, encoding) | 0;
    let buf = $64559fa3faab4b06$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $64559fa3faab4b06$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $64559fa3faab4b06$var$checked(array.length) | 0;
    const buf = $64559fa3faab4b06$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $64559fa3faab4b06$var$fromArrayView(arrayView) {
    if ($64559fa3faab4b06$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $64559fa3faab4b06$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $64559fa3faab4b06$var$fromArrayLike(arrayView);
}
function $64559fa3faab4b06$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $64559fa3faab4b06$var$Buffer.prototype);
    return buf;
}
function $64559fa3faab4b06$var$fromObject(obj) {
    if ($64559fa3faab4b06$var$Buffer.isBuffer(obj)) {
        const len = $64559fa3faab4b06$var$checked(obj.length) | 0;
        const buf = $64559fa3faab4b06$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $64559fa3faab4b06$var$numberIsNaN(obj.length)) return $64559fa3faab4b06$var$createBuffer(0);
        return $64559fa3faab4b06$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $64559fa3faab4b06$var$fromArrayLike(obj.data);
}
function $64559fa3faab4b06$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $64559fa3faab4b06$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $64559fa3faab4b06$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $64559fa3faab4b06$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $64559fa3faab4b06$var$Buffer.alloc(+length);
}
$64559fa3faab4b06$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $64559fa3faab4b06$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$64559fa3faab4b06$var$Buffer.compare = function compare(a, b) {
    if ($64559fa3faab4b06$var$isInstance(a, Uint8Array)) a = $64559fa3faab4b06$var$Buffer.from(a, a.offset, a.byteLength);
    if ($64559fa3faab4b06$var$isInstance(b, Uint8Array)) b = $64559fa3faab4b06$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$64559fa3faab4b06$var$Buffer.isBuffer(a) || !$64559fa3faab4b06$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$64559fa3faab4b06$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$64559fa3faab4b06$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $64559fa3faab4b06$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $64559fa3faab4b06$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($64559fa3faab4b06$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$64559fa3faab4b06$var$Buffer.isBuffer(buf)) buf = $64559fa3faab4b06$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$64559fa3faab4b06$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $64559fa3faab4b06$var$byteLength(string, encoding) {
    if ($64559fa3faab4b06$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $64559fa3faab4b06$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $64559fa3faab4b06$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $64559fa3faab4b06$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $64559fa3faab4b06$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$64559fa3faab4b06$var$Buffer.byteLength = $64559fa3faab4b06$var$byteLength;
function $64559fa3faab4b06$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $64559fa3faab4b06$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $64559fa3faab4b06$var$utf8Slice(this, start, end);
        case 'ascii':
            return $64559fa3faab4b06$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $64559fa3faab4b06$var$latin1Slice(this, start, end);
        case 'base64':
            return $64559fa3faab4b06$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $64559fa3faab4b06$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$64559fa3faab4b06$var$Buffer.prototype._isBuffer = true;
function $64559fa3faab4b06$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$64559fa3faab4b06$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$64559fa3faab4b06$var$swap(this, i, i + 1);
    return this;
};
$64559fa3faab4b06$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $64559fa3faab4b06$var$swap(this, i, i + 3);
        $64559fa3faab4b06$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$64559fa3faab4b06$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $64559fa3faab4b06$var$swap(this, i, i + 7);
        $64559fa3faab4b06$var$swap(this, i + 1, i + 6);
        $64559fa3faab4b06$var$swap(this, i + 2, i + 5);
        $64559fa3faab4b06$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$64559fa3faab4b06$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $64559fa3faab4b06$var$utf8Slice(this, 0, length);
    return $64559fa3faab4b06$var$slowToString.apply(this, arguments);
};
$64559fa3faab4b06$var$Buffer.prototype.toLocaleString = $64559fa3faab4b06$var$Buffer.prototype.toString;
$64559fa3faab4b06$var$Buffer.prototype.equals = function equals(b) {
    if (!$64559fa3faab4b06$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $64559fa3faab4b06$var$Buffer.compare(this, b) === 0;
};
$64559fa3faab4b06$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $64559fa3faab4b06$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($64559fa3faab4b06$var$customInspectSymbol) $64559fa3faab4b06$var$Buffer.prototype[$64559fa3faab4b06$var$customInspectSymbol] = $64559fa3faab4b06$var$Buffer.prototype.inspect;
$64559fa3faab4b06$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($64559fa3faab4b06$var$isInstance(target, Uint8Array)) target = $64559fa3faab4b06$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$64559fa3faab4b06$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $64559fa3faab4b06$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($64559fa3faab4b06$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $64559fa3faab4b06$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($64559fa3faab4b06$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $64559fa3faab4b06$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $64559fa3faab4b06$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $64559fa3faab4b06$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$64559fa3faab4b06$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$64559fa3faab4b06$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $64559fa3faab4b06$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$64559fa3faab4b06$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $64559fa3faab4b06$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $64559fa3faab4b06$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($64559fa3faab4b06$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $64559fa3faab4b06$var$utf8Write(buf, string, offset, length) {
    return $64559fa3faab4b06$var$blitBuffer($64559fa3faab4b06$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $64559fa3faab4b06$var$asciiWrite(buf, string, offset, length) {
    return $64559fa3faab4b06$var$blitBuffer($64559fa3faab4b06$var$asciiToBytes(string), buf, offset, length);
}
function $64559fa3faab4b06$var$base64Write(buf, string, offset, length) {
    return $64559fa3faab4b06$var$blitBuffer($64559fa3faab4b06$var$base64ToBytes(string), buf, offset, length);
}
function $64559fa3faab4b06$var$ucs2Write(buf, string, offset, length) {
    return $64559fa3faab4b06$var$blitBuffer($64559fa3faab4b06$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$64559fa3faab4b06$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $64559fa3faab4b06$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $64559fa3faab4b06$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $64559fa3faab4b06$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $64559fa3faab4b06$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $64559fa3faab4b06$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$64559fa3faab4b06$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $64559fa3faab4b06$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $aBiUS.fromByteArray(buf);
    else return $aBiUS.fromByteArray(buf.slice(start, end));
}
function $64559fa3faab4b06$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $64559fa3faab4b06$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $64559fa3faab4b06$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $64559fa3faab4b06$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $64559fa3faab4b06$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $64559fa3faab4b06$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $64559fa3faab4b06$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $64559fa3faab4b06$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $64559fa3faab4b06$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $64559fa3faab4b06$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $64559fa3faab4b06$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$64559fa3faab4b06$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $64559fa3faab4b06$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $64559fa3faab4b06$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$64559fa3faab4b06$var$Buffer.prototype.readUintLE = $64559fa3faab4b06$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$64559fa3faab4b06$var$Buffer.prototype.readUintBE = $64559fa3faab4b06$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$64559fa3faab4b06$var$Buffer.prototype.readUint8 = $64559fa3faab4b06$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$64559fa3faab4b06$var$Buffer.prototype.readUint16LE = $64559fa3faab4b06$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$64559fa3faab4b06$var$Buffer.prototype.readUint16BE = $64559fa3faab4b06$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$64559fa3faab4b06$var$Buffer.prototype.readUint32LE = $64559fa3faab4b06$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$64559fa3faab4b06$var$Buffer.prototype.readUint32BE = $64559fa3faab4b06$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$64559fa3faab4b06$var$Buffer.prototype.readBigUInt64LE = $64559fa3faab4b06$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $64559fa3faab4b06$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $64559fa3faab4b06$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$64559fa3faab4b06$var$Buffer.prototype.readBigUInt64BE = $64559fa3faab4b06$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $64559fa3faab4b06$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $64559fa3faab4b06$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$64559fa3faab4b06$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$64559fa3faab4b06$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$64559fa3faab4b06$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$64559fa3faab4b06$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$64559fa3faab4b06$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$64559fa3faab4b06$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$64559fa3faab4b06$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$64559fa3faab4b06$var$Buffer.prototype.readBigInt64LE = $64559fa3faab4b06$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $64559fa3faab4b06$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $64559fa3faab4b06$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$64559fa3faab4b06$var$Buffer.prototype.readBigInt64BE = $64559fa3faab4b06$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $64559fa3faab4b06$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $64559fa3faab4b06$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$64559fa3faab4b06$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 4, this.length);
    return $ktjyo.read(this, offset, true, 23, 4);
};
$64559fa3faab4b06$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 4, this.length);
    return $ktjyo.read(this, offset, false, 23, 4);
};
$64559fa3faab4b06$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 8, this.length);
    return $ktjyo.read(this, offset, true, 52, 8);
};
$64559fa3faab4b06$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkOffset(offset, 8, this.length);
    return $ktjyo.read(this, offset, false, 52, 8);
};
function $64559fa3faab4b06$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$64559fa3faab4b06$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$64559fa3faab4b06$var$Buffer.prototype.writeUintLE = $64559fa3faab4b06$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $64559fa3faab4b06$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$64559fa3faab4b06$var$Buffer.prototype.writeUintBE = $64559fa3faab4b06$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $64559fa3faab4b06$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$64559fa3faab4b06$var$Buffer.prototype.writeUint8 = $64559fa3faab4b06$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$64559fa3faab4b06$var$Buffer.prototype.writeUint16LE = $64559fa3faab4b06$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$64559fa3faab4b06$var$Buffer.prototype.writeUint16BE = $64559fa3faab4b06$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$64559fa3faab4b06$var$Buffer.prototype.writeUint32LE = $64559fa3faab4b06$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$64559fa3faab4b06$var$Buffer.prototype.writeUint32BE = $64559fa3faab4b06$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $64559fa3faab4b06$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $64559fa3faab4b06$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $64559fa3faab4b06$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $64559fa3faab4b06$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$64559fa3faab4b06$var$Buffer.prototype.writeBigUInt64LE = $64559fa3faab4b06$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $64559fa3faab4b06$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$64559fa3faab4b06$var$Buffer.prototype.writeBigUInt64BE = $64559fa3faab4b06$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $64559fa3faab4b06$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$64559fa3faab4b06$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $64559fa3faab4b06$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$64559fa3faab4b06$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $64559fa3faab4b06$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$64559fa3faab4b06$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$64559fa3faab4b06$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$64559fa3faab4b06$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$64559fa3faab4b06$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$64559fa3faab4b06$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$64559fa3faab4b06$var$Buffer.prototype.writeBigInt64LE = $64559fa3faab4b06$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $64559fa3faab4b06$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$64559fa3faab4b06$var$Buffer.prototype.writeBigInt64BE = $64559fa3faab4b06$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $64559fa3faab4b06$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $64559fa3faab4b06$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $64559fa3faab4b06$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $ktjyo.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$64559fa3faab4b06$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $64559fa3faab4b06$var$writeFloat(this, value, offset, true, noAssert);
};
$64559fa3faab4b06$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $64559fa3faab4b06$var$writeFloat(this, value, offset, false, noAssert);
};
function $64559fa3faab4b06$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $64559fa3faab4b06$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $ktjyo.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$64559fa3faab4b06$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $64559fa3faab4b06$var$writeDouble(this, value, offset, true, noAssert);
};
$64559fa3faab4b06$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $64559fa3faab4b06$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$64559fa3faab4b06$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$64559fa3faab4b06$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$64559fa3faab4b06$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$64559fa3faab4b06$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $64559fa3faab4b06$var$Buffer.isBuffer(val) ? val : $64559fa3faab4b06$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $64559fa3faab4b06$var$errors = {};
function $64559fa3faab4b06$var$E(sym, getMessage, Base) {
    $64559fa3faab4b06$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$64559fa3faab4b06$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$64559fa3faab4b06$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$64559fa3faab4b06$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $64559fa3faab4b06$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $64559fa3faab4b06$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $64559fa3faab4b06$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $64559fa3faab4b06$var$checkBounds(buf, offset, byteLength) {
    $64559fa3faab4b06$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $64559fa3faab4b06$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $64559fa3faab4b06$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $64559fa3faab4b06$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $64559fa3faab4b06$var$checkBounds(buf, offset, byteLength);
}
function $64559fa3faab4b06$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $64559fa3faab4b06$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $64559fa3faab4b06$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $64559fa3faab4b06$var$validateNumber(value, type);
        throw new $64559fa3faab4b06$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $64559fa3faab4b06$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $64559fa3faab4b06$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $64559fa3faab4b06$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $64559fa3faab4b06$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($64559fa3faab4b06$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $64559fa3faab4b06$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $64559fa3faab4b06$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $64559fa3faab4b06$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $64559fa3faab4b06$var$base64ToBytes(str) {
    return $aBiUS.toByteArray($64559fa3faab4b06$var$base64clean(str));
}
function $64559fa3faab4b06$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $64559fa3faab4b06$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $64559fa3faab4b06$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $64559fa3faab4b06$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $64559fa3faab4b06$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $64559fa3faab4b06$var$BufferBigIntNotDefined : fn;
}
function $64559fa3faab4b06$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("aBiUS", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $7b7c08750dcaf303$export$d622b2ad8d90c771, (v) => $7b7c08750dcaf303$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $7b7c08750dcaf303$export$6100ba28696e12de, (v) => $7b7c08750dcaf303$export$6100ba28696e12de = v);
var $7b7c08750dcaf303$export$a48f0734ac7c2329;
var $7b7c08750dcaf303$export$d622b2ad8d90c771;
var $7b7c08750dcaf303$export$6100ba28696e12de;
'use strict';
$7b7c08750dcaf303$export$a48f0734ac7c2329 = $7b7c08750dcaf303$var$byteLength;
$7b7c08750dcaf303$export$d622b2ad8d90c771 = $7b7c08750dcaf303$var$toByteArray;
$7b7c08750dcaf303$export$6100ba28696e12de = $7b7c08750dcaf303$var$fromByteArray;
var $7b7c08750dcaf303$var$lookup = [];
var $7b7c08750dcaf303$var$revLookup = [];
var $7b7c08750dcaf303$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $7b7c08750dcaf303$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $7b7c08750dcaf303$var$i = 0, $7b7c08750dcaf303$var$len = $7b7c08750dcaf303$var$code.length; $7b7c08750dcaf303$var$i < $7b7c08750dcaf303$var$len; ++$7b7c08750dcaf303$var$i){
    $7b7c08750dcaf303$var$lookup[$7b7c08750dcaf303$var$i] = $7b7c08750dcaf303$var$code[$7b7c08750dcaf303$var$i];
    $7b7c08750dcaf303$var$revLookup[$7b7c08750dcaf303$var$code.charCodeAt($7b7c08750dcaf303$var$i)] = $7b7c08750dcaf303$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$7b7c08750dcaf303$var$revLookup['-'.charCodeAt(0)] = 62;
$7b7c08750dcaf303$var$revLookup['_'.charCodeAt(0)] = 63;
function $7b7c08750dcaf303$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $7b7c08750dcaf303$var$byteLength(b64) {
    var lens = $7b7c08750dcaf303$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7b7c08750dcaf303$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7b7c08750dcaf303$var$toByteArray(b64) {
    var tmp;
    var lens = $7b7c08750dcaf303$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $7b7c08750dcaf303$var$Arr($7b7c08750dcaf303$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $7b7c08750dcaf303$var$revLookup[b64.charCodeAt(i)] << 18 | $7b7c08750dcaf303$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $7b7c08750dcaf303$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $7b7c08750dcaf303$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $7b7c08750dcaf303$var$revLookup[b64.charCodeAt(i)] << 2 | $7b7c08750dcaf303$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $7b7c08750dcaf303$var$revLookup[b64.charCodeAt(i)] << 10 | $7b7c08750dcaf303$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $7b7c08750dcaf303$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $7b7c08750dcaf303$var$tripletToBase64(num) {
    return $7b7c08750dcaf303$var$lookup[num >> 18 & 0x3F] + $7b7c08750dcaf303$var$lookup[num >> 12 & 0x3F] + $7b7c08750dcaf303$var$lookup[num >> 6 & 0x3F] + $7b7c08750dcaf303$var$lookup[num & 0x3F];
}
function $7b7c08750dcaf303$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($7b7c08750dcaf303$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $7b7c08750dcaf303$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($7b7c08750dcaf303$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($7b7c08750dcaf303$var$lookup[tmp >> 2] + $7b7c08750dcaf303$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($7b7c08750dcaf303$var$lookup[tmp >> 10] + $7b7c08750dcaf303$var$lookup[tmp >> 4 & 0x3F] + $7b7c08750dcaf303$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("ktjyo", function(module, exports) {

$parcel$export(module.exports, "read", () => $ee75af095e2bc433$export$aafa59e2e03f2942, (v) => $ee75af095e2bc433$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $ee75af095e2bc433$export$68d8715fc104d294, (v) => $ee75af095e2bc433$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $ee75af095e2bc433$export$aafa59e2e03f2942;
var $ee75af095e2bc433$export$68d8715fc104d294;
$ee75af095e2bc433$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$ee75af095e2bc433$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




var $2M70Q = parcelRequire("2M70Q");
var $5d331f9df93627f3$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5d331f9df93627f3$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $5d331f9df93627f3$exports));
try {
    regeneratorRuntime = $5d331f9df93627f3$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $5d331f9df93627f3$var$runtime;
    else Function("r", "regeneratorRuntime = r")($5d331f9df93627f3$var$runtime);
}



var $3OyDL = parcelRequire("3OyDL");

var $dy6Cj = parcelRequire("dy6Cj");

var $jNtCy = parcelRequire("jNtCy");

var $3OyDL = parcelRequire("3OyDL");


var $gOPoC = parcelRequire("gOPoC");
function $bd531439a33c8ddb$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $bd531439a33c8ddb$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $bd531439a33c8ddb$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $bd531439a33c8ddb$var$isAbsolute(to);
    var isFromAbs = from && $bd531439a33c8ddb$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $bd531439a33c8ddb$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $bd531439a33c8ddb$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $bd531439a33c8ddb$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $bd531439a33c8ddb$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$bd531439a33c8ddb$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $bd531439a33c8ddb$export$2e2bcd8739ae039 = $bd531439a33c8ddb$var$resolvePathname;


function $1c14f57998a68914$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $1c14f57998a68914$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $1c14f57998a68914$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $1c14f57998a68914$var$valueOf(a);
        var bValue = $1c14f57998a68914$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $1c14f57998a68914$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $1c14f57998a68914$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $1c14f57998a68914$export$2e2bcd8739ae039 = $1c14f57998a68914$var$valueEqual;



var $fddaac7c89f58d3d$var$isProduction = true;
var $fddaac7c89f58d3d$var$prefix = 'Invariant failed';
function $fddaac7c89f58d3d$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($fddaac7c89f58d3d$var$isProduction) throw new Error($fddaac7c89f58d3d$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($fddaac7c89f58d3d$var$prefix, ": ").concat(provided) : $fddaac7c89f58d3d$var$prefix;
    throw new Error(value);
}


function $241b46700f82c4d4$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $241b46700f82c4d4$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $241b46700f82c4d4$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $241b46700f82c4d4$var$stripBasename(path, prefix) {
    return $241b46700f82c4d4$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $241b46700f82c4d4$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $241b46700f82c4d4$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $241b46700f82c4d4$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $241b46700f82c4d4$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $241b46700f82c4d4$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $gOPoC.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $bd531439a33c8ddb$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $241b46700f82c4d4$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $1c14f57998a68914$export$2e2bcd8739ae039)(a.state, b.state);
}
function $241b46700f82c4d4$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $241b46700f82c4d4$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $241b46700f82c4d4$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $241b46700f82c4d4$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $241b46700f82c4d4$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $241b46700f82c4d4$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $241b46700f82c4d4$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $241b46700f82c4d4$var$PopStateEvent = 'popstate';
var $241b46700f82c4d4$var$HashChangeEvent = 'hashchange';
function $241b46700f82c4d4$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $241b46700f82c4d4$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$241b46700f82c4d4$var$canUseDOM && (0, $fddaac7c89f58d3d$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $241b46700f82c4d4$var$supportsHistory();
    var needsHashChangeListener = !$241b46700f82c4d4$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $241b46700f82c4d4$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $241b46700f82c4d4$var$stripTrailingSlash($241b46700f82c4d4$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $241b46700f82c4d4$var$stripBasename(path, basename);
        return $241b46700f82c4d4$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $241b46700f82c4d4$var$createTransitionManager();
    function setState(nextState) {
        (0, $gOPoC.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($241b46700f82c4d4$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($241b46700f82c4d4$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($241b46700f82c4d4$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $241b46700f82c4d4$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $241b46700f82c4d4$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $241b46700f82c4d4$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($241b46700f82c4d4$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($241b46700f82c4d4$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($241b46700f82c4d4$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($241b46700f82c4d4$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $241b46700f82c4d4$var$HashChangeEvent$1 = 'hashchange';
var $241b46700f82c4d4$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $241b46700f82c4d4$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $241b46700f82c4d4$var$stripLeadingSlash,
        decodePath: $241b46700f82c4d4$var$addLeadingSlash
    },
    slash: {
        encodePath: $241b46700f82c4d4$var$addLeadingSlash,
        decodePath: $241b46700f82c4d4$var$addLeadingSlash
    }
};
function $241b46700f82c4d4$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $241b46700f82c4d4$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $241b46700f82c4d4$var$pushHashPath(path) {
    window.location.hash = path;
}
function $241b46700f82c4d4$var$replaceHashPath(path) {
    window.location.replace($241b46700f82c4d4$var$stripHash(window.location.href) + '#' + path);
}
function $241b46700f82c4d4$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$241b46700f82c4d4$var$canUseDOM && (0, $fddaac7c89f58d3d$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $241b46700f82c4d4$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $241b46700f82c4d4$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $241b46700f82c4d4$var$stripTrailingSlash($241b46700f82c4d4$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $241b46700f82c4d4$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($241b46700f82c4d4$var$getHashPath());
        if (basename) path = $241b46700f82c4d4$var$stripBasename(path, basename);
        return $241b46700f82c4d4$export$90c043f1c57770b8(path);
    }
    var transitionManager = $241b46700f82c4d4$var$createTransitionManager();
    function setState(nextState) {
        (0, $gOPoC.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $241b46700f82c4d4$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $241b46700f82c4d4$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $241b46700f82c4d4$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($241b46700f82c4d4$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($241b46700f82c4d4$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $241b46700f82c4d4$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $241b46700f82c4d4$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $241b46700f82c4d4$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $241b46700f82c4d4$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $241b46700f82c4d4$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $241b46700f82c4d4$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $241b46700f82c4d4$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $241b46700f82c4d4$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $241b46700f82c4d4$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($241b46700f82c4d4$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $241b46700f82c4d4$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $241b46700f82c4d4$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $241b46700f82c4d4$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $241b46700f82c4d4$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($241b46700f82c4d4$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($241b46700f82c4d4$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($241b46700f82c4d4$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $241b46700f82c4d4$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $241b46700f82c4d4$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $241b46700f82c4d4$var$createTransitionManager();
    function setState(nextState) {
        (0, $gOPoC.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $241b46700f82c4d4$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $241b46700f82c4d4$export$90c043f1c57770b8(entry, undefined, createKey()) : $241b46700f82c4d4$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $241b46700f82c4d4$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $241b46700f82c4d4$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $241b46700f82c4d4$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $241b46700f82c4d4$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}




var $3OyDL = parcelRequire("3OyDL");

var $jNtCy = parcelRequire("jNtCy");
var $9762ea3dbd152f69$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9762ea3dbd152f69$var$ReactIs, $9762ea3dbd152f69$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$9762ea3dbd152f69$exports = (parcelRequire("2fAqF"))();



var $95344b38e08069cc$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $95344b38e08069cc$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {};
function $95344b38e08069cc$var$getUniqueId() {
    var key = '__global_unique_id__';
    return $95344b38e08069cc$var$commonjsGlobal[key] = ($95344b38e08069cc$var$commonjsGlobal[key] || 0) + 1;
}
function $95344b38e08069cc$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $95344b38e08069cc$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $95344b38e08069cc$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $95344b38e08069cc$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + $95344b38e08069cc$var$getUniqueId() + '__';
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $jNtCy.default)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $95344b38e08069cc$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($95344b38e08069cc$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : $95344b38e08069cc$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $3OyDL.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($9762ea3dbd152f69$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, $jNtCy.default)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $95344b38e08069cc$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $95344b38e08069cc$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $95344b38e08069cc$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $3OyDL.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($9762ea3dbd152f69$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $95344b38e08069cc$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createContext || $95344b38e08069cc$var$createReactContext;
var $95344b38e08069cc$export$2e2bcd8739ae039 = $95344b38e08069cc$var$index;




var $gOPoC = parcelRequire("gOPoC");
var $1a81a00e398131bb$exports = {};
var $d3b93354d130a74f$exports = {};
$d3b93354d130a74f$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $1a81a00e398131bb$exports = $1a81a00e398131bb$var$pathToRegexp;
$1a81a00e398131bb$exports.parse = $1a81a00e398131bb$var$parse;
$1a81a00e398131bb$exports.compile = $1a81a00e398131bb$var$compile;
$1a81a00e398131bb$exports.tokensToFunction = $1a81a00e398131bb$var$tokensToFunction;
$1a81a00e398131bb$exports.tokensToRegExp = $1a81a00e398131bb$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $1a81a00e398131bb$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $1a81a00e398131bb$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $1a81a00e398131bb$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $1a81a00e398131bb$var$escapeGroup(pattern) : asterisk ? '.*' : $1a81a00e398131bb$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $1a81a00e398131bb$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $1a81a00e398131bb$var$escapeString(delimiter) + ']+?';
    return $1a81a00e398131bb$var$escapeString(prevText) + '|(?:(?!' + $1a81a00e398131bb$var$escapeString(prevText) + ')[^' + $1a81a00e398131bb$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $1a81a00e398131bb$var$compile(str, options) {
    return $1a81a00e398131bb$var$tokensToFunction($1a81a00e398131bb$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $1a81a00e398131bb$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $1a81a00e398131bb$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $1a81a00e398131bb$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $1a81a00e398131bb$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $1a81a00e398131bb$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($d3b93354d130a74f$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $1a81a00e398131bb$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $1a81a00e398131bb$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $1a81a00e398131bb$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $1a81a00e398131bb$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $1a81a00e398131bb$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $1a81a00e398131bb$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $1a81a00e398131bb$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $1a81a00e398131bb$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($1a81a00e398131bb$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $1a81a00e398131bb$var$flags(options));
    return $1a81a00e398131bb$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $1a81a00e398131bb$var$stringToRegexp(path, keys, options) {
    return $1a81a00e398131bb$var$tokensToRegExp($1a81a00e398131bb$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $1a81a00e398131bb$var$tokensToRegExp(tokens, keys, options) {
    if (!$d3b93354d130a74f$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $1a81a00e398131bb$var$escapeString(token);
        else {
            var prefix = $1a81a00e398131bb$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $1a81a00e398131bb$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $1a81a00e398131bb$var$attachKeys(new RegExp('^' + route, $1a81a00e398131bb$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $1a81a00e398131bb$var$pathToRegexp(path, keys, options) {
    if (!$d3b93354d130a74f$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $1a81a00e398131bb$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($d3b93354d130a74f$exports(path)) return $1a81a00e398131bb$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $1a81a00e398131bb$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


parcelRequire("6ZBvu");

var $aBenZ = parcelRequire("aBenZ");

var $9PRjv = parcelRequire("9PRjv");
// TODO: Replace with React.createContext once we can assume React 16+
var $4e1a33337564f167$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $95344b38e08069cc$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $4e1a33337564f167$export$c213558b66925821 = /*#__PURE__*/ $4e1a33337564f167$var$createNamedContext("Router-History");
// TODO: Replace with React.createContext once we can assume React 16+
var $4e1a33337564f167$var$createNamedContext$1 = function createNamedContext(name) {
    var context = (0, $95344b38e08069cc$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $4e1a33337564f167$export$63baa8ccbe60bb07 = /*#__PURE__*/ $4e1a33337564f167$var$createNamedContext$1("Router");
/**
 * The public API for putting history on context.
 */ var $4e1a33337564f167$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $jNtCy.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    };
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($4e1a33337564f167$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($4e1a33337564f167$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $4e1a33337564f167$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $jNtCy.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $241b46700f82c4d4$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($4e1a33337564f167$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Component);
var $4e1a33337564f167$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $jNtCy.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $4e1a33337564f167$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($4e1a33337564f167$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $fddaac7c89f58d3d$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($4e1a33337564f167$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $4e1a33337564f167$var$messageType;
var $4e1a33337564f167$var$cache = {};
var $4e1a33337564f167$var$cacheLimit = 10000;
var $4e1a33337564f167$var$cacheCount = 0;
function $4e1a33337564f167$var$compilePath(path) {
    if ($4e1a33337564f167$var$cache[path]) return $4e1a33337564f167$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($1a81a00e398131bb$exports))).compile(path);
    if ($4e1a33337564f167$var$cacheCount < $4e1a33337564f167$var$cacheLimit) {
        $4e1a33337564f167$var$cache[path] = generator;
        $4e1a33337564f167$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $4e1a33337564f167$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $4e1a33337564f167$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $4e1a33337564f167$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($4e1a33337564f167$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $fddaac7c89f58d3d$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $241b46700f82c4d4$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $4e1a33337564f167$export$82476f982757e71e(to, computedMatch.params) : (0, $gOPoC.default)({}, to, {
            pathname: $4e1a33337564f167$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($4e1a33337564f167$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $241b46700f82c4d4$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $241b46700f82c4d4$export$c3e8bb440bd55b18)(prevLocation, (0, $gOPoC.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $4e1a33337564f167$var$cache$1 = {};
var $4e1a33337564f167$var$cacheLimit$1 = 10000;
var $4e1a33337564f167$var$cacheCount$1 = 0;
function $4e1a33337564f167$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $4e1a33337564f167$var$cache$1[cacheKey] || ($4e1a33337564f167$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($1a81a00e398131bb$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($4e1a33337564f167$var$cacheCount$1 < $4e1a33337564f167$var$cacheLimit$1) {
        pathCache[path] = result;
        $4e1a33337564f167$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $4e1a33337564f167$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $4e1a33337564f167$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $4e1a33337564f167$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Children.count(children) === 0;
}
function $4e1a33337564f167$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $4e1a33337564f167$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $jNtCy.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($4e1a33337564f167$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $fddaac7c89f58d3d$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $4e1a33337564f167$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $gOPoC.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && children.length === 0) children = null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($4e1a33337564f167$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Component);
function $4e1a33337564f167$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $4e1a33337564f167$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $gOPoC.default)({}, location, {
        pathname: $4e1a33337564f167$var$addLeadingSlash(basename) + location.pathname
    });
}
function $4e1a33337564f167$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $4e1a33337564f167$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $gOPoC.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $4e1a33337564f167$var$createURL(location) {
    return typeof location === "string" ? location : (0, $241b46700f82c4d4$export$fe53371bee54353d)(location);
}
function $4e1a33337564f167$var$staticHandler(methodName) {
    return function() {
        (0, $fddaac7c89f58d3d$export$2e2bcd8739ae039)(false);
    };
}
function $4e1a33337564f167$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $4e1a33337564f167$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $jNtCy.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $4e1a33337564f167$var$noop;
        };
        _this.handleBlock = function() {
            return $4e1a33337564f167$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $4e1a33337564f167$var$addBasename(basename, (0, $241b46700f82c4d4$export$90c043f1c57770b8)(location));
        context.url = $4e1a33337564f167$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $aBenZ.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $4e1a33337564f167$var$addLeadingSlash(basename + $4e1a33337564f167$var$createURL(path));
            },
            action: "POP",
            location: $4e1a33337564f167$var$stripBasename(basename, (0, $241b46700f82c4d4$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $4e1a33337564f167$var$staticHandler("go"),
            goBack: $4e1a33337564f167$var$staticHandler("goBack"),
            goForward: $4e1a33337564f167$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($4e1a33337564f167$export$55185c17a0fcbe46, (0, $gOPoC.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $4e1a33337564f167$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $jNtCy.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($4e1a33337564f167$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $fddaac7c89f58d3d$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Children.forEach(_this.props.children, function(child) {
                if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $4e1a33337564f167$export$81336c211d5ff295(location.pathname, (0, $gOPoC.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $4e1a33337564f167$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $aBenZ.default)(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($4e1a33337564f167$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $fddaac7c89f58d3d$export$2e2bcd8739ae039)(false);
            return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement(Component, (0, $gOPoC.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9PRjv)))(C, Component);
}
var $4e1a33337564f167$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useContext;
function $4e1a33337564f167$export$3420e1dc2c4a518c() {
    return $4e1a33337564f167$var$useContext($4e1a33337564f167$export$c213558b66925821);
}
function $4e1a33337564f167$export$45d76561a5302f2b() {
    return $4e1a33337564f167$var$useContext($4e1a33337564f167$export$63baa8ccbe60bb07).location;
}
function $4e1a33337564f167$export$99eaa27ddbbb95ef() {
    var match = $4e1a33337564f167$var$useContext($4e1a33337564f167$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $4e1a33337564f167$export$632be4bb944c1bc7(path) {
    var location = $4e1a33337564f167$export$45d76561a5302f2b();
    var match = $4e1a33337564f167$var$useContext($4e1a33337564f167$export$63baa8ccbe60bb07).match;
    return path ? $4e1a33337564f167$export$81336c211d5ff295(location.pathname, path) : match;
}
var $4e1a33337564f167$var$global, $4e1a33337564f167$var$key, $4e1a33337564f167$var$buildNames, $4e1a33337564f167$var$initialBuildName, $4e1a33337564f167$var$secondaryBuildName;



var $jNtCy = parcelRequire("jNtCy");

var $3OyDL = parcelRequire("3OyDL");




var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $bd8e9bc1f452c97a$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $jNtCy.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $241b46700f82c4d4$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement((0, $4e1a33337564f167$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $bd8e9bc1f452c97a$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $jNtCy.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $241b46700f82c4d4$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement((0, $4e1a33337564f167$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Component);
var $bd8e9bc1f452c97a$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $bd8e9bc1f452c97a$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $241b46700f82c4d4$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $bd8e9bc1f452c97a$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $bd8e9bc1f452c97a$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).forwardRef;
if (typeof $bd8e9bc1f452c97a$var$forwardRef === "undefined") $bd8e9bc1f452c97a$var$forwardRef = $bd8e9bc1f452c97a$var$forwardRefShim;
function $bd8e9bc1f452c97a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $bd8e9bc1f452c97a$var$LinkAnchor = $bd8e9bc1f452c97a$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $aBenZ.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $gOPoC.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$bd8e9bc1f452c97a$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($bd8e9bc1f452c97a$var$forwardRefShim !== $bd8e9bc1f452c97a$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $bd8e9bc1f452c97a$export$a6c7ac8248d6e38a = $bd8e9bc1f452c97a$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $bd8e9bc1f452c97a$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $aBenZ.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement((0, $4e1a33337564f167$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $fddaac7c89f58d3d$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $bd8e9bc1f452c97a$var$normalizeToLocation($bd8e9bc1f452c97a$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $gOPoC.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $bd8e9bc1f452c97a$var$resolveToLocation(to, context.location);
                var method = replace ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($bd8e9bc1f452c97a$var$forwardRefShim !== $bd8e9bc1f452c97a$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement(component, props);
    });
});
var $bd8e9bc1f452c97a$var$toType, $bd8e9bc1f452c97a$var$refType;
var $bd8e9bc1f452c97a$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $bd8e9bc1f452c97a$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).forwardRef;
if (typeof $bd8e9bc1f452c97a$var$forwardRef$1 === "undefined") $bd8e9bc1f452c97a$var$forwardRef$1 = $bd8e9bc1f452c97a$var$forwardRefShim$1;
function $bd8e9bc1f452c97a$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $bd8e9bc1f452c97a$export$b0d92dbee9b5b60d = $bd8e9bc1f452c97a$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $aBenZ.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement((0, $4e1a33337564f167$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $fddaac7c89f58d3d$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $bd8e9bc1f452c97a$var$normalizeToLocation($bd8e9bc1f452c97a$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $4e1a33337564f167$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = isActive ? $bd8e9bc1f452c97a$var$joinClassnames(classNameProp, activeClassName) : classNameProp;
        var style = isActive ? (0, $gOPoC.default)({}, styleProp, {}, activeStyle) : styleProp;
        var props = (0, $gOPoC.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($bd8e9bc1f452c97a$var$forwardRefShim$1 !== $bd8e9bc1f452c97a$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($bd8e9bc1f452c97a$export$a6c7ac8248d6e38a, props);
    });
});
var $bd8e9bc1f452c97a$var$ariaCurrentType;



var $2NPO8 = parcelRequire("2NPO8");
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $46555720e4c9b283$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $46555720e4c9b283$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $46555720e4c9b283$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $46555720e4c9b283$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $46555720e4c9b283$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $46555720e4c9b283$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ function $46555720e4c9b283$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error("It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function.");
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer($46555720e4c9b283$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected the listener to be a function.');
        if (isDispatching) throw new Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api-reference/store#subscribelistener for more details.");
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api-reference/store#subscribelistener for more details.");
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$46555720e4c9b283$var$isPlainObject(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $46555720e4c9b283$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $2NPO8.default] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $46555720e4c9b283$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $2NPO8.default] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $46555720e4c9b283$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $46555720e4c9b283$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
    return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}
function $46555720e4c9b283$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $46555720e4c9b283$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$46555720e4c9b283$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $46555720e4c9b283$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $46555720e4c9b283$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $46555720e4c9b283$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
        if (typeof reducer(undefined, {
            type: $46555720e4c9b283$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + $46555720e4c9b283$export$4219e499db7ca678.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $46555720e4c9b283$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $46555720e4c9b283$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var errorMessage = $46555720e4c9b283$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $46555720e4c9b283$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $46555720e4c9b283$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $46555720e4c9b283$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $46555720e4c9b283$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
function $46555720e4c9b283$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $46555720e4c9b283$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) keys.push.apply(keys, Object.getOwnPropertySymbols(object));
    if (enumerableOnly) keys = keys.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    return keys;
}
function $46555720e4c9b283$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $46555720e4c9b283$var$ownKeys(source, true).forEach(function(key) {
            $46555720e4c9b283$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $46555720e4c9b283$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $46555720e4c9b283$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $46555720e4c9b283$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error("Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $46555720e4c9b283$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return $46555720e4c9b283$var$_objectSpread2({}, store, {
                dispatch: _dispatch
            });
        };
    };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function $46555720e4c9b283$var$isCrushed() {}



var $3OyDL = parcelRequire("3OyDL");


var $3OyDL = parcelRequire("3OyDL");
var $609dac489a8a9a26$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createContext(null);
var $609dac489a8a9a26$export$2e2bcd8739ae039 = $609dac489a8a9a26$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $aeb6614d4576dfda$var$defaultNoopBatch(callback) {
    callback();
}
var $aeb6614d4576dfda$var$batch = $aeb6614d4576dfda$var$defaultNoopBatch; // Allow injecting another batching function later
var $aeb6614d4576dfda$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $aeb6614d4576dfda$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $aeb6614d4576dfda$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $aeb6614d4576dfda$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $cfd52ffaa97999b9$var$createListenerCollection() {
    var batch = (0, $aeb6614d4576dfda$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $cfd52ffaa97999b9$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $cfd52ffaa97999b9$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $cfd52ffaa97999b9$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $cfd52ffaa97999b9$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $cfd52ffaa97999b9$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $3OyDL = parcelRequire("3OyDL");
var $b1431c3bf2a8474a$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $3OyDL.useLayoutEffect) : (0, $3OyDL.useEffect);


function $248d245009f22637$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $3OyDL.useMemo)(function() {
        var subscription = (0, $cfd52ffaa97999b9$export$d567d2b9af322f8f)(store);
        subscription.onStateChange = subscription.notifyNestedSubs;
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $3OyDL.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $b1431c3bf2a8474a$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $609dac489a8a9a26$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $248d245009f22637$export$2e2bcd8739ae039 = $248d245009f22637$var$Provider;



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $9PRjv = parcelRequire("9PRjv");

var $3OyDL = parcelRequire("3OyDL");
var $63e08656a4fa2ec7$exports = {};
'use strict';

$63e08656a4fa2ec7$exports = (parcelRequire("kM9SO"));





var $1aa7da0f74136dc5$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $1aa7da0f74136dc5$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $1aa7da0f74136dc5$var$EMPTY_ARRAY = [];
var $1aa7da0f74136dc5$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $1aa7da0f74136dc5$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $1aa7da0f74136dc5$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $1aa7da0f74136dc5$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $b1431c3bf2a8474a$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $1aa7da0f74136dc5$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $1aa7da0f74136dc5$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $1aa7da0f74136dc5$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $1aa7da0f74136dc5$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $609dac489a8a9a26$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $aBenZ.default)(_ref2, $1aa7da0f74136dc5$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $gOPoC.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $3OyDL.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $3OyDL.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $aBenZ.default)(props, $1aa7da0f74136dc5$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $3OyDL.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $63e08656a4fa2ec7$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $3OyDL.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $3OyDL.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $3OyDL.useMemo)(function() {
                if (!shouldHandleStateChanges) return $1aa7da0f74136dc5$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $cfd52ffaa97999b9$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $3OyDL.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $gOPoC.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $3OyDL.useReducer)($1aa7da0f74136dc5$var$storeStateUpdatesReducer, $1aa7da0f74136dc5$var$EMPTY_ARRAY, $1aa7da0f74136dc5$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $3OyDL.useRef)();
            var lastWrapperProps = (0, $3OyDL.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $3OyDL.useRef)();
            var renderIsScheduled = (0, $3OyDL.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $1aa7da0f74136dc5$var$useIsomorphicLayoutEffectWithArgs($1aa7da0f74136dc5$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $1aa7da0f74136dc5$var$useIsomorphicLayoutEffectWithArgs($1aa7da0f74136dc5$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $3OyDL.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement(WrappedComponent, (0, $gOPoC.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $3OyDL.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement(Connect, (0, $gOPoC.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9PRjv)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($9PRjv)))(Connect, WrappedComponent);
    };
}




var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

function $7091e1b1473d1b66$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $7091e1b1473d1b66$export$2e2bcd8739ae039(objA, objB) {
    if ($7091e1b1473d1b66$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$7091e1b1473d1b66$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $3622063c6b7498d4$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $208a7a3abd4946b1$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $da531aa10cc49c25$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $01ba4937c4710b01$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $208a7a3abd4946b1$export$2e2bcd8739ae039)(value)) (0, $da531aa10cc49c25$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $d171223bc8bb0a7f$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $d171223bc8bb0a7f$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $d171223bc8bb0a7f$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $d171223bc8bb0a7f$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $d171223bc8bb0a7f$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $72c41109049157a8$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $d171223bc8bb0a7f$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $72c41109049157a8$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $d171223bc8bb0a7f$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $72c41109049157a8$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $d171223bc8bb0a7f$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $3622063c6b7498d4$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $72c41109049157a8$export$2e2bcd8739ae039 = [
    $72c41109049157a8$export$a9f27b4b187c1166,
    $72c41109049157a8$export$ba20d1a7aa0c4a90,
    $72c41109049157a8$export$94a6e55709d4d961
];



function $dfa9bc9524c606bf$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $d171223bc8bb0a7f$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $dfa9bc9524c606bf$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $d171223bc8bb0a7f$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $dfa9bc9524c606bf$export$2e2bcd8739ae039 = [
    $dfa9bc9524c606bf$export$23fc470827b14aa,
    $dfa9bc9524c606bf$export$514bc8c1a53c1d66
];



var $gOPoC = parcelRequire("gOPoC");

function $2d4bb4e12d5b4e64$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $gOPoC.default)({}, ownProps, stateProps, dispatchProps);
}
function $2d4bb4e12d5b4e64$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $2d4bb4e12d5b4e64$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $2d4bb4e12d5b4e64$export$5b105939c84b5234(mergeProps) : undefined;
}
function $2d4bb4e12d5b4e64$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $2d4bb4e12d5b4e64$export$691c327fc30bc857;
    } : undefined;
}
var $2d4bb4e12d5b4e64$export$2e2bcd8739ae039 = [
    $2d4bb4e12d5b4e64$export$d61b680184bc3f00,
    $2d4bb4e12d5b4e64$export$a13ba70ef50dda6d
];



var $aBenZ = parcelRequire("aBenZ");

function $90d152449a8bf6eb$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $da531aa10cc49c25$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $90d152449a8bf6eb$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $90d152449a8bf6eb$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $90d152449a8bf6eb$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $90d152449a8bf6eb$var$verify(mergeProps, 'mergeProps', displayName);
}


var $7e8f90e30bfaa998$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $7e8f90e30bfaa998$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $7e8f90e30bfaa998$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $7e8f90e30bfaa998$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $aBenZ.default)(_ref2, $7e8f90e30bfaa998$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $7e8f90e30bfaa998$export$d20c0c2ca6eb2b6f : $7e8f90e30bfaa998$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $d914d331f22ad513$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $d914d331f22ad513$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $d914d331f22ad513$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $d914d331f22ad513$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $1aa7da0f74136dc5$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $dfa9bc9524c606bf$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $72c41109049157a8$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $2d4bb4e12d5b4e64$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $7e8f90e30bfaa998$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $d914d331f22ad513$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $7091e1b1473d1b66$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $7091e1b1473d1b66$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $7091e1b1473d1b66$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $aBenZ.default)(_ref3, $d914d331f22ad513$var$_excluded);
        var initMapStateToProps = $d914d331f22ad513$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $d914d331f22ad513$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $d914d331f22ad513$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $gOPoC.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $d914d331f22ad513$export$2e2bcd8739ae039 = /*#__PURE__*/ $d914d331f22ad513$export$9f9feb656dec1fc4();




var $3OyDL = parcelRequire("3OyDL");


var $3OyDL = parcelRequire("3OyDL");

function $b68fbec60a4a2b48$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $3OyDL.useContext)((0, $609dac489a8a9a26$export$cc80c08dc91f1c00));
    return contextValue;
}


function $c10536fd816ab2a3$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $609dac489a8a9a26$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $609dac489a8a9a26$export$cc80c08dc91f1c00) ? (0, $b68fbec60a4a2b48$export$c1275ca9a6fd3ec5) : function() {
        return (0, $3OyDL.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $c10536fd816ab2a3$export$6ccbb43953eebf8 = /*#__PURE__*/ $c10536fd816ab2a3$export$671dba69185d0304();


function $40700d9745177b04$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $609dac489a8a9a26$export$cc80c08dc91f1c00);
    var useStore = context === (0, $609dac489a8a9a26$export$cc80c08dc91f1c00) ? (0, $c10536fd816ab2a3$export$6ccbb43953eebf8) : (0, $c10536fd816ab2a3$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $40700d9745177b04$export$8ad76b76a4c905f8 = /*#__PURE__*/ $40700d9745177b04$export$bc9b55530897c558();



var $3OyDL = parcelRequire("3OyDL");




var $2f56bfc833fc72e6$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $2f56bfc833fc72e6$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $3OyDL.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $3OyDL.useMemo)(function() {
        return (0, $cfd52ffaa97999b9$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $3OyDL.useRef)();
    var latestSelector = (0, $3OyDL.useRef)();
    var latestStoreState = (0, $3OyDL.useRef)();
    var latestSelectedState = (0, $3OyDL.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $b1431c3bf2a8474a$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $b1431c3bf2a8474a$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $2f56bfc833fc72e6$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $609dac489a8a9a26$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $609dac489a8a9a26$export$cc80c08dc91f1c00) ? (0, $b68fbec60a4a2b48$export$c1275ca9a6fd3ec5) : function() {
        return (0, $3OyDL.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $2f56bfc833fc72e6$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $2f56bfc833fc72e6$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $3OyDL.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $2f56bfc833fc72e6$export$2105062e25df4afe = /*#__PURE__*/ $2f56bfc833fc72e6$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ 
var $dy6Cj = parcelRequire("dy6Cj");


var $dy6Cj = parcelRequire("dy6Cj");

// with standard React renderers (ReactDOM, React Native)
(0, $aeb6614d4576dfda$export$4b9874722d0da7bc)((0, $dy6Cj.unstable_batchedUpdates));



var $6vszX = parcelRequire("6vszX");

var $h2uGY = parcelRequire("h2uGY");
function $4ef5ed73e6ad1f10$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $h2uGY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $1ec9015ff660489a$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), o.forEach(function(r) {
            (0, $4ef5ed73e6ad1f10$export$2e2bcd8739ae039)(e, r, t[r]);
        });
    }
    return e;
}


function $bc7b0385e56411c4$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



var $ct8ww = parcelRequire("ct8ww");

var $6vszX = parcelRequire("6vszX");

var $45Uts = parcelRequire("45Uts");
function $f0bd8fa07e04fc6e$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $6vszX.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $45Uts.default)(t);
}


function $6c62fc255ea97813$export$2e2bcd8739ae039(t) {
    return $6c62fc255ea97813$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $6c62fc255ea97813$export$2e2bcd8739ae039(t);
}



var $45Uts = parcelRequire("45Uts");

var $4Cm2L = parcelRequire("4Cm2L");
function $88ee7bb5d2406c72$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $4Cm2L.default)(t, e);
}


var $ddce666daee6ccef$var$consoleLogger = {
    type: 'logger',
    log: function log(args) {
        this.output('log', args);
    },
    warn: function warn(args) {
        this.output('warn', args);
    },
    error: function error(args) {
        this.output('error', args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $ddce666daee6ccef$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $bc7b0385e56411c4$export$2e2bcd8739ae039)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $ct8ww.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || 'i18next:';
                this.logger = concreteLogger || $ddce666daee6ccef$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, 'log', '', true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, 'warn', '', true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, 'error', '');
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }, this.options));
            }
        }
    ]);
    return Logger;
}();
var $ddce666daee6ccef$var$baseLogger = new $ddce666daee6ccef$var$Logger();
var $ddce666daee6ccef$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $bc7b0385e56411c4$export$2e2bcd8739ae039)(this, EventEmitter);
        this.observers = {};
    }
    (0, $ct8ww.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(' ').forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers['*']) {
                    var _cloned = [].concat(this.observers['*']);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $ddce666daee6ccef$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $ddce666daee6ccef$var$makeString(object) {
    if (object == null) return '';
    return '' + object;
}
function $ddce666daee6ccef$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $ddce666daee6ccef$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === 'string';
    }
    var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        object = object[key];
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $ddce666daee6ccef$var$setPath(object, path, newValue) {
    var _getLastOfPath = $ddce666daee6ccef$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $ddce666daee6ccef$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $ddce666daee6ccef$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $ddce666daee6ccef$var$getPath(object, path) {
    var _getLastOfPath3 = $ddce666daee6ccef$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $ddce666daee6ccef$var$getPathWithDefaults(data, defaultData, key) {
    var value = $ddce666daee6ccef$var$getPath(data, key);
    if (value !== undefined) return value;
    return $ddce666daee6ccef$var$getPath(defaultData, key);
}
function $ddce666daee6ccef$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== '__proto__') {
        if (prop in target) {
            if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $ddce666daee6ccef$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $ddce666daee6ccef$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var $ddce666daee6ccef$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
function $ddce666daee6ccef$var$escape(data) {
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, function(s) {
        return $ddce666daee6ccef$var$_entityMap[s];
    });
    return data;
}
var $ddce666daee6ccef$var$isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var $ddce666daee6ccef$var$ResourceStore = function(_EventEmitter) {
    (0, $88ee7bb5d2406c72$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        (0, $bc7b0385e56411c4$export$2e2bcd8739ae039)(this, ResourceStore);
        _this = (0, $f0bd8fa07e04fc6e$export$2e2bcd8739ae039)(this, (0, $6c62fc255ea97813$export$2e2bcd8739ae039)(ResourceStore).call(this));
        if ($ddce666daee6ccef$var$isIE10) $ddce666daee6ccef$var$EventEmitter.call((0, $45Uts.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        return _this;
    }
    (0, $ct8ww.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== 'string') path = path.concat(key);
                if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) path = lng.split('.');
                return $ddce666daee6ccef$var$getPath(this.data, path);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = '.';
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $ddce666daee6ccef$var$setPath(this.data, path, value);
                if (!options.silent) this.emit('added', lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $ddce666daee6ccef$var$getPath(this.data, path) || {};
                if (deep) $ddce666daee6ccef$var$deepExtend(pack, resources, overwrite);
                else pack = (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, pack, resources);
                $ddce666daee6ccef$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit('removed', lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === 'v1') return (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, {}, this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($ddce666daee6ccef$var$EventEmitter);
var $ddce666daee6ccef$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
var $ddce666daee6ccef$var$checkedLoadedFor = {};
var $ddce666daee6ccef$var$Translator = function(_EventEmitter) {
    (0, $88ee7bb5d2406c72$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $bc7b0385e56411c4$export$2e2bcd8739ae039)(this, Translator);
        _this = (0, $f0bd8fa07e04fc6e$export$2e2bcd8739ae039)(this, (0, $6c62fc255ea97813$export$2e2bcd8739ae039)(Translator).call(this));
        if ($ddce666daee6ccef$var$isIE10) $ddce666daee6ccef$var$EventEmitter.call((0, $45Uts.default)(_this));
        $ddce666daee6ccef$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, (0, $45Uts.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        _this.logger = $ddce666daee6ccef$var$baseLogger.create('translator');
        return _this;
    }
    (0, $ct8ww.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ':';
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS;
                if (nsSeparator && key.indexOf(nsSeparator) > -1) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $6vszX.default)(options) !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return '';
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === 'cimode') {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        return namespace + nsSeparator + key;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    '[object Number]',
                    '[object Function]',
                    '[object RegExp]'
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === '[object Array]';
                        var copy$$1 = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy$$1[m] = this.translate(deepKey, (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, options, {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy$$1[m] === deepKey) copy$$1[m] = res[m];
                        }
                        res = copy$$1;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
                        usedDefault = true;
                        if (options.count !== undefined) {
                            var suffix = this.pluralResolver.getSuffix(lng, options.count);
                            res = options["defaultValue".concat(suffix)];
                        }
                        if (!res) res = options.defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, options, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k) {
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
                            _this2.emit('missingKey', l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(l) {
                                var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);
                                plurals.forEach(function(p) {
                                    return send([
                                        l
                                    ], p);
                                });
                            });
                            else send(lngs, key);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init((0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, options, {
                        interpolation: (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, this.options.interpolation, options.interpolation)
                    }));
                    var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, this.options.interpolation.defaultVariables, data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0]) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === 'string' ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $ddce666daee6ccef$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === 'string') keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$ddce666daee6ccef$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $ddce666daee6ccef$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKey = key;
                            var finalKeys = [
                                finalKey
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
                                if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
                                if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
                                if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ]);
    return Translator;
}($ddce666daee6ccef$var$EventEmitter);
function $ddce666daee6ccef$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $ddce666daee6ccef$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $bc7b0385e56411c4$export$2e2bcd8739ae039)(this, LanguageUtil);
        this.options = options;
        this.whitelist = this.options.supportedLngs || false;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $ddce666daee6ccef$var$baseLogger.create('languageUtils');
    }
    (0, $ct8ww.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return null;
                var p = code.split('-');
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === 'x') return null;
                return this.formatLanguageCode(p.join('-'));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return code;
                var p = code.split('-');
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    var specialCases = [
                        'hans',
                        'hant',
                        'latn',
                        'cyrl',
                        'cans',
                        'mong',
                        'arab'
                    ];
                    var p = code.split('-');
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $ddce666daee6ccef$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $ddce666daee6ccef$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $ddce666daee6ccef$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join('-');
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isWhitelisted",
            value: function isWhitelisted(code) {
                this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
                return this.isSupportedCode(code);
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === 'string') fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
                    if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $ddce666daee6ccef$var$sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'kk',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $ddce666daee6ccef$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
function $ddce666daee6ccef$var$createRules() {
    var rules = {};
    $ddce666daee6ccef$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $ddce666daee6ccef$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $ddce666daee6ccef$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $bc7b0385e56411c4$export$2e2bcd8739ae039)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $ddce666daee6ccef$var$baseLogger.create('pluralResolver');
        this.rules = $ddce666daee6ccef$var$createRules();
    }
    (0, $ct8ww.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var rule = this.getRule(code);
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var _this = this;
                var ret = [];
                var rule = this.getRule(code);
                if (!rule) return ret;
                rule.numbers.forEach(function(n) {
                    var suffix = _this.getSuffix(code, n);
                    ret.push("".concat(key).concat(suffix));
                });
                return ret;
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var _this2 = this;
                var rule = this.getRule(code);
                if (rule) {
                    var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                    var suffix = rule.numbers[idx];
                    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                        if (suffix === 2) suffix = 'plural';
                        else if (suffix === 1) suffix = '';
                    }
                    var returnSuffix = function returnSuffix() {
                        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                    };
                    if (this.options.compatibilityJSON === 'v1') {
                        if (suffix === 1) return '';
                        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
                        return returnSuffix();
                    } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
                    else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return '';
            }
        }
    ]);
    return PluralResolver;
}();
var $ddce666daee6ccef$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $bc7b0385e56411c4$export$2e2bcd8739ae039)(this, Interpolator);
        this.logger = $ddce666daee6ccef$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $ct8ww.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $ddce666daee6ccef$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $ddce666daee6ccef$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
                this.suffix = iOpts.suffix ? $ddce666daee6ccef$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
                this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
                this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
                this.nestingPrefix = iOpts.nestingPrefix ? $ddce666daee6ccef$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $ddce666daee6ccef$var$regexEscape('$t(');
                this.nestingSuffix = iOpts.nestingSuffix ? $ddce666daee6ccef$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $ddce666daee6ccef$var$regexEscape(')');
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, 'g');
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, '$$$$');
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $ddce666daee6ccef$var$getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($ddce666daee6ccef$var$getPathWithDefaults(data, defaultData, k), f, lng, options);
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        value = handleFormat(match[1].trim());
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === 'function') {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === 'string' ? temp : '';
                            } else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
                                value = '';
                            }
                        } else if (typeof value !== 'string' && !_this.useRawValueToEscape) value = $ddce666daee6ccef$var$makeString(value);
                        str = str.replace(match[0], todo.safeValue(value));
                        todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, inheritedOptions, clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== 'string') return value;
                    if (typeof value !== 'string') value = $ddce666daee6ccef$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = '';
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, options);
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $ddce666daee6ccef$var$remove(arr, what) {
    var found = arr.indexOf(what);
    while(found !== -1){
        arr.splice(found, 1);
        found = arr.indexOf(what);
    }
}
var $ddce666daee6ccef$var$Connector = function(_EventEmitter) {
    (0, $88ee7bb5d2406c72$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $bc7b0385e56411c4$export$2e2bcd8739ae039)(this, Connector);
        _this = (0, $f0bd8fa07e04fc6e$export$2e2bcd8739ae039)(this, (0, $6c62fc255ea97813$export$2e2bcd8739ae039)(Connector).call(this));
        if ($ddce666daee6ccef$var$isIE10) $ddce666daee6ccef$var$EventEmitter.call((0, $45Uts.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $ddce666daee6ccef$var$baseLogger.create('backendConnector');
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $ct8ww.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = [];
                var pending = [];
                var toLoadLanguages = [];
                var toLoadNamespaces = [];
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending.indexOf(name) < 0) pending.push(name);
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending.indexOf(name) < 0) pending.push(name);
                            if (toLoad.indexOf(name) < 0) toLoad.push(name);
                            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages.push(lng);
                });
                if (toLoad.length || pending.length) this.queue.push({
                    pending: pending,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: toLoad,
                    pending: pending,
                    toLoadLanguages: toLoadLanguages,
                    toLoadNamespaces: toLoadNamespaces
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit('failedLoading', lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $ddce666daee6ccef$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $ddce666daee6ccef$var$remove(q.pending, name);
                    if (err) q.errors.push(err);
                    if (q.pending.length === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = [];
                            if (q.loaded[l].length) q.loaded[l].forEach(function(ns) {
                                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit('loaded', loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                return this.backend[fcName](lng, ns, function(err, data) {
                    if (err && data && tried < 5) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn('No backend was added via i18next.use. Will not load resources.');
                    return callback && callback();
                }
                if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, 'read', undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                    return;
                }
                if (key === undefined || key === null || key === '') return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, options, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($ddce666daee6ccef$var$EventEmitter);
function $ddce666daee6ccef$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        whitelist: false,
        nonExplicitWhitelist: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $6vszX.default)(args[1]) === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if ((0, $6vszX.default)(args[2]) === 'object' || (0, $6vszX.default)(args[3]) === 'object') {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: false
        }
    };
}
function $ddce666daee6ccef$var$transformOptions(options) {
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.whitelist) {
        if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist = options.whitelist.concat([
            'cimode'
        ]);
        options.supportedLngs = options.whitelist;
    }
    if (options.nonExplicitWhitelist) options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
}
function $ddce666daee6ccef$var$noop() {}
var $ddce666daee6ccef$var$I18n = function(_EventEmitter) {
    (0, $88ee7bb5d2406c72$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $bc7b0385e56411c4$export$2e2bcd8739ae039)(this, I18n);
        _this = (0, $f0bd8fa07e04fc6e$export$2e2bcd8739ae039)(this, (0, $6c62fc255ea97813$export$2e2bcd8739ae039)(I18n).call(this));
        if ($ddce666daee6ccef$var$isIE10) $ddce666daee6ccef$var$EventEmitter.call((0, $45Uts.default)(_this));
        _this.options = $ddce666daee6ccef$var$transformOptions(options);
        _this.services = {};
        _this.logger = $ddce666daee6ccef$var$baseLogger;
        _this.modules = {
            external: []
        };
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $f0bd8fa07e04fc6e$export$2e2bcd8739ae039)(_this, (0, $45Uts.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $ct8ww.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (options.whitelist && !options.supportedLngs) this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
                if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
                this.options = (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, $ddce666daee6ccef$var$get(), this.options, $ddce666daee6ccef$var$transformOptions(options));
                this.format = this.options.interpolation.format;
                if (!callback) callback = $ddce666daee6ccef$var$noop;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === 'function') return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $ddce666daee6ccef$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $ddce666daee6ccef$var$baseLogger.init(null, this.options);
                    var lu = new $ddce666daee6ccef$var$LanguageUtil(this.options);
                    this.store = new $ddce666daee6ccef$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $ddce666daee6ccef$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $ddce666daee6ccef$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    s.interpolator = new $ddce666daee6ccef$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $ddce666daee6ccef$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on('*', function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $ddce666daee6ccef$var$Translator(this.services, this.options);
                    this.translator.on('*', function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                if (!this.modules.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
                var storeApi = [
                    'getResource',
                    'addResource',
                    'addResources',
                    'addResourceBundle',
                    'removeResourceBundle',
                    'hasResourceBundle',
                    'getResourceBundle',
                    'getDataByLanguage'
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var deferred = $ddce666daee6ccef$var$defer();
                var load = function load() {
                    _this2.changeLanguage(_this2.options.lng, function(err, t) {
                        _this2.isInitialized = true;
                        _this2.logger.log('initialized', _this2.options);
                        _this2.emit('initialized', _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    });
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ddce666daee6ccef$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === 'string' ? language : this.language;
                if (typeof language === 'function') usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $ddce666daee6ccef$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $ddce666daee6ccef$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
                if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
                if (module.type === 'backend') this.modules.backend = module;
                if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === 'languageDetector') this.modules.languageDetector = module;
                if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
                if (module.type === 'postProcessor') $ddce666daee6ccef$var$postProcessor.addPostProcessor(module);
                if (module.type === '3rdParty') this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $ddce666daee6ccef$var$defer();
                this.emit('languageChanging', lng);
                var done = function done(err, l) {
                    if (l) {
                        _this4.language = l;
                        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit('languageChanged', l);
                        _this4.logger.log('languageChanged', l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) {
                            _this4.language = l;
                            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        }
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $6vszX.default)(opts) !== 'object') {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    return _this5.t(key, options);
                };
                if (typeof lng === 'string') fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
                    return false;
                }
                var lng = this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === 'cimode') return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $ddce666daee6ccef$var$defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === 'string') ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $ddce666daee6ccef$var$defer();
                if (typeof lngs === 'string') lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
                if (!lng) return 'rtl';
                var rtlLngs = [
                    'ar',
                    'shu',
                    'sqr',
                    'ssh',
                    'xaa',
                    'yhd',
                    'yud',
                    'aao',
                    'abh',
                    'abv',
                    'acm',
                    'acq',
                    'acw',
                    'acx',
                    'acy',
                    'adf',
                    'ads',
                    'aeb',
                    'aec',
                    'afb',
                    'ajp',
                    'apc',
                    'apd',
                    'arb',
                    'arq',
                    'ars',
                    'ary',
                    'arz',
                    'auz',
                    'avl',
                    'ayh',
                    'ayl',
                    'ayn',
                    'ayp',
                    'bbz',
                    'pga',
                    'he',
                    'iw',
                    'ps',
                    'pbt',
                    'pbu',
                    'pst',
                    'prp',
                    'prd',
                    'ug',
                    'ur',
                    'ydd',
                    'yds',
                    'yih',
                    'ji',
                    'yi',
                    'hbo',
                    'men',
                    'xmn',
                    'fa',
                    'jpr',
                    'peo',
                    'pes',
                    'prs',
                    'dv',
                    'sam'
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
            }
        },
        {
            key: "createInstance",
            value: function createInstance() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                return new I18n(options, callback);
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ddce666daee6ccef$var$noop;
                var mergedOptions = (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, this.options, options, {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                var membersToCopy = [
                    'store',
                    'services',
                    'language'
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = (0, $1ec9015ff660489a$export$2e2bcd8739ae039)({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $ddce666daee6ccef$var$Translator(clone.services, clone.options);
                clone.translator.on('*', function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        }
    ]);
    return I18n;
}($ddce666daee6ccef$var$EventEmitter);
var $ddce666daee6ccef$var$i18next = new $ddce666daee6ccef$var$I18n();
var $ddce666daee6ccef$export$2e2bcd8739ae039 = $ddce666daee6ccef$var$i18next;


var $df5279312cc03979$exports = {};
function $df5279312cc03979$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$df5279312cc03979$exports = $df5279312cc03979$var$_classCallCheck, $df5279312cc03979$exports.__esModule = true, $df5279312cc03979$exports["default"] = $df5279312cc03979$exports;


var $7db84cf7586b02a1$exports = {};
var $bfaf4f1cddf9b523$exports = {};
var $3d93096d0d6169cd$exports = {};
function $3d93096d0d6169cd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3d93096d0d6169cd$exports = $3d93096d0d6169cd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3d93096d0d6169cd$exports.__esModule = true, $3d93096d0d6169cd$exports["default"] = $3d93096d0d6169cd$exports, $3d93096d0d6169cd$var$_typeof(o);
}
$3d93096d0d6169cd$exports = $3d93096d0d6169cd$var$_typeof, $3d93096d0d6169cd$exports.__esModule = true, $3d93096d0d6169cd$exports["default"] = $3d93096d0d6169cd$exports;


var $bfaf4f1cddf9b523$var$_typeof = $3d93096d0d6169cd$exports.default;
var $0d7b7fdd5ba11c76$exports = {};

var $0d7b7fdd5ba11c76$var$_typeof = $3d93096d0d6169cd$exports.default;
function $0d7b7fdd5ba11c76$var$toPrimitive(t, r) {
    if ("object" != $0d7b7fdd5ba11c76$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0d7b7fdd5ba11c76$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$0d7b7fdd5ba11c76$exports = $0d7b7fdd5ba11c76$var$toPrimitive, $0d7b7fdd5ba11c76$exports.__esModule = true, $0d7b7fdd5ba11c76$exports["default"] = $0d7b7fdd5ba11c76$exports;


function $bfaf4f1cddf9b523$var$toPropertyKey(t) {
    var i = $0d7b7fdd5ba11c76$exports(t, "string");
    return "symbol" == $bfaf4f1cddf9b523$var$_typeof(i) ? i : i + "";
}
$bfaf4f1cddf9b523$exports = $bfaf4f1cddf9b523$var$toPropertyKey, $bfaf4f1cddf9b523$exports.__esModule = true, $bfaf4f1cddf9b523$exports["default"] = $bfaf4f1cddf9b523$exports;


function $7db84cf7586b02a1$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $bfaf4f1cddf9b523$exports(o.key), o);
    }
}
function $7db84cf7586b02a1$var$_createClass(e, r, t) {
    return r && $7db84cf7586b02a1$var$_defineProperties(e.prototype, r), t && $7db84cf7586b02a1$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$7db84cf7586b02a1$exports = $7db84cf7586b02a1$var$_createClass, $7db84cf7586b02a1$exports.__esModule = true, $7db84cf7586b02a1$exports["default"] = $7db84cf7586b02a1$exports;


var $46d6e0f6ddaa3991$exports = {};

function $46d6e0f6ddaa3991$var$_defineProperty(e, r, t) {
    return (r = $bfaf4f1cddf9b523$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$46d6e0f6ddaa3991$exports = $46d6e0f6ddaa3991$var$_defineProperty, $46d6e0f6ddaa3991$exports.__esModule = true, $46d6e0f6ddaa3991$exports["default"] = $46d6e0f6ddaa3991$exports;



var $3OyDL = parcelRequire("3OyDL");
function $fc39639f6f9b74a5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fc39639f6f9b74a5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $fc39639f6f9b74a5$var$ownKeys(source, true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($46d6e0f6ddaa3991$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $fc39639f6f9b74a5$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $fc39639f6f9b74a5$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true
};
var $fc39639f6f9b74a5$var$i18nInstance;
var $fc39639f6f9b74a5$export$5603ab5ced17ce64 = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createContext();
function $fc39639f6f9b74a5$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $fc39639f6f9b74a5$var$defaultOptions = $fc39639f6f9b74a5$var$_objectSpread({}, $fc39639f6f9b74a5$var$defaultOptions, {}, options);
}
function $fc39639f6f9b74a5$export$212bb2fc580a90a8() {
    return $fc39639f6f9b74a5$var$defaultOptions;
}
var $fc39639f6f9b74a5$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($df5279312cc03979$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7db84cf7586b02a1$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $fc39639f6f9b74a5$export$a039134f2fc7e0(instance) {
    $fc39639f6f9b74a5$var$i18nInstance = instance;
}
function $fc39639f6f9b74a5$export$64af334f494c2f47() {
    return $fc39639f6f9b74a5$var$i18nInstance;
}
var $fc39639f6f9b74a5$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init: function init(instance) {
        $fc39639f6f9b74a5$export$2e2366488d12e20d(instance.options.react);
        $fc39639f6f9b74a5$export$a039134f2fc7e0(instance);
    }
};
function $fc39639f6f9b74a5$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $fc39639f6f9b74a5$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($fc39639f6f9b74a5$var$_objectSpread({}, componentsInitialProps, {}, i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $fc39639f6f9b74a5$export$704200e5d0b9e8f() {
    var i18n = $fc39639f6f9b74a5$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


var $654ffe0449ba0221$exports = {};
$654ffe0449ba0221$exports = JSON.parse("{\"labels\":{\"family\":\"Familiengeschichte\",\"events\":\"Skatturniere\",\"gallery\":\"Galerie\",\"locations\":\"Veranstaltungsorte\",\"familyTree\":\"Stammbaum\",\"familyMember\":\"Familienmitglieder\",\"tree\":\"Stammbaum\",\"calendar\":\"Kalender\",\"table\":\"Mitgliederliste\",\"map\":\"Wohnorte\",\"userProfile\":\"Nutzerprofil\",\"statistics\":\"Statistiken\",\"imprint\":\"Impressum\",\"security\":\"Datenschutz\",\"ottoMeissner\":\"Otto Meissner\",\"niederstaucha\":\"Niederstaucha\",\"leipzig\":\"Leipzig\"},\"options\":{\"einfach\":\"Einfach\",\"schneider\":\"Schneider\",\"schwarz\":\"Schwarz\",\"hand\":\"Hand\",\"handSchneider\":\"Hand Schneider\",\"handSchwarz\":\"Hand Schwarz\",\"handSchneiderAngesagt\":\"Hand Schneider angesagt\",\"handSchneiderAngesagtSchwarz\":\"Hand Schneider angesagt Schwarz\",\"handSchwarzAngesagt\":\"Hand Schwarz angesagt\",\"handOuvert\":\"Hand Ouvert\",\"ouvert\":\"Ouvert\"}}");


var $70a04d78b8274455$exports = {};
$70a04d78b8274455$exports = JSON.parse("{\"common\":{\"submit\":\"Submit\",\"cancel\":\"Cancel\",\"info\":\"Weitere Informationen\"}}");


localStorage.setItem('language', 'de-DE');
const $3925bbd7166fcead$var$resources = {
    de: Object.assign((0, (/*@__PURE__*/$parcel$interopDefault($654ffe0449ba0221$exports)))),
    en: Object.assign((0, (/*@__PURE__*/$parcel$interopDefault($70a04d78b8274455$exports))))
};
var $3925bbd7166fcead$export$2e2bcd8739ae039 = $3925bbd7166fcead$var$resources;


(0, $ddce666daee6ccef$export$2e2bcd8739ae039).use((0, $fc39639f6f9b74a5$export$ae7e14d40d89f296)).init({
    resources: $3925bbd7166fcead$export$2e2bcd8739ae039,
    lng: 'de',
    keySeparator: false,
    interpolation: {
        escapeValue: false
    }
});
var $0c070eccaf065f25$export$2e2bcd8739ae039 = (0, $ddce666daee6ccef$export$2e2bcd8739ae039);



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");


var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");

var $2DySd = parcelRequire("2DySd");

var $ktnoN = parcelRequire("ktnoN");
var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $798ep = parcelRequire("798ep");

var $a3DMF = parcelRequire("a3DMF");
const $69603c939df88ab4$var$_excluded = [
    "sx"
];
const $69603c939df88ab4$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $a3DMF.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $69603c939df88ab4$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $aBenZ.default)(props, $69603c939df88ab4$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $69603c939df88ab4$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $798ep.isPlainObject)(result)) return systemProps;
        return (0, $gOPoC.default)({}, systemProps, result);
    };
    else finalSx = (0, $gOPoC.default)({}, systemProps, inSx);
    return (0, $gOPoC.default)({}, otherProps, {
        sx: finalSx
    });
}



var $9oaul = parcelRequire("9oaul");

var $2M70Q = parcelRequire("2M70Q");
'use client';
const $eaca1935d89bf7b0$var$_excluded = [
    "className",
    "component"
];
function $eaca1935d89bf7b0$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $2DySd.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $ktnoN.default));
    const Box = /*#__PURE__*/ $3OyDL.forwardRef(function Box(inProps, ref) {
        const theme = (0, $9oaul.default)(defaultTheme);
        const _extendSxProp = (0, $69603c939df88ab4$export$2e2bcd8739ae039)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $aBenZ.default)(_extendSxProp, $eaca1935d89bf7b0$var$_excluded);
        return /*#__PURE__*/ (0, $2M70Q.jsx)(BoxRoot, (0, $gOPoC.default)({
            as: component,
            ref: ref,
            className: (0, $3DmQB.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $jFRWu = parcelRequire("jFRWu");

var $hsK2b = parcelRequire("hsK2b");

var $joa2L = parcelRequire("joa2L");
'use client';
const $2daf4a960b0a0c38$var$defaultTheme = (0, $hsK2b.default)();
const $2daf4a960b0a0c38$var$Box = (0, $eaca1935d89bf7b0$export$2e2bcd8739ae039)({
    themeId: (0, $joa2L.default),
    defaultTheme: $2daf4a960b0a0c38$var$defaultTheme,
    defaultClassName: 'MuiBox-root',
    generateClassName: (0, $jFRWu.default).generate
});
var $2daf4a960b0a0c38$export$2e2bcd8739ae039 = $2daf4a960b0a0c38$var$Box;


var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");
var $3693fc9387266795$exports = {};
'use strict';

$3693fc9387266795$exports = (parcelRequire("6wK2u"));




var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");
var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $3d851111a0dedfa6$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $c9f4324d1af2c9eb$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $3OyDL.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $3d851111a0dedfa6$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}



var $gOPoC = parcelRequire("gOPoC");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $03d7e3d159693402$export$e28348cc2430497(element) {
    return typeof element === 'string';
}


function $72a4660f5b097d47$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $03d7e3d159693402$export$e28348cc2430497)(elementType)) return otherProps;
    return (0, $gOPoC.default)({}, otherProps, {
        ownerState: (0, $gOPoC.default)({}, otherProps.ownerState, ownerState)
    });
}



var $gOPoC = parcelRequire("gOPoC");

var $3DmQB = parcelRequire("3DmQB");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $490c663e21a90948$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $968179a5918e3ed5$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $ae8bea07f7dd9dea$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $3DmQB.default)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $gOPoC.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $gOPoC.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $490c663e21a90948$export$24d5698b57eff81c)((0, $gOPoC.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $968179a5918e3ed5$export$2ac0fa4d3a39be45)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $968179a5918e3ed5$export$2ac0fa4d3a39be45)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $3DmQB.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $gOPoC.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $gOPoC.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $412af8dc0ce10993$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}


'use client';
const $9be467578d9a8fea$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $9be467578d9a8fea$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $aBenZ.default)(parameters, $9be467578d9a8fea$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $412af8dc0ce10993$export$308c24034cde71de)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $ae8bea07f7dd9dea$export$b01d1e419b049226)((0, $gOPoC.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $c9f4324d1af2c9eb$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $72a4660f5b097d47$export$b089efb01a7bdf50)(elementType, (0, $gOPoC.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $g4LX8 = parcelRequire("g4LX8");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $fc740a68946b02a5$export$24c1f8f60cbac79e(slot) {
    return (0, $6AMoU.default)('MuiTypography', slot);
}
const $fc740a68946b02a5$var$typographyClasses = (0, $ithJf.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $fc740a68946b02a5$export$2e2bcd8739ae039 = $fc740a68946b02a5$var$typographyClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $c015ac4126046deb$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $c015ac4126046deb$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $g4LX8.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $fc740a68946b02a5$export$24c1f8f60cbac79e), classes);
};
const $c015ac4126046deb$export$140e2f5526d3cad8 = (0, $jH1k7.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $g4LX8.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $c015ac4126046deb$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $c015ac4126046deb$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $c015ac4126046deb$var$transformDeprecatedColors = (color)=>{
    return $c015ac4126046deb$var$colorTransformations[color] || color;
};
const $c015ac4126046deb$var$Typography = /*#__PURE__*/ $3OyDL.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $c015ac4126046deb$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $69603c939df88ab4$export$2e2bcd8739ae039)((0, $gOPoC.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $c015ac4126046deb$var$defaultVariantMapping } = props, other = (0, $aBenZ.default)(props, $c015ac4126046deb$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $c015ac4126046deb$var$defaultVariantMapping[variant]) || 'span';
    const classes = $c015ac4126046deb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($c015ac4126046deb$export$140e2f5526d3cad8, (0, $gOPoC.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $3DmQB.default)(classes.root, className)
    }, other));
});
var $c015ac4126046deb$export$2e2bcd8739ae039 = $c015ac4126046deb$var$Typography;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");
parcelRequire("3OyDL");


var $7m2iU = parcelRequire("7m2iU");

var $jH1k7 = parcelRequire("jH1k7");
parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $c6062fb7687188e5$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $3OyDL = parcelRequire("3OyDL");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $f467f10ba40ab30d$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $accb486119812d2f$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $3OyDL.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $f467f10ba40ab30d$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $a31efceb4de56944$export$2e2bcd8739ae039 = (0, $accb486119812d2f$export$2e2bcd8739ae039);



var $3OyDL = parcelRequire("3OyDL");

var $3OyDL = parcelRequire("3OyDL");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $8f90f522593e04a8$var$useEnhancedEffect = typeof window !== 'undefined' ? $3OyDL.useLayoutEffect : $3OyDL.useEffect;
var $8f90f522593e04a8$export$2e2bcd8739ae039 = $8f90f522593e04a8$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $0199acdbeaee80c9$var$useEventCallback(fn) {
    const ref = $3OyDL.useRef(fn);
    (0, $8f90f522593e04a8$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $3OyDL.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $0199acdbeaee80c9$export$2e2bcd8739ae039 = $0199acdbeaee80c9$var$useEventCallback;


'use client';
var $614ff53a4e7d9506$export$2e2bcd8739ae039 = (0, $0199acdbeaee80c9$export$2e2bcd8739ae039);



var $3OyDL = parcelRequire("3OyDL");

var $3OyDL = parcelRequire("3OyDL");
'use client';
const $21de44ff98c383ca$var$UNINITIALIZED = {};
function $21de44ff98c383ca$export$2e2bcd8739ae039(init, initArg) {
    const ref = $3OyDL.useRef($21de44ff98c383ca$var$UNINITIALIZED);
    if (ref.current === $21de44ff98c383ca$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $3OyDL = parcelRequire("3OyDL");
'use client';
const $a764b3c06c01181f$var$EMPTY = [];
function $a764b3c06c01181f$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $3OyDL.useEffect(fn, $a764b3c06c01181f$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $6fc9e03ffa285ee6$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $6fc9e03ffa285ee6$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $6fc9e03ffa285ee6$export$2e2bcd8739ae039() {
    const timeout = (0, $21de44ff98c383ca$export$2e2bcd8739ae039)($6fc9e03ffa285ee6$export$786b4da70f00938b.create).current;
    (0, $a764b3c06c01181f$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $e4467b2c3ed4ff1b$var$hadKeyboardEvent = true;
let $e4467b2c3ed4ff1b$var$hadFocusVisibleRecently = false;
const $e4467b2c3ed4ff1b$var$hadFocusVisibleRecentlyTimeout = new (0, $6fc9e03ffa285ee6$export$786b4da70f00938b)();
const $e4467b2c3ed4ff1b$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $e4467b2c3ed4ff1b$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $e4467b2c3ed4ff1b$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $e4467b2c3ed4ff1b$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $e4467b2c3ed4ff1b$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $e4467b2c3ed4ff1b$var$handlePointerDown() {
    $e4467b2c3ed4ff1b$var$hadKeyboardEvent = false;
}
function $e4467b2c3ed4ff1b$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($e4467b2c3ed4ff1b$var$hadFocusVisibleRecently) $e4467b2c3ed4ff1b$var$hadKeyboardEvent = true;
    }
}
function $e4467b2c3ed4ff1b$var$prepare(doc) {
    doc.addEventListener('keydown', $e4467b2c3ed4ff1b$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $e4467b2c3ed4ff1b$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $e4467b2c3ed4ff1b$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $e4467b2c3ed4ff1b$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $e4467b2c3ed4ff1b$var$handleVisibilityChange, true);
}
function $e4467b2c3ed4ff1b$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $e4467b2c3ed4ff1b$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $e4467b2c3ed4ff1b$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $e4467b2c3ed4ff1b$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $e4467b2c3ed4ff1b$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $e4467b2c3ed4ff1b$var$handleVisibilityChange, true);
}
function $e4467b2c3ed4ff1b$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $e4467b2c3ed4ff1b$var$hadKeyboardEvent || $e4467b2c3ed4ff1b$var$focusTriggersKeyboardModality(target);
}
function $e4467b2c3ed4ff1b$export$2e2bcd8739ae039() {
    const ref = $3OyDL.useCallback((node)=>{
        if (node != null) $e4467b2c3ed4ff1b$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $3OyDL.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $e4467b2c3ed4ff1b$var$hadFocusVisibleRecently = true;
            $e4467b2c3ed4ff1b$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $e4467b2c3ed4ff1b$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($e4467b2c3ed4ff1b$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $4df9c68cc24f8d29$export$2e2bcd8739ae039 = (0, $e4467b2c3ed4ff1b$export$2e2bcd8739ae039);



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $45Uts = parcelRequire("45Uts");

var $jNtCy = parcelRequire("jNtCy");


var $3OyDL = parcelRequire("3OyDL");

var $3OyDL = parcelRequire("3OyDL");
var $2ae11cec99932928$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createContext(null);



var $3OyDL = parcelRequire("3OyDL");
function $12a063f1a1751691$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $3OyDL.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $3OyDL.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $12a063f1a1751691$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $12a063f1a1751691$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $12a063f1a1751691$export$fa71e2345c31d7a2(props, onExited) {
    return $12a063f1a1751691$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $3OyDL.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $12a063f1a1751691$var$getProp(child, 'appear', props),
            enter: $12a063f1a1751691$var$getProp(child, 'enter', props),
            exit: $12a063f1a1751691$var$getProp(child, 'exit', props)
        });
    });
}
function $12a063f1a1751691$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $12a063f1a1751691$export$bbc8a025727ea824(nextProps.children);
    var children = $12a063f1a1751691$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $3OyDL.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $3OyDL.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $3OyDL.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $12a063f1a1751691$var$getProp(child, 'exit', nextProps),
            enter: $12a063f1a1751691$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $3OyDL.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $3OyDL.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $3OyDL.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $12a063f1a1751691$var$getProp(child, 'exit', nextProps),
            enter: $12a063f1a1751691$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $08574b535870a4c0$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $08574b535870a4c0$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $08574b535870a4c0$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $jNtCy.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $45Uts.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $12a063f1a1751691$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $12a063f1a1751691$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $12a063f1a1751691$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $gOPoC.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $aBenZ.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $08574b535870a4c0$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement((0, $2ae11cec99932928$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement((0, $2ae11cec99932928$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Component);
$08574b535870a4c0$var$TransitionGroup.propTypes = {};
$08574b535870a4c0$var$TransitionGroup.defaultProps = $08574b535870a4c0$var$defaultProps;
var $08574b535870a4c0$export$2e2bcd8739ae039 = $08574b535870a4c0$var$TransitionGroup;



var $3DmQB = parcelRequire("3DmQB");

var $hDCOm = parcelRequire("hDCOm");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $2M70Q = parcelRequire("2M70Q");
'use client';
function $ce9a6946581658eb$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $3OyDL.useState(false);
    const rippleClassName = (0, $3DmQB.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $3DmQB.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $3OyDL.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
            className: childClassName
        })
    });
}
var $ce9a6946581658eb$export$2e2bcd8739ae039 = $ce9a6946581658eb$var$Ripple;



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $6c31c1a5b61598f2$export$b464606f735ab902(slot) {
    return (0, $6AMoU.default)('MuiTouchRipple', slot);
}
const $6c31c1a5b61598f2$var$touchRippleClasses = (0, $ithJf.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $6c31c1a5b61598f2$export$2e2bcd8739ae039 = $6c31c1a5b61598f2$var$touchRippleClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $92763fcf6be2255a$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $92763fcf6be2255a$var$_ = (t)=>t, $92763fcf6be2255a$var$_t, $92763fcf6be2255a$var$_t2, $92763fcf6be2255a$var$_t3, $92763fcf6be2255a$var$_t4;
const $92763fcf6be2255a$var$DURATION = 550;
const $92763fcf6be2255a$export$95d0c9356b2231a3 = 80;
const $92763fcf6be2255a$var$enterKeyframe = (0, $hDCOm.keyframes)($92763fcf6be2255a$var$_t || ($92763fcf6be2255a$var$_t = $92763fcf6be2255a$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $92763fcf6be2255a$var$exitKeyframe = (0, $hDCOm.keyframes)($92763fcf6be2255a$var$_t2 || ($92763fcf6be2255a$var$_t2 = $92763fcf6be2255a$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $92763fcf6be2255a$var$pulsateKeyframe = (0, $hDCOm.keyframes)($92763fcf6be2255a$var$_t3 || ($92763fcf6be2255a$var$_t3 = $92763fcf6be2255a$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $92763fcf6be2255a$export$f6b7418508c72c25 = (0, $jH1k7.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $92763fcf6be2255a$export$676cfe7b12693c4b = (0, $jH1k7.default)((0, $ce9a6946581658eb$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($92763fcf6be2255a$var$_t4 || ($92763fcf6be2255a$var$_t4 = $92763fcf6be2255a$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $6c31c1a5b61598f2$export$2e2bcd8739ae039).rippleVisible, $92763fcf6be2255a$var$enterKeyframe, $92763fcf6be2255a$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $6c31c1a5b61598f2$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $6c31c1a5b61598f2$export$2e2bcd8739ae039).child, (0, $6c31c1a5b61598f2$export$2e2bcd8739ae039).childLeaving, $92763fcf6be2255a$var$exitKeyframe, $92763fcf6be2255a$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $6c31c1a5b61598f2$export$2e2bcd8739ae039).childPulsate, $92763fcf6be2255a$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $92763fcf6be2255a$var$TouchRipple = /*#__PURE__*/ $3OyDL.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $aBenZ.default)(props, $92763fcf6be2255a$var$_excluded);
    const [ripples, setRipples] = $3OyDL.useState([]);
    const nextKey = $3OyDL.useRef(0);
    const rippleCallback = $3OyDL.useRef(null);
    $3OyDL.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $3OyDL.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $3OyDL.useRef(0);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $3OyDL.useRef(null);
    const container = $3OyDL.useRef(null);
    $3OyDL.useEffect(()=>{
        return ()=>{
            if (startTimer.current) clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $3OyDL.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $2M70Q.jsx)($92763fcf6be2255a$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $3DmQB.default)(classes.ripple, (0, $6c31c1a5b61598f2$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $3DmQB.default)(classes.rippleVisible, (0, $6c31c1a5b61598f2$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $3DmQB.default)(classes.ripplePulsate, (0, $6c31c1a5b61598f2$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $3DmQB.default)(classes.child, (0, $6c31c1a5b61598f2$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $3DmQB.default)(classes.childLeaving, (0, $6c31c1a5b61598f2$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $3DmQB.default)(classes.childPulsate, (0, $6c31c1a5b61598f2$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $92763fcf6be2255a$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $3OyDL.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $92763fcf6be2255a$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $3OyDL.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $3OyDL.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $3OyDL.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($92763fcf6be2255a$export$f6b7418508c72c25, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)((0, $6c31c1a5b61598f2$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $08574b535870a4c0$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $92763fcf6be2255a$export$2e2bcd8739ae039 = $92763fcf6be2255a$var$TouchRipple;



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $9143b5bffa452ec2$export$fccb0498dcd99783(slot) {
    return (0, $6AMoU.default)('MuiButtonBase', slot);
}
const $9143b5bffa452ec2$var$buttonBaseClasses = (0, $ithJf.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $9143b5bffa452ec2$export$2e2bcd8739ae039 = $9143b5bffa452ec2$var$buttonBaseClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $c582f66505800c92$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $c582f66505800c92$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $5jsOu.default)(slots, (0, $9143b5bffa452ec2$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $c582f66505800c92$export$7ec0dcc5e3cdcd36 = (0, $jH1k7.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $9143b5bffa452ec2$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $c582f66505800c92$var$ButtonBase = /*#__PURE__*/ $3OyDL.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $aBenZ.default)(props, $c582f66505800c92$var$_excluded);
    const buttonRef = $3OyDL.useRef(null);
    const rippleRef = $3OyDL.useRef(null);
    const handleRippleRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $4df9c68cc24f8d29$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $3OyDL.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $3OyDL.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $3OyDL.useState(false);
    $3OyDL.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $3OyDL.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $614ff53a4e7d9506$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $614ff53a4e7d9506$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $3OyDL.useRef(false);
    const handleKeyDown = (0, $614ff53a4e7d9506$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $614ff53a4e7d9506$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $gOPoC.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $c582f66505800c92$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($c582f66505800c92$export$7ec0dcc5e3cdcd36, (0, $gOPoC.default)({
        as: ComponentProp,
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $2M70Q.jsx)((0, $92763fcf6be2255a$export$2e2bcd8739ae039), (0, $gOPoC.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $c582f66505800c92$export$2e2bcd8739ae039 = $c582f66505800c92$var$ButtonBase;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $86bf59bfb771de03$var$_excluded = [
    "slots",
    "slotProps"
];
const $86bf59bfb771de03$var$BreadcrumbCollapsedButton = (0, $jH1k7.default)((0, $c582f66505800c92$export$2e2bcd8739ae039))(({ theme: theme })=>(0, $gOPoC.default)({
        display: 'flex',
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`
    }, theme.palette.mode === 'light' ? {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[700]
    } : {
        backgroundColor: theme.palette.grey[700],
        color: theme.palette.grey[100]
    }, {
        borderRadius: 2,
        '&:hover, &:focus': (0, $gOPoC.default)({}, theme.palette.mode === 'light' ? {
            backgroundColor: theme.palette.grey[200]
        } : {
            backgroundColor: theme.palette.grey[600]
        }),
        '&:active': (0, $gOPoC.default)({
            boxShadow: theme.shadows[0]
        }, theme.palette.mode === 'light' ? {
            backgroundColor: (0, $7m2iU.emphasize)(theme.palette.grey[200], 0.12)
        } : {
            backgroundColor: (0, $7m2iU.emphasize)(theme.palette.grey[600], 0.12)
        })
    }));
const $86bf59bfb771de03$var$BreadcrumbCollapsedIcon = (0, $jH1k7.default)((0, $c6062fb7687188e5$export$2e2bcd8739ae039))({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $86bf59bfb771de03$var$BreadcrumbCollapsed(props) {
    const { slots: slots = {}, slotProps: slotProps = {} } = props, otherProps = (0, $aBenZ.default)(props, $86bf59bfb771de03$var$_excluded);
    const ownerState = props;
    return /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($86bf59bfb771de03$var$BreadcrumbCollapsedButton, (0, $gOPoC.default)({
            focusRipple: true
        }, otherProps, {
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $2M70Q.jsx)($86bf59bfb771de03$var$BreadcrumbCollapsedIcon, (0, $gOPoC.default)({
                as: slots.CollapsedIcon,
                ownerState: ownerState
            }, slotProps.collapsedIcon))
        }))
    });
}
var $86bf59bfb771de03$export$2e2bcd8739ae039 = $86bf59bfb771de03$var$BreadcrumbCollapsed;



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $a91be0c413814ac5$export$17261110b18c8084(slot) {
    return (0, $6AMoU.default)('MuiBreadcrumbs', slot);
}
const $a91be0c413814ac5$var$breadcrumbsClasses = (0, $ithJf.default)('MuiBreadcrumbs', [
    'root',
    'ol',
    'li',
    'separator'
]);
var $a91be0c413814ac5$export$2e2bcd8739ae039 = $a91be0c413814ac5$var$breadcrumbsClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $ecd6c8d84b4b7e2d$var$_excluded = [
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "expandText",
    "itemsAfterCollapse",
    "itemsBeforeCollapse",
    "maxItems",
    "separator"
];
const $ecd6c8d84b4b7e2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        li: [
            'li'
        ],
        ol: [
            'ol'
        ],
        separator: [
            'separator'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $a91be0c413814ac5$export$17261110b18c8084), classes);
};
const $ecd6c8d84b4b7e2d$var$BreadcrumbsRoot = (0, $jH1k7.default)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
    name: 'MuiBreadcrumbs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $a91be0c413814ac5$export$2e2bcd8739ae039).li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $ecd6c8d84b4b7e2d$var$BreadcrumbsOl = (0, $jH1k7.default)('ol', {
    name: 'MuiBreadcrumbs',
    slot: 'Ol',
    overridesResolver: (props, styles)=>styles.ol
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
const $ecd6c8d84b4b7e2d$var$BreadcrumbsSeparator = (0, $jH1k7.default)('li', {
    name: 'MuiBreadcrumbs',
    slot: 'Separator',
    overridesResolver: (props, styles)=>styles.separator
})({
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
});
function $ecd6c8d84b4b7e2d$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $2M70Q.jsx)($ecd6c8d84b4b7e2d$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $ecd6c8d84b4b7e2d$var$Breadcrumbs = /*#__PURE__*/ $3OyDL.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiBreadcrumbs'
    });
    const { children: children, className: className, component: component = 'nav', slots: slots = {}, slotProps: slotProps = {}, expandText: expandText = 'Show path', itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = '/' } = props, other = (0, $aBenZ.default)(props, $ecd6c8d84b4b7e2d$var$_excluded);
    const [expanded, setExpanded] = $3OyDL.useState(false);
    const ownerState = (0, $gOPoC.default)({}, props, {
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    });
    const classes = $ecd6c8d84b4b7e2d$var$useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, $9be467578d9a8fea$export$1e5c9e6e4e15efe3)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState: ownerState
    });
    const listRef = $3OyDL.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $86bf59bfb771de03$export$2e2bcd8739ae039), {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $3OyDL.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ $3OyDL.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $2M70Q.jsx)($ecd6c8d84b4b7e2d$var$BreadcrumbsRoot, (0, $gOPoC.default)({
        ref: ref,
        component: component,
        color: "text.secondary",
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($ecd6c8d84b4b7e2d$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $ecd6c8d84b4b7e2d$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    }));
});
var $ecd6c8d84b4b7e2d$export$2e2bcd8739ae039 = $ecd6c8d84b4b7e2d$var$Breadcrumbs;


var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $jFgmT = parcelRequire("jFgmT");

var $gOPoC = parcelRequire("gOPoC");
parcelRequire("3OyDL");

parcelRequire("3OyDL");


var $b6qO8 = parcelRequire("b6qO8");

var $9oaul = parcelRequire("9oaul");

var $2M70Q = parcelRequire("2M70Q");
'use client';
function $b739e30face51156$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $9oaul.default)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b6qO8.default), {
        styles: globalStyles
    });
}
var $b739e30face51156$export$2e2bcd8739ae039 = $b739e30face51156$var$GlobalStyles;



var $1M38U = parcelRequire("1M38U");

var $joa2L = parcelRequire("joa2L");

var $2M70Q = parcelRequire("2M70Q");
'use client';
function $75fb50280c5459b0$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b739e30face51156$export$2e2bcd8739ae039), (0, $gOPoC.default)({}, props, {
        defaultTheme: (0, $1M38U.default),
        themeId: (0, $joa2L.default)
    }));
}
var $75fb50280c5459b0$export$2e2bcd8739ae039 = $75fb50280c5459b0$var$GlobalStyles;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $9a68738520314e8a$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $gOPoC.default)({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%'
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $9a68738520314e8a$export$32180ef41b15b513 = (theme)=>(0, $gOPoC.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $9a68738520314e8a$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, '')] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $gOPoC.default)({
        html: $9a68738520314e8a$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $gOPoC.default)({
            margin: 0
        }, $9a68738520314e8a$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $9a68738520314e8a$var$CssBaseline(inProps) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $75fb50280c5459b0$export$2e2bcd8739ae039), {
                styles: (theme)=>$9a68738520314e8a$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $9a68738520314e8a$export$2e2bcd8739ae039 = $9a68738520314e8a$var$CssBaseline;


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $3OyDL = parcelRequire("3OyDL");
'use client';
let $17b6a17d80ba65b8$var$globalId = 0;
function $17b6a17d80ba65b8$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $3OyDL.useState(idOverride);
    const id = idOverride || defaultId;
    $3OyDL.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $17b6a17d80ba65b8$var$globalId += 1;
            setDefaultId(`mui-${$17b6a17d80ba65b8$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $17b6a17d80ba65b8$var$maybeReactUseId = $3OyDL['useId'.toString()];
function $17b6a17d80ba65b8$export$2e2bcd8739ae039(idOverride) {
    if ($17b6a17d80ba65b8$var$maybeReactUseId !== undefined) {
        const reactId = $17b6a17d80ba65b8$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $17b6a17d80ba65b8$var$useGlobalId(idOverride);
}



var $g4LX8 = parcelRequire("g4LX8");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");



var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $3346e55fd2faf80d$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

function $35fb2c86e44ba0e8$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $3OyDL = parcelRequire("3OyDL");

var $3OyDL = parcelRequire("3OyDL");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $9df71761ea25deba$var$useEnhancedEffect = typeof window !== 'undefined' ? $3OyDL.useLayoutEffect : $3OyDL.useEffect;
var $9df71761ea25deba$export$2e2bcd8739ae039 = $9df71761ea25deba$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $fc6260e66a3c9db4$var$useEventCallback(fn) {
    const ref = $3OyDL.useRef(fn);
    (0, $9df71761ea25deba$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $3OyDL.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $fc6260e66a3c9db4$export$2e2bcd8739ae039 = $fc6260e66a3c9db4$var$useEventCallback;



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $e1cb3760e5db0309$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


function $f92353c1dc740692$export$2e2bcd8739ae039(node) {
    const doc = (0, $35fb2c86e44ba0e8$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Is a vertical scrollbar displayed?
function $05740a69bde6efdc$var$isOverflowing(container) {
    const doc = (0, $35fb2c86e44ba0e8$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $f92353c1dc740692$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $05740a69bde6efdc$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $05740a69bde6efdc$var$getPaddingRight(element) {
    return parseInt((0, $f92353c1dc740692$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $05740a69bde6efdc$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $05740a69bde6efdc$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$05740a69bde6efdc$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $05740a69bde6efdc$export$e1bd0c6150f13d96(element, show);
    });
}
function $05740a69bde6efdc$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $05740a69bde6efdc$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($05740a69bde6efdc$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $e1cb3760e5db0309$export$2e2bcd8739ae039)((0, $35fb2c86e44ba0e8$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$05740a69bde6efdc$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $35fb2c86e44ba0e8$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$05740a69bde6efdc$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $35fb2c86e44ba0e8$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $f92353c1dc740692$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $05740a69bde6efdc$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $05740a69bde6efdc$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $05740a69bde6efdc$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $05740a69bde6efdc$var$getHiddenSiblings(container);
        $05740a69bde6efdc$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $05740a69bde6efdc$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $05740a69bde6efdc$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $05740a69bde6efdc$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $05740a69bde6efdc$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $05740a69bde6efdc$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $05740a69bde6efdc$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $05740a69bde6efdc$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $678791228221ac2a$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $678791228221ac2a$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $678791228221ac2a$var$defaultManager = new (0, $05740a69bde6efdc$export$ce11c4ecd08cea67)();
function $678791228221ac2a$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $678791228221ac2a$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $3OyDL.useRef({});
    const mountNodeRef = $3OyDL.useRef(null);
    const modalRef = $3OyDL.useRef(null);
    const handleRef = (0, $c9f4324d1af2c9eb$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $3OyDL.useState(!open);
    const hasTransition = $678791228221ac2a$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $35fb2c86e44ba0e8$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $fc6260e66a3c9db4$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $678791228221ac2a$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $3OyDL.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $fc6260e66a3c9db4$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $05740a69bde6efdc$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $3OyDL.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $3OyDL.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $3OyDL.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $490c663e21a90948$export$24d5698b57eff81c)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $gOPoC.default)({}, propsEventHandlers, otherHandlers);
        return (0, $gOPoC.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $gOPoC.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $3346e55fd2faf80d$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $3346e55fd2faf80d$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}



var $5jsOu = parcelRequire("5jsOu");

var $3OyDL = parcelRequire("3OyDL");



var $2M70Q = parcelRequire("2M70Q");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $25bc699f83f7857d$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $25bc699f83f7857d$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $25bc699f83f7857d$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $25bc699f83f7857d$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $25bc699f83f7857d$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $25bc699f83f7857d$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($25bc699f83f7857d$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $25bc699f83f7857d$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$25bc699f83f7857d$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $25bc699f83f7857d$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $25bc699f83f7857d$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $25bc699f83f7857d$var$defaultGetTabbable, isEnabled: isEnabled = $25bc699f83f7857d$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $3OyDL.useRef(false);
    const sentinelStart = $3OyDL.useRef(null);
    const sentinelEnd = $3OyDL.useRef(null);
    const nodeToRestore = $3OyDL.useRef(null);
    const reactFocusEventTarget = $3OyDL.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $3OyDL.useRef(false);
    const rootRef = $3OyDL.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $c9f4324d1af2c9eb$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $3OyDL.useRef(null);
    $3OyDL.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $3OyDL.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $35fb2c86e44ba0e8$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $3OyDL.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $35fb2c86e44ba0e8$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $3OyDL.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}



var $3OyDL = parcelRequire("3OyDL");

var $dy6Cj = parcelRequire("dy6Cj");



var $2M70Q = parcelRequire("2M70Q");
'use client';
function $3b311f2fcf840ada$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $3b311f2fcf840ada$export$602eac185826482c = /*#__PURE__*/ $3OyDL.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $3OyDL.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $c9f4324d1af2c9eb$export$2e2bcd8739ae039)(/*#__PURE__*/ $3OyDL.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $9df71761ea25deba$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($3b311f2fcf840ada$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $9df71761ea25deba$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $3d851111a0dedfa6$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $3d851111a0dedfa6$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $3OyDL.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $3OyDL.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $2M70Q.jsx)($3OyDL.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2M70Q.jsx)($3OyDL.Fragment, {
        children: mountNode ? /*#__PURE__*/ $dy6Cj.createPortal(children, mountNode) : mountNode
    });
});



var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $aBenZ = parcelRequire("aBenZ");

var $jNtCy = parcelRequire("jNtCy");


var $3OyDL = parcelRequire("3OyDL");

var $dy6Cj = parcelRequire("dy6Cj");
var $7845abdd3f89787e$export$2e2bcd8739ae039 = {
    disabled: false
};




var $c3010db8cdef10e6$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $af8ce78d3d22dabd$export$bb38bb9a1161268 = 'unmounted';
var $af8ce78d3d22dabd$export$84cbff306f539230 = 'exited';
var $af8ce78d3d22dabd$export$df38205c966be359 = 'entering';
var $af8ce78d3d22dabd$export$78e9e6e3e014d60a = 'entered';
var $af8ce78d3d22dabd$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $af8ce78d3d22dabd$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $jNtCy.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $af8ce78d3d22dabd$export$84cbff306f539230;
                _this.appearStatus = $af8ce78d3d22dabd$export$df38205c966be359;
            } else initialStatus = $af8ce78d3d22dabd$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $af8ce78d3d22dabd$export$bb38bb9a1161268;
        else initialStatus = $af8ce78d3d22dabd$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $af8ce78d3d22dabd$export$bb38bb9a1161268) return {
            status: $af8ce78d3d22dabd$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $af8ce78d3d22dabd$export$df38205c966be359 && status !== $af8ce78d3d22dabd$export$78e9e6e3e014d60a) nextStatus = $af8ce78d3d22dabd$export$df38205c966be359;
            } else if (status === $af8ce78d3d22dabd$export$df38205c966be359 || status === $af8ce78d3d22dabd$export$78e9e6e3e014d60a) nextStatus = $af8ce78d3d22dabd$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $af8ce78d3d22dabd$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($dy6Cj))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $c3010db8cdef10e6$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $af8ce78d3d22dabd$export$84cbff306f539230) this.setState({
            status: $af8ce78d3d22dabd$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($dy6Cj))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $7845abdd3f89787e$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $af8ce78d3d22dabd$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $af8ce78d3d22dabd$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $af8ce78d3d22dabd$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($dy6Cj))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $7845abdd3f89787e$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $af8ce78d3d22dabd$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $af8ce78d3d22dabd$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $af8ce78d3d22dabd$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($dy6Cj))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $af8ce78d3d22dabd$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $aBenZ.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement((0, $2ae11cec99932928$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Component);
$af8ce78d3d22dabd$var$Transition.contextType = (0, $2ae11cec99932928$export$2e2bcd8739ae039);
$af8ce78d3d22dabd$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $af8ce78d3d22dabd$var$noop() {}
$af8ce78d3d22dabd$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $af8ce78d3d22dabd$var$noop,
    onEntering: $af8ce78d3d22dabd$var$noop,
    onEntered: $af8ce78d3d22dabd$var$noop,
    onExit: $af8ce78d3d22dabd$var$noop,
    onExiting: $af8ce78d3d22dabd$var$noop,
    onExited: $af8ce78d3d22dabd$var$noop
};
$af8ce78d3d22dabd$var$Transition.UNMOUNTED = $af8ce78d3d22dabd$export$bb38bb9a1161268;
$af8ce78d3d22dabd$var$Transition.EXITED = $af8ce78d3d22dabd$export$84cbff306f539230;
$af8ce78d3d22dabd$var$Transition.ENTERING = $af8ce78d3d22dabd$export$df38205c966be359;
$af8ce78d3d22dabd$var$Transition.ENTERED = $af8ce78d3d22dabd$export$78e9e6e3e014d60a;
$af8ce78d3d22dabd$var$Transition.EXITING = $af8ce78d3d22dabd$export$4aacc83d4d59139f;
var $af8ce78d3d22dabd$export$2e2bcd8739ae039 = $af8ce78d3d22dabd$var$Transition;



parcelRequire("3OyDL");

var $9oaul = parcelRequire("9oaul");

var $1M38U = parcelRequire("1M38U");

var $joa2L = parcelRequire("joa2L");
'use client';
function $a973137ee63d871f$export$2e2bcd8739ae039() {
    const theme = (0, $9oaul.default)((0, $1M38U.default));
    return theme[0, $joa2L.default] || theme;
}


const $737230c2f504d625$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $737230c2f504d625$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $2M70Q = parcelRequire("2M70Q");
'use client';
const $9c9203b21cd916fe$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $9c9203b21cd916fe$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $9c9203b21cd916fe$var$Fade = /*#__PURE__*/ $3OyDL.forwardRef(function Fade(props, ref) {
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $af8ce78d3d22dabd$export$2e2bcd8739ae039) } = props, other = (0, $aBenZ.default)(props, $9c9203b21cd916fe$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $3OyDL.useRef(null);
    const handleRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $737230c2f504d625$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $737230c2f504d625$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $737230c2f504d625$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)(TransitionComponent, (0, $gOPoC.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $3OyDL.cloneElement(children, (0, $gOPoC.default)({
                style: (0, $gOPoC.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $9c9203b21cd916fe$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $9c9203b21cd916fe$export$2e2bcd8739ae039 = $9c9203b21cd916fe$var$Fade;



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $015a0b4dbac81367$export$9927a91fd93152bd(slot) {
    return (0, $6AMoU.default)('MuiBackdrop', slot);
}
const $015a0b4dbac81367$var$backdropClasses = (0, $ithJf.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $015a0b4dbac81367$export$2e2bcd8739ae039 = $015a0b4dbac81367$var$backdropClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $32713ed66b3486bb$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $32713ed66b3486bb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $015a0b4dbac81367$export$9927a91fd93152bd), classes);
};
const $32713ed66b3486bb$var$BackdropRoot = (0, $jH1k7.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $32713ed66b3486bb$var$Backdrop = /*#__PURE__*/ $3OyDL.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $9c9203b21cd916fe$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $aBenZ.default)(props, $32713ed66b3486bb$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $32713ed66b3486bb$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $2M70Q.jsx)(TransitionComponent, (0, $gOPoC.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($32713ed66b3486bb$var$BackdropRoot, (0, $gOPoC.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $3DmQB.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $gOPoC.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $32713ed66b3486bb$export$2e2bcd8739ae039 = $32713ed66b3486bb$var$Backdrop;



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $bad91842fbb5eca1$export$67960e22b12a638d(slot) {
    return (0, $6AMoU.default)('MuiModal', slot);
}
const $bad91842fbb5eca1$var$modalClasses = (0, $ithJf.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $bad91842fbb5eca1$export$2e2bcd8739ae039 = $bad91842fbb5eca1$var$modalClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $52be310452cd31e6$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $52be310452cd31e6$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $bad91842fbb5eca1$export$67960e22b12a638d), classes);
};
const $52be310452cd31e6$var$ModalRoot = (0, $jH1k7.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $52be310452cd31e6$var$ModalBackdrop = (0, $jH1k7.default)((0, $32713ed66b3486bb$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $52be310452cd31e6$var$Modal = /*#__PURE__*/ $3OyDL.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $jFgmT.default)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $52be310452cd31e6$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $aBenZ.default)(props, $52be310452cd31e6$var$_excluded);
    const propsWithDefaults = (0, $gOPoC.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $678791228221ac2a$export$33ffd74ebf07f060)((0, $gOPoC.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $gOPoC.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $52be310452cd31e6$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $52be310452cd31e6$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $9be467578d9a8fea$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $3DmQB.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $9be467578d9a8fea$export$1e5c9e6e4e15efe3)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $gOPoC.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $3DmQB.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3b311f2fcf840ada$export$602eac185826482c), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)(RootSlot, (0, $gOPoC.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $2M70Q.jsx)(BackdropSlot, (0, $gOPoC.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $25bc699f83f7857d$export$34eba2437817a67b), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $3OyDL.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $52be310452cd31e6$export$2e2bcd8739ae039 = $52be310452cd31e6$var$Modal;




var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");

var $jH1k7 = parcelRequire("jH1k7");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $2dc5ab780f0487e2$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $2dc5ab780f0487e2$export$2e2bcd8739ae039 = $2dc5ab780f0487e2$var$getOverlayAlpha;



var $jFgmT = parcelRequire("jFgmT");


var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $8647ff7eed19b5b9$export$29cdb466b9b6f20b(slot) {
    return (0, $6AMoU.default)('MuiPaper', slot);
}
const $8647ff7eed19b5b9$var$paperClasses = (0, $ithJf.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $8647ff7eed19b5b9$export$2e2bcd8739ae039 = $8647ff7eed19b5b9$var$paperClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $38f1a2d6fcf2073b$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $38f1a2d6fcf2073b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $8647ff7eed19b5b9$export$29cdb466b9b6f20b), classes);
};
const $38f1a2d6fcf2073b$var$PaperRoot = (0, $jH1k7.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $gOPoC.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $gOPoC.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $7m2iU.alpha)('#fff', (0, $2dc5ab780f0487e2$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $7m2iU.alpha)('#fff', (0, $2dc5ab780f0487e2$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $38f1a2d6fcf2073b$var$Paper = /*#__PURE__*/ $3OyDL.forwardRef(function Paper(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $aBenZ.default)(props, $38f1a2d6fcf2073b$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $38f1a2d6fcf2073b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($38f1a2d6fcf2073b$var$PaperRoot, (0, $gOPoC.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $3DmQB.default)(classes.root, className),
        ref: ref
    }, other));
});
var $38f1a2d6fcf2073b$export$2e2bcd8739ae039 = $38f1a2d6fcf2073b$var$Paper;



var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $2fc9738b1d778be5$export$2177af0aa15c34c2(slot) {
    return (0, $6AMoU.default)('MuiDialog', slot);
}
const $2fc9738b1d778be5$var$dialogClasses = (0, $ithJf.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $2fc9738b1d778be5$export$2e2bcd8739ae039 = $2fc9738b1d778be5$var$dialogClasses;



var $3OyDL = parcelRequire("3OyDL");
const $63afba6451e451c6$var$DialogContext = /*#__PURE__*/ $3OyDL.createContext({});
var $63afba6451e451c6$export$2e2bcd8739ae039 = $63afba6451e451c6$var$DialogContext;





var $2M70Q = parcelRequire("2M70Q");
'use client';
const $ee30f4276828974b$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $ee30f4276828974b$var$DialogBackdrop = (0, $jH1k7.default)((0, $32713ed66b3486bb$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $ee30f4276828974b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $g4LX8.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $g4LX8.default)(scroll)}`,
            `paperWidth${(0, $g4LX8.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $2fc9738b1d778be5$export$2177af0aa15c34c2), classes);
};
const $ee30f4276828974b$var$DialogRoot = (0, $jH1k7.default)((0, $52be310452cd31e6$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $ee30f4276828974b$var$DialogContainer = (0, $jH1k7.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $g4LX8.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&:after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $ee30f4276828974b$var$DialogPaper = (0, $jH1k7.default)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $g4LX8.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $g4LX8.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $2fc9738b1d778be5$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $2fc9738b1d778be5$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $2fc9738b1d778be5$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $ee30f4276828974b$var$Dialog = /*#__PURE__*/ $3OyDL.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $9c9203b21cd916fe$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $aBenZ.default)(props, $ee30f4276828974b$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $ee30f4276828974b$var$useUtilityClasses(ownerState);
    const backdropClick = $3OyDL.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $17b6a17d80ba65b8$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $3OyDL.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($ee30f4276828974b$var$DialogRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $ee30f4276828974b$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $gOPoC.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)(TransitionComponent, (0, $gOPoC.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $2M70Q.jsx)($ee30f4276828974b$var$DialogContainer, {
                className: (0, $3DmQB.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $2M70Q.jsx)($ee30f4276828974b$var$DialogPaper, (0, $gOPoC.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $3DmQB.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $63afba6451e451c6$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $ee30f4276828974b$export$2e2bcd8739ae039 = $ee30f4276828974b$var$Dialog;


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $c976541676782b8b$export$61b0ee1f05fb344e(slot) {
    return (0, $6AMoU.default)('MuiDialogContent', slot);
}
const $c976541676782b8b$var$dialogContentClasses = (0, $ithJf.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $c976541676782b8b$export$2e2bcd8739ae039 = $c976541676782b8b$var$dialogContentClasses;



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $f74e53158e91aa84$export$f5d2ec7e4c47e088(slot) {
    return (0, $6AMoU.default)('MuiDialogTitle', slot);
}
const $f74e53158e91aa84$var$dialogTitleClasses = (0, $ithJf.default)('MuiDialogTitle', [
    'root'
]);
var $f74e53158e91aa84$export$2e2bcd8739ae039 = $f74e53158e91aa84$var$dialogTitleClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $b9097f1d6e2a4efc$var$_excluded = [
    "className",
    "dividers"
];
const $b9097f1d6e2a4efc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $c976541676782b8b$export$61b0ee1f05fb344e), classes);
};
const $b9097f1d6e2a4efc$var$DialogContentRoot = (0, $jH1k7.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $f74e53158e91aa84$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $b9097f1d6e2a4efc$var$DialogContent = /*#__PURE__*/ $3OyDL.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $aBenZ.default)(props, $b9097f1d6e2a4efc$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        dividers: dividers
    });
    const classes = $b9097f1d6e2a4efc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($b9097f1d6e2a4efc$var$DialogContentRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $b9097f1d6e2a4efc$export$2e2bcd8739ae039 = $b9097f1d6e2a4efc$var$DialogContent;


var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");


var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $286e44e498de27a0$var$_excluded = [
    "className",
    "id"
];
const $286e44e498de27a0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $f74e53158e91aa84$export$f5d2ec7e4c47e088), classes);
};
const $286e44e498de27a0$var$DialogTitleRoot = (0, $jH1k7.default)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $286e44e498de27a0$var$DialogTitle = /*#__PURE__*/ $3OyDL.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $aBenZ.default)(props, $286e44e498de27a0$var$_excluded);
    const ownerState = props;
    const classes = $286e44e498de27a0$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $3OyDL.useContext((0, $63afba6451e451c6$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $2M70Q.jsx)($286e44e498de27a0$var$DialogTitleRoot, (0, $gOPoC.default)({
        component: "h2",
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $286e44e498de27a0$export$2e2bcd8739ae039 = $286e44e498de27a0$var$DialogTitle;


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");


var $g4LX8 = parcelRequire("g4LX8");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $5bf2bb79969ab013$export$5e8702d71474f093(slot) {
    return (0, $6AMoU.default)('MuiIconButton', slot);
}
const $5bf2bb79969ab013$var$iconButtonClasses = (0, $ithJf.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $5bf2bb79969ab013$export$2e2bcd8739ae039 = $5bf2bb79969ab013$var$iconButtonClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $90c0807a34b52605$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $90c0807a34b52605$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $g4LX8.default)(color)}`,
            edge && `edge${(0, $g4LX8.default)(edge)}`,
            `size${(0, $g4LX8.default)(size)}`
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $5bf2bb79969ab013$export$5e8702d71474f093), classes);
};
const $90c0807a34b52605$var$IconButtonRoot = (0, $jH1k7.default)((0, $c582f66505800c92$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $g4LX8.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $g4LX8.default)(ownerState.edge)}`],
            styles[`size${(0, $g4LX8.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $gOPoC.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $gOPoC.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $gOPoC.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $5bf2bb79969ab013$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $90c0807a34b52605$var$IconButton = /*#__PURE__*/ $3OyDL.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $aBenZ.default)(props, $90c0807a34b52605$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $90c0807a34b52605$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($90c0807a34b52605$var$IconButtonRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $90c0807a34b52605$export$2e2bcd8739ae039 = $90c0807a34b52605$var$IconButton;


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $g4LX8 = parcelRequire("g4LX8");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");




var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $af64303eb0d0734b$export$d6efab9620b78fec(slot) {
    return (0, $6AMoU.default)('MuiLink', slot);
}
const $af64303eb0d0734b$var$linkClasses = (0, $ithJf.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $af64303eb0d0734b$export$2e2bcd8739ae039 = $af64303eb0d0734b$var$linkClasses;



var $7m2iU = parcelRequire("7m2iU");
var $9rP4D = parcelRequire("9rP4D");
const $605b32c802c6b1e9$export$c4e140d5d351182b = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $605b32c802c6b1e9$var$transformDeprecatedColors = (color)=>{
    return $605b32c802c6b1e9$export$c4e140d5d351182b[color] || color;
};
const $605b32c802c6b1e9$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $605b32c802c6b1e9$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $9rP4D.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $9rP4D.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $7m2iU.alpha)(color, 0.4);
};
var $605b32c802c6b1e9$export$2e2bcd8739ae039 = $605b32c802c6b1e9$var$getTextDecoration;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $f7f3118c741d399b$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $f7f3118c741d399b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $g4LX8.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $af64303eb0d0734b$export$d6efab9620b78fec), classes);
};
const $f7f3118c741d399b$var$LinkRoot = (0, $jH1k7.default)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $g4LX8.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $gOPoC.default)({}, ownerState.underline === 'none' && {
        textDecoration: 'none'
    }, ownerState.underline === 'hover' && {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }, ownerState.underline === 'always' && (0, $gOPoC.default)({
        textDecoration: 'underline'
    }, ownerState.color !== 'inherit' && {
        textDecorationColor: (0, $605b32c802c6b1e9$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        '&:hover': {
            textDecorationColor: 'inherit'
        }
    }), ownerState.component === 'button' && {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        [`&.${(0, $af64303eb0d0734b$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: 'auto'
        }
    });
});
const $f7f3118c741d399b$var$Link = /*#__PURE__*/ $3OyDL.forwardRef(function Link(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiLink'
    });
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx } = props, other = (0, $aBenZ.default)(props, $f7f3118c741d399b$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $4df9c68cc24f8d29$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $3OyDL.useState(false);
    const handlerRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $gOPoC.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $f7f3118c741d399b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($f7f3118c741d399b$var$LinkRoot, (0, $gOPoC.default)({
        color: color,
        className: (0, $3DmQB.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $605b32c802c6b1e9$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $f7f3118c741d399b$export$2e2bcd8739ae039 = $f7f3118c741d399b$var$Link;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $798ep = parcelRequire("798ep");

var $6AMoU = parcelRequire("6AMoU");
function $c08f2ba405329ce0$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}



var $aFUPg = parcelRequire("aFUPg");
const $2ea57c141d992d5e$var$styled = (0, $aFUPg.default)();
var $2ea57c141d992d5e$export$2e2bcd8739ae039 = $2ea57c141d992d5e$var$styled;



var $5M5yC = parcelRequire("5M5yC");


var $jjyU4 = parcelRequire("jjyU4");

var $eTtV3 = parcelRequire("eTtV3");

var $a4Gzm = parcelRequire("a4Gzm");

var $2M70Q = parcelRequire("2M70Q");
const $def12e8f137c43f1$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $def12e8f137c43f1$var$defaultTheme = (0, $jjyU4.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $def12e8f137c43f1$var$defaultCreateStyledComponent = (0, $2ea57c141d992d5e$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $def12e8f137c43f1$var$useThemePropsDefault(props) {
    return (0, $5M5yC.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $def12e8f137c43f1$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $def12e8f137c43f1$var$joinChildren(children, separator) {
    const childrenArray = $3OyDL.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $3OyDL.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $def12e8f137c43f1$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $def12e8f137c43f1$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $gOPoC.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $eTtV3.handleBreakpoints)({
        theme: theme
    }, (0, $eTtV3.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $a4Gzm.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $eTtV3.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $eTtV3.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $a4Gzm.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$def12e8f137c43f1$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $a4Gzm.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $798ep.default)(styles, (0, $eTtV3.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $eTtV3.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $def12e8f137c43f1$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $def12e8f137c43f1$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $def12e8f137c43f1$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $c08f2ba405329ce0$export$2e2bcd8739ae039)(slots, (slot)=>(0, $6AMoU.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($def12e8f137c43f1$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $3OyDL.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $69603c939df88ab4$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $aBenZ.default)(props, $def12e8f137c43f1$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $2M70Q.jsx)(StackRoot, (0, $gOPoC.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $3DmQB.default)(classes.root, className)
        }, other, {
            children: divider ? $def12e8f137c43f1$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");
'use client';
const $1733cc38690c208f$var$Stack = (0, $def12e8f137c43f1$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $jH1k7.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $jFgmT.default)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $1733cc38690c208f$export$2e2bcd8739ae039 = $1733cc38690c208f$var$Stack;


var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");
parcelRequire("3OyDL");


var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");



var $3OyDL = parcelRequire("3OyDL");
const $d3dfa32765973786$var$ThemeContext = /*#__PURE__*/ $3OyDL.createContext(null);
var $d3dfa32765973786$export$2e2bcd8739ae039 = $d3dfa32765973786$var$ThemeContext;



var $3OyDL = parcelRequire("3OyDL");

function $dd650febbd4df59e$export$2e2bcd8739ae039() {
    const theme = $3OyDL.useContext((0, $d3dfa32765973786$export$2e2bcd8739ae039));
    return theme;
}


const $a370289ca0d850d2$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $a370289ca0d850d2$export$2e2bcd8739ae039 = $a370289ca0d850d2$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $2M70Q = parcelRequire("2M70Q");
function $3065fbbdd81cb4b4$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $gOPoC.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $3065fbbdd81cb4b4$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $dd650febbd4df59e$export$2e2bcd8739ae039)();
    const theme = $3OyDL.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $3065fbbdd81cb4b4$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $a370289ca0d850d2$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d3dfa32765973786$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $3065fbbdd81cb4b4$export$2e2bcd8739ae039 = $3065fbbdd81cb4b4$var$ThemeProvider;



parcelRequire("hDCOm");
var $aTrHR = parcelRequire("aTrHR");

var $cZI7n = parcelRequire("cZI7n");

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $2M70Q = parcelRequire("2M70Q");
const $b58e16b0d9a27dac$var$_excluded = [
    "value"
];
const $b58e16b0d9a27dac$var$RtlContext = /*#__PURE__*/ $3OyDL.createContext();
function $b58e16b0d9a27dac$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $aBenZ.default)(_ref, $b58e16b0d9a27dac$var$_excluded);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($b58e16b0d9a27dac$var$RtlContext.Provider, (0, $gOPoC.default)({
        value: value != null ? value : true
    }, props));
}
const $b58e16b0d9a27dac$export$b2dd014b6c321cb = ()=>{
    const value = $3OyDL.useContext($b58e16b0d9a27dac$var$RtlContext);
    return value != null ? value : false;
};
var $b58e16b0d9a27dac$export$2e2bcd8739ae039 = $b58e16b0d9a27dac$var$RtlProvider;



var $3OyDL = parcelRequire("3OyDL");


var $eeWAX = parcelRequire("eeWAX");

var $2M70Q = parcelRequire("2M70Q");
'use client';
const $47edeb7d5849adc3$var$PropsContext = /*#__PURE__*/ $3OyDL.createContext(undefined);
function $47edeb7d5849adc3$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)($47edeb7d5849adc3$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $47edeb7d5849adc3$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $eeWAX.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $eeWAX.default)(config, props);
    return props;
}
function $47edeb7d5849adc3$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $3OyDL.useContext($47edeb7d5849adc3$var$PropsContext);
    return $47edeb7d5849adc3$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $47edeb7d5849adc3$export$2e2bcd8739ae039 = $47edeb7d5849adc3$var$DefaultPropsProvider;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $95c2ef8a6c02fa05$var$EMPTY_THEME = {};
function $95c2ef8a6c02fa05$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $3OyDL.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $gOPoC.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $gOPoC.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $gOPoC.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $95c2ef8a6c02fa05$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $cZI7n.default)($95c2ef8a6c02fa05$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $dd650febbd4df59e$export$2e2bcd8739ae039)() || $95c2ef8a6c02fa05$var$EMPTY_THEME;
    const engineTheme = $95c2ef8a6c02fa05$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $95c2ef8a6c02fa05$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3065fbbdd81cb4b4$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $aTrHR.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b58e16b0d9a27dac$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $47edeb7d5849adc3$export$2e2bcd8739ae039), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $95c2ef8a6c02fa05$export$2e2bcd8739ae039 = $95c2ef8a6c02fa05$var$ThemeProvider;



var $joa2L = parcelRequire("joa2L");

var $2M70Q = parcelRequire("2M70Q");
'use client';
const $ead356dc16e3cc23$var$_excluded = [
    "theme"
];
function $ead356dc16e3cc23$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $aBenZ.default)(_ref, $ead356dc16e3cc23$var$_excluded);
    const scopedTheme = themeInput[0, $joa2L.default];
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $95c2ef8a6c02fa05$export$2e2bcd8739ae039), (0, $gOPoC.default)({}, props, {
        themeId: scopedTheme ? (0, $joa2L.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");

var $jH1k7 = parcelRequire("jH1k7");


var $jFgmT = parcelRequire("jFgmT");

var $g4LX8 = parcelRequire("g4LX8");

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");







var $2M70Q = parcelRequire("2M70Q");
'use client';
const $a144ebfc440ec800$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $a144ebfc440ec800$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $a144ebfc440ec800$var$styles = {
    entering: {
        opacity: 1,
        transform: $a144ebfc440ec800$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $a144ebfc440ec800$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $a144ebfc440ec800$var$Grow = /*#__PURE__*/ $3OyDL.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $af8ce78d3d22dabd$export$2e2bcd8739ae039) } = props, other = (0, $aBenZ.default)(props, $a144ebfc440ec800$var$_excluded);
    const timer = $3OyDL.useRef();
    const autoTimeout = $3OyDL.useRef();
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const nodeRef = $3OyDL.useRef(null);
    const handleRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $737230c2f504d625$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $737230c2f504d625$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $a144ebfc440ec800$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $737230c2f504d625$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $a144ebfc440ec800$var$isWebKit154 ? duration : duration * 0.666,
                delay: $a144ebfc440ec800$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $a144ebfc440ec800$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $3OyDL.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $2M70Q.jsx)(TransitionComponent, (0, $gOPoC.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $3OyDL.cloneElement(children, (0, $gOPoC.default)({
                style: (0, $gOPoC.default)({
                    opacity: 0,
                    transform: $a144ebfc440ec800$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $a144ebfc440ec800$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$a144ebfc440ec800$var$Grow.muiSupportAuto = true;
var $a144ebfc440ec800$export$2e2bcd8739ae039 = $a144ebfc440ec800$var$Grow;



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");

function $5dae54816602a2fc$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $16722bc99873c870$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $5dae54816602a2fc$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $16722bc99873c870$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $5dae54816602a2fc$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $16722bc99873c870$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $5dae54816602a2fc$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $1f801e911dff1cf6$export$8960430cfd85939f = Math.max;
var $1f801e911dff1cf6$export$96ec731ed4dcb222 = Math.min;
var $1f801e911dff1cf6$export$2077e0241d6afd3c = Math.round;



function $324100deadd63f7f$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $9d6af8d0536b6b8e$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $324100deadd63f7f$export$2e2bcd8739ae039)());
}


function $8331a4683c562f78$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $16722bc99873c870$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $1f801e911dff1cf6$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $1f801e911dff1cf6$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $16722bc99873c870$export$45a5e7f76e0caa8d)(element) ? (0, $5dae54816602a2fc$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $9d6af8d0536b6b8e$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $a40e744aa6e0c2ff$export$2e2bcd8739ae039(node) {
    var win = (0, $5dae54816602a2fc$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $f75aecf859f076ef$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $d4a3bad5df06a740$export$2e2bcd8739ae039(node) {
    if (node === (0, $5dae54816602a2fc$export$2e2bcd8739ae039)(node) || !(0, $16722bc99873c870$export$1b3bfaa9684536aa)(node)) return (0, $a40e744aa6e0c2ff$export$2e2bcd8739ae039)(node);
    else return (0, $f75aecf859f076ef$export$2e2bcd8739ae039)(node);
}


function $0d2d63408899a2c7$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $a13d60bde9156901$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $16722bc99873c870$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $2718a8a5342a434b$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $8331a4683c562f78$export$2e2bcd8739ae039)((0, $a13d60bde9156901$export$2e2bcd8739ae039)(element)).left + (0, $a40e744aa6e0c2ff$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $c3455d7e1ed22d45$export$2e2bcd8739ae039(element) {
    return (0, $5dae54816602a2fc$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $61919c8b84cd93af$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $c3455d7e1ed22d45$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $4e8a4c705b899f1c$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $1f801e911dff1cf6$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $1f801e911dff1cf6$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $4e8a4c705b899f1c$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $16722bc99873c870$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $16722bc99873c870$export$1b3bfaa9684536aa)(offsetParent) && $4e8a4c705b899f1c$var$isElementScaled(offsetParent);
    var documentElement = (0, $a13d60bde9156901$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $8331a4683c562f78$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $0d2d63408899a2c7$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $61919c8b84cd93af$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $d4a3bad5df06a740$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $16722bc99873c870$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $8331a4683c562f78$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2718a8a5342a434b$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $91d9ad005909ffaa$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $8331a4683c562f78$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $8d2614d7b173d051$export$2e2bcd8739ae039(element) {
    if ((0, $0d2d63408899a2c7$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $16722bc99873c870$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $a13d60bde9156901$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $78ca69bc98ff636e$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $0d2d63408899a2c7$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $16722bc99873c870$export$1b3bfaa9684536aa)(node) && (0, $61919c8b84cd93af$export$2e2bcd8739ae039)(node)) return node;
    return $78ca69bc98ff636e$export$2e2bcd8739ae039((0, $8d2614d7b173d051$export$2e2bcd8739ae039)(node));
}





function $8917f2e87368c72a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $78ca69bc98ff636e$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $5dae54816602a2fc$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $61919c8b84cd93af$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($8917f2e87368c72a$export$2e2bcd8739ae039((0, $8d2614d7b173d051$export$2e2bcd8739ae039)(target)));
}







function $76dacf8b450109ab$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $0d2d63408899a2c7$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0aeb1fc52e6a5c2f$var$getTrueOffsetParent(element) {
    if (!(0, $16722bc99873c870$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $c3455d7e1ed22d45$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $0aeb1fc52e6a5c2f$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $324100deadd63f7f$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $324100deadd63f7f$export$2e2bcd8739ae039)());
    if (isIE && (0, $16722bc99873c870$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $c3455d7e1ed22d45$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $8d2614d7b173d051$export$2e2bcd8739ae039)(element);
    if ((0, $16722bc99873c870$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $16722bc99873c870$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $0d2d63408899a2c7$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $c3455d7e1ed22d45$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $0aeb1fc52e6a5c2f$export$2e2bcd8739ae039(element) {
    var window = (0, $5dae54816602a2fc$export$2e2bcd8739ae039)(element);
    var offsetParent = $0aeb1fc52e6a5c2f$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $76dacf8b450109ab$export$2e2bcd8739ae039)(offsetParent) && (0, $c3455d7e1ed22d45$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $0aeb1fc52e6a5c2f$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $0d2d63408899a2c7$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $0d2d63408899a2c7$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $c3455d7e1ed22d45$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $0aeb1fc52e6a5c2f$var$getContainingBlock(element) || window;
}


var $d562cf6d01641c41$export$1e95b668f3b82d = 'top';
var $d562cf6d01641c41$export$40e543e69a8b3fbb = 'bottom';
var $d562cf6d01641c41$export$79ffe56a765070d2 = 'right';
var $d562cf6d01641c41$export$eabcd2c8791e7bf4 = 'left';
var $d562cf6d01641c41$export$dfb5619354ba860 = 'auto';
var $d562cf6d01641c41$export$aec2ce47c367b8c3 = [
    $d562cf6d01641c41$export$1e95b668f3b82d,
    $d562cf6d01641c41$export$40e543e69a8b3fbb,
    $d562cf6d01641c41$export$79ffe56a765070d2,
    $d562cf6d01641c41$export$eabcd2c8791e7bf4
];
var $d562cf6d01641c41$export$b3571188c770cc5a = 'start';
var $d562cf6d01641c41$export$bd5df0f255a350f8 = 'end';
var $d562cf6d01641c41$export$390fd549c5303b4d = 'clippingParents';
var $d562cf6d01641c41$export$d7b7311ec04a3e8f = 'viewport';
var $d562cf6d01641c41$export$ae5ab1c730825774 = 'popper';
var $d562cf6d01641c41$export$ca50aac9f3ba507f = 'reference';
var $d562cf6d01641c41$export$368f9a87e87fa4e1 = /*#__PURE__*/ $d562cf6d01641c41$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $d562cf6d01641c41$export$b3571188c770cc5a,
        placement + "-" + $d562cf6d01641c41$export$bd5df0f255a350f8
    ]);
}, []);
var $d562cf6d01641c41$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($d562cf6d01641c41$export$aec2ce47c367b8c3, [
    $d562cf6d01641c41$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $d562cf6d01641c41$export$b3571188c770cc5a,
        placement + "-" + $d562cf6d01641c41$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $d562cf6d01641c41$export$421679a7c3d56e = 'beforeRead';
var $d562cf6d01641c41$export$aafa59e2e03f2942 = 'read';
var $d562cf6d01641c41$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $d562cf6d01641c41$export$c65e99957a05207c = 'beforeMain';
var $d562cf6d01641c41$export$f22da7240b7add18 = 'main';
var $d562cf6d01641c41$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $d562cf6d01641c41$export$8d4d2d70e7d46032 = 'beforeWrite';
var $d562cf6d01641c41$export$68d8715fc104d294 = 'write';
var $d562cf6d01641c41$export$70a6e5159acce2e6 = 'afterWrite';
var $d562cf6d01641c41$export$d087d3878fdf71d5 = [
    $d562cf6d01641c41$export$421679a7c3d56e,
    $d562cf6d01641c41$export$aafa59e2e03f2942,
    $d562cf6d01641c41$export$6964f6c886723980,
    $d562cf6d01641c41$export$c65e99957a05207c,
    $d562cf6d01641c41$export$f22da7240b7add18,
    $d562cf6d01641c41$export$bab79516f2d662fe,
    $d562cf6d01641c41$export$8d4d2d70e7d46032,
    $d562cf6d01641c41$export$68d8715fc104d294,
    $d562cf6d01641c41$export$70a6e5159acce2e6
];


function $efe9f109accc086e$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $efe9f109accc086e$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $efe9f109accc086e$var$order(modifiers); // order based on phase
    return (0, $d562cf6d01641c41$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $44a28dd047972139$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $3005754580f1d8cc$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $8d735a4644d7929b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $8d735a4644d7929b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $8d735a4644d7929b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $8d735a4644d7929b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $8d735a4644d7929b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $16722bc99873c870$export$45a5e7f76e0caa8d)(reference) ? (0, $8917f2e87368c72a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $8917f2e87368c72a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $8917f2e87368c72a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $efe9f109accc086e$export$2e2bcd8739ae039)((0, $3005754580f1d8cc$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$8d735a4644d7929b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $4e8a4c705b899f1c$export$2e2bcd8739ae039)(reference, (0, $0aeb1fc52e6a5c2f$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $91d9ad005909ffaa$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $44a28dd047972139$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$8d735a4644d7929b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $8d735a4644d7929b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $8d735a4644d7929b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $a73610fa5cba912e$var$passive = {
    passive: true
};
function $a73610fa5cba912e$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $5dae54816602a2fc$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $a73610fa5cba912e$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $a73610fa5cba912e$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $a73610fa5cba912e$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $a73610fa5cba912e$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $a73610fa5cba912e$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $a73610fa5cba912e$var$effect,
    data: {}
};



function $56ac686a3f20de20$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $0ee903ae972df3ad$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $c26ecb286d15a5e1$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $71fdca1b92db574c$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $56ac686a3f20de20$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $0ee903ae972df3ad$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $d562cf6d01641c41$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $d562cf6d01641c41$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $d562cf6d01641c41$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $d562cf6d01641c41$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $c26ecb286d15a5e1$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $d562cf6d01641c41$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $d562cf6d01641c41$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8d09b702a5e645f6$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $71fdca1b92db574c$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8d09b702a5e645f6$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8d09b702a5e645f6$var$popperOffsets,
    data: {}
};










var $6ac590ee11110672$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $6ac590ee11110672$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $1f801e911dff1cf6$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $1f801e911dff1cf6$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $6ac590ee11110672$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $d562cf6d01641c41$export$eabcd2c8791e7bf4);
    var sideY = (0, $d562cf6d01641c41$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $0aeb1fc52e6a5c2f$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $5dae54816602a2fc$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $a13d60bde9156901$export$2e2bcd8739ae039)(popper);
            if ((0, $c3455d7e1ed22d45$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $d562cf6d01641c41$export$1e95b668f3b82d) || (placement === (0, $d562cf6d01641c41$export$eabcd2c8791e7bf4) || placement === (0, $d562cf6d01641c41$export$79ffe56a765070d2)) && variation === (0, $d562cf6d01641c41$export$bd5df0f255a350f8)) {
            sideY = (0, $d562cf6d01641c41$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $d562cf6d01641c41$export$eabcd2c8791e7bf4) || (placement === (0, $d562cf6d01641c41$export$1e95b668f3b82d) || placement === (0, $d562cf6d01641c41$export$40e543e69a8b3fbb)) && variation === (0, $d562cf6d01641c41$export$bd5df0f255a350f8)) {
            sideX = (0, $d562cf6d01641c41$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $6ac590ee11110672$var$unsetSides);
    var _ref4 = roundOffsets === true ? $6ac590ee11110672$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $5dae54816602a2fc$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $6ac590ee11110672$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $56ac686a3f20de20$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $0ee903ae972df3ad$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $6ac590ee11110672$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $6ac590ee11110672$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6ac590ee11110672$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $6ac590ee11110672$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $9d59b1d92bff789c$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $16722bc99873c870$export$1b3bfaa9684536aa)(element) || !(0, $0d2d63408899a2c7$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $9d59b1d92bff789c$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $16722bc99873c870$export$1b3bfaa9684536aa)(element) || !(0, $0d2d63408899a2c7$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $9d59b1d92bff789c$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $9d59b1d92bff789c$var$applyStyles,
    effect: $9d59b1d92bff789c$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $2b4d521598230566$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $56ac686a3f20de20$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $d562cf6d01641c41$export$eabcd2c8791e7bf4),
        (0, $d562cf6d01641c41$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $d562cf6d01641c41$export$eabcd2c8791e7bf4),
        (0, $d562cf6d01641c41$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $2b4d521598230566$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $d562cf6d01641c41$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $2b4d521598230566$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $2b4d521598230566$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $2b4d521598230566$var$offset
};


var $25c16b2c63284c61$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $25c16b2c63284c61$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $25c16b2c63284c61$var$hash[matched];
    });
}



var $85ff828e96851d94$var$hash = {
    start: 'end',
    end: 'start'
};
function $85ff828e96851d94$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $85ff828e96851d94$var$hash[matched];
    });
}







function $85aec598c3cc9c22$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $5dae54816602a2fc$export$2e2bcd8739ae039)(element);
    var html = (0, $a13d60bde9156901$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $9d6af8d0536b6b8e$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2718a8a5342a434b$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $2cee7f68beff9a88$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $a13d60bde9156901$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $a40e744aa6e0c2ff$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $1f801e911dff1cf6$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $1f801e911dff1cf6$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2718a8a5342a434b$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $c3455d7e1ed22d45$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $1f801e911dff1cf6$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $2b83b8b116dad730$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $16722bc99873c870$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $de74f029c2ed1d1a$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $595b97e45627fe66$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $8331a4683c562f78$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $595b97e45627fe66$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $d562cf6d01641c41$export$d7b7311ec04a3e8f) ? (0, $de74f029c2ed1d1a$export$2e2bcd8739ae039)((0, $85aec598c3cc9c22$export$2e2bcd8739ae039)(element, strategy)) : (0, $16722bc99873c870$export$45a5e7f76e0caa8d)(clippingParent) ? $595b97e45627fe66$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $de74f029c2ed1d1a$export$2e2bcd8739ae039)((0, $2cee7f68beff9a88$export$2e2bcd8739ae039)((0, $a13d60bde9156901$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $595b97e45627fe66$var$getClippingParents(element) {
    var clippingParents = (0, $8917f2e87368c72a$export$2e2bcd8739ae039)((0, $8d2614d7b173d051$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $c3455d7e1ed22d45$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $16722bc99873c870$export$1b3bfaa9684536aa)(element) ? (0, $0aeb1fc52e6a5c2f$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $16722bc99873c870$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $16722bc99873c870$export$45a5e7f76e0caa8d)(clippingParent) && (0, $2b83b8b116dad730$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $0d2d63408899a2c7$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $595b97e45627fe66$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $595b97e45627fe66$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $595b97e45627fe66$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $1f801e911dff1cf6$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $1f801e911dff1cf6$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $1f801e911dff1cf6$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $1f801e911dff1cf6$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $595b97e45627fe66$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $4583c12c55cb75ab$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $43c13776a614bb42$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $4583c12c55cb75ab$export$2e2bcd8739ae039)(), paddingObject);
}


function $84e5f07e7c5fdbe7$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $9ac182dc2a383692$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $d562cf6d01641c41$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $d562cf6d01641c41$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $d562cf6d01641c41$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $43c13776a614bb42$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $84e5f07e7c5fdbe7$export$2e2bcd8739ae039)(padding, (0, $d562cf6d01641c41$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $d562cf6d01641c41$export$ae5ab1c730825774) ? (0, $d562cf6d01641c41$export$ca50aac9f3ba507f) : (0, $d562cf6d01641c41$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $595b97e45627fe66$export$2e2bcd8739ae039)((0, $16722bc99873c870$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $a13d60bde9156901$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $8331a4683c562f78$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $71fdca1b92db574c$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $de74f029c2ed1d1a$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $d562cf6d01641c41$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $d562cf6d01641c41$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $d562cf6d01641c41$export$79ffe56a765070d2),
                (0, $d562cf6d01641c41$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $d562cf6d01641c41$export$1e95b668f3b82d),
                (0, $d562cf6d01641c41$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $6dc007c1ec2d5a18$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $d562cf6d01641c41$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $0ee903ae972df3ad$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $d562cf6d01641c41$export$368f9a87e87fa4e1) : (0, $d562cf6d01641c41$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $0ee903ae972df3ad$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $d562cf6d01641c41$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9ac182dc2a383692$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $56ac686a3f20de20$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $8e259a6f850988a2$var$getExpandedFallbackPlacements(placement) {
    if ((0, $56ac686a3f20de20$export$2e2bcd8739ae039)(placement) === (0, $d562cf6d01641c41$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $25c16b2c63284c61$export$2e2bcd8739ae039)(placement);
    return [
        (0, $85ff828e96851d94$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $85ff828e96851d94$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $8e259a6f850988a2$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $56ac686a3f20de20$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $25c16b2c63284c61$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $8e259a6f850988a2$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $56ac686a3f20de20$export$2e2bcd8739ae039)(placement) === (0, $d562cf6d01641c41$export$dfb5619354ba860) ? (0, $6dc007c1ec2d5a18$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $56ac686a3f20de20$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $0ee903ae972df3ad$export$2e2bcd8739ae039)(placement) === (0, $d562cf6d01641c41$export$b3571188c770cc5a);
        var isVertical = [
            (0, $d562cf6d01641c41$export$1e95b668f3b82d),
            (0, $d562cf6d01641c41$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9ac182dc2a383692$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $d562cf6d01641c41$export$79ffe56a765070d2) : (0, $d562cf6d01641c41$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $d562cf6d01641c41$export$40e543e69a8b3fbb) : (0, $d562cf6d01641c41$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $25c16b2c63284c61$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $25c16b2c63284c61$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $8e259a6f850988a2$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $8e259a6f850988a2$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $ab5940830ebb3e2a$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $6031a09fff7f8c6e$export$f28d906d67a997f3(min, value, max) {
    return (0, $1f801e911dff1cf6$export$8960430cfd85939f)(min, (0, $1f801e911dff1cf6$export$96ec731ed4dcb222)(value, max));
}
function $6031a09fff7f8c6e$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $6031a09fff7f8c6e$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $9d5ad81ca1cae1ff$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9ac182dc2a383692$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $56ac686a3f20de20$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $0ee903ae972df3ad$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $c26ecb286d15a5e1$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $ab5940830ebb3e2a$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $d562cf6d01641c41$export$1e95b668f3b82d) : (0, $d562cf6d01641c41$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $d562cf6d01641c41$export$40e543e69a8b3fbb) : (0, $d562cf6d01641c41$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $d562cf6d01641c41$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $d562cf6d01641c41$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $91d9ad005909ffaa$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $4583c12c55cb75ab$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $6031a09fff7f8c6e$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $0aeb1fc52e6a5c2f$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $6031a09fff7f8c6e$export$f28d906d67a997f3)(tether ? (0, $1f801e911dff1cf6$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $1f801e911dff1cf6$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $d562cf6d01641c41$export$1e95b668f3b82d) : (0, $d562cf6d01641c41$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $d562cf6d01641c41$export$40e543e69a8b3fbb) : (0, $d562cf6d01641c41$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $d562cf6d01641c41$export$1e95b668f3b82d),
            (0, $d562cf6d01641c41$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $6031a09fff7f8c6e$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $6031a09fff7f8c6e$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9d5ad81ca1cae1ff$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $9d5ad81ca1cae1ff$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $73a5e4381e8f331f$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $43c13776a614bb42$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $84e5f07e7c5fdbe7$export$2e2bcd8739ae039)(padding, (0, $d562cf6d01641c41$export$aec2ce47c367b8c3)));
};
function $73a5e4381e8f331f$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $56ac686a3f20de20$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $c26ecb286d15a5e1$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $d562cf6d01641c41$export$eabcd2c8791e7bf4),
        (0, $d562cf6d01641c41$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $73a5e4381e8f331f$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $91d9ad005909ffaa$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $d562cf6d01641c41$export$1e95b668f3b82d) : (0, $d562cf6d01641c41$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $d562cf6d01641c41$export$40e543e69a8b3fbb) : (0, $d562cf6d01641c41$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $0aeb1fc52e6a5c2f$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $6031a09fff7f8c6e$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $73a5e4381e8f331f$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $2b83b8b116dad730$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $73a5e4381e8f331f$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $73a5e4381e8f331f$var$arrow,
    effect: $73a5e4381e8f331f$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $a80cc043d6026ffa$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $a80cc043d6026ffa$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $d562cf6d01641c41$export$1e95b668f3b82d),
        (0, $d562cf6d01641c41$export$79ffe56a765070d2),
        (0, $d562cf6d01641c41$export$40e543e69a8b3fbb),
        (0, $d562cf6d01641c41$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $a80cc043d6026ffa$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9ac182dc2a383692$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9ac182dc2a383692$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $a80cc043d6026ffa$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $a80cc043d6026ffa$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $a80cc043d6026ffa$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $a80cc043d6026ffa$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $a80cc043d6026ffa$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $a80cc043d6026ffa$var$hide
};




var $dd2cbcf48537f505$export$d34966752335dd47 = [
    (0, $a73610fa5cba912e$export$2e2bcd8739ae039),
    (0, $8d09b702a5e645f6$export$2e2bcd8739ae039),
    (0, $6ac590ee11110672$export$2e2bcd8739ae039),
    (0, $9d59b1d92bff789c$export$2e2bcd8739ae039),
    (0, $2b4d521598230566$export$2e2bcd8739ae039),
    (0, $8e259a6f850988a2$export$2e2bcd8739ae039),
    (0, $9d5ad81ca1cae1ff$export$2e2bcd8739ae039),
    (0, $73a5e4381e8f331f$export$2e2bcd8739ae039),
    (0, $a80cc043d6026ffa$export$2e2bcd8739ae039)
];
var $dd2cbcf48537f505$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8d735a4644d7929b$export$ed5e13716264f202)({
    defaultModifiers: $dd2cbcf48537f505$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $5jsOu = parcelRequire("5jsOu");

const $e0b226b3e4f59e60$var$defaultGenerator = (componentName)=>componentName;
const $e0b226b3e4f59e60$var$createClassNameGenerator = ()=>{
    let generate = $e0b226b3e4f59e60$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $e0b226b3e4f59e60$var$defaultGenerator;
        }
    };
};
const $e0b226b3e4f59e60$var$ClassNameGenerator = $e0b226b3e4f59e60$var$createClassNameGenerator();
var $e0b226b3e4f59e60$export$2e2bcd8739ae039 = $e0b226b3e4f59e60$var$ClassNameGenerator;


const $9a63a53789922a58$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $9a63a53789922a58$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $9a63a53789922a58$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $e0b226b3e4f59e60$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $9a63a53789922a58$export$34c0130b1f3e8ae3(slot) {
    return $9a63a53789922a58$export$9d6b9120de57c54[slot] !== undefined;
}



function $d534d1fd183cb636$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $9a63a53789922a58$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}


function $7f7adbde4141b5ed$export$1b69b6cd0fa638a1(slot) {
    return (0, $9a63a53789922a58$export$2e2bcd8739ae039)('MuiPopper', slot);
}
const $7f7adbde4141b5ed$export$b6aa214021e734b0 = (0, $d534d1fd183cb636$export$2e2bcd8739ae039)('MuiPopper', [
    'root'
]);




var $3OyDL = parcelRequire("3OyDL");

var $2M70Q = parcelRequire("2M70Q");
'use client';
const $adfea82709133472$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $adfea82709133472$var$ClassNameConfiguratorContext = /*#__PURE__*/ $3OyDL.createContext($adfea82709133472$var$defaultContextValue);
function $adfea82709133472$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $3OyDL.useContext($adfea82709133472$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return '';
        return generateUtilityClass(slot);
    };
}
function $adfea82709133472$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $3OyDL.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($adfea82709133472$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $15235190143f009c$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $15235190143f009c$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $15235190143f009c$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $15235190143f009c$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $15235190143f009c$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $15235190143f009c$var$isVirtualElement(element) {
    return !$15235190143f009c$var$isHTMLElement(element);
}
const $15235190143f009c$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $adfea82709133472$export$b0f7603cd2f9ee15)((0, $7f7adbde4141b5ed$export$1b69b6cd0fa638a1)));
};
const $15235190143f009c$var$defaultPopperOptions = {};
const $15235190143f009c$var$PopperTooltip = /*#__PURE__*/ $3OyDL.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $aBenZ.default)(props, $15235190143f009c$var$_excluded);
    const tooltipRef = $3OyDL.useRef(null);
    const ownRef = (0, $c9f4324d1af2c9eb$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $3OyDL.useRef(null);
    const handlePopperRef = (0, $c9f4324d1af2c9eb$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $3OyDL.useRef(handlePopperRef);
    (0, $9df71761ea25deba$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $3OyDL.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $15235190143f009c$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $3OyDL.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $3OyDL.useState($15235190143f009c$var$resolveAnchorEl(anchorEl));
    $3OyDL.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $3OyDL.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($15235190143f009c$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $9df71761ea25deba$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $dd2cbcf48537f505$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $gOPoC.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $15235190143f009c$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $9be467578d9a8fea$export$1e5c9e6e4e15efe3)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)(Root, (0, $gOPoC.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $15235190143f009c$export$badac9ada3a0bdf9 = /*#__PURE__*/ $3OyDL.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $15235190143f009c$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $aBenZ.default)(props, $15235190143f009c$var$_excluded2);
    const [exited, setExited] = $3OyDL.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $15235190143f009c$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $15235190143f009c$var$isHTMLElement(resolvedAnchorEl) ? (0, $35fb2c86e44ba0e8$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $35fb2c86e44ba0e8$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3b311f2fcf840ada$export$602eac185826482c), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($15235190143f009c$var$PopperTooltip, (0, $gOPoC.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $gOPoC.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});



var $cZI7n = parcelRequire("cZI7n");



var $3OyDL = parcelRequire("3OyDL");

var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
const $a61641bec19ba88c$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $a61641bec19ba88c$var$PopperRoot = (0, $jH1k7.default)((0, $15235190143f009c$export$badac9ada3a0bdf9), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $a61641bec19ba88c$var$Popper = /*#__PURE__*/ $3OyDL.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $cZI7n.default)();
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $aBenZ.default)(props, $a61641bec19ba88c$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $gOPoC.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($a61641bec19ba88c$var$PopperRoot, (0, $gOPoC.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $a61641bec19ba88c$export$2e2bcd8739ae039 = $a61641bec19ba88c$var$Popper;





'use client';
var $690598a7908d0f71$export$2e2bcd8739ae039 = (0, $17b6a17d80ba65b8$export$2e2bcd8739ae039);




var $3OyDL = parcelRequire("3OyDL");
'use client';
function $2ad7d6f597504689$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $3OyDL.useRef(controlled !== undefined);
    const [valueState, setValue] = $3OyDL.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $3OyDL.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $ac2de2dab926b929$export$2e2bcd8739ae039 = (0, $2ad7d6f597504689$export$2e2bcd8739ae039);



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $ce564adeed61eb6d$export$837848f5f6cee923(slot) {
    return (0, $6AMoU.default)('MuiTooltip', slot);
}
const $ce564adeed61eb6d$var$tooltipClasses = (0, $ithJf.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $ce564adeed61eb6d$export$2e2bcd8739ae039 = $ce564adeed61eb6d$var$tooltipClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $a0c8194f99ad3309$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $a0c8194f99ad3309$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $a0c8194f99ad3309$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $g4LX8.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $ce564adeed61eb6d$export$837848f5f6cee923), classes);
};
const $a0c8194f99ad3309$var$TooltipPopper = (0, $jH1k7.default)((0, $a61641bec19ba88c$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $gOPoC.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $ce564adeed61eb6d$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $ce564adeed61eb6d$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $ce564adeed61eb6d$export$2e2bcd8739ae039).arrow}`]: (0, $gOPoC.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $ce564adeed61eb6d$export$2e2bcd8739ae039).arrow}`]: (0, $gOPoC.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $a0c8194f99ad3309$var$TooltipTooltip = (0, $jH1k7.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $g4LX8.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $7m2iU.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$a0c8194f99ad3309$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $ce564adeed61eb6d$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $gOPoC.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $gOPoC.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $gOPoC.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $ce564adeed61eb6d$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $gOPoC.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $gOPoC.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $gOPoC.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $ce564adeed61eb6d$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $gOPoC.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $ce564adeed61eb6d$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $gOPoC.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $a0c8194f99ad3309$var$TooltipArrow = (0, $jH1k7.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $7m2iU.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $a0c8194f99ad3309$var$hystersisOpen = false;
let $a0c8194f99ad3309$var$hystersisTimer = null;
let $a0c8194f99ad3309$var$cursorPosition = {
    x: 0,
    y: 0
};
function $a0c8194f99ad3309$export$b9ee5a7ace0541f8() {
    $a0c8194f99ad3309$var$hystersisOpen = false;
    clearTimeout($a0c8194f99ad3309$var$hystersisTimer);
}
function $a0c8194f99ad3309$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $a0c8194f99ad3309$var$Tooltip = /*#__PURE__*/ $3OyDL.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $a144ebfc440ec800$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $aBenZ.default)(props, $a0c8194f99ad3309$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $3OyDL.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === 'rtl';
    const [childNode, setChildNode] = $3OyDL.useState();
    const [arrowRef, setArrowRef] = $3OyDL.useState(null);
    const ignoreNonTouchEvents = $3OyDL.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = $3OyDL.useRef();
    const enterTimer = $3OyDL.useRef();
    const leaveTimer = $3OyDL.useRef();
    const touchTimer = $3OyDL.useRef();
    const [openState, setOpenState] = (0, $ac2de2dab926b929$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $690598a7908d0f71$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $3OyDL.useRef();
    const stopTouchInteraction = $3OyDL.useCallback(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        clearTimeout(touchTimer.current);
    }, []);
    $3OyDL.useEffect(()=>{
        return ()=>{
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            stopTouchInteraction();
        };
    }, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        clearTimeout($a0c8194f99ad3309$var$hystersisTimer);
        $a0c8194f99ad3309$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $614ff53a4e7d9506$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        clearTimeout($a0c8194f99ad3309$var$hystersisTimer);
        $a0c8194f99ad3309$var$hystersisTimer = setTimeout(()=>{
            $a0c8194f99ad3309$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose && open) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(()=>{
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        if (enterDelay || $a0c8194f99ad3309$var$hystersisOpen && enterNextDelay) enterTimer.current = setTimeout(()=>{
            handleOpen(event);
        }, $a0c8194f99ad3309$var$hystersisOpen ? enterNextDelay : enterDelay);
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveDelay);
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $4df9c68cc24f8d29$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $3OyDL.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.current = setTimeout(()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        }, enterTouchDelay);
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveTouchDelay);
    };
    $3OyDL.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    if (!title && title !== 0) open = false;
    const popperRef = $3OyDL.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $a0c8194f99ad3309$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $gOPoC.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $3DmQB.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $a0c8194f99ad3309$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $a0c8194f99ad3309$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $a0c8194f99ad3309$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $a0c8194f99ad3309$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $3OyDL.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $gOPoC.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $gOPoC.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $a0c8194f99ad3309$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $a0c8194f99ad3309$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $a144ebfc440ec800$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $a0c8194f99ad3309$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $a0c8194f99ad3309$var$TooltipArrow;
    const popperProps = (0, $72a4660f5b097d47$export$b089efb01a7bdf50)(PopperComponent, (0, $gOPoC.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $3DmQB.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $72a4660f5b097d47$export$b089efb01a7bdf50)(TransitionComponent, (0, $gOPoC.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $72a4660f5b097d47$export$b089efb01a7bdf50)(TooltipComponent, (0, $gOPoC.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $3DmQB.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $72a4660f5b097d47$export$b089efb01a7bdf50)(ArrowComponent, (0, $gOPoC.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $3DmQB.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
        children: [
            /*#__PURE__*/ $3OyDL.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $2M70Q.jsx)(PopperComponent, (0, $gOPoC.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $a61641bec19ba88c$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $a0c8194f99ad3309$var$cursorPosition.y,
                            left: $a0c8194f99ad3309$var$cursorPosition.x,
                            right: $a0c8194f99ad3309$var$cursorPosition.x,
                            bottom: $a0c8194f99ad3309$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $2M70Q.jsx)(TransitionComponent, (0, $gOPoC.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)(TooltipComponent, (0, $gOPoC.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $2M70Q.jsx)(ArrowComponent, (0, $gOPoC.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $a0c8194f99ad3309$export$2e2bcd8739ae039 = $a0c8194f99ad3309$var$Tooltip;


var $3OyDL = parcelRequire("3OyDL");

var $9gZBl = parcelRequire("9gZBl");
var $cZI7n = parcelRequire("cZI7n");

'use client';
var $b8bb11a9fe67b1a2$export$2e2bcd8739ae039 = (0, $8f90f522593e04a8$export$2e2bcd8739ae039);


'use client';
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $978a5d21e044c57f$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $3OyDL.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $b8bb11a9fe67b1a2$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $978a5d21e044c57f$var$maybeReactUseSyncExternalStore = $3OyDL.useSyncExternalStore;
function $978a5d21e044c57f$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $3OyDL.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $3OyDL.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $3OyDL.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $978a5d21e044c57f$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $978a5d21e044c57f$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $cZI7n.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $9gZBl.default)({
        name: 'MuiUseMediaQuery',
        props: options,
        theme: theme
    });
    let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, '');
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $978a5d21e044c57f$var$maybeReactUseSyncExternalStore !== undefined ? $978a5d21e044c57f$var$useMediaQueryNew : $978a5d21e044c57f$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}


var $ee1843d167ed9f75$exports = {};
"use strict";
"use client";
var $4cb0592c905e8c88$exports = {};
function $4cb0592c905e8c88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$4cb0592c905e8c88$exports = $4cb0592c905e8c88$var$_interopRequireDefault, $4cb0592c905e8c88$exports.__esModule = true, $4cb0592c905e8c88$exports["default"] = $4cb0592c905e8c88$exports;


Object.defineProperty($ee1843d167ed9f75$exports, "__esModule", {
    value: true
});
$ee1843d167ed9f75$exports.default = void 0;

var $ee1843d167ed9f75$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $ee1843d167ed9f75$var$_default = (0, $ee1843d167ed9f75$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');
$ee1843d167ed9f75$exports.default = $ee1843d167ed9f75$var$_default;


var $d8698a584d579689$exports = {};
"use strict";
"use client";

Object.defineProperty($d8698a584d579689$exports, "__esModule", {
    value: true
});
$d8698a584d579689$exports.default = void 0;

var $d8698a584d579689$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $d8698a584d579689$var$_default = (0, $d8698a584d579689$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M21.95 10.99c-1.79-.03-3.7-1.95-2.68-4.22-2.98 1-5.77-1.59-5.19-4.56C6.95.71 2 6.58 2 12c0 5.52 4.48 10 10 10 5.89 0 10.54-5.08 9.95-11.01zM8.5 15c-.83 0-1.5-.67-1.5-1.5S7.67 12 8.5 12s1.5.67 1.5 1.5S9.33 15 8.5 15zm2-5C9.67 10 9 9.33 9 8.5S9.67 7 10.5 7s1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
}), 'Cookie');
$d8698a584d579689$exports.default = $d8698a584d579689$var$_default;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $70b0ba4efb41b0d3$export$5e57a444791c63be(slot) {
    return (0, $6AMoU.default)('MuiDialogActions', slot);
}
const $70b0ba4efb41b0d3$var$dialogActionsClasses = (0, $ithJf.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $70b0ba4efb41b0d3$export$2e2bcd8739ae039 = $70b0ba4efb41b0d3$var$dialogActionsClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $08e4970efe955928$var$_excluded = [
    "className",
    "disableSpacing"
];
const $08e4970efe955928$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $70b0ba4efb41b0d3$export$5e57a444791c63be), classes);
};
const $08e4970efe955928$var$DialogActionsRoot = (0, $jH1k7.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(:first-of-type)': {
            marginLeft: 8
        }
    }));
const $08e4970efe955928$var$DialogActions = /*#__PURE__*/ $3OyDL.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $aBenZ.default)(props, $08e4970efe955928$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $08e4970efe955928$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($08e4970efe955928$var$DialogActionsRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $08e4970efe955928$export$2e2bcd8739ae039 = $08e4970efe955928$var$DialogActions;


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $eTtV3 = parcelRequire("eTtV3");

var $5jsOu = parcelRequire("5jsOu");


var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");


var $3OyDL = parcelRequire("3OyDL");
'use client';
/**
 * @ignore - internal component.
 */ const $e33c6b169f1b80f9$var$GridContext = /*#__PURE__*/ $3OyDL.createContext();
var $e33c6b169f1b80f9$export$2e2bcd8739ae039 = $e33c6b169f1b80f9$var$GridContext;



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $2a241d4edcf23e17$export$9973ac5fd0181f33(slot) {
    return (0, $6AMoU.default)('MuiGrid', slot);
}
const $2a241d4edcf23e17$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $2a241d4edcf23e17$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $2a241d4edcf23e17$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $2a241d4edcf23e17$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $2a241d4edcf23e17$var$gridClasses = (0, $ithJf.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$2a241d4edcf23e17$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$2a241d4edcf23e17$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$2a241d4edcf23e17$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$2a241d4edcf23e17$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$2a241d4edcf23e17$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$2a241d4edcf23e17$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$2a241d4edcf23e17$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$2a241d4edcf23e17$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $2a241d4edcf23e17$export$2e2bcd8739ae039 = $2a241d4edcf23e17$var$gridClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $a48a6bd1d1605299$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $a48a6bd1d1605299$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $a48a6bd1d1605299$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $eTtV3.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$a48a6bd1d1605299$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $gOPoC.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $a48a6bd1d1605299$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $eTtV3.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $eTtV3.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $2a241d4edcf23e17$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $a48a6bd1d1605299$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $a48a6bd1d1605299$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $eTtV3.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $a48a6bd1d1605299$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $eTtV3.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$a48a6bd1d1605299$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $2a241d4edcf23e17$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $a48a6bd1d1605299$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $2a241d4edcf23e17$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $a48a6bd1d1605299$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $eTtV3.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $a48a6bd1d1605299$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $eTtV3.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$a48a6bd1d1605299$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$a48a6bd1d1605299$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $2a241d4edcf23e17$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $a48a6bd1d1605299$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $2a241d4edcf23e17$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $a48a6bd1d1605299$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $a48a6bd1d1605299$var$GridRoot = (0, $jH1k7.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $a48a6bd1d1605299$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $a48a6bd1d1605299$export$71d4225eeb1bc13e, $a48a6bd1d1605299$export$380604d7c79f9e8f, $a48a6bd1d1605299$export$4315fba5128fb4a1, $a48a6bd1d1605299$export$ca2a698f6020fda);
function $a48a6bd1d1605299$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $a48a6bd1d1605299$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $a48a6bd1d1605299$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $2a241d4edcf23e17$export$9973ac5fd0181f33), classes);
};
const $a48a6bd1d1605299$var$Grid = /*#__PURE__*/ $3OyDL.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const props = (0, $69603c939df88ab4$export$2e2bcd8739ae039)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $aBenZ.default)(props, $a48a6bd1d1605299$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $3OyDL.useContext((0, $e33c6b169f1b80f9$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $gOPoC.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $gOPoC.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $a48a6bd1d1605299$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e33c6b169f1b80f9$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($a48a6bd1d1605299$var$GridRoot, (0, $gOPoC.default)({
            ownerState: ownerState,
            className: (0, $3DmQB.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $a48a6bd1d1605299$export$2e2bcd8739ae039 = $a48a6bd1d1605299$var$Grid;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $41GnX = parcelRequire("41GnX");

var $gOPoC = parcelRequire("gOPoC");

function $f4bcbc2695e6a504$export$2e2bcd8739ae039(options = {}) {
    const { baseClasses: baseClasses, newClasses: newClasses, Component: Component } = options;
    if (!newClasses) return baseClasses;
    const nextClasses = (0, $gOPoC.default)({}, baseClasses);
    Object.keys(newClasses).forEach((key)=>{
        if (newClasses[key]) nextClasses[key] = `${baseClasses[key]} ${newClasses[key]}`;
    });
    return nextClasses;
}


// Used https://github.com/thinkloop/multi-key-cache as inspiration
const $630bbd28cdac4484$var$multiKeyStore = {
    set: (cache, key1, key2, value)=>{
        let subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $630bbd28cdac4484$export$2e2bcd8739ae039 = $630bbd28cdac4484$var$multiKeyStore;



function $dc07639a1cd81e56$export$2e2bcd8739ae039() {
    var _privateTheme$$$mater;
    const privateTheme = (0, $dd650febbd4df59e$export$2e2bcd8739ae039)();
    return (_privateTheme$$$mater = privateTheme == null ? void 0 : privateTheme.$$material) != null ? _privateTheme$$$mater : privateTheme;
}



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");



var $41GnX = parcelRequire("41GnX");

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously defined styles as well as
 * being untouched by simple user overrides.
 */ const $c8a86d334054b14d$var$stateClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
];
function $c8a86d334054b14d$export$2e2bcd8739ae039(options = {}) {
    const { disableGlobal: disableGlobal = false, productionPrefix: productionPrefix = 'jss', seed: seed = '' } = options;
    const seedPrefix = seed === '' ? '' : `${seed}-`;
    let ruleCounter = 0;
    const getNextCounterId = ()=>{
        ruleCounter += 1;
        return ruleCounter;
    };
    return (rule, styleSheet)=>{
        const name = styleSheet.options.name;
        // Is a global static MUI style?
        if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($c8a86d334054b14d$var$stateClasses.indexOf(rule.key) !== -1) return `Mui-${rule.key}`;
            const prefix = `${seedPrefix}${name}-${rule.key}`;
            if (!styleSheet.options.theme[0, $a370289ca0d850d2$export$2e2bcd8739ae039] || seed !== '') return prefix;
            return `${prefix}-${getNextCounterId()}`;
        }
        return `${seedPrefix}${productionPrefix}${getNextCounterId()}`;
    };
}




var $41GnX = parcelRequire("41GnX");
var $a624f1da1b5b62c5$var$now = Date.now();
var $a624f1da1b5b62c5$var$fnValuesNs = "fnValues" + $a624f1da1b5b62c5$var$now;
var $a624f1da1b5b62c5$var$fnRuleNs = "fnStyle" + ++$a624f1da1b5b62c5$var$now;
var $a624f1da1b5b62c5$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, $41GnX.createRule)(name, {}, options);
            rule[$a624f1da1b5b62c5$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($a624f1da1b5b62c5$var$fnValuesNs in rule || $a624f1da1b5b62c5$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$a624f1da1b5b62c5$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$a624f1da1b5b62c5$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$a624f1da1b5b62c5$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $a624f1da1b5b62c5$export$2e2bcd8739ae039 = $a624f1da1b5b62c5$var$functionPlugin;



var $gOPoC = parcelRequire("gOPoC");

var $41GnX = parcelRequire("41GnX");
var $2fdaa43c2995e40f$var$at = '@global';
var $2fdaa43c2995e40f$var$atPrefix = '@global ';
var $2fdaa43c2995e40f$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = $2fdaa43c2995e40f$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $41GnX.RuleList)((0, $gOPoC.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $2fdaa43c2995e40f$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = $2fdaa43c2995e40f$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($2fdaa43c2995e40f$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $gOPoC.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var $2fdaa43c2995e40f$var$separatorRegExp = /\s*,\s*/g;
function $2fdaa43c2995e40f$var$addScope(selector, scope) {
    var parts = selector.split($2fdaa43c2995e40f$var$separatorRegExp);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function $2fdaa43c2995e40f$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$2fdaa43c2995e40f$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $gOPoC.default)({}, options, {
        selector: $2fdaa43c2995e40f$var$addScope(name, rule.selector)
    }));
    delete style[$2fdaa43c2995e40f$var$at];
}
function $2fdaa43c2995e40f$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, $2fdaa43c2995e40f$var$at.length) !== $2fdaa43c2995e40f$var$at) continue;
        var selector = $2fdaa43c2995e40f$var$addScope(prop.substr($2fdaa43c2995e40f$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $gOPoC.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $2fdaa43c2995e40f$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $2fdaa43c2995e40f$var$at) return new $2fdaa43c2995e40f$var$GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, $2fdaa43c2995e40f$var$atPrefix.length) === $2fdaa43c2995e40f$var$atPrefix) return new $2fdaa43c2995e40f$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        $2fdaa43c2995e40f$var$handleNestedGlobalContainerRule(rule, sheet);
        $2fdaa43c2995e40f$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $2fdaa43c2995e40f$export$2e2bcd8739ae039 = $2fdaa43c2995e40f$var$jssGlobal;



var $gOPoC = parcelRequire("gOPoC");

var $b0fcb91bfcc773b6$var$separatorRegExp = /\s*,\s*/g;
var $b0fcb91bfcc773b6$var$parentRegExp = /&/g;
var $b0fcb91bfcc773b6$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $b0fcb91bfcc773b6$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($b0fcb91bfcc773b6$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($b0fcb91bfcc773b6$var$separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace($b0fcb91bfcc773b6$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $gOPoC.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $gOPoC.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($b0fcb91bfcc773b6$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $gOPoC.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $gOPoC.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $b0fcb91bfcc773b6$export$2e2bcd8739ae039 = $b0fcb91bfcc773b6$var$jssNested;


/* eslint-disable no-var, prefer-template */ var $98ca44d3457eb3bb$var$uppercasePattern = /[A-Z]/g;
var $98ca44d3457eb3bb$var$msPattern = /^ms-/;
var $98ca44d3457eb3bb$var$cache = {};
function $98ca44d3457eb3bb$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $98ca44d3457eb3bb$var$hyphenateStyleName(name) {
    if ($98ca44d3457eb3bb$var$cache.hasOwnProperty(name)) return $98ca44d3457eb3bb$var$cache[name];
    var hName = name.replace($98ca44d3457eb3bb$var$uppercasePattern, $98ca44d3457eb3bb$var$toHyphenLower);
    return $98ca44d3457eb3bb$var$cache[name] = $98ca44d3457eb3bb$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $98ca44d3457eb3bb$export$2e2bcd8739ae039 = $98ca44d3457eb3bb$var$hyphenateStyleName;


/**
 * Convert camel cased property names to dash separated.
 */ function $811f91540e077e05$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : (0, $98ca44d3457eb3bb$export$2e2bcd8739ae039)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($811f91540e077e05$var$convertCase);
        else converted.fallbacks = $811f91540e077e05$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $811f91540e077e05$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $811f91540e077e05$var$convertCase(style[index]);
            return style;
        }
        return $811f91540e077e05$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = (0, $98ca44d3457eb3bb$export$2e2bcd8739ae039)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $811f91540e077e05$export$2e2bcd8739ae039 = $811f91540e077e05$var$camelCase;



var $41GnX = parcelRequire("41GnX");
var $f142b68c6ddda9ee$var$px = (0, $41GnX.hasCSSTOMSupport) && CSS ? CSS.px : 'px';
var $f142b68c6ddda9ee$var$ms = (0, $41GnX.hasCSSTOMSupport) && CSS ? CSS.ms : 'ms';
var $f142b68c6ddda9ee$var$percent = (0, $41GnX.hasCSSTOMSupport) && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $f142b68c6ddda9ee$var$defaultUnits = {
    // Animation properties
    'animation-delay': $f142b68c6ddda9ee$var$ms,
    'animation-duration': $f142b68c6ddda9ee$var$ms,
    // Background properties
    'background-position': $f142b68c6ddda9ee$var$px,
    'background-position-x': $f142b68c6ddda9ee$var$px,
    'background-position-y': $f142b68c6ddda9ee$var$px,
    'background-size': $f142b68c6ddda9ee$var$px,
    // Border Properties
    border: $f142b68c6ddda9ee$var$px,
    'border-bottom': $f142b68c6ddda9ee$var$px,
    'border-bottom-left-radius': $f142b68c6ddda9ee$var$px,
    'border-bottom-right-radius': $f142b68c6ddda9ee$var$px,
    'border-bottom-width': $f142b68c6ddda9ee$var$px,
    'border-left': $f142b68c6ddda9ee$var$px,
    'border-left-width': $f142b68c6ddda9ee$var$px,
    'border-radius': $f142b68c6ddda9ee$var$px,
    'border-right': $f142b68c6ddda9ee$var$px,
    'border-right-width': $f142b68c6ddda9ee$var$px,
    'border-top': $f142b68c6ddda9ee$var$px,
    'border-top-left-radius': $f142b68c6ddda9ee$var$px,
    'border-top-right-radius': $f142b68c6ddda9ee$var$px,
    'border-top-width': $f142b68c6ddda9ee$var$px,
    'border-width': $f142b68c6ddda9ee$var$px,
    'border-block': $f142b68c6ddda9ee$var$px,
    'border-block-end': $f142b68c6ddda9ee$var$px,
    'border-block-end-width': $f142b68c6ddda9ee$var$px,
    'border-block-start': $f142b68c6ddda9ee$var$px,
    'border-block-start-width': $f142b68c6ddda9ee$var$px,
    'border-block-width': $f142b68c6ddda9ee$var$px,
    'border-inline': $f142b68c6ddda9ee$var$px,
    'border-inline-end': $f142b68c6ddda9ee$var$px,
    'border-inline-end-width': $f142b68c6ddda9ee$var$px,
    'border-inline-start': $f142b68c6ddda9ee$var$px,
    'border-inline-start-width': $f142b68c6ddda9ee$var$px,
    'border-inline-width': $f142b68c6ddda9ee$var$px,
    'border-start-start-radius': $f142b68c6ddda9ee$var$px,
    'border-start-end-radius': $f142b68c6ddda9ee$var$px,
    'border-end-start-radius': $f142b68c6ddda9ee$var$px,
    'border-end-end-radius': $f142b68c6ddda9ee$var$px,
    // Margin properties
    margin: $f142b68c6ddda9ee$var$px,
    'margin-bottom': $f142b68c6ddda9ee$var$px,
    'margin-left': $f142b68c6ddda9ee$var$px,
    'margin-right': $f142b68c6ddda9ee$var$px,
    'margin-top': $f142b68c6ddda9ee$var$px,
    'margin-block': $f142b68c6ddda9ee$var$px,
    'margin-block-end': $f142b68c6ddda9ee$var$px,
    'margin-block-start': $f142b68c6ddda9ee$var$px,
    'margin-inline': $f142b68c6ddda9ee$var$px,
    'margin-inline-end': $f142b68c6ddda9ee$var$px,
    'margin-inline-start': $f142b68c6ddda9ee$var$px,
    // Padding properties
    padding: $f142b68c6ddda9ee$var$px,
    'padding-bottom': $f142b68c6ddda9ee$var$px,
    'padding-left': $f142b68c6ddda9ee$var$px,
    'padding-right': $f142b68c6ddda9ee$var$px,
    'padding-top': $f142b68c6ddda9ee$var$px,
    'padding-block': $f142b68c6ddda9ee$var$px,
    'padding-block-end': $f142b68c6ddda9ee$var$px,
    'padding-block-start': $f142b68c6ddda9ee$var$px,
    'padding-inline': $f142b68c6ddda9ee$var$px,
    'padding-inline-end': $f142b68c6ddda9ee$var$px,
    'padding-inline-start': $f142b68c6ddda9ee$var$px,
    // Mask properties
    'mask-position-x': $f142b68c6ddda9ee$var$px,
    'mask-position-y': $f142b68c6ddda9ee$var$px,
    'mask-size': $f142b68c6ddda9ee$var$px,
    // Width and height properties
    height: $f142b68c6ddda9ee$var$px,
    width: $f142b68c6ddda9ee$var$px,
    'min-height': $f142b68c6ddda9ee$var$px,
    'max-height': $f142b68c6ddda9ee$var$px,
    'min-width': $f142b68c6ddda9ee$var$px,
    'max-width': $f142b68c6ddda9ee$var$px,
    // Position properties
    bottom: $f142b68c6ddda9ee$var$px,
    left: $f142b68c6ddda9ee$var$px,
    top: $f142b68c6ddda9ee$var$px,
    right: $f142b68c6ddda9ee$var$px,
    inset: $f142b68c6ddda9ee$var$px,
    'inset-block': $f142b68c6ddda9ee$var$px,
    'inset-block-end': $f142b68c6ddda9ee$var$px,
    'inset-block-start': $f142b68c6ddda9ee$var$px,
    'inset-inline': $f142b68c6ddda9ee$var$px,
    'inset-inline-end': $f142b68c6ddda9ee$var$px,
    'inset-inline-start': $f142b68c6ddda9ee$var$px,
    // Shadow properties
    'box-shadow': $f142b68c6ddda9ee$var$px,
    'text-shadow': $f142b68c6ddda9ee$var$px,
    // Column properties
    'column-gap': $f142b68c6ddda9ee$var$px,
    'column-rule': $f142b68c6ddda9ee$var$px,
    'column-rule-width': $f142b68c6ddda9ee$var$px,
    'column-width': $f142b68c6ddda9ee$var$px,
    // Font and text properties
    'font-size': $f142b68c6ddda9ee$var$px,
    'font-size-delta': $f142b68c6ddda9ee$var$px,
    'letter-spacing': $f142b68c6ddda9ee$var$px,
    'text-decoration-thickness': $f142b68c6ddda9ee$var$px,
    'text-indent': $f142b68c6ddda9ee$var$px,
    'text-stroke': $f142b68c6ddda9ee$var$px,
    'text-stroke-width': $f142b68c6ddda9ee$var$px,
    'word-spacing': $f142b68c6ddda9ee$var$px,
    // Motion properties
    motion: $f142b68c6ddda9ee$var$px,
    'motion-offset': $f142b68c6ddda9ee$var$px,
    // Outline properties
    outline: $f142b68c6ddda9ee$var$px,
    'outline-offset': $f142b68c6ddda9ee$var$px,
    'outline-width': $f142b68c6ddda9ee$var$px,
    // Perspective properties
    perspective: $f142b68c6ddda9ee$var$px,
    'perspective-origin-x': $f142b68c6ddda9ee$var$percent,
    'perspective-origin-y': $f142b68c6ddda9ee$var$percent,
    // Transform properties
    'transform-origin': $f142b68c6ddda9ee$var$percent,
    'transform-origin-x': $f142b68c6ddda9ee$var$percent,
    'transform-origin-y': $f142b68c6ddda9ee$var$percent,
    'transform-origin-z': $f142b68c6ddda9ee$var$percent,
    // Transition properties
    'transition-delay': $f142b68c6ddda9ee$var$ms,
    'transition-duration': $f142b68c6ddda9ee$var$ms,
    // Alignment properties
    'vertical-align': $f142b68c6ddda9ee$var$px,
    'flex-basis': $f142b68c6ddda9ee$var$px,
    // Some random properties
    'shape-margin': $f142b68c6ddda9ee$var$px,
    size: $f142b68c6ddda9ee$var$px,
    gap: $f142b68c6ddda9ee$var$px,
    // Grid properties
    grid: $f142b68c6ddda9ee$var$px,
    'grid-gap': $f142b68c6ddda9ee$var$px,
    'row-gap': $f142b68c6ddda9ee$var$px,
    'grid-row-gap': $f142b68c6ddda9ee$var$px,
    'grid-column-gap': $f142b68c6ddda9ee$var$px,
    'grid-template-rows': $f142b68c6ddda9ee$var$px,
    'grid-template-columns': $f142b68c6ddda9ee$var$px,
    'grid-auto-rows': $f142b68c6ddda9ee$var$px,
    'grid-auto-columns': $f142b68c6ddda9ee$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': $f142b68c6ddda9ee$var$px,
    'box-shadow-y': $f142b68c6ddda9ee$var$px,
    'box-shadow-blur': $f142b68c6ddda9ee$var$px,
    'box-shadow-spread': $f142b68c6ddda9ee$var$px,
    'font-line-height': $f142b68c6ddda9ee$var$px,
    'text-shadow-x': $f142b68c6ddda9ee$var$px,
    'text-shadow-y': $f142b68c6ddda9ee$var$px,
    'text-shadow-blur': $f142b68c6ddda9ee$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $f142b68c6ddda9ee$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $f142b68c6ddda9ee$var$units = $f142b68c6ddda9ee$var$addCamelCasedVersion($f142b68c6ddda9ee$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $f142b68c6ddda9ee$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $f142b68c6ddda9ee$var$iterate(prop, value[i], options);
    else if (typeof value === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = $f142b68c6ddda9ee$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $f142b68c6ddda9ee$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || $f142b68c6ddda9ee$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $f142b68c6ddda9ee$var$px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $f142b68c6ddda9ee$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $f142b68c6ddda9ee$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = $f142b68c6ddda9ee$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $f142b68c6ddda9ee$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $f142b68c6ddda9ee$export$2e2bcd8739ae039 = $f142b68c6ddda9ee$var$defaultUnit;



var $9DnwR = parcelRequire("9DnwR");
function $eb6d49b453b7823a$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $ab461524ecac063b$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $eb6d49b453b7823a$export$2e2bcd8739ae039)(r);
}


function $f4d9858c2b447cea$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $b9c677b435a19550$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $eb6d49b453b7823a$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $eb6d49b453b7823a$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $3acad4da5e9960dd$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $d041038556248e67$export$2e2bcd8739ae039(r) {
    return (0, $ab461524ecac063b$export$2e2bcd8739ae039)(r) || (0, $f4d9858c2b447cea$export$2e2bcd8739ae039)(r) || (0, $b9c677b435a19550$export$2e2bcd8739ae039)(r) || (0, $3acad4da5e9960dd$export$2e2bcd8739ae039)();
}


// Export javascript style and css style vendor prefixes.
var $a09187793cdc9305$var$js = '';
var $a09187793cdc9305$var$css = '';
var $a09187793cdc9305$var$vendor = '';
var $a09187793cdc9305$var$browser = '';
var $a09187793cdc9305$var$isTouch = (0, $9DnwR.default) && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (0, $9DnwR.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $a09187793cdc9305$var$jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var $a09187793cdc9305$var$_document$createEleme = document.createElement('p'), $a09187793cdc9305$var$style = $a09187793cdc9305$var$_document$createEleme.style;
    var $a09187793cdc9305$var$testProp = 'Transform';
    for(var $a09187793cdc9305$var$key in $a09187793cdc9305$var$jsCssMap)if ($a09187793cdc9305$var$key + $a09187793cdc9305$var$testProp in $a09187793cdc9305$var$style) {
        $a09187793cdc9305$var$js = $a09187793cdc9305$var$key;
        $a09187793cdc9305$var$css = $a09187793cdc9305$var$jsCssMap[$a09187793cdc9305$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($a09187793cdc9305$var$js === 'Webkit' && 'msHyphens' in $a09187793cdc9305$var$style) {
        $a09187793cdc9305$var$js = 'ms';
        $a09187793cdc9305$var$css = $a09187793cdc9305$var$jsCssMap.ms;
        $a09187793cdc9305$var$browser = 'edge';
    } // Correctly detect the Safari browser.
    if ($a09187793cdc9305$var$js === 'Webkit' && '-apple-trailing-word' in $a09187793cdc9305$var$style) $a09187793cdc9305$var$vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $a09187793cdc9305$export$82e9f45cca5ba907 = {
    js: $a09187793cdc9305$var$js,
    css: $a09187793cdc9305$var$css,
    vendor: $a09187793cdc9305$var$vendor,
    browser: $a09187793cdc9305$var$browser,
    isTouch: $a09187793cdc9305$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $a09187793cdc9305$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($a09187793cdc9305$export$82e9f45cca5ba907.js === 'ms') return key;
    return "@" + $a09187793cdc9305$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $a09187793cdc9305$var$appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if ($a09187793cdc9305$export$82e9f45cca5ba907.js === 'ms') return "-webkit-" + prop;
        return $a09187793cdc9305$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $a09187793cdc9305$var$colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if ($a09187793cdc9305$export$82e9f45cca5ba907.js === 'Webkit') return $a09187793cdc9305$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $a09187793cdc9305$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $a09187793cdc9305$var$toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $a09187793cdc9305$var$camelize(str) {
    return str.replace($a09187793cdc9305$var$regExp, $a09187793cdc9305$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $a09187793cdc9305$var$pascalize(str) {
    return $a09187793cdc9305$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $a09187793cdc9305$var$mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($a09187793cdc9305$export$82e9f45cca5ba907.js === 'Webkit') {
            var longhand = 'mask-image';
            if ($a09187793cdc9305$var$camelize(longhand) in style) return prop;
            if ($a09187793cdc9305$export$82e9f45cca5ba907.js + $a09187793cdc9305$var$pascalize(longhand) in style) return $a09187793cdc9305$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $a09187793cdc9305$var$textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if ($a09187793cdc9305$export$82e9f45cca5ba907.vendor === 'apple' && !$a09187793cdc9305$export$82e9f45cca5ba907.isTouch) return $a09187793cdc9305$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $a09187793cdc9305$var$transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return $a09187793cdc9305$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $a09187793cdc9305$var$transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return $a09187793cdc9305$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $a09187793cdc9305$var$writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if ($a09187793cdc9305$export$82e9f45cca5ba907.js === 'Webkit' || $a09187793cdc9305$export$82e9f45cca5ba907.js === 'ms' && $a09187793cdc9305$export$82e9f45cca5ba907.browser !== 'edge') return $a09187793cdc9305$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $a09187793cdc9305$var$userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if ($a09187793cdc9305$export$82e9f45cca5ba907.js === 'Moz' || $a09187793cdc9305$export$82e9f45cca5ba907.js === 'ms' || $a09187793cdc9305$export$82e9f45cca5ba907.vendor === 'apple') return $a09187793cdc9305$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $a09187793cdc9305$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($a09187793cdc9305$export$82e9f45cca5ba907.js === 'Webkit') {
            var jsProp = "WebkitColumn" + $a09187793cdc9305$var$pascalize(prop);
            return jsProp in style ? $a09187793cdc9305$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($a09187793cdc9305$export$82e9f45cca5ba907.js === 'Moz') {
            var _jsProp = "page" + $a09187793cdc9305$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $a09187793cdc9305$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($a09187793cdc9305$export$82e9f45cca5ba907.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return $a09187793cdc9305$export$82e9f45cca5ba907.js + $a09187793cdc9305$var$pascalize(newProp) in style ? $a09187793cdc9305$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $a09187793cdc9305$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $a09187793cdc9305$var$camelize(prop) in style ? prop : false;
    }
};
var $a09187793cdc9305$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $a09187793cdc9305$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if ($a09187793cdc9305$export$82e9f45cca5ba907.js + pascalized in style) return $a09187793cdc9305$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($a09187793cdc9305$export$82e9f45cca5ba907.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $a09187793cdc9305$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if ($a09187793cdc9305$export$82e9f45cca5ba907.js === 'ms') return "" + $a09187793cdc9305$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $a09187793cdc9305$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if ($a09187793cdc9305$export$82e9f45cca5ba907.js === 'ms') return $a09187793cdc9305$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $a09187793cdc9305$var$propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $a09187793cdc9305$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $a09187793cdc9305$var$propMap[prop];
        if (!newProp) return false;
        return $a09187793cdc9305$export$82e9f45cca5ba907.js + $a09187793cdc9305$var$pascalize(newProp) in style ? $a09187793cdc9305$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $a09187793cdc9305$var$propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var $a09187793cdc9305$var$propKeys = Object.keys($a09187793cdc9305$var$propMap$1);
var $a09187793cdc9305$var$prefixCss = function prefixCss(p) {
    return $a09187793cdc9305$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $a09187793cdc9305$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($a09187793cdc9305$var$propKeys.indexOf(prop) > -1) {
            var newProp = $a09187793cdc9305$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $a09187793cdc9305$export$82e9f45cca5ba907.js + $a09187793cdc9305$var$pascalize(newProp) in style ? $a09187793cdc9305$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($a09187793cdc9305$export$82e9f45cca5ba907.js + $a09187793cdc9305$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($a09187793cdc9305$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $a09187793cdc9305$var$plugins = [
    $a09187793cdc9305$var$appearence,
    $a09187793cdc9305$var$colorAdjust,
    $a09187793cdc9305$var$mask,
    $a09187793cdc9305$var$textOrientation,
    $a09187793cdc9305$var$transform,
    $a09187793cdc9305$var$transition,
    $a09187793cdc9305$var$writingMode,
    $a09187793cdc9305$var$userSelect,
    $a09187793cdc9305$var$breakPropsOld,
    $a09187793cdc9305$var$inlineLogicalOld,
    $a09187793cdc9305$var$unprefixed,
    $a09187793cdc9305$var$prefixed,
    $a09187793cdc9305$var$scrollSnap,
    $a09187793cdc9305$var$overscrollBehavior,
    $a09187793cdc9305$var$flex2012,
    $a09187793cdc9305$var$flex2009
];
var $a09187793cdc9305$var$propertyDetectors = $a09187793cdc9305$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $a09187793cdc9305$var$noPrefill = $a09187793cdc9305$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $d041038556248e67$export$2e2bcd8739ae039)(p.noPrefill));
    return a;
}, []);
var $a09187793cdc9305$var$el;
var $a09187793cdc9305$var$cache = {};
if (0, $9DnwR.default) {
    $a09187793cdc9305$var$el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $a09187793cdc9305$var$computed = window.getComputedStyle(document.documentElement, '');
    for(var $a09187793cdc9305$var$key$1 in $a09187793cdc9305$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($a09187793cdc9305$var$key$1)) $a09187793cdc9305$var$cache[$a09187793cdc9305$var$computed[$a09187793cdc9305$var$key$1]] = $a09187793cdc9305$var$computed[$a09187793cdc9305$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $a09187793cdc9305$var$noPrefill.forEach(function(x) {
        return delete $a09187793cdc9305$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $a09187793cdc9305$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$a09187793cdc9305$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($a09187793cdc9305$var$cache[prop] != null) return $a09187793cdc9305$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in $a09187793cdc9305$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $a09187793cdc9305$var$propertyDetectors.length; i++){
        $a09187793cdc9305$var$cache[prop] = $a09187793cdc9305$var$propertyDetectors[i](prop, $a09187793cdc9305$var$el.style, options); // Break loop, if value found.
        if ($a09187793cdc9305$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $a09187793cdc9305$var$el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return $a09187793cdc9305$var$cache[prop];
}
var $a09187793cdc9305$var$cache$1 = {};
var $a09187793cdc9305$var$transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var $a09187793cdc9305$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $a09187793cdc9305$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $a09187793cdc9305$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? $a09187793cdc9305$export$ce097f82c2e4551a(p1) : ", " + $a09187793cdc9305$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $9DnwR.default) $a09187793cdc9305$var$el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $a09187793cdc9305$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$a09187793cdc9305$var$el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($a09187793cdc9305$var$cache$1[cacheKey] != null) return $a09187793cdc9305$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $a09187793cdc9305$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $a09187793cdc9305$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($a09187793cdc9305$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($a09187793cdc9305$var$transPropsRegExp, $a09187793cdc9305$var$prefixTransitionCallback);
    else if ($a09187793cdc9305$var$el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = $a09187793cdc9305$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') $a09187793cdc9305$var$el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        $a09187793cdc9305$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($a09187793cdc9305$var$el$1.style[property] === '') {
            $a09187793cdc9305$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $a09187793cdc9305$var$el$1.style[property] = ''; // Write current value to cache.
    $a09187793cdc9305$var$cache$1[cacheKey] = prefixedValue;
    return $a09187793cdc9305$var$cache$1[cacheKey];
}



var $41GnX = parcelRequire("41GnX");
/**
 * Add vendor prefix to a property name when needed.
 */ function $e6b351016c9184cc$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = (0, $a09187793cdc9305$export$b6aa0648d950180a)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $a09187793cdc9305$export$ce097f82c2e4551a)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $a09187793cdc9305$export$511766124059c277)(supportedProp, (0, $41GnX.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $a09187793cdc9305$export$511766124059c277)(prop, (0, $41GnX.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $e6b351016c9184cc$export$2e2bcd8739ae039 = $e6b351016c9184cc$var$jssVendorPrefixer;


/**
 * Sort props by length.
 */ function $1120c70fb40fa2c9$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $1120c70fb40fa2c9$export$2e2bcd8739ae039 = $1120c70fb40fa2c9$var$jssPropsSort;


function $3083b504dd6f6379$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $a624f1da1b5b62c5$export$2e2bcd8739ae039)(),
            (0, $2fdaa43c2995e40f$export$2e2bcd8739ae039)(),
            (0, $b0fcb91bfcc773b6$export$2e2bcd8739ae039)(),
            (0, $811f91540e077e05$export$2e2bcd8739ae039)(),
            (0, $f142b68c6ddda9ee$export$2e2bcd8739ae039)(),
            // Disable the vendor prefixer server-side, it does nothing.
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, $e6b351016c9184cc$export$2e2bcd8739ae039)(),
            (0, $1120c70fb40fa2c9$export$2e2bcd8739ae039)()
        ]
    };
}



var $2M70Q = parcelRequire("2M70Q");
const $e559d9072c38917b$var$_excluded = [
    "children",
    "injectFirst",
    "disableGeneration"
];
const $e559d9072c38917b$var$defaultJSS = (0, $41GnX.create)((0, $3083b504dd6f6379$export$2e2bcd8739ae039)());
// Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
const $e559d9072c38917b$var$defaultGenerateClassName = (0, $c8a86d334054b14d$export$2e2bcd8739ae039)();
const $e559d9072c38917b$export$70a8aea9ff58d1cd = new Map();
const $e559d9072c38917b$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $e559d9072c38917b$var$defaultGenerateClassName,
    jss: $e559d9072c38917b$var$defaultJSS,
    sheetsCache: null,
    sheetsManager: $e559d9072c38917b$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
const $e559d9072c38917b$export$f4de434b269fe487 = /*#__PURE__*/ $3OyDL.createContext($e559d9072c38917b$var$defaultOptions);
let $e559d9072c38917b$var$injectFirstNode;
function $e559d9072c38917b$export$2e2bcd8739ae039(props) {
    const { children: children, injectFirst: injectFirst = false, disableGeneration: disableGeneration = false } = props, localOptions = (0, $aBenZ.default)(props, $e559d9072c38917b$var$_excluded);
    const outerOptions = $3OyDL.useContext($e559d9072c38917b$export$f4de434b269fe487);
    const { generateClassName: generateClassName, jss: jss, serverGenerateClassName: serverGenerateClassName, sheetsCache: sheetsCache, sheetsManager: sheetsManager, sheetsRegistry: sheetsRegistry } = (0, $gOPoC.default)({}, outerOptions, localOptions);
    const value = $3OyDL.useMemo(()=>{
        const context = {
            disableGeneration: disableGeneration,
            generateClassName: generateClassName,
            jss: jss,
            serverGenerateClassName: serverGenerateClassName,
            sheetsCache: sheetsCache,
            sheetsManager: sheetsManager,
            sheetsRegistry: sheetsRegistry
        };
        if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
            if (!$e559d9072c38917b$var$injectFirstNode) {
                const head = document.head;
                $e559d9072c38917b$var$injectFirstNode = document.createComment('mui-inject-first');
                head.insertBefore($e559d9072c38917b$var$injectFirstNode, head.firstChild);
            }
            context.jss = (0, $41GnX.create)({
                plugins: (0, $3083b504dd6f6379$export$2e2bcd8739ae039)().plugins,
                insertionPoint: $e559d9072c38917b$var$injectFirstNode
            });
        }
        return context;
    }, [
        injectFirst,
        disableGeneration,
        generateClassName,
        jss,
        serverGenerateClassName,
        sheetsCache,
        sheetsManager,
        sheetsRegistry
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($e559d9072c38917b$export$f4de434b269fe487.Provider, {
        value: value,
        children: children
    });
}


/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
let $d2187f95ec9a4de3$var$indexCounter = -1000000000;
function $d2187f95ec9a4de3$export$a2647aa13413c947() {
    $d2187f95ec9a4de3$var$indexCounter += 1;
    return $d2187f95ec9a4de3$var$indexCounter;
}



var $gOPoC = parcelRequire("gOPoC");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");
function $cc3898314eb7c477$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $cc3898314eb7c477$var$deepClone(source) {
    if (/*#__PURE__*/ $3OyDL.isValidElement(source) || !$cc3898314eb7c477$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $cc3898314eb7c477$var$deepClone(source[key]);
    });
    return output;
}
function $cc3898314eb7c477$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $gOPoC.default)({}, target) : target;
    if ($cc3898314eb7c477$export$53b83ca8eaab0383(target) && $cc3898314eb7c477$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $3OyDL.isValidElement(source[key])) output[key] = source[key];
        else if ($cc3898314eb7c477$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $cc3898314eb7c477$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $cc3898314eb7c477$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $cc3898314eb7c477$export$53b83ca8eaab0383(source[key]) ? $cc3898314eb7c477$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}



var $aBenZ = parcelRequire("aBenZ");
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $59c0797e6a9a8653$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }


function $e3f5131b68b28ff1$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $59c0797e6a9a8653$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}


const $eac1a24b1fbd921b$var$_excluded = [
    "variant"
];
function $eac1a24b1fbd921b$var$isEmpty(string) {
    return string.length === 0;
}
function $eac1a24b1fbd921b$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $aBenZ.default)(props, $eac1a24b1fbd921b$var$_excluded);
    let classKey = variant || '';
    Object.keys(other).sort().forEach((key)=>{
        if (key === 'color') classKey += $eac1a24b1fbd921b$var$isEmpty(classKey) ? props[key] : (0, $e3f5131b68b28ff1$export$2e2bcd8739ae039)(props[key]);
        else classKey += `${$eac1a24b1fbd921b$var$isEmpty(classKey) ? key : (0, $e3f5131b68b28ff1$export$2e2bcd8739ae039)(key)}${(0, $e3f5131b68b28ff1$export$2e2bcd8739ae039)(props[key].toString())}`;
    });
    return classKey;
}



function $f8af91b16e348abd$export$2e2bcd8739ae039(stylesOrCreator) {
    const themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: (theme, name)=>{
            let styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.components || !theme.components[name] || !theme.components[name].styleOverrides && !theme.components[name].variants) return styles;
            const overrides = theme.components[name].styleOverrides || {};
            const variants = theme.components[name].variants || [];
            const stylesWithOverrides = (0, $gOPoC.default)({}, styles);
            Object.keys(overrides).forEach((key)=>{
                stylesWithOverrides[key] = (0, $cc3898314eb7c477$export$2e2bcd8739ae039)(stylesWithOverrides[key] || {}, overrides[key]);
            });
            variants.forEach((definition)=>{
                const classKey = (0, $eac1a24b1fbd921b$export$2e2bcd8739ae039)(definition.props);
                stylesWithOverrides[classKey] = (0, $cc3898314eb7c477$export$2e2bcd8739ae039)(stylesWithOverrides[classKey] || {}, definition.style);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}


// We use the same empty object to ref count the styles that don't need a theme object.
const $06707aca864de0cd$var$noopTheme = {};
var $06707aca864de0cd$export$2e2bcd8739ae039 = $06707aca864de0cd$var$noopTheme;


const $1527019e4f1136b9$var$_excluded = [
    "name",
    "classNamePrefix",
    "Component",
    "defaultTheme"
];
function $1527019e4f1136b9$var$getClasses({ state: state, stylesOptions: stylesOptions }, classes, Component) {
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
    // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    let generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $f4bcbc2695e6a504$export$2e2bcd8739ae039)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $1527019e4f1136b9$var$attach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator, name: name }, props) {
    if (stylesOptions.disableGeneration) return;
    let sheetManager = (0, $630bbd28cdac4484$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $630bbd28cdac4484$export$2e2bcd8739ae039).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    const options = (0, $gOPoC.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        let staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $630bbd28cdac4484$export$2e2bcd8739ae039).get(stylesOptions.sheetsCache, stylesCreator, theme);
        const styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $gOPoC.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $630bbd28cdac4484$export$2e2bcd8739ae039).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $41GnX.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        const dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $gOPoC.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $f4bcbc2695e6a504$export$2e2bcd8739ae039)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $1527019e4f1136b9$var$update({ state: state }, props) {
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $1527019e4f1136b9$var$detach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator }) {
    if (stylesOptions.disableGeneration) return;
    const sheetManager = (0, $630bbd28cdac4484$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $630bbd28cdac4484$export$2e2bcd8739ae039).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $1527019e4f1136b9$var$useSynchronousEffect(func, values) {
    const key = $3OyDL.useRef([]);
    let output;
    // Store "generation" key. Just returns a new object every time
    const currentKey = $3OyDL.useMemo(()=>({}), values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    $3OyDL.useEffect(()=>()=>{
            if (output) output();
        }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $1527019e4f1136b9$export$2e2bcd8739ae039(stylesOrCreator, options = {}) {
    const { name: // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name, // Help with debuggability.
    classNamePrefix: classNamePrefixOption, Component: Component, defaultTheme: defaultTheme = (0, $06707aca864de0cd$export$2e2bcd8739ae039) } = options, stylesOptions2 = (0, $aBenZ.default)(options, $1527019e4f1136b9$var$_excluded);
    const stylesCreator = (0, $f8af91b16e348abd$export$2e2bcd8739ae039)(stylesOrCreator);
    const classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, $d2187f95ec9a4de3$export$a2647aa13413c947)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    const useStyles = (props = {})=>{
        const theme = (0, $dc07639a1cd81e56$export$2e2bcd8739ae039)() || defaultTheme;
        const stylesOptions = (0, $gOPoC.default)({}, $3OyDL.useContext((0, $e559d9072c38917b$export$f4de434b269fe487)), stylesOptions2);
        const instance = $3OyDL.useRef();
        const shouldUpdate = $3OyDL.useRef();
        $1527019e4f1136b9$var$useSynchronousEffect(()=>{
            const current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $1527019e4f1136b9$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return ()=>{
                $1527019e4f1136b9$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        $3OyDL.useEffect(()=>{
            if (shouldUpdate.current) $1527019e4f1136b9$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        const classes = $1527019e4f1136b9$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");

var $3OyDL = parcelRequire("3OyDL");
/**
 * @ignore - internal component.
 */ const $944cc4a3dc3f5808$var$TimelineContext = /*#__PURE__*/ $3OyDL.createContext({});
var $944cc4a3dc3f5808$export$2e2bcd8739ae039 = $944cc4a3dc3f5808$var$TimelineContext;



var $6AMoU = parcelRequire("6AMoU");

var $ithJf = parcelRequire("ithJf");
function $29afcbfd8ceb7d46$export$bc39e980dadb0eed(slot) {
    return (0, $6AMoU.default)('MuiTimeline', slot);
}
const $29afcbfd8ceb7d46$var$timelineClasses = (0, $ithJf.default)('MuiTimeline', [
    'root',
    'positionLeft',
    'positionRight',
    'positionAlternate',
    'positionAlternateReverse'
]);
var $29afcbfd8ceb7d46$export$2e2bcd8739ae039 = $29afcbfd8ceb7d46$var$timelineClasses;



var $g4LX8 = parcelRequire("g4LX8");
function $1ab3d292e8b9d01d$export$2e2bcd8739ae039(position) {
    return position === 'alternate-reverse' ? 'positionAlternateReverse' : `position${(0, $g4LX8.default)(position)}`;
}



var $2M70Q = parcelRequire("2M70Q");
const $e559194eb7cbbba6$var$_excluded = [
    "position",
    "className"
];
const $e559194eb7cbbba6$var$useUtilityClasses = (ownerState)=>{
    const { position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            position && (0, $1ab3d292e8b9d01d$export$2e2bcd8739ae039)(position)
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $29afcbfd8ceb7d46$export$bc39e980dadb0eed), classes);
};
const $e559194eb7cbbba6$var$TimelineRoot = (0, $jH1k7.default)('ul', {
    name: 'MuiTimeline',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.position && styles[(0, $1ab3d292e8b9d01d$export$2e2bcd8739ae039)(ownerState.position)]
        ];
    }
})({
    display: 'flex',
    flexDirection: 'column',
    padding: '6px 16px',
    flexGrow: 1
});
/**
 *
 * Demos:
 *
 * - [Timeline](https://mui.com/material-ui/react-timeline/)
 *
 * API:
 *
 * - [Timeline API](https://mui.com/material-ui/api/timeline/)
 */ const $e559194eb7cbbba6$var$Timeline = /*#__PURE__*/ $3OyDL.forwardRef(function Timeline(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTimeline'
    });
    const { position: position = 'right', className: className } = props, other = (0, $aBenZ.default)(props, $e559194eb7cbbba6$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        position: position
    });
    const classes = $e559194eb7cbbba6$var$useUtilityClasses(ownerState);
    const contextValue = $3OyDL.useMemo(()=>({
            position: position
        }), [
        position
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $944cc4a3dc3f5808$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($e559194eb7cbbba6$var$TimelineRoot, (0, $gOPoC.default)({
            className: (0, $3DmQB.default)(classes.root, className),
            ownerState: ownerState,
            ref: ref
        }, other))
    });
});
var /**
 *
 * Demos:
 *
 * - [Timeline](https://mui.com/components/timeline/)
 *
 * API:
 *
 * - [Timeline API](https://mui.com/api/timeline/)
 */ $e559194eb7cbbba6$export$2e2bcd8739ae039 = $e559194eb7cbbba6$var$Timeline;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $3OyDL = parcelRequire("3OyDL");
function $47c6b2ead049a80e$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $3OyDL.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $ad7a1c4dcda17e88$export$2e2bcd8739ae039 = (0, $47c6b2ead049a80e$export$2e2bcd8739ae039);



var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");

var $5jsOu = parcelRequire("5jsOu");

var $6AMoU = parcelRequire("6AMoU");

var $ithJf = parcelRequire("ithJf");
function $9ff2ccec0f342b6e$export$5218636a7b893758(slot) {
    return (0, $6AMoU.default)('MuiTimelineContent', slot);
}
const $9ff2ccec0f342b6e$var$timelineContentClasses = (0, $ithJf.default)('MuiTimelineContent', [
    'root',
    'positionLeft',
    'positionRight',
    'positionAlternate',
    'positionAlternateReverse'
]);
var $9ff2ccec0f342b6e$export$2e2bcd8739ae039 = $9ff2ccec0f342b6e$var$timelineContentClasses;



var $6AMoU = parcelRequire("6AMoU");

var $ithJf = parcelRequire("ithJf");
function $987741bab38adc8d$export$2f4bb08e1f7d500f(slot) {
    return (0, $6AMoU.default)('MuiTimelineOppositeContent', slot);
}
const $987741bab38adc8d$var$timelineOppositeContentClasses = (0, $ithJf.default)('MuiTimelineOppositeContent', [
    'root',
    'positionLeft',
    'positionRight',
    'positionAlternate',
    'positionAlternateReverse'
]);
var $987741bab38adc8d$export$2e2bcd8739ae039 = $987741bab38adc8d$var$timelineOppositeContentClasses;




var $6AMoU = parcelRequire("6AMoU");

var $ithJf = parcelRequire("ithJf");
function $eff8a72081c42e6d$export$76efc064aabca070(slot) {
    return (0, $6AMoU.default)('MuiTimelineItem', slot);
}
const $eff8a72081c42e6d$var$timelineItemClasses = (0, $ithJf.default)('MuiTimelineItem', [
    'root',
    'positionLeft',
    'positionRight',
    'positionAlternate',
    'positionAlternateReverse',
    'missingOppositeContent'
]);
var $eff8a72081c42e6d$export$2e2bcd8739ae039 = $eff8a72081c42e6d$var$timelineItemClasses;




var $2M70Q = parcelRequire("2M70Q");
const $7aaee05def34269d$var$_excluded = [
    "position",
    "className"
];
const $7aaee05def34269d$var$useUtilityClasses = (ownerState)=>{
    const { position: position, classes: classes, hasOppositeContent: hasOppositeContent } = ownerState;
    const slots = {
        root: [
            'root',
            (0, $1ab3d292e8b9d01d$export$2e2bcd8739ae039)(position),
            !hasOppositeContent && 'missingOppositeContent'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $eff8a72081c42e6d$export$76efc064aabca070), classes);
};
const $7aaee05def34269d$var$TimelineItemRoot = (0, $jH1k7.default)('li', {
    name: 'MuiTimelineItem',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[(0, $1ab3d292e8b9d01d$export$2e2bcd8739ae039)(ownerState.position)]
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        listStyle: 'none',
        display: 'flex',
        position: 'relative',
        minHeight: 70
    }, ownerState.position === 'left' && {
        flexDirection: 'row-reverse'
    }, (ownerState.position === 'alternate' || ownerState.position === 'alternate-reverse') && {
        [`&:nth-of-type(${ownerState.position === 'alternate' ? 'even' : 'odd'})`]: {
            flexDirection: 'row-reverse',
            [`& .${(0, $9ff2ccec0f342b6e$export$2e2bcd8739ae039).root}`]: {
                textAlign: 'right'
            },
            [`& .${(0, $987741bab38adc8d$export$2e2bcd8739ae039).root}`]: {
                textAlign: 'left'
            }
        }
    }, !ownerState.hasOppositeContent && {
        '&:before': {
            content: '""',
            flex: 1,
            padding: '6px 16px'
        }
    }));
const $7aaee05def34269d$var$TimelineItem = /*#__PURE__*/ $3OyDL.forwardRef(function TimelineItem(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTimelineItem'
    });
    const { position: positionProp, className: className } = props, other = (0, $aBenZ.default)(props, $7aaee05def34269d$var$_excluded);
    const { position: positionContext } = $3OyDL.useContext((0, $944cc4a3dc3f5808$export$2e2bcd8739ae039));
    let hasOppositeContent = false;
    $3OyDL.Children.forEach(props.children, (child)=>{
        if ((0, $ad7a1c4dcda17e88$export$2e2bcd8739ae039)(child, [
            'TimelineOppositeContent'
        ])) hasOppositeContent = true;
    });
    const ownerState = (0, $gOPoC.default)({}, props, {
        position: positionProp || positionContext || 'right',
        hasOppositeContent: hasOppositeContent
    });
    const classes = $7aaee05def34269d$var$useUtilityClasses(ownerState);
    const contextValue = $3OyDL.useMemo(()=>({
            position: ownerState.position
        }), [
        ownerState.position
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $944cc4a3dc3f5808$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($7aaee05def34269d$var$TimelineItemRoot, (0, $gOPoC.default)({
            className: (0, $3DmQB.default)(classes.root, className),
            ownerState: ownerState,
            ref: ref
        }, other))
    });
});
var $7aaee05def34269d$export$2e2bcd8739ae039 = $7aaee05def34269d$var$TimelineItem;



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");

var $6AMoU = parcelRequire("6AMoU");

var $ithJf = parcelRequire("ithJf");
function $23401d1d5dd06c26$export$3133e632d3686f53(slot) {
    return (0, $6AMoU.default)('MuiTimelineSeparator', slot);
}
const $23401d1d5dd06c26$var$timelineSeparatorClasses = (0, $ithJf.default)('MuiTimelineSeparator', [
    'root'
]);
var $23401d1d5dd06c26$export$2e2bcd8739ae039 = $23401d1d5dd06c26$var$timelineSeparatorClasses;



var $2M70Q = parcelRequire("2M70Q");
const $292c6b13e3b71ec0$var$_excluded = [
    "className"
];
const $292c6b13e3b71ec0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $23401d1d5dd06c26$export$3133e632d3686f53), classes);
};
const $292c6b13e3b71ec0$var$TimelineSeparatorRoot = (0, $jH1k7.default)('div', {
    name: 'MuiTimelineSeparator',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column',
    flex: 0,
    alignItems: 'center'
});
const $292c6b13e3b71ec0$var$TimelineSeparator = /*#__PURE__*/ $3OyDL.forwardRef(function TimelineSeparator(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTimelineSeparator'
    });
    const { className: className } = props, other = (0, $aBenZ.default)(props, $292c6b13e3b71ec0$var$_excluded);
    const ownerState = props;
    const classes = $292c6b13e3b71ec0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($292c6b13e3b71ec0$var$TimelineSeparatorRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $292c6b13e3b71ec0$export$2e2bcd8739ae039 = $292c6b13e3b71ec0$var$TimelineSeparator;



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");

var $6AMoU = parcelRequire("6AMoU");

var $ithJf = parcelRequire("ithJf");
function $5dea4da2c8304e4c$export$9efd08b8465d0f31(slot) {
    return (0, $6AMoU.default)('MuiTimelineConnector', slot);
}
const $5dea4da2c8304e4c$var$timelineConnectorClasses = (0, $ithJf.default)('MuiTimelineConnector', [
    'root'
]);
var $5dea4da2c8304e4c$export$2e2bcd8739ae039 = $5dea4da2c8304e4c$var$timelineConnectorClasses;



var $2M70Q = parcelRequire("2M70Q");
const $8f50fc4ee7fe8ffc$var$_excluded = [
    "className"
];
const $8f50fc4ee7fe8ffc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $5dea4da2c8304e4c$export$9efd08b8465d0f31), classes);
};
const $8f50fc4ee7fe8ffc$var$TimelineConnectorRoot = (0, $jH1k7.default)('span', {
    name: 'MuiTimelineConnector',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        width: 2,
        backgroundColor: (theme.vars || theme).palette.grey[400],
        flexGrow: 1
    };
});
const $8f50fc4ee7fe8ffc$var$TimelineConnector = /*#__PURE__*/ $3OyDL.forwardRef(function TimelineConnector(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTimelineConnector'
    });
    const { className: className } = props, other = (0, $aBenZ.default)(props, $8f50fc4ee7fe8ffc$var$_excluded);
    const ownerState = props;
    const classes = $8f50fc4ee7fe8ffc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($8f50fc4ee7fe8ffc$var$TimelineConnectorRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $8f50fc4ee7fe8ffc$export$2e2bcd8739ae039 = $8f50fc4ee7fe8ffc$var$TimelineConnector;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");

var $5jsOu = parcelRequire("5jsOu");





var $2M70Q = parcelRequire("2M70Q");
const $134d667c4e8a499c$var$_excluded = [
    "className"
];
const $134d667c4e8a499c$var$useUtilityClasses = (ownerState)=>{
    const { position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            (0, $1ab3d292e8b9d01d$export$2e2bcd8739ae039)(position)
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $9ff2ccec0f342b6e$export$5218636a7b893758), classes);
};
const $134d667c4e8a499c$var$TimelineContentRoot = (0, $jH1k7.default)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
    name: 'MuiTimelineContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[(0, $1ab3d292e8b9d01d$export$2e2bcd8739ae039)(ownerState.position)]
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        flex: 1,
        padding: '6px 16px',
        textAlign: 'left'
    }, ownerState.position === 'left' && {
        textAlign: 'right'
    }));
const $134d667c4e8a499c$var$TimelineContent = /*#__PURE__*/ $3OyDL.forwardRef(function TimelineContent(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTimelineContent'
    });
    const { className: className } = props, other = (0, $aBenZ.default)(props, $134d667c4e8a499c$var$_excluded);
    const { position: positionContext } = $3OyDL.useContext((0, $944cc4a3dc3f5808$export$2e2bcd8739ae039));
    const ownerState = (0, $gOPoC.default)({}, props, {
        position: positionContext || 'right'
    });
    const classes = $134d667c4e8a499c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($134d667c4e8a499c$var$TimelineContentRoot, (0, $gOPoC.default)({
        component: "div",
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $134d667c4e8a499c$export$2e2bcd8739ae039 = $134d667c4e8a499c$var$TimelineContent;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");

var $g4LX8 = parcelRequire("g4LX8");

var $5jsOu = parcelRequire("5jsOu");

var $6AMoU = parcelRequire("6AMoU");

var $ithJf = parcelRequire("ithJf");
function $47b4edfdd1c06a57$export$4140aec9ebaaa10a(slot) {
    return (0, $6AMoU.default)('MuiTimelineDot', slot);
}
const $47b4edfdd1c06a57$var$timelineDotClasses = (0, $ithJf.default)('MuiTimelineDot', [
    'root',
    'filled',
    'outlined',
    'filledGrey',
    'outlinedGrey',
    'filledPrimary',
    'outlinedPrimary',
    'filledSecondary',
    'outlinedSecondary'
]);
var $47b4edfdd1c06a57$export$2e2bcd8739ae039 = $47b4edfdd1c06a57$var$timelineDotClasses;



var $2M70Q = parcelRequire("2M70Q");
const $5bbc5e33333b8ab4$var$_excluded = [
    "className",
    "color",
    "variant"
];
const $5bbc5e33333b8ab4$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            color !== 'inherit' && `${variant}${(0, $g4LX8.default)(color)}`
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $47b4edfdd1c06a57$export$4140aec9ebaaa10a), classes);
};
const $5bbc5e33333b8ab4$var$TimelineDotRoot = (0, $jH1k7.default)('span', {
    name: 'MuiTimelineDot',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.color !== 'inherit' && `${ownerState.variant}${(0, $g4LX8.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $gOPoC.default)({
        display: 'flex',
        alignSelf: 'baseline',
        borderStyle: 'solid',
        borderWidth: 2,
        padding: 4,
        borderRadius: '50%',
        boxShadow: (theme.vars || theme).shadows[1],
        margin: '11.5px 0'
    }, ownerState.variant === 'filled' && (0, $gOPoC.default)({
        borderColor: 'transparent'
    }, ownerState.color !== 'inherit' && (0, $gOPoC.default)({}, ownerState.color === 'grey' ? {
        color: (theme.vars || theme).palette.grey[50],
        backgroundColor: (theme.vars || theme).palette.grey[400]
    } : {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    })), ownerState.variant === 'outlined' && (0, $gOPoC.default)({
        boxShadow: 'none',
        backgroundColor: 'transparent'
    }, ownerState.color !== 'inherit' && (0, $gOPoC.default)({}, ownerState.color === 'grey' ? {
        borderColor: (theme.vars || theme).palette.grey[400]
    } : {
        borderColor: (theme.vars || theme).palette[ownerState.color].main
    }))));
const $5bbc5e33333b8ab4$var$TimelineDot = /*#__PURE__*/ $3OyDL.forwardRef(function TimelineDot(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTimelineDot'
    });
    const { className: className, color: color = 'grey', variant: variant = 'filled' } = props, other = (0, $aBenZ.default)(props, $5bbc5e33333b8ab4$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $5bbc5e33333b8ab4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($5bbc5e33333b8ab4$var$TimelineDotRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $5bbc5e33333b8ab4$export$2e2bcd8739ae039 = $5bbc5e33333b8ab4$var$TimelineDot;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");


const $5154e9d6612df9c0$var$TimelineElement = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const elementWidth = props.width || 'big';
    const elementWidthValues = {
        big: {
            width: 300,
            height: 200
        },
        medium: {
            width: 240,
            height: 180
        },
        small: {
            width: 200,
            height: 150
        }
    };
    const [imageWidth, setImageWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState('auto');
    const [imageHeight, setImageHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState('200px');
    const [element, setElement] = (0, $3OyDL.useState)(props.element);
    const [active, setActive] = (0, $3OyDL.useState)(props.active);
    (0, $3OyDL.useEffect)(()=>{
        setElement(props.element);
        const img = new Image();
        if (props.element?.event.imageUrls && props.element?.event.imageUrls[0] || props.element?.eventLocation?.imageUrls && props.element?.eventLocation?.imageUrls[0]) {
            img.onload = function() {
                const height = img.height;
                const width = img.width;
                const ratio = width / height;
                if (ratio > 1.5) {
                    setImageWidth('auto');
                    setImageHeight(`${elementWidthValues[elementWidth].height}px`);
                } else {
                    setImageWidth(`${elementWidthValues[elementWidth].width}px`);
                    setImageHeight('auto');
                }
            };
            img.src = props.element?.event.imageUrls && props.element?.event.imageUrls[0] || props.element?.eventLocation?.imageUrls && props.element?.eventLocation?.imageUrls[0] || '';
        }
    }, [
        props.element
    ]);
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)(()=>({
            elementContainer: {
                width: `${elementWidthValues[elementWidth].width}px`,
                height: `${elementWidthValues[elementWidth].height}px`,
                position: 'relative',
                overflow: 'hidden'
            },
            activeElement: {
                filter: 'grayscale(0%)'
            },
            textOverlay: {
                zIndex: '100',
                position: 'absolute',
                width: `${elementWidthValues[elementWidth].width - 10}px`,
                opacity: '0.8',
                backgroundColor: '#fff',
                padding: '5px',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            },
            imageContainer: {
                width: `${elementWidthValues[elementWidth].width - 10}px`,
                height: `${elementWidthValues[elementWidth].height}px`,
                overflow: 'hidden'
            },
            image: {
                width: imageWidth,
                height: imageHeight,
                cursor: 'pointer',
                filter: 'grayscale(100%)',
                '&:hover': {
                    filter: 'grayscale(0%)'
                }
            },
            location: {
                textTransform: 'uppercase',
                opacity: '0.8',
                width: '100%',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
            },
            description: {
                cursor: 'pointer',
                textTransform: 'uppercase',
                opacity: '0.8',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
            }
        }));
    const classes = useStyles();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: classes.elementContainer,
        children: element && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                    className: classes.textOverlay,
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                            className: classes.location,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                variant: "button",
                                style: {
                                    fontWeight: '501',
                                    color: theme.palette.grey['900']
                                },
                                children: element.event.title
                            })
                        }),
                        element.eventLocation?.caption && element.eventLocation?.linkUrl && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "caption",
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                                style: {
                                    textDecoration: 'none'
                                },
                                color: theme.palette.grey[600],
                                href: element.eventLocation?.linkUrl,
                                className: classes.description,
                                target: "_blank",
                                children: element.eventLocation?.caption
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                    className: `${classes.imageContainer}`,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                        onMouseEnter: ()=>setActive(true),
                        onMouseLeave: ()=>setActive(false),
                        className: `${classes.image} ${active ? classes.activeElement : ''}`,
                        src: element.event?.imageUrls ? element.event?.imageUrls[0] : element.eventLocation?.imageUrls ? element.eventLocation?.imageUrls[0] : './images/dummyEvent.jpg'
                    })
                })
            ]
        })
    });
};
var $5154e9d6612df9c0$export$2e2bcd8739ae039 = $5154e9d6612df9c0$var$TimelineElement;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");



function $9365bc52a37388f7$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $9365bc52a37388f7$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $9365bc52a37388f7$export$281bff7f05488aa2(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9365bc52a37388f7$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$9365bc52a37388f7$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $9365bc52a37388f7$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $9365bc52a37388f7$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $9365bc52a37388f7$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.dependencies = dependencies;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $9365bc52a37388f7$export$595d22ed68ca2841 = $9365bc52a37388f7$export$5943f4447f6ef248($9365bc52a37388f7$export$281bff7f05488aa2);
function $9365bc52a37388f7$export$75979cfcd91bf38f(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9365bc52a37388f7$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}


const $09fe4dd5fa74c93e$export$3813fceac631a2fa = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.settingsStore.prefersDarkMode, (state)=>state);
const $09fe4dd5fa74c93e$export$89cbf1a0881c8b9c = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.settingsStore.theme, (state)=>state);
const $09fe4dd5fa74c93e$export$2e51780da3c3a61 = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.settingsStore.message, (state)=>state);
const $09fe4dd5fa74c93e$export$2fa22ca814667ff4 = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.settingsStore.searchInput, (state)=>state);
const $09fe4dd5fa74c93e$export$7cbf767827cd68ba = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.settingsStore.user, (state)=>state);
const $09fe4dd5fa74c93e$export$367314d85393c4e = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.settingsStore.activeMember, (state)=>state);
const $09fe4dd5fa74c93e$export$7eb85035e0831f9 = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.settingsStore.userPermissions, (state)=>state);
const $09fe4dd5fa74c93e$export$1759e81b1d90346 = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.settingsStore.navPoint, (state)=>state);
const $09fe4dd5fa74c93e$export$a948215c3728951f = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.settingsStore.biography, (state)=>state);
const $09fe4dd5fa74c93e$export$7e51fdd8c00191b1 = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.settingsStore.geography, (state)=>state);
const $09fe4dd5fa74c93e$export$e3e51f7b74509850 = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.settingsStore.redirectPath, (state)=>state);


const $b923b35411141fb9$var$TimelineDotComponent = (props)=>{
    const darkMode = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$3813fceac631a2fa));
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            dot: {
                cursor: 'pointer',
                width: '40px',
                height: '40px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: theme.palette.primary.main
            },
            activeDot: {
                color: theme.palette.grey.A100
            },
            hoverDot: {
                color: darkMode ? theme.palette.grey.A100 : theme.palette.primary.dark
            }
        }));
    const classes = useStyles();
    const [active, setActive] = (0, $3OyDL.useState)(props.active);
    const [hover, setHover] = (0, $3OyDL.useState)(false);
    const [year, setYear] = (0, $3OyDL.useState)(props.year);
    (0, $3OyDL.useEffect)(()=>{
        setActive(props.active);
    }, [
        props.active
    ]);
    (0, $3OyDL.useEffect)(()=>{
        setYear(props.year);
    }, [
        props.year
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: classes.dot,
        onMouseEnter: ()=>!active && setHover(true),
        onMouseLeave: ()=>setHover(false),
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
            className: active ? classes.activeDot : hover ? classes.hoverDot : '',
            children: year || '+'
        })
    });
};
var $b923b35411141fb9$export$2e2bcd8739ae039 = $b923b35411141fb9$var$TimelineDotComponent;


var $c7fa01100a96d1f7$export$918a9776c0a3cf27 = /*#__PURE__*/ function(Severity) {
    Severity["error"] = "error";
    Severity["info"] = "info";
    Severity["success"] = "success";
    Severity["warning"] = "warning";
    return Severity;
}({});
var $c7fa01100a96d1f7$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["delete"] = "delete";
    MessageType["create"] = "create";
    MessageType["update"] = "update";
    MessageType["upload"] = "upload";
    MessageType["load"] = "load";
    return MessageType;
}({});
var $c7fa01100a96d1f7$export$4e872ec0b227b4b6 = /*#__PURE__*/ function(PreviewFormat) {
    PreviewFormat["square"] = "square";
    PreviewFormat["origin"] = "origin";
    return PreviewFormat;
}({});
var $c7fa01100a96d1f7$export$f8c1145424afc42f = /*#__PURE__*/ function(Allergy) {
    Allergy["nuts"] = "nuts";
    Allergy["lactose"] = "lactose";
    Allergy["sesame"] = "sesame";
    Allergy["fish"] = "fish";
    Allergy["eggs"] = "eggs";
    Allergy["gluten"] = "gluten";
    Allergy["mustard"] = "mustard";
    Allergy["celery"] = "celery";
    Allergy["soy"] = "soy";
    return Allergy;
}({});
var $c7fa01100a96d1f7$export$9fa29051aff709ee = /*#__PURE__*/ function(DietType) {
    DietType["vegetarian"] = "vegetarian";
    DietType["vegan"] = "vegan";
    DietType["custom"] = "custom";
    DietType["keto"] = "keto";
    DietType["paleo"] = "paleo";
    DietType["kosher"] = "kosher";
    DietType["halal"] = "halal";
    return DietType;
}({});
var $c7fa01100a96d1f7$export$ebeccdce1e2968d0 = /*#__PURE__*/ function(RelationType) {
    RelationType["partnership"] = "partnership";
    RelationType["marriage"] = "marriage";
    RelationType["parentChild"] = "parentChild";
    RelationType["adoptedParentChild"] = "adoptedParentChild";
    RelationType["custom"] = "custom";
    return RelationType;
}({});
var $c7fa01100a96d1f7$export$f99233281efd08a0 = /*#__PURE__*/ function(Title) {
    Title["prof"] = "prof";
    Title["dr"] = "dr";
    Title["profDr"] = "profDr";
    return Title;
}({});
var $c7fa01100a96d1f7$export$eb3485a690c2f0b8 = /*#__PURE__*/ function(UserRole) {
    UserRole["user"] = "user";
    UserRole["organizer"] = "organizer";
    UserRole["jury"] = "jury";
    UserRole["admin"] = "admin";
    return UserRole;
}({});
var $c7fa01100a96d1f7$export$af2022a36dc13b47 = /*#__PURE__*/ function(PermissionType) {
    PermissionType["read"] = "read";
    PermissionType["update"] = "update";
    PermissionType["create"] = "create";
    PermissionType["delete"] = "delete";
    return PermissionType;
}({});
var $c7fa01100a96d1f7$export$d549c77c8a078892 = /*#__PURE__*/ function(Gender) {
    Gender["male"] = "male";
    Gender["female"] = "female";
    Gender["diverse"] = "diverse";
    return Gender;
}({});
var $c7fa01100a96d1f7$export$56404fea6c08a4d9 = /*#__PURE__*/ function(Generation) {
    Generation["yellow"] = "yellow";
    Generation["orange"] = "orange";
    Generation["green"] = "green";
    Generation["blue"] = "blue";
    Generation["red"] = "red";
    Generation["violet"] = "violet";
    return Generation;
}({});
var $c7fa01100a96d1f7$export$985739bfa5723e08 = /*#__PURE__*/ function(Game) {
    Game["eichel"] = "eichel";
    Game["gruen"] = "gruen";
    Game["rot"] = "rot";
    Game["schell"] = "schell";
    Game["grand"] = "grand";
    Game["zero"] = "zero";
    Game["eingemischt"] = "eingemischt";
    return Game;
}({});
var $c7fa01100a96d1f7$export$bc6f4160c6da2a6b = /*#__PURE__*/ function(GameProperty) {
    GameProperty["einfach"] = "einfach";
    GameProperty["schneider"] = "schneider";
    GameProperty["schwarz"] = "schwarz";
    GameProperty["hand"] = "hand";
    GameProperty["handSchneider"] = "handSchneider";
    GameProperty["handSchwarz"] = "handSchwarz";
    GameProperty["handSchneiderAngesagt"] = "handSchneiderAngesagt";
    GameProperty["handSchneiderAngesagtSchwarz"] = "handSchneiderAngesagtSchwarz";
    GameProperty["handSchwarzAngesagt"] = "handSchwarzAngesagt";
    GameProperty["handOuvert"] = "handOuvert";
    GameProperty["ouvert"] = "ouvert";
    return GameProperty;
}({});
var $c7fa01100a96d1f7$export$dfa1772eefa7c8c2 = /*#__PURE__*/ function(MitOhne) {
    MitOhne["mit"] = "mit";
    MitOhne["ohne"] = "ohne";
    return MitOhne;
}({});
var $c7fa01100a96d1f7$export$bc644a473284d944 = /*#__PURE__*/ function(Entity) {
    Entity["members"] = "members";
    Entity["relations"] = "relations";
    Entity["events"] = "events";
    Entity["users"] = "users";
    Entity["eventMembers"] = "eventMembers";
    Entity["eventPriceCategories"] = "eventPriceCategories";
    Entity["eventLocations"] = "eventLocations";
    Entity["eventResults"] = "eventResults";
    return Entity;
}({});
var $c7fa01100a96d1f7$export$31bb55db0b3e4187 = /*#__PURE__*/ function(Method) {
    Method["POST"] = "POST";
    Method["GET"] = "GET";
    Method["PUT"] = "PUT";
    Method["DELETE"] = "DELETE";
    return Method;
}({});



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");

var $ad5a22b7e45eeb01$exports = {};
/* @preserve
 * Leaflet 1.7.1, a JS library for interactive maps. http://leafletjs.com
 * (c) 2010-2019 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($ad5a22b7e45eeb01$exports);
})($ad5a22b7e45eeb01$exports, function(exports1) {
    'use strict';
    var version = "1.7.1";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        /*eslint-disable */ obj._leaflet_id = obj._leaflet_id || ++lastId;
        return obj._leaflet_id;
    /* eslint-enable */ }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, digits?: Number): Number
    // Returns the number `num` rounded to `digits` decimals, or to 6 decimals by default.
    function formatNum(num, digits) {
        var pow = Math.pow(10, digits === undefined ? 6 : digits);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_-]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        extend: extend,
        create: create,
        bind: bind,
        lastId: lastId,
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) {
            extend(NewClass, props.statics);
            delete props.statics;
        }
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
            delete props.includes;
        }
        // merge options
        if (proto.options) props.options = extend(create(proto.options), props.options);
        // mix given properties into the prototype
        extend(proto, props);
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        extend(this.prototype, props);
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!types) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context) {
            this._events = this._events || {};
            /* get/init listeners for type */ var typeListeners = this._events[type];
            if (!typeListeners) {
                typeListeners = [];
                this._events[type] = typeListeners;
            }
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            }, listeners = typeListeners;
            // check if fn already there
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return;
            }
            listeners.push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (!fn) {
                // Set all removed listeners to noop so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (context === this) context = undefined;
            if (listeners) // find fn and remove it
            for(i = 0, len = listeners.length; i < len; i++){
                var l = listeners[i];
                if (l.ctx !== context) continue;
                if (l.fn === fn) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    l.fn = falseFn;
                    if (this._firingCount) /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                    listeners.splice(i, 1);
                    return;
                }
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide an data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        l.fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        listens: function(type, propagate) {
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) return true;
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, propagate)) return true;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            if (typeof types === 'object') {
                for(var type in types)this.once(type, types[type], fn);
                return this;
            }
            var handler = bind(function() {
                this.off(types, fn, context).off(types, handler, context);
            }, this);
            // add a listener that's executed once and removed after that
            return this.on(types, fn, context).on(types, handler, context);
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        extend: function(point) {
            point = toPoint(point);
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = point.clone();
                this.max = point.clone();
            } else {
                this.min.x = Math.min(point.x, this.min.x);
                this.max.x = Math.max(point.x, this.max.x);
                this.min.y = Math.min(point.y, this.min.y);
                this.max.y = Math.max(point.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return new Point((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return new Point(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return new Point(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        isValid: function() {
            return !!(this.min && this.max);
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see http://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style$1 = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style$1;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style$1;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style$1;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touch: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // This does not necessarily mean that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas,
        svg: svg,
        vml: vml
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = msPointer ? 'MSPointerCancel' : 'pointercancel';
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler, id) {
        if (type === 'touchstart') _addPointerStart(obj, handler, id);
        else if (type === 'touchmove') _addPointerMove(obj, handler, id);
        else if (type === 'touchend') _addPointerEnd(obj, handler, id);
        return this;
    }
    function removePointerListener(obj, type, id) {
        var handler = obj['_leaflet_' + type + id];
        if (type === 'touchstart') obj.removeEventListener(POINTER_DOWN, handler, false);
        else if (type === 'touchmove') obj.removeEventListener(POINTER_MOVE, handler, false);
        else if (type === 'touchend') {
            obj.removeEventListener(POINTER_UP, handler, false);
            obj.removeEventListener(POINTER_CANCEL, handler, false);
        }
        return this;
    }
    function _addPointerStart(obj, handler, id) {
        var onDown = bind(function(e) {
            // IE10 specific: MsTouch needs preventDefault. See #2000
            if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
            _handlePointer(e, handler);
        });
        obj['_leaflet_touchstart' + id] = onDown;
        obj.addEventListener(POINTER_DOWN, onDown, false);
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _handlePointer(e, handler) {
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _addPointerMove(obj, handler, id) {
        var onMove = function(e) {
            // don't fire touch moves when mouse isn't down
            if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse') && e.buttons === 0) return;
            _handlePointer(e, handler);
        };
        obj['_leaflet_touchmove' + id] = onMove;
        obj.addEventListener(POINTER_MOVE, onMove, false);
    }
    function _addPointerEnd(obj, handler, id) {
        var onUp = function(e) {
            _handlePointer(e, handler);
        };
        obj['_leaflet_touchend' + id] = onUp;
        obj.addEventListener(POINTER_UP, onUp, false);
        obj.addEventListener(POINTER_CANCEL, onUp, false);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   */ var _touchstart = msPointer ? 'MSPointerDown' : pointer ? 'pointerdown' : 'touchstart';
    var _touchend = msPointer ? 'MSPointerUp' : pointer ? 'pointerup' : 'touchend';
    var _pre = '_leaflet_';
    // inspired by Zepto touch code by Thomas Fuchs
    function addDoubleTapListener(obj, handler, id) {
        var last, touch$$1, doubleTap = false, delay = 250;
        function onTouchStart(e) {
            if (pointer) {
                if (!e.isPrimary) return;
                if (e.pointerType === 'mouse') return;
                 // mouse fires native dblclick
            } else if (e.touches.length > 1) return;
            var now = Date.now(), delta = now - (last || now);
            touch$$1 = e.touches ? e.touches[0] : e;
            doubleTap = delta > 0 && delta <= delay;
            last = now;
        }
        function onTouchEnd(e) {
            if (doubleTap && !touch$$1.cancelBubble) {
                if (pointer) {
                    if (e.pointerType === 'mouse') return;
                    // work around .type being readonly with MSPointer* events
                    var newTouch = {}, prop, i;
                    for(i in touch$$1){
                        prop = touch$$1[i];
                        newTouch[i] = prop && prop.bind ? prop.bind(touch$$1) : prop;
                    }
                    touch$$1 = newTouch;
                }
                touch$$1.type = 'dblclick';
                touch$$1.button = 0;
                handler(touch$$1);
                last = null;
            }
        }
        obj[_pre + _touchstart + id] = onTouchStart;
        obj[_pre + _touchend + id] = onTouchEnd;
        obj[_pre + 'dblclick' + id] = handler;
        obj.addEventListener(_touchstart, onTouchStart, passiveEvents ? {
            passive: false
        } : false);
        obj.addEventListener(_touchend, onTouchEnd, passiveEvents ? {
            passive: false
        } : false);
        // On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
        // the browser doesn't fire touchend/pointerup events but does fire
        // native dblclicks. See #4127.
        // Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
        obj.addEventListener('dblclick', handler, false);
        return this;
    }
    function removeDoubleTapListener(obj, id) {
        var touchstart = obj[_pre + _touchstart + id], touchend = obj[_pre + _touchend + id], dblclick = obj[_pre + 'dblclick' + id];
        obj.removeEventListener(_touchstart, touchstart, passiveEvents ? {
            passive: false
        } : false);
        obj.removeEventListener(_touchend, touchend, passiveEvents ? {
            passive: false
        } : false);
        obj.removeEventListener('dblclick', dblclick, false);
        return this;
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outline;
        element.style.outline = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outline = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        disableTextSelection: disableTextSelection,
        enableTextSelection: enableTextSelection,
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function off(obj, types, fn, context) {
        if (typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else if (types) {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        } else {
            for(var j in obj[eventsKey])removeOne(obj, j, obj[eventsKey][j]);
            delete obj[eventsKey];
        }
        return this;
    }
    function browserFiresNativeDblClick() {
        // See https://github.com/w3c/pointerevents/issues/171
        if (pointer) return !(edge || safari);
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        addPointerListener(obj, type, handler, id);
        else if (touch && type === 'dblclick' && !browserFiresNativeDblClick()) addDoubleTapListener(obj, handler, id);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else if ('attachEvent' in obj) obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : ''), handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, id);
        else if (touch && type === 'dblclick' && !browserFiresNativeDblClick()) removeDoubleTapListener(obj, id);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else if ('detachEvent' in obj) obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        skipped(e);
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick', stopPropagation);
        addOne(el, 'click', fakeStop);
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    // Chrome on Win scrolls double the pixels as in other platforms (see #4538),
    // and Firefox scrolls device pixels, not CSS pixels
    var wheelPxFactor = win && chrome ? 2 * window.devicePixelRatio : gecko ? window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    var skipEvents = {};
    function fakeStop(e) {
        // fakes stopPropagation by setting a special event flag, checked/reset with skipped(e)
        skipEvents[e.type] = true;
    }
    function skipped(e) {
        var events = skipEvents[e.type];
        // reset when checking, as it's only used in map container and propagates outside of the map
        skipEvents[e.type] = false;
        return events;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        fakeStop: fakeStop,
        skipped: skipped,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var fx = new L.PosAnimation();
   * fx.run(el, [300, 500], 0.5);
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && any3d && !mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this.off('moveend', this._panInsideMaxBounds);
            } else if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // `padding`, `paddingTopLeft` and `paddingTopRight` options to fit
        // the display to more restricted bounds, like [`fitBounds`](#map-fitbounds).
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), center = this.getCenter(), pixelCenter = this.project(center), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), halfPixelBounds = pixelBounds.getSize().divideBy(2), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]);
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var diff = pixelCenter.subtract(pixelPoint), newCenter = toPoint(pixelPoint.x + diff.x, pixelPoint.y + diff.y);
                if (pixelPoint.x < paddedBounds.min.x || pixelPoint.x > paddedBounds.max.x) {
                    newCenter.x = pixelCenter.x - diff.x;
                    if (diff.x > 0) newCenter.x += halfPixelBounds.x - paddingTL.x;
                    else newCenter.x -= halfPixelBounds.x - paddingBR.x;
                }
                if (pixelPoint.y < paddedBounds.min.y || pixelPoint.y > paddedBounds.max.y) {
                    newCenter.y = pixelCenter.y - diff.y;
                    if (diff.y > 0) newCenter.y += halfPixelBounds.y - paddingTL.y;
                    else newCenter.y -= halfPixelBounds.y - paddingBR.y;
                }
                this.panTo(this.unproject(newCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter;
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && any3d;
            addClass(container, 'leaflet-container' + (touch ? ' leaflet-touch' : '') + (retina ? ' leaflet-retina' : '') + (ielt9 ? ' leaflet-oldie' : '') + (safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, false)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            // @event zoom: Event
            // Fired repeatedly during any change in zoom level, including zoom
            // and fly animations.
            if (zoomChanged || data && data.pinch) this.fire('zoom', data);
            // @event move: Event
            // Fired repeatedly during any movement of the map, including pan and
            // fly animations.
            return this.fire('move', data);
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map has changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing (e.g. user stopped
            // dragging the map).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove$$1) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove$$1 ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (any3d && this.options.transform3DLimit) (remove$$1 ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && isExternalTarget(src, e)) targets = [
                this
            ];
            return targets;
        },
        _handleDOMEvent: function(e) {
            if (!this._loaded || skipped(e)) return;
            var type = e.type;
            if (type === 'mousedown' || type === 'keypress' || type === 'keyup' || type === 'keydown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(e.target || e.srcElement);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, targets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, targets);
            }
            if (e._stopped) return;
            // Find the layer the event is propagating from and its parents.
            targets = (targets || []).concat(this._findEventTargets(e, type));
            if (!targets.length) return;
            var target = targets[0];
            if (type === 'contextmenu' && target.listens(type, true)) preventDefault(e);
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(var i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (offset.round().equals([
                0,
                0
            ])) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom);
            // This anim frame should prevent an obscure iOS webkit tile loading race condition.
            requestAnimFrame(function() {
                this._moveEnd(true);
            }, this);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                if (!android) on(container, {
                    mouseenter: this.expand,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            if (touch) {
                on(link, 'click', stop);
                on(link, 'click', this.expand, this);
            } else on(link, 'focus', this.expand, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('div');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expand: function() {
            // Backward compatibility, remove me in 1.1.
            return this.expand();
        },
        _collapse: function() {
            // Backward compatibility, remove me in 1.1.
            return this.collapse();
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '+'
            // The text set on the 'zoom in' button.
            zoomInText: '+',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '&#x2212;'
            // The text set on the 'zoom out' button.
            zoomOutText: '&#x2212;',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            if (this._disabled || map._zoom === map.getMinZoom()) addClass(this._zoomOutButton, className);
            if (this._disabled || map._zoom === map.getMaxZoom()) addClass(this._zoomInButton, className);
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            return this._container;
        },
        // @method setPrefix(prefix: String): this
        // Sets the text before the attributions.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' | ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = touch ? 'touchstart mousedown' : 'mousedown';
    var END = {
        mousedown: 'mouseup',
        touchstart: 'touchend',
        pointerdown: 'touchend',
        MSPointerDown: 'touchend'
    };
    var MOVE = {
        mousedown: 'mousemove',
        touchstart: 'touchmove',
        pointerdown: 'touchmove',
        MSPointerDown: 'touchmove'
    };
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline$$1, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline$$1;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag();
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore simulated events, since we handle both touch and
            // mouse explicitly; otherwise we risk getting duplicates of
            // touch events, see #4315.
            // Also ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (e._simulated || !this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            on(document, MOVE[e.type], this._onMove, this);
            on(document, END[e.type], this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore simulated events, since we handle both touch and
            // mouse explicitly; otherwise we risk getting duplicates of
            // touch events, see #4315.
            // Also ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (e._simulated || !this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                this._startPos = getPosition(this._element).subtract(offset);
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            cancelAnimFrame(this._animRequest);
            this._lastEvent = e;
            this._animRequest = requestAnimFrame(this._updatePosition, this, true);
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function(e) {
            // Ignore simulated events, since we handle both touch and
            // mouse explicitly; otherwise we risk getting duplicates of
            // touch events, see #4315.
            // Also ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (e._simulated || !this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function() {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            for(var i in MOVE){
                off(document, MOVE[i], this._onMove, this);
                off(document, END[i], this._onUp, this);
            }
            enableImageDrag();
            enableTextSelection();
            if (this._moved && this._moving) {
                // ensure drag is not fired after dragend
                cancelAnimFrame(this._animRequest);
                // @event dragend: DragEndEvent
                // Fired when the drag ends.
                this.fire('dragend', {
                    distance: this._newPos.distanceTo(this._startPos)
                });
            }
            this._moving = false;
            Draggable._dragging = false;
        }
    });
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    var LineUtil = {
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat
    };
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    var PolyUtil = {
        clipPolygon: clipPolygon
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](http://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            if (this.getAttribution && map.attributionControl) map.attributionControl.addAttribution(this.getAttribution());
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            if (layer.getAttribution && this.attributionControl) this.attributionControl.removeAttribution(layer.getAttribution());
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return !!layer && stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            if (!layer) return false;
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ]
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (!IconDefault.imagePath) IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            if (path === null || path.indexOf('url') !== 0) path = '';
            else path = path.replace(/^url\(["']?/, '').replace(/marker-icon\.png["']?\)$/, '');
            return path;
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            title: '',
            // @option alt: String = ''
            // Text for the `alt` attribute of the icon image (useful for accessibility).
            alt: '',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) icon.tabIndex = '0';
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + this._renderer.options.tolerance;
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            var i, halfDist, segDist, dist, p1, p2, ratio, points = this._rings[0], len = points.length;
            if (!len) return null;
            // polyline centroid algorithm; only uses the first ring if there are multiple
            for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
            // The line is so small in the current view that all points are on the same pixel.
            if (halfDist === 0) return this._map.layerPointToLatLng(points[0]);
            for(i = 0, dist = 0; i < len - 1; i++){
                p1 = points[i];
                p2 = points[i + 1];
                segDist = p1.distanceTo(p2);
                dist += segDist;
                if (dist > halfDist) {
                    ratio = (dist - halfDist) / segDist;
                    return this._map.layerPointToLatLng([
                        p2.x - ratio * (p2.x - p1.x),
                        p2.y - ratio * (p2.y - p1.y)
                    ]);
                }
            }
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            var i, j, p1, p2, f, area, x, y, center, points = this._rings[0], len = points.length;
            if (!len) return null;
            // polygon centroid algorithm; only uses the first ring if there are multiple
            area = x = y = 0;
            for(i = 0, j = len - 1; i < len; j = i++){
                p1 = points[i];
                p2 = points[j];
                f = p1.y * p2.x - p2.y * p1.x;
                x += (p1.x + p2.x) * f;
                y += (p1.y + p2.y) * f;
                area += f * 3;
            }
            if (area === 0) // Polygon is so small that all points are on same pixel.
            center = points[0];
            else center = [
                x / area,
                y / area
            ];
            return this._map.layerPointToLatLng(center);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var layer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (layer) layers.push(layer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    function latLngToCoords(latlng, precision) {
        precision = typeof precision === 'number' ? precision : 6;
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)coords.push(levelsDeep ? latLngsToCoords(latlngs[i], levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed) coords.push(coords[0]);
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number): Object
    // `precision` is the number of decimal places for coordinates.
    // The default value is 6 places.
    // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number): Object
    // `precision` is the number of decimal places for coordinates.
    // The default value is 6 places.
    // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number): Object
    // `precision` is the number of decimal places for coordinates.
    // The default value is 6 places.
    // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number): Object
    // `precision` is the number of decimal places for coordinates.
    // The default value is 6 places.
    // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number): Object
        // `precision` is the number of decimal places for coordinates.
        // The default value is 6 places.
        // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. Browser compatibility- https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position. Useful to control the anchor
            // of the popup when opening it on some overlays.
            offset: [
                0,
                7
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: '',
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane'
        },
        initialize: function(options, source) {
            setOptions(this, options);
            this._source = source;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
        },
        // @namespace Popup
        // @method getLatLng: LatLng
        // Returns the geographical point of popup.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the popup will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the popup.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the popup.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the popup is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this popup in front of other popups (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this popup to the back of other popups (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        _prepareOpen: function(parent, layer, latlng) {
            if (!(layer instanceof Layer)) {
                latlng = layer;
                layer = parent;
            }
            if (layer instanceof FeatureGroup) for(var id in parent._layers){
                layer = parent._layers[id];
                break;
            }
            if (!latlng) {
                if (layer.getCenter) latlng = layer.getCenter();
                else if (layer.getLatLng) latlng = layer.getLatLng();
                else throw new Error('Unable to get source layer LatLng.');
            }
            // set overlay source to this layer
            this._source = layer;
            // update the overlay (content, layout, ect...)
            this.update();
            return latlng;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the popup in case the height of the popup changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   * Here's a more complicated way to open a popup on a map:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
        openOn: function(map) {
            map.openPopup(this);
            return this;
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this._close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _close: function() {
            if (this._map) this._map.closePopup(this);
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.href = '#close';
                closeButton.innerHTML = '&#215;';
                on(closeButton, 'click', this._onCloseButtonClick, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) map.fire('autopanstart').panBy([
                dx,
                dy
            ]);
        },
        _onCloseButtonClick: function(e) {
            this._close();
            stop(e);
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            if (!(popup instanceof Popup)) popup = new Popup(options).setContent(popup);
            if (latlng) popup.setLatLng(latlng);
            if (this.hasLayer(popup)) return this;
            if (this._popup && this._popup.options.autoClose) this.closePopup();
            this._popup = popup;
            return this.addLayer(popup);
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            if (!popup || popup === this._popup) {
                popup = this._popup;
                this._popup = null;
            }
            if (popup) this.removeLayer(popup);
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            if (content instanceof Popup) {
                setOptions(content, options);
                this._popup = content;
                content._source = this;
            } else {
                if (!this._popup || options) this._popup = new Popup(options, this);
                this._popup.setContent(content);
            }
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(layer, latlng) {
            if (this._popup && this._map) {
                latlng = this._popup._prepareOpen(this, layer, latlng);
                // open the popup on the map
                this._map.openPopup(this._popup, latlng);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup._close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function(target) {
            if (this._popup) {
                if (this._popup._map) this.closePopup();
                else this.openPopup(target);
            }
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            var layer = e.layer || e.target;
            if (!this._popup) return;
            if (!this._map) return;
            // prevent map click
            stop(e);
            // if this inherits from Path its a vector and we can just
            // open the popup at the new location
            if (layer instanceof Path) {
                this.openPopup(e.layer || e.target, e.latlng);
                return;
            }
            // otherwise treat it like a marker and figure out
            // if we should toggle it open/closed
            if (this._map.hasLayer(this._popup) && this._popup._source === layer) this.closePopup();
            else this.openPopup(layer, e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option interactive: Boolean = false
            // If true, the tooltip will listen to the feature events.
            interactive: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) // @namespace Layer
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip bound to this layer is opened.
            this._source.fire('tooltipopen', {
                tooltip: this
            }, true);
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) // @namespace Layer
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip bound to this layer is closed.
            this._source.fire('tooltipclose', {
                tooltip: this
            }, true);
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (touch && !this.options.permanent) events.preclick = this._close;
            return events;
        },
        _close: function() {
            if (this._map) this._map.closeTooltip(this);
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            if (!(tooltip instanceof Tooltip)) tooltip = new Tooltip(options).setContent(tooltip);
            if (latlng) tooltip.setLatLng(latlng);
            if (this.hasLayer(tooltip)) return this;
            return this.addLayer(tooltip);
        },
        // @method closeTooltip(tooltip?: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            if (tooltip) this.removeLayer(tooltip);
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (content instanceof Tooltip) {
                setOptions(content, options);
                this._tooltip = content;
                content._source = this;
            } else {
                if (!this._tooltip || options) this._tooltip = new Tooltip(options, this);
                this._tooltip.setContent(content);
            }
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove$$1) {
            if (!remove$$1 && this._tooltipHandlersAdded) return;
            var onOff = remove$$1 ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
                if (touch) events.click = this._openTooltip;
            } else events.add = this._openTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove$$1;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(layer, latlng) {
            if (this._tooltip && this._map) {
                latlng = this._tooltip._prepareOpen(this, layer, latlng);
                // open the tooltip on the map
                this._map.openTooltip(this._tooltip, latlng);
                // Tooltip container may not be defined if not permanent and never
                // opened.
                if (this._tooltip.options.interactive && this._tooltip._container) {
                    addClass(this._tooltip._container, 'leaflet-clickable');
                    this.addInteractiveTarget(this._tooltip._container);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) {
                this._tooltip._close();
                if (this._tooltip.options.interactive && this._tooltip._container) {
                    removeClass(this._tooltip._container, 'leaflet-clickable');
                    this.removeInteractiveTarget(this._tooltip._container);
                }
            }
            return this;
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function(target) {
            if (this._tooltip) {
                if (this._tooltip._map) this.closeTooltip();
                else this.openTooltip(target);
            }
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _openTooltip: function(e) {
            var layer = e.layer || e.target;
            if (!this._tooltip || !this._map) return;
            this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView();
            this._update();
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
            // without this hack, tiles disappear after zoom on Chrome for Android
            // https://github.com/Leaflet/Leaflet/issues/2078
            if (android && !android23) tile.style.WebkitBackfaceVisibility = 'hidden';
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom--;
                } else {
                    options.zoomOffset--;
                    options.minZoom++;
                }
                options.minZoom = Math.max(0, options.minZoom);
            }
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            // for https://github.com/Leaflet/Leaflet/issues/137
            if (!android) this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            /*
  		 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
  		 http://www.w3.org/TR/WCAG20-TECHS/H67
  		*/ tile.alt = '';
            /*
  		 Set role="presentation" to force screen readers to ignore this
  		 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
  		*/ tile.setAttribute('role', 'presentation');
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    remove(tile);
                    delete this._tiles[i];
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            // unless we're on Android's stock browser,
            // see https://github.com/Leaflet/Leaflet/issues/137
            if (!androidStock) tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1,
            // @option tolerance: Number = 0
            // How much to extend click tolerance round a path/object on the map
            tolerance: 0
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                if (this._zoomAnimated) addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), position = getPosition(this._container), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), destCenterPoint = this._map.project(center, zoom), centerOffset = destCenterPoint.subtract(currentCenterPoint), topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);
            if (any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type !== 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            if (clickedLayer) {
                fakeStop(e);
                this._fireEvent([
                    clickedLayer
                ], e);
            }
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            if (this._hoveredLayer) this._fireEvent([
                this._hoveredLayer
            ], e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas$1(options) {
        return canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
            return function(name) {
                return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
            };
        }
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create$2 = vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.zoomstart = this._onZoomStart;
            return events;
        },
        _initContainer: function() {
            this._container = create$2('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create$2('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _onZoomStart: function() {
            // Drag-then-pinch interactions might mess up the center and zoom.
            // In this case, the easiest way to prevent this is re-do the renderer
            //   bounds and padding when the zooming starts.
            this._update();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create$2('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg$1(options) {
        return svg || vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas$1(options) || svg$1(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create$2;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) this._finish();
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map be draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default unless running on old Android devices.
        inertia: !android23,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    map.panBy(offset);
                    if (map.options.maxBounds) map.panInsideBounds(map.options.maxBounds);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tap: Boolean = true
        // Enables mobile hacks for supporting instant taps (fixing 200ms click
        // delay on iOS/Android) and touch holds (fired as `contextmenu` events).
        tap: true,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var Tap = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            if (!e.touches) return;
            preventDefault(e);
            this._fireClick = true;
            // don't simulate click or track longpress if more than 1 touch
            if (e.touches.length > 1) {
                this._fireClick = false;
                clearTimeout(this._holdTimeout);
                return;
            }
            var first = e.touches[0], el = first.target;
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            // if touching a link, highlight it
            if (el.tagName && el.tagName.toLowerCase() === 'a') addClass(el, 'leaflet-active');
            // simulate long hold but setting a timeout
            this._holdTimeout = setTimeout(bind(function() {
                if (this._isTapValid()) {
                    this._fireClick = false;
                    this._onUp();
                    this._simulateEvent('contextmenu', first);
                }
            }, this), 1000);
            this._simulateEvent('mousedown', first);
            on(document, {
                touchmove: this._onMove,
                touchend: this._onUp
            }, this);
        },
        _onUp: function(e) {
            clearTimeout(this._holdTimeout);
            off(document, {
                touchmove: this._onMove,
                touchend: this._onUp
            }, this);
            if (this._fireClick && e && e.changedTouches) {
                var first = e.changedTouches[0], el = first.target;
                if (el && el.tagName && el.tagName.toLowerCase() === 'a') removeClass(el, 'leaflet-active');
                this._simulateEvent('mouseup', first);
                // simulate click if the touch didn't move too much
                if (this._isTapValid()) this._simulateEvent('click', first);
            }
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
            this._simulateEvent('mousemove', first);
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = document.createEvent('MouseEvents');
            simulatedEvent._simulated = true;
            e.target._simulatedClick = true;
            simulatedEvent.initMouseEvent(type, true, true, window, 1, e.screenX, e.screenY, e.clientX, e.clientY, false, false, false, false, 0, null);
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tap: Handler
    // Mobile touch hacks (quick tap and touch hold) handler.
    if (touch && (!pointer || safari)) Map.addInitHook('addHandler', 'tap', Tap);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers except for old Androids.
        touchZoom: touch && !android23,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            });
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.Tap = Tap;
    Map.TouchZoom = TouchZoom;
    exports1.version = version;
    exports1.Control = Control;
    exports1.control = control;
    exports1.Browser = Browser;
    exports1.Evented = Evented;
    exports1.Mixin = Mixin;
    exports1.Util = Util;
    exports1.Class = Class;
    exports1.Handler = Handler;
    exports1.extend = extend;
    exports1.bind = bind;
    exports1.stamp = stamp;
    exports1.setOptions = setOptions;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.PosAnimation = PosAnimation;
    exports1.Draggable = Draggable;
    exports1.LineUtil = LineUtil;
    exports1.PolyUtil = PolyUtil;
    exports1.Point = Point;
    exports1.point = toPoint;
    exports1.Bounds = Bounds;
    exports1.bounds = toBounds;
    exports1.Transformation = Transformation;
    exports1.transformation = toTransformation;
    exports1.Projection = index;
    exports1.LatLng = LatLng;
    exports1.latLng = toLatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.latLngBounds = toLatLngBounds;
    exports1.CRS = CRS;
    exports1.GeoJSON = GeoJSON;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.layerGroup = layerGroup;
    exports1.FeatureGroup = FeatureGroup;
    exports1.featureGroup = featureGroup;
    exports1.ImageOverlay = ImageOverlay;
    exports1.imageOverlay = imageOverlay;
    exports1.VideoOverlay = VideoOverlay;
    exports1.videoOverlay = videoOverlay;
    exports1.SVGOverlay = SVGOverlay;
    exports1.svgOverlay = svgOverlay;
    exports1.DivOverlay = DivOverlay;
    exports1.Popup = Popup;
    exports1.popup = popup;
    exports1.Tooltip = Tooltip;
    exports1.tooltip = tooltip;
    exports1.Icon = Icon;
    exports1.icon = icon;
    exports1.DivIcon = DivIcon;
    exports1.divIcon = divIcon;
    exports1.Marker = Marker;
    exports1.marker = marker;
    exports1.TileLayer = TileLayer;
    exports1.tileLayer = tileLayer;
    exports1.GridLayer = GridLayer;
    exports1.gridLayer = gridLayer;
    exports1.SVG = SVG;
    exports1.svg = svg$1;
    exports1.Renderer = Renderer;
    exports1.Canvas = Canvas;
    exports1.canvas = canvas$1;
    exports1.Path = Path;
    exports1.CircleMarker = CircleMarker;
    exports1.circleMarker = circleMarker;
    exports1.Circle = Circle;
    exports1.circle = circle;
    exports1.Polyline = Polyline;
    exports1.polyline = polyline;
    exports1.Polygon = Polygon;
    exports1.polygon = polygon;
    exports1.Rectangle = Rectangle;
    exports1.rectangle = rectangle;
    exports1.Map = Map;
    exports1.map = createMap;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});


var $80b8df6a6d317902$exports = {};
"use strict";
"use client";

Object.defineProperty($80b8df6a6d317902$exports, "__esModule", {
    value: true
});
$80b8df6a6d317902$exports.default = void 0;

var $80b8df6a6d317902$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $80b8df6a6d317902$var$_default = (0, $80b8df6a6d317902$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');
$80b8df6a6d317902$exports.default = $80b8df6a6d317902$var$_default;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");



var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");




var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $cICjK = parcelRequire("cICjK");




var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $2bdc2a51980b15c4$export$5162da8f798e0959(slot) {
    return (0, $6AMoU.default)('MuiCollapse', slot);
}
const $2bdc2a51980b15c4$var$collapseClasses = (0, $ithJf.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $2bdc2a51980b15c4$export$2e2bcd8739ae039 = $2bdc2a51980b15c4$var$collapseClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $56fef0a1611427f9$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $56fef0a1611427f9$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $2bdc2a51980b15c4$export$5162da8f798e0959), classes);
};
const $56fef0a1611427f9$var$CollapseRoot = (0, $jH1k7.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
        height: 'auto',
        width: 0,
        transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && (0, $gOPoC.default)({
        height: 'auto',
        overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
        visibility: 'hidden'
    }));
const $56fef0a1611427f9$var$CollapseWrapper = (0, $jH1k7.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: 'flex',
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
const $56fef0a1611427f9$var$CollapseWrapperInner = (0, $jH1k7.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $56fef0a1611427f9$var$Collapse = /*#__PURE__*/ $3OyDL.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $cICjK.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $af8ce78d3d22dabd$export$2e2bcd8739ae039) } = props, other = (0, $aBenZ.default)(props, $56fef0a1611427f9$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $56fef0a1611427f9$var$useUtilityClasses(ownerState);
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const timer = $3OyDL.useRef();
    const wrapperRef = $3OyDL.useRef(null);
    const autoTransitionDuration = $3OyDL.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    $3OyDL.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    const nodeRef = $3OyDL.useRef(null);
    const handleRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $737230c2f504d625$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $737230c2f504d625$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.current = setTimeout(next, autoTransitionDuration.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)(TransitionComponent, (0, $gOPoC.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $2M70Q.jsx)($56fef0a1611427f9$var$CollapseRoot, (0, $gOPoC.default)({
                as: component,
                className: (0, $3DmQB.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: (0, $gOPoC.default)({
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
                }, style),
                ownerState: (0, $gOPoC.default)({}, ownerState, {
                    state: state
                }),
                ref: handleRef
            }, childProps, {
                children: /*#__PURE__*/ (0, $2M70Q.jsx)($56fef0a1611427f9$var$CollapseWrapper, {
                    ownerState: (0, $gOPoC.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)($56fef0a1611427f9$var$CollapseWrapperInner, {
                        ownerState: (0, $gOPoC.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$56fef0a1611427f9$var$Collapse.muiSupportAuto = true;
var $56fef0a1611427f9$export$2e2bcd8739ae039 = $56fef0a1611427f9$var$Collapse;




var $3OyDL = parcelRequire("3OyDL");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $439a6efcba91a155$var$AccordionContext = /*#__PURE__*/ $3OyDL.createContext({});
var $439a6efcba91a155$export$2e2bcd8739ae039 = $439a6efcba91a155$var$AccordionContext;




var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $2ece32905b2e8d04$export$80fb6a2cb3f13b8b(slot) {
    return (0, $6AMoU.default)('MuiAccordion', slot);
}
const $2ece32905b2e8d04$var$accordionClasses = (0, $ithJf.default)('MuiAccordion', [
    'root',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $2ece32905b2e8d04$export$2e2bcd8739ae039 = $2ece32905b2e8d04$var$accordionClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $19e56772b842faf0$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "TransitionComponent",
    "TransitionProps"
];
const $19e56772b842faf0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        region: [
            'region'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $2ece32905b2e8d04$export$80fb6a2cb3f13b8b), classes);
};
const $19e56772b842faf0$var$AccordionRoot = (0, $jH1k7.default)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $2ece32905b2e8d04$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&:before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&:before': {
                display: 'none'
            }
        },
        [`&.${(0, $2ece32905b2e8d04$export$2e2bcd8739ae039).expanded}`]: {
            '&:before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&:before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $2ece32905b2e8d04$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({}, !ownerState.square && {
        borderRadius: 0,
        '&:first-of-type': {
            borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
            borderTopRightRadius: (theme.vars || theme).shape.borderRadius
        },
        '&:last-of-type': {
            borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
            borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
            // Fix a rendering issue on Edge
            '@supports (-ms-ime-align: auto)': {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
            }
        }
    }, !ownerState.disableGutters && {
        [`&.${(0, $2ece32905b2e8d04$export$2e2bcd8739ae039).expanded}`]: {
            margin: '16px 0'
        }
    }));
const $19e56772b842faf0$var$Accordion = /*#__PURE__*/ $3OyDL.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, TransitionComponent: TransitionComponent = (0, $56fef0a1611427f9$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $aBenZ.default)(props, $19e56772b842faf0$var$_excluded);
    const [expanded, setExpandedState] = (0, $ac2de2dab926b929$export$2e2bcd8739ae039)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $3OyDL.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $3OyDL.Children.toArray(childrenProp);
    const contextValue = $3OyDL.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $gOPoC.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $19e56772b842faf0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($19e56772b842faf0$var$AccordionRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $439a6efcba91a155$export$2e2bcd8739ae039).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)(TransitionComponent, (0, $gOPoC.default)({
                in: expanded,
                timeout: "auto"
            }, TransitionProps, {
                children: /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
var $19e56772b842faf0$export$2e2bcd8739ae039 = $19e56772b842faf0$var$Accordion;


var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $44fe6bea81488bad$export$a6afb527becfac26(slot) {
    return (0, $6AMoU.default)('MuiAccordionDetails', slot);
}
const $44fe6bea81488bad$var$accordionDetailsClasses = (0, $ithJf.default)('MuiAccordionDetails', [
    'root'
]);
var $44fe6bea81488bad$export$2e2bcd8739ae039 = $44fe6bea81488bad$var$accordionDetailsClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $bd3612b92fc47d5c$var$_excluded = [
    "className"
];
const $bd3612b92fc47d5c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $44fe6bea81488bad$export$a6afb527becfac26), classes);
};
const $bd3612b92fc47d5c$var$AccordionDetailsRoot = (0, $jH1k7.default)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $bd3612b92fc47d5c$var$AccordionDetails = /*#__PURE__*/ $3OyDL.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className } = props, other = (0, $aBenZ.default)(props, $bd3612b92fc47d5c$var$_excluded);
    const ownerState = props;
    const classes = $bd3612b92fc47d5c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($bd3612b92fc47d5c$var$AccordionDetailsRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $bd3612b92fc47d5c$export$2e2bcd8739ae039 = $bd3612b92fc47d5c$var$AccordionDetails;


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $b3e6b70230d684b7$export$282216ad123d6580(slot) {
    return (0, $6AMoU.default)('MuiAccordionSummary', slot);
}
const $b3e6b70230d684b7$var$accordionSummaryClasses = (0, $ithJf.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $b3e6b70230d684b7$export$2e2bcd8739ae039 = $b3e6b70230d684b7$var$accordionSummaryClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $7ba21131579dfa21$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $7ba21131579dfa21$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $b3e6b70230d684b7$export$282216ad123d6580), classes);
};
const $7ba21131579dfa21$var$AccordionSummaryRoot = (0, $jH1k7.default)((0, $c582f66505800c92$export$2e2bcd8739ae039), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return (0, $gOPoC.default)({
        display: 'flex',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $b3e6b70230d684b7$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $b3e6b70230d684b7$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $b3e6b70230d684b7$export$2e2bcd8739ae039).disabled})`]: {
            cursor: 'pointer'
        }
    }, !ownerState.disableGutters && {
        [`&.${(0, $b3e6b70230d684b7$export$2e2bcd8739ae039).expanded}`]: {
            minHeight: 64
        }
    });
});
const $7ba21131579dfa21$var$AccordionSummaryContent = (0, $jH1k7.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'flex',
        flexGrow: 1,
        margin: '12px 0'
    }, !ownerState.disableGutters && {
        transition: theme.transitions.create([
            'margin'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $b3e6b70230d684b7$export$2e2bcd8739ae039).expanded}`]: {
            margin: '20px 0'
        }
    }));
const $7ba21131579dfa21$var$AccordionSummaryExpandIconWrapper = (0, $jH1k7.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $b3e6b70230d684b7$export$2e2bcd8739ae039).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $7ba21131579dfa21$var$AccordionSummary = /*#__PURE__*/ $3OyDL.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $aBenZ.default)(props, $7ba21131579dfa21$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $3OyDL.useContext((0, $439a6efcba91a155$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $gOPoC.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $7ba21131579dfa21$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($7ba21131579dfa21$var$AccordionSummaryRoot, (0, $gOPoC.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $3DmQB.default)(classes.root, className),
        focusVisibleClassName: (0, $3DmQB.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)($7ba21131579dfa21$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $2M70Q.jsx)($7ba21131579dfa21$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
var $7ba21131579dfa21$export$2e2bcd8739ae039 = $7ba21131579dfa21$var$AccordionSummary;


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");


var $g4LX8 = parcelRequire("g4LX8");

var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");


var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $304184a91197be9e$export$72aef224d6115253(slot) {
    return (0, $6AMoU.default)('MuiTab', slot);
}
const $304184a91197be9e$var$tabClasses = (0, $ithJf.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper'
]);
var $304184a91197be9e$export$2e2bcd8739ae039 = $304184a91197be9e$var$tabClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $d43daa6ddaf4aee6$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $d43daa6ddaf4aee6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $g4LX8.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        iconWrapper: [
            'iconWrapper'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $304184a91197be9e$export$72aef224d6115253), classes);
};
const $d43daa6ddaf4aee6$var$TabRoot = (0, $jH1k7.default)((0, $c582f66505800c92$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $g4LX8.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center'
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $304184a91197be9e$export$2e2bcd8739ae039).iconWrapper}`]: (0, $gOPoC.default)({}, ownerState.iconPosition === 'top' && {
            marginBottom: 6
        }, ownerState.iconPosition === 'bottom' && {
            marginTop: 6
        }, ownerState.iconPosition === 'start' && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === 'end' && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === 'inherit' && {
        color: 'inherit',
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $304184a91197be9e$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $304184a91197be9e$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === 'primary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $304184a91197be9e$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $304184a91197be9e$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === 'secondary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $304184a91197be9e$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $304184a91197be9e$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $d43daa6ddaf4aee6$var$Tab = /*#__PURE__*/ $3OyDL.forwardRef(function Tab(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false } = props, other = (0, $aBenZ.default)(props, $d43daa6ddaf4aee6$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $d43daa6ddaf4aee6$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $3OyDL.isValidElement(iconProp) ? /*#__PURE__*/ $3OyDL.cloneElement(iconProp, {
        className: (0, $3DmQB.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($d43daa6ddaf4aee6$var$TabRoot, (0, $gOPoC.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $3DmQB.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $d43daa6ddaf4aee6$export$2e2bcd8739ae039 = $d43daa6ddaf4aee6$var$Tab;


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $3OyDL = parcelRequire("3OyDL");
'use client';
/**
 * @ignore - internal component.
 */ const $ef7a8fb2602dee30$var$TableContext = /*#__PURE__*/ $3OyDL.createContext();
var $ef7a8fb2602dee30$export$2e2bcd8739ae039 = $ef7a8fb2602dee30$var$TableContext;



var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $44860369a539ddfc$export$315cb19215f77ce0(slot) {
    return (0, $6AMoU.default)('MuiTable', slot);
}
const $44860369a539ddfc$var$tableClasses = (0, $ithJf.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $44860369a539ddfc$export$2e2bcd8739ae039 = $44860369a539ddfc$var$tableClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $e490cf7770112412$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $e490cf7770112412$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $44860369a539ddfc$export$315cb19215f77ce0), classes);
};
const $e490cf7770112412$var$TableRoot = (0, $jH1k7.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': (0, $gOPoC.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        })
    }, ownerState.stickyHeader && {
        borderCollapse: 'separate'
    }));
const $e490cf7770112412$var$defaultComponent = 'table';
const $e490cf7770112412$var$Table = /*#__PURE__*/ $3OyDL.forwardRef(function Table(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $e490cf7770112412$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false } = props, other = (0, $aBenZ.default)(props, $e490cf7770112412$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $e490cf7770112412$var$useUtilityClasses(ownerState);
    const table = $3OyDL.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ef7a8fb2602dee30$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($e490cf7770112412$var$TableRoot, (0, $gOPoC.default)({
            as: component,
            role: component === $e490cf7770112412$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $3DmQB.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $e490cf7770112412$export$2e2bcd8739ae039 = $e490cf7770112412$var$Table;


var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $3OyDL = parcelRequire("3OyDL");
/**
 * @ignore - internal component.
 */ const $0b239047812602a0$var$Tablelvl2Context = /*#__PURE__*/ $3OyDL.createContext();
var $0b239047812602a0$export$2e2bcd8739ae039 = $0b239047812602a0$var$Tablelvl2Context;



var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $4d4c8be7397d1989$export$98bd2a9b566ec665(slot) {
    return (0, $6AMoU.default)('MuiTableBody', slot);
}
const $4d4c8be7397d1989$var$tableBodyClasses = (0, $ithJf.default)('MuiTableBody', [
    'root'
]);
var $4d4c8be7397d1989$export$2e2bcd8739ae039 = $4d4c8be7397d1989$var$tableBodyClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $9cd8fb6cfe32623d$var$_excluded = [
    "className",
    "component"
];
const $9cd8fb6cfe32623d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $4d4c8be7397d1989$export$98bd2a9b566ec665), classes);
};
const $9cd8fb6cfe32623d$var$TableBodyRoot = (0, $jH1k7.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $9cd8fb6cfe32623d$var$tablelvl2 = {
    variant: 'body'
};
const $9cd8fb6cfe32623d$var$defaultComponent = 'tbody';
const $9cd8fb6cfe32623d$var$TableBody = /*#__PURE__*/ $3OyDL.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $9cd8fb6cfe32623d$var$defaultComponent } = props, other = (0, $aBenZ.default)(props, $9cd8fb6cfe32623d$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        component: component
    });
    const classes = $9cd8fb6cfe32623d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0b239047812602a0$export$2e2bcd8739ae039).Provider, {
        value: $9cd8fb6cfe32623d$var$tablelvl2,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($9cd8fb6cfe32623d$var$TableBodyRoot, (0, $gOPoC.default)({
            className: (0, $3DmQB.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $9cd8fb6cfe32623d$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $9cd8fb6cfe32623d$export$2e2bcd8739ae039 = $9cd8fb6cfe32623d$var$TableBody;


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");

var $g4LX8 = parcelRequire("g4LX8");



var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $8ce28433ab23dca3$export$33a0f07a16a10b1b(slot) {
    return (0, $6AMoU.default)('MuiTableCell', slot);
}
const $8ce28433ab23dca3$var$tableCellClasses = (0, $ithJf.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $8ce28433ab23dca3$export$2e2bcd8739ae039 = $8ce28433ab23dca3$var$tableCellClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $c13abfcb1085f546$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $c13abfcb1085f546$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $g4LX8.default)(align)}`,
            padding !== 'normal' && `padding${(0, $g4LX8.default)(padding)}`,
            `size${(0, $g4LX8.default)(size)}`
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $8ce28433ab23dca3$export$33a0f07a16a10b1b), classes);
};
const $c13abfcb1085f546$var$TableCellRoot = (0, $jH1k7.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $g4LX8.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $g4LX8.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $g4LX8.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $7m2iU.lighten)((0, $7m2iU.alpha)(theme.palette.divider, 1), 0.88) : (0, $7m2iU.darken)((0, $7m2iU.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, $8ce28433ab23dca3$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $c13abfcb1085f546$var$TableCell = /*#__PURE__*/ $3OyDL.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $aBenZ.default)(props, $c13abfcb1085f546$var$_excluded);
    const table = $3OyDL.useContext((0, $ef7a8fb2602dee30$export$2e2bcd8739ae039));
    const tablelvl2 = $3OyDL.useContext((0, $0b239047812602a0$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $gOPoC.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    });
    const classes = $c13abfcb1085f546$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $2M70Q.jsx)($c13abfcb1085f546$var$TableCellRoot, (0, $gOPoC.default)({
        as: component,
        ref: ref,
        className: (0, $3DmQB.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $c13abfcb1085f546$export$2e2bcd8739ae039 = $c13abfcb1085f546$var$TableCell;


var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");


var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $b4fe94ef0ce144ab$export$2e731cea2d1c2392(slot) {
    return (0, $6AMoU.default)('MuiTableHead', slot);
}
const $b4fe94ef0ce144ab$var$tableHeadClasses = (0, $ithJf.default)('MuiTableHead', [
    'root'
]);
var $b4fe94ef0ce144ab$export$2e2bcd8739ae039 = $b4fe94ef0ce144ab$var$tableHeadClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $e688dee05635481c$var$_excluded = [
    "className",
    "component"
];
const $e688dee05635481c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $b4fe94ef0ce144ab$export$2e731cea2d1c2392), classes);
};
const $e688dee05635481c$var$TableHeadRoot = (0, $jH1k7.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $e688dee05635481c$var$tablelvl2 = {
    variant: 'head'
};
const $e688dee05635481c$var$defaultComponent = 'thead';
const $e688dee05635481c$var$TableHead = /*#__PURE__*/ $3OyDL.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $e688dee05635481c$var$defaultComponent } = props, other = (0, $aBenZ.default)(props, $e688dee05635481c$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        component: component
    });
    const classes = $e688dee05635481c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0b239047812602a0$export$2e2bcd8739ae039).Provider, {
        value: $e688dee05635481c$var$tablelvl2,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($e688dee05635481c$var$TableHeadRoot, (0, $gOPoC.default)({
            as: component,
            className: (0, $3DmQB.default)(classes.root, className),
            ref: ref,
            role: component === $e688dee05635481c$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $e688dee05635481c$export$2e2bcd8739ae039 = $e688dee05635481c$var$TableHead;


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $caYvM = parcelRequire("caYvM");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $dy6Cj = parcelRequire("dy6Cj");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $d56c030fc10f81b6$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $08f8242d1335e94b$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $08f8242d1335e94b$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $08f8242d1335e94b$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $08f8242d1335e94b$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $08f8242d1335e94b$export$d1710922ecaf577a = /*#__PURE__*/ $3OyDL.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $aBenZ.default)(props, $08f8242d1335e94b$var$_excluded);
    const { current: isControlled } = $3OyDL.useRef(value != null);
    const inputRef = $3OyDL.useRef(null);
    const handleRef = (0, $c9f4324d1af2c9eb$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $3OyDL.useRef(null);
    const renders = $3OyDL.useRef(0);
    const [state, setState] = $3OyDL.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $3OyDL.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $f92353c1dc740692$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $08f8242d1335e94b$var$getStyleValue(computedStyle.paddingBottom) + $08f8242d1335e94b$var$getStyleValue(computedStyle.paddingTop);
        const border = $08f8242d1335e94b$var$getStyleValue(computedStyle.borderBottomWidth) + $08f8242d1335e94b$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle, overflow: overflow } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $3OyDL.useCallback(()=>{
        const newState = getUpdatedState();
        if ($08f8242d1335e94b$var$isEmpty(newState)) return;
        setState((prevState)=>updateState(prevState, newState));
    }, [
        getUpdatedState
    ]);
    (0, $9df71761ea25deba$export$2e2bcd8739ae039)(()=>{
        const syncHeightWithFlushSync = ()=>{
            const newState = getUpdatedState();
            if ($08f8242d1335e94b$var$isEmpty(newState)) return;
            // In React 18, state updates in a ResizeObserver's callback are happening after
            // the paint, this leads to an infinite rendering.
            //
            // Using flushSync ensures that the states is updated before the next pain.
            // Related issue - https://github.com/facebook/react/issues/24331
            $dy6Cj.flushSync(()=>{
                setState((prevState)=>updateState(prevState, newState));
            });
        };
        const handleResize = ()=>{
            renders.current = 0;
            syncHeightWithFlushSync();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $d56c030fc10f81b6$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $f92353c1dc740692$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener('resize', debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener('resize', debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        getUpdatedState
    ]);
    (0, $9df71761ea25deba$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    $3OyDL.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("textarea", (0, $gOPoC.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $gOPoC.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? 'hidden' : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $2M70Q.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $gOPoC.default)({}, $08f8242d1335e94b$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});


var $5jsOu = parcelRequire("5jsOu");
function $26b79efadb7be4d4$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $3OyDL = parcelRequire("3OyDL");
/**
 * @ignore - internal component.
 */ const $677abf603a37a554$var$FormControlContext = /*#__PURE__*/ $3OyDL.createContext(undefined);
var $677abf603a37a554$export$2e2bcd8739ae039 = $677abf603a37a554$var$FormControlContext;



var $3OyDL = parcelRequire("3OyDL");

'use client';
function $38dd66485068cbe7$export$2e2bcd8739ae039() {
    return $3OyDL.useContext((0, $677abf603a37a554$export$2e2bcd8739ae039));
}



var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $g4LX8 = parcelRequire("g4LX8");



// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $5c90c10b8a42aafe$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $5c90c10b8a42aafe$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($5c90c10b8a42aafe$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $5c90c10b8a42aafe$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $5c90c10b8a42aafe$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $70f299dd29a343ff$export$ef57d5c8ca2278f6(slot) {
    return (0, $6AMoU.default)('MuiInputBase', slot);
}
const $70f299dd29a343ff$var$inputBaseClasses = (0, $ithJf.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $70f299dd29a343ff$export$2e2bcd8739ae039 = $70f299dd29a343ff$var$inputBaseClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $f708841d75fb4e6f$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $f708841d75fb4e6f$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $g4LX8.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $f708841d75fb4e6f$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $f708841d75fb4e6f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $g4LX8.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $g4LX8.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $70f299dd29a343ff$export$ef57d5c8ca2278f6), classes);
};
const $f708841d75fb4e6f$export$298a043133d72a38 = (0, $jH1k7.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $f708841d75fb4e6f$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $70f299dd29a343ff$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $gOPoC.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $f708841d75fb4e6f$export$a1ad29c901026019 = (0, $jH1k7.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $f708841d75fb4e6f$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $gOPoC.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $gOPoC.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $70f299dd29a343ff$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $70f299dd29a343ff$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $f708841d75fb4e6f$var$inputGlobalStyles = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $75fb50280c5459b0$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $f708841d75fb4e6f$var$InputBase = /*#__PURE__*/ $3OyDL.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $aBenZ.default)(props, $f708841d75fb4e6f$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $3OyDL.useRef(value != null);
    const inputRef = $3OyDL.useRef();
    const handleInputRefWarning = $3OyDL.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $3OyDL.useState(false);
    const muiFormControl = (0, $38dd66485068cbe7$export$2e2bcd8739ae039)();
    const fcs = (0, $26b79efadb7be4d4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $3OyDL.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $3OyDL.useCallback((obj)=>{
        if ((0, $5c90c10b8a42aafe$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $b8bb11a9fe67b1a2$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $caYvM.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $3OyDL.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $gOPoC.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $gOPoC.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $08f8242d1335e94b$export$d1710922ecaf577a);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $3OyDL.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $gOPoC.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $f708841d75fb4e6f$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $f708841d75fb4e6f$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $f708841d75fb4e6f$export$a1ad29c901026019;
    inputProps = (0, $gOPoC.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $f708841d75fb4e6f$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $2M70Q.jsxs)(Root, (0, $gOPoC.default)({}, rootProps, !(0, $03d7e3d159693402$export$e28348cc2430497)(Root) && {
                ownerState: (0, $gOPoC.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $3DmQB.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $677abf603a37a554$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)(Input, (0, $gOPoC.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $03d7e3d159693402$export$e28348cc2430497)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $gOPoC.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $3DmQB.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $gOPoC.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $f708841d75fb4e6f$export$2e2bcd8739ae039 = $f708841d75fb4e6f$var$InputBase;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $3OyDL = parcelRequire("3OyDL");
'use client';
/**
 * @ignore - internal component.
 */ const $3818dd11f6b8b9fa$var$ListContext = /*#__PURE__*/ $3OyDL.createContext({});
var $3818dd11f6b8b9fa$export$2e2bcd8739ae039 = $3818dd11f6b8b9fa$var$ListContext;






var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $339578e4784e018b$export$46f01d01378ec5a2(slot) {
    return (0, $6AMoU.default)('MuiDivider', slot);
}
const $339578e4784e018b$var$dividerClasses = (0, $ithJf.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $339578e4784e018b$export$2e2bcd8739ae039 = $339578e4784e018b$var$dividerClasses;



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $afefa0c5da26362b$export$81478e24460c57f2(slot) {
    return (0, $6AMoU.default)('MuiListItemIcon', slot);
}
const $afefa0c5da26362b$var$listItemIconClasses = (0, $ithJf.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $afefa0c5da26362b$export$2e2bcd8739ae039 = $afefa0c5da26362b$var$listItemIconClasses;



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $96922334656d0b63$export$1061006a0db3aeb5(slot) {
    return (0, $6AMoU.default)('MuiListItemText', slot);
}
const $96922334656d0b63$var$listItemTextClasses = (0, $ithJf.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $96922334656d0b63$export$2e2bcd8739ae039 = $96922334656d0b63$var$listItemTextClasses;



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $5412428268a853af$export$515f8c67b5305377(slot) {
    return (0, $6AMoU.default)('MuiMenuItem', slot);
}
const $5412428268a853af$var$menuItemClasses = (0, $ithJf.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $5412428268a853af$export$2e2bcd8739ae039 = $5412428268a853af$var$menuItemClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $c79ba0e99ec70dbd$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $c79ba0e99ec70dbd$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $c79ba0e99ec70dbd$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $5jsOu.default)(slots, (0, $5412428268a853af$export$515f8c67b5305377), classes);
    return (0, $gOPoC.default)({}, classes, composedClasses);
};
const $c79ba0e99ec70dbd$var$MenuItemRoot = (0, $jH1k7.default)((0, $c582f66505800c92$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $jH1k7.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $c79ba0e99ec70dbd$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $5412428268a853af$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $5412428268a853af$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $5412428268a853af$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $5412428268a853af$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $5412428268a853af$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $339578e4784e018b$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $339578e4784e018b$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $96922334656d0b63$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $96922334656d0b63$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $afefa0c5da26362b$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $gOPoC.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $afefa0c5da26362b$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $c79ba0e99ec70dbd$var$MenuItem = /*#__PURE__*/ $3OyDL.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $aBenZ.default)(props, $c79ba0e99ec70dbd$var$_excluded);
    const context = $3OyDL.useContext((0, $3818dd11f6b8b9fa$export$2e2bcd8739ae039));
    const childContext = $3OyDL.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $3OyDL.useRef(null);
    (0, $b8bb11a9fe67b1a2$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $gOPoC.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $c79ba0e99ec70dbd$var$useUtilityClasses(props);
    const handleRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3818dd11f6b8b9fa$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($c79ba0e99ec70dbd$var$MenuItemRoot, (0, $gOPoC.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $3DmQB.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $3DmQB.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $c79ba0e99ec70dbd$export$2e2bcd8739ae039 = $c79ba0e99ec70dbd$var$MenuItem;



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $798ep = parcelRequire("798ep");

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $caYvM = parcelRequire("caYvM");

var $3OyDL = parcelRequire("3OyDL");



var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");
function $57e487ec207f4c73$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $e2c4e3ce20421058$export$2e2bcd8739ae039 = (0, $57e487ec207f4c73$export$2e2bcd8739ae039);



var $g4LX8 = parcelRequire("g4LX8");

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");



var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");




var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");


var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $9bd0992dd231b203$export$c6bd6795ed6e3203(slot) {
    return (0, $6AMoU.default)('MuiList', slot);
}
const $9bd0992dd231b203$var$listClasses = (0, $ithJf.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $9bd0992dd231b203$export$2e2bcd8739ae039 = $9bd0992dd231b203$var$listClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $77956800979257fa$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $77956800979257fa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $9bd0992dd231b203$export$c6bd6795ed6e3203), classes);
};
const $77956800979257fa$var$ListRoot = (0, $jH1k7.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $77956800979257fa$var$List = /*#__PURE__*/ $3OyDL.forwardRef(function List(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $aBenZ.default)(props, $77956800979257fa$var$_excluded);
    const context = $3OyDL.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $gOPoC.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $77956800979257fa$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3818dd11f6b8b9fa$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)($77956800979257fa$var$ListRoot, (0, $gOPoC.default)({
            as: component,
            className: (0, $3DmQB.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $77956800979257fa$export$2e2bcd8739ae039 = $77956800979257fa$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $178613948c0f2324$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $ba7f7b55a3b9a199$export$2e2bcd8739ae039 = (0, $178613948c0f2324$export$2e2bcd8739ae039);





var $2M70Q = parcelRequire("2M70Q");
'use client';
const $ae62bf342774ffad$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $ae62bf342774ffad$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $ae62bf342774ffad$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $ae62bf342774ffad$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $ae62bf342774ffad$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$ae62bf342774ffad$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $ae62bf342774ffad$var$MenuList = /*#__PURE__*/ $3OyDL.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $aBenZ.default)(props, $ae62bf342774ffad$var$_excluded);
    const listRef = $3OyDL.useRef(null);
    const textCriteriaRef = $3OyDL.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $b8bb11a9fe67b1a2$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $3OyDL.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $ba7f7b55a3b9a199$export$2e2bcd8739ae039)((0, $e2c4e3ce20421058$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $e2c4e3ce20421058$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $ae62bf342774ffad$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $ae62bf342774ffad$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $ae62bf342774ffad$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $ae62bf342774ffad$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $ae62bf342774ffad$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $ae62bf342774ffad$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $ae62bf342774ffad$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $ae62bf342774ffad$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $ae62bf342774ffad$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $ae62bf342774ffad$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $ae62bf342774ffad$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $3OyDL.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $3OyDL.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $3OyDL.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $3OyDL.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $77956800979257fa$export$2e2bcd8739ae039), (0, $gOPoC.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $ae62bf342774ffad$export$2e2bcd8739ae039 = $ae62bf342774ffad$var$MenuList;



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");


var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7d09891dbef35d12$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $866c689a9d9fa1f1$export$2e2bcd8739ae039 = (0, $7d09891dbef35d12$export$2e2bcd8739ae039);




function $7fea3adabc8e950e$export$2e2bcd8739ae039(node) {
    const doc = (0, $57e487ec207f4c73$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $53d8d8b54b711b01$export$2e2bcd8739ae039 = (0, $7fea3adabc8e950e$export$2e2bcd8739ae039);







var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $4539dd06821f0631$export$88f455dd56c95edb(slot) {
    return (0, $6AMoU.default)('MuiPopover', slot);
}
const $4539dd06821f0631$var$popoverClasses = (0, $ithJf.default)('MuiPopover', [
    'root',
    'paper'
]);
var $4539dd06821f0631$export$2e2bcd8739ae039 = $4539dd06821f0631$var$popoverClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $3d66e9e40e3cbf49$var$_excluded = [
    "onEntering"
], $3d66e9e40e3cbf49$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $3d66e9e40e3cbf49$var$_excluded3 = [
    "slotProps"
];
function $3d66e9e40e3cbf49$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $3d66e9e40e3cbf49$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $3d66e9e40e3cbf49$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $3d66e9e40e3cbf49$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $3d66e9e40e3cbf49$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $4539dd06821f0631$export$88f455dd56c95edb), classes);
};
const $3d66e9e40e3cbf49$export$bcce13685275fc99 = (0, $jH1k7.default)((0, $52be310452cd31e6$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $3d66e9e40e3cbf49$export$821346c38a2d9390 = (0, $jH1k7.default)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $3d66e9e40e3cbf49$var$Popover = /*#__PURE__*/ $3OyDL.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $a144ebfc440ec800$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $aBenZ.default)(props.TransitionProps, $3d66e9e40e3cbf49$var$_excluded), other = (0, $aBenZ.default)(props, $3d66e9e40e3cbf49$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $3OyDL.useRef();
    const handlePaperRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $gOPoC.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $3d66e9e40e3cbf49$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $3OyDL.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $3d66e9e40e3cbf49$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $e2c4e3ce20421058$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $3d66e9e40e3cbf49$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $3d66e9e40e3cbf49$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $3OyDL.useCallback((elemRect)=>{
        return {
            vertical: $3d66e9e40e3cbf49$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $3d66e9e40e3cbf49$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $3OyDL.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $3d66e9e40e3cbf49$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $53d8d8b54b711b01$export$2e2bcd8739ae039)($3d66e9e40e3cbf49$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $3d66e9e40e3cbf49$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $3OyDL.useState(open);
    const setPositioningStyles = $3OyDL.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $3OyDL.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $3OyDL.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $3OyDL.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $3OyDL.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $866c689a9d9fa1f1$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $53d8d8b54b711b01$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $e2c4e3ce20421058$export$2e2bcd8739ae039)($3d66e9e40e3cbf49$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $3d66e9e40e3cbf49$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $3d66e9e40e3cbf49$export$821346c38a2d9390;
    const paperProps = (0, $9be467578d9a8fea$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: (0, $gOPoC.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $gOPoC.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $3DmQB.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $9be467578d9a8fea$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $3DmQB.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $aBenZ.default)(_useSlotProps, $3d66e9e40e3cbf49$var$_excluded3);
    return /*#__PURE__*/ (0, $2M70Q.jsx)(RootSlot, (0, $gOPoC.default)({}, rootProps, !(0, $03d7e3d159693402$export$e28348cc2430497)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)(TransitionComponent, (0, $gOPoC.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $2M70Q.jsx)(PaperSlot, (0, $gOPoC.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $3d66e9e40e3cbf49$export$2e2bcd8739ae039 = $3d66e9e40e3cbf49$var$Popover;



var $jH1k7 = parcelRequire("jH1k7");


var $jFgmT = parcelRequire("jFgmT");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $d27904345e0f68c4$export$2cf86a63a84fe23d(slot) {
    return (0, $6AMoU.default)('MuiMenu', slot);
}
const $d27904345e0f68c4$var$menuClasses = (0, $ithJf.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $d27904345e0f68c4$export$2e2bcd8739ae039 = $d27904345e0f68c4$var$menuClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $224f5bbe5b959c30$var$_excluded = [
    "onEntering"
], $224f5bbe5b959c30$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $224f5bbe5b959c30$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $224f5bbe5b959c30$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $224f5bbe5b959c30$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $d27904345e0f68c4$export$2cf86a63a84fe23d), classes);
};
const $224f5bbe5b959c30$var$MenuRoot = (0, $jH1k7.default)((0, $3d66e9e40e3cbf49$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $jH1k7.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $224f5bbe5b959c30$export$4f7c51a5920c9f33 = (0, $jH1k7.default)((0, $3d66e9e40e3cbf49$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $224f5bbe5b959c30$var$MenuMenuList = (0, $jH1k7.default)((0, $ae62bf342774ffad$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $224f5bbe5b959c30$var$Menu = /*#__PURE__*/ $3OyDL.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $aBenZ.default)(props.TransitionProps, $224f5bbe5b959c30$var$_excluded), other = (0, $aBenZ.default)(props, $224f5bbe5b959c30$var$_excluded2);
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === 'rtl';
    const ownerState = (0, $gOPoC.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $224f5bbe5b959c30$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $3OyDL.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $3OyDL.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $3OyDL.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $224f5bbe5b959c30$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $9be467578d9a8fea$export$1e5c9e6e4e15efe3)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $9be467578d9a8fea$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)($224f5bbe5b959c30$var$MenuRoot, (0, $gOPoC.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $224f5bbe5b959c30$var$RTL_ORIGIN : $224f5bbe5b959c30$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $gOPoC.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($224f5bbe5b959c30$var$MenuMenuList, (0, $gOPoC.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $3DmQB.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $224f5bbe5b959c30$export$2e2bcd8739ae039 = $224f5bbe5b959c30$var$Menu;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $g4LX8 = parcelRequire("g4LX8");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $4e60fabe8ee1dead$export$1ee13051fd9e2ab5(slot) {
    return (0, $6AMoU.default)('MuiNativeSelect', slot);
}
const $4e60fabe8ee1dead$var$nativeSelectClasses = (0, $ithJf.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $4e60fabe8ee1dead$export$2e2bcd8739ae039 = $4e60fabe8ee1dead$var$nativeSelectClasses;



var $jH1k7 = parcelRequire("jH1k7");

var $2M70Q = parcelRequire("2M70Q");
'use client';
const $d15a8bebcf4f4836$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $d15a8bebcf4f4836$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $g4LX8.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $4e60fabe8ee1dead$export$1ee13051fd9e2ab5), classes);
};
const $d15a8bebcf4f4836$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $gOPoC.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $gOPoC.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $4e60fabe8ee1dead$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $d15a8bebcf4f4836$var$NativeSelectSelect = (0, $jH1k7.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $jH1k7.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $4e60fabe8ee1dead$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($d15a8bebcf4f4836$export$c1eccd1617458c87);
const $d15a8bebcf4f4836$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $gOPoC.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $4e60fabe8ee1dead$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $d15a8bebcf4f4836$var$NativeSelectIcon = (0, $jH1k7.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $g4LX8.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($d15a8bebcf4f4836$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $d15a8bebcf4f4836$var$NativeSelectInput = /*#__PURE__*/ $3OyDL.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $aBenZ.default)(props, $d15a8bebcf4f4836$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $d15a8bebcf4f4836$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)($d15a8bebcf4f4836$var$NativeSelectSelect, (0, $gOPoC.default)({
                ownerState: ownerState,
                className: (0, $3DmQB.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $2M70Q.jsx)($d15a8bebcf4f4836$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $d15a8bebcf4f4836$export$2e2bcd8739ae039 = $d15a8bebcf4f4836$var$NativeSelectInput;




var $jH1k7 = parcelRequire("jH1k7");



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $a1ee1a1ea45c07ae$export$2c0c1ee5a3392e(slot) {
    return (0, $6AMoU.default)('MuiSelect', slot);
}
const $a1ee1a1ea45c07ae$var$selectClasses = (0, $ithJf.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $a1ee1a1ea45c07ae$export$2e2bcd8739ae039 = $a1ee1a1ea45c07ae$var$selectClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
var $b0bd2ed87670090c$var$_span;
const $b0bd2ed87670090c$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $b0bd2ed87670090c$var$SelectSelect = (0, $jH1k7.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $a1ee1a1ea45c07ae$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $a1ee1a1ea45c07ae$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $a1ee1a1ea45c07ae$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $a1ee1a1ea45c07ae$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $d15a8bebcf4f4836$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $a1ee1a1ea45c07ae$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $b0bd2ed87670090c$var$SelectIcon = (0, $jH1k7.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $g4LX8.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $d15a8bebcf4f4836$export$e7a817afd12a40d0));
const $b0bd2ed87670090c$var$SelectNativeInput = (0, $jH1k7.default)('input', {
    shouldForwardProp: (prop)=>(0, $jH1k7.slotShouldForwardProp)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $b0bd2ed87670090c$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $b0bd2ed87670090c$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $b0bd2ed87670090c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $g4LX8.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $a1ee1a1ea45c07ae$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $b0bd2ed87670090c$var$SelectInput = /*#__PURE__*/ $3OyDL.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $aBenZ.default)(props, $b0bd2ed87670090c$var$_excluded);
    const [value, setValueState] = (0, $ac2de2dab926b929$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $ac2de2dab926b929$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $3OyDL.useRef(null);
    const displayRef = $3OyDL.useRef(null);
    const [displayNode, setDisplayNode] = $3OyDL.useState(null);
    const { current: isOpenControlled } = $3OyDL.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $3OyDL.useState();
    const handleRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $3OyDL.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $3OyDL.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $3OyDL.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $3OyDL.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $3OyDL.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $e2c4e3ce20421058$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $3OyDL.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $5c90c10b8a42aafe$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $3OyDL.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $caYvM.default)(2));
            selected = value.some((v)=>$b0bd2ed87670090c$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $b0bd2ed87670090c$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $3OyDL.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $gOPoC.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $b0bd2ed87670090c$var$useUtilityClasses(ownerState);
    const paperProps = (0, $gOPoC.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)($b0bd2ed87670090c$var$SelectSelect, (0, $gOPoC.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "button",
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $3DmQB.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $b0bd2ed87670090c$var$isEmpty(display) ? $b0bd2ed87670090c$var$_span || ($b0bd2ed87670090c$var$_span = /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $2M70Q.jsx)($b0bd2ed87670090c$var$SelectNativeInput, (0, $gOPoC.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $2M70Q.jsx)($b0bd2ed87670090c$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $224f5bbe5b959c30$export$2e2bcd8739ae039), (0, $gOPoC.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $gOPoC.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true
                }, MenuProps.MenuListProps),
                slotProps: {
                    paper: (0, $gOPoC.default)({}, paperProps, {
                        style: (0, $gOPoC.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                },
                children: items
            }))
        ]
    });
});
var $b0bd2ed87670090c$export$2e2bcd8739ae039 = $b0bd2ed87670090c$var$SelectInput;




parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $9492c6fe2457f8c9$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $5jsOu = parcelRequire("5jsOu");

var $798ep = parcelRequire("798ep");


var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $gOPoC = parcelRequire("gOPoC");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");

function $c590c70ed64f391b$export$cdb270390122322b(slot) {
    return (0, $6AMoU.default)('MuiInput', slot);
}
const $c590c70ed64f391b$var$inputClasses = (0, $gOPoC.default)({}, (0, $70f299dd29a343ff$export$2e2bcd8739ae039), (0, $ithJf.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $c590c70ed64f391b$export$2e2bcd8739ae039 = $c590c70ed64f391b$var$inputClasses;




var $2M70Q = parcelRequire("2M70Q");
'use client';
const $af5f6013d5f6a10c$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $af5f6013d5f6a10c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $5jsOu.default)(slots, (0, $c590c70ed64f391b$export$cdb270390122322b), classes);
    return (0, $gOPoC.default)({}, classes, composedClasses);
};
const $af5f6013d5f6a10c$var$InputRoot = (0, $jH1k7.default)((0, $f708841d75fb4e6f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $jH1k7.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $f708841d75fb4e6f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $gOPoC.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&:after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $c590c70ed64f391b$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $c590c70ed64f391b$export$2e2bcd8739ae039).error}`]: {
            '&:before, &:after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&:before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $c590c70ed64f391b$export$2e2bcd8739ae039).disabled}, .${(0, $c590c70ed64f391b$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $c590c70ed64f391b$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $af5f6013d5f6a10c$var$InputInput = (0, $jH1k7.default)((0, $f708841d75fb4e6f$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $f708841d75fb4e6f$export$cf507b112810e72d)
})({});
const $af5f6013d5f6a10c$var$Input = /*#__PURE__*/ $3OyDL.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $aBenZ.default)(props, $af5f6013d5f6a10c$var$_excluded);
    const classes = $af5f6013d5f6a10c$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $798ep.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $af5f6013d5f6a10c$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $af5f6013d5f6a10c$var$InputInput;
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f708841d75fb4e6f$export$2e2bcd8739ae039), (0, $gOPoC.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$af5f6013d5f6a10c$var$Input.muiName = 'Input';
var $af5f6013d5f6a10c$export$2e2bcd8739ae039 = $af5f6013d5f6a10c$var$Input;




var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $798ep = parcelRequire("798ep");


var $5jsOu = parcelRequire("5jsOu");


var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $gOPoC = parcelRequire("gOPoC");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");

function $ee9f8d4ca5e8ce80$export$3331e419f1a48437(slot) {
    return (0, $6AMoU.default)('MuiFilledInput', slot);
}
const $ee9f8d4ca5e8ce80$var$filledInputClasses = (0, $gOPoC.default)({}, (0, $70f299dd29a343ff$export$2e2bcd8739ae039), (0, $ithJf.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039 = $ee9f8d4ca5e8ce80$var$filledInputClasses;




var $2M70Q = parcelRequire("2M70Q");
'use client';
const $c581196ed9d5e621$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $c581196ed9d5e621$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $5jsOu.default)(slots, (0, $ee9f8d4ca5e8ce80$export$3331e419f1a48437), classes);
    return (0, $gOPoC.default)({}, classes, composedClasses);
};
const $c581196ed9d5e621$var$FilledInputRoot = (0, $jH1k7.default)((0, $f708841d75fb4e6f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $jH1k7.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $f708841d75fb4e6f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $gOPoC.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&:after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039).error}`]: {
            '&:before, &:after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&:before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039).disabled}, .${(0, $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $gOPoC.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $c581196ed9d5e621$var$FilledInputInput = (0, $jH1k7.default)((0, $f708841d75fb4e6f$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $f708841d75fb4e6f$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $c581196ed9d5e621$var$FilledInput = /*#__PURE__*/ $3OyDL.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $aBenZ.default)(props, $c581196ed9d5e621$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $c581196ed9d5e621$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $798ep.default)(slotProps != null ? slotProps : componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $c581196ed9d5e621$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $c581196ed9d5e621$var$FilledInputInput;
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f708841d75fb4e6f$export$2e2bcd8739ae039), (0, $gOPoC.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$c581196ed9d5e621$var$FilledInput.muiName = 'Input';
var $c581196ed9d5e621$export$2e2bcd8739ae039 = $c581196ed9d5e621$var$FilledInput;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");



var $5jsOu = parcelRequire("5jsOu");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");
parcelRequire("3OyDL");


var $jH1k7 = parcelRequire("jH1k7");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $86eb0d6a6cd065e3$var$_span;
const $86eb0d6a6cd065e3$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $86eb0d6a6cd065e3$var$NotchedOutlineRoot = (0, $jH1k7.default)('fieldset')({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $86eb0d6a6cd065e3$var$NotchedOutlineLegend = (0, $jH1k7.default)('legend')(({ ownerState: ownerState, theme: theme })=>(0, $gOPoC.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $gOPoC.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $86eb0d6a6cd065e3$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $aBenZ.default)(props, $86eb0d6a6cd065e3$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $gOPoC.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)($86eb0d6a6cd065e3$var$NotchedOutlineRoot, (0, $gOPoC.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($86eb0d6a6cd065e3$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                children: label
            }) : $86eb0d6a6cd065e3$var$_span || ($86eb0d6a6cd065e3$var$_span = /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $jH1k7 = parcelRequire("jH1k7");

var $gOPoC = parcelRequire("gOPoC");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");

function $e50b7ddb1f511773$export$89922944c7227687(slot) {
    return (0, $6AMoU.default)('MuiOutlinedInput', slot);
}
const $e50b7ddb1f511773$var$outlinedInputClasses = (0, $gOPoC.default)({}, (0, $70f299dd29a343ff$export$2e2bcd8739ae039), (0, $ithJf.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $e50b7ddb1f511773$export$2e2bcd8739ae039 = $e50b7ddb1f511773$var$outlinedInputClasses;




var $jFgmT = parcelRequire("jFgmT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
const $010361f6348e7d57$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $010361f6348e7d57$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $5jsOu.default)(slots, (0, $e50b7ddb1f511773$export$89922944c7227687), classes);
    return (0, $gOPoC.default)({}, classes, composedClasses);
};
const $010361f6348e7d57$var$OutlinedInputRoot = (0, $jH1k7.default)((0, $f708841d75fb4e6f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $jH1k7.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $f708841d75fb4e6f$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $gOPoC.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $e50b7ddb1f511773$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $e50b7ddb1f511773$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $e50b7ddb1f511773$export$2e2bcd8739ae039).focused} .${(0, $e50b7ddb1f511773$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $e50b7ddb1f511773$export$2e2bcd8739ae039).error} .${(0, $e50b7ddb1f511773$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $e50b7ddb1f511773$export$2e2bcd8739ae039).disabled} .${(0, $e50b7ddb1f511773$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $gOPoC.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $010361f6348e7d57$var$NotchedOutlineRoot = (0, $jH1k7.default)((0, $86eb0d6a6cd065e3$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $010361f6348e7d57$var$OutlinedInputInput = (0, $jH1k7.default)((0, $f708841d75fb4e6f$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $f708841d75fb4e6f$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $010361f6348e7d57$var$OutlinedInput = /*#__PURE__*/ $3OyDL.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $aBenZ.default)(props, $010361f6348e7d57$var$_excluded);
    const classes = $010361f6348e7d57$var$useUtilityClasses(props);
    const muiFormControl = (0, $38dd66485068cbe7$export$2e2bcd8739ae039)();
    const fcs = (0, $26b79efadb7be4d4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $gOPoC.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $010361f6348e7d57$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $010361f6348e7d57$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f708841d75fb4e6f$export$2e2bcd8739ae039), (0, $gOPoC.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $2M70Q.jsx)($010361f6348e7d57$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $gOPoC.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$010361f6348e7d57$var$OutlinedInput.muiName = 'Input';
var $010361f6348e7d57$export$2e2bcd8739ae039 = $010361f6348e7d57$var$OutlinedInput;



var $jFgmT = parcelRequire("jFgmT");


var $jH1k7 = parcelRequire("jH1k7");

var $2M70Q = parcelRequire("2M70Q");
'use client';
const $b1485b6cef47f8e9$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $b1485b6cef47f8e9$var$_excluded2 = [
    "root"
];
const $b1485b6cef47f8e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $b1485b6cef47f8e9$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $jH1k7.rootShouldForwardProp)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $b1485b6cef47f8e9$var$StyledInput = (0, $jH1k7.default)((0, $af5f6013d5f6a10c$export$2e2bcd8739ae039), $b1485b6cef47f8e9$var$styledRootConfig)('');
const $b1485b6cef47f8e9$var$StyledOutlinedInput = (0, $jH1k7.default)((0, $010361f6348e7d57$export$2e2bcd8739ae039), $b1485b6cef47f8e9$var$styledRootConfig)('');
const $b1485b6cef47f8e9$var$StyledFilledInput = (0, $jH1k7.default)((0, $c581196ed9d5e621$export$2e2bcd8739ae039), $b1485b6cef47f8e9$var$styledRootConfig)('');
const $b1485b6cef47f8e9$var$Select = /*#__PURE__*/ $3OyDL.forwardRef(function Select(inProps, ref) {
    const props = (0, $jFgmT.default)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $9492c6fe2457f8c9$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $aBenZ.default)(props, $b1485b6cef47f8e9$var$_excluded);
    const inputComponent = native ? (0, $d15a8bebcf4f4836$export$2e2bcd8739ae039) : (0, $b0bd2ed87670090c$export$2e2bcd8739ae039);
    const muiFormControl = (0, $38dd66485068cbe7$export$2e2bcd8739ae039)();
    const fcs = (0, $26b79efadb7be4d4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $gOPoC.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $b1485b6cef47f8e9$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $aBenZ.default)(classes, $b1485b6cef47f8e9$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $2M70Q.jsx)($b1485b6cef47f8e9$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $2M70Q.jsx)($b1485b6cef47f8e9$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $2M70Q.jsx)($b1485b6cef47f8e9$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($3OyDL.Fragment, {
        children: /*#__PURE__*/ $3OyDL.cloneElement(InputComponent, (0, $gOPoC.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $gOPoC.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $gOPoC.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $798ep.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, multiple && native && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $3DmQB.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$b1485b6cef47f8e9$var$Select.muiName = 'Select';
var $b1485b6cef47f8e9$export$2e2bcd8739ae039 = $b1485b6cef47f8e9$var$Select;




var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $db2d31e1940eb465$export$b12cb262231eef32(slot) {
    return (0, $6AMoU.default)('MuiToolbar', slot);
}
const $db2d31e1940eb465$var$toolbarClasses = (0, $ithJf.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $db2d31e1940eb465$export$2e2bcd8739ae039 = $db2d31e1940eb465$var$toolbarClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $3e138736a7ecac97$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $3e138736a7ecac97$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $db2d31e1940eb465$export$b12cb262231eef32), classes);
};
const $3e138736a7ecac97$var$ToolbarRoot = (0, $jH1k7.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === 'dense' && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === 'regular' && theme.mixins.toolbar);
const $3e138736a7ecac97$var$Toolbar = /*#__PURE__*/ $3OyDL.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular' } = props, other = (0, $aBenZ.default)(props, $3e138736a7ecac97$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $3e138736a7ecac97$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($3e138736a7ecac97$var$ToolbarRoot, (0, $gOPoC.default)({
        as: component,
        className: (0, $3DmQB.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $3e138736a7ecac97$export$2e2bcd8739ae039 = $3e138736a7ecac97$var$Toolbar;



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");

parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $7fb9952ec9971822$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $720609f44e854f21$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');




parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $6e441e0a2f443b94$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');


parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $2ad9b91991fb1bc8$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');



var $2M70Q = parcelRequire("2M70Q");
'use client';
var $25b1861e2caecc85$var$_LastPageIcon, $25b1861e2caecc85$var$_FirstPageIcon, $25b1861e2caecc85$var$_KeyboardArrowRight, $25b1861e2caecc85$var$_KeyboardArrowLeft, $25b1861e2caecc85$var$_KeyboardArrowLeft2, $25b1861e2caecc85$var$_KeyboardArrowRight2, $25b1861e2caecc85$var$_FirstPageIcon2, $25b1861e2caecc85$var$_LastPageIcon2;
const $25b1861e2caecc85$var$_excluded = [
    "backIconButtonProps",
    "count",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton"
];
const $25b1861e2caecc85$var$TablePaginationActions = /*#__PURE__*/ $3OyDL.forwardRef(function TablePaginationActions(props, ref) {
    const { backIconButtonProps: backIconButtonProps, count: count, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton } = props, other = (0, $aBenZ.default)(props, $25b1861e2caecc85$var$_excluded);
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", (0, $gOPoC.default)({
        ref: ref
    }, other, {
        children: [
            showFirstButton && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                onClick: handleFirstPageButtonClick,
                disabled: page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page),
                children: theme.direction === 'rtl' ? $25b1861e2caecc85$var$_LastPageIcon || ($25b1861e2caecc85$var$_LastPageIcon = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6e441e0a2f443b94$export$2e2bcd8739ae039), {})) : $25b1861e2caecc85$var$_FirstPageIcon || ($25b1861e2caecc85$var$_FirstPageIcon = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2ad9b91991fb1bc8$export$2e2bcd8739ae039), {}))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), (0, $gOPoC.default)({
                onClick: handleBackButtonClick,
                disabled: page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page)
            }, backIconButtonProps, {
                children: theme.direction === 'rtl' ? $25b1861e2caecc85$var$_KeyboardArrowRight || ($25b1861e2caecc85$var$_KeyboardArrowRight = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $720609f44e854f21$export$2e2bcd8739ae039), {})) : $25b1861e2caecc85$var$_KeyboardArrowLeft || ($25b1861e2caecc85$var$_KeyboardArrowLeft = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7fb9952ec9971822$export$2e2bcd8739ae039), {}))
            })),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), (0, $gOPoC.default)({
                onClick: handleNextButtonClick,
                disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page)
            }, nextIconButtonProps, {
                children: theme.direction === 'rtl' ? $25b1861e2caecc85$var$_KeyboardArrowLeft2 || ($25b1861e2caecc85$var$_KeyboardArrowLeft2 = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7fb9952ec9971822$export$2e2bcd8739ae039), {})) : $25b1861e2caecc85$var$_KeyboardArrowRight2 || ($25b1861e2caecc85$var$_KeyboardArrowRight2 = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $720609f44e854f21$export$2e2bcd8739ae039), {}))
            })),
            showLastButton && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                onClick: handleLastPageButtonClick,
                disabled: page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page),
                children: theme.direction === 'rtl' ? $25b1861e2caecc85$var$_FirstPageIcon2 || ($25b1861e2caecc85$var$_FirstPageIcon2 = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2ad9b91991fb1bc8$export$2e2bcd8739ae039), {})) : $25b1861e2caecc85$var$_LastPageIcon2 || ($25b1861e2caecc85$var$_LastPageIcon2 = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6e441e0a2f443b94$export$2e2bcd8739ae039), {}))
            })
        ]
    }));
});
var $25b1861e2caecc85$export$2e2bcd8739ae039 = $25b1861e2caecc85$var$TablePaginationActions;




var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $c7a20c0dfd70927a$export$909e637b22246f4c(slot) {
    return (0, $6AMoU.default)('MuiTablePagination', slot);
}
const $c7a20c0dfd70927a$var$tablePaginationClasses = (0, $ithJf.default)('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $c7a20c0dfd70927a$export$2e2bcd8739ae039 = $c7a20c0dfd70927a$var$tablePaginationClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
var $6aef60d9c63e7548$var$_InputBase;
const $6aef60d9c63e7548$var$_excluded = [
    "ActionsComponent",
    "backIconButtonProps",
    "className",
    "colSpan",
    "component",
    "count",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton"
];
const $6aef60d9c63e7548$var$TablePaginationRoot = (0, $jH1k7.default)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    }));
const $6aef60d9c63e7548$var$TablePaginationToolbar = (0, $jH1k7.default)((0, $3e138736a7ecac97$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>(0, $gOPoC.default)({
            [`& .${(0, $c7a20c0dfd70927a$export$2e2bcd8739ae039).actions}`]: styles.actions
        }, styles.toolbar)
})(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $c7a20c0dfd70927a$export$2e2bcd8739ae039).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    }));
const $6aef60d9c63e7548$var$TablePaginationSpacer = (0, $jH1k7.default)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: '1 1 100%'
});
const $6aef60d9c63e7548$var$TablePaginationSelectLabel = (0, $jH1k7.default)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel',
    overridesResolver: (props, styles)=>styles.selectLabel
})(({ theme: theme })=>(0, $gOPoC.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
const $6aef60d9c63e7548$var$TablePaginationSelect = (0, $jH1k7.default)((0, $b1485b6cef47f8e9$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>(0, $gOPoC.default)({
            [`& .${(0, $c7a20c0dfd70927a$export$2e2bcd8739ae039).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $c7a20c0dfd70927a$export$2e2bcd8739ae039).select}`]: styles.select
        }, styles.input, styles.selectRoot)
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $c7a20c0dfd70927a$export$2e2bcd8739ae039).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $6aef60d9c63e7548$var$TablePaginationMenuItem = (0, $jH1k7.default)((0, $c79ba0e99ec70dbd$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'MenuItem',
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $6aef60d9c63e7548$var$TablePaginationDisplayedRows = (0, $jH1k7.default)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows',
    overridesResolver: (props, styles)=>styles.displayedRows
})(({ theme: theme })=>(0, $gOPoC.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
function $6aef60d9c63e7548$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $6aef60d9c63e7548$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $6aef60d9c63e7548$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $c7a20c0dfd70927a$export$909e637b22246f4c), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $6aef60d9c63e7548$var$TablePagination = /*#__PURE__*/ $3OyDL.forwardRef(function TablePagination(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = (0, $25b1861e2caecc85$export$2e2bcd8739ae039), backIconButtonProps: backIconButtonProps, className: className, colSpan: colSpanProp, component: component = (0, $c13abfcb1085f546$export$2e2bcd8739ae039), count: count, getItemAriaLabel: getItemAriaLabel = $6aef60d9c63e7548$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $6aef60d9c63e7548$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false } = props, other = (0, $aBenZ.default)(props, $6aef60d9c63e7548$var$_excluded);
    const ownerState = props;
    const classes = $6aef60d9c63e7548$var$useUtilityClasses(ownerState);
    const MenuItemComponent = SelectProps.native ? 'option' : $6aef60d9c63e7548$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $c13abfcb1085f546$export$2e2bcd8739ae039) || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $690598a7908d0f71$export$2e2bcd8739ae039)(SelectProps.id);
    const labelId = (0, $690598a7908d0f71$export$2e2bcd8739ae039)(SelectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)($6aef60d9c63e7548$var$TablePaginationRoot, (0, $gOPoC.default)({
        colSpan: colSpan,
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, $3DmQB.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)($6aef60d9c63e7548$var$TablePaginationToolbar, {
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)($6aef60d9c63e7548$var$TablePaginationSpacer, {
                    className: classes.spacer
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $2M70Q.jsx)($6aef60d9c63e7548$var$TablePaginationSelectLabel, {
                    className: classes.selectLabel,
                    id: labelId,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $2M70Q.jsx)($6aef60d9c63e7548$var$TablePaginationSelect, (0, $gOPoC.default)({
                    variant: "standard"
                }, !SelectProps.variant && {
                    input: $6aef60d9c63e7548$var$_InputBase || ($6aef60d9c63e7548$var$_InputBase = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f708841d75fb4e6f$export$2e2bcd8739ae039), {}))
                }, {
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId
                }, SelectProps, {
                    classes: (0, $gOPoC.default)({}, SelectProps.classes, {
                        // TODO v5 remove `classes.input`
                        root: (0, $3DmQB.default)(classes.input, classes.selectRoot, (SelectProps.classes || {}).root),
                        select: (0, $3DmQB.default)(classes.select, (SelectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $3DmQB.default)(classes.selectIcon, (SelectProps.classes || {}).icon)
                    }),
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $3OyDL.createElement)(MenuItemComponent, (0, $gOPoC.default)({}, !(0, $03d7e3d159693402$export$e28348cc2430497)(MenuItemComponent) && {
                            ownerState: ownerState
                        }, {
                            className: classes.menuItem,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                })),
                /*#__PURE__*/ (0, $2M70Q.jsx)($6aef60d9c63e7548$var$TablePaginationDisplayedRows, {
                    className: classes.displayedRows,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    getItemAriaLabel: getItemAriaLabel
                })
            ]
        })
    }));
});
var $6aef60d9c63e7548$export$2e2bcd8739ae039 = $6aef60d9c63e7548$var$TablePagination;


var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");


var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $61229686c3b794ec$export$ba0a6d6c28940107(slot) {
    return (0, $6AMoU.default)('MuiTableRow', slot);
}
const $61229686c3b794ec$var$tableRowClasses = (0, $ithJf.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $61229686c3b794ec$export$2e2bcd8739ae039 = $61229686c3b794ec$var$tableRowClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $1a28739087e1cb55$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $1a28739087e1cb55$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $61229686c3b794ec$export$ba0a6d6c28940107), classes);
};
const $1a28739087e1cb55$var$TableRowRoot = (0, $jH1k7.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $61229686c3b794ec$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $61229686c3b794ec$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $1a28739087e1cb55$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $1a28739087e1cb55$var$TableRow = /*#__PURE__*/ $3OyDL.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $1a28739087e1cb55$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $aBenZ.default)(props, $1a28739087e1cb55$var$_excluded);
    const tablelvl2 = $3OyDL.useContext((0, $0b239047812602a0$export$2e2bcd8739ae039));
    const ownerState = (0, $gOPoC.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    });
    const classes = $1a28739087e1cb55$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($1a28739087e1cb55$var$TableRowRoot, (0, $gOPoC.default)({
        as: component,
        ref: ref,
        className: (0, $3DmQB.default)(classes.root, className),
        role: component === $1a28739087e1cb55$var$defaultComponent ? null : 'row',
        ownerState: ownerState
    }, other));
});
var $1a28739087e1cb55$export$2e2bcd8739ae039 = $1a28739087e1cb55$var$TableRow;


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");



var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");


// Source from https://github.com/alitaheri/normalize-scroll-left
let $50234e81b1283160$var$cachedType;
function $50234e81b1283160$export$a10970ffb6510128() {
    if ($50234e81b1283160$var$cachedType) return $50234e81b1283160$var$cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $50234e81b1283160$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $50234e81b1283160$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $50234e81b1283160$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $50234e81b1283160$var$cachedType;
}
function $50234e81b1283160$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = $50234e81b1283160$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $0d6da2dbd3b44bee$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $0d6da2dbd3b44bee$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $0d6da2dbd3b44bee$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");




var $2M70Q = parcelRequire("2M70Q");
'use client';
const $7c34685fbd79a9cb$var$_excluded = [
    "onChange"
];
const $7c34685fbd79a9cb$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $7c34685fbd79a9cb$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $aBenZ.default)(props, $7c34685fbd79a9cb$var$_excluded);
    const scrollbarHeight = $3OyDL.useRef();
    const nodeRef = $3OyDL.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $b8bb11a9fe67b1a2$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $866c689a9d9fa1f1$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $53d8d8b54b711b01$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $3OyDL.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)("div", (0, $gOPoC.default)({
        style: $7c34685fbd79a9cb$var$styles,
        ref: nodeRef
    }, other));
}



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");





var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $fa3a6be165daebd6$export$34861783d3c2eef8(slot) {
    return (0, $6AMoU.default)('MuiTabScrollButton', slot);
}
const $fa3a6be165daebd6$var$tabScrollButtonClasses = (0, $ithJf.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $fa3a6be165daebd6$export$2e2bcd8739ae039 = $fa3a6be165daebd6$var$tabScrollButtonClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $83e5d89c19c8ccc8$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $83e5d89c19c8ccc8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $fa3a6be165daebd6$export$34861783d3c2eef8), classes);
};
const $83e5d89c19c8ccc8$var$TabScrollButtonRoot = (0, $jH1k7.default)((0, $c582f66505800c92$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $fa3a6be165daebd6$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === 'vertical' && {
        width: '100%',
        height: 40,
        '& svg': {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $83e5d89c19c8ccc8$var$TabScrollButton = /*#__PURE__*/ $3OyDL.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $aBenZ.default)(props, $83e5d89c19c8ccc8$var$_excluded);
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === 'rtl';
    const ownerState = (0, $gOPoC.default)({
        isRtl: isRtl
    }, props);
    const classes = $83e5d89c19c8ccc8$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $7fb9952ec9971822$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $720609f44e854f21$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $9be467578d9a8fea$export$1e5c9e6e4e15efe3)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $9be467578d9a8fea$export$1e5c9e6e4e15efe3)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)($83e5d89c19c8ccc8$var$TabScrollButtonRoot, (0, $gOPoC.default)({
        component: "div",
        className: (0, $3DmQB.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === 'left' ? /*#__PURE__*/ (0, $2M70Q.jsx)(StartButtonIcon, (0, $gOPoC.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $2M70Q.jsx)(EndButtonIcon, (0, $gOPoC.default)({}, endButtonIconProps))
    }));
});
var $83e5d89c19c8ccc8$export$2e2bcd8739ae039 = $83e5d89c19c8ccc8$var$TabScrollButton;




var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $add293d9d9766538$export$cdd93bd054dec359(slot) {
    return (0, $6AMoU.default)('MuiTabs', slot);
}
const $add293d9d9766538$var$tabsClasses = (0, $ithJf.default)('MuiTabs', [
    'root',
    'vertical',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $add293d9d9766538$export$2e2bcd8739ae039 = $add293d9d9766538$var$tabsClasses;





var $2M70Q = parcelRequire("2M70Q");
'use client';
const $300390f560fe3d4d$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $300390f560fe3d4d$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $300390f560fe3d4d$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $300390f560fe3d4d$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $300390f560fe3d4d$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        flexContainer: [
            'flexContainer',
            vertical && 'flexContainerVertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $add293d9d9766538$export$cdd93bd054dec359), classes);
};
const $300390f560fe3d4d$var$TabsRoot = (0, $jH1k7.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $add293d9d9766538$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $add293d9d9766538$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $gOPoC.default)({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $add293d9d9766538$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        }
    }));
const $300390f560fe3d4d$var$TabsScroller = (0, $jH1k7.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        position: 'relative',
        display: 'inline-block',
        flex: '1 1 auto',
        whiteSpace: 'nowrap'
    }, ownerState.fixed && {
        overflowX: 'hidden',
        width: '100%'
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: 'none',
        // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: 'auto',
        overflowY: 'hidden'
    }, ownerState.scrollableY && {
        overflowY: 'auto',
        overflowX: 'hidden'
    }));
const $300390f560fe3d4d$var$FlexContainer = (0, $jH1k7.default)('div', {
    name: 'MuiTabs',
    slot: 'FlexContainer',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.centered && {
        justifyContent: 'center'
    }));
const $300390f560fe3d4d$var$TabsIndicator = (0, $jH1k7.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $gOPoC.default)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === 'primary' && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === 'secondary' && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: '100%',
        width: 2,
        right: 0
    }));
const $300390f560fe3d4d$var$TabsScrollbarSize = (0, $jH1k7.default)((0, $7c34685fbd79a9cb$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $300390f560fe3d4d$var$defaultIndicatorStyle = {};
let $300390f560fe3d4d$var$warnedOnceTabPresent = false;
const $300390f560fe3d4d$var$Tabs = /*#__PURE__*/ $3OyDL.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === 'rtl';
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent = (0, $83e5d89c19c8ccc8$export$2e2bcd8739ae039), scrollButtons: scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false } = props, other = (0, $aBenZ.default)(props, $300390f560fe3d4d$var$_excluded);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, $gOPoC.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $300390f560fe3d4d$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $9be467578d9a8fea$export$1e5c9e6e4e15efe3)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $9be467578d9a8fea$export$1e5c9e6e4e15efe3)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $3OyDL.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $3OyDL.useState($300390f560fe3d4d$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $3OyDL.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $3OyDL.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $3OyDL.useState(false);
    const [scrollerStyle, setScrollerStyle] = $3OyDL.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $3OyDL.useRef(null);
    const tabListRef = $3OyDL.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $50234e81b1283160$export$3c615b88e5d7e4f6)(tabsNode, theme.direction),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $614ff53a4e7d9506$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $0d6da2dbd3b44bee$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $50234e81b1283160$export$a10970ffb6510128)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $3OyDL.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $2M70Q.jsx)($300390f560fe3d4d$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $3DmQB.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $2M70Q.jsx)(ScrollButtonComponent, (0, $gOPoC.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $3DmQB.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $2M70Q.jsx)(ScrollButtonComponent, (0, $gOPoC.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $3DmQB.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $614ff53a4e7d9506$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $614ff53a4e7d9506$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $3OyDL.useEffect(()=>{
        const handleResize = (0, $866c689a9d9fa1f1$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        const win = (0, $53d8d8b54b711b01$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        updateIndicatorState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $3OyDL.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $3OyDL.useEffect(()=>{
        setMounted(true);
    }, []);
    $3OyDL.useEffect(()=>{
        updateIndicatorState();
    });
    $3OyDL.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($300390f560fe3d4d$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $3OyDL.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $2M70Q.jsx)($300390f560fe3d4d$var$TabsIndicator, (0, $gOPoC.default)({}, TabIndicatorProps, {
        className: (0, $3DmQB.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $gOPoC.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $3OyDL.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $3OyDL.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $3OyDL.cloneElement(child, (0, $gOPoC.default)({
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $e2c4e3ce20421058$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $300390f560fe3d4d$var$moveFocus(list, currentFocus, $300390f560fe3d4d$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $300390f560fe3d4d$var$moveFocus(list, currentFocus, $300390f560fe3d4d$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $300390f560fe3d4d$var$moveFocus(list, null, $300390f560fe3d4d$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $300390f560fe3d4d$var$moveFocus(list, null, $300390f560fe3d4d$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($300390f560fe3d4d$var$TabsRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $2M70Q.jsxs)($300390f560fe3d4d$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)($300390f560fe3d4d$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $300390f560fe3d4d$export$2e2bcd8739ae039 = $300390f560fe3d4d$var$Tabs;



var $1e0e42f5f37a7922$exports = {};
"use strict";
"use client";

Object.defineProperty($1e0e42f5f37a7922$exports, "__esModule", {
    value: true
});
$1e0e42f5f37a7922$exports.default = void 0;

var $1e0e42f5f37a7922$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $1e0e42f5f37a7922$var$_default = (0, $1e0e42f5f37a7922$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');
$1e0e42f5f37a7922$exports.default = $1e0e42f5f37a7922$var$_default;


var $2f1d1e8698c2a400$exports = {};
"use strict";
"use client";

Object.defineProperty($2f1d1e8698c2a400$exports, "__esModule", {
    value: true
});
$2f1d1e8698c2a400$exports.default = void 0;

var $2f1d1e8698c2a400$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $2f1d1e8698c2a400$var$_default = (0, $2f1d1e8698c2a400$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
$2f1d1e8698c2a400$exports.default = $2f1d1e8698c2a400$var$_default;


var $748d42c5fe8bcf47$exports = {};
"use strict";
"use client";

Object.defineProperty($748d42c5fe8bcf47$exports, "__esModule", {
    value: true
});
$748d42c5fe8bcf47$exports.default = void 0;

var $748d42c5fe8bcf47$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $748d42c5fe8bcf47$var$_default = (0, $748d42c5fe8bcf47$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Edit');
$748d42c5fe8bcf47$exports.default = $748d42c5fe8bcf47$var$_default;


var $f6bef95756d9e672$exports = {};
"use strict";
"use client";

Object.defineProperty($f6bef95756d9e672$exports, "__esModule", {
    value: true
});
$f6bef95756d9e672$exports.default = void 0;

var $f6bef95756d9e672$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $f6bef95756d9e672$var$_default = (0, $f6bef95756d9e672$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M19 7H9c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 2v2H9V9h10zm-6 6v-2h2v2h-2zm2 2v2h-2v-2h2zm-4-2H9v-2h2v2zm6-2h2v2h-2v-2zm-8 4h2v2H9v-2zm8 2v-2h2v2h-2zM6 17H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v1h-2V5H5v10h1v2z"
}), 'TableView');
$f6bef95756d9e672$exports.default = $f6bef95756d9e672$var$_default;


var $70fa1035e174fb27$exports = {};
"use strict";
"use client";

Object.defineProperty($70fa1035e174fb27$exports, "__esModule", {
    value: true
});
$70fa1035e174fb27$exports.default = void 0;

var $70fa1035e174fb27$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $70fa1035e174fb27$var$_default = (0, $70fa1035e174fb27$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 3 4.2 15.5l1.7 1.06L7 14.8V21h4v-5h2v5h4v-6.21l1.1 1.77 1.7-1.06L12 3zm1 11h-2v-2h2v2z"
}), 'Bungalow');
$70fa1035e174fb27$exports.default = $70fa1035e174fb27$var$_default;


var $87685c4b93d32359$exports = {};
"use strict";
"use client";

Object.defineProperty($87685c4b93d32359$exports, "__esModule", {
    value: true
});
$87685c4b93d32359$exports.default = void 0;

var $87685c4b93d32359$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $87685c4b93d32359$var$_default = (0, $87685c4b93d32359$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4 2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
}), 'Collections');
$87685c4b93d32359$exports.default = $87685c4b93d32359$var$_default;


var $99e273523f9e6319$exports = {};
"use strict";
"use client";

Object.defineProperty($99e273523f9e6319$exports, "__esModule", {
    value: true
});
$99e273523f9e6319$exports.default = void 0;

var $99e273523f9e6319$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $99e273523f9e6319$var$_default = (0, $99e273523f9e6319$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
}), 'FormatListNumbered');
$99e273523f9e6319$exports.default = $99e273523f9e6319$var$_default;





const $b64f1e586855c0fa$var$getDateFormat = (option)=>{
    if (option === 'time') return 'HH:mm';
    if (option === 'dateTime') return 'dd.MM.yyyy HH:mm';
    return 'dd.MM.yyyy';
};
var $b64f1e586855c0fa$export$2e2bcd8739ae039 = $b64f1e586855c0fa$var$getDateFormat;


function $eafc2fd4bf99c988$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $26f386a2bccb8f3f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $26f386a2bccb8f3f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $26f386a2bccb8f3f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $26f386a2bccb8f3f$var$_typeof(obj);
}
function $26f386a2bccb8f3f$export$2e2bcd8739ae039(value) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || $26f386a2bccb8f3f$var$_typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}



function $48d6caaf3810fe04$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $48d6caaf3810fe04$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $48d6caaf3810fe04$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $48d6caaf3810fe04$var$_typeof(obj);
}
function $48d6caaf3810fe04$export$2e2bcd8739ae039(argument) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || $48d6caaf3810fe04$var$_typeof(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $d929e023868e1e82$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $26f386a2bccb8f3f$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $b119caf18c17d74c$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $bbf672973d1421c5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $dace8d5317e0d210$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $bbf672973d1421c5$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $34f9b315854c9311$var$MILLISECONDS_IN_DAY = 86400000;
function $34f9b315854c9311$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $34f9b315854c9311$var$MILLISECONDS_IN_DAY) + 1;
}





function $b802085f0f1650ef$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $204c6f87a0cd57dc$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $b802085f0f1650ef$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $b802085f0f1650ef$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $d9e30bb15b38fd27$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $204c6f87a0cd57dc$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $b802085f0f1650ef$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $688d44451f09b750$var$MILLISECONDS_IN_WEEK = 604800000;
function $688d44451f09b750$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $b802085f0f1650ef$export$2e2bcd8739ae039)(date).getTime() - (0, $d9e30bb15b38fd27$export$2e2bcd8739ae039)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $688d44451f09b750$var$MILLISECONDS_IN_WEEK) + 1;
}







var $41b814f6c92f57a3$var$defaultOptions = {};
function $41b814f6c92f57a3$export$430a3269e24b912e() {
    return $41b814f6c92f57a3$var$defaultOptions;
}
function $41b814f6c92f57a3$export$95365be1b0704abc(newOptions) {
    $41b814f6c92f57a3$var$defaultOptions = newOptions;
}


function $6235b5f82708dfe3$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $41b814f6c92f57a3$export$430a3269e24b912e)();
    var weekStartsOn = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $c501c1ef4eb68741$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $41b814f6c92f57a3$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $6235b5f82708dfe3$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $6235b5f82708dfe3$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $ca880d7e899bc11a$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $41b814f6c92f57a3$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $c501c1ef4eb68741$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $6235b5f82708dfe3$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $50a8e0e0a0f78f6c$var$MILLISECONDS_IN_WEEK = 604800000;
function $50a8e0e0a0f78f6c$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $6235b5f82708dfe3$export$2e2bcd8739ae039)(date, options).getTime() - (0, $ca880d7e899bc11a$export$2e2bcd8739ae039)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $50a8e0e0a0f78f6c$var$MILLISECONDS_IN_WEEK) + 1;
}



function $5ef226fb190d9c05$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $d66c93e8f55f3ba4$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $d66c93e8f55f3ba4$export$2e2bcd8739ae039 = $d66c93e8f55f3ba4$var$formatters;


var $d8136a3289ed2363$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $d8136a3289ed2363$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $d66c93e8f55f3ba4$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $c501c1ef4eb68741$export$2e2bcd8739ae039)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $204c6f87a0cd57dc$export$2e2bcd8739ae039)(date); // Padding
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $d66c93e8f55f3ba4$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $50a8e0e0a0f78f6c$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $688d44451f09b750$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $d66c93e8f55f3ba4$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $34f9b315854c9311$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $d8136a3289ed2363$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $d8136a3289ed2363$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $d8136a3289ed2363$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $d8136a3289ed2363$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $d8136a3289ed2363$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $d8136a3289ed2363$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $d66c93e8f55f3ba4$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $d66c93e8f55f3ba4$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $d66c93e8f55f3ba4$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $d66c93e8f55f3ba4$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $d66c93e8f55f3ba4$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $d8136a3289ed2363$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $d8136a3289ed2363$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $d8136a3289ed2363$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $d8136a3289ed2363$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $d8136a3289ed2363$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $d8136a3289ed2363$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $d8136a3289ed2363$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $d8136a3289ed2363$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $d8136a3289ed2363$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $d8136a3289ed2363$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $d8136a3289ed2363$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(minutes, 2);
}
function $d8136a3289ed2363$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $d8136a3289ed2363$var$formatTimezone(offset, dirtyDelimiter);
}
function $d8136a3289ed2363$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $d8136a3289ed2363$export$2e2bcd8739ae039 = $d8136a3289ed2363$var$formatters;


var $fa54546a4789faa1$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $fa54546a4789faa1$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $fa54546a4789faa1$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $fa54546a4789faa1$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $fa54546a4789faa1$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $fa54546a4789faa1$var$timeLongFormatter(timePattern, formatLong));
};
var $fa54546a4789faa1$var$longFormatters = {
    p: $fa54546a4789faa1$var$timeLongFormatter,
    P: $fa54546a4789faa1$var$dateTimeLongFormatter
};
var $fa54546a4789faa1$export$2e2bcd8739ae039 = $fa54546a4789faa1$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $aa0ce4e10613bc89$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $132314102daa75b2$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $132314102daa75b2$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $132314102daa75b2$export$c6cc36aa33304772(token) {
    return $132314102daa75b2$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $132314102daa75b2$export$c6b49d6dceb604a1(token) {
    return $132314102daa75b2$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $132314102daa75b2$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $bc99b6a0f1ae8964$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $bc99b6a0f1ae8964$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bc99b6a0f1ae8964$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $bc99b6a0f1ae8964$export$2e2bcd8739ae039 = $bc99b6a0f1ae8964$var$formatDistance;


function $373b7f141b5dacce$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $43b237e271be0598$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $43b237e271be0598$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $43b237e271be0598$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $43b237e271be0598$var$formatLong = {
    date: (0, $373b7f141b5dacce$export$2e2bcd8739ae039)({
        formats: $43b237e271be0598$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $373b7f141b5dacce$export$2e2bcd8739ae039)({
        formats: $43b237e271be0598$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $373b7f141b5dacce$export$2e2bcd8739ae039)({
        formats: $43b237e271be0598$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $43b237e271be0598$export$2e2bcd8739ae039 = $43b237e271be0598$var$formatLong;


var $d593ba4f030a4bf5$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $d593ba4f030a4bf5$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d593ba4f030a4bf5$var$formatRelativeLocale[token];
};
var $d593ba4f030a4bf5$export$2e2bcd8739ae039 = $d593ba4f030a4bf5$var$formatRelative;


function $d57edd4af7d6d8b6$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $811f9654f91dbb5d$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $811f9654f91dbb5d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $811f9654f91dbb5d$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $811f9654f91dbb5d$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $811f9654f91dbb5d$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $811f9654f91dbb5d$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $811f9654f91dbb5d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $811f9654f91dbb5d$var$localize = {
    ordinalNumber: $811f9654f91dbb5d$var$ordinalNumber,
    era: (0, $d57edd4af7d6d8b6$export$2e2bcd8739ae039)({
        values: $811f9654f91dbb5d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $d57edd4af7d6d8b6$export$2e2bcd8739ae039)({
        values: $811f9654f91dbb5d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $d57edd4af7d6d8b6$export$2e2bcd8739ae039)({
        values: $811f9654f91dbb5d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $d57edd4af7d6d8b6$export$2e2bcd8739ae039)({
        values: $811f9654f91dbb5d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $d57edd4af7d6d8b6$export$2e2bcd8739ae039)({
        values: $811f9654f91dbb5d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $811f9654f91dbb5d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $811f9654f91dbb5d$export$2e2bcd8739ae039 = $811f9654f91dbb5d$var$localize;


function $4664451f1486a0c3$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $4664451f1486a0c3$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $4664451f1486a0c3$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $4664451f1486a0c3$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $4664451f1486a0c3$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $92a592e71cbd8844$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $ee5fd373cf6c41bd$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $ee5fd373cf6c41bd$var$parseOrdinalNumberPattern = /\d+/i;
var $ee5fd373cf6c41bd$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $ee5fd373cf6c41bd$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $ee5fd373cf6c41bd$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $ee5fd373cf6c41bd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ee5fd373cf6c41bd$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $ee5fd373cf6c41bd$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $ee5fd373cf6c41bd$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $ee5fd373cf6c41bd$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $ee5fd373cf6c41bd$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $ee5fd373cf6c41bd$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $ee5fd373cf6c41bd$var$match = {
    ordinalNumber: (0, $92a592e71cbd8844$export$2e2bcd8739ae039)({
        matchPattern: $ee5fd373cf6c41bd$var$matchOrdinalNumberPattern,
        parsePattern: $ee5fd373cf6c41bd$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $4664451f1486a0c3$export$2e2bcd8739ae039)({
        matchPatterns: $ee5fd373cf6c41bd$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ee5fd373cf6c41bd$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $4664451f1486a0c3$export$2e2bcd8739ae039)({
        matchPatterns: $ee5fd373cf6c41bd$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ee5fd373cf6c41bd$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $4664451f1486a0c3$export$2e2bcd8739ae039)({
        matchPatterns: $ee5fd373cf6c41bd$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ee5fd373cf6c41bd$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $4664451f1486a0c3$export$2e2bcd8739ae039)({
        matchPatterns: $ee5fd373cf6c41bd$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ee5fd373cf6c41bd$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $4664451f1486a0c3$export$2e2bcd8739ae039)({
        matchPatterns: $ee5fd373cf6c41bd$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ee5fd373cf6c41bd$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ee5fd373cf6c41bd$export$2e2bcd8739ae039 = $ee5fd373cf6c41bd$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $71465c18f1b50106$var$locale = {
    code: 'en-US',
    formatDistance: (0, $bc99b6a0f1ae8964$export$2e2bcd8739ae039),
    formatLong: (0, $43b237e271be0598$export$2e2bcd8739ae039),
    formatRelative: (0, $d593ba4f030a4bf5$export$2e2bcd8739ae039),
    localize: (0, $811f9654f91dbb5d$export$2e2bcd8739ae039),
    match: (0, $ee5fd373cf6c41bd$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $71465c18f1b50106$export$2e2bcd8739ae039 = $71465c18f1b50106$var$locale;


var $1d66184b7ffb065b$export$2e2bcd8739ae039 = (0, $71465c18f1b50106$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $470528c785dcbc23$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $470528c785dcbc23$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $470528c785dcbc23$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $470528c785dcbc23$var$doubleQuoteRegExp = /''/g;
var $470528c785dcbc23$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $470528c785dcbc23$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $41b814f6c92f57a3$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $1d66184b7ffb065b$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $d929e023868e1e82$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $aa0ce4e10613bc89$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $dace8d5317e0d210$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($470528c785dcbc23$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $fa54546a4789faa1$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($470528c785dcbc23$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $470528c785dcbc23$var$cleanEscapedString(substring);
        var formatter = (0, $d8136a3289ed2363$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $132314102daa75b2$export$c6b49d6dceb604a1)(substring)) (0, $132314102daa75b2$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $132314102daa75b2$export$c6cc36aa33304772)(substring)) (0, $132314102daa75b2$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($470528c785dcbc23$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $470528c785dcbc23$var$cleanEscapedString(input) {
    var matched = input.match($470528c785dcbc23$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($470528c785dcbc23$var$doubleQuoteRegExp, "'");
}


const $f88738dfeeda6137$var$formatDate = (date, selectedFormat)=>{
    const dateFormat = selectedFormat || (0, $b64f1e586855c0fa$export$2e2bcd8739ae039)('date');
    if (date && date.year && date.month && date.day) return (0, $470528c785dcbc23$export$2e2bcd8739ae039)(new Date(date.year, date.month - 1, date.day), dateFormat);
};
var $f88738dfeeda6137$export$2e2bcd8739ae039 = $f88738dfeeda6137$var$formatDate;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");

var $3OyDL = parcelRequire("3OyDL");
const $df22a106505cd38b$export$b8efcc4bff45e15b = 1;
const $df22a106505cd38b$export$7de1b54b0142048f = /*#__PURE__*/ (0, $3OyDL.createContext)(null);
const $df22a106505cd38b$export$a24c9fc2f87814b2 = $df22a106505cd38b$export$7de1b54b0142048f.Provider;
function $df22a106505cd38b$export$ea59151b8430a4e9() {
    const context = (0, $3OyDL.useContext)($df22a106505cd38b$export$7de1b54b0142048f);
    if (context == null) throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
    return context;
}




var $3OyDL = parcelRequire("3OyDL");
function $a358b76745ac1ee3$var$_extends() {
    $a358b76745ac1ee3$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a358b76745ac1ee3$var$_extends.apply(this, arguments);
}
function $a358b76745ac1ee3$export$54c1e9a8bb896c95(mapRef, props) {
    const [map, setMap] = (0, $3OyDL.useState)(null);
    (0, $3OyDL.useEffect)(()=>{
        if (mapRef.current !== null && map === null) {
            const instance = new (0, $ad5a22b7e45eeb01$exports.Map)(mapRef.current, props);
            if (props.center != null && props.zoom != null) instance.setView(props.center, props.zoom);
            else if (props.bounds != null) instance.fitBounds(props.bounds, props.boundsOptions);
            if (props.whenReady != null) instance.whenReady(props.whenReady);
            setMap(instance);
        }
    }, [
        mapRef,
        map,
        props
    ]);
    return map;
}
function $a358b76745ac1ee3$export$23f3dfd47374502b({ children: children, className: className, id: id, placeholder: placeholder, style: style, whenCreated: whenCreated, ...options }) {
    const mapRef = (0, $3OyDL.useRef)(null);
    const map = $a358b76745ac1ee3$export$54c1e9a8bb896c95(mapRef, options);
    const createdRef = (0, $3OyDL.useRef)(false);
    (0, $3OyDL.useEffect)(()=>{
        if (map != null && createdRef.current === false && whenCreated != null) {
            createdRef.current = true;
            whenCreated(map);
        }
    }, [
        map,
        whenCreated
    ]);
    const [props] = (0, $3OyDL.useState)({
        className: className,
        id: id,
        style: style
    });
    const context = (0, $3OyDL.useMemo)(()=>map ? {
            __version: (0, $df22a106505cd38b$export$b8efcc4bff45e15b),
            map: map
        } : null, [
        map
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement((0, $df22a106505cd38b$export$a24c9fc2f87814b2), {
        value: context
    }, children) : placeholder != null ? placeholder : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement("div", $a358b76745ac1ee3$var$_extends({}, props, {
        ref: mapRef
    }), contents);
}


var $3OyDL = parcelRequire("3OyDL");

var $dy6Cj = parcelRequire("dy6Cj");

function $c686ea55ad2d033b$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, ref) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $3OyDL.useImperativeHandle)(ref, ()=>instance);
        return props.children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement((0, $df22a106505cd38b$export$a24c9fc2f87814b2), {
            value: context
        }, props.children);
    }
    return /*#__PURE__*/ (0, $3OyDL.forwardRef)(ContainerComponent);
}
function $c686ea55ad2d033b$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, ref) {
        const [isOpen, setOpen] = (0, $3OyDL.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $3OyDL.useImperativeHandle)(ref, ()=>instance);
        (0, $3OyDL.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]); // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $dy6Cj.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $3OyDL.forwardRef)(OverlayComponent);
}
function $c686ea55ad2d033b$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, ref) {
        const { instance: instance } = useElement(props).current;
        (0, $3OyDL.useImperativeHandle)(ref, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $3OyDL.forwardRef)(LeafComponent);
}



var $3OyDL = parcelRequire("3OyDL");

function $8758da653e7c1db5$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $df22a106505cd38b$export$ea59151b8430a4e9)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $3OyDL.useRef)(props.position);
        const { position: position } = props;
        (0, $3OyDL.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $3OyDL.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}



var $3OyDL = parcelRequire("3OyDL");
function $32d7652bc320543e$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        return (0, $3OyDL.useRef)(createElement(props, context));
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $3OyDL.useRef)(createElement(props, context));
        const propsRef = (0, $3OyDL.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $3OyDL.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}



var $3OyDL = parcelRequire("3OyDL");

var $3OyDL = parcelRequire("3OyDL");
function $4c3ea37a290439a3$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $3OyDL.useRef)(attribution);
    (0, $3OyDL.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}




var $3OyDL = parcelRequire("3OyDL");
function $30d32fb74a59c004$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $3OyDL.useRef)();
    (0, $3OyDL.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}


function $9b6d830a3c5df9c5$export$6ee5d263358f5c0e(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane: pane
    } : props;
}


function $b2aa2d9343d9ccc6$export$cd00a227f8cfb2c2(element, context) {
    (0, $3OyDL.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            var _context$layerContain;
            (_context$layerContain = context.layerContainer) == null || _context$layerContain.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $b2aa2d9343d9ccc6$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $df22a106505cd38b$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $9b6d830a3c5df9c5$export$6ee5d263358f5c0e)(props, context), context);
        (0, $4c3ea37a290439a3$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $30d32fb74a59c004$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        $b2aa2d9343d9ccc6$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}






function $c9a6eadb020b7fbd$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $df22a106505cd38b$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $9b6d830a3c5df9c5$export$6ee5d263358f5c0e)(props, context), context);
        (0, $4c3ea37a290439a3$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $30d32fb74a59c004$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}



var $3OyDL = parcelRequire("3OyDL");




function $594ffd62bcdab9a2$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $3OyDL.useRef)();
    (0, $3OyDL.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $594ffd62bcdab9a2$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $df22a106505cd38b$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $9b6d830a3c5df9c5$export$6ee5d263358f5c0e)(props, context), context);
        (0, $30d32fb74a59c004$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        (0, $b2aa2d9343d9ccc6$export$cd00a227f8cfb2c2)(elementRef.current, context);
        $594ffd62bcdab9a2$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}


function $5d2619eb752b5a22$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return {
            instance: createInstance(props),
            context: context
        };
    }
    const useElement = (0, $32d7652bc320543e$export$2e66ec8a7fb1892f)(createElement);
    const useControl = (0, $8758da653e7c1db5$export$28d24ab3914549cd)(useElement);
    return (0, $c686ea55ad2d033b$export$18af5c7a9e9b3664)(useControl);
}
function $5d2619eb752b5a22$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $32d7652bc320543e$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $b2aa2d9343d9ccc6$export$73f852c6a5abdefa)(useElement);
    return (0, $c686ea55ad2d033b$export$96eac748c3f41e82)(useLayer);
}
function $5d2619eb752b5a22$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $32d7652bc320543e$export$2e66ec8a7fb1892f)(createElement);
    const useOverlay = (0, $c9a6eadb020b7fbd$export$d5eca53b0accc0e0)(useElement, useLifecycle);
    return (0, $c686ea55ad2d033b$export$bc37ddc24ed05446)(useOverlay);
}
function $5d2619eb752b5a22$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $32d7652bc320543e$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const usePath = (0, $594ffd62bcdab9a2$export$5fea2fe6048fc3db)(useElement);
    return (0, $c686ea55ad2d033b$export$96eac748c3f41e82)(usePath);
}
function $5d2619eb752b5a22$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $32d7652bc320543e$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $b2aa2d9343d9ccc6$export$73f852c6a5abdefa)(useElement);
    return (0, $c686ea55ad2d033b$export$18af5c7a9e9b3664)(useLayer);
}



const $94a936208b69bd53$export$e98856a975cab58e = (0, $5d2619eb752b5a22$export$8a4d5778bce4c3ac)(function createMarker({ position: position, ...options }, ctx) {
    const instance = new (0, $ad5a22b7e45eeb01$exports.Marker)(position, options);
    return {
        instance: instance,
        context: {
            ...ctx,
            overlayContainer: instance
        }
    };
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) marker.setLatLng(props.position);
    if (props.icon != null && props.icon !== prevProps.icon) marker.setIcon(props.icon);
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) marker.setZIndexOffset(props.zIndexOffset);
    if (props.opacity != null && props.opacity !== prevProps.opacity) marker.setOpacity(props.opacity);
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) marker.dragging.enable();
        else marker.dragging.disable();
    }
});




var $3OyDL = parcelRequire("3OyDL");
const $4ab80f6906567b2f$export$129a32eedafa97c5 = (0, $5d2619eb752b5a22$export$7d18e209be943d7d)(function createPopup(props, context) {
    return {
        instance: new (0, $ad5a22b7e45eeb01$exports.Popup)(props, context.overlayContainer),
        context: context
    };
}, function usePopupLifecycle(element, context, props, setOpen) {
    const { onClose: onClose, onOpen: onOpen, position: position } = props;
    (0, $3OyDL.useEffect)(function addPopup() {
        const { instance: instance } = element;
        function onPopupOpen(event) {
            if (event.popup === instance) {
                instance.update();
                setOpen(true);
                onOpen == null || onOpen();
            }
        }
        function onPopupClose(event) {
            if (event.popup === instance) {
                setOpen(false);
                onClose == null || onClose();
            }
        }
        context.map.on({
            popupopen: onPopupOpen,
            popupclose: onPopupClose
        });
        if (context.overlayContainer == null) {
            // Attach to a Map
            if (position != null) instance.setLatLng(position);
            instance.openOn(context.map);
        } else // Attach to container component
        context.overlayContainer.bindPopup(instance);
        return function removePopup() {
            context.map.off({
                popupopen: onPopupOpen,
                popupclose: onPopupClose
            });
            if (context.overlayContainer == null) context.map.removeLayer(instance);
            else context.overlayContainer.unbindPopup();
        };
    }, [
        element,
        context,
        setOpen,
        onClose,
        onOpen,
        position
    ]);
});

function $45be5047abff01ee$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}



const $3060c1ec0bc05063$export$f52ee31d61d0b27b = (0, $5d2619eb752b5a22$export$4f432c6de5c4ddb8)(function createTileLayer({ url: url, ...options }, context) {
    return {
        instance: new (0, $ad5a22b7e45eeb01$exports.TileLayer)(url, (0, $9b6d830a3c5df9c5$export$6ee5d263358f5c0e)(options, context)),
        context: context
    };
}, (0, $45be5047abff01ee$export$b39104a5f1b9296f));



var $3OyDL = parcelRequire("3OyDL");
function $629b970fa3d9dc1e$export$86f8f9f08863e403() {
    return (0, $df22a106505cd38b$export$ea59151b8430a4e9)().map;
}
function $629b970fa3d9dc1e$export$4c2959913f5c7962(type, handler) {
    const map = $629b970fa3d9dc1e$export$86f8f9f08863e403();
    (0, $3OyDL.useEffect)(function addMapEventHandler() {
        // @ts-ignore event type
        map.on(type, handler);
        return function removeMapEventHandler() {
            // @ts-ignore event type
            map.off(type, handler);
        };
    }, [
        map,
        type,
        handler
    ]);
    return map;
}
function $629b970fa3d9dc1e$export$1c51e2c234152172(handlers) {
    const map = $629b970fa3d9dc1e$export$86f8f9f08863e403();
    (0, $3OyDL.useEffect)(function addMapEventHandlers() {
        map.on(handlers);
        return function removeMapEventHandlers() {
            map.off(handlers);
        };
    }, [
        map,
        handlers
    ]);
    return map;
}




var $3b290aa680817c09$exports = {};
/*! @license DOMPurify 2.3.10 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.3.10/LICENSE */ (function(global, factory) {
    $3b290aa680817c09$exports = factory();
})($3b290aa680817c09$exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        transformCaseFunc = transformCaseFunc ? transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ])) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]); // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]); // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]); // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
         // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.3.10';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks? */ var SANITIZE_DOM = true;
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? function(x) {
                return x;
            } : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            } // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'foreignobject',
            'desc',
            'title',
            'annotation-xml'
        ]); // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: HTML_NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                 // The only way to switch from MathML to SVG is via
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                 // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                 // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                 // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                 // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            } // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG or MathML). Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml') // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? '' : dirtyPayload;
                } catch (_) {}
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i)parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (!value) ;
            else return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName.indexOf('-') > 0;
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty, cfg) {
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                // eslint-disable-next-line no-negated-condition
                if (typeof dirty.toString !== 'function') throw typeErrorCreate('toString is not a function');
                else {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                }
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


const $7801af78bc29c2a9$var$LocationMap = (props)=>{
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            map: {
                height: props.height ? `${props.height}px` : '40vh',
                width: '100%',
                borderRadius: 2,
                borderWidth: 'thin'
            },
            mapBox: {
                height: props.height ? `${props.height}px` : '40vh'
            }
        }));
    const classes = useStyles();
    const { positions: positions } = props;
    const mapZoom = props.mapZoom || 12;
    const [isCssElementLoaded, setCssElementLoaded] = (0, $3OyDL.useState)(false);
    (0, $3OyDL.useEffect)(()=>{
        const linkElement = document.createElement('link');
        linkElement.setAttribute('rel', 'stylesheet');
        linkElement.setAttribute('type', 'text/css');
        linkElement.setAttribute('href', 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css');
        document.head.appendChild(linkElement);
        setCssElementLoaded(true);
    }, []);
    const [isScriptElementLoaded, setScriptElementLoaded] = (0, $3OyDL.useState)(false);
    (0, $3OyDL.useEffect)(()=>{
        const linkElement = document.createElement('script');
        linkElement.setAttribute('type', 'text/javascript');
        linkElement.setAttribute('src', 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js');
        document.head.appendChild(linkElement);
        setScriptElementLoaded(true);
    }, []);
    function ChangeMapView() {
        const map = (0, $629b970fa3d9dc1e$export$86f8f9f08863e403)();
        map.flyTo(positions[0], map.getZoom());
        return null;
    }
    const LocationMarker = ()=>{
        return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
            children: positions && positions.length === 0 ? null : positions.map((position, index)=>{
                const label = props.label && props.label[index] ? props.label[index] : 'Familienskatturnier';
                return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $94a936208b69bd53$export$e98856a975cab58e), {
                        position: position,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4ab80f6906567b2f$export$129a32eedafa97c5), {
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                variant: "body1",
                                dangerouslySetInnerHTML: {
                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize(label)
                                }
                            })
                        })
                    })
                }, index);
            })
        });
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: isCssElementLoaded && isScriptElementLoaded && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
            className: classes.mapBox,
            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a358b76745ac1ee3$export$23f3dfd47374502b), {
                className: classes.map,
                center: positions[0],
                zoom: mapZoom,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3060c1ec0bc05063$export$f52ee31d61d0b27b), {
                        attribution: '&copy <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    }),
                    positions.length === 1 && /*#__PURE__*/ (0, $2M70Q.jsx)(ChangeMapView, {}),
                    /*#__PURE__*/ (0, $2M70Q.jsx)(LocationMarker, {})
                ]
            })
        })
    });
};
var $7801af78bc29c2a9$export$2e2bcd8739ae039 = $7801af78bc29c2a9$var$LocationMap;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $3OyDL = parcelRequire("3OyDL");
'use client';
function $f1aca04659deba32$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $3OyDL.useRef(controlled !== undefined);
    const [valueState, setValue] = $3OyDL.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $3OyDL.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


var $3OyDL = parcelRequire("3OyDL");
'use client';
let $2719898863e3140c$var$globalId = 0;
function $2719898863e3140c$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $3OyDL.useState(idOverride);
    const id = idOverride || defaultId;
    $3OyDL.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $2719898863e3140c$var$globalId += 1;
            setDefaultId(`mui-${$2719898863e3140c$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $2719898863e3140c$var$maybeReactUseId = $3OyDL['useId'.toString()];
function $2719898863e3140c$export$2e2bcd8739ae039(idOverride) {
    if ($2719898863e3140c$var$maybeReactUseId !== undefined) {
        const reactId = $2719898863e3140c$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $2719898863e3140c$var$useGlobalId(idOverride);
}


var $3OyDL = parcelRequire("3OyDL");
'use client';
const $81e0614ceb9fdee7$var$usePreviousProps = (value)=>{
    const ref = $3OyDL.useRef({});
    $3OyDL.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $81e0614ceb9fdee7$export$2e2bcd8739ae039 = $81e0614ceb9fdee7$var$usePreviousProps;


'use client';
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $3bf0e97acb2aa4b7$var$stripDiacritics(string) {
    return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function $3bf0e97acb2aa4b7$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $3bf0e97acb2aa4b7$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $3bf0e97acb2aa4b7$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $3bf0e97acb2aa4b7$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $3bf0e97acb2aa4b7$var$defaultFilterOptions = $3bf0e97acb2aa4b7$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $3bf0e97acb2aa4b7$var$pageSize = 5;
const $3bf0e97acb2aa4b7$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function $3bf0e97acb2aa4b7$export$1e40b3ca02d92d21(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $3bf0e97acb2aa4b7$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $3bf0e97acb2aa4b7$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $2719898863e3140c$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $3OyDL.useRef(false);
    const firstFocus = $3OyDL.useRef(true);
    const inputRef = $3OyDL.useRef(null);
    const listboxRef = $3OyDL.useRef(null);
    const [anchorEl, setAnchorEl] = $3OyDL.useState(null);
    const [focusedTag, setFocusedTag] = $3OyDL.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $3OyDL.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $f1aca04659deba32$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $f1aca04659deba32$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: '',
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $3OyDL.useState(false);
    const resetInputValue = $3OyDL.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = '';
        else if (newValue == null) newInputValue = '';
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, 'reset');
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $f1aca04659deba32$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $3OyDL.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $81e0614ceb9fdee7$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $3OyDL.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $fc6260e66a3c9db4$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $3OyDL.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && !option.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
            nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const setHighlightedIndex = (0, $fc6260e66a3c9db4$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = 'auto' })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $fc6260e66a3c9db4$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = 'next', reason: reason = 'auto' })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const checkHighlightedOptionExists = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) {
                const previousHighlightedOptionExists = filteredOptions.some((option)=>{
                    return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
                });
                if (previousHighlightedOptionExists) return true;
            }
        }
        return false;
    };
    const syncHighlightedIndex = $3OyDL.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, return, otherwise continue execution
        if (checkHighlightedOptionExists()) return;
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $3bf0e97acb2aa4b7$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $3bf0e97acb2aa4b7$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $fc6260e66a3c9db4$export$2e2bcd8739ae039)((node)=>{
        (0, $3d851111a0dedfa6$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $3OyDL.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $3OyDL.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $3bf0e97acb2aa4b7$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                'ArrowLeft',
                'ArrowRight'
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$3bf0e97acb2aa4b7$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $3bf0e97acb2aa4b7$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                case 'Delete':
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $gOPoC.default)({
                'aria-owns': listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $gOPoC.default)({
                key: index,
                'data-tag-index': index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}


var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $g4LX8 = parcelRequire("g4LX8");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $04ca7c9a350f22ad$export$6816d4fc0981ec7(slot) {
    return (0, $6AMoU.default)('MuiListSubheader', slot);
}
const $04ca7c9a350f22ad$var$listSubheaderClasses = (0, $ithJf.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $04ca7c9a350f22ad$export$2e2bcd8739ae039 = $04ca7c9a350f22ad$var$listSubheaderClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $3fc26b73cced47e3$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $3fc26b73cced47e3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $g4LX8.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $04ca7c9a350f22ad$export$6816d4fc0981ec7), classes);
};
const $3fc26b73cced47e3$var$ListSubheaderRoot = (0, $jH1k7.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $g4LX8.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === 'primary' && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $3fc26b73cced47e3$var$ListSubheader = /*#__PURE__*/ $3OyDL.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $aBenZ.default)(props, $3fc26b73cced47e3$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $3fc26b73cced47e3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($3fc26b73cced47e3$var$ListSubheaderRoot, (0, $gOPoC.default)({
        as: component,
        className: (0, $3DmQB.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$3fc26b73cced47e3$var$ListSubheader.muiSkipListHighlight = true;
var $3fc26b73cced47e3$export$2e2bcd8739ae039 = $3fc26b73cced47e3$var$ListSubheader;





var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");
parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $fc13d163cb234ec8$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');





var $g4LX8 = parcelRequire("g4LX8");


var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $967b4a8c69a28c5c$export$31444911e4ee6fdd(slot) {
    return (0, $6AMoU.default)('MuiChip', slot);
}
const $967b4a8c69a28c5c$var$chipClasses = (0, $ithJf.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $967b4a8c69a28c5c$export$2e2bcd8739ae039 = $967b4a8c69a28c5c$var$chipClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $8c02f7497c61ac2b$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $8c02f7497c61ac2b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $g4LX8.default)(size)}`,
            `color${(0, $g4LX8.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $g4LX8.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $g4LX8.default)(color)}`,
            `${variant}${(0, $g4LX8.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $g4LX8.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $g4LX8.default)(size)}`,
            `avatarColor${(0, $g4LX8.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $g4LX8.default)(size)}`,
            `iconColor${(0, $g4LX8.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $g4LX8.default)(size)}`,
            `deleteIconColor${(0, $g4LX8.default)(color)}`,
            `deleteIcon${(0, $g4LX8.default)(variant)}Color${(0, $g4LX8.default)(color)}`
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $967b4a8c69a28c5c$export$31444911e4ee6fdd), classes);
};
const $8c02f7497c61ac2b$var$ChipRoot = (0, $jH1k7.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $g4LX8.default)(size)}`]
            },
            {
                [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $g4LX8.default)(color)}`]
            },
            {
                [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $g4LX8.default)(size)}`]
            },
            {
                [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $g4LX8.default)(iconColor)}`]
            },
            {
                [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $g4LX8.default)(size)}`]
            },
            {
                [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $g4LX8.default)(color)}`]
            },
            {
                [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $g4LX8.default)(variant)}Color${(0, $g4LX8.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $g4LX8.default)(size)}`],
            styles[`color${(0, $g4LX8.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $g4LX8.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $g4LX8.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $g4LX8.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $gOPoC.default)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).icon}`]: (0, $gOPoC.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $gOPoC.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).deleteIcon}`]: (0, $gOPoC.default)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $7m2iU.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $7m2iU.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $7m2iU.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7m2iU.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7m2iU.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7m2iU.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $7m2iU.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7m2iU.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $967b4a8c69a28c5c$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $7m2iU.alpha)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $8c02f7497c61ac2b$var$ChipLabel = (0, $jH1k7.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $g4LX8.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }));
function $8c02f7497c61ac2b$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $8c02f7497c61ac2b$var$Chip = /*#__PURE__*/ $3OyDL.forwardRef(function Chip(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $aBenZ.default)(props, $8c02f7497c61ac2b$var$_excluded);
    const chipRef = $3OyDL.useRef(null);
    const handleRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $8c02f7497c61ac2b$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $8c02f7497c61ac2b$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $c582f66505800c92$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = (0, $gOPoC.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $3OyDL.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $8c02f7497c61ac2b$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $c582f66505800c92$export$2e2bcd8739ae039) ? (0, $gOPoC.default)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $3OyDL.isValidElement(deleteIconProp) ? /*#__PURE__*/ $3OyDL.cloneElement(deleteIconProp, {
        className: (0, $3DmQB.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $fc13d163cb234ec8$export$2e2bcd8739ae039), {
        className: (0, $3DmQB.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $3OyDL.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $3OyDL.cloneElement(avatarProp, {
        className: (0, $3DmQB.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $3OyDL.isValidElement(iconProp)) icon = /*#__PURE__*/ $3OyDL.cloneElement(iconProp, {
        className: (0, $3DmQB.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($8c02f7497c61ac2b$var$ChipRoot, (0, $gOPoC.default)({
        as: component,
        className: (0, $3DmQB.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $2M70Q.jsx)($8c02f7497c61ac2b$var$ChipLabel, {
                className: (0, $3DmQB.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $8c02f7497c61ac2b$export$2e2bcd8739ae039 = $8c02f7497c61ac2b$var$Chip;






parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $ffbce2540bf8a072$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');




var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $7fb77f1fd3ee2f16$export$8ee01529667e66d9(slot) {
    return (0, $6AMoU.default)('MuiAutocomplete', slot);
}
const $7fb77f1fd3ee2f16$var$autocompleteClasses = (0, $ithJf.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $7fb77f1fd3ee2f16$export$2e2bcd8739ae039 = $7fb77f1fd3ee2f16$var$autocompleteClasses;



var $g4LX8 = parcelRequire("g4LX8");


var $2M70Q = parcelRequire("2M70Q");
'use client';
var $1b4498b40a103fd2$var$_ClearIcon, $1b4498b40a103fd2$var$_ArrowDropDownIcon;
const $1b4498b40a103fd2$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $1b4498b40a103fd2$var$_excluded2 = [
    "ref"
];
const $1b4498b40a103fd2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $g4LX8.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $7fb77f1fd3ee2f16$export$8ee01529667e66d9), classes);
};
const $1b4498b40a103fd2$var$AutocompleteRoot = (0, $jH1k7.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $g4LX8.default)(size)}`]
            },
            {
                [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        [`&.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).focused} .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: 'visible'
        },
        /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
            [`&:hover .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).clearIndicator}`]: {
                visibility: 'visible'
            }
        }
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).tag}`]: (0, $gOPoC.default)({
            margin: 3,
            maxWidth: 'calc(100% - 6px)'
        }, ownerState.size === 'small' && {
            margin: 2,
            maxWidth: 'calc(100% - 4px)'
        }),
        [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).inputRoot}`]: {
            flexWrap: 'wrap',
            [`.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 30
            },
            [`.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 56
            },
            [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).input}`]: {
                width: 0,
                minWidth: 30
            }
        },
        [`& .${(0, $c590c70ed64f391b$export$2e2bcd8739ae039).root}`]: {
            paddingBottom: 1,
            '& .MuiInput-input': {
                padding: '4px 4px 4px 0px'
            }
        },
        [`& .${(0, $c590c70ed64f391b$export$2e2bcd8739ae039).root}.${(0, $70f299dd29a343ff$export$2e2bcd8739ae039).sizeSmall}`]: {
            [`& .${(0, $c590c70ed64f391b$export$2e2bcd8739ae039).input}`]: {
                padding: '2px 4px 3px 0'
            }
        },
        [`& .${(0, $e50b7ddb1f511773$export$2e2bcd8739ae039).root}`]: {
            padding: 9,
            [`.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).input}`]: {
                padding: '7.5px 4px 7.5px 5px'
            },
            [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $e50b7ddb1f511773$export$2e2bcd8739ae039).root}.${(0, $70f299dd29a343ff$export$2e2bcd8739ae039).sizeSmall}`]: {
            // Don't specify paddingRight, as it overrides the default value set when there is only
            // one of the popup or clear icon as the specificity is equal so the latter one wins
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).input}`]: {
                padding: '2.5px 4px 2.5px 8px'
            }
        },
        [`& .${(0, $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039).root}`]: {
            paddingTop: 19,
            paddingLeft: 8,
            [`.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039).input}`]: {
                padding: '7px 4px'
            },
            [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039).root}.${(0, $70f299dd29a343ff$export$2e2bcd8739ae039).sizeSmall}`]: {
            paddingBottom: 1,
            [`& .${(0, $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039).input}`]: {
                padding: '2.5px 4px'
            }
        },
        [`& .${(0, $70f299dd29a343ff$export$2e2bcd8739ae039).hiddenLabel}`]: {
            paddingTop: 8
        },
        [`& .${(0, $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039).root}.${(0, $70f299dd29a343ff$export$2e2bcd8739ae039).hiddenLabel}`]: {
            paddingTop: 0,
            paddingBottom: 0,
            [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).input}`]: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        [`& .${(0, $ee9f8d4ca5e8ce80$export$2e2bcd8739ae039).root}.${(0, $70f299dd29a343ff$export$2e2bcd8739ae039).hiddenLabel}.${(0, $70f299dd29a343ff$export$2e2bcd8739ae039).sizeSmall}`]: {
            [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).input}`]: {
                paddingTop: 8,
                paddingBottom: 9
            }
        },
        [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).input}`]: (0, $gOPoC.default)({
            flexGrow: 1,
            textOverflow: 'ellipsis',
            opacity: 0
        }, ownerState.inputFocused && {
            opacity: 1
        })
    }));
const $1b4498b40a103fd2$var$AutocompleteEndAdornment = (0, $jH1k7.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: 'calc(50% - 14px)' // Center vertically
});
const $1b4498b40a103fd2$var$AutocompleteClearIndicator = (0, $jH1k7.default)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $1b4498b40a103fd2$var$AutocompletePopupIndicator = (0, $jH1k7.default)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $gOPoC.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        padding: 2,
        marginRight: -2
    }, ownerState.popupOpen && {
        transform: 'rotate(180deg)'
    }));
const $1b4498b40a103fd2$var$AutocompletePopper = (0, $jH1k7.default)((0, $a61641bec19ba88c$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        zIndex: (theme.vars || theme).zIndex.modal
    }, ownerState.disablePortal && {
        position: 'absolute'
    }));
const $1b4498b40a103fd2$var$AutocompletePaper = (0, $jH1k7.default)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $gOPoC.default)({}, theme.typography.body1, {
        overflow: 'auto'
    }));
const $1b4498b40a103fd2$var$AutocompleteLoading = (0, $jH1k7.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $1b4498b40a103fd2$var$AutocompleteNoOptions = (0, $jH1k7.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $1b4498b40a103fd2$var$AutocompleteListbox = (0, $jH1k7.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $1b4498b40a103fd2$var$AutocompleteGroupLabel = (0, $jH1k7.default)((0, $3fc26b73cced47e3$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $1b4498b40a103fd2$var$AutocompleteGroupUl = (0, $jH1k7.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $7fb77f1fd3ee2f16$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $1b4498b40a103fd2$var$Autocomplete = /*#__PURE__*/ $3OyDL.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $1b4498b40a103fd2$var$_ClearIcon || ($1b4498b40a103fd2$var$_ClearIcon = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ffbce2540bf8a072$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = 'ul', ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', openOnFocus: openOnFocus = false, openText: openText = 'Open', PaperComponent: PaperComponent = (0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $a61641bec19ba88c$export$2e2bcd8739ae039), popupIcon: popupIcon = $1b4498b40a103fd2$var$_ArrowDropDownIcon || ($1b4498b40a103fd2$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9492c6fe2457f8c9$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slotProps: slotProps = {} } = props, other = (0, $aBenZ.default)(props, $1b4498b40a103fd2$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $3bf0e97acb2aa4b7$export$1e40b3ca02d92d21)((0, $gOPoC.default)({}, props, {
        componentName: 'Autocomplete'
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $aBenZ.default)(_getListboxProps, $1b4498b40a103fd2$var$_excluded2);
    const combinedListboxRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $gOPoC.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $1b4498b40a103fd2$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $gOPoC.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $8c02f7497c61ac2b$export$2e2bcd8739ae039), (0, $gOPoC.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps)));
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)($1b4498b40a103fd2$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)($1b4498b40a103fd2$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>/*#__PURE__*/ (0, $2M70Q.jsx)("li", (0, $gOPoC.default)({}, props2, {
            children: getOptionLabel(option)
        }));
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $gOPoC.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)($1b4498b40a103fd2$var$AutocompleteRoot, (0, $gOPoC.default)({
                ref: ref,
                className: (0, $3DmQB.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $gOPoC.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $2M70Q.jsxs)($1b4498b40a103fd2$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $2M70Q.jsx)($1b4498b40a103fd2$var$AutocompleteClearIndicator, (0, $gOPoC.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $3DmQB.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $2M70Q.jsx)($1b4498b40a103fd2$var$AutocompletePopupIndicator, (0, $gOPoC.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $3DmQB.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $gOPoC.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $2M70Q.jsx)($1b4498b40a103fd2$var$AutocompletePopper, (0, $gOPoC.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $3DmQB.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)($1b4498b40a103fd2$var$AutocompletePaper, (0, $gOPoC.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $3DmQB.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $2M70Q.jsx)($1b4498b40a103fd2$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $2M70Q.jsx)($1b4498b40a103fd2$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $2M70Q.jsx)($1b4498b40a103fd2$var$AutocompleteListbox, (0, $gOPoC.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $1b4498b40a103fd2$export$2e2bcd8739ae039 = $1b4498b40a103fd2$var$Autocomplete;


var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");


var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");




var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $5jsOu = parcelRequire("5jsOu");

var $3DmQB = parcelRequire("3DmQB");



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");



var $g4LX8 = parcelRequire("g4LX8");

var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $f2a9ce24a6588973$export$f7d501e40371cd17(slot) {
    return (0, $6AMoU.default)('MuiFormLabel', slot);
}
const $f2a9ce24a6588973$var$formLabelClasses = (0, $ithJf.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $f2a9ce24a6588973$export$2e2bcd8739ae039 = $f2a9ce24a6588973$var$formLabelClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $63ca5dbbb3498060$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $63ca5dbbb3498060$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $g4LX8.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $f2a9ce24a6588973$export$f7d501e40371cd17), classes);
};
const $63ca5dbbb3498060$export$aa5bc7f8a4705b27 = (0, $jH1k7.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $gOPoC.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $f2a9ce24a6588973$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $f2a9ce24a6588973$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $f2a9ce24a6588973$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $63ca5dbbb3498060$var$AsteriskComponent = (0, $jH1k7.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $f2a9ce24a6588973$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $63ca5dbbb3498060$var$FormLabel = /*#__PURE__*/ $3OyDL.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $aBenZ.default)(props, $63ca5dbbb3498060$var$_excluded);
    const muiFormControl = (0, $38dd66485068cbe7$export$2e2bcd8739ae039)();
    const fcs = (0, $26b79efadb7be4d4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $gOPoC.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $63ca5dbbb3498060$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($63ca5dbbb3498060$export$aa5bc7f8a4705b27, (0, $gOPoC.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $3DmQB.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $2M70Q.jsxs)($63ca5dbbb3498060$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $63ca5dbbb3498060$export$2e2bcd8739ae039 = $63ca5dbbb3498060$var$FormLabel;



var $jFgmT = parcelRequire("jFgmT");

var $g4LX8 = parcelRequire("g4LX8");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $831855bfbb28e240$export$c1c4b4545ad2ea5f(slot) {
    return (0, $6AMoU.default)('MuiInputLabel', slot);
}
const $831855bfbb28e240$var$inputLabelClasses = (0, $ithJf.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $831855bfbb28e240$export$2e2bcd8739ae039 = $831855bfbb28e240$var$inputLabelClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $922045e1db52dbe6$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $922045e1db52dbe6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $g4LX8.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $5jsOu.default)(slots, (0, $831855bfbb28e240$export$c1c4b4545ad2ea5f), classes);
    return (0, $gOPoC.default)({}, classes, composedClasses);
};
const $922045e1db52dbe6$var$InputLabelRoot = (0, $jH1k7.default)((0, $63ca5dbbb3498060$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $jH1k7.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $f2a9ce24a6588973$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $gOPoC.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $gOPoC.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $gOPoC.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $922045e1db52dbe6$var$InputLabel = /*#__PURE__*/ $3OyDL.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $jFgmT.default)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $aBenZ.default)(props, $922045e1db52dbe6$var$_excluded);
    const muiFormControl = (0, $38dd66485068cbe7$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $26b79efadb7be4d4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required'
        ]
    });
    const ownerState = (0, $gOPoC.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required
    });
    const classes = $922045e1db52dbe6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($922045e1db52dbe6$var$InputLabelRoot, (0, $gOPoC.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $3DmQB.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $922045e1db52dbe6$export$2e2bcd8739ae039 = $922045e1db52dbe6$var$InputLabel;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");


var $g4LX8 = parcelRequire("g4LX8");



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $6e7987c9e0c7e994$export$149c8b8bab2289d1(slot) {
    return (0, $6AMoU.default)('MuiFormControl', slot);
}
const $6e7987c9e0c7e994$var$formControlClasses = (0, $ithJf.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $6e7987c9e0c7e994$export$2e2bcd8739ae039 = $6e7987c9e0c7e994$var$formControlClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $2fe65d1538ae7232$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $2fe65d1538ae7232$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $g4LX8.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $6e7987c9e0c7e994$export$149c8b8bab2289d1), classes);
};
const $2fe65d1538ae7232$var$FormControlRoot = (0, $jH1k7.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $gOPoC.default)({}, styles.root, styles[`margin${(0, $g4LX8.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $2fe65d1538ae7232$var$FormControl = /*#__PURE__*/ $3OyDL.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $aBenZ.default)(props, $2fe65d1538ae7232$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $2fe65d1538ae7232$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $3OyDL.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $3OyDL.Children.forEach(children, (child)=>{
            if (!(0, $ad7a1c4dcda17e88$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $ad7a1c4dcda17e88$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $5c90c10b8a42aafe$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $3OyDL.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $3OyDL.Children.forEach(children, (child)=>{
            if (!(0, $ad7a1c4dcda17e88$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $5c90c10b8a42aafe$export$d652b828d7fdeff8)(child.props, true) || (0, $5c90c10b8a42aafe$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $3OyDL.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $3OyDL.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $677abf603a37a554$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($2fe65d1538ae7232$var$FormControlRoot, (0, $gOPoC.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $3DmQB.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $2fe65d1538ae7232$export$2e2bcd8739ae039 = $2fe65d1538ae7232$var$FormControl;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");



var $jH1k7 = parcelRequire("jH1k7");

var $g4LX8 = parcelRequire("g4LX8");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $f226b74446026733$export$a394fa61b1d583a9(slot) {
    return (0, $6AMoU.default)('MuiFormHelperText', slot);
}
const $f226b74446026733$var$formHelperTextClasses = (0, $ithJf.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $f226b74446026733$export$2e2bcd8739ae039 = $f226b74446026733$var$formHelperTextClasses;



var $jFgmT = parcelRequire("jFgmT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $065e7ec4f391a0de$var$_span;
const $065e7ec4f391a0de$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $065e7ec4f391a0de$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $g4LX8.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $f226b74446026733$export$a394fa61b1d583a9), classes);
};
const $065e7ec4f391a0de$var$FormHelperTextRoot = (0, $jH1k7.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $g4LX8.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $f226b74446026733$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $f226b74446026733$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $065e7ec4f391a0de$var$FormHelperText = /*#__PURE__*/ $3OyDL.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $aBenZ.default)(props, $065e7ec4f391a0de$var$_excluded);
    const muiFormControl = (0, $38dd66485068cbe7$export$2e2bcd8739ae039)();
    const fcs = (0, $26b79efadb7be4d4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $gOPoC.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $065e7ec4f391a0de$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($065e7ec4f391a0de$var$FormHelperTextRoot, (0, $gOPoC.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $3DmQB.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $065e7ec4f391a0de$var$_span || ($065e7ec4f391a0de$var$_span = /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $065e7ec4f391a0de$export$2e2bcd8739ae039 = $065e7ec4f391a0de$var$FormHelperText;




var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $a9cf21a5f4fa7081$export$c1bdcbaf0596aeda(slot) {
    return (0, $6AMoU.default)('MuiTextField', slot);
}
const $a9cf21a5f4fa7081$var$textFieldClasses = (0, $ithJf.default)('MuiTextField', [
    'root'
]);
var $a9cf21a5f4fa7081$export$2e2bcd8739ae039 = $a9cf21a5f4fa7081$var$textFieldClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $328e9bc68740648b$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $328e9bc68740648b$var$variantComponent = {
    standard: (0, $af5f6013d5f6a10c$export$2e2bcd8739ae039),
    filled: (0, $c581196ed9d5e621$export$2e2bcd8739ae039),
    outlined: (0, $010361f6348e7d57$export$2e2bcd8739ae039)
};
const $328e9bc68740648b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $a9cf21a5f4fa7081$export$c1bdcbaf0596aeda), classes);
};
const $328e9bc68740648b$var$TextFieldRoot = (0, $jH1k7.default)((0, $2fe65d1538ae7232$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $328e9bc68740648b$var$TextField = /*#__PURE__*/ $3OyDL.forwardRef(function TextField(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $aBenZ.default)(props, $328e9bc68740648b$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $328e9bc68740648b$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $17b6a17d80ba65b8$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $328e9bc68740648b$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $2M70Q.jsx)(InputComponent, (0, $gOPoC.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($328e9bc68740648b$var$TextFieldRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $922045e1db52dbe6$export$2e2bcd8739ae039), (0, $gOPoC.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b1485b6cef47f8e9$export$2e2bcd8739ae039), (0, $gOPoC.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $065e7ec4f391a0de$export$2e2bcd8739ae039), (0, $gOPoC.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $328e9bc68740648b$export$2e2bcd8739ae039 = $328e9bc68740648b$var$TextField;



const $fcd8906eca00ae5f$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        root: {
            width: '100%',
            minWidth: '200px'
        }
    }));
const $fcd8906eca00ae5f$var$TagComponent = (props)=>{
    const classes = $fcd8906eca00ae5f$var$useStyles();
    const [value, setValue] = (0, $3OyDL.useState)(props.value || []);
    const [selectActive, setSelectActive] = (0, $3OyDL.useState)(false);
    (0, $3OyDL.useEffect)(()=>{
        props.value && setValue(props.value);
    }, [
        props.value
    ]);
    const filter = (0, $3bf0e97acb2aa4b7$export$f76f94b238d946d8)();
    const checkTags = (tags)=>{
        const cleanedTags = [];
        tags.forEach((tag)=>{
            if (typeof tag !== 'string') {
                if (!(tag.id && tag.id.includes('newTag_')) || !tag.id) {
                    if (!cleanedTags.find((elem)=>elem.label === tag.label)) cleanedTags.push(tag);
                } else {
                    const tagLabel = tag.id.replace('newTag_', '').replace('"', '');
                    if (!cleanedTags.find((elem)=>elem.label === tag.label)) cleanedTags.push({
                        label: tagLabel
                    });
                }
            }
        });
        return cleanedTags;
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1b4498b40a103fd2$export$2e2bcd8739ae039), {
        multiple: true,
        value: value,
        id: props.id,
        selectOnFocus: true,
        clearOnBlur: true,
        className: classes.root,
        disableClearable: props.disableClearable ? props.disableClearable : false,
        disabled: props.disabled ? props.disabled : false,
        fullWidth: props.fullWidth,
        size: props.size,
        limitTags: props.limitTags,
        options: props.options,
        defaultValue: props.defaultValue,
        freeSolo: true,
        handleHomeEndKeys: true,
        onChange: (event, elem)=>{
            setValue(checkTags(elem));
            props.onChange && props.onChange(checkTags(elem));
        },
        filterOptions: (options, params)=>{
            const filtered = filter(options, params);
            const { inputValue: inputValue } = params;
            // Suggest the creation of a new value
            const isExisting = options.some((option)=>inputValue === option.label);
            if (inputValue !== '' && !isExisting) filtered.push({
                id: `newTag_${inputValue}`,
                label: `"${inputValue}" hinzuf\xfcgen`
            });
            return filtered;
        },
        renderTags: (value, getTagProps)=>value.map((option, index)=>{
                let tagLabel = option.label;
                if (option.id && option.id.includes('newTag_')) tagLabel = option.id.replace('newTag_', '').replace('"', '');
                return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8c02f7497c61ac2b$export$2e2bcd8739ae039), {
                        variant: "filled",
                        label: tagLabel,
                        ...getTagProps({
                            index: index
                        })
                    })
                }, index);
            }),
        renderInput: (params)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $328e9bc68740648b$export$2e2bcd8739ae039), {
                ...params,
                label: props.label,
                name: props.name,
                placeholder: props.placeholder,
                required: props.required,
                helperText: props.helperText,
                error: props.error,
                InputLabelProps: {
                    shrink: true
                },
                variant: props.variant,
                margin: props.margin,
                onKeyDown: (event)=>{
                    if (event.code === 'ArrowDown' || event.code === 'ArrowUp') setSelectActive(true);
                    if (event.code === 'Enter' && selectActive) setSelectActive(false);
                    if (event.code === 'Enter' && event.target && !selectActive) {
                        const target = event.target;
                        const newValues = value;
                        const equalToExistingTag = props.options.find((Tag)=>Tag.label.toLowerCase() === target.value.toLowerCase());
                        if (equalToExistingTag) newValues.push(equalToExistingTag);
                        else newValues.push({
                            label: target.value
                        });
                        setValue(newValues);
                    }
                }
            })
    });
};
var $fcd8906eca00ae5f$export$2e2bcd8739ae039 = $fcd8906eca00ae5f$var$TagComponent;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $41d4a6fe6ca19494$export$5f5333fe417019a7(slot) {
    return (0, $6AMoU.default)('MuiCardMedia', slot);
}
const $41d4a6fe6ca19494$var$cardMediaClasses = (0, $ithJf.default)('MuiCardMedia', [
    'root',
    'media',
    'img'
]);
var $41d4a6fe6ca19494$export$2e2bcd8739ae039 = $41d4a6fe6ca19494$var$cardMediaClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $4a6e8b03cc4f36e7$var$_excluded = [
    "children",
    "className",
    "component",
    "image",
    "src",
    "style"
];
const $4a6e8b03cc4f36e7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
    const slots = {
        root: [
            'root',
            isMediaComponent && 'media',
            isImageComponent && 'img'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $41d4a6fe6ca19494$export$5f5333fe417019a7), classes);
};
const $4a6e8b03cc4f36e7$var$CardMediaRoot = (0, $jH1k7.default)('div', {
    name: 'MuiCardMedia',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'block',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
    }, ownerState.isMediaComponent && {
        width: '100%'
    }, ownerState.isImageComponent && {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: 'cover'
    }));
const $4a6e8b03cc4f36e7$var$MEDIA_COMPONENTS = [
    'video',
    'audio',
    'picture',
    'iframe',
    'img'
];
const $4a6e8b03cc4f36e7$var$IMAGE_COMPONENTS = [
    'picture',
    'img'
];
const $4a6e8b03cc4f36e7$var$CardMedia = /*#__PURE__*/ $3OyDL.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiCardMedia'
    });
    const { children: children, className: className, component: component = 'div', image: image, src: src, style: style } = props, other = (0, $aBenZ.default)(props, $4a6e8b03cc4f36e7$var$_excluded);
    const isMediaComponent = $4a6e8b03cc4f36e7$var$MEDIA_COMPONENTS.indexOf(component) !== -1;
    const composedStyle = !isMediaComponent && image ? (0, $gOPoC.default)({
        backgroundImage: `url("${image}")`
    }, style) : style;
    const ownerState = (0, $gOPoC.default)({}, props, {
        component: component,
        isMediaComponent: isMediaComponent,
        isImageComponent: $4a6e8b03cc4f36e7$var$IMAGE_COMPONENTS.indexOf(component) !== -1
    });
    const classes = $4a6e8b03cc4f36e7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($4a6e8b03cc4f36e7$var$CardMediaRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? 'img' : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined
    }, other, {
        children: children
    }));
});
var $4a6e8b03cc4f36e7$export$2e2bcd8739ae039 = $4a6e8b03cc4f36e7$var$CardMedia;



var $d36d293eeee0b55a$exports = {};
"use strict";
"use client";

Object.defineProperty($d36d293eeee0b55a$exports, "__esModule", {
    value: true
});
$d36d293eeee0b55a$exports.default = void 0;

var $d36d293eeee0b55a$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $d36d293eeee0b55a$var$_default = (0, $d36d293eeee0b55a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2z"
}), 'Circle');
$d36d293eeee0b55a$exports.default = $d36d293eeee0b55a$var$_default;


var $dd8505b3e4398ebe$exports = {};
"use strict";
"use client";

Object.defineProperty($dd8505b3e4398ebe$exports, "__esModule", {
    value: true
});
$dd8505b3e4398ebe$exports.default = void 0;

var $dd8505b3e4398ebe$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $dd8505b3e4398ebe$var$_default = (0, $dd8505b3e4398ebe$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M17.77 3.77 16 2 6 12l10 10 1.77-1.77L9.54 12z"
}), 'ArrowBackIosNew');
$dd8505b3e4398ebe$exports.default = $dd8505b3e4398ebe$var$_default;


var $3a33fd87c92782f5$exports = {};
"use strict";
"use client";

Object.defineProperty($3a33fd87c92782f5$exports, "__esModule", {
    value: true
});
$3a33fd87c92782f5$exports.default = void 0;

var $3a33fd87c92782f5$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $3a33fd87c92782f5$var$_default = (0, $3a33fd87c92782f5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"
}), 'ArrowForwardIos');
$3a33fd87c92782f5$exports.default = $3a33fd87c92782f5$var$_default;



const $34aa91b0cc02ff7a$var$carouselDefaults = {
    navDotsVisible: true,
    navButtonsAlwaysVisible: true
};
const $34aa91b0cc02ff7a$var$MediaCarousel = (props)=>{
    const navDotsVisible = props.navDotsVisible === undefined ? $34aa91b0cc02ff7a$var$carouselDefaults.navDotsVisible : props.navDotsVisible;
    const navButtonsAlwaysVisible = props.navButtonsAlwaysVisible === undefined ? $34aa91b0cc02ff7a$var$carouselDefaults.navButtonsAlwaysVisible : props.navButtonsAlwaysVisible;
    const [currentImageIndex, setCurrentImageIndex] = (0, $3OyDL.useState)(0);
    const [selectedImage, setSelectedImage] = (0, $3OyDL.useState)(props.items[0]);
    const [onHover, setOnHover] = (0, $3OyDL.useState)(false);
    const [isNext, setIsNext] = (0, $3OyDL.useState)(true);
    const onNext = ()=>{
        setIsNext(true);
        setCurrentImageIndex(currentImageIndex + 1);
    };
    const onPrev = ()=>{
        setIsNext(false);
        setCurrentImageIndex(currentImageIndex - 1);
    };
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            icons: {
                display: 'flex',
                justifyContent: 'center',
                color: '#fff',
                cursor: 'pointer',
                margin: '5px',
                filter: 'drop-shadow(0px 0px 3px rgba(0, 0, 0, .65))',
                opacity: onHover ? '0.7' : '0',
                transition: 'all .2s',
                visibility: onHover ? 'visible' : 'hidden',
                '&:hover': {
                    color: theme.palette.common.white,
                    opacity: 1
                },
                '&$selectedDot:hover': {
                    color: theme.palette.common.white,
                    opacity: 1
                }
            },
            arrowBackground: {
                display: 'flex',
                cursor: 'pointer',
                justifyContent: 'center',
                alignItems: 'center',
                width: '40px',
                height: '100%',
                transition: 'all .1s',
                backgroundColor: onHover ? 'rgba(0, 0, 0, 0.15)' : 'transparent',
                '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.25)',
                    '& $icons': {
                        opacity: 1
                    }
                }
            },
            disabled: {
                visibility: 'hidden'
            },
            selectedDot: {
                color: theme.palette.common.white,
                opacity: 1
            },
            currentImage: {
                position: 'relative',
                top: 0,
                left: 0
            },
            carouselBase: {
                width: props.maxWidth,
                position: 'relative',
                overflow: 'hidden',
                transition: 'all 200ms ease',
                height: props.height
            }
        }));
    const classes = useStyles();
    (0, $3OyDL.useEffect)(()=>{
        setSelectedImage(props.items[currentImageIndex]);
    }, [
        currentImageIndex,
        props.items
    ]);
    (0, $3OyDL.useEffect)(()=>{
        navButtonsAlwaysVisible && setOnHover(true);
    }, []);
    (0, $3OyDL.useEffect)(()=>{
        props.parentIndex && setCurrentImageIndex(props.parentIndex);
    }, [
        props.parentIndex
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
        className: `${classes.carouselBase} slideshow ${isNext ? 'next' : 'prev'}`,
        onMouseEnter: ()=>{
            !navButtonsAlwaysVisible && setOnHover(true);
        },
        onMouseLeave: ()=>{
            !navButtonsAlwaysVisible && setOnHover(false);
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "slide",
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4a6e8b03cc4f36e7$export$2e2bcd8739ae039), {
                    component: "img",
                    height: props.height,
                    src: selectedImage,
                    className: classes.currentImage
                })
            }),
            props.items && props.items.length > 1 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                    sx: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    },
                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        sx: {
                            position: 'relative',
                            width: '100%',
                            height: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    position: 'absolute',
                                    top: 0,
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    height: '100%'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        className: `${classes.arrowBackground} ${currentImageIndex === 0 && classes.disabled}`,
                                        onClick: onPrev,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dd8505b3e4398ebe$exports))), {
                                            onClick: onPrev,
                                            className: `${classes.icons} ${currentImageIndex === 0 && classes.disabled}`,
                                            sx: {
                                                width: '30px'
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        className: `${classes.arrowBackground} ${currentImageIndex === props.items.length - 1 && classes.disabled}`,
                                        onClick: onNext,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a33fd87c92782f5$exports))), {
                                            onClick: onNext,
                                            className: `${classes.icons} ${currentImageIndex === props.items.length - 1 && classes.disabled}`,
                                            sx: {
                                                width: '30px'
                                            }
                                        })
                                    })
                                ]
                            }),
                            navDotsVisible && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    position: 'absolute',
                                    bottom: 0,
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'flex-end',
                                    height: 'auto'
                                },
                                children: props.items.map((elem, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d36d293eeee0b55a$exports))), {
                                        onClick: ()=>{
                                            setCurrentImageIndex(index);
                                        },
                                        className: `${classes.icons} ${index === currentImageIndex && classes.selectedDot}`,
                                        sx: {
                                            width: '12px'
                                        }
                                    }, index))
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $34aa91b0cc02ff7a$export$2e2bcd8739ae039 = $34aa91b0cc02ff7a$var$MediaCarousel;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $g4LX8 = parcelRequire("g4LX8");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $b085e7874d466598$export$e7545bb336f9a5fc(slot) {
    return (0, $6AMoU.default)('MuiIcon', slot);
}
const $b085e7874d466598$var$iconClasses = (0, $ithJf.default)('MuiIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $b085e7874d466598$export$2e2bcd8739ae039 = $b085e7874d466598$var$iconClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $97304d1ac631f514$var$_excluded = [
    "baseClassName",
    "className",
    "color",
    "component",
    "fontSize"
];
const $97304d1ac631f514$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $g4LX8.default)(color)}`,
            `fontSize${(0, $g4LX8.default)(fontSize)}`
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $b085e7874d466598$export$e7545bb336f9a5fc), classes);
};
const $97304d1ac631f514$var$IconRoot = (0, $jH1k7.default)('span', {
    name: 'MuiIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $g4LX8.default)(ownerState.color)}`],
            styles[`fontSize${(0, $g4LX8.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
        // To remove at some point.
        overflow: 'hidden',
        display: 'inline-block',
        // allow overflow hidden to take action
        textAlign: 'center',
        // support non-square icon
        flexShrink: 0,
        fontSize: ({
            inherit: 'inherit',
            small: theme.typography.pxToRem(20),
            medium: theme.typography.pxToRem(24),
            large: theme.typography.pxToRem(36)
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: ({
            primary: (theme.vars || theme).palette.primary.main,
            secondary: (theme.vars || theme).palette.secondary.main,
            info: (theme.vars || theme).palette.info.main,
            success: (theme.vars || theme).palette.success.main,
            warning: (theme.vars || theme).palette.warning.main,
            action: (theme.vars || theme).palette.action.active,
            error: (theme.vars || theme).palette.error.main,
            disabled: (theme.vars || theme).palette.action.disabled,
            inherit: undefined
        })[ownerState.color]
    }));
const $97304d1ac631f514$var$Icon = /*#__PURE__*/ $3OyDL.forwardRef(function Icon(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiIcon'
    });
    const { baseClassName: baseClassName = 'material-icons', className: className, color: color = 'inherit', component: Component = 'span', fontSize: fontSize = 'medium' } = props, other = (0, $aBenZ.default)(props, $97304d1ac631f514$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        baseClassName: baseClassName,
        color: color,
        component: Component,
        fontSize: fontSize
    });
    const classes = $97304d1ac631f514$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($97304d1ac631f514$var$IconRoot, (0, $gOPoC.default)({
        as: Component,
        className: (0, $3DmQB.default)(baseClassName, // Prevent the translation of the text content.
        // The font relies on the exact text content to render the icon.
        'notranslate', classes.root, className),
        ownerState: ownerState,
        "aria-hidden": true,
        ref: ref
    }, other));
});
$97304d1ac631f514$var$Icon.muiName = 'Icon';
var $97304d1ac631f514$export$2e2bcd8739ae039 = $97304d1ac631f514$var$Icon;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $eeWAX = parcelRequire("eeWAX");

var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");


var $g4LX8 = parcelRequire("g4LX8");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $e5bd38774f2a3056$export$5a6f9035944c8119(slot) {
    return (0, $6AMoU.default)('MuiButton', slot);
}
const $e5bd38774f2a3056$var$buttonClasses = (0, $ithJf.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $e5bd38774f2a3056$export$2e2bcd8739ae039 = $e5bd38774f2a3056$var$buttonClasses;



var $3OyDL = parcelRequire("3OyDL");
/**
 * @ignore - internal component.
 */ const $f11a2cdb9e0c7fc4$var$ButtonGroupContext = /*#__PURE__*/ $3OyDL.createContext({});
var $f11a2cdb9e0c7fc4$export$2e2bcd8739ae039 = $f11a2cdb9e0c7fc4$var$ButtonGroupContext;



var $3OyDL = parcelRequire("3OyDL");
/**
 * @ignore - internal component.
 */ const $914e17e9971b39b0$var$ButtonGroupButtonContext = /*#__PURE__*/ $3OyDL.createContext(undefined);
var $914e17e9971b39b0$export$2e2bcd8739ae039 = $914e17e9971b39b0$var$ButtonGroupButtonContext;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $a55b2c6a514356c8$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $a55b2c6a514356c8$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $g4LX8.default)(color)}`,
            `size${(0, $g4LX8.default)(size)}`,
            `${variant}Size${(0, $g4LX8.default)(size)}`,
            color === 'inherit' && 'colorInherit',
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'startIcon',
            `iconSize${(0, $g4LX8.default)(size)}`
        ],
        endIcon: [
            'endIcon',
            `iconSize${(0, $g4LX8.default)(size)}`
        ]
    };
    const composedClasses = (0, $5jsOu.default)(slots, (0, $e5bd38774f2a3056$export$5a6f9035944c8119), classes);
    return (0, $gOPoC.default)({}, classes, composedClasses);
};
const $a55b2c6a514356c8$var$commonIconStyles = (ownerState)=>(0, $gOPoC.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $a55b2c6a514356c8$var$ButtonRoot = (0, $jH1k7.default)((0, $c582f66505800c92$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $jH1k7.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $g4LX8.default)(ownerState.color)}`],
            styles[`size${(0, $g4LX8.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $g4LX8.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $gOPoC.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $gOPoC.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $gOPoC.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $e5bd38774f2a3056$export$2e2bcd8739ae039).focusVisible}`]: (0, $gOPoC.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $e5bd38774f2a3056$export$2e2bcd8739ae039).disabled}`]: (0, $gOPoC.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $7m2iU.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $e5bd38774f2a3056$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $e5bd38774f2a3056$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $a55b2c6a514356c8$var$ButtonStartIcon = (0, $jH1k7.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $g4LX8.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $a55b2c6a514356c8$var$commonIconStyles(ownerState)));
const $a55b2c6a514356c8$var$ButtonEndIcon = (0, $jH1k7.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $g4LX8.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $a55b2c6a514356c8$var$commonIconStyles(ownerState)));
const $a55b2c6a514356c8$var$Button = /*#__PURE__*/ $3OyDL.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $3OyDL.useContext((0, $f11a2cdb9e0c7fc4$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $3OyDL.useContext((0, $914e17e9971b39b0$export$2e2bcd8739ae039));
    const resolvedProps = (0, $eeWAX.default)(contextProps, inProps);
    const props = (0, $jFgmT.default)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $aBenZ.default)(props, $a55b2c6a514356c8$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $a55b2c6a514356c8$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $2M70Q.jsx)($a55b2c6a514356c8$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $2M70Q.jsx)($a55b2c6a514356c8$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($a55b2c6a514356c8$var$ButtonRoot, (0, $gOPoC.default)({
        ownerState: ownerState,
        className: (0, $3DmQB.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $3DmQB.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $a55b2c6a514356c8$export$2e2bcd8739ae039 = $a55b2c6a514356c8$var$Button;



const $959f967bf942d924$var$defaultSettings = {
    disabled: false,
    disableElevation: true,
    variant: 'contained',
    size: 'medium',
    type: 'button'
};
const $959f967bf942d924$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        text: {
            '&:hover': {
                border: '0px'
            }
        },
        base: {
            '&.MuiButton-root': {
                lineHeight: 1.6,
                '& span': {
                    display: 'flex'
                }
            }
        }
    }));
const $959f967bf942d924$var$ButtonComponent = (props)=>{
    const classes = $959f967bf942d924$var$useStyles();
    const startIcon = props.startIcon;
    const color = props.color ? props.color : undefined;
    const disabled = props.disabled ? props.disabled : $959f967bf942d924$var$defaultSettings.disabled;
    const disableElevation = props.disableElevation ? props.disableElevation : $959f967bf942d924$var$defaultSettings.disableElevation;
    const variant = props.variant ? props.variant : $959f967bf942d924$var$defaultSettings.variant;
    const size = props.size ? props.size : $959f967bf942d924$var$defaultSettings.size;
    const type = props.type ? props.type : $959f967bf942d924$var$defaultSettings.type;
    const link = props.link ? props.link : '';
    const target = props.target ? props.target : '_blank';
    const fullWidth = props.fullWidth || false;
    if (startIcon) return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a55b2c6a514356c8$export$2e2bcd8739ae039), {
        href: link,
        target: target,
        color: color,
        className: `${props.className} ${variant === 'text' && classes.text}`,
        variant: variant,
        type: type,
        size: size,
        fullWidth: fullWidth,
        disabled: disabled,
        disableElevation: disableElevation,
        "aria-label": props.text,
        startIcon: typeof props.startIcon === 'string' ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $97304d1ac631f514$export$2e2bcd8739ae039), {
            style: {
                textTransform: 'none'
            },
            children: props.startIcon
        }) : props.startIcon,
        onClick: ()=>props.onClick && props.onClick(),
        children: props.text
    });
    else return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a55b2c6a514356c8$export$2e2bcd8739ae039), {
        href: link,
        target: target,
        color: color,
        className: `${props.className} ${classes.base} ${variant === 'text' && classes.text}`,
        variant: variant,
        size: size,
        disabled: disabled,
        fullWidth: fullWidth,
        disableElevation: disableElevation,
        "aria-label": props.text,
        onClick: ()=>props.onClick && props.onClick(),
        type: type,
        children: props.text
    });
};
var $959f967bf942d924$export$2e2bcd8739ae039 = $959f967bf942d924$var$ButtonComponent;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");
const $8e6251e768e64172$var$ImageComponent = ({ fallback: fallback, src: src, ...props })=>{
    return /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
        src: src || fallback,
        ...props
    });
};
var $8e6251e768e64172$export$2e2bcd8739ae039 = $8e6251e768e64172$var$ImageComponent;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");

var $3OyDL = parcelRequire("3OyDL");
var $d02e888071d23636$exports = {};
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */ (function(global, factory) {
    $d02e888071d23636$exports = factory();
})($d02e888071d23636$exports, function() {
    'use strict';
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _typeof(o) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    var WINDOW = IS_BROWSER ? window : {};
    var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? 'ontouchstart' in WINDOW.document.documentElement : false;
    var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
    var NAMESPACE = 'cropper';
    // Actions
    var ACTION_ALL = 'all';
    var ACTION_CROP = 'crop';
    var ACTION_MOVE = 'move';
    var ACTION_ZOOM = 'zoom';
    var ACTION_EAST = 'e';
    var ACTION_WEST = 'w';
    var ACTION_SOUTH = 's';
    var ACTION_NORTH = 'n';
    var ACTION_NORTH_EAST = 'ne';
    var ACTION_NORTH_WEST = 'nw';
    var ACTION_SOUTH_EAST = 'se';
    var ACTION_SOUTH_WEST = 'sw';
    // Classes
    var CLASS_CROP = "".concat(NAMESPACE, "-crop");
    var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
    var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
    var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
    var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
    var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
    var CLASS_MOVE = "".concat(NAMESPACE, "-move");
    // Data keys
    var DATA_ACTION = "".concat(NAMESPACE, "Action");
    var DATA_PREVIEW = "".concat(NAMESPACE, "Preview");
    // Drag modes
    var DRAG_MODE_CROP = 'crop';
    var DRAG_MODE_MOVE = 'move';
    var DRAG_MODE_NONE = 'none';
    // Events
    var EVENT_CROP = 'crop';
    var EVENT_CROP_END = 'cropend';
    var EVENT_CROP_MOVE = 'cropmove';
    var EVENT_CROP_START = 'cropstart';
    var EVENT_DBLCLICK = 'dblclick';
    var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
    var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
    var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
    var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
    var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
    var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
    var EVENT_READY = 'ready';
    var EVENT_RESIZE = 'resize';
    var EVENT_WHEEL = 'wheel';
    var EVENT_ZOOM = 'zoom';
    // Mime types
    var MIME_TYPE_JPEG = 'image/jpeg';
    // RegExps
    var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
    var REGEXP_DATA_URL = /^data:/;
    var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
    var REGEXP_TAG_NAME = /^img|canvas$/i;
    // Misc
    // Inspired by the default width and height of a canvas element.
    var MIN_CONTAINER_WIDTH = 200;
    var MIN_CONTAINER_HEIGHT = 100;
    var DEFAULTS = {
        // Define the view mode of the cropper
        viewMode: 0,
        // 0, 1, 2, 3
        // Define the dragging mode of the cropper
        dragMode: DRAG_MODE_CROP,
        // 'crop', 'move' or 'none'
        // Define the initial aspect ratio of the crop box
        initialAspectRatio: NaN,
        // Define the aspect ratio of the crop box
        aspectRatio: NaN,
        // An object with the previous cropping result data
        data: null,
        // A selector for adding extra containers to preview
        preview: '',
        // Re-render the cropper when resize the window
        responsive: true,
        // Restore the cropped area after resize the window
        restore: true,
        // Check if the current image is a cross-origin image
        checkCrossOrigin: true,
        // Check the current image's Exif Orientation information
        checkOrientation: true,
        // Show the black modal
        modal: true,
        // Show the dashed lines for guiding
        guides: true,
        // Show the center indicator for guiding
        center: true,
        // Show the white modal to highlight the crop box
        highlight: true,
        // Show the grid background
        background: true,
        // Enable to crop the image automatically when initialize
        autoCrop: true,
        // Define the percentage of automatic cropping area when initializes
        autoCropArea: 0.8,
        // Enable to move the image
        movable: true,
        // Enable to rotate the image
        rotatable: true,
        // Enable to scale the image
        scalable: true,
        // Enable to zoom the image
        zoomable: true,
        // Enable to zoom the image by dragging touch
        zoomOnTouch: true,
        // Enable to zoom the image by wheeling mouse
        zoomOnWheel: true,
        // Define zoom ratio when zoom the image by wheeling mouse
        wheelZoomRatio: 0.1,
        // Enable to move the crop box
        cropBoxMovable: true,
        // Enable to resize the crop box
        cropBoxResizable: true,
        // Toggle drag mode between "crop" and "move" when click twice on the cropper
        toggleDragModeOnDblclick: true,
        // Size limitation
        minCanvasWidth: 0,
        minCanvasHeight: 0,
        minCropBoxWidth: 0,
        minCropBoxHeight: 0,
        minContainerWidth: MIN_CONTAINER_WIDTH,
        minContainerHeight: MIN_CONTAINER_HEIGHT,
        // Shortcuts of events
        ready: null,
        cropstart: null,
        cropmove: null,
        cropend: null,
        crop: null,
        zoom: null
    };
    var TEMPLATE = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>';
    /**
   * Check if the given value is not a number.
   */ var isNaN = Number.isNaN || WINDOW.isNaN;
    /**
   * Check if the given value is a number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
   */ function isNumber(value) {
        return typeof value === 'number' && !isNaN(value);
    }
    /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */ var isPositiveNumber = function isPositiveNumber(value) {
        return value > 0 && value < Infinity;
    };
    /**
   * Check if the given value is undefined.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
   */ function isUndefined(value) {
        return typeof value === 'undefined';
    }
    /**
   * Check if the given value is an object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
   */ function isObject(value) {
        return _typeof(value) === 'object' && value !== null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
   * Check if the given value is a plain object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
   */ function isPlainObject(value) {
        if (!isObject(value)) return false;
        try {
            var _constructor = value.constructor;
            var prototype = _constructor.prototype;
            return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
        } catch (error) {
            return false;
        }
    }
    /**
   * Check if the given value is a function.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
   */ function isFunction(value) {
        return typeof value === 'function';
    }
    var slice = Array.prototype.slice;
    /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */ function toArray(value) {
        return Array.from ? Array.from(value) : slice.call(value);
    }
    /**
   * Iterate the given data.
   * @param {*} data - The data to iterate.
   * @param {Function} callback - The process function for each element.
   * @returns {*} The original data.
   */ function forEach(data, callback) {
        if (data && isFunction(callback)) {
            if (Array.isArray(data) || isNumber(data.length)) toArray(data).forEach(function(value, key) {
                callback.call(data, value, key, data);
            });
            else if (isObject(data)) Object.keys(data).forEach(function(key) {
                callback.call(data, data[key], key, data);
            });
        }
        return data;
    }
    /**
   * Extend the given object.
   * @param {*} target - The target object to extend.
   * @param {*} args - The rest objects for merging to the target object.
   * @returns {Object} The extended object.
   */ var assign = Object.assign || function assign(target) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (isObject(target) && args.length > 0) args.forEach(function(arg) {
            if (isObject(arg)) Object.keys(arg).forEach(function(key) {
                target[key] = arg[key];
            });
        });
        return target;
    };
    var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
    /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */ function normalizeDecimalNumber(value) {
        var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
        return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
    }
    var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
    /**
   * Apply styles to the given element.
   * @param {Element} element - The target element.
   * @param {Object} styles - The styles for applying.
   */ function setStyle(element, styles) {
        var style = element.style;
        forEach(styles, function(value, property) {
            if (REGEXP_SUFFIX.test(property) && isNumber(value)) value = "".concat(value, "px");
            style[property] = value;
        });
    }
    /**
   * Check if the given element has a special class.
   * @param {Element} element - The element to check.
   * @param {string} value - The class to search.
   * @returns {boolean} Returns `true` if the special class was found.
   */ function hasClass(element, value) {
        return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
    }
    /**
   * Add classes to the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be added.
   */ function addClass(element, value) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                addClass(elem, value);
            });
            return;
        }
        if (element.classList) {
            element.classList.add(value);
            return;
        }
        var className = element.className.trim();
        if (!className) element.className = value;
        else if (className.indexOf(value) < 0) element.className = "".concat(className, " ").concat(value);
    }
    /**
   * Remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be removed.
   */ function removeClass(element, value) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                removeClass(elem, value);
            });
            return;
        }
        if (element.classList) {
            element.classList.remove(value);
            return;
        }
        if (element.className.indexOf(value) >= 0) element.className = element.className.replace(value, '');
    }
    /**
   * Add or remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be toggled.
   * @param {boolean} added - Add only.
   */ function toggleClass(element, value, added) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                toggleClass(elem, value, added);
            });
            return;
        }
        // IE10-11 doesn't support the second parameter of `classList.toggle`
        if (added) addClass(element, value);
        else removeClass(element, value);
    }
    var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
    /**
   * Transform the given string from camelCase to kebab-case
   * @param {string} value - The value to transform.
   * @returns {string} The transformed value.
   */ function toParamCase(value) {
        return value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
    }
    /**
   * Get data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to get.
   * @returns {string} The data value.
   */ function getData(element, name) {
        if (isObject(element[name])) return element[name];
        if (element.dataset) return element.dataset[name];
        return element.getAttribute("data-".concat(toParamCase(name)));
    }
    /**
   * Set data to the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to set.
   * @param {string} data - The data value.
   */ function setData(element, name, data) {
        if (isObject(data)) element[name] = data;
        else if (element.dataset) element.dataset[name] = data;
        else element.setAttribute("data-".concat(toParamCase(name)), data);
    }
    /**
   * Remove data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to remove.
   */ function removeData(element, name) {
        if (isObject(element[name])) try {
            delete element[name];
        } catch (error) {
            element[name] = undefined;
        }
        else if (element.dataset) // #128 Safari not allows to delete dataset property
        try {
            delete element.dataset[name];
        } catch (error) {
            element.dataset[name] = undefined;
        }
        else element.removeAttribute("data-".concat(toParamCase(name)));
    }
    var REGEXP_SPACES = /\s\s*/;
    var onceSupported = function() {
        var supported = false;
        if (IS_BROWSER) {
            var once = false;
            var listener = function listener() {};
            var options = Object.defineProperty({}, 'once', {
                get: function get() {
                    supported = true;
                    return once;
                },
                /**
         * This setter can fix a `TypeError` in strict mode
         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
         * @param {boolean} value - The value to set
         */ set: function set(value) {
                    once = value;
                }
            });
            WINDOW.addEventListener('test', listener, options);
            WINDOW.removeEventListener('test', listener, options);
        }
        return supported;
    }();
    /**
   * Remove event listener from the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */ function removeListener(element, type, listener) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var handler = listener;
        type.trim().split(REGEXP_SPACES).forEach(function(event) {
            if (!onceSupported) {
                var listeners = element.listeners;
                if (listeners && listeners[event] && listeners[event][listener]) {
                    handler = listeners[event][listener];
                    delete listeners[event][listener];
                    if (Object.keys(listeners[event]).length === 0) delete listeners[event];
                    if (Object.keys(listeners).length === 0) delete element.listeners;
                }
            }
            element.removeEventListener(event, handler, options);
        });
    }
    /**
   * Add event listener to the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */ function addListener(element, type, listener) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var _handler = listener;
        type.trim().split(REGEXP_SPACES).forEach(function(event) {
            if (options.once && !onceSupported) {
                var _element$listeners = element.listeners, listeners = _element$listeners === void 0 ? {} : _element$listeners;
                _handler = function handler() {
                    delete listeners[event][listener];
                    element.removeEventListener(event, _handler, options);
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    listener.apply(element, args);
                };
                if (!listeners[event]) listeners[event] = {};
                if (listeners[event][listener]) element.removeEventListener(event, listeners[event][listener], options);
                listeners[event][listener] = _handler;
                element.listeners = listeners;
            }
            element.addEventListener(event, _handler, options);
        });
    }
    /**
   * Dispatch event on the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Object} data - The additional event data.
   * @returns {boolean} Indicate if the event is default prevented or not.
   */ function dispatchEvent(element, type, data) {
        var event;
        // Event and CustomEvent on IE9-11 are global objects, not constructors
        if (isFunction(Event) && isFunction(CustomEvent)) event = new CustomEvent(type, {
            detail: data,
            bubbles: true,
            cancelable: true
        });
        else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(type, true, true, data);
        }
        return element.dispatchEvent(event);
    }
    /**
   * Get the offset base on the document.
   * @param {Element} element - The target element.
   * @returns {Object} The offset data.
   */ function getOffset(element) {
        var box = element.getBoundingClientRect();
        return {
            left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
            top: box.top + (window.pageYOffset - document.documentElement.clientTop)
        };
    }
    var location = WINDOW.location;
    var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
    /**
   * Check if the given URL is a cross origin URL.
   * @param {string} url - The target URL.
   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
   */ function isCrossOriginURL(url) {
        var parts = url.match(REGEXP_ORIGINS);
        return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
    }
    /**
   * Add timestamp to the given URL.
   * @param {string} url - The target URL.
   * @returns {string} The result URL.
   */ function addTimestamp(url) {
        var timestamp = "timestamp=".concat(new Date().getTime());
        return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
    }
    /**
   * Get transforms base on the given object.
   * @param {Object} obj - The target object.
   * @returns {string} A string contains transform values.
   */ function getTransforms(_ref) {
        var rotate = _ref.rotate, scaleX = _ref.scaleX, scaleY = _ref.scaleY, translateX = _ref.translateX, translateY = _ref.translateY;
        var values = [];
        if (isNumber(translateX) && translateX !== 0) values.push("translateX(".concat(translateX, "px)"));
        if (isNumber(translateY) && translateY !== 0) values.push("translateY(".concat(translateY, "px)"));
        // Rotate should come first before scale to match orientation transform
        if (isNumber(rotate) && rotate !== 0) values.push("rotate(".concat(rotate, "deg)"));
        if (isNumber(scaleX) && scaleX !== 1) values.push("scaleX(".concat(scaleX, ")"));
        if (isNumber(scaleY) && scaleY !== 1) values.push("scaleY(".concat(scaleY, ")"));
        var transform = values.length ? values.join(' ') : 'none';
        return {
            WebkitTransform: transform,
            msTransform: transform,
            transform: transform
        };
    }
    /**
   * Get the max ratio of a group of pointers.
   * @param {string} pointers - The target pointers.
   * @returns {number} The result ratio.
   */ function getMaxZoomRatio(pointers) {
        var pointers2 = _objectSpread2({}, pointers);
        var maxRatio = 0;
        forEach(pointers, function(pointer, pointerId) {
            delete pointers2[pointerId];
            forEach(pointers2, function(pointer2) {
                var x1 = Math.abs(pointer.startX - pointer2.startX);
                var y1 = Math.abs(pointer.startY - pointer2.startY);
                var x2 = Math.abs(pointer.endX - pointer2.endX);
                var y2 = Math.abs(pointer.endY - pointer2.endY);
                var z1 = Math.sqrt(x1 * x1 + y1 * y1);
                var z2 = Math.sqrt(x2 * x2 + y2 * y2);
                var ratio = (z2 - z1) / z1;
                if (Math.abs(ratio) > Math.abs(maxRatio)) maxRatio = ratio;
            });
        });
        return maxRatio;
    }
    /**
   * Get a pointer from an event object.
   * @param {Object} event - The target event object.
   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
   * @returns {Object} The result pointer contains start and/or end point coordinates.
   */ function getPointer(_ref2, endOnly) {
        var pageX = _ref2.pageX, pageY = _ref2.pageY;
        var end = {
            endX: pageX,
            endY: pageY
        };
        return endOnly ? end : _objectSpread2({
            startX: pageX,
            startY: pageY
        }, end);
    }
    /**
   * Get the center point coordinate of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {Object} The center point coordinate.
   */ function getPointersCenter(pointers) {
        var pageX = 0;
        var pageY = 0;
        var count = 0;
        forEach(pointers, function(_ref3) {
            var startX = _ref3.startX, startY = _ref3.startY;
            pageX += startX;
            pageY += startY;
            count += 1;
        });
        pageX /= count;
        pageY /= count;
        return {
            pageX: pageX,
            pageY: pageY
        };
    }
    /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */ function getAdjustedSizes(_ref4) {
        var aspectRatio = _ref4.aspectRatio, height = _ref4.height, width = _ref4.width;
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
        var isValidWidth = isPositiveNumber(width);
        var isValidHeight = isPositiveNumber(height);
        if (isValidWidth && isValidHeight) {
            var adjustedWidth = height * aspectRatio;
            if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) height = width / aspectRatio;
            else width = height * aspectRatio;
        } else if (isValidWidth) height = width / aspectRatio;
        else if (isValidHeight) width = height * aspectRatio;
        return {
            width: width,
            height: height
        };
    }
    /**
   * Get the new sizes of a rectangle after rotated.
   * @param {Object} data - The original sizes.
   * @returns {Object} The result sizes.
   */ function getRotatedSizes(_ref5) {
        var width = _ref5.width, height = _ref5.height, degree = _ref5.degree;
        degree = Math.abs(degree) % 180;
        if (degree === 90) return {
            width: height,
            height: width
        };
        var arc = degree % 90 * Math.PI / 180;
        var sinArc = Math.sin(arc);
        var cosArc = Math.cos(arc);
        var newWidth = width * cosArc + height * sinArc;
        var newHeight = width * sinArc + height * cosArc;
        return degree > 90 ? {
            width: newHeight,
            height: newWidth
        } : {
            width: newWidth,
            height: newHeight
        };
    }
    /**
   * Get a canvas which drew the given image.
   * @param {HTMLImageElement} image - The image for drawing.
   * @param {Object} imageData - The image data.
   * @param {Object} canvasData - The canvas data.
   * @param {Object} options - The options.
   * @returns {HTMLCanvasElement} The result canvas.
   */ function getSourceCanvas(image, _ref6, _ref7, _ref8) {
        var imageAspectRatio = _ref6.aspectRatio, imageNaturalWidth = _ref6.naturalWidth, imageNaturalHeight = _ref6.naturalHeight, _ref6$rotate = _ref6.rotate, rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate, _ref6$scaleX = _ref6.scaleX, scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX, _ref6$scaleY = _ref6.scaleY, scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
        var aspectRatio = _ref7.aspectRatio, naturalWidth = _ref7.naturalWidth, naturalHeight = _ref7.naturalHeight;
        var _ref8$fillColor = _ref8.fillColor, fillColor = _ref8$fillColor === void 0 ? 'transparent' : _ref8$fillColor, _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled, imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE, _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality, imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? 'low' : _ref8$imageSmoothingQ, _ref8$maxWidth = _ref8.maxWidth, maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth, _ref8$maxHeight = _ref8.maxHeight, maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight, _ref8$minWidth = _ref8.minWidth, minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth, _ref8$minHeight = _ref8.minHeight, minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var maxSizes = getAdjustedSizes({
            aspectRatio: aspectRatio,
            width: maxWidth,
            height: maxHeight
        });
        var minSizes = getAdjustedSizes({
            aspectRatio: aspectRatio,
            width: minWidth,
            height: minHeight
        }, 'cover');
        var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
        var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight));
        // Note: should always use image's natural sizes for drawing as
        // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90
        var destMaxSizes = getAdjustedSizes({
            aspectRatio: imageAspectRatio,
            width: maxWidth,
            height: maxHeight
        });
        var destMinSizes = getAdjustedSizes({
            aspectRatio: imageAspectRatio,
            width: minWidth,
            height: minHeight
        }, 'cover');
        var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
        var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
        var params = [
            -destWidth / 2,
            -destHeight / 2,
            destWidth,
            destHeight
        ];
        canvas.width = normalizeDecimalNumber(width);
        canvas.height = normalizeDecimalNumber(height);
        context.fillStyle = fillColor;
        context.fillRect(0, 0, width, height);
        context.save();
        context.translate(width / 2, height / 2);
        context.rotate(rotate * Math.PI / 180);
        context.scale(scaleX, scaleY);
        context.imageSmoothingEnabled = imageSmoothingEnabled;
        context.imageSmoothingQuality = imageSmoothingQuality;
        context.drawImage.apply(context, [
            image
        ].concat(_toConsumableArray(params.map(function(param) {
            return Math.floor(normalizeDecimalNumber(param));
        }))));
        context.restore();
        return canvas;
    }
    var fromCharCode = String.fromCharCode;
    /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */ function getStringFromCharCode(dataView, start, length) {
        var str = '';
        length += start;
        for(var i = start; i < length; i += 1)str += fromCharCode(dataView.getUint8(i));
        return str;
    }
    var REGEXP_DATA_URL_HEAD = /^data:.*,/;
    /**
   * Transform Data URL to array buffer.
   * @param {string} dataURL - The Data URL to transform.
   * @returns {ArrayBuffer} The result array buffer.
   */ function dataURLToArrayBuffer(dataURL) {
        var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
        var binary = atob(base64);
        var arrayBuffer = new ArrayBuffer(binary.length);
        var uint8 = new Uint8Array(arrayBuffer);
        forEach(uint8, function(value, i) {
            uint8[i] = binary.charCodeAt(i);
        });
        return arrayBuffer;
    }
    /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */ function arrayBufferToDataURL(arrayBuffer, mimeType) {
        var chunks = [];
        // Chunk Typed Array for better performance (#435)
        var chunkSize = 8192;
        var uint8 = new Uint8Array(arrayBuffer);
        while(uint8.length > 0){
            // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
            // eslint-disable-next-line prefer-spread
            chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
            uint8 = uint8.subarray(chunkSize);
        }
        return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
    }
    /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */ function resetAndGetOrientation(arrayBuffer) {
        var dataView = new DataView(arrayBuffer);
        var orientation;
        // Ignores range error when the image does not have correct Exif information
        try {
            var littleEndian;
            var app1Start;
            var ifdStart;
            // Only handle JPEG image (start by 0xFFD8)
            if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
                var length = dataView.byteLength;
                var offset = 2;
                while(offset + 1 < length){
                    if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
                        app1Start = offset;
                        break;
                    }
                    offset += 1;
                }
            }
            if (app1Start) {
                var exifIDCode = app1Start + 4;
                var tiffOffset = app1Start + 10;
                if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
                    var endianness = dataView.getUint16(tiffOffset);
                    littleEndian = endianness === 0x4949;
                    if (littleEndian || endianness === 0x4D4D /* bigEndian */ ) {
                        if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                            var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
                            if (firstIFDOffset >= 0x00000008) ifdStart = tiffOffset + firstIFDOffset;
                        }
                    }
                }
            }
            if (ifdStart) {
                var _length = dataView.getUint16(ifdStart, littleEndian);
                var _offset;
                var i;
                for(i = 0; i < _length; i += 1){
                    _offset = ifdStart + i * 12 + 2;
                    if (dataView.getUint16(_offset, littleEndian) === 0x0112 /* Orientation */ ) {
                        // 8 is the offset of the current tag's value
                        _offset += 8;
                        // Get the original orientation value
                        orientation = dataView.getUint16(_offset, littleEndian);
                        // Override the orientation with its default value
                        dataView.setUint16(_offset, 1, littleEndian);
                        break;
                    }
                }
            }
        } catch (error) {
            orientation = 1;
        }
        return orientation;
    }
    /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */ function parseOrientation(orientation) {
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;
        switch(orientation){
            // Flip horizontal
            case 2:
                scaleX = -1;
                break;
            // Rotate left 180°
            case 3:
                rotate = -180;
                break;
            // Flip vertical
            case 4:
                scaleY = -1;
                break;
            // Flip vertical and rotate right 90°
            case 5:
                rotate = 90;
                scaleY = -1;
                break;
            // Rotate right 90°
            case 6:
                rotate = 90;
                break;
            // Flip horizontal and rotate right 90°
            case 7:
                rotate = 90;
                scaleX = -1;
                break;
            // Rotate left 90°
            case 8:
                rotate = -90;
                break;
        }
        return {
            rotate: rotate,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    var render = {
        render: function render() {
            this.initContainer();
            this.initCanvas();
            this.initCropBox();
            this.renderCanvas();
            if (this.cropped) this.renderCropBox();
        },
        initContainer: function initContainer() {
            var element = this.element, options = this.options, container = this.container, cropper = this.cropper;
            var minWidth = Number(options.minContainerWidth);
            var minHeight = Number(options.minContainerHeight);
            addClass(cropper, CLASS_HIDDEN);
            removeClass(element, CLASS_HIDDEN);
            var containerData = {
                width: Math.max(container.offsetWidth, minWidth >= 0 ? minWidth : MIN_CONTAINER_WIDTH),
                height: Math.max(container.offsetHeight, minHeight >= 0 ? minHeight : MIN_CONTAINER_HEIGHT)
            };
            this.containerData = containerData;
            setStyle(cropper, {
                width: containerData.width,
                height: containerData.height
            });
            addClass(element, CLASS_HIDDEN);
            removeClass(cropper, CLASS_HIDDEN);
        },
        // Canvas (image wrapper)
        initCanvas: function initCanvas() {
            var containerData = this.containerData, imageData = this.imageData;
            var viewMode = this.options.viewMode;
            var rotated = Math.abs(imageData.rotate) % 180 === 90;
            var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
            var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
            var aspectRatio = naturalWidth / naturalHeight;
            var canvasWidth = containerData.width;
            var canvasHeight = containerData.height;
            if (containerData.height * aspectRatio > containerData.width) {
                if (viewMode === 3) canvasWidth = containerData.height * aspectRatio;
                else canvasHeight = containerData.width / aspectRatio;
            } else if (viewMode === 3) canvasHeight = containerData.width / aspectRatio;
            else canvasWidth = containerData.height * aspectRatio;
            var canvasData = {
                aspectRatio: aspectRatio,
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight,
                width: canvasWidth,
                height: canvasHeight
            };
            this.canvasData = canvasData;
            this.limited = viewMode === 1 || viewMode === 2;
            this.limitCanvas(true, true);
            canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
            canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
            canvasData.left = (containerData.width - canvasData.width) / 2;
            canvasData.top = (containerData.height - canvasData.height) / 2;
            canvasData.oldLeft = canvasData.left;
            canvasData.oldTop = canvasData.top;
            this.initialCanvasData = assign({}, canvasData);
        },
        limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
            var options = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var viewMode = options.viewMode;
            var aspectRatio = canvasData.aspectRatio;
            var cropped = this.cropped && cropBoxData;
            if (sizeLimited) {
                var minCanvasWidth = Number(options.minCanvasWidth) || 0;
                var minCanvasHeight = Number(options.minCanvasHeight) || 0;
                if (viewMode > 1) {
                    minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
                    minCanvasHeight = Math.max(minCanvasHeight, containerData.height);
                    if (viewMode === 3) {
                        if (minCanvasHeight * aspectRatio > minCanvasWidth) minCanvasWidth = minCanvasHeight * aspectRatio;
                        else minCanvasHeight = minCanvasWidth / aspectRatio;
                    }
                } else if (viewMode > 0) {
                    if (minCanvasWidth) minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
                    else if (minCanvasHeight) minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
                    else if (cropped) {
                        minCanvasWidth = cropBoxData.width;
                        minCanvasHeight = cropBoxData.height;
                        if (minCanvasHeight * aspectRatio > minCanvasWidth) minCanvasWidth = minCanvasHeight * aspectRatio;
                        else minCanvasHeight = minCanvasWidth / aspectRatio;
                    }
                }
                var _getAdjustedSizes = getAdjustedSizes({
                    aspectRatio: aspectRatio,
                    width: minCanvasWidth,
                    height: minCanvasHeight
                });
                minCanvasWidth = _getAdjustedSizes.width;
                minCanvasHeight = _getAdjustedSizes.height;
                canvasData.minWidth = minCanvasWidth;
                canvasData.minHeight = minCanvasHeight;
                canvasData.maxWidth = Infinity;
                canvasData.maxHeight = Infinity;
            }
            if (positionLimited) {
                if (viewMode > (cropped ? 0 : 1)) {
                    var newCanvasLeft = containerData.width - canvasData.width;
                    var newCanvasTop = containerData.height - canvasData.height;
                    canvasData.minLeft = Math.min(0, newCanvasLeft);
                    canvasData.minTop = Math.min(0, newCanvasTop);
                    canvasData.maxLeft = Math.max(0, newCanvasLeft);
                    canvasData.maxTop = Math.max(0, newCanvasTop);
                    if (cropped && this.limited) {
                        canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
                        canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
                        canvasData.maxLeft = cropBoxData.left;
                        canvasData.maxTop = cropBoxData.top;
                        if (viewMode === 2) {
                            if (canvasData.width >= containerData.width) {
                                canvasData.minLeft = Math.min(0, newCanvasLeft);
                                canvasData.maxLeft = Math.max(0, newCanvasLeft);
                            }
                            if (canvasData.height >= containerData.height) {
                                canvasData.minTop = Math.min(0, newCanvasTop);
                                canvasData.maxTop = Math.max(0, newCanvasTop);
                            }
                        }
                    }
                } else {
                    canvasData.minLeft = -canvasData.width;
                    canvasData.minTop = -canvasData.height;
                    canvasData.maxLeft = containerData.width;
                    canvasData.maxTop = containerData.height;
                }
            }
        },
        renderCanvas: function renderCanvas(changed, transformed) {
            var canvasData = this.canvasData, imageData = this.imageData;
            if (transformed) {
                var _getRotatedSizes = getRotatedSizes({
                    width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
                    height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
                    degree: imageData.rotate || 0
                }), naturalWidth = _getRotatedSizes.width, naturalHeight = _getRotatedSizes.height;
                var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
                var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
                canvasData.left -= (width - canvasData.width) / 2;
                canvasData.top -= (height - canvasData.height) / 2;
                canvasData.width = width;
                canvasData.height = height;
                canvasData.aspectRatio = naturalWidth / naturalHeight;
                canvasData.naturalWidth = naturalWidth;
                canvasData.naturalHeight = naturalHeight;
                this.limitCanvas(true, false);
            }
            if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) canvasData.left = canvasData.oldLeft;
            if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) canvasData.top = canvasData.oldTop;
            canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
            canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
            this.limitCanvas(false, true);
            canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
            canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
            canvasData.oldLeft = canvasData.left;
            canvasData.oldTop = canvasData.top;
            setStyle(this.canvas, assign({
                width: canvasData.width,
                height: canvasData.height
            }, getTransforms({
                translateX: canvasData.left,
                translateY: canvasData.top
            })));
            this.renderImage(changed);
            if (this.cropped && this.limited) this.limitCropBox(true, true);
        },
        renderImage: function renderImage(changed) {
            var canvasData = this.canvasData, imageData = this.imageData;
            var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
            var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
            assign(imageData, {
                width: width,
                height: height,
                left: (canvasData.width - width) / 2,
                top: (canvasData.height - height) / 2
            });
            setStyle(this.image, assign({
                width: imageData.width,
                height: imageData.height
            }, getTransforms(assign({
                translateX: imageData.left,
                translateY: imageData.top
            }, imageData))));
            if (changed) this.output();
        },
        initCropBox: function initCropBox() {
            var options = this.options, canvasData = this.canvasData;
            var aspectRatio = options.aspectRatio || options.initialAspectRatio;
            var autoCropArea = Number(options.autoCropArea) || 0.8;
            var cropBoxData = {
                width: canvasData.width,
                height: canvasData.height
            };
            if (aspectRatio) {
                if (canvasData.height * aspectRatio > canvasData.width) cropBoxData.height = cropBoxData.width / aspectRatio;
                else cropBoxData.width = cropBoxData.height * aspectRatio;
            }
            this.cropBoxData = cropBoxData;
            this.limitCropBox(true, true);
            // Initialize auto crop area
            cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
            cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
            // The width/height of auto crop area must large than "minWidth/Height"
            cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
            cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
            cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
            cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
            cropBoxData.oldLeft = cropBoxData.left;
            cropBoxData.oldTop = cropBoxData.top;
            this.initialCropBoxData = assign({}, cropBoxData);
        },
        limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
            var options = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData, limited = this.limited;
            var aspectRatio = options.aspectRatio;
            if (sizeLimited) {
                var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
                var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
                var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
                var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height;
                // The min/maxCropBoxWidth/Height must be less than container's width/height
                minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
                minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);
                if (aspectRatio) {
                    if (minCropBoxWidth && minCropBoxHeight) {
                        if (minCropBoxHeight * aspectRatio > minCropBoxWidth) minCropBoxHeight = minCropBoxWidth / aspectRatio;
                        else minCropBoxWidth = minCropBoxHeight * aspectRatio;
                    } else if (minCropBoxWidth) minCropBoxHeight = minCropBoxWidth / aspectRatio;
                    else if (minCropBoxHeight) minCropBoxWidth = minCropBoxHeight * aspectRatio;
                    if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
                    else maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
                }
                // The minWidth/Height must be less than maxWidth/Height
                cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
                cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
                cropBoxData.maxWidth = maxCropBoxWidth;
                cropBoxData.maxHeight = maxCropBoxHeight;
            }
            if (positionLimited) {
                if (limited) {
                    cropBoxData.minLeft = Math.max(0, canvasData.left);
                    cropBoxData.minTop = Math.max(0, canvasData.top);
                    cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
                    cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
                } else {
                    cropBoxData.minLeft = 0;
                    cropBoxData.minTop = 0;
                    cropBoxData.maxLeft = containerData.width - cropBoxData.width;
                    cropBoxData.maxTop = containerData.height - cropBoxData.height;
                }
            }
        },
        renderCropBox: function renderCropBox() {
            var options = this.options, containerData = this.containerData, cropBoxData = this.cropBoxData;
            if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) cropBoxData.left = cropBoxData.oldLeft;
            if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) cropBoxData.top = cropBoxData.oldTop;
            cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
            cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
            this.limitCropBox(false, true);
            cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
            cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
            cropBoxData.oldLeft = cropBoxData.left;
            cropBoxData.oldTop = cropBoxData.top;
            if (options.movable && options.cropBoxMovable) // Turn to move the canvas when the crop box is equal to the container
            setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
            setStyle(this.cropBox, assign({
                width: cropBoxData.width,
                height: cropBoxData.height
            }, getTransforms({
                translateX: cropBoxData.left,
                translateY: cropBoxData.top
            })));
            if (this.cropped && this.limited) this.limitCanvas(true, true);
            if (!this.disabled) this.output();
        },
        output: function output() {
            this.preview();
            dispatchEvent(this.element, EVENT_CROP, this.getData());
        }
    };
    var preview = {
        initPreview: function initPreview() {
            var element = this.element, crossOrigin = this.crossOrigin;
            var preview = this.options.preview;
            var url = crossOrigin ? this.crossOriginUrl : this.url;
            var alt = element.alt || 'The image to preview';
            var image = document.createElement('img');
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = url;
            image.alt = alt;
            this.viewBox.appendChild(image);
            this.viewBoxImage = image;
            if (!preview) return;
            var previews = preview;
            if (typeof preview === 'string') previews = element.ownerDocument.querySelectorAll(preview);
            else if (preview.querySelector) previews = [
                preview
            ];
            this.previews = previews;
            forEach(previews, function(el) {
                var img = document.createElement('img');
                // Save the original size for recover
                setData(el, DATA_PREVIEW, {
                    width: el.offsetWidth,
                    height: el.offsetHeight,
                    html: el.innerHTML
                });
                if (crossOrigin) img.crossOrigin = crossOrigin;
                img.src = url;
                img.alt = alt;
                /**
         * Override img element styles
         * Add `display:block` to avoid margin top issue
         * Add `height:auto` to override `height` attribute on IE8
         * (Occur only when margin-top <= -height)
         */ img.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"';
                el.innerHTML = '';
                el.appendChild(img);
            });
        },
        resetPreview: function resetPreview() {
            forEach(this.previews, function(element) {
                var data = getData(element, DATA_PREVIEW);
                setStyle(element, {
                    width: data.width,
                    height: data.height
                });
                element.innerHTML = data.html;
                removeData(element, DATA_PREVIEW);
            });
        },
        preview: function preview() {
            var imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var cropBoxWidth = cropBoxData.width, cropBoxHeight = cropBoxData.height;
            var width = imageData.width, height = imageData.height;
            var left = cropBoxData.left - canvasData.left - imageData.left;
            var top = cropBoxData.top - canvasData.top - imageData.top;
            if (!this.cropped || this.disabled) return;
            setStyle(this.viewBoxImage, assign({
                width: width,
                height: height
            }, getTransforms(assign({
                translateX: -left,
                translateY: -top
            }, imageData))));
            forEach(this.previews, function(element) {
                var data = getData(element, DATA_PREVIEW);
                var originalWidth = data.width;
                var originalHeight = data.height;
                var newWidth = originalWidth;
                var newHeight = originalHeight;
                var ratio = 1;
                if (cropBoxWidth) {
                    ratio = originalWidth / cropBoxWidth;
                    newHeight = cropBoxHeight * ratio;
                }
                if (cropBoxHeight && newHeight > originalHeight) {
                    ratio = originalHeight / cropBoxHeight;
                    newWidth = cropBoxWidth * ratio;
                    newHeight = originalHeight;
                }
                setStyle(element, {
                    width: newWidth,
                    height: newHeight
                });
                setStyle(element.getElementsByTagName('img')[0], assign({
                    width: width * ratio,
                    height: height * ratio
                }, getTransforms(assign({
                    translateX: -left * ratio,
                    translateY: -top * ratio
                }, imageData))));
            });
        }
    };
    var events = {
        bind: function bind() {
            var element = this.element, options = this.options, cropper = this.cropper;
            if (isFunction(options.cropstart)) addListener(element, EVENT_CROP_START, options.cropstart);
            if (isFunction(options.cropmove)) addListener(element, EVENT_CROP_MOVE, options.cropmove);
            if (isFunction(options.cropend)) addListener(element, EVENT_CROP_END, options.cropend);
            if (isFunction(options.crop)) addListener(element, EVENT_CROP, options.crop);
            if (isFunction(options.zoom)) addListener(element, EVENT_ZOOM, options.zoom);
            addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));
            if (options.zoomable && options.zoomOnWheel) addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
                passive: false,
                capture: true
            });
            if (options.toggleDragModeOnDblclick) addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
            addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
            addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));
            if (options.responsive) addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
        },
        unbind: function unbind() {
            var element = this.element, options = this.options, cropper = this.cropper;
            if (isFunction(options.cropstart)) removeListener(element, EVENT_CROP_START, options.cropstart);
            if (isFunction(options.cropmove)) removeListener(element, EVENT_CROP_MOVE, options.cropmove);
            if (isFunction(options.cropend)) removeListener(element, EVENT_CROP_END, options.cropend);
            if (isFunction(options.crop)) removeListener(element, EVENT_CROP, options.crop);
            if (isFunction(options.zoom)) removeListener(element, EVENT_ZOOM, options.zoom);
            removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);
            if (options.zoomable && options.zoomOnWheel) removeListener(cropper, EVENT_WHEEL, this.onWheel, {
                passive: false,
                capture: true
            });
            if (options.toggleDragModeOnDblclick) removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
            removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
            removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);
            if (options.responsive) removeListener(window, EVENT_RESIZE, this.onResize);
        }
    };
    var handlers = {
        resize: function resize() {
            if (this.disabled) return;
            var options = this.options, container = this.container, containerData = this.containerData;
            var ratioX = container.offsetWidth / containerData.width;
            var ratioY = container.offsetHeight / containerData.height;
            var ratio = Math.abs(ratioX - 1) > Math.abs(ratioY - 1) ? ratioX : ratioY;
            // Resize when width changed or height changed
            if (ratio !== 1) {
                var canvasData;
                var cropBoxData;
                if (options.restore) {
                    canvasData = this.getCanvasData();
                    cropBoxData = this.getCropBoxData();
                }
                this.render();
                if (options.restore) {
                    this.setCanvasData(forEach(canvasData, function(n, i) {
                        canvasData[i] = n * ratio;
                    }));
                    this.setCropBoxData(forEach(cropBoxData, function(n, i) {
                        cropBoxData[i] = n * ratio;
                    }));
                }
            }
        },
        dblclick: function dblclick() {
            if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) return;
            this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
        },
        wheel: function wheel(event) {
            var _this = this;
            var ratio = Number(this.options.wheelZoomRatio) || 0.1;
            var delta = 1;
            if (this.disabled) return;
            event.preventDefault();
            // Limit wheel speed to prevent zoom too fast (#21)
            if (this.wheeling) return;
            this.wheeling = true;
            setTimeout(function() {
                _this.wheeling = false;
            }, 50);
            if (event.deltaY) delta = event.deltaY > 0 ? 1 : -1;
            else if (event.wheelDelta) delta = -event.wheelDelta / 120;
            else if (event.detail) delta = event.detail > 0 ? 1 : -1;
            this.zoom(-delta * ratio, event);
        },
        cropStart: function cropStart(event) {
            var buttons = event.buttons, button = event.button;
            if (this.disabled || (event.type === 'mousedown' || event.type === 'pointerdown' && event.pointerType === 'mouse') && // No primary button (Usually the left button)
            (isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 || event.ctrlKey)) return;
            var options = this.options, pointers = this.pointers;
            var action;
            if (event.changedTouches) // Handle touch event
            forEach(event.changedTouches, function(touch) {
                pointers[touch.identifier] = getPointer(touch);
            });
            else // Handle mouse event and pointer event
            pointers[event.pointerId || 0] = getPointer(event);
            if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) action = ACTION_ZOOM;
            else action = getData(event.target, DATA_ACTION);
            if (!REGEXP_ACTIONS.test(action)) return;
            if (dispatchEvent(this.element, EVENT_CROP_START, {
                originalEvent: event,
                action: action
            }) === false) return;
            // This line is required for preventing page zooming in iOS browsers
            event.preventDefault();
            this.action = action;
            this.cropping = false;
            if (action === ACTION_CROP) {
                this.cropping = true;
                addClass(this.dragBox, CLASS_MODAL);
            }
        },
        cropMove: function cropMove(event) {
            var action = this.action;
            if (this.disabled || !action) return;
            var pointers = this.pointers;
            event.preventDefault();
            if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
                originalEvent: event,
                action: action
            }) === false) return;
            if (event.changedTouches) forEach(event.changedTouches, function(touch) {
                // The first parameter should not be undefined (#432)
                assign(pointers[touch.identifier] || {}, getPointer(touch, true));
            });
            else assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
            this.change(event);
        },
        cropEnd: function cropEnd(event) {
            if (this.disabled) return;
            var action = this.action, pointers = this.pointers;
            if (event.changedTouches) forEach(event.changedTouches, function(touch) {
                delete pointers[touch.identifier];
            });
            else delete pointers[event.pointerId || 0];
            if (!action) return;
            event.preventDefault();
            if (!Object.keys(pointers).length) this.action = '';
            if (this.cropping) {
                this.cropping = false;
                toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
            }
            dispatchEvent(this.element, EVENT_CROP_END, {
                originalEvent: event,
                action: action
            });
        }
    };
    var change = {
        change: function change(event) {
            var options = this.options, canvasData = this.canvasData, containerData = this.containerData, cropBoxData = this.cropBoxData, pointers = this.pointers;
            var action = this.action;
            var aspectRatio = options.aspectRatio;
            var left = cropBoxData.left, top = cropBoxData.top, width = cropBoxData.width, height = cropBoxData.height;
            var right = left + width;
            var bottom = top + height;
            var minLeft = 0;
            var minTop = 0;
            var maxWidth = containerData.width;
            var maxHeight = containerData.height;
            var renderable = true;
            var offset;
            // Locking aspect ratio in "free mode" by holding shift key
            if (!aspectRatio && event.shiftKey) aspectRatio = width && height ? width / height : 1;
            if (this.limited) {
                minLeft = cropBoxData.minLeft;
                minTop = cropBoxData.minTop;
                maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
                maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
            }
            var pointer = pointers[Object.keys(pointers)[0]];
            var range = {
                x: pointer.endX - pointer.startX,
                y: pointer.endY - pointer.startY
            };
            var check = function check(side) {
                switch(side){
                    case ACTION_EAST:
                        if (right + range.x > maxWidth) range.x = maxWidth - right;
                        break;
                    case ACTION_WEST:
                        if (left + range.x < minLeft) range.x = minLeft - left;
                        break;
                    case ACTION_NORTH:
                        if (top + range.y < minTop) range.y = minTop - top;
                        break;
                    case ACTION_SOUTH:
                        if (bottom + range.y > maxHeight) range.y = maxHeight - bottom;
                        break;
                }
            };
            switch(action){
                // Move crop box
                case ACTION_ALL:
                    left += range.x;
                    top += range.y;
                    break;
                // Resize crop box
                case ACTION_EAST:
                    if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_EAST);
                    width += range.x;
                    if (width < 0) {
                        action = ACTION_WEST;
                        width = -width;
                        left -= width;
                    }
                    if (aspectRatio) {
                        height = width / aspectRatio;
                        top += (cropBoxData.height - height) / 2;
                    }
                    break;
                case ACTION_NORTH:
                    if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_NORTH);
                    height -= range.y;
                    top += range.y;
                    if (height < 0) {
                        action = ACTION_SOUTH;
                        height = -height;
                        top -= height;
                    }
                    if (aspectRatio) {
                        width = height * aspectRatio;
                        left += (cropBoxData.width - width) / 2;
                    }
                    break;
                case ACTION_WEST:
                    if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_WEST);
                    width -= range.x;
                    left += range.x;
                    if (width < 0) {
                        action = ACTION_EAST;
                        width = -width;
                        left -= width;
                    }
                    if (aspectRatio) {
                        height = width / aspectRatio;
                        top += (cropBoxData.height - height) / 2;
                    }
                    break;
                case ACTION_SOUTH:
                    if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_SOUTH);
                    height += range.y;
                    if (height < 0) {
                        action = ACTION_NORTH;
                        height = -height;
                        top -= height;
                    }
                    if (aspectRatio) {
                        width = height * aspectRatio;
                        left += (cropBoxData.width - width) / 2;
                    }
                    break;
                case ACTION_NORTH_EAST:
                    if (aspectRatio) {
                        if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_NORTH);
                        height -= range.y;
                        top += range.y;
                        width = height * aspectRatio;
                    } else {
                        check(ACTION_NORTH);
                        check(ACTION_EAST);
                        if (range.x >= 0) {
                            if (right < maxWidth) width += range.x;
                            else if (range.y <= 0 && top <= minTop) renderable = false;
                        } else width += range.x;
                        if (range.y <= 0) {
                            if (top > minTop) {
                                height -= range.y;
                                top += range.y;
                            }
                        } else {
                            height -= range.y;
                            top += range.y;
                        }
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_SOUTH_WEST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_NORTH_WEST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_SOUTH_EAST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_NORTH_WEST:
                    if (aspectRatio) {
                        if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_NORTH);
                        height -= range.y;
                        top += range.y;
                        width = height * aspectRatio;
                        left += cropBoxData.width - width;
                    } else {
                        check(ACTION_NORTH);
                        check(ACTION_WEST);
                        if (range.x <= 0) {
                            if (left > minLeft) {
                                width -= range.x;
                                left += range.x;
                            } else if (range.y <= 0 && top <= minTop) renderable = false;
                        } else {
                            width -= range.x;
                            left += range.x;
                        }
                        if (range.y <= 0) {
                            if (top > minTop) {
                                height -= range.y;
                                top += range.y;
                            }
                        } else {
                            height -= range.y;
                            top += range.y;
                        }
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_SOUTH_EAST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_NORTH_EAST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_SOUTH_WEST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_SOUTH_WEST:
                    if (aspectRatio) {
                        if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_WEST);
                        width -= range.x;
                        left += range.x;
                        height = width / aspectRatio;
                    } else {
                        check(ACTION_SOUTH);
                        check(ACTION_WEST);
                        if (range.x <= 0) {
                            if (left > minLeft) {
                                width -= range.x;
                                left += range.x;
                            } else if (range.y >= 0 && bottom >= maxHeight) renderable = false;
                        } else {
                            width -= range.x;
                            left += range.x;
                        }
                        if (range.y >= 0) {
                            if (bottom < maxHeight) height += range.y;
                        } else height += range.y;
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_NORTH_EAST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_SOUTH_EAST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_NORTH_WEST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_SOUTH_EAST:
                    if (aspectRatio) {
                        if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_EAST);
                        width += range.x;
                        height = width / aspectRatio;
                    } else {
                        check(ACTION_SOUTH);
                        check(ACTION_EAST);
                        if (range.x >= 0) {
                            if (right < maxWidth) width += range.x;
                            else if (range.y >= 0 && bottom >= maxHeight) renderable = false;
                        } else width += range.x;
                        if (range.y >= 0) {
                            if (bottom < maxHeight) height += range.y;
                        } else height += range.y;
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_NORTH_WEST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_SOUTH_WEST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_NORTH_EAST;
                        height = -height;
                        top -= height;
                    }
                    break;
                // Move canvas
                case ACTION_MOVE:
                    this.move(range.x, range.y);
                    renderable = false;
                    break;
                // Zoom canvas
                case ACTION_ZOOM:
                    this.zoom(getMaxZoomRatio(pointers), event);
                    renderable = false;
                    break;
                // Create crop box
                case ACTION_CROP:
                    if (!range.x || !range.y) {
                        renderable = false;
                        break;
                    }
                    offset = getOffset(this.cropper);
                    left = pointer.startX - offset.left;
                    top = pointer.startY - offset.top;
                    width = cropBoxData.minWidth;
                    height = cropBoxData.minHeight;
                    if (range.x > 0) action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
                    else if (range.x < 0) {
                        left -= width;
                        action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
                    }
                    if (range.y < 0) top -= height;
                    // Show the crop box if is hidden
                    if (!this.cropped) {
                        removeClass(this.cropBox, CLASS_HIDDEN);
                        this.cropped = true;
                        if (this.limited) this.limitCropBox(true, true);
                    }
                    break;
            }
            if (renderable) {
                cropBoxData.width = width;
                cropBoxData.height = height;
                cropBoxData.left = left;
                cropBoxData.top = top;
                this.action = action;
                this.renderCropBox();
            }
            // Override
            forEach(pointers, function(p) {
                p.startX = p.endX;
                p.startY = p.endY;
            });
        }
    };
    var methods = {
        // Show the crop box manually
        crop: function crop() {
            if (this.ready && !this.cropped && !this.disabled) {
                this.cropped = true;
                this.limitCropBox(true, true);
                if (this.options.modal) addClass(this.dragBox, CLASS_MODAL);
                removeClass(this.cropBox, CLASS_HIDDEN);
                this.setCropBoxData(this.initialCropBoxData);
            }
            return this;
        },
        // Reset the image and crop box to their initial states
        reset: function reset() {
            if (this.ready && !this.disabled) {
                this.imageData = assign({}, this.initialImageData);
                this.canvasData = assign({}, this.initialCanvasData);
                this.cropBoxData = assign({}, this.initialCropBoxData);
                this.renderCanvas();
                if (this.cropped) this.renderCropBox();
            }
            return this;
        },
        // Clear the crop box
        clear: function clear() {
            if (this.cropped && !this.disabled) {
                assign(this.cropBoxData, {
                    left: 0,
                    top: 0,
                    width: 0,
                    height: 0
                });
                this.cropped = false;
                this.renderCropBox();
                this.limitCanvas(true, true);
                // Render canvas after crop box rendered
                this.renderCanvas();
                removeClass(this.dragBox, CLASS_MODAL);
                addClass(this.cropBox, CLASS_HIDDEN);
            }
            return this;
        },
        /**
     * Replace the image's src and rebuild the cropper
     * @param {string} url - The new URL.
     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
     * @returns {Cropper} this
     */ replace: function replace(url) {
            var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            if (!this.disabled && url) {
                if (this.isImg) this.element.src = url;
                if (hasSameSize) {
                    this.url = url;
                    this.image.src = url;
                    if (this.ready) {
                        this.viewBoxImage.src = url;
                        forEach(this.previews, function(element) {
                            element.getElementsByTagName('img')[0].src = url;
                        });
                    }
                } else {
                    if (this.isImg) this.replaced = true;
                    this.options.data = null;
                    this.uncreate();
                    this.load(url);
                }
            }
            return this;
        },
        // Enable (unfreeze) the cropper
        enable: function enable() {
            if (this.ready && this.disabled) {
                this.disabled = false;
                removeClass(this.cropper, CLASS_DISABLED);
            }
            return this;
        },
        // Disable (freeze) the cropper
        disable: function disable() {
            if (this.ready && !this.disabled) {
                this.disabled = true;
                addClass(this.cropper, CLASS_DISABLED);
            }
            return this;
        },
        /**
     * Destroy the cropper and remove the instance from the image
     * @returns {Cropper} this
     */ destroy: function destroy() {
            var element = this.element;
            if (!element[NAMESPACE]) return this;
            element[NAMESPACE] = undefined;
            if (this.isImg && this.replaced) element.src = this.originalUrl;
            this.uncreate();
            return this;
        },
        /**
     * Move the canvas with relative offsets
     * @param {number} offsetX - The relative offset distance on the x-axis.
     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
     * @returns {Cropper} this
     */ move: function move(offsetX) {
            var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
            var _this$canvasData = this.canvasData, left = _this$canvasData.left, top = _this$canvasData.top;
            return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
        },
        /**
     * Move the canvas to an absolute point
     * @param {number} x - The x-axis coordinate.
     * @param {number} [y=x] - The y-axis coordinate.
     * @returns {Cropper} this
     */ moveTo: function moveTo(x) {
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
            var canvasData = this.canvasData;
            var changed = false;
            x = Number(x);
            y = Number(y);
            if (this.ready && !this.disabled && this.options.movable) {
                if (isNumber(x)) {
                    canvasData.left = x;
                    changed = true;
                }
                if (isNumber(y)) {
                    canvasData.top = y;
                    changed = true;
                }
                if (changed) this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Zoom the canvas with a relative ratio
     * @param {number} ratio - The target ratio.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */ zoom: function zoom(ratio, _originalEvent) {
            var canvasData = this.canvasData;
            ratio = Number(ratio);
            if (ratio < 0) ratio = 1 / (1 - ratio);
            else ratio = 1 + ratio;
            return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
        },
        /**
     * Zoom the canvas to an absolute ratio
     * @param {number} ratio - The target ratio.
     * @param {Object} pivot - The zoom pivot point coordinate.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */ zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
            var options = this.options, canvasData = this.canvasData;
            var width = canvasData.width, height = canvasData.height, naturalWidth = canvasData.naturalWidth, naturalHeight = canvasData.naturalHeight;
            ratio = Number(ratio);
            if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
                var newWidth = naturalWidth * ratio;
                var newHeight = naturalHeight * ratio;
                if (dispatchEvent(this.element, EVENT_ZOOM, {
                    ratio: ratio,
                    oldRatio: width / naturalWidth,
                    originalEvent: _originalEvent
                }) === false) return this;
                if (_originalEvent) {
                    var pointers = this.pointers;
                    var offset = getOffset(this.cropper);
                    var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
                        pageX: _originalEvent.pageX,
                        pageY: _originalEvent.pageY
                    };
                    // Zoom from the triggering point of the event
                    canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
                    canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
                } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
                    canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
                    canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
                } else {
                    // Zoom from the center of the canvas
                    canvasData.left -= (newWidth - width) / 2;
                    canvasData.top -= (newHeight - height) / 2;
                }
                canvasData.width = newWidth;
                canvasData.height = newHeight;
                this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Rotate the canvas with a relative degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */ rotate: function rotate(degree) {
            return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
        },
        /**
     * Rotate the canvas to an absolute degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */ rotateTo: function rotateTo(degree) {
            degree = Number(degree);
            if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
                this.imageData.rotate = degree % 360;
                this.renderCanvas(true, true);
            }
            return this;
        },
        /**
     * Scale the image on the x-axis.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @returns {Cropper} this
     */ scaleX: function scaleX(_scaleX) {
            var scaleY = this.imageData.scaleY;
            return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
        },
        /**
     * Scale the image on the y-axis.
     * @param {number} scaleY - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */ scaleY: function scaleY(_scaleY) {
            var scaleX = this.imageData.scaleX;
            return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
        },
        /**
     * Scale the image
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */ scale: function scale(scaleX) {
            var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
            var imageData = this.imageData;
            var transformed = false;
            scaleX = Number(scaleX);
            scaleY = Number(scaleY);
            if (this.ready && !this.disabled && this.options.scalable) {
                if (isNumber(scaleX)) {
                    imageData.scaleX = scaleX;
                    transformed = true;
                }
                if (isNumber(scaleY)) {
                    imageData.scaleY = scaleY;
                    transformed = true;
                }
                if (transformed) this.renderCanvas(true, true);
            }
            return this;
        },
        /**
     * Get the cropped area position and size data (base on the original image)
     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
     * @returns {Object} The result cropped data.
     */ getData: function getData() {
            var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var options = this.options, imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var data;
            if (this.ready && this.cropped) {
                data = {
                    x: cropBoxData.left - canvasData.left,
                    y: cropBoxData.top - canvasData.top,
                    width: cropBoxData.width,
                    height: cropBoxData.height
                };
                var ratio = imageData.width / imageData.naturalWidth;
                forEach(data, function(n, i) {
                    data[i] = n / ratio;
                });
                if (rounded) {
                    // In case rounding off leads to extra 1px in right or bottom border
                    // we should round the top-left corner and the dimension (#343).
                    var bottom = Math.round(data.y + data.height);
                    var right = Math.round(data.x + data.width);
                    data.x = Math.round(data.x);
                    data.y = Math.round(data.y);
                    data.width = right - data.x;
                    data.height = bottom - data.y;
                }
            } else data = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            };
            if (options.rotatable) data.rotate = imageData.rotate || 0;
            if (options.scalable) {
                data.scaleX = imageData.scaleX || 1;
                data.scaleY = imageData.scaleY || 1;
            }
            return data;
        },
        /**
     * Set the cropped area position and size with new data
     * @param {Object} data - The new data.
     * @returns {Cropper} this
     */ setData: function setData(data) {
            var options = this.options, imageData = this.imageData, canvasData = this.canvasData;
            var cropBoxData = {};
            if (this.ready && !this.disabled && isPlainObject(data)) {
                var transformed = false;
                if (options.rotatable) {
                    if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
                        imageData.rotate = data.rotate;
                        transformed = true;
                    }
                }
                if (options.scalable) {
                    if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
                        imageData.scaleX = data.scaleX;
                        transformed = true;
                    }
                    if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
                        imageData.scaleY = data.scaleY;
                        transformed = true;
                    }
                }
                if (transformed) this.renderCanvas(true, true);
                var ratio = imageData.width / imageData.naturalWidth;
                if (isNumber(data.x)) cropBoxData.left = data.x * ratio + canvasData.left;
                if (isNumber(data.y)) cropBoxData.top = data.y * ratio + canvasData.top;
                if (isNumber(data.width)) cropBoxData.width = data.width * ratio;
                if (isNumber(data.height)) cropBoxData.height = data.height * ratio;
                this.setCropBoxData(cropBoxData);
            }
            return this;
        },
        /**
     * Get the container size data.
     * @returns {Object} The result container data.
     */ getContainerData: function getContainerData() {
            return this.ready ? assign({}, this.containerData) : {};
        },
        /**
     * Get the image position and size data.
     * @returns {Object} The result image data.
     */ getImageData: function getImageData() {
            return this.sized ? assign({}, this.imageData) : {};
        },
        /**
     * Get the canvas position and size data.
     * @returns {Object} The result canvas data.
     */ getCanvasData: function getCanvasData() {
            var canvasData = this.canvasData;
            var data = {};
            if (this.ready) forEach([
                'left',
                'top',
                'width',
                'height',
                'naturalWidth',
                'naturalHeight'
            ], function(n) {
                data[n] = canvasData[n];
            });
            return data;
        },
        /**
     * Set the canvas position and size with new data.
     * @param {Object} data - The new canvas data.
     * @returns {Cropper} this
     */ setCanvasData: function setCanvasData(data) {
            var canvasData = this.canvasData;
            var aspectRatio = canvasData.aspectRatio;
            if (this.ready && !this.disabled && isPlainObject(data)) {
                if (isNumber(data.left)) canvasData.left = data.left;
                if (isNumber(data.top)) canvasData.top = data.top;
                if (isNumber(data.width)) {
                    canvasData.width = data.width;
                    canvasData.height = data.width / aspectRatio;
                } else if (isNumber(data.height)) {
                    canvasData.height = data.height;
                    canvasData.width = data.height * aspectRatio;
                }
                this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Get the crop box position and size data.
     * @returns {Object} The result crop box data.
     */ getCropBoxData: function getCropBoxData() {
            var cropBoxData = this.cropBoxData;
            var data;
            if (this.ready && this.cropped) data = {
                left: cropBoxData.left,
                top: cropBoxData.top,
                width: cropBoxData.width,
                height: cropBoxData.height
            };
            return data || {};
        },
        /**
     * Set the crop box position and size with new data.
     * @param {Object} data - The new crop box data.
     * @returns {Cropper} this
     */ setCropBoxData: function setCropBoxData(data) {
            var cropBoxData = this.cropBoxData;
            var aspectRatio = this.options.aspectRatio;
            var widthChanged;
            var heightChanged;
            if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
                if (isNumber(data.left)) cropBoxData.left = data.left;
                if (isNumber(data.top)) cropBoxData.top = data.top;
                if (isNumber(data.width) && data.width !== cropBoxData.width) {
                    widthChanged = true;
                    cropBoxData.width = data.width;
                }
                if (isNumber(data.height) && data.height !== cropBoxData.height) {
                    heightChanged = true;
                    cropBoxData.height = data.height;
                }
                if (aspectRatio) {
                    if (widthChanged) cropBoxData.height = cropBoxData.width / aspectRatio;
                    else if (heightChanged) cropBoxData.width = cropBoxData.height * aspectRatio;
                }
                this.renderCropBox();
            }
            return this;
        },
        /**
     * Get a canvas drawn the cropped image.
     * @param {Object} [options={}] - The config options.
     * @returns {HTMLCanvasElement} - The result canvas.
     */ getCroppedCanvas: function getCroppedCanvas() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (!this.ready || !window.HTMLCanvasElement) return null;
            var canvasData = this.canvasData;
            var source = getSourceCanvas(this.image, this.imageData, canvasData, options);
            // Returns the source canvas if it is not cropped.
            if (!this.cropped) return source;
            var _this$getData = this.getData(options.rounded), initialX = _this$getData.x, initialY = _this$getData.y, initialWidth = _this$getData.width, initialHeight = _this$getData.height;
            var ratio = source.width / Math.floor(canvasData.naturalWidth);
            if (ratio !== 1) {
                initialX *= ratio;
                initialY *= ratio;
                initialWidth *= ratio;
                initialHeight *= ratio;
            }
            var aspectRatio = initialWidth / initialHeight;
            var maxSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.maxWidth || Infinity,
                height: options.maxHeight || Infinity
            });
            var minSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.minWidth || 0,
                height: options.minHeight || 0
            }, 'cover');
            var _getAdjustedSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.width || (ratio !== 1 ? source.width : initialWidth),
                height: options.height || (ratio !== 1 ? source.height : initialHeight)
            }), width = _getAdjustedSizes.width, height = _getAdjustedSizes.height;
            width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
            height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            canvas.width = normalizeDecimalNumber(width);
            canvas.height = normalizeDecimalNumber(height);
            context.fillStyle = options.fillColor || 'transparent';
            context.fillRect(0, 0, width, height);
            var _options$imageSmoothi = options.imageSmoothingEnabled, imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi, imageSmoothingQuality = options.imageSmoothingQuality;
            context.imageSmoothingEnabled = imageSmoothingEnabled;
            if (imageSmoothingQuality) context.imageSmoothingQuality = imageSmoothingQuality;
            // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage
            var sourceWidth = source.width;
            var sourceHeight = source.height;
            // Source canvas parameters
            var srcX = initialX;
            var srcY = initialY;
            var srcWidth;
            var srcHeight;
            // Destination canvas parameters
            var dstX;
            var dstY;
            var dstWidth;
            var dstHeight;
            if (srcX <= -initialWidth || srcX > sourceWidth) {
                srcX = 0;
                srcWidth = 0;
                dstX = 0;
                dstWidth = 0;
            } else if (srcX <= 0) {
                dstX = -srcX;
                srcX = 0;
                srcWidth = Math.min(sourceWidth, initialWidth + srcX);
                dstWidth = srcWidth;
            } else if (srcX <= sourceWidth) {
                dstX = 0;
                srcWidth = Math.min(initialWidth, sourceWidth - srcX);
                dstWidth = srcWidth;
            }
            if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
                srcY = 0;
                srcHeight = 0;
                dstY = 0;
                dstHeight = 0;
            } else if (srcY <= 0) {
                dstY = -srcY;
                srcY = 0;
                srcHeight = Math.min(sourceHeight, initialHeight + srcY);
                dstHeight = srcHeight;
            } else if (srcY <= sourceHeight) {
                dstY = 0;
                srcHeight = Math.min(initialHeight, sourceHeight - srcY);
                dstHeight = srcHeight;
            }
            var params = [
                srcX,
                srcY,
                srcWidth,
                srcHeight
            ];
            // Avoid "IndexSizeError"
            if (dstWidth > 0 && dstHeight > 0) {
                var scale = width / initialWidth;
                params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
            }
            // All the numerical parameters should be integer for `drawImage`
            // https://github.com/fengyuanchen/cropper/issues/476
            context.drawImage.apply(context, [
                source
            ].concat(_toConsumableArray(params.map(function(param) {
                return Math.floor(normalizeDecimalNumber(param));
            }))));
            return canvas;
        },
        /**
     * Change the aspect ratio of the crop box.
     * @param {number} aspectRatio - The new aspect ratio.
     * @returns {Cropper} this
     */ setAspectRatio: function setAspectRatio(aspectRatio) {
            var options = this.options;
            if (!this.disabled && !isUndefined(aspectRatio)) {
                // 0 -> NaN
                options.aspectRatio = Math.max(0, aspectRatio) || NaN;
                if (this.ready) {
                    this.initCropBox();
                    if (this.cropped) this.renderCropBox();
                }
            }
            return this;
        },
        /**
     * Change the drag mode.
     * @param {string} mode - The new drag mode.
     * @returns {Cropper} this
     */ setDragMode: function setDragMode(mode) {
            var options = this.options, dragBox = this.dragBox, face = this.face;
            if (this.ready && !this.disabled) {
                var croppable = mode === DRAG_MODE_CROP;
                var movable = options.movable && mode === DRAG_MODE_MOVE;
                mode = croppable || movable ? mode : DRAG_MODE_NONE;
                options.dragMode = mode;
                setData(dragBox, DATA_ACTION, mode);
                toggleClass(dragBox, CLASS_CROP, croppable);
                toggleClass(dragBox, CLASS_MOVE, movable);
                if (!options.cropBoxMovable) {
                    // Sync drag mode to crop box when it is not movable
                    setData(face, DATA_ACTION, mode);
                    toggleClass(face, CLASS_CROP, croppable);
                    toggleClass(face, CLASS_MOVE, movable);
                }
            }
            return this;
        }
    };
    var AnotherCropper = WINDOW.Cropper;
    var Cropper = /*#__PURE__*/ function() {
        /**
     * Create a new Cropper.
     * @param {Element} element - The target element for cropping.
     * @param {Object} [options={}] - The configuration options.
     */ function Cropper(element) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            _classCallCheck(this, Cropper);
            if (!element || !REGEXP_TAG_NAME.test(element.tagName)) throw new Error('The first argument is required and must be an <img> or <canvas> element.');
            this.element = element;
            this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
            this.cropped = false;
            this.disabled = false;
            this.pointers = {};
            this.ready = false;
            this.reloading = false;
            this.replaced = false;
            this.sized = false;
            this.sizing = false;
            this.init();
        }
        return _createClass(Cropper, [
            {
                key: "init",
                value: function init() {
                    var element = this.element;
                    var tagName = element.tagName.toLowerCase();
                    var url;
                    if (element[NAMESPACE]) return;
                    element[NAMESPACE] = this;
                    if (tagName === 'img') {
                        this.isImg = true;
                        // e.g.: "img/picture.jpg"
                        url = element.getAttribute('src') || '';
                        this.originalUrl = url;
                        // Stop when it's a blank image
                        if (!url) return;
                        // e.g.: "https://example.com/img/picture.jpg"
                        url = element.src;
                    } else if (tagName === 'canvas' && window.HTMLCanvasElement) url = element.toDataURL();
                    this.load(url);
                }
            },
            {
                key: "load",
                value: function load(url) {
                    var _this = this;
                    if (!url) return;
                    this.url = url;
                    this.imageData = {};
                    var element = this.element, options = this.options;
                    if (!options.rotatable && !options.scalable) options.checkOrientation = false;
                    // Only IE10+ supports Typed Arrays
                    if (!options.checkOrientation || !window.ArrayBuffer) {
                        this.clone();
                        return;
                    }
                    // Detect the mime type of the image directly if it is a Data URL
                    if (REGEXP_DATA_URL.test(url)) {
                        // Read ArrayBuffer from Data URL of JPEG images directly for better performance
                        if (REGEXP_DATA_URL_JPEG.test(url)) this.read(dataURLToArrayBuffer(url));
                        else // Only a JPEG image may contains Exif Orientation information,
                        // the rest types of Data URLs are not necessary to check orientation at all.
                        this.clone();
                        return;
                    }
                    // 1. Detect the mime type of the image by a XMLHttpRequest.
                    // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.
                    var xhr = new XMLHttpRequest();
                    var clone = this.clone.bind(this);
                    this.reloading = true;
                    this.xhr = xhr;
                    // 1. Cross origin requests are only supported for protocol schemes:
                    // http, https, data, chrome, chrome-extension.
                    // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
                    // in some browsers as IE11 and Safari.
                    xhr.onabort = clone;
                    xhr.onerror = clone;
                    xhr.ontimeout = clone;
                    xhr.onprogress = function() {
                        // Abort the request directly if it not a JPEG image for better performance
                        if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) xhr.abort();
                    };
                    xhr.onload = function() {
                        _this.read(xhr.response);
                    };
                    xhr.onloadend = function() {
                        _this.reloading = false;
                        _this.xhr = null;
                    };
                    // Bust cache when there is a "crossOrigin" property to avoid browser cache error
                    if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) url = addTimestamp(url);
                    // The third parameter is required for avoiding side-effect (#682)
                    xhr.open('GET', url, true);
                    xhr.responseType = 'arraybuffer';
                    xhr.withCredentials = element.crossOrigin === 'use-credentials';
                    xhr.send();
                }
            },
            {
                key: "read",
                value: function read(arrayBuffer) {
                    var options = this.options, imageData = this.imageData;
                    // Reset the orientation value to its default value 1
                    // as some iOS browsers will render image with its orientation
                    var orientation = resetAndGetOrientation(arrayBuffer);
                    var rotate = 0;
                    var scaleX = 1;
                    var scaleY = 1;
                    if (orientation > 1) {
                        // Generate a new URL which has the default orientation value
                        this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);
                        var _parseOrientation = parseOrientation(orientation);
                        rotate = _parseOrientation.rotate;
                        scaleX = _parseOrientation.scaleX;
                        scaleY = _parseOrientation.scaleY;
                    }
                    if (options.rotatable) imageData.rotate = rotate;
                    if (options.scalable) {
                        imageData.scaleX = scaleX;
                        imageData.scaleY = scaleY;
                    }
                    this.clone();
                }
            },
            {
                key: "clone",
                value: function clone() {
                    var element = this.element, url = this.url;
                    var crossOrigin = element.crossOrigin;
                    var crossOriginUrl = url;
                    if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
                        if (!crossOrigin) crossOrigin = 'anonymous';
                        // Bust cache when there is not a "crossOrigin" property (#519)
                        crossOriginUrl = addTimestamp(url);
                    }
                    this.crossOrigin = crossOrigin;
                    this.crossOriginUrl = crossOriginUrl;
                    var image = document.createElement('img');
                    if (crossOrigin) image.crossOrigin = crossOrigin;
                    image.src = crossOriginUrl || url;
                    image.alt = element.alt || 'The image to crop';
                    this.image = image;
                    image.onload = this.start.bind(this);
                    image.onerror = this.stop.bind(this);
                    addClass(image, CLASS_HIDE);
                    element.parentNode.insertBefore(image, element.nextSibling);
                }
            },
            {
                key: "start",
                value: function start() {
                    var _this2 = this;
                    var image = this.image;
                    image.onload = null;
                    image.onerror = null;
                    this.sizing = true;
                    // Match all browsers that use WebKit as the layout engine in iOS devices,
                    // such as Safari for iOS, Chrome for iOS, and in-app browsers.
                    var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);
                    var done = function done(naturalWidth, naturalHeight) {
                        assign(_this2.imageData, {
                            naturalWidth: naturalWidth,
                            naturalHeight: naturalHeight,
                            aspectRatio: naturalWidth / naturalHeight
                        });
                        _this2.initialImageData = assign({}, _this2.imageData);
                        _this2.sizing = false;
                        _this2.sized = true;
                        _this2.build();
                    };
                    // Most modern browsers (excepts iOS WebKit)
                    if (image.naturalWidth && !isIOSWebKit) {
                        done(image.naturalWidth, image.naturalHeight);
                        return;
                    }
                    var sizingImage = document.createElement('img');
                    var body = document.body || document.documentElement;
                    this.sizingImage = sizingImage;
                    sizingImage.onload = function() {
                        done(sizingImage.width, sizingImage.height);
                        if (!isIOSWebKit) body.removeChild(sizingImage);
                    };
                    sizingImage.src = image.src;
                    // iOS WebKit will convert the image automatically
                    // with its orientation once append it into DOM (#279)
                    if (!isIOSWebKit) {
                        sizingImage.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;";
                        body.appendChild(sizingImage);
                    }
                }
            },
            {
                key: "stop",
                value: function stop() {
                    var image = this.image;
                    image.onload = null;
                    image.onerror = null;
                    image.parentNode.removeChild(image);
                    this.image = null;
                }
            },
            {
                key: "build",
                value: function build() {
                    if (!this.sized || this.ready) return;
                    var element = this.element, options = this.options, image = this.image;
                    // Create cropper elements
                    var container = element.parentNode;
                    var template = document.createElement('div');
                    template.innerHTML = TEMPLATE;
                    var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
                    var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
                    var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
                    var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
                    var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
                    this.container = container;
                    this.cropper = cropper;
                    this.canvas = canvas;
                    this.dragBox = dragBox;
                    this.cropBox = cropBox;
                    this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
                    this.face = face;
                    canvas.appendChild(image);
                    // Hide the original image
                    addClass(element, CLASS_HIDDEN);
                    // Inserts the cropper after to the current image
                    container.insertBefore(cropper, element.nextSibling);
                    // Show the hidden image
                    removeClass(image, CLASS_HIDE);
                    this.initPreview();
                    this.bind();
                    options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
                    options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
                    options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
                    addClass(cropBox, CLASS_HIDDEN);
                    if (!options.guides) addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
                    if (!options.center) addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
                    if (options.background) addClass(cropper, "".concat(NAMESPACE, "-bg"));
                    if (!options.highlight) addClass(face, CLASS_INVISIBLE);
                    if (options.cropBoxMovable) {
                        addClass(face, CLASS_MOVE);
                        setData(face, DATA_ACTION, ACTION_ALL);
                    }
                    if (!options.cropBoxResizable) {
                        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
                        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
                    }
                    this.render();
                    this.ready = true;
                    this.setDragMode(options.dragMode);
                    if (options.autoCrop) this.crop();
                    this.setData(options.data);
                    if (isFunction(options.ready)) addListener(element, EVENT_READY, options.ready, {
                        once: true
                    });
                    dispatchEvent(element, EVENT_READY);
                }
            },
            {
                key: "unbuild",
                value: function unbuild() {
                    if (!this.ready) return;
                    this.ready = false;
                    this.unbind();
                    this.resetPreview();
                    var parentNode = this.cropper.parentNode;
                    if (parentNode) parentNode.removeChild(this.cropper);
                    removeClass(this.element, CLASS_HIDDEN);
                }
            },
            {
                key: "uncreate",
                value: function uncreate() {
                    if (this.ready) {
                        this.unbuild();
                        this.ready = false;
                        this.cropped = false;
                    } else if (this.sizing) {
                        this.sizingImage.onload = null;
                        this.sizing = false;
                        this.sized = false;
                    } else if (this.reloading) {
                        this.xhr.onabort = null;
                        this.xhr.abort();
                    } else if (this.image) this.stop();
                }
            }
        ], [
            {
                key: "noConflict",
                value: function noConflict() {
                    window.Cropper = AnotherCropper;
                    return Cropper;
                }
            },
            {
                key: "setDefaults",
                value: function setDefaults(options) {
                    assign(DEFAULTS, isPlainObject(options) && options);
                }
            }
        ]);
    }();
    assign(Cropper.prototype, render, preview, events, handlers, change, methods);
    return Cropper;
});


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $1363aa40f897f638$var$__assign = function() {
    $1363aa40f897f638$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1363aa40f897f638$var$__assign.apply(this, arguments);
};
function $1363aa40f897f638$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $1363aa40f897f638$var$applyDefaultOptions = function(cropper, options) {
    if (options === void 0) options = {};
    var _a = options.enable, enable = _a === void 0 ? true : _a, _b = options.scaleX, scaleX = _b === void 0 ? 1 : _b, _c = options.scaleY, scaleY = _c === void 0 ? 1 : _c, _d = options.zoomTo, zoomTo = _d === void 0 ? 0 : _d, rotateTo = options.rotateTo;
    enable ? cropper.enable() : cropper.disable();
    cropper.scaleX(scaleX);
    cropper.scaleY(scaleY);
    rotateTo !== undefined && cropper.rotateTo(rotateTo);
    zoomTo > 0 && cropper.zoomTo(zoomTo);
};
/**
 * sourced from: https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd
 */ var $1363aa40f897f638$var$useCombinedRefs = function() {
    var refs = [];
    for(var _i = 0; _i < arguments.length; _i++)refs[_i] = arguments[_i];
    var targetRef = (0, $3OyDL.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useEffect(function() {
        refs.forEach(function(ref) {
            if (!ref) return;
            if (typeof ref === 'function') ref(targetRef.current);
            else ref.current = targetRef.current;
        });
    }, [
        refs
    ]);
    return targetRef;
};
var $1363aa40f897f638$export$71ed2b85d4ca43d3 = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).forwardRef(function(_a, ref) {
    var props = $1363aa40f897f638$var$__rest(_a, []);
    var _b = props.dragMode, dragMode = _b === void 0 ? 'crop' : _b, src = props.src, style = props.style, className = props.className, crossOrigin = props.crossOrigin, scaleX = props.scaleX, scaleY = props.scaleY, enable = props.enable, zoomTo = props.zoomTo, rotateTo = props.rotateTo, _c = props.alt, alt = _c === void 0 ? 'picture' : _c, ready = props.ready, onInitialized = props.onInitialized, rest = $1363aa40f897f638$var$__rest(props, [
        "dragMode",
        "src",
        "style",
        "className",
        "crossOrigin",
        "scaleX",
        "scaleY",
        "enable",
        "zoomTo",
        "rotateTo",
        "alt",
        "ready",
        "onInitialized"
    ]);
    var defaultOptions = {
        scaleY: scaleY,
        scaleX: scaleX,
        enable: enable,
        zoomTo: zoomTo,
        rotateTo: rotateTo
    };
    var innerRef = (0, $3OyDL.useRef)(null);
    var combinedRef = $1363aa40f897f638$var$useCombinedRefs(ref, innerRef);
    /**
     * Invoke zoomTo method when cropper is set and zoomTo prop changes
     */ (0, $3OyDL.useEffect)(function() {
        var _a;
        if (((_a = combinedRef.current) === null || _a === void 0 ? void 0 : _a.cropper) && typeof zoomTo === 'number') combinedRef.current.cropper.zoomTo(zoomTo);
    }, [
        props.zoomTo
    ]);
    /**
     * re-render when src changes
     */ (0, $3OyDL.useEffect)(function() {
        var _a;
        if (((_a = combinedRef.current) === null || _a === void 0 ? void 0 : _a.cropper) && typeof src !== 'undefined') combinedRef.current.cropper.reset().clear().replace(src);
    }, [
        src
    ]);
    (0, $3OyDL.useEffect)(function() {
        if (combinedRef.current !== null) {
            var cropper = new (0, (/*@__PURE__*/$parcel$interopDefault($d02e888071d23636$exports)))(combinedRef.current, $1363aa40f897f638$var$__assign($1363aa40f897f638$var$__assign({
                dragMode: dragMode
            }, rest), {
                ready: function(e) {
                    if (e.currentTarget !== null) $1363aa40f897f638$var$applyDefaultOptions(e.currentTarget.cropper, defaultOptions);
                    ready && ready(e);
                }
            }));
            onInitialized && onInitialized(cropper);
        }
        /**
         * destroy cropper on un-mount
         */ return function() {
            var _a, _b;
            (_b = (_a = combinedRef.current) === null || _a === void 0 ? void 0 : _a.cropper) === null || _b === void 0 || _b.destroy();
        };
    }, [
        combinedRef
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement("div", {
        style: style,
        className: className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement("img", {
        crossOrigin: crossOrigin,
        src: src,
        alt: alt,
        style: {
            opacity: 0,
            maxWidth: '100%'
        },
        ref: combinedRef
    }));
});
var $1363aa40f897f638$export$2e2bcd8739ae039 = $1363aa40f897f638$export$71ed2b85d4ca43d3;




var $c391be7c60ca8fb6$exports = {};
"use strict";
"use client";

Object.defineProperty($c391be7c60ca8fb6$exports, "__esModule", {
    value: true
});
$c391be7c60ca8fb6$exports.default = void 0;

var $c391be7c60ca8fb6$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $c391be7c60ca8fb6$var$_default = (0, $c391be7c60ca8fb6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8 2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z"
}), 'PhotoSizeSelectLarge');
$c391be7c60ca8fb6$exports.default = $c391be7c60ca8fb6$var$_default;




var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");


const $c98581141fcf8a16$export$4b13930e2f7acda = (props)=>{
    const [fileUrl, setFileUrl] = (0, $3OyDL.useState)();
    const [file, setFile] = (0, $3OyDL.useState)();
    const [allowImageUpload, setAllowImageUpload] = (0, $3OyDL.useState)(true);
    const [allowVideoUpload, setAllowVideoUpload] = (0, $3OyDL.useState)(true);
    const [allowAdditionalTypes, setAllowAdditionalTypes] = (0, $3OyDL.useState)('');
    (0, $3OyDL.useEffect)(()=>{
        props.allowImageUpload !== undefined && setAllowImageUpload(props.allowImageUpload);
        props.allowVideoUpload !== undefined && setAllowVideoUpload(props.allowVideoUpload);
        props.allowAdditionalTypes && setAllowAdditionalTypes(props.allowAdditionalTypes);
    }, [
        props
    ]);
    (0, $3OyDL.useEffect)(()=>{
        if (file && fileUrl) {
            file.type.includes('image') && props.onImageUpload && props.onImageUpload(fileUrl, file);
            file.type.includes('video') && props.onVideoUpload && props.onVideoUpload(fileUrl, file);
            props.onFileUpload && props.onFileUpload(fileUrl, file) // Control what Files can be sent here via the allowAditionalTypes property
            ;
        }
    }, [
        fileUrl,
        file
    ]);
    const onChange = (e)=>{
        e.preventDefault();
        let files;
        if (e.dataTransfer) files = e.dataTransfer.files;
        else if (e.target) files = e.target.files;
        setFile(files[0]);
        const reader = new FileReader();
        reader.onload = ()=>{
            setFileUrl(reader.result);
        };
        reader.readAsDataURL(files[0]);
    };
    const hiddenFileInput = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useRef(null);
    const handleClick = ()=>{
        hiddenFileInput?.current?.click();
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                color: "primary",
                text: "Neue Datei hochladen",
                onClick: handleClick
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                type: "file",
                ref: hiddenFileInput,
                onInput: onChange,
                style: {
                    display: 'none'
                },
                accept: (allowImageUpload && 'image/* ' || '') + (allowVideoUpload && 'video/* ' || '') + allowAdditionalTypes
            })
        ]
    });
};
var $c98581141fcf8a16$export$2e2bcd8739ae039 = $c98581141fcf8a16$export$4b13930e2f7acda;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");
var $56e4c9099ed61a7a$exports = {};
var $6c8d3b60155cda18$exports = {};
function $6c8d3b60155cda18$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$6c8d3b60155cda18$exports = $6c8d3b60155cda18$var$_arrayWithHoles, $6c8d3b60155cda18$exports.__esModule = true, $6c8d3b60155cda18$exports["default"] = $6c8d3b60155cda18$exports;


var $8008c35ee3ed433b$exports = {};
function $8008c35ee3ed433b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$8008c35ee3ed433b$exports = $8008c35ee3ed433b$var$_iterableToArrayLimit, $8008c35ee3ed433b$exports.__esModule = true, $8008c35ee3ed433b$exports["default"] = $8008c35ee3ed433b$exports;


var $093d7a0cd4718719$exports = {};
var $28e2c9267c1e27c9$exports = {};
function $28e2c9267c1e27c9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$28e2c9267c1e27c9$exports = $28e2c9267c1e27c9$var$_arrayLikeToArray, $28e2c9267c1e27c9$exports.__esModule = true, $28e2c9267c1e27c9$exports["default"] = $28e2c9267c1e27c9$exports;


function $093d7a0cd4718719$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $28e2c9267c1e27c9$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $28e2c9267c1e27c9$exports(r, a) : void 0;
    }
}
$093d7a0cd4718719$exports = $093d7a0cd4718719$var$_unsupportedIterableToArray, $093d7a0cd4718719$exports.__esModule = true, $093d7a0cd4718719$exports["default"] = $093d7a0cd4718719$exports;


var $0dda1f2335ddb56b$exports = {};
function $0dda1f2335ddb56b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$0dda1f2335ddb56b$exports = $0dda1f2335ddb56b$var$_nonIterableRest, $0dda1f2335ddb56b$exports.__esModule = true, $0dda1f2335ddb56b$exports["default"] = $0dda1f2335ddb56b$exports;


function $56e4c9099ed61a7a$var$_slicedToArray(r, e) {
    return $6c8d3b60155cda18$exports(r) || $8008c35ee3ed433b$exports(r, e) || $093d7a0cd4718719$exports(r, e) || $0dda1f2335ddb56b$exports();
}
$56e4c9099ed61a7a$exports = $56e4c9099ed61a7a$var$_slicedToArray, $56e4c9099ed61a7a$exports.__esModule = true, $56e4c9099ed61a7a$exports["default"] = $56e4c9099ed61a7a$exports;




var $3OyDL = parcelRequire("3OyDL");

function $07bad33897b9e6b0$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $07bad33897b9e6b0$var$alreadyWarned = {};
function $07bad33897b9e6b0$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && $07bad33897b9e6b0$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') $07bad33897b9e6b0$var$alreadyWarned[args[0]] = new Date();
    $07bad33897b9e6b0$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $07bad33897b9e6b0$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    });
}
function $07bad33897b9e6b0$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $07bad33897b9e6b0$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $07bad33897b9e6b0$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}


function $ead5e217b39556c6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ead5e217b39556c6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ead5e217b39556c6$var$ownKeys(source, true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($46d6e0f6ddaa3991$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ead5e217b39556c6$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ead5e217b39556c6$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $3OyDL.useContext)((0, $fc39639f6f9b74a5$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $fc39639f6f9b74a5$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $fc39639f6f9b74a5$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $07bad33897b9e6b0$export$5b28268982f175ba)('You will need pass in an i18next instance by using initReactI18next');
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    var i18nOptions = $ead5e217b39556c6$var$_objectSpread({}, (0, $fc39639f6f9b74a5$export$212bb2fc580a90a8)(), {}, i18n.options.react, {}, props);
    var useSuspense = i18nOptions.useSuspense;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $07bad33897b9e6b0$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return {
            t: i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0])
        };
    }
    var _useState = (0, $3OyDL.useState)(getT()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($56e4c9099ed61a7a$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var isMounted = (0, $3OyDL.useRef)(true);
    (0, $3OyDL.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $07bad33897b9e6b0$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT());
        });
        function boundReset() {
            if (isMounted.current) setT(getT());
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        namespaces.join()
    ]);
    var ret = [
        t.t,
        i18n,
        ready
    ];
    ret.t = t.t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $07bad33897b9e6b0$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT());
            resolve();
        });
    });
}



var $c677c753a54bdfd8$exports = {};
"use strict";
"use client";

Object.defineProperty($c677c753a54bdfd8$exports, "__esModule", {
    value: true
});
$c677c753a54bdfd8$exports.default = void 0;

var $c677c753a54bdfd8$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $c677c753a54bdfd8$var$_default = (0, $c677c753a54bdfd8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
$c677c753a54bdfd8$exports.default = $c677c753a54bdfd8$var$_default;


var $90598b9d425796f0$exports = {};
"use strict";
"use client";

Object.defineProperty($90598b9d425796f0$exports, "__esModule", {
    value: true
});
$90598b9d425796f0$exports.default = void 0;

var $90598b9d425796f0$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $90598b9d425796f0$var$_default = (0, $90598b9d425796f0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
}), 'VisibilityRounded');
$90598b9d425796f0$exports.default = $90598b9d425796f0$var$_default;






var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");


var $181c16a327d4d403$exports = {};
"use strict";
"use client";

Object.defineProperty($181c16a327d4d403$exports, "__esModule", {
    value: true
});
$181c16a327d4d403$exports.default = void 0;

var $181c16a327d4d403$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $181c16a327d4d403$var$_default = (0, $181c16a327d4d403$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm4.3 14.3c-.39.39-1.02.39-1.41 0L12 13.41 9.11 16.3c-.39.39-1.02.39-1.41 0a.9959.9959 0 0 1 0-1.41L10.59 12 7.7 9.11a.9959.9959 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L12 10.59l2.89-2.89c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L13.41 12l2.89 2.89c.38.38.38 1.02 0 1.41z"
}), 'CancelRounded');
$181c16a327d4d403$exports.default = $181c16a327d4d403$var$_default;


const $3a79eb8c7ee58034$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: '0',
            height: '100vh',
            width: '100vw',
            backgroundColor: 'rgba(0,0,0,0.2)',
            cursor: 'pointer',
            zIndex: 100,
            [theme.breakpoints.up('md')]: {
                top: 0,
                height: '100vh'
            }
        },
        paper: {
            width: '100%',
            padding: theme.spacing(5)
        },
        wrapper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        image: {
            maxHeight: '75vh',
            maxWidth: '90vw',
            borderRadius: theme.spacing(4),
            [theme.breakpoints.up('md')]: {
                maxHeight: '85vh'
            }
        },
        grid: {
            width: '90vw',
            maxWidth: '1000px',
            height: '75vh',
            maxHeight: '620px',
            [theme.breakpoints.up('md')]: {
                height: '85vh'
            }
        },
        closeIcon: {
            alignSelf: 'flex-end',
            color: '#fff',
            marginRight: '-30px'
        },
        embedResponsive: {
            borderRadius: theme.spacing(4),
            position: 'relative',
            display: 'block',
            width: '90vw',
            padding: '56.25% 0 0 0',
            overflow: 'hidden',
            [theme.breakpoints.up('md')]: {
                width: '60vw'
            }
        },
        embedResponsiveItem: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0
        },
        disabled: {
            pointerEvents: 'none'
        }
    }));
const $3a79eb8c7ee58034$var$LightBox = (props)=>{
    const { isOpenParent: isOpenParent, setOpenParent: setOpenParent, payload: payload, src: src, children: children, videoSrc: videoSrc, alt: alt } = props;
    const [isOpen, setIsOpen] = (0, $3OyDL.useState)(false);
    const classes = $3a79eb8c7ee58034$var$useStyles();
    (0, $3OyDL.useEffect)(()=>{
        setOpenParent && setIsOpen(false);
    }, [
        isOpenParent
    ]);
    const toggleIsOpen = (event)=>{
        setIsOpen(!isOpen);
    };
    const videoImage = src ? `<style>*{padding:0margin:0overflow:hidden}html,body{height:100%}img,span{position:absolutewidth:100%top:0bottom:0margin:auto}span{height:1.5emtext-align:centerfont:48px/1.5 sans-serifcolor:whitetext-shadow:0 0 0.5em black}</style><a href=${videoSrc}><img src=${src} alt=''/><span>\u{25B6}</span></a>` : `<style>*{padding:0margin:0overflow:hidden}html,body{height:100%}img,span{position:absolutewidth:100%top:0bottom:0margin:auto}div{position:relativeheight:100%width:100%background-color: #eeeeee}span{height:1.5emtext-align:centerfont:48px/1.5 sans-serifcolor:whitetext-shadow:0 0 0.5em black}</style><a href=${videoSrc}><div><div/><span>\u{25B6}</span></a>`;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: props.disabled ? classes.disabled : undefined,
        onClick: toggleIsOpen,
        children: [
            children,
            isOpen ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                children: /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                    className: classes.container,
                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: classes.wrapper,
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                className: `${classes.closeIcon}`,
                                color: "default",
                                component: "div",
                                onClick: toggleIsOpen,
                                size: "large",
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($181c16a327d4d403$exports))), {})
                            }),
                            src && !videoSrc && /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                src: src,
                                alt: alt,
                                className: classes.image,
                                onClick: (e)=>e.stopPropagation()
                            }),
                            videoSrc && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                className: classes.embedResponsive,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("iframe", {
                                    id: "",
                                    style: {},
                                    className: classes.embedResponsiveItem,
                                    allow: "autoplay clipboard-write encrypted-media picture-in-picture web-share",
                                    srcDoc: videoImage,
                                    allowFullScreen: true,
                                    onClick: (e)=>e.stopPropagation()
                                })
                            }),
                            payload && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    container: true,
                                    className: classes.grid,
                                    onClick: (e)=>e.stopPropagation(),
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
                                            className: classes.paper,
                                            children: payload
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            }) : null
        ]
    });
};
var $3a79eb8c7ee58034$export$2e2bcd8739ae039 = $3a79eb8c7ee58034$var$LightBox;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $e9cd4ed05f3fe469$var$VideoComponent = ({ fallbackThumb: fallbackThumb, type: type, src: src, ...props })=>{
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: src ? /*#__PURE__*/ (0, $2M70Q.jsx)("video", {
            width: props.width || '300px',
            height: props.height || 'auto',
            src: src
        }) : fallbackThumb && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8e6251e768e64172$export$2e2bcd8739ae039), {
            fallback: fallbackThumb
        })
    });
};
var $e9cd4ed05f3fe469$export$2e2bcd8739ae039 = $e9cd4ed05f3fe469$var$VideoComponent;



const $66c81be31df2ca93$var$MediaPreview = (props)=>{
    const isViewRow = props.view === 'row';
    const previewFormat = props.previewFormat || (0, $c7fa01100a96d1f7$export$4e872ec0b227b4b6).square;
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            button: {
                fontWeight: 700,
                textTransform: 'initial',
                padding: '4px 8px',
                marginRight: '20px',
                justifyContent: props.showAsPopUp ? 'center' : 'left',
                marginTop: isViewRow ? '' : '10px'
            },
            image: {
                position: 'relative',
                objectFit: 'cover',
                height: previewFormat === (0, $c7fa01100a96d1f7$export$4e872ec0b227b4b6).square ? '105px' : '120px',
                width: isViewRow ? previewFormat === (0, $c7fa01100a96d1f7$export$4e872ec0b227b4b6).square ? '105px' : 'auto' : '100%',
                zIndex: 0
            },
            video: {
                position: 'relative',
                objectFit: 'cover',
                height: previewFormat === (0, $c7fa01100a96d1f7$export$4e872ec0b227b4b6).square ? '105px' : '120px',
                width: isViewRow ? previewFormat === (0, $c7fa01100a96d1f7$export$4e872ec0b227b4b6).square ? '105px' : 'auto' : '100%',
                zIndex: 0
            },
            fileBlock: {
                display: 'flex',
                flexDirection: isViewRow ? 'row' : 'column',
                justifyContent: 'flex-start'
            },
            imageProperties: {
                display: 'flex',
                flexDirection: isViewRow ? 'column' : 'row',
                justifyContent: 'center',
                marginLeft: theme.spacing(2.5)
            }
        }));
    const classes = useStyles();
    const { t: t } = (0, $ead5e217b39556c6$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
        className: classes.fileBlock,
        children: [
            props.src && (props.type === 'image' || props.type === undefined) && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8e6251e768e64172$export$2e2bcd8739ae039), {
                src: props.src,
                fallback: "/src/shared/assets/images/icon-img-placeholder.svg",
                className: classes.image,
                alt: ""
            }),
            props.src && props.type === 'video' && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e9cd4ed05f3fe469$export$2e2bcd8739ae039), {
                className: classes.video,
                fallbackThumb: undefined,
                src: props.src
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                className: classes.imageProperties,
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 2,
                    alignItems: "flex-start",
                    children: [
                        isViewRow ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3a79eb8c7ee58034$export$2e2bcd8739ae039), {
                                src: props.type !== 'video' ? props.src : undefined,
                                videoSrc: props.type === 'video' ? props.src : undefined,
                                disabled: !props.src,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    className: classes.button,
                                    startIcon: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90598b9d425796f0$exports))), {}),
                                    variant: "text",
                                    color: "info",
                                    disabled: !props.src,
                                    text: t('postingCommon:preview'),
                                    fullWidth: true
                                })
                            })
                        }) : null,
                        props.deleteMediaFile && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                className: classes.button,
                                variant: "text",
                                color: "info",
                                onClick: props.deleteMediaFile && props.deleteMediaFile,
                                startIcon: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c677c753a54bdfd8$exports))), {}),
                                disabled: !props.src,
                                text: t(isViewRow ? 'postingCommon:deleteMediaFile' : 'postingCommon:deleteLink'),
                                fullWidth: true
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $66c81be31df2ca93$export$2e2bcd8739ae039 = $66c81be31df2ca93$var$MediaPreview;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $hDCOm = parcelRequire("hDCOm");

var $g4LX8 = parcelRequire("g4LX8");

var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $7c6bd76525b616b3$export$29cad1383b3f235d(slot) {
    return (0, $6AMoU.default)('MuiCircularProgress', slot);
}
const $7c6bd76525b616b3$var$circularProgressClasses = (0, $ithJf.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $7c6bd76525b616b3$export$2e2bcd8739ae039 = $7c6bd76525b616b3$var$circularProgressClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $7e901111c04c1af5$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $7e901111c04c1af5$var$_ = (t)=>t, $7e901111c04c1af5$var$_t, $7e901111c04c1af5$var$_t2, $7e901111c04c1af5$var$_t3, $7e901111c04c1af5$var$_t4;
const $7e901111c04c1af5$var$SIZE = 44;
const $7e901111c04c1af5$var$circularRotateKeyframe = (0, $hDCOm.keyframes)($7e901111c04c1af5$var$_t || ($7e901111c04c1af5$var$_t = $7e901111c04c1af5$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $7e901111c04c1af5$var$circularDashKeyframe = (0, $hDCOm.keyframes)($7e901111c04c1af5$var$_t2 || ($7e901111c04c1af5$var$_t2 = $7e901111c04c1af5$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $7e901111c04c1af5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $g4LX8.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $g4LX8.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $7c6bd76525b616b3$export$29cad1383b3f235d), classes);
};
const $7e901111c04c1af5$var$CircularProgressRoot = (0, $jH1k7.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $g4LX8.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $gOPoC.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $hDCOm.css)($7e901111c04c1af5$var$_t3 || ($7e901111c04c1af5$var$_t3 = $7e901111c04c1af5$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $7e901111c04c1af5$var$circularRotateKeyframe));
const $7e901111c04c1af5$var$CircularProgressSVG = (0, $jH1k7.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $7e901111c04c1af5$var$CircularProgressCircle = (0, $jH1k7.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $g4LX8.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $gOPoC.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $hDCOm.css)($7e901111c04c1af5$var$_t4 || ($7e901111c04c1af5$var$_t4 = $7e901111c04c1af5$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $7e901111c04c1af5$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $7e901111c04c1af5$var$CircularProgress = /*#__PURE__*/ $3OyDL.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $aBenZ.default)(props, $7e901111c04c1af5$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $7e901111c04c1af5$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($7e901111c04c1af5$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $2M70Q.jsx)($7e901111c04c1af5$var$CircularProgressRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        style: (0, $gOPoC.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($7e901111c04c1af5$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$7e901111c04c1af5$var$SIZE / 2} ${$7e901111c04c1af5$var$SIZE / 2} ${$7e901111c04c1af5$var$SIZE} ${$7e901111c04c1af5$var$SIZE}`,
            children: /*#__PURE__*/ (0, $2M70Q.jsx)($7e901111c04c1af5$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $7e901111c04c1af5$var$SIZE,
                cy: $7e901111c04c1af5$var$SIZE,
                r: ($7e901111c04c1af5$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $7e901111c04c1af5$export$2e2bcd8739ae039 = $7e901111c04c1af5$var$CircularProgress;



const $f17f03f9390e11c7$var$Preloader = (props)=>{
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            root: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: props.minHeight ? props.minHeight : '150px',
                width: props.width ? props.width : '100%'
            }
        }));
    const classes = useStyles();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7e901111c04c1af5$export$2e2bcd8739ae039), {
            size: props.size,
            color: props.color,
            thickness: props.thickness
        })
    });
};
var $f17f03f9390e11c7$export$2e2bcd8739ae039 = $f17f03f9390e11c7$var$Preloader;



const $f5ed9f6a9eb1f249$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        space: {
            margin: '0 0 30px 0'
        },
        ratioSelect: {
            width: '100px',
            background: 'rgba(0, 0, 0, 0.6)',
            color: '#FFF',
            borderRadius: theme.spacing(),
            padding: theme.spacing(),
            position: 'absolute',
            left: '75px',
            top: 0,
            zIndex: 100,
            cursor: 'pointer'
        }
    }));
const $f5ed9f6a9eb1f249$var$MediaCropperComponent = (props)=>{
    const classes = $f5ed9f6a9eb1f249$var$useStyles();
    const newImage = props?.newImage || false;
    const previewFormat = props.previewFormat || (0, $c7fa01100a96d1f7$export$4e872ec0b227b4b6).square;
    const [showRatioSelection, setShowRatioSelection] = (0, $3OyDL.useState)(props.openRationSelection || false);
    const [aspectRatio, setAspectRatio] = (0, $3OyDL.useState)(props.aspectRatio);
    const [cropper, setCropper] = (0, $3OyDL.useState)();
    const [imageUploadAllowed] = (0, $3OyDL.useState)(props.allowImageUpload ? props.allowImageUpload : true);
    const [preview, setPreview] = (0, $3OyDL.useState)(props.preview);
    (0, $3OyDL.useEffect)(()=>{
        setShowRatioSelection(props.openRationSelection || false);
    }, [
        props.openRationSelection
    ]);
    (0, $3OyDL.useEffect)(()=>{
        setPreview(props.preview);
    }, [
        props.preview
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            props.description && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                className: classes.space,
                children: props.description
            }),
            !props.loading ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    !props.mediaFile && !preview && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c98581141fcf8a16$export$2e2bcd8739ae039), {
                        onImageUpload: (imageUrl, file)=>{
                            props.onChangeImage && props.onChangeImage(imageUrl, file);
                        },
                        onVideoUpload: (videoUrl, file)=>{
                            props.onChangeVideo && props.onChangeVideo(videoUrl, file);
                        },
                        allowVideoUpload: props.allowVideoUpload,
                        allowImageUpload: imageUploadAllowed
                    }),
                    props.preview && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $66c81be31df2ca93$export$2e2bcd8739ae039), {
                        view: "row",
                        previewFormat: previewFormat,
                        src: preview,
                        type: props.mediaFileType,
                        deleteMediaFile: ()=>{
                            props.deleteImage && props.deleteImage() // TODO replace with deleteMediaFile function
                            ;
                        }
                    }),
                    props.mediaFile && !preview && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                className: "previewImage"
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1363aa40f897f638$export$2e2bcd8739ae039), {
                                style: {
                                    height: 400,
                                    width: '100%'
                                },
                                className: classes.space,
                                preview: ".previewImage",
                                src: props.mediaFile,
                                aspectRatio: aspectRatio,
                                initialAspectRatio: props.initialAspectRatio ? props.initialAspectRatio : aspectRatio,
                                viewMode: 1,
                                guides: true,
                                minCropBoxHeight: props.minCropBoxHeight ? props.minCropBoxHeight : 10,
                                minCropBoxWidth: props.minCropBoxWidth ? props.minCropBoxWidth : 10,
                                cropBoxResizable: props.cropBoxResizable ? props.cropBoxResizable : true,
                                scalable: true,
                                zoomable: true,
                                background: true,
                                responsive: true,
                                autoCropArea: 1,
                                checkOrientation: false,
                                onInitialized: (instance)=>{
                                    setCropper(instance);
                                    props.handleCropped(instance);
                                }
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                direction: "row",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        sx: {
                                            position: 'relative'
                                        },
                                        children: props.ratioSelection && !newImage && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                                    size: "small",
                                                    onClick: ()=>setShowRatioSelection(!showRatioSelection),
                                                    text: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c391be7c60ca8fb6$exports))), {}),
                                                    disabled: !props.mediaFile
                                                }),
                                                showRatioSelection && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                                    className: classes.ratioSelect,
                                                    children: props.ratioSelection.map((elem, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                                            onClick: ()=>{
                                                                if (cropper) {
                                                                    // const originRatio = cropper.initialImageData.aspectRatio
                                                                    if (elem.ratio) {
                                                                        setAspectRatio(elem.ratio);
                                                                        cropper.setAspectRatio(elem.ratio);
                                                                    } else {
                                                                        setAspectRatio(undefined);
                                                                        cropper.setAspectRatio(null);
                                                                    // cropper.setInitialAspectRatio(originRatio)
                                                                    }
                                                                }
                                                                setShowRatioSelection(!showRatioSelection);
                                                            },
                                                            children: elem.label
                                                        }, index))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                            color: "primary",
                                            onClick: ()=>{
                                                props.getCropData && props.getCropData();
                                            },
                                            text: "Bereich ausw\xe4hlen"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f17f03f9390e11c7$export$2e2bcd8739ae039), {})
        ]
    });
};
var $f5ed9f6a9eb1f249$export$2e2bcd8739ae039 = $f5ed9f6a9eb1f249$var$MediaCropperComponent;



const $25c2ff9358099864$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        root: {
            minWidth: '300px',
            width: '100%'
        },
        imgDesc: {
            padding: theme.spacing(2)
        },
        image: {
            height: 'auto',
            width: '100%',
            objectFit: 'cover',
            borderTopLeftRadius: '1%',
            borderTopRightRadius: '1%'
        },
        actionItem: {
            marginLeft: theme.spacing(1),
            '&:hover': {
                color: theme.palette.primary.dark
            }
        }
    }));
const $25c2ff9358099864$var$MediaUploadComponent = (props)=>{
    const classes = $25c2ff9358099864$var$useStyles();
    const [cropper, setCropper] = (0, $3OyDL.useState)();
    const [file, setFile] = (0, $3OyDL.useState)();
    const [isVideo, setIsVideo] = (0, $3OyDL.useState)(false);
    const [preview, setPreview] = (0, $3OyDL.useState)();
    const [actualImage, setActualImage] = (0, $3OyDL.useState)(undefined);
    // TODO const [innerLoading, setInnerLoading] = useState(false)
    const innerLoading = false;
    const temporaryMediaFile = props.temporaryMediaFile;
    const getCropData = ()=>{
        if (typeof cropper !== 'undefined') {
            const img = cropper.getCroppedCanvas().toDataURL();
            props.setMediaFile && props.setMediaFile(img);
            setPreview(img);
            setFile(undefined);
        }
    };
    const onChangeImage = (img, file)=>{
        setFile(img);
    };
    const onChangeVideo = (video, file)=>{
        setFile(video);
        props.setMediaFile && props.setMediaFile(video);
        setPreview(video);
        setIsVideo(true);
        setFile(undefined);
    };
    const handleCropped = (instance)=>{
        setCropper(instance);
    };
    const deleteImage = ()=>{
        setFile(undefined);
        setPreview(undefined);
        setIsVideo(false);
        setActualImage(undefined);
        props.setMediaFile && props.setMediaFile(undefined);
    };
    (0, $3OyDL.useEffect)(()=>{
        temporaryMediaFile && props.setMediaFile && props.setMediaFile(temporaryMediaFile.directLink, temporaryMediaFile.mediaFileId, temporaryMediaFile.mimeType);
        temporaryMediaFile && (temporaryMediaFile.mimeType.includes('video') ? setIsVideo(true) : setIsVideo(false));
    }, [
        temporaryMediaFile
    ]);
    (0, $3OyDL.useEffect)(()=>{
        setActualImage(props.file ? props.file : undefined);
        setFile(undefined);
        setPreview(undefined);
    }, [
        props.file
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            props.onlyUploadButton && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f5ed9f6a9eb1f249$export$2e2bcd8739ae039), {
                mediaFile: file,
                preview: preview,
                getCropData: getCropData,
                handleCropped: handleCropped,
                deleteImage: deleteImage,
                onChangeImage: onChangeImage,
                onChangeVideo: onChangeVideo,
                allowVideoUpload: props.allowVideoUpload,
                allowImageUpload: props.allowImageUpload,
                minCropBoxHeight: props.minCropBoxHeight,
                minCropBoxWidth: props.minCropBoxWidth,
                cropBoxResizable: props.cropBoxResizable,
                loading: innerLoading || props.loading,
                initialAspectRatio: props.initialAspectRatio,
                aspectRatio: props.aspectRatio
            }),
            !props.onlyUploadButton && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
                className: classes.root,
                children: [
                    !file && !(props.isVideo || isVideo) && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8e6251e768e64172$export$2e2bcd8739ae039), {
                            className: classes.image,
                            src: preview || actualImage
                        })
                    }),
                    !file && (props.isVideo || isVideo) && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e9cd4ed05f3fe469$export$2e2bcd8739ae039), {
                            src: preview || actualImage,
                            fallbackThumb: "/src/shared/assets/images/icon-img-placeholder.svg",
                            height: 450,
                            width: "100%",
                            controls: true
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        className: classes.imgDesc,
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f5ed9f6a9eb1f249$export$2e2bcd8739ae039), {
                                    mediaFile: file,
                                    getCropData: getCropData,
                                    handleCropped: handleCropped,
                                    deleteImage: deleteImage,
                                    onChangeImage: onChangeImage,
                                    onChangeVideo: onChangeVideo,
                                    allowVideoUpload: props.allowVideoUpload,
                                    allowImageUpload: props.allowImageUpload,
                                    loading: innerLoading || props.loading
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    className: classes.actionItem,
                                    text: "L\xf6schen",
                                    color: "info",
                                    variant: "outlined",
                                    onClick: deleteImage
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $25c2ff9358099864$export$2e2bcd8739ae039 = $25c2ff9358099864$var$MediaUploadComponent;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");


var $hDCOm = parcelRequire("hDCOm");

var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");function $5f94f074f1b95c09$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $5f94f074f1b95c09$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $5f94f074f1b95c09$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $5f94f074f1b95c09$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $5f94f074f1b95c09$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $5f94f074f1b95c09$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $5f94f074f1b95c09$export$8af1d214c6c2f0f1(length) * $5f94f074f1b95c09$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $5f94f074f1b95c09$export$8af1d214c6c2f0f1(length) * $5f94f074f1b95c09$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $5f94f074f1b95c09$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $5f94f074f1b95c09$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $5f94f074f1b95c09$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $5f94f074f1b95c09$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $5f94f074f1b95c09$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}



var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $592d49fe5ad6cb2f$export$c987db9fc844f86(slot) {
    return (0, $6AMoU.default)('MuiSkeleton', slot);
}
const $592d49fe5ad6cb2f$var$skeletonClasses = (0, $ithJf.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $592d49fe5ad6cb2f$export$2e2bcd8739ae039 = $592d49fe5ad6cb2f$var$skeletonClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $6af082c91b7e5e26$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $6af082c91b7e5e26$var$_ = (t)=>t, $6af082c91b7e5e26$var$_t, $6af082c91b7e5e26$var$_t2, $6af082c91b7e5e26$var$_t3, $6af082c91b7e5e26$var$_t4;
const $6af082c91b7e5e26$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $592d49fe5ad6cb2f$export$c987db9fc844f86), classes);
};
const $6af082c91b7e5e26$var$pulseKeyframe = (0, $hDCOm.keyframes)($6af082c91b7e5e26$var$_t || ($6af082c91b7e5e26$var$_t = $6af082c91b7e5e26$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const $6af082c91b7e5e26$var$waveKeyframe = (0, $hDCOm.keyframes)($6af082c91b7e5e26$var$_t2 || ($6af082c91b7e5e26$var$_t2 = $6af082c91b7e5e26$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $6af082c91b7e5e26$var$SkeletonRoot = (0, $jH1k7.default)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $5f94f074f1b95c09$export$65f2564e9a9b9222)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $5f94f074f1b95c09$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $gOPoC.default)({
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $7m2iU.alpha)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em'
    }, ownerState.variant === 'text' && {
        marginTop: 0,
        marginBottom: 0,
        height: 'auto',
        transformOrigin: '0 55%',
        transform: 'scale(1, 0.60)',
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        '&:empty:before': {
            content: '"\\00a0"'
        }
    }, ownerState.variant === 'circular' && {
        borderRadius: '50%'
    }, ownerState.variant === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        '& > *': {
            visibility: 'hidden'
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: 'fit-content'
    }, ownerState.hasChildren && !ownerState.height && {
        height: 'auto'
    });
}, ({ ownerState: ownerState })=>ownerState.animation === 'pulse' && (0, $hDCOm.css)($6af082c91b7e5e26$var$_t3 || ($6af082c91b7e5e26$var$_t3 = $6af082c91b7e5e26$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), $6af082c91b7e5e26$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === 'wave' && (0, $hDCOm.css)($6af082c91b7e5e26$var$_t4 || ($6af082c91b7e5e26$var$_t4 = $6af082c91b7e5e26$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), $6af082c91b7e5e26$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $6af082c91b7e5e26$var$Skeleton = /*#__PURE__*/ $3OyDL.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width } = props, other = (0, $aBenZ.default)(props, $6af082c91b7e5e26$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $6af082c91b7e5e26$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($6af082c91b7e5e26$var$SkeletonRoot, (0, $gOPoC.default)({
        as: component,
        ref: ref,
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $gOPoC.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $6af082c91b7e5e26$export$2e2bcd8739ae039 = $6af082c91b7e5e26$var$Skeleton;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");

var $89bdec2a5524eb93$exports = {};
"use strict";
"use client";

Object.defineProperty($89bdec2a5524eb93$exports, "__esModule", {
    value: true
});
$89bdec2a5524eb93$exports.default = void 0;

var $89bdec2a5524eb93$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $89bdec2a5524eb93$var$_default = (0, $89bdec2a5524eb93$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), 'KeyboardArrowDown');
$89bdec2a5524eb93$exports.default = $89bdec2a5524eb93$var$_default;



const $71ca7bea65a3d5d9$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        root: {
            width: '100%'
        }
    }));
const $71ca7bea65a3d5d9$var$DropDownComponent = (props)=>{
    const classes = $71ca7bea65a3d5d9$var$useStyles();
    const extractValue = ()=>{
        let response = null;
        if (typeof props.value === 'string') {
            const elem = props.value && props.options.find((elem)=>elem.key === props.value);
            if (elem) response = elem;
        } else response = null;
        return response;
    };
    const extractMultipleValue = ()=>{
        const array = [];
        if (props.multipleValue) props.multipleValue.map((elem)=>{
            const element = props.options.find((option)=>option.key === elem);
            if (element) array.push(element);
        });
        return array;
    };
    const [value, setValue] = (0, $3OyDL.useState)(extractValue());
    const [multipleValue, setMultipleValue] = (0, $3OyDL.useState)(extractMultipleValue());
    (0, $3OyDL.useEffect)(()=>{
        !props.multiple && setValue(extractValue());
        props.multiple && setMultipleValue(extractMultipleValue());
    }, [
        props.value,
        props.multipleValue
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: props.disableAutocomplete ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2fe65d1538ae7232$export$2e2bcd8739ae039), {
            className: classes.root,
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $922045e1db52dbe6$export$2e2bcd8739ae039), {
                    children: props.label
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b1485b6cef47f8e9$export$2e2bcd8739ae039), {
                    id: props.id,
                    value: props.multiple ? props.multipleValue : value?.key,
                    label: props.label,
                    onChange: (event)=>{
                        const element = props.options.find((elem)=>elem.key === event.target.value);
                        props.onChange && props.onChange(element);
                    },
                    fullWidth: props.fullWidth,
                    displayEmpty: true,
                    renderValue: (selected)=>{
                        if (Array.isArray(selected)) return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 0.5
                            },
                            children: selected.map((value)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $8c02f7497c61ac2b$export$2e2bcd8739ae039), {
                                    label: value
                                }, value))
                        });
                        return '';
                    },
                    children: props.options.map((elem)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c79ba0e99ec70dbd$export$2e2bcd8739ae039), {
                            value: elem.key,
                            children: elem.value
                        }, elem.key))
                })
            ]
        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1b4498b40a103fd2$export$2e2bcd8739ae039), {
            options: props.options,
            multiple: props.multiple ? props.multiple : false,
            value: props.multiple ? multipleValue : value,
            inputValue: props.inputValue,
            onInputChange: (event, newInputValue)=>props.onInputChange && props.onInputChange(newInputValue),
            id: props.id,
            size: props.size,
            limitTags: props.limitTags,
            defaultValue: multipleValue,
            isOptionEqualToValue: (option, value)=>option.value === value.value,
            getOptionLabel: (option)=>option.value,
            renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, $3OyDL.createElement)((0, $8c02f7497c61ac2b$export$2e2bcd8739ae039), {
                        ...getTagProps({
                            index: index
                        }),
                        key: index,
                        style: {
                            backgroundColor: option.color && props.multiple ? option.color : ''
                        },
                        label: option.value
                    })),
            renderOption: (prop, option, { selected: selected })=>/*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                    ...prop,
                    style: {
                        borderRight: option.color && !props.multiple ? `3px solid ${option.color}` : ''
                    },
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: option.value
                        }
                    })
                }),
            onChange: (event, value)=>{
                if (props.multiple) {
                    setMultipleValue(value);
                    props.onChangeList && props.onChangeList(value);
                } else {
                    setValue(value);
                    props.onChange && props.onChange(value);
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $328e9bc68740648b$export$2e2bcd8739ae039), {
                    ...params,
                    label: props.label,
                    name: props.name,
                    placeholder: props.placeholder,
                    required: props.required,
                    helperText: props.helperText,
                    error: props.error,
                    InputLabelProps: {
                        shrink: true
                    },
                    variant: props.variant,
                    margin: props.margin
                }),
            className: classes.root,
            disableClearable: props.disableClearable ? props.disableClearable : false,
            disabled: props.disabled ? props.disabled : false,
            popupIcon: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($89bdec2a5524eb93$exports))), {}),
            fullWidth: props.fullWidth
        })
    });
};
var $71ca7bea65a3d5d9$export$2e2bcd8739ae039 = $71ca7bea65a3d5d9$var$DropDownComponent;


const $a2cd30d20cc85586$var$TagFilterComponent = (props)=>{
    const [tagOptions, setTagOptions] = (0, $3OyDL.useState)(null);
    const { t: t } = (0, $ead5e217b39556c6$export$9fc83ad70ead8663)();
    //  create array of unique tag options
    const createTagOptions = (data)=>{
        if (data) {
            const tagsArray = [];
            data.map((item)=>{
                if (item.tags.length > 0) return item.tags.map((tag)=>{
                    tagsArray.push({
                        key: tag.id,
                        value: tag.label.toLowerCase()
                    });
                });
            });
            const tagsUnique = tagsArray.filter((value, index, self)=>index === self.findIndex((t)=>t.key === value.key));
            setTagOptions(tagsUnique);
        }
    };
    (0, $3OyDL.useEffect)(()=>{
        createTagOptions(props.mediaData);
    }, [
        props.mediaData
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: tagOptions && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                multiple: true,
                options: tagOptions,
                label: t('postingCommon:filterByTags'),
                onChange: (options)=>{
                    if (Array.isArray(options)) props.handleFilter({
                        tags: options
                    });
                }
            })
        })
    });
};
var $a2cd30d20cc85586$export$2e2bcd8739ae039 = $a2cd30d20cc85586$var$TagFilterComponent;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");


var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");
var $98e8f239594acf5f$exports = {};
"use strict";
"use client";

Object.defineProperty($98e8f239594acf5f$exports, "__esModule", {
    value: true
});
$98e8f239594acf5f$exports.default = void 0;

var $98e8f239594acf5f$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $98e8f239594acf5f$var$_default = (0, $98e8f239594acf5f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 13.5v-7c0-.41.47-.65.8-.4l4.67 3.5c.27.2.27.6 0 .8l-4.67 3.5c-.33.25-.8.01-.8-.4z"
}), 'PlayCircleFilledRounded');
$98e8f239594acf5f$exports.default = $98e8f239594acf5f$var$_default;


var $f1462c57f2b9ee3d$exports = {};
"use strict";
"use client";

Object.defineProperty($f1462c57f2b9ee3d$exports, "__esModule", {
    value: true
});
$f1462c57f2b9ee3d$exports.default = void 0;

var $f1462c57f2b9ee3d$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $f1462c57f2b9ee3d$var$_default = (0, $f1462c57f2b9ee3d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M9 16.17 5.53 12.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71c.39-.39.39-1.02 0-1.41a.9959.9959 0 0 0-1.41 0L9 16.17z"
}), 'CheckRounded');
$f1462c57f2b9ee3d$exports.default = $f1462c57f2b9ee3d$var$_default;



var $856b1a6fee02a542$exports = {};
"use strict";
Object.defineProperty($856b1a6fee02a542$exports, "__esModule", {
    value: true
});
$856b1a6fee02a542$exports.getVideoDurationFromVideoFile = $856b1a6fee02a542$exports.generateVideoThumbnailViaUrl = $856b1a6fee02a542$exports.getVideoCover = $856b1a6fee02a542$exports.generateVideoThumbnails = $856b1a6fee02a542$exports.importFileandPreview = void 0;
const $856b1a6fee02a542$var$importFileandPreview = (file, revoke)=>{
    return new Promise((resolve, reject)=>{
        window.URL = window.URL || window.webkitURL;
        let preview = window.URL.createObjectURL(file);
        if (revoke) window.URL.revokeObjectURL(preview);
        setTimeout(()=>{
            resolve(preview);
        }, 100);
    });
};
$856b1a6fee02a542$exports.importFileandPreview = $856b1a6fee02a542$var$importFileandPreview;
const $856b1a6fee02a542$var$generateVideoThumbnails = async (videoFile, numberOfThumbnails, type)=>{
    let thumbnail = [];
    let fractions = [];
    return type !== "url" ? new Promise(async (resolve, reject)=>{
        var _a;
        if (!((_a = videoFile.type) === null || _a === void 0 ? void 0 : _a.includes("video"))) reject("not a valid video file");
        await (0, $856b1a6fee02a542$exports.getVideoDurationFromVideoFile)(videoFile).then(async (duration)=>{
            for(let i = 0; i <= duration; i += duration / numberOfThumbnails)fractions.push(Math.floor(i));
            let promiseArray = fractions.map((time, index)=>$856b1a6fee02a542$var$getVideoThumbnail(videoFile, index >= fractions.length - 1 ? time - 2 : time));
            await Promise.all(promiseArray).then((res)=>{
                res.forEach((res)=>{
                    thumbnail.push(res);
                });
                resolve(thumbnail);
            }).catch((err)=>{
                reject(err);
            }).finally(()=>resolve(thumbnail));
        }).catch((err)=>{
            reject(err);
        });
        reject("something went wrong");
    }) : new Promise(async (resolve, reject)=>{
        await (0, $856b1a6fee02a542$exports.getVideoDurationFromVideoFile)(videoFile).then(async (duration)=>{
            console.log("duration", duration);
            for(let i = 0; i <= duration; i += duration / numberOfThumbnails)fractions.push(Math.floor(i));
            let promiseArray = fractions.map((time, index)=>$856b1a6fee02a542$var$getVideoThumbnail(videoFile, index >= fractions.length - 1 ? time - 2 : time));
            await Promise.all(promiseArray).then((res)=>{
                res.forEach((res)=>{
                    thumbnail.push(res);
                });
                resolve(thumbnail);
            }).catch((err)=>{
                reject(err);
            }).finally(()=>resolve(thumbnail));
        });
        reject("something went wrong");
    });
};
$856b1a6fee02a542$exports.generateVideoThumbnails = $856b1a6fee02a542$var$generateVideoThumbnails;
const $856b1a6fee02a542$var$getVideoThumbnail = (file, videoTimeInSeconds)=>{
    return new Promise((resolve, reject)=>{
        var _a;
        if ((_a = file === null || file === void 0 ? void 0 : file.type) === null || _a === void 0 ? void 0 : _a.match("video")) (0, $856b1a6fee02a542$exports.importFileandPreview)(file).then((urlOfFIle)=>{
            (0, $856b1a6fee02a542$exports.getVideoCover)(urlOfFIle, videoTimeInSeconds).then((res)=>{
                resolve(res);
            });
        });
        else if (file) (0, $856b1a6fee02a542$exports.getVideoCover)(file, videoTimeInSeconds).then((res)=>{
            resolve(res);
        }).catch((err)=>{
            reject(err);
        });
        else reject("file not valid");
    });
};
const $856b1a6fee02a542$var$getVideoCover = (urlOfFIle, seekTo = 0)=>{
    return new Promise((resolve, reject)=>{
        try {
            const videoPlayer = document.createElement("video");
            videoPlayer.setAttribute("src", urlOfFIle);
            videoPlayer.crossOrigin = "Anonymous";
            videoPlayer.load();
            videoPlayer.addEventListener("error", (ex)=>{
                reject(`error when loading video file ${ex}`);
            });
            videoPlayer.addEventListener("loadedmetadata", ()=>{
                if (videoPlayer.duration < seekTo) {
                    reject("video is too short.");
                    return;
                }
                setTimeout(()=>{
                    videoPlayer.currentTime = seekTo;
                }, 200);
                videoPlayer.addEventListener("seeked", ()=>{
                    const canvas = document.createElement("canvas");
                    canvas.width = videoPlayer.videoWidth;
                    canvas.height = videoPlayer.videoHeight;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);
                    ctx.canvas.toBlob((blob)=>{
                        var reader = new FileReader;
                        reader.readAsDataURL(blob);
                        reader.onloadend = function() {
                            var base64data = reader.result;
                            resolve(base64data);
                        };
                    }, "image/jpeg", 1);
                });
            });
        } catch (error) {
            reject(error);
        }
    });
};
$856b1a6fee02a542$exports.getVideoCover = $856b1a6fee02a542$var$getVideoCover;
const $856b1a6fee02a542$var$generateVideoThumbnailViaUrl = (urlOfFIle, videoTimeInSeconds)=>{
    return new Promise((resolve, reject)=>{
        try {
            var video = document.createElement("video");
            var timeupdate = function() {
                if (snapImage()) {
                    video.removeEventListener("timeupdate", timeupdate);
                    video.pause();
                }
            };
            video.addEventListener("loadeddata", function() {
                try {
                    if (snapImage()) video.removeEventListener("timeupdate", timeupdate);
                } catch (error) {
                    reject(error);
                }
            });
            var snapImage = function() {
                var canvas = document.createElement("canvas");
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
                var image = canvas.toBlob((blob)=>{
                    var reader = new FileReader;
                    reader.readAsDataURL(blob);
                    reader.onloadend = function() {
                        var base64data = reader.result;
                        resolve(base64data);
                    };
                }, "image/jpeg", 1);
                var success = (image === null || image === void 0 ? void 0 : image.length) > 1e5;
                if (success) {
                    URL.revokeObjectURL(urlOfFIle);
                    resolve(image);
                }
                return success;
            };
            video.addEventListener("timeupdate", timeupdate);
            video.preload = "metadata";
            video.src = urlOfFIle;
            video.muted = true;
            video.playsInline = true;
            video.crossOrigin = "Anonymous";
            video.currentTime = videoTimeInSeconds;
            video.play().then().catch((err)=>{
                reject({
                    status: 500,
                    reason: `Access to video at ${urlOfFIle} from origin ${window.location.hostname} has been blocked by CORS policy: No 'Access-Control-Allow-Origin' header is present on the requested resource.`,
                    message: err
                });
            });
        } catch (error) {
            reject(error);
        }
    });
};
$856b1a6fee02a542$exports.generateVideoThumbnailViaUrl = $856b1a6fee02a542$var$generateVideoThumbnailViaUrl;
const $856b1a6fee02a542$var$getVideoDurationFromVideoFile = (videoFile)=>{
    return new Promise((resolve, reject)=>{
        var _a;
        try {
            if (videoFile) {
                if ((_a = videoFile === null || videoFile === void 0 ? void 0 : videoFile.type) === null || _a === void 0 ? void 0 : _a.match("video")) (0, $856b1a6fee02a542$exports.importFileandPreview)(videoFile).then((url)=>{
                    $856b1a6fee02a542$var$generateVideoDurationFromUrl(url).then((res)=>{
                        resolve(res);
                    });
                });
                else $856b1a6fee02a542$var$generateVideoDurationFromUrl(videoFile).then((res)=>{
                    resolve(res);
                });
            } else reject("Cannot generate video duration for this video file.");
        } catch (error) {
            reject(error);
        }
    });
};
$856b1a6fee02a542$exports.getVideoDurationFromVideoFile = $856b1a6fee02a542$var$getVideoDurationFromVideoFile;
const $856b1a6fee02a542$var$generateVideoDurationFromUrl = (url)=>{
    return new Promise((resolve, reject)=>{
        let video = document.createElement("video");
        video.addEventListener("loadeddata", function() {
            resolve(video.duration);
            window.URL.revokeObjectURL(url);
        });
        video.preload = "metadata";
        video.src = url;
        video.muted = true;
        video.crossOrigin = "Anonymous";
        video.playsInline = true;
        video.play();
    });
};



const $94ecc0572449bec0$var$MediaListItem = ({ item: item, handleClick: handleClick, width: width, selected: selected })=>{
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            imageContainer: {
                position: 'relative',
                margin: '2.5px',
                height: '105px',
                width: width || '105px',
                '&:hover': {
                    cursor: 'pointer'
                },
                '&:hover > $overlay': {
                    opacity: '0.64'
                }
            },
            checked: {
                '& $overlay': {
                    opacity: '0.64'
                },
                '& $iconBlock': {
                    opacity: 1
                }
            },
            image: {
                position: 'relative',
                objectFit: 'cover',
                height: '105px',
                width: width || '105px',
                zIndex: 0
            },
            overlay: {
                position: 'absolute',
                display: 'block',
                height: '105px',
                width: width || '105px',
                top: 0,
                left: 0,
                background: '#000000 0% 0% no-repeat padding-box',
                opacity: 0,
                zIndex: 1
            },
            iconBlock: {
                position: 'absolute',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '105px',
                width: width || '105px',
                opacity: 0,
                top: 0,
                left: 0,
                zIndex: 2
            },
            videoNoImage: {
                position: 'absolute',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
                height: '105px',
                width: width || '105px',
                top: 0,
                left: 0,
                zIndex: 2,
                '& svg': {
                    margin: '8px'
                }
            },
            animated: {
                animation: '$scale .5s ease-in-out  alternate'
            },
            '@keyframes scale': {
                '0%': {
                    opacity: 0,
                    transform: 'scale(1.0)'
                },
                '50%': {
                    opacity: 1,
                    transform: 'scale(1.2)'
                },
                '100%': {
                    opacity: 1,
                    transform: 'scale(1.0)'
                }
            }
        }));
    const classes = useStyles();
    const [videoThumbnail, setVideoThumbnail] = (0, $3OyDL.useState)();
    const isVideo = !!item.mimeType.match('video.*');
    (0, $3OyDL.useEffect)(()=>{
        isVideo && (0, $856b1a6fee02a542$exports.generateVideoThumbnailViaUrl)(item.mediaUrl, 2).then((value)=>{
            setVideoThumbnail(value);
        });
    }, []);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: `${classes.imageContainer}`,
        onClick: ()=>handleClick(item, videoThumbnail && videoThumbnail),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8e6251e768e64172$export$2e2bcd8739ae039), {
                src: isVideo && videoThumbnail ? videoThumbnail : item.mediaUrl,
                fallback: "/src/shared/assets/images/icon-img-placeholder.svg",
                className: classes.image
            }),
            isVideo ? /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: classes.videoNoImage,
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($98e8f239594acf5f$exports))), {
                    style: {
                        color: '#fff',
                        filter: 'drop-shadow( 0px 0px 3px rgba(0, 0, 0, .15))'
                    }
                })
            }) : '',
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: classes.overlay
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: classes.iconBlock,
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f1462c57f2b9ee3d$exports))), {
                    className: `${selected && item.mediaUrl === selected.mediaUrl ? classes.animated : ''}`,
                    style: {
                        color: '#fff'
                    }
                })
            })
        ]
    });
};
var $94ecc0572449bec0$export$2e2bcd8739ae039 = $94ecc0572449bec0$var$MediaListItem;


const $4b0aa4693aa73218$var$MediaList = ({ setSelected: setSelected, selected: selected, mediaData: mediaData, elementSize: elementSize, useRoundImageBorders: useRoundImageBorders })=>{
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            uList: {
                display: 'flex',
                flexWrap: 'wrap',
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            roundBorder: {
                borderRadius: '50%'
            }
        }));
    const classes = useStyles();
    const handleClick = (item, thumbnail)=>{
        return selected && item.id === selected.id ? setSelected({}, undefined) : setSelected(item, thumbnail);
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
            className: classes.uList,
            children: mediaData && mediaData.map((item, index)=>{
                return /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                    className: useRoundImageBorders ? classes.roundBorder : undefined,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $94ecc0572449bec0$export$2e2bcd8739ae039), {
                        handleClick: handleClick,
                        item: item,
                        selected: selected,
                        width: elementSize
                    })
                }, index);
            })
        })
    });
};
var $4b0aa4693aa73218$export$2e2bcd8739ae039 = $4b0aa4693aa73218$var$MediaList;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");



var $3ed217829cf37fba$exports = {};
"use strict";
"use client";

Object.defineProperty($3ed217829cf37fba$exports, "__esModule", {
    value: true
});
$3ed217829cf37fba$exports.default = void 0;

var $3ed217829cf37fba$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $3ed217829cf37fba$var$_default = (0, $3ed217829cf37fba$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M17.7 15.89 13.82 12l3.89-3.89c.39-.39.39-1.02 0-1.41a.9959.9959 0 0 0-1.41 0l-4.59 4.59c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.38.38-1.02-.01-1.4zM7 6c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1s-1-.45-1-1V7c0-.55.45-1 1-1z"
}), 'FirstPageRounded');
$3ed217829cf37fba$exports.default = $3ed217829cf37fba$var$_default;


var $151a8c7273cf1778$exports = {};
"use strict";
"use client";

Object.defineProperty($151a8c7273cf1778$exports, "__esModule", {
    value: true
});
$151a8c7273cf1778$exports.default = void 0;

var $151a8c7273cf1778$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $151a8c7273cf1778$var$_default = (0, $151a8c7273cf1778$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M6.29 8.11 10.18 12l-3.89 3.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L7.7 6.7a.9959.9959 0 0 0-1.41 0c-.38.39-.38 1.03 0 1.41zM17 6c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1s-1-.45-1-1V7c0-.55.45-1 1-1z"
}), 'LastPageRounded');
$151a8c7273cf1778$exports.default = $151a8c7273cf1778$var$_default;


var $068d9311976b63b5$exports = {};
"use strict";
"use client";

Object.defineProperty($068d9311976b63b5$exports, "__esModule", {
    value: true
});
$068d9311976b63b5$exports.default = void 0;

var $068d9311976b63b5$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $068d9311976b63b5$var$_default = (0, $068d9311976b63b5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M14.91 6.71a.9959.9959 0 0 0-1.41 0L8.91 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L11.03 12l3.88-3.88c.38-.39.38-1.03 0-1.41z"
}), 'NavigateBeforeRounded');
$068d9311976b63b5$exports.default = $068d9311976b63b5$var$_default;


var $acf14657a0db239b$exports = {};
"use strict";
"use client";

Object.defineProperty($acf14657a0db239b$exports, "__esModule", {
    value: true
});
$acf14657a0db239b$exports.default = void 0;

var $acf14657a0db239b$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $acf14657a0db239b$var$_default = (0, $acf14657a0db239b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M9.31 6.71c-.39.39-.39 1.02 0 1.41L13.19 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.72 6.7c-.38-.38-1.02-.38-1.41.01z"
}), 'NavigateNextRounded');
$acf14657a0db239b$exports.default = $acf14657a0db239b$var$_default;


const $0d325fc141710284$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        pagination: {
            margin: '0',
            display: 'flex',
            padding: 0,
            flexWrap: 'wrap',
            listStyle: 'none',
            alignItems: 'center'
        },
        pageLink: {
            margin: '0 1px'
        },
        disabled: {
            opacity: 0.38,
            pointerEvents: 'none',
            cursor: 'default'
        }
    }));
function $0d325fc141710284$export$2e2bcd8739ae039(props) {
    const { totalItems: totalItems, itemsPerPage: itemsPerPage, page: page, setPage: setPage } = props;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const classes = $0d325fc141710284$var$useStyles();
    const { t: t } = (0, $ead5e217b39556c6$export$9fc83ad70ead8663)();
    const onFirstPage = ()=>{
        setPage(1);
    };
    const onLastPage = ()=>{
        setPage(totalPages);
    };
    const onNextPage = ()=>{
        setPage(page + 1);
    };
    const onPreviousPage = ()=>{
        setPage(page - 1);
    };
    const getItemsCounter = ()=>{
        let fromTo = '';
        if (page === 1) fromTo = `${page}-${itemsPerPage}`;
        else if (page > 1 && page !== totalPages) fromTo = `${itemsPerPage * page - itemsPerPage + 1}-${itemsPerPage * page}`;
        else fromTo = `${itemsPerPage * page - (itemsPerPage - 1)}-${totalItems}`;
        return `${fromTo} ${t('coreDashboard:of')} ${totalItems}`;
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: totalItems > itemsPerPage && /*#__PURE__*/ (0, $2M70Q.jsx)("nav", {
            style: {
                marginTop: '8px'
            },
            children: /*#__PURE__*/ (0, $2M70Q.jsxs)("ul", {
                className: classes.pagination,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                        style: {
                            marginRight: '12px'
                        },
                        children: getItemsCounter()
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                            className: `${classes.pageLink} ${page === 1 && classes.disabled}`,
                            color: "primary",
                            component: "div",
                            onClick: ()=>onFirstPage(),
                            size: "large",
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3ed217829cf37fba$exports))), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                            className: `${classes.pageLink} ${page === 1 && classes.disabled}`,
                            color: "primary",
                            component: "div",
                            onClick: ()=>onPreviousPage(),
                            size: "large",
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($068d9311976b63b5$exports))), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                            className: `${classes.pageLink} ${page === totalPages && classes.disabled}`,
                            color: "primary",
                            component: "div",
                            onClick: ()=>onNextPage(),
                            size: "large",
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acf14657a0db239b$exports))), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                            className: `${classes.pageLink} ${page === totalPages && classes.disabled}`,
                            color: "primary",
                            component: "div",
                            onClick: ()=>onLastPage(),
                            size: "large",
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($151a8c7273cf1778$exports))), {})
                        })
                    })
                ]
            })
        })
    });
}



var $3OyDL = parcelRequire("3OyDL");
const $5fab66439444a54d$var$useGalleryWidth = (ref, trigger, elemSize = 110, items = 20)=>{
    const [itemsPerPage, setItemsPerPage] = (0, $3OyDL.useState)(items);
    const [elementSize, setElementSize] = (0, $3OyDL.useState)(elemSize);
    (0, $3OyDL.useEffect)(()=>{
        const handleResize = ()=>{
            if (ref.current) {
                const containerWidth = ref.current.offsetWidth;
                const elemProRow = Math.floor(containerWidth / elementSize);
                const remainingSpace = containerWidth - elemProRow * elementSize;
                setItemsPerPage(elemProRow * 2) // two rows
                ;
                setElementSize(remainingSpace / elemProRow + elementSize - 5.2) // minus 5px margin + 0.2 interference leveled
                ;
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, [
        ref,
        trigger
    ]);
    return {
        itemsPerPage: itemsPerPage,
        elementSize: elementSize
    };
};
var $5fab66439444a54d$export$2e2bcd8739ae039 = $5fab66439444a54d$var$useGalleryWidth;


const $3a48fbcdb50c9177$var$MediaGalleryComponent = (props)=>{
    const [filter, setFilter] = (0, $3OyDL.useState)({
        tags: []
    });
    const [data, setData] = (0, $3OyDL.useState)();
    const [page, setPage] = (0, $3OyDL.useState)(1);
    const [filtered, setFiltered] = (0, $3OyDL.useState)(false);
    const mediaContainerRef = (0, $3OyDL.useRef)(null);
    const { itemsPerPage: itemsPerPage, elementSize: elementSize } = (0, $5fab66439444a54d$export$2e2bcd8739ae039)(mediaContainerRef);
    const mediaListView = ()=>{
        if (filtered && filter.tags.length > 0) filterGalleryData(props.mediaData);
        else {
            setFiltered(false);
            handlePageChange(props.mediaData);
        }
    };
    const filterGalleryData = (fData)=>{
        const tempData = [];
        if (fData) {
            fData.map((elem)=>{
                let elemExist = false;
                elem.tags.map((tag)=>{
                    if (filter.tags.findIndex((filterTag)=>filterTag.key === tag.id) !== -1) elemExist = true;
                });
                if (elemExist) tempData.push(elem);
            });
            setPage(1);
            handlePageChange(tempData);
        }
    };
    const handlePageChange = (mData, page = 1)=>{
        if (mData) {
            const startItem = (page - 1) * itemsPerPage;
            const endItem = page * itemsPerPage;
            setData(mData.slice(startItem, endItem));
        }
    };
    // eslint-disable-next-line no-unused-vars
    const handleFilter = (tags)=>{
        setFilter(tags);
        setFiltered(true);
    };
    (0, $3OyDL.useEffect)(()=>{
        mediaListView();
    }, [
        filter,
        props.mediaData,
        itemsPerPage
    ]);
    (0, $3OyDL.useEffect)(()=>{
        handlePageChange(props.mediaData, page);
    }, [
        page
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
        container: true,
        ref: mediaContainerRef,
        children: data ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                    xs: 12,
                    item: true,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        component: "div",
                        style: {
                            marginBottom: '24px'
                        },
                        children: props.activateTagSearch && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a2cd30d20cc85586$export$2e2bcd8739ae039), {
                            handleFilter: handleFilter,
                            mediaData: undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                    xs: 12,
                    item: true,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        component: "div",
                        children: data.length !== 0 ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4b0aa4693aa73218$export$2e2bcd8739ae039), {
                            elementSize: elementSize,
                            setSelected: props.setSelected,
                            selected: props.selected,
                            mediaData: data && data,
                            useRoundImageBorders: props.useRoundImageBorders
                        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                minHeight: '200px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            },
                            children: "Keine Mediendaten vorhanden"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                    xs: 12,
                    item: true,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        component: "div",
                        style: {
                            display: 'flex',
                            justifyContent: 'center'
                        },
                        children: props.mediaData && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0d325fc141710284$export$2e2bcd8739ae039), {
                            totalItems: filtered ? data.length : props.mediaData.length,
                            itemsPerPage: itemsPerPage,
                            page: page,
                            setPage: setPage
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6af082c91b7e5e26$export$2e2bcd8739ae039), {
                    style: {
                        marginBottom: '24px'
                    },
                    variant: "rectangular",
                    width: "100%",
                    height: 48
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                    style: {
                        display: 'flex',
                        flexWrap: 'wrap'
                    },
                    children: [
                        ...Array(itemsPerPage)
                    ].map((x, i)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $6af082c91b7e5e26$export$2e2bcd8739ae039), {
                            style: {
                                margin: '2.5px'
                            },
                            variant: "rectangular",
                            width: elementSize,
                            height: 105
                        }, i))
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                    style: {
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center'
                    },
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6af082c91b7e5e26$export$2e2bcd8739ae039), {
                        style: {
                            marginTop: '24px'
                        },
                        variant: "rectangular",
                        width: 305,
                        height: 25
                    })
                })
            ]
        })
    });
};
var $3a48fbcdb50c9177$export$2e2bcd8739ae039 = $3a48fbcdb50c9177$var$MediaGalleryComponent;




const $ce5483b24fb77199$export$f4931e6f9feb30c5 = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.dataStore.member, (state)=>state);
const $ce5483b24fb77199$export$3f41ece7d7128238 = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.dataStore.events, (state)=>state);
const $ce5483b24fb77199$export$fe140eefbe221ed9 = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.dataStore.eventPriceCategories, (state)=>state);
const $ce5483b24fb77199$export$a1da1323b0778446 = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.dataStore.eventMember, (state)=>state);
const $ce5483b24fb77199$export$503e5e11c8cc005e = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.dataStore.eventLocations, (state)=>state);
const $ce5483b24fb77199$export$79c726a1641bb9ad = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.dataStore.eventResults, (state)=>state);
const $ce5483b24fb77199$export$b8e54fb0b8f14b48 = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.dataStore.relations, (state)=>state);
const $ce5483b24fb77199$export$115663dc807a2e95 = (0, $9365bc52a37388f7$export$595d22ed68ca2841)((state)=>state.dataStore.statistics, (state)=>state);



const $eb2357c3a13424e5$var$fetchData = (restPath, version, fetchHeaders, entity, method, id, data, setData, setMessage)=>{
    let eventType = (0, $c7fa01100a96d1f7$export$80edbf15fa61a4db).load;
    switch(method){
        case (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).PUT:
            eventType = (0, $c7fa01100a96d1f7$export$80edbf15fa61a4db).update;
            break;
        case (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).DELETE:
            eventType = (0, $c7fa01100a96d1f7$export$80edbf15fa61a4db).delete;
            break;
        case (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).POST:
            eventType = (0, $c7fa01100a96d1f7$export$80edbf15fa61a4db).create;
            break;
    }
    fetch(`${restPath}/api/${version}/${entity}${id ? `/${id}` : ''}`, {
        credentials: 'include',
        method: method,
        headers: fetchHeaders,
        body: JSON.stringify(data)
    }).then(async (res)=>{
        if (res.status === 403) window.location.href = '/login';
        let message = 'Etwas ist schief gegangen!';
        if (res.status < 400) {
            switch(method){
                case (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).PUT:
                    message = 'Daten wurden gespeichert';
                    break;
                case (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).POST:
                    message = 'Daten wurden erstellt';
                    break;
                case (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).GET:
                    message = 'Daten wurden geladen';
                    break;
                case (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).DELETE:
                    message = "Daten wurden gel\xf6scht";
                    break;
            }
            try {
                const response = await res.json();
                response && setData && setData(response);
                setMessage && setMessage({
                    message: message,
                    severity: (0, $c7fa01100a96d1f7$export$918a9776c0a3cf27).success,
                    eventType: eventType
                });
            } catch (err) {
                console.log(err);
            }
        } else try {
            const response = await res.json();
            message = response.message;
            setMessage && setMessage({
                message: message,
                severity: (0, $c7fa01100a96d1f7$export$918a9776c0a3cf27).error,
                eventType: eventType
            });
        } catch (err) {
            console.log(err);
        }
    });
};
var $eb2357c3a13424e5$export$2e2bcd8739ae039 = $eb2357c3a13424e5$var$fetchData;


function $d5fc91037e1fb59a$export$36de249ab5dcbcd5() {
    return 'v1';
}


var $dfbdbe88c8dd8d40$exports = {};
"use strict";
Object.defineProperty($dfbdbe88c8dd8d40$exports, "__esModule", {
    value: true
});
/**
 * Returns `true` if action has the same type as action creator.
 * Defines Type Guard that lets TypeScript know `payload` type inside blocks
 * where `isType` returned `true`.
 *
 * @example
 *
 *    const somethingHappened =
 *      actionCreator<{foo: string}>('SOMETHING_HAPPENED');
 *
 *    if (isType(action, somethingHappened)) {
 *      // action.payload has type {foo: string}
 *    }
 */ function $dfbdbe88c8dd8d40$var$isType(action, actionCreator) {
    return action.type === actionCreator.type;
}
$dfbdbe88c8dd8d40$exports.isType = $dfbdbe88c8dd8d40$var$isType;
/**
 * Creates Action Creator factory with optional prefix for action types.
 * @param prefix Prefix to be prepended to action types as `<prefix>/<type>`.
 * @param defaultIsError Function that detects whether action is error given the
 *   payload. Default is `payload => payload instanceof Error`.
 */ function $dfbdbe88c8dd8d40$var$actionCreatorFactory(prefix, defaultIsError) {
    if (defaultIsError === void 0) defaultIsError = function(p) {
        return p instanceof Error;
    };
    var actionTypes = {};
    var base = prefix ? prefix + "/" : '';
    function actionCreator(type, commonMeta, isError) {
        if (isError === void 0) isError = defaultIsError;
        var fullType = base + type;
        return Object.assign(function(payload, meta) {
            var action = {
                type: fullType,
                payload: payload
            };
            if (commonMeta || meta) action.meta = Object.assign({}, commonMeta, meta);
            if (isError && (typeof isError === 'boolean' || isError(payload))) action.error = true;
            return action;
        }, {
            type: fullType,
            toString: function() {
                return fullType;
            },
            match: function(action) {
                return action.type === fullType;
            }
        });
    }
    function asyncActionCreators(type, commonMeta) {
        return {
            type: base + type,
            started: actionCreator(type + "_STARTED", commonMeta, false),
            done: actionCreator(type + "_DONE", commonMeta, false),
            failed: actionCreator(type + "_FAILED", commonMeta, true)
        };
    }
    return Object.assign(actionCreator, {
        async: asyncActionCreators
    });
}
$dfbdbe88c8dd8d40$exports.actionCreatorFactory = $dfbdbe88c8dd8d40$var$actionCreatorFactory;
$dfbdbe88c8dd8d40$exports.default = $dfbdbe88c8dd8d40$var$actionCreatorFactory;


const $5993246da723f2dd$export$43bc62a3d577b850 = (0, (/*@__PURE__*/$parcel$interopDefault($dfbdbe88c8dd8d40$exports)))('DATA');
const $5993246da723f2dd$export$3e5f62cfeebace10 = $5993246da723f2dd$export$43bc62a3d577b850('SET_MEMBERS');
const $5993246da723f2dd$export$b36d0489da17a330 = $5993246da723f2dd$export$43bc62a3d577b850('SET_RELATIONS');
const $5993246da723f2dd$export$60e96fb0202719e5 = $5993246da723f2dd$export$43bc62a3d577b850('SET_EVENTS');
const $5993246da723f2dd$export$ad62873327949bc6 = $5993246da723f2dd$export$43bc62a3d577b850('SET_EVENT_MEMBER');
const $5993246da723f2dd$export$d70f6b01a5244300 = $5993246da723f2dd$export$43bc62a3d577b850('SET_EVENT_PRICE_CATEGORIES');
const $5993246da723f2dd$export$af0d9692e57c37e3 = $5993246da723f2dd$export$43bc62a3d577b850('SET_EVENT_LOCATIONS');
const $5993246da723f2dd$export$32f26ecd1d16cf = $5993246da723f2dd$export$43bc62a3d577b850('SET_EVENT_RESULT');
const $5993246da723f2dd$export$822ee8c4fcfb573b = $5993246da723f2dd$export$43bc62a3d577b850('SET_STATISTICS');



const $7173820326fb9f6c$export$82bc26edf87309d = (0, (/*@__PURE__*/$parcel$interopDefault($dfbdbe88c8dd8d40$exports)))('SETTINGS');
const $7173820326fb9f6c$export$f371be8ef3fc4263 = $7173820326fb9f6c$export$82bc26edf87309d('SET_DARK_MODE');
const $7173820326fb9f6c$export$2e49b867b7a0847c = $7173820326fb9f6c$export$82bc26edf87309d('SET_THEME');
const $7173820326fb9f6c$export$706cdae1b5419ef8 = $7173820326fb9f6c$export$82bc26edf87309d('SET_MESSAGE');
const $7173820326fb9f6c$export$5cbff2416b95c79c = $7173820326fb9f6c$export$82bc26edf87309d('SET_SEARCH_INPUT');
const $7173820326fb9f6c$export$a1f268530c5060ed = $7173820326fb9f6c$export$82bc26edf87309d('SET_USER_PERMISSIONS');
const $7173820326fb9f6c$export$8f827b63222d82c5 = $7173820326fb9f6c$export$82bc26edf87309d('SET_NAV_POINT');
const $7173820326fb9f6c$export$38eb4755744c35e0 = $7173820326fb9f6c$export$82bc26edf87309d('SET_BIOGRAPHY');
const $7173820326fb9f6c$export$3f718a5018550532 = $7173820326fb9f6c$export$82bc26edf87309d('SET_GEOGRAPHY');
const $7173820326fb9f6c$export$8b6bb3dd62a01be2 = $7173820326fb9f6c$export$82bc26edf87309d('SET_USER');
const $7173820326fb9f6c$export$c879816e1d08940b = $7173820326fb9f6c$export$82bc26edf87309d('SET_ACTIVE_MEMBER');
const $7173820326fb9f6c$export$5fe35dca4873f8c4 = $7173820326fb9f6c$export$82bc26edf87309d('SET_REDIRECT_PATH');


const $19493b1888c07ad7$export$2812a1fb15aca49c = window.location.origin.search('localhost') !== -1 ? 'http://localhost:8011' : `${window.location.origin}`;
const $19493b1888c07ad7$var$requestHeaders = new Headers();
$19493b1888c07ad7$var$requestHeaders.set('Accept', 'application/json');
$19493b1888c07ad7$var$requestHeaders.set('Content-Type', 'application/json');
const $19493b1888c07ad7$var$devEnv = {
    restBase: $19493b1888c07ad7$export$2812a1fb15aca49c,
    fetchHeaders: $19493b1888c07ad7$var$requestHeaders
};
const $19493b1888c07ad7$var$stageEnv = {
    ...$19493b1888c07ad7$var$devEnv
};
const $19493b1888c07ad7$var$prodEnv = {
    ...$19493b1888c07ad7$var$devEnv
};
const $19493b1888c07ad7$var$getEnvValues = ()=>{
    return $19493b1888c07ad7$var$devEnv;
};
const $19493b1888c07ad7$export$eb512c93954ec044 = false;
var $19493b1888c07ad7$export$2e2bcd8739ae039 = $19493b1888c07ad7$var$getEnvValues();



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");
parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $8ee65d1170e50bb4$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $58f390287efdc7d9$export$ffd560f22c0ecf04(slot) {
    return (0, $6AMoU.default)('MuiAvatar', slot);
}
const $58f390287efdc7d9$var$avatarClasses = (0, $ithJf.default)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $58f390287efdc7d9$export$2e2bcd8739ae039 = $58f390287efdc7d9$var$avatarClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $d93387bfb3b3cba0$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $d93387bfb3b3cba0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $58f390287efdc7d9$export$ffd560f22c0ecf04), classes);
};
const $d93387bfb3b3cba0$var$AvatarRoot = (0, $jH1k7.default)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none'
    }, ownerState.variant === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === 'square' && {
        borderRadius: 0
    }, ownerState.colorDefault && (0, $gOPoC.default)({
        color: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
        backgroundColor: theme.vars.palette.Avatar.defaultBg
    } : {
        backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    })));
const $d93387bfb3b3cba0$var$AvatarImg = (0, $jH1k7.default)('img', {
    name: 'MuiAvatar',
    slot: 'Img',
    overridesResolver: (props, styles)=>styles.img
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $d93387bfb3b3cba0$var$AvatarFallback = (0, $jH1k7.default)((0, $8ee65d1170e50bb4$export$2e2bcd8739ae039), {
    name: 'MuiAvatar',
    slot: 'Fallback',
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: '75%',
    height: '75%'
});
function $d93387bfb3b3cba0$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $3OyDL.useState(false);
    $3OyDL.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $d93387bfb3b3cba0$var$Avatar = /*#__PURE__*/ $3OyDL.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular' } = props, other = (0, $aBenZ.default)(props, $d93387bfb3b3cba0$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $d93387bfb3b3cba0$var$useLoaded((0, $gOPoC.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    const ownerState = (0, $gOPoC.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $d93387bfb3b3cba0$var$useUtilityClasses(ownerState);
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $2M70Q.jsx)($d93387bfb3b3cba0$var$AvatarImg, (0, $gOPoC.default)({
        alt: alt,
        srcSet: srcSet,
        src: src,
        sizes: sizes,
        ownerState: ownerState,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $2M70Q.jsx)($d93387bfb3b3cba0$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)($d93387bfb3b3cba0$var$AvatarRoot, (0, $gOPoC.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $3DmQB.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $d93387bfb3b3cba0$export$2e2bcd8739ae039 = $d93387bfb3b3cba0$var$Avatar;





var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $g4LX8 = parcelRequire("g4LX8");

var $jH1k7 = parcelRequire("jH1k7");




var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $6dd2ef7e4d265b9b$export$baa0faa0c7ad8085(slot) {
    return (0, $6AMoU.default)('PrivateSwitchBase', slot);
}
const $6dd2ef7e4d265b9b$var$switchBaseClasses = (0, $ithJf.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $6dd2ef7e4d265b9b$export$2e2bcd8739ae039 = $6dd2ef7e4d265b9b$var$switchBaseClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $02423c2e2951683c$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $02423c2e2951683c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $g4LX8.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $6dd2ef7e4d265b9b$export$baa0faa0c7ad8085), classes);
};
const $02423c2e2951683c$var$SwitchBaseRoot = (0, $jH1k7.default)((0, $c582f66505800c92$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $02423c2e2951683c$var$SwitchBaseInput = (0, $jH1k7.default)('input')({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $02423c2e2951683c$var$SwitchBase = /*#__PURE__*/ $3OyDL.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $aBenZ.default)(props, $02423c2e2951683c$var$_excluded);
    const [checked, setCheckedState] = (0, $ac2de2dab926b929$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $38dd66485068cbe7$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $gOPoC.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $02423c2e2951683c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($02423c2e2951683c$var$SwitchBaseRoot, (0, $gOPoC.default)({
        component: "span",
        className: (0, $3DmQB.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)($02423c2e2951683c$var$SwitchBaseInput, (0, $gOPoC.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $02423c2e2951683c$export$2e2bcd8739ae039 = $02423c2e2951683c$var$SwitchBase;


parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $ddeabb082bf3b8ca$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $190a4e6a3eaa4ab7$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $87ea82285b107732$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');



var $g4LX8 = parcelRequire("g4LX8");

var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $ba9c9c45647428fa$export$6c57c6e16b4063b(slot) {
    return (0, $6AMoU.default)('MuiCheckbox', slot);
}
const $ba9c9c45647428fa$var$checkboxClasses = (0, $ithJf.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $ba9c9c45647428fa$export$2e2bcd8739ae039 = $ba9c9c45647428fa$var$checkboxClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $11e9a1a673403348$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $11e9a1a673403348$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $g4LX8.default)(color)}`,
            `size${(0, $g4LX8.default)(size)}`
        ]
    };
    const composedClasses = (0, $5jsOu.default)(slots, (0, $ba9c9c45647428fa$export$6c57c6e16b4063b), classes);
    return (0, $gOPoC.default)({}, classes, composedClasses);
};
const $11e9a1a673403348$var$CheckboxRoot = (0, $jH1k7.default)((0, $02423c2e2951683c$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $jH1k7.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            ownerState.color !== 'default' && styles[`color${(0, $g4LX8.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $ba9c9c45647428fa$export$2e2bcd8739ae039).checked}, &.${(0, $ba9c9c45647428fa$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $ba9c9c45647428fa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $11e9a1a673403348$var$defaultCheckedIcon = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $190a4e6a3eaa4ab7$export$2e2bcd8739ae039), {});
const $11e9a1a673403348$var$defaultIcon = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ddeabb082bf3b8ca$export$2e2bcd8739ae039), {});
const $11e9a1a673403348$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $87ea82285b107732$export$2e2bcd8739ae039), {});
const $11e9a1a673403348$var$Checkbox = /*#__PURE__*/ $3OyDL.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $11e9a1a673403348$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $11e9a1a673403348$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $11e9a1a673403348$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', className: className } = props, other = (0, $aBenZ.default)(props, $11e9a1a673403348$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $gOPoC.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $11e9a1a673403348$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($11e9a1a673403348$var$CheckboxRoot, (0, $gOPoC.default)({
        type: "checkbox",
        inputProps: (0, $gOPoC.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $3OyDL.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $3OyDL.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $3DmQB.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $11e9a1a673403348$export$2e2bcd8739ae039 = $11e9a1a673403348$var$Checkbox;


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");




var $g4LX8 = parcelRequire("g4LX8");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $88faeb6780366151$export$717666c39ec07e12(slot) {
    return (0, $6AMoU.default)('MuiFormControlLabel', slot);
}
const $88faeb6780366151$var$formControlLabelClasses = (0, $ithJf.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $88faeb6780366151$export$2e2bcd8739ae039 = $88faeb6780366151$var$formControlLabelClasses;




var $2M70Q = parcelRequire("2M70Q");
'use client';
const $42a2fa0c87210680$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $42a2fa0c87210680$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $g4LX8.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $88faeb6780366151$export$717666c39ec07e12), classes);
};
const $42a2fa0c87210680$export$1b479270917a5676 = (0, $jH1k7.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $88faeb6780366151$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $g4LX8.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $88faeb6780366151$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $88faeb6780366151$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $88faeb6780366151$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $42a2fa0c87210680$var$AsteriskComponent = (0, $jH1k7.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $88faeb6780366151$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $42a2fa0c87210680$var$FormControlLabel = /*#__PURE__*/ $3OyDL.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $aBenZ.default)(props, $42a2fa0c87210680$var$_excluded);
    const muiFormControl = (0, $38dd66485068cbe7$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $26b79efadb7be4d4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $gOPoC.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $42a2fa0c87210680$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $c015ac4126046deb$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), (0, $gOPoC.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $3DmQB.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($42a2fa0c87210680$export$1b479270917a5676, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $3OyDL.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                direction: "row",
                alignItems: "center",
                children: [
                    label,
                    /*#__PURE__*/ (0, $2M70Q.jsxs)($42a2fa0c87210680$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $42a2fa0c87210680$export$2e2bcd8739ae039 = $42a2fa0c87210680$var$FormControlLabel;


const $052636c3663f28c2$var$CheckBoxComponent = (props)=>{
    const [value, setValue] = (0, $3OyDL.useState)(props.value || false);
    const disabled = props.disabled || false;
    (0, $3OyDL.useEffect)(()=>{
        setValue(props.value || false);
    }, [
        props.value
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $42a2fa0c87210680$export$2e2bcd8739ae039), {
        sx: {
            alignItems: 'flex-start'
        },
        control: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $11e9a1a673403348$export$2e2bcd8739ae039), {
            disabled: disabled,
            checked: value,
            onChange: (event)=>props.onChange && props.onChange(event.target.checked)
        }),
        label: props.label || ''
    });
};
var $052636c3663f28c2$export$2e2bcd8739ae039 = $052636c3663f28c2$var$CheckBoxComponent;




const $07e0544037b0637a$var$getSortedResults = (eventResults, sortingOption)=>{
    const items = [];
    const memberObject = {};
    eventResults.map((element)=>{
        if (element.results && Object.keys(element.results).length > 0) Object.keys(element.results).map((memberId)=>{
            if (!memberObject[memberId]) memberObject[memberId] = {
                wonOffense: 0,
                lostOffense: 0,
                lostDefense: 0,
                offensePoints: 0,
                defensePoints: 0,
                completeResult: 0
            };
            memberObject[memberId] = {
                wonOffense: memberObject[memberId].wonOffense + element.results[memberId].wonOffense,
                lostOffense: memberObject[memberId].lostOffense + element.results[memberId].lostOffense,
                lostDefense: memberObject[memberId].lostDefense + element.results[memberId].lostDefense,
                // TODO offensePoints und defensePoints noch berechnen
                offensePoints: 0,
                defensePoints: 0,
                round2: memberObject[memberId].wonOffense,
                round1: element.results[memberId].wonOffense,
                completeResult: memberObject[memberId].completeResult + element.results[memberId].completeResult
            };
        });
    });
    Object.keys(memberObject).map((memberId)=>{
        items.push({
            ...memberObject[memberId],
            memberId: memberId
        });
    });
    let sortedResult;
    switch(sortingOption){
        case (0, $46668510321f1f9f$export$19fbfcba8fe44d89).complete:
            sortedResult = items.sort((a, b)=>b.completeResult - a.completeResult);
            break;
        case (0, $46668510321f1f9f$export$19fbfcba8fe44d89).round1:
            sortedResult = items.sort((a, b)=>b.round1 - a.round1);
            break;
        case (0, $46668510321f1f9f$export$19fbfcba8fe44d89).round2:
            sortedResult = items.sort((a, b)=>b.round2 - a.round2);
            break;
    }
    return sortedResult;
};
var $07e0544037b0637a$export$2e2bcd8739ae039 = $07e0544037b0637a$var$getSortedResults;




var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");



var $10952671b2bf65c2$exports = {};
"use strict";
"use client";

Object.defineProperty($10952671b2bf65c2$exports, "__esModule", {
    value: true
});
$10952671b2bf65c2$exports.default = void 0;

var $10952671b2bf65c2$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $10952671b2bf65c2$var$_default = (0, $10952671b2bf65c2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M17.63 7H6.37C3.96 7 2 9.24 2 12s1.96 5 4.37 5h11.26c2.41 0 4.37-2.24 4.37-5s-1.96-5-4.37-5zM7.24 14.46l-2.57-2.57.7-.7 1.87 1.87 3.52-3.52.7.7-4.22 4.22z"
}), 'EditAttributes');
$10952671b2bf65c2$exports.default = $10952671b2bf65c2$var$_default;


var $e1308a8edf04f328$exports = {};
"use strict";
"use client";

Object.defineProperty($e1308a8edf04f328$exports, "__esModule", {
    value: true
});
$e1308a8edf04f328$exports.default = void 0;

var $e1308a8edf04f328$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $e1308a8edf04f328$var$_default = (0, $e1308a8edf04f328$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');
$e1308a8edf04f328$exports.default = $e1308a8edf04f328$var$_default;




var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");


var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $g4LX8 = parcelRequire("g4LX8");




var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $26f7f6ffee1f39ed$export$4b135a4b3a6c4550(slot) {
    return (0, $6AMoU.default)('MuiInputAdornment', slot);
}
const $26f7f6ffee1f39ed$var$inputAdornmentClasses = (0, $ithJf.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $26f7f6ffee1f39ed$export$2e2bcd8739ae039 = $26f7f6ffee1f39ed$var$inputAdornmentClasses;



var $jFgmT = parcelRequire("jFgmT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $251953dff96397bc$var$_span;
const $251953dff96397bc$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $251953dff96397bc$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $g4LX8.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $251953dff96397bc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $g4LX8.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $g4LX8.default)(size)}`
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $26f7f6ffee1f39ed$export$4b135a4b3a6c4550), classes);
};
const $251953dff96397bc$var$InputAdornmentRoot = (0, $jH1k7.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $251953dff96397bc$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $26f7f6ffee1f39ed$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $26f7f6ffee1f39ed$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $251953dff96397bc$var$InputAdornment = /*#__PURE__*/ $3OyDL.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $aBenZ.default)(props, $251953dff96397bc$var$_excluded);
    const muiFormControl = (0, $38dd66485068cbe7$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $gOPoC.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $251953dff96397bc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $677abf603a37a554$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($251953dff96397bc$var$InputAdornmentRoot, (0, $gOPoC.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $3DmQB.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $251953dff96397bc$var$_span || ($251953dff96397bc$var$_span = /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $251953dff96397bc$export$2e2bcd8739ae039 = $251953dff96397bc$var$InputAdornment;



const $0193f2c943b26596$var$TextInputTrash = (props)=>{
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $251953dff96397bc$export$2e2bcd8739ae039), {
        style: {
            marginRight: '-12px'
        },
        onClick: (event)=>props.onTrashClick(event),
        position: "end",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
            "aria-label": "delete",
            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c677c753a54bdfd8$exports))), {})
        })
    });
};
var $0193f2c943b26596$export$2e2bcd8739ae039 = $0193f2c943b26596$var$TextInputTrash;


/**
 * TooltipComponent
 *
 */ 
var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

var $3ed52aa8e90b7939$exports = {};
"use strict";
"use client";

Object.defineProperty($3ed52aa8e90b7939$exports, "__esModule", {
    value: true
});
$3ed52aa8e90b7939$exports.default = void 0;

var $3ed52aa8e90b7939$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $3ed52aa8e90b7939$var$_default = (0, $3ed52aa8e90b7939$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
}), 'Info');
$3ed52aa8e90b7939$exports.default = $3ed52aa8e90b7939$var$_default;


/**
 * TooltipComponent
 *
 */ 
var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $1d8633a2188b89ba$var$TooltipComponent = (props)=>{
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a0c8194f99ad3309$export$2e2bcd8739ae039), {
        title: props.title,
        placement: props.placement || 'right',
        children: props.element
    });
};
var $1d8633a2188b89ba$export$2e2bcd8739ae039 = $1d8633a2188b89ba$var$TooltipComponent;



const $97b5652ba004fde7$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        tooltipIcon: {
            cursor: 'pointer',
            margin: '0 0 0 5px',
            color: 'rgb(0,0,0,0.6)',
            width: '16px',
            height: '16px'
        }
    }));
const $97b5652ba004fde7$var$LabelWithTooltipComponent = (props)=>{
    const classes = $97b5652ba004fde7$var$useStyles();
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
            sx: {
                display: 'flex',
                flexWrap: 'nowrap'
            },
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    sx: {
                        fontSize: '12px',
                        color: 'rgb(0,0,0,0.6)'
                    },
                    variant: "body2",
                    children: props.label
                }),
                props.description && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1d8633a2188b89ba$export$2e2bcd8739ae039), {
                    title: props.description || 'hallo',
                    element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3ed52aa8e90b7939$exports))), {
                        className: classes.tooltipIcon
                    })
                })
            ]
        })
    });
};
var $97b5652ba004fde7$export$2e2bcd8739ae039 = $97b5652ba004fde7$var$LabelWithTooltipComponent;


var $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf = /*#__PURE__*/ function(TextFieldType) {
    TextFieldType["text"] = "text";
    TextFieldType["number"] = "number";
    TextFieldType["password"] = "password";
    return TextFieldType;
}({});
const $b4ce4bf716fba2b0$export$62680b65e63e14ec = {
    color: 'primary',
    disabled: false,
    size: 'medium',
    variant: 'outlined',
    type: "text",
    margin: 'dense'
};
const $b4ce4bf716fba2b0$var$TextInputComponent = (props)=>{
    const variant = props.variant || $b4ce4bf716fba2b0$export$62680b65e63e14ec.variant;
    const margin = props.margin || $b4ce4bf716fba2b0$export$62680b65e63e14ec.margin;
    const type = props.type || $b4ce4bf716fba2b0$export$62680b65e63e14ec.type;
    const label = props.label;
    const description = props.description;
    const multiline = props.multiline || false;
    const required = props.required ? props.required : false;
    const disabled = props.disabled ? props.disabled : false;
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(props.showError || false);
    (0, $3OyDL.useEffect)(()=>{
        setError(props.showError || false);
    }, [
        props.showError
    ]);
    (0, $3OyDL.useEffect)(()=>{
        props.value && setValue(props.value);
    }, [
        props.value
    ]);
    const onTrashClick = (event)=>{
        event.stopPropagation();
        setValue('');
        props.onChange && props.onChange();
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $328e9bc68740648b$export$2e2bcd8739ae039), {
            error: error,
            helperText: error && props.helperText,
            size: props.size,
            InputProps: {
                startAdornment: props.startAdornment,
                inputProps: {
                    max: props.max,
                    min: props.min
                },
                endAdornment: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                    children: (props.clearable && value || !required && value && !disabled) && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0193f2c943b26596$export$2e2bcd8739ae039), {
                        onTrashClick: (event)=>onTrashClick(event)
                    })
                }),
                readOnly: disabled,
                disabled: disabled
            },
            "aria-label": label,
            label: label && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $97b5652ba004fde7$export$2e2bcd8739ae039), {
                label: label,
                description: description
            }),
            InputLabelProps: {
                shrink: true,
                style: {
                    pointerEvents: 'auto',
                    display: 'flex',
                    alignItems: 'center'
                }
            },
            variant: variant,
            required: required,
            disabled: disabled,
            type: type,
            minRows: multiline ? props.minRows || 8 : 1,
            maxRows: multiline ? props.maxRows || 8 : 1,
            sx: {
                width: props.fullWidth ? '100%' : '300px'
            },
            margin: margin,
            autoFocus: false,
            multiline: multiline,
            value: value,
            onChange: (event)=>{
                setValue(event.target.value);
                props.onChange && props.onChange(event.target.value);
            }
        })
    });
};
var $b4ce4bf716fba2b0$export$2e2bcd8739ae039 = $b4ce4bf716fba2b0$var$TextInputComponent;







const $c93be8f0268c3535$var$getDefaultCompleteResult = (players)=>{
    const result = {
        [players[0]]: {
            sessionResult: 0,
            wonOffense: 0,
            lostOffense: 0,
            lostDefense: 0,
            offensePoints: 0,
            defensePoints: 0,
            completeResult: 0
        },
        [players[1]]: {
            sessionResult: 0,
            wonOffense: 0,
            lostOffense: 0,
            lostDefense: 0,
            offensePoints: 0,
            defensePoints: 0,
            completeResult: 0
        },
        [players[2]]: {
            sessionResult: 0,
            wonOffense: 0,
            lostOffense: 0,
            lostDefense: 0,
            offensePoints: 0,
            defensePoints: 0,
            completeResult: 0
        }
    };
    if (players.length === 4) result[players[3]] = {
        sessionResult: 0,
        wonOffense: 0,
        lostOffense: 0,
        lostDefense: 0,
        offensePoints: 0,
        defensePoints: 0,
        completeResult: 0
    };
    return result;
};
var $c93be8f0268c3535$export$2e2bcd8739ae039 = $c93be8f0268c3535$var$getDefaultCompleteResult;


const $4ba4333e5e4430b7$export$bd447ddcc9a6c1be = (eventResult, round)=>{
    return eventResult.games[round].results;
};
const $4ba4333e5e4430b7$export$d1c462c8194bd24f = (players)=>{
    const defaultResults = {
        [players[0]]: 0,
        [players[1]]: 0,
        [players[2]]: 0
    };
    if (players.length === 4) defaultResults[players[3]] = 0;
    return defaultResults;
};
const $4ba4333e5e4430b7$var$getPlayerResultsForEachRound = (eventResult)=>{
    const completeResults = {
        ...(0, $c93be8f0268c3535$export$2e2bcd8739ae039)(eventResult.players)
    };
    const calcutedEventResult = {
        ...eventResult
    };
    // completeResult zurücksetzen
    calcutedEventResult.results = (0, $c93be8f0268c3535$export$2e2bcd8739ae039)(eventResult.players);
    eventResult && Object.keys(calcutedEventResult.games).map((round, index)=>{
        const roundNumber = parseInt(round, 10);
        const roundData = calcutedEventResult.games[roundNumber];
        const newResults = roundNumber === 1 ? $4ba4333e5e4430b7$export$d1c462c8194bd24f(eventResult.players) : {
            ...$4ba4333e5e4430b7$export$bd447ddcc9a6c1be(eventResult, roundNumber - 1)
        };
        if (roundData.player) {
            // wenn gewonnen, dann drauf rechnen, wenn verloren, dann doppelt abziehen (außer bei Hand, dann nur einfach)
            if (roundData.won) {
                completeResults[roundData.player].wonOffense = completeResults[roundData.player].wonOffense + 1;
                newResults[roundData.player] = newResults[roundData.player] + (roundData.gameValue || 0);
            } else {
                completeResults[roundData.player].lostOffense = completeResults[roundData.player].lostOffense + 1;
                // bei anderen Spielern lostDefense + 1
                Object.keys(newResults).map((player)=>{
                    if (player !== roundData.player) completeResults[player].lostDefense = completeResults[player].lostDefense + 1;
                });
                const factor = roundData.hand ? 1 : 2;
                newResults[roundData.player] = newResults[roundData.player] - (roundData.gameValue || 0) * factor;
            }
            // completeResult übertragen
            completeResults[roundData.player].sessionResult = newResults[roundData.player];
        }
        calcutedEventResult.results = completeResults;
        calcutedEventResult.games[roundNumber].results = {
            ...newResults
        };
    });
    // calculate complete game
    const factor = calcutedEventResult.players.length === 4 ? 30 : 40;
    Object.keys(calcutedEventResult.results).map((player)=>{
        calcutedEventResult.results[player] = {
            ...calcutedEventResult.results[player],
            completeResult: calcutedEventResult.results[player].sessionResult + (calcutedEventResult.results[player].wonOffense - calcutedEventResult.results[player].lostOffense) * 50 + calcutedEventResult.results[player].lostDefense * factor
        };
        return calcutedEventResult.results[player];
    });
    return calcutedEventResult;
};
var $4ba4333e5e4430b7$export$2e2bcd8739ae039 = $4ba4333e5e4430b7$var$getPlayerResultsForEachRound;




var $8ef96f908dc0bdb8$exports = {};
"use strict";
"use client";

Object.defineProperty($8ef96f908dc0bdb8$exports, "__esModule", {
    value: true
});
$8ef96f908dc0bdb8$exports.default = void 0;

var $8ef96f908dc0bdb8$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $8ef96f908dc0bdb8$var$_default = (0, $8ef96f908dc0bdb8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
}), 'Save');
$8ef96f908dc0bdb8$exports.default = $8ef96f908dc0bdb8$var$_default;



var $6f042400abba8c2b$exports = {};
"use strict";
"use client";

Object.defineProperty($6f042400abba8c2b$exports, "__esModule", {
    value: true
});
$6f042400abba8c2b$exports.default = void 0;

var $6f042400abba8c2b$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $6f042400abba8c2b$var$_default = (0, $6f042400abba8c2b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');
$6f042400abba8c2b$exports.default = $6f042400abba8c2b$var$_default;




var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");














const $aefaf578420618f8$var$EditResultRound = (props)=>{
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $ead5e217b39556c6$export$9fc83ad70ead8663)();
    const restPath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
    const requestHeaders = new Headers();
    requestHeaders.set('Accept', 'application/json');
    requestHeaders.set('Content-Type', 'application/json');
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const members = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$f4931e6f9feb30c5));
    const eventResults = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$79c726a1641bb9ad));
    const player4 = props.players[3] ? props.players[3] : undefined;
    const [game, setGame] = (0, $3OyDL.useState)(props.round.game);
    const [player, setPlayer] = (0, $3OyDL.useState)(props.round.player);
    const [factor, setFactor] = (0, $3OyDL.useState)(props.round.factor);
    const [mitOhne, setMitOhne] = (0, $3OyDL.useState)(props.round.mitOhne);
    const [gameProperty, setGameProperty] = (0, $3OyDL.useState)(props.round.gameProperty || (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).einfach);
    const [win, setWin] = (0, $3OyDL.useState)(props.round.won);
    const [hand, setHand] = (0, $3OyDL.useState)(props.round.hand);
    const [player1Result, setPlayer1Result] = (0, $3OyDL.useState)(props.round.results[props.players[0]] || 0);
    const [player2Result, setPlayer2Result] = (0, $3OyDL.useState)(props.round.results[props.players[1]] || 0);
    const [player3Result, setPlayer3Result] = (0, $3OyDL.useState)(props.round.results[props.players[2]] || 0);
    const [player4Result, setPlayer4Result] = (0, $3OyDL.useState)(props.round.results[props.players[3]] || 0);
    (0, $3OyDL.useEffect)(()=>{
        setGamePropertyOptions(getGamePropertyOptions());
    }, [
        game
    ]);
    const getGameOptions = ()=>{
        return [
            {
                key: (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eichel,
                value: 'Eichel'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$985739bfa5723e08).gruen,
                value: "Gr\xfcn"
            },
            {
                key: (0, $c7fa01100a96d1f7$export$985739bfa5723e08).rot,
                value: 'Rot'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$985739bfa5723e08).schell,
                value: 'Schell'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$985739bfa5723e08).grand,
                value: 'Grand'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$985739bfa5723e08).zero,
                value: 'Null'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt,
                value: 'eingemischt'
            }
        ];
    };
    const getMitOhneOptions = ()=>{
        return [
            {
                key: '1',
                value: 'Ohne 4'
            },
            {
                key: '2',
                value: 'Ohne 3'
            },
            {
                key: '3',
                value: 'Ohne 2'
            },
            {
                key: '4',
                value: 'Ohne 1'
            },
            {
                key: '5',
                value: 'Mit 1'
            },
            {
                key: '6',
                value: 'Mit 2'
            },
            {
                key: '7',
                value: 'Mit 3'
            },
            {
                key: '8',
                value: 'Mit 4'
            }
        ];
    };
    const getGamePropertyOptions = ()=>{
        if (game === (0, $c7fa01100a96d1f7$export$985739bfa5723e08).zero) return [
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).einfach,
                value: '-'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).hand,
                value: 'Hand'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).ouvert,
                value: 'Ouvert'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handOuvert,
                value: 'Hand Ouvert'
            }
        ];
        else return [
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).einfach,
                value: 'Einfach'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).schneider,
                value: 'Schneider'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).schwarz,
                value: 'Schwarz'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).hand,
                value: 'Hand'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handSchneider,
                value: 'Hand Schneider'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handSchwarz,
                value: 'Hand Schwarz'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handSchneiderAngesagt,
                value: 'Hand Schneider angesagt'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handSchneiderAngesagtSchwarz,
                value: 'Hand Schneider angesagt Schwarz'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handSchwarzAngesagt,
                value: 'Hand Schwarz angesagt'
            },
            {
                key: (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handOuvert,
                value: 'Hand Ouvert'
            }
        ];
    };
    const gameOptions = getGameOptions();
    const mitOhneOptions = getMitOhneOptions();
    const [gamePropertyOptions, setGamePropertyOptions] = (0, $3OyDL.useState)(getGamePropertyOptions());
    const getGameValue = ()=>{
        let gameValue = 0;
        switch(game){
            case (0, $c7fa01100a96d1f7$export$985739bfa5723e08).grand:
                gameValue = 24;
                break;
            case (0, $c7fa01100a96d1f7$export$985739bfa5723e08).zero:
                gameValue = 23;
                break;
            case (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eichel:
                gameValue = 12;
                break;
            case (0, $c7fa01100a96d1f7$export$985739bfa5723e08).gruen:
                gameValue = 11;
                break;
            case (0, $c7fa01100a96d1f7$export$985739bfa5723e08).rot:
                gameValue = 10;
                break;
            case (0, $c7fa01100a96d1f7$export$985739bfa5723e08).schell:
                gameValue = 9;
                break;
            case (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt:
                gameValue = 0;
                break;
        }
        let propertyFactor = 0;
        switch(gameProperty){
            case (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).einfach:
                propertyFactor = 0;
                break;
            case (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).schneider:
                propertyFactor = 1;
                break;
            case (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).schwarz:
                propertyFactor = 2;
                break;
            case (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).ouvert:
                propertyFactor = 0;
                break;
            case (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).hand:
                propertyFactor = 1;
                break;
            case (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handSchneider:
                propertyFactor = 2;
                break;
            case (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handSchwarz:
                propertyFactor = 3;
                break;
            case (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handSchneiderAngesagt:
                propertyFactor = 3;
                break;
            case (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handSchneiderAngesagtSchwarz:
                propertyFactor = 4;
                break;
            case (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handSchwarzAngesagt:
                propertyFactor = 5;
                break;
            case (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handOuvert:
                propertyFactor = 6;
                break;
        }
        if (game === (0, $c7fa01100a96d1f7$export$985739bfa5723e08).zero) return gameProperty === (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).hand ? 35 : gameProperty === (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).ouvert ? 46 : gameProperty === (0, $c7fa01100a96d1f7$export$bc6f4160c6da2a6b).handOuvert ? 59 : 23;
        else return factor ? gameValue * (factor + 1 + propertyFactor) : 0;
    };
    const getGamerOptions = ()=>{
        const options = [];
        props.players?.map((elem)=>{
            const member = members?.results.find((member)=>member.originId === elem);
            member && options.push({
                key: elem,
                value: `${member.firstname} ${member.lastname.charAt(0)}.`
            });
        });
        return options;
    };
    const saveResult = ()=>{
        const validGame = true;
        if (validGame) {
            const value = win ? getGameValue() : hand ? getGameValue() * -1 : getGameValue() * -2;
            // neues Spiel in DB speichern
            const restUrl = `${restPath}/api/${(0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)()}/game`;
            props?.id && fetch(restUrl, {
                method: props.round.id ? 'PUT' : 'POST',
                body: JSON.stringify({
                    game: {
                        id: props.round.id,
                        roundId: props?.id,
                        gameNumber: props.gameNumber,
                        gameValue: value,
                        gameProperty: gameProperty,
                        mitOhne: mitOhne,
                        hand: hand,
                        game: game,
                        won: win,
                        factor: factor,
                        player: player,
                        eventId: props.eventId,
                        player1Result: props.advancedEdit ? player1Result : null,
                        player2Result: props.advancedEdit ? player2Result : null,
                        player3Result: props.advancedEdit ? player3Result : null,
                        player4Result: props.advancedEdit ? player4Result : null
                    }
                }),
                credentials: 'include',
                headers: requestHeaders
            }).then((res)=>res.json()).then((json)=>{
                dispatch($5993246da723f2dd$export$32f26ecd1d16cf({
                    ...eventResults,
                    [props.eventId]: json.results
                }));
            }).catch((err)=>console.log(err));
        } else dispatch($7173820326fb9f6c$export$706cdae1b5419ef8({
            severity: (0, $c7fa01100a96d1f7$export$918a9776c0a3cf27).error,
            message: `Ein verlorenes Spiel kann nicht ${t(`options:${gameProperty}`)} gespielt worden sein.`
        }));
    };
    const getMitOhneValue = (mitOhne, factor)=>{
        let value = '1';
        if (mitOhne && factor) {
            switch(factor){
                case 1:
                    if (mitOhne === (0, $c7fa01100a96d1f7$export$dfa1772eefa7c8c2).mit) value = '5';
                    else value = '4';
                    break;
                case 2:
                    if (mitOhne === (0, $c7fa01100a96d1f7$export$dfa1772eefa7c8c2).mit) value = '6';
                    else value = '3';
                    break;
                case 3:
                    if (mitOhne === (0, $c7fa01100a96d1f7$export$dfa1772eefa7c8c2).mit) value = '7';
                    else value = '2';
                    break;
                case 4:
                    if (mitOhne === (0, $c7fa01100a96d1f7$export$dfa1772eefa7c8c2).mit) value = '8';
                    else value = '1';
                    break;
            }
            return value;
        }
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            props.advancedEdit ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                        align: "center",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            children: props.round.gameValue || 0
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                width: '150px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    label: "Spielwert",
                                    value: player1Result,
                                    onChange: (value)=>{
                                        value && setPlayer1Result(parseInt(value, 10));
                                    }
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'flex',
                                        flexWrap: 'nowrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                            label: "gew.",
                                            value: player === props.players[0] ? win : false,
                                            onChange: (value)=>{
                                                setWin(value);
                                                setPlayer(props.players[0]);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                            label: "verl.",
                                            value: player === props.players[0] ? !win : false,
                                            onChange: (value)=>{
                                                setWin(value);
                                                setPlayer(props.players[0]);
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                width: '150px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    label: "Spielwert",
                                    value: player2Result,
                                    onChange: (value)=>{
                                        value && setPlayer2Result(parseInt(value, 10));
                                    }
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'flex',
                                        flexWrap: 'nowrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                            label: "gew.",
                                            value: player === props.players[1] ? win : false,
                                            onChange: (value)=>{
                                                setWin(value);
                                                setPlayer(props.players[1]);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                            label: "verl.",
                                            value: player === props.players[1] ? !win : false,
                                            onChange: (value)=>{
                                                setWin(value);
                                                setPlayer(props.players[1]);
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                width: '150px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    label: "Spielwert",
                                    value: player3Result,
                                    onChange: (value)=>{
                                        value && setPlayer3Result(parseInt(value, 10));
                                    }
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'flex',
                                        flexWrap: 'nowrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                            label: "gew.",
                                            value: player === props.players[2] ? win : false,
                                            onChange: (value)=>{
                                                setWin(value);
                                                setPlayer(props.players[2]);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                            label: "verl.",
                                            value: player === props.players[2] ? !win : false,
                                            onChange: (value)=>{
                                                setWin(value);
                                                setPlayer(props.players[2]);
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                width: '150px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    label: "Spielwert",
                                    value: player4Result || 0,
                                    onChange: (value)=>{
                                        value && setPlayer4Result(parseInt(value, 10));
                                    }
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'flex',
                                        flexWrap: 'nowrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                            label: "gew.",
                                            value: player === props.players[3] ? win : false,
                                            onChange: (value)=>{
                                                setWin(value);
                                                setPlayer(props.players[3]);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                            label: "verl.",
                                            value: player === props.players[3] ? !win : false,
                                            onChange: (value)=>{
                                                setWin(value);
                                                setPlayer(props.players[3]);
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                colSpan: player4 ? 5 : 4,
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                    container: true,
                    padding: 2,
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            xs: downMd ? 12 : 2,
                            sx: {
                                padding: '5px'
                            },
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                value: game,
                                label: "Spiel",
                                options: gameOptions,
                                onChange: (value)=>{
                                    if (value) {
                                        setGame(value.key);
                                        if (value.key === (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt) {
                                            setWin(true);
                                            setPlayer(props.dealer);
                                            setFactor(undefined);
                                            setGameProperty(undefined);
                                            setMitOhne(undefined);
                                            setHand(undefined);
                                        }
                                    } else {
                                        setPlayer(undefined);
                                        setGame(undefined);
                                    }
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            xs: downMd ? 12 : 2,
                            sx: {
                                padding: '5px'
                            },
                            children: game && game !== (0, $c7fa01100a96d1f7$export$985739bfa5723e08).zero && game !== (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                value: getMitOhneValue(mitOhne, factor),
                                label: "Mit / Ohne",
                                options: mitOhneOptions,
                                onChange: (value)=>{
                                    let tempMitOhne = (0, $c7fa01100a96d1f7$export$dfa1772eefa7c8c2).mit;
                                    let tempFactor = 1;
                                    switch(value?.key){
                                        case '1':
                                            tempMitOhne = (0, $c7fa01100a96d1f7$export$dfa1772eefa7c8c2).ohne;
                                            tempFactor = 4;
                                            break;
                                        case '2':
                                            tempMitOhne = (0, $c7fa01100a96d1f7$export$dfa1772eefa7c8c2).ohne;
                                            tempFactor = 3;
                                            break;
                                        case '3':
                                            tempMitOhne = (0, $c7fa01100a96d1f7$export$dfa1772eefa7c8c2).ohne;
                                            tempFactor = 2;
                                            break;
                                        case '4':
                                            tempMitOhne = (0, $c7fa01100a96d1f7$export$dfa1772eefa7c8c2).ohne;
                                            tempFactor = 1;
                                            break;
                                        case '5':
                                            tempMitOhne = (0, $c7fa01100a96d1f7$export$dfa1772eefa7c8c2).mit;
                                            tempFactor = 1;
                                            break;
                                        case '6':
                                            tempMitOhne = (0, $c7fa01100a96d1f7$export$dfa1772eefa7c8c2).mit;
                                            tempFactor = 2;
                                            break;
                                        case '7':
                                            tempMitOhne = (0, $c7fa01100a96d1f7$export$dfa1772eefa7c8c2).mit;
                                            tempFactor = 3;
                                            break;
                                        case '8':
                                            tempMitOhne = (0, $c7fa01100a96d1f7$export$dfa1772eefa7c8c2).mit;
                                            tempFactor = 4;
                                            break;
                                    }
                                    setMitOhne(tempMitOhne);
                                    setFactor(tempFactor);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            xs: downMd ? 12 : 3,
                            sx: {
                                padding: '5px'
                            },
                            children: game && game !== (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                value: gameProperty,
                                label: "Gespielt",
                                options: gamePropertyOptions,
                                onChange: (value)=>{
                                    if (value) setGameProperty(value.key);
                                    else setGameProperty(undefined);
                                    if (value?.key.startsWith('hand')) setHand(true);
                                    else setHand(false);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            xs: downMd ? 12 : 2,
                            sx: {
                                padding: '5px'
                            },
                            children: game && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                value: player,
                                label: game === (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt ? 'Kartengeber' : 'Spieler',
                                options: getGamerOptions(),
                                onChange: (value)=>{
                                    if (value) setPlayer(value.key);
                                    else setPlayer(undefined);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            xs: downMd ? 12 : 2,
                            sx: {
                                padding: '5px'
                            },
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    height: '56px',
                                    marginTop: '8px',
                                    display: 'flex',
                                    alignItems: 'center'
                                },
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                    label: "Gewonnen?",
                                    disabled: game === (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt,
                                    value: win,
                                    onChange: (value)=>{
                                        setWin(value);
                                    }
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                    disabled: !game && !player,
                    onClick: ()=>saveResult(),
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8ef96f908dc0bdb8$exports))), {})
                })
            })
        ]
    });
};
var $aefaf578420618f8$export$2e2bcd8739ae039 = $aefaf578420618f8$var$EditResultRound;




const $b1de94706b48215e$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        playerResult: {
            fontWeight: 'bold'
        },
        tableHeader: {
            textAlign: 'center',
            fontWeight: 'bold',
            verticalAlign: 'bottom'
        },
        dealer: {
            backgroundColor: 'lightgrey'
        },
        stickyFooter: {
            position: 'sticky',
            bottom: 0
        },
        footer: {
            fontWeight: 'bold',
            textAlign: 'center'
        },
        footerTitle: {
            fontWeight: 'bold',
            textAlign: 'right'
        },
        baseBox: {
            position: 'relative'
        }
    }));
const $b1de94706b48215e$var$NewEventResults = (props)=>{
    const classes = $b1de94706b48215e$var$useStyles();
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const restPath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
    const requestHeaders = new Headers();
    requestHeaders.set('Accept', 'application/json');
    requestHeaders.set('Content-Type', 'application/json');
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const downXl = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('xl'));
    const members = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$f4931e6f9feb30c5));
    const [player1, setPlayer1] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [player2, setPlayer2] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [player3, setPlayer3] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [player4, setPlayer4] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [session, setSession] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(undefined);
    const [table, setTable] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(undefined);
    const [games, setgames] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState([]);
    const [newEventResult, setNewEventResult] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(props.eventResult);
    const [editRound, setEditRound] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(undefined);
    const [advancedEdit, setAdvancedEdit] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const [newRound, setNewRound] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(undefined);
    const [editCompleteResult, setEditCompleteResult] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const [actualDealer, setActualDealer] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [footerOpen, setFooterOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    (0, $3OyDL.useEffect)(()=>{
        let saveAllowed = true;
        if (!!newRound || !!editRound || !!editCompleteResult) saveAllowed = false;
        props.saveAllowed(saveAllowed);
    }, [
        newRound,
        editRound,
        editCompleteResult
    ]);
    (0, $3OyDL.useEffect)(()=>{
        console.log(newEventResult);
    }, [
        newEventResult
    ]);
    (0, $3OyDL.useEffect)(()=>{
        setNewRound(undefined);
        setEditRound(undefined);
        setNewEventResult(props.eventResult);
    }, [
        props.eventResult
    ]);
    const getPlayerName = (id)=>{
        const member = members?.results.find((member)=>member.originId === id);
        return member ? `${member.firstname} ${member.lastname}` : null;
    };
    const getPlayerInitial = (id)=>{
        const member = members?.results.find((member)=>member.originId === id);
        return member ? `${member.firstname.charAt(0)}${member.lastname.charAt(0)}` : null;
    };
    (0, $3OyDL.useEffect)(()=>{
        const resultList = props.eventResult;
        const games = [];
        resultList && Object.keys(resultList?.games).map((round)=>{
            games.push(parseInt(round, 10));
        });
        setNewEventResult(resultList);
        setTable(resultList?.table);
        setSession(resultList?.session);
        setgames(games);
        setPlayer1(resultList?.players[0]);
        setPlayer2(resultList?.players[1]);
        setPlayer3(resultList?.players[2]);
        if (resultList?.players.length === 4) setPlayer4(resultList?.players[3]);
    }, []);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("b", {
                    children: [
                        "Durchgang: ",
                        session
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("b", {
                    children: [
                        "Tisch: ",
                        table
                    ]
                })
            }),
            !downMd ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                size: "small",
                stickyHeader: true,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    sx: {
                                        width: '80px',
                                        maxWidth: '80px'
                                    },
                                    children: "Runde"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    sx: {
                                        width: '100px',
                                        maxWidth: '100px'
                                    },
                                    children: "Spielwert"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    sx: {
                                        minWidth: '100px'
                                    },
                                    children: player1 && getPlayerName(player1)
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    sx: {
                                        minWidth: '100px'
                                    },
                                    children: player2 && getPlayerName(player2)
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    sx: {
                                        minWidth: '100px'
                                    },
                                    children: player3 && getPlayerName(player3)
                                }),
                                player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    sx: {
                                        minWidth: '100px'
                                    },
                                    children: player4 && getPlayerName(player4)
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    sx: {
                                        width: '30px'
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                        children: games?.map((round)=>{
                            return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        align: "center",
                                        children: round
                                    }),
                                    newEventResult?.games[round].player ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                        children: editRound !== round ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                    align: "center",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "body1",
                                                        children: newEventResult?.games[round].gameValue
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                    className: round % (player4 ? 4 : 3) === 1 ? classes.dealer : '',
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                        container: true,
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                item: true,
                                                                xs: 6,
                                                                sx: {
                                                                    width: '30px',
                                                                    maxWidth: '30px',
                                                                    textAlign: 'center'
                                                                },
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                    className: classes.playerResult,
                                                                    children: newEventResult?.games[round].game === (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt ? round % (player4 ? 4 : 3) === 1 ? player1 && newEventResult?.games[round].results[player1] ? newEventResult?.games[round].results[player1] : 0 : '-' : player1 && newEventResult?.games[round].player === player1 && newEventResult?.games[round].gameValue ? newEventResult?.games[round].results[player1] : '-'
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                item: true,
                                                                xs: 6,
                                                                sx: {
                                                                    display: 'flex',
                                                                    flexWrap: downXl ? 'wrap' : 'nowrap'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                        label: "gew.",
                                                                        value: player1 && newEventResult?.games[round].player === player1 ? newEventResult?.games[round].won : false,
                                                                        disabled: true,
                                                                        onChange: (value)=>{
                                                                            if (newEventResult?.games[round] && value) {
                                                                                const tempResult = {
                                                                                    ...newEventResult,
                                                                                    games: {
                                                                                        ...newEventResult?.games,
                                                                                        [round]: {
                                                                                            ...newEventResult?.games[round],
                                                                                            win: true,
                                                                                            player: player1
                                                                                        }
                                                                                    }
                                                                                };
                                                                                tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                            }
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                        label: "verl.",
                                                                        value: player1 && newEventResult?.games[round].player === player1 ? !newEventResult?.games[round].won : false,
                                                                        disabled: true,
                                                                        onChange: (value)=>{
                                                                            if (newEventResult?.games[round] && value) {
                                                                                const tempResult = {
                                                                                    ...newEventResult,
                                                                                    games: {
                                                                                        ...newEventResult?.games,
                                                                                        [round]: {
                                                                                            ...newEventResult?.games[round],
                                                                                            win: false,
                                                                                            player: player1
                                                                                        }
                                                                                    }
                                                                                };
                                                                                tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                            }
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                    className: round % (player4 ? 4 : 3) === 2 ? classes.dealer : '',
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                        container: true,
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                item: true,
                                                                xs: 6,
                                                                sx: {
                                                                    width: '30px',
                                                                    maxWidth: '30px',
                                                                    textAlign: 'center'
                                                                },
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                    className: classes.playerResult,
                                                                    children: newEventResult?.games[round].game === (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt ? round % (player4 ? 4 : 3) === 2 ? player2 && newEventResult?.games[round].results[player2] ? newEventResult?.games[round].results[player2] : 0 : '-' : player2 && newEventResult?.games[round].player === player2 && newEventResult?.games[round].gameValue ? newEventResult?.games[round].results[player2] : '-'
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                item: true,
                                                                xs: 6,
                                                                sx: {
                                                                    display: 'flex',
                                                                    flexWrap: downXl ? 'wrap' : 'nowrap'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                        disabled: true,
                                                                        onChange: (value)=>{
                                                                            if (newEventResult?.games[round] && value) {
                                                                                const tempResult = {
                                                                                    ...newEventResult,
                                                                                    games: {
                                                                                        ...newEventResult?.games,
                                                                                        [round]: {
                                                                                            ...newEventResult?.games[round],
                                                                                            win: true,
                                                                                            player: player2
                                                                                        }
                                                                                    }
                                                                                };
                                                                                tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                            }
                                                                        },
                                                                        label: "gew.",
                                                                        value: player2 && newEventResult?.games[round].player === player2 ? newEventResult?.games[round].won : false
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                        disabled: true,
                                                                        onChange: (value)=>{
                                                                            if (newEventResult?.games[round] && value) {
                                                                                const tempResult = {
                                                                                    ...newEventResult,
                                                                                    games: {
                                                                                        ...newEventResult?.games,
                                                                                        [round]: {
                                                                                            ...newEventResult?.games[round],
                                                                                            win: false,
                                                                                            player: player2
                                                                                        }
                                                                                    }
                                                                                };
                                                                                tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                            }
                                                                        },
                                                                        label: "verl.",
                                                                        value: player2 && newEventResult?.games[round].player === player2 ? !newEventResult?.games[round].won : false
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                    className: round % (player4 ? 4 : 3) === (player4 ? 3 : 0) ? classes.dealer : '',
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                        container: true,
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                item: true,
                                                                xs: 6,
                                                                sx: {
                                                                    width: '30px',
                                                                    maxWidth: '30px',
                                                                    textAlign: 'center'
                                                                },
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                    className: classes.playerResult,
                                                                    children: newEventResult?.games[round].game === (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt ? round % (player4 ? 4 : 3) === 0 ? player3 && newEventResult?.games[round].results[player3] ? newEventResult?.games[round].results[player3] : 0 : '-' : player3 && newEventResult?.games[round].player === player3 && newEventResult?.games[round].gameValue ? newEventResult?.games[round].results[player3] : '-'
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                item: true,
                                                                xs: 6,
                                                                sx: {
                                                                    display: 'flex',
                                                                    flexWrap: downXl ? 'wrap' : 'nowrap'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                        label: "gew.",
                                                                        value: player3 && newEventResult?.games[round].player === player3 ? newEventResult?.games[round].won : false,
                                                                        disabled: true,
                                                                        onChange: (value)=>{
                                                                            if (newEventResult?.games[round] && value) {
                                                                                const tempResult = {
                                                                                    ...newEventResult,
                                                                                    games: {
                                                                                        ...newEventResult?.games,
                                                                                        [round]: {
                                                                                            ...newEventResult?.games[round],
                                                                                            win: true,
                                                                                            player: player3
                                                                                        }
                                                                                    }
                                                                                };
                                                                                tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                            }
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                        label: "verl.",
                                                                        value: player3 && newEventResult?.games[round].player === player3 ? !newEventResult?.games[round].won : false,
                                                                        disabled: true,
                                                                        onChange: (value)=>{
                                                                            if (newEventResult?.games[round] && value) {
                                                                                const tempResult = {
                                                                                    ...newEventResult,
                                                                                    games: {
                                                                                        ...newEventResult?.games,
                                                                                        [round]: {
                                                                                            ...newEventResult?.games[round],
                                                                                            win: false,
                                                                                            player: player3
                                                                                        }
                                                                                    }
                                                                                };
                                                                                tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                            }
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                    className: round % (player4 ? 4 : 3) === 0 ? classes.dealer : '',
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                        container: true,
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                item: true,
                                                                xs: 6,
                                                                sx: {
                                                                    width: '30px',
                                                                    maxWidth: '30px',
                                                                    textAlign: 'center'
                                                                },
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                    className: classes.playerResult,
                                                                    children: newEventResult?.games[round]?.game === (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt ? round % (player4 ? 4 : 3) === 0 ? player4 && newEventResult?.games[round].results[player4] ? newEventResult?.games[round].results[player4] : 0 : '-' : player4 && newEventResult?.games[round].player === player4 && newEventResult?.games[round].gameValue ? newEventResult?.games[round].results[player4] : '-'
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                item: true,
                                                                xs: 6,
                                                                sx: {
                                                                    display: 'flex',
                                                                    flexWrap: downXl ? 'wrap' : 'nowrap'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                        label: "gew.",
                                                                        value: player4 && newEventResult?.games[round]?.player === player4 ? newEventResult?.games[round].won : false,
                                                                        disabled: true,
                                                                        onChange: (value)=>{
                                                                            if (newEventResult?.games[round] && value) {
                                                                                const tempResult = {
                                                                                    ...newEventResult,
                                                                                    games: {
                                                                                        ...newEventResult?.games,
                                                                                        [round]: {
                                                                                            ...newEventResult?.games[round],
                                                                                            win: true,
                                                                                            player: player4
                                                                                        }
                                                                                    }
                                                                                };
                                                                                tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                            }
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                        label: "verl.",
                                                                        value: player4 && newEventResult?.games[round].player === player4 ? !newEventResult?.games[round].won : false,
                                                                        disabled: true,
                                                                        onChange: (value)=>{
                                                                            if (newEventResult?.games[round] && value) {
                                                                                const tempResult = {
                                                                                    ...newEventResult,
                                                                                    games: {
                                                                                        ...newEventResult?.games,
                                                                                        [round]: {
                                                                                            ...newEventResult?.games[round],
                                                                                            win: false,
                                                                                            player: player4
                                                                                        }
                                                                                    }
                                                                                };
                                                                                tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                            }
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                            disabled: !!newRound,
                                                            onClick: ()=>{
                                                                setEditRound(round);
                                                                setAdvancedEdit(false);
                                                            },
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($748d42c5fe8bcf47$exports))), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                            disabled: !!newRound,
                                                            onClick: ()=>{
                                                                setEditRound(round);
                                                                setAdvancedEdit(true);
                                                            },
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($10952671b2bf65c2$exports))), {})
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                            children: newEventResult?.players && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $aefaf578420618f8$export$2e2bcd8739ae039), {
                                                id: props.eventResult?.id,
                                                roundNumber: round,
                                                round: newEventResult?.games[round],
                                                players: newEventResult?.players,
                                                dealer: actualDealer,
                                                eventId: props.event.id,
                                                gameNumber: round,
                                                eventResult: newEventResult,
                                                advancedEdit: advancedEdit
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                        children: newEventResult?.players && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $aefaf578420618f8$export$2e2bcd8739ae039), {
                                            id: props.eventResult?.id,
                                            roundNumber: round,
                                            round: newEventResult?.games[round],
                                            players: newEventResult?.players,
                                            dealer: actualDealer,
                                            eventId: props.event.id,
                                            gameNumber: round,
                                            eventResult: newEventResult,
                                            advancedEdit: false
                                        })
                                    })
                                ]
                            }, round);
                        })
                    }),
                    !footerOpen && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                        className: classes.stickyFooter,
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.footerTitle,
                                    colSpan: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                            onClick: ()=>setFooterOpen(!footerOpen),
                                            children: footerOpen ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e1308a8edf04f328$exports))), {}) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1e0e42f5f37a7922$exports))), {})
                                        }),
                                        "Ergebnis"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.footer,
                                    children: player1 && newEventResult?.results && newEventResult?.results[player1]?.sessionResult
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.footer,
                                    children: player2 && newEventResult?.results && newEventResult?.results[player2]?.sessionResult
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.footer,
                                    children: player3 && newEventResult?.results && newEventResult?.results[player3]?.sessionResult
                                }),
                                player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.footer,
                                    children: player4 && newEventResult?.results && newEventResult?.results[player4]?.sessionResult
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.footer,
                                    sx: {
                                        width: '30px'
                                    }
                                })
                            ]
                        })
                    }),
                    footerOpen && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                        className: classes.stickyFooter,
                        sx: {
                            width: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footerTitle,
                                        colSpan: 2,
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                onClick: ()=>setFooterOpen(!footerOpen),
                                                children: footerOpen ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e1308a8edf04f328$exports))), {}) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1e0e42f5f37a7922$exports))), {})
                                            }),
                                            "Ergebnis"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: player1 && newEventResult?.results && newEventResult?.results[player1]?.sessionResult
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: player2 && newEventResult?.results && newEventResult?.results[player2]?.sessionResult
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: player3 && newEventResult?.results && newEventResult?.results[player3]?.sessionResult
                                    }),
                                    player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: player4 && newEventResult?.results && newEventResult?.results[player4]?.sessionResult
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        sx: {
                                            width: '30px'
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                sx: {
                                    width: '100%}'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footerTitle,
                                        colSpan: 2,
                                        children: "Gew. / Verl."
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: `${player1 && newEventResult?.results && newEventResult?.results[player1]?.wonOffense} / ${player1 && newEventResult?.results && newEventResult?.results[player1]?.lostOffense}`
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: `${player2 && newEventResult?.results && newEventResult?.results[player2]?.wonOffense} / ${player2 && newEventResult?.results && newEventResult?.results[player2]?.lostOffense}`
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: `${player3 && newEventResult?.results && newEventResult?.results[player3]?.wonOffense} / ${player3 && newEventResult?.results && newEventResult?.results[player3]?.lostOffense}`
                                    }),
                                    player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: `${player4 && newEventResult?.results && newEventResult?.results[player4]?.wonOffense} / ${player4 && newEventResult?.results && newEventResult?.results[player4]?.lostOffense}`
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        sx: {
                                            width: '30px'
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footerTitle,
                                        colSpan: 2,
                                        children: [
                                            "+50 je gew. Spiel ",
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                                            "-50 je verl. Spiel"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: player1 && newEventResult?.results && ((newEventResult?.results[player1]?.wonOffense || 0) - (newEventResult?.results[player1]?.lostOffense || 0)) * 50
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: player2 && newEventResult?.results && ((newEventResult?.results[player2]?.wonOffense || 0) - (newEventResult?.results[player2]?.lostOffense || 0)) * 50
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: player3 && newEventResult?.results && ((newEventResult?.results[player3]?.wonOffense || 0) - (newEventResult?.results[player3]?.lostOffense || 0)) * 50
                                    }),
                                    player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: player4 && newEventResult?.results && ((newEventResult?.results[player4]?.wonOffense || 0) - (newEventResult?.results[player4]?.lostOffense || 0)) * 50
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footerTitle,
                                        colSpan: 2,
                                        children: [
                                            "+",
                                            player4 ? 30 : 40,
                                            " je verlorenes Spiel des Gegners"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: player1 && newEventResult?.results && (newEventResult?.results[player1]?.lostDefense || 0) * (player4 ? 30 : 40)
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: player2 && newEventResult?.results && (newEventResult?.results[player2]?.lostDefense || 0) * (player4 ? 30 : 40)
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: player3 && newEventResult?.results && (newEventResult?.results[player3]?.lostDefense || 0) * (player4 ? 30 : 40)
                                    }),
                                    player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: player4 && newEventResult?.results && (newEventResult?.results[player4]?.lostDefense || 0) * 30
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footerTitle,
                                        colSpan: 2,
                                        children: "Gesamtergebnis"
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: editCompleteResult ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            required: true,
                                            type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).number,
                                            onChange: (value)=>{
                                                if (newEventResult?.results && player1) {
                                                    const tempResult = {
                                                        ...newEventResult,
                                                        results: {
                                                            ...newEventResult?.results,
                                                            [player1]: {
                                                                ...newEventResult?.results[player1],
                                                                completeResult: parseInt(value, 10)
                                                            }
                                                        }
                                                    };
                                                    setNewEventResult(tempResult);
                                                }
                                            },
                                            value: player1 && newEventResult?.results ? newEventResult?.results[player1]?.completeResult : 0
                                        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                            children: player1 && newEventResult?.results && newEventResult?.results[player1]?.completeResult
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: editCompleteResult ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            required: true,
                                            type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).number,
                                            onChange: (value)=>{
                                                if (newEventResult?.results && player2) {
                                                    const tempResult = {
                                                        ...newEventResult,
                                                        results: {
                                                            ...newEventResult?.results,
                                                            [player2]: {
                                                                ...newEventResult?.results[player2],
                                                                completeResult: parseInt(value, 10)
                                                            }
                                                        }
                                                    };
                                                    setNewEventResult(tempResult);
                                                }
                                            },
                                            value: player2 && newEventResult?.results ? newEventResult?.results[player2]?.completeResult : 0
                                        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                            children: player2 && newEventResult?.results && newEventResult?.results[player2]?.completeResult
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: editCompleteResult ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            required: true,
                                            type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).number,
                                            onChange: (value)=>{
                                                if (newEventResult?.results && player3) {
                                                    const tempResult = {
                                                        ...newEventResult,
                                                        results: {
                                                            ...newEventResult?.results,
                                                            [player3]: {
                                                                ...newEventResult?.results[player3],
                                                                completeResult: parseInt(value, 10)
                                                            }
                                                        }
                                                    };
                                                    setNewEventResult(tempResult);
                                                }
                                            },
                                            value: player3 && newEventResult?.results ? newEventResult?.results[player3]?.completeResult : 0
                                        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                            children: player3 && newEventResult?.results && newEventResult?.results[player3]?.completeResult
                                        })
                                    }),
                                    player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: editCompleteResult ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            required: true,
                                            type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).number,
                                            onChange: (value)=>{
                                                if (newEventResult?.results && player4) {
                                                    const tempResult = {
                                                        ...newEventResult,
                                                        results: {
                                                            ...newEventResult?.results,
                                                            [player4]: {
                                                                ...newEventResult?.results[player4],
                                                                completeResult: parseInt(value, 10)
                                                            }
                                                        }
                                                    };
                                                    setNewEventResult(tempResult);
                                                }
                                            },
                                            value: player4 && newEventResult?.results ? newEventResult?.results[player4]?.completeResult : 0
                                        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                            children: player4 && newEventResult?.results && newEventResult?.results[player4]?.completeResult
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        children: editCompleteResult ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                            onClick: ()=>{
                                                setEditCompleteResult(false);
                                                // Speichern des completeResults
                                                const restUrl = `${restPath}/api/${(0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)()}/results`;
                                                const playerResults = [];
                                                newEventResult && Object.keys(newEventResult.results).forEach((member)=>{
                                                    playerResults.push({
                                                        memberId: member,
                                                        roundResult: newEventResult?.results[member].sessionResult,
                                                        lostDefense: newEventResult?.results[member].lostDefense,
                                                        lostOffense: newEventResult?.results[member].lostOffense,
                                                        wonOffense: newEventResult?.results[member].wonOffense,
                                                        defensePoints: newEventResult?.results[member].defensePoints,
                                                        offensePoints: newEventResult?.results[member].offensePoints,
                                                        completeResult: newEventResult?.results[member].completeResult
                                                    });
                                                });
                                                const body = {
                                                    table: newEventResult?.table,
                                                    session: newEventResult?.session,
                                                    eventId: props.event?.id,
                                                    playerResults: playerResults
                                                };
                                                fetch(restUrl, {
                                                    method: 'PUT',
                                                    body: JSON.stringify(body),
                                                    credentials: 'include',
                                                    headers: requestHeaders
                                                }).then((res)=>res.json()).then((json)=>{
                                                    setNewEventResult(json.results.find((elem)=>elem.table === newEventResult?.table && elem.session === newEventResult?.session));
                                                }).catch((err)=>console.log(err));
                                            },
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8ef96f908dc0bdb8$exports))), {})
                                        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                            onClick: ()=>setEditCompleteResult(true),
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($748d42c5fe8bcf47$exports))), {})
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                size: "small",
                stickyHeader: true,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    padding: "none",
                                    className: classes.tableHeader,
                                    sx: {
                                        width: '30px',
                                        maxWidth: '30px'
                                    },
                                    children: "Nr."
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    padding: "none",
                                    className: classes.tableHeader,
                                    sx: {
                                        width: '30px',
                                        maxWidth: '30px'
                                    },
                                    children: "Spiel"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    padding: "none",
                                    className: classes.tableHeader,
                                    sx: {
                                        minWidth: '70px'
                                    },
                                    children: player1 && getPlayerInitial(player1)
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    padding: "none",
                                    className: classes.tableHeader,
                                    sx: {
                                        minWidth: '70px'
                                    },
                                    children: player2 && getPlayerInitial(player2)
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    padding: "none",
                                    className: classes.tableHeader,
                                    sx: {
                                        minWidth: '70px'
                                    },
                                    children: player3 && getPlayerInitial(player3)
                                }),
                                player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    padding: "none",
                                    className: classes.tableHeader,
                                    sx: {
                                        minWidth: '70px'
                                    },
                                    children: player4 && getPlayerInitial(player4)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                        children: games.map((round)=>{
                            return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        align: "left",
                                        padding: "none",
                                        children: [
                                            editRound && editRound === round ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                onClick: ()=>console.log('SAVING IS BUGGY > Mobile???'),
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8ef96f908dc0bdb8$exports))), {})
                                            }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                disabled: !!newRound,
                                                onClick: ()=>setEditRound(round),
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($748d42c5fe8bcf47$exports))), {})
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                variant: "caption",
                                                children: round
                                            })
                                        ]
                                    }),
                                    newEventResult?.games[round].player ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                align: "center",
                                                padding: "none",
                                                children: editRound !== round ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    variant: "caption",
                                                    children: newEventResult?.games[round].gameValue || 0
                                                }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    fullWidth: true,
                                                    required: true,
                                                    type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).number,
                                                    label: "Spielwert",
                                                    onChange: (value)=>{
                                                        if (newEventResult?.games[round].gameValue) {
                                                            const tempResult = {
                                                                ...newEventResult,
                                                                games: {
                                                                    ...newEventResult?.games,
                                                                    [round]: {
                                                                        ...newEventResult?.games[round],
                                                                        gameValue: parseInt(games, 10)
                                                                    }
                                                                }
                                                            };
                                                            tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                        }
                                                    },
                                                    value: newEventResult?.games[round].gameValue || 0
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                padding: "none",
                                                className: round % (player4 ? 4 : 3) === 1 ? classes.dealer : '',
                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                    container: true,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            sx: {
                                                                width: '20px',
                                                                maxWidth: '20px',
                                                                textAlign: 'center'
                                                            },
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                variant: "caption",
                                                                className: classes.playerResult,
                                                                children: player1 && newEventResult?.games[round].player === player1 && newEventResult?.games[round].gameValue ? newEventResult?.games[round].results[player1] : '-'
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            sx: {
                                                                display: 'flex',
                                                                flexWrap: 'wrap'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                    label: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6f042400abba8c2b$exports))), {}),
                                                                    value: player1 && newEventResult?.games[round].player === player1 ? newEventResult?.games[round].won : false,
                                                                    disabled: editRound !== round,
                                                                    onChange: (value)=>{
                                                                        if (newEventResult?.games[round] && value) {
                                                                            const tempResult = {
                                                                                ...newEventResult,
                                                                                games: {
                                                                                    ...newEventResult?.games,
                                                                                    [round]: {
                                                                                        ...newEventResult?.games[round],
                                                                                        win: true,
                                                                                        player: player1
                                                                                    }
                                                                                }
                                                                            };
                                                                            tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                        }
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                    label: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2f1d1e8698c2a400$exports))), {}),
                                                                    value: player1 && newEventResult?.games[round].player === player1 ? !newEventResult?.games[round].won : false,
                                                                    disabled: editRound !== round,
                                                                    onChange: (value)=>{
                                                                        if (newEventResult?.games[round] && value) {
                                                                            const tempResult = {
                                                                                ...newEventResult,
                                                                                games: {
                                                                                    ...newEventResult?.games,
                                                                                    [round]: {
                                                                                        ...newEventResult?.games[round],
                                                                                        win: false,
                                                                                        player: player1
                                                                                    }
                                                                                }
                                                                            };
                                                                            tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                        }
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                padding: "none",
                                                className: round % (player4 ? 4 : 3) === 2 ? classes.dealer : '',
                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                    container: true,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            sx: {
                                                                width: '20px',
                                                                maxWidth: '20px',
                                                                textAlign: 'center'
                                                            },
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                variant: "caption",
                                                                className: classes.playerResult,
                                                                children: player2 && newEventResult?.games[round].player === player2 && newEventResult?.games[round].gameValue ? newEventResult?.games[round].results[player2] : '-'
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            sx: {
                                                                display: 'flex',
                                                                flexWrap: 'wrap'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                    label: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6f042400abba8c2b$exports))), {}),
                                                                    disabled: editRound !== round,
                                                                    onChange: (value)=>{
                                                                        if (newEventResult?.games[round] && value) {
                                                                            const tempResult = {
                                                                                ...newEventResult,
                                                                                games: {
                                                                                    ...newEventResult?.games,
                                                                                    [round]: {
                                                                                        ...newEventResult?.games[round],
                                                                                        win: true,
                                                                                        player: player2
                                                                                    }
                                                                                }
                                                                            };
                                                                            tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                        }
                                                                    },
                                                                    value: player2 && newEventResult?.games[round].player === player2 ? newEventResult?.games[round].won : false
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                    label: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2f1d1e8698c2a400$exports))), {}),
                                                                    disabled: editRound !== round,
                                                                    onChange: (value)=>{
                                                                        if (newEventResult?.games[round] && value) {
                                                                            const tempResult = {
                                                                                ...newEventResult,
                                                                                games: {
                                                                                    ...newEventResult?.games,
                                                                                    [round]: {
                                                                                        ...newEventResult?.games[round],
                                                                                        win: false,
                                                                                        player: player2
                                                                                    }
                                                                                }
                                                                            };
                                                                            tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                        }
                                                                    },
                                                                    value: player2 && newEventResult?.games[round].player === player2 ? !newEventResult?.games[round].won : false
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                padding: "none",
                                                className: round % (player4 ? 4 : 3) === (player4 ? 3 : 0) ? classes.dealer : '',
                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                    container: true,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            sx: {
                                                                width: '20px',
                                                                maxWidth: '20px',
                                                                textAlign: 'center'
                                                            },
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                variant: "caption",
                                                                className: classes.playerResult,
                                                                children: player3 && newEventResult?.games[round].player === player3 && newEventResult?.games[round].gameValue ? newEventResult?.games[round].results[player3] : '-'
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            sx: {
                                                                display: 'flex',
                                                                flexWrap: 'wrap'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                    label: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6f042400abba8c2b$exports))), {}),
                                                                    value: player3 && newEventResult?.games[round].player === player3 ? newEventResult?.games[round].won : false,
                                                                    disabled: editRound !== round,
                                                                    onChange: (value)=>{
                                                                        if (newEventResult?.games[round] && value) {
                                                                            const tempResult = {
                                                                                ...newEventResult,
                                                                                games: {
                                                                                    ...newEventResult?.games,
                                                                                    [round]: {
                                                                                        ...newEventResult?.games[round],
                                                                                        win: true,
                                                                                        player: player3
                                                                                    }
                                                                                }
                                                                            };
                                                                            tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                        }
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                    label: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2f1d1e8698c2a400$exports))), {}),
                                                                    value: player3 && newEventResult?.games[round].player === player3 ? !newEventResult?.games[round].won : false,
                                                                    disabled: editRound !== round,
                                                                    onChange: (value)=>{
                                                                        if (newEventResult?.games[round] && value) {
                                                                            const tempResult = {
                                                                                ...newEventResult,
                                                                                games: {
                                                                                    ...newEventResult?.games,
                                                                                    [round]: {
                                                                                        ...newEventResult?.games[round],
                                                                                        win: false,
                                                                                        player: player3
                                                                                    }
                                                                                }
                                                                            };
                                                                            tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                        }
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                padding: "none",
                                                className: round % (player4 ? 4 : 3) === 0 ? classes.dealer : '',
                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                    container: true,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            sx: {
                                                                width: '20px',
                                                                maxWidth: '20px',
                                                                textAlign: 'center'
                                                            },
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                variant: "caption",
                                                                className: classes.playerResult,
                                                                children: player4 && newEventResult?.games[round].player === player4 && newEventResult?.games[round].gameValue ? newEventResult?.games[round].results[player4] : '-'
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            sx: {
                                                                display: 'flex',
                                                                flexWrap: 'wrap'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                    label: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6f042400abba8c2b$exports))), {}),
                                                                    value: player4 && newEventResult?.games[round].player === player4 ? newEventResult?.games[round].won : false,
                                                                    disabled: editRound !== round,
                                                                    onChange: (value)=>{
                                                                        if (newEventResult?.games[round] && value) {
                                                                            const tempResult = {
                                                                                ...newEventResult,
                                                                                games: {
                                                                                    ...newEventResult?.games,
                                                                                    [round]: {
                                                                                        ...newEventResult?.games[round],
                                                                                        win: true,
                                                                                        player: player4
                                                                                    }
                                                                                }
                                                                            };
                                                                            tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                        }
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                    label: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2f1d1e8698c2a400$exports))), {}),
                                                                    value: player4 && newEventResult?.games[round].player === player4 ? !newEventResult?.games[round].won : false,
                                                                    disabled: editRound !== round,
                                                                    onChange: (value)=>{
                                                                        if (newEventResult?.games[round] && value) {
                                                                            const tempResult = {
                                                                                ...newEventResult,
                                                                                games: {
                                                                                    ...newEventResult?.games,
                                                                                    [round]: {
                                                                                        ...newEventResult?.games[round],
                                                                                        win: false,
                                                                                        player: player4
                                                                                    }
                                                                                }
                                                                            };
                                                                            tempResult && setNewEventResult((0, $4ba4333e5e4430b7$export$2e2bcd8739ae039)(tempResult));
                                                                        }
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                        children: newEventResult?.players && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $aefaf578420618f8$export$2e2bcd8739ae039), {
                                            id: props.eventResult?.id,
                                            round: newEventResult?.games[round],
                                            players: newEventResult?.players,
                                            dealer: actualDealer,
                                            eventId: props.event.id,
                                            gameNumber: round
                                        })
                                    })
                                ]
                            }, round);
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footerTitle,
                                        colSpan: 2,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Ergebnis"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: [
                                                " ",
                                                player1 && newEventResult?.results[player1]?.sessionResult
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: [
                                                " ",
                                                player2 && newEventResult?.results[player2]?.sessionResult
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: [
                                                " ",
                                                player3 && newEventResult?.results[player3]?.sessionResult
                                            ]
                                        })
                                    }),
                                    player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: [
                                                " ",
                                                player4 && newEventResult?.results[player4]?.sessionResult
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footerTitle,
                                        colSpan: 2,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: [
                                                "+50 je gew. Spiel ",
                                                /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                                                "-50 je verl. Spiel"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: player1 && (newEventResult?.results[player1]?.offensePoints || 0)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: player2 && (newEventResult?.results[player2]?.offensePoints || 0)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: player3 && (newEventResult?.results[player3]?.offensePoints || 0)
                                        })
                                    }),
                                    player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: player4 && (newEventResult?.results[player4]?.offensePoints || 0)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footerTitle,
                                        colSpan: 2,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: [
                                                "+",
                                                player4 ? 30 : 40,
                                                " je verlorenes Spiel des Gegners"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: player1 && (newEventResult?.results[player1]?.defensePoints || 0)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: player2 && (newEventResult?.results[player2]?.defensePoints || 0)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: player3 && (newEventResult?.results[player3]?.defensePoints || 0)
                                        })
                                    }),
                                    player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: player4 && (newEventResult?.results[player4]?.defensePoints || 0)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footerTitle,
                                        colSpan: 2,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Gesamtergebnis"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: player1 && newEventResult?.results[player1]?.completeResult
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: player2 && newEventResult?.results[player2]?.completeResult
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: player3 && newEventResult?.results[player3]?.completeResult
                                        })
                                    }),
                                    player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.footer,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: player4 && newEventResult?.results[player4]?.completeResult
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                sx: {
                    marginTop: '20px'
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                    disabled: !!editRound || !!newRound,
                    text: "+ Neues Spiel erfassen",
                    onClick: ()=>{
                        if (player1 && player2 && player3 && session && table) {
                            const newArray = [
                                ...games
                            ];
                            const playerCount = player4 ? 4 : 3;
                            const helper = games.length / playerCount;
                            let tempEventResult = newEventResult ? {
                                ...newEventResult
                            } : undefined;
                            // neuer Durchgang
                            if (helper === 0 || !tempEventResult) {
                                const players = [];
                                players.push(player1);
                                players.push(player2);
                                players.push(player3);
                                if (player4) players.push(player4);
                                tempEventResult = {
                                    eventId: props.event.id,
                                    table: table,
                                    session: session,
                                    players: players,
                                    games: {},
                                    result: (0, $c93be8f0268c3535$export$2e2bcd8739ae039)(players)
                                };
                            }
                            // neue Runden hinzufügen
                            const newgames = tempEventResult && tempEventResult.games ? {
                                ...tempEventResult.games
                            } : {};
                            newgames[helper * playerCount + 1] = {
                                results: {}
                            };
                            newArray.push(helper * playerCount + 1);
                            setgames(newArray);
                            // neuer Dealer als Dealer setzen
                            let dealer = player4;
                            switch((games.length + 1) % (player4 ? 4 : 3)){
                                case 1:
                                    dealer = player1;
                                    break;
                                case 2:
                                    dealer = player2;
                                    break;
                                case 3:
                                    dealer = player3;
                                    break;
                                case 0:
                                    dealer = player4 || player3;
                                    break;
                            }
                            setActualDealer(dealer);
                            if (tempEventResult) {
                                tempEventResult.games = newgames;
                                setNewEventResult(tempEventResult);
                                setNewRound(helper * playerCount + 1);
                            }
                        } else dispatch($7173820326fb9f6c$export$706cdae1b5419ef8({
                            severity: (0, $c7fa01100a96d1f7$export$918a9776c0a3cf27).error,
                            message: "Bitte zun\xe4chst Durchgang, Tisch und Spieler eintragen!"
                        }));
                    }
                })
            })
        ]
    });
};
var $b1de94706b48215e$export$2e2bcd8739ae039 = $b1de94706b48215e$var$NewEventResults;











/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $e2f8f7e097473d4b$export$98e6a39c04603d36;
var $e2f8f7e097473d4b$export$dfdc1655ccc5b9cb;
'use strict';
$e2f8f7e097473d4b$export$98e6a39c04603d36 = $e2f8f7e097473d4b$var$parse;
$e2f8f7e097473d4b$export$dfdc1655ccc5b9cb = $e2f8f7e097473d4b$var$serialize;
/**
 * Module variables.
 * @private
 */ var $e2f8f7e097473d4b$var$decode = decodeURIComponent;
var $e2f8f7e097473d4b$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $e2f8f7e097473d4b$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $e2f8f7e097473d4b$var$parse(str, options) {
    if (typeof str !== 'string') throw new TypeError('argument str must be a string');
    var obj = {};
    var opt = options || {};
    var pairs = str.split(';');
    var dec = opt.decode || $e2f8f7e097473d4b$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf('=');
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $e2f8f7e097473d4b$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $e2f8f7e097473d4b$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $e2f8f7e097473d4b$var$encode;
    if (typeof enc !== 'function') throw new TypeError('option encode is invalid');
    if (!$e2f8f7e097473d4b$var$fieldContentRegExp.test(name)) throw new TypeError('argument name is invalid');
    var value = enc(val);
    if (value && !$e2f8f7e097473d4b$var$fieldContentRegExp.test(value)) throw new TypeError('argument val is invalid');
    var str = name + '=' + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError('option maxAge is invalid');
        str += '; Max-Age=' + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$e2f8f7e097473d4b$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += '; Domain=' + opt.domain;
    }
    if (opt.path) {
        if (!$e2f8f7e097473d4b$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += '; Path=' + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += '; Expires=' + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $e2f8f7e097473d4b$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}



function $d2ab1ed0cafd7917$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function $d2ab1ed0cafd7917$export$bfce569af136abdc() {
    document.cookie.split(';').forEach(function(c) {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function $d2ab1ed0cafd7917$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === 'string') return $e2f8f7e097473d4b$export$98e6a39c04603d36(cookies, options);
    else if (typeof cookies === 'object' && cookies !== null) return cookies;
    else return {};
}
function $d2ab1ed0cafd7917$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === 'undefined') // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
    return !doNotParse;
}
function $d2ab1ed0cafd7917$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $d2ab1ed0cafd7917$var$cleanupCookieValue(value);
    if ($d2ab1ed0cafd7917$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $d2ab1ed0cafd7917$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}


var $295d8296ffe85dd9$var$__assign = undefined && undefined.__assign || function() {
    $295d8296ffe85dd9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $295d8296ffe85dd9$var$__assign.apply(this, arguments);
};
var $295d8296ffe85dd9$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $d2ab1ed0cafd7917$export$d2e637738f5e6ae8)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $d2ab1ed0cafd7917$export$56232575010ba89)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $e2f8f7e097473d4b$export$98e6a39c04603d36(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $d2ab1ed0cafd7917$export$bead674655ff515d)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $d2ab1ed0cafd7917$export$bead674655ff515d)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === 'object') value = JSON.stringify(value);
        this.cookies = $295d8296ffe85dd9$var$__assign($295d8296ffe85dd9$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $e2f8f7e097473d4b$export$dfdc1655ccc5b9cb(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $295d8296ffe85dd9$var$__assign($295d8296ffe85dd9$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $295d8296ffe85dd9$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $e2f8f7e097473d4b$export$dfdc1655ccc5b9cb(name, '', finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $295d8296ffe85dd9$export$2e2bcd8739ae039 = $295d8296ffe85dd9$var$Cookies;


var $1e6a4c3d769ee60e$export$2e2bcd8739ae039 = (0, $295d8296ffe85dd9$export$2e2bcd8739ae039);


const $58718165e7ed8d4a$var$COOKIES = new (0, $1e6a4c3d769ee60e$export$2e2bcd8739ae039)();
const $58718165e7ed8d4a$export$83d589c0aed0f8ee = 'XSRF-TOKEN';
const $58718165e7ed8d4a$export$7d1231b924dad25c = 'X-XSRF-TOKEN';
const $58718165e7ed8d4a$export$52160ca23629dd6f = ()=>{
    return $58718165e7ed8d4a$var$COOKIES.get($58718165e7ed8d4a$export$83d589c0aed0f8ee, {
        doNotParse: true
    });
};
const $58718165e7ed8d4a$export$bacd26fe3052ded6 = (headers)=>{
    headers.set($58718165e7ed8d4a$export$7d1231b924dad25c, $58718165e7ed8d4a$export$52160ca23629dd6f());
    return headers;
};


const $46668510321f1f9f$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        playerResult: {
            fontWeight: 'bold',
            textAlign: 'center'
        },
        tableHeader: {
            textAlign: 'left',
            fontWeight: 'bold',
            verticalAlign: 'bottom'
        },
        dealer: {
            backgroundColor: 'lightgrey'
        },
        stickyFooter: {
            position: 'sticky',
            bottom: 0
        },
        footer: {
            fontWeight: 'bold',
            textAlign: 'center'
        },
        footerTitle: {
            fontWeight: 'bold',
            textAlign: 'right'
        },
        baseBox: {
            position: 'relative'
        }
    }));
var $46668510321f1f9f$export$19fbfcba8fe44d89 = /*#__PURE__*/ function(SortingOption) {
    SortingOption["round1"] = "round1";
    SortingOption["round2"] = "round2";
    SortingOption["complete"] = "complete";
    return SortingOption;
}({});
// TODO stifte am ende der Zeile um evt die Berechnungen zu überschreiben
const $46668510321f1f9f$var$EventResults = (props)=>{
    const classes = $46668510321f1f9f$var$useStyles();
    const basePath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
    const fetchHeaders = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).fetchHeaders;
    (0, $58718165e7ed8d4a$export$bacd26fe3052ded6)(fetchHeaders);
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const restPath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
    const requestHeaders = new Headers();
    requestHeaders.set('Accept', 'application/json');
    requestHeaders.set('Content-Type', 'application/json');
    const user = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$7cbf767827cd68ba));
    const members = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$f4931e6f9feb30c5));
    const events = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$3f41ece7d7128238));
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const storedEventResults = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$79c726a1641bb9ad));
    const [showResultDialog, setShowResultDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const [editResultDialog, setEditResultDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const [openNewStartDialog, setOpenNewStartDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(window.localStorage.getItem('openNewStartDialog') === 'true');
    const [saveAllowed, setSaveAllowed] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const [startAllowed, setStartAllowed] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const [eventStarted, setEventStartet] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const [showTablePlayerDialog, setShowTablePlayerDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const [playerArray, setPlayerArray] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState([]);
    const [playerOptions, setPlayerOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState([]);
    const [newGamerId, setNewGamerId] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [event, setEvent] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [eventResults, setEventResults] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState([]);
    const [sortingOption, setSortingOption] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState("complete");
    const [player1, setPlayer1] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [player2, setPlayer2] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [player3, setPlayer3] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [player4, setPlayer4] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [session, setSession] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(undefined);
    const [table, setTable] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(undefined);
    const [rounds, setRounds] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState([]);
    const [selectedEventResult, setSelectedEventResult] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const setEventMember = (data)=>{
        dispatch($5993246da723f2dd$export$ad62873327949bc6({
            count: data.count,
            results: data.results
        }));
    };
    const [message, setMessage] = (0, $3OyDL.useState)();
    (0, $3OyDL.useEffect)(()=>{
        const results = storedEventResults[props.eventId] || [];
        setEventResults(results);
        if (table && session) {
            const result = results.find((elem)=>elem.table === table && elem.session === session);
            setSelectedEventResult(result);
            const games = [];
            result && result.games && Object.keys(result.games).map((round)=>{
                games.push(parseInt(round, 10));
            });
            setRounds(games);
        }
    }, [
        storedEventResults,
        table,
        session
    ]);
    (0, $3OyDL.useEffect)(()=>{
        message && dispatch($7173820326fb9f6c$export$706cdae1b5419ef8(message));
    }, [
        message
    ]);
    (0, $3OyDL.useEffect)(()=>{
        const actualEvent = events?.results.find((event)=>event.id === props.eventId);
        actualEvent && setEvent(actualEvent);
    }, [
        events
    ]);
    const getPlayerName = (originId)=>{
        const member = originId && members?.results.find((member)=>member.originId === originId);
        return member ? `${member.firstname} ${member.lastname}` : null;
    };
    const getSessionTables = ()=>{
        const tables = [];
        const gamerCount = props.eventMember?.filter((elem)=>elem.gamer).length;
        const tableCount = gamerCount && Math.floor(gamerCount / 3);
        if (tableCount) for(let i = 1; i <= tableCount; i++)tables.push({
            key: `${i}`,
            value: `Tisch ${i}`
        });
        return tables;
    };
    const playerList = ()=>{
        const newPlayerList = [];
        props.eventMember?.map((elem)=>{
            elem.gamer && newPlayerList.push(elem.memberId);
        });
        setPlayerArray(newPlayerList);
    };
    const getPlayerOptions = ()=>{
        const options = [];
        members?.results.map((member)=>{
            if (member.originId && !playerArray.find((elem)=>elem === member.originId)) options.push({
                key: member.originId,
                value: getPlayerName(member.originId) || member.originId
            });
        });
        setPlayerOptions(options);
    };
    const getSessionPlayers = ()=>{
        const elements = [];
        props.eventMember?.forEach((member)=>{
            if (member.gamer && member.id) elements.push({
                key: member.memberId,
                value: `${members?.results.find((elem)=>elem.originId === member.memberId)?.firstname} ${members?.results.find((elem)=>elem.originId === member.memberId)?.lastname}`
            });
        });
        return elements;
    };
    (0, $3OyDL.useEffect)(()=>{
        playerList();
    }, [
        props.eventMember,
        props
    ]);
    (0, $3OyDL.useEffect)(()=>{
        getPlayerOptions();
    }, [
        playerArray
    ]);
    const TableAvatar = (player)=>{
        const avatarSize = downMd ? '50px' : '70px';
        return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
            children: player ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d93387bfb3b3cba0$export$2e2bcd8739ae039), {
                sx: {
                    bgcolor: '#fff',
                    color: theme.palette.primary.light,
                    width: avatarSize,
                    height: avatarSize
                },
                alt: `${player.firstname} ${player.lastname}`,
                src: player.profileImageUrl,
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                    style: {
                        fontSize: '1rem',
                        fontStyle: 'bold',
                        textAlign: 'center'
                    },
                    children: [
                        `${player.firstname}`,
                        " ",
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        " ",
                        `${player.lastname.substring(0, 1).toUpperCase()}.`
                    ]
                })
            }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d93387bfb3b3cba0$export$2e2bcd8739ae039), {
                sx: {
                    color: '#fff',
                    bgcolor: theme.palette.primary.light,
                    border: '2px solid #fff',
                    width: avatarSize,
                    height: avatarSize
                },
                alt: "?",
                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                    children: "?"
                })
            })
        });
    };
    const TableAvatarBox = (eventResult)=>{
        const player1 = members?.results.find((member)=>member.originId === eventResult.players[0]);
        const player2 = members?.results.find((member)=>member.originId === eventResult.players[1]);
        const player3 = members?.results.find((member)=>member.originId === eventResult.players[2]);
        const player4 = members?.results.find((member)=>member.originId === eventResult.players[3]);
        if (!eventResult.results) eventResult.results = {};
        if (Object.keys(eventResult.results).length === 0) eventResult.results = (0, $c93be8f0268c3535$export$2e2bcd8739ae039)(eventResult.players);
        return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
            onClick: ()=>{
                if (eventStarted || eventResult) {
                    setTable(eventResult.table);
                    setSession(eventResult.session);
                    setPlayer1(eventResult.players[0]);
                    setPlayer2(eventResult.players[1]);
                    setPlayer3(eventResult.players[2]);
                    setPlayer4(eventResult.players[3]);
                    setSelectedEventResult(eventResult);
                    if (event?.tablesClosed) setShowResultDialog(true);
                    else setEditResultDialog(true);
                }
            },
            sx: {
                display: 'flex',
                width: downMd ? '150px' : '175px',
                height: downMd ? '150px' : '175px',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                bgcolor: theme.palette.primary.light,
                borderRadius: '10px',
                padding: '10px',
                position: 'relative',
                cursor: 'pointer',
                marginBottom: '20px',
                marginRight: '20px'
            },
            children: [
                TableAvatar(player1),
                TableAvatar(player2),
                TableAvatar(player3),
                eventResult.players[3] && TableAvatar(player4),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    variant: "h1",
                    sx: {
                        opacity: 0.6,
                        position: 'absolute',
                        color: '#fff',
                        top: downMd ? '40px' : '54px',
                        left: downMd ? '64px' : '77px'
                    },
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                        children: eventResult.table
                    })
                })
            ]
        });
    };
    const delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
    const sendToBackend = async (game)=>{
        const restUrl = `${restPath}/api/${(0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)()}/game`;
        try {
            fetch(restUrl, {
                method: 'POST',
                body: JSON.stringify({
                    game: game
                }),
                credentials: 'include',
                headers: requestHeaders
            }).then((res)=>res.json()).then((json)=>{
                console.log(json);
            }).catch((err)=>console.log(err));
        } catch (e) {
            console.log(e);
        }
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            (user?.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).admin || user?.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).jury) && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                        variant: "body1",
                        children: "Nachfolgend werden die Ergebnisse des disj\xe4hrigen Skat-Turniers ausgegeben. Als Admin / Jury kannst du die Tische zu einem bestimmten Zeitpunkt sperren, dann k\xf6nnen keine \xc4nderungen mehr vorgenommen werden. Auch das Anzeigen der Gesamtergebnisse erfolgt erst nach Freigabe. Beide Aktionen k\xf6nnen jederzeit r\xfcckg\xe4ngig gemacht werden."
                    }),
                    !event?.tablesClosed && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                        color: "primary",
                        variant: "text",
                        text: "Tische schlie\xdfen",
                        onClick: ()=>{
                            const actualEvent = event;
                            if (actualEvent) {
                                actualEvent.tablesClosed = true;
                                (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).events, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).PUT, props.eventId, {
                                    event: actualEvent
                                }, undefined, setMessage);
                            }
                        }
                    }),
                    event?.tablesClosed && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                        color: "primary",
                        variant: "text",
                        text: "Bearbeitung freigeben",
                        onClick: ()=>{
                            const actualEvent = event;
                            if (actualEvent) {
                                actualEvent.tablesClosed = false;
                                setEvent(actualEvent);
                                (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).events, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).PUT, props.eventId, {
                                    event: actualEvent
                                }, undefined, setMessage);
                            }
                        }
                    }),
                    !event?.displayResults && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                        color: "primary",
                        variant: "text",
                        text: "Ergebnisse anzeigen",
                        onClick: ()=>{
                            const actualEvent = event;
                            if (actualEvent) {
                                actualEvent.displayResults = true;
                                (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).events, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).PUT, props.eventId, {
                                    event: actualEvent
                                }, undefined, setMessage);
                            }
                        }
                    }),
                    event?.displayResults && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                        color: "primary",
                        variant: "text",
                        text: "Ergebnisse verbergen",
                        onClick: ()=>{
                            const actualEvent = event;
                            if (actualEvent) {
                                actualEvent.displayResults = false;
                                (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).events, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).PUT, props.eventId, {
                                    event: actualEvent
                                }, undefined, setMessage);
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ee30f4276828974b$export$2e2bcd8739ae039), {
                open: showResultDialog,
                onClose: ()=>setShowResultDialog(false),
                sx: {
                    '& .MuiDialog-paper': {
                        borderRadius: 0,
                        maxWidth: '90%',
                        minWidth: '90%'
                    }
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                    sx: {
                        p: 3
                    },
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                            direction: "row",
                            spacing: 3,
                            alignItems: "center",
                            justifyContent: "space-between",
                            className: classes.baseBox,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $286e44e498de27a0$export$2e2bcd8739ae039), {
                                sx: {
                                    fontWeight: 600,
                                    p: 0,
                                    fontSize: '16px',
                                    marginBottom: '20px'
                                },
                                children: `Ergebnisse ${session}. Runde: Tisch ${table}`
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b9097f1d6e2a4efc$export$2e2bcd8739ae039), {
                            sx: {
                                p: 0,
                                overflow: 'visible'
                            },
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                                    size: "small",
                                    stickyHeader: true,
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.tableHeader,
                                                        sx: {
                                                            width: '80px',
                                                            maxWidth: '80px'
                                                        },
                                                        children: "Runde"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.tableHeader,
                                                        sx: {
                                                            width: '100px',
                                                            maxWidth: '100px'
                                                        },
                                                        children: "Spielwert"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.tableHeader,
                                                        sx: {
                                                            minWidth: '120px'
                                                        },
                                                        children: player1 && getPlayerName(player1)
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.tableHeader,
                                                        sx: {
                                                            minWidth: '120px'
                                                        },
                                                        children: player2 && getPlayerName(player2)
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.tableHeader,
                                                        sx: {
                                                            minWidth: '120px'
                                                        },
                                                        children: player3 && getPlayerName(player3)
                                                    }),
                                                    player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.tableHeader,
                                                        sx: {
                                                            minWidth: '120px'
                                                        },
                                                        children: player4 && getPlayerName(player4)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                                            children: rounds.map((round)=>{
                                                return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            align: "center",
                                                            children: round
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            align: "center",
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                variant: "body1",
                                                                children: selectedEventResult?.games[round]?.gameValue || 0
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: round % (player4 ? 4 : 3) === 1 ? classes.dealer : '',
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                container: true,
                                                                alignItems: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                        item: true,
                                                                        xs: 6,
                                                                        sx: {
                                                                            width: '50px',
                                                                            maxWidth: '50px'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                            className: classes.playerResult,
                                                                            children: selectedEventResult?.games[round]?.game === (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt ? round % (player4 ? 4 : 3) === 1 ? player1 && selectedEventResult?.games[round]?.results[player1] ? selectedEventResult?.games[round]?.results[player1] : 0 : '-' : player1 && selectedEventResult?.games[round]?.player === player1 && selectedEventResult?.games[round]?.gameValue ? selectedEventResult?.games[round]?.results[player1] : '-'
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                        item: true,
                                                                        xs: 6,
                                                                        sx: {
                                                                            display: 'flex'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                                label: "gew.",
                                                                                value: player1 && selectedEventResult?.games[round]?.player === player1 ? selectedEventResult?.games[round]?.won : false,
                                                                                disabled: true
                                                                            }),
                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                                label: "verl.",
                                                                                value: player1 && selectedEventResult?.games[round]?.player === player1 ? !selectedEventResult?.games[round]?.won : false,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: round % (player4 ? 4 : 3) === 2 ? classes.dealer : '',
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                container: true,
                                                                alignItems: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                        item: true,
                                                                        xs: 6,
                                                                        sx: {
                                                                            width: '50px',
                                                                            maxWidth: '50px'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                            className: classes.playerResult,
                                                                            children: selectedEventResult?.games[round]?.game === (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt ? round % (player4 ? 4 : 3) === 2 ? player2 && selectedEventResult?.games[round]?.results[player2] ? selectedEventResult?.games[round]?.results[player2] : 0 : '-' : player2 && selectedEventResult?.games[round]?.player === player2 && selectedEventResult?.games[round]?.gameValue ? selectedEventResult?.games[round]?.results[player2] : '-'
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                        item: true,
                                                                        xs: 6,
                                                                        sx: {
                                                                            display: 'flex'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                                disabled: true,
                                                                                label: "gew.",
                                                                                value: player2 && selectedEventResult?.games[round]?.player === player2 ? selectedEventResult?.games[round]?.won : false
                                                                            }),
                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                                disabled: true,
                                                                                label: "verl.",
                                                                                value: player2 && selectedEventResult?.games[round]?.player === player2 ? !selectedEventResult?.games[round]?.won : false
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: round % (player4 ? 4 : 3) === (player4 ? 3 : 0) ? classes.dealer : '',
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                container: true,
                                                                alignItems: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                        item: true,
                                                                        xs: 6,
                                                                        sx: {
                                                                            width: '50px',
                                                                            maxWidth: '50px'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                            className: classes.playerResult,
                                                                            children: selectedEventResult?.games[round]?.game === (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt ? round % (player4 ? 4 : 3) === 0 ? player3 && selectedEventResult?.games[round]?.results[player3] ? selectedEventResult?.games[round]?.results[player3] : 0 : '-' : player3 && selectedEventResult?.games[round]?.player === player3 && selectedEventResult?.games[round]?.gameValue ? selectedEventResult?.games[round]?.results[player3] : '-'
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                        item: true,
                                                                        xs: 6,
                                                                        sx: {
                                                                            display: 'flex'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                                label: "gew.",
                                                                                value: player3 && selectedEventResult?.games[round]?.player === player3 ? selectedEventResult?.games[round]?.won : false,
                                                                                disabled: true
                                                                            }),
                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                                label: "verl.",
                                                                                value: player3 && selectedEventResult?.games[round]?.player === player3 ? !selectedEventResult?.games[round]?.won : false,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: round % (player4 ? 4 : 3) === 0 ? classes.dealer : '',
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                container: true,
                                                                alignItems: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                        item: true,
                                                                        xs: 6,
                                                                        sx: {
                                                                            width: '50px',
                                                                            maxWidth: '50px'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                            className: classes.playerResult,
                                                                            children: selectedEventResult?.games[round]?.game === (0, $c7fa01100a96d1f7$export$985739bfa5723e08).eingemischt ? round % (player4 ? 4 : 3) === 0 ? player4 && selectedEventResult?.games[round]?.results[player4] ? selectedEventResult?.games[round]?.results[player4] : 0 : '-' : player4 && selectedEventResult?.games[round]?.player === player4 && selectedEventResult?.games[round]?.gameValue ? selectedEventResult?.games[round]?.results[player4] : '-'
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                        item: true,
                                                                        xs: 6,
                                                                        sx: {
                                                                            display: 'flex'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                                label: "gew.",
                                                                                value: player4 && selectedEventResult?.games[round]?.player === player4 ? selectedEventResult?.games[round]?.won : false,
                                                                                disabled: true
                                                                            }),
                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                                label: "verl.",
                                                                                value: player4 && selectedEventResult?.games[round]?.player === player4 ? !selectedEventResult?.games[round]?.won : false,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }, round);
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                                            className: classes.stickyFooter,
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footerTitle,
                                                            colSpan: 2,
                                                            children: "Ergebnis"
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player1 && selectedEventResult?.results[player1]?.sessionResult
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player2 && selectedEventResult?.results[player2]?.sessionResult
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player3 && selectedEventResult?.results[player3]?.sessionResult
                                                        }),
                                                        player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player4 && selectedEventResult?.results[player4]?.sessionResult
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footerTitle,
                                                            colSpan: 2,
                                                            children: "Gew. / Verl."
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: `${player1 && selectedEventResult?.results[player1]?.wonOffense} / ${player1 && selectedEventResult?.results[player1]?.lostOffense}`
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: `${player2 && selectedEventResult?.results[player2]?.wonOffense} / ${player2 && selectedEventResult?.results[player2]?.lostOffense}`
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: `${player3 && selectedEventResult?.results[player3]?.wonOffense} / ${player3 && selectedEventResult?.results[player3]?.lostOffense}`
                                                        }),
                                                        player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: `${player4 && selectedEventResult?.results[player4]?.wonOffense} / ${player4 && selectedEventResult?.results[player4]?.lostOffense}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footerTitle,
                                                            colSpan: 2,
                                                            children: [
                                                                "+50 je gew. Spiel ",
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                                                                "-50 je verl. Spiel"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player1 && ((selectedEventResult?.results[player1]?.wonOffense || 0) - (selectedEventResult?.results[player1]?.lostOffense || 0)) * 50
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player2 && ((selectedEventResult?.results[player2]?.wonOffense || 0) - (selectedEventResult?.results[player2]?.lostOffense || 0)) * 50
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player3 && ((selectedEventResult?.results[player3]?.wonOffense || 0) - (selectedEventResult?.results[player3]?.lostOffense || 0)) * 50
                                                        }),
                                                        player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player4 && ((selectedEventResult?.results[player4]?.wonOffense || 0) - (selectedEventResult?.results[player4]?.lostOffense || 0)) * 50
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footerTitle,
                                                            colSpan: 2,
                                                            children: [
                                                                "+",
                                                                player4 ? 30 : 40,
                                                                " je verlorenes Spiel des Gegners"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player1 && (selectedEventResult?.results[player1]?.lostDefense || 0) * (player4 ? 30 : 40)
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player2 && (selectedEventResult?.results[player2]?.lostDefense || 0) * (player4 ? 30 : 40)
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player3 && (selectedEventResult?.results[player3]?.lostDefense || 0) * (player4 ? 30 : 40)
                                                        }),
                                                        player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player4 && (selectedEventResult?.results[player4]?.lostDefense || 0) * 30
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footerTitle,
                                                            colSpan: 2,
                                                            children: "Gesamtergebnis"
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player1 && selectedEventResult?.results[player1]?.completeResult
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player2 && selectedEventResult?.results[player2]?.completeResult
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player3 && selectedEventResult?.results[player3]?.completeResult
                                                        }),
                                                        player4 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.footer,
                                                            children: player4 && selectedEventResult?.results[player4]?.completeResult
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ee30f4276828974b$export$2e2bcd8739ae039), {
                open: editResultDialog && event?.tablesClosed === false,
                onClose: ()=>setEditResultDialog(false),
                sx: {
                    '& .MuiDialog-paper': {
                        borderRadius: 0,
                        maxWidth: '95%',
                        minWidth: '95%'
                    }
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                    sx: {
                        p: downMd ? 1 : 3
                    },
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                            direction: "row",
                            spacing: downMd ? 1 : 3,
                            alignItems: "center",
                            justifyContent: "space-between",
                            className: classes.baseBox,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $286e44e498de27a0$export$2e2bcd8739ae039), {
                                sx: {
                                    fontWeight: 600,
                                    p: 0,
                                    fontSize: '16px',
                                    marginBottom: '20px'
                                },
                                children: "Ergebnisse eintragen"
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b9097f1d6e2a4efc$export$2e2bcd8739ae039), {
                            sx: {
                                p: 0,
                                overflow: 'visible'
                            },
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b1de94706b48215e$export$2e2bcd8739ae039), {
                                eventResult: selectedEventResult,
                                event: event,
                                saveAllowed: (value)=>setSaveAllowed(value)
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $08e4970efe955928$export$2e2bcd8739ae039), {
                            sx: {
                                p: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    color: "secondary",
                                    variant: "text",
                                    text: "Abbrechen",
                                    onClick: ()=>setEditResultDialog(false)
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    variant: "contained",
                                    text: "Speichern",
                                    disabled: !saveAllowed,
                                    onClick: ()=>{
                                        setEditResultDialog(false);
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            eventResults.length > 0 ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                direction: "column",
                spacing: 2,
                alignItems: "flex-start",
                justifyContent: "space-between",
                children: [
                    (event?.displayResults || user?.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).jury || user?.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).admin) && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                        sx: {
                            width: '100%',
                            marginRight: '20px'
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                            size: "small",
                            sx: {
                                width: '100%'
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                align: "center",
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                    children: "Nr."
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                    children: "Name"
                                                })
                                            }),
                                            !downMd && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        align: "center",
                                                        sx: {
                                                            whiteSpace: 'nowrap',
                                                            cursor: 'pointer'
                                                        },
                                                        onClick: ()=>setSortingOption("round1"),
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Runde 1"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        align: "center",
                                                        sx: {
                                                            whiteSpace: 'nowrap',
                                                            cursor: 'pointer'
                                                        },
                                                        onClick: ()=>setSortingOption("round2"),
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Runde 2"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                align: "center",
                                                sx: {
                                                    cursor: 'pointer'
                                                },
                                                onClick: ()=>setSortingOption("complete"),
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                    children: "Gesamt"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                                    children: eventResults && (0, $07e0544037b0637a$export$2e2bcd8739ae039)(eventResults, sortingOption).map((element, index)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                    align: "center",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                        children: index + 1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        whiteSpace: 'nowrap'
                                                    },
                                                    children: getPlayerName(element.memberId)
                                                }),
                                                !downMd && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            align: "center",
                                                            children: eventResults.find((result)=>result.session === 1 && result.players.find((player)=>player === element.memberId))?.results[element.memberId].completeResult
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            align: "center",
                                                            children: eventResults.find((result)=>result.session === 2 && result.players.find((player)=>player === element.memberId))?.results[element.memberId].completeResult
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                    align: "center",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                        children: element.completeResult
                                                    })
                                                })
                                            ]
                                        }, index))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                        direction: "column",
                        spacing: 2,
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: '100%'
                                        },
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "body1",
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                children: "Runde 1"
                                            })
                                        })
                                    }),
                                    event?.displayResults || user?.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).admin || user?.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).jury ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                        children: eventResults.sort((a, b)=>a.table - b.table).map((result)=>{
                                            return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                children: result.session === 1 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                    children: TableAvatarBox(result)
                                                })
                                            });
                                        })
                                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                        children: user?.memberId && eventResults.filter((result)=>result.players.includes(user?.memberId)).sort((a, b)=>a.table - b.table).map((result)=>{
                                            return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                children: result.session === 1 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                    children: TableAvatarBox(result)
                                                })
                                            });
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: '100%'
                                        },
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "body1",
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                children: "Runde 2"
                                            })
                                        })
                                    }),
                                    event?.displayResults || user?.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).admin || user?.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).jury ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                        children: eventResults.sort((a, b)=>a.table - b.table).map((result)=>{
                                            return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                children: result.session === 2 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                    children: TableAvatarBox(result)
                                                })
                                            });
                                        })
                                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                        children: user?.memberId && eventResults.filter((result)=>result.players.includes(user?.memberId)).sort((a, b)=>a.table - b.table).map((result)=>{
                                            return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                children: result.session === 2 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                    children: TableAvatarBox(result)
                                                })
                                            });
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                        variant: "body1",
                        children: "Noch keine Ergebnisse."
                    }),
                    user?.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).admin && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            window.localStorage.setItem('openNewStartDialog', 'true');
                            setOpenNewStartDialog(true);
                            setEventStartet(true);
                        },
                        text: "Neues Skatturnier starten"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ee30f4276828974b$export$2e2bcd8739ae039), {
                open: openNewStartDialog,
                onClose: ()=>{
                    setOpenNewStartDialog(false);
                    window.localStorage.setItem('openNewStartDialog', 'false');
                    window.localStorage.removeItem('activeEventTab');
                },
                sx: {
                    '& .MuiDialog-paper': {
                        borderRadius: 0,
                        maxWidth: '95%',
                        minWidth: '95%'
                    }
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                    sx: {
                        p: downMd ? 1 : 3
                    },
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                            direction: "row",
                            spacing: downMd ? 1 : 3,
                            alignItems: "center",
                            justifyContent: "space-between",
                            className: classes.baseBox,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $286e44e498de27a0$export$2e2bcd8739ae039), {
                                sx: {
                                    fontWeight: 600,
                                    p: 0,
                                    fontSize: '16px',
                                    marginBottom: '20px'
                                },
                                children: "Neues Skatturnier starten"
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b9097f1d6e2a4efc$export$2e2bcd8739ae039), {
                            sx: {
                                p: 0,
                                overflow: 'visible'
                            },
                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                        variant: "body1",
                                        children: [
                                            "Willkommen beim diesj\xe4hrigen Skatturnier. Bevor wir die Tische verteilen und das Turnier starten, hast du jetzt die Gelegenheit, die Spieler festzulegen. ",
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                                            "Wir w\xfcnschen allen Teilnehmern viel Erfolg und vor allem viel Spa\xdf beim Spiel!"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                        container: true,
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 6,
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                                                        size: "small",
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                            className: classes.tableHeader,
                                                                            sx: {
                                                                                width: '20px'
                                                                            },
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                            className: classes.tableHeader,
                                                                            children: "Vorname"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                            className: classes.tableHeader,
                                                                            children: "Nachname"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                                                                children: props.eventMember?.map((member)=>{
                                                                    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                                        children: member.gamer && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                                        value: member.gamer,
                                                                                        onChange: (checked)=>{
                                                                                            member.gamer = false;
                                                                                            (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventMembers, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).PUT, member.id, {
                                                                                                eventMember: member
                                                                                            }, setEventMember, setMessage);
                                                                                        }
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                                    children: members?.results.find((elem)=>elem.originId === member.memberId)?.firstname
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                                    children: members?.results.find((elem)=>elem.originId === member.memberId)?.lastname
                                                                                })
                                                                            ]
                                                                        }, member.id)
                                                                    });
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            display: 'flex',
                                                            justifyContent: 'space-between'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                                                options: playerOptions,
                                                                value: newGamerId,
                                                                label: "Weiteren Spieler hinzuf\xfcgen",
                                                                onChange: (value)=>{
                                                                    value?.key && setNewGamerId(value.key);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                                onClick: ()=>{
                                                                    const existingEventMember = props.eventMember?.find((elem)=>elem.memberId === newGamerId);
                                                                    if (newGamerId) {
                                                                        if (existingEventMember) {
                                                                            existingEventMember.gamer = true;
                                                                            (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventMembers, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).PUT, existingEventMember.id, {
                                                                                eventMember: existingEventMember
                                                                            }, setEventMember, setMessage);
                                                                        } else {
                                                                            const newEventMember = {
                                                                                registeredByMemberId: newGamerId,
                                                                                eventId: props.eventId,
                                                                                memberId: newGamerId,
                                                                                participate: true,
                                                                                gamer: true,
                                                                                from: {},
                                                                                to: {},
                                                                                eventPriceCategories: []
                                                                            };
                                                                            (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventMembers, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).POST, undefined, {
                                                                                eventMember: newEventMember
                                                                            }, setEventMember, setMessage);
                                                                        }
                                                                        setNewGamerId(undefined);
                                                                    }
                                                                },
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8ef96f908dc0bdb8$exports))), {})
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 6,
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginBottom: '20px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                                            fullWidth: true,
                                                            text: `${playerArray.length} Spieler an Tische zuf\xe4llig verteilen`,
                                                            onClick: ()=>{
                                                                setShowTablePlayerDialog(false);
                                                                const getPlayerTables = ()=>{
                                                                    const playerTables = {};
                                                                    const shuffle = ()=>{
                                                                        return Math.random() - 0.5;
                                                                    };
                                                                    const shuffledArray = playerArray.sort(shuffle);
                                                                    // prüfen ob Handicap-Spieler mitspielen
                                                                    let handicapPlayer = false;
                                                                    shuffledArray.map((player)=>{
                                                                        const member = members?.results.find((member)=>member.originId === player);
                                                                        if (member?.handicap) handicapPlayer = true;
                                                                    });
                                                                    let playerCount = 3;
                                                                    if (handicapPlayer) playerCount = 3;
                                                                    else // mod 3 oder mod 4 === 0 > die Zahl jeweils nehmen
                                                                    if (playerCount % 4 === 0) playerCount = 4;
                                                                    const tableCount = Math.floor(shuffledArray.length / playerCount);
                                                                    for(let table = 1; table <= tableCount; table += 1)playerTables[table] = [];
                                                                    let i = 0;
                                                                    shuffledArray.map((elem)=>{
                                                                        i += 1;
                                                                        const table = i % tableCount + 1;
                                                                        playerTables[table].push(elem);
                                                                    });
                                                                    return playerTables;
                                                                };
                                                                const validTables = (playerTables)=>{
                                                                    // prüfen ob genauso viele 3er Tische, wie Handicap-Spieler da sind, sonst return true
                                                                    let tableWithThreePlayers = 0;
                                                                    let handicapPlayers = 0;
                                                                    Object.keys(playerTables).map((table)=>{
                                                                        if (playerTables[table].length === 3) tableWithThreePlayers += 1;
                                                                        playerTables[table].map((player)=>{
                                                                            const member = members?.results.find((member)=>member.originId === player);
                                                                            if (member?.handicap) handicapPlayers += 1;
                                                                        });
                                                                    });
                                                                    if (handicapPlayers > tableWithThreePlayers) return true;
                                                                    else {
                                                                        // prüfen, ob alle mit handycap an verschiedenen Tischen sitzen
                                                                        // und nicht an 4er Tischen
                                                                        let valid = true;
                                                                        Object.keys(playerTables).map((table)=>{
                                                                            let handicapCount = 0;
                                                                            playerTables[table].map((player)=>{
                                                                                const member = members?.results.find((member)=>member.originId === player);
                                                                                if (member?.handicap) handicapCount += 1;
                                                                            });
                                                                            if (handicapCount > 1 || handicapCount === 1 && playerTables[table].length === 4) valid = false;
                                                                        });
                                                                        return valid;
                                                                    }
                                                                };
                                                                const newEventResult = [];
                                                                for(let i = 1; i < 3; i += 1){
                                                                    let valid = false;
                                                                    let possibleTables = {};
                                                                    while(!valid){
                                                                        possibleTables = getPlayerTables();
                                                                        if (validTables(possibleTables)) valid = true;
                                                                    }
                                                                    Object.keys(possibleTables).map((table)=>{
                                                                        const results = {};
                                                                        possibleTables[table].map((player)=>{
                                                                            results[player] = {
                                                                                sessionResult: 0,
                                                                                wonOffense: 0,
                                                                                lostOffense: 0,
                                                                                lostDefense: 0,
                                                                                offensePoints: 0,
                                                                                defensePoints: 0,
                                                                                completeResult: 0
                                                                            };
                                                                        });
                                                                        const newResult = {
                                                                            eventId: props.eventId,
                                                                            table: table,
                                                                            session: i,
                                                                            players: possibleTables[table],
                                                                            games: {},
                                                                            results: results
                                                                        };
                                                                        newEventResult.push(newResult);
                                                                    });
                                                                }
                                                                setEventResults(newEventResult);
                                                                setStartAllowed(true);
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        children: user?.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).admin && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                                            fullWidth: true,
                                                            text: `${playerArray.length} Spieler an Tische direkt verteilen`,
                                                            onClick: ()=>{
                                                                setShowTablePlayerDialog(true);
                                                            }
                                                        })
                                                    }),
                                                    showTablePlayerDialog && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                                                            size: "small",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                                className: classes.tableHeader,
                                                                                children: "Tische"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                                className: classes.tableHeader,
                                                                                children: "Runde 1"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                                className: classes.tableHeader,
                                                                                children: "Runde 2"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                                                                    children: getSessionTables().map((table)=>{
                                                                        return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                                        children: table.value
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                                                                            multiple: true,
                                                                                            size: "small",
                                                                                            margin: "none",
                                                                                            label: "Spieler ausw\xe4hlen",
                                                                                            options: getSessionPlayers(),
                                                                                            onChangeList: (multipleValues)=>{
                                                                                                const players = [];
                                                                                                multipleValues.forEach((elem)=>{
                                                                                                    players.push(elem.key);
                                                                                                });
                                                                                                const results = {};
                                                                                                players.map((player)=>{
                                                                                                    results[player] = {
                                                                                                        sessionResult: 0,
                                                                                                        wonOffense: 0,
                                                                                                        lostOffense: 0,
                                                                                                        lostDefense: 0,
                                                                                                        offensePoints: 0,
                                                                                                        defensePoints: 0,
                                                                                                        completeResult: 0
                                                                                                    };
                                                                                                });
                                                                                                const newList = eventResults;
                                                                                                let elementFound = false;
                                                                                                newList.map((resultElement)=>{
                                                                                                    if (resultElement.table === parseInt(table.key, 10) && resultElement.session === 1) {
                                                                                                        elementFound = true;
                                                                                                        resultElement.players = players;
                                                                                                        resultElement.results = results;
                                                                                                    }
                                                                                                    return resultElement;
                                                                                                });
                                                                                                if (!elementFound) newList.push({
                                                                                                    eventId: props.eventId,
                                                                                                    table: parseInt(table.key, 10),
                                                                                                    session: 1,
                                                                                                    players: players,
                                                                                                    games: {},
                                                                                                    results: results
                                                                                                });
                                                                                                else setStartAllowed(true);
                                                                                                setEventResults(newList);
                                                                                                console.log(newList);
                                                                                            }
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                                                                            multiple: true,
                                                                                            size: "small",
                                                                                            margin: "none",
                                                                                            label: "Spieler ausw\xe4hlen",
                                                                                            options: getSessionPlayers(),
                                                                                            onChangeList: (multipleValues)=>{
                                                                                                const players = [];
                                                                                                multipleValues.forEach((elem)=>{
                                                                                                    players.push(elem.key);
                                                                                                });
                                                                                                const results = {};
                                                                                                players.map((player)=>{
                                                                                                    results[player] = {
                                                                                                        sessionResult: 0,
                                                                                                        wonOffense: 0,
                                                                                                        lostOffense: 0,
                                                                                                        lostDefense: 0,
                                                                                                        offensePoints: 0,
                                                                                                        defensePoints: 0,
                                                                                                        completeResult: 0
                                                                                                    };
                                                                                                });
                                                                                                const newList = eventResults;
                                                                                                let elementFound = false;
                                                                                                newList.map((resultElement)=>{
                                                                                                    if (resultElement.table === parseInt(table.key, 10) && resultElement.session === 2) {
                                                                                                        elementFound = true;
                                                                                                        resultElement.players = players;
                                                                                                        resultElement.results = results;
                                                                                                    }
                                                                                                    return resultElement;
                                                                                                });
                                                                                                if (!elementFound) newList.push({
                                                                                                    eventId: props.eventId,
                                                                                                    table: parseInt(table.key, 10),
                                                                                                    session: 2,
                                                                                                    players: players,
                                                                                                    games: {},
                                                                                                    results: results
                                                                                                });
                                                                                                else setStartAllowed(true);
                                                                                                setEventResults(newList);
                                                                                                console.log(newList);
                                                                                            }
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }, table.key)
                                                                        });
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    eventResults.length > 0 && !showTablePlayerDialog && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                                        direction: "column",
                                                        spacing: 2,
                                                        alignItems: "flex-start",
                                                        justifyContent: "space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                sx: {
                                                                    display: 'flex',
                                                                    flexWrap: 'wrap'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            width: '100%'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                            variant: "body1",
                                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                                children: "Runde 1"
                                                                            })
                                                                        })
                                                                    }),
                                                                    eventResults.sort((a, b)=>a.table - b.table).map((result)=>{
                                                                        return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                                            children: result.session === 1 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                                                children: TableAvatarBox(result)
                                                                            })
                                                                        });
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                sx: {
                                                                    display: 'flex',
                                                                    flexWrap: 'wrap'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            width: '100%'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                            variant: "body1",
                                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                                children: "Runde 2"
                                                                            })
                                                                        })
                                                                    }),
                                                                    eventResults.sort((a, b)=>a.table - b.table).map((result)=>{
                                                                        return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                                            children: result.session === 2 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                                                children: TableAvatarBox(result)
                                                                            })
                                                                        });
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $08e4970efe955928$export$2e2bcd8739ae039), {
                            sx: {
                                p: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    color: "secondary",
                                    variant: "text",
                                    text: "Abbrechen",
                                    onClick: ()=>{
                                        window.localStorage.setItem('openNewStartDialog', 'false');
                                        window.localStorage.removeItem('activeEventTab');
                                        setOpenNewStartDialog(false);
                                    }
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    variant: "contained",
                                    text: "Turnier starten",
                                    disabled: !startAllowed,
                                    onClick: ()=>{
                                        setEventStartet(true);
                                        setOpenNewStartDialog(false);
                                        window.localStorage.setItem('openNewStartDialog', 'false');
                                        window.localStorage.removeItem('activeEventTab');
                                        eventResults.map((round)=>{
                                            // neue Runden in DB anlegen
                                            const restUrl = `${restPath}/api/${(0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)()}/round`;
                                            fetch(restUrl, {
                                                method: 'POST',
                                                body: JSON.stringify({
                                                    round: {
                                                        eventId: props.eventId,
                                                        table: round.table,
                                                        session: round.session,
                                                        players: round.players
                                                    }
                                                }),
                                                credentials: 'include',
                                                headers: requestHeaders
                                            }).then((res)=>res.json()).then((json)=>{
                                                setEventResults(json);
                                            }).catch((err)=>console.log(err));
                                        });
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $46668510321f1f9f$export$2e2bcd8739ae039 = $46668510321f1f9f$var$EventResults;





var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");


var $gOPoC = parcelRequire("gOPoC");



function $69000087cbd5ebc7$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}





function $cfbd728dc663d8c9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $bbf672973d1421c5$export$2e2bcd8739ae039)(dirtyDate, amount * 1000);
}





var $934c914be0223c3d$var$MILLISECONDS_IN_MINUTE = 60000;
function $934c914be0223c3d$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $bbf672973d1421c5$export$2e2bcd8739ae039)(dirtyDate, amount * $934c914be0223c3d$var$MILLISECONDS_IN_MINUTE);
}





var $70bee95d8daf2f0a$var$MILLISECONDS_IN_HOUR = 3600000;
function $70bee95d8daf2f0a$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $bbf672973d1421c5$export$2e2bcd8739ae039)(dirtyDate, amount * $70bee95d8daf2f0a$var$MILLISECONDS_IN_HOUR);
}





function $5eeb5560d9f90b69$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyAmount);
    var days = amount * 7;
    return (0, $69000087cbd5ebc7$export$2e2bcd8739ae039)(dirtyDate, days);
}





function $8930a3f306514e64$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}





function $e052cdbe3be9402b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $8930a3f306514e64$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}





function $48956236fe1d4b01$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}




function $2088103071de2ed5$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1; // Return 0 if diff is 0; return NaN if diff is NaN
    else return diff;
}



function $b44f5ed897624aab$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $2088103071de2ed5$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $48956236fe1d4b01$export$2e2bcd8739ae039)(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $2088103071de2ed5$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero
    return result === 0 ? 0 : result;
}





function $17ef7f479598fb0a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}







function $564827580abaabe0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $cb24fcc00faea449$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $9d61d05e75b64edd$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    return (0, $564827580abaabe0$export$2e2bcd8739ae039)(date).getTime() === (0, $cb24fcc00faea449$export$2e2bcd8739ae039)(date).getTime();
}


function $d821a207cc5d6261$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $2088103071de2ed5$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $17ef7f479598fb0a$export$2e2bcd8739ae039)(dateLeft, dateRight));
    var result; // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $2088103071de2ed5$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month
        if ((0, $9d61d05e75b64edd$export$2e2bcd8739ae039)((0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateLeft)) && difference === 1 && (0, $2088103071de2ed5$export$2e2bcd8739ae039)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    } // Prevent negative zero
    return result === 0 ? 0 : result;
}



var $d7759e629bad2a97$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $d7759e629bad2a97$var$defaultRoundingMethod = 'trunc';
function $d7759e629bad2a97$export$b6474a47258c1211(method) {
    return method ? $d7759e629bad2a97$var$roundingMap[method] : $d7759e629bad2a97$var$roundingMap[$d7759e629bad2a97$var$defaultRoundingMethod];
}


function $3724d191adaefc07$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $d821a207cc5d6261$export$2e2bcd8739ae039)(dateLeft, dateRight) / 3;
    return (0, $d7759e629bad2a97$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}







function $9448c654ab8115b5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $f109192cd49aee8e$var$MILLISECONDS_IN_DAY = 86400000;
function $f109192cd49aee8e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $9448c654ab8115b5$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $9448c654ab8115b5$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $aa0ce4e10613bc89$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $aa0ce4e10613bc89$export$2e2bcd8739ae039)(startOfDayRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $f109192cd49aee8e$var$MILLISECONDS_IN_DAY);
}



// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $f54bc72aa4f5e7b1$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1; // Return 0 if diff is 0; return NaN if diff is NaN
    else return diff;
}
function $f54bc72aa4f5e7b1$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $f54bc72aa4f5e7b1$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $f109192cd49aee8e$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($f54bc72aa4f5e7b1$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull); // Prevent negative zero
    return result === 0 ? 0 : result;
}




function $411d679886711161$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $f54bc72aa4f5e7b1$export$2e2bcd8739ae039)(dateLeft, dateRight) / 7;
    return (0, $d7759e629bad2a97$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}



/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $db100e32c0b4bec4$export$dfd9b671c89acc8e = 7;
var $db100e32c0b4bec4$export$3913210603d8e9ae = 365.2425;
var $db100e32c0b4bec4$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $db100e32c0b4bec4$export$91246f0b9bd9beff = 60000;
var $db100e32c0b4bec4$export$7f72910d6dfd237a = 3600000;
var $db100e32c0b4bec4$export$397c2d5776aa9055 = 1000;
var $db100e32c0b4bec4$export$4dec998e48f9c246 = -$db100e32c0b4bec4$export$81caae6e1cc7a622;
var $db100e32c0b4bec4$export$f2f5ae5a8e2d8f9f = 60;
var $db100e32c0b4bec4$export$3c58128db900d44e = 3;
var $db100e32c0b4bec4$export$80d7e435f744f319 = 12;
var $db100e32c0b4bec4$export$4db7641526e3241f = 4;
var $db100e32c0b4bec4$export$698aec755e92c695 = 3600;
var $db100e32c0b4bec4$export$a77c1a7ebebe2a5a = 60;
var $db100e32c0b4bec4$export$815a9362476d2fe3 = $db100e32c0b4bec4$export$698aec755e92c695 * 24;
var $db100e32c0b4bec4$export$34804a017b31e2fe = $db100e32c0b4bec4$export$815a9362476d2fe3 * 7;
var $db100e32c0b4bec4$export$7271e9e3478110d1 = $db100e32c0b4bec4$export$815a9362476d2fe3 * $db100e32c0b4bec4$export$3913210603d8e9ae;
var $db100e32c0b4bec4$export$8e6600bbdee7dabb = $db100e32c0b4bec4$export$7271e9e3478110d1 / 12;
var $db100e32c0b4bec4$export$be1dccf2de902d31 = $db100e32c0b4bec4$export$8e6600bbdee7dabb * 3;




function $7d8eb08b69f2833e$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    return (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dateRight).getTime();
}




function $06fa58f6ec7ce547$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $7d8eb08b69f2833e$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $db100e32c0b4bec4$export$7f72910d6dfd237a);
    return (0, $d7759e629bad2a97$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}






function $1324f73a4ed7d73b$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $7d8eb08b69f2833e$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $db100e32c0b4bec4$export$91246f0b9bd9beff);
    return (0, $d7759e629bad2a97$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}





function $5ddaaeaf5281a1d7$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $7d8eb08b69f2833e$export$2e2bcd8739ae039)(dateLeft, dateRight) / 1000;
    return (0, $d7759e629bad2a97$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}





function $93e6480b9eb681b3$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(interval.start);
    var endDate = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(interval.end);
    var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}







function $a98ee795f1625aad$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $41b814f6c92f57a3$export$430a3269e24b912e)();
    var weekStartsOn = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $d7d551c90987298b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}





function $547920fa0626bab6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}




function $7d5f3d61cb138ad1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}




function $00cf5bd1b093c772$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var hours = date.getHours();
    return hours;
}




function $d257f12add849293$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}




function $2fe37e68266a3afe$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    return month;
}




function $f5e298044095f4c3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}




function $601d641e9a7e118d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var milliseconds = date.getMilliseconds();
    return milliseconds;
}






function $5ec71ed98601cb43$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $41b814f6c92f57a3$export$430a3269e24b912e)();
    var weekStartsOn = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}







function $90dd04b99b9f267f$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var defaultOptions = (0, $41b814f6c92f57a3$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $5ec71ed98601cb43$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $5ec71ed98601cb43$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $dfaddd302c4ef01f$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $41b814f6c92f57a3$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $90dd04b99b9f267f$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var date = (0, $5ec71ed98601cb43$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}




var $0baab285aeaff1e5$var$MILLISECONDS_IN_WEEK = 604800000;
function $0baab285aeaff1e5$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $5ec71ed98601cb43$export$2e2bcd8739ae039)(date, options).getTime() - (0, $dfaddd302c4ef01f$export$2e2bcd8739ae039)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $0baab285aeaff1e5$var$MILLISECONDS_IN_WEEK) + 1;
}




function $2ab9455fcba18cf3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    return (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate).getFullYear();
}




function $9bf8e5dcf0aa19e0$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}




function $b813b7e29ad2543f$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}




function $21fb9357be9d14c6$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyLeftDate);
    var dateRight = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}




function $8360ffa185725310$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $9448c654ab8115b5$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $9448c654ab8115b5$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}




function $d7d7b4da2a5ff3d9$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}




function $ed9e5a37d094d714$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}




function $cf2ef24f036b3968$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}



function $8c1bf20f1f686273$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfHour = (0, $cf2ef24f036b3968$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfHour = (0, $cf2ef24f036b3968$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}






function $207a83f6572786a2$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}







function $038c9c8ed64398ae$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $038c9c8ed64398ae$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $038c9c8ed64398ae$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $038c9c8ed64398ae$var$_typeof(obj);
}
function $038c9c8ed64398ae$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $038c9c8ed64398ae$var$_setPrototypeOf(subClass, superClass);
}
function $038c9c8ed64398ae$var$_setPrototypeOf(o, p) {
    $038c9c8ed64398ae$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $038c9c8ed64398ae$var$_setPrototypeOf(o, p);
}
function $038c9c8ed64398ae$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $038c9c8ed64398ae$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $038c9c8ed64398ae$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $038c9c8ed64398ae$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $038c9c8ed64398ae$var$_possibleConstructorReturn(this, result);
    };
}
function $038c9c8ed64398ae$var$_possibleConstructorReturn(self, call) {
    if (call && ($038c9c8ed64398ae$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $038c9c8ed64398ae$var$_assertThisInitialized(self);
}
function $038c9c8ed64398ae$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $038c9c8ed64398ae$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $038c9c8ed64398ae$var$_getPrototypeOf(o) {
    $038c9c8ed64398ae$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $038c9c8ed64398ae$var$_getPrototypeOf(o);
}
function $038c9c8ed64398ae$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $038c9c8ed64398ae$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $038c9c8ed64398ae$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $038c9c8ed64398ae$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $038c9c8ed64398ae$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $038c9c8ed64398ae$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $038c9c8ed64398ae$var$TIMEZONE_UNIT_PRIORITY = 10;
var $038c9c8ed64398ae$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        $038c9c8ed64398ae$var$_classCallCheck(this, Setter);
        $038c9c8ed64398ae$var$_defineProperty(this, "subPriority", 0);
    }
    $038c9c8ed64398ae$var$_createClass(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $038c9c8ed64398ae$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    $038c9c8ed64398ae$var$_inherits(ValueSetter, _Setter);
    var _super = $038c9c8ed64398ae$var$_createSuper(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        $038c9c8ed64398ae$var$_classCallCheck(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    $038c9c8ed64398ae$var$_createClass(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($038c9c8ed64398ae$export$81d53e3678089a6);
var $038c9c8ed64398ae$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    $038c9c8ed64398ae$var$_inherits(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = $038c9c8ed64398ae$var$_createSuper(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        $038c9c8ed64398ae$var$_classCallCheck(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        $038c9c8ed64398ae$var$_defineProperty($038c9c8ed64398ae$var$_assertThisInitialized(_this2), "priority", $038c9c8ed64398ae$var$TIMEZONE_UNIT_PRIORITY);
        $038c9c8ed64398ae$var$_defineProperty($038c9c8ed64398ae$var$_assertThisInitialized(_this2), "subPriority", -1);
        return _this2;
    }
    $038c9c8ed64398ae$var$_createClass(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($038c9c8ed64398ae$export$81d53e3678089a6);



function $4ffa53d668de2cfc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4ffa53d668de2cfc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4ffa53d668de2cfc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4ffa53d668de2cfc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4ffa53d668de2cfc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $4ffa53d668de2cfc$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        $4ffa53d668de2cfc$var$_classCallCheck(this, Parser);
    }
    $4ffa53d668de2cfc$var$_createClass(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $038c9c8ed64398ae$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


function $ac41d9fd9881319f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ac41d9fd9881319f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ac41d9fd9881319f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ac41d9fd9881319f$var$_typeof(obj);
}
function $ac41d9fd9881319f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ac41d9fd9881319f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ac41d9fd9881319f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ac41d9fd9881319f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ac41d9fd9881319f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ac41d9fd9881319f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ac41d9fd9881319f$var$_setPrototypeOf(subClass, superClass);
}
function $ac41d9fd9881319f$var$_setPrototypeOf(o, p) {
    $ac41d9fd9881319f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ac41d9fd9881319f$var$_setPrototypeOf(o, p);
}
function $ac41d9fd9881319f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ac41d9fd9881319f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ac41d9fd9881319f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ac41d9fd9881319f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ac41d9fd9881319f$var$_possibleConstructorReturn(this, result);
    };
}
function $ac41d9fd9881319f$var$_possibleConstructorReturn(self, call) {
    if (call && ($ac41d9fd9881319f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ac41d9fd9881319f$var$_assertThisInitialized(self);
}
function $ac41d9fd9881319f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ac41d9fd9881319f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ac41d9fd9881319f$var$_getPrototypeOf(o) {
    $ac41d9fd9881319f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ac41d9fd9881319f$var$_getPrototypeOf(o);
}
function $ac41d9fd9881319f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ac41d9fd9881319f$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    $ac41d9fd9881319f$var$_inherits(EraParser, _Parser);
    var _super = $ac41d9fd9881319f$var$_createSuper(EraParser);
    function EraParser() {
        var _this;
        $ac41d9fd9881319f$var$_classCallCheck(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $ac41d9fd9881319f$var$_defineProperty($ac41d9fd9881319f$var$_assertThisInitialized(_this), "priority", 140);
        $ac41d9fd9881319f$var$_defineProperty($ac41d9fd9881319f$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    $ac41d9fd9881319f$var$_createClass(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));




var $1cfbf898d09435e4$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $1cfbf898d09435e4$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $fcb051c3b30f179b$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $fcb051c3b30f179b$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $fcb051c3b30f179b$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
     // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $db100e32c0b4bec4$export$7f72910d6dfd237a) + minutes * (0, $db100e32c0b4bec4$export$91246f0b9bd9beff) + seconds * (0, $db100e32c0b4bec4$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $fcb051c3b30f179b$export$d931c43c4608a164(dateString) {
    return $fcb051c3b30f179b$export$cc7cc9e2a3ff9388((0, $1cfbf898d09435e4$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $fcb051c3b30f179b$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $fcb051c3b30f179b$export$cc7cc9e2a3ff9388((0, $1cfbf898d09435e4$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $fcb051c3b30f179b$export$cc7cc9e2a3ff9388((0, $1cfbf898d09435e4$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $fcb051c3b30f179b$export$cc7cc9e2a3ff9388((0, $1cfbf898d09435e4$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $fcb051c3b30f179b$export$cc7cc9e2a3ff9388((0, $1cfbf898d09435e4$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $fcb051c3b30f179b$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $fcb051c3b30f179b$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $fcb051c3b30f179b$export$cc7cc9e2a3ff9388((0, $1cfbf898d09435e4$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $fcb051c3b30f179b$export$cc7cc9e2a3ff9388((0, $1cfbf898d09435e4$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $fcb051c3b30f179b$export$cc7cc9e2a3ff9388((0, $1cfbf898d09435e4$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $fcb051c3b30f179b$export$cc7cc9e2a3ff9388((0, $1cfbf898d09435e4$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $fcb051c3b30f179b$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $fcb051c3b30f179b$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $fcb051c3b30f179b$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0; // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $fcb051c3b30f179b$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


function $a3a659d03da51084$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a3a659d03da51084$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a3a659d03da51084$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a3a659d03da51084$var$_typeof(obj);
}
function $a3a659d03da51084$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a3a659d03da51084$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a3a659d03da51084$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a3a659d03da51084$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a3a659d03da51084$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a3a659d03da51084$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a3a659d03da51084$var$_setPrototypeOf(subClass, superClass);
}
function $a3a659d03da51084$var$_setPrototypeOf(o, p) {
    $a3a659d03da51084$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a3a659d03da51084$var$_setPrototypeOf(o, p);
}
function $a3a659d03da51084$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a3a659d03da51084$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a3a659d03da51084$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a3a659d03da51084$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a3a659d03da51084$var$_possibleConstructorReturn(this, result);
    };
}
function $a3a659d03da51084$var$_possibleConstructorReturn(self, call) {
    if (call && ($a3a659d03da51084$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a3a659d03da51084$var$_assertThisInitialized(self);
}
function $a3a659d03da51084$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a3a659d03da51084$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a3a659d03da51084$var$_getPrototypeOf(o) {
    $a3a659d03da51084$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a3a659d03da51084$var$_getPrototypeOf(o);
}
function $a3a659d03da51084$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a3a659d03da51084$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    $a3a659d03da51084$var$_inherits(YearParser, _Parser);
    var _super = $a3a659d03da51084$var$_createSuper(YearParser);
    function YearParser() {
        var _this;
        $a3a659d03da51084$var$_classCallCheck(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $a3a659d03da51084$var$_defineProperty($a3a659d03da51084$var$_assertThisInitialized(_this), "priority", 130);
        $a3a659d03da51084$var$_defineProperty($a3a659d03da51084$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $a3a659d03da51084$var$_createClass(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)((0, $fcb051c3b30f179b$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)((0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $fcb051c3b30f179b$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));






function $a4e78b8ac2c8f02c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a4e78b8ac2c8f02c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a4e78b8ac2c8f02c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a4e78b8ac2c8f02c$var$_typeof(obj);
}
function $a4e78b8ac2c8f02c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a4e78b8ac2c8f02c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a4e78b8ac2c8f02c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a4e78b8ac2c8f02c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a4e78b8ac2c8f02c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a4e78b8ac2c8f02c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a4e78b8ac2c8f02c$var$_setPrototypeOf(subClass, superClass);
}
function $a4e78b8ac2c8f02c$var$_setPrototypeOf(o, p) {
    $a4e78b8ac2c8f02c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a4e78b8ac2c8f02c$var$_setPrototypeOf(o, p);
}
function $a4e78b8ac2c8f02c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a4e78b8ac2c8f02c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a4e78b8ac2c8f02c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a4e78b8ac2c8f02c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a4e78b8ac2c8f02c$var$_possibleConstructorReturn(this, result);
    };
}
function $a4e78b8ac2c8f02c$var$_possibleConstructorReturn(self, call) {
    if (call && ($a4e78b8ac2c8f02c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a4e78b8ac2c8f02c$var$_assertThisInitialized(self);
}
function $a4e78b8ac2c8f02c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a4e78b8ac2c8f02c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a4e78b8ac2c8f02c$var$_getPrototypeOf(o) {
    $a4e78b8ac2c8f02c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a4e78b8ac2c8f02c$var$_getPrototypeOf(o);
}
function $a4e78b8ac2c8f02c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a4e78b8ac2c8f02c$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    $a4e78b8ac2c8f02c$var$_inherits(LocalWeekYearParser, _Parser);
    var _super = $a4e78b8ac2c8f02c$var$_createSuper(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        $a4e78b8ac2c8f02c$var$_classCallCheck(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $a4e78b8ac2c8f02c$var$_defineProperty($a4e78b8ac2c8f02c$var$_assertThisInitialized(_this), "priority", 130);
        $a4e78b8ac2c8f02c$var$_defineProperty($a4e78b8ac2c8f02c$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    $a4e78b8ac2c8f02c$var$_createClass(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)((0, $fcb051c3b30f179b$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)((0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $c501c1ef4eb68741$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $fcb051c3b30f179b$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $6235b5f82708dfe3$export$2e2bcd8739ae039)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $6235b5f82708dfe3$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $e2155b2ce1d52a78$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e2155b2ce1d52a78$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e2155b2ce1d52a78$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e2155b2ce1d52a78$var$_typeof(obj);
}
function $e2155b2ce1d52a78$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e2155b2ce1d52a78$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e2155b2ce1d52a78$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e2155b2ce1d52a78$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e2155b2ce1d52a78$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e2155b2ce1d52a78$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e2155b2ce1d52a78$var$_setPrototypeOf(subClass, superClass);
}
function $e2155b2ce1d52a78$var$_setPrototypeOf(o, p) {
    $e2155b2ce1d52a78$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e2155b2ce1d52a78$var$_setPrototypeOf(o, p);
}
function $e2155b2ce1d52a78$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e2155b2ce1d52a78$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e2155b2ce1d52a78$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e2155b2ce1d52a78$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e2155b2ce1d52a78$var$_possibleConstructorReturn(this, result);
    };
}
function $e2155b2ce1d52a78$var$_possibleConstructorReturn(self, call) {
    if (call && ($e2155b2ce1d52a78$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $e2155b2ce1d52a78$var$_assertThisInitialized(self);
}
function $e2155b2ce1d52a78$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e2155b2ce1d52a78$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e2155b2ce1d52a78$var$_getPrototypeOf(o) {
    $e2155b2ce1d52a78$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e2155b2ce1d52a78$var$_getPrototypeOf(o);
}
function $e2155b2ce1d52a78$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $e2155b2ce1d52a78$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    $e2155b2ce1d52a78$var$_inherits(ISOWeekYearParser, _Parser);
    var _super = $e2155b2ce1d52a78$var$_createSuper(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        $e2155b2ce1d52a78$var$_classCallCheck(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $e2155b2ce1d52a78$var$_defineProperty($e2155b2ce1d52a78$var$_assertThisInitialized(_this), "priority", 130);
        $e2155b2ce1d52a78$var$_defineProperty($e2155b2ce1d52a78$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $e2155b2ce1d52a78$var$_createClass(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $fcb051c3b30f179b$export$2c9307b2e29c533c)(4, dateString);
                return (0, $fcb051c3b30f179b$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $b802085f0f1650ef$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));




function $db954a02b06dc7e9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $db954a02b06dc7e9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $db954a02b06dc7e9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $db954a02b06dc7e9$var$_typeof(obj);
}
function $db954a02b06dc7e9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $db954a02b06dc7e9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $db954a02b06dc7e9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $db954a02b06dc7e9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $db954a02b06dc7e9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $db954a02b06dc7e9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $db954a02b06dc7e9$var$_setPrototypeOf(subClass, superClass);
}
function $db954a02b06dc7e9$var$_setPrototypeOf(o, p) {
    $db954a02b06dc7e9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $db954a02b06dc7e9$var$_setPrototypeOf(o, p);
}
function $db954a02b06dc7e9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $db954a02b06dc7e9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $db954a02b06dc7e9$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $db954a02b06dc7e9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $db954a02b06dc7e9$var$_possibleConstructorReturn(this, result);
    };
}
function $db954a02b06dc7e9$var$_possibleConstructorReturn(self, call) {
    if (call && ($db954a02b06dc7e9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $db954a02b06dc7e9$var$_assertThisInitialized(self);
}
function $db954a02b06dc7e9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $db954a02b06dc7e9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $db954a02b06dc7e9$var$_getPrototypeOf(o) {
    $db954a02b06dc7e9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $db954a02b06dc7e9$var$_getPrototypeOf(o);
}
function $db954a02b06dc7e9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $db954a02b06dc7e9$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    $db954a02b06dc7e9$var$_inherits(ExtendedYearParser, _Parser);
    var _super = $db954a02b06dc7e9$var$_createSuper(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        $db954a02b06dc7e9$var$_classCallCheck(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $db954a02b06dc7e9$var$_defineProperty($db954a02b06dc7e9$var$_assertThisInitialized(_this), "priority", 130);
        $db954a02b06dc7e9$var$_defineProperty($db954a02b06dc7e9$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $db954a02b06dc7e9$var$_createClass(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $fcb051c3b30f179b$export$2c9307b2e29c533c)(4, dateString);
                return (0, $fcb051c3b30f179b$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));




function $d8f73969f249ac76$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d8f73969f249ac76$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d8f73969f249ac76$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d8f73969f249ac76$var$_typeof(obj);
}
function $d8f73969f249ac76$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d8f73969f249ac76$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d8f73969f249ac76$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d8f73969f249ac76$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d8f73969f249ac76$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d8f73969f249ac76$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d8f73969f249ac76$var$_setPrototypeOf(subClass, superClass);
}
function $d8f73969f249ac76$var$_setPrototypeOf(o, p) {
    $d8f73969f249ac76$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d8f73969f249ac76$var$_setPrototypeOf(o, p);
}
function $d8f73969f249ac76$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d8f73969f249ac76$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d8f73969f249ac76$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d8f73969f249ac76$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d8f73969f249ac76$var$_possibleConstructorReturn(this, result);
    };
}
function $d8f73969f249ac76$var$_possibleConstructorReturn(self, call) {
    if (call && ($d8f73969f249ac76$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d8f73969f249ac76$var$_assertThisInitialized(self);
}
function $d8f73969f249ac76$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d8f73969f249ac76$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d8f73969f249ac76$var$_getPrototypeOf(o) {
    $d8f73969f249ac76$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d8f73969f249ac76$var$_getPrototypeOf(o);
}
function $d8f73969f249ac76$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d8f73969f249ac76$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    $d8f73969f249ac76$var$_inherits(QuarterParser, _Parser);
    var _super = $d8f73969f249ac76$var$_createSuper(QuarterParser);
    function QuarterParser() {
        var _this;
        $d8f73969f249ac76$var$_classCallCheck(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $d8f73969f249ac76$var$_defineProperty($d8f73969f249ac76$var$_assertThisInitialized(_this), "priority", 120);
        $d8f73969f249ac76$var$_defineProperty($d8f73969f249ac76$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $d8f73969f249ac76$var$_createClass(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));




function $69a436102bb875a0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $69a436102bb875a0$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $69a436102bb875a0$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $69a436102bb875a0$var$_typeof(obj);
}
function $69a436102bb875a0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $69a436102bb875a0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $69a436102bb875a0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $69a436102bb875a0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $69a436102bb875a0$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $69a436102bb875a0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $69a436102bb875a0$var$_setPrototypeOf(subClass, superClass);
}
function $69a436102bb875a0$var$_setPrototypeOf(o, p) {
    $69a436102bb875a0$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $69a436102bb875a0$var$_setPrototypeOf(o, p);
}
function $69a436102bb875a0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $69a436102bb875a0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $69a436102bb875a0$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $69a436102bb875a0$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $69a436102bb875a0$var$_possibleConstructorReturn(this, result);
    };
}
function $69a436102bb875a0$var$_possibleConstructorReturn(self, call) {
    if (call && ($69a436102bb875a0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $69a436102bb875a0$var$_assertThisInitialized(self);
}
function $69a436102bb875a0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $69a436102bb875a0$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $69a436102bb875a0$var$_getPrototypeOf(o) {
    $69a436102bb875a0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $69a436102bb875a0$var$_getPrototypeOf(o);
}
function $69a436102bb875a0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $69a436102bb875a0$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    $69a436102bb875a0$var$_inherits(StandAloneQuarterParser, _Parser);
    var _super = $69a436102bb875a0$var$_createSuper(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        $69a436102bb875a0$var$_classCallCheck(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $69a436102bb875a0$var$_defineProperty($69a436102bb875a0$var$_assertThisInitialized(_this), "priority", 120);
        $69a436102bb875a0$var$_defineProperty($69a436102bb875a0$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $69a436102bb875a0$var$_createClass(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $d51d307bced53a8e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d51d307bced53a8e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d51d307bced53a8e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d51d307bced53a8e$var$_typeof(obj);
}
function $d51d307bced53a8e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d51d307bced53a8e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d51d307bced53a8e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d51d307bced53a8e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d51d307bced53a8e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d51d307bced53a8e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d51d307bced53a8e$var$_setPrototypeOf(subClass, superClass);
}
function $d51d307bced53a8e$var$_setPrototypeOf(o, p) {
    $d51d307bced53a8e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d51d307bced53a8e$var$_setPrototypeOf(o, p);
}
function $d51d307bced53a8e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d51d307bced53a8e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d51d307bced53a8e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d51d307bced53a8e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d51d307bced53a8e$var$_possibleConstructorReturn(this, result);
    };
}
function $d51d307bced53a8e$var$_possibleConstructorReturn(self, call) {
    if (call && ($d51d307bced53a8e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d51d307bced53a8e$var$_assertThisInitialized(self);
}
function $d51d307bced53a8e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d51d307bced53a8e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d51d307bced53a8e$var$_getPrototypeOf(o) {
    $d51d307bced53a8e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d51d307bced53a8e$var$_getPrototypeOf(o);
}
function $d51d307bced53a8e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d51d307bced53a8e$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    $d51d307bced53a8e$var$_inherits(MonthParser, _Parser);
    var _super = $d51d307bced53a8e$var$_createSuper(MonthParser);
    function MonthParser() {
        var _this;
        $d51d307bced53a8e$var$_classCallCheck(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $d51d307bced53a8e$var$_defineProperty($d51d307bced53a8e$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        $d51d307bced53a8e$var$_defineProperty($d51d307bced53a8e$var$_assertThisInitialized(_this), "priority", 110);
        return _this;
    }
    $d51d307bced53a8e$var$_createClass(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)((0, $fcb051c3b30f179b$export$cc7cc9e2a3ff9388)((0, $1cfbf898d09435e4$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)((0, $fcb051c3b30f179b$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $eba882d18251dd6b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $eba882d18251dd6b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $eba882d18251dd6b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eba882d18251dd6b$var$_typeof(obj);
}
function $eba882d18251dd6b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $eba882d18251dd6b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $eba882d18251dd6b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $eba882d18251dd6b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $eba882d18251dd6b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $eba882d18251dd6b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $eba882d18251dd6b$var$_setPrototypeOf(subClass, superClass);
}
function $eba882d18251dd6b$var$_setPrototypeOf(o, p) {
    $eba882d18251dd6b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $eba882d18251dd6b$var$_setPrototypeOf(o, p);
}
function $eba882d18251dd6b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $eba882d18251dd6b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $eba882d18251dd6b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $eba882d18251dd6b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $eba882d18251dd6b$var$_possibleConstructorReturn(this, result);
    };
}
function $eba882d18251dd6b$var$_possibleConstructorReturn(self, call) {
    if (call && ($eba882d18251dd6b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $eba882d18251dd6b$var$_assertThisInitialized(self);
}
function $eba882d18251dd6b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $eba882d18251dd6b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $eba882d18251dd6b$var$_getPrototypeOf(o) {
    $eba882d18251dd6b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $eba882d18251dd6b$var$_getPrototypeOf(o);
}
function $eba882d18251dd6b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $eba882d18251dd6b$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    $eba882d18251dd6b$var$_inherits(StandAloneMonthParser, _Parser);
    var _super = $eba882d18251dd6b$var$_createSuper(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        $eba882d18251dd6b$var$_classCallCheck(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $eba882d18251dd6b$var$_defineProperty($eba882d18251dd6b$var$_assertThisInitialized(_this), "priority", 110);
        $eba882d18251dd6b$var$_defineProperty($eba882d18251dd6b$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $eba882d18251dd6b$var$_createClass(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)((0, $fcb051c3b30f179b$export$cc7cc9e2a3ff9388)((0, $1cfbf898d09435e4$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)((0, $fcb051c3b30f179b$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));









function $fcadf103b52da18f$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $50a8e0e0a0f78f6c$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



function $a27805f28ac507c9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a27805f28ac507c9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a27805f28ac507c9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a27805f28ac507c9$var$_typeof(obj);
}
function $a27805f28ac507c9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a27805f28ac507c9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a27805f28ac507c9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a27805f28ac507c9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a27805f28ac507c9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a27805f28ac507c9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a27805f28ac507c9$var$_setPrototypeOf(subClass, superClass);
}
function $a27805f28ac507c9$var$_setPrototypeOf(o, p) {
    $a27805f28ac507c9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a27805f28ac507c9$var$_setPrototypeOf(o, p);
}
function $a27805f28ac507c9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a27805f28ac507c9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a27805f28ac507c9$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a27805f28ac507c9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a27805f28ac507c9$var$_possibleConstructorReturn(this, result);
    };
}
function $a27805f28ac507c9$var$_possibleConstructorReturn(self, call) {
    if (call && ($a27805f28ac507c9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a27805f28ac507c9$var$_assertThisInitialized(self);
}
function $a27805f28ac507c9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a27805f28ac507c9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a27805f28ac507c9$var$_getPrototypeOf(o) {
    $a27805f28ac507c9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a27805f28ac507c9$var$_getPrototypeOf(o);
}
function $a27805f28ac507c9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a27805f28ac507c9$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    $a27805f28ac507c9$var$_inherits(LocalWeekParser, _Parser);
    var _super = $a27805f28ac507c9$var$_createSuper(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        $a27805f28ac507c9$var$_classCallCheck(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $a27805f28ac507c9$var$_defineProperty($a27805f28ac507c9$var$_assertThisInitialized(_this), "priority", 100);
        $a27805f28ac507c9$var$_defineProperty($a27805f28ac507c9$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    $a27805f28ac507c9$var$_createClass(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $fcb051c3b30f179b$export$cc7cc9e2a3ff9388)((0, $1cfbf898d09435e4$export$c123ee06d9da8480).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $6235b5f82708dfe3$export$2e2bcd8739ae039)((0, $fcadf103b52da18f$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));









function $538cb0c017ec8b23$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $688d44451f09b750$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



function $783d620d7bac1f76$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $783d620d7bac1f76$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $783d620d7bac1f76$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $783d620d7bac1f76$var$_typeof(obj);
}
function $783d620d7bac1f76$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $783d620d7bac1f76$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $783d620d7bac1f76$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $783d620d7bac1f76$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $783d620d7bac1f76$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $783d620d7bac1f76$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $783d620d7bac1f76$var$_setPrototypeOf(subClass, superClass);
}
function $783d620d7bac1f76$var$_setPrototypeOf(o, p) {
    $783d620d7bac1f76$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $783d620d7bac1f76$var$_setPrototypeOf(o, p);
}
function $783d620d7bac1f76$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $783d620d7bac1f76$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $783d620d7bac1f76$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $783d620d7bac1f76$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $783d620d7bac1f76$var$_possibleConstructorReturn(this, result);
    };
}
function $783d620d7bac1f76$var$_possibleConstructorReturn(self, call) {
    if (call && ($783d620d7bac1f76$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $783d620d7bac1f76$var$_assertThisInitialized(self);
}
function $783d620d7bac1f76$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $783d620d7bac1f76$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $783d620d7bac1f76$var$_getPrototypeOf(o) {
    $783d620d7bac1f76$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $783d620d7bac1f76$var$_getPrototypeOf(o);
}
function $783d620d7bac1f76$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $783d620d7bac1f76$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    $783d620d7bac1f76$var$_inherits(ISOWeekParser, _Parser);
    var _super = $783d620d7bac1f76$var$_createSuper(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        $783d620d7bac1f76$var$_classCallCheck(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $783d620d7bac1f76$var$_defineProperty($783d620d7bac1f76$var$_assertThisInitialized(_this), "priority", 100);
        $783d620d7bac1f76$var$_defineProperty($783d620d7bac1f76$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $783d620d7bac1f76$var$_createClass(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $fcb051c3b30f179b$export$cc7cc9e2a3ff9388)((0, $1cfbf898d09435e4$export$c123ee06d9da8480).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $b802085f0f1650ef$export$2e2bcd8739ae039)((0, $538cb0c017ec8b23$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $80fe019a970b7ea9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $80fe019a970b7ea9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $80fe019a970b7ea9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $80fe019a970b7ea9$var$_typeof(obj);
}
function $80fe019a970b7ea9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $80fe019a970b7ea9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $80fe019a970b7ea9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $80fe019a970b7ea9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $80fe019a970b7ea9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $80fe019a970b7ea9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $80fe019a970b7ea9$var$_setPrototypeOf(subClass, superClass);
}
function $80fe019a970b7ea9$var$_setPrototypeOf(o, p) {
    $80fe019a970b7ea9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $80fe019a970b7ea9$var$_setPrototypeOf(o, p);
}
function $80fe019a970b7ea9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $80fe019a970b7ea9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $80fe019a970b7ea9$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $80fe019a970b7ea9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $80fe019a970b7ea9$var$_possibleConstructorReturn(this, result);
    };
}
function $80fe019a970b7ea9$var$_possibleConstructorReturn(self, call) {
    if (call && ($80fe019a970b7ea9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $80fe019a970b7ea9$var$_assertThisInitialized(self);
}
function $80fe019a970b7ea9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $80fe019a970b7ea9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $80fe019a970b7ea9$var$_getPrototypeOf(o) {
    $80fe019a970b7ea9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $80fe019a970b7ea9$var$_getPrototypeOf(o);
}
function $80fe019a970b7ea9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $80fe019a970b7ea9$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $80fe019a970b7ea9$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
]; // Day of the month
var $80fe019a970b7ea9$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    $80fe019a970b7ea9$var$_inherits(DateParser, _Parser);
    var _super = $80fe019a970b7ea9$var$_createSuper(DateParser);
    function DateParser() {
        var _this;
        $80fe019a970b7ea9$var$_classCallCheck(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $80fe019a970b7ea9$var$_defineProperty($80fe019a970b7ea9$var$_assertThisInitialized(_this), "priority", 90);
        $80fe019a970b7ea9$var$_defineProperty($80fe019a970b7ea9$var$_assertThisInitialized(_this), "subPriority", 1);
        $80fe019a970b7ea9$var$_defineProperty($80fe019a970b7ea9$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $80fe019a970b7ea9$var$_createClass(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $fcb051c3b30f179b$export$cc7cc9e2a3ff9388)((0, $1cfbf898d09435e4$export$c123ee06d9da8480).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $fcb051c3b30f179b$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $80fe019a970b7ea9$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $80fe019a970b7ea9$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $03154af5f62474b3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $03154af5f62474b3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $03154af5f62474b3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $03154af5f62474b3$var$_typeof(obj);
}
function $03154af5f62474b3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $03154af5f62474b3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $03154af5f62474b3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $03154af5f62474b3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $03154af5f62474b3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $03154af5f62474b3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $03154af5f62474b3$var$_setPrototypeOf(subClass, superClass);
}
function $03154af5f62474b3$var$_setPrototypeOf(o, p) {
    $03154af5f62474b3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $03154af5f62474b3$var$_setPrototypeOf(o, p);
}
function $03154af5f62474b3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $03154af5f62474b3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $03154af5f62474b3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $03154af5f62474b3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $03154af5f62474b3$var$_possibleConstructorReturn(this, result);
    };
}
function $03154af5f62474b3$var$_possibleConstructorReturn(self, call) {
    if (call && ($03154af5f62474b3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $03154af5f62474b3$var$_assertThisInitialized(self);
}
function $03154af5f62474b3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $03154af5f62474b3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $03154af5f62474b3$var$_getPrototypeOf(o) {
    $03154af5f62474b3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $03154af5f62474b3$var$_getPrototypeOf(o);
}
function $03154af5f62474b3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $03154af5f62474b3$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    $03154af5f62474b3$var$_inherits(DayOfYearParser, _Parser);
    var _super = $03154af5f62474b3$var$_createSuper(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        $03154af5f62474b3$var$_classCallCheck(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $03154af5f62474b3$var$_defineProperty($03154af5f62474b3$var$_assertThisInitialized(_this), "priority", 90);
        $03154af5f62474b3$var$_defineProperty($03154af5f62474b3$var$_assertThisInitialized(_this), "subpriority", 1);
        $03154af5f62474b3$var$_defineProperty($03154af5f62474b3$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $03154af5f62474b3$var$_createClass(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $fcb051c3b30f179b$export$cc7cc9e2a3ff9388)((0, $1cfbf898d09435e4$export$c123ee06d9da8480).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $fcb051c3b30f179b$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));







function $f0038eaf85b506f8$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $41b814f6c92f57a3$export$430a3269e24b912e)();
    var weekStartsOn = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


function $4b528792c95e40a5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4b528792c95e40a5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4b528792c95e40a5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4b528792c95e40a5$var$_typeof(obj);
}
function $4b528792c95e40a5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4b528792c95e40a5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4b528792c95e40a5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4b528792c95e40a5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4b528792c95e40a5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4b528792c95e40a5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $4b528792c95e40a5$var$_setPrototypeOf(subClass, superClass);
}
function $4b528792c95e40a5$var$_setPrototypeOf(o, p) {
    $4b528792c95e40a5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4b528792c95e40a5$var$_setPrototypeOf(o, p);
}
function $4b528792c95e40a5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4b528792c95e40a5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $4b528792c95e40a5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4b528792c95e40a5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4b528792c95e40a5$var$_possibleConstructorReturn(this, result);
    };
}
function $4b528792c95e40a5$var$_possibleConstructorReturn(self, call) {
    if (call && ($4b528792c95e40a5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $4b528792c95e40a5$var$_assertThisInitialized(self);
}
function $4b528792c95e40a5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4b528792c95e40a5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4b528792c95e40a5$var$_getPrototypeOf(o) {
    $4b528792c95e40a5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4b528792c95e40a5$var$_getPrototypeOf(o);
}
function $4b528792c95e40a5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $4b528792c95e40a5$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    $4b528792c95e40a5$var$_inherits(DayParser, _Parser);
    var _super = $4b528792c95e40a5$var$_createSuper(DayParser);
    function DayParser() {
        var _this;
        $4b528792c95e40a5$var$_classCallCheck(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $4b528792c95e40a5$var$_defineProperty($4b528792c95e40a5$var$_assertThisInitialized(_this), "priority", 90);
        $4b528792c95e40a5$var$_defineProperty($4b528792c95e40a5$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $4b528792c95e40a5$var$_createClass(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $f0038eaf85b506f8$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $a73947081e6f7a0d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a73947081e6f7a0d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a73947081e6f7a0d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a73947081e6f7a0d$var$_typeof(obj);
}
function $a73947081e6f7a0d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a73947081e6f7a0d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a73947081e6f7a0d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a73947081e6f7a0d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a73947081e6f7a0d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a73947081e6f7a0d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a73947081e6f7a0d$var$_setPrototypeOf(subClass, superClass);
}
function $a73947081e6f7a0d$var$_setPrototypeOf(o, p) {
    $a73947081e6f7a0d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a73947081e6f7a0d$var$_setPrototypeOf(o, p);
}
function $a73947081e6f7a0d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a73947081e6f7a0d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a73947081e6f7a0d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a73947081e6f7a0d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a73947081e6f7a0d$var$_possibleConstructorReturn(this, result);
    };
}
function $a73947081e6f7a0d$var$_possibleConstructorReturn(self, call) {
    if (call && ($a73947081e6f7a0d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a73947081e6f7a0d$var$_assertThisInitialized(self);
}
function $a73947081e6f7a0d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a73947081e6f7a0d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a73947081e6f7a0d$var$_getPrototypeOf(o) {
    $a73947081e6f7a0d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a73947081e6f7a0d$var$_getPrototypeOf(o);
}
function $a73947081e6f7a0d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a73947081e6f7a0d$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    $a73947081e6f7a0d$var$_inherits(LocalDayParser, _Parser);
    var _super = $a73947081e6f7a0d$var$_createSuper(LocalDayParser);
    function LocalDayParser() {
        var _this;
        $a73947081e6f7a0d$var$_classCallCheck(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $a73947081e6f7a0d$var$_defineProperty($a73947081e6f7a0d$var$_assertThisInitialized(_this), "priority", 90);
        $a73947081e6f7a0d$var$_defineProperty($a73947081e6f7a0d$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $a73947081e6f7a0d$var$_createClass(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)((0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $f0038eaf85b506f8$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $48ca28ea3abcf8b7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $48ca28ea3abcf8b7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $48ca28ea3abcf8b7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $48ca28ea3abcf8b7$var$_typeof(obj);
}
function $48ca28ea3abcf8b7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $48ca28ea3abcf8b7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $48ca28ea3abcf8b7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $48ca28ea3abcf8b7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $48ca28ea3abcf8b7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $48ca28ea3abcf8b7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $48ca28ea3abcf8b7$var$_setPrototypeOf(subClass, superClass);
}
function $48ca28ea3abcf8b7$var$_setPrototypeOf(o, p) {
    $48ca28ea3abcf8b7$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $48ca28ea3abcf8b7$var$_setPrototypeOf(o, p);
}
function $48ca28ea3abcf8b7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $48ca28ea3abcf8b7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $48ca28ea3abcf8b7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $48ca28ea3abcf8b7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $48ca28ea3abcf8b7$var$_possibleConstructorReturn(this, result);
    };
}
function $48ca28ea3abcf8b7$var$_possibleConstructorReturn(self, call) {
    if (call && ($48ca28ea3abcf8b7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $48ca28ea3abcf8b7$var$_assertThisInitialized(self);
}
function $48ca28ea3abcf8b7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $48ca28ea3abcf8b7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $48ca28ea3abcf8b7$var$_getPrototypeOf(o) {
    $48ca28ea3abcf8b7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $48ca28ea3abcf8b7$var$_getPrototypeOf(o);
}
function $48ca28ea3abcf8b7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $48ca28ea3abcf8b7$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    $48ca28ea3abcf8b7$var$_inherits(StandAloneLocalDayParser, _Parser);
    var _super = $48ca28ea3abcf8b7$var$_createSuper(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        $48ca28ea3abcf8b7$var$_classCallCheck(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $48ca28ea3abcf8b7$var$_defineProperty($48ca28ea3abcf8b7$var$_assertThisInitialized(_this), "priority", 90);
        $48ca28ea3abcf8b7$var$_defineProperty($48ca28ea3abcf8b7$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    $48ca28ea3abcf8b7$var$_createClass(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)((0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $f0038eaf85b506f8$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));







function $4843b5d436646c94$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


function $8e24f9cc98485f6d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8e24f9cc98485f6d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8e24f9cc98485f6d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8e24f9cc98485f6d$var$_typeof(obj);
}
function $8e24f9cc98485f6d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8e24f9cc98485f6d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8e24f9cc98485f6d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8e24f9cc98485f6d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8e24f9cc98485f6d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8e24f9cc98485f6d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8e24f9cc98485f6d$var$_setPrototypeOf(subClass, superClass);
}
function $8e24f9cc98485f6d$var$_setPrototypeOf(o, p) {
    $8e24f9cc98485f6d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8e24f9cc98485f6d$var$_setPrototypeOf(o, p);
}
function $8e24f9cc98485f6d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8e24f9cc98485f6d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8e24f9cc98485f6d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8e24f9cc98485f6d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8e24f9cc98485f6d$var$_possibleConstructorReturn(this, result);
    };
}
function $8e24f9cc98485f6d$var$_possibleConstructorReturn(self, call) {
    if (call && ($8e24f9cc98485f6d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $8e24f9cc98485f6d$var$_assertThisInitialized(self);
}
function $8e24f9cc98485f6d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8e24f9cc98485f6d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8e24f9cc98485f6d$var$_getPrototypeOf(o) {
    $8e24f9cc98485f6d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8e24f9cc98485f6d$var$_getPrototypeOf(o);
}
function $8e24f9cc98485f6d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $8e24f9cc98485f6d$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    $8e24f9cc98485f6d$var$_inherits(ISODayParser, _Parser);
    var _super = $8e24f9cc98485f6d$var$_createSuper(ISODayParser);
    function ISODayParser() {
        var _this;
        $8e24f9cc98485f6d$var$_classCallCheck(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $8e24f9cc98485f6d$var$_defineProperty($8e24f9cc98485f6d$var$_assertThisInitialized(_this), "priority", 90);
        $8e24f9cc98485f6d$var$_defineProperty($8e24f9cc98485f6d$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $8e24f9cc98485f6d$var$_createClass(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $4843b5d436646c94$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));




function $08880b8d891e1ab0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $08880b8d891e1ab0$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $08880b8d891e1ab0$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $08880b8d891e1ab0$var$_typeof(obj);
}
function $08880b8d891e1ab0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $08880b8d891e1ab0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $08880b8d891e1ab0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $08880b8d891e1ab0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $08880b8d891e1ab0$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $08880b8d891e1ab0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $08880b8d891e1ab0$var$_setPrototypeOf(subClass, superClass);
}
function $08880b8d891e1ab0$var$_setPrototypeOf(o, p) {
    $08880b8d891e1ab0$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $08880b8d891e1ab0$var$_setPrototypeOf(o, p);
}
function $08880b8d891e1ab0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $08880b8d891e1ab0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $08880b8d891e1ab0$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $08880b8d891e1ab0$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $08880b8d891e1ab0$var$_possibleConstructorReturn(this, result);
    };
}
function $08880b8d891e1ab0$var$_possibleConstructorReturn(self, call) {
    if (call && ($08880b8d891e1ab0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $08880b8d891e1ab0$var$_assertThisInitialized(self);
}
function $08880b8d891e1ab0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $08880b8d891e1ab0$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $08880b8d891e1ab0$var$_getPrototypeOf(o) {
    $08880b8d891e1ab0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $08880b8d891e1ab0$var$_getPrototypeOf(o);
}
function $08880b8d891e1ab0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $08880b8d891e1ab0$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    $08880b8d891e1ab0$var$_inherits(AMPMParser, _Parser);
    var _super = $08880b8d891e1ab0$var$_createSuper(AMPMParser);
    function AMPMParser() {
        var _this;
        $08880b8d891e1ab0$var$_classCallCheck(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $08880b8d891e1ab0$var$_defineProperty($08880b8d891e1ab0$var$_assertThisInitialized(_this), "priority", 80);
        $08880b8d891e1ab0$var$_defineProperty($08880b8d891e1ab0$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $08880b8d891e1ab0$var$_createClass(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $fcb051c3b30f179b$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));




function $1272d444b3e31e9a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1272d444b3e31e9a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1272d444b3e31e9a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1272d444b3e31e9a$var$_typeof(obj);
}
function $1272d444b3e31e9a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1272d444b3e31e9a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1272d444b3e31e9a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1272d444b3e31e9a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1272d444b3e31e9a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1272d444b3e31e9a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1272d444b3e31e9a$var$_setPrototypeOf(subClass, superClass);
}
function $1272d444b3e31e9a$var$_setPrototypeOf(o, p) {
    $1272d444b3e31e9a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1272d444b3e31e9a$var$_setPrototypeOf(o, p);
}
function $1272d444b3e31e9a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1272d444b3e31e9a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1272d444b3e31e9a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1272d444b3e31e9a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1272d444b3e31e9a$var$_possibleConstructorReturn(this, result);
    };
}
function $1272d444b3e31e9a$var$_possibleConstructorReturn(self, call) {
    if (call && ($1272d444b3e31e9a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $1272d444b3e31e9a$var$_assertThisInitialized(self);
}
function $1272d444b3e31e9a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1272d444b3e31e9a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1272d444b3e31e9a$var$_getPrototypeOf(o) {
    $1272d444b3e31e9a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1272d444b3e31e9a$var$_getPrototypeOf(o);
}
function $1272d444b3e31e9a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1272d444b3e31e9a$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    $1272d444b3e31e9a$var$_inherits(AMPMMidnightParser, _Parser);
    var _super = $1272d444b3e31e9a$var$_createSuper(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        $1272d444b3e31e9a$var$_classCallCheck(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $1272d444b3e31e9a$var$_defineProperty($1272d444b3e31e9a$var$_assertThisInitialized(_this), "priority", 80);
        $1272d444b3e31e9a$var$_defineProperty($1272d444b3e31e9a$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $1272d444b3e31e9a$var$_createClass(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $fcb051c3b30f179b$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));




function $24ec60640777809c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $24ec60640777809c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $24ec60640777809c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $24ec60640777809c$var$_typeof(obj);
}
function $24ec60640777809c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $24ec60640777809c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $24ec60640777809c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $24ec60640777809c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $24ec60640777809c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $24ec60640777809c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $24ec60640777809c$var$_setPrototypeOf(subClass, superClass);
}
function $24ec60640777809c$var$_setPrototypeOf(o, p) {
    $24ec60640777809c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $24ec60640777809c$var$_setPrototypeOf(o, p);
}
function $24ec60640777809c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $24ec60640777809c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $24ec60640777809c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $24ec60640777809c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $24ec60640777809c$var$_possibleConstructorReturn(this, result);
    };
}
function $24ec60640777809c$var$_possibleConstructorReturn(self, call) {
    if (call && ($24ec60640777809c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $24ec60640777809c$var$_assertThisInitialized(self);
}
function $24ec60640777809c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $24ec60640777809c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $24ec60640777809c$var$_getPrototypeOf(o) {
    $24ec60640777809c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $24ec60640777809c$var$_getPrototypeOf(o);
}
function $24ec60640777809c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $24ec60640777809c$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    $24ec60640777809c$var$_inherits(DayPeriodParser, _Parser);
    var _super = $24ec60640777809c$var$_createSuper(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        $24ec60640777809c$var$_classCallCheck(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $24ec60640777809c$var$_defineProperty($24ec60640777809c$var$_assertThisInitialized(_this), "priority", 80);
        $24ec60640777809c$var$_defineProperty($24ec60640777809c$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    $24ec60640777809c$var$_createClass(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $fcb051c3b30f179b$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $9ea953e6e89d225c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9ea953e6e89d225c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9ea953e6e89d225c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9ea953e6e89d225c$var$_typeof(obj);
}
function $9ea953e6e89d225c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9ea953e6e89d225c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9ea953e6e89d225c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9ea953e6e89d225c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9ea953e6e89d225c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $9ea953e6e89d225c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $9ea953e6e89d225c$var$_setPrototypeOf(subClass, superClass);
}
function $9ea953e6e89d225c$var$_setPrototypeOf(o, p) {
    $9ea953e6e89d225c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9ea953e6e89d225c$var$_setPrototypeOf(o, p);
}
function $9ea953e6e89d225c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9ea953e6e89d225c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9ea953e6e89d225c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9ea953e6e89d225c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9ea953e6e89d225c$var$_possibleConstructorReturn(this, result);
    };
}
function $9ea953e6e89d225c$var$_possibleConstructorReturn(self, call) {
    if (call && ($9ea953e6e89d225c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $9ea953e6e89d225c$var$_assertThisInitialized(self);
}
function $9ea953e6e89d225c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9ea953e6e89d225c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9ea953e6e89d225c$var$_getPrototypeOf(o) {
    $9ea953e6e89d225c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9ea953e6e89d225c$var$_getPrototypeOf(o);
}
function $9ea953e6e89d225c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $9ea953e6e89d225c$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    $9ea953e6e89d225c$var$_inherits(Hour1to12Parser, _Parser);
    var _super = $9ea953e6e89d225c$var$_createSuper(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        $9ea953e6e89d225c$var$_classCallCheck(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $9ea953e6e89d225c$var$_defineProperty($9ea953e6e89d225c$var$_assertThisInitialized(_this), "priority", 70);
        $9ea953e6e89d225c$var$_defineProperty($9ea953e6e89d225c$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $9ea953e6e89d225c$var$_createClass(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $fcb051c3b30f179b$export$cc7cc9e2a3ff9388)((0, $1cfbf898d09435e4$export$c123ee06d9da8480).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $4e136bb445622747$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4e136bb445622747$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4e136bb445622747$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4e136bb445622747$var$_typeof(obj);
}
function $4e136bb445622747$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4e136bb445622747$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4e136bb445622747$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4e136bb445622747$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4e136bb445622747$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4e136bb445622747$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $4e136bb445622747$var$_setPrototypeOf(subClass, superClass);
}
function $4e136bb445622747$var$_setPrototypeOf(o, p) {
    $4e136bb445622747$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4e136bb445622747$var$_setPrototypeOf(o, p);
}
function $4e136bb445622747$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4e136bb445622747$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $4e136bb445622747$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4e136bb445622747$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4e136bb445622747$var$_possibleConstructorReturn(this, result);
    };
}
function $4e136bb445622747$var$_possibleConstructorReturn(self, call) {
    if (call && ($4e136bb445622747$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $4e136bb445622747$var$_assertThisInitialized(self);
}
function $4e136bb445622747$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4e136bb445622747$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4e136bb445622747$var$_getPrototypeOf(o) {
    $4e136bb445622747$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4e136bb445622747$var$_getPrototypeOf(o);
}
function $4e136bb445622747$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $4e136bb445622747$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    $4e136bb445622747$var$_inherits(Hour0to23Parser, _Parser);
    var _super = $4e136bb445622747$var$_createSuper(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        $4e136bb445622747$var$_classCallCheck(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $4e136bb445622747$var$_defineProperty($4e136bb445622747$var$_assertThisInitialized(_this), "priority", 70);
        $4e136bb445622747$var$_defineProperty($4e136bb445622747$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $4e136bb445622747$var$_createClass(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $fcb051c3b30f179b$export$cc7cc9e2a3ff9388)((0, $1cfbf898d09435e4$export$c123ee06d9da8480).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $419a70fff13c331c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $419a70fff13c331c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $419a70fff13c331c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $419a70fff13c331c$var$_typeof(obj);
}
function $419a70fff13c331c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $419a70fff13c331c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $419a70fff13c331c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $419a70fff13c331c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $419a70fff13c331c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $419a70fff13c331c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $419a70fff13c331c$var$_setPrototypeOf(subClass, superClass);
}
function $419a70fff13c331c$var$_setPrototypeOf(o, p) {
    $419a70fff13c331c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $419a70fff13c331c$var$_setPrototypeOf(o, p);
}
function $419a70fff13c331c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $419a70fff13c331c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $419a70fff13c331c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $419a70fff13c331c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $419a70fff13c331c$var$_possibleConstructorReturn(this, result);
    };
}
function $419a70fff13c331c$var$_possibleConstructorReturn(self, call) {
    if (call && ($419a70fff13c331c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $419a70fff13c331c$var$_assertThisInitialized(self);
}
function $419a70fff13c331c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $419a70fff13c331c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $419a70fff13c331c$var$_getPrototypeOf(o) {
    $419a70fff13c331c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $419a70fff13c331c$var$_getPrototypeOf(o);
}
function $419a70fff13c331c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $419a70fff13c331c$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    $419a70fff13c331c$var$_inherits(Hour0To11Parser, _Parser);
    var _super = $419a70fff13c331c$var$_createSuper(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        $419a70fff13c331c$var$_classCallCheck(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $419a70fff13c331c$var$_defineProperty($419a70fff13c331c$var$_assertThisInitialized(_this), "priority", 70);
        $419a70fff13c331c$var$_defineProperty($419a70fff13c331c$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $419a70fff13c331c$var$_createClass(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $fcb051c3b30f179b$export$cc7cc9e2a3ff9388)((0, $1cfbf898d09435e4$export$c123ee06d9da8480).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $abb86d9810ed7f24$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $abb86d9810ed7f24$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $abb86d9810ed7f24$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $abb86d9810ed7f24$var$_typeof(obj);
}
function $abb86d9810ed7f24$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $abb86d9810ed7f24$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $abb86d9810ed7f24$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $abb86d9810ed7f24$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $abb86d9810ed7f24$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $abb86d9810ed7f24$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $abb86d9810ed7f24$var$_setPrototypeOf(subClass, superClass);
}
function $abb86d9810ed7f24$var$_setPrototypeOf(o, p) {
    $abb86d9810ed7f24$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $abb86d9810ed7f24$var$_setPrototypeOf(o, p);
}
function $abb86d9810ed7f24$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $abb86d9810ed7f24$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $abb86d9810ed7f24$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $abb86d9810ed7f24$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $abb86d9810ed7f24$var$_possibleConstructorReturn(this, result);
    };
}
function $abb86d9810ed7f24$var$_possibleConstructorReturn(self, call) {
    if (call && ($abb86d9810ed7f24$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $abb86d9810ed7f24$var$_assertThisInitialized(self);
}
function $abb86d9810ed7f24$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $abb86d9810ed7f24$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $abb86d9810ed7f24$var$_getPrototypeOf(o) {
    $abb86d9810ed7f24$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $abb86d9810ed7f24$var$_getPrototypeOf(o);
}
function $abb86d9810ed7f24$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $abb86d9810ed7f24$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    $abb86d9810ed7f24$var$_inherits(Hour1To24Parser, _Parser);
    var _super = $abb86d9810ed7f24$var$_createSuper(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        $abb86d9810ed7f24$var$_classCallCheck(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $abb86d9810ed7f24$var$_defineProperty($abb86d9810ed7f24$var$_assertThisInitialized(_this), "priority", 70);
        $abb86d9810ed7f24$var$_defineProperty($abb86d9810ed7f24$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    $abb86d9810ed7f24$var$_createClass(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $fcb051c3b30f179b$export$cc7cc9e2a3ff9388)((0, $1cfbf898d09435e4$export$c123ee06d9da8480).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $6229dbb5225e5bd6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6229dbb5225e5bd6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6229dbb5225e5bd6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6229dbb5225e5bd6$var$_typeof(obj);
}
function $6229dbb5225e5bd6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6229dbb5225e5bd6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6229dbb5225e5bd6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6229dbb5225e5bd6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6229dbb5225e5bd6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6229dbb5225e5bd6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6229dbb5225e5bd6$var$_setPrototypeOf(subClass, superClass);
}
function $6229dbb5225e5bd6$var$_setPrototypeOf(o, p) {
    $6229dbb5225e5bd6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6229dbb5225e5bd6$var$_setPrototypeOf(o, p);
}
function $6229dbb5225e5bd6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6229dbb5225e5bd6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6229dbb5225e5bd6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6229dbb5225e5bd6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6229dbb5225e5bd6$var$_possibleConstructorReturn(this, result);
    };
}
function $6229dbb5225e5bd6$var$_possibleConstructorReturn(self, call) {
    if (call && ($6229dbb5225e5bd6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6229dbb5225e5bd6$var$_assertThisInitialized(self);
}
function $6229dbb5225e5bd6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6229dbb5225e5bd6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6229dbb5225e5bd6$var$_getPrototypeOf(o) {
    $6229dbb5225e5bd6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6229dbb5225e5bd6$var$_getPrototypeOf(o);
}
function $6229dbb5225e5bd6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6229dbb5225e5bd6$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    $6229dbb5225e5bd6$var$_inherits(MinuteParser, _Parser);
    var _super = $6229dbb5225e5bd6$var$_createSuper(MinuteParser);
    function MinuteParser() {
        var _this;
        $6229dbb5225e5bd6$var$_classCallCheck(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $6229dbb5225e5bd6$var$_defineProperty($6229dbb5225e5bd6$var$_assertThisInitialized(_this), "priority", 60);
        $6229dbb5225e5bd6$var$_defineProperty($6229dbb5225e5bd6$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    $6229dbb5225e5bd6$var$_createClass(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $fcb051c3b30f179b$export$cc7cc9e2a3ff9388)((0, $1cfbf898d09435e4$export$c123ee06d9da8480).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $1b4df03ec638d56c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1b4df03ec638d56c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1b4df03ec638d56c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1b4df03ec638d56c$var$_typeof(obj);
}
function $1b4df03ec638d56c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1b4df03ec638d56c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1b4df03ec638d56c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1b4df03ec638d56c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1b4df03ec638d56c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1b4df03ec638d56c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1b4df03ec638d56c$var$_setPrototypeOf(subClass, superClass);
}
function $1b4df03ec638d56c$var$_setPrototypeOf(o, p) {
    $1b4df03ec638d56c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1b4df03ec638d56c$var$_setPrototypeOf(o, p);
}
function $1b4df03ec638d56c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1b4df03ec638d56c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1b4df03ec638d56c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1b4df03ec638d56c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1b4df03ec638d56c$var$_possibleConstructorReturn(this, result);
    };
}
function $1b4df03ec638d56c$var$_possibleConstructorReturn(self, call) {
    if (call && ($1b4df03ec638d56c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $1b4df03ec638d56c$var$_assertThisInitialized(self);
}
function $1b4df03ec638d56c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1b4df03ec638d56c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1b4df03ec638d56c$var$_getPrototypeOf(o) {
    $1b4df03ec638d56c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1b4df03ec638d56c$var$_getPrototypeOf(o);
}
function $1b4df03ec638d56c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1b4df03ec638d56c$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    $1b4df03ec638d56c$var$_inherits(SecondParser, _Parser);
    var _super = $1b4df03ec638d56c$var$_createSuper(SecondParser);
    function SecondParser() {
        var _this;
        $1b4df03ec638d56c$var$_classCallCheck(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $1b4df03ec638d56c$var$_defineProperty($1b4df03ec638d56c$var$_assertThisInitialized(_this), "priority", 50);
        $1b4df03ec638d56c$var$_defineProperty($1b4df03ec638d56c$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    $1b4df03ec638d56c$var$_createClass(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $fcb051c3b30f179b$export$cc7cc9e2a3ff9388)((0, $1cfbf898d09435e4$export$c123ee06d9da8480).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));




function $28d78cd32e0a59c3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $28d78cd32e0a59c3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $28d78cd32e0a59c3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $28d78cd32e0a59c3$var$_typeof(obj);
}
function $28d78cd32e0a59c3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $28d78cd32e0a59c3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $28d78cd32e0a59c3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $28d78cd32e0a59c3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $28d78cd32e0a59c3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $28d78cd32e0a59c3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $28d78cd32e0a59c3$var$_setPrototypeOf(subClass, superClass);
}
function $28d78cd32e0a59c3$var$_setPrototypeOf(o, p) {
    $28d78cd32e0a59c3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $28d78cd32e0a59c3$var$_setPrototypeOf(o, p);
}
function $28d78cd32e0a59c3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $28d78cd32e0a59c3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $28d78cd32e0a59c3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $28d78cd32e0a59c3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $28d78cd32e0a59c3$var$_possibleConstructorReturn(this, result);
    };
}
function $28d78cd32e0a59c3$var$_possibleConstructorReturn(self, call) {
    if (call && ($28d78cd32e0a59c3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $28d78cd32e0a59c3$var$_assertThisInitialized(self);
}
function $28d78cd32e0a59c3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $28d78cd32e0a59c3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $28d78cd32e0a59c3$var$_getPrototypeOf(o) {
    $28d78cd32e0a59c3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $28d78cd32e0a59c3$var$_getPrototypeOf(o);
}
function $28d78cd32e0a59c3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $28d78cd32e0a59c3$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    $28d78cd32e0a59c3$var$_inherits(FractionOfSecondParser, _Parser);
    var _super = $28d78cd32e0a59c3$var$_createSuper(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        $28d78cd32e0a59c3$var$_classCallCheck(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $28d78cd32e0a59c3$var$_defineProperty($28d78cd32e0a59c3$var$_assertThisInitialized(_this), "priority", 30);
        $28d78cd32e0a59c3$var$_defineProperty($28d78cd32e0a59c3$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    $28d78cd32e0a59c3$var$_createClass(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $fcb051c3b30f179b$export$4f84e3a82c7b538)((0, $fcb051c3b30f179b$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $a1329010c4a57155$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a1329010c4a57155$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a1329010c4a57155$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a1329010c4a57155$var$_typeof(obj);
}
function $a1329010c4a57155$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a1329010c4a57155$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a1329010c4a57155$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a1329010c4a57155$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a1329010c4a57155$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a1329010c4a57155$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a1329010c4a57155$var$_setPrototypeOf(subClass, superClass);
}
function $a1329010c4a57155$var$_setPrototypeOf(o, p) {
    $a1329010c4a57155$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a1329010c4a57155$var$_setPrototypeOf(o, p);
}
function $a1329010c4a57155$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a1329010c4a57155$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a1329010c4a57155$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a1329010c4a57155$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a1329010c4a57155$var$_possibleConstructorReturn(this, result);
    };
}
function $a1329010c4a57155$var$_possibleConstructorReturn(self, call) {
    if (call && ($a1329010c4a57155$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a1329010c4a57155$var$_assertThisInitialized(self);
}
function $a1329010c4a57155$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a1329010c4a57155$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a1329010c4a57155$var$_getPrototypeOf(o) {
    $a1329010c4a57155$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a1329010c4a57155$var$_getPrototypeOf(o);
}
function $a1329010c4a57155$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a1329010c4a57155$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    $a1329010c4a57155$var$_inherits(ISOTimezoneWithZParser, _Parser);
    var _super = $a1329010c4a57155$var$_createSuper(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        $a1329010c4a57155$var$_classCallCheck(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $a1329010c4a57155$var$_defineProperty($a1329010c4a57155$var$_assertThisInitialized(_this), "priority", 10);
        $a1329010c4a57155$var$_defineProperty($a1329010c4a57155$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    $a1329010c4a57155$var$_createClass(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $fcb051c3b30f179b$export$6497f4c0ecdfba8e)((0, $1cfbf898d09435e4$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $fcb051c3b30f179b$export$6497f4c0ecdfba8e)((0, $1cfbf898d09435e4$export$a7ee192b982af9c1).basic, dateString);
                    case 'XXXX':
                        return (0, $fcb051c3b30f179b$export$6497f4c0ecdfba8e)((0, $1cfbf898d09435e4$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $fcb051c3b30f179b$export$6497f4c0ecdfba8e)((0, $1cfbf898d09435e4$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $fcb051c3b30f179b$export$6497f4c0ecdfba8e)((0, $1cfbf898d09435e4$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));





function $5ddde25a02ee4729$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5ddde25a02ee4729$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5ddde25a02ee4729$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5ddde25a02ee4729$var$_typeof(obj);
}
function $5ddde25a02ee4729$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5ddde25a02ee4729$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5ddde25a02ee4729$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5ddde25a02ee4729$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5ddde25a02ee4729$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5ddde25a02ee4729$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5ddde25a02ee4729$var$_setPrototypeOf(subClass, superClass);
}
function $5ddde25a02ee4729$var$_setPrototypeOf(o, p) {
    $5ddde25a02ee4729$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5ddde25a02ee4729$var$_setPrototypeOf(o, p);
}
function $5ddde25a02ee4729$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5ddde25a02ee4729$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5ddde25a02ee4729$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5ddde25a02ee4729$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5ddde25a02ee4729$var$_possibleConstructorReturn(this, result);
    };
}
function $5ddde25a02ee4729$var$_possibleConstructorReturn(self, call) {
    if (call && ($5ddde25a02ee4729$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $5ddde25a02ee4729$var$_assertThisInitialized(self);
}
function $5ddde25a02ee4729$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5ddde25a02ee4729$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5ddde25a02ee4729$var$_getPrototypeOf(o) {
    $5ddde25a02ee4729$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5ddde25a02ee4729$var$_getPrototypeOf(o);
}
function $5ddde25a02ee4729$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5ddde25a02ee4729$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    $5ddde25a02ee4729$var$_inherits(ISOTimezoneParser, _Parser);
    var _super = $5ddde25a02ee4729$var$_createSuper(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        $5ddde25a02ee4729$var$_classCallCheck(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $5ddde25a02ee4729$var$_defineProperty($5ddde25a02ee4729$var$_assertThisInitialized(_this), "priority", 10);
        $5ddde25a02ee4729$var$_defineProperty($5ddde25a02ee4729$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    $5ddde25a02ee4729$var$_createClass(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $fcb051c3b30f179b$export$6497f4c0ecdfba8e)((0, $1cfbf898d09435e4$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $fcb051c3b30f179b$export$6497f4c0ecdfba8e)((0, $1cfbf898d09435e4$export$a7ee192b982af9c1).basic, dateString);
                    case 'xxxx':
                        return (0, $fcb051c3b30f179b$export$6497f4c0ecdfba8e)((0, $1cfbf898d09435e4$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $fcb051c3b30f179b$export$6497f4c0ecdfba8e)((0, $1cfbf898d09435e4$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $fcb051c3b30f179b$export$6497f4c0ecdfba8e)((0, $1cfbf898d09435e4$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));




function $eff7cd4e4b7616a2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $eff7cd4e4b7616a2$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $eff7cd4e4b7616a2$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eff7cd4e4b7616a2$var$_typeof(obj);
}
function $eff7cd4e4b7616a2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $eff7cd4e4b7616a2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $eff7cd4e4b7616a2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $eff7cd4e4b7616a2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $eff7cd4e4b7616a2$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $eff7cd4e4b7616a2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $eff7cd4e4b7616a2$var$_setPrototypeOf(subClass, superClass);
}
function $eff7cd4e4b7616a2$var$_setPrototypeOf(o, p) {
    $eff7cd4e4b7616a2$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $eff7cd4e4b7616a2$var$_setPrototypeOf(o, p);
}
function $eff7cd4e4b7616a2$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $eff7cd4e4b7616a2$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $eff7cd4e4b7616a2$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $eff7cd4e4b7616a2$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $eff7cd4e4b7616a2$var$_possibleConstructorReturn(this, result);
    };
}
function $eff7cd4e4b7616a2$var$_possibleConstructorReturn(self, call) {
    if (call && ($eff7cd4e4b7616a2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $eff7cd4e4b7616a2$var$_assertThisInitialized(self);
}
function $eff7cd4e4b7616a2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $eff7cd4e4b7616a2$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $eff7cd4e4b7616a2$var$_getPrototypeOf(o) {
    $eff7cd4e4b7616a2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $eff7cd4e4b7616a2$var$_getPrototypeOf(o);
}
function $eff7cd4e4b7616a2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $eff7cd4e4b7616a2$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    $eff7cd4e4b7616a2$var$_inherits(TimestampSecondsParser, _Parser);
    var _super = $eff7cd4e4b7616a2$var$_createSuper(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        $eff7cd4e4b7616a2$var$_classCallCheck(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $eff7cd4e4b7616a2$var$_defineProperty($eff7cd4e4b7616a2$var$_assertThisInitialized(_this), "priority", 40);
        $eff7cd4e4b7616a2$var$_defineProperty($eff7cd4e4b7616a2$var$_assertThisInitialized(_this), "incompatibleTokens", '*');
        return _this;
    }
    $eff7cd4e4b7616a2$var$_createClass(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $fcb051c3b30f179b$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));




function $6992d5ed8f62380d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6992d5ed8f62380d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6992d5ed8f62380d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6992d5ed8f62380d$var$_typeof(obj);
}
function $6992d5ed8f62380d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6992d5ed8f62380d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6992d5ed8f62380d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6992d5ed8f62380d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6992d5ed8f62380d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6992d5ed8f62380d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6992d5ed8f62380d$var$_setPrototypeOf(subClass, superClass);
}
function $6992d5ed8f62380d$var$_setPrototypeOf(o, p) {
    $6992d5ed8f62380d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6992d5ed8f62380d$var$_setPrototypeOf(o, p);
}
function $6992d5ed8f62380d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6992d5ed8f62380d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6992d5ed8f62380d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6992d5ed8f62380d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6992d5ed8f62380d$var$_possibleConstructorReturn(this, result);
    };
}
function $6992d5ed8f62380d$var$_possibleConstructorReturn(self, call) {
    if (call && ($6992d5ed8f62380d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6992d5ed8f62380d$var$_assertThisInitialized(self);
}
function $6992d5ed8f62380d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6992d5ed8f62380d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6992d5ed8f62380d$var$_getPrototypeOf(o) {
    $6992d5ed8f62380d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6992d5ed8f62380d$var$_getPrototypeOf(o);
}
function $6992d5ed8f62380d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6992d5ed8f62380d$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    $6992d5ed8f62380d$var$_inherits(TimestampMillisecondsParser, _Parser);
    var _super = $6992d5ed8f62380d$var$_createSuper(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        $6992d5ed8f62380d$var$_classCallCheck(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $6992d5ed8f62380d$var$_defineProperty($6992d5ed8f62380d$var$_assertThisInitialized(_this), "priority", 20);
        $6992d5ed8f62380d$var$_defineProperty($6992d5ed8f62380d$var$_assertThisInitialized(_this), "incompatibleTokens", '*');
        return _this;
    }
    $6992d5ed8f62380d$var$_createClass(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $fcb051c3b30f179b$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $4ffa53d668de2cfc$export$7acfa6ed01010e37));


var $640e2f227ead08b6$export$19131010e7fd8373 = {
    G: new (0, $ac41d9fd9881319f$export$8e5a1d3f85a9688)(),
    y: new (0, $a3a659d03da51084$export$48d352de7cd4a988)(),
    Y: new (0, $a4e78b8ac2c8f02c$export$b8ef38dfcf05d5db)(),
    R: new (0, $e2155b2ce1d52a78$export$951d1df011fde06f)(),
    u: new (0, $db954a02b06dc7e9$export$bad9d2ea38e8f1a)(),
    Q: new (0, $d8f73969f249ac76$export$5cb0f701186dde1d)(),
    q: new (0, $69a436102bb875a0$export$300c0c2990e20e6d)(),
    M: new (0, $d51d307bced53a8e$export$400dd8b40ef138a3)(),
    L: new (0, $eba882d18251dd6b$export$1d7eaa53eaa5deba)(),
    w: new (0, $a27805f28ac507c9$export$c4005ffc174e07c0)(),
    I: new (0, $783d620d7bac1f76$export$6fc8dbedd560a6af)(),
    d: new (0, $80fe019a970b7ea9$export$e8d4b28a20981dd2)(),
    D: new (0, $03154af5f62474b3$export$6cfe0d613455f615)(),
    E: new (0, $4b528792c95e40a5$export$1b03c8b76262f7bd)(),
    e: new (0, $a73947081e6f7a0d$export$44d1c127ab42c480)(),
    c: new (0, $48ca28ea3abcf8b7$export$e447a647caaaec1d)(),
    i: new (0, $8e24f9cc98485f6d$export$693fb1e525095b2a)(),
    a: new (0, $08880b8d891e1ab0$export$8d1e08492351df91)(),
    b: new (0, $1272d444b3e31e9a$export$73ca2bd0a17d273)(),
    B: new (0, $24ec60640777809c$export$bb9212adf05373db)(),
    h: new (0, $9ea953e6e89d225c$export$8a04050a727a1756)(),
    H: new (0, $4e136bb445622747$export$e56f4dea2c3e56dd)(),
    K: new (0, $419a70fff13c331c$export$cbbe855312f87d77)(),
    k: new (0, $abb86d9810ed7f24$export$6008046d2b34b6a5)(),
    m: new (0, $6229dbb5225e5bd6$export$2b52670d9e2be53)(),
    s: new (0, $1b4df03ec638d56c$export$94d46d540cf1366a)(),
    S: new (0, $28d78cd32e0a59c3$export$b8e6f8b2d70893b1)(),
    X: new (0, $a1329010c4a57155$export$104d901d49fea29b)(),
    x: new (0, $5ddde25a02ee4729$export$12910e5204b52b9)(),
    t: new (0, $eff7cd4e4b7616a2$export$2cd8bf877a05e96)(),
    T: new (0, $6992d5ed8f62380d$export$6d8f69c6906d6368)()
};



function $8b17d612209da895$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8b17d612209da895$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8b17d612209da895$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8b17d612209da895$var$_typeof(obj);
}
function $8b17d612209da895$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $8b17d612209da895$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $8b17d612209da895$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8b17d612209da895$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8b17d612209da895$var$_arrayLikeToArray(o, minLen);
}
function $8b17d612209da895$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $8b17d612209da895$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $8b17d612209da895$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $8b17d612209da895$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $8b17d612209da895$var$doubleQuoteRegExp = /''/g;
var $8b17d612209da895$var$notWhitespaceRegExp = /\S/;
var $8b17d612209da895$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $8b17d612209da895$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $41b814f6c92f57a3$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $1d66184b7ffb065b$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    }; // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $038c9c8ed64398ae$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($8b17d612209da895$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $fa54546a4789faa1$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $fa54546a4789faa1$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($8b17d612209da895$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = $8b17d612209da895$var$_createForOfIteratorHelper(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $132314102daa75b2$export$c6b49d6dceb604a1)(token)) (0, $132314102daa75b2$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $132314102daa75b2$export$c6cc36aa33304772)(token)) (0, $132314102daa75b2$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $640e2f227ead08b6$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($8b17d612209da895$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                 // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $8b17d612209da895$var$cleanEscapedString(token);
                 // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ($8b17d612209da895$var$_typeof(_ret) === "object") return _ret.v;
        } // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $8b17d612209da895$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $dace8d5317e0d210$export$2e2bcd8739ae039)(date, (0, $aa0ce4e10613bc89$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = $8b17d612209da895$var$_createForOfIteratorHelper(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions); // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $207a83f6572786a2$export$2e2bcd8739ae039)(flags, result[1]); // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $8b17d612209da895$var$cleanEscapedString(input) {
    return input.match($8b17d612209da895$var$escapedStringRegExp)[1].replace($8b17d612209da895$var$doubleQuoteRegExp, "'");
}





function $8612b4f219a82cf7$export$2e2bcd8739ae039(dirtyDate, dirtyDayOfMonth) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyDayOfMonth);
    date.setDate(dayOfMonth);
    return date;
}





function $cc7f7f299c9617ff$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var hours = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyHours);
    date.setHours(hours);
    return date;
}





function $f4ba7f37ef5f0548$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}






function $a6610c661adbd91e$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var month = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $7d5f3d61cb138ad1$export$2e2bcd8739ae039)(dateWithDesiredMonth); // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}





function $9565d1a4429bcb54$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}





function $e4aa7292a19d9a65$export$2e2bcd8739ae039(dirtyDate, dirtyMilliseconds) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var milliseconds = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyMilliseconds);
    date.setMilliseconds(milliseconds);
    return date;
}





function $4a783a0bcff12818$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var year = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}





function $2743463f2c87f1d5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}






function $35cf19526812dd46$export$2e2bcd8739ae039(dirtyDate) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}





function $cc2085d9bbef1e10$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var additionalDigits = (0, $b119caf18c17d74c$export$2e2bcd8739ae039)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $cc2085d9bbef1e10$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $cc2085d9bbef1e10$var$parseYear(dateStrings.date, additionalDigits);
        date = $cc2085d9bbef1e10$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $cc2085d9bbef1e10$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $cc2085d9bbef1e10$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $cc2085d9bbef1e10$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $cc2085d9bbef1e10$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $cc2085d9bbef1e10$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $cc2085d9bbef1e10$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $cc2085d9bbef1e10$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($cc2085d9bbef1e10$var$patterns.dateTimeDelimiter);
    var timeString; // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($cc2085d9bbef1e10$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($cc2085d9bbef1e10$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $cc2085d9bbef1e10$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $cc2085d9bbef1e10$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex); // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $cc2085d9bbef1e10$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($cc2085d9bbef1e10$var$dateRegex); // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $cc2085d9bbef1e10$var$parseDateUnit(captures[1]);
    var month = $cc2085d9bbef1e10$var$parseDateUnit(captures[2]) - 1;
    var day = $cc2085d9bbef1e10$var$parseDateUnit(captures[3]);
    var week = $cc2085d9bbef1e10$var$parseDateUnit(captures[4]);
    var dayOfWeek = $cc2085d9bbef1e10$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$cc2085d9bbef1e10$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $cc2085d9bbef1e10$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$cc2085d9bbef1e10$var$validateDate(year, month, day) || !$cc2085d9bbef1e10$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $cc2085d9bbef1e10$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $cc2085d9bbef1e10$var$parseTime(timeString) {
    var captures = timeString.match($cc2085d9bbef1e10$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $cc2085d9bbef1e10$var$parseTimeUnit(captures[1]);
    var minutes = $cc2085d9bbef1e10$var$parseTimeUnit(captures[2]);
    var seconds = $cc2085d9bbef1e10$var$parseTimeUnit(captures[3]);
    if (!$cc2085d9bbef1e10$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $db100e32c0b4bec4$export$7f72910d6dfd237a) + minutes * (0, $db100e32c0b4bec4$export$91246f0b9bd9beff) + seconds * 1000;
}
function $cc2085d9bbef1e10$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $cc2085d9bbef1e10$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($cc2085d9bbef1e10$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$cc2085d9bbef1e10$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $db100e32c0b4bec4$export$7f72910d6dfd237a) + minutes * (0, $db100e32c0b4bec4$export$91246f0b9bd9beff));
}
function $cc2085d9bbef1e10$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
} // Validation functions
// February is null to handle the leap year (using ||)
var $cc2085d9bbef1e10$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $cc2085d9bbef1e10$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $cc2085d9bbef1e10$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($cc2085d9bbef1e10$var$daysInMonths[month] || ($cc2085d9bbef1e10$var$isLeapYearIndex(year) ? 29 : 28));
}
function $cc2085d9bbef1e10$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($cc2085d9bbef1e10$var$isLeapYearIndex(year) ? 366 : 365);
}
function $cc2085d9bbef1e10$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $cc2085d9bbef1e10$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $cc2085d9bbef1e10$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}





function $415418e6027fa6b0$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(1, arguments);
    var originalDate = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(originalDate.getDate(), 2);
        var month = (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(originalDate.getMonth() + 1, 2);
        var year = (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    } // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(originalDate.getHours(), 2);
        var minute = (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(originalDate.getMinutes(), 2);
        var second = (0, $5ef226fb190d9c05$export$2e2bcd8739ae039)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter); // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}




function $f866a4579097efff$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $eafc2fd4bf99c988$export$2e2bcd8739ae039)(2, arguments);
    var time = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var startTime = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(interval.start).getTime();
    var endTime = (0, $48d6caaf3810fe04$export$2e2bcd8739ae039)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}



var $4193575ec529fa39$exports = {};
"use strict";
Object.defineProperty($4193575ec529fa39$exports, "__esModule", {
    value: true
});
$4193575ec529fa39$exports.default = void 0;
var $4193575ec529fa39$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $4193575ec529fa39$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $4193575ec529fa39$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $4193575ec529fa39$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $4193575ec529fa39$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $4193575ec529fa39$var$timeLongFormatter(timePattern, formatLong));
};
var $4193575ec529fa39$var$longFormatters = {
    p: $4193575ec529fa39$var$timeLongFormatter,
    P: $4193575ec529fa39$var$dateTimeLongFormatter
};
var $4193575ec529fa39$var$_default = $4193575ec529fa39$var$longFormatters;
$4193575ec529fa39$exports.default = $4193575ec529fa39$var$_default;
$4193575ec529fa39$exports = $4193575ec529fa39$exports.default;


const $d82d5b43348c96eb$var$formatTokenMap = {
    // Year
    y: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yy: 'year',
    yyy: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yyyy: 'year',
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    L: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    LL: 'month',
    LLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    LLLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    d: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    dd: 'day',
    do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    E: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    i: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ii: 'weekDay',
    iii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    iiii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    e: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ee: 'weekDay',
    eee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    c: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    cc: 'weekDay',
    ccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    a: 'meridiem',
    aa: 'meridiem',
    aaa: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const $d82d5b43348c96eb$var$defaultFormats = {
    year: 'yyyy',
    month: 'LLLL',
    monthShort: 'MMM',
    dayOfMonth: 'd',
    weekday: 'EEEE',
    weekdayShort: 'EEE',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'aa',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'PP',
    fullDateWithWeekday: 'PPPP',
    keyboardDate: 'P',
    shortDate: 'MMM d',
    normalDate: 'd MMMM',
    normalDateWithWeekday: 'EEE, MMM d',
    monthAndYear: 'LLLL yyyy',
    monthAndDate: 'MMMM d',
    fullTime: 'p',
    fullTime12h: 'hh:mm aa',
    fullTime24h: 'HH:mm',
    fullDateTime: 'PP p',
    fullDateTime12h: 'PP hh:mm aa',
    fullDateTime24h: 'PP HH:mm',
    keyboardDateTime: 'P p',
    keyboardDateTime12h: 'P hh:mm aa',
    keyboardDateTime24h: 'P HH:mm'
};
class $d82d5b43348c96eb$export$81f56c0329a1921d {
    constructor({ locale: _locale, formats: formats } = {}){
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = false;
        this.lib = 'date-fns';
        this.locale = void 0;
        this.formats = void 0;
        this.formatTokenMap = $d82d5b43348c96eb$var$formatTokenMap;
        this.escapedCharacters = {
            start: "'",
            end: "'"
        };
        this.date = (value)=>{
            if (typeof value === 'undefined') return new Date();
            if (value === null) return null;
            return new Date(value);
        };
        this.dateWithTimezone = (value)=>{
            return this.date(value);
        };
        this.getTimezone = ()=>{
            return 'default';
        };
        this.setTimezone = (value)=>{
            return value;
        };
        this.toJsDate = (value)=>{
            return value;
        };
        this.parseISO = (isoString)=>{
            return (0, $cc2085d9bbef1e10$export$2e2bcd8739ae039)(isoString);
        };
        this.toISO = (value)=>{
            return (0, $415418e6027fa6b0$export$2e2bcd8739ae039)(value, {
                format: 'extended'
            });
        };
        this.parse = (value, format)=>{
            if (value === '') return null;
            return (0, $8b17d612209da895$export$2e2bcd8739ae039)(value, format, new Date(), {
                locale: this.locale
            });
        };
        this.getCurrentLocaleCode = ()=>{
            var _this$locale;
            return ((_this$locale = this.locale) == null ? void 0 : _this$locale.code) || 'en-US';
        };
        // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
        // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
        this.is12HourCycleInCurrentLocale = ()=>{
            if (this.locale) return /a/.test(this.locale.formatLong.time());
            // By default, date-fns is using en-US locale with am/pm enabled
            return true;
        };
        this.expandFormat = (format)=>{
            const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            return format.match(longFormatRegexp).map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === 'p' || firstCharacter === 'P') {
                    const longFormatter = (0, (/*@__PURE__*/$parcel$interopDefault($4193575ec529fa39$exports)))[firstCharacter];
                    const locale = this.locale || (0, $71465c18f1b50106$export$2e2bcd8739ae039);
                    return longFormatter(token, locale.formatLong, {});
                }
                return token;
            }).join('');
        };
        this.getFormatHelperText = (format)=>{
            return this.expandFormat(format).replace(/(aaa|aa|a)/g, '(a|p)m').toLocaleLowerCase();
        };
        this.isNull = (value)=>{
            return value === null;
        };
        this.isValid = (value)=>{
            return (0, $d929e023868e1e82$export$2e2bcd8739ae039)(this.date(value));
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, formatString)=>{
            return (0, $470528c785dcbc23$export$2e2bcd8739ae039)(value, formatString, {
                locale: this.locale
            });
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getDiff = (value, comparing, unit)=>{
            switch(unit){
                case 'years':
                    return (0, $b44f5ed897624aab$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'quarters':
                    return (0, $3724d191adaefc07$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'months':
                    return (0, $d821a207cc5d6261$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'weeks':
                    return (0, $411d679886711161$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'days':
                    return (0, $f54bc72aa4f5e7b1$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'hours':
                    return (0, $06fa58f6ec7ce547$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'minutes':
                    return (0, $1324f73a4ed7d73b$export$2e2bcd8739ae039)(value, this.date(comparing));
                case 'seconds':
                    return (0, $5ddaaeaf5281a1d7$export$2e2bcd8739ae039)(value, this.date(comparing));
                default:
                    return (0, $7d8eb08b69f2833e$export$2e2bcd8739ae039)(value, this.date(comparing));
            }
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            return (0, $21fb9357be9d14c6$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameYear = (value, comparing)=>{
            return (0, $d7d7b4da2a5ff3d9$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameMonth = (value, comparing)=>{
            return (0, $ed9e5a37d094d714$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameDay = (value, comparing)=>{
            return (0, $8360ffa185725310$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameHour = (value, comparing)=>{
            return (0, $8c1bf20f1f686273$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isAfter = (value, comparing)=>{
            return (0, $9bf8e5dcf0aa19e0$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isAfterYear = (value, comparing)=>{
            return (0, $9bf8e5dcf0aa19e0$export$2e2bcd8739ae039)(value, (0, $d7d551c90987298b$export$2e2bcd8739ae039)(comparing));
        };
        this.isAfterDay = (value, comparing)=>{
            return (0, $9bf8e5dcf0aa19e0$export$2e2bcd8739ae039)(value, (0, $564827580abaabe0$export$2e2bcd8739ae039)(comparing));
        };
        this.isBefore = (value, comparing)=>{
            return (0, $b813b7e29ad2543f$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isBeforeYear = (value, comparing)=>{
            return (0, $b813b7e29ad2543f$export$2e2bcd8739ae039)(value, (0, $35cf19526812dd46$export$2e2bcd8739ae039)(comparing));
        };
        this.isBeforeDay = (value, comparing)=>{
            return (0, $b813b7e29ad2543f$export$2e2bcd8739ae039)(value, (0, $9448c654ab8115b5$export$2e2bcd8739ae039)(comparing));
        };
        this.isWithinRange = (value, [start, end])=>{
            return (0, $f866a4579097efff$export$2e2bcd8739ae039)(value, {
                start: start,
                end: end
            });
        };
        this.startOfYear = (value)=>{
            return (0, $35cf19526812dd46$export$2e2bcd8739ae039)(value);
        };
        this.startOfMonth = (value)=>{
            return (0, $2743463f2c87f1d5$export$2e2bcd8739ae039)(value);
        };
        this.startOfWeek = (value)=>{
            return (0, $5ec71ed98601cb43$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.startOfDay = (value)=>{
            return (0, $9448c654ab8115b5$export$2e2bcd8739ae039)(value);
        };
        this.endOfYear = (value)=>{
            return (0, $d7d551c90987298b$export$2e2bcd8739ae039)(value);
        };
        this.endOfMonth = (value)=>{
            return (0, $cb24fcc00faea449$export$2e2bcd8739ae039)(value);
        };
        this.endOfWeek = (value)=>{
            return (0, $a98ee795f1625aad$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.endOfDay = (value)=>{
            return (0, $564827580abaabe0$export$2e2bcd8739ae039)(value);
        };
        this.addYears = (value, amount)=>{
            return (0, $e052cdbe3be9402b$export$2e2bcd8739ae039)(value, amount);
        };
        this.addMonths = (value, amount)=>{
            return (0, $8930a3f306514e64$export$2e2bcd8739ae039)(value, amount);
        };
        this.addWeeks = (value, amount)=>{
            return (0, $5eeb5560d9f90b69$export$2e2bcd8739ae039)(value, amount);
        };
        this.addDays = (value, amount)=>{
            return (0, $69000087cbd5ebc7$export$2e2bcd8739ae039)(value, amount);
        };
        this.addHours = (value, amount)=>{
            return (0, $70bee95d8daf2f0a$export$2e2bcd8739ae039)(value, amount);
        };
        this.addMinutes = (value, amount)=>{
            return (0, $934c914be0223c3d$export$2e2bcd8739ae039)(value, amount);
        };
        this.addSeconds = (value, amount)=>{
            return (0, $cfbd728dc663d8c9$export$2e2bcd8739ae039)(value, amount);
        };
        this.getYear = (value)=>{
            return (0, $2ab9455fcba18cf3$export$2e2bcd8739ae039)(value);
        };
        this.getMonth = (value)=>{
            return (0, $2fe37e68266a3afe$export$2e2bcd8739ae039)(value);
        };
        this.getDate = (value)=>{
            return (0, $547920fa0626bab6$export$2e2bcd8739ae039)(value);
        };
        this.getHours = (value)=>{
            return (0, $00cf5bd1b093c772$export$2e2bcd8739ae039)(value);
        };
        this.getMinutes = (value)=>{
            return (0, $d257f12add849293$export$2e2bcd8739ae039)(value);
        };
        this.getSeconds = (value)=>{
            return (0, $f5e298044095f4c3$export$2e2bcd8739ae039)(value);
        };
        this.getMilliseconds = (value)=>{
            return (0, $601d641e9a7e118d$export$2e2bcd8739ae039)(value);
        };
        this.setYear = (value, year)=>{
            return (0, $4a783a0bcff12818$export$2e2bcd8739ae039)(value, year);
        };
        this.setMonth = (value, month)=>{
            return (0, $a6610c661adbd91e$export$2e2bcd8739ae039)(value, month);
        };
        this.setDate = (value, date)=>{
            return (0, $8612b4f219a82cf7$export$2e2bcd8739ae039)(value, date);
        };
        this.setHours = (value, hours)=>{
            return (0, $cc7f7f299c9617ff$export$2e2bcd8739ae039)(value, hours);
        };
        this.setMinutes = (value, minutes)=>{
            return (0, $f4ba7f37ef5f0548$export$2e2bcd8739ae039)(value, minutes);
        };
        this.setSeconds = (value, seconds)=>{
            return (0, $9565d1a4429bcb54$export$2e2bcd8739ae039)(value, seconds);
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return (0, $e4aa7292a19d9a65$export$2e2bcd8739ae039)(value, milliseconds);
        };
        this.getDaysInMonth = (value)=>{
            return (0, $7d5f3d61cb138ad1$export$2e2bcd8739ae039)(value);
        };
        this.getNextMonth = (value)=>{
            return (0, $8930a3f306514e64$export$2e2bcd8739ae039)(value, 1);
        };
        this.getPreviousMonth = (value)=>{
            return (0, $8930a3f306514e64$export$2e2bcd8739ae039)(value, -1);
        };
        this.getMonthArray = (value)=>{
            const firstMonth = (0, $35cf19526812dd46$export$2e2bcd8739ae039)(value);
            const monthArray = [
                firstMonth
            ];
            while(monthArray.length < 12){
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.mergeDateAndTime = (dateParam, timeParam)=>{
            return this.setSeconds(this.setMinutes(this.setHours(dateParam, this.getHours(timeParam)), this.getMinutes(timeParam)), this.getSeconds(timeParam));
        };
        this.getWeekdays = ()=>{
            const now = new Date();
            return (0, $93e6480b9eb681b3$export$2e2bcd8739ae039)({
                start: (0, $5ec71ed98601cb43$export$2e2bcd8739ae039)(now, {
                    locale: this.locale
                }),
                end: (0, $a98ee795f1625aad$export$2e2bcd8739ae039)(now, {
                    locale: this.locale
                })
            }).map((day)=>this.formatByString(day, 'EEEEEE'));
        };
        this.getWeekArray = (value)=>{
            const start = (0, $5ec71ed98601cb43$export$2e2bcd8739ae039)((0, $2743463f2c87f1d5$export$2e2bcd8739ae039)(value), {
                locale: this.locale
            });
            const end = (0, $a98ee795f1625aad$export$2e2bcd8739ae039)((0, $cb24fcc00faea449$export$2e2bcd8739ae039)(value), {
                locale: this.locale
            });
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while((0, $b813b7e29ad2543f$export$2e2bcd8739ae039)(current, end)){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = (0, $69000087cbd5ebc7$export$2e2bcd8739ae039)(current, 1);
                count += 1;
            }
            return nestedWeeks;
        };
        this.getWeekNumber = (value)=>{
            return (0, $0baab285aeaff1e5$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.getYearRange = (start, end)=>{
            const startDate = (0, $35cf19526812dd46$export$2e2bcd8739ae039)(start);
            const endDate = (0, $d7d551c90987298b$export$2e2bcd8739ae039)(end);
            const years = [];
            let current = startDate;
            while((0, $b813b7e29ad2543f$export$2e2bcd8739ae039)(current, endDate)){
                years.push(current);
                current = (0, $e052cdbe3be9402b$export$2e2bcd8739ae039)(current, 1);
            }
            return years;
        };
        this.getMeridiemText = (ampm)=>{
            return ampm === 'am' ? 'AM' : 'PM';
        };
        this.locale = _locale;
        this.formats = (0, $gOPoC.default)({}, $d82d5b43348c96eb$var$defaultFormats, formats);
    }
}



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");


var $jFgmT = parcelRequire("jFgmT");

var $2M70Q = parcelRequire("2M70Q");
const $0dca6c5826980612$var$_excluded = [
    "localeText"
];
const $0dca6c5826980612$export$544976378534cf9 = /*#__PURE__*/ $3OyDL.createContext(null);
const $0dca6c5826980612$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    var _React$useContext;
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $aBenZ.default)(inProps, $0dca6c5826980612$var$_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = (_React$useContext = $3OyDL.useContext($0dca6c5826980612$export$544976378534cf9)) != null ? _React$useContext : {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, $jFgmT.default)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $3OyDL.useMemo(()=>(0, $gOPoC.default)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = $3OyDL.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            'MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation'
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = $3OyDL.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date('1900-01-01T00:00:00.000'),
            maxDate: utils.date('2099-12-31T00:00:00.000')
        };
    }, [
        utils
    ]);
    const contextValue = $3OyDL.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($0dca6c5826980612$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
};


var $9274c431a4e57f69$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        },
        withPreposition: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        }
    },
    xSeconds: {
        standalone: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        },
        withPreposition: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        }
    },
    halfAMinute: {
        standalone: 'halbe Minute',
        withPreposition: 'halben Minute'
    },
    lessThanXMinutes: {
        standalone: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        },
        withPreposition: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        }
    },
    xMinutes: {
        standalone: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        },
        withPreposition: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        }
    },
    aboutXHours: {
        standalone: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        },
        withPreposition: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        }
    },
    xHours: {
        standalone: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        },
        withPreposition: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        }
    },
    xDays: {
        standalone: {
            one: '1 Tag',
            other: '{{count}} Tage'
        },
        withPreposition: {
            one: '1 Tag',
            other: '{{count}} Tagen'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        },
        withPreposition: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        }
    },
    xWeeks: {
        standalone: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monate'
        },
        withPreposition: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monaten'
        }
    },
    xMonths: {
        standalone: {
            one: '1 Monat',
            other: '{{count}} Monate'
        },
        withPreposition: {
            one: '1 Monat',
            other: '{{count}} Monaten'
        }
    },
    aboutXYears: {
        standalone: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahre'
        },
        withPreposition: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahren'
        }
    },
    xYears: {
        standalone: {
            one: '1 Jahr',
            other: '{{count}} Jahre'
        },
        withPreposition: {
            one: '1 Jahr',
            other: '{{count}} Jahren'
        }
    },
    overXYears: {
        standalone: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahre'
        },
        withPreposition: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahren'
        }
    },
    almostXYears: {
        standalone: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahre'
        },
        withPreposition: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahren'
        }
    }
};
var $9274c431a4e57f69$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $9274c431a4e57f69$var$formatDistanceLocale[token].withPreposition : $9274c431a4e57f69$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return 'vor ' + result;
    }
    return result;
};
var $9274c431a4e57f69$export$2e2bcd8739ae039 = $9274c431a4e57f69$var$formatDistance;



// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var $10493540b9f22e3b$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    // Montag, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan. 2018
    short: 'dd.MM.y' // 07.01.2018
};
var $10493540b9f22e3b$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $10493540b9f22e3b$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $10493540b9f22e3b$var$formatLong = {
    date: (0, $373b7f141b5dacce$export$2e2bcd8739ae039)({
        formats: $10493540b9f22e3b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $373b7f141b5dacce$export$2e2bcd8739ae039)({
        formats: $10493540b9f22e3b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $373b7f141b5dacce$export$2e2bcd8739ae039)({
        formats: $10493540b9f22e3b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $10493540b9f22e3b$export$2e2bcd8739ae039 = $10493540b9f22e3b$var$formatLong;


var $220eb661b5d71e57$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var $220eb661b5d71e57$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $220eb661b5d71e57$var$formatRelativeLocale[token];
};
var $220eb661b5d71e57$export$2e2bcd8739ae039 = $220eb661b5d71e57$var$formatRelative;



var $cd92e837a5095bb8$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var $cd92e837a5095bb8$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
}; // Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $cd92e837a5095bb8$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
}; // https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var $cd92e837a5095bb8$var$formattingMonthValues = {
    narrow: $cd92e837a5095bb8$var$monthValues.narrow,
    abbreviated: [
        'Jan.',
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: $cd92e837a5095bb8$var$monthValues.wide
};
var $cd92e837a5095bb8$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
}; // https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $cd92e837a5095bb8$var$dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var $cd92e837a5095bb8$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var $cd92e837a5095bb8$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $cd92e837a5095bb8$var$localize = {
    ordinalNumber: $cd92e837a5095bb8$var$ordinalNumber,
    era: (0, $d57edd4af7d6d8b6$export$2e2bcd8739ae039)({
        values: $cd92e837a5095bb8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $d57edd4af7d6d8b6$export$2e2bcd8739ae039)({
        values: $cd92e837a5095bb8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $d57edd4af7d6d8b6$export$2e2bcd8739ae039)({
        values: $cd92e837a5095bb8$var$monthValues,
        formattingValues: $cd92e837a5095bb8$var$formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $d57edd4af7d6d8b6$export$2e2bcd8739ae039)({
        values: $cd92e837a5095bb8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $d57edd4af7d6d8b6$export$2e2bcd8739ae039)({
        values: $cd92e837a5095bb8$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $cd92e837a5095bb8$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $cd92e837a5095bb8$export$2e2bcd8739ae039 = $cd92e837a5095bb8$var$localize;




var $e461374a56e02273$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $e461374a56e02273$var$parseOrdinalNumberPattern = /\d+/i;
var $e461374a56e02273$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var $e461374a56e02273$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $e461374a56e02273$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $e461374a56e02273$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e461374a56e02273$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var $e461374a56e02273$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $e461374a56e02273$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var $e461374a56e02273$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $e461374a56e02273$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var $e461374a56e02273$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var $e461374a56e02273$var$match = {
    ordinalNumber: (0, $92a592e71cbd8844$export$2e2bcd8739ae039)({
        matchPattern: $e461374a56e02273$var$matchOrdinalNumberPattern,
        parsePattern: $e461374a56e02273$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $4664451f1486a0c3$export$2e2bcd8739ae039)({
        matchPatterns: $e461374a56e02273$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e461374a56e02273$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $4664451f1486a0c3$export$2e2bcd8739ae039)({
        matchPatterns: $e461374a56e02273$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e461374a56e02273$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $4664451f1486a0c3$export$2e2bcd8739ae039)({
        matchPatterns: $e461374a56e02273$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e461374a56e02273$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $4664451f1486a0c3$export$2e2bcd8739ae039)({
        matchPatterns: $e461374a56e02273$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e461374a56e02273$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $4664451f1486a0c3$export$2e2bcd8739ae039)({
        matchPatterns: $e461374a56e02273$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e461374a56e02273$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e461374a56e02273$export$2e2bcd8739ae039 = $e461374a56e02273$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var $c7a7e7744306e3de$var$locale = {
    code: 'de',
    formatDistance: (0, $9274c431a4e57f69$export$2e2bcd8739ae039),
    formatLong: (0, $10493540b9f22e3b$export$2e2bcd8739ae039),
    formatRelative: (0, $220eb661b5d71e57$export$2e2bcd8739ae039),
    localize: (0, $cd92e837a5095bb8$export$2e2bcd8739ae039),
    match: (0, $e461374a56e02273$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $c7a7e7744306e3de$export$2e2bcd8739ae039 = $c7a7e7744306e3de$var$locale;



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");



var $jFgmT = parcelRequire("jFgmT");


var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");
var $0421136038e70f36$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0421136038e70f36$var$ReactIs, $0421136038e70f36$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$0421136038e70f36$exports = (parcelRequire("e1GlX"))();


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $b66ccc5bec543ea6$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}



const $4e068a1bef6674c3$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object
]);
var $4e068a1bef6674c3$export$2e2bcd8739ae039 = $4e068a1bef6674c3$var$refType;



var $aBenZ = parcelRequire("aBenZ");
const $77b769676d9b7e67$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $77b769676d9b7e67$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views != null ? views : defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error('MUI: The `views` prop must contain at least one view');
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};


const $915ec64656c7dd6f$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, utils: utils, timezone: timezone })=>{
    const today = utils.startOfDay(utils.dateWithTimezone(undefined, timezone));
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const $915ec64656c7dd6f$export$36ca889e039badd5 = (utils, value)=>value == null || !utils.isValid(value) ? null : value;
const $915ec64656c7dd6f$export$eb73579ccade48fd = (utils, value, defaultValue)=>{
    if (value == null || !utils.isValid(value)) return defaultValue;
    return value;
};
const $915ec64656c7dd6f$export$8fabf9a4cbada414 = (utils, a, b)=>{
    if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) return true;
    return utils.isEqual(a, b);
};
const $915ec64656c7dd6f$export$62591b96a734eacd = (utils, year)=>{
    const firstMonth = utils.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(utils.addMonths(prevMonth, 1));
    }
    return months;
};
const $915ec64656c7dd6f$export$a98b123b8f29e004 = (utils, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
    mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
    mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
    return mergedDate;
};
const $915ec64656c7dd6f$export$1118e4272ea1e258 = (utils, timezone, valueType)=>valueType === 'date' ? utils.startOfDay(utils.dateWithTimezone(undefined, timezone)) : utils.dateWithTimezone(undefined, timezone);
const $915ec64656c7dd6f$export$fae94c0a662107ef = (utils, meridiem)=>{
    const date = utils.setHours(utils.date(), meridiem === 'am' ? 2 : 14);
    return utils.format(date, 'meridiem');
};
const $915ec64656c7dd6f$var$dateViews = [
    'year',
    'month',
    'day'
];
const $915ec64656c7dd6f$export$b32dfef9f07dea64 = (view)=>$915ec64656c7dd6f$var$dateViews.includes(view);
const $915ec64656c7dd6f$export$bb1c921f313ec928 = (utils, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $77b769676d9b7e67$export$f07872cd524bec98)(views, [
        'year'
    ])) return formats.year;
    if ((0, $77b769676d9b7e67$export$f07872cd524bec98)(views, [
        'month'
    ])) return formats.month;
    if ((0, $77b769676d9b7e67$export$f07872cd524bec98)(views, [
        'day'
    ])) return formats.dayOfMonth;
    if ((0, $77b769676d9b7e67$export$f07872cd524bec98)(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $77b769676d9b7e67$export$f07872cd524bec98)(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};



const $ab8b9fd82a664ad3$var$timeViews = [
    'hours',
    'minutes',
    'seconds'
];
const $ab8b9fd82a664ad3$export$8f04d380cefd5a0d = (view)=>$ab8b9fd82a664ad3$var$timeViews.includes(view);
const $ab8b9fd82a664ad3$export$a3328136ac50623d = (view)=>$ab8b9fd82a664ad3$var$timeViews.includes(view) || view === 'meridiem';
const $ab8b9fd82a664ad3$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
const $ab8b9fd82a664ad3$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
const $ab8b9fd82a664ad3$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $ab8b9fd82a664ad3$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $ab8b9fd82a664ad3$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $ab8b9fd82a664ad3$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $ab8b9fd82a664ad3$export$888a1ce13aa61986(dateLeft, utils) > $ab8b9fd82a664ad3$export$888a1ce13aa61986(dateRight, utils);
    };
const $ab8b9fd82a664ad3$export$3a6776b3863772fe = (utils, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $77b769676d9b7e67$export$f07872cd524bec98)(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $77b769676d9b7e67$export$f07872cd524bec98)(views, [
        'minutes'
    ])) return formats.minutes;
    if ((0, $77b769676d9b7e67$export$f07872cd524bec98)(views, [
        'seconds'
    ])) return formats.seconds;
    if ((0, $77b769676d9b7e67$export$f07872cd524bec98)(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $77b769676d9b7e67$export$f07872cd524bec98)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};



const $296cf343c750d880$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $296cf343c750d880$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>{
        var _SECTION_TYPE_GRANULA;
        return (_SECTION_TYPE_GRANULA = $296cf343c750d880$export$8f74e8f4ed8ae0ac[section.type]) != null ? _SECTION_TYPE_GRANULA : 1;
    }));
const $296cf343c750d880$export$e7c8ae702868847 = (views)=>Math.max(...views.map((view)=>{
        var _SECTION_TYPE_GRANULA2;
        return (_SECTION_TYPE_GRANULA2 = $296cf343c750d880$export$8f74e8f4ed8ae0ac[view]) != null ? _SECTION_TYPE_GRANULA2 : 1;
    }));
const $296cf343c750d880$var$roundDate = (utils, granularity, date)=>{
    if (granularity === $296cf343c750d880$export$8f74e8f4ed8ae0ac.year) return utils.startOfYear(date);
    if (granularity === $296cf343c750d880$export$8f74e8f4ed8ae0ac.month) return utils.startOfMonth(date);
    if (granularity === $296cf343c750d880$export$8f74e8f4ed8ae0ac.day) return utils.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $296cf343c750d880$export$8f74e8f4ed8ae0ac.minutes) roundedDate = utils.setMinutes(roundedDate, 0);
    if (granularity < $296cf343c750d880$export$8f74e8f4ed8ae0ac.seconds) roundedDate = utils.setSeconds(roundedDate, 0);
    if (granularity < $296cf343c750d880$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = utils.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $296cf343c750d880$export$6a31d56794238e4e = ({ props: props, utils: utils, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    var _props$disableIgnorin;
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $296cf343c750d880$var$roundDate(utils, granularity, (0, $915ec64656c7dd6f$export$1118e4272ea1e258)(utils, timezone));
    if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) referenceDate = $296cf343c750d880$var$roundDate(utils, granularity, props.minDate);
    if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $296cf343c750d880$var$roundDate(utils, granularity, props.maxDate);
    const isAfter = (0, $ab8b9fd82a664ad3$export$fb87c80b35a46b89)((_props$disableIgnorin = props.disableIgnoringDatePartForTimeValidation) != null ? _props$disableIgnorin : false, utils);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $296cf343c750d880$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $915ec64656c7dd6f$export$a98b123b8f29e004)(utils, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $296cf343c750d880$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $915ec64656c7dd6f$export$a98b123b8f29e004)(utils, referenceDate, props.maxTime));
    return referenceDate;
};



var $gOPoC = parcelRequire("gOPoC");

const $93ec44f7cf837915$export$2f3c5fac7a2a65f6 = (utils, formatToken)=>{
    const config = utils.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'
    ].join('\n'));
    if (typeof config === 'string') return {
        type: config,
        contentType: config === 'meridiem' ? 'letter' : 'digit',
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $93ec44f7cf837915$var$getDeltaFromKeyCode = (keyCode)=>{
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
};
const $93ec44f7cf837915$export$c65c7173f879039f = (utils, timezone, format)=>{
    const elements = [];
    const now = utils.dateWithTimezone(undefined, timezone);
    const startDate = utils.startOfWeek(now);
    const endDate = utils.endOfWeek(now);
    let current = startDate;
    while(utils.isBefore(current, endDate)){
        elements.push(current);
        current = utils.addDays(current, 1);
    }
    return elements.map((weekDay)=>utils.formatByString(weekDay, format));
};
const $93ec44f7cf837915$export$3ee1e7e19c2b047a = (utils, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return (0, $915ec64656c7dd6f$export$62591b96a734eacd)(utils, utils.dateWithTimezone(undefined, timezone)).map((month)=>utils.formatByString(month, format));
        case 'weekDay':
            return $93ec44f7cf837915$export$c65c7173f879039f(utils, timezone, format);
        case 'meridiem':
            {
                const now = utils.dateWithTimezone(undefined, timezone);
                return [
                    utils.startOfDay(now),
                    utils.endOfDay(now)
                ].map((date)=>utils.formatByString(date, format));
            }
        default:
            return [];
    }
};
const $93ec44f7cf837915$export$713c6d756c12fc27 = (utils, valueStr, size)=>{
    let cleanValueStr = valueStr;
    // Remove the leading zeros
    cleanValueStr = Number(cleanValueStr).toString();
    // Add enough leading zeros to fill the section
    while(cleanValueStr.length < size)cleanValueStr = `0${cleanValueStr}`;
    return cleanValueStr;
};
const $93ec44f7cf837915$export$ef88db4bceade9fd = (utils, timezone, value, sectionBoundaries, section)=>{
    if (section.type === 'day' && section.contentType === 'digit-with-letter') {
        const date = utils.setDate(sectionBoundaries.longestMonth, value);
        return utils.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    const valueStr = value.toString();
    if (section.hasLeadingZerosInInput) return $93ec44f7cf837915$export$713c6d756c12fc27(utils, valueStr, section.maxLength);
    return valueStr;
};
const $93ec44f7cf837915$export$5ed0f22513e58fe3 = (utils, timezone, section, keyCode, sectionsValueBoundaries, activeDate, stepsAttributes)=>{
    const delta = $93ec44f7cf837915$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === 'Home';
    const isEnd = keyCode === 'End';
    const shouldSetAbsolute = section.value === '' || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>$93ec44f7cf837915$export$ef88db4bceade9fd(utils, timezone, value, sectionBoundaries, section);
        const step = section.type === 'minutes' && stepsAttributes != null && stepsAttributes.minutesStep ? stepsAttributes.minutesStep : 1;
        const currentSectionValue = parseInt(section.value, 10);
        let newSectionValueNumber = currentSectionValue + delta * step;
        if (shouldSetAbsolute) {
            if (section.type === 'year' && !isEnd && !isStart) return utils.formatByString(utils.dateWithTimezone(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = $93ec44f7cf837915$export$3ee1e7e19c2b047a(utils, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + options.length + delta) % options.length;
        return options[newOptionIndex];
    };
    if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') return adjustDigitSection();
    return adjustLetterSection();
};
const $93ec44f7cf837915$export$85daa91f6c6e875f = (section, target)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number(value).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === 'input-rtl') value = `\u2068${value}\u2069`;
    return value;
};
const $93ec44f7cf837915$export$cb0bbc88c7f09596 = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const $93ec44f7cf837915$export$8bb5d1c9951d10ca = (sections, isRTL)=>{
    let position = 0;
    let positionInInput = isRTL ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = $93ec44f7cf837915$export$85daa91f6c6e875f(section, isRTL ? 'input-rtl' : 'input-ltr');
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $93ec44f7cf837915$export$cb0bbc88c7f09596(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $93ec44f7cf837915$export$cb0bbc88c7f09596(renderedValue);
        const startInInput = positionInInput + renderedValue.indexOf(cleanedValue[0]) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $gOPoC.default)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const $93ec44f7cf837915$var$getSectionPlaceholder = (utils, timezone, localeText, sectionConfig, currentTokenValue)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: utils.formatByString(utils.dateWithTimezone(undefined, timezone), currentTokenValue).length
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType
            });
        case 'day':
            return localeText.fieldDayPlaceholder();
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder();
        case 'minutes':
            return localeText.fieldMinutesPlaceholder();
        case 'seconds':
            return localeText.fieldSecondsPlaceholder();
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder();
        default:
            return currentTokenValue;
    }
};
const $93ec44f7cf837915$export$2816862a602354ce = (utils, valueStr, currentFormat, newFormat)=>{
    return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const $93ec44f7cf837915$var$isFourDigitYearFormat = (utils, timezone, format)=>utils.formatByString(utils.dateWithTimezone(undefined, timezone), format).length === 4;
const $93ec44f7cf837915$export$78b5830e2dd2de49 = (utils, timezone, contentType, sectionType, format)=>{
    if (contentType !== 'digit') return false;
    const now = utils.dateWithTimezone(undefined, timezone);
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case 'year':
            {
                if ($93ec44f7cf837915$var$isFourDigitYearFormat(utils, timezone, format)) {
                    const formatted0001 = utils.formatByString(utils.setYear(now, 1), format);
                    return formatted0001 === '0001';
                }
                const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format);
                return formatted2001 === '01';
            }
        case 'month':
            return utils.formatByString(utils.startOfYear(now), format).length > 1;
        case 'day':
            return utils.formatByString(utils.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return utils.formatByString(utils.startOfWeek(now), format).length > 1;
        case 'hours':
            return utils.formatByString(utils.setHours(now, 1), format).length > 1;
        case 'minutes':
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        default:
            throw new Error('Invalid section type');
    }
};
const $93ec44f7cf837915$var$getEscapedPartsFromFormat = (utils, format)=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = utils.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(format))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $93ec44f7cf837915$export$fd71d82fe42bada1 = (utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL)=>{
    let startSeparator = '';
    const sections = [];
    const now = utils.date();
    const commitToken = (token)=>{
        if (token === '') return null;
        const sectionConfig = $93ec44f7cf837915$export$2f3c5fac7a2a65f6(utils, token);
        const hasLeadingZerosInFormat = $93ec44f7cf837915$export$78b5830e2dd2de49(utils, timezone, sectionConfig.contentType, sectionConfig.type, token);
        const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
        const isValidDate = date != null && utils.isValid(date);
        let sectionValue = isValidDate ? utils.formatByString(date, token) : '';
        let maxLength = null;
        if (hasLeadingZerosInInput) {
            if (hasLeadingZerosInFormat) maxLength = sectionValue === '' ? utils.formatByString(now, token).length : sectionValue.length;
            else {
                if (sectionConfig.maxLength == null) throw new Error(`MUI: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
                maxLength = sectionConfig.maxLength;
                if (isValidDate) sectionValue = $93ec44f7cf837915$export$713c6d756c12fc27(utils, sectionValue, maxLength);
            }
        }
        sections.push((0, $gOPoC.default)({}, sectionConfig, {
            format: token,
            maxLength: maxLength,
            value: sectionValue,
            placeholder: $93ec44f7cf837915$var$getSectionPlaceholder(utils, timezone, localeText, sectionConfig, token),
            hasLeadingZeros: hasLeadingZerosInFormat,
            hasLeadingZerosInFormat: hasLeadingZerosInFormat,
            hasLeadingZerosInInput: hasLeadingZerosInInput,
            startSeparator: sections.length === 0 ? startSeparator : '',
            endSeparator: '',
            modified: false
        }));
        return null;
    };
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = utils.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = utils.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error('MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component');
    }
    const expandedFormat = nextFormat;
    // Get start/end indexes of escaped sections
    const escapedParts = $93ec44f7cf837915$var$getEscapedPartsFromFormat(utils, expandedFormat);
    // This RegExp test if the beginning of a string correspond to a supported token
    const isTokenStartRegExp = new RegExp(`^(${Object.keys(utils.formatTokenMap).sort((a, b)=>b.length - a.length) // Sort to put longest word first
    .join('|')})`, 'g') // used to get access to lastIndex state
    ;
    let currentTokenValue = '';
    for(let i = 0; i < expandedFormat.length; i += 1){
        const escapedPartOfCurrentChar = escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
        const char = expandedFormat[i];
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const potentialToken = `${currentTokenValue}${expandedFormat.slice(i)}`;
        const regExpMatch = isTokenStartRegExp.test(potentialToken);
        if (!isEscapedChar && char.match(/([A-Za-z]+)/) && regExpMatch) {
            currentTokenValue = potentialToken.slice(0, isTokenStartRegExp.lastIndex);
            i += isTokenStartRegExp.lastIndex - 1;
        } else {
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.start) === i || (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.end) === i;
            if (!isEscapeBoundary) {
                commitToken(currentTokenValue);
                currentTokenValue = '';
                if (sections.length === 0) startSeparator += char;
                else sections[sections.length - 1].endSeparator += char;
            }
        }
    }
    commitToken(currentTokenValue);
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRTL && cleanedSeparator !== null && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === 'spacious' && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $93ec44f7cf837915$export$b0c1bfd065bfe742 = (utils, sections)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === 'day');
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($93ec44f7cf837915$export$85daa91f6c6e875f(section, 'non-input'));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $93ec44f7cf837915$export$e990c4332a617e3d = (sections, isRTL)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $93ec44f7cf837915$export$85daa91f6c6e875f(section, isRTL ? 'input-rtl' : 'input-ltr');
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join('');
    if (!isRTL) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const $93ec44f7cf837915$export$360600f456ea7d5f = (utils, timezone)=>{
    const today = utils.dateWithTimezone(undefined, timezone);
    const endOfYear = utils.endOfYear(today);
    const endOfDay = utils.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $915ec64656c7dd6f$export$62591b96a734eacd)(utils, today).reduce((acc, month)=>{
        const daysInMonth = utils.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $93ec44f7cf837915$var$isFourDigitYearFormat(utils, timezone, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: utils.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === 'digit') {
                const daysInWeek = $93ec44f7cf837915$export$c65c7173f879039f(utils, timezone, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = utils.getHours(endOfDay);
            const hasMeridiem = utils.formatByString(utils.endOfDay(today), format) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number(utils.formatByString(utils.startOfDay(today), format))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: utils.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: utils.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $93ec44f7cf837915$var$warnedOnceInvalidSection = false;
const $93ec44f7cf837915$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $93ec44f7cf837915$var$transferDateSectionValue = (utils, timezone, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
        case 'month':
            return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                const formattedDaysInWeek = $93ec44f7cf837915$export$c65c7173f879039f(utils, timezone, section.format);
                const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return utils.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const isAM = utils.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = utils.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return utils.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return utils.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case 'hours':
            return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
        case 'minutes':
            return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
        case 'seconds':
            return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $93ec44f7cf837915$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8
};
const $93ec44f7cf837915$export$6c6df982c77f60a9 = (utils, timezone, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$93ec44f7cf837915$var$reliableSectionModificationOrder[a.type] - $93ec44f7cf837915$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $93ec44f7cf837915$var$transferDateSectionValue(utils, timezone, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $93ec44f7cf837915$export$a11b0059900ceec8 = ()=>navigator.userAgent.toLowerCase().indexOf('android') > -1;
const $93ec44f7cf837915$export$7725fd6fe0a2aadf = (sections, isRTL)=>{
    const neighbors = {};
    if (!isRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>{
            var _section$endSeparator;
            return index >= groupedSectionsStart && ((_section$endSeparator = section.endSeparator) == null ? void 0 : _section$endSeparator.includes(' ')) && // Special case where the spaces were not there in the initial input
            section.endSeparator !== ' / ';
        });
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};


const $286007e7644aad7a$var$_excluded = [
    "value",
    "referenceDate"
];
const $286007e7644aad7a$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $915ec64656c7dd6f$export$1118e4272ea1e258),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $aBenZ.default)(_ref, $286007e7644aad7a$var$_excluded);
        if (value != null && params.utils.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $296cf343c750d880$export$6a31d56794238e4e)(params);
    },
    cleanValue: (0, $915ec64656c7dd6f$export$36ca889e039badd5),
    areValuesEqual: (0, $915ec64656c7dd6f$export$8fabf9a4cbada414),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (utils, value)=>value == null || !utils.isValid(value) ? null : utils.getTimezone(value),
    setTimezone: (utils, timezone, value)=>value == null ? null : utils.setTimezone(value, timezone)
};
const $286007e7644aad7a$export$b602c94f557316b4 = {
    updateReferenceValue: (utils, value, prevReferenceValue)=>value == null || !utils.isValid(value) ? prevReferenceValue : value,
    getSectionsFromValue: (utils, date, prevSections, isRTL, getSectionsFromDate)=>{
        const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
        if (shouldReUsePrevDateSections) return prevSections;
        return (0, $93ec44f7cf837915$export$8bb5d1c9951d10ca)(getSectionsFromDate(date), isRTL);
    },
    getValueStrFromSections: (0, $93ec44f7cf837915$export$e990c4332a617e3d),
    getActiveDateManager: (utils, state)=>({
            date: state.value,
            referenceDate: state.referenceValue,
            getSections: (sections)=>sections,
            getNewValuesFromNewActiveDate: (newActiveDate)=>({
                    value: newActiveDate,
                    referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
                })
        }),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue)
};



var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $jFgmT = parcelRequire("jFgmT");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $gOPoC = parcelRequire("gOPoC");
const $2edb420d9411291f$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $gOPoC.default)({}, pickersTranslations)
                }
            }
        }
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $1973ceb1535dfb33$var$enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'open previous view',
    openNextView: 'open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange placeholders
    start: 'Start',
    end: 'End',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    // Clock labels
    clockLabelText: (view, time, adapter)=>`Select ${view}. ${time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose date, selected date is ${utils.format(value, 'fullDate')}` : 'Choose date',
    openTimePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose time, selected time is ${utils.format(value, 'fullTime')}` : 'Choose time',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa'
};
const $1973ceb1535dfb33$export$1af4c7e47ad72f44 = $1973ceb1535dfb33$var$enUSPickers;
const $1973ceb1535dfb33$export$137380d9ce54f7f = (0, $2edb420d9411291f$export$67c96d35a1b010b3)($1973ceb1535dfb33$var$enUSPickers);


const $aa5fe19dd76d6423$export$4b5a24245de9f7f9 = ()=>{
    const localization = $3OyDL.useContext((0, $0dca6c5826980612$export$544976378534cf9));
    if (localization === null) throw new Error([
        'MUI: Can not find the date and time pickers localization context.',
        'It looks like you forgot to wrap your component in LocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'
    ].join('\n'));
    if (localization.utils === null) throw new Error([
        'MUI: Can not find the date and time pickers adapter from its localization context.',
        'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'
    ].join('\n'));
    const localeText = $3OyDL.useMemo(()=>(0, $gOPoC.default)({}, (0, $1973ceb1535dfb33$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $3OyDL.useMemo(()=>(0, $gOPoC.default)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $aa5fe19dd76d6423$export$1163b47e39508a46 = ()=>$aa5fe19dd76d6423$export$4b5a24245de9f7f9().utils;
const $aa5fe19dd76d6423$export$7c38da3a2e90fa83 = ()=>$aa5fe19dd76d6423$export$4b5a24245de9f7f9().defaultDates;
const $aa5fe19dd76d6423$export$24fdeaa0f591a73e = ()=>$aa5fe19dd76d6423$export$4b5a24245de9f7f9().localeText;
const $aa5fe19dd76d6423$export$3a404aece3dff2fa = (timezone)=>{
    const utils = $aa5fe19dd76d6423$export$1163b47e39508a46();
    const now = $3OyDL.useRef();
    if (now.current === undefined) now.current = utils.dateWithTimezone(undefined, timezone);
    return now.current;
};





var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");



var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");
function $65bce60271b3eb78$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}



var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");


var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");

const $969be89905639ddd$var$defaultGenerator = (componentName)=>componentName;
const $969be89905639ddd$var$createClassNameGenerator = ()=>{
    let generate = $969be89905639ddd$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $969be89905639ddd$var$defaultGenerator;
        }
    };
};
const $969be89905639ddd$var$ClassNameGenerator = $969be89905639ddd$var$createClassNameGenerator();
var $969be89905639ddd$export$2e2bcd8739ae039 = $969be89905639ddd$var$ClassNameGenerator;


const $616566cb1dde16a6$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $616566cb1dde16a6$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $616566cb1dde16a6$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $969be89905639ddd$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $616566cb1dde16a6$export$34c0130b1f3e8ae3(slot) {
    return $616566cb1dde16a6$export$9d6b9120de57c54[slot] !== undefined;
}


function $fccf60b7720ad689$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $616566cb1dde16a6$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}


function $3b30ba85142e2c48$export$b109c489973c3d80(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiPickersToolbar', slot);
}
const $3b30ba85142e2c48$export$59f09e5e2b3d9913 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiPickersToolbar', [
    'root',
    'content'
]);



var $2M70Q = parcelRequire("2M70Q");
const $fcd14893ba098a3f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        content: [
            'content'
        ],
        penIconButton: [
            'penIconButton',
            isLandscape && 'penIconButtonLandscape'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $3b30ba85142e2c48$export$b109c489973c3d80), classes);
};
const $fcd14893ba098a3f$var$PickersToolbarRoot = (0, $jH1k7.default)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3)
    }, ownerState.isLandscape && {
        height: 'auto',
        maxWidth: 160,
        padding: 16,
        justifyContent: 'flex-start',
        flexWrap: 'wrap'
    }));
const $fcd14893ba098a3f$var$PickersToolbarContent = (0, $jH1k7.default)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ ownerState: ownerState })=>{
    var _ownerState$landscape;
    return {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: ownerState.isLandscape ? 'flex-start' : 'space-between',
        flexDirection: ownerState.isLandscape ? (_ownerState$landscape = ownerState.landscapeDirection) != null ? _ownerState$landscape : 'column' : 'row',
        flex: 1,
        alignItems: ownerState.isLandscape ? 'flex-start' : 'center'
    };
});
const $fcd14893ba098a3f$export$eb3c4d84783d6feb = /*#__PURE__*/ $3OyDL.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children: children, className: className, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId } = props;
    const ownerState = props;
    const classes = $fcd14893ba098a3f$var$useUtilityClasses(ownerState);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($fcd14893ba098a3f$var$PickersToolbarRoot, {
        ref: ref,
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($fcd14893ba098a3f$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            })
        ]
    });
});




function $3b68844bbc40d3d7$export$a1c3879af2c3b694(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiDatePickerToolbar', slot);
}
const $3b68844bbc40d3d7$export$2e35fa7d24ef4179 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiDatePickerToolbar', [
    'root',
    'title'
]);




var $2M70Q = parcelRequire("2M70Q");
const $947df1ac1726b07e$var$_excluded = [
    "value",
    "isLandscape",
    "onChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views"
];
const $947df1ac1726b07e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $3b68844bbc40d3d7$export$a1c3879af2c3b694), classes);
};
const $947df1ac1726b07e$var$DatePickerToolbarRoot = (0, $jH1k7.default)((0, $fcd14893ba098a3f$export$eb3c4d84783d6feb), {
    name: 'MuiDatePickerToolbar',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({});
/**
 * @ignore - do not document.
 */ const $947df1ac1726b07e$var$DatePickerToolbarTitle = (0, $jH1k7.default)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
    name: 'MuiDatePickerToolbar',
    slot: 'Title',
    overridesResolver: (_, styles)=>styles.title
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({}, ownerState.isLandscape && {
        margin: 'auto 16px auto auto'
    }));
const $947df1ac1726b07e$export$21b7f8ea763109eb = /*#__PURE__*/ $3OyDL.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { value: value, isLandscape: isLandscape, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", views: views } = props, other = (0, $aBenZ.default)(props, $947df1ac1726b07e$var$_excluded);
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const classes = $947df1ac1726b07e$var$useUtilityClasses(props);
    const dateText = $3OyDL.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        const formatFromViews = (0, $915ec64656c7dd6f$export$bb1c921f313ec928)(utils, {
            format: toolbarFormat,
            views: views
        }, true);
        return utils.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, $2M70Q.jsx)($947df1ac1726b07e$var$DatePickerToolbarRoot, (0, $gOPoC.default)({
        ref: ref,
        toolbarTitle: localeText.datePickerToolbarTitle,
        isLandscape: isLandscape,
        className: classes.root
    }, other, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($947df1ac1726b07e$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});



var $gOPoC = parcelRequire("gOPoC");
const $95ed0f26a5eee9f7$export$ee17bc394843b249 = (capitalizedObject)=>{
    if (capitalizedObject === undefined) return undefined;
    return Object.keys(capitalizedObject).reduce((acc, key)=>(0, $gOPoC.default)({}, acc, {
            [`${key.slice(0, 1).toLowerCase()}${key.slice(1)}`]: capitalizedObject[key]
        }), {});
};


function $7cf6384dc8d40c20$export$a552c17ed3587731(props, name) {
    var _themeProps$slots, _themeProps$disableFu, _themeProps$disablePa, _themeProps$slotProps;
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const defaultDates = (0, $aa5fe19dd76d6423$export$7c38da3a2e90fa83)();
    const themeProps = (0, $jFgmT.default)({
        props: props,
        name: name
    });
    const localeText = $3OyDL.useMemo(()=>{
        var _themeProps$localeTex;
        if (((_themeProps$localeTex = themeProps.localeText) == null ? void 0 : _themeProps$localeTex.toolbarTitle) == null) return themeProps.localeText;
        return (0, $gOPoC.default)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const slots = (_themeProps$slots = themeProps.slots) != null ? _themeProps$slots : (0, $95ed0f26a5eee9f7$export$ee17bc394843b249)(themeProps.components);
    return (0, $gOPoC.default)({}, themeProps, {
        localeText: localeText
    }, (0, $77b769676d9b7e67$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day'
        ],
        defaultOpenTo: 'day'
    }), {
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        minDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate),
        slots: (0, $gOPoC.default)({
            toolbar: (0, $947df1ac1726b07e$export$21b7f8ea763109eb)
        }, slots),
        slotProps: (_themeProps$slotProps = themeProps.slotProps) != null ? _themeProps$slotProps : themeProps.componentsProps
    });
}



const $709ab20d38d8c90a$export$ffb3d0046ef3a2 = ({ props: props, value: value, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture, timezone: timezone } = props;
    const now = adapter.utils.dateWithTimezone(undefined, timezone);
    const minDate = (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");

var $3OyDL = parcelRequire("3OyDL");
'use client';
function $9f798df044ac9206$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $3OyDL.useRef(undefined);
    const refEffect = $3OyDL.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $3OyDL.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $f3662d41b7b7d649$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $f3662d41b7b7d649$export$2e2bcd8739ae039 = $f3662d41b7b7d649$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $35837d01ce762ee7$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $f3662d41b7b7d649$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $35837d01ce762ee7$export$2e2bcd8739ae039 = $35837d01ce762ee7$var$appendOwnerState;



var $3DmQB = parcelRequire("3DmQB");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $dec795f7821d6a08$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $dec795f7821d6a08$export$2e2bcd8739ae039 = $dec795f7821d6a08$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $f666b253f85bfc20$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $f666b253f85bfc20$export$2e2bcd8739ae039 = $f666b253f85bfc20$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $c128c10e1900ea73$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $3DmQB.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $dec795f7821d6a08$export$2e2bcd8739ae039)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $f666b253f85bfc20$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $f666b253f85bfc20$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $3DmQB.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $c128c10e1900ea73$export$2e2bcd8739ae039 = $c128c10e1900ea73$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $1a3534b70da57b18$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $1a3534b70da57b18$export$2e2bcd8739ae039 = $1a3534b70da57b18$var$resolveComponentProps;


'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $a8db9ed8fe7432f4$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $1a3534b70da57b18$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $c128c10e1900ea73$export$2e2bcd8739ae039)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $9f798df044ac9206$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $35837d01ce762ee7$export$2e2bcd8739ae039)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $a8db9ed8fe7432f4$export$2e2bcd8739ae039 = $a8db9ed8fe7432f4$var$useSlotProps;





var $3OyDL = parcelRequire("3OyDL");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $f03a7cefd3f53a50$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $a0093ef70e9dc99d$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $3OyDL.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $f03a7cefd3f53a50$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}



var $3OyDL = parcelRequire("3OyDL");
'use client';
let $da50f700e88904fb$var$globalId = 0;
function $da50f700e88904fb$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $3OyDL.useState(idOverride);
    const id = idOverride || defaultId;
    $3OyDL.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $da50f700e88904fb$var$globalId += 1;
            setDefaultId(`mui-${$da50f700e88904fb$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $da50f700e88904fb$var$maybeReactUseId = $3OyDL['useId'.toString()];
function $da50f700e88904fb$export$2e2bcd8739ae039(idOverride) {
    if ($da50f700e88904fb$var$maybeReactUseId !== undefined) {
        const reactId = $da50f700e88904fb$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $da50f700e88904fb$var$useGlobalId(idOverride);
}



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");






function $3e58bdba8c66ef5b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $3OyDL = parcelRequire("3OyDL");

var $3OyDL = parcelRequire("3OyDL");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $54812c32efbf145d$var$useEnhancedEffect = typeof window !== 'undefined' ? $3OyDL.useLayoutEffect : $3OyDL.useEffect;
var $54812c32efbf145d$export$2e2bcd8739ae039 = $54812c32efbf145d$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $09ed1aada0557388$var$useEventCallback(fn) {
    const ref = $3OyDL.useRef(fn);
    (0, $54812c32efbf145d$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $3OyDL.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $09ed1aada0557388$export$2e2bcd8739ae039 = $09ed1aada0557388$var$useEventCallback;



var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");

function $be5ddc2aafba3a70$export$5519b4d4bf80ce6f(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiPickersPopper', slot);
}
const $be5ddc2aafba3a70$export$46e9184c9b1af0ce = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiPickersPopper', [
    'root',
    'paper'
]);


/* Use it instead of .includes method for IE support */ function $c744f6b99d4ca951$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $c744f6b99d4ca951$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $c744f6b99d4ca951$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
const $c744f6b99d4ca951$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $c744f6b99d4ca951$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
const $c744f6b99d4ca951$export$9ae5b19305db48ce = '@media (pointer: fine)';



const $ed2824d9d63e757f$var$PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
// detect if user agent has Android version < 10 or iOS version < 13
const $ed2824d9d63e757f$var$mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $ed2824d9d63e757f$var$androidVersion = $ed2824d9d63e757f$var$mobileVersionMatches && $ed2824d9d63e757f$var$mobileVersionMatches[1] ? parseInt($ed2824d9d63e757f$var$mobileVersionMatches[1], 10) : null;
const $ed2824d9d63e757f$var$iOSVersion = $ed2824d9d63e757f$var$mobileVersionMatches && $ed2824d9d63e757f$var$mobileVersionMatches[2] ? parseInt($ed2824d9d63e757f$var$mobileVersionMatches[2], 10) : null;
const $ed2824d9d63e757f$export$7e3b2a595fb375e5 = $ed2824d9d63e757f$var$androidVersion && $ed2824d9d63e757f$var$androidVersion < 10 || $ed2824d9d63e757f$var$iOSVersion && $ed2824d9d63e757f$var$iOSVersion < 13 || false;
const $ed2824d9d63e757f$export$ce40fb97be7f02d9 = ()=>{
    const prefersReduced = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)($ed2824d9d63e757f$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    return prefersReduced || $ed2824d9d63e757f$export$7e3b2a595fb375e5;
};



var $2M70Q = parcelRequire("2M70Q");
const $da98bf67df64ceef$var$_excluded = [
    "PaperComponent",
    "popperPlacement",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const $da98bf67df64ceef$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $be5ddc2aafba3a70$export$5519b4d4bf80ce6f), classes);
};
const $da98bf67df64ceef$var$PickersPopperRoot = (0, $jH1k7.default)((0, $a61641bec19ba88c$export$2e2bcd8739ae039), {
    name: 'MuiPickersPopper',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $da98bf67df64ceef$var$PickersPopperPaper = (0, $jH1k7.default)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
    name: 'MuiPickersPopper',
    slot: 'Paper',
    overridesResolver: (_, styles)=>styles.paper
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        outline: 0,
        transformOrigin: 'top center'
    }, ownerState.placement.includes('top') && {
        transformOrigin: 'bottom center'
    }));
function $da98bf67df64ceef$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $da98bf67df64ceef$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $3OyDL.useRef(false);
    const syntheticEventRef = $3OyDL.useRef(false);
    const nodeRef = $3OyDL.useRef(null);
    const activatedRef = $3OyDL.useRef(false);
    $3OyDL.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $3e58bdba8c66ef5b$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        'clientX' in event && $da98bf67df64ceef$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    $3OyDL.useEffect(()=>{
        if (active) {
            const doc = (0, $3e58bdba8c66ef5b$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $3OyDL.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (e.g. setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $3e58bdba8c66ef5b$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const $da98bf67df64ceef$var$PickersPopperPaperWrapper = /*#__PURE__*/ $3OyDL.forwardRef((props, ref)=>{
    const { PaperComponent: PaperComponent, popperPlacement: popperPlacement, ownerState: inOwnerState, children: children, paperSlotProps: paperSlotProps, paperClasses: paperClasses, onPaperClick: onPaperClick, onPaperTouchStart: onPaperTouchStart } = props, other = (0, $aBenZ.default)(props, $da98bf67df64ceef$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, inOwnerState, {
        placement: popperPlacement
    });
    const paperProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: ref
        },
        className: paperClasses,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)(PaperComponent, (0, $gOPoC.default)({}, other, paperProps, {
        onClick: (event)=>{
            var _paperProps$onClick;
            onPaperClick(event);
            (_paperProps$onClick = paperProps.onClick) == null || _paperProps$onClick.call(paperProps, event);
        },
        onTouchStart: (event)=>{
            var _paperProps$onTouchSt;
            onPaperTouchStart(event);
            (_paperProps$onTouchSt = paperProps.onTouchStart) == null || _paperProps$onTouchSt.call(paperProps, event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function $da98bf67df64ceef$export$96ce8482474de8a5(inProps) {
    var _slots$desktopTransit, _slots$desktopTrapFoc, _slots$desktopPaper, _slots$popper;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPickersPopper'
    });
    const { anchorEl: anchorEl, children: children, containerRef: containerRef = null, shouldRestoreFocus: shouldRestoreFocus, onBlur: onBlur, onDismiss: onDismiss, open: open, role: role, placement: placement, slots: slots, slotProps: slotProps, reduceAnimations: inReduceAnimations } = props;
    $3OyDL.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Blink?) use 'Esc'
            if (open && (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc')) onDismiss();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        onDismiss,
        open
    ]);
    const lastFocusedElementRef = $3OyDL.useRef(null);
    $3OyDL.useEffect(()=>{
        if (role === 'tooltip' || shouldRestoreFocus && !shouldRestoreFocus()) return;
        if (open) lastFocusedElementRef.current = (0, $c744f6b99d4ca951$export$cd4e5573fbe2b576)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role,
        shouldRestoreFocus
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $da98bf67df64ceef$var$useClickAwayListener(open, onBlur != null ? onBlur : onDismiss);
    const paperRef = $3OyDL.useRef(null);
    const handleRef = (0, $a0093ef70e9dc99d$export$2e2bcd8739ae039)(paperRef, containerRef);
    const handlePaperRef = (0, $a0093ef70e9dc99d$export$2e2bcd8739ae039)(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = $da98bf67df64ceef$var$useUtilityClasses(ownerState);
    const defaultReduceAnimations = (0, $ed2824d9d63e757f$export$ce40fb97be7f02d9)();
    const reduceAnimations = inReduceAnimations != null ? inReduceAnimations : defaultReduceAnimations;
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            onDismiss();
        }
    };
    const Transition = ((_slots$desktopTransit = slots == null ? void 0 : slots.desktopTransition) != null ? _slots$desktopTransit : reduceAnimations) ? (0, $9c9203b21cd916fe$export$2e2bcd8739ae039) : (0, $a144ebfc440ec800$export$2e2bcd8739ae039);
    const FocusTrap = (_slots$desktopTrapFoc = slots == null ? void 0 : slots.desktopTrapFocus) != null ? _slots$desktopTrapFoc : (0, $25bc699f83f7857d$export$34eba2437817a67b);
    const Paper = (_slots$desktopPaper = slots == null ? void 0 : slots.desktopPaper) != null ? _slots$desktopPaper : $da98bf67df64ceef$var$PickersPopperPaper;
    const Popper = (_slots$popper = slots == null ? void 0 : slots.popper) != null ? _slots$popper : $da98bf67df64ceef$var$PickersPopperRoot;
    const popperProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: Popper,
        externalSlotProps: slotProps == null ? void 0 : slotProps.popper,
        additionalProps: {
            transition: true,
            role: role,
            open: open,
            anchorEl: anchorEl,
            placement: placement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: props
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)(Popper, (0, $gOPoC.default)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps, placement: popperPlacement })=>/*#__PURE__*/ (0, $2M70Q.jsx)(FocusTrap, (0, $gOPoC.default)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: role === 'tooltip',
                isEnabled: ()=>true
            }, slotProps == null ? void 0 : slotProps.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $2M70Q.jsx)(Transition, (0, $gOPoC.default)({}, TransitionProps, slotProps == null ? void 0 : slotProps.desktopTransition, {
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)($da98bf67df64ceef$var$PickersPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        popperPlacement: popperPlacement,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps == null ? void 0 : slotProps.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}




var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $3OyDL = parcelRequire("3OyDL");
'use client';
function $3bd2ff427a59ae77$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $3OyDL.useRef(controlled !== undefined);
    const [valueState, setValue] = $3OyDL.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $3OyDL.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}




var $3OyDL = parcelRequire("3OyDL");
const $5834eba83a32e302$export$7d3a09d5141ab1f4 = ({ open: open, onOpen: onOpen, onClose: onClose })=>{
    const isControllingOpenProp = $3OyDL.useRef(typeof open === 'boolean').current;
    const [openState, setIsOpenState] = $3OyDL.useState(false);
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)
    $3OyDL.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== 'boolean') throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $3OyDL.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
};




var $3OyDL = parcelRequire("3OyDL");

function $0801d7d4ea653bc3$export$87fe492f99f25a20(props, validate, isSameError, defaultErrorState) {
    const { value: value, onError: onError } = props;
    const adapter = (0, $aa5fe19dd76d6423$export$4b5a24245de9f7f9)();
    const previousValidationErrorRef = $3OyDL.useRef(defaultErrorState);
    const validationError = validate({
        adapter: adapter,
        value: value,
        props: props
    });
    $3OyDL.useEffect(()=>{
        if (onError && !isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        isSameError,
        onError,
        previousValidationErrorRef,
        validationError,
        value
    ]);
    return validationError;
}



var $3OyDL = parcelRequire("3OyDL");



const $c1a1b9e58f0b723e$export$c7e050e908c1b2bc = ({ timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChange, valueManager: valueManager })=>{
    var _ref, _ref2;
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const firstDefaultValue = $3OyDL.useRef(defaultValue);
    const inputValue = (_ref = valueProp != null ? valueProp : firstDefaultValue.current) != null ? _ref : valueManager.emptyValue;
    const inputTimezone = $3OyDL.useMemo(()=>valueManager.getTimezone(utils, inputValue), [
        utils,
        valueManager,
        inputValue
    ]);
    const setInputTimezone = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(utils, inputTimezone, newValue);
    });
    const timezoneToRender = (_ref2 = timezoneProp != null ? timezoneProp : inputTimezone) != null ? _ref2 : 'default';
    const valueWithTimezoneToRender = $3OyDL.useMemo(()=>valueManager.setTimezone(utils, timezoneToRender, inputValue), [
        valueManager,
        utils,
        timezoneToRender,
        inputValue
    ]);
    const handleValueChange = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        onChange == null || onChange(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};
const $c1a1b9e58f0b723e$export$174d749f3b4c0f49 = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChangeProp, valueManager: valueManager })=>{
    const [valueWithInputTimezone, setValue] = (0, $3bd2ff427a59ae77$export$2e2bcd8739ae039)({
        name: name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : valueManager.emptyValue
    });
    const onChange = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        setValue(newValue);
        onChangeProp == null || onChangeProp(newValue, ...otherParams);
    });
    return $c1a1b9e58f0b723e$export$c7e050e908c1b2bc({
        timezone: timezoneProp,
        value: valueWithInputTimezone,
        defaultValue: undefined,
        onChange: onChange,
        valueManager: valueManager
    });
};


/**
 * Decide if the new value should be published
 * The published value will be passed to `onChange` if defined.
 */ const $d6961099fa025e4f$var$shouldPublishValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    // The field is responsible for only calling `onChange` when needed.
    if (action.name === 'setValueFromField') return true;
    if (action.name === 'setValueFromAction') {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to publish the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === 'setValueFromView' && action.selectionState !== 'shallow') {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === 'setValueFromShortcut') {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    return false;
};
/**
 * Decide if the new value should be committed.
 * The committed value will be passed to `onAccept` if defined.
 * It will also be used as a reset target when calling the `cancel` picker action (when clicking on the "Cancel" button).
 */ const $d6961099fa025e4f$var$shouldCommitValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled, closeOnSelect: closeOnSelect } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    if (action.name === 'setValueFromAction') {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to commit the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === 'setValueFromView' && action.selectionState === 'finish' && closeOnSelect) {
        // On picker where the 1st view is also the last view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onAccept`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === 'setValueFromShortcut') return action.changeImportance === 'accept' && hasChanged(dateState.lastCommittedValue);
    return false;
};
/**
 * Decide if the picker should be closed after the value is updated.
 */ const $d6961099fa025e4f$var$shouldClosePicker = (params)=>{
    const { action: action, closeOnSelect: closeOnSelect } = params;
    if (action.name === 'setValueFromAction') return true;
    if (action.name === 'setValueFromView') return action.selectionState === 'finish' && closeOnSelect;
    if (action.name === 'setValueFromShortcut') return action.changeImportance === 'accept';
    return false;
};
const $d6961099fa025e4f$export$799b22a7b7fffaa3 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, validator: validator })=>{
    const { onAccept: onAccept, onChange: onChange, value: inValue, defaultValue: inDefaultValue, closeOnSelect: closeOnSelect = wrapperVariant === 'desktop', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezoneProp } = props;
    const { current: defaultValue } = $3OyDL.useRef(inDefaultValue);
    const { current: isControlled } = $3OyDL.useRef(inValue !== undefined);
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const adapter = (0, $aa5fe19dd76d6423$export$4b5a24245de9f7f9)();
    const [selectedSections, setSelectedSections] = (0, $3bd2ff427a59ae77$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'usePickerValue',
        state: 'selectedSections'
    });
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $5834eba83a32e302$export$7d3a09d5141ab1f4)(props);
    const [dateState, setDateState] = $3OyDL.useState(()=>{
        let initialValue;
        if (inValue !== undefined) initialValue = inValue;
        else if (defaultValue !== undefined) initialValue = defaultValue;
        else initialValue = valueManager.emptyValue;
        return {
            draft: initialValue,
            lastPublishedValue: initialValue,
            lastCommittedValue: initialValue,
            lastControlledValue: inValue,
            hasBeenModifiedSinceMount: false
        };
    });
    const { timezone: timezone, handleValueChange: handleValueChange } = (0, $c1a1b9e58f0b723e$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: inValue,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    (0, $0801d7d4ea653bc3$export$87fe492f99f25a20)((0, $gOPoC.default)({}, props, {
        value: dateState.draft,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const updateDate = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((action)=>{
        const updaterParams = {
            action: action,
            dateState: dateState,
            hasChanged: (comparison)=>!valueManager.areValuesEqual(utils, action.value, comparison),
            isControlled: isControlled,
            closeOnSelect: closeOnSelect
        };
        const shouldPublish = $d6961099fa025e4f$var$shouldPublishValue(updaterParams);
        const shouldCommit = $d6961099fa025e4f$var$shouldCommitValue(updaterParams);
        const shouldClose = $d6961099fa025e4f$var$shouldClosePicker(updaterParams);
        setDateState((prev)=>(0, $gOPoC.default)({}, prev, {
                draft: action.value,
                lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
                lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        if (shouldPublish) {
            const validationError = action.name === 'setValueFromField' ? action.context.validationError : validator({
                adapter: adapter,
                value: action.value,
                props: (0, $gOPoC.default)({}, props, {
                    value: action.value,
                    timezone: timezone
                })
            });
            const context = {
                validationError: validationError
            };
            // TODO v7: Remove 2nd condition
            if (action.name === 'setValueFromShortcut' && action.shortcut != null) context.shortcut = action.shortcut;
            handleValueChange(action.value, context);
        }
        if (shouldCommit && onAccept) onAccept(action.value);
        if (shouldClose) setIsOpen(false);
    });
    if (inValue !== undefined && (dateState.lastControlledValue === undefined || !valueManager.areValuesEqual(utils, dateState.lastControlledValue, inValue))) {
        const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValue);
        setDateState((prev)=>(0, $gOPoC.default)({}, prev, {
                lastControlledValue: inValue
            }, isUpdateComingFromPicker ? {} : {
                lastCommittedValue: inValue,
                lastPublishedValue: inValue,
                draft: inValue,
                hasBeenModifiedSinceMount: true
            }));
    }
    const handleClear = (0, $09ed1aada0557388$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.emptyValue,
            name: 'setValueFromAction',
            pickerAction: 'clear'
        });
    });
    const handleAccept = (0, $09ed1aada0557388$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'accept'
        });
    });
    const handleDismiss = (0, $09ed1aada0557388$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'dismiss'
        });
    });
    const handleCancel = (0, $09ed1aada0557388$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastCommittedValue,
            name: 'setValueFromAction',
            pickerAction: 'cancel'
        });
    });
    const handleSetToday = (0, $09ed1aada0557388$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.getTodayValue(utils, timezone, valueType),
            name: 'setValueFromAction',
            pickerAction: 'today'
        });
    });
    const handleOpen = (0, $09ed1aada0557388$export$2e2bcd8739ae039)(()=>setIsOpen(true));
    const handleClose = (0, $09ed1aada0557388$export$2e2bcd8739ae039)(()=>setIsOpen(false));
    const handleChange = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newValue, selectionState = 'partial')=>updateDate({
            name: 'setValueFromView',
            value: newValue,
            selectionState: selectionState
        }));
    // TODO v7: Make changeImportance and label mandatory.
    const handleSelectShortcut = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newValue, changeImportance, shortcut)=>updateDate({
            name: 'setValueFromShortcut',
            value: newValue,
            changeImportance: changeImportance != null ? changeImportance : 'accept',
            shortcut: shortcut
        }));
    const handleChangeFromField = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newValue, context)=>updateDate({
            name: 'setValueFromField',
            value: newValue,
            context: context
        }));
    const handleFieldSelectedSectionsChange = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newSelectedSections)=>{
        setSelectedSections(newSelectedSections);
        onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
    });
    const actions = {
        onClear: handleClear,
        onAccept: handleAccept,
        onDismiss: handleDismiss,
        onCancel: handleCancel,
        onSetToday: handleSetToday,
        onOpen: handleOpen,
        onClose: handleClose
    };
    const fieldResponse = {
        value: dateState.draft,
        onChange: handleChangeFromField,
        selectedSections: selectedSections,
        onSelectedSectionsChange: handleFieldSelectedSectionsChange
    };
    const viewValue = $3OyDL.useMemo(()=>valueManager.cleanValue(utils, dateState.draft), [
        utils,
        valueManager,
        dateState.draft
    ]);
    const viewResponse = {
        value: viewValue,
        onChange: handleChange,
        onClose: handleClose,
        open: isOpen,
        onSelectedSectionsChange: handleFieldSelectedSectionsChange
    };
    const isValid = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            props: (0, $gOPoC.default)({}, props, {
                value: testedValue,
                timezone: timezone
            })
        });
        return !valueManager.hasError(error);
    };
    const layoutResponse = (0, $gOPoC.default)({}, actions, {
        value: viewValue,
        onChange: handleChange,
        onSelectShortcut: handleSelectShortcut,
        isValid: isValid
    });
    return {
        open: isOpen,
        fieldProps: fieldResponse,
        viewProps: viewResponse,
        layoutProps: layoutResponse,
        actions: actions
    };
};



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");



var $3OyDL = parcelRequire("3OyDL");


let $f3f961a3b0e6e0b6$var$warnedOnceNotValidView = false;
function $f3f961a3b0e6e0b6$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange }) {
    var _views, _views2;
    const previousOpenTo = $3OyDL.useRef(openTo);
    const previousViews = $3OyDL.useRef(views);
    const defaultView = $3OyDL.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $3bd2ff427a59ae77$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $3OyDL.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $3bd2ff427a59ae77$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    $3OyDL.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = (_views = views[viewIndex - 1]) != null ? _views : null;
    const nextView = (_views2 = views[viewIndex + 1]) != null ? _views2 : null;
    const handleFocusedViewChange = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange == null || onFocusedViewChange(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newView)=>{
        if (newView === view) return;
        setView(newView);
        handleFocusedViewChange(newView, true);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $09ed1aada0557388$export$2e2bcd8739ae039)(()=>{
        if (nextView) handleChangeView(nextView);
        handleFocusedViewChange(nextView, true);
    });
    const setValueAndGoToNextView = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but we it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState);
        if (isSelectionFinishedOnCurrentView) goToNextView();
    });
    const setValueAndGoToView = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((value, newView, selectedView)=>{
        onChange(value, newView ? 'partial' : 'finish', selectedView);
        if (newView) {
            handleChangeView(newView);
            handleFocusedViewChange(newView, true);
        }
    });
    return {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        defaultView: defaultView.current,
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView,
        setValueAndGoToView: setValueAndGoToView
    };
}



const $d24e3d2453c8f12c$var$_excluded = [
    "className",
    "sx"
];
const $d24e3d2453c8f12c$export$c0a71b697a2df210 = ({ props: props, propsFromPickerValue: propsFromPickerValue, additionalViewProps: additionalViewProps, inputRef: inputRef, autoFocusView: autoFocusView })=>{
    const { onChange: onChange, open: open, onSelectedSectionsChange: onSelectedSectionsChange, onClose: onClose } = propsFromPickerValue;
    const { views: views, openTo: openTo, onViewChange: onViewChange, disableOpenPicker: disableOpenPicker, viewRenderers: viewRenderers, timezone: timezone } = props;
    const propsToForwardToView = (0, $aBenZ.default)(props, $d24e3d2453c8f12c$var$_excluded);
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $f3f961a3b0e6e0b6$export$9b46cba8f8ccd954)({
        view: undefined,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange,
        autoFocus: autoFocusView
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup } = $3OyDL.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            let viewMode;
            if (disableOpenPicker) viewMode = 'field';
            else if (viewRenderers[viewForReduce] != null) viewMode = 'UI';
            else viewMode = 'field';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === 'UI') acc.hasUIView = true;
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {}
        }), [
        disableOpenPicker,
        viewRenderers,
        views
    ]);
    const timeViewsCount = $3OyDL.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            if (viewRenderers[viewForReduce] != null && (0, $ab8b9fd82a664ad3$export$8f04d380cefd5a0d)(viewForReduce)) return acc + 1;
            return acc;
        }, 0), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const shouldRestoreFocus = (0, $09ed1aada0557388$export$2e2bcd8739ae039)(()=>currentViewMode === 'UI');
    const [popperView, setPopperView] = $3OyDL.useState(currentViewMode === 'UI' ? view : null);
    if (popperView !== view && viewModeLookup[view] === 'UI') setPopperView(view);
    (0, $54812c32efbf145d$export$2e2bcd8739ae039)(()=>{
        // Handle case of `DateTimePicker` without time renderers
        if (currentViewMode === 'field' && open) {
            onClose();
            setTimeout(()=>{
                // focusing the input before the range selection is done
                // calling `onSelectedSectionsChange` outside of timeout results in an inconsistent behavior between Safari And Chrome
                inputRef == null || inputRef.current.focus();
                onSelectedSectionsChange(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $54812c32efbf145d$export$2e2bcd8739ae039)(()=>{
        if (!open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === 'field' && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const layoutProps = {
        views: views,
        view: popperView,
        onViewChange: setView
    };
    return {
        hasUIView: hasUIView,
        shouldRestoreFocus: shouldRestoreFocus,
        layoutProps: layoutProps,
        renderCurrentView: ()=>{
            if (popperView == null) return null;
            const renderer = viewRenderers[popperView];
            if (renderer == null) return null;
            return renderer((0, $gOPoC.default)({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
                views: views,
                timezone: timezone,
                onChange: setValueAndGoToNextView,
                view: popperView,
                onViewChange: setView,
                focusedView: focusedView,
                onFocusedViewChange: setFocusedView,
                showViewSwitcher: timeViewsCount > 1,
                timeViewsCount: timeViewsCount
            }));
        }
    };
};



var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


function $e98376e85eb48e79$var$getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
const $e98376e85eb48e79$export$6f60b24e37af6448 = (views, customOrientation)=>{
    const [orientation, setOrientation] = $3OyDL.useState($e98376e85eb48e79$var$getOrientation);
    (0, $54812c32efbf145d$export$2e2bcd8739ae039)(()=>{
        const eventHandler = ()=>{
            setOrientation($e98376e85eb48e79$var$getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, $c744f6b99d4ca951$export$22012a5c726bef55)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
};


const $115fb32f06fc6463$export$4e5139e5825b7b27 = ({ props: props, propsFromPickerValue: propsFromPickerValue, propsFromPickerViews: propsFromPickerViews, wrapperVariant: wrapperVariant })=>{
    const { orientation: orientation } = props;
    const isLandscape = (0, $e98376e85eb48e79$export$6f60b24e37af6448)(propsFromPickerViews.views, orientation);
    const layoutProps = (0, $gOPoC.default)({}, propsFromPickerViews, propsFromPickerValue, {
        isLandscape: isLandscape,
        wrapperVariant: wrapperVariant,
        disabled: props.disabled,
        readOnly: props.readOnly
    });
    return {
        layoutProps: layoutProps
    };
};


const $bdf45c79545934fa$export$be61413ca3629f52 = (message)=>{
    let alreadyWarned = false;
    var deprecatedProps;
    return ()=>{};
};
const $bdf45c79545934fa$export$baf331755d84b871 = (message, gravity = 'warning')=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if (gravity === 'error') console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};


const $4e4f7729fec91532$var$warnRenderInputIsDefined = (0, $bdf45c79545934fa$export$baf331755d84b871)([
    'The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.',
    'You can replace it with the `textField` component slot in most cases.',
    'For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5).'
]);
const $4e4f7729fec91532$export$fc3313977ac596c4 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, inputRef: inputRef, additionalViewProps: additionalViewProps, validator: validator, autoFocusView: autoFocusView })=>{
    const pickerValueResponse = (0, $d6961099fa025e4f$export$799b22a7b7fffaa3)({
        props: props,
        valueManager: valueManager,
        valueType: valueType,
        wrapperVariant: wrapperVariant,
        validator: validator
    });
    const pickerViewsResponse = (0, $d24e3d2453c8f12c$export$c0a71b697a2df210)({
        props: props,
        inputRef: inputRef,
        additionalViewProps: additionalViewProps,
        autoFocusView: autoFocusView,
        propsFromPickerValue: pickerValueResponse.viewProps
    });
    const pickerLayoutResponse = (0, $115fb32f06fc6463$export$4e5139e5825b7b27)({
        props: props,
        wrapperVariant: wrapperVariant,
        propsFromPickerValue: pickerValueResponse.layoutProps,
        propsFromPickerViews: pickerViewsResponse.layoutProps
    });
    return {
        // Picker value
        open: pickerValueResponse.open,
        actions: pickerValueResponse.actions,
        fieldProps: pickerValueResponse.fieldProps,
        // Picker views
        renderCurrentView: pickerViewsResponse.renderCurrentView,
        hasUIView: pickerViewsResponse.hasUIView,
        shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
        // Picker layout
        layoutProps: pickerLayoutResponse.layoutProps
    };
};




var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");


function $c07708fe38f3f8a0$export$1671c31de798d429(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiPickersLayout', slot);
}
const $c07708fe38f3f8a0$export$7a6dac186703fe4c = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'shortcuts'
]);



var $gOPoC = parcelRequire("gOPoC");
parcelRequire("3OyDL");



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");
parcelRequire("3OyDL");





var $2M70Q = parcelRequire("2M70Q");
const $2b953057b8a4622a$var$_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
function $2b953057b8a4622a$export$72ffda3bb7ecf665(props) {
    const { onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, actions: actions } = props, other = (0, $aBenZ.default)(props, $2b953057b8a4622a$var$_excluded);
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions == null ? void 0 : actions.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a55b2c6a514356c8$export$2e2bcd8739ae039), {
                    onClick: onClear,
                    children: localeText.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a55b2c6a514356c8$export$2e2bcd8739ae039), {
                    onClick: onCancel,
                    children: localeText.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a55b2c6a514356c8$export$2e2bcd8739ae039), {
                    onClick: onAccept,
                    children: localeText.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a55b2c6a514356c8$export$2e2bcd8739ae039), {
                    onClick: onSetToday,
                    children: localeText.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $08e4970efe955928$export$2e2bcd8739ae039), (0, $gOPoC.default)({}, other, {
        children: buttons
    }));
}




var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");
parcelRequire("3OyDL");



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");


var $7m2iU = parcelRequire("7m2iU");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");






var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $ffb904a54951eedd$export$5682c366c0c669d9(slot) {
    return (0, $6AMoU.default)('MuiListItem', slot);
}
const $ffb904a54951eedd$var$listItemClasses = (0, $ithJf.default)('MuiListItem', [
    'root',
    'container',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'padding',
    'button',
    'secondaryAction',
    'selected'
]);
var $ffb904a54951eedd$export$2e2bcd8739ae039 = $ffb904a54951eedd$var$listItemClasses;



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $e109bc152590f7cf$export$c09531d8563c67a5(slot) {
    return (0, $6AMoU.default)('MuiListItemButton', slot);
}
const $e109bc152590f7cf$var$listItemButtonClasses = (0, $ithJf.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $e109bc152590f7cf$export$2e2bcd8739ae039 = $e109bc152590f7cf$var$listItemButtonClasses;



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");


var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $4094b3f76976cf31$export$ccdb26aeba48a86e(slot) {
    return (0, $6AMoU.default)('MuiListItemSecondaryAction', slot);
}
const $4094b3f76976cf31$var$listItemSecondaryActionClasses = (0, $ithJf.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $4094b3f76976cf31$export$2e2bcd8739ae039 = $4094b3f76976cf31$var$listItemSecondaryActionClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $53da766a85a47069$var$_excluded = [
    "className"
];
const $53da766a85a47069$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $4094b3f76976cf31$export$ccdb26aeba48a86e), classes);
};
const $53da766a85a47069$var$ListItemSecondaryActionRoot = (0, $jH1k7.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $53da766a85a47069$var$ListItemSecondaryAction = /*#__PURE__*/ $3OyDL.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className } = props, other = (0, $aBenZ.default)(props, $53da766a85a47069$var$_excluded);
    const context = $3OyDL.useContext((0, $3818dd11f6b8b9fa$export$2e2bcd8739ae039));
    const ownerState = (0, $gOPoC.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $53da766a85a47069$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($53da766a85a47069$var$ListItemSecondaryActionRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$53da766a85a47069$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $53da766a85a47069$export$2e2bcd8739ae039 = $53da766a85a47069$var$ListItemSecondaryAction;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $e969e2bf623d3658$var$_excluded = [
    "className"
], $e969e2bf623d3658$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $e969e2bf623d3658$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $e969e2bf623d3658$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            disabled && 'disabled',
            button && 'button',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction',
            selected && 'selected'
        ],
        container: [
            'container'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $ffb904a54951eedd$export$5682c366c0c669d9), classes);
};
const $e969e2bf623d3658$export$aed538f7519abe89 = (0, $jH1k7.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $e969e2bf623d3658$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
    }, !ownerState.disablePadding && (0, $gOPoC.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $e109bc152590f7cf$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $ffb904a54951eedd$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $ffb904a54951eedd$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $ffb904a54951eedd$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $ffb904a54951eedd$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.button && {
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $ffb904a54951eedd$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $e969e2bf623d3658$var$ListItemContainer = (0, $jH1k7.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $e969e2bf623d3658$var$ListItem = /*#__PURE__*/ $3OyDL.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $aBenZ.default)(props.ContainerProps, $e969e2bf623d3658$var$_excluded), other = (0, $aBenZ.default)(props, $e969e2bf623d3658$var$_excluded2);
    const context = $3OyDL.useContext((0, $3818dd11f6b8b9fa$export$2e2bcd8739ae039));
    const childContext = $3OyDL.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $3OyDL.useRef(null);
    (0, $b8bb11a9fe67b1a2$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $3OyDL.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $ad7a1c4dcda17e88$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, $gOPoC.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $e969e2bf623d3658$var$useUtilityClasses(ownerState);
    const handleRef = (0, $a31efceb4de56944$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $e969e2bf623d3658$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $3DmQB.default)((0, $ffb904a54951eedd$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $c582f66505800c92$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3818dd11f6b8b9fa$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $2M70Q.jsxs)($e969e2bf623d3658$var$ListItemContainer, (0, $gOPoC.default)({
                as: ContainerComponent,
                className: (0, $3DmQB.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)(Root, (0, $gOPoC.default)({}, rootProps, !(0, $03d7e3d159693402$export$e28348cc2430497)(Root) && {
                        as: Component,
                        ownerState: (0, $gOPoC.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3818dd11f6b8b9fa$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)(Root, (0, $gOPoC.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $03d7e3d159693402$export$e28348cc2430497)(Root) && {
            ownerState: (0, $gOPoC.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $53da766a85a47069$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $e969e2bf623d3658$export$2e2bcd8739ae039 = $e969e2bf623d3658$var$ListItem;



const $c8ed6f2a54427aa9$export$3f0060ce4cc8f4d0 = 36;
const $c8ed6f2a54427aa9$export$dde58b009b497666 = 2;
const $c8ed6f2a54427aa9$export$ee46b8a74d6c94d3 = 320;
const $c8ed6f2a54427aa9$export$f2fef360e2df0cb7 = 358;
const $c8ed6f2a54427aa9$export$1c2eabda4acea0e4 = 232;
const $c8ed6f2a54427aa9$export$a462ceb9cfdb5d71 = 48;



var $2M70Q = parcelRequire("2M70Q");
const $9b26a02db31e8eb7$var$_excluded = [
    "items",
    "changeImportance",
    "isLandscape",
    "onChange",
    "isValid"
], $9b26a02db31e8eb7$var$_excluded2 = [
    "getValue"
];
function $9b26a02db31e8eb7$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance, onChange: onChange, isValid: isValid } = props, other = (0, $aBenZ.default)(props, $9b26a02db31e8eb7$var$_excluded);
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $aBenZ.default)(_ref, $9b26a02db31e8eb7$var$_excluded2);
        const newValue = getValue({
            isValid: isValid
        });
        return {
            label: item.label,
            onClick: ()=>{
                onChange(newValue, changeImportance, item);
            },
            disabled: !isValid(newValue)
        };
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $77956800979257fa$export$2e2bcd8739ae039), (0, $gOPoC.default)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $c8ed6f2a54427aa9$export$f2fef360e2df0cb7),
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e969e2bf623d3658$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8c02f7497c61ac2b$export$2e2bcd8739ae039), (0, $gOPoC.default)({}, item))
            }, item.label);
        })
    }));
}




var $2M70Q = parcelRequire("2M70Q");
function $dbdbd09c9da8745d$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $dbdbd09c9da8745d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $c07708fe38f3f8a0$export$1671c31de798d429), classes);
};
const $dbdbd09c9da8745d$var$usePickerLayout = (props)=>{
    var _slots$actionBar, _slots$shortcuts;
    const { wrapperVariant: wrapperVariant, onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, view: view, views: views, onViewChange: onViewChange, value: value, onChange: onChange, onSelectShortcut: onSelectShortcut, isValid: isValid, isLandscape: isLandscape, disabled: disabled, readOnly: readOnly, children: children, components: components, componentsProps: componentsProps, slots: innerSlots, slotProps: innerSlotProps } = props;
    const slots = innerSlots != null ? innerSlots : (0, $95ed0f26a5eee9f7$export$ee17bc394843b249)(components);
    const slotProps = innerSlotProps != null ? innerSlotProps : componentsProps;
    const classes = $dbdbd09c9da8745d$var$useUtilityClasses(props);
    // Action bar
    const ActionBar = (_slots$actionBar = slots == null ? void 0 : slots.actionBar) != null ? _slots$actionBar : (0, $2b953057b8a4622a$export$72ffda3bb7ecf665);
    const actionBarProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: ActionBar,
        externalSlotProps: slotProps == null ? void 0 : slotProps.actionBar,
        additionalProps: {
            onAccept: onAccept,
            onClear: onClear,
            onCancel: onCancel,
            onSetToday: onSetToday,
            actions: wrapperVariant === 'desktop' ? [] : [
                'cancel',
                'accept'
            ],
            className: classes.actionBar
        },
        ownerState: (0, $gOPoC.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const actionBar = /*#__PURE__*/ (0, $2M70Q.jsx)(ActionBar, (0, $gOPoC.default)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots == null ? void 0 : slots.toolbar;
    const toolbarProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: Toolbar,
        externalSlotProps: slotProps == null ? void 0 : slotProps.toolbar,
        additionalProps: {
            isLandscape: isLandscape,
            onChange: onChange,
            value: value,
            view: view,
            onViewChange: onViewChange,
            views: views,
            disabled: disabled,
            readOnly: readOnly,
            className: classes.toolbar
        },
        ownerState: (0, $gOPoC.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const toolbar = $dbdbd09c9da8745d$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $2M70Q.jsx)(Toolbar, (0, $gOPoC.default)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots == null ? void 0 : slots.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $2M70Q.jsx)(Tabs, (0, $gOPoC.default)({
        view: view,
        onViewChange: onViewChange
    }, slotProps == null ? void 0 : slotProps.tabs)) : null;
    // Shortcuts
    const Shortcuts = (_slots$shortcuts = slots == null ? void 0 : slots.shortcuts) != null ? _slots$shortcuts : (0, $9b26a02db31e8eb7$export$8ba8fc65919fa1fe);
    const shortcutsProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: Shortcuts,
        externalSlotProps: slotProps == null ? void 0 : slotProps.shortcuts,
        additionalProps: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts
        },
        ownerState: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts,
            wrapperVariant: wrapperVariant
        }
    });
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $2M70Q.jsx)(Shortcuts, (0, $gOPoC.default)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts
    };
};
var $dbdbd09c9da8745d$export$2e2bcd8739ae039 = $dbdbd09c9da8745d$var$usePickerLayout;



var $2M70Q = parcelRequire("2M70Q");
const $1d0bfa2a9296ecf7$var$useUtilityClasses = (ownerState)=>{
    const { isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $c07708fe38f3f8a0$export$1671c31de798d429), classes);
};
const $1d0bfa2a9296ecf7$export$9a9363506c13836 = (0, $jH1k7.default)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>({
        display: 'grid',
        gridAutoColumns: 'max-content auto max-content',
        gridAutoRows: 'max-content auto max-content',
        [`& .${(0, $c07708fe38f3f8a0$export$7a6dac186703fe4c).toolbar}`]: ownerState.isLandscape ? {
            gridColumn: theme.direction === 'rtl' ? 3 : 1,
            gridRow: '2 / 3'
        } : {
            gridColumn: '2 / 4',
            gridRow: 1
        },
        [`.${(0, $c07708fe38f3f8a0$export$7a6dac186703fe4c).shortcuts}`]: ownerState.isLandscape ? {
            gridColumn: '2 / 4',
            gridRow: 1
        } : {
            gridColumn: theme.direction === 'rtl' ? 3 : 1,
            gridRow: '2 / 3'
        },
        [`& .${(0, $c07708fe38f3f8a0$export$7a6dac186703fe4c).actionBar}`]: {
            gridColumn: '1 / 4',
            gridRow: 3
        }
    }));
$1d0bfa2a9296ecf7$export$9a9363506c13836.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).shape({
        isLandscape: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool.isRequired
    }).isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object
    ])
};
const $1d0bfa2a9296ecf7$export$bc1494d918129235 = (0, $jH1k7.default)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper',
    overridesResolver: (props, styles)=>styles.contentWrapper
})({
    gridColumn: 2,
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
const $1d0bfa2a9296ecf7$export$647f604ea2397c05 = function PickersLayout(inProps) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts } = (0, $dbdbd09c9da8745d$export$2e2bcd8739ae039)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, ref: ref, wrapperVariant: wrapperVariant } = props;
    const ownerState = props;
    const classes = $1d0bfa2a9296ecf7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($1d0bfa2a9296ecf7$export$9a9363506c13836, {
        ref: ref,
        sx: sx,
        className: (0, $3DmQB.default)(className, classes.root),
        ownerState: ownerState,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $2M70Q.jsx)($1d0bfa2a9296ecf7$export$bc1494d918129235, {
                className: classes.contentWrapper,
                children: wrapperVariant === 'desktop' ? /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
};



var $2M70Q = parcelRequire("2M70Q");
const $bc32b77511da4487$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
], $bc32b77511da4487$var$_excluded2 = [
    "ownerState"
], $bc32b77511da4487$var$_excluded3 = [
    "ownerState"
];
const $bc32b77511da4487$export$b1b70bc56ac5be0e = (_ref)=>{
    var _innerSlotProps$toolb, _innerSlotProps$toolb2, _slots$inputAdornment, _slots$openPickerButt, _slots$layout;
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $aBenZ.default)(_ref, $bc32b77511da4487$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, timezone: timezone, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, autoFocus: autoFocus, localeText: localeText, reduceAnimations: reduceAnimations } = props;
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const internalInputRef = $3OyDL.useRef(null);
    const containerRef = $3OyDL.useRef(null);
    const labelId = (0, $da50f700e88904fb$export$2e2bcd8739ae039)();
    const isToolbarHidden = (_innerSlotProps$toolb = innerSlotProps == null || (_innerSlotProps$toolb2 = innerSlotProps.toolbar) == null ? void 0 : _innerSlotProps$toolb2.hidden) != null ? _innerSlotProps$toolb : false;
    const { open: open, actions: actions, hasUIView: hasUIView, layoutProps: layoutProps, renderCurrentView: renderCurrentView, shouldRestoreFocus: shouldRestoreFocus, fieldProps: pickerFieldProps } = (0, $4e4f7729fec91532$export$fc3313977ac596c4)((0, $gOPoC.default)({}, pickerParams, {
        props: props,
        inputRef: internalInputRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: 'desktop'
    }));
    const InputAdornment = (_slots$inputAdornment = slots.inputAdornment) != null ? _slots$inputAdornment : (0, $251953dff96397bc$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: InputAdornment,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.inputAdornment,
        additionalProps: {
            position: 'end'
        },
        ownerState: props
    }), inputAdornmentProps = (0, $aBenZ.default)(_useSlotProps, $bc32b77511da4487$var$_excluded2);
    const OpenPickerButton = (_slots$openPickerButt = slots.openPickerButton) != null ? _slots$openPickerButt : (0, $90c0807a34b52605$export$2e2bcd8739ae039);
    const _useSlotProps2 = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: OpenPickerButton,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.openPickerButton,
        additionalProps: {
            disabled: disabled || readOnly,
            onClick: open ? actions.onClose : actions.onOpen,
            'aria-label': getOpenDialogAriaText(pickerFieldProps.value, utils),
            edge: inputAdornmentProps.position
        },
        ownerState: props
    }), openPickerButtonProps = (0, $aBenZ.default)(_useSlotProps2, $bc32b77511da4487$var$_excluded3);
    const OpenPickerIcon = slots.openPickerIcon;
    const Field = slots.field;
    const fieldProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.field,
        additionalProps: (0, $gOPoC.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, {
            readOnly: readOnly,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            timezone: timezone,
            label: label,
            autoFocus: autoFocus && !props.open,
            focused: open ? true : undefined
        }),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    if (hasUIView) fieldProps.InputProps = (0, $gOPoC.default)({}, fieldProps.InputProps, {
        ref: containerRef,
        [`${inputAdornmentProps.position}Adornment`]: /*#__PURE__*/ (0, $2M70Q.jsx)(InputAdornment, (0, $gOPoC.default)({}, inputAdornmentProps, {
            children: /*#__PURE__*/ (0, $2M70Q.jsx)(OpenPickerButton, (0, $gOPoC.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $2M70Q.jsx)(OpenPickerIcon, (0, $gOPoC.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.openPickerIcon))
            }))
        }))
    });
    const slotsForField = (0, $gOPoC.default)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = (_slots$layout = slots.layout) != null ? _slots$layout : (0, $1d0bfa2a9296ecf7$export$647f604ea2397c05);
    const handleInputRef = (0, $a0093ef70e9dc99d$export$2e2bcd8739ae039)(internalInputRef, fieldProps.inputRef, inputRef);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $gOPoC.default)({}, innerSlotProps, {
        toolbar: (0, $gOPoC.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.toolbar, {
            titleId: labelId
        }),
        popper: (0, $gOPoC.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps == null ? void 0 : innerSlotProps.popper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $0dca6c5826980612$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)(Field, (0, $gOPoC.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    inputRef: handleInputRef
                })),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $da98bf67df64ceef$export$96ce8482474de8a5), (0, $gOPoC.default)({
                    role: "dialog",
                    placement: "bottom-start",
                    anchorEl: containerRef.current
                }, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    shouldRestoreFocus: shouldRestoreFocus,
                    reduceAnimations: reduceAnimations,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)(Layout, (0, $gOPoC.default)({}, layoutProps, slotProps == null ? void 0 : slotProps.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};



var $agWwT = parcelRequire("agWwT");

var $3OyDL = parcelRequire("3OyDL");

var $2M70Q = parcelRequire("2M70Q");
const $77fe2edc650c8e6d$export$ed0fe318cc298673 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
const $77fe2edc650c8e6d$export$8afed21ef5c2afa5 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
const $77fe2edc650c8e6d$export$9ca09caa9c849d9c = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
const $77fe2edc650c8e6d$export$5fda1783bb83f57b = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
const $77fe2edc650c8e6d$export$8099ab97743c966c = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
    children: [
        /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
const $77fe2edc650c8e6d$export$90a8eab2a2411720 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
const $77fe2edc650c8e6d$export$7e95adcf912503e3 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
    children: [
        /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");



var $jFgmT = parcelRequire("jFgmT");



var $gOPoC = parcelRequire("gOPoC");


var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");








var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");






const $3a446c27f85a8681$export$4e8d6353e50062e7 = (params)=>{
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const adapter = (0, $aa5fe19dd76d6423$export$4b5a24245de9f7f9)();
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const { valueManager: valueManager, fieldValueManager: fieldValueManager, valueType: valueType, validator: validator, internalProps: internalProps, internalProps: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp } } = params;
    const { timezone: timezone, value: valueFromTheOutside, handleValueChange: handleValueChange } = (0, $c1a1b9e58f0b723e$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    const sectionsValueBoundaries = $3OyDL.useMemo(()=>(0, $93ec44f7cf837915$export$360600f456ea7d5f)(utils, timezone), [
        utils,
        timezone
    ]);
    const getSectionsFromValue = $3OyDL.useCallback((value, fallbackSections = null)=>fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, isRTL, (date)=>(0, $93ec44f7cf837915$export$fd71d82fe42bada1)(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL)), [
        fieldValueManager,
        format,
        localeText,
        isRTL,
        shouldRespectLeadingZeros,
        utils,
        formatDensity,
        timezone
    ]);
    const placeholder = $3OyDL.useMemo(()=>fieldValueManager.getValueStrFromSections(getSectionsFromValue(valueManager.emptyValue), isRTL), [
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        isRTL
    ]);
    const [state, setState] = $3OyDL.useState(()=>{
        const sections = getSectionsFromValue(valueFromTheOutside);
        (0, $93ec44f7cf837915$export$ef6fbc09372bd65c)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            value: valueFromTheOutside,
            referenceValue: valueManager.emptyValue,
            tempValueStrAndroid: null
        };
        const granularity = (0, $296cf343c750d880$export$3f2547ddf892237a)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: valueFromTheOutside,
            utils: utils,
            props: internalProps,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $gOPoC.default)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $3bd2ff427a59ae77$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSectionIndexes'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
        setState((prevState)=>(0, $gOPoC.default)({}, prevState, {
                selectedSectionQuery: null
            }));
    };
    const selectedSectionIndexes = $3OyDL.useMemo(()=>{
        if (selectedSections == null) return null;
        if (selectedSections === 'all') return {
            startIndex: 0,
            endIndex: state.sections.length - 1,
            shouldSelectBoundarySelectors: true
        };
        if (typeof selectedSections === 'number') return {
            startIndex: selectedSections,
            endIndex: selectedSections
        };
        if (typeof selectedSections === 'string') {
            const selectedSectionIndex = state.sections.findIndex((section)=>section.type === selectedSections);
            return {
                startIndex: selectedSectionIndex,
                endIndex: selectedSectionIndex
            };
        }
        return selectedSections;
    }, [
        selectedSections,
        state.sections
    ]);
    const publishValue = ({ value: value, referenceValue: referenceValue, sections: sections })=>{
        setState((prevState)=>(0, $gOPoC.default)({}, prevState, {
                sections: sections,
                value: value,
                referenceValue: referenceValue,
                tempValueStrAndroid: null
            }));
        const context = {
            validationError: validator({
                adapter: adapter,
                value: value,
                props: (0, $gOPoC.default)({}, internalProps, {
                    value: value,
                    timezone: timezone
                })
            })
        };
        handleValueChange(value, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $gOPoC.default)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return (0, $93ec44f7cf837915$export$8bb5d1c9951d10ca)(newSections, isRTL);
    };
    const clearValue = ()=>{
        if (valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue)) return;
        publishValue({
            value: valueManager.emptyValue,
            referenceValue: state.referenceValue,
            sections: getSectionsFromValue(valueManager.emptyValue)
        });
    };
    const clearActiveSection = ()=>{
        if (selectedSectionIndexes == null) return;
        const activeSection = state.sections[selectedSectionIndexes.startIndex];
        if (activeSection.value === '') return;
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter((section)=>section.value !== '').length;
        const isTheOnlyNonEmptySection = nonEmptySectionCountBefore === 1;
        const newSections = setSectionValue(selectedSectionIndexes.startIndex, '');
        const newActiveDate = isTheOnlyNonEmptySection ? null : utils.date(new Date(''));
        const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
        if ((newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date))) publishValue((0, $gOPoC.default)({}, newValues, {
            sections: newSections
        }));
        else setState((prevState)=>(0, $gOPoC.default)({}, prevState, newValues, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = utils.parse(dateStr, format);
            if (date == null || !utils.isValid(date)) return null;
            const sections = (0, $93ec44f7cf837915$export$fd71d82fe42bada1)(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL);
            return (0, $93ec44f7cf837915$export$6c6df982c77f60a9)(utils, timezone, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
        publishValue({
            value: newValue,
            referenceValue: newReferenceValue,
            sections: getSectionsFromValue(newValue, state.sections)
        });
    };
    const updateSectionValue = ({ activeSection: activeSection, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        /**
     * 1. Decide which section should be focused
     */ if (shouldGoToNextSection && selectedSectionIndexes && selectedSectionIndexes.startIndex < state.sections.length - 1) setSelectedSections(selectedSectionIndexes.startIndex + 1);
        else if (selectedSectionIndexes && selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.startIndex);
        /**
     * 2. Try to build a valid date from the new section value
     */ const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const newSections = setSectionValue(selectedSectionIndexes.startIndex, newSectionValue);
        const newActiveDateSections = activeDateManager.getSections(newSections);
        const newActiveDate = (0, $93ec44f7cf837915$export$b0c1bfd065bfe742)(utils, newActiveDateSections);
        let values;
        let shouldPublish;
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (newActiveDate != null && utils.isValid(newActiveDate)) {
            const mergedDate = (0, $93ec44f7cf837915$export$6c6df982c77f60a9)(utils, timezone, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
            values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
            shouldPublish = true;
        } else {
            values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
            shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
        }
        /**
     * Publish or update the internal state with the new value and sections.
     */ if (shouldPublish) return publishValue((0, $gOPoC.default)({}, values, {
            sections: newSections
        }));
        return setState((prevState)=>(0, $gOPoC.default)({}, prevState, values, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prev)=>(0, $gOPoC.default)({}, prev, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    $3OyDL.useEffect(()=>{
        const sections = getSectionsFromValue(state.value);
        (0, $93ec44f7cf837915$export$ef6fbc09372bd65c)(sections, valueType);
        setState((prevState)=>(0, $gOPoC.default)({}, prevState, {
                sections: sections
            }));
    }, [
        format,
        utils.locale
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $3OyDL.useEffect(()=>{
        let shouldUpdate = false;
        if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) shouldUpdate = true;
        else shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
        if (shouldUpdate) setState((prevState)=>(0, $gOPoC.default)({}, prevState, {
                value: valueFromTheOutside,
                referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
                sections: getSectionsFromValue(valueFromTheOutside)
            }));
    }, [
        valueFromTheOutside
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        state: state,
        selectedSectionIndexes: selectedSectionIndexes,
        setSelectedSections: setSelectedSections,
        clearValue: clearValue,
        clearActiveSection: clearActiveSection,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        setTempAndroidValueStr: setTempAndroidValueStr,
        sectionsValueBoundaries: sectionsValueBoundaries,
        placeholder: placeholder,
        timezone: timezone
    };
};



var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");



/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ const $027b381f3eca160a$var$QUERY_LIFE_DURATION_MS = 5000;
const $027b381f3eca160a$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $027b381f3eca160a$export$66d00048b8bb82f6 = ({ sections: sections, updateSectionValue: updateSectionValue, sectionsValueBoundaries: sectionsValueBoundaries, setTempAndroidValueStr: setTempAndroidValueStr, timezone: timezone })=>{
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const [query, setQuery] = $3OyDL.useState(null);
    const resetQuery = (0, $09ed1aada0557388$export$2e2bcd8739ae039)(()=>setQuery(null));
    $3OyDL.useEffect(()=>{
        var _sections$query$secti;
        if (query != null && ((_sections$query$secti = sections[query.sectionIndex]) == null ? void 0 : _sections$query$secti.type) !== query.sectionType) resetQuery();
    }, [
        sections,
        query,
        resetQuery
    ]);
    $3OyDL.useEffect(()=>{
        if (query != null) {
            const timeout = setTimeout(()=>resetQuery(), $027b381f3eca160a$var$QUERY_LIFE_DURATION_MS);
            return ()=>{
                window.clearTimeout(timeout);
            };
        }
        return ()=>{};
    }, [
        query,
        resetQuery
    ]);
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenated value
        if (query != null && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$027b381f3eca160a$var$isQueryResponseWithoutValue(queryResponse)) {
                setQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($027b381f3eca160a$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            resetQuery();
            return null;
        }
        setQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($027b381f3eca160a$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $93ec44f7cf837915$export$3ee1e7e19c2b047a)(utils, timezone, activeSection.type, format);
            if (activeSection.contentType === 'letter') return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $93ec44f7cf837915$export$2f3c5fac7a2a65f6)(utils, fallbackFormat).contentType === 'letter') {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($027b381f3eca160a$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $gOPoC.default)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $93ec44f7cf837915$export$2816862a602354ce)(utils, fallbackValue, utils.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = (queryValue, section)=>{
            const queryValueNumber = Number(`${queryValue}`);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = Number(`${queryValue}0`) > sectionBoundaries.maximum || queryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $93ec44f7cf837915$export$ef88db4bceade9fd)(utils, timezone, queryValueNumber, sectionBoundaries, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') return getNewSectionValue(queryValue, activeSection);
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === 'month') {
                const hasLeadingZerosInFormat = (0, $93ec44f7cf837915$export$78b5830e2dd2de49)(utils, timezone, 'digit', 'month', 'MM');
                const response = getNewSectionValue(queryValue, {
                    type: activeSection.type,
                    format: 'MM',
                    hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                    hasLeadingZerosInInput: true,
                    contentType: 'digit',
                    maxLength: 2
                });
                if ($027b381f3eca160a$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $93ec44f7cf837915$export$2816862a602354ce)(utils, response.sectionValue, 'MM', activeSection.format);
                return (0, $gOPoC.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === 'weekDay') {
                const response = getNewSectionValue(queryValue, activeSection);
                if ($027b381f3eca160a$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $93ec44f7cf837915$export$c65c7173f879039f)(utils, timezone, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $gOPoC.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>!Number.isNaN(Number(queryValue)));
    };
    const applyCharacterEditing = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((params)=>{
        const activeSection = sections[params.sectionIndex];
        const isNumericEditing = !Number.isNaN(Number(params.keyPressed));
        const response = isNumericEditing ? applyNumericEditing(params) : applyLetterEditing(params);
        if (response == null) setTempAndroidValueStr(null);
        else updateSectionValue({
            activeSection: activeSection,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
    return {
        applyCharacterEditing: applyCharacterEditing,
        resetCharacterQuery: resetQuery
    };
};



const $4d47b8bcbcea9404$var$_excluded = [
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onMouseUp",
    "onPaste",
    "error"
];
const $4d47b8bcbcea9404$export$294aa081a6c6f55d = (params)=>{
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const { state: state, selectedSectionIndexes: selectedSectionIndexes, setSelectedSections: setSelectedSections, clearValue: clearValue, clearActiveSection: clearActiveSection, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, setTempAndroidValueStr: setTempAndroidValueStr, sectionsValueBoundaries: sectionsValueBoundaries, placeholder: placeholder, timezone: timezone } = (0, $3a446c27f85a8681$export$4e8d6353e50062e7)(params);
    const { inputRef: inputRefProp, internalProps: internalProps, internalProps: { readOnly: readOnly = false, unstableFieldRef: unstableFieldRef, minutesStep: minutesStep }, forwardedProps: { onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, onMouseUp: onMouseUp, onPaste: onPaste, error: error }, fieldValueManager: fieldValueManager, valueManager: valueManager, validator: validator } = params, otherForwardedProps = (0, $aBenZ.default)(params.forwardedProps, $4d47b8bcbcea9404$var$_excluded);
    const { applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery } = (0, $027b381f3eca160a$export$66d00048b8bb82f6)({
        sections: state.sections,
        updateSectionValue: updateSectionValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        setTempAndroidValueStr: setTempAndroidValueStr,
        timezone: timezone
    });
    const inputRef = $3OyDL.useRef(null);
    const handleRef = (0, $a0093ef70e9dc99d$export$2e2bcd8739ae039)(inputRefProp, inputRef);
    const focusTimeoutRef = $3OyDL.useRef(undefined);
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const sectionOrder = $3OyDL.useMemo(()=>(0, $93ec44f7cf837915$export$7725fd6fe0a2aadf)(state.sections, isRTL), [
        state.sections,
        isRTL
    ]);
    const syncSelectionFromDOM = ()=>{
        var _selectionStart;
        if (readOnly) {
            setSelectedSections(null);
            return;
        }
        const browserStartIndex = (_selectionStart = inputRef.current.selectionStart) != null ? _selectionStart : 0;
        let nextSectionIndex;
        if (browserStartIndex <= state.sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= state.sections[state.sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = state.sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    };
    const handleInputClick = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((...args)=>{
        onClick == null || onClick(...args);
        syncSelectionFromDOM();
    });
    const handleInputMouseUp = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event)=>{
        onMouseUp == null || onMouseUp(event);
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const handleInputFocus = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((...args)=>{
        onFocus == null || onFocus(...args);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        window.clearTimeout(focusTimeoutRef.current);
        focusTimeoutRef.current = setTimeout(()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (selectedSectionIndexes != null || readOnly) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections('all');
            else syncSelectionFromDOM();
        });
    });
    const handleInputBlur = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((...args)=>{
        onBlur == null || onBlur(...args);
        setSelectedSections(null);
    });
    const handleInputPaste = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event)=>{
        onPaste == null || onPaste(event);
        if (readOnly) {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData('text');
        if (selectedSectionIndexes && selectedSectionIndexes.startIndex === selectedSectionIndexes.endIndex) {
            const activeSection = state.sections[selectedSectionIndexes.startIndex];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
            if (isValidPastedValue) // Early return to let the paste update section, value
            return;
            if (lettersOnly || digitsOnly) {
                // The pasted value correspond to a single section but not the expected type
                // skip the modification
                event.preventDefault();
                return;
            }
        }
        event.preventDefault();
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleInputChange = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = (0, $93ec44f7cf837915$export$cb0bbc88c7f09596)(valueStr);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (selectedSectionIndexes == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1 && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = (0, $93ec44f7cf837915$export$cb0bbc88c7f09596)(fieldValueManager.getValueStrFromSections(state.sections, isRTL));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = state.sections[selectedSectionIndexes.startIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - (0, $93ec44f7cf837915$export$cb0bbc88c7f09596)(activeSection.endSeparator || '').length;
            keyPressed = cleanValueStr.slice(activeSection.start + (0, $93ec44f7cf837915$export$cb0bbc88c7f09596)(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
        }
        if ((0, $93ec44f7cf837915$export$a11b0059900ceec8)() && keyPressed.length === 0) {
            setTempAndroidValueStr(valueStr);
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: selectedSectionIndexes.startIndex
        });
    });
    const handleInputKeyDown = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event)=>{
        onKeyDown == null || onKeyDown(event);
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case event.key === 'a' && (event.ctrlKey || event.metaKey):
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections('all');
                break;
            // Move selection to next section
            case event.key === 'ArrowRight':
                event.preventDefault();
                if (selectedSectionIndexes == null) setSelectedSections(sectionOrder.startIndex);
                else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === 'ArrowLeft':
                event.preventDefault();
                if (selectedSectionIndexes == null) setSelectedSections(sectionOrder.endIndex);
                else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case [
                'Backspace',
                'Delete'
            ].includes(event.key):
                event.preventDefault();
                if (readOnly) break;
                if (selectedSectionIndexes == null || selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1) clearValue();
                else clearActiveSection();
                resetCharacterQuery();
                break;
            // Increment / decrement the selected section value
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || selectedSectionIndexes == null) break;
                    const activeSection = state.sections[selectedSectionIndexes.startIndex];
                    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
                    const newSectionValue = (0, $93ec44f7cf837915$export$5ed0f22513e58fe3)(utils, timezone, activeSection, event.key, sectionsValueBoundaries, activeDateManager.date, {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        activeSection: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
    (0, $54812c32efbf145d$export$2e2bcd8739ae039)(()=>{
        if (!inputRef.current) return;
        if (selectedSectionIndexes == null) {
            if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
            // setting selection range to 0 causes issues in Safari.
            // https://bugs.webkit.org/show_bug.cgi?id=224425
            inputRef.current.scrollLeft = 0;
            return;
        }
        const firstSelectedSection = state.sections[selectedSectionIndexes.startIndex];
        const lastSelectedSection = state.sections[selectedSectionIndexes.endIndex];
        let selectionStart = firstSelectedSection.startInInput;
        let selectionEnd = lastSelectedSection.endInInput;
        if (selectedSectionIndexes.shouldSelectBoundarySelectors) {
            selectionStart -= firstSelectedSection.startSeparator.length;
            selectionEnd += lastSelectedSection.endSeparator.length;
        }
        if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
            // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
            const currentScrollTop = inputRef.current.scrollTop;
            // On multi input range pickers we want to update selection range only for the active input
            // This helps avoiding the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
            // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
            if (inputRef.current === (0, $c744f6b99d4ca951$export$cd4e5573fbe2b576)(document)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
            // Even reading this variable seems to do the trick, but also setting it just to make use of it
            inputRef.current.scrollTop = currentScrollTop;
        }
    });
    const validationError = (0, $0801d7d4ea653bc3$export$87fe492f99f25a20)((0, $gOPoC.default)({}, internalProps, {
        value: state.value,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const inputError = $3OyDL.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (error !== undefined) return error;
        return valueManager.hasError(validationError);
    }, [
        valueManager,
        validationError,
        error
    ]);
    $3OyDL.useEffect(()=>{
        if (!inputError && !selectedSectionIndexes) resetCharacterQuery();
    }, [
        state.referenceValue,
        selectedSectionIndexes,
        inputError
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $3OyDL.useEffect(()=>{
        // Select the right section when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === document.activeElement) setSelectedSections('all');
        return ()=>window.clearTimeout(focusTimeoutRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // If `state.tempValueStrAndroid` is still defined when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $3OyDL.useEffect(()=>{
        if (state.tempValueStrAndroid != null && selectedSectionIndexes != null) {
            resetCharacterQuery();
            clearActiveSection();
        }
    }, [
        state.tempValueStrAndroid
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const valueStr = $3OyDL.useMemo(()=>{
        var _state$tempValueStrAn;
        return (_state$tempValueStrAn = state.tempValueStrAndroid) != null ? _state$tempValueStrAn : fieldValueManager.getValueStrFromSections(state.sections, isRTL);
    }, [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        isRTL
    ]);
    const inputMode = $3OyDL.useMemo(()=>{
        if (selectedSectionIndexes == null) return 'text';
        if (state.sections[selectedSectionIndexes.startIndex].contentType === 'letter') return 'text';
        return 'numeric';
    }, [
        selectedSectionIndexes,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $c744f6b99d4ca951$export$cd4e5573fbe2b576)(document);
    const shouldShowPlaceholder = !inputHasFocus && valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
    $3OyDL.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>{
                var _selectionStart2, _selectionEnd;
                const browserStartIndex = (_selectionStart2 = inputRef.current.selectionStart) != null ? _selectionStart2 : 0;
                const browserEndIndex = (_selectionEnd = inputRef.current.selectionEnd) != null ? _selectionEnd : 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= state.sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : state.sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
            },
            setSelectedSections: (activeSectionIndex)=>setSelectedSections(activeSectionIndex)
        }));
    return (0, $gOPoC.default)({
        placeholder: placeholder,
        autoComplete: 'off'
    }, otherForwardedProps, {
        value: shouldShowPlaceholder ? '' : valueStr,
        inputMode: inputMode,
        readOnly: readOnly,
        onClick: handleInputClick,
        onFocus: handleInputFocus,
        onBlur: handleInputBlur,
        onPaste: handleInputPaste,
        onChange: handleInputChange,
        onKeyDown: handleInputKeyDown,
        onMouseUp: handleInputMouseUp,
        error: inputError,
        ref: handleRef
    });
};






var $gOPoC = parcelRequire("gOPoC");
const $6899e10b900e4274$export$430d9fc64cf058d6 = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const $6899e10b900e4274$export$fd5e0f8b4115a8c7 = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableClock',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const $6899e10b900e4274$export$1df62d3ba2121371 = [
    'minDateTime',
    'maxDateTime'
];
const $6899e10b900e4274$var$VALIDATION_PROP_NAMES = [
    ...$6899e10b900e4274$export$430d9fc64cf058d6,
    ...$6899e10b900e4274$export$fd5e0f8b4115a8c7,
    ...$6899e10b900e4274$export$1df62d3ba2121371
];
const $6899e10b900e4274$export$5890f750904acddb = (props)=>$6899e10b900e4274$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});


const $0325b003561ddae0$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'readOnly',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'unstableFieldRef'
];
const $0325b003561ddae0$export$cdde224d2939fd84 = (props, valueType)=>{
    const forwardedProps = (0, $gOPoC.default)({}, props);
    const internalProps = {};
    const extractProp = (propName)=>{
        if (forwardedProps.hasOwnProperty(propName)) {
            // @ts-ignore
            internalProps[propName] = forwardedProps[propName];
            delete forwardedProps[propName];
        }
    };
    $0325b003561ddae0$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
    if (valueType === 'date') (0, $6899e10b900e4274$export$430d9fc64cf058d6).forEach(extractProp);
    else if (valueType === 'time') (0, $6899e10b900e4274$export$fd5e0f8b4115a8c7).forEach(extractProp);
    else if (valueType === 'date-time') {
        (0, $6899e10b900e4274$export$430d9fc64cf058d6).forEach(extractProp);
        (0, $6899e10b900e4274$export$fd5e0f8b4115a8c7).forEach(extractProp);
        (0, $6899e10b900e4274$export$1df62d3ba2121371).forEach(extractProp);
    }
    return {
        forwardedProps: forwardedProps,
        internalProps: internalProps
    };
};


const $756e64d0e493a05b$var$useDefaultizedDateField = (props)=>{
    var _props$disablePast, _props$disableFuture, _props$format;
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const defaultDates = (0, $aa5fe19dd76d6423$export$7c38da3a2e90fa83)();
    return (0, $gOPoC.default)({}, props, {
        disablePast: (_props$disablePast = props.disablePast) != null ? _props$disablePast : false,
        disableFuture: (_props$disableFuture = props.disableFuture) != null ? _props$disableFuture : false,
        format: (_props$format = props.format) != null ? _props$format : utils.formats.keyboardDate,
        minDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, props.minDate, defaultDates.minDate),
        maxDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, props.maxDate, defaultDates.maxDate)
    });
};
const $756e64d0e493a05b$export$5591b0b878c1a989 = ({ props: inProps, inputRef: inputRef })=>{
    const props = $756e64d0e493a05b$var$useDefaultizedDateField(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $0325b003561ddae0$export$cdde224d2939fd84)(props, 'date');
    return (0, $4d47b8bcbcea9404$export$294aa081a6c6f55d)({
        inputRef: inputRef,
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $286007e7644aad7a$export$2764b246aa3b75ba),
        fieldValueManager: (0, $286007e7644aad7a$export$b602c94f557316b4),
        validator: (0, $709ab20d38d8c90a$export$ffb3d0046ef3a2),
        valueType: 'date'
    });
};



var $2M70Q = parcelRequire("2M70Q");
const $9e0a703a8327f82d$var$_excluded = [
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
], $9e0a703a8327f82d$var$_excluded2 = [
    "inputRef"
], $9e0a703a8327f82d$var$_excluded3 = [
    "ref",
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly"
];
const $9e0a703a8327f82d$export$d9781c7894a82487 = /*#__PURE__*/ $3OyDL.forwardRef(function DateField(inProps, ref) {
    var _ref, _slots$textField, _slotProps$textField;
    const themeProps = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDateField'
    });
    const { components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $aBenZ.default)(themeProps, $9e0a703a8327f82d$var$_excluded);
    const ownerState = themeProps;
    const TextField = (_ref = (_slots$textField = slots == null ? void 0 : slots.textField) != null ? _slots$textField : components == null ? void 0 : components.TextField) != null ? _ref : (0, $328e9bc68740648b$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: TextField,
        externalSlotProps: (_slotProps$textField = slotProps == null ? void 0 : slotProps.textField) != null ? _slotProps$textField : componentsProps == null ? void 0 : componentsProps.textField,
        externalForwardedProps: other,
        ownerState: ownerState
    }), { inputRef: externalInputRef } = _useSlotProps, textFieldProps = (0, $aBenZ.default)(_useSlotProps, $9e0a703a8327f82d$var$_excluded2);
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $gOPoC.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $gOPoC.default)({}, InputProps, textFieldProps.InputProps);
    const _useDateField = (0, $756e64d0e493a05b$export$5591b0b878c1a989)({
        props: textFieldProps,
        inputRef: externalInputRef
    }), { ref: inputRef, onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly } = _useDateField, fieldProps = (0, $aBenZ.default)(_useDateField, $9e0a703a8327f82d$var$_excluded3);
    return /*#__PURE__*/ (0, $2M70Q.jsx)(TextField, (0, $gOPoC.default)({
        ref: ref
    }, fieldProps, {
        InputProps: (0, $gOPoC.default)({}, fieldProps.InputProps, {
            readOnly: readOnly
        }),
        inputProps: (0, $gOPoC.default)({}, fieldProps.inputProps, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    }));
});



parcelRequire("3OyDL");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");


var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3OyDL = parcelRequire("3OyDL");


const $48c4a3d2631d9b8b$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $aa5fe19dd76d6423$export$4b5a24245de9f7f9)();
    return $3OyDL.useCallback((day)=>(0, $709ab20d38d8c90a$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: day,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast,
                timezone: timezone
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};





const $77e1db9ff9240c30$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case 'changeMonth':
                return (0, $gOPoC.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case 'finishMonthSwitchingAnimation':
                return (0, $gOPoC.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case 'changeFocusedDay':
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $gOPoC.default)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
                    });
                }
            default:
                throw new Error('missing support');
        }
    };
const $77e1db9ff9240c30$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, defaultCalendarMonth: defaultCalendarMonth, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone } = params;
    const now = (0, $aa5fe19dd76d6423$export$3a404aece3dff2fa)(timezone);
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const reducerFn = $3OyDL.useRef($77e1db9ff9240c30$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const referenceDate = $3OyDL.useMemo(()=>{
        let externalReferenceDate = null;
        if (referenceDateProp) externalReferenceDate = referenceDateProp;
        else if (defaultCalendarMonth) // For `defaultCalendarMonth`, we just want to keep the month and the year to avoid a behavior change.
        externalReferenceDate = utils.startOfMonth(defaultCalendarMonth);
        return (0, $286007e7644aad7a$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            timezone: timezone,
            props: params,
            referenceDate: externalReferenceDate,
            granularity: (0, $296cf343c750d880$export$8f74e8f4ed8ae0ac).day
        });
    }, [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const [calendarState, dispatch] = $3OyDL.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: value || now,
        currentMonth: utils.startOfMonth(referenceDate),
        slideDirection: 'left'
    });
    const handleChangeMonth = $3OyDL.useCallback((payload)=>{
        dispatch((0, $gOPoC.default)({
            type: 'changeMonth'
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $3OyDL.useCallback((newDate)=>{
        const newDateRequested = newDate;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        utils
    ]);
    const isDateDisabled = (0, $48c4a3d2631d9b8b$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    const onMonthSwitchingAnimationEnd = $3OyDL.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    const changeFocusedDay = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: 'changeFocusedDay',
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation: withoutMonthSwitchingAnimation
        });
    });
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
};



parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");


var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");



const $026a68d7e7b65cfc$export$5b0bb0174eb448ca = (slot)=>(0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiPickersFadeTransitionGroup', slot);
const $026a68d7e7b65cfc$export$1461f245817ac559 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiPickersFadeTransitionGroup', [
    'root'
]);



var $2M70Q = parcelRequire("2M70Q");
const $db8717935695594d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $026a68d7e7b65cfc$export$5b0bb0174eb448ca), classes);
};
const $db8717935695594d$var$animationDuration = 500;
const $db8717935695594d$var$PickersFadeTransitionGroupRoot = (0, $jH1k7.default)((0, $08574b535870a4c0$export$2e2bcd8739ae039), {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'block',
    position: 'relative'
});
function $db8717935695594d$export$5262185daf493fee(inProps) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props;
    const classes = $db8717935695594d$var$useUtilityClasses(props);
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $2M70Q.jsx)($db8717935695594d$var$PickersFadeTransitionGroupRoot, {
        className: (0, $3DmQB.default)(classes.root, className),
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9c9203b21cd916fe$export$2e2bcd8739ae039), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: $db8717935695594d$var$animationDuration,
                enter: $db8717935695594d$var$animationDuration / 2,
                exit: 0
            },
            children: children
        }, transKey)
    });
}



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");




var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");


var $3DmQB = parcelRequire("3DmQB");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");



var $7m2iU = parcelRequire("7m2iU");
var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");



function $16dc3bb9dcec76f1$export$4b25deb0350d3e53(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiPickersDay', slot);
}
const $16dc3bb9dcec76f1$export$68b221ad3c35e288 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);



var $2M70Q = parcelRequire("2M70Q");
const $8c828728b8f83f18$var$_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const $8c828728b8f83f18$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, disabled: disabled, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            'root',
            selected && !isHiddenDaySpacingFiller && 'selected',
            disabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && today && 'today',
            outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $16dc3bb9dcec76f1$export$4b25deb0350d3e53), classes);
};
const $8c828728b8f83f18$var$styleArg = ({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({}, theme.typography.caption, {
        width: (0, $c8ed6f2a54427aa9$export$3f0060ce4cc8f4d0),
        height: (0, $c8ed6f2a54427aa9$export$3f0060ce4cc8f4d0),
        borderRadius: '50%',
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: 'transparent',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, $16dc3bb9dcec76f1$export$68b221ad3c35e288).selected}`]: {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $16dc3bb9dcec76f1$export$68b221ad3c35e288).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $16dc3bb9dcec76f1$export$68b221ad3c35e288).disabled}:not(.${(0, $16dc3bb9dcec76f1$export$68b221ad3c35e288).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $16dc3bb9dcec76f1$export$68b221ad3c35e288).disabled}&.${(0, $16dc3bb9dcec76f1$export$68b221ad3c35e288).selected}`]: {
            opacity: 0.6
        }
    }, !ownerState.disableMargin && {
        margin: `0 ${0, $c8ed6f2a54427aa9$export$dde58b009b497666}px`
    }, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableHighlightToday && ownerState.today && {
        [`&:not(.${(0, $16dc3bb9dcec76f1$export$68b221ad3c35e288).selected})`]: {
            border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
        }
    });
const $8c828728b8f83f18$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $8c828728b8f83f18$var$PickersDayRoot = (0, $jH1k7.default)((0, $c582f66505800c92$export$2e2bcd8739ae039), {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $8c828728b8f83f18$var$overridesResolver
})($8c828728b8f83f18$var$styleArg);
const $8c828728b8f83f18$var$PickersDayFiller = (0, $jH1k7.default)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $8c828728b8f83f18$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({}, $8c828728b8f83f18$var$styleArg({
        theme: theme,
        ownerState: ownerState
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: 'none'
    }));
const $8c828728b8f83f18$var$noop = ()=>{};
const $8c828728b8f83f18$var$PickersDayRaw = /*#__PURE__*/ $3OyDL.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $8c828728b8f83f18$var$noop, onBlur: onBlur = $8c828728b8f83f18$var$noop, onKeyDown: onKeyDown = $8c828728b8f83f18$var$noop, onMouseDown: onMouseDown = $8c828728b8f83f18$var$noop, onMouseEnter: onMouseEnter = $8c828728b8f83f18$var$noop, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $aBenZ.default)(props, $8c828728b8f83f18$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $8c828728b8f83f18$var$useUtilityClasses(ownerState);
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const ref = $3OyDL.useRef(null);
    const handleRef = (0, $a0093ef70e9dc99d$export$2e2bcd8739ae039)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $54812c32efbf145d$export$2e2bcd8739ae039)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For day outside of current month, move focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $2M70Q.jsx)($8c828728b8f83f18$var$PickersDayFiller, {
        className: (0, $3DmQB.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)($8c828728b8f83f18$var$PickersDayRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: !children ? utils.format(day, 'dayOfMonth') : children
    }));
});
const $8c828728b8f83f18$export$d7378e6e864346fa = /*#__PURE__*/ $3OyDL.memo($8c828728b8f83f18$var$PickersDayRaw);





var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");

var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");


var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $jNtCy = parcelRequire("jNtCy");

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $6b91458ca5284d66$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $238c0f2b7ec49435$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $6b91458ca5284d66$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $a95ab6f18220b104$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $a95ab6f18220b104$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $a95ab6f18220b104$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $a95ab6f18220b104$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $3OyDL = parcelRequire("3OyDL");



var $693b83347024104d$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $238c0f2b7ec49435$export$2e2bcd8739ae039)(node, c);
    });
};
var $693b83347024104d$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $a95ab6f18220b104$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $693b83347024104d$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $jNtCy.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $c3010db8cdef10e6$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $693b83347024104d$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $693b83347024104d$var$removeClass(node, baseClassName);
        if (activeClassName) $693b83347024104d$var$removeClass(node, activeClassName);
        if (doneClassName) $693b83347024104d$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $aBenZ.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement((0, $af8ce78d3d22dabd$export$2e2bcd8739ae039), (0, $gOPoC.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Component);
$693b83347024104d$var$CSSTransition.defaultProps = {
    classNames: ''
};
$693b83347024104d$var$CSSTransition.propTypes = {};
var $693b83347024104d$export$2e2bcd8739ae039 = $693b83347024104d$var$CSSTransition;



const $6ab7401d092195b7$export$e98c1b6c3bbc3c59 = (slot)=>(0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiPickersSlideTransition', slot);
const $6ab7401d092195b7$export$d251a58673156a67 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);



var $2M70Q = parcelRequire("2M70Q");
const $4232c1c03fd5819e$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $4232c1c03fd5819e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $6ab7401d092195b7$export$e98c1b6c3bbc3c59), classes);
};
const $4232c1c03fd5819e$export$ee7cc8ee8a5215ec = 350;
const $4232c1c03fd5819e$var$PickersSlideTransitionRoot = (0, $jH1k7.default)((0, $08574b535870a4c0$export$2e2bcd8739ae039), {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $6ab7401d092195b7$export$d251a58673156a67)['slideEnter-left']}`]: styles['slideEnter-left']
            },
            {
                [`.${(0, $6ab7401d092195b7$export$d251a58673156a67)['slideEnter-right']}`]: styles['slideEnter-right']
            },
            {
                [`.${(0, $6ab7401d092195b7$export$d251a58673156a67).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $6ab7401d092195b7$export$d251a58673156a67).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $6ab7401d092195b7$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${(0, $6ab7401d092195b7$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: $4232c1c03fd5819e$export$ee7cc8ee8a5215ec,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $6ab7401d092195b7$export$d251a58673156a67)['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${(0, $6ab7401d092195b7$export$d251a58673156a67)['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${(0, $6ab7401d092195b7$export$d251a58673156a67).slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${(0, $6ab7401d092195b7$export$d251a58673156a67).slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${(0, $6ab7401d092195b7$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $6ab7401d092195b7$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $4232c1c03fd5819e$export$e868fcc7557d3a06(inProps) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props, other = (0, $aBenZ.default)(props, $4232c1c03fd5819e$var$_excluded);
    const classes = $4232c1c03fd5819e$var$useUtilityClasses(props);
    if (reduceAnimations) return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: (0, $3DmQB.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)($4232c1c03fd5819e$var$PickersSlideTransitionRoot, {
        className: (0, $3DmQB.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $3OyDL.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $693b83347024104d$export$2e2bcd8739ae039), (0, $gOPoC.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: $4232c1c03fd5819e$export$ee7cc8ee8a5215ec,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}





const $e5040637136236e7$export$fbe827982a69894a = (slot)=>(0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiDayCalendar', slot);
const $e5040637136236e7$export$e0770f35b28ac552 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiDayCalendar', [
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);



var $2M70Q = parcelRequire("2M70Q");
const $49c9caa03a312071$var$_excluded = [
    "parentProps",
    "day",
    "focusableDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $49c9caa03a312071$var$_excluded2 = [
    "ownerState"
];
const $49c9caa03a312071$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $e5040637136236e7$export$fbe827982a69894a), classes);
};
const $49c9caa03a312071$var$defaultDayOfWeekFormatter = (day)=>day.charAt(0).toUpperCase();
const $49c9caa03a312071$var$weeksContainerHeight = ((0, $c8ed6f2a54427aa9$export$3f0060ce4cc8f4d0) + (0, $c8ed6f2a54427aa9$export$dde58b009b497666) * 2) * 6;
const $49c9caa03a312071$var$PickersCalendarDayHeader = (0, $jH1k7.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header',
    overridesResolver: (_, styles)=>styles.header
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $49c9caa03a312071$var$PickersCalendarWeekDayLabel = (0, $jH1k7.default)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel',
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const $49c9caa03a312071$var$PickersCalendarWeekNumberLabel = (0, $jH1k7.default)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
    name: 'MuiDayPicker',
    slot: 'WeekNumberLabel',
    overridesResolver: (_, styles)=>styles.weekNumberLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.text.disabled
    }));
const $49c9caa03a312071$var$PickersCalendarWeekNumber = (0, $jH1k7.default)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
    name: 'MuiDayPicker',
    slot: 'WeekNumber',
    overridesResolver: (_, styles)=>styles.weekNumber
})(({ theme: theme })=>(0, $gOPoC.default)({}, theme.typography.caption, {
        width: (0, $c8ed6f2a54427aa9$export$3f0060ce4cc8f4d0),
        height: (0, $c8ed6f2a54427aa9$export$3f0060ce4cc8f4d0),
        padding: 0,
        margin: `0 ${(0, $c8ed6f2a54427aa9$export$dde58b009b497666)}px`,
        color: theme.palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const $49c9caa03a312071$var$PickersCalendarLoadingContainer = (0, $jH1k7.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer',
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: $49c9caa03a312071$var$weeksContainerHeight
});
const $49c9caa03a312071$var$PickersCalendarSlideTransition = (0, $jH1k7.default)((0, $4232c1c03fd5819e$export$e868fcc7557d3a06), {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition',
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: $49c9caa03a312071$var$weeksContainerHeight
});
const $49c9caa03a312071$var$PickersCalendarWeekContainer = (0, $jH1k7.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer',
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: 'hidden'
});
const $49c9caa03a312071$var$PickersCalendarWeek = (0, $jH1k7.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer',
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, $c8ed6f2a54427aa9$export$dde58b009b497666)}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function $49c9caa03a312071$var$WrappedDay(_ref) {
    var _ref2, _slots$day, _slotProps$day;
    let { parentProps: parentProps, day: day, focusableDay: focusableDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $aBenZ.default)(_ref, $49c9caa03a312071$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const now = (0, $aa5fe19dd76d6423$export$3a404aece3dff2fa)(timezone);
    const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
    const isSelected = selectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
    const isToday = utils.isSameDay(day, now);
    const Day = (_ref2 = (_slots$day = slots == null ? void 0 : slots.day) != null ? _slots$day : components == null ? void 0 : components.Day) != null ? _ref2 : (0, $8c828728b8f83f18$export$d7378e6e864346fa);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: Day,
        externalSlotProps: (_slotProps$day = slotProps == null ? void 0 : slotProps.day) != null ? _slotProps$day : componentsProps == null ? void 0 : componentsProps.day,
        additionalProps: (0, $gOPoC.default)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            'data-timestamp': utils.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $gOPoC.default)({}, parentProps, {
            day: day,
            selected: isSelected
        })
    }), dayProps = (0, $aBenZ.default)(_useSlotProps, $49c9caa03a312071$var$_excluded2);
    const isDisabled = $3OyDL.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const outsideCurrentMonth = $3OyDL.useMemo(()=>utils.getMonth(day) !== currentMonthNumber, [
        utils,
        day,
        currentMonthNumber
    ]);
    const isFirstVisibleCell = $3OyDL.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, startOfMonth);
        return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    const isLastVisibleCell = $3OyDL.useMemo(()=>{
        const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, endOfMonth);
        return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)(Day, (0, $gOPoC.default)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: isViewFocused && isFocusableDay,
        today: isToday,
        outsideCurrentMonth: outsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : undefined
    }));
}
function $49c9caa03a312071$export$8fb56b32a5df6314(inProps) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const { onFocusedDayChange: onFocusedDayChange, className: className, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatter = $49c9caa03a312071$var$defaultDayOfWeekFormatter, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, autoFocus: autoFocus, timezone: timezone } = props;
    const now = (0, $aa5fe19dd76d6423$export$3a404aece3dff2fa)(timezone);
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const classes = $49c9caa03a312071$var$useUtilityClasses(props);
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const isDateDisabled = (0, $48c4a3d2631d9b8b$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const [internalHasFocus, setInternalHasFocus] = (0, $3bd2ff427a59ae77$export$2e2bcd8739ae039)({
        name: 'DayCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const [internalFocusedDay, setInternalFocusedDay] = $3OyDL.useState(()=>focusedDay || now);
    const handleDaySelect = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            onFocusedViewChange == null || onFocusedViewChange(true);
            setInternalHasFocus(true);
        }
    };
    const handleKeyDown = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? 1 : -1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? 1 : -1);
                    const closestDayToFocus = (0, $915ec64656c7dd6f$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: isRTL ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? -1 : 1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? -1 : 1);
                    const closestDayToFocus = (0, $915ec64656c7dd6f$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRTL ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(utils.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(utils.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event, day)=>focusDay(day));
    const handleBlur = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event, day)=>{
        if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) onFocusedViewChange == null || onFocusedViewChange(false);
    });
    const currentMonthNumber = utils.getMonth(currentMonth);
    const validSelectedDays = $3OyDL.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)), [
        utils,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = currentMonthNumber;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $3OyDL.useMemo(()=>/*#__PURE__*/ $3OyDL.createRef(), [
        transitionKey
    ]);
    const startOfCurrentWeek = utils.startOfWeek(now);
    const focusableDay = $3OyDL.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, $915ec64656c7dd6f$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils,
        timezone
    ]);
    const weeksToDisplay = $3OyDL.useMemo(()=>{
        const currentMonthWithTimezone = utils.setTimezone(currentMonth, timezone);
        const toDisplay = utils.getWeekArray(currentMonthWithTimezone);
        let nextMonth = utils.addMonths(currentMonthWithTimezone, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = utils.getWeekArray(nextMonth);
            const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = utils.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        utils,
        timezone
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        role: "grid",
        "aria-labelledby": gridLabelId,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)($49c9caa03a312071$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $2M70Q.jsx)($49c9caa03a312071$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": localeText.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: localeText.calendarWeekNumberHeaderText
                    }),
                    utils.getWeekdays().map((day, i)=>{
                        var _dayOfWeekFormatter;
                        return /*#__PURE__*/ (0, $2M70Q.jsx)($49c9caa03a312071$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), 'weekday'),
                            className: classes.weekDayLabel,
                            children: (_dayOfWeekFormatter = dayOfWeekFormatter == null ? void 0 : dayOfWeekFormatter(day)) != null ? _dayOfWeekFormatter : day
                        }, day + i.toString());
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $2M70Q.jsx)($49c9caa03a312071$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $2M70Q.jsx)($49c9caa03a312071$var$PickersCalendarSlideTransition, (0, $gOPoC.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $3DmQB.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $2M70Q.jsx)($49c9caa03a312071$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $2M70Q.jsxs)($49c9caa03a312071$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $2M70Q.jsx)($49c9caa03a312071$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": localeText.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
                                    children: localeText.calendarWeekNumberText(utils.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $2M70Q.jsx)($49c9caa03a312071$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        focusableDay: focusableDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        isViewFocused: internalHasFocus,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");
function $601e235257c2cf89$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $601e235257c2cf89$var$deepClone(source) {
    if (/*#__PURE__*/ $3OyDL.isValidElement(source) || !$601e235257c2cf89$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $601e235257c2cf89$var$deepClone(source[key]);
    });
    return output;
}
function $601e235257c2cf89$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $gOPoC.default)({}, target) : target;
    if ($601e235257c2cf89$export$53b83ca8eaab0383(target) && $601e235257c2cf89$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $3OyDL.isValidElement(source[key])) output[key] = source[key];
        else if ($601e235257c2cf89$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $601e235257c2cf89$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $601e235257c2cf89$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $601e235257c2cf89$export$53b83ca8eaab0383(source[key]) ? $601e235257c2cf89$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");
const $717f130b2369ba7a$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $717f130b2369ba7a$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]; // Keep in mind that @media is inclusive by the CSS specification.
function $717f130b2369ba7a$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $aBenZ.default)(breakpoints, $717f130b2369ba7a$var$_excluded);
    const keys = Object.keys(values);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    return (0, $gOPoC.default)({
        keys: keys,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        unit: unit
    }, other);
}


const $c39854564301f3ed$var$shape = {
    borderRadius: 4
};
var $c39854564301f3ed$export$2e2bcd8739ae039 = $c39854564301f3ed$var$shape;




var $gOPoC = parcelRequire("gOPoC");



function $7b45b6943329c4bd$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $601e235257c2cf89$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $7b45b6943329c4bd$export$2e2bcd8739ae039 = $7b45b6943329c4bd$var$merge;


const $52810d7684044ac4$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $52810d7684044ac4$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$52810d7684044ac4$export$68c286be0e7e55b7[key]}px)`
};
function $52810d7684044ac4$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $52810d7684044ac4$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $52810d7684044ac4$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $52810d7684044ac4$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $52810d7684044ac4$var$breakpoints(styleFunction) {
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $52810d7684044ac4$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $gOPoC.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $7b45b6943329c4bd$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $52810d7684044ac4$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = breakpointsInput == null ? void 0 : (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $52810d7684044ac4$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $52810d7684044ac4$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $52810d7684044ac4$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $601e235257c2cf89$export$2e2bcd8739ae039)(prev, next), {});
    return $52810d7684044ac4$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
} // compute base for responsive values; e.g.,
function $52810d7684044ac4$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $52810d7684044ac4$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $52810d7684044ac4$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous] || breakpointValues;
            previous = breakpoint;
        }
        return acc;
    }, {});
}
var $52810d7684044ac4$export$2e2bcd8739ae039 = $52810d7684044ac4$var$breakpoints;


/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $fb9af7597c25a1b5$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }


function $c8a425144c795a53$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $fb9af7597c25a1b5$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}




function $c5c9d5e64a6688be$export$2aa3fd96c49a84a8(obj, path) {
    if (!path || typeof path !== 'string') return null;
    return path.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
}
function $c5c9d5e64a6688be$var$getValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $c5c9d5e64a6688be$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value);
    return value;
}
function $c5c9d5e64a6688be$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $c5c9d5e64a6688be$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $c5c9d5e64a6688be$var$getValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $c5c9d5e64a6688be$var$getValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $c8a425144c795a53$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $52810d7684044ac4$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $c5c9d5e64a6688be$export$2e2bcd8739ae039 = $c5c9d5e64a6688be$var$style;



function $ab34ad1ed5527b33$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $ce1d43ef17ce32b2$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $ce1d43ef17ce32b2$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $ce1d43ef17ce32b2$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $ce1d43ef17ce32b2$var$getCssProperties = (0, $ab34ad1ed5527b33$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($ce1d43ef17ce32b2$var$aliases[prop]) prop = $ce1d43ef17ce32b2$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $ce1d43ef17ce32b2$var$properties[a];
    const direction = $ce1d43ef17ce32b2$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $ce1d43ef17ce32b2$var$marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $ce1d43ef17ce32b2$var$paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $ce1d43ef17ce32b2$var$spacingKeys = [
    ...$ce1d43ef17ce32b2$var$marginKeys,
    ...$ce1d43ef17ce32b2$var$paddingKeys
];
function $ce1d43ef17ce32b2$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $c5c9d5e64a6688be$export$2aa3fd96c49a84a8)(theme, themeKey) || defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $ce1d43ef17ce32b2$export$1def6f833384e3d1(theme) {
    return $ce1d43ef17ce32b2$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $ce1d43ef17ce32b2$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $ce1d43ef17ce32b2$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $ce1d43ef17ce32b2$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $ce1d43ef17ce32b2$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $ce1d43ef17ce32b2$var$getCssProperties(prop);
    const styleFromPropValue = $ce1d43ef17ce32b2$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $52810d7684044ac4$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $ce1d43ef17ce32b2$var$style(props, keys) {
    const transformer = $ce1d43ef17ce32b2$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$ce1d43ef17ce32b2$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $7b45b6943329c4bd$export$2e2bcd8739ae039), {});
}
function $ce1d43ef17ce32b2$export$7ede87f9b603dd3c(props) {
    return $ce1d43ef17ce32b2$var$style(props, $ce1d43ef17ce32b2$var$marginKeys);
}
$ce1d43ef17ce32b2$export$7ede87f9b603dd3c.propTypes = {};
$ce1d43ef17ce32b2$export$7ede87f9b603dd3c.filterProps = $ce1d43ef17ce32b2$var$marginKeys;
function $ce1d43ef17ce32b2$export$6f98e8eaf0be1996(props) {
    return $ce1d43ef17ce32b2$var$style(props, $ce1d43ef17ce32b2$var$paddingKeys);
}
$ce1d43ef17ce32b2$export$6f98e8eaf0be1996.propTypes = {};
$ce1d43ef17ce32b2$export$6f98e8eaf0be1996.filterProps = $ce1d43ef17ce32b2$var$paddingKeys;
function $ce1d43ef17ce32b2$var$spacing(props) {
    return $ce1d43ef17ce32b2$var$style(props, $ce1d43ef17ce32b2$var$spacingKeys);
}
$ce1d43ef17ce32b2$var$spacing.propTypes = {};
$ce1d43ef17ce32b2$var$spacing.filterProps = $ce1d43ef17ce32b2$var$spacingKeys;
var $ce1d43ef17ce32b2$export$2e2bcd8739ae039 = $ce1d43ef17ce32b2$var$spacing;


function $f0501c6992e648ac$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    const transform = (0, $ce1d43ef17ce32b2$export$1def6f833384e3d1)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}


const $0efe28af772e2722$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $0efe28af772e2722$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $aBenZ.default)(options, $0efe28af772e2722$var$_excluded);
    const breakpoints = (0, $717f130b2369ba7a$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $f0501c6992e648ac$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $601e235257c2cf89$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $gOPoC.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $gOPoC.default)({}, (0, $c39854564301f3ed$export$2e2bcd8739ae039), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $601e235257c2cf89$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    return muiTheme;
}
var $0efe28af772e2722$export$2e2bcd8739ae039 = $0efe28af772e2722$var$createTheme;



function $de0ae02733b9c9ca$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $de0ae02733b9c9ca$var$useTheme(defaultTheme = null) {
    const contextTheme = (0, $dd650febbd4df59e$export$2e2bcd8739ae039)();
    return !contextTheme || $de0ae02733b9c9ca$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $de0ae02733b9c9ca$export$2e2bcd8739ae039 = $de0ae02733b9c9ca$var$useTheme;


const $5e6e4e8532fb7d1e$export$35e57303dbd8a66 = (0, $0efe28af772e2722$export$2e2bcd8739ae039)();
function $5e6e4e8532fb7d1e$var$useTheme(defaultTheme = $5e6e4e8532fb7d1e$export$35e57303dbd8a66) {
    return (0, $de0ae02733b9c9ca$export$2e2bcd8739ae039)(defaultTheme);
}
var $5e6e4e8532fb7d1e$export$2e2bcd8739ae039 = $5e6e4e8532fb7d1e$var$useTheme;



var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $7m2iU = parcelRequire("7m2iU");
var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");


function $93f9d8fdb8ca280e$export$db90a620ac957a73(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiPickersMonth', slot);
}
const $93f9d8fdb8ca280e$export$911e3973fa70a12b = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiPickersMonth', [
    'root',
    'monthButton',
    'disabled',
    'selected'
]);



var $2M70Q = parcelRequire("2M70Q");
const $712668b01364dde7$var$_excluded = [
    "autoFocus",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "aria-label",
    "monthsPerRow"
];
const $712668b01364dde7$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        monthButton: [
            'monthButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $93f9d8fdb8ca280e$export$db90a620ac957a73), classes);
};
const $712668b01364dde7$var$PickersMonthRoot = (0, $jH1k7.default)('div', {
    name: 'MuiPickersMonth',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})(({ ownerState: ownerState })=>({
        flexBasis: ownerState.monthsPerRow === 3 ? '33.3%' : '25%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }));
const $712668b01364dde7$var$PickersMonthButton = (0, $jH1k7.default)('button', {
    name: 'MuiPickersMonth',
    slot: 'MonthButton',
    overridesResolver: (_, styles)=>[
            styles.monthButton,
            {
                [`&.${(0, $93f9d8fdb8ca280e$export$911e3973fa70a12b).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $93f9d8fdb8ca280e$export$911e3973fa70a12b).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $gOPoC.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '8px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $93f9d8fdb8ca280e$export$911e3973fa70a12b).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $93f9d8fdb8ca280e$export$911e3973fa70a12b).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $712668b01364dde7$export$bc52fdb7f02f591a = /*#__PURE__*/ $3OyDL.memo(function PickersMonth(inProps) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPickersMonth'
    });
    const { autoFocus: autoFocus, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, 'aria-current': ariaCurrent, 'aria-label': ariaLabel } = props, other = (0, $aBenZ.default)(props, $712668b01364dde7$var$_excluded);
    const ref = $3OyDL.useRef(null);
    const classes = $712668b01364dde7$var$useUtilityClasses(props);
    (0, $54812c32efbf145d$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            var _ref$current;
            (_ref$current = ref.current) == null || _ref$current.focus();
        }
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($712668b01364dde7$var$PickersMonthRoot, (0, $gOPoC.default)({
        className: classes.root,
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($712668b01364dde7$var$PickersMonthButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            role: "radio",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            "aria-label": ariaLabel,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.monthButton,
            ownerState: props,
            children: children
        })
    }));
});




function $d240824cb12c554c$export$da0c97315339ebd9(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiMonthCalendar', slot);
}
const $d240824cb12c554c$export$edf77d5566c7007c = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiMonthCalendar', [
    'root'
]);







var $2M70Q = parcelRequire("2M70Q");
const $c464ecdacb3d482d$var$_excluded = [
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId"
];
const $c464ecdacb3d482d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $d240824cb12c554c$export$da0c97315339ebd9), classes);
};
function $c464ecdacb3d482d$export$5b6e066572408095(props, name) {
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const defaultDates = (0, $aa5fe19dd76d6423$export$7c38da3a2e90fa83)();
    const themeProps = (0, $jFgmT.default)({
        props: props,
        name: name
    });
    return (0, $gOPoC.default)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $c464ecdacb3d482d$var$MonthCalendarRoot = (0, $jH1k7.default)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch',
    padding: '0 4px',
    width: 320
});
const $c464ecdacb3d482d$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $3OyDL.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $c464ecdacb3d482d$export$5b6e066572408095(inProps, 'MuiMonthCalendar');
    const { className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, disableHighlightToday: disableHighlightToday, autoFocus: autoFocus = false, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow = 3, timezone: timezoneProp, gridLabelId: gridLabelId } = props, other = (0, $aBenZ.default)(props, $c464ecdacb3d482d$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $c1a1b9e58f0b723e$export$174d749f3b4c0f49)({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $286007e7644aad7a$export$2764b246aa3b75ba)
    });
    const now = (0, $aa5fe19dd76d6423$export$3a404aece3dff2fa)(timezone);
    const theme = (0, $5e6e4e8532fb7d1e$export$2e2bcd8739ae039)();
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const referenceDate = $3OyDL.useMemo(()=>(0, $286007e7644aad7a$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $296cf343c750d880$export$8f74e8f4ed8ae0ac).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $c464ecdacb3d482d$var$useUtilityClasses(ownerState);
    const todayMonth = $3OyDL.useMemo(()=>utils.getMonth(now), [
        utils,
        now
    ]);
    const selectedMonth = $3OyDL.useMemo(()=>{
        if (value != null) return utils.getMonth(value);
        if (disableHighlightToday) return null;
        return utils.getMonth(referenceDate);
    }, [
        value,
        utils,
        disableHighlightToday,
        referenceDate
    ]);
    const [focusedMonth, setFocusedMonth] = $3OyDL.useState(()=>selectedMonth || todayMonth);
    const [internalHasFocus, setInternalHasFocus] = (0, $3bd2ff427a59ae77$export$2e2bcd8739ae039)({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const changeHasFocus = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $3OyDL.useCallback((dateToValidate)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = utils.startOfMonth(dateToValidate);
        if (utils.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (utils.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const handleMonthSelection = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event, month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(value != null ? value : referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((month)=>{
        if (!isMonthDisabled(utils.setMonth(value != null ? value : referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $3OyDL.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + (theme.direction === 'ltr' ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + (theme.direction === 'ltr' ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)($c464ecdacb3d482d$var$MonthCalendarRoot, (0, $gOPoC.default)({
        ref: ref,
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: (0, $915ec64656c7dd6f$export$62591b96a734eacd)(utils, value != null ? value : referenceDate).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, 'monthShort');
            const monthLabel = utils.format(month, 'month');
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $712668b01364dde7$export$bc52fdb7f02f591a), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? 'date' : undefined,
                "aria-label": monthLabel,
                monthsPerRow: monthsPerRow,
                children: monthText
            }, monthText);
        })
    }));
});



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");


var $7m2iU = parcelRequire("7m2iU");
var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");

function $68149eb6cdd1a25b$export$183c9f339a61cd79(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiPickersYear', slot);
}
const $68149eb6cdd1a25b$export$4ef58a3d9c6f4296 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiPickersYear', [
    'root',
    'yearButton',
    'selected',
    'disabled'
]);



var $2M70Q = parcelRequire("2M70Q");
const $67d2c3fb19226a22$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "yearsPerRow"
];
const $67d2c3fb19226a22$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        yearButton: [
            'yearButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $68149eb6cdd1a25b$export$183c9f339a61cd79), classes);
};
const $67d2c3fb19226a22$var$PickersYearRoot = (0, $jH1k7.default)('div', {
    name: 'MuiPickersYear',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})(({ ownerState: ownerState })=>({
        flexBasis: ownerState.yearsPerRow === 3 ? '33.3%' : '25%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }));
const $67d2c3fb19226a22$var$PickersYearButton = (0, $jH1k7.default)('button', {
    name: 'MuiPickersYear',
    slot: 'YearButton',
    overridesResolver: (_, styles)=>[
            styles.yearButton,
            {
                [`&.${(0, $68149eb6cdd1a25b$export$4ef58a3d9c6f4296).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $68149eb6cdd1a25b$export$4ef58a3d9c6f4296).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $gOPoC.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '8px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7m2iU.alpha)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $68149eb6cdd1a25b$export$4ef58a3d9c6f4296).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $68149eb6cdd1a25b$export$4ef58a3d9c6f4296).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $67d2c3fb19226a22$export$261f3fbd5fd5814d = /*#__PURE__*/ $3OyDL.memo(function PickersYear(inProps) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPickersYear'
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, 'aria-current': ariaCurrent } = props, other = (0, $aBenZ.default)(props, $67d2c3fb19226a22$var$_excluded);
    const ref = $3OyDL.useRef(null);
    const classes = $67d2c3fb19226a22$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    $3OyDL.useEffect(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($67d2c3fb19226a22$var$PickersYearRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($67d2c3fb19226a22$var$PickersYearButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            role: "radio",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.yearButton,
            ownerState: props,
            children: children
        })
    }));
});




function $52b024b84fcaf518$export$4477acc520094dec(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiYearCalendar', slot);
}
const $52b024b84fcaf518$export$e42d427cd9fe5fd7 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiYearCalendar', [
    'root'
]);







var $2M70Q = parcelRequire("2M70Q");
const $a4c9b36e8c4fc154$var$_excluded = [
    "autoFocus",
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsPerRow",
    "timezone",
    "gridLabelId"
];
const $a4c9b36e8c4fc154$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $52b024b84fcaf518$export$4477acc520094dec), classes);
};
function $a4c9b36e8c4fc154$var$useYearCalendarDefaultizedProps(props, name) {
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const defaultDates = (0, $aa5fe19dd76d6423$export$7c38da3a2e90fa83)();
    const themeProps = (0, $jFgmT.default)({
        props: props,
        name: name
    });
    return (0, $gOPoC.default)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        minDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $a4c9b36e8c4fc154$var$YearCalendarRoot = (0, $jH1k7.default)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'auto',
    height: '100%',
    padding: '0 4px',
    width: 320,
    maxHeight: 304,
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    position: 'relative'
});
const $a4c9b36e8c4fc154$export$657f9200591b2b71 = /*#__PURE__*/ $3OyDL.forwardRef(function YearCalendar(inProps, ref) {
    const props = $a4c9b36e8c4fc154$var$useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus: autoFocus, className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, disableHighlightToday: disableHighlightToday, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsPerRow: yearsPerRow = 3, timezone: timezoneProp, gridLabelId: gridLabelId } = props, other = (0, $aBenZ.default)(props, $a4c9b36e8c4fc154$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $c1a1b9e58f0b723e$export$174d749f3b4c0f49)({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $286007e7644aad7a$export$2764b246aa3b75ba)
    });
    const now = (0, $aa5fe19dd76d6423$export$3a404aece3dff2fa)(timezone);
    const theme = (0, $5e6e4e8532fb7d1e$export$2e2bcd8739ae039)();
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const referenceDate = $3OyDL.useMemo(()=>(0, $286007e7644aad7a$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $296cf343c750d880$export$8f74e8f4ed8ae0ac).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $a4c9b36e8c4fc154$var$useUtilityClasses(ownerState);
    const todayYear = $3OyDL.useMemo(()=>utils.getYear(now), [
        utils,
        now
    ]);
    const selectedYear = $3OyDL.useMemo(()=>{
        if (value != null) return utils.getYear(value);
        if (disableHighlightToday) return null;
        return utils.getYear(referenceDate);
    }, [
        value,
        utils,
        disableHighlightToday,
        referenceDate
    ]);
    const [focusedYear, setFocusedYear] = $3OyDL.useState(()=>selectedYear || todayYear);
    const [internalHasFocus, setInternalHasFocus] = (0, $3bd2ff427a59ae77$export$2e2bcd8739ae039)({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const changeHasFocus = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $3OyDL.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = utils.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event, year)=>{
        if (readOnly) return;
        const newDate = utils.setYear(value != null ? value : referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((year)=>{
        if (!isYearDisabled(utils.setYear(value != null ? value : referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus == null || onYearFocus(year);
        }
    });
    $3OyDL.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const handleKeyDown = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - yearsPerRow);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + yearsPerRow);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year + (theme.direction === 'ltr' ? -1 : 1));
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + (theme.direction === 'ltr' ? 1 : -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $3OyDL.useRef(null);
    const handleRef = (0, $a0093ef70e9dc99d$export$2e2bcd8739ae039)(ref, scrollerRef);
    $3OyDL.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($a4c9b36e8c4fc154$var$YearCalendarRoot, (0, $gOPoC.default)({
        ref: handleRef,
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: utils.getYearRange(minDate, maxDate).map((year)=>{
            const yearNumber = utils.getYear(year);
            const isSelected = yearNumber === selectedYear;
            const isDisabled = disabled || isYearDisabled(year);
            return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $67d2c3fb19226a22$export$261f3fbd5fd5814d), {
                selected: isSelected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                disabled: isDisabled,
                tabIndex: yearNumber === focusedYear ? 0 : -1,
                onFocus: handleYearFocus,
                onBlur: handleYearBlur,
                "aria-current": todayYear === yearNumber ? 'date' : undefined,
                yearsPerRow: yearsPerRow,
                children: utils.format(year, 'year')
            }, utils.format(year, 'year'));
        })
    }));
});




var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");







var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");


var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");





function $5b9751c53d07e6ac$export$cef978c25740de90(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiPickersArrowSwitcher', slot);
}
const $5b9751c53d07e6ac$export$f8819209558cd362 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button'
]);



var $2M70Q = parcelRequire("2M70Q");
const $403ec616f1b9959c$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel"
], $403ec616f1b9959c$var$_excluded2 = [
    "ownerState"
], $403ec616f1b9959c$var$_excluded3 = [
    "ownerState"
];
const $403ec616f1b9959c$var$PickersArrowSwitcherRoot = (0, $jH1k7.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex'
});
const $403ec616f1b9959c$var$PickersArrowSwitcherSpacer = (0, $jH1k7.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $403ec616f1b9959c$var$PickersArrowSwitcherButton = (0, $jH1k7.default)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button',
    overridesResolver: (props, styles)=>styles.button
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({}, ownerState.hidden && {
        visibility: 'hidden'
    }));
const $403ec616f1b9959c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $5b9751c53d07e6ac$export$cef978c25740de90), classes);
};
const $403ec616f1b9959c$export$597b7cbdb7b2a24c = /*#__PURE__*/ $3OyDL.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    var _slots$previousIconBu, _slots$nextIconButton, _slots$leftArrowIcon, _slots$rightArrowIcon;
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel } = props, other = (0, $aBenZ.default)(props, $403ec616f1b9959c$var$_excluded);
    const ownerState = props;
    const classes = $403ec616f1b9959c$var$useUtilityClasses(ownerState);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = (_slots$previousIconBu = slots == null ? void 0 : slots.previousIconButton) != null ? _slots$previousIconBu : $403ec616f1b9959c$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: previousProps.label,
            'aria-label': previousProps.label,
            disabled: previousProps.isDisabled,
            edge: 'end',
            onClick: previousProps.goTo
        },
        ownerState: (0, $gOPoC.default)({}, ownerState, {
            hidden: previousProps.isHidden
        }),
        className: classes.button
    });
    const NextIconButton = (_slots$nextIconButton = slots == null ? void 0 : slots.nextIconButton) != null ? _slots$nextIconButton : $403ec616f1b9959c$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: NextIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: nextProps.label,
            'aria-label': nextProps.label,
            disabled: nextProps.isDisabled,
            edge: 'start',
            onClick: nextProps.goTo
        },
        ownerState: (0, $gOPoC.default)({}, ownerState, {
            hidden: nextProps.isHidden
        }),
        className: classes.button
    });
    const LeftArrowIcon = (_slots$leftArrowIcon = slots == null ? void 0 : slots.leftArrowIcon) != null ? _slots$leftArrowIcon : (0, $77fe2edc650c8e6d$export$8afed21ef5c2afa5);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: undefined
    }), leftArrowIconProps = (0, $aBenZ.default)(_useSlotProps, $403ec616f1b9959c$var$_excluded2);
    const RightArrowIcon = (_slots$rightArrowIcon = slots == null ? void 0 : slots.rightArrowIcon) != null ? _slots$rightArrowIcon : (0, $77fe2edc650c8e6d$export$9ca09caa9c849d9c);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: undefined
    }), rightArrowIconProps = (0, $aBenZ.default)(_useSlotProps2, $403ec616f1b9959c$var$_excluded3);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($403ec616f1b9959c$var$PickersArrowSwitcherRoot, (0, $gOPoC.default)({
        ref: ref,
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)(PreviousIconButton, (0, $gOPoC.default)({}, previousIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $2M70Q.jsx)(RightArrowIcon, (0, $gOPoC.default)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $2M70Q.jsx)(LeftArrowIcon, (0, $gOPoC.default)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "span",
                children: children
            }) : /*#__PURE__*/ (0, $2M70Q.jsx)($403ec616f1b9959c$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)(NextIconButton, (0, $gOPoC.default)({}, nextIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $2M70Q.jsx)(LeftArrowIcon, (0, $gOPoC.default)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $2M70Q.jsx)(RightArrowIcon, (0, $gOPoC.default)({}, rightArrowIconProps))
            }))
        ]
    }));
});



var $3OyDL = parcelRequire("3OyDL");


function $6bc09be28b20c2f3$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    return $3OyDL.useMemo(()=>{
        const now = utils.dateWithTimezone(undefined, timezone);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils,
        timezone
    ]);
}
function $6bc09be28b20c2f3$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    return $3OyDL.useMemo(()=>{
        const now = utils.dateWithTimezone(undefined, timezone);
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils,
        timezone
    ]);
}
function $6bc09be28b20c2f3$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const meridiemMode = (0, $ab8b9fd82a664ad3$export$c3352ead7b032236)(date, utils);
    const handleMeridiemChange = $3OyDL.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $ab8b9fd82a664ad3$export$c368d4ff66779998)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, selectionState != null ? selectionState : 'partial');
    }, [
        ampm,
        date,
        onChange,
        selectionState,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}



const $ebb20788b9dbe61c$export$457ac4d3a1ad92b4 = (slot)=>(0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiPickersCalendarHeader', slot);
const $ebb20788b9dbe61c$export$63db7afb9247cb91 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);



var $2M70Q = parcelRequire("2M70Q");
const $b1d40df76453cd50$var$_excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "timezone"
], $b1d40df76453cd50$var$_excluded2 = [
    "ownerState"
];
const $b1d40df76453cd50$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $ebb20788b9dbe61c$export$457ac4d3a1ad92b4), classes);
};
const $b1d40df76453cd50$var$PickersCalendarHeaderRoot = (0, $jH1k7.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 8,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 30,
    minHeight: 30
});
const $b1d40df76453cd50$var$PickersCalendarHeaderLabelContainer = (0, $jH1k7.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer',
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme: theme })=>(0, $gOPoC.default)({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $b1d40df76453cd50$var$PickersCalendarHeaderLabel = (0, $jH1k7.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label',
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const $b1d40df76453cd50$var$PickersCalendarHeaderSwitchViewButton = (0, $jH1k7.default)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton',
    overridesResolver: (_, styles)=>styles.switchViewButton
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        marginRight: 'auto'
    }, ownerState.view === 'year' && {
        [`.${(0, $ebb20788b9dbe61c$export$63db7afb9247cb91).switchViewIcon}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $b1d40df76453cd50$var$PickersCalendarHeaderSwitchViewIcon = (0, $jH1k7.default)((0, $77fe2edc650c8e6d$export$ed0fe318cc298673), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon',
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme: theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
const $b1d40df76453cd50$export$6801ffebb353f473 = /*#__PURE__*/ $3OyDL.forwardRef(function PickersCalendarHeader(inProps, ref) {
    var _slots$switchViewButt, _slots$switchViewIcon;
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots: slots, slotProps: slotProps, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, timezone: timezone } = props, other = (0, $aBenZ.default)(props, $b1d40df76453cd50$var$_excluded);
    const ownerState = props;
    const classes = $b1d40df76453cd50$var$useUtilityClasses(props);
    const SwitchViewButton = (_slots$switchViewButt = slots == null ? void 0 : slots.switchViewButton) != null ? _slots$switchViewButt : $b1d40df76453cd50$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': localeText.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: ownerState,
        className: classes.switchViewButton
    });
    const SwitchViewIcon = (_slots$switchViewIcon = slots == null ? void 0 : slots.switchViewIcon) != null ? _slots$switchViewIcon : $b1d40df76453cd50$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewIcon,
        ownerState: undefined,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $aBenZ.default)(_useSlotProps, $b1d40df76453cd50$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(month, 1), 'left');
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(month, -1), 'right');
    const isNextMonthDisabled = (0, $6bc09be28b20c2f3$export$923e8cc135843169)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $6bc09be28b20c2f3$export$3b46d38ff4932cf7)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($b1d40df76453cd50$var$PickersCalendarHeaderRoot, (0, $gOPoC.default)({}, other, {
        ownerState: ownerState,
        className: (0, $3DmQB.default)(className, classes.root),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)($b1d40df76453cd50$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $db8717935695594d$export$5262185daf493fee), {
                        reduceAnimations: reduceAnimations,
                        transKey: utils.format(month, 'monthAndYear'),
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)($b1d40df76453cd50$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: utils.format(month, 'monthAndYear')
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $2M70Q.jsx)(SwitchViewButton, (0, $gOPoC.default)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)(SwitchViewIcon, (0, $gOPoC.default)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9c9203b21cd916fe$export$2e2bcd8739ae039), {
                in: view === 'day',
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $403ec616f1b9959c$export$597b7cbdb7b2a24c), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: localeText.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: localeText.nextMonth
                })
            })
        ]
    }));
});




var $jH1k7 = parcelRequire("jH1k7");

const $86e2d434c5b86080$export$512b066b8abdfde4 = (0, $jH1k7.default)('div')({
    overflow: 'hidden',
    width: (0, $c8ed6f2a54427aa9$export$ee46b8a74d6c94d3),
    maxHeight: (0, $c8ed6f2a54427aa9$export$f2fef360e2df0cb7),
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});




const $84b88f05afb55f50$export$da8c2318897a6672 = (slot)=>(0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiDateCalendar', slot);
const $84b88f05afb55f50$export$d0237e2bb9598e8d = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);





var $2M70Q = parcelRequire("2M70Q");
const $e2c97183dc7732ed$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "defaultCalendarMonth",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $e2c97183dc7732ed$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $84b88f05afb55f50$export$da8c2318897a6672), classes);
};
function $e2c97183dc7732ed$var$useDateCalendarDefaultizedProps(props, name) {
    var _themeProps$loading, _themeProps$disablePa, _themeProps$disableFu, _themeProps$openTo, _themeProps$views, _themeProps$reduceAni, _themeProps$renderLoa;
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const defaultDates = (0, $aa5fe19dd76d6423$export$7c38da3a2e90fa83)();
    const defaultReduceAnimations = (0, $ed2824d9d63e757f$export$ce40fb97be7f02d9)();
    const themeProps = (0, $jFgmT.default)({
        props: props,
        name: name
    });
    return (0, $gOPoC.default)({}, themeProps, {
        loading: (_themeProps$loading = themeProps.loading) != null ? _themeProps$loading : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        openTo: (_themeProps$openTo = themeProps.openTo) != null ? _themeProps$openTo : 'day',
        views: (_themeProps$views = themeProps.views) != null ? _themeProps$views : [
            'year',
            'day'
        ],
        reduceAnimations: (_themeProps$reduceAni = themeProps.reduceAnimations) != null ? _themeProps$reduceAni : defaultReduceAnimations,
        renderLoading: (_themeProps$renderLoa = themeProps.renderLoading) != null ? _themeProps$renderLoa : ()=>/*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                children: "..."
            }),
        minDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $e2c97183dc7732ed$var$DateCalendarRoot = (0, $jH1k7.default)((0, $86e2d434c5b86080$export$512b066b8abdfde4), {
    name: 'MuiDateCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column'
});
const $e2c97183dc7732ed$var$DateCalendarViewTransitionContainer = (0, $jH1k7.default)((0, $db8717935695594d$export$5262185daf493fee), {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer',
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const $e2c97183dc7732ed$export$68078fe5d2bf8909 = /*#__PURE__*/ $3OyDL.forwardRef(function DateCalendar(inProps, ref) {
    var _ref, _slots$calendarHeader, _slotProps$calendarHe;
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const id = (0, $da50f700e88904fb$export$2e2bcd8739ae039)();
    const props = $e2c97183dc7732ed$var$useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, defaultCalendarMonth: defaultCalendarMonth, onChange: onChange, onYearChange: onYearChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $aBenZ.default)(props, $e2c97183dc7732ed$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $c1a1b9e58f0b723e$export$174d749f3b4c0f49)({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $286007e7644aad7a$export$2764b246aa3b75ba)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $f3f961a3b0e6e0b6$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $77e1db9ff9240c30$export$6d095e787d2b5e1f)({
        value: value,
        defaultCalendarMonth: defaultCalendarMonth,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = (_ref = (_slots$calendarHeader = slots == null ? void 0 : slots.calendarHeader) != null ? _slots$calendarHeader : components == null ? void 0 : components.CalendarHeader) != null ? _ref : (0, $b1d40df76453cd50$export$6801ffebb353f473);
    const calendarHeaderProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: CalendarHeader,
        externalSlotProps: (_slotProps$calendarHe = slotProps == null ? void 0 : slotProps.calendarHeader) != null ? _slotProps$calendarHe : componentsProps == null ? void 0 : componentsProps.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (newMonth, direction)=>handleChangeMonth({
                    newMonth: newMonth,
                    direction: direction
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId,
            slots: slots,
            slotProps: slotProps
        },
        ownerState: props
    });
    const handleDateMonthChange = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newDate)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $915ec64656c7dd6f$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onMonthChange == null || onMonthChange(startOfMonth);
        } else {
            goToNextView();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleDateYearChange = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newDate)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $915ec64656c7dd6f$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onYearChange == null || onYearChange(closestEnabledDate);
        } else {
            goToNextView();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleSelectedDayChange = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $915ec64656c7dd6f$export$a98b123b8f29e004)(utils, day, value != null ? value : referenceDate), 'finish');
        return handleValueChange(day, 'finish');
    });
    $3OyDL.useEffect(()=>{
        if (value != null && utils.isValid(value)) changeMonth(value);
    }, [
        value
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $e2c97183dc7732ed$var$useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId
    };
    const prevOpenViewRef = $3OyDL.useRef(view);
    $3OyDL.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $3OyDL.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($e2c97183dc7732ed$var$DateCalendarRoot, (0, $gOPoC.default)({
        ref: ref,
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)(CalendarHeader, (0, $gOPoC.default)({}, calendarHeaderProps)),
            /*#__PURE__*/ (0, $2M70Q.jsx)($e2c97183dc7732ed$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                    children: [
                        view === 'year' && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a4c9b36e8c4fc154$export$657f9200591b2b71), (0, $gOPoC.default)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'month' && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c464ecdacb3d482d$export$d7a7c85c0f5afc4a), (0, $gOPoC.default)({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'day' && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $49c9caa03a312071$export$8fb56b32a5df6314), (0, $gOPoC.default)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            components: components,
                            componentsProps: componentsProps,
                            slots: slots,
                            slotProps: slotProps,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});




var $2M70Q = parcelRequire("2M70Q");
const $494930d48812a2bb$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsPerRow: yearsPerRow, defaultCalendarMonth: defaultCalendarMonth, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $e2c97183dc7732ed$export$68078fe5d2bf8909), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $915ec64656c7dd6f$export$b32dfef9f07dea64)),
        focusedView: focusedView && (0, $915ec64656c7dd6f$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsPerRow: yearsPerRow,
        defaultCalendarMonth: defaultCalendarMonth,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });



const $315750c4c3c3cac0$export$5a73641f0156e1e4 = /*#__PURE__*/ $3OyDL.forwardRef(function DesktopDatePicker(inProps, ref) {
    var _defaultizedProps$yea, _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $7cf6384dc8d40c20$export$a552c17ed3587731)(inProps, 'MuiDesktopDatePicker');
    const viewRenderers = (0, $gOPoC.default)({
        day: (0, $494930d48812a2bb$export$69888ffe06193e5e),
        month: (0, $494930d48812a2bb$export$69888ffe06193e5e),
        year: (0, $494930d48812a2bb$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the desktop variant
    const props = (0, $gOPoC.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $915ec64656c7dd6f$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        yearsPerRow: (_defaultizedProps$yea = defaultizedProps.yearsPerRow) != null ? _defaultizedProps$yea : 4,
        slots: (0, $gOPoC.default)({
            openPickerIcon: (0, $77fe2edc650c8e6d$export$5fda1783bb83f57b),
            field: (0, $9e0a703a8327f82d$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $gOPoC.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $gOPoC.default)({}, (0, $b66ccc5bec543ea6$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $6899e10b900e4274$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $gOPoC.default)({
                hidden: true
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $bc32b77511da4487$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $286007e7644aad7a$export$2764b246aa3b75ba),
        valueType: 'date',
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openDatePickerDialogue) != null ? _props$localeText$ope : localeText.openDatePickerDialogue,
        validator: (0, $709ab20d38d8c90a$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$315750c4c3c3cac0$export$5a73641f0156e1e4.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $4e068a1bef6674c3$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        3,
        4
    ]),
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
            'all',
            'day',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number.isRequired
        })
    ]),
    /**
   * Disable specific date.
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        3,
        4
    ])
};



var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");




var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");




var $gOPoC = parcelRequire("gOPoC");
parcelRequire("3OyDL");




var $jH1k7 = parcelRequire("jH1k7");


var $2M70Q = parcelRequire("2M70Q");
const $3b8d38f26f397039$var$PickersModalDialogRoot = (0, $jH1k7.default)((0, $ee30f4276828974b$export$2e2bcd8739ae039))({
    [`& .${(0, $2fc9738b1d778be5$export$2e2bcd8739ae039).container}`]: {
        outline: 0
    },
    [`& .${(0, $2fc9738b1d778be5$export$2e2bcd8739ae039).paper}`]: {
        outline: 0,
        minWidth: (0, $c8ed6f2a54427aa9$export$ee46b8a74d6c94d3)
    }
});
const $3b8d38f26f397039$var$PickersModalDialogContent = (0, $jH1k7.default)((0, $b9097f1d6e2a4efc$export$2e2bcd8739ae039))({
    '&:first-of-type': {
        padding: 0
    }
});
function $3b8d38f26f397039$export$99f83c99e1491f77(props) {
    var _slots$dialog, _slots$mobileTransiti;
    const { children: children, onDismiss: onDismiss, open: open, slots: slots, slotProps: slotProps } = props;
    const Dialog = (_slots$dialog = slots == null ? void 0 : slots.dialog) != null ? _slots$dialog : $3b8d38f26f397039$var$PickersModalDialogRoot;
    const Transition = (_slots$mobileTransiti = slots == null ? void 0 : slots.mobileTransition) != null ? _slots$mobileTransiti : (0, $9c9203b21cd916fe$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $2M70Q.jsx)(Dialog, (0, $gOPoC.default)({
        open: open,
        onClose: onDismiss
    }, slotProps == null ? void 0 : slotProps.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps == null ? void 0 : slotProps.mobileTransition,
        PaperComponent: slots == null ? void 0 : slots.mobilePaper,
        PaperProps: slotProps == null ? void 0 : slotProps.mobilePaper,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($3b8d38f26f397039$var$PickersModalDialogContent, {
            children: children
        })
    }));
}








var $2M70Q = parcelRequire("2M70Q");
const $6b6b90550cc7fd15$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
];
const $6b6b90550cc7fd15$export$5ca0153a626a7dd7 = (_ref)=>{
    var _innerSlotProps$toolb, _innerSlotProps$toolb2, _slots$layout;
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $aBenZ.default)(_ref, $6b6b90550cc7fd15$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, timezone: timezone, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, localeText: localeText } = props;
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const internalInputRef = $3OyDL.useRef(null);
    const labelId = (0, $da50f700e88904fb$export$2e2bcd8739ae039)();
    const isToolbarHidden = (_innerSlotProps$toolb = innerSlotProps == null || (_innerSlotProps$toolb2 = innerSlotProps.toolbar) == null ? void 0 : _innerSlotProps$toolb2.hidden) != null ? _innerSlotProps$toolb : false;
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, fieldProps: pickerFieldProps } = (0, $4e4f7729fec91532$export$fc3313977ac596c4)((0, $gOPoC.default)({}, pickerParams, {
        props: props,
        inputRef: internalInputRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: 'mobile'
    }));
    const Field = slots.field;
    const fieldProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.field,
        additionalProps: (0, $gOPoC.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, !(disabled || readOnly) && {
            onClick: actions.onOpen,
            onKeyDown: (0, $c744f6b99d4ca951$export$4467fe8634707c85)(actions.onOpen)
        }, {
            readOnly: readOnly != null ? readOnly : true,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            timezone: timezone,
            label: label
        }),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    fieldProps.inputProps = (0, $gOPoC.default)({}, fieldProps.inputProps, {
        'aria-label': getOpenDialogAriaText(pickerFieldProps.value, utils)
    });
    const slotsForField = (0, $gOPoC.default)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = (_slots$layout = slots.layout) != null ? _slots$layout : (0, $1d0bfa2a9296ecf7$export$647f604ea2397c05);
    const handleInputRef = (0, $a0093ef70e9dc99d$export$2e2bcd8739ae039)(internalInputRef, fieldProps.inputRef, inputRef);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $gOPoC.default)({}, innerSlotProps, {
        toolbar: (0, $gOPoC.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $gOPoC.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps == null ? void 0 : innerSlotProps.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $0dca6c5826980612$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)(Field, (0, $gOPoC.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    inputRef: handleInputRef
                })),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3b8d38f26f397039$export$99f83c99e1491f77), (0, $gOPoC.default)({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)(Layout, (0, $gOPoC.default)({}, layoutProps, slotProps == null ? void 0 : slotProps.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};









const $1436612200e47fca$export$97b476d7a92fee62 = /*#__PURE__*/ $3OyDL.forwardRef(function MobileDatePicker(inProps, ref) {
    var _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $7cf6384dc8d40c20$export$a552c17ed3587731)(inProps, 'MuiMobileDatePicker');
    const viewRenderers = (0, $gOPoC.default)({
        day: (0, $494930d48812a2bb$export$69888ffe06193e5e),
        month: (0, $494930d48812a2bb$export$69888ffe06193e5e),
        year: (0, $494930d48812a2bb$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, $gOPoC.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $915ec64656c7dd6f$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        slots: (0, $gOPoC.default)({
            field: (0, $9e0a703a8327f82d$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $gOPoC.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $gOPoC.default)({}, (0, $b66ccc5bec543ea6$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $6899e10b900e4274$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $gOPoC.default)({
                hidden: false
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $6b6b90550cc7fd15$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $286007e7644aad7a$export$2764b246aa3b75ba),
        valueType: 'date',
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openDatePickerDialogue) != null ? _props$localeText$ope : localeText.openDatePickerDialogue,
        validator: (0, $709ab20d38d8c90a$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$1436612200e47fca$export$97b476d7a92fee62.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $4e068a1bef6674c3$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        3,
        4
    ]),
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
            'all',
            'day',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number.isRequired
        })
    ]),
    /**
   * Disable specific date.
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        3,
        4
    ])
};




var $2M70Q = parcelRequire("2M70Q");
const $8b9b7a71fee8ee09$var$_excluded = [
    "desktopModeMediaQuery"
];
const $8b9b7a71fee8ee09$export$5109c6dd95d8fb00 = /*#__PURE__*/ $3OyDL.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDatePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $c744f6b99d4ca951$export$9ae5b19305db48ce) } = props, other = (0, $aBenZ.default)(props, $8b9b7a71fee8ee09$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $315750c4c3c3cac0$export$5a73641f0156e1e4), (0, $gOPoC.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1436612200e47fca$export$97b476d7a92fee62), (0, $gOPoC.default)({
        ref: ref
    }, other));
});



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");



var $jFgmT = parcelRequire("jFgmT");


var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");





var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");



var $jFgmT = parcelRequire("jFgmT");



var $gOPoC = parcelRequire("gOPoC");




const $c324baf6fed40584$export$7bd013ac69eb590c = ({ adapter: adapter, value: value, props: props })=>{
    if (value === null) return null;
    const { minTime: minTime, maxTime: maxTime, minutesStep: minutesStep, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, disablePast: disablePast, disableFuture: disableFuture, timezone: timezone } = props;
    const now = adapter.utils.dateWithTimezone(undefined, timezone);
    const isAfter = (0, $ab8b9fd82a664ad3$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, adapter.utils);
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(minTime && isAfter(minTime, value)):
            return 'minTime';
        case Boolean(maxTime && isAfter(value, maxTime)):
            return 'maxTime';
        case Boolean(disableFuture && adapter.utils.isAfter(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.utils.isBefore(value, now)):
            return 'disablePast';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'hours')):
            return 'shouldDisableTime-hours';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'minutes')):
            return 'shouldDisableTime-minutes';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'seconds')):
            return 'shouldDisableTime-seconds';
        case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getHours(value), 'hours')):
            return 'shouldDisableClock-hours';
        case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getMinutes(value), 'minutes')):
            return 'shouldDisableClock-minutes';
        case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getSeconds(value), 'seconds')):
            return 'shouldDisableClock-seconds';
        case Boolean(minutesStep && adapter.utils.getMinutes(value) % minutesStep !== 0):
            return 'minutesStep';
        default:
            return null;
    }
};


const $6f21a188e7254b89$export$ed94a8ff1f54c4f = ({ props: props, value: value, adapter: adapter })=>{
    const dateValidationResult = (0, $709ab20d38d8c90a$export$ffb3d0046ef3a2)({
        adapter: adapter,
        value: value,
        props: props
    });
    if (dateValidationResult !== null) return dateValidationResult;
    return (0, $c324baf6fed40584$export$7bd013ac69eb590c)({
        adapter: adapter,
        value: value,
        props: props
    });
};





const $0f2b49caf9483bfe$var$useDefaultizedDateTimeField = (props)=>{
    var _props$ampm, _props$disablePast, _props$disableFuture, _props$format, _props$minDateTime, _props$maxDateTime, _props$minDateTime2, _props$maxDateTime2;
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const defaultDates = (0, $aa5fe19dd76d6423$export$7c38da3a2e90fa83)();
    const ampm = (_props$ampm = props.ampm) != null ? _props$ampm : utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.keyboardDateTime12h : utils.formats.keyboardDateTime24h;
    return (0, $gOPoC.default)({}, props, {
        disablePast: (_props$disablePast = props.disablePast) != null ? _props$disablePast : false,
        disableFuture: (_props$disableFuture = props.disableFuture) != null ? _props$disableFuture : false,
        format: (_props$format = props.format) != null ? _props$format : defaultFormat,
        disableIgnoringDatePartForTimeValidation: Boolean(props.minDateTime || props.maxDateTime),
        minDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, (_props$minDateTime = props.minDateTime) != null ? _props$minDateTime : props.minDate, defaultDates.minDate),
        maxDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, (_props$maxDateTime = props.maxDateTime) != null ? _props$maxDateTime : props.maxDate, defaultDates.maxDate),
        minTime: (_props$minDateTime2 = props.minDateTime) != null ? _props$minDateTime2 : props.minTime,
        maxTime: (_props$maxDateTime2 = props.maxDateTime) != null ? _props$maxDateTime2 : props.maxTime
    });
};
const $0f2b49caf9483bfe$export$2c2e7f1ceedfa8fa = ({ props: inProps, inputRef: inputRef })=>{
    const props = $0f2b49caf9483bfe$var$useDefaultizedDateTimeField(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $0325b003561ddae0$export$cdde224d2939fd84)(props, 'date-time');
    return (0, $4d47b8bcbcea9404$export$294aa081a6c6f55d)({
        inputRef: inputRef,
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $286007e7644aad7a$export$2764b246aa3b75ba),
        fieldValueManager: (0, $286007e7644aad7a$export$b602c94f557316b4),
        validator: (0, $6f21a188e7254b89$export$ed94a8ff1f54c4f),
        valueType: 'date-time'
    });
};



var $2M70Q = parcelRequire("2M70Q");
const $f4fcf5cb36bd78f1$var$_excluded = [
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
], $f4fcf5cb36bd78f1$var$_excluded2 = [
    "inputRef"
], $f4fcf5cb36bd78f1$var$_excluded3 = [
    "ref",
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly"
];
const $f4fcf5cb36bd78f1$export$ae1ced156568f0b0 = /*#__PURE__*/ $3OyDL.forwardRef(function DateTimeField(inProps, ref) {
    var _ref, _slots$textField, _slotProps$textField;
    const themeProps = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDateTimeField'
    });
    const { components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $aBenZ.default)(themeProps, $f4fcf5cb36bd78f1$var$_excluded);
    const ownerState = themeProps;
    const TextField = (_ref = (_slots$textField = slots == null ? void 0 : slots.textField) != null ? _slots$textField : components == null ? void 0 : components.TextField) != null ? _ref : (0, $328e9bc68740648b$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: TextField,
        externalSlotProps: (_slotProps$textField = slotProps == null ? void 0 : slotProps.textField) != null ? _slotProps$textField : componentsProps == null ? void 0 : componentsProps.textField,
        externalForwardedProps: other,
        ownerState: ownerState
    }), { inputRef: externalInputRef } = _useSlotProps, textFieldProps = (0, $aBenZ.default)(_useSlotProps, $f4fcf5cb36bd78f1$var$_excluded2);
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $gOPoC.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $gOPoC.default)({}, InputProps, textFieldProps.InputProps);
    const _useDateTimeField = (0, $0f2b49caf9483bfe$export$2c2e7f1ceedfa8fa)({
        props: textFieldProps,
        inputRef: externalInputRef
    }), { ref: inputRef, onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly } = _useDateTimeField, fieldProps = (0, $aBenZ.default)(_useDateTimeField, $f4fcf5cb36bd78f1$var$_excluded3);
    return /*#__PURE__*/ (0, $2M70Q.jsx)(TextField, (0, $gOPoC.default)({
        ref: ref
    }, fieldProps, {
        InputProps: (0, $gOPoC.default)({}, fieldProps.InputProps, {
            readOnly: readOnly
        }),
        inputProps: (0, $gOPoC.default)({}, fieldProps.inputProps, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    }));
});



var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $jFgmT = parcelRequire("jFgmT");



var $3OyDL = parcelRequire("3OyDL");




var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");




function $3b531fb3d351106b$export$c994a6b377ce38df(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiDateTimePickerTabs', slot);
}
const $3b531fb3d351106b$export$a2a6922f6f97d267 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiDateTimePickerTabs', [
    'root'
]);




var $2M70Q = parcelRequire("2M70Q");
const $5edc6ef12de476a5$var$viewToTab = (view)=>{
    if ((0, $915ec64656c7dd6f$export$b32dfef9f07dea64)(view)) return 'date';
    return 'time';
};
const $5edc6ef12de476a5$var$tabToView = (tab)=>{
    if (tab === 'date') return 'day';
    return 'hours';
};
const $5edc6ef12de476a5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $3b531fb3d351106b$export$c994a6b377ce38df), classes);
};
const $5edc6ef12de476a5$var$DateTimePickerTabsRoot = (0, $jH1k7.default)((0, $300390f560fe3d4d$export$2e2bcd8739ae039), {
    name: 'MuiDateTimePickerTabs',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        boxShadow: `0 -1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
        '&:last-child': {
            boxShadow: `0 1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
            [`& .${(0, $add293d9d9766538$export$2e2bcd8739ae039).indicator}`]: {
                bottom: 'auto',
                top: 0
            }
        }
    }));
const $5edc6ef12de476a5$export$95dfad4074502244 = function DateTimePickerTabs(inProps) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDateTimePickerTabs'
    });
    const { dateIcon: dateIcon = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $77fe2edc650c8e6d$export$90a8eab2a2411720), {}), onViewChange: onViewChange, timeIcon: timeIcon = /*#__PURE__*/ (0, $2M70Q.jsx)((0, $77fe2edc650c8e6d$export$7e95adcf912503e3), {}), view: view, hidden: hidden = typeof window === 'undefined' || window.innerHeight < 667 } = props;
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const classes = $5edc6ef12de476a5$var$useUtilityClasses(props);
    const handleChange = (event, value)=>{
        onViewChange($5edc6ef12de476a5$var$tabToView(value));
    };
    if (hidden) return null;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($5edc6ef12de476a5$var$DateTimePickerTabsRoot, {
        ownerState: props,
        variant: "fullWidth",
        value: $5edc6ef12de476a5$var$viewToTab(view),
        onChange: handleChange,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                value: "date",
                "aria-label": localeText.dateTableLabel,
                icon: /*#__PURE__*/ (0, $2M70Q.jsx)($3OyDL.Fragment, {
                    children: dateIcon
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                value: "time",
                "aria-label": localeText.timeTableLabel,
                icon: /*#__PURE__*/ (0, $2M70Q.jsx)($3OyDL.Fragment, {
                    children: timeIcon
                })
            })
        ]
    });
};



var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");


var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");


var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");


function $75df3979b62da5aa$export$2aab7addfa1bc589(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiPickersToolbarText', slot);
}
const $75df3979b62da5aa$export$4ca7b92014bf2e56 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiPickersToolbarText', [
    'root',
    'selected'
]);



var $2M70Q = parcelRequire("2M70Q");
const $c025e4f1e796799f$var$_excluded = [
    "className",
    "selected",
    "value"
];
const $c025e4f1e796799f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $75df3979b62da5aa$export$2aab7addfa1bc589), classes);
};
const $c025e4f1e796799f$var$PickersToolbarTextRoot = (0, $jH1k7.default)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
    name: 'MuiPickersToolbarText',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $75df3979b62da5aa$export$4ca7b92014bf2e56).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        transition: theme.transitions.create('color'),
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $75df3979b62da5aa$export$4ca7b92014bf2e56).selected}`]: {
            color: (theme.vars || theme).palette.text.primary
        }
    }));
const $c025e4f1e796799f$export$2006bc630443fa2 = /*#__PURE__*/ $3OyDL.forwardRef(function PickersToolbarText(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPickersToolbarText'
    });
    const { className: className, value: value } = props, other = (0, $aBenZ.default)(props, $c025e4f1e796799f$var$_excluded);
    const classes = $c025e4f1e796799f$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($c025e4f1e796799f$var$PickersToolbarTextRoot, (0, $gOPoC.default)({
        ref: ref,
        className: (0, $3DmQB.default)(className, classes.root),
        component: "span"
    }, other, {
        children: value
    }));
});




var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");


var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");




var $2M70Q = parcelRequire("2M70Q");
const $649e0ffc269e8c93$var$_excluded = [
    "align",
    "className",
    "selected",
    "typographyClassName",
    "value",
    "variant",
    "width"
];
const $649e0ffc269e8c93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $3b30ba85142e2c48$export$b109c489973c3d80), classes);
};
const $649e0ffc269e8c93$var$PickersToolbarButtonRoot = (0, $jH1k7.default)((0, $a55b2c6a514356c8$export$2e2bcd8739ae039), {
    name: 'MuiPickersToolbarButton',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    padding: 0,
    minWidth: 16,
    textTransform: 'none'
});
const $649e0ffc269e8c93$export$614ed940168c780c = /*#__PURE__*/ $3OyDL.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiPickersToolbarButton'
    });
    const { align: align, className: className, selected: selected, typographyClassName: typographyClassName, value: value, variant: variant, width: width } = props, other = (0, $aBenZ.default)(props, $649e0ffc269e8c93$var$_excluded);
    const classes = $649e0ffc269e8c93$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($649e0ffc269e8c93$var$PickersToolbarButtonRoot, (0, $gOPoC.default)({
        variant: "text",
        ref: ref,
        className: (0, $3DmQB.default)(className, classes.root)
    }, width ? {
        sx: {
            width: width
        }
    } : {}, other, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c025e4f1e796799f$export$2006bc630443fa2), {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});




function $e4e9d438bbec05d4$export$c40f5731216f0c9d(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiDateTimePickerToolbar', slot);
}
const $e4e9d438bbec05d4$export$82ac739c3153ffd4 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiDateTimePickerToolbar', [
    'root',
    'dateContainer',
    'timeContainer',
    'timeDigitsContainer',
    'separator',
    'timeLabelReverse',
    'ampmSelection',
    'ampmLandscape',
    'ampmLabel'
]);






var $2M70Q = parcelRequire("2M70Q");
const $db769c5ec6705774$var$_excluded = [
    "ampm",
    "ampmInClock",
    "value",
    "onChange",
    "view",
    "isLandscape",
    "onViewChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views",
    "disabled",
    "readOnly",
    "toolbarVariant"
];
const $db769c5ec6705774$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, theme: theme, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        dateContainer: [
            'dateContainer'
        ],
        timeContainer: [
            'timeContainer',
            theme.direction === 'rtl' && 'timeLabelReverse'
        ],
        timeDigitsContainer: [
            'timeDigitsContainer',
            theme.direction === 'rtl' && 'timeLabelReverse'
        ],
        separator: [
            'separator'
        ],
        ampmSelection: [
            'ampmSelection',
            isLandscape && 'ampmLandscape'
        ],
        ampmLabel: [
            'ampmLabel'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $e4e9d438bbec05d4$export$c40f5731216f0c9d), classes);
};
const $db769c5ec6705774$var$DateTimePickerToolbarRoot = (0, $jH1k7.default)((0, $fcd14893ba098a3f$export$eb3c4d84783d6feb), {
    name: 'MuiDateTimePickerToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>({
        paddingLeft: ownerState.toolbarVariant === 'desktop' && !ownerState.isLandscape ? 24 : 16,
        paddingRight: ownerState.toolbarVariant === 'desktop' && !ownerState.isLandscape ? 0 : 16,
        borderBottom: ownerState.toolbarVariant === 'desktop' ? `1px solid ${(theme.vars || theme).palette.divider}` : undefined,
        borderRight: ownerState.toolbarVariant === 'desktop' && ownerState.isLandscape ? `1px solid ${(theme.vars || theme).palette.divider}` : undefined,
        justifyContent: 'space-around',
        position: 'relative'
    }));
$db769c5ec6705774$var$DateTimePickerToolbarRoot.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).elementType,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).string,
    isLandscape: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool.isRequired,
    isMobileKeyboardViewOpen: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    landscapeDirection: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'column',
        'row'
    ]),
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object.isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object
    ]),
    toggleMobileKeyboardView: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    toolbarTitle: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).node,
    viewType: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'date',
        'time'
    ])
};
const $db769c5ec6705774$var$DateTimePickerToolbarDateContainer = (0, $jH1k7.default)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'DateContainer',
    overridesResolver: (props, styles)=>styles.dateContainer
})({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
});
const $db769c5ec6705774$var$DateTimePickerToolbarTimeContainer = (0, $jH1k7.default)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'TimeContainer',
    overridesResolver: (props, styles)=>styles.timeContainer
})(({ theme: theme, ownerState: ownerState })=>{
    const direction = ownerState.isLandscape && ownerState.toolbarVariant !== 'desktop' ? 'column' : 'row';
    return (0, $gOPoC.default)({
        display: 'flex',
        flexDirection: direction
    }, ownerState.toolbarVariant === 'desktop' && (0, $gOPoC.default)({}, !ownerState.isLandscape && {
        gap: 9,
        marginRight: 4,
        alignSelf: 'flex-end'
    }), theme.direction === 'rtl' && {
        flexDirection: `${direction}-reverse`
    });
});
const $db769c5ec6705774$var$DateTimePickerToolbarTimeDigitsContainer = (0, $jH1k7.default)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'TimeDigitsContainer',
    overridesResolver: (props, styles)=>styles.timeDigitsContainer
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'flex'
    }, ownerState.toolbarVariant === 'desktop' && {
        gap: 1.5
    }, theme.direction === 'rtl' && {
        flexDirection: 'row-reverse'
    }));
$db769c5ec6705774$var$DateTimePickerToolbarTimeContainer.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object.isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object
    ])
};
const $db769c5ec6705774$var$DateTimePickerToolbarSeparator = (0, $jH1k7.default)((0, $c025e4f1e796799f$export$2006bc630443fa2), {
    name: 'MuiDateTimePickerToolbar',
    slot: 'Separator',
    overridesResolver: (props, styles)=>styles.separator
})(({ ownerState: ownerState })=>({
        margin: ownerState.toolbarVariant === 'desktop' ? 0 : '0 4px 0 2px',
        cursor: 'default'
    }));
// Taken from TimePickerToolbar
const $db769c5ec6705774$var$DateTimePickerToolbarAmPmSelection = (0, $jH1k7.default)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'AmPmSelection',
    overridesResolver: (props, styles)=>[
            {
                [`.${(0, $e4e9d438bbec05d4$export$82ac739c3153ffd4).ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${(0, $e4e9d438bbec05d4$export$82ac739c3153ffd4).ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'flex',
        flexDirection: 'column',
        marginRight: 'auto',
        marginLeft: 12
    }, ownerState.isLandscape && {
        margin: '4px 0 auto',
        flexDirection: 'row',
        justifyContent: 'space-around',
        width: '100%'
    }, {
        [`& .${(0, $e4e9d438bbec05d4$export$82ac739c3153ffd4).ampmLabel}`]: {
            fontSize: 17
        }
    }));
function $db769c5ec6705774$export$fe4ab7cbc0078243(inProps) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDateTimePickerToolbar'
    });
    const { ampm: ampm, ampmInClock: ampmInClock, value: value, onChange: onChange, view: view, isLandscape: isLandscape, onViewChange: onViewChange, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", views: views, disabled: disabled, readOnly: readOnly, toolbarVariant: toolbarVariant = 'mobile' } = props, other = (0, $aBenZ.default)(props, $db769c5ec6705774$var$_excluded);
    const ownerState = props;
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $6bc09be28b20c2f3$export$6aaabc31cb076d17)(value, ampm, onChange);
    const showAmPmControl = Boolean(ampm && !ampmInClock);
    const isDesktop = toolbarVariant === 'desktop';
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const classes = $db769c5ec6705774$var$useUtilityClasses((0, $gOPoC.default)({}, ownerState, {
        theme: theme
    }));
    const formatHours = (time)=>ampm ? utils.format(time, 'hours12h') : utils.format(time, 'hours24h');
    const dateText = $3OyDL.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        if (toolbarFormat) return utils.formatByString(value, toolbarFormat);
        return utils.format(value, 'shortDate');
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($db769c5ec6705774$var$DateTimePickerToolbarRoot, (0, $gOPoC.default)({
        toolbarTitle: localeText.dateTimePickerToolbarTitle,
        isLandscape: isLandscape,
        className: classes.root
    }, other, {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)($db769c5ec6705774$var$DateTimePickerToolbarDateContainer, {
                className: classes.dateContainer,
                ownerState: ownerState,
                children: [
                    views.includes('year') && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $649e0ffc269e8c93$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: "subtitle1",
                        onClick: ()=>onViewChange('year'),
                        selected: view === 'year',
                        value: value ? utils.format(value, 'year') : "\u2013"
                    }),
                    views.includes('day') && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $649e0ffc269e8c93$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: isDesktop ? 'h5' : 'h4',
                        onClick: ()=>onViewChange('day'),
                        selected: view === 'day',
                        value: dateText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)($db769c5ec6705774$var$DateTimePickerToolbarTimeContainer, {
                className: classes.timeContainer,
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)($db769c5ec6705774$var$DateTimePickerToolbarTimeDigitsContainer, {
                        className: classes.timeDigitsContainer,
                        ownerState: ownerState,
                        children: [
                            views.includes('hours') && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $649e0ffc269e8c93$export$614ed940168c780c), {
                                variant: isDesktop ? 'h5' : 'h3',
                                width: isDesktop && !isLandscape ? (0, $c8ed6f2a54427aa9$export$a462ceb9cfdb5d71) : undefined,
                                onClick: ()=>onViewChange('hours'),
                                selected: view === 'hours',
                                value: value ? formatHours(value) : '--'
                            }),
                            views.includes('minutes') && /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)($db769c5ec6705774$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $649e0ffc269e8c93$export$614ed940168c780c), {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && !isLandscape ? (0, $c8ed6f2a54427aa9$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>onViewChange('minutes'),
                                        selected: view === 'minutes',
                                        value: value ? utils.format(value, 'minutes') : '--'
                                    })
                                ]
                            }),
                            views.includes('seconds') && /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)($db769c5ec6705774$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $649e0ffc269e8c93$export$614ed940168c780c), {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && !isLandscape ? (0, $c8ed6f2a54427aa9$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>onViewChange('seconds'),
                                        selected: view === 'seconds',
                                        value: value ? utils.format(value, 'seconds') : '--'
                                    })
                                ]
                            })
                        ]
                    }),
                    showAmPmControl && !isDesktop && /*#__PURE__*/ (0, $2M70Q.jsxs)($db769c5ec6705774$var$DateTimePickerToolbarAmPmSelection, {
                        className: classes.ampmSelection,
                        ownerState: ownerState,
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $649e0ffc269e8c93$export$614ed940168c780c), {
                                variant: "subtitle2",
                                selected: meridiemMode === 'am',
                                typographyClassName: classes.ampmLabel,
                                value: (0, $915ec64656c7dd6f$export$fae94c0a662107ef)(utils, 'am'),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $649e0ffc269e8c93$export$614ed940168c780c), {
                                variant: "subtitle2",
                                selected: meridiemMode === 'pm',
                                typographyClassName: classes.ampmLabel,
                                value: (0, $915ec64656c7dd6f$export$fae94c0a662107ef)(utils, 'pm'),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                                disabled: disabled
                            })
                        ]
                    }),
                    ampm && isDesktop && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $649e0ffc269e8c93$export$614ed940168c780c), {
                        variant: "h5",
                        onClick: ()=>onViewChange('meridiem'),
                        selected: view === 'meridiem',
                        value: value && meridiemMode ? (0, $915ec64656c7dd6f$export$fae94c0a662107ef)(utils, meridiemMode) : '--',
                        width: (0, $c8ed6f2a54427aa9$export$a462ceb9cfdb5d71)
                    })
                ]
            })
        ]
    }));
}




function $a4651057013a765e$export$6e4d96e87e6dc2d3(props, name) {
    var _themeProps$ampm, _themeProps$slots, _themeProps$slotProps, _themeProps$orientati, _themeProps$disableIg, _themeProps$disableFu, _themeProps$disablePa, _themeProps$minDateTi, _themeProps$maxDateTi, _themeProps$minDateTi2, _themeProps$maxDateTi2;
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const defaultDates = (0, $aa5fe19dd76d6423$export$7c38da3a2e90fa83)();
    const themeProps = (0, $jFgmT.default)({
        props: props,
        name: name
    });
    const ampm = (_themeProps$ampm = themeProps.ampm) != null ? _themeProps$ampm : utils.is12HourCycleInCurrentLocale();
    const localeText = $3OyDL.useMemo(()=>{
        var _themeProps$localeTex;
        if (((_themeProps$localeTex = themeProps.localeText) == null ? void 0 : _themeProps$localeTex.toolbarTitle) == null) return themeProps.localeText;
        return (0, $gOPoC.default)({}, themeProps.localeText, {
            dateTimePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const slots = (_themeProps$slots = themeProps.slots) != null ? _themeProps$slots : (0, $95ed0f26a5eee9f7$export$ee17bc394843b249)(themeProps.components);
    const slotProps = (_themeProps$slotProps = themeProps.slotProps) != null ? _themeProps$slotProps : themeProps.componentsProps;
    return (0, $gOPoC.default)({}, themeProps, (0, $77b769676d9b7e67$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day',
            'hours',
            'minutes'
        ],
        defaultOpenTo: 'day'
    }), {
        ampm: ampm,
        localeText: localeText,
        orientation: (_themeProps$orientati = themeProps.orientation) != null ? _themeProps$orientati : 'portrait',
        // TODO: Remove from public API
        disableIgnoringDatePartForTimeValidation: (_themeProps$disableIg = themeProps.disableIgnoringDatePartForTimeValidation) != null ? _themeProps$disableIg : Boolean(themeProps.minDateTime || themeProps.maxDateTime || // allow time clock to correctly check time validity: https://github.com/mui/mui-x/issues/8520
        themeProps.disablePast || themeProps.disableFuture),
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        minDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, (_themeProps$minDateTi = themeProps.minDateTime) != null ? _themeProps$minDateTi : themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $915ec64656c7dd6f$export$eb73579ccade48fd)(utils, (_themeProps$maxDateTi = themeProps.maxDateTime) != null ? _themeProps$maxDateTi : themeProps.maxDate, defaultDates.maxDate),
        minTime: (_themeProps$minDateTi2 = themeProps.minDateTime) != null ? _themeProps$minDateTi2 : themeProps.minTime,
        maxTime: (_themeProps$maxDateTi2 = themeProps.maxDateTime) != null ? _themeProps$maxDateTi2 : themeProps.maxTime,
        slots: (0, $gOPoC.default)({
            toolbar: (0, $db769c5ec6705774$export$fe4ab7cbc0078243),
            tabs: (0, $5edc6ef12de476a5$export$95dfad4074502244)
        }, slots),
        slotProps: (0, $gOPoC.default)({}, slotProps, {
            toolbar: (0, $gOPoC.default)({
                ampm: ampm
            }, slotProps == null ? void 0 : slotProps.toolbar)
        })
    });
}




var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");


var $2M70Q = parcelRequire("2M70Q");
'use client';
const $18cdc96991ab6ed1$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $18cdc96991ab6ed1$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $339578e4784e018b$export$46f01d01378ec5a2), classes);
};
const $18cdc96991ab6ed1$var$DividerRoot = (0, $jH1k7.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $7m2iU.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $gOPoC.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $gOPoC.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $18cdc96991ab6ed1$var$DividerWrapper = (0, $jH1k7.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $18cdc96991ab6ed1$var$Divider = /*#__PURE__*/ $3OyDL.forwardRef(function Divider(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $aBenZ.default)(props, $18cdc96991ab6ed1$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $18cdc96991ab6ed1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($18cdc96991ab6ed1$var$DividerRoot, (0, $gOPoC.default)({
        as: component,
        className: (0, $3DmQB.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $2M70Q.jsx)($18cdc96991ab6ed1$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $18cdc96991ab6ed1$var$Divider.muiSkipListHighlight = true;
var $18cdc96991ab6ed1$export$2e2bcd8739ae039 = $18cdc96991ab6ed1$var$Divider;





var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");


var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");









function $8d3126c44617153e$export$b828b7724b7b2890(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiMultiSectionDigitalClock', slot);
}
const $8d3126c44617153e$export$f2277d947b8f7a8a = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiMultiSectionDigitalClock', [
    'root'
]);



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");

var $7m2iU = parcelRequire("7m2iU");
var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");






function $76de10a53612e3ad$export$ab23463cad6963ff(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiMultiSectionDigitalClock', slot);
}
const $76de10a53612e3ad$export$eaf2b63fa45eff23 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiMultiSectionDigitalClock', [
    'root',
    'item'
]);




var $2M70Q = parcelRequire("2M70Q");
const $65ece1406ca94c3d$var$_excluded = [
    "autoFocus",
    "onChange",
    "className",
    "disabled",
    "readOnly",
    "items",
    "active",
    "slots",
    "slotProps",
    "skipDisabled"
];
const $65ece1406ca94c3d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        item: [
            'item'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $76de10a53612e3ad$export$ab23463cad6963ff), classes);
};
const $65ece1406ca94c3d$var$MultiSectionDigitalClockSectionRoot = (0, $jH1k7.default)((0, $ae62bf342774ffad$export$2e2bcd8739ae039), {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>({
        maxHeight: (0, $c8ed6f2a54427aa9$export$1c2eabda4acea0e4),
        width: 56,
        padding: 0,
        overflow: 'hidden',
        '@media (prefers-reduced-motion: no-preference)': {
            scrollBehavior: ownerState.alreadyRendered ? 'smooth' : 'auto'
        },
        '&:hover': {
            overflowY: 'auto'
        },
        '&:not(:first-of-type)': {
            borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        '&:after': {
            display: 'block',
            content: '""',
            // subtracting the height of one item, extra margin and borders to make sure the max height is correct
            height: 'calc(100% - 40px - 6px)'
        }
    }));
const $65ece1406ca94c3d$var$MultiSectionDigitalClockSectionItem = (0, $jH1k7.default)((0, $c79ba0e99ec70dbd$export$2e2bcd8739ae039), {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Item',
    overridesResolver: (_, styles)=>styles.item
})(({ theme: theme })=>({
        padding: 8,
        margin: '2px 4px',
        width: (0, $c8ed6f2a54427aa9$export$a462ceb9cfdb5d71),
        justifyContent: 'center',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $65ece1406ca94c3d$export$f971f93dc8464c = /*#__PURE__*/ $3OyDL.forwardRef(function MultiSectionDigitalClockSection(inProps, ref) {
    var _slots$digitalClockSe;
    const containerRef = $3OyDL.useRef(null);
    const handleRef = (0, $a0093ef70e9dc99d$export$2e2bcd8739ae039)(ref, containerRef);
    const previousSelected = $3OyDL.useRef(null);
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClockSection'
    });
    const { autoFocus: autoFocus, onChange: onChange, className: className, disabled: disabled, readOnly: readOnly, items: items, active: active, slots: slots, slotProps: slotProps, skipDisabled: skipDisabled } = props, other = (0, $aBenZ.default)(props, $65ece1406ca94c3d$var$_excluded);
    const ownerState = $3OyDL.useMemo(()=>(0, $gOPoC.default)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $65ece1406ca94c3d$var$useUtilityClasses(ownerState);
    const DigitalClockSectionItem = (_slots$digitalClockSe = slots == null ? void 0 : slots.digitalClockSectionItem) != null ? _slots$digitalClockSe : $65ece1406ca94c3d$var$MultiSectionDigitalClockSectionItem;
    $3OyDL.useEffect(()=>{
        if (containerRef.current === null) return;
        const selectedItem = containerRef.current.querySelector('[role="option"][aria-selected="true"]');
        if (!selectedItem || previousSelected.current === selectedItem) {
            // Handle setting the ref to null if the selected item is ever reset via UI
            if (previousSelected.current !== selectedItem) previousSelected.current = selectedItem;
            return;
        }
        previousSelected.current = selectedItem;
        if (active && autoFocus) selectedItem.focus();
        const offsetTop = selectedItem.offsetTop;
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)($65ece1406ca94c3d$var$MultiSectionDigitalClockSectionRoot, (0, $gOPoC.default)({
        ref: handleRef,
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        autoFocusItem: autoFocus && active,
        role: "listbox"
    }, other, {
        children: items.map((option)=>{
            var _option$isDisabled, _option$isDisabled2;
            if (skipDisabled && (_option$isDisabled = option.isDisabled) != null && _option$isDisabled.call(option, option.value)) return null;
            const isSelected = option.isSelected(option.value);
            return /*#__PURE__*/ (0, $2M70Q.jsx)(DigitalClockSectionItem, (0, $gOPoC.default)({
                onClick: ()=>!readOnly && onChange(option.value),
                selected: isSelected,
                disabled: disabled || ((_option$isDisabled2 = option.isDisabled) == null ? void 0 : _option$isDisabled2.call(option, option.value)),
                disableRipple: readOnly,
                role: "option",
                "aria-disabled": readOnly,
                "aria-label": option.ariaLabel,
                "aria-selected": isSelected
            }, slotProps == null ? void 0 : slotProps.digitalClockSectionItem, {
                children: option.label
            }), option.label);
        })
    }));
});


const $c09569dd716a0551$export$9101aa7ba362bb4e = ({ now: now, value: value, utils: utils, ampm: ampm, isDisabled: isDisabled, resolveAriaLabel: resolveAriaLabel, timeStep: timeStep })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const result = [];
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    const endHour = ampm ? 11 : 23;
    for(let hour = 0; hour <= endHour; hour += timeStep){
        let label = utils.format(utils.setHours(now, hour), ampm ? 'hours12h' : 'hours24h');
        const ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
        label = utils.formatNumber(label);
        result.push({
            value: hour,
            label: label,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaLabel: ariaLabel
        });
    }
    return result;
};
const $c09569dd716a0551$export$e7b56db95f8a7b9c = ({ value: value, isDisabled: isDisabled, timeStep: timeStep, resolveLabel: resolveLabel, resolveAriaLabel: resolveAriaLabel, hasValue: hasValue = true })=>{
    const isSelected = (timeValue)=>{
        if (value === null) return false;
        return hasValue && value === timeValue;
    };
    return [
        ...Array.from({
            length: Math.ceil(60 / timeStep)
        }, (_, index)=>{
            const timeValue = timeStep * index;
            return {
                value: timeValue,
                label: resolveLabel(timeValue),
                isDisabled: isDisabled,
                isSelected: isSelected,
                ariaLabel: resolveAriaLabel(timeValue.toString())
            };
        })
    ];
};





var $3OyDL = parcelRequire("3OyDL");



const $a6068267c72c4439$export$86ee3b7a301faaa3 = ({ value: value, referenceDate: referenceDateProp, utils: utils, props: props, timezone: timezone })=>{
    const referenceDate = $3OyDL.useMemo(()=>(0, $286007e7644aad7a$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            referenceDate: referenceDateProp,
            granularity: (0, $296cf343c750d880$export$8f74e8f4ed8ae0ac).day,
            timezone: timezone,
            getTodayDate: ()=>(0, $915ec64656c7dd6f$export$1118e4272ea1e258)(utils, timezone, 'date')
        }), // We only want to compute the reference date on mount.
    [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return value != null ? value : referenceDate;
};




var $2M70Q = parcelRequire("2M70Q");
const $f2ca009ebc6e8f6c$var$_excluded = [
    "ampm",
    "timeSteps",
    "autoFocus",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableClock",
    "shouldDisableTime",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "skipDisabled",
    "timezone"
];
const $f2ca009ebc6e8f6c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $8d3126c44617153e$export$b828b7724b7b2890), classes);
};
const $f2ca009ebc6e8f6c$var$MultiSectionDigitalClockRoot = (0, $jH1k7.default)((0, $86e2d434c5b86080$export$512b066b8abdfde4), {
    name: 'MuiMultiSectionDigitalClock',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $f2ca009ebc6e8f6c$export$c48dada788ff933b = /*#__PURE__*/ $3OyDL.forwardRef(function MultiSectionDigitalClock(inProps, ref) {
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClock'
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeSteps: inTimeSteps, autoFocus: autoFocus, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, views: inViews = [
        'hours',
        'minutes'
    ], openTo: openTo, onViewChange: onViewChange, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $aBenZ.default)(props, $f2ca009ebc6e8f6c$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $c1a1b9e58f0b723e$export$174d749f3b4c0f49)({
        name: 'MultiSectionDigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $286007e7644aad7a$export$2764b246aa3b75ba)
    });
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const now = (0, $aa5fe19dd76d6423$export$3a404aece3dff2fa)(timezone);
    const timeSteps = $3OyDL.useMemo(()=>(0, $gOPoC.default)({
            hours: 1,
            minutes: 5,
            seconds: 5
        }, inTimeSteps), [
        inTimeSteps
    ]);
    const valueOrReferenceDate = (0, $a6068267c72c4439$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newValue, selectionState, selectedView)=>handleRawValueChange(newValue, selectionState, selectedView));
    const views = $3OyDL.useMemo(()=>{
        if (!ampm || !inViews.includes('hours')) return inViews;
        return inViews.includes('meridiem') ? inViews : [
            ...inViews,
            'meridiem'
        ];
    }, [
        ampm,
        inViews
    ]);
    const { view: view, setValueAndGoToView: setValueAndGoToView, focusedView: focusedView } = (0, $f3f961a3b0e6e0b6$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleMeridiemValueChange = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newValue)=>{
        setValueAndGoToView(newValue, null, 'meridiem');
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $6bc09be28b20c2f3$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, handleMeridiemValueChange, 'finish');
    const isTimeDisabled = $3OyDL.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $ab8b9fd82a664ad3$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableClock != null && shouldDisableClock(timeValue, viewType)) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, $ab8b9fd82a664ad3$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableClock,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const handleSectionChange = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((sectionView, newValue)=>{
        const viewIndex = views.indexOf(sectionView);
        const nextView = views[viewIndex + 1];
        setValueAndGoToView(newValue, nextView, sectionView);
    });
    const buildViewProps = $3OyDL.useCallback((viewToBuild)=>{
        switch(viewToBuild){
            case 'hours':
                return {
                    onChange: (hours)=>{
                        const valueWithMeridiem = (0, $ab8b9fd82a664ad3$export$4159dc823695870e)(hours, meridiemMode, ampm);
                        handleSectionChange('hours', utils.setHours(valueOrReferenceDate, valueWithMeridiem));
                    },
                    items: (0, $c09569dd716a0551$export$9101aa7ba362bb4e)({
                        now: now,
                        value: value,
                        ampm: ampm,
                        utils: utils,
                        isDisabled: (hours)=>disabled || isTimeDisabled(hours, 'hours'),
                        timeStep: timeSteps.hours,
                        resolveAriaLabel: localeText.hoursClockNumberText
                    })
                };
            case 'minutes':
                return {
                    onChange: (minutes)=>{
                        handleSectionChange('minutes', utils.setMinutes(valueOrReferenceDate, minutes));
                    },
                    items: (0, $c09569dd716a0551$export$e7b56db95f8a7b9c)({
                        value: utils.getMinutes(valueOrReferenceDate),
                        isDisabled: (minutes)=>disabled || isTimeDisabled(minutes, 'minutes'),
                        resolveLabel: (minutes)=>utils.format(utils.setMinutes(now, minutes), 'minutes'),
                        timeStep: timeSteps.minutes,
                        hasValue: !!value,
                        resolveAriaLabel: localeText.minutesClockNumberText
                    })
                };
            case 'seconds':
                return {
                    onChange: (seconds)=>{
                        handleSectionChange('seconds', utils.setSeconds(valueOrReferenceDate, seconds));
                    },
                    items: (0, $c09569dd716a0551$export$e7b56db95f8a7b9c)({
                        value: utils.getSeconds(valueOrReferenceDate),
                        isDisabled: (seconds)=>disabled || isTimeDisabled(seconds, 'seconds'),
                        resolveLabel: (seconds)=>utils.format(utils.setSeconds(now, seconds), 'seconds'),
                        timeStep: timeSteps.seconds,
                        hasValue: !!value,
                        resolveAriaLabel: localeText.secondsClockNumberText
                    })
                };
            case 'meridiem':
                {
                    const amLabel = (0, $915ec64656c7dd6f$export$fae94c0a662107ef)(utils, 'am');
                    const pmLabel = (0, $915ec64656c7dd6f$export$fae94c0a662107ef)(utils, 'pm');
                    return {
                        onChange: handleMeridiemChange,
                        items: [
                            {
                                value: 'am',
                                label: amLabel,
                                isSelected: ()=>!!value && meridiemMode === 'am',
                                ariaLabel: amLabel
                            },
                            {
                                value: 'pm',
                                label: pmLabel,
                                isSelected: ()=>!!value && meridiemMode === 'pm',
                                ariaLabel: pmLabel
                            }
                        ]
                    };
                }
            default:
                throw new Error(`Unknown view: ${viewToBuild} found.`);
        }
    }, [
        now,
        value,
        ampm,
        utils,
        timeSteps.hours,
        timeSteps.minutes,
        timeSteps.seconds,
        localeText.hoursClockNumberText,
        localeText.minutesClockNumberText,
        localeText.secondsClockNumberText,
        meridiemMode,
        handleSectionChange,
        valueOrReferenceDate,
        disabled,
        isTimeDisabled,
        handleMeridiemChange
    ]);
    const viewTimeOptions = $3OyDL.useMemo(()=>{
        return views.reduce((result, currentView)=>{
            return (0, $gOPoC.default)({}, result, {
                [currentView]: buildViewProps(currentView)
            });
        }, {});
    }, [
        views,
        buildViewProps
    ]);
    const ownerState = props;
    const classes = $f2ca009ebc6e8f6c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($f2ca009ebc6e8f6c$var$MultiSectionDigitalClockRoot, (0, $gOPoC.default)({
        ref: ref,
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        role: "group"
    }, other, {
        children: Object.entries(viewTimeOptions).map(([timeView, viewOptions])=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $65ece1406ca94c3d$export$f971f93dc8464c), {
                items: viewOptions.items,
                onChange: viewOptions.onChange,
                active: view === timeView,
                autoFocus: autoFocus != null ? autoFocus : focusedView === timeView,
                disabled: disabled,
                readOnly: readOnly,
                slots: slots != null ? slots : components,
                slotProps: slotProps != null ? slotProps : componentsProps,
                skipDisabled: skipDisabled,
                "aria-label": localeText.selectViewText(timeView)
            }, timeView))
    }));
});



var $jH1k7 = parcelRequire("jH1k7");
const $a6b604bea8c02ae5$export$145a5d1054188a2c = (0, $jH1k7.default)('div')({
    display: 'flex',
    margin: '0 auto'
});





var $2M70Q = parcelRequire("2M70Q");
const $8dfb7debbb036a08$export$cabee3ffe5275f6 = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, minTime: minTime, maxDate: maxDate, maxTime: maxTime, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, reduceAnimations: reduceAnimations, minutesStep: minutesStep, ampm: ampm, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsPerRow: yearsPerRow, defaultCalendarMonth: defaultCalendarMonth, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timeViewsCount: timeViewsCount })=>{
    var _resolveComponentProp, _slotProps$actionBar;
    const isActionBarVisible = !!((_resolveComponentProp = (0, $b66ccc5bec543ea6$export$308c24034cde71de)((_slotProps$actionBar = slotProps == null ? void 0 : slotProps.actionBar) != null ? _slotProps$actionBar : componentsProps == null ? void 0 : componentsProps.actionBar, {})) != null && (_resolveComponentProp = _resolveComponentProp.actions) != null && _resolveComponentProp.length);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a6b604bea8c02ae5$export$145a5d1054188a2c), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e2c97183dc7732ed$export$68078fe5d2bf8909), {
                        view: (0, $915ec64656c7dd6f$export$b32dfef9f07dea64)(view) ? view : 'day',
                        onViewChange: onViewChange,
                        views: views.filter((0, $915ec64656c7dd6f$export$b32dfef9f07dea64)),
                        focusedView: focusedView && (0, $915ec64656c7dd6f$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
                        onFocusedViewChange: onFocusedViewChange,
                        value: value,
                        defaultValue: defaultValue,
                        referenceDate: referenceDate,
                        onChange: onChange,
                        className: className,
                        classes: classes,
                        disableFuture: disableFuture,
                        disablePast: disablePast,
                        minDate: minDate,
                        maxDate: maxDate,
                        shouldDisableDate: shouldDisableDate,
                        shouldDisableMonth: shouldDisableMonth,
                        shouldDisableYear: shouldDisableYear,
                        reduceAnimations: reduceAnimations,
                        onMonthChange: onMonthChange,
                        monthsPerRow: monthsPerRow,
                        onYearChange: onYearChange,
                        yearsPerRow: yearsPerRow,
                        defaultCalendarMonth: defaultCalendarMonth,
                        components: components,
                        componentsProps: componentsProps,
                        slots: slots,
                        slotProps: slotProps,
                        loading: loading,
                        renderLoading: renderLoading,
                        disableHighlightToday: disableHighlightToday,
                        readOnly: readOnly,
                        disabled: disabled,
                        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                        dayOfWeekFormatter: dayOfWeekFormatter,
                        sx: sx,
                        autoFocus: autoFocus,
                        fixedWeekNumber: fixedWeekNumber,
                        displayWeekNumber: displayWeekNumber,
                        timezone: timezone
                    }),
                    timeViewsCount > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $18cdc96991ab6ed1$export$2e2bcd8739ae039), {
                                orientation: "vertical"
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f2ca009ebc6e8f6c$export$c48dada788ff933b), {
                                view: (0, $ab8b9fd82a664ad3$export$a3328136ac50623d)(view) ? view : 'hours',
                                onViewChange: onViewChange,
                                focusedView: focusedView && (0, $ab8b9fd82a664ad3$export$a3328136ac50623d)(focusedView) ? focusedView : null,
                                onFocusedViewChange: onFocusedViewChange,
                                views: views.filter((0, $ab8b9fd82a664ad3$export$a3328136ac50623d)),
                                value: value,
                                defaultValue: defaultValue,
                                referenceDate: referenceDate,
                                onChange: onChange,
                                className: className,
                                classes: classes,
                                disableFuture: disableFuture,
                                disablePast: disablePast,
                                minTime: minTime,
                                maxTime: maxTime,
                                shouldDisableTime: shouldDisableTime,
                                shouldDisableClock: shouldDisableClock,
                                minutesStep: minutesStep,
                                ampm: ampm,
                                components: components,
                                componentsProps: componentsProps,
                                slots: slots,
                                slotProps: slotProps,
                                readOnly: readOnly,
                                disabled: disabled,
                                sx: (0, $gOPoC.default)({
                                    borderBottom: 0,
                                    width: 'auto',
                                    [`.${(0, $76de10a53612e3ad$export$eaf2b63fa45eff23).root}`]: {
                                        maxHeight: '100%'
                                    }
                                }, Array.isArray(sx) ? sx : [
                                    sx
                                ]),
                                autoFocus: autoFocus,
                                disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
                                timeSteps: timeSteps,
                                skipDisabled: skipDisabled,
                                timezone: timezone
                            })
                        ]
                    })
                ]
            }),
            isActionBarVisible && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $18cdc96991ab6ed1$export$2e2bcd8739ae039), {})
        ]
    });
};








var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");


const $41de0ef766017afa$var$_excluded = [
    "views",
    "format"
];
const $41de0ef766017afa$export$ebf7b30b32db6f57 = (utils, _ref)=>{
    let { views: views, format: format } = _ref, other = (0, $aBenZ.default)(_ref, $41de0ef766017afa$var$_excluded);
    if (format) return format;
    const dateViews = [];
    const timeViews = [];
    views.forEach((view)=>{
        if ((0, $ab8b9fd82a664ad3$export$8f04d380cefd5a0d)(view)) timeViews.push(view);
        else dateViews.push(view);
    });
    if (timeViews.length === 0) return (0, $915ec64656c7dd6f$export$bb1c921f313ec928)(utils, (0, $gOPoC.default)({
        views: dateViews
    }, other), false);
    if (dateViews.length === 0) return (0, $ab8b9fd82a664ad3$export$3a6776b3863772fe)(utils, (0, $gOPoC.default)({
        views: timeViews
    }, other));
    const timeFormat = (0, $ab8b9fd82a664ad3$export$3a6776b3863772fe)(utils, (0, $gOPoC.default)({
        views: timeViews
    }, other));
    const dateFormat = (0, $915ec64656c7dd6f$export$bb1c921f313ec928)(utils, (0, $gOPoC.default)({
        views: dateViews
    }, other), false);
    return `${dateFormat} ${timeFormat}`;
};


const $e593e8dff7f24eab$export$74e5e82f1557571f = /*#__PURE__*/ $3OyDL.forwardRef(function DesktopDateTimePicker(inProps, ref) {
    var _defaultizedProps$amp, _defaultizedProps$yea, _defaultizedProps$slo2, _defaultizedProps$slo3, _defaultizedProps$slo4, _props$localeText$ope, _props$localeText;
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $a4651057013a765e$export$6e4d96e87e6dc2d3)(inProps, 'MuiDesktopDateTimePicker');
    const timeSteps = (0, $gOPoC.default)({
        hours: 1,
        minutes: 5,
        seconds: 5
    }, defaultizedProps.timeSteps);
    const shouldUseNewRenderer = !defaultizedProps.viewRenderers || Object.keys(defaultizedProps.viewRenderers).length === 0;
    const viewRenderers = // we can only ensure the expected two-column layout if none of the renderers are overridden
    shouldUseNewRenderer ? {
        day: (0, $8dfb7debbb036a08$export$cabee3ffe5275f6),
        month: (0, $8dfb7debbb036a08$export$cabee3ffe5275f6),
        year: (0, $8dfb7debbb036a08$export$cabee3ffe5275f6),
        hours: (0, $8dfb7debbb036a08$export$cabee3ffe5275f6),
        minutes: (0, $8dfb7debbb036a08$export$cabee3ffe5275f6),
        seconds: (0, $8dfb7debbb036a08$export$cabee3ffe5275f6),
        meridiem: (0, $8dfb7debbb036a08$export$cabee3ffe5275f6)
    } : (0, $gOPoC.default)({
        day: (0, $494930d48812a2bb$export$69888ffe06193e5e),
        month: (0, $494930d48812a2bb$export$69888ffe06193e5e),
        year: (0, $494930d48812a2bb$export$69888ffe06193e5e),
        hours: null,
        minutes: null,
        seconds: null,
        meridiem: null
    }, defaultizedProps.viewRenderers);
    const ampmInClock = (_defaultizedProps$amp = defaultizedProps.ampmInClock) != null ? _defaultizedProps$amp : true;
    // add "accept" action only when the new date time view renderers are used
    const actionBarActions = shouldUseNewRenderer ? [
        'accept'
    ] : [];
    // Props with the default values specific to the desktop variant
    const props = (0, $gOPoC.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $41de0ef766017afa$export$ebf7b30b32db6f57)(utils, defaultizedProps),
        views: defaultizedProps.ampm ? [
            ...defaultizedProps.views,
            'meridiem'
        ] : defaultizedProps.views,
        yearsPerRow: (_defaultizedProps$yea = defaultizedProps.yearsPerRow) != null ? _defaultizedProps$yea : 4,
        ampmInClock: ampmInClock,
        timeSteps: timeSteps,
        slots: (0, $gOPoC.default)({
            field: (0, $f4fcf5cb36bd78f1$export$ae1ced156568f0b0),
            openPickerIcon: (0, $77fe2edc650c8e6d$export$5fda1783bb83f57b)
        }, defaultizedProps.slots),
        slotProps: (0, $gOPoC.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $gOPoC.default)({}, (0, $b66ccc5bec543ea6$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $6899e10b900e4274$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $gOPoC.default)({
                hidden: true,
                ampmInClock: ampmInClock,
                toolbarVariant: shouldUseNewRenderer ? 'desktop' : 'mobile'
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar),
            tabs: (0, $gOPoC.default)({
                hidden: true
            }, (_defaultizedProps$slo3 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo3.tabs),
            actionBar: (0, $gOPoC.default)({
                actions: actionBarActions
            }, (_defaultizedProps$slo4 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo4.actionBar)
        })
    });
    const { renderPicker: renderPicker } = (0, $bc32b77511da4487$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $286007e7644aad7a$export$2764b246aa3b75ba),
        valueType: 'date-time',
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openDatePickerDialogue) != null ? _props$localeText$ope : localeText.openDatePickerDialogue,
        validator: (0, $6f21a188e7254b89$export$ed94a8ff1f54c4f)
    });
    return renderPicker();
});
$e593e8dff7f24eab$export$74e5e82f1557571f.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $4e068a1bef6674c3$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        3,
        4
    ]),
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
            'all',
            'day',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number.isRequired
        })
    ]),
    /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */ shouldDisableClock: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Disable specific date.
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object
    ]),
    /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        meridiem: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        3,
        4
    ])
};



var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");











parcelRequire("3OyDL");

var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");


var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");








function $2e114691368c04fe$export$148b188041a720e4(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiTimeClock', slot);
}
const $2e114691368c04fe$export$191dec874db3257b = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiTimeClock', [
    'root',
    'arrowSwitcher'
]);



var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");



var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");

var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");

const $3cfa6eee80d555ad$export$8c8ec20d3854d7e6 = 220;
const $3cfa6eee80d555ad$export$729c0e543e4dc21d = 36;
const $3cfa6eee80d555ad$var$clockCenter = {
    x: $3cfa6eee80d555ad$export$8c8ec20d3854d7e6 / 2,
    y: $3cfa6eee80d555ad$export$8c8ec20d3854d7e6 / 2
};
const $3cfa6eee80d555ad$var$baseClockPoint = {
    x: $3cfa6eee80d555ad$var$clockCenter.x,
    y: 0
};
const $3cfa6eee80d555ad$var$cx = $3cfa6eee80d555ad$var$baseClockPoint.x - $3cfa6eee80d555ad$var$clockCenter.x;
const $3cfa6eee80d555ad$var$cy = $3cfa6eee80d555ad$var$baseClockPoint.y - $3cfa6eee80d555ad$var$clockCenter.y;
const $3cfa6eee80d555ad$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $3cfa6eee80d555ad$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $3cfa6eee80d555ad$var$clockCenter.x;
    const y = offsetY - $3cfa6eee80d555ad$var$clockCenter.y;
    const atan = Math.atan2($3cfa6eee80d555ad$var$cx, $3cfa6eee80d555ad$var$cy) - Math.atan2(x, y);
    let deg = $3cfa6eee80d555ad$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $3cfa6eee80d555ad$export$b7f1bc3ea3ac4145 = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $3cfa6eee80d555ad$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const $3cfa6eee80d555ad$export$257b40f71c07d58f = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $3cfa6eee80d555ad$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $3cfa6eee80d555ad$export$8c8ec20d3854d7e6 / 2 - $3cfa6eee80d555ad$export$729c0e543e4dc21d) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};



function $8b3b113011618fc8$export$12faa62796978e2f(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiClockPointer', slot);
}
const $8b3b113011618fc8$export$64afeec9352615cb = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiClockPointer', [
    'root',
    'thumb'
]);



var $2M70Q = parcelRequire("2M70Q");
const $f3dc3c53221071fb$var$_excluded = [
    "className",
    "hasSelected",
    "isInner",
    "type",
    "viewValue"
];
const $f3dc3c53221071fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        thumb: [
            'thumb'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $8b3b113011618fc8$export$12faa62796978e2f), classes);
};
const $f3dc3c53221071fb$var$ClockPointerRoot = (0, $jH1k7.default)('div', {
    name: 'MuiClockPointer',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        left: 'calc(50% - 1px)',
        bottom: '50%',
        transformOrigin: 'center bottom 0px'
    }, ownerState.shouldAnimate && {
        transition: theme.transitions.create([
            'transform',
            'height'
        ])
    }));
const $f3dc3c53221071fb$var$ClockPointerThumb = (0, $jH1k7.default)('div', {
    name: 'MuiClockPointer',
    slot: 'Thumb',
    overridesResolver: (_, styles)=>styles.thumb
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: '50%',
        position: 'absolute',
        top: -21,
        left: `calc(50% - ${(0, $3cfa6eee80d555ad$export$729c0e543e4dc21d) / 2}px)`,
        border: `${((0, $3cfa6eee80d555ad$export$729c0e543e4dc21d) - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: 'content-box'
    }, ownerState.hasSelected && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }));
function $f3dc3c53221071fb$export$f257f213e6c08f97(inProps) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiClockPointer'
    });
    const { className: className, isInner: isInner, type: type, viewValue: viewValue } = props, other = (0, $aBenZ.default)(props, $f3dc3c53221071fb$var$_excluded);
    const previousType = $3OyDL.useRef(type);
    $3OyDL.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const ownerState = (0, $gOPoC.default)({}, props, {
        shouldAnimate: previousType.current !== type
    });
    const classes = $f3dc3c53221071fb$var$useUtilityClasses(ownerState);
    const getAngleStyle = ()=>{
        const max = type === 'hours' ? 12 : 60;
        let angle = 360 / max * viewValue;
        if (type === 'hours' && viewValue > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * (0, $3cfa6eee80d555ad$export$8c8ec20d3854d7e6)),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)($f3dc3c53221071fb$var$ClockPointerRoot, (0, $gOPoC.default)({
        style: getAngleStyle(),
        className: (0, $3DmQB.default)(className, classes.root),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($f3dc3c53221071fb$var$ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}





function $a1e5a566b94ef932$export$e44ecab24167799b(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiClock', slot);
}
const $a1e5a566b94ef932$export$4626e3a61e161c64 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiClock', [
    'root',
    'clock',
    'wrapper',
    'squareMask',
    'pin',
    'amButton',
    'pmButton',
    'meridiemText'
]);




var $2M70Q = parcelRequire("2M70Q");
const $9ebd854f89b39fc4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        clock: [
            'clock'
        ],
        wrapper: [
            'wrapper'
        ],
        squareMask: [
            'squareMask'
        ],
        pin: [
            'pin'
        ],
        amButton: [
            'amButton'
        ],
        pmButton: [
            'pmButton'
        ],
        meridiemText: [
            'meridiemText'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $a1e5a566b94ef932$export$e44ecab24167799b), classes);
};
const $9ebd854f89b39fc4$var$ClockRoot = (0, $jH1k7.default)('div', {
    name: 'MuiClock',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(2)
    }));
const $9ebd854f89b39fc4$var$ClockClock = (0, $jH1k7.default)('div', {
    name: 'MuiClock',
    slot: 'Clock',
    overridesResolver: (_, styles)=>styles.clock
})({
    backgroundColor: 'rgba(0,0,0,.07)',
    borderRadius: '50%',
    height: 220,
    width: 220,
    flexShrink: 0,
    position: 'relative',
    pointerEvents: 'none'
});
const $9ebd854f89b39fc4$var$ClockWrapper = (0, $jH1k7.default)('div', {
    name: 'MuiClock',
    slot: 'Wrapper',
    overridesResolver: (_, styles)=>styles.wrapper
})({
    '&:focus': {
        outline: 'none'
    }
});
const $9ebd854f89b39fc4$var$ClockSquareMask = (0, $jH1k7.default)('div', {
    name: 'MuiClock',
    slot: 'SquareMask',
    overridesResolver: (_, styles)=>styles.squareMask
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        width: '100%',
        height: '100%',
        position: 'absolute',
        pointerEvents: 'auto',
        outline: 0,
        // Disable scroll capabilities.
        touchAction: 'none',
        userSelect: 'none'
    }, ownerState.disabled ? {} : {
        '@media (pointer: fine)': {
            cursor: 'pointer',
            borderRadius: '50%'
        },
        '&:active': {
            cursor: 'move'
        }
    }));
const $9ebd854f89b39fc4$var$ClockPin = (0, $jH1k7.default)('div', {
    name: 'MuiClock',
    slot: 'Pin',
    overridesResolver: (_, styles)=>styles.pin
})(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }));
const $9ebd854f89b39fc4$var$ClockAmButton = (0, $jH1k7.default)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
    name: 'MuiClock',
    slot: 'AmButton',
    overridesResolver: (_, styles)=>styles.amButton
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        zIndex: 1,
        position: 'absolute',
        bottom: 8,
        left: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: (0, $3cfa6eee80d555ad$export$729c0e543e4dc21d)
    }, ownerState.meridiemMode === 'am' && {
        backgroundColor: (theme.vars || theme).palette.primary.main,
        color: (theme.vars || theme).palette.primary.contrastText,
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.primary.light
        }
    }));
const $9ebd854f89b39fc4$var$ClockPmButton = (0, $jH1k7.default)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
    name: 'MuiClock',
    slot: 'PmButton',
    overridesResolver: (_, styles)=>styles.pmButton
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        zIndex: 1,
        position: 'absolute',
        bottom: 8,
        right: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: (0, $3cfa6eee80d555ad$export$729c0e543e4dc21d)
    }, ownerState.meridiemMode === 'pm' && {
        backgroundColor: (theme.vars || theme).palette.primary.main,
        color: (theme.vars || theme).palette.primary.contrastText,
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.primary.light
        }
    }));
const $9ebd854f89b39fc4$var$ClockMeridiemText = (0, $jH1k7.default)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
    name: 'MuiClock',
    slot: 'meridiemText',
    overridesResolver: (_, styles)=>styles.meridiemText
})({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
function $9ebd854f89b39fc4$export$9735c82c4bae3302(inProps) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiClock'
    });
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, value: value, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, viewValue: viewValue, disabled: disabled, readOnly: readOnly, className: className } = props;
    const ownerState = props;
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const isMoving = $3OyDL.useRef(false);
    const classes = $9ebd854f89b39fc4$var$useUtilityClasses(ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && type === 'hours' && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === 'seconds' || type === 'minutes' ? (0, $3cfa6eee80d555ad$export$b7f1bc3ea3ac4145)(offsetX, offsetY, minutesStep) : (0, $3cfa6eee80d555ad$export$257b40f71c07d58f)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchMove = (event)=>{
        isMoving.current = true;
        setTime(event, 'shallow');
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, 'finish');
            isMoving.current = false;
        }
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, 'shallow');
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, 'finish');
    };
    const hasSelected = $3OyDL.useMemo(()=>{
        if (type === 'hours') return true;
        return viewValue % 5 === 0;
    }, [
        type,
        viewValue
    ]);
    const keyboardControlStep = type === 'minutes' ? minutesStep : 1;
    const listboxRef = $3OyDL.useRef(null);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $54812c32efbf145d$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case 'Home':
                // annulate both hours and minutes
                handleValueChange(0, 'partial');
                event.preventDefault();
                break;
            case 'End':
                handleValueChange(type === 'minutes' ? 59 : 23, 'partial');
                event.preventDefault();
                break;
            case 'ArrowUp':
                handleValueChange(viewValue + keyboardControlStep, 'partial');
                event.preventDefault();
                break;
            case 'ArrowDown':
                handleValueChange(viewValue - keyboardControlStep, 'partial');
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($9ebd854f89b39fc4$var$ClockRoot, {
        className: (0, $3DmQB.default)(className, classes.root),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)($9ebd854f89b39fc4$var$ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)($9ebd854f89b39fc4$var$ClockSquareMask, {
                        onTouchMove: handleTouchMove,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: {
                            disabled: disabled
                        },
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)($9ebd854f89b39fc4$var$ClockPin, {
                                className: classes.pin
                            }),
                            value != null && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f3dc3c53221071fb$export$f257f213e6c08f97), {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                hasSelected: hasSelected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)($9ebd854f89b39fc4$var$ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": localeText.clockLabelText(type, value, utils),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, $2M70Q.jsxs)($3OyDL.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)($9ebd854f89b39fc4$var$ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        title: (0, $915ec64656c7dd6f$export$fae94c0a662107ef)(utils, 'am'),
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)($9ebd854f89b39fc4$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $915ec64656c7dd6f$export$fae94c0a662107ef)(utils, 'am')
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)($9ebd854f89b39fc4$var$ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        title: (0, $915ec64656c7dd6f$export$fae94c0a662107ef)(utils, 'pm'),
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)($9ebd854f89b39fc4$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $915ec64656c7dd6f$export$fae94c0a662107ef)(utils, 'pm')
                        })
                    })
                ]
            })
        ]
    });
}


parcelRequire("3OyDL");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");
parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");

var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");



function $42d17b4d33443eaa$export$527226d166658911(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiClockNumber', slot);
}
const $42d17b4d33443eaa$export$c8efb3a779c9844a = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiClockNumber', [
    'root',
    'selected',
    'disabled'
]);



var $2M70Q = parcelRequire("2M70Q");
const $ba8bf4fd6e57c642$var$_excluded = [
    "className",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $ba8bf4fd6e57c642$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $42d17b4d33443eaa$export$527226d166658911), classes);
};
const $ba8bf4fd6e57c642$var$ClockNumberRoot = (0, $jH1k7.default)('span', {
    name: 'MuiClockNumber',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $42d17b4d33443eaa$export$c8efb3a779c9844a).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $42d17b4d33443eaa$export$c8efb3a779c9844a).selected}`]: styles.selected
            }
        ]
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        height: (0, $3cfa6eee80d555ad$export$729c0e543e4dc21d),
        width: (0, $3cfa6eee80d555ad$export$729c0e543e4dc21d),
        position: 'absolute',
        left: `calc((100% - ${(0, $3cfa6eee80d555ad$export$729c0e543e4dc21d)}px) / 2)`,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        '&:focused': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${(0, $42d17b4d33443eaa$export$c8efb3a779c9844a).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${(0, $42d17b4d33443eaa$export$c8efb3a779c9844a).disabled}`]: {
            pointerEvents: 'none',
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.inner && (0, $gOPoC.default)({}, theme.typography.body2, {
        color: (theme.vars || theme).palette.text.secondary
    })));
function $ba8bf4fd6e57c642$export$6d5c4c748c9cc92c(inProps) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiClockNumber'
    });
    const { className: className, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $aBenZ.default)(props, $ba8bf4fd6e57c642$var$_excluded);
    const ownerState = props;
    const classes = $ba8bf4fd6e57c642$var$useUtilityClasses(ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, $3cfa6eee80d555ad$export$8c8ec20d3854d7e6) - (0, $3cfa6eee80d555ad$export$729c0e543e4dc21d) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($ba8bf4fd6e57c642$var$ClockNumberRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(className, classes.root),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, $3cfa6eee80d555ad$export$8c8ec20d3854d7e6) - (0, $3cfa6eee80d555ad$export$729c0e543e4dc21d)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}



var $2M70Q = parcelRequire("2M70Q");
const $7e238f6df839fb38$export$10850582eda9a8c7 = ({ ampm: ampm, value: value, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, utils: utils })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = '00';
        const inner = !ampm && (hour === 0 || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $2M70Q.jsx)((0, $ba8bf4fd6e57c642$export$6d5c4c748c9cc92c), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const $7e238f6df839fb38$export$2c440057d7a731e4 = ({ utils: utils, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f('05')
        ],
        [
            10,
            f('10')
        ],
        [
            15,
            f('15')
        ],
        [
            20,
            f('20')
        ],
        [
            25,
            f('25')
        ],
        [
            30,
            f('30')
        ],
        [
            35,
            f('35')
        ],
        [
            40,
            f('40')
        ],
        [
            45,
            f('45')
        ],
        [
            50,
            f('50')
        ],
        [
            55,
            f('55')
        ],
        [
            0,
            f('00')
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ba8bf4fd6e57c642$export$6d5c4c748c9cc92c), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};







var $2M70Q = parcelRequire("2M70Q");
const $ae19500e2d2cfbef$var$_excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableClock",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "timezone"
];
const $ae19500e2d2cfbef$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        arrowSwitcher: [
            'arrowSwitcher'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $2e114691368c04fe$export$148b188041a720e4), classes);
};
const $ae19500e2d2cfbef$var$TimeClockRoot = (0, $jH1k7.default)((0, $86e2d434c5b86080$export$512b066b8abdfde4), {
    name: 'MuiTimeClock',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
});
const $ae19500e2d2cfbef$var$TimeClockArrowSwitcher = (0, $jH1k7.default)((0, $403ec616f1b9959c$export$597b7cbdb7b2a24c), {
    name: 'MuiTimeClock',
    slot: 'ArrowSwitcher',
    overridesResolver: (props, styles)=>styles.arrowSwitcher
})({
    position: 'absolute',
    right: 12,
    top: 15
});
const $ae19500e2d2cfbef$var$TIME_CLOCK_DEFAULT_VIEWS = [
    'hours',
    'minutes'
];
const $ae19500e2d2cfbef$export$7e96244e18c4be57 = /*#__PURE__*/ $3OyDL.forwardRef(function TimeClock(inProps, ref) {
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTimeClock'
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), ampmInClock: ampmInClock = false, autoFocus: autoFocus, components: components, componentsProps: componentsProps, slots: innerSlots, slotProps: innerSlotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, onChange: onChange, view: inView, views: views = $ae19500e2d2cfbef$var$TIME_CLOCK_DEFAULT_VIEWS, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, timezone: timezoneProp } = props, other = (0, $aBenZ.default)(props, $ae19500e2d2cfbef$var$_excluded);
    const slots = innerSlots != null ? innerSlots : (0, $95ed0f26a5eee9f7$export$ee17bc394843b249)(components);
    const slotProps = innerSlotProps != null ? innerSlotProps : componentsProps;
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $c1a1b9e58f0b723e$export$174d749f3b4c0f49)({
        name: 'TimeClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $286007e7644aad7a$export$2764b246aa3b75ba)
    });
    const valueOrReferenceDate = (0, $a6068267c72c4439$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const now = (0, $aa5fe19dd76d6423$export$3a404aece3dff2fa)(timezone);
    const { view: view, setView: setView, previousView: previousView, nextView: nextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $f3f961a3b0e6e0b6$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $6bc09be28b20c2f3$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, setValueAndGoToNextView);
    const isTimeDisabled = $3OyDL.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $ab8b9fd82a664ad3$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableClock != null && shouldDisableClock(timeValue, viewType)) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, $ab8b9fd82a664ad3$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableClock,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const selectedId = (0, $da50f700e88904fb$export$2e2bcd8739ae039)();
    const viewProps = $3OyDL.useMemo(()=>{
        switch(view){
            case 'hours':
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = (0, $ab8b9fd82a664ad3$export$4159dc823695870e)(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), isFinish);
                    };
                    return {
                        onChange: handleHoursChange,
                        viewValue: utils.getHours(valueOrReferenceDate),
                        children: (0, $7e238f6df839fb38$export$10850582eda9a8c7)({
                            value: value,
                            utils: utils,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: localeText.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, 'hours'),
                            selectedId: selectedId
                        })
                    };
                }
            case 'minutes':
                {
                    const minutesValue = utils.getMinutes(valueOrReferenceDate);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minuteValue), isFinish);
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $7e238f6df839fb38$export$2c440057d7a731e4)({
                            utils: utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: localeText.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, 'minutes'),
                            selectedId: selectedId
                        })
                    };
                }
            case 'seconds':
                {
                    const secondsValue = utils.getSeconds(valueOrReferenceDate);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, secondValue), isFinish);
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $7e238f6df839fb38$export$2c440057d7a731e4)({
                            utils: utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: localeText.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, 'seconds'),
                            selectedId: selectedId
                        })
                    };
                }
            default:
                throw new Error('You must provide the type for ClockView');
        }
    }, [
        view,
        utils,
        value,
        ampm,
        localeText.hoursClockNumberText,
        localeText.minutesClockNumberText,
        localeText.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const ownerState = props;
    const classes = $ae19500e2d2cfbef$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($ae19500e2d2cfbef$var$TimeClockRoot, (0, $gOPoC.default)({
        ref: ref,
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9ebd854f89b39fc4$export$9735c82c4bae3302), (0, $gOPoC.default)({
                autoFocus: autoFocus != null ? autoFocus : !!focusedView,
                ampmInClock: ampmInClock && views.includes('hours'),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, $2M70Q.jsx)($ae19500e2d2cfbef$var$TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: localeText.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: localeText.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});



var $gOPoC = parcelRequire("gOPoC");

var $aBenZ = parcelRequire("aBenZ");

var $3OyDL = parcelRequire("3OyDL");

var $3DmQB = parcelRequire("3DmQB");



var $7m2iU = parcelRequire("7m2iU");
var $jH1k7 = parcelRequire("jH1k7");
var $jFgmT = parcelRequire("jFgmT");










function $caa96cd0ee60bab8$export$aeb645018b209578(slot) {
    return (0, $616566cb1dde16a6$export$2e2bcd8739ae039)('MuiDigitalClock', slot);
}
const $caa96cd0ee60bab8$export$baf91642e79c8163 = (0, $fccf60b7720ad689$export$2e2bcd8739ae039)('MuiDigitalClock', [
    'root',
    'list',
    'item'
]);








var $2M70Q = parcelRequire("2M70Q");
const $35811ba48dd612bb$var$_excluded = [
    "ampm",
    "timeStep",
    "autoFocus",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableClock",
    "shouldDisableTime",
    "onChange",
    "view",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "views",
    "skipDisabled",
    "timezone"
];
const $35811ba48dd612bb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        list: [
            'list'
        ],
        item: [
            'item'
        ]
    };
    return (0, $65bce60271b3eb78$export$2e2bcd8739ae039)(slots, (0, $caa96cd0ee60bab8$export$aeb645018b209578), classes);
};
const $35811ba48dd612bb$var$DigitalClockRoot = (0, $jH1k7.default)((0, $86e2d434c5b86080$export$512b066b8abdfde4), {
    name: 'MuiDigitalClock',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ ownerState: ownerState })=>({
        overflowY: 'auto',
        width: '100%',
        '@media (prefers-reduced-motion: no-preference)': {
            scrollBehavior: ownerState.alreadyRendered ? 'smooth' : 'auto'
        },
        maxHeight: (0, $c8ed6f2a54427aa9$export$1c2eabda4acea0e4)
    }));
const $35811ba48dd612bb$var$DigitalClockList = (0, $jH1k7.default)((0, $ae62bf342774ffad$export$2e2bcd8739ae039), {
    name: 'MuiDigitalClock',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    padding: 0
});
const $35811ba48dd612bb$var$DigitalClockItem = (0, $jH1k7.default)((0, $c79ba0e99ec70dbd$export$2e2bcd8739ae039), {
    name: 'MuiDigitalClock',
    slot: 'Item',
    overridesResolver: (props, styles)=>styles.item
})(({ theme: theme })=>({
        padding: '8px 16px',
        margin: '2px 4px',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7m2iU.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $35811ba48dd612bb$export$9a2b219a5b06deb7 = /*#__PURE__*/ $3OyDL.forwardRef(function DigitalClock(inProps, ref) {
    var _ref, _slots$digitalClockIt, _slotProps$digitalClo;
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    const containerRef = $3OyDL.useRef(null);
    const handleRef = (0, $a0093ef70e9dc99d$export$2e2bcd8739ae039)(ref, containerRef);
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDigitalClock'
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeStep: timeStep = 30, autoFocus: autoFocus, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, views: views = [
        'hours'
    ], skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $aBenZ.default)(props, $35811ba48dd612bb$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $c1a1b9e58f0b723e$export$174d749f3b4c0f49)({
        name: 'DigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $286007e7644aad7a$export$2764b246aa3b75ba)
    });
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const now = (0, $aa5fe19dd76d6423$export$3a404aece3dff2fa)(timezone);
    const ownerState = $3OyDL.useMemo(()=>(0, $gOPoC.default)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $35811ba48dd612bb$var$useUtilityClasses(ownerState);
    const ClockItem = (_ref = (_slots$digitalClockIt = slots == null ? void 0 : slots.digitalClockItem) != null ? _slots$digitalClockIt : components == null ? void 0 : components.DigitalClockItem) != null ? _ref : $35811ba48dd612bb$var$DigitalClockItem;
    const clockItemProps = (0, $a8db9ed8fe7432f4$export$2e2bcd8739ae039)({
        elementType: ClockItem,
        externalSlotProps: (_slotProps$digitalClo = slotProps == null ? void 0 : slotProps.digitalClockItem) != null ? _slotProps$digitalClo : componentsProps == null ? void 0 : componentsProps.digitalClockItem,
        ownerState: {},
        className: classes.item
    });
    const valueOrReferenceDate = (0, $a6068267c72c4439$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newValue)=>handleRawValueChange(newValue, 'finish'));
    const { setValueAndGoToNextView: setValueAndGoToNextView } = (0, $f3f961a3b0e6e0b6$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleItemSelect = (0, $09ed1aada0557388$export$2e2bcd8739ae039)((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish');
    });
    $3OyDL.useEffect(()=>{
        if (containerRef.current === null) return;
        const selectedItem = containerRef.current.querySelector('[role="listbox"] [role="option"][aria-selected="true"]');
        if (!selectedItem) return;
        const offsetTop = selectedItem.offsetTop;
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const isTimeDisabled = $3OyDL.useCallback((valueToCheck)=>{
        const isAfter = (0, $ab8b9fd82a664ad3$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const containsValidTime = ()=>{
            if (minTime && isAfter(minTime, valueToCheck)) return false;
            if (maxTime && isAfter(valueToCheck, maxTime)) return false;
            if (disableFuture && isAfter(valueToCheck, now)) return false;
            if (disablePast && isAfter(now, valueToCheck)) return false;
            return true;
        };
        const isValidValue = ()=>{
            if (utils.getMinutes(valueToCheck) % minutesStep !== 0) return false;
            if (shouldDisableClock != null && shouldDisableClock(utils.toJsDate(valueToCheck).getTime(), 'hours')) return false;
            if (shouldDisableTime) return !shouldDisableTime(valueToCheck, 'hours');
            return true;
        };
        return !containsValidTime() || !isValidValue();
    }, [
        disableIgnoringDatePartForTimeValidation,
        utils,
        minTime,
        maxTime,
        disableFuture,
        now,
        disablePast,
        minutesStep,
        shouldDisableClock,
        shouldDisableTime
    ]);
    const timeOptions = $3OyDL.useMemo(()=>{
        const startOfDay = utils.startOfDay(valueOrReferenceDate);
        return [
            startOfDay,
            ...Array.from({
                length: Math.ceil(1440 / timeStep) - 1
            }, (_, index)=>utils.addMinutes(startOfDay, timeStep * (index + 1)))
        ];
    }, [
        valueOrReferenceDate,
        timeStep,
        utils
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($35811ba48dd612bb$var$DigitalClockRoot, (0, $gOPoC.default)({
        ref: handleRef,
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($35811ba48dd612bb$var$DigitalClockList, {
            autoFocusItem: autoFocus || !!focusedView,
            role: "listbox",
            "aria-label": localeText.timePickerToolbarTitle,
            className: classes.list,
            children: timeOptions.map((option)=>{
                if (skipDisabled && isTimeDisabled(option)) return null;
                const isSelected = utils.isEqual(option, value);
                return /*#__PURE__*/ (0, $2M70Q.jsx)(ClockItem, (0, $gOPoC.default)({
                    onClick: ()=>!readOnly && handleItemSelect(option),
                    selected: isSelected,
                    disabled: disabled || isTimeDisabled(option),
                    disableRipple: readOnly,
                    role: "option",
                    "aria-disabled": readOnly,
                    "aria-selected": isSelected
                }, clockItemProps, {
                    children: utils.format(option, ampm ? 'fullTime12h' : 'fullTime24h')
                }), utils.toISO(option));
            })
        })
    }));
});





var $2M70Q = parcelRequire("2M70Q");
const $c0610c66c3d301e3$export$a3ad21a1b07c504f = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, minutesStep: minutesStep, ampm: ampm, ampmInClock: ampmInClock, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, showViewSwitcher: showViewSwitcher, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timezone: timezone })=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $ae19500e2d2cfbef$export$7e96244e18c4be57), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $ab8b9fd82a664ad3$export$8f04d380cefd5a0d)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $ab8b9fd82a664ad3$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        shouldDisableClock: shouldDisableClock,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timezone: timezone
    });
const $c0610c66c3d301e3$export$a2917c76dc0aa7e = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, minutesStep: minutesStep, ampm: ampm, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $35811ba48dd612bb$export$9a2b219a5b06deb7), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $ab8b9fd82a664ad3$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        shouldDisableClock: shouldDisableClock,
        minutesStep: minutesStep,
        ampm: ampm,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeStep: timeSteps == null ? void 0 : timeSteps.minutes,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
const $c0610c66c3d301e3$export$48a290886291c531 = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, minutesStep: minutesStep, ampm: ampm, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $f2ca009ebc6e8f6c$export$c48dada788ff933b), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $ab8b9fd82a664ad3$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        shouldDisableClock: shouldDisableClock,
        minutesStep: minutesStep,
        ampm: ampm,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeSteps: timeSteps,
        skipDisabled: skipDisabled,
        timezone: timezone
    });



const $be603a3f0c7b71d5$export$5b4e219fe76d27da = /*#__PURE__*/ $3OyDL.forwardRef(function MobileDateTimePicker(inProps, ref) {
    var _defaultizedProps$amp, _defaultizedProps$slo2, _defaultizedProps$slo3, _props$localeText$ope, _props$localeText;
    const localeText = (0, $aa5fe19dd76d6423$export$24fdeaa0f591a73e)();
    const utils = (0, $aa5fe19dd76d6423$export$1163b47e39508a46)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $a4651057013a765e$export$6e4d96e87e6dc2d3)(inProps, 'MuiMobileDateTimePicker');
    const viewRenderers = (0, $gOPoC.default)({
        day: (0, $494930d48812a2bb$export$69888ffe06193e5e),
        month: (0, $494930d48812a2bb$export$69888ffe06193e5e),
        year: (0, $494930d48812a2bb$export$69888ffe06193e5e),
        hours: (0, $c0610c66c3d301e3$export$a3ad21a1b07c504f),
        minutes: (0, $c0610c66c3d301e3$export$a3ad21a1b07c504f),
        seconds: (0, $c0610c66c3d301e3$export$a3ad21a1b07c504f)
    }, defaultizedProps.viewRenderers);
    const ampmInClock = (_defaultizedProps$amp = defaultizedProps.ampmInClock) != null ? _defaultizedProps$amp : false;
    // Props with the default values specific to the mobile variant
    const props = (0, $gOPoC.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $41de0ef766017afa$export$ebf7b30b32db6f57)(utils, defaultizedProps),
        ampmInClock: ampmInClock,
        slots: (0, $gOPoC.default)({
            field: (0, $f4fcf5cb36bd78f1$export$ae1ced156568f0b0)
        }, defaultizedProps.slots),
        slotProps: (0, $gOPoC.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $gOPoC.default)({}, (0, $b66ccc5bec543ea6$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $6899e10b900e4274$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $gOPoC.default)({
                hidden: false,
                ampmInClock: ampmInClock
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar),
            tabs: (0, $gOPoC.default)({
                hidden: false
            }, (_defaultizedProps$slo3 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo3.tabs)
        })
    });
    const { renderPicker: renderPicker } = (0, $6b6b90550cc7fd15$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $286007e7644aad7a$export$2764b246aa3b75ba),
        valueType: 'date-time',
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openDatePickerDialogue) != null ? _props$localeText$ope : localeText.openDatePickerDialogue,
        validator: (0, $6f21a188e7254b89$export$ed94a8ff1f54c4f)
    });
    return renderPicker();
});
$be603a3f0c7b71d5$export$5b4e219fe76d27da.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $4e068a1bef6674c3$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        3,
        4
    ]),
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
            'all',
            'day',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).number.isRequired
        })
    ]),
    /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */ shouldDisableClock: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Disable specific date.
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($0421136038e70f36$exports))).oneOf([
        3,
        4
    ])
};




var $2M70Q = parcelRequire("2M70Q");
const $b55b7a514280b5c0$var$_excluded = [
    "desktopModeMediaQuery"
];
const $b55b7a514280b5c0$export$ccdfd7928785632e = /*#__PURE__*/ $3OyDL.forwardRef(function DateTimePicker(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiDateTimePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $c744f6b99d4ca951$export$9ae5b19305db48ce) } = props, other = (0, $aBenZ.default)(props, $b55b7a514280b5c0$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e593e8dff7f24eab$export$74e5e82f1557571f), (0, $gOPoC.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $be603a3f0c7b71d5$export$5b4e219fe76d27da), (0, $gOPoC.default)({
        ref: ref
    }, other));
});


const $dd1551179d3d9c5a$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        root: {
            width: '100%'
        },
        datePicker: {
            fontSize: '14px'
        }
    }));
const $dd1551179d3d9c5a$var$DatePickerComponent = (props)=>{
    const classes = $dd1551179d3d9c5a$var$useStyles();
    const changeValue = (date)=>{
        props.onChangeDate && props.onChangeDate(date);
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0dca6c5826980612$export$dc45bdc734ce6f1e), {
            dateAdapter: (0, $d82d5b43348c96eb$export$81f56c0329a1921d),
            adapterLocale: (0, $c7a7e7744306e3de$export$2e2bcd8739ae039),
            children: props.timePicker ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b55b7a514280b5c0$export$ccdfd7928785632e), {
                sx: {
                    width: props.fullWidth ? '100%' : 'auto'
                },
                className: classes.datePicker,
                label: props.label,
                value: props.value,
                minDate: props.minDate,
                maxDate: props.maxDate,
                disabled: props.disabled,
                onChange: (date)=>{
                    changeValue(date);
                }
            }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8b9b7a71fee8ee09$export$5109c6dd95d8fb00), {
                sx: {
                    width: props.fullWidth ? '100%' : 'auto'
                },
                className: classes.datePicker,
                label: props.label,
                value: props.value,
                onChange: (date)=>{
                    changeValue(date);
                },
                minDate: props.minDate,
                maxDate: props.maxDate,
                disabled: props.disabled
            })
        })
    });
};
var $dd1551179d3d9c5a$export$2e2bcd8739ae039 = $dd1551179d3d9c5a$var$DatePickerComponent;


const $4cb44f2a89d6823b$var$getDateFromCustomDate = (customDate)=>{
    if (customDate.year && customDate.month && customDate.day) {
        const date = new Date();
        date.setFullYear(customDate.year);
        date.setMonth(customDate.month - 1);
        date.setDate(customDate.day);
        return date;
    }
};
var $4cb44f2a89d6823b$export$2e2bcd8739ae039 = $4cb44f2a89d6823b$var$getDateFromCustomDate;



const $d67ad22a7bb63f61$var$getCustomDateFromDate = (date)=>{
    const customDate = {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
    return customDate;
};
var $d67ad22a7bb63f61$export$2e2bcd8739ae039 = $d67ad22a7bb63f61$var$getCustomDateFromDate;




const $a2b7530d91ffaeb5$var$getAgeOfMemberAtDate = (member, customDate)=>{
    const date = (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(customDate);
    const memberBirthday = (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(member.birthday);
    if (date && memberBirthday) {
        const diffMs = date?.getTime() - memberBirthday?.getTime();
        const ageMs = new Date(diffMs);
        const ageYears = ageMs.getUTCFullYear() - 1970;
        return ageYears;
    }
};
var $a2b7530d91ffaeb5$export$2e2bcd8739ae039 = $a2b7530d91ffaeb5$var$getAgeOfMemberAtDate;


const $b324537ad6642403$var$getPriceForEventMember = (eventMember, eventPriceCategories)=>{
    let price = 0;
    eventMember.eventPriceCategories.map((category)=>{
        const categoryPriceElement = eventPriceCategories?.find((elem)=>elem.id === category.eventPriceCategoryId);
        price += categoryPriceElement && categoryPriceElement.price ? categoryPriceElement.price * category.quantity : 0;
    });
    return price;
};
var $b324537ad6642403$export$2e2bcd8739ae039 = $b324537ad6642403$var$getPriceForEventMember;


const $47024d0ef744770b$var$formatCurrency = (price)=>{
    return `${price.toFixed(2).toString().replace('.', ',')} \u{20AC}`;
};
var $47024d0ef744770b$export$2e2bcd8739ae039 = $47024d0ef744770b$var$formatCurrency;



const $b320b82673f30664$var$getPriceForAllEventMembers = (eventMember, eventPrices)=>{
    let price = 0;
    eventMember.map((member)=>{
        price += (0, $b324537ad6642403$export$2e2bcd8739ae039)(member, eventPrices);
    });
    return price;
};
var $b320b82673f30664$export$2e2bcd8739ae039 = $b320b82673f30664$var$getPriceForAllEventMembers;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $21c840b7db424828$var$CardIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("svg", {
        id: "Capa_1",
        enableBackground: "new 0 0 512 512",
        height: props.width,
        viewBox: "0 0 512 512",
        width: props.width,
        fill: props.color || theme.palette.text.primary,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m479.001 34.656-193.068-34.043c-21.715-3.829-42.423 10.671-46.252 32.386l-1.827 10.363c27.921 3.44 51.51 23.554 58.937 51.269l11.799 44.035c6.247-2.709 13.329-3.685 20.537-2.414 13.677 2.412 24.17 12.255 28.079 24.642 7.91-10.303 21.137-15.964 34.814-13.552 19.575 3.452 32.646 22.119 29.194 41.694-7.5 42.534-53.143 76.721-74.804 90.782l33.071 123.423c1.773 6.616 2.512 13.266 2.349 19.79l27.824 4.906c21.715 3.829 42.423-10.671 46.252-32.386l55.48-314.641c3.83-21.717-10.67-42.425-32.385-46.254z"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m267.867 102.382c-4.78-17.838-20.911-29.603-38.54-29.602-3.42 0-6.898.443-10.359 1.37l-189.366 50.74c-21.299 5.707-33.939 27.6-28.232 48.899l82.691 308.609c4.78 17.838 20.911 29.602 38.54 29.602 3.42 0 6.898-.443 10.358-1.37l189.366-50.741c21.299-5.707 33.939-27.6 28.232-48.899zm-147.357 210.951c-3.211-2.825-4.41-7.302-3.042-11.353l28.956-85.738c2.422-7.172 11.364-9.568 17.048-4.568l67.946 59.774c3.211 2.825 4.41 7.302 3.042 11.353l-28.956 85.738c-2.422 7.172-11.364 9.569-17.048 4.568z"
            })
        ]
    });
};
var $21c840b7db424828$export$2e2bcd8739ae039 = $21c840b7db424828$var$CardIcon;



const $33e41acc90e15337$var$getDefaultEventPriceCategories = (eventPriceCategories, memberAge)=>{
    const defaultEventPrices = [];
    if (memberAge) eventPriceCategories.map((priceCategory)=>{
        if (priceCategory.ageFrom && memberAge && priceCategory.ageFrom <= memberAge || !priceCategory.ageFrom) {
            if (priceCategory.ageTo && memberAge && priceCategory.ageTo >= memberAge || !priceCategory.ageTo) {
                if (priceCategory.defaultCount > 0 && priceCategory.id) defaultEventPrices.push({
                    eventPriceCategoryId: priceCategory.id,
                    quantity: priceCategory.defaultCount
                });
            }
        }
    });
    return defaultEventPrices;
};
var $33e41acc90e15337$export$2e2bcd8739ae039 = $33e41acc90e15337$var$getDefaultEventPriceCategories;


const $b2b5269c382e0c51$var$getTextAsFormattedString = (text)=>{
    const formattedText = text.replace('\n', '<br />');
    return formattedText;
};
var $b2b5269c382e0c51$export$2e2bcd8739ae039 = $b2b5269c382e0c51$var$getTextAsFormattedString;



var $44fd8c9e8fff88a7$var$TabEnum = /*#__PURE__*/ function(TabEnum) {
    TabEnum["overview"] = "overview";
    TabEnum["location"] = "location";
    TabEnum["participation"] = "participation";
    TabEnum["registration"] = "registration";
    TabEnum["gallery"] = "gallery";
    TabEnum["results"] = "results";
    return TabEnum;
}($44fd8c9e8fff88a7$var$TabEnum || {});
const $44fd8c9e8fff88a7$var$SingleEvent = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            paper: {
                margin: downMd ? '0px' : '24px 24px 24px 0',
                padding: downMd ? '0px 8px' : '24px',
                width: '100%'
            },
            location: {
                textTransform: 'uppercase',
                opacity: '0.8',
                width: '100%',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
            },
            description: {
                cursor: 'pointer',
                textTransform: 'uppercase',
                opacity: '0.8',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
            },
            container: {
                marginTop: theme.spacing(4)
            },
            image: {
                width: '100%',
                height: 'auto',
                cursor: 'pointer'
            },
            tableHeader: {
                fontWeight: 'bold',
                textAlign: 'left'
            }
        }));
    const classes = useStyles();
    const userPermissions = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$7eb85035e0831f9));
    const user = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$7cbf767827cd68ba));
    const eventResults = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$79c726a1641bb9ad));
    const basePath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
    const fetchHeaders = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).fetchHeaders;
    (0, $58718165e7ed8d4a$export$bacd26fe3052ded6)(fetchHeaders);
    const setEventResults = (res)=>{
        dispatch($5993246da723f2dd$export$32f26ecd1d16cf({
            ...eventResults,
            [props.data.event.id]: res.results
        }));
    };
    const [message, setMessage] = (0, $3OyDL.useState)();
    (0, $3OyDL.useEffect)(()=>{
        message && dispatch($7173820326fb9f6c$export$706cdae1b5419ef8(message));
    }, [
        message
    ]);
    (0, $3OyDL.useEffect)(()=>{
        userPermissions.eventResults.find((elem)=>elem === (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read) && props.data.event.id && props.data.event.id !== 'new' && !eventResults[props.data.event.id] && (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventResults, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).GET, props.data.event.id, undefined, setEventResults, setMessage);
    }, [
        props.data,
        props.data.event.id
    ]);
    const getMyEventMember = ()=>{
        const eventMemberFromUser = [];
        activeEvent.eventMember.map((eventMember)=>{
            if (eventMember.memberId === user?.memberId || eventMember.registeredByMemberId === user?.memberId) {
                eventMember.from = eventMember.from || activeEvent.event.eventFrom || {};
                eventMember.to = eventMember.to || activeEvent.event.eventTo || {};
                eventMemberFromUser.push(eventMember);
            }
        });
        return eventMemberFromUser;
    };
    const members = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$f4931e6f9feb30c5));
    const eventPriceCategories = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$fe140eefbe221ed9));
    const [showNewRegistration, setShowNewRegistration] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(10);
    const [actualPage, setActualPage] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(0);
    const [activeTab, setActiveTab] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(window.localStorage.getItem('activeEventTab'));
    const [activeEvent, setActiveEvent] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(props.data);
    const [myEventMember, setMyEventMember] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(getMyEventMember());
    (0, $3OyDL.useEffect)(()=>{
        setMyEventMember(getMyEventMember());
    }, [
        activeEvent,
        activeEvent.eventMember
    ]);
    (0, $3OyDL.useEffect)(()=>{
        if (activeEvent.event.id === props.data.event.id) setActiveTab(window.localStorage.getItem('activeEventTab') ? window.localStorage.getItem('activeEventTab') : "location");
        else {
            window.localStorage.removeItem('activeEventTab');
            setActiveTab("location");
        }
        setActiveEvent(props.data);
    }, [
        props
    ]);
    const handleChangePage = (e, page)=>{
        setActualPage(page);
    };
    const handleChangePageSize = (e)=>{
        setRowsPerPage(Number.parseInt(e.target.value));
    };
    const getPriceOptions = (memberId)=>{
        const member = members?.results.find((elem)=>elem.originId === memberId);
        const memberAge = member && props.data.event.eventFrom && (0, $a2b7530d91ffaeb5$export$2e2bcd8739ae039)(member, props.data.event.eventFrom);
        const options = [];
        eventPriceCategories?.results.map((priceCategory)=>{
            const eventMem = myEventMember.find((member)=>member.memberId === memberId);
            const eventMemPrice = eventMem && eventMem.eventPriceCategories.find((price)=>price.id === priceCategory.id);
            if (!eventMemPrice) {
                if (priceCategory.ageFrom && memberAge && priceCategory.ageFrom <= memberAge || !priceCategory.ageFrom) {
                    if (priceCategory.ageTo && memberAge && priceCategory.ageTo >= memberAge || !priceCategory.ageTo) priceCategory.id && options.push({
                        key: priceCategory.id,
                        value: priceCategory.title
                    });
                }
            }
        });
        return options;
    };
    const getMemberOptions = ()=>{
        const options = [];
        members?.results.map((tempMember)=>{
            // prüfen ob bereits in eventMemberListe enthalten
            if (!tempMember.dead) {
                if (!myEventMember.find((eM)=>eM.memberId === tempMember.originId) && !activeEvent.eventMember.find((eM)=>eM.memberId === tempMember.originId)) tempMember.originId && options.push({
                    key: tempMember.originId,
                    value: `${tempMember.firstname} ${tempMember.lastname}`
                });
            }
        });
        options.sort((a, b)=>{
            const nameA = a.value.toUpperCase();
            const nameB = b.value.toUpperCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        });
        return options;
    };
    const getFilteredEventMember = (eventMember)=>{
        let end = actualPage * rowsPerPage + rowsPerPage;
        if (end > eventMember.length) end = eventMember.length;
        const filteredMember = eventMember.slice(actualPage * rowsPerPage, end);
        return filteredMember;
    };
    const editRegistration = (myEventMember)=>{
        if (myEventMember.length === 0) {
            const newEventMem = [
                ...myEventMember
            ];
            activeEvent.event.id && user && user.memberId && newEventMem.push({
                id: 'new',
                memberId: '',
                eventId: activeEvent.event.id,
                participate: true,
                gamer: false,
                registeredByMemberId: user.memberId,
                eventPriceCategories: [],
                from: props.data.event.eventFrom || {},
                to: props.data.event.eventTo || {},
                notes: ''
            });
            setMyEventMember(newEventMem);
        }
        setShowNewRegistration(true);
    };
    const getParticipationTable = ()=>{
        return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.tableHeader,
                                        sx: {
                                            width: '20px'
                                        },
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.tableHeader,
                                        children: "Vorname"
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.tableHeader,
                                        children: "Nachname"
                                    }),
                                    !downMd && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                className: classes.tableHeader,
                                                children: "Anreise"
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                className: classes.tableHeader,
                                                children: "Abreise"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                        className: classes.tableHeader,
                                        sx: {
                                            width: '20px'
                                        },
                                        children: "\xa0"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                            children: getFilteredEventMember(activeEvent?.eventMember)?.map((member)=>{
                                return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                            sx: {
                                                height: '48px'
                                            },
                                            children: member.gamer && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $21c840b7db424828$export$2e2bcd8739ae039), {
                                                width: "16px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                            children: members?.results.find((elem)=>elem.originId === member.memberId)?.firstname
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                            children: members?.results.find((elem)=>elem.originId === member.memberId)?.lastname
                                        }),
                                        !downMd && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                    children: (0, $f88738dfeeda6137$export$2e2bcd8739ae039)(member.from)
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                    children: (0, $f88738dfeeda6137$export$2e2bcd8739ae039)(member.to)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                            className: classes.tableHeader,
                                            sx: {
                                                width: '20px'
                                            },
                                            children: (member.memberId === user?.memberId || member.registeredByMemberId === user?.memberId) && activeEvent.event.eventTo && (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(activeEvent.event.eventTo) && (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(activeEvent.event.eventTo)?.getMilliseconds() > new Date().getMilliseconds() && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                onClick: ()=>{
                                                    editRegistration(myEventMember);
                                                },
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($748d42c5fe8bcf47$exports))), {})
                                            })
                                        })
                                    ]
                                }, member.id);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6aef60d9c63e7548$export$2e2bcd8739ae039), {
                    component: "div",
                    count: activeEvent.eventMember.length,
                    rowsPerPage: rowsPerPage,
                    page: actualPage,
                    rowsPerPageOptions: downMd ? [] : [
                        10,
                        25,
                        50,
                        100
                    ],
                    backIconButtonProps: {
                        'aria-label': 'voherige Seite'
                    },
                    nextIconButtonProps: {
                        'aria-label': "n\xe4chste Seite"
                    },
                    onPageChange: handleChangePage,
                    onRowsPerPageChange: handleChangePageSize
                })
            ]
        });
    };
    const setEventMember = (data)=>{
        dispatch($5993246da723f2dd$export$ad62873327949bc6({
            count: data.count,
            results: data.results
        }));
    };
    let registrationOpen = false;
    if (activeEvent.event.registrationUntil && (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(activeEvent.event.registrationUntil)) {
        const registrationDate = (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(activeEvent.event.registrationUntil);
        if (registrationDate && registrationDate > new Date()) registrationOpen = true;
    }
    const SingleEventContent = ()=>{
        const stringCoords = activeEvent?.eventLocation?.coordinates?.split(',');
        const coordinates = [];
        stringCoords && stringCoords[0] && coordinates.push(parseInt(stringCoords[0], 10));
        stringCoords && stringCoords[1] && coordinates.push(parseInt(stringCoords[1], 10));
        return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                    className: classes.location,
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                justifyContent: 'Spave-between',
                                flexWrap: 'nowrap'
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "h5",
                                    style: {
                                        fontWeight: '501'
                                    },
                                    children: activeEvent.event.title
                                }),
                                userPermissions.events.find((elem)=>elem === (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).update) && downMd && /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($748d42c5fe8bcf47$exports))), {
                                    sx: {
                                        color: theme.palette.primary.main,
                                        position: 'absolute',
                                        right: '30px',
                                        zIndex: 100,
                                        cursor: 'pointer'
                                    },
                                    onClick: ()=>props.setAdminMode(true)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            children: [
                                (0, $f88738dfeeda6137$export$2e2bcd8739ae039)(activeEvent.event.eventFrom),
                                " - ",
                                (0, $f88738dfeeda6137$export$2e2bcd8739ae039)(activeEvent.event.eventTo)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $300390f560fe3d4d$export$2e2bcd8739ae039), {
                    sx: {
                        marginBottom: '20px'
                    },
                    value: activeTab,
                    onChange: (e, newValue)=>{
                        window.localStorage.setItem('activeEventTab', newValue);
                        setActiveTab(newValue);
                    },
                    children: [
                        activeEvent.event.description && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                            sx: {
                                minWidth: '70px!important'
                            },
                            value: "overview",
                            label: downMd ? undefined : 'Skatturnier',
                            icon: downMd ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $21c840b7db424828$export$2e2bcd8739ae039), {
                                width: "20px",
                                color: activeTab === "results" ? theme.palette.primary.main : theme.palette.grey.A700
                            }) : undefined
                        }, "overview"),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                            sx: {
                                minWidth: '70px!important'
                            },
                            value: "location",
                            label: downMd ? undefined : 'Unterkunft',
                            icon: downMd ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($70fa1035e174fb27$exports))), {}) : undefined
                        }, "location"),
                        registrationOpen || user && user.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).admin ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                            sx: {
                                minWidth: '70px!important'
                            },
                            value: "registration",
                            icon: downMd ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($748d42c5fe8bcf47$exports))), {}) : undefined,
                            label: downMd ? undefined : 'Anmeldung'
                        }, "registration") : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                            sx: {
                                minWidth: '70px!important'
                            },
                            value: "participation",
                            icon: downMd ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($748d42c5fe8bcf47$exports))), {}) : undefined,
                            label: downMd ? undefined : 'Teilnehmer'
                        }, "participation"),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                            sx: {
                                minWidth: '70px!important'
                            },
                            value: "results",
                            icon: downMd ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($99e273523f9e6319$exports))), {}) : undefined,
                            label: downMd ? undefined : 'Ergebnisse'
                        }, "results"),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                            sx: {
                                minWidth: '70px!important'
                            },
                            value: "gallery",
                            icon: downMd ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87685c4b93d32359$exports))), {}) : undefined,
                            label: downMd ? undefined : 'Galerie'
                        }, "gallery")
                    ]
                }),
                activeTab === "overview" && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                    container: true,
                    item: true,
                    xs: 12,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                variant: "h6",
                                children: activeEvent.event.title
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: [
                                activeEvent.event.eventTo?.year && /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                    width: "100%",
                                    src: `/eventImages/${activeEvent.event.eventTo?.year}.png`,
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    dangerouslySetInnerHTML: {
                                        __html: (0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize((0, $b2b5269c382e0c51$export$2e2bcd8739ae039)(activeEvent.event.description?.trim() || ''))
                                    }
                                }),
                                activeEvent.event.signature && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        textAlign: 'right',
                                        fontFamily: 'Allura',
                                        fontSize: '24px'
                                    },
                                    children: activeEvent.event.signature
                                })
                            ]
                        })
                    ]
                }),
                activeTab === "location" && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                    container: true,
                    item: true,
                    xs: 12,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "h6",
                                    children: activeEvent.eventLocation?.name
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                                        style: {
                                            textDecoration: 'none'
                                        },
                                        color: theme.palette.grey[600],
                                        href: activeEvent.eventLocation?.linkUrl,
                                        className: classes.description,
                                        target: "_blank",
                                        children: activeEvent.eventLocation?.caption
                                    })
                                })
                            ]
                        }),
                        downMd && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            width: "100%",
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $34aa91b0cc02ff7a$export$2e2bcd8739ae039), {
                                items: activeEvent.eventLocation?.imageUrls || [],
                                maxWidth: "100%",
                                height: window.screen.width + 3 / 4,
                                navButtonsAlwaysVisible: true
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: downMd ? 12 : 6,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    dangerouslySetInnerHTML: {
                                        __html: (0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize((0, $b2b5269c382e0c51$export$2e2bcd8739ae039)(activeEvent.eventLocation?.description))
                                    }
                                }),
                                activeEvent.event.signature && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        textAlign: 'right',
                                        fontFamily: 'Allura',
                                        fontSize: '24px'
                                    },
                                    children: activeEvent.eventLocation?.signature
                                })
                            ]
                        }),
                        downMd && activeEvent?.eventLocation?.coordinates && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7801af78bc29c2a9$export$2e2bcd8739ae039), {
                                label: [
                                    activeEvent?.eventLocation?.name
                                ],
                                mapZoom: 12,
                                positions: [
                                    new (0, $ad5a22b7e45eeb01$exports.LatLng)(coordinates[0], coordinates[1])
                                ]
                            })
                        }),
                        !downMd && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 6,
                            container: true,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $34aa91b0cc02ff7a$export$2e2bcd8739ae039), {
                                        items: activeEvent.eventLocation?.imageUrls || [],
                                        maxWidth: "100%",
                                        height: 2 * window.screen.width / 9,
                                        navButtonsAlwaysVisible: true
                                    })
                                }),
                                activeEvent?.eventLocation?.coordinates && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7801af78bc29c2a9$export$2e2bcd8739ae039), {
                                        label: [
                                            activeEvent?.eventLocation?.name
                                        ],
                                        mapZoom: 12,
                                        positions: [
                                            new (0, $ad5a22b7e45eeb01$exports.LatLng)(coordinates[0], coordinates[1])
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                activeTab === "registration" && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                width: '100%',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "h6",
                                            children: "Bisherige Meldungen"
                                        }),
                                        user?.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).admin && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                            onClick: ()=>{
                                                const restUrl = `${basePath}/api/export/eventMember/${activeEvent.event.id}`;
                                                fetch(restUrl, {
                                                    method: 'GET',
                                                    credentials: 'include'
                                                }).then((response)=>response.blob()).then((blob)=>{
                                                    const url = window.URL.createObjectURL(blob);
                                                    const a = document.createElement('a');
                                                    a.href = url;
                                                    a.target = '_blank';
                                                    a.download = `Anmeldeliste${activeEvent.event.eventFrom?.year}_${Date.now()}.xlsx`;
                                                    document.body.appendChild(a);
                                                    a.click();
                                                    a.remove();
                                                });
                                            },
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f6bef95756d9e672$exports))), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                    onClick: ()=>{
                                        editRegistration(myEventMember);
                                    },
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($80b8df6a6d317902$exports))), {})
                                })
                            ]
                        }),
                        getParticipationTable()
                    ]
                }),
                activeTab === "gallery" && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3a48fbcdb50c9177$export$2e2bcd8739ae039), {
                            mediaData: [],
                            setSelected: (data)=>console.log(data),
                            useRoundImageBorders: true
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $25c2ff9358099864$export$2e2bcd8739ae039), {
                            onlyUploadButton: true,
                            loading: false,
                            minCropBoxHeight: 170,
                            minCropBoxWidth: 170,
                            aspectRatio: 1
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $fcd8906eca00ae5f$export$2e2bcd8739ae039), {
                            options: [
                                {
                                    id: '001',
                                    label: 'Robi'
                                }
                            ],
                            label: "Tags"
                        })
                    ]
                }),
                activeTab === "results" && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                    children: props.data.event.id && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $46668510321f1f9f$export$2e2bcd8739ae039), {
                        eventMember: activeEvent.eventMember,
                        eventId: props.data.event.id
                    })
                }),
                activeTab === "participation" && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                flexWrap: 'nowrap'
                            },
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                variant: "h6",
                                sx: {
                                    marginRight: '10px'
                                },
                                children: "Anmeldungen"
                            })
                        }),
                        getParticipationTable()
                    ]
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $ee30f4276828974b$export$2e2bcd8739ae039), {
                    open: showNewRegistration,
                    onClose: ()=>setShowNewRegistration(false),
                    sx: {
                        '& .MuiDialog-paper': {
                            borderRadius: 0,
                            minWidth: '80%',
                            maxWidth: '80%'
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                            sx: {
                                p: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                    direction: "row",
                                    spacing: 3,
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $286e44e498de27a0$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontWeight: 600,
                                            p: 0,
                                            fontSize: '16px',
                                            marginBottom: '20px'
                                        },
                                        children: "Neue Anmeldung"
                                    })
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b9097f1d6e2a4efc$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                        container: true,
                                        children: [
                                            myEventMember.map((eM, index)=>{
                                                const selectedMember = members?.results.find((member)=>member.originId === eM.memberId);
                                                return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                    children: eM.memberId ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'flex-start',
                                                            width: '100%',
                                                            marginBottom: '20px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $19e56772b842faf0$export$2e2bcd8739ae039), {
                                                                sx: {
                                                                    width: '100%'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7ba21131579dfa21$export$2e2bcd8739ae039), {
                                                                        expandIcon: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1e0e42f5f37a7922$exports))), {}),
                                                                        id: eM.memberId,
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                display: 'flex',
                                                                                justifyContent: 'space-between',
                                                                                alignItems: 'center',
                                                                                width: '100%'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                                    sx: {
                                                                                        display: 'flex',
                                                                                        justifyContent: 'flex-start',
                                                                                        alignItems: 'center'
                                                                                    },
                                                                                    children: [
                                                                                        eM.gamer ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $21c840b7db424828$export$2e2bcd8739ae039), {
                                                                                            color: theme.typography.body1.color,
                                                                                            width: "16px"
                                                                                        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                                            sx: {
                                                                                                marginLeft: '8px'
                                                                                            },
                                                                                            children: "\xa0"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                                            sx: {
                                                                                                marginLeft: '8px'
                                                                                            },
                                                                                            variant: "body1",
                                                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                                                children: `${selectedMember && selectedMember.firstname} ${selectedMember && selectedMember.lastname}`
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                                    variant: "body1",
                                                                                    sx: {
                                                                                        marginRight: '12px'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                                        children: (0, $47024d0ef744770b$export$2e2bcd8739ae039)((0, $b324537ad6642403$export$2e2bcd8739ae039)(eM, eventPriceCategories?.results))
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $bd3612b92fc47d5c$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            marginLeft: '20px'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                                container: true,
                                                                                spacing: 2,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                                        item: true,
                                                                                        xs: 12,
                                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                                            value: eM.gamer,
                                                                                            label: "Skatspieler",
                                                                                            onChange: (value)=>{
                                                                                                const newEventMem = [
                                                                                                    ...myEventMember
                                                                                                ];
                                                                                                newEventMem[index].gamer = value;
                                                                                                setMyEventMember(newEventMem);
                                                                                            }
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                                        item: true,
                                                                                        xs: 3,
                                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $dd1551179d3d9c5a$export$2e2bcd8739ae039), {
                                                                                            onChangeDate: (value)=>{
                                                                                                const newEventMem = [
                                                                                                    ...myEventMember
                                                                                                ];
                                                                                                newEventMem[index].from = value ? (0, $d67ad22a7bb63f61$export$2e2bcd8739ae039)(value) : {};
                                                                                                setMyEventMember(newEventMem);
                                                                                            },
                                                                                            value: myEventMember[index].from && (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(myEventMember[index].from),
                                                                                            label: "Anreise"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                                        item: true,
                                                                                        xs: 3,
                                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $dd1551179d3d9c5a$export$2e2bcd8739ae039), {
                                                                                            onChangeDate: (value)=>{
                                                                                                const newEventMem = [
                                                                                                    ...myEventMember
                                                                                                ];
                                                                                                newEventMem[index].to = value ? (0, $d67ad22a7bb63f61$export$2e2bcd8739ae039)(value) : {};
                                                                                                setMyEventMember(newEventMem);
                                                                                            },
                                                                                            value: myEventMember[index].to && (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(myEventMember[index].to),
                                                                                            label: "Abreise"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                                        item: true,
                                                                                        xs: 6,
                                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                                                            margin: "none",
                                                                                            fullWidth: true,
                                                                                            onChange: (value)=>{
                                                                                                const newEventMem = [
                                                                                                    ...myEventMember
                                                                                                ];
                                                                                                newEventMem[index].notes = value?.toString();
                                                                                                setMyEventMember(newEventMem);
                                                                                            },
                                                                                            label: "Anmerkungen"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                                variant: "body1",
                                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                                    children: "Gebuchte Optionen:"
                                                                                })
                                                                            }),
                                                                            myEventMember[index].memberId && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                                                children: myEventMember[index].eventPriceCategories.map((evPriceCat, priceIndex)=>{
                                                                                    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                                        children: evPriceCat.quantity > 0 ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                                            container: true,
                                                                                            spacing: 2,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                                                    item: true,
                                                                                                    xs: 6,
                                                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                                                        variant: "body1",
                                                                                                        children: eventPriceCategories?.results.find((elem)=>elem.id === evPriceCat.eventPriceCategoryId)?.title
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                                                    item: true,
                                                                                                    xs: 3,
                                                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                                                                        margin: "none",
                                                                                                        label: "Anzahl",
                                                                                                        required: true,
                                                                                                        value: evPriceCat.quantity || 0,
                                                                                                        type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).number,
                                                                                                        min: 1,
                                                                                                        fullWidth: true,
                                                                                                        size: "small",
                                                                                                        onChange: (value)=>{
                                                                                                            const newValue = parseInt(value, 10);
                                                                                                            const newEventMem = [];
                                                                                                            myEventMember.map((elem)=>{
                                                                                                                const element = {
                                                                                                                    ...elem
                                                                                                                };
                                                                                                                if (elem.id === myEventMember[index].id) {
                                                                                                                    const newPriceCategories = [
                                                                                                                        ...elem.eventPriceCategories
                                                                                                                    ];
                                                                                                                    newPriceCategories[priceIndex].quantity = newValue;
                                                                                                                    element.eventPriceCategories = newPriceCategories;
                                                                                                                }
                                                                                                                newEventMem.push(element);
                                                                                                            });
                                                                                                            setMyEventMember(newEventMem);
                                                                                                        }
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                                                    item: true,
                                                                                                    xs: 3,
                                                                                                    alignItems: "flex-end",
                                                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                                                        sx: {
                                                                                                            display: 'flex',
                                                                                                            justifyContent: 'flex-end',
                                                                                                            alignItems: 'center'
                                                                                                        },
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                                                                variant: "body1",
                                                                                                                align: "right",
                                                                                                                children: (0, $47024d0ef744770b$export$2e2bcd8739ae039)(eventPriceCategories?.results?.find((elem)=>elem.id === evPriceCat.eventPriceCategoryId)?.price ? evPriceCat.quantity * (eventPriceCategories?.results?.find((elem)=>elem.id === evPriceCat.eventPriceCategoryId)?.price || 0) : 0)
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                                                                                sx: {
                                                                                                                    marginTop: '0px'
                                                                                                                },
                                                                                                                onClick: ()=>{
                                                                                                                    const newEventMem = [];
                                                                                                                    myEventMember.map((elem)=>{
                                                                                                                        const element = {
                                                                                                                            ...elem
                                                                                                                        };
                                                                                                                        if (elem.id === myEventMember[index].id) {
                                                                                                                            const newPriceCategories = [];
                                                                                                                            elem.eventPriceCategories.map((price, priceIdx)=>{
                                                                                                                                if (priceIndex !== priceIdx) newPriceCategories.push(price);
                                                                                                                            });
                                                                                                                            element.eventPriceCategories = newPriceCategories;
                                                                                                                        }
                                                                                                                        newEventMem.push(element);
                                                                                                                    });
                                                                                                                    setMyEventMember(newEventMem);
                                                                                                                },
                                                                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2f1d1e8698c2a400$exports))), {})
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }) : /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                                            container: true,
                                                                                            spacing: 2,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                                                    item: true,
                                                                                                    xs: 6,
                                                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                                                                                        size: "small",
                                                                                                        options: getPriceOptions(myEventMember[index].memberId),
                                                                                                        label: "Option",
                                                                                                        multiple: false,
                                                                                                        onChange: (value)=>{
                                                                                                            const newEventMem = [];
                                                                                                            myEventMember.map((elem)=>{
                                                                                                                const element = {
                                                                                                                    ...elem
                                                                                                                };
                                                                                                                if (elem.id === myEventMember[index].id) {
                                                                                                                    const newPriceCategories = [
                                                                                                                        ...elem.eventPriceCategories
                                                                                                                    ];
                                                                                                                    newPriceCategories[priceIndex].eventPriceCategoryId = value?.key;
                                                                                                                    element.eventPriceCategories = newPriceCategories;
                                                                                                                }
                                                                                                                newEventMem.push(element);
                                                                                                            });
                                                                                                            setMyEventMember(newEventMem);
                                                                                                        }
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                                                    item: true,
                                                                                                    xs: 3,
                                                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                                                                        margin: "none",
                                                                                                        label: "Anzahl",
                                                                                                        required: true,
                                                                                                        type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).number,
                                                                                                        min: 1,
                                                                                                        fullWidth: true,
                                                                                                        size: "small",
                                                                                                        onChange: (value)=>{
                                                                                                            const newValue = parseInt(value, 10);
                                                                                                            const newEventMem = [];
                                                                                                            myEventMember.map((elem)=>{
                                                                                                                const element = {
                                                                                                                    ...elem
                                                                                                                };
                                                                                                                if (elem.id === myEventMember[index].id) {
                                                                                                                    const newPriceCategories = [
                                                                                                                        ...elem.eventPriceCategories
                                                                                                                    ];
                                                                                                                    newPriceCategories[priceIndex].quantity = newValue;
                                                                                                                    element.eventPriceCategories = newPriceCategories;
                                                                                                                }
                                                                                                                newEventMem.push(element);
                                                                                                            });
                                                                                                            setMyEventMember(newEventMem);
                                                                                                        }
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                                                                    item: true,
                                                                                                    xs: 3,
                                                                                                    alignItems: "flex-end",
                                                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                                                        sx: {
                                                                                                            display: 'flex',
                                                                                                            justifyContent: 'flex-end',
                                                                                                            alignItems: 'center'
                                                                                                        },
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                                                                variant: "body1",
                                                                                                                align: "right",
                                                                                                                children: (0, $47024d0ef744770b$export$2e2bcd8739ae039)(eventPriceCategories?.results?.find((elem)=>elem.id === evPriceCat.eventPriceCategoryId)?.price ? evPriceCat.quantity * (eventPriceCategories?.results?.find((elem)=>elem.id === evPriceCat.eventPriceCategoryId)?.price || 0) : 0)
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                                                                                sx: {
                                                                                                                    marginTop: '0px'
                                                                                                                },
                                                                                                                onClick: ()=>{
                                                                                                                    const newEventMem = [];
                                                                                                                    myEventMember.map((elem)=>{
                                                                                                                        const element = {
                                                                                                                            ...elem
                                                                                                                        };
                                                                                                                        if (elem.id === myEventMember[index].id) {
                                                                                                                            const newPriceCategories = [];
                                                                                                                            elem.eventPriceCategories.map((price, priceIdx)=>{
                                                                                                                                if (priceIndex !== priceIdx) newPriceCategories.push(price);
                                                                                                                            });
                                                                                                                            element.eventPriceCategories = newPriceCategories;
                                                                                                                        }
                                                                                                                        newEventMem.push(element);
                                                                                                                    });
                                                                                                                    setMyEventMember(newEventMem);
                                                                                                                },
                                                                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2f1d1e8698c2a400$exports))), {})
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }, priceIndex);
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                                sx: {
                                                                                    cursor: 'pointer',
                                                                                    display: 'flex',
                                                                                    justifyContent: 'flex-start',
                                                                                    alignItems: 'center',
                                                                                    width: 'max-content'
                                                                                },
                                                                                onClick: ()=>{
                                                                                    const newEventMem = [];
                                                                                    myEventMember.map((elem)=>{
                                                                                        const element = {
                                                                                            ...elem
                                                                                        };
                                                                                        if (elem.id === myEventMember[index].id) {
                                                                                            const newPriceCategories = [
                                                                                                ...elem.eventPriceCategories
                                                                                            ];
                                                                                            newPriceCategories.push({
                                                                                                eventPriceCategoryId: '',
                                                                                                quantity: 0
                                                                                            });
                                                                                            element.eventPriceCategories = newPriceCategories;
                                                                                        }
                                                                                        newEventMem.push(element);
                                                                                    });
                                                                                    setMyEventMember(newEventMem);
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($80b8df6a6d317902$exports))), {}),
                                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                                        variant: "body1",
                                                                                        children: "Weitere Option hinzuf\xfcgen"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                                sx: {
                                                                    marginTop: '12px'
                                                                },
                                                                onClick: ()=>{
                                                                    const newEventMem = [];
                                                                    myEventMember.map((elem, id)=>{
                                                                        if (index !== id) newEventMem.push(elem);
                                                                    });
                                                                    setMyEventMember(newEventMem);
                                                                },
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c677c753a54bdfd8$exports))), {})
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                                        options: getMemberOptions(),
                                                        label: "Teilnehmer",
                                                        multiple: false,
                                                        onChange: (value)=>{
                                                            const newEventMem = [
                                                                ...myEventMember
                                                            ];
                                                            newEventMem[index].memberId = value?.key;
                                                            const member = members?.results.find((elem)=>elem.originId === value?.key);
                                                            const memberAge = member && props.data.event.eventFrom && (0, $a2b7530d91ffaeb5$export$2e2bcd8739ae039)(member, props.data.event.eventFrom);
                                                            newEventMem[index].eventPriceCategories = (0, $33e41acc90e15337$export$2e2bcd8739ae039)(activeEvent.eventPrices, memberAge);
                                                            setMyEventMember(newEventMem);
                                                        }
                                                    })
                                                });
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 6,
                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        justifyContent: 'flex-start',
                                                        alignItems: 'center',
                                                        width: 'max-content'
                                                    },
                                                    onClick: ()=>{
                                                        const newEventMem = [
                                                            ...myEventMember
                                                        ];
                                                        activeEvent.event.id && user && user.memberId && newEventMem.push({
                                                            id: 'new',
                                                            memberId: '',
                                                            registeredByMemberId: user.memberId,
                                                            eventPriceCategories: [],
                                                            eventId: activeEvent.event.id,
                                                            participate: true,
                                                            gamer: false,
                                                            from: props.data.event.eventFrom || {},
                                                            to: props.data.event.eventTo || {},
                                                            notes: ''
                                                        });
                                                        setMyEventMember(newEventMem);
                                                        setShowNewRegistration(true);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($80b8df6a6d317902$exports))), {}),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                            variant: "body1",
                                                            children: "Weitere Person hinzuf\xfcgen"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 6,
                                                textAlign: "right",
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        marginRight: '92px'
                                                    },
                                                    variant: "body1",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)("b", {
                                                        children: [
                                                            "Gesamt: ",
                                                            eventPriceCategories?.results && (0, $47024d0ef744770b$export$2e2bcd8739ae039)((0, $b320b82673f30664$export$2e2bcd8739ae039)(myEventMember, eventPriceCategories?.results))
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $08e4970efe955928$export$2e2bcd8739ae039), {
                            sx: {
                                p: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    variant: "text",
                                    text: "Verwerfen",
                                    onClick: ()=>{
                                        setMyEventMember(getMyEventMember());
                                        setShowNewRegistration(false);
                                    }
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    variant: "contained",
                                    text: "Anmelden",
                                    onClick: ()=>{
                                        // delete member, die nicht mehr in der Liste sind
                                        activeEvent.eventMember.map((elem)=>{
                                            if (!myEventMember.find((eM)=>eM.id === elem.id)) (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventMembers, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).DELETE, elem.id, undefined, setEventMember, setMessage);
                                        });
                                        // erste ändern
                                        myEventMember.map((eventMem)=>{
                                            if (eventMem.id !== 'new') (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventMembers, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).PUT, eventMem.id, {
                                                eventMember: eventMem
                                            }, setEventMember, setMessage);
                                        });
                                        // dann neu anlegen
                                        myEventMember.map((eventMem)=>{
                                            if (eventMem.id === 'new') (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventMembers, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).POST, undefined, {
                                                eventMember: eventMem
                                            }, setEventMember, setMessage);
                                        });
                                        setShowNewRegistration(false);
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: downMd ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
            children: SingleEventContent()
        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
            className: classes.paper,
            children: SingleEventContent()
        })
    });
};
var $44fd8c9e8fff88a7$export$2e2bcd8739ae039 = $44fd8c9e8fff88a7$var$SingleEvent;




const $f03e96cce7f8431d$var$getEventObject = (events, eventMember, eventPriceCategories, eventLocations, members, searchInput)=>{
    const eventObjects = [];
    events.results.map((event)=>{
        const prices = eventPriceCategories.results.filter((price)=>price.eventId === event.id);
        const member = eventMember.results.filter((member)=>member.eventId === event.id);
        const location = eventLocations.results.find((location)=>location.id === event.locationId);
        if (searchInput) {
            const regEx = new RegExp(searchInput.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss'), 'gim');
            // const regExp = new RegExp((searchInput || '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i')
            const temp = [];
            member.map((elem)=>{
                const tempMem = members?.results.find((mem)=>mem.id === elem.memberId);
                if (tempMem && tempMem.firstname.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1 || tempMem && tempMem.lastname.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1) temp.push(tempMem);
            });
            // Suche in Year, Title, EventLocation
            if (event?.eventFrom?.year?.toString()?.search(regEx) !== -1 || event?.eventTo?.year?.toString()?.search(regEx) !== -1 || event?.title.toString()?.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1 || temp.length > 0 || location?.name && location?.name.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1) eventObjects.push({
                event: event,
                eventPrices: prices,
                eventMember: member,
                eventLocation: location,
                media: []
            });
        } else eventObjects.push({
            event: event,
            eventPrices: prices,
            eventMember: member,
            eventLocation: location,
            media: []
        });
    });
    return eventObjects;
};
var $f03e96cce7f8431d$export$2e2bcd8739ae039 = $f03e96cce7f8431d$var$getEventObject;




var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");


var $5a57ac24af0bf3ca$exports = {};
'use strict';

$5a57ac24af0bf3ca$exports = (parcelRequire("iaJl6"));




const $bd7a1b8dae1ad8b8$var$getEventLocationDropdownOptions = (eventLocations)=>{
    const options = [];
    eventLocations.results.map((location)=>{
        location.id && options.push({
            key: location.id,
            value: location.name
        });
    });
    return options;
};
var $bd7a1b8dae1ad8b8$export$2e2bcd8739ae039 = $bd7a1b8dae1ad8b8$var$getEventLocationDropdownOptions;









const $fbde4f20a5469c7e$var$getEventMemberDropdownOptions = (eventMember)=>{
    const options = [];
    eventMember.results.map((member)=>{
        member.originId && options.push({
            key: member.originId,
            value: `${member.firstname} ${member.lastname}`
        });
    });
    options.sort((a, b)=>{
        const nameA = a.value.toUpperCase();
        const nameB = b.value.toUpperCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        // names must be equal
        return 0;
    });
    return options;
};
var $fbde4f20a5469c7e$export$2e2bcd8739ae039 = $fbde4f20a5469c7e$var$getEventMemberDropdownOptions;




var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");
var $defb55c3fac0cfee$exports = {};
"use strict";
"use client";

Object.defineProperty($defb55c3fac0cfee$exports, "__esModule", {
    value: true
});
$defb55c3fac0cfee$exports.default = void 0;

var $defb55c3fac0cfee$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $defb55c3fac0cfee$var$_default = (0, $defb55c3fac0cfee$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');
$defb55c3fac0cfee$exports.default = $defb55c3fac0cfee$var$_default;





const $ae5314790b38ab46$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        inputFieldContainer: {
            background: 'rgba(200, 200, 200, 0.5)',
            borderRadius: '4px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '5px',
            marginBottom: '5px',
            maxHeight: 'fit-content'
        },
        iconProps: {
            color: '#c8c8c8',
            marginTop: '5px',
            paddingLeft: '4px'
        },
        input: {
            '& .MuiInput-input': {
                height: '22px'
            }
        },
        searchButton: {
            width: '100%',
            right: 0
        },
        button: {
            height: '46px'
        }
    }));
const $ae5314790b38ab46$var$LocationSearch = (props)=>{
    const classes = $ae5314790b38ab46$var$useStyles();
    const [searchValue, setSearchValue] = (0, $3OyDL.useState)(props.destination);
    const fetchAltLong = ()=>{
        const query = 'https://nominatim.openstreetmap.org/search?q=' + searchValue + '&format=json&polygon=1&addressdetails=1';
        fetch(query).then((result)=>{
            result.json().then((json)=>{
                props.setPosition({
                    lat: json[0].lat,
                    long: json[0].lon
                });
            });
        });
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                item: true,
                xs: 8,
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                    component: "div",
                    className: classes.inputFieldContainer,
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            component: "div",
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($defb55c3fac0cfee$exports))), {
                                className: classes.iconProps
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $328e9bc68740648b$export$2e2bcd8739ae039), {
                            className: classes.input,
                            autoFocus: true,
                            value: searchValue,
                            onChange: (e)=>setSearchValue(e.target.value),
                            onKeyPress: (e)=>e.key === 'Enter' && fetchAltLong(),
                            placeholder: "Wo soll es hingehen?",
                            margin: "none",
                            id: "name",
                            type: "text",
                            fullWidth: true,
                            variant: "standard",
                            InputProps: {
                                disableUnderline: true
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                className: classes.searchButton,
                item: true,
                xs: 4,
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    onClick: ()=>fetchAltLong(),
                    text: "Suchen",
                    className: classes.button
                })
            })
        ]
    });
};
var $ae5314790b38ab46$export$2e2bcd8739ae039 = $ae5314790b38ab46$var$LocationSearch;









var $bb8e3cea3d4722f4$exports = {};
"use strict";
"use client";

Object.defineProperty($bb8e3cea3d4722f4$exports, "__esModule", {
    value: true
});
$bb8e3cea3d4722f4$exports.default = void 0;

var $bb8e3cea3d4722f4$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $bb8e3cea3d4722f4$var$_default = (0, $bb8e3cea3d4722f4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15l1-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15l1-2H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3l-1 2h4.06c-.04.33-.06.66-.06 1s.02.67.06 1H3l-1 2h4.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
}), 'Euro');
$bb8e3cea3d4722f4$exports.default = $bb8e3cea3d4722f4$var$_default;


var $e7a38a4908cae58a$exports = {};
"use strict";
"use client";

Object.defineProperty($e7a38a4908cae58a$exports, "__esModule", {
    value: true
});
$e7a38a4908cae58a$exports.default = void 0;

var $e7a38a4908cae58a$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $e7a38a4908cae58a$var$_default = (0, $e7a38a4908cae58a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M3 18h12v-2H3v2zM3 6v2h18V6H3zm0 7h18v-2H3v2z"
}), 'Notes');
$e7a38a4908cae58a$exports.default = $e7a38a4908cae58a$var$_default;




var $85e09de6caf3f045$exports = {};
"use strict";
"use client";

Object.defineProperty($85e09de6caf3f045$exports, "__esModule", {
    value: true
});
$85e09de6caf3f045$exports.default = void 0;

var $85e09de6caf3f045$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $85e09de6caf3f045$var$_default = (0, $85e09de6caf3f045$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
}), 'Email');
$85e09de6caf3f045$exports.default = $85e09de6caf3f045$var$_default;







var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

var $bced97677fc48886$exports = {};
"use strict";
/*
React-Quill
https://github.com/zenoamaro/react-quill
*/ var $bced97677fc48886$var$__extends = $bced97677fc48886$exports && $bced97677fc48886$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $bced97677fc48886$var$__assign = $bced97677fc48886$exports && $bced97677fc48886$exports.__assign || function() {
    $bced97677fc48886$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bced97677fc48886$var$__assign.apply(this, arguments);
};
var $bced97677fc48886$var$__spreadArrays = $bced97677fc48886$exports && $bced97677fc48886$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $bced97677fc48886$var$__importDefault = $bced97677fc48886$exports && $bced97677fc48886$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $bced97677fc48886$var$react_1 = $bced97677fc48886$var$__importDefault((parcelRequire("3OyDL")));

var $bced97677fc48886$var$react_dom_1 = $bced97677fc48886$var$__importDefault((parcelRequire("dy6Cj")));

var $bced97677fc48886$var$isEqual_1 = $bced97677fc48886$var$__importDefault((parcelRequire("6VLH2")));

var $bced97677fc48886$var$quill_1 = $bced97677fc48886$var$__importDefault((parcelRequire("kvsBE")));
var $bced97677fc48886$var$ReactQuill = /** @class */ function(_super) {
    $bced97677fc48886$var$__extends(ReactQuill, _super);
    function ReactQuill(props) {
        var _this = _super.call(this, props) || this;
        /*
        Changing one of these props should cause a full re-render and a
        re-instantiation of the Quill editor.
        */ _this.dirtyProps = [
            'modules',
            'formats',
            'bounds',
            'theme',
            'children'
        ];
        /*
        Changing one of these props should cause a regular update. These are mostly
        props that act on the container, rather than the quillized editing area.
        */ _this.cleanProps = [
            'id',
            'className',
            'style',
            'placeholder',
            'tabIndex',
            'onChange',
            'onChangeSelection',
            'onFocus',
            'onBlur',
            'onKeyPress',
            'onKeyDown',
            'onKeyUp'
        ];
        _this.state = {
            generation: 0
        };
        /*
        Tracks the internal selection of the Quill editor
        */ _this.selection = null;
        _this.onEditorChange = function(eventName, rangeOrDelta, oldRangeOrDelta, source) {
            var _a, _b, _c, _d;
            if (eventName === 'text-change') (_b = (_a = _this).onEditorChangeText) === null || _b === void 0 || _b.call(_a, _this.editor.root.innerHTML, rangeOrDelta, source, _this.unprivilegedEditor);
            else if (eventName === 'selection-change') (_d = (_c = _this).onEditorChangeSelection) === null || _d === void 0 || _d.call(_c, rangeOrDelta, source, _this.unprivilegedEditor);
        };
        var value = _this.isControlled() ? props.value : props.defaultValue;
        _this.value = value !== null && value !== void 0 ? value : '';
        return _this;
    }
    ReactQuill.prototype.validateProps = function(props) {
        var _a;
        if ($bced97677fc48886$var$react_1.default.Children.count(props.children) > 1) throw new Error('The Quill editing area can only be composed of a single React element.');
        if ($bced97677fc48886$var$react_1.default.Children.count(props.children)) {
            var child = $bced97677fc48886$var$react_1.default.Children.only(props.children);
            if (((_a = child) === null || _a === void 0 ? void 0 : _a.type) === 'textarea') throw new Error('Quill does not support editing on a <textarea>. Use a <div> instead.');
        }
        if (this.lastDeltaChangeSet && props.value === this.lastDeltaChangeSet) throw new Error("You are passing the `delta` object from the `onChange` event back as `value`. You most probably want `editor.getContents()` instead. See: https://github.com/zenoamaro/react-quill#using-deltas");
    };
    ReactQuill.prototype.shouldComponentUpdate = function(nextProps, nextState) {
        var _this = this;
        var _a;
        this.validateProps(nextProps);
        // If the editor hasn't been instantiated yet, or the component has been
        // regenerated, we already know we should update.
        if (!this.editor || this.state.generation !== nextState.generation) return true;
        // Handle value changes in-place
        if ('value' in nextProps) {
            var prevContents = this.getEditorContents();
            var nextContents = (_a = nextProps.value, _a !== null && _a !== void 0 ? _a : '');
            // NOTE: Seeing that Quill is missing a way to prevent edits, we have to
            //       settle for a hybrid between controlled and uncontrolled mode. We
            //       can't prevent the change, but we'll still override content
            //       whenever `value` differs from current state.
            // NOTE: Comparing an HTML string and a Quill Delta will always trigger a
            //       change, regardless of whether they represent the same document.
            if (!this.isEqualValue(nextContents, prevContents)) this.setEditorContents(this.editor, nextContents);
        }
        // Handle read-only changes in-place
        if (nextProps.readOnly !== this.props.readOnly) this.setEditorReadOnly(this.editor, nextProps.readOnly);
        // Clean and Dirty props require a render
        return $bced97677fc48886$var$__spreadArrays(this.cleanProps, this.dirtyProps).some(function(prop) {
            return !$bced97677fc48886$var$isEqual_1.default(nextProps[prop], _this.props[prop]);
        });
    };
    ReactQuill.prototype.shouldComponentRegenerate = function(nextProps) {
        var _this = this;
        // Whenever a `dirtyProp` changes, the editor needs reinstantiation.
        return this.dirtyProps.some(function(prop) {
            return !$bced97677fc48886$var$isEqual_1.default(nextProps[prop], _this.props[prop]);
        });
    };
    ReactQuill.prototype.componentDidMount = function() {
        this.instantiateEditor();
        this.setEditorContents(this.editor, this.getEditorContents());
    };
    ReactQuill.prototype.componentWillUnmount = function() {
        this.destroyEditor();
    };
    ReactQuill.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _this = this;
        // If we're changing one of the `dirtyProps`, the entire Quill Editor needs
        // to be re-instantiated. Regenerating the editor will cause the whole tree,
        // including the container, to be cleaned up and re-rendered from scratch.
        // Store the contents so they can be restored later.
        if (this.editor && this.shouldComponentRegenerate(prevProps)) {
            var delta = this.editor.getContents();
            var selection = this.editor.getSelection();
            this.regenerationSnapshot = {
                delta: delta,
                selection: selection
            };
            this.setState({
                generation: this.state.generation + 1
            });
            this.destroyEditor();
        }
        // The component has been regenerated, so it must be re-instantiated, and
        // its content must be restored to the previous values from the snapshot.
        if (this.state.generation !== prevState.generation) {
            var _a = this.regenerationSnapshot, delta = _a.delta, selection_1 = _a.selection;
            delete this.regenerationSnapshot;
            this.instantiateEditor();
            var editor_1 = this.editor;
            editor_1.setContents(delta);
            $bced97677fc48886$var$postpone(function() {
                return _this.setEditorSelection(editor_1, selection_1);
            });
        }
    };
    ReactQuill.prototype.instantiateEditor = function() {
        if (this.editor) this.hookEditor(this.editor);
        else this.editor = this.createEditor(this.getEditingArea(), this.getEditorConfig());
    };
    ReactQuill.prototype.destroyEditor = function() {
        if (!this.editor) return;
        this.unhookEditor(this.editor);
    };
    /*
    We consider the component to be controlled if `value` is being sent in props.
    */ ReactQuill.prototype.isControlled = function() {
        return 'value' in this.props;
    };
    ReactQuill.prototype.getEditorConfig = function() {
        return {
            bounds: this.props.bounds,
            formats: this.props.formats,
            modules: this.props.modules,
            placeholder: this.props.placeholder,
            readOnly: this.props.readOnly,
            scrollingContainer: this.props.scrollingContainer,
            tabIndex: this.props.tabIndex,
            theme: this.props.theme
        };
    };
    ReactQuill.prototype.getEditor = function() {
        if (!this.editor) throw new Error('Accessing non-instantiated editor');
        return this.editor;
    };
    /**
    Creates an editor on the given element. The editor will be passed the
    configuration, have its events bound,
    */ ReactQuill.prototype.createEditor = function(element, config) {
        var editor = new $bced97677fc48886$var$quill_1.default(element, config);
        if (config.tabIndex != null) this.setEditorTabIndex(editor, config.tabIndex);
        this.hookEditor(editor);
        return editor;
    };
    ReactQuill.prototype.hookEditor = function(editor) {
        // Expose the editor on change events via a weaker, unprivileged proxy
        // object that does not allow accidentally modifying editor state.
        this.unprivilegedEditor = this.makeUnprivilegedEditor(editor);
        // Using `editor-change` allows picking up silent updates, like selection
        // changes on typing.
        editor.on('editor-change', this.onEditorChange);
    };
    ReactQuill.prototype.unhookEditor = function(editor) {
        editor.off('editor-change', this.onEditorChange);
    };
    ReactQuill.prototype.getEditorContents = function() {
        return this.value;
    };
    ReactQuill.prototype.getEditorSelection = function() {
        return this.selection;
    };
    /*
    True if the value is a Delta instance or a Delta look-alike.
    */ ReactQuill.prototype.isDelta = function(value) {
        return value && value.ops;
    };
    /*
    Special comparison function that knows how to compare Deltas.
    */ ReactQuill.prototype.isEqualValue = function(value, nextValue) {
        if (this.isDelta(value) && this.isDelta(nextValue)) return $bced97677fc48886$var$isEqual_1.default(value.ops, nextValue.ops);
        else return $bced97677fc48886$var$isEqual_1.default(value, nextValue);
    };
    /*
    Replace the contents of the editor, but keep the previous selection hanging
    around so that the cursor won't move.
    */ ReactQuill.prototype.setEditorContents = function(editor, value) {
        var _this = this;
        this.value = value;
        var sel = this.getEditorSelection();
        if (typeof value === 'string') editor.setContents(editor.clipboard.convert(value));
        else editor.setContents(value);
        $bced97677fc48886$var$postpone(function() {
            return _this.setEditorSelection(editor, sel);
        });
    };
    ReactQuill.prototype.setEditorSelection = function(editor, range) {
        this.selection = range;
        if (range) {
            // Validate bounds before applying.
            var length_1 = editor.getLength();
            range.index = Math.max(0, Math.min(range.index, length_1 - 1));
            range.length = Math.max(0, Math.min(range.length, length_1 - 1 - range.index));
            editor.setSelection(range);
        }
    };
    ReactQuill.prototype.setEditorTabIndex = function(editor, tabIndex) {
        var _a, _b;
        if ((_b = (_a = editor) === null || _a === void 0 ? void 0 : _a.scroll) === null || _b === void 0 ? void 0 : _b.domNode) editor.scroll.domNode.tabIndex = tabIndex;
    };
    ReactQuill.prototype.setEditorReadOnly = function(editor, value) {
        if (value) editor.disable();
        else editor.enable();
    };
    /*
    Returns a weaker, unprivileged proxy object that only exposes read-only
    accessors found on the editor instance, without any state-modifying methods.
    */ ReactQuill.prototype.makeUnprivilegedEditor = function(editor) {
        var e = editor;
        return {
            getHTML: function() {
                return e.root.innerHTML;
            },
            getLength: e.getLength.bind(e),
            getText: e.getText.bind(e),
            getContents: e.getContents.bind(e),
            getSelection: e.getSelection.bind(e),
            getBounds: e.getBounds.bind(e)
        };
    };
    ReactQuill.prototype.getEditingArea = function() {
        if (!this.editingArea) throw new Error('Instantiating on missing editing area');
        var element = $bced97677fc48886$var$react_dom_1.default.findDOMNode(this.editingArea);
        if (!element) throw new Error('Cannot find element for editing area');
        if (element.nodeType === 3) throw new Error('Editing area cannot be a text node');
        return element;
    };
    /*
    Renders an editor area, unless it has been provided one to clone.
    */ ReactQuill.prototype.renderEditingArea = function() {
        var _this = this;
        var _a = this.props, children = _a.children, preserveWhitespace = _a.preserveWhitespace;
        var generation = this.state.generation;
        var properties = {
            key: generation,
            ref: function(instance) {
                _this.editingArea = instance;
            }
        };
        if ($bced97677fc48886$var$react_1.default.Children.count(children)) return $bced97677fc48886$var$react_1.default.cloneElement($bced97677fc48886$var$react_1.default.Children.only(children), properties);
        return preserveWhitespace ? $bced97677fc48886$var$react_1.default.createElement("pre", $bced97677fc48886$var$__assign({}, properties)) : $bced97677fc48886$var$react_1.default.createElement("div", $bced97677fc48886$var$__assign({}, properties));
    };
    ReactQuill.prototype.render = function() {
        var _a;
        return $bced97677fc48886$var$react_1.default.createElement("div", {
            id: this.props.id,
            style: this.props.style,
            key: this.state.generation,
            className: "quill " + (_a = this.props.className, _a !== null && _a !== void 0 ? _a : ''),
            onKeyPress: this.props.onKeyPress,
            onKeyDown: this.props.onKeyDown,
            onKeyUp: this.props.onKeyUp
        }, this.renderEditingArea());
    };
    ReactQuill.prototype.onEditorChangeText = function(value, delta, source, editor) {
        var _a, _b;
        if (!this.editor) return;
        // We keep storing the same type of value as what the user gives us,
        // so that value comparisons will be more stable and predictable.
        var nextContents = this.isDelta(this.value) ? editor.getContents() : editor.getHTML();
        if (nextContents !== this.getEditorContents()) {
            // Taint this `delta` object, so we can recognize whether the user
            // is trying to send it back as `value`, preventing a likely loop.
            this.lastDeltaChangeSet = delta;
            this.value = nextContents;
            (_b = (_a = this.props).onChange) === null || _b === void 0 || _b.call(_a, value, delta, source, editor);
        }
    };
    ReactQuill.prototype.onEditorChangeSelection = function(nextSelection, source, editor) {
        var _a, _b, _c, _d, _e, _f;
        if (!this.editor) return;
        var currentSelection = this.getEditorSelection();
        var hasGainedFocus = !currentSelection && nextSelection;
        var hasLostFocus = currentSelection && !nextSelection;
        if ($bced97677fc48886$var$isEqual_1.default(nextSelection, currentSelection)) return;
        this.selection = nextSelection;
        (_b = (_a = this.props).onChangeSelection) === null || _b === void 0 || _b.call(_a, nextSelection, source, editor);
        if (hasGainedFocus) (_d = (_c = this.props).onFocus) === null || _d === void 0 || _d.call(_c, nextSelection, source, editor);
        else if (hasLostFocus) (_f = (_e = this.props).onBlur) === null || _f === void 0 || _f.call(_e, currentSelection, source, editor);
    };
    ReactQuill.prototype.focus = function() {
        if (!this.editor) return;
        this.editor.focus();
    };
    ReactQuill.prototype.blur = function() {
        if (!this.editor) return;
        this.selection = null;
        this.editor.blur();
    };
    ReactQuill.displayName = 'React Quill';
    /*
    Export Quill to be able to call `register`
    */ ReactQuill.Quill = $bced97677fc48886$var$quill_1.default;
    ReactQuill.defaultProps = {
        theme: 'snow',
        modules: {},
        readOnly: false
    };
    return ReactQuill;
}($bced97677fc48886$var$react_1.default.Component);
/*
Small helper to execute a function in the next micro-tick.
*/ function $bced97677fc48886$var$postpone(fn) {
    Promise.resolve().then(fn);
}
$bced97677fc48886$exports = $bced97677fc48886$var$ReactQuill;







const $20c6b651fc290466$var$RichTextEditorComponent = (props)=>{
    const useDarkMode = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$3813fceac631a2fa));
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
        sx: {
            position: 'relative'
        },
        children: [
            props.label && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                sx: {
                    position: 'absolute',
                    backgroundColor: 'white',
                    padding: '5px',
                    top: '-14px',
                    left: '10px'
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $97b5652ba004fde7$export$2e2bcd8739ae039), {
                    label: props.label,
                    description: props.tooltip
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bced97677fc48886$exports))), {
                className: useDarkMode ? 'dark' : '',
                defaultValue: props.value,
                readOnly: props.disabled,
                modules: {
                    toolbar: [
                        [
                            {
                                header: [
                                    1,
                                    2,
                                    3,
                                    false
                                ]
                            },
                            'bold',
                            'italic',
                            'underline',
                            'strike',
                            'blockquote',
                            {
                                color: []
                            },
                            {
                                list: 'ordered'
                            },
                            {
                                list: 'bullet'
                            },
                            {
                                script: 'sub'
                            },
                            {
                                script: 'super'
                            }
                        ]
                    ]
                },
                theme: "snow",
                onChange: (value)=>{
                    props.onChange(value);
                },
                style: {
                    color: theme.palette.text.primary,
                    borderTop: '1px solid #ccc',
                    borderBottom: '1px solid #ccc',
                    marginTop: '8px',
                    height: props.height || 'auto'
                }
            })
        ]
    });
};
var $20c6b651fc290466$export$2e2bcd8739ae039 = $20c6b651fc290466$var$RichTextEditorComponent;




const $3ba6ea6d28b153a2$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        paper: {
            margin: '25px 25px 25px 0',
            padding: '25px',
            width: '100%'
        },
        baseBox: {
            position: 'relative'
        }
    }));
var $3ba6ea6d28b153a2$var$TabEnum = /*#__PURE__*/ function(TabEnum) {
    TabEnum["general"] = "general";
    TabEnum["prices"] = "prices";
    TabEnum["email"] = "email";
    return TabEnum;
}($3ba6ea6d28b153a2$var$TabEnum || {});
const $3ba6ea6d28b153a2$var$defaultEmailObject = {
    subject: '',
    template: undefined,
    text: undefined,
    senderId: '',
    recipients: []
};
var $3ba6ea6d28b153a2$var$EmailTemplate = /*#__PURE__*/ function(EmailTemplate) {
    EmailTemplate["invitation"] = "invitation";
    return EmailTemplate;
}($3ba6ea6d28b153a2$var$EmailTemplate || {});
var $3ba6ea6d28b153a2$var$MemberOption = /*#__PURE__*/ function(MemberOption) {
    MemberOption["member"] = "member";
    MemberOption["eventMember"] = "eventMember";
    MemberOption["player"] = "player";
    MemberOption["custom"] = "custom";
    return MemberOption;
}($3ba6ea6d28b153a2$var$MemberOption || {});
const $3ba6ea6d28b153a2$var$TimelineElementEditor = (props)=>{
    const classes = $3ba6ea6d28b153a2$var$useStyles();
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const basePath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
    const fetchHeaders = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).fetchHeaders;
    (0, $58718165e7ed8d4a$export$bacd26fe3052ded6)(fetchHeaders);
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const downLg = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('lg'));
    const activeMember = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$367314d85393c4e));
    const eventLocations = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$503e5e11c8cc005e));
    const member = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$f4931e6f9feb30c5));
    const user = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$7cbf767827cd68ba));
    const eventPrices = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$fe140eefbe221ed9));
    const events = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$3f41ece7d7128238));
    const [data, setData] = (0, $3OyDL.useState)(props.data);
    const [emailData, setEmailData] = (0, $3OyDL.useState)($3ba6ea6d28b153a2$var$defaultEmailObject);
    const [emailTemplateHtml, setEmailTemplateHtml] = (0, $3OyDL.useState)();
    const [testMemberEmail, setTestMemberEmail] = (0, $3OyDL.useState)();
    const [memberOption, setMemberOption] = (0, $3OyDL.useState)();
    const [eventLocationOptions, setEventLocationOptions] = (0, $3OyDL.useState)([]);
    const [eventMemberOptions, setEventMemberOptions] = (0, $3OyDL.useState)([]);
    const [showNewLocationDialog, setShowNewLocationDialog] = (0, $3OyDL.useState)(false);
    const [eventImages, setEventImages] = (0, $3OyDL.useState)(undefined);
    const [position, setPosition] = (0, $3OyDL.useState)(new (0, $ad5a22b7e45eeb01$exports.LatLng)(51.0834196, 10.4234469));
    const [activeTab, setActiveTab] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState("general");
    const [newLocation, setNewLocation] = (0, $3OyDL.useState)({
        name: ''
    });
    const setEventPriceCategories = (fetchData)=>{
        setData({
            ...data,
            eventPrices: fetchData.results
        });
        const newArray = [];
        eventPrices?.results.map((elem)=>{
            if (elem.eventId !== data.event.id) newArray.push(elem);
        });
        fetchData.results.map((elem)=>{
            newArray.push(elem);
        });
        const newEventPrices = {
            count: newArray.length,
            results: newArray
        };
        dispatch($5993246da723f2dd$export$d70f6b01a5244300(newEventPrices));
    };
    const setEventLocations = (data)=>{
        dispatch($5993246da723f2dd$export$af0d9692e57c37e3({
            count: data.count,
            results: data.results
        }));
    };
    (0, $3OyDL.useEffect)(()=>{
        const opt = eventLocations ? (0, $bd7a1b8dae1ad8b8$export$2e2bcd8739ae039)(eventLocations) : [];
        opt.unshift({
            key: 'new',
            value: '<em>Neuen Veranstaltungsort anlegen</em>'
        });
        setEventLocationOptions(opt);
    }, [
        eventLocations
    ]);
    (0, $3OyDL.useEffect)(()=>{
        const opt = member ? (0, $fbde4f20a5469c7e$export$2e2bcd8739ae039)(member) : [];
        setEventMemberOptions(opt);
    }, [
        member
    ]);
    (0, $3OyDL.useEffect)(()=>{
        setData(props.data);
        setEventImages(props.data.event.imageUrls || []);
        setActiveTab("general");
        setEmailTemplateHtml(undefined);
        setEmailData($3ba6ea6d28b153a2$var$defaultEmailObject);
    }, [
        props.data,
        props.data.eventPrices
    ]);
    const setEvents = (data)=>{
        const results = data.results.sort((a, b)=>{
            const yearA = a.eventFrom.year;
            const yearB = b.eventFrom.year;
            if (yearA > yearB) return -1;
            if (yearA < yearB) return 1;
            return 0;
        });
        dispatch($5993246da723f2dd$export$60e96fb0202719e5({
            count: data.count,
            results: results
        }));
    };
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [temporaryPricesEventId, setTemporaryPricesEventId] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const getOlderPriceOptions = ()=>{
        const olderPriceOptions = [];
        eventPrices?.results.map((price)=>{
            const element = {
                key: price.eventId,
                value: events?.results.find((elem)=>elem.id === price.eventId)?.title || price.eventId
            };
            if (!olderPriceOptions.find((old)=>old.key === price.eventId)) olderPriceOptions.push(element);
        });
        return olderPriceOptions;
    };
    const getInvitation = ()=>{
        return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                    children: "Hallo [vorname],"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                    children: [
                        "ich hoffe, diese Nachricht erreicht dich bei bester Gesundheit und noch besserer Laune. Es ist mal wieder an der Zeit, dass wir uns alle zum gem\xfctlichen Familientreffen zusammenfinden.",
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        "Deshalb m\xf6chte ich euch herzlich zu unserem n\xe4chsten Familientreffen einladen, das vom ",
                        (0, $f88738dfeeda6137$export$2e2bcd8739ae039)(props.data.event.eventFrom),
                        " bis zum ",
                        (0, $f88738dfeeda6137$export$2e2bcd8739ae039)(props.data.event.eventTo),
                        " in ",
                        props.data.eventLocation?.name,
                        " stattfinden wird. Wir haben wieder eine wundervolle Herberge ausgew\xe4hlt, die genug Platz f\xfcr uns alle bietet und uns die M\xf6glichkeit gibt, gemeinsam zu feiern, zu lachen und sch\xf6ne Erinnerungen zu schaffen.",
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                            children: "Veranstaltungsdetails"
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        "Datum: ",
                        (0, $f88738dfeeda6137$export$2e2bcd8739ae039)(props.data.event.eventFrom),
                        " bis ",
                        (0, $f88738dfeeda6137$export$2e2bcd8739ae039)(props.data.event.eventTo),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        "Ort: ",
                        props.data.eventLocation?.name,
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        props.data.eventLocation?.coordinates && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                            children: [
                                "Anreise: ",
                                /*#__PURE__*/ (0, $2M70Q.jsx)("a", {
                                    href: `https://www.google.de/maps/dir//'${props.data.eventLocation?.coordinates}'/@${props.data.eventLocation?.coordinates},13z/data=${props.data.eventLocation?.coordinates}?entry=ttu`,
                                    target: "_blank",
                                    children: "Google Maps"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {})
                    ]
                }),
                props.data.eventLocation?.description && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                            children: "Informationen zur Unterkunft"
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: `${(0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize(props.data.eventLocation.description)}`
                            }
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {})
                    ]
                }),
                data.eventPrices.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                            children: "Preisinformationen"
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("table", {
                            children: data.eventPrices?.sort((a, b)=>{
                                const nameA = a.title.toUpperCase();
                                const nameB = b.title.toUpperCase();
                                if (nameA < nameB) return -1;
                                if (nameA > nameB) return 1;
                                return 0;
                            }).map((priceElement, index)=>{
                                return /*#__PURE__*/ (0, $2M70Q.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                            children: priceElement.title
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                            children: priceElement.description
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                            align: "right",
                                            children: (0, $47024d0ef744770b$export$2e2bcd8739ae039)(priceElement.price || 0)
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                    children: [
                        "Bitte meldet euch verbindlich bis sp\xe4testens ",
                        (0, $f88738dfeeda6137$export$2e2bcd8739ae039)(props.data.event.registrationUntil),
                        " an. Das geht ganz einfach online unter",
                        /*#__PURE__*/ (0, $2M70Q.jsx)("a", {
                            href: "https://www.familienskatturnier.de",
                            target: "_blank",
                            children: " www.familienskatturnier.de"
                        }),
                        ". Dort werden alle eure Buchungen und auch bereits hinterlegte Allergien / Unvertr\xe4glichkeiten ber\xfccksichtigt.",
                        (activeMember?.email || activeMember?.phone) && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                                "Alternativ k\xf6nnt ihr euch auch, wie bisher "
                            ]
                        }),
                        activeMember?.email && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                            children: [
                                " per E-Mail an ",
                                activeMember?.email
                            ]
                        }),
                        activeMember?.phone && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                            children: [
                                " oder per SMS/WhatsApp an ",
                                activeMember?.phone
                            ]
                        }),
                        " anmelden. Bitte gebt dann an, wie viele Erwachsene und Kinder in welchem Alter teilnehmen werden. Zus\xe4tzlich bitte ich euch, besondere Ern\xe4hrungsformen, eventuelle Allergien oder Unvertr\xe4glichkeiten anzugeben, damit wir entsprechende Vorkehrungen treffen k\xf6nnen.",
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        "Wir freuen uns auf jeden einzelnen von euch, entspannte Tage im Kreis der Familie und spannende Skatrunden."
                    ]
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                    children: [
                        "Liebe Gr\xfc\xdfe, ",
                        /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                        activeMember?.gender === (0, $c7fa01100a96d1f7$export$d549c77c8a078892).female ? 'Eure ' : activeMember?.gender === (0, $c7fa01100a96d1f7$export$d549c77c8a078892).male ? 'Euer ' : '',
                        activeMember?.firstname
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        className: classes.paper,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $300390f560fe3d4d$export$2e2bcd8739ae039), {
                sx: {
                    marginBottom: '20px'
                },
                value: activeTab,
                onChange: (e, newValue)=>setActiveTab(newValue),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                        sx: {
                            minWidth: '70px!important'
                        },
                        value: "general",
                        label: downMd ? undefined : 'Allgemein',
                        icon: downMd ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e7a38a4908cae58a$exports))), {}) : undefined
                    }, "general"),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                        sx: {
                            minWidth: '70px!important'
                        },
                        value: "prices",
                        icon: downMd ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bb8e3cea3d4722f4$exports))), {}) : undefined,
                        label: downMd ? undefined : 'Preisliste'
                    }, "prices"),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                        sx: {
                            minWidth: '70px!important'
                        },
                        value: "email",
                        icon: downMd ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85e09de6caf3f045$exports))), {}) : undefined,
                        label: downMd ? undefined : 'E-Mail'
                    }, "email")
                ]
            }),
            activeTab === "email" && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                            label: "Vorlage ausw\xe4hlen",
                            options: [
                                {
                                    key: "invitation",
                                    value: 'Einladung'
                                }
                            ],
                            onChange: (value)=>{
                                let templateString = '';
                                switch(value?.key){
                                    case "invitation":
                                        // @ts-ignore
                                        templateString = (0, $5a57ac24af0bf3ca$exports.renderToString)(getInvitation()).replace('[vorname]', '%s');
                                        setEmailTemplateHtml(getInvitation());
                                }
                                setEmailData({
                                    ...emailData,
                                    subject: `Einladung zum "Otto-Mei\xdfner-Pokal" Familientreffen ${props.data.event.eventFrom?.year}`,
                                    template: templateString,
                                    text: undefined
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $18cdc96991ab6ed1$export$2e2bcd8739ae039), {
                        sx: {
                            margin: '20px 0'
                        }
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                        label: "Betreff",
                        fullWidth: true,
                        required: true,
                        value: emailData.subject,
                        onChange: (value)=>{
                            setEmailData({
                                ...emailData,
                                subject: value || ''
                            });
                        }
                    }),
                    emailTemplateHtml && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                        children: emailTemplateHtml
                    }),
                    !emailTemplateHtml && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $20c6b651fc290466$export$2e2bcd8739ae039), {
                        onChange: (value)=>{
                            setEmailData({
                                ...emailData,
                                template: undefined,
                                text: value
                            });
                            setEmailTemplateHtml(undefined);
                        }
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $18cdc96991ab6ed1$export$2e2bcd8739ae039), {
                        sx: {
                            margin: '20px 0'
                        }
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    width: '100%'
                                },
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                    value: memberOption === "member",
                                    label: "Alle Familienmitglieder ausw\xe4hlen",
                                    onChange: (checked)=>{
                                        setMemberOption("member");
                                        if (checked) {
                                            const newRecipients = [];
                                            member?.results.map((tempMember)=>{
                                                if (tempMember.email) newRecipients.push(tempMember.originId);
                                            });
                                            setEmailData({
                                                ...emailData,
                                                recipients: newRecipients
                                            });
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    width: '100%'
                                },
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                    value: memberOption === "eventMember",
                                    label: "Nur angemeldete Familienmitglieder ausw\xe4hlen",
                                    onChange: (checked)=>{
                                        setMemberOption("eventMember");
                                        if (checked) {
                                            const newRecipients = [];
                                            props.data.eventMember.map((eventMember)=>{
                                                newRecipients.push(eventMember.memberId);
                                            });
                                            setEmailData({
                                                ...emailData,
                                                recipients: newRecipients
                                            });
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    width: '100%'
                                },
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                    value: memberOption === "player",
                                    label: "Alle Skatspieler ausw\xe4hlen",
                                    onChange: (checked)=>{
                                        setMemberOption("player");
                                        if (checked) {
                                            const newRecipients = [];
                                            props.data.eventMember.map((eventMember)=>{
                                                if (eventMember.gamer) newRecipients.push(eventMember.memberId);
                                            });
                                            setEmailData({
                                                ...emailData,
                                                recipients: newRecipients
                                            });
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    width: '100%'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                        value: memberOption === "custom",
                                        label: "Nur bestimmte Familienmitglieder ausw\xe4hlen",
                                        onChange: (checked)=>{
                                            setMemberOption("custom");
                                            setEmailData({
                                                ...emailData,
                                                recipients: []
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $18cdc96991ab6ed1$export$2e2bcd8739ae039), {
                                        sx: {
                                            margin: '20px 0'
                                        }
                                    }),
                                    memberOption === "custom" && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        children: member?.results.sort((a, b)=>{
                                            const nameA = a.firstname.toUpperCase();
                                            const nameB = b.firstname.toUpperCase();
                                            if (nameA < nameB) return -1;
                                            if (nameA > nameB) return 1;
                                            return 0;
                                        }).map((tempMember)=>{
                                            if (tempMember.email) return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '100%'
                                                },
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                    value: emailData.recipients.findIndex((elem)=>elem === tempMember.originId) > -1,
                                                    label: `${tempMember.firstname} ${tempMember.lastname}`,
                                                    onChange: (checked)=>{
                                                        const newRecipients = emailData.recipients;
                                                        if (checked) newRecipients.push(tempMember.originId);
                                                        else newRecipients.splice(newRecipients.findIndex((elem)=>elem === tempMember.originId), 1);
                                                        setEmailData({
                                                            ...emailData,
                                                            recipients: newRecipients
                                                        });
                                                    }
                                                })
                                            });
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            margin: '20px 0',
                            flexWrap: downSm ? 'wrap' : 'nowrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    width: downSm ? '100%' : '45%',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    flexWrap: 'wrap',
                                    marginRight: downSm ? 0 : '10px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: '100%'
                                        },
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            value: testMemberEmail,
                                            size: "small",
                                            label: "Test E-Mail",
                                            onChange: (value)=>{
                                                setTestMemberEmail(value);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginTop: downSm ? '10px' : 0
                                        },
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            text: "Test-E-Mail absenden",
                                            disabled: emailData.subject === '' || !emailData.template && !emailData.text || !testMemberEmail,
                                            onClick: ()=>{
                                                if (emailData.subject !== '' && emailData.template !== '') {
                                                    const restUrl = `${basePath}/api/email/send`;
                                                    const body = {
                                                        ...emailData,
                                                        senderId: user?.memberId,
                                                        recipients: [],
                                                        testEmail: testMemberEmail
                                                    };
                                                    setTestMemberEmail(undefined);
                                                    fetch(restUrl, {
                                                        method: 'POST',
                                                        credentials: 'include',
                                                        headers: fetchHeaders,
                                                        body: JSON.stringify(body)
                                                    }).then((res)=>res.json()).then((json)=>{
                                                        (0, $7173820326fb9f6c$export$706cdae1b5419ef8)({
                                                            message: 'E-Mail erfolgreich versandt',
                                                            severity: (0, $c7fa01100a96d1f7$export$918a9776c0a3cf27).success
                                                        });
                                                    }).catch((err)=>console.log(err));
                                                }
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    width: downSm ? '100%' : '45%',
                                    display: 'flex',
                                    alignItems: 'flex-end',
                                    marginTop: downSm ? '10px' : 0
                                },
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    size: "medium",
                                    text: "E-Mail(s) absenden",
                                    disabled: emailData.subject === '' || !emailData.template && !emailData.text,
                                    onClick: ()=>{
                                        if (emailData.subject !== '' && emailData.template !== '') {
                                            const restUrl = `${basePath}/api/email/send`;
                                            const body = {
                                                ...emailData,
                                                senderId: user?.memberId,
                                                testEmail: undefined
                                            };
                                            setEmailData($3ba6ea6d28b153a2$var$defaultEmailObject);
                                            setEmailTemplateHtml(undefined);
                                            setMemberOption(undefined);
                                            fetch(restUrl, {
                                                method: 'POST',
                                                credentials: 'include',
                                                headers: fetchHeaders,
                                                body: JSON.stringify(body)
                                            }).then((res)=>res.json()).then((json)=>{
                                                (0, $7173820326fb9f6c$export$706cdae1b5419ef8)({
                                                    message: 'E-Mails erfolgreich versandt',
                                                    severity: (0, $c7fa01100a96d1f7$export$918a9776c0a3cf27).success
                                                });
                                            }).catch((err)=>console.log(err));
                                        }
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            activeTab === "prices" && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    data.eventPrices.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: "Hier k\xf6nnen Buchungsoptionen mit Preisen angelegt oder aus einem der Vorjahre \xfcbernommen werden."
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    flexWrap: 'nnowrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: '45%'
                                        },
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            size: "small",
                                            options: getOlderPriceOptions(),
                                            label: "Preislisten der Vorjahre",
                                            onChange: (value)=>{
                                                setTemporaryPricesEventId(value?.key);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        sx: {
                                            width: '45%',
                                            paddingTop: '10px'
                                        },
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            size: "medium",
                                            disabled: !temporaryPricesEventId,
                                            text: "Ausw\xe4hlen",
                                            onClick: ()=>{
                                                if (props.data.event.id) {
                                                    const tempArray = [];
                                                    temporaryPricesEventId && eventPrices?.results.map((price)=>{
                                                        if (price.eventId === temporaryPricesEventId) props.data.event.id && tempArray.push({
                                                            ...price,
                                                            eventId: props.data.event.id
                                                        });
                                                    });
                                                    setData({
                                                        ...data,
                                                        eventPrices: tempArray
                                                    });
                                                    tempArray.map((elem)=>{
                                                        (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventPriceCategories, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).POST, undefined, {
                                                            priceCategory: elem
                                                        }, undefined, (0, $7173820326fb9f6c$export$706cdae1b5419ef8));
                                                    });
                                                }
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    data.eventPrices?.sort((a, b)=>{
                        const nameA = a.title.toUpperCase();
                        const nameB = b.title.toUpperCase();
                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;
                        return 0;
                    }).map((priceElement, index)=>{
                        return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $19e56772b842faf0$export$2e2bcd8739ae039), {
                            sx: {
                                margin: '0px!important',
                                borderBottom: `1px solid ${theme.palette.grey.A400}`
                            },
                            TransitionProps: {
                                unmountOnExit: true
                            },
                            expanded: expanded === priceElement.id,
                            onChange: ()=>{
                                expanded === priceElement.id ? setExpanded(undefined) : setExpanded(priceElement.id);
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7ba21131579dfa21$export$2e2bcd8739ae039), {
                                    expandIcon: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1e0e42f5f37a7922$exports))), {}),
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                        children: priceElement.title
                                    })
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $bd3612b92fc47d5c$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                            spacing: theme.spacing(1),
                                            container: true,
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                        label: "Titel",
                                                        value: priceElement.title,
                                                        required: true,
                                                        fullWidth: true,
                                                        onChange: (value)=>{
                                                            const newValue = value || '';
                                                            const tempArray = data.eventPrices.map((elem)=>{
                                                                if (elem.id === priceElement.id) elem.title = newValue;
                                                                return elem;
                                                            });
                                                            setData({
                                                                ...data,
                                                                eventPrices: tempArray
                                                            });
                                                        }
                                                    })
                                                }, index),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                        label: "Beschreibung",
                                                        value: priceElement.description,
                                                        multiline: true,
                                                        minRows: 2,
                                                        fullWidth: true,
                                                        onChange: (value)=>{
                                                            const newValue = value || '';
                                                            const tempArray = data.eventPrices.map((elem)=>{
                                                                if (elem.id === priceElement.id) elem.description = newValue;
                                                                return elem;
                                                            });
                                                            setData({
                                                                ...data,
                                                                eventPrices: tempArray
                                                            });
                                                        }
                                                    })
                                                }, index),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: 6,
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                        label: "Preis",
                                                        value: priceElement.price,
                                                        type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).number,
                                                        fullWidth: true,
                                                        required: true,
                                                        startAdornment: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $251953dff96397bc$export$2e2bcd8739ae039), {
                                                            position: "start",
                                                            children: "\u20AC"
                                                        }),
                                                        onChange: (value)=>{
                                                            const newValue = value;
                                                            const tempArray = data.eventPrices.map((elem)=>{
                                                                if (elem.id === priceElement.id) elem.price = newValue;
                                                                return elem;
                                                            });
                                                            setData({
                                                                ...data,
                                                                eventPrices: tempArray
                                                            });
                                                        }
                                                    })
                                                }, index),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: 6,
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                        label: "Anzahl",
                                                        value: priceElement.defaultCount,
                                                        type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).number,
                                                        fullWidth: true,
                                                        required: true,
                                                        onChange: (value)=>{
                                                            const newValue = value;
                                                            const tempArray = data.eventPrices.map((elem)=>{
                                                                if (elem.id === priceElement.id) elem.defaultCount = newValue;
                                                                return elem;
                                                            });
                                                            setData({
                                                                ...data,
                                                                eventPrices: tempArray
                                                            });
                                                        }
                                                    })
                                                }, index),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: 6,
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                        label: "Alter von",
                                                        value: priceElement.ageFrom,
                                                        type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).number,
                                                        fullWidth: true,
                                                        onChange: (value)=>{
                                                            const newValue = value;
                                                            const tempArray = data.eventPrices.map((elem)=>{
                                                                if (elem.id === priceElement.id) elem.ageFrom = newValue;
                                                                return elem;
                                                            });
                                                            setData({
                                                                ...data,
                                                                eventPrices: tempArray
                                                            });
                                                        }
                                                    })
                                                }, index),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: 6,
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                        label: "Alter bis",
                                                        value: priceElement.ageTo,
                                                        type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).number,
                                                        fullWidth: true,
                                                        onChange: (value)=>{
                                                            const newValue = value;
                                                            const tempArray = data.eventPrices.map((elem)=>{
                                                                if (elem.id === priceElement.id) elem.ageTo = newValue;
                                                                return elem;
                                                            });
                                                            setData({
                                                                ...data,
                                                                eventPrices: tempArray
                                                            });
                                                        }
                                                    })
                                                }, index)
                                            ]
                                        }, index),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'space-between'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                                    text: "L\xf6schen",
                                                    color: "secondary",
                                                    onClick: ()=>{
                                                        if (priceElement.id === 'new') {
                                                            const dataPrices = [];
                                                            data.eventPrices.map((elem)=>{
                                                                if (elem.id !== 'new') dataPrices.push(elem);
                                                            });
                                                            setData({
                                                                ...data,
                                                                eventPrices: dataPrices
                                                            });
                                                        } else (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventPriceCategories, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).DELETE, priceElement.id, undefined, setEventPriceCategories, (0, $7173820326fb9f6c$export$706cdae1b5419ef8));
                                                        setExpanded(undefined);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                                    text: "Speichern",
                                                    onClick: ()=>{
                                                        if (priceElement.id === 'new') (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventPriceCategories, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).POST, undefined, {
                                                            priceCategory: data.eventPrices.find((elem)=>elem.id === 'new')
                                                        }, setEventPriceCategories, (0, $7173820326fb9f6c$export$706cdae1b5419ef8));
                                                        else (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventPriceCategories, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).PUT, priceElement.id, {
                                                            priceCategory: data.eventPrices.find((elem)=>elem.id === priceElement.id)
                                                        }, setEventPriceCategories, (0, $7173820326fb9f6c$export$706cdae1b5419ef8));
                                                        setExpanded(undefined);
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        });
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                        disabled: !!data.eventPrices.find((elem)=>elem.id === 'new'),
                        onClick: ()=>{
                            if (data.event.id) {
                                const newPriceElement = {
                                    id: 'new',
                                    eventId: data.event.id,
                                    defaultCount: 1,
                                    title: '',
                                    description: '',
                                    price: 0.00
                                };
                                const dataPrices = data.eventPrices;
                                if (!dataPrices.find((elem)=>elem.id === 'new')) {
                                    dataPrices.push(newPriceElement);
                                    setData({
                                        ...data,
                                        eventPrices: dataPrices
                                    });
                                    setExpanded('new');
                                }
                            }
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($80b8df6a6d317902$exports))), {})
                    })
                ]
            }),
            activeTab === "general" && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                            label: "Titel",
                            value: data?.event.title,
                            required: true,
                            fullWidth: true,
                            onChange: (value)=>{
                                const newValue = value || '';
                                setData({
                                    ...data,
                                    event: {
                                        ...data.event,
                                        title: newValue
                                    }
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        container: true,
                        item: true,
                        xs: downLg ? 12 : downSm ? 12 : 6,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 6,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $dd1551179d3d9c5a$export$2e2bcd8739ae039), {
                                    label: "Von",
                                    fullWidth: true,
                                    value: data.event.eventFrom && (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(data.event.eventFrom),
                                    onChangeDate: (value)=>{
                                        setData({
                                            ...data,
                                            event: {
                                                ...data.event,
                                                eventFrom: value ? (0, $d67ad22a7bb63f61$export$2e2bcd8739ae039)(value) : {}
                                            }
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 6,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $dd1551179d3d9c5a$export$2e2bcd8739ae039), {
                                    label: "Bis",
                                    fullWidth: true,
                                    minDate: data.event.eventFrom && (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(data.event.eventFrom),
                                    value: data.event.eventTo && (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(data.event.eventTo),
                                    onChangeDate: (value)=>{
                                        setData({
                                            ...data,
                                            event: {
                                                ...data.event,
                                                eventTo: value ? (0, $d67ad22a7bb63f61$export$2e2bcd8739ae039)(value) : {}
                                            }
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                    label: "Veranstaltungsort",
                                    options: eventLocationOptions,
                                    value: eventLocationOptions.find((elem)=>elem.key === data.event.locationId)?.key,
                                    multiple: false,
                                    onChange: (value)=>{
                                        if (value?.key === 'new') {
                                            setShowNewLocationDialog(true);
                                            setData({
                                                ...data,
                                                event: {
                                                    ...data.event,
                                                    locationId: undefined
                                                }
                                            });
                                        } else setData({
                                            ...data,
                                            event: {
                                                ...data.event,
                                                locationId: value?.key
                                            }
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                    label: "Signatur",
                                    value: data.event.signature,
                                    fullWidth: true,
                                    onChange: (value)=>{
                                        const newValue = value || '';
                                        setData({
                                            ...data,
                                            event: {
                                                ...data.event,
                                                signature: newValue
                                            }
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $dd1551179d3d9c5a$export$2e2bcd8739ae039), {
                                    label: "Anmeldung bis",
                                    fullWidth: true,
                                    value: data.event.registrationUntil && (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(data.event.registrationUntil),
                                    onChangeDate: (value)=>{
                                        value && setData({
                                            ...data,
                                            event: {
                                                ...data.event,
                                                registrationUntil: (0, $d67ad22a7bb63f61$export$2e2bcd8739ae039)(value)
                                            }
                                        });
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        container: true,
                        item: true,
                        xs: downLg ? 12 : downSm ? 12 : 6,
                        spacing: 2,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $20c6b651fc290466$export$2e2bcd8739ae039), {
                                label: "Zusammenfassung",
                                height: "330px",
                                tooltip: "Hier kann die Zusammenfassung des Events eingetragen werden, falls verf\xfcgbar.",
                                value: data.event.description,
                                onChange: (value)=>{
                                    let newValue = value || undefined;
                                    if (newValue === '' || newValue === ' ') newValue = undefined;
                                    setData({
                                        ...data,
                                        event: {
                                            ...data.event,
                                            description: newValue
                                        }
                                    });
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                            label: "Organisatoren",
                            options: eventMemberOptions,
                            multipleValue: data.event.organizer,
                            multiple: true,
                            onChangeList: (value)=>{
                                const organizer = [];
                                value.map((elem)=>{
                                    organizer.push(elem.key);
                                });
                                setData({
                                    ...data,
                                    event: {
                                        ...data.event,
                                        organizer: organizer
                                    }
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $25c2ff9358099864$export$2e2bcd8739ae039), {
                            allowVideoUpload: false,
                            file: eventImages,
                            setMediaFile: (file)=>setEventImages(file)
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        textAlign: "right",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                            text: data.event.id === 'new' ? 'Erstellen' : 'Speichern',
                            color: "primary",
                            onClick: ()=>{
                                eventImages;
                                let method = (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).PUT;
                                let id = data.event.id;
                                if (!data.event.id || data.event.id === 'new') {
                                    method = (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).POST;
                                    delete data.event.id;
                                    id = undefined;
                                }
                                (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).events, method, id, {
                                    event: data.event
                                }, setEvents, (0, $7173820326fb9f6c$export$706cdae1b5419ef8));
                                props.setAdminMode(false);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $ee30f4276828974b$export$2e2bcd8739ae039), {
                open: showNewLocationDialog,
                onClose: ()=>setShowNewLocationDialog(false),
                sx: {
                    '& .MuiDialog-paper': {
                        borderRadius: 0,
                        minWidth: '80%',
                        maxWidth: '80%'
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                        sx: {
                            p: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 3,
                                alignItems: "center",
                                justifyContent: "space-between",
                                className: classes.baseBox,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $286e44e498de27a0$export$2e2bcd8739ae039), {
                                    sx: {
                                        fontWeight: 600,
                                        p: 0,
                                        fontSize: '16px',
                                        marginBottom: '20px'
                                    },
                                    children: "Neuer Veranstaltungsort"
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b9097f1d6e2a4efc$export$2e2bcd8739ae039), {
                                sx: {
                                    p: 0,
                                    overflow: 'visible'
                                },
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    container: true,
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: downMd ? 12 : 6,
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                label: "Name",
                                                required: true,
                                                fullWidth: true,
                                                onChange: (value)=>{
                                                    const newValue = value || '';
                                                    newLocation && setNewLocation({
                                                        ...newLocation,
                                                        name: newValue
                                                    });
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: downMd ? 12 : 6,
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                label: "Signatur",
                                                required: true,
                                                fullWidth: true,
                                                onChange: (value)=>{
                                                    const newValue = value || '';
                                                    newLocation && setNewLocation({
                                                        ...newLocation,
                                                        signature: newValue
                                                    });
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                label: "Beschreibung",
                                                required: true,
                                                multiline: true,
                                                fullWidth: true,
                                                minRows: 5,
                                                onChange: (value)=>{
                                                    const newValue = value || '';
                                                    newLocation && setNewLocation({
                                                        ...newLocation,
                                                        description: newValue
                                                    });
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: downMd ? 12 : 6,
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                label: "Linktitel",
                                                fullWidth: true,
                                                onChange: (value)=>{
                                                    const newValue = value || '';
                                                    newLocation && setNewLocation({
                                                        ...newLocation,
                                                        caption: newValue
                                                    });
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: downMd ? 12 : 6,
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                label: "Linkurl",
                                                fullWidth: true,
                                                onChange: (value)=>{
                                                    const newValue = value || '';
                                                    newLocation && setNewLocation({
                                                        ...newLocation,
                                                        linkUrl: newValue
                                                    });
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: downMd ? 12 : 6,
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ae5314790b38ab46$export$2e2bcd8739ae039), {
                                                    destination: newLocation?.name,
                                                    setPosition: (obj)=>{
                                                        setPosition(new (0, $ad5a22b7e45eeb01$exports.LatLng)(obj.lat, obj.long));
                                                        newLocation && setNewLocation({
                                                            ...newLocation,
                                                            coordinates: `${obj.lat},${obj.long}`
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7801af78bc29c2a9$export$2e2bcd8739ae039), {
                                                    mapZoom: 12,
                                                    positions: [
                                                        position
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: downMd ? 12 : 6,
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $25c2ff9358099864$export$2e2bcd8739ae039), {
                                                allowVideoUpload: false,
                                                file: undefined,
                                                setMediaFile: (file)=>// TODO save file
                                                    file && newLocation && setNewLocation({
                                                        ...newLocation,
                                                        imageUrls: [
                                                            file
                                                        ]
                                                    })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $08e4970efe955928$export$2e2bcd8739ae039), {
                        sx: {
                            p: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                color: "primary",
                                variant: "text",
                                text: "Verwerfen",
                                onClick: ()=>{
                                    setNewLocation({
                                        name: '',
                                        imageUrls: []
                                    });
                                    setShowNewLocationDialog(false);
                                }
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                color: "primary",
                                variant: "contained",
                                text: "Speichern",
                                onClick: ()=>{
                                    (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventLocations, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).POST, undefined, {
                                        location: newLocation
                                    }, setEventLocations, (0, $7173820326fb9f6c$export$706cdae1b5419ef8));
                                    setShowNewLocationDialog(false);
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $3ba6ea6d28b153a2$export$2e2bcd8739ae039 = $3ba6ea6d28b153a2$var$TimelineElementEditor;





var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");





const $3ebecbb817f83ba8$var$EventMap = (props)=>{
    const eventLocations = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$503e5e11c8cc005e));
    const [positions, setPositions] = (0, $3OyDL.useState)([]);
    const [label, setLabel] = (0, $3OyDL.useState)([]);
    (0, $3OyDL.useEffect)(()=>{
        const newPos = [];
        const newLabel = [];
        eventLocations?.results.map((location)=>{
            const stringCoords = location.coordinates?.split(',');
            const coordinates = [];
            stringCoords && stringCoords[0] && coordinates.push(parseInt(stringCoords[0], 10));
            stringCoords && stringCoords[1] && coordinates.push(parseInt(stringCoords[1], 10));
            location.coordinates && newPos.push(new (0, $ad5a22b7e45eeb01$exports.LatLng)(coordinates[0], coordinates[1]));
            location.coordinates && newLabel.push(location.name);
        });
        setPositions(newPos);
        setLabel(newLabel);
    }, [
        eventLocations
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7801af78bc29c2a9$export$2e2bcd8739ae039), {
            height: props.height,
            positions: positions,
            mapZoom: props.mapZoom,
            label: label
        })
    });
};
var $3ebecbb817f83ba8$export$2e2bcd8739ae039 = $3ebecbb817f83ba8$var$EventMap;



var $f4be88c6641a5d35$exports = {};
"use strict";
"use client";

Object.defineProperty($f4be88c6641a5d35$exports, "__esModule", {
    value: true
});
$f4be88c6641a5d35$exports.default = void 0;

var $f4be88c6641a5d35$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $f4be88c6641a5d35$var$_default = (0, $f4be88c6641a5d35$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
}), 'Undo');
$f4be88c6641a5d35$exports.default = $f4be88c6641a5d35$var$_default;



const $80c2b55805160fce$var$EventComponent = ()=>{
    const headerHeight = 300;
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const downLg = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('lg'));
    const userPermissions = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$7eb85035e0831f9));
    const events = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$3f41ece7d7128238));
    const members = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$f4931e6f9feb30c5));
    const eventMember = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$a1da1323b0778446));
    const eventPrices = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$fe140eefbe221ed9));
    const eventLocations = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$503e5e11c8cc005e));
    const searchInput = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$2fa22ca814667ff4));
    const [data, setData] = (0, $3OyDL.useState)([]);
    const [adminMode, setAdminMode] = (0, $3OyDL.useState)(false);
    const [activeEvent, setActiveEvent] = (0, $3OyDL.useState)();
    const [showNewEventDialog, setShowNewEventDialog] = (0, $3OyDL.useState)(false);
    const [newEventYear, setNewEventYear] = (0, $3OyDL.useState)();
    (0, $3OyDL.useEffect)(()=>{
        const tempEventId = activeEvent?.event.id;
        setActiveEvent(data.find((elem)=>elem.event.id === tempEventId));
    }, [
        data
    ]);
    (0, $3OyDL.useEffect)(()=>{
        if (activeEvent?.event.id !== 'new') setAdminMode(false);
    }, [
        activeEvent?.event.id
    ]);
    (0, $3OyDL.useEffect)(()=>{
        events && eventMember && eventPrices && eventLocations && setData((0, $f03e96cce7f8431d$export$2e2bcd8739ae039)(events, eventMember, eventPrices, eventLocations, members, searchInput));
    }, [
        events,
        eventMember,
        eventPrices,
        eventLocations,
        searchInput
    ]);
    const ref = (0, $3OyDL.useRef)(null);
    const [contentHeight, setContentHeight] = (0, $3OyDL.useState)(0);
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            root: {
                width: '100%',
                minHeight: 'calc(100vh - 250px)',
                display: 'flex',
                position: 'relative',
                justifyContent: downMd ? 'center' : 'space-between'
            },
            timeline: {
                flexGrow: '0!important',
                width: downMd ? '360px' : '450px',
                overflowY: 'scroll',
                overflowX: 'hidden'
            },
            item: {
                '&:before': {
                    flex: 1,
                    content: '',
                    padding: '6px 0px!important'
                }
            },
            settingsIcon: {
                position: 'absolute',
                top: '-10px',
                right: '10px',
                color: theme.palette.primary.main
            },
            icons: {
                transform: 'scale(1.2)'
            },
            addIcon: {
                borderRadius: 42,
                height: '52px',
                width: '52px',
                border: `2px solid ${theme.palette.primary.main}`,
                position: 'absolute',
                top: downSm ? '10px' : downMd ? '44px' : '44px',
                left: downSm ? '46px' : downMd ? '80px' : downLg ? '174px' : '114px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '24px',
                color: theme.palette.primary.main
            },
            image: {
                width: '100%',
                height: 'auto',
                cursor: 'pointer'
            }
        }));
    const classes = useStyles();
    const createNewEvent = ()=>{
        setActiveEvent({
            event: {
                id: 'new',
                title: `Veranstaltung ${newEventYear}`,
                description: ' ',
                organizer: [],
                eventFrom: {
                    year: newEventYear
                }
            },
            eventPrices: [],
            eventMember: [],
            media: []
        });
    };
    (0, $3OyDL.useEffect)(()=>ref?.current && setContentHeight(ref?.current.offsetHeight - headerHeight - 20));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
        sx: {
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                className: classes.root,
                children: [
                    userPermissions.events.find((elem)=>elem === (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).create) && (!downMd || downMd && !activeEvent) && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                        onClick: ()=>setShowNewEventDialog(true),
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            component: "div",
                            className: classes.addIcon,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                style: {
                                    marginBottom: '4px'
                                },
                                children: "+"
                            })
                        })
                    }),
                    (!downMd || downMd && !activeEvent) && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
                        sx: {
                            margin: downSm ? '0px' : '24px',
                            padding: downSm ? '8px' : '24px'
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e559194eb7cbbba6$export$2e2bcd8739ae039), {
                            position: "right",
                            className: classes.timeline,
                            sx: {
                                marginTop: '40px'
                            },
                            children: data.map((element, index)=>{
                                const color = 'primary';
                                const filled = element.event.id === activeEvent?.event.id ? 'filled' : 'outlined';
                                return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $7aaee05def34269d$export$2e2bcd8739ae039), {
                                    sx: {
                                        minHeight: '220px'
                                    },
                                    className: classes.item,
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $292c6b13e3b71ec0$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $5bbc5e33333b8ab4$export$2e2bcd8739ae039), {
                                                    onClick: ()=>{
                                                        setActiveEvent(element);
                                                    },
                                                    color: color,
                                                    variant: filled,
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b923b35411141fb9$export$2e2bcd8739ae039), {
                                                        year: element.event.eventFrom?.year,
                                                        active: element.event.id === activeEvent?.event.id
                                                    })
                                                }),
                                                index < data.length - 1 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8f50fc4ee7fe8ffc$export$2e2bcd8739ae039), {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $134d667c4e8a499c$export$2e2bcd8739ae039), {
                                            sx: {
                                                position: 'relative'
                                            },
                                            onClick: ()=>{
                                                setActiveEvent(element);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $5154e9d6612df9c0$export$2e2bcd8739ae039), {
                                                    active: element.event.id === activeEvent?.event.id,
                                                    element: element,
                                                    width: downLg ? downMd ? downSm ? 'medium' : 'big' : 'medium' : 'big'
                                                }),
                                                userPermissions.events.find((elem)=>elem === (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).update) && /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($748d42c5fe8bcf47$exports))), {
                                                    sx: {
                                                        color: theme.palette.primary.main,
                                                        position: 'absolute',
                                                        top: '10px',
                                                        right: '30px',
                                                        zIndex: 100,
                                                        cursor: 'pointer'
                                                    },
                                                    onClick: ()=>setAdminMode(!adminMode)
                                                })
                                            ]
                                        })
                                    ]
                                }, element.event.eventFrom?.year);
                            })
                        })
                    }),
                    downMd ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                        children: activeEvent && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            style: {
                                width: '100%',
                                overflow: 'hidden'
                            },
                            ref: ref,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        margin: '8px',
                                        cursor: 'pointer'
                                    },
                                    onClick: ()=>{
                                        setActiveEvent(undefined);
                                    },
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4be88c6641a5d35$exports))), {})
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
                                    sx: {
                                        padding: '8px'
                                    },
                                    children: adminMode ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3ba6ea6d28b153a2$export$2e2bcd8739ae039), {
                                        data: activeEvent,
                                        setAdminMode: (mode)=>setAdminMode(mode)
                                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $44fd8c9e8fff88a7$export$2e2bcd8739ae039), {
                                        data: activeEvent,
                                        setAdminMode: setAdminMode
                                    })
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        textAlign: 'right',
                                        margin: '8px',
                                        cursor: 'pointer'
                                    },
                                    onClick: ()=>{
                                        setActiveEvent(undefined);
                                    },
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4be88c6641a5d35$exports))), {})
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        style: {
                            width: 'calc(100% - 340px)',
                            marginRight: '20px'
                        },
                        children: activeEvent ? /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                            ref: ref,
                            children: adminMode ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3ba6ea6d28b153a2$export$2e2bcd8739ae039), {
                                data: activeEvent,
                                setAdminMode: (mode)=>setAdminMode(mode)
                            }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $44fd8c9e8fff88a7$export$2e2bcd8739ae039), {
                                data: activeEvent,
                                setAdminMode: ()=>console.log('TODO')
                            })
                        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                height: window.screen.availHeight - headerHeight - 20,
                                marginTop: '24px'
                            },
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3ebecbb817f83ba8$export$2e2bcd8739ae039), {
                                height: window.screen.availHeight - headerHeight - 20,
                                mapZoom: 6,
                                positions: []
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $ee30f4276828974b$export$2e2bcd8739ae039), {
                open: showNewEventDialog,
                onClose: ()=>setShowNewEventDialog(false),
                sx: {
                    '& .MuiDialog-paper': {
                        borderRadius: 0,
                        minWidth: '400px',
                        maxWidth: '400px'
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                        sx: {
                            p: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 3,
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $286e44e498de27a0$export$2e2bcd8739ae039), {
                                    sx: {
                                        fontWeight: 600,
                                        p: 0,
                                        fontSize: '16px',
                                        marginBottom: '20px'
                                    },
                                    children: "Neue Veranstaltung"
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b9097f1d6e2a4efc$export$2e2bcd8739ae039), {
                                sx: {
                                    p: 0,
                                    overflow: 'visible'
                                },
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    container: true,
                                    spacing: 1,
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                            label: "Veranstaltungsjahr",
                                            required: true,
                                            fullWidth: true,
                                            onChange: (value)=>{
                                                const newValue = parseInt(value, 10);
                                                setNewEventYear(newValue);
                                            }
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $08e4970efe955928$export$2e2bcd8739ae039), {
                        sx: {
                            p: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                color: "primary",
                                variant: "text",
                                text: "Verwerfen",
                                onClick: ()=>{
                                    setNewEventYear(undefined);
                                    setShowNewEventDialog(false);
                                }
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                color: "primary",
                                variant: "contained",
                                text: "Erstellen",
                                onClick: ()=>{
                                    createNewEvent();
                                    setAdminMode(true);
                                    setShowNewEventDialog(false);
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $80c2b55805160fce$export$2e2bcd8739ae039 = $80c2b55805160fce$var$EventComponent;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");

/**
 * SearchInput
 *
 */ 
var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");






const $b8fbac4e695f5ba5$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        search: {
            margin: 0,
            color: theme.palette.primary.main
        }
    }));
const $b8fbac4e695f5ba5$var$SearchComponent = (props)=>{
    const classes = $b8fbac4e695f5ba5$var$useStyles();
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const history = (0, $4e1a33337564f167$export$3420e1dc2c4a518c)();
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downXl = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('xl'));
    const [searchInput, setSearchInput] = (0, $3OyDL.useState)(props.value);
    const disabled = props.disabled ? props.disabled : false;
    (0, $3OyDL.useEffect)(()=>{
        props.changeSearch && props.changeSearch(searchInput);
    }, [
        searchInput
    ]);
    (0, $3OyDL.useEffect)(()=>{
        setSearchInput(props.value);
    }, [
        props.value
    ]);
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const SearchInput = ()=>{
        return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $328e9bc68740648b$export$2e2bcd8739ae039), {
            className: classes.search,
            disabled: disabled,
            id: "search",
            autoFocus: true,
            label: "Suchen",
            name: "name",
            sx: {
                width: '280px',
                mb: '1rem',
                '& label.Mui-focused': {
                    color: theme.palette.primary.main
                },
                '& label': {
                    color: theme.palette.primary.main
                },
                '& .MuiInputBase-root': {
                    color: theme.palette.primary.main,
                    '& > fieldset': {
                        borderColor: theme.palette.primary.main
                    },
                    '&:hover fieldset': {
                        borderColor: theme.palette.primary.main
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: theme.palette.primary.main
                    }
                }
            },
            InputProps: {
                style: {
                    color: `${theme.palette.primary.main}!important`
                },
                startAdornment: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $251953dff96397bc$export$2e2bcd8739ae039), {
                    position: "start",
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($defb55c3fac0cfee$exports))), {
                        onClick: ()=>{
                            const actualPath = history.location.pathname;
                            actualPath !== '/searchResults' && history.push('/searchresults');
                            dispatch($7173820326fb9f6c$export$8f827b63222d82c5([]));
                        },
                        sx: {
                            color: theme.palette.primary.main,
                            cursor: 'pointer'
                        }
                    })
                })
            },
            InputLabelProps: {
                shrink: true
            },
            onChange: (event)=>{
                setSearchInput(event.target.value);
            },
            size: "small",
            value: searchInput
        });
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
        sx: {
            position: 'absolute',
            display: 'flex',
            top: '0px',
            left: '0px',
            padding: '20px',
            color: '#fff'
        },
        children: downXl ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                    sx: {
                        position: 'relative'
                    },
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($defb55c3fac0cfee$exports))), {
                            sx: {
                                color: '#fff'
                            }
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: searchInput ? {
                                borderRadius: '10px',
                                width: '15px',
                                height: '15px',
                                backgroundColor: theme.palette.primary.dark,
                                color: '#fff',
                                position: 'absolute',
                                top: '5px',
                                right: '5px',
                                fontSize: '12px',
                                fontWeight: 'bold'
                            } : {
                                width: '15px',
                                height: '15px',
                                color: 'transparent'
                            },
                            children: "!"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3d66e9e40e3cbf49$export$2e2bcd8739ae039), {
                    open: open,
                    anchorEl: anchorEl,
                    onClose: handleClose,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                    },
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        sx: {
                            padding: '24px'
                        },
                        children: SearchInput()
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
            children: SearchInput()
        })
    });
};
var $b8fbac4e695f5ba5$export$2e2bcd8739ae039 = $b8fbac4e695f5ba5$var$SearchComponent;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");
var $9fe54991acc15884$exports = {};
"use strict";
"use client";

Object.defineProperty($9fe54991acc15884$exports, "__esModule", {
    value: true
});
$9fe54991acc15884$exports.default = void 0;

var $9fe54991acc15884$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $9fe54991acc15884$var$_default = (0, $9fe54991acc15884$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');
$9fe54991acc15884$exports.default = $9fe54991acc15884$var$_default;






const $620f4eee67a0f5c9$var$NavBar = (props)=>{
    const navPoint = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$1759e81b1d90346));
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downLg = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('lg'));
    const [tab, setTab] = (0, $3OyDL.useState)(props.selectedTab);
    (0, $3OyDL.useEffect)(()=>{
        setTab(props.selectedTab);
    }, [
        props.selectedTab
    ]);
    (0, $3OyDL.useEffect)(()=>{
        const selectedTab = navPoint[0];
        setTab(props.items.find((tab)=>tab.value === selectedTab));
    }, [
        navPoint
    ]);
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: downLg ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                    sx: {
                        position: 'absolute',
                        display: 'flex',
                        top: 8,
                        right: '60px',
                        padding: '20px',
                        color: '#fff'
                    },
                    onClick: handleClick,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9fe54991acc15884$exports))), {})
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3d66e9e40e3cbf49$export$2e2bcd8739ae039), {
                    open: open,
                    anchorEl: anchorEl,
                    onClose: handleClose,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                    },
                    children: props.items && props.items.map((item, index)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                padding: '5px 20px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                cursor: 'pointer'
                            },
                            onClick: ()=>{
                                props.changeTab(item.value);
                                handleClose();
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    sx: {
                                        color: theme.palette.primary.main
                                    },
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a33fd87c92782f5$exports))), {
                                    sx: {
                                        width: '15px',
                                        height: '15px',
                                        color: theme.palette.primary.main,
                                        marginLeft: '10px'
                                    }
                                })
                            ]
                        }, index))
                })
            ]
        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $300390f560fe3d4d$export$2e2bcd8739ae039), {
            sx: {
                position: 'absolute',
                display: 'flex',
                top: 0,
                right: 50,
                padding: '20px'
            },
            value: tab?.value || props.items[0].value,
            onChange: (e, newValue)=>{
                props.changeTab(newValue);
            },
            children: props.items && props.items.map((item, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                    sx: {
                        fontWeight: 'bold',
                        fontSize: '14px',
                        color: '#fff'
                    },
                    value: item.value,
                    label: item.title
                }, index))
        })
    });
};
var $620f4eee67a0f5c9$export$2e2bcd8739ae039 = $620f4eee67a0f5c9$var$NavBar;




var $189d3ad9de946e2f$exports = {};
"use strict";
"use client";

Object.defineProperty($189d3ad9de946e2f$exports, "__esModule", {
    value: true
});
$189d3ad9de946e2f$exports.default = void 0;

var $189d3ad9de946e2f$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $189d3ad9de946e2f$var$_default = (0, $189d3ad9de946e2f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');
$189d3ad9de946e2f$exports.default = $189d3ad9de946e2f$var$_default;


var $f856a214a33c2fd1$exports = {};
"use strict";
"use client";

Object.defineProperty($f856a214a33c2fd1$exports, "__esModule", {
    value: true
});
$f856a214a33c2fd1$exports.default = void 0;

var $f856a214a33c2fd1$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $f856a214a33c2fd1$var$_default = (0, $f856a214a33c2fd1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
}), 'Logout');
$f856a214a33c2fd1$exports.default = $f856a214a33c2fd1$var$_default;





const $22eed9cacb4508d6$var$HeaderComponent = (props)=>{
    const history = (0, $4e1a33337564f167$export$3420e1dc2c4a518c)();
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const navPoint = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$1759e81b1d90346));
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downXs = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('xs'));
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const downLg = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('lg'));
    const [tab, setTab] = (0, $3OyDL.useState)(props.items.find((elem)=>elem.value === navPoint[0]));
    const [activeUserProfile, setActiveUserProfile] = (0, $3OyDL.useState)(false);
    const [searchValue, setSearchValue] = (0, $3OyDL.useState)('');
    const changeTab = (value)=>{
        setSearchValue('');
        setActiveUserProfile(false);
        const newTab = props.items.find((elem)=>elem.value === value) || props.items[0];
        setTab(newTab);
        dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
            value
        ]));
        history.replace(newTab.path);
    };
    const top = downXs ? '-5vh' : downSm ? '-10vh' : downMd ? '-15vh' : downLg ? '-20vh' : '-30vh';
    const height = downXs ? '15vh' : downSm ? '25vh' : downMd ? '30vh' : downLg ? '40vh' : '50vh';
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                sx: {
                    position: 'relative',
                    height: height,
                    overflow: 'hidden'
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                    sx: {
                        position: 'absolute',
                        top: top,
                        width: '100%'
                    },
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                        src: "/images/header.jpg",
                        style: {
                            width: '100%',
                            filter: 'brightness(40%)'
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $620f4eee67a0f5c9$export$2e2bcd8739ae039), {
                items: props.items,
                changeTab: changeTab,
                selectedTab: tab
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    setSearchValue('');
                    setTab(undefined);
                    setActiveUserProfile(true);
                    dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
                        'userProfile'
                    ]));
                    history.replace('/' + (0, $47cf5ffcc30e4a77$export$2ce376c2cc3355c8).userProfile);
                },
                sx: {
                    position: 'absolute',
                    display: 'flex',
                    top: 8,
                    right: 50,
                    padding: '20px 0',
                    color: activeUserProfile ? theme.palette.primary.main : '#fff'
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($189d3ad9de946e2f$exports))), {})
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    props.onLogout();
                },
                sx: {
                    position: 'absolute',
                    display: 'flex',
                    top: 8,
                    right: 20,
                    padding: '20px  0',
                    color: '#fff'
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f856a214a33c2fd1$exports))), {})
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b8fbac4e695f5ba5$export$2e2bcd8739ae039), {
                value: searchValue,
                changeSearch: (value)=>props.changeSearch && props.changeSearch(value)
            })
        ]
    });
};
var $22eed9cacb4508d6$export$2e2bcd8739ae039 = $22eed9cacb4508d6$var$HeaderComponent;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");


const $e975925df8bfad2e$var$Gallery = ()=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const images = [
        'images/test.jpg',
        'images/test.jpg'
    ];
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $34aa91b0cc02ff7a$export$2e2bcd8739ae039), {
            items: images,
            navButtonsAlwaysVisible: true,
            maxWidth: "100%"
        })
    });
};
var $e975925df8bfad2e$export$2e2bcd8739ae039 = $e975925df8bfad2e$var$Gallery;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");


var $7c39fca43dd8a727$exports = {};
"use strict";
"use client";

Object.defineProperty($7c39fca43dd8a727$exports, "__esModule", {
    value: true
});
$7c39fca43dd8a727$exports.default = void 0;

var $7c39fca43dd8a727$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $7c39fca43dd8a727$var$_default = (0, $7c39fca43dd8a727$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
}), 'Visibility');
$7c39fca43dd8a727$exports.default = $7c39fca43dd8a727$var$_default;


var $702f2064b60c5fc9$exports = {};
"use strict";
"use client";

Object.defineProperty($702f2064b60c5fc9$exports, "__esModule", {
    value: true
});
$702f2064b60c5fc9$exports.default = void 0;

var $702f2064b60c5fc9$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $702f2064b60c5fc9$var$_default = (0, $702f2064b60c5fc9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), 'VisibilityOff');
$702f2064b60c5fc9$exports.default = $702f2064b60c5fc9$var$_default;








const $06f2b11196bc0bcc$var$LoginComponent = ()=>{
    const history = (0, $4e1a33337564f167$export$3420e1dc2c4a518c)();
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const [login, setLogin] = (0, $3OyDL.useState)('');
    const [password, setPassword] = (0, $3OyDL.useState)('');
    const imageOrientation = 1209 / 818;
    const [screenOrientation, setScreenOrientation] = (0, $3OyDL.useState)(window.innerWidth / window.innerHeight);
    (0, $3OyDL.useEffect)(()=>{
        setScreenOrientation(window.innerWidth / window.innerHeight);
    }, []);
    const _onLogin = ()=>{
        const loginRequest = {
            login: login,
            password: password
        };
        const basePath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
        const restUrl = `${basePath}/api/session/login`;
        const requestHeaders = new Headers();
        requestHeaders.set('Accept', 'application/json');
        requestHeaders.set('Content-Type', 'application/json');
        fetch(restUrl, {
            method: 'POST',
            body: JSON.stringify(loginRequest),
            credentials: 'include',
            headers: requestHeaders
        }).then((res)=>res.json()).then(()=>{
            const userUrl = `${basePath}/api/session/user`;
            fetch(userUrl, {
                method: 'GET',
                credentials: 'include',
                headers: requestHeaders
            }).then((res)=>res.json()).then((json)=>{
                !json.error && dispatch((0, $7173820326fb9f6c$export$8b6bb3dd62a01be2)(json));
                history.push('/family');
            }).catch((err)=>console.log(err));
        }).catch((err)=>console.log(err));
    };
    const _onKeyPress = (event)=>{
        if (event.key === 'Enter') _onLogin();
    };
    const [showPassword, setShowPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const [showForgotPasswordDialog, setShowForgotPasswordDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const [username, setUsername] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const handleClickShowPassword = ()=>setShowPassword((show)=>!show);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
        sx: {
            background: 'linear-gradient(rgba(0, 0, 0, .8), rgba(0, 0, 0, .5)), url("/images/ottoMeissner.jpg")',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: imageOrientation > screenOrientation ? 'auto 100%' : '100% auto',
            height: '100vh'
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                sx: {
                    width: downSm ? '300px' : '500px',
                    padding: '40px',
                    backgroundColor: '#fff',
                    opacity: 0.7,
                    borderRadius: '10px',
                    position: 'absolute',
                    top: 'calc(50% - 50px)',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                },
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                        variant: "h1",
                        sx: {
                            textAlign: 'center',
                            width: '100%'
                        },
                        children: "Willkommen"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("form", {
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $328e9bc68740648b$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                required: true,
                                fullWidth: true,
                                id: "login",
                                label: "Login",
                                autoComplete: "login",
                                value: login,
                                onChange: (event)=>setLogin(event.currentTarget.value),
                                onKeyPress: _onKeyPress
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $328e9bc68740648b$export$2e2bcd8739ae039), {
                                required: true,
                                variant: "outlined",
                                fullWidth: true,
                                label: "Password",
                                type: showPassword ? 'text' : 'password',
                                id: "password",
                                autoComplete: "current-password",
                                value: password,
                                onChange: (event)=>setPassword(event.currentTarget.value),
                                onKeyPress: _onKeyPress,
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $251953dff96397bc$export$2e2bcd8739ae039), {
                                        position: "end",
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                            "aria-label": "toggle password visibility",
                                            onClick: handleClickShowPassword,
                                            edge: "end",
                                            children: showPassword ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($702f2064b60c5fc9$exports))), {}) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7c39fca43dd8a727$exports))), {})
                                        })
                                    })
                                }
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    margin: '10px 0 20px 0',
                                    width: '100%',
                                    textAlign: 'center',
                                    cursor: 'pointer'
                                },
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                                    onClick: ()=>setShowForgotPasswordDialog(true),
                                    children: "Passwort vergessen?"
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a55b2c6a514356c8$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                sx: {
                                    height: '50px'
                                },
                                variant: "contained",
                                color: "primary",
                                onClick: _onLogin,
                                children: "LOGIN"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $ee30f4276828974b$export$2e2bcd8739ae039), {
                open: showForgotPasswordDialog,
                onClose: ()=>{
                    setUsername(undefined);
                    setShowForgotPasswordDialog(false);
                },
                sx: {
                    '& .MuiDialog-paper': {
                        borderRadius: 0,
                        minWidth: '300px',
                        maxWidth: '600px'
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                        sx: {
                            p: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 3,
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $286e44e498de27a0$export$2e2bcd8739ae039), {
                                    sx: {
                                        fontWeight: 600,
                                        p: 0,
                                        fontSize: '16px',
                                        marginBottom: '20px'
                                    },
                                    children: "Passswort vergessen?"
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $b9097f1d6e2a4efc$export$2e2bcd8739ae039), {
                                sx: {
                                    p: 0,
                                    overflow: 'visible'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                        variant: "body1",
                                        children: 'Wenn du dein Passwort vergessen hast, kannst du es hier zur\xfccksetzen. Gib bitte deine registrierte E-Mail Adresse oder deinen Nutzernamen ein und dr\xfccke "Passwort zur\xfccksetzen". Danach wird dir eine E-Mail mit einem Link zugesandt. Mit diesem Link kannst du ein neues Passwort vergeben.'
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                        label: "Nutzername oder E-Mail",
                                        fullWidth: true,
                                        onChange: (value)=>setUsername(value)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $08e4970efe955928$export$2e2bcd8739ae039), {
                        sx: {
                            p: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                text: "Abbrechen",
                                variant: "text",
                                color: "secondary",
                                onClick: ()=>{
                                    setUsername(undefined);
                                    setShowForgotPasswordDialog(false);
                                }
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                text: "Passwort zur\xfccksetzen",
                                color: "primary",
                                disabled: !username,
                                variant: "text",
                                onClick: ()=>{
                                    const fetchHeaders = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).fetchHeaders;
                                    const basePath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
                                    const restUrl = `${basePath}/api/session/forgotPassword`;
                                    fetch(restUrl, {
                                        method: 'POST',
                                        credentials: 'include',
                                        headers: fetchHeaders,
                                        body: JSON.stringify({
                                            user: username
                                        })
                                    }).then((res)=>{
                                        (0, $7173820326fb9f6c$export$706cdae1b5419ef8)({
                                            message: 'E-Mails erfolgreich versandt',
                                            severity: (0, $c7fa01100a96d1f7$export$918a9776c0a3cf27).success
                                        });
                                        setShowForgotPasswordDialog(false);
                                        setUsername(undefined);
                                    }).catch(()=>{
                                        setShowForgotPasswordDialog(false);
                                        setUsername(undefined);
                                        (0, $7173820326fb9f6c$export$706cdae1b5419ef8)({
                                            message: 'Ein unerwarteter Fehler. Bitte erneut versuchen.',
                                            severity: (0, $c7fa01100a96d1f7$export$918a9776c0a3cf27).error
                                        });
                                    });
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $06f2b11196bc0bcc$export$2e2bcd8739ae039 = $06f2b11196bc0bcc$var$LoginComponent;











var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");




var $3OyDL = parcelRequire("3OyDL");
const $888aa44cdb4ab34b$export$977f3f6a9323c0f6 = (name)=>(item)=>item[name];
const $888aa44cdb4ab34b$export$a57a6e31efd7989a = (id)=>(item)=>item.id === id;
const $888aa44cdb4ab34b$export$d5328c3c393e68b8 = (...types)=>(item)=>types.includes(item.type);
const $888aa44cdb4ab34b$export$6ac9c152b03c9388 = (target)=>(unit)=>target.ids.join('') === unit.ids.join('');
const $888aa44cdb4ab34b$export$40fa977508bcf282 = (items, item)=>items.concat(item);
const $888aa44cdb4ab34b$export$7a5d5c156e7dc406 = (item, index, arr)=>arr.indexOf(item) === index;
const $888aa44cdb4ab34b$export$484725e8d899ab2e = (v1, v2)=>v1 - v2;
const $888aa44cdb4ab34b$export$a4627e546088548d = (...fus)=>(init)=>fus.reduce((res, fn)=>fn(res), init);
const $888aa44cdb4ab34b$export$5c42707206f2d482 = (store)=>(rel)=>store.getNode(rel.id);
const $888aa44cdb4ab34b$export$96ec731ed4dcb222 = (arr)=>Math.min.apply(null, arr);
const $888aa44cdb4ab34b$export$8960430cfd85939f = (arr)=>Math.max.apply(null, arr);
const $888aa44cdb4ab34b$export$22b2154fd0bb0288 = (node)=>node.parents.map($888aa44cdb4ab34b$export$977f3f6a9323c0f6('type')).filter($888aa44cdb4ab34b$export$7a5d5c156e7dc406).length > 1;


const $f7a1a9e133ed7803$var$ERROR_PREFIX = '[relatives-tree::store]:';
const $f7a1a9e133ed7803$var$mapNode = (node)=>[
        node.id,
        Object.assign({}, node)
    ];
class $f7a1a9e133ed7803$var$Store {
    constructor(nodes, rootId){
        if (!nodes.find((0, $888aa44cdb4ab34b$export$a57a6e31efd7989a)(rootId))) throw new Error(`${$f7a1a9e133ed7803$var$ERROR_PREFIX} Can't find a root node with ID: ${rootId}`);
        this.nextId = 0;
        this.families = new Map();
        this.nodes = new Map(nodes.map($f7a1a9e133ed7803$var$mapNode));
        this.rootNode = this.nodes.get(rootId);
        this.gender = this.rootNode.gender;
    }
    getNextId() {
        return ++this.nextId;
    }
    getNode(id) {
        return this.nodes.get(id);
    }
    getNodes(ids) {
        return ids.map(this.getNode.bind(this));
    }
    getFamily(id) {
        return this.families.get(id);
    }
    get familiesArray() {
        return [
            ...this.families.values()
        ];
    }
}
var $f7a1a9e133ed7803$export$2e2bcd8739ae039 = $f7a1a9e133ed7803$var$Store;



const $42a5ce7d32795677$var$createRel = (id, type = 'blood')=>({
        id: id,
        type: type
    });
const $42a5ce7d32795677$var$createNode = (gender)=>({
        id: `${gender}-placeholder`,
        placeholder: true,
        gender: gender,
        parents: [],
        siblings: [],
        spouses: [],
        children: []
    });
const $42a5ce7d32795677$var$createParents = (store, root)=>{
    const father = $42a5ce7d32795677$var$createNode('male');
    const mother = $42a5ce7d32795677$var$createNode('female');
    father.spouses = [
        $42a5ce7d32795677$var$createRel(mother.id, 'married')
    ];
    mother.spouses = [
        $42a5ce7d32795677$var$createRel(father.id, 'married')
    ];
    return [
        father,
        mother
    ].map((node)=>{
        node.children = root.siblings.concat($42a5ce7d32795677$var$createRel(root.id));
        store.nodes.set(node.id, node);
        return $42a5ce7d32795677$var$createRel(node.id);
    });
};
const $42a5ce7d32795677$var$setParents = (parents)=>(node)=>node.parents = parents.slice();
var $42a5ce7d32795677$export$2e2bcd8739ae039 = (store)=>{
    if (store.rootNode.parents.length) return store;
    const root = store.rootNode;
    const setParentsTo = $42a5ce7d32795677$var$setParents($42a5ce7d32795677$var$createParents(store, root));
    setParentsTo(root);
    root.siblings.map((0, $888aa44cdb4ab34b$export$5c42707206f2d482)(store)).forEach(setParentsTo);
    return store;
};



class $352d39e5f93c5dd3$var$Unit {
    constructor(familyId, nodes, isChild = false){
        this.familyId = familyId;
        this.isChild = isChild;
        this.nodes = nodes;
        this.shift = 0;
    }
    get size() {
        return this.nodes.length;
    }
    get right() {
        return this.shift + this.size * 2;
    }
    get ids() {
        return this.nodes.map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('id'));
    }
}
var $352d39e5f93c5dd3$export$2e2bcd8739ae039 = $352d39e5f93c5dd3$var$Unit;



var $77dd49efabc9e4bf$export$2e2bcd8739ae039 = (store, parents)=>{
    const middle = [
        ...parents
    ];
    if (middle.length === 1) {
        let spouse;
        const parent = middle[0];
        const married = parent.spouses.find((0, $888aa44cdb4ab34b$export$d5328c3c393e68b8)('married'));
        if (married) spouse = store.getNode(married.id);
        else if (parent.spouses.length === 1) spouse = store.getNode(parent.spouses[0].id);
        else if (parent.spouses.length > 1) spouse = parent.spouses.map((0, $888aa44cdb4ab34b$export$5c42707206f2d482)(store)).sort((a, b)=>b.children.length - a.children.length)[0];
        if (spouse) parent.gender === store.gender ? middle.push(spouse) : middle.unshift(spouse);
    }
    const result = {
        left: [],
        middle: middle,
        right: []
    };
    if (middle.length === 2) {
        const middleIds = result.middle.map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('id'));
        result.left = middle[0].spouses.filter((rel)=>middleIds.indexOf(rel.id) === -1).sort((a)=>a.type === 'married' ? 1 : 0).map((0, $888aa44cdb4ab34b$export$5c42707206f2d482)(store));
        result.right = middle[1].spouses.filter((rel)=>middleIds.indexOf(rel.id) === -1).sort((a)=>a.type === 'married' ? -1 : 0).map((0, $888aa44cdb4ab34b$export$5c42707206f2d482)(store));
    }
    return result;
};


function $cd492813bb0e1e3a$var$getChildUnits(store, familyId, child) {
    if (child.spouses.length) {
        const { left: left, middle: middle, right: right } = (0, $77dd49efabc9e4bf$export$2e2bcd8739ae039)(store, [
            child
        ]);
        return [
            ...left.map((node)=>[
                    node
                ]),
            middle,
            ...right.map((node)=>[
                    node
                ])
        ].map((nodes)=>new (0, $352d39e5f93c5dd3$export$2e2bcd8739ae039)(familyId, nodes, true));
    }
    return [
        new (0, $352d39e5f93c5dd3$export$2e2bcd8739ae039)(familyId, [
            child
        ], true)
    ];
}
var $cd492813bb0e1e3a$export$2e2bcd8739ae039 = $cd492813bb0e1e3a$var$getChildUnits;


const $3489cb4c3a30d4ab$export$8d4e26484c874870 = 2;



class $2a763c07bf655dfd$var$Family {
    constructor(id, type, isMain = false){
        this.id = id;
        this.type = type;
        this.main = isMain;
        this.pID = null;
        this.cID = null;
        this.top = 0;
        this.left = 0;
        this.pUnits = [];
        this.cUnits = [];
    }
    get width() {
        return (0, $888aa44cdb4ab34b$export$8960430cfd85939f)([
            ...this.pUnits,
            ...this.cUnits
        ].map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('right')));
    }
    get height() {
        return this.pUnits.length ? (0, $3489cb4c3a30d4ab$export$8d4e26484c874870) * 2 : (0, $3489cb4c3a30d4ab$export$8d4e26484c874870);
    }
    get right() {
        return this.left + this.width;
    }
    get pCount() {
        return this.pUnits.reduce((a, b)=>a + b.size, 0);
    }
    get cCount() {
        return this.cUnits.reduce((a, b)=>a + b.size, 0);
    }
    get pUnitsWithParents() {
        return this.pUnits.filter((unit)=>!!unit.nodes.find((node)=>!!node.parents.length));
    }
    get cUnitsWithChildren() {
        return this.cUnits.filter((unit)=>!!unit.nodes.find((node)=>!!node.children.length));
    }
}
var $2a763c07bf655dfd$export$2e2bcd8739ae039 = $2a763c07bf655dfd$var$Family;




const $05e9ab77342a5b8d$var$shiftUnits = (units, shift)=>{
    units.forEach((unit, idx, self)=>unit.shift = idx === 0 ? shift : self[idx - 1].right);
};
function $05e9ab77342a5b8d$var$setUnitDefShifts(family) {
    const diff = family.cCount - family.pCount;
    $05e9ab77342a5b8d$var$shiftUnits(family.pUnits, diff > 0 ? Math.abs(diff) : 0);
    $05e9ab77342a5b8d$var$shiftUnits(family.cUnits, diff < 0 ? Math.abs(diff) : 0);
}
var $05e9ab77342a5b8d$export$2e2bcd8739ae039 = $05e9ab77342a5b8d$var$setUnitDefShifts;



var $5fd6c2f6c1b4eba7$export$2e2bcd8739ae039 = (store)=>{
    return function(parentIDs, type = 'root', isMain = false) {
        const family = new (0, $2a763c07bf655dfd$export$2e2bcd8739ae039)(store.getNextId(), type, isMain);
        const parents = parentIDs.map(store.getNode.bind(store));
        if (family.main) parents.sort((a, b)=>b.gender !== store.gender ? -1 : 0);
        family.pUnits.push(new (0, $352d39e5f93c5dd3$export$2e2bcd8739ae039)(family.id, parents));
        let children = [];
        if (parents.length === 1) children = parents[0].children.map((0, $888aa44cdb4ab34b$export$5c42707206f2d482)(store));
        else {
            const firstParent = parents[0];
            const secondParent = parents[1];
            children = firstParent.children.filter((rel)=>secondParent.children.find((0, $888aa44cdb4ab34b$export$a57a6e31efd7989a)(rel.id))).map((0, $888aa44cdb4ab34b$export$5c42707206f2d482)(store));
        }
        children.forEach((child)=>{
            (0, $cd492813bb0e1e3a$export$2e2bcd8739ae039)(store, family.id, child).forEach((unit)=>{
                family.cUnits.push(unit);
            });
        });
        (0, $05e9ab77342a5b8d$export$2e2bcd8739ae039)(family);
        return family;
    };
};





var $ad1637f953a4548d$export$2e2bcd8739ae039 = (lFamily, rFamily)=>{
    const lChildren = lFamily.cUnits.reduce((a, b)=>a.concat(b.nodes), []);
    const rChildren = rFamily.cUnits.reduce((a, b)=>a.concat(b.nodes), []);
    const ids = lChildren.filter((node)=>!!rChildren.find((0, $888aa44cdb4ab34b$export$a57a6e31efd7989a)(node.id))).map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('id'));
    const shifts = lFamily.cUnits.map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('shift'));
    lFamily.cUnits = lFamily.cUnits.sort((a, b)=>{
        const foundA = !!a.nodes.find((node)=>ids.indexOf(node.id) !== -1);
        const foundB = !!b.nodes.find((node)=>ids.indexOf(node.id) !== -1);
        if (foundA && !foundB) return 1;
        else if (!foundA && foundB) return -1;
        return 0;
    });
    lFamily.cUnits.forEach((unit, idx)=>unit.shift = shifts[idx]);
    rFamily.cUnits = rFamily.cUnits.filter((unit)=>!!unit.nodes.find((node)=>ids.indexOf(node.id) === -1));
    (0, $05e9ab77342a5b8d$export$2e2bcd8739ae039)(rFamily);
};





var $f63ebc3118d91ebf$export$2e2bcd8739ae039 = (store)=>{
    let families = [];
    if (!store.rootNode.parents.length) {
        const family = new (0, $2a763c07bf655dfd$export$2e2bcd8739ae039)(store.getNextId(), 'root', true);
        (0, $cd492813bb0e1e3a$export$2e2bcd8739ae039)(store, family.id, store.rootNode).forEach((unit)=>family.cUnits.push(unit));
        (0, $05e9ab77342a5b8d$export$2e2bcd8739ae039)(family);
        families.push(family);
    } else {
        const createFamily = (0, $5fd6c2f6c1b4eba7$export$2e2bcd8739ae039)(store);
        if ((0, $888aa44cdb4ab34b$export$22b2154fd0bb0288)(store.rootNode)) {
            const bloodParentIDs = store.rootNode.parents.filter((0, $888aa44cdb4ab34b$export$d5328c3c393e68b8)('blood')).map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('id'));
            const adoptedParentIDs = store.rootNode.parents.filter((0, $888aa44cdb4ab34b$export$d5328c3c393e68b8)('adopted')).map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('id'));
            const bloodFamily = createFamily(bloodParentIDs, 'root', true);
            const adoptedFamily = createFamily(adoptedParentIDs);
            (0, $ad1637f953a4548d$export$2e2bcd8739ae039)(bloodFamily, adoptedFamily);
            families = [
                bloodFamily,
                adoptedFamily
            ];
        } else {
            const parentIDs = store.rootNode.parents.map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('id'));
            const mainFamily = createFamily(parentIDs, 'root', true);
            families.push(mainFamily);
            const parents = mainFamily.pUnits.map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('nodes')).reduce((0, $888aa44cdb4ab34b$export$40fa977508bcf282));
            if (parents.length === 2) {
                const { left: left, right: right } = (0, $77dd49efabc9e4bf$export$2e2bcd8739ae039)(store, parents);
                families = [
                    ...left.map((node)=>createFamily([
                            node.id
                        ])),
                    ...families,
                    ...right.map((node)=>createFamily([
                            node.id
                        ]))
                ];
            }
        }
    }
    if (families.length > 1) for(let i = 1; i < families.length; i++)families[i].left = families[i - 1].right;
    families.forEach((family)=>store.families.set(family.id, family));
    return store;
};





var $d424712639fff533$export$2e2bcd8739ae039 = (store)=>{
    return function(childIDs) {
        const family = new (0, $2a763c07bf655dfd$export$2e2bcd8739ae039)(store.getNextId(), 'parent');
        const cUnit = new (0, $352d39e5f93c5dd3$export$2e2bcd8739ae039)(family.id, store.getNodes(childIDs), true);
        cUnit.nodes.forEach((child, cIndex)=>{
            const parents = store.getNodes(child.parents.map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('id'))).sort((a, b)=>b.gender !== store.gender ? -1 : 0);
            if (parents.length) {
                const pUnit = new (0, $352d39e5f93c5dd3$export$2e2bcd8739ae039)(family.id, parents);
                pUnit.size > 1 && cUnit.size > 1 && store.gender === child.gender ? cUnit.shift += 2 : pUnit.shift = cUnit.shift + cIndex * 2;
                family.pUnits.push(pUnit);
            }
        });
        family.cUnits.push(cUnit);
        return family;
    };
};



var $24a482f22fcfb6e2$export$2e2bcd8739ae039 = (store)=>{
    return function(family) {
        if (family.cID === null) return;
        let right = 0;
        while(family){
            const fUnit = family.cUnits[0];
            if (family.pUnits.length === 2 && family.pCount > 2) fUnit.shift = Math.floor(family.pUnits[1].shift / 2);
            const shift = fUnit.shift;
            right = Math.max(right, family.right);
            const cFamily = store.getFamily(family.cID);
            if (cFamily.cID === null) {
                fUnit.shift = (family.width - fUnit.size * 2) / 2;
                break;
            }
            const pUnit = cFamily.pUnits.find((0, $888aa44cdb4ab34b$export$6ac9c152b03c9388)(fUnit));
            const uIndex = cFamily.pUnits.findIndex((unit)=>unit.nodes[0].id === fUnit.nodes[0].id);
            if (uIndex === 0 && pUnit.shift === 0) {
                const left = family.left + shift;
                cFamily.left = Math.max(cFamily.left, left);
            } else pUnit.shift = family.left + fUnit.shift - cFamily.left;
            const next = cFamily.pUnits[uIndex + 1];
            if (next) {
                const diff = right - (cFamily.left + next.shift);
                if (diff > 0) for(let i = uIndex + 1; i < cFamily.pUnits.length; i++)cFamily.pUnits[i].shift += diff;
            }
            family = cFamily;
        }
    };
};



var $ff53c72334d4563c$export$2e2bcd8739ae039 = (store)=>{
    const createFamily = (0, $d424712639fff533$export$2e2bcd8739ae039)(store);
    const arrangeFamily = (0, $24a482f22fcfb6e2$export$2e2bcd8739ae039)(store);
    const root = store.familiesArray.filter((0, $888aa44cdb4ab34b$export$d5328c3c393e68b8)('root'));
    for (const rootFamily of root){
        if (!rootFamily.main) continue;
        let stack = rootFamily.pUnitsWithParents.reverse();
        while(stack.length){
            const familyUnit = stack.pop();
            const family = createFamily(familyUnit.nodes.map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('id')));
            const childFamily = store.getFamily(familyUnit.familyId);
            family.cID = childFamily.id;
            family.top = childFamily.top - 2;
            family.left = childFamily.left + familyUnit.shift;
            arrangeFamily(family);
            store.families.set(family.id, family);
            const nextUnits = family.pUnitsWithParents;
            if (nextUnits.length) stack = [
                ...stack,
                ...nextUnits.reverse()
            ];
        }
    }
    return store;
};





var $6fd8ad14e4261dfc$export$2e2bcd8739ae039 = (families, start = 1, left = 0)=>{
    if (families.length >= start + 1) {
        const shift = left - families[start].left;
        for(let i = start; i < families.length; i++)families[i].left += shift;
    }
};



var $89d4fa801c2d9dbd$export$2e2bcd8739ae039 = (store)=>{
    return function(family) {
        if (family.pID === null) return;
        let right = 0;
        while(family){
            const fUnit = family.pUnits[0];
            const shift = fUnit.shift;
            right = Math.max(right, family.right);
            const pFamily = store.getFamily(family.pID);
            const cUnit = pFamily.cUnits.find((0, $888aa44cdb4ab34b$export$6ac9c152b03c9388)(fUnit));
            const uIndex = pFamily.cUnits.findIndex((unit)=>unit.nodes[0].id === fUnit.nodes[0].id);
            if (uIndex === 0) {
                const left = family.left + shift - cUnit.shift;
                pFamily.left = Math.max(pFamily.left, left);
            } else cUnit.shift = family.left + fUnit.shift - pFamily.left;
            const next = pFamily.cUnits[uIndex + 1];
            if (next) {
                const diff = right - (pFamily.left + next.shift);
                for(let i = uIndex + 1; i < pFamily.cUnits.length; i++)pFamily.cUnits[i].shift += diff;
            }
            const ppUnit = pFamily.pUnits[0];
            if (ppUnit) {
                const size = pFamily.width;
                ppUnit.shift = Math.floor((size - 2 * ppUnit.size) / 2);
            }
            if (pFamily.pID === null) {
                const rootFamily = store.familiesArray.filter((0, $888aa44cdb4ab34b$export$d5328c3c393e68b8)('root'));
                const start = rootFamily.findIndex((0, $888aa44cdb4ab34b$export$a57a6e31efd7989a)(pFamily.id));
                (0, $6fd8ad14e4261dfc$export$2e2bcd8739ae039)(rootFamily, start + 1, family.right);
                break;
            }
            family = pFamily;
        }
    };
};


var $ae1b40fa5d21fa6b$export$2e2bcd8739ae039 = (store)=>{
    const createFamily = (0, $5fd6c2f6c1b4eba7$export$2e2bcd8739ae039)(store);
    const arrangeFamily = (0, $89d4fa801c2d9dbd$export$2e2bcd8739ae039)(store);
    const root = store.familiesArray.filter((0, $888aa44cdb4ab34b$export$d5328c3c393e68b8)('root'));
    for (const rootFamily of root){
        let stack = rootFamily.cUnitsWithChildren.reverse();
        while(stack.length){
            const familyUnit = stack.pop();
            const family = createFamily(familyUnit.nodes.map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('id')), 'child');
            const parentFamily = store.getFamily(familyUnit.familyId);
            family.pID = parentFamily.id;
            family.top = parentFamily.top + parentFamily.height - (0, $3489cb4c3a30d4ab$export$8d4e26484c874870);
            family.left = parentFamily.left + familyUnit.shift;
            arrangeFamily(family);
            store.families.set(family.id, family);
            const nextUnits = family.cUnitsWithChildren;
            if (nextUnits.length) stack = [
                ...stack,
                ...nextUnits.reverse()
            ];
        }
    }
    return store;
};



var $7bf09183ba23dbde$export$2e2bcd8739ae039 = (families)=>{
    const connectors = [];
    families.filter((0, $888aa44cdb4ab34b$export$d5328c3c393e68b8)('parent')).forEach((family)=>{
        family.pUnits.forEach((pUnit)=>{
            const pX = family.left + pUnit.shift + pUnit.size;
            const pY = family.top + 1;
            const mY = family.top + 2;
            if (pUnit.size === 2) connectors.push({
                points: [
                    pX - 1,
                    pY,
                    pX - 1 + 2,
                    pY
                ]
            });
            connectors.push({
                points: [
                    pX,
                    pY,
                    pX,
                    mY
                ]
            });
            const ids = pUnit.nodes.map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('children')).reduce((0, $888aa44cdb4ab34b$export$40fa977508bcf282)).map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('id')).filter((0, $888aa44cdb4ab34b$export$7a5d5c156e7dc406));
            family.cUnits.forEach((cUnit)=>{
                const cIndex = cUnit.nodes.findIndex((node)=>ids.indexOf(node.id) !== -1);
                const cX = family.left + cUnit.shift + cIndex * 2 + 1;
                connectors.push({
                    points: [
                        cX,
                        mY,
                        cX,
                        mY + 1
                    ]
                });
                if (pX !== cX) connectors.push({
                    points: [
                        Math.min(pX, cX),
                        mY,
                        Math.max(pX, cX),
                        mY
                    ]
                });
            });
        });
    });
    return connectors;
};



var $7b027cb1b1f09088$export$2e2bcd8739ae039 = (families)=>{
    const connectors = [];
    families.filter((0, $888aa44cdb4ab34b$export$d5328c3c393e68b8)('root')).forEach((family)=>{
        family.pUnits.forEach((pUnit)=>{
            const pX = family.left + pUnit.shift + 1;
            const pY = family.top + 1;
            if (pUnit.size === 2) connectors.push({
                points: [
                    pX,
                    pY,
                    pX + 2,
                    pY
                ]
            });
            else if (pUnit.size === 1 && pUnit.nodes[0].spouses.length) families.filter((rFamily)=>rFamily.id !== family.id).forEach((rFamily)=>{
                rFamily.pUnits.forEach((unit)=>{
                    if (unit.nodes.findIndex((0, $888aa44cdb4ab34b$export$a57a6e31efd7989a)(pUnit.nodes[0].spouses[0].id)) !== -1) {
                        const xX = [
                            pX,
                            rFamily.left + unit.shift + 1
                        ].sort((0, $888aa44cdb4ab34b$export$484725e8d899ab2e));
                        connectors.push({
                            points: [
                                xX[0],
                                pY,
                                xX[1],
                                pY
                            ]
                        });
                    }
                });
            });
        });
    });
    return connectors;
};




var $c9671da55420f391$export$2e2bcd8739ae039 = (families)=>{
    const connectors = [];
    families.filter((0, $888aa44cdb4ab34b$export$d5328c3c393e68b8)('root', 'child')).forEach((family)=>{
        let pX = 0;
        const mY = family.top + (family.pUnits.length ? (0, $3489cb4c3a30d4ab$export$8d4e26484c874870) : 0);
        if (family.pUnits.length === 1) {
            const pUnit = family.pUnits[0];
            pX = family.left + pUnit.shift + pUnit.size;
            if (pUnit.nodes.every((node)=>!!node.children.length)) {
                const pY = family.top + 1;
                connectors.push({
                    points: [
                        pX,
                        pY,
                        pX,
                        mY
                    ]
                });
            }
        }
        const parentIds = family.pUnits.map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('ids')).reduce((0, $888aa44cdb4ab34b$export$40fa977508bcf282), []);
        const cXs = [];
        family.cUnits.forEach((cUnit)=>{
            const cX = family.left + cUnit.shift + 1;
            cUnit.nodes.forEach((node, index)=>{
                if (node.parents.find((rel)=>parentIds.indexOf(rel.id) !== -1)) {
                    const nX = cX + index * 2;
                    cXs.push(nX);
                    connectors.push({
                        points: [
                            nX,
                            mY,
                            nX,
                            mY + 1
                        ]
                    });
                }
            });
            if (cUnit.size === 2) connectors.push({
                points: [
                    cX,
                    mY + 1,
                    cX + 2,
                    mY + 1
                ]
            });
            else if (cUnit.size === 1 && cUnit.nodes[0].spouses.length) family.cUnits.forEach((nUnit)=>{
                if (nUnit.nodes.findIndex((0, $888aa44cdb4ab34b$export$a57a6e31efd7989a)(cUnit.nodes[0].spouses[0].id)) !== -1) {
                    const xX = [
                        cX,
                        family.left + nUnit.shift + 1
                    ].sort((0, $888aa44cdb4ab34b$export$484725e8d899ab2e));
                    connectors.push({
                        points: [
                            xX[0],
                            mY + 1,
                            xX[1],
                            mY + 1
                        ]
                    });
                }
            });
        });
        if (cXs.length > 1) connectors.push({
            points: [
                (0, $888aa44cdb4ab34b$export$96ec731ed4dcb222)(cXs),
                mY,
                (0, $888aa44cdb4ab34b$export$8960430cfd85939f)(cXs),
                mY
            ]
        });
        else if (cXs.length === 1 && pX !== cXs[0]) connectors.push({
            points: [
                Math.min(pX, cXs[0]),
                mY,
                Math.max(pX, cXs[0]),
                mY
            ]
        });
    });
    return connectors;
};



const $078719b5a4eda58c$var$sequence = [
    (0, $7bf09183ba23dbde$export$2e2bcd8739ae039),
    (0, $7b027cb1b1f09088$export$2e2bcd8739ae039),
    (0, $c9671da55420f391$export$2e2bcd8739ae039)
];
function $078719b5a4eda58c$var$toConnectors(families) {
    return (fn)=>fn(families);
}
var $078719b5a4eda58c$export$2e2bcd8739ae039 = (families)=>{
    return $078719b5a4eda58c$var$sequence.map($078719b5a4eda58c$var$toConnectors(families)).reduce((0, $888aa44cdb4ab34b$export$40fa977508bcf282));
};



var $419efb0b4833b9c8$export$2e2bcd8739ae039 = (store)=>{
    const families = store.familiesArray;
    const vShift = (0, $888aa44cdb4ab34b$export$96ec731ed4dcb222)(families.map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('top'))) * -1;
    if (vShift !== 0) families.forEach((family)=>family.top += vShift);
    const rootChild = families.find((f)=>f.main);
    const rootParent = families.find((f)=>f.cID === rootChild.id);
    if (rootParent) {
        const cUnit = rootChild.pUnits[0];
        const pUnit = rootParent.cUnits[0];
        const diff = rootParent.left + pUnit.shift - (rootChild.left + cUnit.shift);
        if (diff > 0) families.filter((0, $888aa44cdb4ab34b$export$d5328c3c393e68b8)('child', 'root')).forEach((family)=>family.left += diff);
        else if (diff < 0) families.filter((0, $888aa44cdb4ab34b$export$d5328c3c393e68b8)('parent')).forEach((family)=>family.left += diff * -1);
        const hShift = (0, $888aa44cdb4ab34b$export$96ec731ed4dcb222)(families.map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('left')));
        if (hShift > 0) families.forEach((family)=>family.left -= hShift);
    }
    const totalShift = (0, $888aa44cdb4ab34b$export$96ec731ed4dcb222)(families.map((f)=>f.left)) * -1;
    if (totalShift !== 0) families.forEach((family)=>family.left += totalShift);
    return store;
};



var $2e33203edc23c5b2$export$2e2bcd8739ae039 = (families)=>{
    return {
        width: (0, $888aa44cdb4ab34b$export$8960430cfd85939f)(families.map((0, $888aa44cdb4ab34b$export$977f3f6a9323c0f6)('right'))),
        height: (0, $888aa44cdb4ab34b$export$8960430cfd85939f)(families.map((family)=>family.top + family.height))
    };
};



function $f70d9a8e6692aeb6$var$inUnits(units, nodeId) {
    return !!units.find((unit)=>!!unit.nodes.find((0, $888aa44cdb4ab34b$export$a57a6e31efd7989a)(nodeId)));
}
var $f70d9a8e6692aeb6$export$2e2bcd8739ae039 = (family, node)=>{
    if (family.type !== 'child' && $f70d9a8e6692aeb6$var$inUnits(family.pUnits, node.id)) return family.type === 'parent' && (node.children.length > 1 || node.spouses.length > 1) || !node.parents.length && !!node.siblings.length;
    if (family.type !== 'parent' && $f70d9a8e6692aeb6$var$inUnits(family.cUnits, node.id)) {
        const parentIds = family.pUnits.length ? family.pUnits[0].ids : [];
        const sameParents = !!node.parents.filter((rel)=>parentIds.includes(rel.id)).length;
        return !sameParents && (!!node.parents.length || !!node.siblings.length);
    }
    return false;
};



const $9eb08d7258a6e4e1$var$PARENTS = [
    'root',
    'parent'
];
const $9eb08d7258a6e4e1$var$CHILDREN = [
    'root',
    'child'
];
function $9eb08d7258a6e4e1$var$extendNode(family) {
    return (unit)=>unit.nodes.map((node, idx)=>Object.assign(Object.assign({}, node), {
                top: family.top + (unit.isChild && !!family.pUnits.length ? 2 : 0),
                left: family.left + unit.shift + idx * 2,
                hasSubTree: (0, $f70d9a8e6692aeb6$export$2e2bcd8739ae039)(family, node)
            }));
}
function $9eb08d7258a6e4e1$var$getParentNodes(family) {
    return ($9eb08d7258a6e4e1$var$PARENTS.includes(family.type) ? family.pUnits : []).map($9eb08d7258a6e4e1$var$extendNode(family));
}
function $9eb08d7258a6e4e1$var$getChildNodes(family) {
    return ($9eb08d7258a6e4e1$var$CHILDREN.includes(family.type) ? family.cUnits : []).map($9eb08d7258a6e4e1$var$extendNode(family));
}
function $9eb08d7258a6e4e1$var$mapFamily(family) {
    return [
        ...$9eb08d7258a6e4e1$var$getParentNodes(family),
        ...$9eb08d7258a6e4e1$var$getChildNodes(family)
    ].reduce((0, $888aa44cdb4ab34b$export$40fa977508bcf282), []);
}
var $9eb08d7258a6e4e1$export$2e2bcd8739ae039 = (families)=>{
    return families.map($9eb08d7258a6e4e1$var$mapFamily).reduce((0, $888aa44cdb4ab34b$export$40fa977508bcf282));
};



const $79dea12d44fed83b$var$pipeline = (0, $888aa44cdb4ab34b$export$a4627e546088548d)((0, $f63ebc3118d91ebf$export$2e2bcd8739ae039), (0, $ff53c72334d4563c$export$2e2bcd8739ae039), (0, $ae1b40fa5d21fa6b$export$2e2bcd8739ae039), (0, $419efb0b4833b9c8$export$2e2bcd8739ae039));
var $79dea12d44fed83b$export$2e2bcd8739ae039 = (nodes, options)=>{
    const store = new (0, $f7a1a9e133ed7803$export$2e2bcd8739ae039)(nodes, options.rootId);
    if (options.placeholders) (0, $42a5ce7d32795677$export$2e2bcd8739ae039)(store);
    const families = $79dea12d44fed83b$var$pipeline(store).familiesArray;
    return {
        families: families,
        canvas: (0, $2e33203edc23c5b2$export$2e2bcd8739ae039)(families),
        nodes: (0, $9eb08d7258a6e4e1$export$2e2bcd8739ae039)(families),
        connectors: (0, $078719b5a4eda58c$export$2e2bcd8739ae039)(families)
    };
};



var $3OyDL = parcelRequire("3OyDL");
var $fe3db7b65c73546f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).memo(function Connector({ connector: connector, width: width, height: height }) {
    const [x1, y1, x2, y2] = connector.points;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement("i", {
        style: {
            position: 'absolute',
            width: Math.max(1, (x2 - x1) * width + 1),
            height: Math.max(1, (y2 - y1) * height + 1),
            background: `#999`,
            transform: `translate(${x1 * width}px, ${y1 * height}px)`,
            pointerEvents: 'none'
        }
    });
});


var $a74235616a4ce429$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).memo(function ReactFamilyTree(props) {
    const data = (0, $79dea12d44fed83b$export$2e2bcd8739ae039)(props.nodes, {
        rootId: props.rootId,
        placeholders: props.placeholders
    });
    const width = props.width / 2;
    const height = props.height / 2;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement("div", {
        className: props.className,
        style: {
            position: 'relative',
            width: data.canvas.width * width,
            height: data.canvas.height * height
        }
    }, data.connectors.map((connector, idx)=>(0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement((0, $fe3db7b65c73546f$export$2e2bcd8739ae039), {
            key: idx,
            connector: connector,
            width: width,
            height: height
        })), data.nodes.map(props.renderNode));
});



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");
const $4b02ced6c38d6270$export$cc618b3f4f6850f5 = 0.1;
const $4b02ced6c38d6270$export$4afc387281808150 = 3.5;
const $4b02ced6c38d6270$export$a3a6a28ae8823b06 = {
    x: 0,
    y: 0,
    z: 1
};


function $bdf3c0467052ca02$export$971e5333ff27c622() {
    return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
}
function $bdf3c0467052ca02$export$c4dfce035d43d1e0(event) {
    return typeof TouchEvent !== 'undefined' && event instanceof TouchEvent;
}
function $bdf3c0467052ca02$export$1115a942b8cb48e1(event) {
    const point = event instanceof MouseEvent ? event : event.touches[0];
    return {
        X: point.clientX,
        Y: point.clientY
    };
}
function $bdf3c0467052ca02$export$701f09307b973829(event) {
    const [a, b] = Array.from(event.touches);
    return {
        mX: (a.pageX + b.pageX) / 2,
        mY: (a.pageY + b.pageY) / 2
    };
}
function $bdf3c0467052ca02$export$871dc7b093c9a524(z, min, max) {
    return Math.max(Math.min(z, max), min);
}
function $bdf3c0467052ca02$export$7b52a85cf1e10d16(event) {
    const [a, b] = Array.from(event.touches);
    return Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY);
}
function $bdf3c0467052ca02$export$5cdac61cf538712e(event, currRange) {
    let scale = event.scale;
    let pageX = event.pageX;
    let pageY = event.pageY;
    if ([
        scale,
        pageX,
        pageY
    ].some((val)=>val === undefined)) {
        scale = $bdf3c0467052ca02$export$7b52a85cf1e10d16(event) / currRange;
        const { mX: mX, mY: mY } = $bdf3c0467052ca02$export$701f09307b973829(event);
        pageX = mX;
        pageY = mY;
    }
    return {
        scale: scale,
        pageX: pageX,
        pageY: pageY
    };
}
function $bdf3c0467052ca02$export$99de932e438a9331(event) {
    const delta = event.deltaY;
    switch(event.deltaMode){
        case WheelEvent.DOM_DELTA_LINE:
            return Math.abs(delta) >= 1 ? delta / 100 : delta / 100 * 2;
        case WheelEvent.DOM_DELTA_PAGE:
            return Math.abs(delta) >= 1 ? delta / 100 : delta / 10;
        default:
            return Math.abs(delta) > 600 ? delta / 10000 : delta / 1000;
    }
}


function $d51aca79639f3733$export$185802fd694ee1f5({ element: element, minZoom: minZoom = (0, $4b02ced6c38d6270$export$cc618b3f4f6850f5), maxZoom: maxZoom = (0, $4b02ced6c38d6270$export$4afc387281808150), captureWheel: captureWheel }) {
    const touch = (0, $bdf3c0467052ca02$export$971e5333ff27c622)();
    let action = 'none';
    let state = (0, $4b02ced6c38d6270$export$a3a6a28ae8823b06);
    const current = {
        x: 0,
        y: 0,
        z: 0,
        range: 0
    };
    function setState(value) {
        state = value;
        const point = element.children.item(0);
        if (point) point.style.transform = `translate(${value.x}px, ${value.y}px) scale(${value.z})`;
    }
    function setCurrentXY({ X: X, Y: Y }) {
        current.x = X;
        current.y = Y;
    }
    function startMoving(event) {
        action = 'move';
        setCurrentXY((0, $bdf3c0467052ca02$export$1115a942b8cb48e1)(event));
    }
    function setPosition(z, pageX, pageY) {
        const { left: left, top: top } = element.getBoundingClientRect();
        const ratio = z / state.z;
        const offsetX = pageX - left - window.pageXOffset - state.x;
        const offsetY = pageY - top - window.pageYOffset - state.y;
        setState({
            x: state.x - (offsetX * ratio - offsetX),
            y: state.y - (offsetY * ratio - offsetY),
            z: z
        });
    }
    function onStart(event) {
        event.preventDefault();
        if ((0, $bdf3c0467052ca02$export$c4dfce035d43d1e0)(event) && event.touches.length === 2) {
            action = 'pinch';
            current.z = state.z;
            current.range = (0, $bdf3c0467052ca02$export$7b52a85cf1e10d16)(event);
        } else startMoving(event);
    }
    function onMove(event) {
        event.stopImmediatePropagation();
        event.preventDefault();
        if (action === 'move') {
            const clientXY = (0, $bdf3c0467052ca02$export$1115a942b8cb48e1)(event);
            const x = state.x - (current.x - clientXY.X);
            const y = state.y - (current.y - clientXY.Y);
            setCurrentXY(clientXY);
            setState({
                x: x,
                y: y,
                z: state.z
            });
        } else if (action === 'pinch') {
            const { scale: scale, pageX: pageX, pageY: pageY } = (0, $bdf3c0467052ca02$export$5cdac61cf538712e)(event, current.range);
            const z = (0, $bdf3c0467052ca02$export$871dc7b093c9a524)(current.z * scale, minZoom, maxZoom);
            setPosition(z, pageX, pageY);
        }
    }
    function onEnd(event) {
        if (action === 'pinch' && (0, $bdf3c0467052ca02$export$c4dfce035d43d1e0)(event) && event.touches.length === 1) startMoving(event);
        else action = 'none';
    }
    function onWheel(event) {
        if (!captureWheel && !event.altKey) return;
        event.preventDefault();
        event.stopPropagation();
        const delta = (0, $bdf3c0467052ca02$export$99de932e438a9331)(event) * -1;
        const z = (0, $bdf3c0467052ca02$export$871dc7b093c9a524)(state.z + delta, minZoom, maxZoom);
        setPosition(z, event.pageX, event.pageY);
    }
    const events = [
        {
            type: touch ? 'touchstart' : 'mousedown',
            listener: onStart
        },
        {
            type: touch ? 'touchmove' : 'mousemove',
            listener: onMove
        },
        {
            type: touch ? 'touchend' : 'mouseup',
            listener: onEnd
        },
        {
            type: touch ? 'touchleave' : 'mouseleave',
            listener: onEnd
        },
        {
            type: 'touchcancel',
            listener: onEnd
        },
        {
            type: 'wheel',
            listener: onWheel
        }
    ];
    const { width: width, height: height } = element.getBoundingClientRect();
    setState({
        x: width / 2,
        y: height / 2,
        z: state.z
    });
    events.forEach(({ type: type, listener: listener })=>element.addEventListener(type, listener));
    return ()=>events.forEach(({ type: type, listener: listener })=>element.removeEventListener(type, listener));
}



const $2a5ce49dca357f23$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        root: {
            position: 'relative',
            transform: 'translateZ(0)',
            overflow: 'hidden',
            flex: 1
        },
        point: {
            position: 'absolute',
            width: 0,
            height: 0,
            transform: 'translate(0, 0) scale(1)',
            transformOrigin: 'center',
            willChange: 'transform'
        },
        canvas: {
            position: 'absolute',
            transform: 'translate(-50%, -50%)'
        }
    }));
const $2a5ce49dca357f23$var$PinchZoomPan = ({ min: min, max: max, captureWheel: captureWheel, children: children })=>{
    const classes = $2a5ce49dca357f23$var$useStyles();
    const root = (0, $3OyDL.useRef)(null);
    (0, $3OyDL.useEffect)(()=>{
        const element = root.current;
        if (!element) return;
        return (0, $d51aca79639f3733$export$185802fd694ee1f5)({
            element: element,
            minZoom: min,
            maxZoom: max,
            captureWheel: captureWheel
        });
    }, [
        min,
        max,
        captureWheel
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        ref: root,
        className: classes.root,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
            className: classes.point,
            children: /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: classes.canvas,
                children: children
            })
        })
    });
};
var $2a5ce49dca357f23$export$2e2bcd8739ae039 = $2a5ce49dca357f23$var$PinchZoomPan;


var $1b52d48d66d53440$export$e526d003245e371 = /*#__PURE__*/ function(SubFamilyType) {
    SubFamilyType["SilkeSchuetz"] = "SilkeSchuetz";
    SubFamilyType["GerlindDerdar"] = "GerlindDerdar";
    SubFamilyType["MargitBronkalla"] = "MargitBronkalla";
    SubFamilyType["RobertFriessleben"] = "RobertFriessleben";
    SubFamilyType["AnkeMueller"] = "AnkeMueller";
    SubFamilyType["ClaudiaPrange"] = "ClaudiaPrange";
    SubFamilyType["TassiloLudwig"] = "TassiloLudwig";
    SubFamilyType["RameshKuther"] = "RameshKuther";
    SubFamilyType["CosimaKuther"] = "CosimaKuther";
    SubFamilyType["MaikaVerbeek"] = "MaikaVerbeek";
    SubFamilyType["DirkMichael"] = "DirkMichael";
    SubFamilyType["RonaldMichael"] = "RonaldMichael";
    SubFamilyType["RoyMichael"] = "RoyMichael";
    return SubFamilyType;
}({});
var $1b52d48d66d53440$export$7e952c50f9d34913 = /*#__PURE__*/ function(FamilyType) {
    FamilyType["Root"] = "Root";
    FamilyType["ThomasKuther"] = "ThomasKuther";
    FamilyType["JuergenKuther"] = "JuergenKuther";
    FamilyType["HeinzMichael"] = "HeinzMichael";
    FamilyType["AndreasKuther"] = "AndreasKuther";
    FamilyType["HeikeKuther"] = "HeikeKuther";
    FamilyType["IlseKaiser"] = "IlseKaiser";
    return FamilyType;
}({});
var $1b52d48d66d53440$export$fc1fffa865f550ef = /*#__PURE__*/ function(RelType) {
    RelType["blood"] = "blood";
    RelType["married"] = "married";
    RelType["adopted"] = "adopted";
    RelType["half"] = "half";
    RelType["partnership"] = "partnership";
    return RelType;
}({});



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");


const $30c861fb72406e5e$export$7e2f7c4b308ce424 = 240;
const $30c861fb72406e5e$export$45315b1ff0a2937 = 330;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");
const $32481be2fe498df5$var$getDateStringFromCustomDate = (customDate)=>{
    let dateString = '';
    if (customDate.day && customDate.month) dateString += `${customDate.day < 10 ? '0' + customDate.day : customDate.day}.${customDate.month < 10 ? '0' + customDate.month : customDate.month}.`;
    if (customDate.year) dateString += customDate.year;
    return dateString;
};
var $32481be2fe498df5$export$2e2bcd8739ae039 = $32481be2fe498df5$var$getDateStringFromCustomDate;


var $3f0d076fd7cb4a4a$export$61befbe894190682 = /*#__PURE__*/ function(DateAndPlaceType) {
    DateAndPlaceType["birth"] = "birth";
    DateAndPlaceType["death"] = "death";
    return DateAndPlaceType;
}({});
const $3f0d076fd7cb4a4a$var$DateAndPlace = ({ date: date, place: place, type: type })=>{
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            date && (0, $32481be2fe498df5$export$2e2bcd8739ae039)(date) && place && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                children: `${type ? type === "birth" ? 'geb. ' : 'gest. ' : ''} ${(0, $32481be2fe498df5$export$2e2bcd8739ae039)(date)} ${place && `in ${place}`}`
            }),
            !date && place && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                children: `${type ? type === "birth" ? 'geb. in' : 'gest. in' : ''} ${place}`
            }),
            date && (0, $32481be2fe498df5$export$2e2bcd8739ae039)(date) && !place && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                children: `${type ? type === "birth" ? 'geb. ' : 'gest. ' : ''} ${(0, $32481be2fe498df5$export$2e2bcd8739ae039)(date)}`
            })
        ]
    });
};
var $3f0d076fd7cb4a4a$export$2e2bcd8739ae039 = $3f0d076fd7cb4a4a$var$DateAndPlace;






var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $0ebf227ecb83e0b8$var$BirthIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        id: "Layer_1",
        enableBackground: "new 0 0 512 512",
        height: props.width,
        viewBox: "0 0 512 512",
        width: props.width,
        fill: props.color || theme.palette.text.primary,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m120.041 440.303c5.688 8.221 12.156 15.999 19.386 23.229 31.255 31.255 72.655 48.468 116.573 48.468s85.318-17.213 116.573-48.468 48.468-72.655 48.468-116.573v-94.273z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m154.128 251.673c2.79-11.033 7.498-21.322 14.172-31.003-8.314-12.6-13.986-27.087-16.225-42.671h-.035c-8.284 0-15-6.716-15-15s6.716-15 15-15h.035c7.303-50.816 51.12-89.999 103.925-89.999s96.623 39.183 103.924 90h.117c8.284 0 15 6.716 15 15s-6.716 15-15 15h-.117c-2.242 15.603-7.926 30.107-16.257 42.719 7.295 10.724 12.548 22.648 15.516 35.173l61.857-38.557v-52.293c0-43.918-17.213-85.318-48.468-116.573-31.253-31.256-72.654-48.469-116.572-48.469s-85.318 17.213-116.573 48.468-48.468 72.655-48.468 116.573v37.822z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m90.959 240.776v106.183c0 23.511 4.938 46.299 14.318 67.197l116.274-72.475z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m331.693 273.027c-.974-10.196-4.023-20.077-8.918-29.054-18.16 15.003-41.433 24.027-66.775 24.027-25.393 0-48.709-9.062-66.886-24.12-4.824 8.76-7.365 18.078-7.935 28.695l67.529 52.177z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m256 238c41.355 0 75-33.645 75-75 0-36.346-25.992-66.727-60.362-73.556 2.242 11.273 10.68 20.283 21.907 23.181 8.021 2.07 12.847 10.251 10.776 18.272-1.746 6.764-7.838 11.255-14.514 11.255-1.241 0-2.502-.155-3.759-.479-23.503-6.065-40.928-25.508-44.393-49.532-.123-.852-.155-1.694-.134-2.526-33.782 7.117-59.252 37.035-59.508 72.844.006.181.027.358.027.54 0 .183-.021.36-.027.541.294 41.106 33.813 74.46 74.987 74.46z"
                })
            ]
        })
    });
};
var $0ebf227ecb83e0b8$export$2e2bcd8739ae039 = $0ebf227ecb83e0b8$var$BirthIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $a22cd9bdf10ac330$var$DeathIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        height: props.width,
        width: props.width,
        fill: props.color || theme.palette.text.primary,
        viewBox: "-76 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
            d: "m225 512v-301h135v-90h-135v-121h-90v121h-135v90h135v301zm0 0"
        })
    });
};
var $a22cd9bdf10ac330$export$2e2bcd8739ae039 = $a22cd9bdf10ac330$var$DeathIcon;


const $0d90c1d5949faa12$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        root: {
            position: 'absolute',
            display: 'flex',
            padding: '10px',
            overflow: 'hidden'
        },
        inner: {
            display: 'flex',
            flex: 1,
            alignItems: 'flex-start',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            border: '2px solid rgba(0, 0, 0, .2)',
            borderRadius: '10px 0',
            overflow: 'hidden',
            cursor: 'pointer',
            padding: '10px'
        },
        yellow: {
            backgroundColor: 'yellow'
        },
        red: {
            backgroundColor: 'red'
        },
        blue: {
            backgroundColor: 'blue'
        },
        violet: {
            backgroundColor: 'violet'
        },
        green: {
            backgroundColor: 'green'
        },
        orange: {
            backgroundColor: 'orange'
        },
        male: {
            color: 'white',
            // filter: 'brightness(60%)',
            backgroundColor: theme.palette.primary.dark
        },
        female: {
            color: 'white',
            backgroundColor: theme.palette.primary.main
        },
        isRoot: {
            borderColor: 'rgba(0, 0, 0, .4)'
        },
        isHover: {
            borderColor: 'rgba(0, 0, 0, .8)'
        },
        id: {
            fontSize: '7px',
            lineHeight: 1,
            opacity: 0.5
        },
        sub: {
            position: 'absolute',
            top: '6px',
            right: '14px',
            width: '28px',
            height: '20px',
            border: '1px solid rgba(0, 0, 0, .2)',
            borderRadius: '4px 0',
            background: '#fff',
            cursor: 'pointer'
        }
    }));
const $0d90c1d5949faa12$var$SingleFamilyNode = ({ node: node, onClick: onClick })=>{
    const classes = $0d90c1d5949faa12$var$useStyles();
    const members = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$f4931e6f9feb30c5));
    const activeMember = members?.results.find((member)=>member.id === node.id);
    const getNodeStyle = ({ left: left, top: top })=>{
        return {
            width: (0, $30c861fb72406e5e$export$7e2f7c4b308ce424),
            height: (0, $30c861fb72406e5e$export$45315b1ff0a2937),
            transform: `translate(${left && left * ((0, $30c861fb72406e5e$export$7e2f7c4b308ce424) / 2)}px, ${top && top * ((0, $30c861fb72406e5e$export$45315b1ff0a2937) / 2)}px)`
        };
    };
    const clickHandler = (0, $3OyDL.useCallback)(()=>{
        onClick && node.id && onClick(node.id);
    }, [
        node.id,
        onClick
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
        className: classes.root,
        style: getNodeStyle(node),
        onClick: ()=>clickHandler(),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                className: `${classes.inner} ${node.gender === (0, $c7fa01100a96d1f7$export$d549c77c8a078892).female ? classes.female : classes.male} ${node.generation ? classes[node.generation] : ''}`,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        style: {
                            width: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                style: {
                                    textAlign: 'left',
                                    marginLeft: '30px'
                                },
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    sx: {
                                        lineHeight: 1.0,
                                        fontSize: '18px'
                                    },
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                        children: `${node.firstname} ${node.lastname}`
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    minHeight: '56px'
                                },
                                children: [
                                    activeMember?.birthname && activeMember?.showDetails && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                        style: {
                                            textAlign: 'left',
                                            marginLeft: '30px'
                                        },
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            sx: {
                                                lineHeight: 1.0,
                                                fontSize: '16px'
                                            },
                                            children: `geb. ${activeMember.birthname}`
                                        })
                                    }),
                                    activeMember?.showDetails && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            width: '100%'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    marginRight: '10px'
                                                },
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0ebf227ecb83e0b8$export$2e2bcd8739ae039), {
                                                    color: "#fff",
                                                    width: "20px"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3f0d076fd7cb4a4a$export$2e2bcd8739ae039), {
                                                date: activeMember?.birthday
                                            })
                                        ]
                                    }),
                                    activeMember?.showDetails && activeMember?.dead && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            width: '100%'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    marginRight: '10px'
                                                },
                                                children: activeMember.dead && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a22cd9bdf10ac330$export$2e2bcd8739ae039), {
                                                    color: "#fff",
                                                    width: "20px"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3f0d076fd7cb4a4a$export$2e2bcd8739ae039), {
                                                date: activeMember?.deathday
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        sx: {
                            height: 'auto',
                            overflow: 'hidden'
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                            style: {
                                width: '100%',
                                height: 'auto'
                            },
                            alt: "",
                            src: activeMember?.profileImage ? activeMember?.profileImage : `/profileImages/${activeMember?.id}.jpg`
                        })
                    })
                ]
            }),
            node.hasSubTree && false,
            node.family === node.id && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                className: classes.sub
            }),
            node.subFamily === node.id && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                className: classes.sub
            })
        ]
    });
};
var $0d90c1d5949faa12$export$2e2bcd8739ae039 = $0d90c1d5949faa12$var$SingleFamilyNode;


















const $1afdd3d01d3a8d5a$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        paper: {
            width: 'calc(100% - 50px)',
            margin: '25px',
            display: 'flex',
            flexDirection: 'column',
            height: '75vh',
            minHeight: '500px'
        },
        tree: {
            borderRadius: '4px'
        },
        contentBox: {
            margin: '10px 0'
        },
        memberName: {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            padding: '20px',
            margin: '40px 0 0 0',
            fontSize: '16px'
        },
        settingsIcon: {
            position: 'absolute',
            top: theme.spacing(),
            right: theme.spacing(),
            color: theme.palette.primary.main,
            cursor: 'pointer'
        },
        icons: {
            transform: 'scale(1.2)'
        }
    }));
const $1afdd3d01d3a8d5a$var$FamilyTree = ()=>{
    const classes = $1afdd3d01d3a8d5a$var$useStyles();
    const initialRootId = 'OttoMeissner';
    const members = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$f4931e6f9feb30c5));
    const user = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$7cbf767827cd68ba));
    const relations = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$b8e54fb0b8f14b48));
    const userPermissions = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$7eb85035e0831f9));
    const [layer, setLayer] = (0, $3OyDL.useState)(0);
    const [family, setFamily] = (0, $3OyDL.useState)();
    const [nodes, setNodes] = (0, $3OyDL.useState)(relations?.results || []);
    const [filteredNodes, setFilteredNodes] = (0, $3OyDL.useState)(relations?.results || []);
    const [temporaryNodes, setTemporaryNodes] = (0, $3OyDL.useState)();
    const [rootId, setRootId] = (0, $3OyDL.useState)(initialRootId);
    const [selectId, setSelectId] = (0, $3OyDL.useState)();
    const [showDialog, setShowDialog] = (0, $3OyDL.useState)(false);
    const [selectedNode, setSelectedNode] = (0, $3OyDL.useState)();
    (0, $3OyDL.useEffect)(()=>{
        filterNodes((0, $1b52d48d66d53440$export$7e952c50f9d34913).Root);
    }, [
        nodes
    ]);
    (0, $3OyDL.useEffect)(()=>{
        setSelectedNode(nodes.find((item)=>item.id === selectId));
    }, [
        nodes,
        selectId
    ]);
    const selectedMember = (0, $3OyDL.useMemo)(()=>members?.results.find((item)=>item.id === selectId), [
        nodes,
        selectId
    ]);
    const [selectedMemberDead, setSelectedMemberDead] = (0, $3OyDL.useState)(false);
    (0, $3OyDL.useEffect)(()=>{
        setSelectedMemberDead(selectedMember?.dead || false);
    }, [
        selectedMember
    ]);
    const getMember = (id)=>{
        if (id) return members?.results.find((item)=>item.id === id);
    };
    const getRelationOptions = (type)=>{
        switch(type){
            case 'parent':
                return [
                    {
                        key: (0, $1b52d48d66d53440$export$fc1fffa865f550ef).blood,
                        value: 'leibliches Elternteil'
                    },
                    {
                        key: (0, $1b52d48d66d53440$export$fc1fffa865f550ef).adopted,
                        value: 'Pflegeelternteil'
                    },
                    {
                        key: (0, $1b52d48d66d53440$export$fc1fffa865f550ef).adopted,
                        value: 'Adoptivelternteil'
                    }
                ];
            case 'child':
                return [
                    {
                        key: (0, $1b52d48d66d53440$export$fc1fffa865f550ef).blood,
                        value: 'leibliches Kind'
                    },
                    {
                        key: (0, $1b52d48d66d53440$export$fc1fffa865f550ef).adopted,
                        value: 'Pflegekind'
                    },
                    {
                        key: (0, $1b52d48d66d53440$export$fc1fffa865f550ef).adopted,
                        value: 'Adoptivkind'
                    }
                ];
            case 'sibling':
                return [
                    {
                        key: (0, $1b52d48d66d53440$export$fc1fffa865f550ef).blood,
                        value: 'Geschwisterkind'
                    },
                    {
                        key: (0, $1b52d48d66d53440$export$fc1fffa865f550ef).half,
                        value: 'Halbgeschwisterkind'
                    }
                ];
            case 'spouse':
                return [
                    {
                        key: (0, $1b52d48d66d53440$export$fc1fffa865f550ef).married,
                        value: 'Ehepartner'
                    },
                    {
                        key: (0, $1b52d48d66d53440$export$fc1fffa865f550ef).partnership,
                        value: 'Partner'
                    }
                ];
        }
    };
    const getParentOptions = (memberId)=>{
        const options = [];
        members?.results.map((member)=>{
            if (member.id !== memberId) {
                if (!selectedNode?.parents.find((elem)=>elem.id === member.id) && !selectedNode?.children.find((elem)=>elem.id === member.id) && !selectedNode?.spouses.find((elem)=>elem.id === member.id) && !selectedNode?.siblings.find((elem)=>elem.id === member.id)) member.id && options.push({
                    key: member.id,
                    value: `${member.firstname} ${member.lastname}`
                });
            }
        });
        return options;
    };
    const [adminMode, setAdminMode] = (0, $3OyDL.useState)(false);
    const [newRelation, setNewRelation] = (0, $3OyDL.useState)();
    const [addParent, setAddParent] = (0, $3OyDL.useState)(false);
    const [newParent, setNewParent] = (0, $3OyDL.useState)();
    const filterNodes = (family, subFamily)=>{
        if (family !== (0, $1b52d48d66d53440$export$7e952c50f9d34913).Root) {
            let filteredNodes = nodes.filter((node)=>node.family === family);
            if (subFamily) filteredNodes = filteredNodes.filter((node)=>node.subFamily === subFamily);
            const cleanedFilteredNodes = filteredNodes.map((node)=>{
                if (node.family === (0, $1b52d48d66d53440$export$7e952c50f9d34913).IlseKaiser) return {
                    ...node,
                    parents: node.generation === (0, $c7fa01100a96d1f7$export$56404fea6c08a4d9).orange ? [] : node.parents
                };
                else {
                    if (subFamily) return {
                        ...node,
                        parents: node.generation === (0, $c7fa01100a96d1f7$export$56404fea6c08a4d9).blue ? [] : node.parents
                    };
                    else {
                        if (node.family === (0, $1b52d48d66d53440$export$7e952c50f9d34913).ThomasKuther || node.family === (0, $1b52d48d66d53440$export$7e952c50f9d34913).HeinzMichael) return {
                            ...node,
                            parents: node.generation === (0, $c7fa01100a96d1f7$export$56404fea6c08a4d9).green ? [] : node.parents,
                            children: node.generation === (0, $c7fa01100a96d1f7$export$56404fea6c08a4d9).blue ? [] : node.children,
                            spouses: node.generation === (0, $c7fa01100a96d1f7$export$56404fea6c08a4d9).blue ? [] : node.spouses
                        };
                        else return {
                            ...node,
                            parents: node.generation === (0, $c7fa01100a96d1f7$export$56404fea6c08a4d9).green ? [] : node.parents
                        };
                    }
                }
            });
            setFilteredNodes(cleanedFilteredNodes);
        } else {
            const rootNodes = nodes.filter((node)=>node.family === (0, $1b52d48d66d53440$export$7e952c50f9d34913).Root);
            const ilse = nodes.find((node)=>node.id === 'IlseKaiser');
            ilse && rootNodes.push(ilse);
            const thomas = nodes.find((node)=>node.id === 'ThomasKuther');
            thomas && rootNodes.push(thomas);
            const andras = nodes.find((node)=>node.id === 'AndreasKuther');
            andras && rootNodes.push(andras);
            const heike = nodes.find((node)=>node.id === 'HeikeKuther');
            heike && rootNodes.push(heike);
            const juergen = nodes.find((node)=>node.id === 'JuergenKuther');
            juergen && rootNodes.push(juergen);
            const heinz = nodes.find((node)=>node.id === 'HeinzMichael');
            heinz && rootNodes.push(heinz);
            const cleanedRootNodes = rootNodes.map((node)=>{
                if (node.family === (0, $1b52d48d66d53440$export$7e952c50f9d34913).IlseKaiser) return {
                    ...node,
                    children: node.generation === (0, $c7fa01100a96d1f7$export$56404fea6c08a4d9).orange ? [] : node.children,
                    spouses: node.generation === (0, $c7fa01100a96d1f7$export$56404fea6c08a4d9).orange ? [] : node.spouses
                };
                else return {
                    ...node,
                    children: node.generation === (0, $c7fa01100a96d1f7$export$56404fea6c08a4d9).green ? [] : node.children,
                    spouses: node.generation === (0, $c7fa01100a96d1f7$export$56404fea6c08a4d9).green ? [] : node.spouses
                };
            });
            setFilteredNodes(cleanedRootNodes);
        }
    };
    const familyTypeArray = [
        'JuergenKuther',
        'AndreasKuther',
        'HeikeKuther',
        'ThomasKuther',
        'HeinzMichael',
        'Root',
        'IlseKaiser'
    ];
    const familySubTypeArray = [
        'SilkeSchuetz',
        'GerlindDerdar',
        'MargitBronkalla',
        'RobertFriessleben',
        'AnkeMueller',
        'ClaudiaPrange',
        'TassiloLudwig',
        'RameshKuther',
        'CosimaKuther',
        'MaikaVerbeek',
        'DirkMichael',
        'RonaldMichael',
        'RoyMichael'
    ];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
                className: classes.paper,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                        variant: "h1",
                        sx: {
                            marginLeft: '10px'
                        },
                        children: "Stammbaum"
                    }),
                    layer > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        sx: {
                            margin: '10px',
                            cursor: 'pointer'
                        },
                        onClick: ()=>{
                            if (layer === 1) {
                                setLayer(0);
                                filterNodes((0, $1b52d48d66d53440$export$7e952c50f9d34913).Root);
                                setRootId(initialRootId);
                                setFamily(undefined);
                            }
                            if (layer === 2 && family) {
                                setLayer(1);
                                filterNodes(family);
                                setRootId(family);
                            }
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4be88c6641a5d35$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2a5ce49dca357f23$export$2e2bcd8739ae039), {
                        min: 0.5,
                        max: 0.8,
                        captureWheel: true,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a74235616a4ce429$export$2e2bcd8739ae039), {
                            nodes: filteredNodes,
                            rootId: rootId,
                            width: (0, $30c861fb72406e5e$export$7e2f7c4b308ce424),
                            height: (0, $30c861fb72406e5e$export$45315b1ff0a2937),
                            className: classes.tree,
                            renderNode: (node)=>{
                                return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0d90c1d5949faa12$export$2e2bcd8739ae039), {
                                    node: node,
                                    onClick: (id)=>{
                                        if (familyTypeArray.find((elem)=>elem === id) && layer === 0) {
                                            // zoom into tree
                                            filterNodes(id);
                                            setRootId(id);
                                            setLayer(layer + 1);
                                        } else if (familySubTypeArray.find((elem)=>elem === id) && layer === 1) {
                                            // zoom into tree
                                            const familyType = nodes.filter((elem)=>elem.subFamily === id)[0].family;
                                            familyType && filterNodes(familyType, id);
                                            setRootId(id);
                                            setLayer(layer + 1);
                                            setFamily(familyType);
                                        } else {
                                            setShowDialog(true);
                                            setSelectId(id);
                                        }
                                    }
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $ee30f4276828974b$export$2e2bcd8739ae039), {
                open: showDialog,
                onClose: ()=>{
                    setShowDialog(false);
                },
                sx: {
                    '& .MuiDialog-paper': {
                        borderRadius: 0,
                        minWidth: '600px',
                        maxWidth: '600px'
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        className: classes.memberName,
                        children: `${selectedMember?.firstname} ${selectedMember?.middlenames ? selectedMember?.middlenames : ''} ${selectedMember?.lastname} ${selectedMember?.birthname ? `(geb. ${selectedMember?.birthname})` : ''}`
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                        sx: {
                            p: 2
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $b9097f1d6e2a4efc$export$2e2bcd8739ae039), {
                            sx: {
                                p: 0,
                                overflow: 'visible'
                            },
                            children: [
                                (userPermissions.relations.find((elem)=>elem === (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).update) || selectedNode?.id === user?.memberId) && !adminMode && false,
                                adminMode ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 2,
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 6,
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        className: classes.contentBox,
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $dd1551179d3d9c5a$export$2e2bcd8739ae039), {
                                                                label: "Geboren am",
                                                                fullWidth: true,
                                                                value: selectedMember?.birthday ? (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(selectedMember?.birthday) : undefined
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                                label: "Geboren in",
                                                                clearable: false,
                                                                fullWidth: true,
                                                                value: selectedMember?.placeOfBirth
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                value: selectedMemberDead,
                                                                label: "Verstorben",
                                                                onChange: (value)=>{
                                                                    setSelectedMemberDead(value);
                                                                }
                                                            }),
                                                            selectedMemberDead && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $dd1551179d3d9c5a$export$2e2bcd8739ae039), {
                                                                        label: "Gestorben am",
                                                                        fullWidth: true,
                                                                        value: selectedMember?.deathday ? (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(selectedMember?.deathday) : undefined
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                                        label: "Gestorben in",
                                                                        fullWidth: true,
                                                                        clearable: false,
                                                                        value: selectedMember?.placeOfDeath
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        className: classes.contentBox,
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                sx: {
                                                                    display: 'flex',
                                                                    justifyContent: 'flex-start',
                                                                    aligItems: 'center',
                                                                    flexWrap: 'nowrap'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                            children: "Eltern"
                                                                        })
                                                                    }),
                                                                    selectedNode?.parents.length && selectedNode?.parents.length < 2 && false
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                sx: {
                                                                    display: 'flex',
                                                                    justifyContent: 'flex-start',
                                                                    aligItems: 'center',
                                                                    flexWrap: 'nowrap'
                                                                },
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                    children: selectedNode?.parents[0] && `${getMember(selectedNode?.parents[0].id)?.firstname} ${getMember(selectedNode?.parents[0].id)?.lastname}`
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: selectedNode?.parents[1] && `${getMember(selectedNode?.parents[1].id)?.firstname} ${getMember(selectedNode?.parents[1].id)?.lastname}`
                                                            }),
                                                            addParent && selectedNode?.id && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                sx: {
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    width: '100%'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            marginRight: '10px'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                                                            options: getParentOptions(selectedNode?.id),
                                                                            label: "Neues Elternteil",
                                                                            onChange: (value)=>setNewParent(value.key)
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            marginRight: '10px'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                                                            options: getRelationOptions('parent'),
                                                                            label: "Beziehung",
                                                                            onChange: (value)=>setNewRelation(value.key)
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            marginRight: '10px'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                                            disabled: !newParent || !newRelation,
                                                                            onClick: ()=>{
                                                                                setTemporaryNodes(nodes);
                                                                                const newNodes = [
                                                                                    ...nodes
                                                                                ];
                                                                                // newParent && newNodes.find(node => node.id === selectedNode.id)?.parents.push({
                                                                                //   id: newParent,
                                                                                //   type: newRelation as RelType,
                                                                                // })
                                                                                // newParent && newNodes.find(node => node.id === newParent)?.children.push({
                                                                                //   id: selectedNode.id,
                                                                                //   type: newRelation as RelType,
                                                                                // })
                                                                                setNodes(newNodes);
                                                                                setAddParent(false);
                                                                                setNewParent(undefined);
                                                                                setNewRelation(undefined);
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6f042400abba8c2b$exports))), {})
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        className: classes.contentBox,
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                    children: "Geschwister"
                                                                })
                                                            }),
                                                            selectedNode?.siblings.map((sibling, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                    children: `${getMember(sibling.id)?.firstname} ${getMember(sibling.id)?.lastname}`
                                                                }, index))
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        className: classes.contentBox,
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                    children: "Partner"
                                                                })
                                                            }),
                                                            selectedNode?.spouses.map((spouse, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                    children: `${getMember(spouse.id)?.firstname} ${getMember(spouse.id)?.lastname}`
                                                                }, index))
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        className: classes.contentBox,
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                    children: "Kinder"
                                                                })
                                                            }),
                                                            selectedNode?.children.map((child, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                    children: `${getMember(child.id)?.firstname} ${getMember(child.id)?.lastname}`
                                                                }, index))
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 6,
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                                    style: {
                                                        width: '100%',
                                                        height: 'auto',
                                                        margin: '10px 0'
                                                    },
                                                    alt: "",
                                                    src: selectedMember?.profileImage ? selectedMember?.profileImage : `/profileImages/${selectedMember?.id}.jpg`
                                                })
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                        container: true,
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 6,
                                                children: [
                                                    selectedMember?.showDetails && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        className: classes.contentBox,
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3f0d076fd7cb4a4a$export$2e2bcd8739ae039), {
                                                                    date: selectedMember?.birthday,
                                                                    place: selectedMember?.placeOfBirth,
                                                                    type: (0, $3f0d076fd7cb4a4a$export$61befbe894190682).birth
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3f0d076fd7cb4a4a$export$2e2bcd8739ae039), {
                                                                    date: selectedMember?.deathday,
                                                                    place: selectedMember?.placeOfDeath,
                                                                    type: (0, $3f0d076fd7cb4a4a$export$61befbe894190682).death
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    selectedNode?.parents && selectedNode?.parents.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        className: classes.contentBox,
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                    children: "Eltern"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: selectedNode?.parents[0] && `${getMember(selectedNode?.parents[0].id)?.firstname} ${getMember(selectedNode?.parents[0].id)?.lastname}`
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: selectedNode?.parents[1] && `${getMember(selectedNode?.parents[1].id)?.firstname} ${getMember(selectedNode?.parents[1].id)?.lastname}`
                                                            })
                                                        ]
                                                    }),
                                                    selectedNode?.siblings && selectedNode?.siblings.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        className: classes.contentBox,
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                    children: "Geschwister"
                                                                })
                                                            }),
                                                            selectedNode?.siblings.map((sibling, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                    children: `${getMember(sibling.id)?.firstname} ${getMember(sibling.id)?.lastname}`
                                                                }, index))
                                                        ]
                                                    }),
                                                    selectedNode?.spouses && selectedNode?.spouses.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        className: classes.contentBox,
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                    children: "Partner"
                                                                })
                                                            }),
                                                            selectedNode?.spouses.map((spouse, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                    children: `${getMember(spouse.id)?.firstname} ${getMember(spouse.id)?.lastname}`
                                                                }, index))
                                                        ]
                                                    }),
                                                    selectedNode?.children && selectedNode?.children.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        className: classes.contentBox,
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                    children: "Kinder"
                                                                })
                                                            }),
                                                            selectedNode?.children.map((child, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                    children: `${getMember(child.id)?.firstname} ${getMember(child.id)?.lastname}`
                                                                }, index))
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 6,
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                                    style: {
                                                        width: '100%',
                                                        height: 'auto',
                                                        margin: '10px 0'
                                                    },
                                                    alt: "",
                                                    src: selectedMember?.profileImage ? selectedMember?.profileImage : `/profileImages/${selectedMember?.id}.jpg`
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $08e4970efe955928$export$2e2bcd8739ae039), {
                        sx: {
                            p: 3
                        },
                        children: adminMode ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    color: "secondary",
                                    variant: "contained",
                                    text: "Abbrechen",
                                    onClick: ()=>{
                                        temporaryNodes && setNodes(temporaryNodes);
                                        setTemporaryNodes(undefined);
                                        setAdminMode(false);
                                    }
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    variant: "contained",
                                    text: "Speichern",
                                    onClick: ()=>{
                                        setAdminMode(false);
                                        setTemporaryNodes(undefined);
                                    // TODO save new settings
                                    }
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                            color: "primary",
                            variant: "contained",
                            text: "Ok",
                            onClick: ()=>{
                                setShowDialog(false);
                            }
                        })
                    })
                ]
            })
        ]
    });
};
var $1afdd3d01d3a8d5a$export$2e2bcd8739ae039 = $1afdd3d01d3a8d5a$var$FamilyTree;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");







var $hsK2b = parcelRequire("hsK2b");
function $76d75229d7c83be5$export$5886efcb490847cc(darkMode) {
    const customTheme = {
        typography: {
            h1: {
                textTransform: 'uppercase',
                fontSize: 30,
                color: '#1c7899',
                margin: '16px 0'
            },
            h2: {
                textTransform: 'uppercase',
                fontSize: 22,
                margin: '16px 0',
                fontWeight: 'bold'
            },
            subtitle1: {
                fontSize: 18,
                textTransform: 'uppercase',
                margin: '12px 0'
            },
            subtitle2: {
                fontSize: 18,
                fontWeight: 'bold',
                margin: '12px 0'
            },
            body1: {
                fontSize: 16,
                margin: '8px 0'
            }
        },
        palette: {
            primary: {
                main: '#6093a4',
                dark: '#1c7899',
                700: '#385763',
                800: '#2b434d',
                900: '#1e2f37'
            },
            secondary: {
                main: '#d1d1d1'
            },
            grey: {
                A700: '#616161'
            },
            background: {
                default: '#ebebeb',
                paper: '#ffffff'
            }
        },
        breakpoints: {
            values: {
                xs: 420,
                sm: 600,
                md: 900,
                lg: 1200,
                xl: 1536
            }
        }
    };
    const darkTheme = {
        typography: {
            h1: {
                textTransform: 'uppercase',
                fontSize: 30,
                color: '#6093a4',
                margin: '16px 0'
            },
            h2: {
                textTransform: 'uppercase',
                fontSize: 22,
                margin: '16px 0',
                fontWeight: 'bold'
            },
            subtitle1: {
                fontSize: 18,
                textTransform: 'uppercase',
                margin: '12px 0'
            },
            subtitle2: {
                fontSize: 18,
                fontWeight: 'bold',
                margin: '12px 0'
            },
            body1: {
                fontSize: 16,
                margin: '8px 0'
            },
            body2: {
                color: 'rgba(0, 0, 0, 0.6)',
                fontSize: 16,
                margin: '8px 0',
                fontWeight: 400
            }
        },
        palette: {
            mode: 'dark',
            primary: {
                main: '#81b4c7',
                dark: '#6093a4'
            },
            secondary: {
                main: '#d1d1d1'
            },
            background: {
                default: '#121212',
                paper: 'rgb(57,57,57)'
            },
            grey: {
                A700: '#393939'
            },
            text: {
                primary: 'rgba(255,255,255,0.79)',
                secondary: 'rgba(255,255,255,0.63)'
            }
        },
        breakpoints: {
            values: {
                xs: 420,
                sm: 600,
                md: 900,
                lg: 1200,
                xl: 1536
            }
        }
    };
    const theme = darkMode ? (0, $hsK2b.default)(darkTheme) : (0, $hsK2b.default)(customTheme);
    return theme;
}



const $3b5b3d1a00a962e4$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        dashboardImage: {
            width: '100%',
            height: 'auto'
        }
    }));
const $3b5b3d1a00a962e4$var$DashboardComponent = ()=>{
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const history = (0, $4e1a33337564f167$export$3420e1dc2c4a518c)();
    const classes = $3b5b3d1a00a962e4$var$useStyles();
    const theme = (0, $76d75229d7c83be5$export$5886efcb490847cc)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const handleNavigation = (section, geography)=>{
        dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
            (0, $47cf5ffcc30e4a77$export$2ce376c2cc3355c8).family,
            section
        ]));
        if (geography) dispatch($7173820326fb9f6c$export$3f718a5018550532(geography));
        history.replace(`/${(0, $47cf5ffcc30e4a77$export$2ce376c2cc3355c8).family}/${section}`);
    };
    const linkStyle = {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center'
    };
    const iconStyle = {
        width: '15px',
        height: '15px',
        color: theme.palette.primary.main,
        marginLeft: '10px',
        marginTop: '-3px'
    };
    const mobileLinkContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        paddingTop: '0!important',
        cursor: 'pointer'
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "h1",
                children: "Familie Mei\xdfner"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                children: "Skat - Eine Tradition, die verbindet"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                container: true,
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downMd ? 12 : 6,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            children: "In dem malerischen Dorf Niederstaucha, tief verwurzelt im Herzen Sachsens, begann eine bemerkenswerte Familiengeschichte, die Generationen von Menschen in ihren Bann zog. Das Jahr war 1879, als Otto Meissner das Licht der Welt erblickte und somit den Grundstein f\xfcr eine Geschichte legte, die von Liebe, Hingabe und unerm\xfcdlichem Streben nach einem besseren Leben gepr\xe4gt war. Die Mei\xdfner-Familie sollte durch die Wirren der Zeit gehen, die Herausforderungen des 20. Jahrhunderts meistern und schlie\xdflich ein Erbe hinterlassen, das bis heute weit \xfcber die Grenzen von Niederstaucha hinaus lebendig ist. Tauchen wir ein in die faszinierende Chronik unserer Familie, die die Vergangenheit ehrt und die Zukunft gestaltet."
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downMd ? 12 : 6,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            children: "Die Familie Mei\xdfner ist ein lebendiges Beispiel f\xfcr generations\xfcbergreifenden Zusammenhalt und die Macht einer gemeinsamen Tradition. Seit Jahren versammelt sich die Familie jedes Jahr, um sich bei einem Skat-Turnier zu messen. Diese jahrzehntelange Tradition hat nicht nur ihre Liebe zum Kartenspiel bewahrt, sondern auch die famili\xe4ren Bande weiter gest\xe4rkt. Das Jahr 1981 markiert den Beginn dieser Tradition, die bis heute anh\xe4lt. Was als ungezwungene Zusammenkunft begann, entwickelte sich rasch zu einem j\xe4hrlichen Highlight im Familienkalender. Die Begeisterung f\xfcr das Kartenspiel verbindet die Familie, und das Turnier wurde zu einer Gelegenheit, bei der Gro\xdfeltern, Eltern, Kinder und Enkel die Zeit miteinander genie\xdfen k\xf6nnen."
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downSm ? 6 : 4,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                            sx: linkStyle,
                            underline: "hover",
                            onClick: ()=>handleNavigation('niederstaucha', 'niederstaucha'),
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                src: "/images/niederstaucha-schloss.jpg",
                                className: classes.dashboardImage,
                                alt: "Niederstaucha Schloss",
                                style: {
                                    filter: 'sepia(0.2)'
                                }
                            })
                        })
                    }),
                    downSm && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 6,
                        sx: mobileLinkContainerStyle,
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                            sx: linkStyle,
                            underline: "hover",
                            onClick: ()=>handleNavigation('niederstaucha', 'niederstaucha'),
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    sx: {
                                        color: theme.palette.primary.main
                                    },
                                    children: "Niederstaucha"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a33fd87c92782f5$exports))), {
                                    sx: iconStyle
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downSm ? 6 : 4,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                            sx: linkStyle,
                            underline: "hover",
                            onClick: ()=>{
                                dispatch($7173820326fb9f6c$export$38eb4755744c35e0('ottoMeissner'));
                                handleNavigation('ottoMeissner');
                            },
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                src: "/images/biography.jpg",
                                className: classes.dashboardImage,
                                alt: "Otto Mei\xdfner",
                                style: {
                                    filter: 'sepia(0.6) brightness(90%)',
                                    border: '1px solid lightgrey'
                                }
                            })
                        })
                    }),
                    downSm && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 6,
                        sx: mobileLinkContainerStyle,
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                            sx: linkStyle,
                            underline: "hover",
                            onClick: ()=>{
                                dispatch($7173820326fb9f6c$export$38eb4755744c35e0('ottoMeissner'));
                                handleNavigation('ottoMeissner');
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    sx: {
                                        color: theme.palette.primary.main
                                    },
                                    children: "Otto Mei\xdfner"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a33fd87c92782f5$exports))), {
                                    sx: iconStyle
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downSm ? 6 : 4,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                            sx: linkStyle,
                            underline: "hover",
                            onClick: ()=>handleNavigation('leipzig', 'leipzig'),
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                src: "/images/Leipzig1911.jpg",
                                className: classes.dashboardImage,
                                alt: "Leipzig 1911"
                            })
                        })
                    }),
                    downSm && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 6,
                        sx: mobileLinkContainerStyle,
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                            sx: linkStyle,
                            underline: "hover",
                            onClick: ()=>handleNavigation('leipzig', 'leipzig'),
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    sx: {
                                        color: theme.palette.primary.main
                                    },
                                    children: "Garnison Leipzig"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a33fd87c92782f5$exports))), {
                                    sx: iconStyle
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $3b5b3d1a00a962e4$export$2e2bcd8739ae039 = $3b5b3d1a00a962e4$var$DashboardComponent;




var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");




const $fa47515f33a4af6c$var$FooterComponent = ()=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const history = (0, $4e1a33337564f167$export$3420e1dc2c4a518c)();
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
            sx: {
                width: '100%',
                display: 'flex',
                backgroundColor: theme.palette.grey.A700,
                padding: '32px',
                justifyContent: 'center',
                alignItems: 'center',
                color: theme.palette.secondary.main,
                textTransform: 'uppercase'
            },
            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "caption",
                children: [
                    !downSm && "\xa9 2023 | ",
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                        sx: {
                            cursor: 'pointer'
                        },
                        underline: "hover",
                        color: theme.palette.secondary.main,
                        onClick: ()=>{
                            history.replace('/imprint');
                            dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
                                'imprint'
                            ]));
                        },
                        children: "Impressum"
                    }, "imprint"),
                    ' | ',
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                        sx: {
                            cursor: 'pointer'
                        },
                        underline: "hover",
                        color: theme.palette.secondary.main,
                        onClick: ()=>{
                            history.replace('/security');
                            dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
                                'security'
                            ]));
                        },
                        children: "Datenschutzerkl\xe4rung"
                    }, "security")
                ]
            })
        })
    });
};
var $fa47515f33a4af6c$export$2e2bcd8739ae039 = $fa47515f33a4af6c$var$FooterComponent;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $6a201568c54db451$var$Imprint = ()=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "h1",
                children: "Impressum"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                children: "Angaben gem\xe4\xdf \xa7 5 TMG"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: [
                    "Kristin Dietze",
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    "Maxim-Gorki-Str. 7a",
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    "01445 Radebeul"
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                children: "Kontakt"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: [
                    "Telefon: +49 (0) 172 61 94 173",
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    "E-Mail: kristinkatrindietze@gmail.com"
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                children: "Haftungshinweis"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "F\xfcr die Richtigkeit und Vollst\xe4ndigkeit der hier dargestellten Inhalte kann keine Haftung \xfcbernommen werden. Insbesondere kann keine Haftung \xfcbernommen werden bei Internetangeboten, auf die diese Seiten verweisen, die jedoch nicht in unserem Verantwortungsbereich liegen. F\xfcr weitere Informationen lesen Sie bitte den Disclaimer/Haftungsausschluss."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                children: "Disclaimer/Haftungsausschluss"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: [
                    "1. Inhalt des Onlineangebotes",
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    "Der Autor \xfcbernimmt keinerlei Gew\xe4hr f\xfcr die Aktualit\xe4t, Korrektheit, Vollst\xe4ndigkeit oder Qualit\xe4t der bereitgestellten Informationen. Haftungsanspr\xfcche gegen den Autor, die sich auf Sch\xe4den materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollst\xe4ndiger Informationen verursacht wurden, sind grunds\xe4tzlich ausgeschlossen, sofern seitens des Autors kein nachweislich vors\xe4tzliches oder grob fahrl\xe4ssiges Verschulden vorliegt.Alle Angebote sind freibleibend und unverbindlich. Der Autor beh\xe4lt es sich ausdr\xfccklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ank\xfcndigung zu ver\xe4ndern, zu erg\xe4nzen, zu l\xf6schen oder die Ver\xf6ffentlichung zeitweise oder endg\xfcltig einzustellen.",
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    "2. Verweise und Links",
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    'Bei direkten oder indirekten Verweisen auf fremde Internetseiten ("Links"), die au\xdferhalb des Verantwortungsbereiches des Autors liegen, w\xfcrde eine Haftungsverpflichtung ausschlie\xdflich in dem Fall in Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es ihm technisch m\xf6glich und zumutbar w\xe4re, die Nutzung im Falle rechtswidriger Inhalte zu verhindern.Der Autor erkl\xe4rt hiermit ausdr\xfccklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle und zuk\xfcnftige Gestaltung, die Inhalte oder die Urheberschaft der gelinkten/verkn\xfcpften Seiten hat der Autor keinerlei Einfluss. Deshalb distanziert er sich hiermit ausdr\xfccklich von allen Inhalten aller gelinkten/verkn\xfcpften Seiten, die nach der Linksetzung ver\xe4ndert wurden. Diese Feststellung gilt f\xfcr alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie f\xfcr Fremdeintr\xe4ge in vom Autor eingerichteten G\xe4steb\xfcchern, Diskussionsforen und Mailinglisten. F\xfcr illegale, fehlerhafte oder unvollst\xe4ndige Inhalte und insbesondere f\xfcr Sch\xe4den, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der \xfcber Links auf die jeweilige Ver\xf6ffentlichung lediglich verweist.',
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    "3. Urheber- und Kennzeichenrecht",
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    "Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zur\xfcckzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte gesch\xfctzten Marken- und Warenzeichen unterliegen uneingeschr\xe4nkt den Bestimmungen des jeweils g\xfcltigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigent\xfcmer. Allein aufgrund der blo\xdfen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter gesch\xfctzt sind! Das Copyright f\xfcr ver\xf6ffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim Autor der Seiten. Eine Vervielf\xe4ltigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdr\xfcckliche Zustimmung des Autors nicht gestattet."
                ]
            })
        ]
    });
};
var $6a201568c54db451$export$2e2bcd8739ae039 = $6a201568c54db451$var$Imprint;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $4a1dc75f8bce665a$var$Security = ()=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "h1",
                children: "Datenschutzerkl\xe4rung"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "h2",
                children: "Allgemeiner Hinweis und Pflichtinformationen"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle2",
                children: "Die verantwortliche Stelle f\xfcr die Datenverarbeitung auf dieser Website ist:"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: [
                    "KD Design",
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    "Kristin Dietze",
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    "Maxim-Gorki-Str. 7a",
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    "01445 Radebeul"
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "Die verantwortliche Stelle entscheidet allein oder gemeinsam mit anderen \xfcber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, Kontaktdaten o. \xc4.)."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle2",
                children: "Widerruf Ihrer Einwilligung zur Datenverarbeitung"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "Nur mit Ihrer ausdr\xfccklichen Einwilligung sind einige Vorg\xe4nge der Datenverarbeitung m\xf6glich. Ein Widerruf Ihrer bereits erteilten Einwilligung ist jederzeit m\xf6glich. F\xfcr den Widerruf gen\xfcgt eine formlose Mitteilung per E-Mail. Die Rechtm\xe4\xdfigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unber\xfchrt."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle2",
                children: "Recht auf Beschwerde bei der zust\xe4ndigen Aufsichtsbeh\xf6rde"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: [
                    "Als Betroffener steht Ihnen im Falle eines datenschutzrechtlichen Versto\xdfes ein Beschwerderecht bei der zust\xe4ndigen Aufsichtsbeh\xf6rde zu. Zust\xe4ndige Aufsichtsbeh\xf6rde bez\xfcglich datenschutzrechtlicher Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem sich der Sitz unseres Unternehmens befindet. Der folgende Link stellt eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten bereit:",
                    ' ',
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                        color: theme.palette.primary.dark,
                        href: "https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html",
                        target: "_blank",
                        children: "https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle2",
                children: "Recht auf Daten\xfcbertragbarkeit"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erf\xfcllung eines Vertrags automatisiert verarbeiten, an sich oder an Dritte aush\xe4ndigen zu lassen. Die Bereitstellung erfolgt in einem maschinenlesbaren Format. Sofern Sie die direkte \xdcbertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle2",
                children: "Recht auf Auskunft, Berichtigung, Sperrung, L\xf6schung"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "Sie haben jederzeit im Rahmen der geltenden gesetzlichen Bestimmungen das Recht auf unentgeltliche Auskunft \xfcber Ihre gespeicherten personenbezogenen Daten, Herkunft der Daten, deren Empf\xe4nger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder L\xf6schung dieser Daten. Diesbez\xfcglich und auch zu weiteren Fragen zum Thema personenbezogene Daten k\xf6nnen Sie sich jederzeit \xfcber die im Impressum aufgef\xfchrten Kontaktm\xf6glichkeiten an uns wenden."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle2",
                children: "SSL- bzw. TLS-Verschl\xfcsselung"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "Aus Sicherheitsgr\xfcnden und zum Schutz der \xdcbertragung vertraulicher Inhalte, die Sie an uns als Seitenbetreiber senden, nutzt unsere Website eine SSL-bzw. TLS-Verschl\xfcsselung. Damit sind Daten, die Sie \xfcber diese Website \xfcbermitteln, f\xfcr Dritte nicht mitlesbar. Sie erkennen eine verschl\xfcsselte Verbindung an der \u201Ehttps://\u201C Adresszeile Ihres Browsers und am Schloss-Symbol in der Browserzeile."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "h2",
                children: "Registrierung auf dieser Website"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "Zur Nutzung bestimmter Funktionen k\xf6nnen Sie sich auf unserer Website registrieren. Die \xfcbermittelten Daten dienen ausschlie\xdflich zum Zwecke der Nutzung des jeweiligen Angebotes oder Dienstes. Bei der Registrierung abgefragte Pflichtangaben sind vollst\xe4ndig anzugeben. Andernfalls werden wir die Registrierung ablehnen."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "Im Falle wichtiger \xc4nderungen, etwa aus technischen Gr\xfcnden, informieren wir Sie per E-Mail. Die E-Mail wird an die Adresse versendet, die bei der Registrierung angegeben wurde."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "Die Verarbeitung der bei der Registrierung eingegebenen Daten erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Ein Widerruf Ihrer bereits erteilten Einwilligung ist jederzeit m\xf6glich. F\xfcr den Widerruf gen\xfcgt eine formlose Mitteilung per E-Mail. Die Rechtm\xe4\xdfigkeit der bereits erfolgten Datenverarbeitung bleibt vom Widerruf unber\xfchrt."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "Wir speichern die bei der Registrierung erfassten Daten w\xe4hrend des Zeitraums, den Sie auf unserer Website registriert sind. Ihren Daten werden gel\xf6scht, sollten Sie Ihre Registrierung aufheben. Gesetzliche Aufbewahrungsfristen bleiben unber\xfchrt."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "h2",
                children: "Google Maps"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle2",
                children: "Art und Umfang der Verarbeitung"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "Wir verwenden zur Erstellung von Anfahrtsbeschreibungen den Kartendienst Google Maps. Google Maps ist ein Dienst der Google Ireland Limited, welcher auf unserer Website eine Karte darstellt. Wenn Sie auf diese Inhalte unserer Website zugreifen, stellen Sie eine Verbindung zu Servern der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland her, wobei Ihre IP-Adresse und ggf. Browserdaten wie Ihr User-Agent \xfcbermittelt werden. Diese Daten werden ausschlie\xdflich zu den oben genannten Zwecken und zur Aufrechterhaltung der Sicherheit und Funktionalit\xe4t von Google Maps verarbeitet."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle2",
                children: "Zweck und Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "Der Einsatz von Google Maps erfolgt auf Grundlage Ihrer Einwilligung gem\xe4\xdf Art. 6 Abs. 1 lit. a. DSGVO und \xa7 25 Abs. 1 TTDSG."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: [
                    "Wir beabsichtigen personenbezogenen Daten an Drittl\xe4nder au\xdferhalb des Europ\xe4ischen Wirtschaftsraums, insbesondere die USA, zu \xfcbermitteln. In F\xe4llen, in denen kein Angemessenheitsbeschluss der Europ\xe4ischen Kommission existiert (z.B. in den USA) haben wir mit den Empf\xe4ngern der Daten anderweitige geeignete Garantien im Sinne der Art. 44 ff. DSGVO vereinbart. Dies sind \u2013 sofern nicht anders angegeben \u2013 Standardvertragsklauseln der EU-Kommission gem\xe4\xdf Durchf\xfchrungsbeschluss (EU) 2021/914 vom 4. Juni 2021. Eine Kopie dieser Standardvertragsklauseln k\xf6nnen Sie unter",
                    ' ',
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                        color: theme.palette.primary.dark,
                        href: "https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32021D0914&from=DE",
                        target: "_blank",
                        children: "https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32021D0914&from=DE"
                    }),
                    ' ',
                    "einsehen."
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "Zudem holen wir vor einem solchen Drittlandtransfer Ihre Einwilligung nach Art. 49 Abs. 1 Satz 1 lit. a. DSGVO ein, die Sie \xfcber die Einwilligung im Consent Manager (oder sonstigen Formularen, Registrierungen etc.) erteilen. Wir weisen Sie darauf hin, dass bei Drittland\xfcbermittlungen im Detail unbekannte Risiken (z.B. die Datenverarbeitung durch Sicherheitsbeh\xf6rden des Drittlandes, deren genauer Umfang und deren Folgen f\xfcr Sie wir nicht kennen, auf die wir keinen Einfluss haben und von denen Sie unter Umst\xe4nden keine Kenntnis erlangen) bestehen k\xf6nnen."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle2",
                children: "Speicherdauer"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: [
                    "Die konkrete Speicherdauer der verarbeiteten Daten ist nicht durch uns beeinflussbar, sondern wird von Google Ireland Limited bestimmt. Weitere Hinweise finden Sie in der Datenschutzerkl\xe4rung f\xfcr Google Maps:",
                    ' ',
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                        color: theme.palette.primary.dark,
                        href: "https://policies.google.com/privacy",
                        target: "_blank",
                        children: "https://policies.google.com/privacy"
                    }),
                    "."
                ]
            })
        ]
    });
};
var $4a1dc75f8bce665a$export$2e2bcd8739ae039 = $4a1dc75f8bce665a$var$Security;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");











const $d110d5d3929fb6a5$var$getDataBiography = (member)=>{
    const biography = {
        ottoMeissner: [
            {
                date: {
                    day: 27,
                    month: 3,
                    year: 1879
                },
                title: 'Das Licht der Welt',
                description: '"Es war an einem sch\xf6nen, sonnigen Fr\xfchlingstage, am 27. M\xe4rz des Jahres 1879, als ich im Hause meiner m\xfctterlichen Gro\xdfeltern in einem kleinen s\xe4chsischen D\xf6rfchen - Niederstaucha, Kreis Mei\xdfen - meine arbeitsreiche, aber von sch\xf6nsten Erfolgen gekr\xf6nte Lebensbahn begann.<br>Wie mir sp\xe4ter der Bruder meiner Mutter, Onkel Hermann Zieger, erz\xe4hlte, soll es ein recht linder, mit viel Sonnenschein ausgezeichneter Tag gewesen sein, an dem ich den ersten Schritt in die Welt getan habe. In diesen Tage vor mein Vater gerade zur Musterung gewesen, wo er als strammer Infanterist gemustert war, als er von Onkel Hermann die Mitteilung erhielt, da\xdf er Vater eines strammen Jungen geworden sei. Also begann mein<br>Lebensweg im Zeichen des Mars, daher auch meine gro\xdfe Liebe zum Soldatenberufe, denn sie war mir sozusagen mit der Muttermilch gereicht worden."'
            },
            {
                date: {
                    year: 1882
                },
                title: "Meine fr\xfcheste Jugendzeit",
                description: '"So mag wohl schon \xfcber meinen ersten Lebensjahren ein guter und heller Stern gestanden haben, denn auch mein Gro\xdfvater war mir in v\xe4terlicher Liebe zugetan. Ich brauchte nur den leisesten Wunsch zu \xe4u\xdfern und schon ging es in Erf\xfcllung. Auch an ihn denke ich noch heute mit Liebe und Hochachtung.<br>Da meine Eltern die Ehe nicht schlie\xdfen konnten, da mein Vater erst seiner Milit\xe4rpflicht gen\xfcgen mu\xdfte, f\xfchrte ich zun\xe4chst den Namen meiner Mutter und hie\xdf Otto Zieger. Erst nach der Eheschlie\xdfung meiner Eltern im Jahre 1834 wurde aus dem Zieger, Otto ein Mei\xdfner, Otto. Und Ich erinnere michnoch heute daran, wie mir meine liebe Tante "Rese" vorher immer bange machte, da\xdf ich bei der Umtaufe in ein Wasserfa\xdf getaucht w\xfcrde, und ich deshalb lieber Zieger, Otto bleiben wollte.<br>Sie war es auch, die mir in sp\xe4teren Jahren so viel aus diesen, meinen ersten Lebensjahren, bei meinen Besuchen bei ihr erz\xe4hlt hat. Es litt mich wenig im Hause, denn schon als kleiner Stepke zog es mich hinaus in den anh\xe4ngenden Garten, wo die ersten Beeren, Blumen usw. nicht sicher vor dem kleinen Spitzbuben waren. Gro\xdfe Not hatten sie mit mir, wenn ich aus Mangel einer M\xfctze ein Kopftuch tragen sollte, denn ich wollte doch kein M\xe4dchen, sondern ein richtiger Junge sein, bis eine abgelegte M\xfctze vom Gro\xdfvater darin Abhilfe schaffte.<br>Da Tante Reschen Damenschneiderin war, trug ich auch bald die ersten Hosen, die sie selbst mit viel Liebe gefertigt hatte. Dar\xfcber erz\xe4hlte sie mir sp\xe4ter einmal folgende Geschichte:<br>Als ich ein Knirps von reichlich vier Jahren war, hatte sie mir auch wieder einmal aus einer abgelegten Hose von Gro\xdfvater f\xfcr das Pfingstfest eine neue gebaut. Mit vielen guten Ermahnungen und Belehrungen, mit den reichlich vorhandenen Spielkameraden nur in der N\xe4he zu spielen, wurde ich entlassen. Doch sie hatten dabei nicht mit dem Beschlusse der gr\xf6\xdferen Jungen gerechnet, die f\xfcr diesen Tag einen Ausflug nach dem in der N\xe4he des Dorfes gelegenen "Huth\xfcbel" beschlossen hatten, an dem nat\xfcrlich Zieger, Otto nicht fehlen durfte und ungefragt ging die Reise dahin los.<br>Der "Huth\xfcbel\u201D war ein etwa eine halbe Stunde entfernt liegender ziemlich hoher Berg mit einer alten Sandgrube, einer noch \xe4lteren Linde und einen H\xfcgel mit einem riesengro\xdfen Stein, von dem man eine wunderbare Fernsicht bis am Collmberg bei Oschatz, bis Lommatzsch und bei sch\xf6nem klaren Wetter bis an den Bergen der Oberlausitz geno\xdf und deshalb auch von Schulen und Erwachsenen besucht wurde.<br>Nach anf\xe4nglichen Jungenspielen - R\xe4uber und Gendarm waren damals die beliebtesten - fand eine allgemeine Rutschpartie in die Sandgrube als Abschlu\xdf statt, ohne R\xfccksicht auf die neue Hose. Das Endergebnis von dieser Rutschpartie auf den Hosenboden war nicht nur eine total zerfetzte Hose, sondem auch eine ganz sch\xf6ne Schramme am Allerwertesten, da die Partie \xfcber eine etwa 12 bis 15 m hohe Sandgrubenwand und die vorstehenden Wurzeln der uralten Linde gegangen war. Der Schaden an der Hose wurde einstweilen mit Dornen geheilt und die Wunde am Popo mit Bl\xe4ttern verbunden. Da die Fahrt \xfcber den ganzen Nachmittag gedauert hatte, war Otto schon l\xe4ngst im ganzen Dorfe vergeblich gesucht worden, doch ohne Erfolg. Bis man den kleinen S\xfcnder in seinen Lieblingsversteck, der Gartenhecke, fand, in die er in Erkenntnis seiner S\xfcnden und aus Furcht vor den bevorstehenden Strafgericht, Versteck fand.<br>Endergebnis: Gro\xdfvater lachte, aber Gro\xdfmutter und Tante weinten, nicht wegen des Risses im Popo, sondern \xfcber das Aussehen der sch\xf6nen neuen Plingsthose, Abmarsch ins Bett und als Ersatz der Leinenhose eine solche aus Leder. Sie sah nicht so fein, aber sie gefiel mir besser, da man mit ihr besser Rutschpartien auf dem Hosenboden machen konnte. <br>Ich hatte auch einen unzertrennbaren Jugendfreund mit Namen Frans G\xfcnsel, den Sohn unseres Nachbarn. Diese Freundschaft war so herzlich und stark, da\xdf sie bis zu dessen pl\xf6tzlichen Tode an Herzschlag 1935 unvermindert gedauert hat. Er war nat\xfcrlich auch bei allen Streichen stiller Teilhaber. Ein idealer Spielplatz f\xfcr uns beide unternehmungslustigen B\xfcrschchen, war ein in der N\xe4he des gro\xdfelterlichen Grundst\xfccks vor\xfcberflie\xdfendes B\xfcchlein. Es verging im Sommer kein Tag, an welchem Franz und Otto nicht in den "Scheppen" - so nannte man die Vertiefungen des B\xfcchleins - nach Schmerlen fischten. Doch dabei kam es sehr oft zu einen unfreiwilligen Bade und so soll es vorgekommen sein, da\xdf Otto zwel oder dreimal am Tage dieses Bad geno\xdf, bis absolut keine trockenen Sachen mehr vorhanden waren, und Otto f\xfcr seine Badesucht Bettarrest erhielt, mein Freund Franz aber f\xfcr seine Reinlichkeltsbed\xfcrfnisse immer die n\xf6tige tracht Pr\xfcgel erhielt.<br>Meine Schlafstube galt auch als Aufbewahrung f\xfcr die ersparten Eier, die in einer Sch\xfcssel auf einen Tisch in der N\xe4he meines Bettes aufbewahrt wurden. Eines Tages hatte ich mir diese Sch\xfcssel als meinen Kaufmannsladen ausersehen und beim Verkaufen der Eier nat\xfcrlich den sch\xf6nsten Eierkuchen gemacht. Mit den sch\xf6nen Gackeiern, die ich so gerne a\xdf, war es f\xfcr 14 Tage vorbei.<br>Da die Gro\xdfeltern auch ihren eigenen Backofen besa\xdfen, backten sie auch ihren Brotbedarf selbst, was f\xfcr mich immer als ein Freudentag galt, denn es fiel ja auch immer ein recht gro\xdfes St\xfcck Kuchen, der meistens mit gebacken wurde, f\xfcr mich ab. Doch eines Tages sollte mir dieses Backgesch\xe4ft zum Verh\xe4ngnis werden. Bei meinem Gang durch die Backsch\xfcsselreihen hatte ich das Gleichgewicht verloren und flugs klebte ein ungebackenes Brot am Hosenboden. Bei solchen Anl\xe4ssen hatten es haupts\xe4chlich meine Ohren meiner lieben Gro\xdfmutter angetan, die sie dann zu gern lang zog. Ich glaube ihre betr\xe4chtliche Gr\xf6\xdfe stammt schon aus dieser Zeit, denn nur zu oft mussten sie  seitens meiner beiden Erzieherinnen auf ihre Dehnbarkeit gepr\xfcft werden. <br>Meines Freundes Vater, Moritz G\xfcnsel, seines Zeichens Obsth\xe4ndler, baute eine neue Scheune. Das aufgestellte Bauger\xfcst war wegen seiner H\xf6he schon lange die Sehnsucht von uns beiden Stepkens, doch der Zutritt war uns aus begreiflichen Gr\xfcnden streng verboten. Mit Entsetzen mussten jedoch Gro\xdfmutter und Tante, w\xe4hrend einer Mittagspause der Maurer, feststellen, wie die beiden Unzertrennlichen mit je einer Tabakpfeife der Maurer im Munde stolz wie ein Pfau auf dem hohen Bauger\xfcst  herum stolzierten. Da mein Freund Franz der Anstifter zu dieser Besteigung gewesen war, wurden wir seinen Vater zur Bestrafung \xfcberwiesen, der uns jedoch mit den Worten entlie\xdf:"<br><br><div style="text-align: center; width=100%">"Aus den wird mal was H\xf6heres"!</div><br>"Von meinem 3. Lebensjahre an kann ich mich selbst auf so manches Erlebnis bei meinen Erziehern erinnern: Wie schon oben erw\xe4hnt, mu\xdfte mein Vater vom Herbst 1879 bis zum Herbst 1882 seiner Milit\xe4rpflicht beim 4. Kgl. S\xe4chs. Inf. Rgt. Nr. 103 gen\xfcgen. Gar gro\xdf soll meine Freude jedes Mal gewesen sein, wenn ich zur Urlaubszeit auf seinen Knien reiten durfte. Auch erinnere ich mich selbst seiner als Soldat, als er pl\xf6tzlich im Herbst 1882, gelegentlich der Kaiserman\xf6ver, die ganz in der N\xe4he von Staucha stattfanden, bei uns feldmarschm\xe4ssig gekleidet erschien, wobei ich behauptet h\xe4tte, da\xdf sei mein Vater nicht, der H\xe4tte keene Spitze off dr. M\xfctze."<br>'
            },
            {
                date: {
                    year: 1884
                },
                title: 'Die Hochzeit meiner Eltern',
                description: '"Am 27. Januar 1884 schlossen meine Eltern die Ehe. Am gleichen Tage bekannte sich mein Vater als meinen rechtlichen Vater, was er durch Eintragung in das Geburtenregister best\xe4tigen lie\xdf. Mit dieser Begebenheit wurde aus dem Zieger, Otto ein Mei\xdfner, Otto.<br>Da ich am Tage meiner Eltern Hochzeit bereits bald f\xfcnf Jahre alt war, kann ich mich noch recht lebhaft an diesen Tag erinnern. Es war ein wundersch\xf6ner Wintertag mit viel Schnee. Wie \xfcblich fuhr die Stauchaer Jugend am G\xfcnselberge Schlitten. Nat\xfcrlich fehlte auch Otto nicht. Pl\xf6tzlich sauste er mit seinem Schlitten - er bestand in Ermangelung etwas Besseren aus einer Fu\xdfbank - seinen im Hochzeitsstaate vor\xfcbergehenden Eltern zwischen die Beine. Da ich nat\xfcrlich mit zur Kirche wollte, hatten meine beiden Gro\xdfv\xe4ter, die als Trauzeugen mitgingen, alle H\xe4nde voll zu tun, um mich davon abzuhalten.<br>Mit dieser Begebenheit mu\xdfte nat\xfcrlich auch die goldene Zeit meiner ersten Jugendjahre zu Ende gehen, denn von nun an stellten meine Eltern ihr Eigentumsrecht an mich in Anspruch. Schon lange vor meiner \xdcbersiedlung in mein Elternhaus, die kurz vor Ostern 1884 erfolgte, lie\xdfen meine lieben Erzieherinnen nochmals alle ihr vortrefflichen Erziehungsk\xfcnste steigen, um aus dem \u201CR\xe4bchen\u201D, ein folgsames \u201CB\xfcrschchen\u201D zu machen. So nahte denn der Tag meines Auszuges aus der sch\xf6nsten Zeit meiner fr\xfchesten Jugendzeit. Eines Tages erschien ein Bruder meines Vaters, Onkel Ernst Mei\xdfner, mit einem Schiebebock, um mich feierlich mit meinen sieben Sachen und den vielen guten Ratschl\xe4gen und Ermahnungen meiner lieben Gro\xdfmutter und Tante Hedehede zu \xfcberf\xfchren. Die Reise in einen neuen Abschnitt meines Lebens hatte begonnen.<br>Den Eindruck, den ich aus meinem gro\xdfelterlichen Hause mitnehmen durfte, war ein recht guter. Alle seine Mitglieder waren einfache, biedere Menschen, dabei arbeitsam, sparsam und gutgl\xe4ubig und rechtschaffend Leute.<br>Mein Gro\xdfvater, vom Beruf Schafmeister, war ein kleiner kr\xe4ftiger Mann, mit rechtschaffenen Charakter, der mit seiner lieben Sophie und Tante Rese in einem schmucken kleinen H\xe4uschen ein vorbildliches Eheleben f\xfchrte. Die war alles nicht ohne Einflu\xdf auf die Bildung meines Charakters geblieben und sooft ich in meine Heimat zur\xfcckkehrte, galt auch ihnen mein Besuch. Bis zu ihrem Lebensende haben sie mit heissen Herzen Anteil auch an meinem Ergehen genommen. Aus diesem Grunde habe ich auch ihnen allezeit ein dankbares, ehrenvolles Andenken bewahrt."<br>'
            },
            {
                date: {
                    year: 1885
                },
                title: 'Meine Jugendzeit im Elternhaus',
                description: '"In dem D\xf6rfchen Zschochau bei Ostrau, dem westlichsten Dorfe des Kreises Mei\xdfen, hatten meine Eltern Wohnung genommen und deshalb auch mir dort eine neue Heimat geschaffen, wo ich nun die Jahre meiner Schulzeit verleben sollte. Zschochau war nicht ganz so gro\xdf wie Staucha, hatte aber eine gr\xf6\xdfere Ausdehnung, da es in einem sch\xf6nen langgestreckten Tal lag und in seiner unmittelbaren N\xe4he sch\xf6ne Wiesengr\xfcnde und W\xe4lder hatte. Bald hatte ich mich auch hier eingelebt und wu\xdfte auch hier in allen Ecken und Enden unseren lieben D\xf6rfchens Bescheid.Auch mangelte es nicht an Jugendkameraden, doch keine wurde hier so innig geschlossen, wie die mit meinem unverge\xdflichen Franz G\xfcnsel in Staucha. So verging das erste Jahr in Zschochau ohne wesentliche Begebenheiten und es nahte der f\xfcr jeden Menschen wichtige Zeitpunkt, der Schulanfang.<br>Zschochau besa\xdf eine erst im Jahre 1873 neuerbaute f\xfcr damalige Verh\xe4ltnisse ziemlich moderne Schule. Dazu einen ganz vorz\xfcglichen Schulmeister, ind er Person meines noch heute hochverehrten Lehrers, Emil Bretschneider. Er war ein hochgewachsener Mann mit einem stattlichen Vollbart, aber lieben, guten Augen, der es verstand, vom ersten Tage an das Vertrauen seiner Sch\xfcler und Sch\xfclerinnen zu gewinnen. Er war ein ganz vorz\xfcglicher P\xe4dagoge, der immer bestrebt war, seinen Sch\xfclern nur das Beste zu vermitteln und hat damit, wenn die Anlagen vorhanden waren, auch oft recht gute Resultate erreicht. Vor meinen Augen steht er heute noch nach so vielen Jahren immer noch als mein bester Lehrer und Erzieher, aber auch als mein v\xe4terlicher Freund, dem ich die ersten Grundlagen meines Wissens und eine ausschlaggebende Bedeutung auf die Bildung meines Charakters verdanke. Aus diesem Grunde habe ich ihm bis heute ein ehrendes Ged\xe4chtnis in dankerf\xfclltem Herzen bewahrt.<br>Durch \xc4u\xdferungen meiner Mutter, auf die Schule aufmerksam geworden, trieb es mich eines Tages vor Schulanfang aus Neugierde hinein in die Schulstube, die meistens offen stand. Mit neugierigen Blicken betrachtete ich mir die sch\xf6nen an den W\xe4nden h\xe4ngenden Bilder und all die anderen Gegenst\xe4nde, bis ich endlich auf einem leeren Platze in den Bankreihen landete. Pl\xf6tzlich stand mein Lehrer gross und schlank vor mir und schaute mich versonnen und ernst an durch seine scharfen Brillengl\xe4ser, und meinte:<br>\u201CDie Schule ist noch nicht losgegangen, dir scheint es aber hier zu gefallen, hoffentlich gef\xe4llt es dir immer so gut.\u201D<br>Das war meine erste Begegnung mit meinem lieben Lehrer, sie sollte eine gute Vorbedeutung f\xfcr meine ganze sp\xe4tere Schulzeit bedeuten.<br>Mit vielen ernsten Ermahnungen seitens meiner Mutter, betrat ich an ihrer Hand am Tage des Schulanfangs, Ostern 1885, unser Klassenzimmer, erstaunt \xfcber die gro\xdfe, ernste Versammlung, die sich zu dieser Feierstunde eingefunden hatte. Sie bestand aus dem Herrn Pfarrer, der damals noch die Aufsicht \xfcber die Schule f\xfchrte, dem gesamten Schulvorstande, den angesehensten M\xe4nnern der Schulgemeinde und unseren Eltern.<br>Nach einer schlichten Feier, die bestand aus gemeinsamen Gesang und Handorgelspiel, wobei ich das erstemal das mit sp\xe4ter ans Herz gewachsene Lied: \u201CSo nimm denn meine H\xe4nde und f\xfchre mich\u2026\u201D h\xf6rte. Dann bl\xfchte f\xfcr uns alle der liebe Zuckert\xfctenbaum, in Form eines wohlgef\xfcllten Waschkorbes mit T\xfcten, die von 20 zitternden Jungens- und M\xe4delsh\xe4nden mit lachenden und gl\xe4nzenden Kinderaugen in Empfang genommen wurden. Wohl keiner von ihnen hat dabei wohl daran gedacht, da\xdf mit diesem Akte nunmehr der Ernst des Lebens und der Pflichterf\xfcllung beginnen sollte.<br>Ein besonderes Zeichen unserer Schule bestand darin, da\xdf der Beste seiner Klasse immer der Bankerste war. Und so nahm mich am n\xe4chsten Tage bei Schulbeginn mein Lehrer bei der Hand und f\xfchrte mich auf diesen, von jedem so heiss begehrten ersten Platz meines Jahrganges. Der Sohn eines einfachen Arbeiters war f\xfcr w\xfcrdig befunden, diese Auszeichnung zu erhalten. Hieraus spricht schon der gerechte und soziale Sinn meines Lehrers, denn zu meinem Jahrgange geh\xf6rten Bauern-, Kaufmanns- und Handwerkers\xf6hne, die von ihm nicht f\xfcr w\xfcrdig befunden wurden, diese Auszeichnung zu geniessen.<br>W\xe4hrend meiner ganzen Schulzeit habe ich diesen Platz inne gehabt, denn kein anderer konnte ihn mir streitig machen. Im siebenten Schuljahr \xfcbersprang ich sogar den achten Jahrgang und hatte damit die Freude zwei Jahre der allererste in der Schule zu sein. Eine Auszeichnung, die wohl einmalig war, da sie keiner meiner sechs Br\xfcder sp\xe4ter wieder erreicht hat.<br>Ich mag wohl ein recht gut begabtes B\xfcrschchen gewesen sein, denn bald konnte ich nciht nur sch\xf6n schreiben und lesen, sondern auch in allen anderen F\xe4chern stellte ich meinen Mann, und oft kam es vor, wenn ein anderer eine Frage des Lehrers nicht beantworten konnte, er mich fragte, und ich sie ihm schnell und richtig beantwortete.<br>So war es selbstverst\xe4ndlich auch f\xfcr meine Eltern immer eine Freude, wenn ich nach beendetem Schuljahre mit lauter Einsen im Zensurbuch nach Hause kam. Auch von meinen Gro\xdfeltern erhielt ich daf\xfcr oft eine Anerkennung in Form eines Groschens oder F\xfcnfers, die dann in die Sparb\xfcchse wanderten.<br>Meine Spezialf\xe4cher waren sp\xe4ter Geographie und Geschichte. <br>Mit neun Jahren war ich soweit, da\xdf ich aus dem Kopfe s\xe4mtliche Erdteile oder die damaligen deutschen Bundesstaaten mit Kreide konnte an die Tafel zeichnen. Dabei erinnerte ich mich folgendes Vorganges:<br>Es ist unerwartete Schulrevision durch den HErrn Schulinspektor, Superintendent Kohlsch\xfctter aus Mei\xdfen. Nachdem er zuerst in Religion und Rechnen gepr\xfcft hat, will er auch noch etwas aus Geschichte und Geographie wissen. Er beginnt selbst zu fragen, nat\xfcrlich bekommt er nicht immer die richtigen Antworten, schlie\xdflich mu\xdfte unser Lehrer selbst fragen, f\xe4ngt nat\xfcrlich bei mir als ersten mit folgender Frage an:<br>\u201CMei\xdfner, nenne mir die F\xfcrsten der Wettiner Hauslinie der Reihenfolge nach!\u201D Schon schnurrt sie Ott der Reihe nach von 1089 bis 1889. Darauf grosses Erstaunen beim Herrn Schulinspektor. Aber es sollte noch besser kommen, denn als mein lieber Lehrer mir das Experiment mit den Deutschen Bundesstaaten an der Wandtafel machen lie\xdf, wurden seine Augen immer gr\xf6\xdfer und mit den Worten: \u201CDas ist f\xfcr eine Volksschule hervorragend!\u201D schied er schnell von uns. Ein triumphierendes L\xe4cheln seitens unseres Lehrers begleitete ihn zur T\xfcr hinaus und mir klopfte er die Schulter mit den Worten: \u201CMei\xdfner, du hast wieder einmal die ganze Schule gerettet.\u201D<br>Dieser Vorfall wurde sp\xe4ter im ganzen Dorfe bekannt. Das ich durch derartige Vorf\xe4lle nat\xfcrlich der Liebling meines Lehrers wurde, war kein Wunder, und so nahm er auch oft Gelegenheit, mich auch au\xdferhalb der \xfcblichen Schulstunden im trauten v\xe4terlichen Gespr\xe4ch, mich noch in anderen F\xe4chern, die der Schulplan nicht vorsah, zu unterrichten.<br>Da ich eine sehr sch\xf6ne, helle Sopranstimme hatte, sang ich schon ab meines neunten Lebenjahres mit im Kirchenchor. Dort hatte mich mein Lehrer bald soweit gebracht, da\xdf ich gelegentlich der Hohen Feiertage in den Arien Solo singen mu\xdfte, zur Freude und Erbauung aller Kirchenbesucher. Da unser Lehrer gleichzeitig auch das Amt des Kanters mit versehen mu\xdfte, so war ich auch hier sein Vertrauter. Beim Herrn Pfarrer die Lieder f\xfcr Sonntag holen, Lieder anstecken in der Kirche, Kirche \xf6ffnen und schlie\xdfen, Kreuztragen bei Begr\xfcbnissen usw. geh\xf6rten dabei zu meiner Besch\xe4ftigung. Daf\xfcr erhielt ich eine kleine Entsch\xe4digung an Geld und jedes Jahr zu Weihnachten einen wundersch\xf6nen \u201CAuerbachs Kinderkalender\u201D, dessen Geschichten mich oft so fesselten, da\xdf ich eines Tages beim Lesen und Kinderwiegen meine damals kleine Schwester Hilda mit samt der ganzen \u201CBeue\u201D umwarf, wof\xfcr ich dann die n\xf6tige Tracht Pr\xfcgel von der lieben Mutter bezog."'
            },
            {
                date: {
                    year: 1889
                },
                title: 'Meine Schulzeit',
                description: '"Einen H\xf6hepunkt w\xe4hrend meiner Schulzeit bildeten allj\xe4hrlich unsere Schulfeste. Schon Wochen vorher wurden dazu die Vorbereitungen getroffen. Der Herr Lehrer diktierte mir dazu eine Bittschrift, die ich auf eine Sammelliste schreiben mu\xdfte, und ich ging nun \u201CFechten\u201D im wahrsten Sinne des Wortes. Zuerst zum Rittergutsp\xe4chter, dann zu den Bauern, Kaufleuten und allen Handwerkern, um dann die reiche Beute - oftmals waren es an die 300,- Mark - meinen Lehrer schmunzelnd zu F\xfc\xdfen zu legen. Dann ging es mit dem Lehrer und noch einigen Schulkameraden nach D\xf6beln, um dort den Bedarf f\xfcr das Schulfest zu decken. Das Fest fand immer Ende Juni an einem Sonntag statt und wurde auf der sogenannten \u201CBaumwiese\u201D des Rittergutes abgehalten. Den Glanzpunkt des Festes bildete der Festzug. Voran die Musik mit Trommlerzug in Bergmannstracht, dann die kleinsten Schulkinder, dann die Schulfahne, der Festwagen mit der vorj\xe4hrigen K\xf6nigin und dem K\xf6nig, dann die anderen Schulkinder in allerhand bunten Trachten, die der Lehrer besorgt hatte und \xfcberreichlichen Blumengewinden - ein wirklich wundersch\xf6ner Festzug -. Im fr\xf6hlichen Zuge ging es durch das ganze Dorf bis zur Festwiese, wo bei Vogel- und Sternschie\xdfen, Spielen, Kuchen- und W\xfcrstchenessen der Rest des Tages verbracht wurde. Mit Einbruch der Dunkelheit begann der Einmarsch, bei dem der neue K\xf6nig und die K\xf6nigin eingebracht wurden. Letztere Ehre - K\xf6nig zu sein - habe ich auch genossen. Ein Kindertanz im Gasthof beschlo\xdf jedesmal das so wundersch\xf6ne und unvergessliche Fest.<br>In meine Schulzeit f\xe4llt auch ein f\xfcr mich unvergessliches Ereignis. Im Herbst 1889 wurden die Kaiserman\xf6ver des damaligen 12. Kgl. S\xe4chs. Armeekorps ganz in der N\xe4he unserer Heimat abgehalten. F\xfcr uns Jungen war dieses Ereignis von ganz besonderer Bedeutung, denn es brachte acht Tage unvorhergesehene Ferien. Den H\xf6hepunkt bildete f\xfcr uns der Kaiserempfang am Bahnhof Ostrau, zu dem die Schulkinder aus der weiteren und n\xe4heren Umgegend von Ostrau Spalier standen. Bei dieser Gelegenheit sah ich zum ersten Male den damals jungen Kaiser Wilhelm II, K\xf6nig Albert von Sachsen, Bismarck, Moltke und all die vielen hohen Herrschaften, die zur Kaiserparade bei Naundorf-M\xfcgeln fuhren; ununterbrochen hatten wir in Zschochau Einquartierung. Zuerste Grenadiere, Ulanen, 104er, 133er, J\xe4ger, Sch\xfctzen und Artillerie, auch einmal die Regimentsmusik der 133er, die abends von \u201CGrossen Zapfenstreich\u201D im Hofe des Ritterguts spielte. Der Hauptgefechtstag fand an einem Montag in der N\xe4he von Zschochau statt, dazu hatte der Kaiser und der gesamte Stab in der N\xe4he der \u201CPatzensch\xe4nke\u201D Aufstellung genommen, von woraus auch die grosse Reiterattacke in Richtung L\xfctzschnitz geritten wurde, die der bei Glaucha stehenden Infanterie galt. Nach beendetem Gefecht hielt ide 23. und 32. Div. bei Meila und Autersch\xfctz und die 24. Div. am schon erw\xe4hnten \u201CHuth\xfcbel\u201D bei Steuden ihre Biwaks ab. Letzteres war f\xfcr uns ein besonderes Erlebnis, da es ja ganz in unmittelbarer N\xe4he stattfand. Ich h\xe4tte mir damals wohl kaum tr\xe4umen lassen, da\xdf ich 10 Jahre sp\xe4ter selbst in einem der Regimenter dieser Division -106 - als Soldat dienen w\xfcrde.<br>So verging ein Jahr nach dem anderen und bald nahte die Zeit der Berufswahl. Dieses war f\xfcr meine Eltern ein Sorgenproblem, da sie zur damaligen Zeit ausser mir noch f\xfcr vier andere Geschwister sorgen mussten. Mein und meines Lehrers lebhafter Wunsch ging dahin, mich Lehrer werden zu lassen, und er war gern bereit, mir am Seminar Nossen eine Freistelle zu vermitteln. Leider erkrankte er im Jahre 1892 ernstlich und starb, ehe er sein Versprechen wahr machen konnte, im Januar 1893, von der ganzen Gemeinde auf das Tiefste betrauert, denn w\xe4hrend seiner 23-j\xe4hrigen T\xe4tigkeit in Zschochau hatte er sich nur Freunde erworben.<br>Nach vielen raten und w\xe4gen kam man endlich zu dem Entschlu\xdf, mich B\xe4cker werden zu lassen.<br>Zur Zeit meiner Schulzeit herrschte in unserem D\xf6rfchen ein ruhiges und friedliches Leben, da\xdf durch keinerlei Zank und Streit von Parteien getr\xfcbt wurde.<br>Den Mittelpunkt im Dorfe bildete das Rittergut, das dem gr\xf6\xdften Teile seiner Einwohner Arbeit und Brot gab. Sein Besitzer war Freiherr von Fritzsch, der es jedoch nicht selbst bewirtschaftete, sondern an den damaligen P\xe4chter, Artur Eulitz, verpachtet hatte. Dieser P\xe4chter war nicht nur ein ausgezeichneter Bewirtschafter seines Gutes, sondern auch ein f\xfcrsorglicher Arbeitgeber, der es verstand, das Vertrauen seiner s\xe4mtlichen Arbeiter und sonstigen Bediensteten im vollsten Masse zu erringen. Da damals die Landwirtschaft noch keine oder wenig Maschinen besa\xdf, mangelte es oft an Arbeitskr\xe4ften, so dass die gr\xf6sseren Kinder zu diesen Arbeiten herangezogen werden mussten. So kann ich mich erinnern, dass ich schon mit neun Jahren Zuckerr\xfcbenverziehen, Kartoffellesen und andere kleine Arbeiten verrichten musste. Mit 12 Jahren war ich stolz, wenn ich im Fr\xfchjahr mit einem Ochsen oder alten, ruhigen Milchpferd -  es hie\xdf so, weil es nur noch zum Abfahren der Milch in die Molkerei benutzt wurde - die Saat eggen durfte. Nat\xfcrlich ritt Otto stolz auf dem Ochsen oder Pferd hinaus und wieder heim. Auch ging ich gern mit Kirschen- oder Pflaumenpfl\xfccken, denn da wanderten die sch\xf6nsten zuerst in den Schnabel.<br>Der von all diesen Arbeiten aufkommende Verdienst wanderte nat\xfcrlich restlos in die Sparb\xfcchse, die am Ende meiner Schulzeit so reichlich gef\xfcllt war, dass meine Eltern in der Lage waren, nicht nur die Kosten f\xfcr meine Konfirmations- und B\xe4ckerausr\xfcstung, sondern auch das Lehrgeld in H\xf6he von 75,- daraus zu bestreiten.<br>Viele sch\xf6ne Erinnerungen stehen aus dieser Zeit noch heute lebhaft vor meinen Augen, so besonders folgende:<br>Jedes Jahr nach beendeter Ernte gab der P\xe4chter des Rittergutes seinem Personal ein Erntefest, den sogenannten \u201EGuten Montag\u201C, der f\xfcr das ganze Dorf ein besonderes Erlebnis bedeutet, denn alles was in der Ernte und mitgeholfen hatte, ob Schuster, Schneider, Schmied, Stellmacher oder sonst einer durfte an diesem Fest mit teilnehmen. Nachdem das letzte \u201EFuder\u201C - ein mit einem paar Ochsen und einem Kopf Pferden bespannter voller Erntewagen, der obenauf mit einer Birke und dem Erntekranz geschm\xfcckt war und auf dem wir Jungen stolz hoch oben thronten - eingebracht war, fand am n\xe4chsten Sonntag darauf das Erntefest statt es begann mit der sogenannten \u201EMahlzeit\u201C. Dazu waren auf einer leeren Scheunentenne lange Tafeln aufgestellt die mit allerhand Blumen geschm\xfcckt waren und auf denen die Speisen in Massen dann aufgetragen wurden. An dieser Mahlzeit nahm alles, ob Erwachsener oder Kind, teil. Nach dem der Eulitzherre - so nannte man den P\xe4chter - an der Tafel Platz genommen hatte, sprach der Vogt (Vorarbeiter) ein Tischgebet und das fr\xf6hliche Schmausen begann. Dazu spielte eine Musikkapelle flotte Weisen. Auch fehlte es nicht an den n\xf6tigen \u201EErntegetr\xe4nken\u201C - Bier und Schnaps, so da\xdf gar bald die fr\xf6hlichste Stimmung herrschte. Nach der Mittagstafel gab es noch Berge von Kuchen, die oft kaum bew\xe4ltigt werden konnten,  so da\xdf oft noch etwas f\xfcr \u201EDerheeme\u201C \xfcbrig blieb. Nach der Mahlzeit wurde zum Erntezug gestellt. Nat\xfcrlich alles in Erntetracht mit geschm\xfcckten Sensen, Rechen und Gabeln und vor allem den riesengro\xdfen Erntekranz an der Spitze, ging es nach dem Gasthofe zum Erntetanz. <br>An allen diesen Begebenheiten nahm selbstverst\xe4ndlich der Eulitzherre mit teil, und selbst beim Erntetanz schwenkte er mit irgendeiner Magd oder Arbeiterin zum Gaudium der anderen durch den Saal. Nat\xfcrlich bekamen auch wir Kinder unseren Erntetanz.<br>Wir hatten auch in unserem D\xf6rfchen zwei schnurrige Kauze mit denen wir R\xe4bchen oftmals unsere \xfcberm\xfctigen Scherze trieben. Es waren diese der F\xf6rster Br\xe4uer und der Rechnungsf\xfchrer des untersten Kalkofens mit Namen Scherper. Beide wohnten abgeschieden von aller Welt, au\xdferhalb des Dorfes in einem wundersch\xf6nen Wiesengrunde zusammen in einem Hause, dem sogenannten Jagdhause. Ersterer war ein richtiger deutscher F\xf6rster mit gro\xdfem schwarzen Vollbart, mit der unvermeidlichen Tabakpfeife und war immer von zwei niedlichen Dackeln begleitet. Er liebte nicht nur seinen Wald, sondern auch sein Wild, und wusste zum Beispiel im Fr\xfchjahr zur Brutzeit jedes Fasanennest, und die freuten wir Lausejungen uns, wenn wir wieder einmal zu seinem \xc4rger ein solches Nest leer gemacht hatten. Wir f\xfcrchteten und liebten ihn zugleich, denn oft standen wir vor seiner Voliere, in welcher er als Kuriosum einen zahmen Fuchs, ein Reh und einige sch\xf6ne Fasanenh\xe4hne beisammen hatte. Oft und gern gedenke ich auch noch heute an die sch\xf6nen Stunden bei seinem Scheibenschie\xdfen und Jagden, bei denen wir Anzeiger und Treiber spielen durften. Er war ein sehr guter Sch\xfctze und oft neckten wir ihn, indem wir f\xfcr einen guten Schu\xdf ein schlechtes Resultat anzeigten und freuten uns dann, wenn er anfing zu wettern, und unserer Lehrer, der regelm\xe4\xdfig am Schie\xdfen teilnahm, ihn mit den Worten neckte: Siehste Breier, nu haste widdermal verbei gehaun. Worauf er dann trocken bemerkte: Ich mu\xdf mir ehm eene neie koofen. Damit meinte er seine Flinte.<br>Sein Nachbar Scherper hatte eine andere Leidenschaft. Er z\xfcchtete, in der im Wiesengrunde entlang flie\xdfenden Bach, Forellen und Krebse. F\xfcr uns Jungen war es daher ein Genuss, wenn wir an einem sch\xf6nen Sonntage Vater Scherper die sch\xf6nsten Forellen aus dem Bach holen konnten und \xfcber die Krebse herfielen. Erwischen durften wir uns nat\xfcrlich nicht lassen, denn er war ein recht flinke M\xe4nnchen und eine Tracht Pr\xfcgel war uns dann sicher. Aber die Umgebung des untersten Kalkhofens hatte so viele sch\xf6ne Verstecke, da\xdf er seine liebe Not hatte, um uns zu finden. Er hatte eine Leidenschaft, er liebte den Schnaps. Sobald sich einer von uns in seiner N\xe4he sehen lie\xdf, musste er sicher erst einmal zum \u201EZ\xfcchner\u201C - so hie\xdf der Schnapsh\xe4ndler \u2013 laufen, um sein nicht gerade kleines Fl\xe4schchen f\xfcllen zu lassen. Nat\xfcrlich probierten wir erst einmal hinter der n\xe4chsten Hausecke und erg\xe4nzten dann den fehlenden Inhalt mit Bachwasser, und freuten uns dann, wenn Vater Scherper meinte: Er w\xe4rd alle Tage d\xfcnner. Seine Belegschaft bestand aus etwa 10 Mann - M\xe4nner und Frauen - als Steinbrucharbeiter und Kalkbrenner, die alle, ob Mann oder Frau, in seinem Fu\xdfstapfen wandelten und so kam es oft vor, da\xdf an Lohntagen ab und zu einer hinter seiner Karre her, mit in den Kessel fiel, wohin dann Vater Scherper mit einer langen Stange wieder herauszog. Nach Lohntagen fanden sie schwer den Weg in die heimatlichen Benaten, sondern es musste erst einer beim \u201EZ\xfcchner\u201C abgehoben werden.<br>Da sie im Laden nicht trinken durften, so versammelten sie sich eintr\xe4chtig miteinander im Hofe unter dem\xc4ppelboom, wo sie dann oft bis sp\xe4t in die Nacht hinein ein Fl\xe4schchen nach dem anderen leerten. Dieser edlen Versammlung hatten wir Jungens den sch\xf6nen Namen \u201ERotzkiekenverein\u201C gegeben, deren Vorstand nat\xfcrlich Vater Scherper war.<br>In den langen Wiesen, das oben erw\xe4hnte Wiesengel\xe4nde, wo Vater Scherper wohnte, ging unser beliebter Sonntagsausflug. Hier behaupteten wir fanatisch unser Eigentumsrecht und luden deshalb auch keine Fremden G\xe4ste darin. Besonders verha\xdft waren uns die Ostrauer Jungen. Deshalb kam es hier oft zu den erbittertsten Jungenschlachten in denen wir meistens die Sieger blieben und die Ostrauer oft mit Heulen und Beulen nach Hause schickten. Nach solchen Schlachten durften wir uns trauen nur noch auf Schleichwegen betreten, um dort nicht der ausgleichenden Gerechtigkeit anheim zu fallen.<br>Ein weiterer sch\xf6ner Ausflugsort war die Kr\xe4henh\xfctte, ein Alter verlassener Steinbruch, wo die Waghalsigsten Kletter\xfcbungen und die ersten Rauchversuche abgehalten wurden. Auch der Hopfenberg, der ehemalige Schlosspark - das Schloss der Frh. Von Fritzsch ist 1867 bei einem gro\xdfen Dorfbrande mit abgebrannt - eignete sich mit seinem dichten Waldbestand vorz\xfcglich zu unseren Jungenspielen.<br>Im Sommer herrschte auf unseren, mitten im Dorf gelegenen, Deiche gro\xdfer Badebetrieb. Mit einem als Holzr\xf6hren zusammen gebautem Flo\xdf wurden Rundfahrten veranstaltet, zu denen auch oft die M\xe4dchen eingeladen wurden. Gar oft hat dabei unter Indianergeheul eine dieser vorwitzigen Damen ein unfreiwilliges Bad nehmen m\xfcssen. An diese sch\xf6nen Sommerbadetage erinnert mich noch sehr lebhaft folgender Vorfall:<br>Hochbetrieb am Deiche. Otto musste zu seinem Leidwesen Kinderwarten, mit dem strengen Verbot, ja nicht in den Deich zu gehen. Doch bald ist in der Person unseres Nachbar T\xf6chterchen ein Ersatzkinderm\xe4dchen gefunden und Otto f\xe4hrt schon l\xe4ngst Flo\xdf. Die die Kleider sind im Kinderwagen verstaut. Doch oh weh, die Mutter braucht das Baby zum F\xfcttern, erster Weg zum Deich. Unter schweren Drohungen f\xe4hrt sie wutentbrannt den Kinderwagen mit meinen Kleidern nach Hause. Auf Um- und Schleichwegen durch das ganze Dorf musste ich ihr notgedrungen im Adamskost\xfcm folgen, nat\xfcrlich unter dem Gel\xe4chter meiner Schulkameraden. Nur ein schneller Sprung ins Bett rettete mich vor allzu gro\xdfen Schmerzen der nun folgenden Abreibungen.<br>Besonders gro\xdf und sch\xf6n waren unserer Winterfreuden, da es bei uns nicht an Schlittenbahnen fehlte. Die beliebteste von allen war die hinter der Kirche in der sogenannten \u201EGasse\u201C. Hier traf sich Jung und Alt, und nach kurzem Gebrauch gl\xe4nzte sie bei ein Spiegel und blitzschnell sausten wir zu dreien und vieren die Gasse hinab. Wenn auch manchmal ein Anlieger \u2013 Schmidts, Wilhelm - uns durch Aschestreuen unseren Spa\xdf verderben wollte, so hatte er nicht mit flei\xdfigen Jungenh\xe4nden gerechnet, denn am n\xe4chsten Tag war sie genauso blank, wie vor dem Aschestreuen.<br>Diese Winterfreuden haben mir manche schwere Abreibungen eingetragen, denn diese herrlichen Winterfreuden zogen mich nicht nur mit Allgewalt an, sondern hielten mich auch mit ebenso gro\xdfer Gewalt fest, und nur da\xdf, dem ganzen Dorfe wohlbekannte, Rufzeichen meiner Mutter: Ot-to-o-o-o-o vermochte mich in die h\xe4uslichen Gefilde, wo es st\xe4ndig nach Arbeit roch, zur\xfcckzuf\xfchren. Hierbei sollte uns, die wir damals zu Hause waren, Buder Max, Paul und ich, folgender Jungenstreich zum Verh\xe4ngnis werden.<br>Ein sch\xf6ner Wintertag. Die Schlittenbahn ist im vollen Betrieb und drei Buben m\xfcssen Federn schleissen, eine an und f\xfcr sich von uns allen verha\xdfte Arbeit. Die Mutter musste zum Einkaufen nach Ostrau gehen. Vorher hatte sie unsere Arbeit in Form eines gar nicht kleinen Saurengurkentopfes, gef\xfcllt mit ungeschlissenen Federn, zugeteilt, mit der Ermahnung, da\xdf dieser Topf erst leer zu schlei\xdfen sei, er einer auf die Schlittenbahn zu gehen habe. Flei\xdfig wird gearbeitet, doch die Federn wollen und wollen nicht alle werden. Schlie\xdflich kommt Max auf den Einfall, den Rest der Federn in den Ofen zu verbrennen, was umgehend geschah. Keiner der S\xfcnder hat nat\xfcrlich nicht beachtet, dass verbrannte Federn einen furchtbaren Gestank verursachen. Doch es geht zum Schlittenfahren und ausnahmsweise rechtzeitig nach Hause, ehe die Mutter kommt. Bei ihrem Eintritt in die Stube und beim Anblick ihrer schnuppernden Nase, Ert\xf6nt es wie auf Kommando: Mutter, wir ham keene Feddern verbrannt! Damit unsere S\xfcnden verraten, \xe4h sie entdeckt war. Ein Pensum, Reihe oben war die Folge unserer Mi\xdftat hat und was schlimmer f\xfcr uns war, acht Tage Sperre der Schlittenbahn.<br>Da mein Vater infolge seines Berufes, er war ab 1890 bis 1903 in Dresden besch\xe4ftigt, dauernd von der Heimat abwesend war, lag die Erziehung der Kinder lediglich in der Hand unserer Mutter und mit unnachsichtiger Strenge hat sie ihres nicht leichten Amtes gewaltet. Hatte irgendeiner von uns nach ihrer Ansicht etwas verbrochen, so folgte die Strafe auf dem Fu\xdfe in Form einer geh\xf6rigen Tracht Pr\xfcgel. Da ich der \xe4lteste von allen war, so bezog ich auch oft, f\xfcr die J\xfcngeren die n\xf6tige Abreibung. Ginge es nach ihrer Meinung nicht gleich richtig in der Arbeit, so sauste blitzschnell ihr Lederpantoffel den armen S\xfcnder auf den Buckel.<br>Doch heutzutage noch k\xf6nnte sie stolz auf das Resultat ihrer Erziehung sein, denn sie hat uns alle zu rechtschaffenen Menschen erzogen.<br>Hierbei steht noch folgender Vorfall recht lebhaft vor meinen Augen:<br>Es naht wieder einmal die Kirmes und zum Kuchenbacken wird Hefe ben\xf6tigt. Mit den n\xf6tigen Gef\xe4\xdfen in einem Tragekorbe wird Otto und Richtung Brauerei Staucha in Bewegung gesetzt, mit der Ermahnung alles richtig zu besorgen und bald wiederzukommen. Alles wird prompt erledigt und schon soll der Heimweg angetreten werden, den Gro\xdfmutter und Tante bis zu ihrem Feldegrundst\xfcck, das am Heimwege lag, als ich eine Einladung f\xfcr Verwandte meiner v\xe4terlichen Gro\xdfeltern vergessen habe. Nochmals Gang ins Oberdorf und hier treffe ich meinen Lieben G\xfcnsel, Franz, der mich zum Fischen an den Sch\xe4ferteich lotste. Es vergeht dabei eine Stunde nach der anderen und kein Otto l\xe4sst sich sehen, bisher freudestrahlend mit einem sch\xf6nen Karpfen angewetzt kommt. Leider sind Gro\xdfmutter und Tante bereits nach dem Felde abmarschiert und haben bereits meinen Hefekorb mitgenommen in der Hoffnung, dass ich bald nachkommen w\xfcrde. Schnell wird ein alter Topf mit Wasser f\xfcr meinen Karpfen besorgt und die Reise beginnt, nicht ahnend, dass sie so kl\xe4glich enden sollte. Auf halben Wege erfolgte der Zusammensto\xdf. Als ich ihnen freudestrahlend meinen Topf mit den Karpfen entgegenhielt, brach das Gewitter los: du L\xfcgner, Spitzbube, Taugenichts und andere Kosenamen fliegen mir an meinen unschuldigen Kopf, begleitet von Kopfn\xfcssen, Ohrenziehen und hieben mit dem Gabelstiel und Meuchlings wird mein sch\xf6ner Karpfen mit der Mistgabel ermordet. Aber meinen lieben Karpfen lie\xdf sich nicht im Stich, sondern gerade sollte er doch noch einen sch\xf6nen Kirmesbraten bilden und fand einstweilen zu Hause ein sicheres Versteck. Mit schweren Herzen trug ich am anderen Tage die erste Kostprobe des wohlgeratenen Kirmeskuchens nach Staucha, Wo ich mit schweren Herzen, die sonst so Liebe und vertraute Stube meiner Gro\xdfeltern mit klopfendem Herzen betrat, da ich erneut mit Vorw\xfcrfen auf meine frevelhafte Mi\xdftat empfangen wurde. Beim Abschied erhielt ich einen Brief an unsere Mutter, mit der Ermahnung, ihn ja ihr auszuh\xe4ndigen, in welchen in den schw\xe4rzesten Farben meine edle Tat geschildert wurde. Ein richtiges Pensum galt auch hier als ausreichende S\xfchne. Doch die Aufkl\xe4rung sollte nicht lange auf sich warten lassen, denn mein lieber G\xfcnsel, Franz hatte noch am gleichen Tag meiner Gro\xdfmutter und Tante beschworen, dass wir unsere Karpfen - er hat ja auch einen solchen mit nach Hause gebracht - nicht geklaut, sondern vom Inspektor des Rittergutes geschenkt erhalten hatten. Am Tage der Kirmes, als Tante Rese erschien, war allseitige Freude dar\xfcber, und der Karpfen kommt doch noch zu seinem rechten und hat allen wohlgeschmeckt.<br>So vergingen die Jahre f\xfcr mich nur gar zu schnell. Viele liebe Erinnerungen auch anderer Art sind in meinem Ged\xe4chtnis haften geblieben, \xfcber die ich mich heute noch wundere und freue.<br>An meinem 14. Geburtstage, am Sonntag Palmarum1893 wurde ich in der Kirche zu Zschochau konfirmiert. Mit dieser feierlichen Handlung war meine sch\xf6ne, erfolgreiche Schulzeit beendet, ein weiteres Blatt meiner Lebensgeschichte hat sich gewendet, ein neuer Abschnitt begann."'
            }
        ]
    };
    return biography[member];
};
var $d110d5d3929fb6a5$export$2e2bcd8739ae039 = $d110d5d3929fb6a5$var$getDataBiography;









const $b46b669b41923313$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)(()=>({
        timeline: {
            flexGrow: '0!important',
            width: '100%',
            height: 'auto',
            overflowX: 'hidden'
        }
    }));
const $b46b669b41923313$var$BackButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
        sx: {
            margin: 0,
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'flex-end'
        },
        onClick: onClick,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4be88c6641a5d35$exports))), {})
    });
const $b46b669b41923313$var$Biography = ()=>{
    const bookmark = window.localStorage.getItem('bookmarkOttoMeissner');
    const history = (0, $4e1a33337564f167$export$3420e1dc2c4a518c)();
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const classes = $b46b669b41923313$var$useStyles();
    const { t: t } = (0, $ead5e217b39556c6$export$9fc83ad70ead8663)();
    const theme = (0, $76d75229d7c83be5$export$5886efcb490847cc)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const biography = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$a948215c3728951f));
    const data = biography ? (0, $d110d5d3929fb6a5$export$2e2bcd8739ae039)(biography) : undefined;
    const [yearIndex, setYearIndex] = (0, $3OyDL.useState)();
    const handleScroll = ()=>{
        window.localStorage.setItem('bookmarkOttoMeissner', window.scrollY.toString());
    };
    (0, $3OyDL.useEffect)(()=>{
        if (bookmark) window.scrollTo({
            top: parseInt(bookmark, 10),
            behavior: 'smooth'
        });
        window.addEventListener('scroll', handleScroll);
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
        };
    }, [
        bookmark
    ]);
    const handleBackToHome = ()=>{
        window.removeEventListener('scroll', handleScroll);
        history.replace('/');
        dispatch($7173820326fb9f6c$export$8f827b63222d82c5([]));
    };
    const renderContent = (index)=>{
        const element = data?.[index];
        if (!element) return null;
        return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                element.title && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    variant: "subtitle1",
                    sx: {
                        marginTop: 0
                    },
                    children: element.title
                }),
                element.description && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    variant: "body1",
                    sx: {
                        marginTop: 0,
                        fontStyle: 'italic'
                    },
                    dangerouslySetInnerHTML: {
                        __html: (0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize(element.description)
                    }
                }),
                element.image && /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                    src: element.image,
                    alt: element.title || 'Biography image',
                    style: {
                        width: '100%',
                        height: 'auto'
                    }
                }),
                !downSm && /*#__PURE__*/ (0, $2M70Q.jsx)($b46b669b41923313$var$BackButton, {
                    onClick: handleBackToHome
                })
            ]
        });
    };
    const renderTimelineView = ()=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                        variant: "h1",
                        children: t(`labels:${biography}`)
                    })
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e559194eb7cbbba6$export$2e2bcd8739ae039), {
                    position: "right",
                    className: classes.timeline,
                    sx: {
                        padding: 0,
                        [`& .${(0, $eff8a72081c42e6d$export$2e2bcd8739ae039).root}:before`]: {
                            flex: 0,
                            padding: 0
                        }
                    },
                    children: data?.map((element, index)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $7aaee05def34269d$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $292c6b13e3b71ec0$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $5bbc5e33333b8ab4$export$2e2bcd8739ae039), {
                                            onClick: ()=>downSm && setYearIndex(index),
                                            color: "primary",
                                            variant: "outlined",
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b923b35411141fb9$export$2e2bcd8739ae039), {
                                                year: element.date.year,
                                                month: element.date.month,
                                                day: element.date.day,
                                                active: false
                                            })
                                        }),
                                        index < data.length - 1 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8f50fc4ee7fe8ffc$export$2e2bcd8739ae039), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $134d667c4e8a499c$export$2e2bcd8739ae039), {
                                    children: downSm ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        sx: {
                                            minHeight: '70px',
                                            cursor: 'pointer'
                                        },
                                        onClick: ()=>setYearIndex(index),
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "body1",
                                            sx: {
                                                marginTop: '12px'
                                            },
                                            children: element.title
                                        })
                                    }) : renderContent(index)
                                })
                            ]
                        }, index))
                })
            ]
        });
    const renderDetailView = ()=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)($b46b669b41923313$var$BackButton, {
                    onClick: ()=>setYearIndex(undefined)
                }),
                yearIndex !== undefined && renderContent(yearIndex),
                /*#__PURE__*/ (0, $2M70Q.jsx)($b46b669b41923313$var$BackButton, {
                    onClick: ()=>setYearIndex(undefined)
                })
            ]
        });
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: typeof yearIndex === 'number' ? renderDetailView() : renderTimelineView()
    });
};
var $b46b669b41923313$export$2e2bcd8739ae039 = $b46b669b41923313$var$Biography;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");




var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");





const $00ae4bfadb56f2f5$var$getDataGeography = (place)=>{
    const geography = {
        leipzig: [
            "Leipzig war aufgrund eines kurf\xfcrstlichen Privilegs von der Stationierung von Truppen befreit. Nur in der Plei\xdfenburg gab es eine kleine Schlosswache und ab 1830 eine kleine k\xf6nigliche Garnison. Leipzig wollte die Plei\xdfenburg, die nicht Eigentum der Stadt war, aus verkehrstechnischen und hygienischen Gr\xfcnden abrei\xdfen. Daher gab es ab Mitte der 1860er Jahre immer wieder Streit wegen der Plei\xdfenburg zwischen der Stadt und dem s\xe4chsischen Kriegsminister Alfred von Fabrice.<br />Nach Einweihung der Kaserne M\xf6ckern ging allm\xe4hlich die jahrhundertelange milit\xe4rische Nutzung der Plei\xdfenburg zu Ende. Die Stadt Leipzig erwarb sie 1895 vom K\xf6nigreich Sachsen, riss sie ab 1897 ab und errichtete auf dem Grundst\xfcck zwischen 1899 und 1905 ihr neues Rathaus unter Leitung von Hugo Licht. Voraussetzung f\xfcr den Burgenkauf war der Bau einer Kaserne f\xfcr das Infanterieregiment 107.<br />Zuvor hatte das K\xf6niglich-S\xe4chsische Kriegsministerium in den fr\xfchen 1870er Jahren f\xfcr den ersten Kasernenbau einen sanft abfallenden H\xf6henr\xfccken an der Stra\xdfe nach Halle (Saale) zwischen M\xf6ckern und Gohlis ausgew\xe4hlt. Diese Entscheidung wurde Ausgangspunkt f\xfcr weitere Kasernenansiedlungen in Gohlis. Gohlis wurde 1890 und M\xf6ckern 1910 nach Leipzig eingemeindet.<br />",
            "In Leipzig stand ab 1869 das Kommando der 24. (2. K\xf6niglich S\xe4chsischen) Division des deutschen Heeres. In M\xf6ckern (ab 1875) und Gohlis (ab 1883) wurde bis 1914 der damals zweitgr\xf6\xdfte Kasernenkomplex  Sachsens errichtet.<br />Als 1875 eine Kaserne f\xfcr das Infanterieregiment 106 gebaut werden sollte, bestimmte Fabrice gegen alle Vorschl\xe4ge der Stadtverwaltung Leipzig das Dorf M\xf6ckern zum Standort \u2013 fernab jeglicher Infrastruktur. Dieser Bau wurde Grundlage daf\xfcr, dass alle weiteren milit\xe4rischen Bauten im Norden von Leipzig entstanden.<br />1880 wurde eine Barackenkaserne f\xfcr das Infanterieregiment 134 auf dem Exerzierplatz Gohlis errichtet. Dieser \u201EExer\u201C lag auf Leipziger Gebiet etwa zwischen dem Chausseehaus, dem Nordplatz, dem Kickerlingsberg und der Ehrensteinstra\xdfe.<br />Ab 1895 begann der Bau eines Kasernenkomplexes entlang der heutigen Olbrichtstra\xdfe. Diese im Verlaufe des Kasernenbaus angelegte Stra\xdfe geh\xf6rt zu Gohlis, die westlich angrenzenden Kasernen zu M\xf6ckern. Da der Ortskern M\xf6ckern nicht allzu nah an den Kasernen lag und der Weg \xfcber die Landsberger Stra\xdfe f\xfchrte, wurden die Kasernen f\xe4lschlicherweise als Gohliser Kasernen bezeichnet.<br />Von 1895 bis 1897 entstanden auf Kosten der Stadt (teilweise verrechnet mit der Summe von 2,5 Millionen Mark, die Leipzig mit dem K\xf6nigreich Sachsen als Kaufpreis f\xfcr die Plei\xdfenburg ausgehandelt hatte): <ul>  <li>die Kaserne des Infanterieregiments 107 (Prinz Johann Georg Kaserne, Olbrichtstra\xdfe / Ecke Liebermannstra\xdfe), </li>  <li>die Kaserne des Ulanenregiments 18 (K\xf6nig-Albert-Kaserne, Olbrichtstra\xdfe / Landsberger Stra\xdfe), </li>  <li>das Divisionsgericht mit Milit\xe4rgef\xe4ngnis (s\xfcdliche Olbrichtstra\xdfe / Ecke Liebermannstra\xdfe), </li>  <li>die Garnisonsverwaltung und</li>  <li>das Proviantamt.</li>  <li>Die Kaserne des Trainbataillons 19 (Werk Motor) folgte um die Jahrhundertwende.</li></ul>Auch entstanden die ersten Milit\xe4rbauten auf Gohliser Flur:<ul>  <li>die Kaserne f\xfcr das Artillerieregiment 77 am Viertelsweg,</li>  <li>das Bekleidungsamt an der Heerstra\xdfe (Olbrichtstra\xdfe) und</li>  <li>das Artilleriedepot an der Heerstra\xdfe (Olbrichtstra\xdfe).</li></ul>"
        ],
        niederstaucha: [
            "Niederstaucha ist ein kleines und malerisches Dorf im Landkreis Mei\xdfen im Bundesland Sachsen, Deutschland. Die Geschichte von Niederstaucha reicht weit zur\xfcck und ist eng mit der Entwicklung der Region und ihrer landwirtschaftlichen Traditionen verkn\xfcpft. Die erste urkundliche Erw\xe4hnung von Niederstaucha datiert aus dem Jahr 1350, aber es wird angenommen, dass die Wurzeln des Dorfes noch weiter zur\xfcckreichen. In seiner fr\xfchen Geschichte geh\xf6rte Niederstaucha zur Grundherrschaft der Ritter von Staucha, die f\xfcr die Verwaltung des Dorfes verantwortlich waren.<br />W\xe4hrend der Jahrhunderte durchlebte Niederstaucha verschiedene historische Epochen, darunter die Reformation im 16. Jahrhundert und die Zerst\xf6rungen des Drei\xdfigj\xe4hrigen Krieges im 17. Jahrhundert. Im 19. Jahrhundert, nach den Napoleonischen Kriegen, wurde Niederstaucha Teil des K\xf6nigreichs Sachsen und sp\xe4ter des Deutschen Kaiserreichs.<br />Die landwirtschaftliche Tradition von Niederstaucha war immer von gro\xdfer Bedeutung. Die fruchtbaren B\xf6den in der Umgebung des Dorfes erm\xf6glichten den Anbau von Getreide, Gem\xfcse und Obst, und die Tierhaltung war ebenfalls ein wichtiger Wirtschaftszweig. Die traditionellen Bauernh\xf6fe und Fachwerkh\xe4user pr\xe4gen noch heute das Erscheinungsbild des Dorfes.<br />Eine bedeutende Ver\xe4nderung in der Geschichte von Niederstaucha ereignete sich im 20. Jahrhundert, als Sachsen Teil der Deutschen Demokratischen Republik (DDR) wurde. W\xe4hrend dieser Zeit fand eine Kollektivierung der Landwirtschaft statt, die die Struktur der landwirtschaftlichen Betriebe ver\xe4nderte.<br />Mit der Wiedervereinigung Deutschlands im Jahr 1990 und dem Ende der DDR kehrte Niederstaucha zu einer marktwirtschaftlichen Wirtschaftsordnung zur\xfcck. Heute ist das Dorf Teil eines l\xe4ndlichen Gebiets im Landkreis Mei\xdfen und dient sowohl als Wohnort f\xfcr die Einheimischen als auch als Ziel f\xfcr Besucher, die die idyllische Landschaft und die historische Atmosph\xe4re erleben m\xf6chten. ",
            "Nur noch selten sieht man in Sachsen ein so geschlossenes und gut restauriertes Rittergut. Die Gemeinde hat vor ihrem Einzug im Jahre 2001 das Rittergut Staucha mit Herrenhaus, Gesindehaus, Kuhstall, Scheune und Nebengeb\xe4uden in vier Jahren umfassend sanieren lassen. Entstanden ist eines der sch\xf6nsten Ensemble s\xe4chsischer Baukunst. Im Erdgeschoss des Herrenhauses ist eine liebevoll eingerichtete Heimatstube zu bewundern. Der Saal neben der Eingangshalle bietet Platz f\xfcr die Gemeinderatssitzungen und kleine Veranstaltungen.<br />Eine Besonderheit stellt die Markthalle dar: Sie ist 1999 im ehemaligen Kuhstall er\xf6ffnet worden. Die Besucher k\xf6nnen nun ihre frischen Lebensmittel zwischen toskanischen S\xe4ulen erwerben oder einfach den Kunsthandwerkern bei der Arbeit zusehen. Daneben hat sich eine weitere Besonderheit eingerichtet: Die Peter-Sodann-Bibliothek. Nach der politischen Wende in der DDR begann der aus Mei\xdfen stammende Schauspieler, Regisseur und ehemalige Theaterintendant B\xfccher, die in der DDR gedruckt wurden, zu sammeln und sie so vor der Vernichtung zu retten. Eine gro\xdfe Anzahl von B\xfcchern umfa\xdft die Sammlung von Literatur, die zwischen dem 8. Mai 1945 und dem 3. Oktober 1990 erschienen sind. Im Rittergut haben sie eine neue Heimat gefunden. Im Antiquariat gibt es B\xfccher zu kaufen, die mehrfach vorhanden sind oder nicht zum Sammlungsgebiet geh\xf6ren. Hierdurch finanziert sich ein Teil der Bibliothek selbst. Die B\xfcchersammlung kann zu den \xd6ffnungszeiten besichtigt werden.<br />Wenngleich der Verkauf von Lebensmitteln und B\xfcchern wie selbstverst\xe4ndlich erscheint, geht dem heutigen Gemeindezentrum doch eine lange Geschichte voraus. Das Rittergut entstand aus einem mittelalterlichen Klosterhof. Burggraf Meinher II. von Mei\xdfen hatte bereits 1223 in Staucha ein Benediktinerinnenkloster gegr\xfcndet. Die Nonnen zogen 1344 nach D\xf6beln um, unterhielten aber weiterhin einen gro\xdfen Wirtschaftshof in Staucha, aus dem nach der Aufl\xf6sung des Klosters das Rittergut Oberstaucha hervorging. Dieses wurde 1731 mit dem im gleichen Ort gelegenen Rittergut Niederstaucha vereinigt. ",
            'Im 18. Jahrhundert beginnt auch die Geschichte des Herrenhauses. Julius Alexander von Hartitzsch lie\xdf in den Jahren 1753 bis 1756 f\xfcr sich und seine zweite Ehefrau Magdalena Elisabeth von Zehmen das zweigeschossige Bauwerk errichten. Von einer etwas erh\xf6ht gelegenen schmalen Gartenterrasse, auf der das Geb\xe4ude steht, konnte der Herr den niedriger gelegenen Rittergutshof \xfcberblicken. Der stattliche Bau eines typischen barocken Landschlosses des 18. Jahrhunderts besitzt eine mit 11 Fenstern ausgestattete Front und ein Mansarddach. Die Fenster sind von schlichten Sandsteingew\xe4nden umrahmt. Die barocke Architekturgliederung mit hellen Wandspiegeln unter den Fenstern und Wandstreifen am Mittelrisalit sowie an den Hausecken ist aufgemalt. Eine zweil\xe4ufige Freitreppe mit kr\xe4ftigen Steinbr\xfcstungen f\xfchrt vom Hof zum Podest vor dem Eingangsportal. Das Tor ist hervorgehoben durch ein Gew\xe4ndeprofil und eine barock geschweifte Verdachung aus Sandstein. Darunter befindet sich das Ehewappen derer von Hartitzsch. Auf gr\xfcnem Grund ist in goldener Schrift zu lesen: "J. A. V. H. | Anno MDCCLIII | M. E. V. H. G. V. Z.". Im Innern des Hauses empf\xe4ngt den Besucher eine mit zwei Pfeilern untergliederte Halle. Dahinter erschlie\xdft eine dreiteilige Treppen die R\xe4ume im Obergeschoss.<br />Der vor dem Herrenhaus liegende Rittergutshof ist vollst\xe4ndig von Geb\xe4uden umrahmt. 1822 brach in der Scheune des Gutes ein Feuer aus, das alle Wirtschaftsgeb\xe4ude vernichtete. Doch Domherr Georg Heinrich von Hartitzsch lie\xdf die Hofgeb\xe4ude bereits im folgenden Jahr wieder neu errichten. Nach dem Zweiten Weltkrieg nahm das Herrenhaus zun\xe4chst Fl\xfcchtlinge auf. Im Erdgeschoss waren die LPG-K\xfcche mit Speiseraum und ein Kindergarten eingerichtet. Dann stand das Haus leer. Erst mit der umfassenden Sanierung in den Jahren 1997 bis 2001 konnte wieder neues Leben in die alten Gem\xe4uer einziehen. ',
            "Staucha im Landkreis Mei\xdfen, das heute als ein Ort des friedlichen Lebens und der nat\xfcrlichen Sch\xf6nheit bekannt ist. Diese idyllische Gemeinde hat sich im Laufe der Zeit zu einem ruhigen Zufluchtsort f\xfcr Einheimische und Besucher entwickelt und bietet eine Mischung aus historischer Erinnerung und modernem l\xe4ndlichem Leben.<br />Das Dorf Staucha zeichnet sich durch seine traditionelle s\xe4chsische Architektur aus. Historische Fachwerkh\xe4user, gem\xfctliche Bauernh\xf6fe und die St.-Nicolai-Kirche, die bereits seit dem 14. Jahrhundert \xfcber dem Dorf thront, sind stolze Symbole der Vergangenheit. Dieses architektonische Erbe wird von den Einwohnern liebevoll gepflegt und tr\xe4gt dazu bei, die historische Atmosph\xe4re des Dorfes zu bewahren.<br />Staucha ist auch von einer zauberhaften Landschaft umgeben. Die sanften H\xfcgel, W\xe4lder und Felder laden Naturliebhaber und Wanderer dazu ein, die malerische Umgebung zu erkunden. In dieser l\xe4ndlichen Umgebung kann man sich wunderbar erholen und die Ruhe der Natur genie\xdfen.<br />Die Gemeinschaft in Staucha ist stark und hegt einen starken Zusammenhalt. Die Bewohner sch\xe4tzen ihre Traditionen und pflegen enge soziale Bindungen. Feste und Veranstaltungen in Staucha sind eine Gelegenheit f\xfcr die Dorfbewohner, zusammenzukommen, zu feiern und die Gemeinschaft zu st\xe4rken.<br />Die Lebensqualit\xe4t in Staucha ist hoch, und die Dorfbewohner sch\xe4tzen die Ruhe und die N\xe4he zur Natur. Gleichzeitig sind die St\xe4dte Mei\xdfen und Dresden in gut erreichbarer N\xe4he, was den Bewohnern Zugang zu kulturellen und wirtschaftlichen M\xf6glichkeiten bietet.<br />Insgesamt ist Staucha heute ein wunderbarer Ort, der die Balance zwischen seiner historischen Bedeutung und den Bed\xfcrfnissen des modernen Lebens gefunden hat. Das Dorf bietet seinen Bewohnern und Besuchern eine ruhige und charmante Umgebung, die von Kultur und Natur gleicherma\xdfen gepr\xe4gt ist. Staucha ist ein Ort, an dem die Zeit scheinbar langsamer verl\xe4uft und die Sch\xf6nheit von Sachsen in ihrer reinsten Form genossen werden kann."
        ]
    };
    return geography[place];
};
var $00ae4bfadb56f2f5$export$2e2bcd8739ae039 = $00ae4bfadb56f2f5$var$getDataGeography;


const $269f1987d94f6cab$var$Niederstaucha = ()=>{
    const theme = (0, $76d75229d7c83be5$export$5886efcb490847cc)();
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "h1",
                children: "Niederstaucha"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                children: "Geschichte"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downMd ? 12 : 8,
                        sx: {
                            display: 'flex',
                            alignItems: 'center'
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            dangerouslySetInnerHTML: {
                                __html: `${(0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize((0, $00ae4bfadb56f2f5$export$2e2bcd8739ae039)('niederstaucha')[0])}`
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downMd ? 12 : 4,
                        sx: {
                            display: 'flex',
                            alignItems: 'center'
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                            src: "/images/niederstaucha-siegel.webp",
                            style: {
                                width: '100%'
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                children: "Rittergut Niederstaucha"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        container: true,
                        xs: downMd ? 12 : 4,
                        sx: {
                            display: 'flex',
                            alignItems: 'flex-start'
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                            src: "/images/niederstaucha-schloss.jpg",
                            style: {
                                width: '100%'
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downMd ? 12 : 8,
                        sx: {
                            display: 'flex',
                            alignItems: 'flex-start'
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            dangerouslySetInnerHTML: {
                                __html: `${(0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize((0, $00ae4bfadb56f2f5$export$2e2bcd8739ae039)('niederstaucha')[1])}`
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            dangerouslySetInnerHTML: {
                                __html: `${(0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize((0, $00ae4bfadb56f2f5$export$2e2bcd8739ae039)('niederstaucha')[2])}`
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                children: "Staucha heute"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downMd ? 12 : 8,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            dangerouslySetInnerHTML: {
                                __html: `${(0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize((0, $00ae4bfadb56f2f5$export$2e2bcd8739ae039)('niederstaucha')[3])}`
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        container: true,
                        xs: downMd ? 12 : 4,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                            src: "/images/staucha-schloss.jpg",
                            style: {
                                width: '100%',
                                height: 'fit-content'
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                sx: {
                    marginTop: '20px'
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7801af78bc29c2a9$export$2e2bcd8739ae039), {
                    mapZoom: 12,
                    label: [
                        'Staucha'
                    ],
                    positions: [
                        new (0, $ad5a22b7e45eeb01$exports.LatLng)(51.221710, 13.219993)
                    ]
                })
            })
        ]
    });
};
var $269f1987d94f6cab$export$2e2bcd8739ae039 = $269f1987d94f6cab$var$Niederstaucha;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");




const $90c287cf5787b11e$var$Leipzig = ()=>{
    const theme = (0, $76d75229d7c83be5$export$5886efcb490847cc)();
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "h1",
                children: "Garnison Leipzig"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                children: "Vorgeschichte"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downMd ? 12 : 8,
                        sx: {
                            display: 'flex',
                            alignItems: 'flex-start'
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            dangerouslySetInnerHTML: {
                                __html: `${(0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize((0, $00ae4bfadb56f2f5$export$2e2bcd8739ae039)('leipzig')[0])}`
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        container: true,
                        xs: downMd ? 12 : 4,
                        sx: {
                            display: 'flex',
                            alignItems: 'flex-start'
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                    src: "/images/plei\xdfenburg1780.jpg",
                                    style: {
                                        width: '100%'
                                    }
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    children: "Hauer, Daniel Adam: Das Schlo\xdf oder Castell zu Leipzig, die Plei\xdfenburg genannt"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                children: "Geschichte"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downMd ? 12 : 8,
                        sx: {
                            display: 'flex',
                            alignItems: 'flex-start'
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            dangerouslySetInnerHTML: {
                                __html: `${(0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize((0, $00ae4bfadb56f2f5$export$2e2bcd8739ae039)('leipzig')[1])}`
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        container: true,
                        xs: downMd ? 12 : 4,
                        sx: {
                            display: 'flex',
                            alignItems: 'flex-start'
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                    src: "/images/Leipzig1911.jpg",
                                    style: {
                                        width: '100%'
                                    }
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    children: "Br\xfcck & Sohn Kunstverlag Mei\xdfen"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                sx: {
                    marginTop: '20px'
                },
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                        src: "/images/garnisionskarteLeipzig.jpg",
                        style: {
                            width: '100%'
                        }
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Stadtgeschichtliches Museum Leipzig Haus B\xf6ttcherg\xe4\xdfchen"
                    })
                ]
            })
        ]
    });
};
var $90c287cf5787b11e$export$2e2bcd8739ae039 = $90c287cf5787b11e$var$Leipzig;


const $33d18e2f0d017bdf$var$Geography = ()=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const geography = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$7e51fdd8c00191b1));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: [
            geography === 'niederstaucha' && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $269f1987d94f6cab$export$2e2bcd8739ae039), {}),
            geography === 'leipzig' && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c287cf5787b11e$export$2e2bcd8739ae039), {})
        ]
    });
};
var $33d18e2f0d017bdf$export$2e2bcd8739ae039 = $33d18e2f0d017bdf$var$Geography;






var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");










var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");


var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");

var $g4LX8 = parcelRequire("g4LX8");


var $jFgmT = parcelRequire("jFgmT");

var $jH1k7 = parcelRequire("jH1k7");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $0937ac4a51dd1343$export$39f6debbec19b3ba(slot) {
    return (0, $6AMoU.default)('MuiSwitch', slot);
}
const $0937ac4a51dd1343$var$switchClasses = (0, $ithJf.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $0937ac4a51dd1343$export$2e2bcd8739ae039 = $0937ac4a51dd1343$var$switchClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $383cd6dd535ed169$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $383cd6dd535ed169$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $g4LX8.default)(edge)}`,
            `size${(0, $g4LX8.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $g4LX8.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $5jsOu.default)(slots, (0, $0937ac4a51dd1343$export$39f6debbec19b3ba), classes);
    return (0, $gOPoC.default)({}, classes, composedClasses);
};
const $383cd6dd535ed169$var$SwitchRoot = (0, $jH1k7.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $g4LX8.default)(ownerState.edge)}`],
            styles[`size${(0, $g4LX8.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $gOPoC.default)({
        display: 'inline-flex',
        width: 58,
        height: 38,
        overflow: 'hidden',
        padding: 12,
        boxSizing: 'border-box',
        position: 'relative',
        flexShrink: 0,
        zIndex: 0,
        // Reset the stacking context.
        verticalAlign: 'middle',
        // For correct alignment with the text.
        '@media print': {
            colorAdjust: 'exact'
        }
    }, ownerState.edge === 'start' && {
        marginLeft: -8
    }, ownerState.edge === 'end' && {
        marginRight: -8
    }, ownerState.size === 'small' && {
        width: 40,
        height: 24,
        padding: 7,
        [`& .${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).thumb}`]: {
            width: 16,
            height: 16
        },
        [`& .${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).switchBase}`]: {
            padding: 4,
            [`&.${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).checked}`]: {
                transform: 'translateX(16px)'
            }
        }
    }));
const $383cd6dd535ed169$var$SwitchSwitchBase = (0, $jH1k7.default)((0, $02423c2e2951683c$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $g4LX8.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).checked} + .${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).disabled} + .${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main,
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7m2iU.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            [`&.${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).disabled}`]: {
                color: theme.vars ? theme.vars.palette.Switch[`${ownerState.color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $7m2iU.lighten)(theme.palette[ownerState.color].main, 0.62) : (0, $7m2iU.darken)(theme.palette[ownerState.color].main, 0.55)}`
            }
        },
        [`&.${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).checked} + .${(0, $0937ac4a51dd1343$export$2e2bcd8739ae039).track}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main
        }
    }));
const $383cd6dd535ed169$var$SwitchTrack = (0, $jH1k7.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    }));
const $383cd6dd535ed169$var$SwitchThumb = (0, $jH1k7.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    }));
const $383cd6dd535ed169$var$Switch = /*#__PURE__*/ $3OyDL.forwardRef(function Switch(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx } = props, other = (0, $aBenZ.default)(props, $383cd6dd535ed169$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $383cd6dd535ed169$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $2M70Q.jsx)($383cd6dd535ed169$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($383cd6dd535ed169$var$SwitchRoot, {
        className: (0, $3DmQB.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)($383cd6dd535ed169$var$SwitchSwitchBase, (0, $gOPoC.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $gOPoC.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $2M70Q.jsx)($383cd6dd535ed169$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $383cd6dd535ed169$export$2e2bcd8739ae039 = $383cd6dd535ed169$var$Switch;



const $c905eea6eb707641$var$SwitchComponent = (props)=>{
    const [value, setValue] = (0, $3OyDL.useState)(props.value || false);
    const disabled = props.disabled || false;
    (0, $3OyDL.useEffect)(()=>{
        setValue(props.value || false);
    }, [
        props.value
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $42a2fa0c87210680$export$2e2bcd8739ae039), {
        control: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $383cd6dd535ed169$export$2e2bcd8739ae039), {
            ...props,
            disabled: disabled,
            checked: value,
            onChange: (event)=>props.onChange && props.onChange(event.target.checked)
        }),
        label: props.label || ''
    });
};
var $c905eea6eb707641$export$2e2bcd8739ae039 = $c905eea6eb707641$var$SwitchComponent;











var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");









const $b3c952adb5d7d752$var$ResetPassword = (props)=>{
    const history = (0, $4e1a33337564f167$export$3420e1dc2c4a518c)();
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const user = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$7cbf767827cd68ba));
    const [oldPassword, setOldPassword] = (0, $3OyDL.useState)();
    const [newPassword, setNewPassword] = (0, $3OyDL.useState)();
    const [confirmPassword, setConfirmPassword] = (0, $3OyDL.useState)();
    const [showHint, setShowHint] = (0, $3OyDL.useState)(false);
    const [showDialog, setShowDialog] = (0, $3OyDL.useState)(props.showDialog);
    (0, $3OyDL.useEffect)(()=>{
        setShowDialog(props.showDialog);
    }, [
        props.showDialog
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $ee30f4276828974b$export$2e2bcd8739ae039), {
        open: showDialog,
        onClose: ()=>props.setShowDialog(false),
        sx: {
            '& .MuiDialog-paper': {
                borderRadius: 0,
                minWidth: '400px',
                maxWidth: '600px'
            }
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                sx: {
                    p: 3
                },
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                        direction: "row",
                        spacing: 3,
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $286e44e498de27a0$export$2e2bcd8739ae039), {
                            sx: {
                                fontWeight: 600,
                                p: 0,
                                fontSize: '16px',
                                marginBottom: '20px'
                            },
                            children: "Passwort \xe4ndern"
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $b9097f1d6e2a4efc$export$2e2bcd8739ae039), {
                        sx: {
                            p: 0,
                            overflow: 'visible'
                        },
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: [
                                    "Bitte gib nachfolgend dein neues Passwort ein und wiederhole es.",
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                                    "Dein neues Passwort muss:"
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                                        children: "mindestens aus 8 Zeichen bestehen,"
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                                        children: "mindestens einen Buchstaben enthalten,"
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                                        children: "mindestens eine Zahl enthalten"
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                                        children: "und mindestens ein Sonderzeichen (@$!%*#?&) enthalten."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    width: '300px'
                                },
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                    size: "small",
                                    type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).password,
                                    label: "Altes Passwort",
                                    value: oldPassword,
                                    required: true,
                                    onChange: (value)=>setOldPassword(value)
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    width: '300px'
                                },
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                    helperText: "Das Passwort entspricht nicht den Richtlinien!",
                                    showError: showHint,
                                    size: "small",
                                    type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).password,
                                    label: "Neues Passwort",
                                    value: newPassword,
                                    required: true,
                                    onChange: (value)=>{
                                        setShowHint(false);
                                        setNewPassword(value);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    width: '300px'
                                },
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                    helperText: "Das wiederholte Passwort stimmt nicht \xfcberein.",
                                    showError: !!(newPassword && newPassword !== confirmPassword),
                                    size: "small",
                                    type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).password,
                                    label: "Neues Password wiederholen",
                                    value: confirmPassword,
                                    required: true,
                                    onChange: (value)=>setConfirmPassword(value)
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $08e4970efe955928$export$2e2bcd8739ae039), {
                sx: {
                    p: 3
                },
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                        color: "primary",
                        variant: "text",
                        text: "Abbrechen",
                        onClick: ()=>{
                            props.setShowDialog(false);
                        }
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                        size: "medium",
                        fullWidth: true,
                        disabled: !newPassword || !confirmPassword || newPassword !== confirmPassword,
                        text: "Passwort \xe4ndern",
                        variant: "text",
                        onClick: ()=>{
                            // checkPassword
                            if (newPassword?.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/) && user) {
                                setShowHint(false);
                                const fetchHeaders = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).fetchHeaders;
                                const basePath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
                                const restUrl = `${basePath}/api/user/${user.userId}/changePassword`;
                                fetch(restUrl, {
                                    method: 'PUT',
                                    credentials: 'include',
                                    headers: fetchHeaders,
                                    body: JSON.stringify({
                                        userId: user.userId,
                                        oldPassword: oldPassword,
                                        newPassword: newPassword
                                    })
                                }).then((res)=>{
                                    (0, $7173820326fb9f6c$export$706cdae1b5419ef8)({
                                        message: "Passwort wurde ge\xe4ndert",
                                        severity: (0, $c7fa01100a96d1f7$export$918a9776c0a3cf27).success
                                    });
                                    setNewPassword(undefined);
                                    setConfirmPassword(undefined);
                                    const restUrl = `${basePath}/api/session/logout`;
                                    fetch(restUrl, {
                                        method: 'POST',
                                        credentials: 'include',
                                        headers: fetchHeaders
                                    }).then(()=>{
                                        history.push('/login');
                                        dispatch((0, $7173820326fb9f6c$export$8b6bb3dd62a01be2)(undefined));
                                    }).catch((err)=>console.log(err));
                                }).catch(()=>{
                                    (0, $7173820326fb9f6c$export$706cdae1b5419ef8)({
                                        message: 'Ein unerwarteter Fehler. Bitte erneut versuchen.',
                                        severity: (0, $c7fa01100a96d1f7$export$918a9776c0a3cf27).error
                                    });
                                });
                            } else setShowHint(true);
                        }
                    })
                ]
            })
        ]
    });
};
var $b3c952adb5d7d752$export$2e2bcd8739ae039 = $b3c952adb5d7d752$var$ResetPassword;



const $742cedbf5d25d362$var$UserProfile = ()=>{
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const darkMode = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$3813fceac631a2fa));
    const basePath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
    const fetchHeaders = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).fetchHeaders;
    (0, $58718165e7ed8d4a$export$bacd26fe3052ded6)(fetchHeaders);
    const storedActiveMember = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$367314d85393c4e));
    const [activeMember, setActiveMember] = (0, $3OyDL.useState)(storedActiveMember);
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState('stammdaten');
    const [showChangePasswordDialog, setShowChangePasswordDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const setMembers = (data)=>{
        dispatch($5993246da723f2dd$export$3e5f62cfeebace10({
            count: data.count,
            results: data.results
        }));
    };
    const handleChange = (panel)=>(event, newExpanded)=>{
            setExpanded(newExpanded ? panel : false);
        };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $19e56772b842faf0$export$2e2bcd8739ae039), {
                        sx: {
                            margin: '0px!important',
                            borderBottom: `1px solid ${theme.palette.grey.A400}`
                        },
                        TransitionProps: {
                            unmountOnExit: true
                        },
                        expanded: expanded === 'stammdaten',
                        onChange: handleChange('stammdaten'),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7ba21131579dfa21$export$2e2bcd8739ae039), {
                                expandIcon: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1e0e42f5f37a7922$exports))), {}),
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    children: "Stammdaten"
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bd3612b92fc47d5c$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        flexWrap: downSm ? 'wrap' : 'nowrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                marginRight: downSm ? 0 : '20px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                                    value: activeMember?.title,
                                                    options: [
                                                        {
                                                            key: (0, $c7fa01100a96d1f7$export$f99233281efd08a0).dr,
                                                            value: 'Dr.'
                                                        },
                                                        {
                                                            key: (0, $c7fa01100a96d1f7$export$f99233281efd08a0).prof,
                                                            value: 'Prof.'
                                                        },
                                                        {
                                                            key: (0, $c7fa01100a96d1f7$export$f99233281efd08a0).profDr,
                                                            value: 'Prof. Dr.'
                                                        }
                                                    ],
                                                    label: "Titel",
                                                    onChange: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                title: value ? value.key : undefined
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "Vorname",
                                                    fullWidth: true,
                                                    value: activeMember?.firstname,
                                                    onChange: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                firstname: value
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "Weitere Vornamen",
                                                    fullWidth: true,
                                                    value: activeMember?.middlenames,
                                                    onChange: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                middlenames: value
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "Nachname",
                                                    fullWidth: true,
                                                    value: activeMember?.lastname,
                                                    onChange: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                lastname: value
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "Geburtsname",
                                                    fullWidth: true,
                                                    value: activeMember?.birthname,
                                                    onChange: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                birthname: value
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $dd1551179d3d9c5a$export$2e2bcd8739ae039), {
                                                    label: "Geboren am",
                                                    fullWidth: true,
                                                    value: activeMember?.birthday ? (0, $4cb44f2a89d6823b$export$2e2bcd8739ae039)(activeMember?.birthday) : undefined,
                                                    onChangeDate: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                birthday: value ? (0, $d67ad22a7bb63f61$export$2e2bcd8739ae039)(value) : {}
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "Geboren in",
                                                    clearable: false,
                                                    fullWidth: true,
                                                    value: activeMember?.placeOfBirth,
                                                    onChange: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                placeOfBirth: value
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: '500px',
                                                overflow: 'hidden',
                                                marginTop: '8px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                                    style: {
                                                        width: '100%',
                                                        height: 'auto',
                                                        borderRadius: '4px'
                                                    },
                                                    alt: `${activeMember?.firstname} ${activeMember?.middlenames ? activeMember?.middlenames : ''} ${activeMember?.lastname}`,
                                                    src: activeMember?.profileImageUrl ? activeMember?.profileImageUrl : `./profileImages/${activeMember?.id}.jpg`
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                    label: "Ich stimme zu, dass meine Geburtsdaten (Geburtstag, -ort) und Wohnort f\xfcr andere Familienmitglieder auf dieser Webseite sichtbar sind.",
                                                    value: activeMember?.showDetails,
                                                    onChange: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                showDetails: value
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $19e56772b842faf0$export$2e2bcd8739ae039), {
                        sx: {
                            margin: '0px!important',
                            borderBottom: `1px solid ${theme.palette.grey.A400}`
                        },
                        TransitionProps: {
                            unmountOnExit: true
                        },
                        expanded: expanded === 'kontakt',
                        onChange: handleChange('kontakt'),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7ba21131579dfa21$export$2e2bcd8739ae039), {
                                expandIcon: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1e0e42f5f37a7922$exports))), {}),
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    children: "Kontaktdaten"
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bd3612b92fc47d5c$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        flexWrap: downSm ? 'wrap' : 'nowrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                marginRight: downSm ? 0 : '20px',
                                                width: downSm ? '100%' : '50%'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "Stra\xdfe & Hausnummer",
                                                    fullWidth: true,
                                                    value: activeMember?.address,
                                                    onChange: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                address: value
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "Stadt",
                                                    fullWidth: true,
                                                    value: activeMember?.city,
                                                    onChange: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                city: value
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "Telefon",
                                                    fullWidth: true,
                                                    value: activeMember?.phone,
                                                    onChange: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                phone: value
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: downSm ? '100%' : '50%'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "PLZ",
                                                    fullWidth: true,
                                                    value: activeMember?.zip,
                                                    onChange: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                zip: value
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "Land",
                                                    fullWidth: true,
                                                    value: activeMember?.country || 'Deutschland',
                                                    onChange: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                country: value
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "E-Mail",
                                                    fullWidth: true,
                                                    value: activeMember?.email,
                                                    onChange: (value)=>{
                                                        if (activeMember) {
                                                            const newMemberData = {
                                                                ...activeMember,
                                                                email: value
                                                            };
                                                            setActiveMember(newMemberData);
                                                        }
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $19e56772b842faf0$export$2e2bcd8739ae039), {
                        sx: {
                            margin: '0px!important',
                            borderBottom: `1px solid ${theme.palette.grey.A400}`
                        },
                        TransitionProps: {
                            unmountOnExit: true
                        },
                        expanded: expanded === 'allergien',
                        onChange: handleChange('allergien'),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7ba21131579dfa21$export$2e2bcd8739ae039), {
                                expandIcon: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1e0e42f5f37a7922$exports))), {}),
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    children: "Allergien / Unvertr\xe4glichkeiten"
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bd3612b92fc47d5c$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        flexWrap: downSm ? 'wrap' : 'nowrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                marginRight: downSm ? 0 : '20px',
                                                width: downSm ? '100%' : '50%'
                                            },
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                                value: activeMember?.dietType,
                                                options: [
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$9fa29051aff709ee).vegetarian,
                                                        value: 'Vegetarisch'
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$9fa29051aff709ee).vegan,
                                                        value: 'Vegan'
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$9fa29051aff709ee).keto,
                                                        value: 'Ketogen'
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$9fa29051aff709ee).paleo,
                                                        value: 'Paleo'
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$9fa29051aff709ee).kosher,
                                                        value: 'Kosher'
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$9fa29051aff709ee).halal,
                                                        value: 'Halal'
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$9fa29051aff709ee).custom,
                                                        value: 'Sonstiges'
                                                    }
                                                ],
                                                label: "Ern\xe4hrungsform",
                                                onChange: (value)=>{
                                                    if (activeMember) {
                                                        const newMemberData = {
                                                            ...activeMember,
                                                            dietType: value ? value.key : undefined
                                                        };
                                                        setActiveMember(newMemberData);
                                                    }
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: downSm ? '100%' : '50%'
                                            },
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                                multipleValue: activeMember?.allergies,
                                                multiple: true,
                                                options: [
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$f8c1145424afc42f).nuts,
                                                        value: "N\xfcsse"
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$f8c1145424afc42f).lactose,
                                                        value: 'Laktose'
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$f8c1145424afc42f).sesame,
                                                        value: 'Sesam'
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$f8c1145424afc42f).fish,
                                                        value: 'Fisch'
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$f8c1145424afc42f).eggs,
                                                        value: 'Eier'
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$f8c1145424afc42f).gluten,
                                                        value: 'Gluten'
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$f8c1145424afc42f).mustard,
                                                        value: 'Senf'
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$f8c1145424afc42f).celery,
                                                        value: 'Sellerie'
                                                    },
                                                    {
                                                        key: (0, $c7fa01100a96d1f7$export$f8c1145424afc42f).soy,
                                                        value: 'Soja'
                                                    }
                                                ],
                                                label: "Allergien",
                                                onChangeList: (value)=>{
                                                    const list = [];
                                                    value.map((elem)=>{
                                                        list.push(elem.key);
                                                    });
                                                    if (activeMember) {
                                                        const newMemberData = {
                                                            ...activeMember,
                                                            allergies: list
                                                        };
                                                        setActiveMember(newMemberData);
                                                    }
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $19e56772b842faf0$export$2e2bcd8739ae039), {
                        sx: {
                            margin: '0px!important',
                            borderBottom: `1px solid ${theme.palette.grey.A400}`
                        },
                        TransitionProps: {
                            unmountOnExit: true
                        },
                        expanded: expanded === 'settings',
                        onChange: handleChange('settings'),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7ba21131579dfa21$export$2e2bcd8739ae039), {
                                expandIcon: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1e0e42f5f37a7922$exports))), {}),
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    children: "Einstellungen"
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bd3612b92fc47d5c$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        justifyContent: 'space-between'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: '100%',
                                                margin: '0 0 20px 0'
                                            },
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                                text: "Passwort \xe4ndern",
                                                onClick: ()=>setShowChangePasswordDialog(true)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: '100%'
                                            },
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c905eea6eb707641$export$2e2bcd8739ae039), {
                                                value: darkMode,
                                                onChange: (checked)=>{
                                                    localStorage.setItem('darkMode', checked.toString());
                                                    dispatch($7173820326fb9f6c$export$f371be8ef3fc4263(checked));
                                                },
                                                label: "Dark Mode"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: '100%',
                    marginTop: '20px'
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                    color: "primary",
                    variant: "text",
                    text: "Speichern",
                    onClick: ()=>{
                        (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).members, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).PUT, activeMember?.originId, {
                            member: activeMember
                        }, setMembers, (0, $7173820326fb9f6c$export$706cdae1b5419ef8));
                    }
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b3c952adb5d7d752$export$2e2bcd8739ae039), {
                showDialog: showChangePasswordDialog,
                setShowDialog: setShowChangePasswordDialog
            })
        ]
    });
};
var $742cedbf5d25d362$export$2e2bcd8739ae039 = $742cedbf5d25d362$var$UserProfile;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");








const $0ccbc7d1c1bf5013$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        dashboardImage: {
            width: '100%',
            height: 'auto'
        }
    }));
const $0ccbc7d1c1bf5013$var$FamilyMember = ()=>{
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const history = (0, $4e1a33337564f167$export$3420e1dc2c4a518c)();
    const classes = $0ccbc7d1c1bf5013$var$useStyles();
    const theme = (0, $76d75229d7c83be5$export$5886efcb490847cc)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const handleNavigation = (section)=>{
        dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
            (0, $47cf5ffcc30e4a77$export$2ce376c2cc3355c8).familyMember,
            section
        ]));
        history.replace(`/${(0, $47cf5ffcc30e4a77$export$2ce376c2cc3355c8).familyMember}/${section}`);
    };
    const linkIconStyle = {
        width: '15px',
        height: '15px',
        color: theme.palette.primary.main,
        marginLeft: '10px',
        marginTop: '-3px'
    };
    const mobileLinkContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        paddingTop: '0!important',
        cursor: 'pointer'
    };
    const linkStyle = {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center'
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "h1",
                children: "Familienmitglieder"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "subtitle1"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                container: true,
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downMd ? 12 : 6,
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            children: [
                                "Hier dreht sich alles um unsere gemeinsame Geschichte, die Freude der besonderen Momente und die einzigartige Verbundenheit, die uns als Familie auszeichnet. Tauche ein in die Vergangenheit und erkunde die Ver\xe4stelungen unseres Familienstammbaums. Von den Wurzeln bis zu den Zweigen erz\xe4hlt jede Verbindung eine einzigartige Geschichte. Hier findest du die grafische Darstellung unserer generations\xfcbergreifenden Bindungen. Feiere mit uns die Freude des Lebens!",
                                /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                                "Der Geburtstagskalender h\xe4lt alle wichtigen Termine fest, damit du keinen besonderen Tag in der Familie verpasst. Gemeinsam die Gl\xfcckw\xfcnsche teilen und die Momente der Freude feiern."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downMd ? 12 : 6,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            children: "Mache dich mit den vielen Gesichtern unserer Familie vertraut. Die Familienmitgliederliste bietet einen \xdcberblick \xfcber die Vielfalt unserer Gemeinschaft. Klicke auf die Namen, um mehr \xfcber jeden Einzelnen zu erfahren. Entdecke die Welt unserer Familie auf einer interaktiven Karte. Finde heraus, wo unsere Familienmitglieder leben und wie weit die Wurzeln unserer Familie gereicht haben. Diese Karte zeigt nicht nur geografische Verteilungen, sondern auch die Ausdehnung unserer famili\xe4ren Bande. Wir hoffen, dass diese Seite dazu beitr\xe4gt, unsere Familiengemeinschaft n\xe4her zusammenzubringen und die verschiedenen Aspekte unseres famili\xe4ren Erbes zu sch\xe4tzen. Viel Freude beim Erkunden!"
                        })
                    }),
                    !downMd && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                item: true,
                                xs: downSm ? 6 : 3,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                                    sx: linkStyle,
                                    underline: "hover",
                                    onClick: ()=>handleNavigation('tree'),
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                        src: "/images/tree.jpg",
                                        className: classes.dashboardImage,
                                        alt: "Stammbaum"
                                    })
                                })
                            }),
                            downSm && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 6,
                                sx: mobileLinkContainerStyle,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                                    sx: linkStyle,
                                    underline: "hover",
                                    onClick: ()=>handleNavigation('tree'),
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                        variant: "body1",
                                        children: "Stammbaum"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downSm ? 6 : downMd ? 4 : 3,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                            sx: linkStyle,
                            underline: "hover",
                            onClick: ()=>handleNavigation('table'),
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                src: "/images/list.jpg",
                                className: classes.dashboardImage,
                                alt: "Mitgliederliste"
                            })
                        })
                    }),
                    downSm && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 6,
                        sx: mobileLinkContainerStyle,
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                            sx: linkStyle,
                            underline: "hover",
                            onClick: ()=>handleNavigation('table'),
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    sx: {
                                        color: theme.palette.primary.main
                                    },
                                    children: "Mitgliederliste"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a33fd87c92782f5$exports))), {
                                    sx: linkIconStyle
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downSm ? 6 : downMd ? 4 : 3,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                            sx: linkStyle,
                            underline: "hover",
                            onClick: ()=>handleNavigation('calendar'),
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                src: "/images/calendar.jpg",
                                className: classes.dashboardImage,
                                alt: "Geburtstagskalender"
                            })
                        })
                    }),
                    downSm && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 6,
                        sx: mobileLinkContainerStyle,
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                            sx: linkStyle,
                            underline: "hover",
                            onClick: ()=>handleNavigation('calendar'),
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    sx: {
                                        color: theme.palette.primary.main
                                    },
                                    children: "Geburtstagskalender"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a33fd87c92782f5$exports))), {
                                    sx: linkIconStyle
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downSm ? 6 : downMd ? 4 : 3,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                            sx: linkStyle,
                            underline: "hover",
                            onClick: ()=>handleNavigation('map'),
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                src: "/images/map.jpg",
                                className: classes.dashboardImage,
                                alt: "Karte"
                            })
                        })
                    }),
                    downSm && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 6,
                        sx: mobileLinkContainerStyle,
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                            sx: linkStyle,
                            underline: "hover",
                            onClick: ()=>handleNavigation('map'),
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    sx: {
                                        color: theme.palette.primary.main
                                    },
                                    children: "Karte der Wohnorte"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a33fd87c92782f5$exports))), {
                                    sx: linkIconStyle
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $0ccbc7d1c1bf5013$export$2e2bcd8739ae039 = $0ccbc7d1c1bf5013$var$FamilyMember;



var $2M70Q = parcelRequire("2M70Q");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $5jsOu = parcelRequire("5jsOu");

var $3DmQB = parcelRequire("3DmQB");


var $3OyDL = parcelRequire("3OyDL");

parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $48a799bebee9cad9$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');



var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $g4LX8 = parcelRequire("g4LX8");

var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $1e9f6c74508d6b2a$export$645d356c89a51794(slot) {
    return (0, $6AMoU.default)('MuiTableSortLabel', slot);
}
const $1e9f6c74508d6b2a$var$tableSortLabelClasses = (0, $ithJf.default)('MuiTableSortLabel', [
    'root',
    'active',
    'icon',
    'iconDirectionDesc',
    'iconDirectionAsc'
]);
var $1e9f6c74508d6b2a$export$2e2bcd8739ae039 = $1e9f6c74508d6b2a$var$tableSortLabelClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $39b0f7b1f528efb3$var$_excluded = [
    "active",
    "children",
    "className",
    "direction",
    "hideSortIcon",
    "IconComponent"
];
const $39b0f7b1f528efb3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, direction: direction, active: active } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active'
        ],
        icon: [
            'icon',
            `iconDirection${(0, $g4LX8.default)(direction)}`
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $1e9f6c74508d6b2a$export$645d356c89a51794), classes);
};
const $39b0f7b1f528efb3$var$TableSortLabelRoot = (0, $jH1k7.default)((0, $c582f66505800c92$export$2e2bcd8739ae039), {
    name: 'MuiTableSortLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})(({ theme: theme })=>({
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        flexDirection: 'inherit',
        alignItems: 'center',
        '&:focus': {
            color: (theme.vars || theme).palette.text.secondary
        },
        '&:hover': {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${(0, $1e9f6c74508d6b2a$export$2e2bcd8739ae039).icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${(0, $1e9f6c74508d6b2a$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${(0, $1e9f6c74508d6b2a$export$2e2bcd8739ae039).icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    }));
const $39b0f7b1f528efb3$var$TableSortLabelIcon = (0, $jH1k7.default)('span', {
    name: 'MuiTableSortLabel',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, $g4LX8.default)(ownerState.direction)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $gOPoC.default)({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            'opacity',
            'transform'
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: 'none'
    }, ownerState.direction === 'desc' && {
        transform: 'rotate(0deg)'
    }, ownerState.direction === 'asc' && {
        transform: 'rotate(180deg)'
    }));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const $39b0f7b1f528efb3$var$TableSortLabel = /*#__PURE__*/ $3OyDL.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiTableSortLabel'
    });
    const { active: active = false, children: children, className: className, direction: direction = 'asc', hideSortIcon: hideSortIcon = false, IconComponent: IconComponent = (0, $48a799bebee9cad9$export$2e2bcd8739ae039) } = props, other = (0, $aBenZ.default)(props, $39b0f7b1f528efb3$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        active: active,
        direction: direction,
        hideSortIcon: hideSortIcon,
        IconComponent: IconComponent
    });
    const classes = $39b0f7b1f528efb3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($39b0f7b1f528efb3$var$TableSortLabelRoot, (0, $gOPoC.default)({
        className: (0, $3DmQB.default)(classes.root, className),
        component: "span",
        disableRipple: true,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, $2M70Q.jsx)($39b0f7b1f528efb3$var$TableSortLabelIcon, {
                as: IconComponent,
                className: (0, $3DmQB.default)(classes.icon),
                ownerState: ownerState
            })
        ]
    }));
});
var $39b0f7b1f528efb3$export$2e2bcd8739ae039 = $39b0f7b1f528efb3$var$TableSortLabel;



var $c0dcc2514c349952$exports = {};
"use strict";
"use client";

Object.defineProperty($c0dcc2514c349952$exports, "__esModule", {
    value: true
});
$c0dcc2514c349952$exports.default = void 0;

var $c0dcc2514c349952$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $c0dcc2514c349952$var$_default = (0, $c0dcc2514c349952$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), 'KeyboardArrowUp');
$c0dcc2514c349952$exports.default = $c0dcc2514c349952$var$_default;


var $91d581d8e8b137b2$exports = {};
"use strict";
"use client";

Object.defineProperty($91d581d8e8b137b2$exports, "__esModule", {
    value: true
});
$91d581d8e8b137b2$exports.default = void 0;

var $91d581d8e8b137b2$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $91d581d8e8b137b2$var$_default = (0, $91d581d8e8b137b2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
}), 'MailOutline');
$91d581d8e8b137b2$exports.default = $91d581d8e8b137b2$var$_default;



var $3OyDL = parcelRequire("3OyDL");



var $fd36c5cfeb020481$exports = {};
"use strict";
"use client";

Object.defineProperty($fd36c5cfeb020481$exports, "__esModule", {
    value: true
});
$fd36c5cfeb020481$exports.default = void 0;

var $fd36c5cfeb020481$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $fd36c5cfeb020481$var$_default = (0, $fd36c5cfeb020481$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M17.5 9.5C17.5 6.46 15.04 4 12 4S6.5 6.46 6.5 9.5c0 2.7 1.94 4.93 4.5 5.4V17H9v2h2v2h2v-2h2v-2h-2v-2.1c2.56-.47 4.5-2.7 4.5-5.4zm-9 0C8.5 7.57 10.07 6 12 6s3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5z"
}), 'Female');
$fd36c5cfeb020481$exports.default = $fd36c5cfeb020481$var$_default;


var $e5059b1b086b52db$exports = {};
"use strict";
"use client";

Object.defineProperty($e5059b1b086b52db$exports, "__esModule", {
    value: true
});
$e5059b1b086b52db$exports.default = void 0;

var $e5059b1b086b52db$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $e5059b1b086b52db$var$_default = (0, $e5059b1b086b52db$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M9.5 11c1.93 0 3.5 1.57 3.5 3.5S11.43 18 9.5 18 6 16.43 6 14.5 7.57 11 9.5 11zm0-2C6.46 9 4 11.46 4 14.5S6.46 20 9.5 20s5.5-2.46 5.5-5.5c0-1.16-.36-2.23-.97-3.12L18 7.42V10h2V4h-6v2h2.58l-3.97 3.97C11.73 9.36 10.66 9 9.5 9z"
}), 'Male');
$e5059b1b086b52db$exports.default = $e5059b1b086b52db$var$_default;






var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

var $0f41ee84bed91066$exports = {};
"use strict";
"use client";

Object.defineProperty($0f41ee84bed91066$exports, "__esModule", {
    value: true
});
$0f41ee84bed91066$exports.default = void 0;

var $0f41ee84bed91066$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $0f41ee84bed91066$var$_default = (0, $0f41ee84bed91066$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');
$0f41ee84bed91066$exports.default = $0f41ee84bed91066$var$_default;




const $b3f71fcbbe24c4db$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        accountSearch: {
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            paddingRight: theme.spacing(1)
        },
        textField: {
            height: 'auto'
        },
        clearIcon: {
            paddingTop: theme.spacing(0.5),
            '&:hover': {
                cursor: 'pointer'
            }
        }
    }));
const $b3f71fcbbe24c4db$var$SearchInput = (props)=>{
    const classes = $b3f71fcbbe24c4db$var$useStyles();
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $328e9bc68740648b$export$2e2bcd8739ae039), {
        className: classes.textField,
        value: props.value,
        id: "search",
        label: "Suchen",
        InputProps: {
            endAdornment: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $251953dff96397bc$export$2e2bcd8739ae039), {
                position: "end",
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                    display: "flex",
                    alignItems: "center",
                    children: !props.value ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($defb55c3fac0cfee$exports))), {}) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                        onClick: ()=>props.onChangeValue && props.onChangeValue(''),
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0f41ee84bed91066$exports))), {
                            className: classes.clearIcon
                        })
                    })
                })
            })
        },
        InputLabelProps: {
            shrink: true
        },
        onChange: (event)=>props.onChangeValue && props.onChangeValue(event.target.value),
        margin: "none",
        size: "small",
        variant: "outlined",
        fullWidth: true
    });
};
var $b3f71fcbbe24c4db$export$2e2bcd8739ae039 = $b3f71fcbbe24c4db$var$SearchInput;



const $bf664bba30665926$var$getAgeFromMember = (member)=>{
    let age;
    if (member.birthday.year) {
        if (member.birthday.month && member.birthday.day) {
            const diffMs = Date.now() - new Date(member.birthday.year, member.birthday.month, member.birthday.day).getTime();
            const ageMs = new Date(diffMs);
            const ageYears = ageMs.getUTCFullYear() - 1970;
            age = ageYears < 0 ? NaN : ageYears;
        } else age = new Date().getFullYear() - member.birthday.year;
    }
    return age;
};
var $bf664bba30665926$export$2e2bcd8739ae039 = $bf664bba30665926$var$getAgeFromMember;




var $6e8385bb380fe9d3$exports = {};
"use strict";
"use client";

Object.defineProperty($6e8385bb380fe9d3$exports, "__esModule", {
    value: true
});
$6e8385bb380fe9d3$exports.default = void 0;

var $6e8385bb380fe9d3$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $6e8385bb380fe9d3$var$_default = (0, $6e8385bb380fe9d3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), 'FilterAlt');
$6e8385bb380fe9d3$exports.default = $6e8385bb380fe9d3$var$_default;





const $0deb024e8c643fd4$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        tableHeader: {
            fontWeight: 'bold',
            textAlign: 'left'
        },
        container: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            flexWrap: 'nowrap'
        },
        content: {
            width: '50%'
        }
    }));
var $0deb024e8c643fd4$export$979bbce5b4752e98 = /*#__PURE__*/ function(LivingState) {
    LivingState["alive"] = "alive";
    LivingState["dead"] = "dead";
    return LivingState;
}({});
var $0deb024e8c643fd4$export$9b4c0f66cdb59c0b = /*#__PURE__*/ function(Aging) {
    Aging["child"] = "child";
    Aging["adult"] = "adult";
    return Aging;
}({});
const $0deb024e8c643fd4$var$FamilyMemberTable = ()=>{
    const theme = (0, $76d75229d7c83be5$export$5886efcb490847cc)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const user = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$7cbf767827cd68ba));
    const searchResult = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$2fa22ca814667ff4));
    const members = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$f4931e6f9feb30c5));
    const relations = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$b8e54fb0b8f14b48));
    const classes = $0deb024e8c643fd4$var$useStyles();
    const [filteredMembers, setFilteredMembers] = (0, $3OyDL.useState)(members?.results || []);
    const [pagedFilteredMembers, setPagedFilteredMembers] = (0, $3OyDL.useState)(members?.results || []);
    const [search, setSearch] = (0, $3OyDL.useState)();
    const [family, setFamily] = (0, $3OyDL.useState)();
    const [gender, setGender] = (0, $3OyDL.useState)();
    const [livingState, setLivingState] = (0, $3OyDL.useState)();
    const [aging, setAgeing] = (0, $3OyDL.useState)();
    const [orderBy, setOrderBy] = (0, $3OyDL.useState)('lastname');
    const [order, setOrder] = (0, $3OyDL.useState)('asc');
    // const [openTree, setOpenTree] = useState<string | undefined>()
    const [page, setPage] = (0, $3OyDL.useState)(0);
    const [pageSize, setPageSize] = (0, $3OyDL.useState)(25);
    const [open, setOpen] = (0, $3OyDL.useState)(null);
    const memberTermArray = [
        'city',
        'zip',
        'lastname',
        'firstname',
        'address',
        'birthname',
        'country',
        'dietType',
        'email',
        'gender',
        'middlenames',
        'nickname',
        'gender',
        'phone',
        'placeOfBirth',
        'placeOfDeath',
        'title'
    ];
    const filterMember = ()=>{
        let newFilteredMembers = members?.results || [];
        // nach Geschlecht filtern
        if (gender) newFilteredMembers = newFilteredMembers.filter((elem)=>elem.gender === gender);
        // nach Familie filtern
        if (family) newFilteredMembers = newFilteredMembers.filter((elem)=>relations?.results.find((rel)=>rel.id === elem.id)?.family === family);
        // nach lebendig filtern
        if (livingState && livingState === "dead") newFilteredMembers = newFilteredMembers.filter((elem)=>elem.dead);
        // nach tot filtern
        if (livingState && livingState === "alive") newFilteredMembers = newFilteredMembers.filter((elem)=>!elem.dead);
        // nach Kindern filtern
        if (aging && aging === "child") newFilteredMembers = newFilteredMembers.filter((elem)=>(0, $bf664bba30665926$export$2e2bcd8739ae039)(elem) && (0, $bf664bba30665926$export$2e2bcd8739ae039)(elem) < 18);
        // nach Erachsenen filtern
        if (aging && aging === "adult") newFilteredMembers = newFilteredMembers.filter((elem)=>(0, $bf664bba30665926$export$2e2bcd8739ae039)(elem) && (0, $bf664bba30665926$export$2e2bcd8739ae039)(elem) >= 18);
        // Suchfeld einbeziehen
        const searchResultArray = search?.split(' ');
        const regExArray = [];
        searchResultArray?.map((elem)=>{
            elem && regExArray.push(new RegExp(elem.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss'), 'gim'));
        });
        if (regExArray.length > 0) {
            const temp = {};
            regExArray.map((regEx, index)=>{
                temp[index] = [];
                newFilteredMembers.map((member)=>{
                    memberTermArray.map((term)=>{
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        if (member[term] && member[term]?.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1) {
                            if (!temp[index].find((elem)=>elem.id === member.id)) temp[index].push(member);
                        }
                    });
                });
            });
            // AND Verknüfung aller Suchergebnisse
            temp[0].map((element, index)=>{
                for(let n = 1; n < Object.keys(temp).length; n += 1)if (!temp[n].find((reference)=>JSON.stringify(reference) === JSON.stringify(element))) delete temp[0][index];
            });
            newFilteredMembers = temp[0];
        }
        // sortieren
        newFilteredMembers.sort((a, b)=>{
            const nameA = a[orderBy].toUpperCase();
            const nameB = b[orderBy].toUpperCase();
            if (order === 'asc') {
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            } else {
                if (nameA > nameB) return -1;
                if (nameA < nameB) return 1;
                return 0;
            }
        });
        // Paging integrieren
        setPagedFilteredMembers(newFilteredMembers.slice(page * pageSize, page * pageSize + pageSize));
        // zurück schreiben
        setFilteredMembers(newFilteredMembers);
    };
    (0, $3OyDL.useEffect)(()=>{
        setFilteredMembers(members?.results || []);
    }, [
        members
    ]);
    (0, $3OyDL.useEffect)(()=>{
        filterMember();
    }, [
        search,
        family,
        gender,
        page,
        pageSize,
        orderBy,
        order,
        livingState,
        aging
    ]);
    (0, $3OyDL.useEffect)(()=>{
        setSearch(searchResult);
    }, [
        searchResult
    ]);
    const getMember = (id)=>{
        if (id) return members?.results.find((item)=>item.id === id);
    };
    // neuen Nutzer anlegen / Email mit Zugansdaten versenden
    const sendMailToUser = (member)=>{
        const restPath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
        const requestHeaders = new Headers();
        requestHeaders.set('Accept', 'application/json');
        requestHeaders.set('Content-Type', 'application/json');
        const restUrl = `${restPath}/api/${(0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)()}/user/passwordmail`;
        fetch(restUrl, {
            method: 'POST',
            body: JSON.stringify({
                memberId: member.originId
            }),
            credentials: 'include',
            headers: requestHeaders
        }).then((res)=>res.json()).then((json)=>{
            console.log(json);
        }).catch((err)=>console.log(err));
    };
    const Row = (member)=>{
        const node = relations?.results.find((elem)=>elem.id === member.id);
        return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                    children: [
                        !downMd && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                            children: member.showDetails && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                size: "small",
                                onClick: ()=>open && open === member.id ? setOpen(null) : setOpen(member.id ? member.id : null),
                                children: open && open === member.id ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c0dcc2514c349952$exports))), {}) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($89bdec2a5524eb93$exports))), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                            children: `${member.firstname} ${member.showDetails && member.middlenames ? member.middlenames : ''}`
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                            children: `${member.lastname} ${member.birthname && member.showDetails ? `(geb. ${member.birthname})` : ''}`
                        }),
                        !downMd && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                            children: member.showDetails && `${(0, $32481be2fe498df5$export$2e2bcd8739ae039)(member.birthday)} ${member.placeOfBirth ? `in ${member.placeOfBirth}` : ''}`
                        }),
                        !downMd && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                            children: member.showDetails && `${(0, $32481be2fe498df5$export$2e2bcd8739ae039)(member.deathday)} ${member.placeOfDeath ? `in ${member.placeOfDeath}` : ''}`
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                            children: member.gender === (0, $c7fa01100a96d1f7$export$d549c77c8a078892).male ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e5059b1b086b52db$exports))), {}) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fd36c5cfeb020481$exports))), {})
                        }),
                        user && user.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).admin && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                            children: member.email && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                onClick: ()=>sendMailToUser(member),
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($91d581d8e8b137b2$exports))), {})
                            })
                        })
                    ]
                }, member.id),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                    children: !downMd && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                        style: {
                            paddingBottom: 0,
                            paddingTop: 0
                        },
                        colSpan: user && user.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).admin ? 7 : 6,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $56fef0a1611427f9$export$2e2bcd8739ae039), {
                            in: !!(open && open === member.id),
                            timeout: "auto",
                            unmountOnExit: true,
                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                sx: {
                                    margin: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                        variant: "h6",
                                        gutterBottom: true,
                                        component: "div",
                                        children: "Daten"
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                        container: true,
                                        width: "100%",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 8,
                                                children: [
                                                    member?.showDetails && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3f0d076fd7cb4a4a$export$2e2bcd8739ae039), {
                                                                    date: member?.birthday,
                                                                    place: member?.placeOfBirth,
                                                                    type: (0, $3f0d076fd7cb4a4a$export$61befbe894190682).birth
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3f0d076fd7cb4a4a$export$2e2bcd8739ae039), {
                                                                    date: member?.deathday,
                                                                    place: member?.placeOfDeath,
                                                                    type: (0, $3f0d076fd7cb4a4a$export$61befbe894190682).death
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        className: classes.container,
                                                        children: [
                                                            node?.parents && node?.parents.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                className: classes.content,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                            children: "Eltern"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                        children: node?.parents[0] && `${getMember(node?.parents[0].id)?.firstname} ${getMember(node?.parents[0].id)?.lastname}`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                        children: node?.parents[1] && `${getMember(node?.parents[1].id)?.firstname} ${getMember(node?.parents[1].id)?.lastname}`
                                                                    })
                                                                ]
                                                            }),
                                                            node?.spouses && node?.spouses.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                className: classes.content,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                            children: "Partner"
                                                                        })
                                                                    }),
                                                                    node?.spouses.map((spouse, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                            children: `${getMember(spouse.id)?.firstname} ${getMember(spouse.id)?.lastname}`
                                                                        }, index))
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                        className: classes.container,
                                                        children: [
                                                            node?.siblings && node?.siblings.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                className: classes.content,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                            children: "Geschwister"
                                                                        })
                                                                    }),
                                                                    node?.siblings.map((sibling, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                            children: `${getMember(sibling.id)?.firstname} ${getMember(sibling.id)?.lastname}`
                                                                        }, index))
                                                                ]
                                                            }),
                                                            node?.children && node?.children.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                className: classes.content,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                            children: "Kinder"
                                                                        })
                                                                    }),
                                                                    node?.children.map((child, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                            children: `${getMember(child.id)?.firstname} ${getMember(child.id)?.lastname}`
                                                                        }, index))
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 4,
                                                textAlign: "right",
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                                                    style: {
                                                        width: 'auto',
                                                        height: '200px',
                                                        margin: '10px 0'
                                                    },
                                                    alt: `${member?.firstname} ${member?.middlenames ? member?.middlenames : ''} ${member?.lastname}`,
                                                    src: member?.profileImageUrl ? member?.profileImageUrl : `/profileImages/${member?.id}.jpg`
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        });
    };
    const FilterTemplate = ()=>{
        return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                    item: true,
                    xs: downMd ? 12 : 4,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                        size: "small",
                        value: family,
                        options: [
                            {
                                key: (0, $1b52d48d66d53440$export$7e952c50f9d34913).IlseKaiser,
                                value: 'Ilse Kaiser'
                            },
                            {
                                key: (0, $1b52d48d66d53440$export$7e952c50f9d34913).HeinzMichael,
                                value: 'Heinz Michael'
                            },
                            {
                                key: (0, $1b52d48d66d53440$export$7e952c50f9d34913).JuergenKuther,
                                value: "J\xfcrgen Kuther"
                            },
                            {
                                key: (0, $1b52d48d66d53440$export$7e952c50f9d34913).ThomasKuther,
                                value: 'Thomas Kuther'
                            },
                            {
                                key: (0, $1b52d48d66d53440$export$7e952c50f9d34913).AndreasKuther,
                                value: 'Andreas Kuther'
                            },
                            {
                                key: (0, $1b52d48d66d53440$export$7e952c50f9d34913).HeikeKuther,
                                value: 'Heike Kuther'
                            }
                        ],
                        label: "Familie",
                        onChange: (value)=>{
                            setPage(0);
                            value ? setFamily(value.key) : setFamily(undefined);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                    item: true,
                    xs: downMd ? 12 : 4,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                        size: "small",
                        value: gender,
                        options: [
                            {
                                key: (0, $c7fa01100a96d1f7$export$d549c77c8a078892).male,
                                value: "m\xe4nnlich"
                            },
                            {
                                key: (0, $c7fa01100a96d1f7$export$d549c77c8a078892).female,
                                value: 'weiblich'
                            }
                        ],
                        label: "Geschlecht",
                        onChange: (value)=>{
                            setPage(0);
                            value ? setGender(value.key) : setGender(undefined);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                    item: true,
                    xs: downMd ? 12 : 4,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                        size: "small",
                        value: livingState,
                        options: [
                            {
                                key: "alive",
                                value: 'lebendig'
                            },
                            {
                                key: "dead",
                                value: 'verstorben'
                            }
                        ],
                        label: "Status",
                        onChange: (value)=>{
                            setPage(0);
                            value ? setLivingState(value.key) : setLivingState(undefined);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                    item: true,
                    xs: downMd ? 12 : 4,
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                        size: "small",
                        value: aging,
                        options: [
                            {
                                key: "child",
                                value: 'Kinder'
                            },
                            {
                                key: "adult",
                                value: 'Erwachsene'
                            }
                        ],
                        label: "Alter",
                        onChange: (value)=>{
                            setPage(0);
                            value ? setAgeing(value.key) : setAgeing(undefined);
                        }
                    })
                })
            ]
        });
    };
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const openFilter = Boolean(anchorEl);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "h1",
                children: "Liste der Familienmitglieder"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                sx: {
                    width: '100%'
                },
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        item: true,
                        xs: downMd ? 12 : 4,
                        spacing: 2,
                        sx: downMd ? {
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        } : {},
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b3f71fcbbe24c4db$export$2e2bcd8739ae039), {
                                value: search,
                                onChangeValue: (value)=>{
                                    setPage(0);
                                    value ? setSearch(value) : setSearch(undefined);
                                }
                            }),
                            downMd && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        sx: {
                                            position: 'relative',
                                            marginLeft: '10px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    border: `1px solid ${theme.palette.grey['400']}`,
                                                    width: '42px',
                                                    borderRadius: '4px'
                                                },
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                    onClick: handleClick,
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6e8385bb380fe9d3$exports))), {})
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: gender || family || livingState || aging ? {
                                                    borderRadius: '10px',
                                                    width: '15px',
                                                    height: '15px',
                                                    backgroundColor: theme.palette.primary.dark,
                                                    color: '#fff',
                                                    position: 'absolute',
                                                    top: '-5px',
                                                    right: '-5px',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                } : {
                                                    width: '15px',
                                                    height: '15px',
                                                    top: '-5px',
                                                    right: '-5px',
                                                    position: 'absolute',
                                                    color: 'transparent'
                                                },
                                                children: "!"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3d66e9e40e3cbf49$export$2e2bcd8739ae039), {
                                        open: openFilter,
                                        anchorEl: anchorEl,
                                        onClose: handleClose,
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left'
                                        },
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                padding: '20px'
                                            },
                                            children: [
                                                FilterTemplate(),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        color: theme.palette.primary.main,
                                                        textAlign: 'center'
                                                    },
                                                    onClick: ()=>{
                                                        setFamily(undefined);
                                                        setGender(undefined);
                                                        setLivingState(undefined);
                                                        setAgeing(undefined);
                                                        handleClose();
                                                    },
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "body1",
                                                        sx: {
                                                            cursor: 'pointer'
                                                        },
                                                        children: "Alle Filter entfernen"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !downMd && FilterTemplate()
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                size: "small",
                sx: {
                    marginTop: '20px'
                },
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                            children: [
                                !downMd && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $39b0f7b1f528efb3$export$2e2bcd8739ae039), {
                                        color: "primary",
                                        active: orderBy === 'firstname',
                                        direction: order,
                                        className: classes.tableHeader,
                                        onClick: ()=>{
                                            setOrderBy('firstname');
                                            setOrder(order === 'asc' ? 'desc' : 'asc');
                                        },
                                        children: "Vorname"
                                    }, "firstname")
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $39b0f7b1f528efb3$export$2e2bcd8739ae039), {
                                        color: "primary",
                                        active: orderBy === 'lastname',
                                        direction: order,
                                        className: classes.tableHeader,
                                        onClick: ()=>{
                                            setOrderBy('lastname');
                                            setOrder(order === 'asc' ? 'desc' : 'asc');
                                        },
                                        children: "Nachname"
                                    }, "lastname")
                                }),
                                !downMd && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    children: "geboren"
                                }),
                                !downMd && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    children: "gestorben"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    children: "\xa0"
                                }),
                                user && user.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).admin && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                    className: classes.tableHeader,
                                    children: "\xa0"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                        children: pagedFilteredMembers.map((member)=>Row(member))
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6aef60d9c63e7548$export$2e2bcd8739ae039), {
                        count: filteredMembers.length,
                        page: page,
                        rowsPerPage: pageSize,
                        rowsPerPageOptions: downSm ? [] : [
                            10,
                            25,
                            50,
                            100
                        ],
                        onPageChange: (event, page)=>setPage(page),
                        onRowsPerPageChange: (pageSize)=>{
                            setPage(0);
                            setPageSize(parseInt(pageSize.target.value, 10));
                        }
                    })
                ]
            })
        ]
    });
};
var $0deb024e8c643fd4$export$2e2bcd8739ae039 = $0deb024e8c643fd4$var$FamilyMemberTable;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");


var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");





var $9132df341948ccf5$exports = {};
"use strict";
"use client";

Object.defineProperty($9132df341948ccf5$exports, "__esModule", {
    value: true
});
$9132df341948ccf5$exports.default = void 0;

var $9132df341948ccf5$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $9132df341948ccf5$var$_default = (0, $9132df341948ccf5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z"
}), 'Cake');
$9132df341948ccf5$exports.default = $9132df341948ccf5$var$_default;





const $9c58c424cca9d00d$var$CalendarDay = ({ day: day, index: index, ...props })=>{
    const { t: t } = (0, $ead5e217b39556c6$export$9fc83ad70ead8663)();
    const theme = (0, $76d75229d7c83be5$export$5886efcb490847cc)();
    const darkMode = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$3813fceac631a2fa));
    const downLg = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('lg'));
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const position = day && new Date(day.year, day.month - 1, day.day).getTime();
    const members = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$f4931e6f9feb30c5));
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            calendarDaysDay: {
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                width: '15%',
                maxWidth: '15%',
                minHeight: '50px',
                height: 'auto',
                borderRight: `1px solid ${darkMode ? '#8a8a8a' : '#f5f5f5'}`,
                backgroundColor: theme.palette.background.paper,
                transition: 'all .2s ease-in-out'
            },
            dayNumber: {
                padding: '10px 12px',
                textAlign: 'right',
                color: day.actualMonth ? day.actualDay ? '#646464' : '#B1B1B1' : '#EBEBEB',
                fontWeight: day.actualDay ? 700 : 500
            },
            postCards: {},
            dropArea: {
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#ffffff',
                position: 'relative',
                padding: '0px !important',
                '&::before': {
                    content: `'${t('coreCalendar:drop')}'`,
                    color: '#646464',
                    fontSize: '.7em',
                    textTransform: 'uppercase',
                    padding: '14px',
                    width: '100%',
                    height: '100%',
                    border: '2px dashed rgba(100, 100, 100, 0.5)',
                    position: 'absolute',
                    display: 'flex',
                    justifyContent: 'flex-start'
                }
            },
            dropAreaRestricted: {
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                padding: '0px !important',
                '&::before': {
                    content: "'\xd7'",
                    color: 'red',
                    fontSize: '1.3em',
                    textTransform: 'uppercase',
                    padding: '5px 12px',
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    display: 'flex',
                    justifyContent: 'flex-start'
                }
            }
        }));
    const classes = useStyles();
    const hasBirthday = (date)=>{
        if (day.month === date.month && day.day === date.day) {
            if (date.year) return {
                birthday: true,
                age: day.year >= date.year ? day.year - date.year : null
            };
            else return {
                birthday: true
            };
        } else return {
            birthday: false
        };
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
        "data-position": position,
        className: `${classes.calendarDaysDay}`,
        component: "div",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body2",
                component: "span",
                className: classes.dayNumber,
                children: day.day
            }),
            day.actualDay && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                sx: {
                    position: 'absolute',
                    width: '30px',
                    height: '30px',
                    border: `2px solid ${theme.palette.primary.main}`,
                    borderRadius: '15px',
                    top: '4px',
                    right: day.day < 10 ? '2px' : '4px'
                }
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                className: classes.postCards,
                component: "div",
                children: members?.results.map((member)=>{
                    if (member.showDetails && hasBirthday(member.birthday).birthday) return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '10px',
                                width: 'calc(100% - 10px)',
                                backgroundColor: member.dead ? theme.palette.grey['500'] : theme.palette.primary.main,
                                color: '#fff',
                                padding: '5px',
                                margin: '5px'
                            },
                            children: [
                                member.dead && !downMd && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a22cd9bdf10ac330$export$2e2bcd8739ae039), {
                                    width: "20px",
                                    color: "#fff"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    sx: downMd ? {
                                        fontSize: '10px',
                                        textAlign: 'center'
                                    } : downSm ? {
                                        fontSize: '12px'
                                    } : downLg ? {
                                        fontSize: '12px'
                                    } : {
                                        whiteSpace: 'nowrap'
                                    },
                                    children: [
                                        `${member.firstname} ${downLg ? member.lastname.charAt(0).toUpperCase() + `. (${hasBirthday(member.birthday).age})` : member.lastname}`,
                                        "\xa0"
                                    ]
                                }),
                                hasBirthday(member.birthday).age === 0 ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                    children: !downMd && /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9132df341948ccf5$exports))), {})
                                }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                    children: !downLg && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                        sx: downMd ? {
                                            fontSize: '10px'
                                        } : downSm ? {
                                            fontSize: '12px'
                                        } : downLg ? {
                                            fontSize: '12px'
                                        } : {},
                                        variant: "body1",
                                        children: [
                                            "(",
                                            hasBirthday(member.birthday).age,
                                            ")"
                                        ]
                                    })
                                })
                            ]
                        })
                    });
                })
            })
        ]
    }, position);
};
var $9c58c424cca9d00d$export$2e2bcd8739ae039 = $9c58c424cca9d00d$var$CalendarDay;




const $a18d0d3ddbe8ec18$var$CalendarWeek = ({ week: week, index: index, ...props })=>{
    const darkMode = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$3813fceac631a2fa));
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            calendarDaysRow: {
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                borderBottom: `1px solid ${darkMode ? '#8a8a8a' : '#f5f5f5'}`
            }
        }));
    const classes = useStyles();
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
        className: classes.calendarDaysRow,
        component: "div",
        children: week.days.map((day, i)=>{
            return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9c58c424cca9d00d$export$2e2bcd8739ae039), {
                index: i,
                day: day,
                calendarData: props.calendarData,
                setSelectedDate: props.setSelectedDate
            }, i);
        })
    }, index);
};
var $a18d0d3ddbe8ec18$export$2e2bcd8739ae039 = $a18d0d3ddbe8ec18$var$CalendarWeek;



var $3OyDL = parcelRequire("3OyDL");
function $4c564e220daa287f$export$4169ecd548fbc13a(month, year) {
    return new Date(year, month, 0).getDate();
}


const $91cb650f319bae77$export$8d6f3e598a4b7ded = (first, second)=>first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
const $91cb650f319bae77$export$3fbef843a041402e = (first, second)=>first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth();


const $e9b79a3e75abb796$var$useDisplayCalendar = (changeDataParams)=>{
    const [value, setValue] = (0, $3OyDL.useState)();
    const handleChange = (selectedDate)=>{
        const workDate = new Date(selectedDate);
        const hour = workDate.getHours();
        const minute = workDate.getMinutes();
        const month = workDate.getMonth() + 1;
        const year = workDate.getFullYear();
        const today = new Date(Date.now());
        const dayCount = (0, $4c564e220daa287f$export$4169ecd548fbc13a)(month, year);
        workDate.setDate(1);
        let firstWeekDay = workDate.getDay();
        // Sunday - Saturday : 0 - 6
        workDate.setDate(dayCount);
        let lastWeekDay = workDate.getDay();
        const actualMonth = [];
        let actualDay = false;
        // let published = false
        let i = 1;
        while(i <= dayCount){
            workDate.setDate(i);
            actualDay = (0, $91cb650f319bae77$export$8d6f3e598a4b7ded)(workDate, today);
            // published = workDate <= today
            const weekday = workDate.getDay();
            actualMonth.push({
                month: month,
                day: i,
                year: year,
                date: new Date(year, month - 1, i, hour, minute),
                weekday: weekday,
                actualDay: actualDay,
                actualMonth: true
            });
            i += 1;
        }
        let lastMonth = [];
        const nextMonth = [];
        let to = new Date();
        const from = new Date(workDate.getFullYear(), workDate.getMonth(), 1);
        // Auffüllen der vollen Wochen
        let newFirstWeek = 0;
        // if firstWeekDay on Sunday
        if (firstWeekDay === 0) firstWeekDay = 7;
        while(firstWeekDay > 1){
            firstWeekDay -= 1;
            let newMonth = month;
            let newYear = workDate.getFullYear();
            if (month === 1) {
                newMonth = 12;
                newYear -= 1;
            } else newMonth -= 1;
            const lastDayCount = (0, $4c564e220daa287f$export$4169ecd548fbc13a)(newMonth, newYear);
            lastMonth.push({
                month: newMonth,
                day: lastDayCount - newFirstWeek,
                date: new Date(newYear, newMonth, lastDayCount - newFirstWeek),
                year: newYear,
                weekday: firstWeekDay,
                actualDay: false,
                actualMonth: false
            });
            from.setFullYear(newYear);
            from.setMonth(newMonth - 1);
            from.setDate(lastDayCount - newFirstWeek);
            newFirstWeek += 1;
        }
        let newLastWeek = 0;
        if (lastWeekDay === 7) to = new Date(workDate.getFullYear(), workDate.getMonth(), workDate.getDate());
        while(lastWeekDay < 7){
            lastWeekDay += 1;
            let newMonth = month;
            let newYear = workDate.getFullYear();
            if (month === 12) {
                newMonth = 1;
                newYear += 1;
            } else newMonth += 1;
            nextMonth.push({
                month: newMonth,
                day: 1 + newLastWeek,
                date: new Date(newYear, newMonth - 1, 1 + newLastWeek),
                year: newYear,
                weekday: lastWeekDay,
                actualDay: false,
                actualMonth: false
            });
            to = new Date(newYear, newMonth - 1, 1 + newLastWeek);
            newLastWeek += 1;
        }
        lastMonth = lastMonth.reverse();
        const completeCalendar = [];
        lastMonth.map((last)=>{
            completeCalendar.push(last);
        });
        actualMonth.map((actual)=>{
            completeCalendar.push(actual);
        });
        nextMonth.map((next)=>{
            completeCalendar.push(next);
        });
        const weeks = [];
        let week = {
            days: []
        };
        let counter = 0;
        completeCalendar.map((elem)=>{
            if (counter !== 0 && counter % 7 === 0) {
                weeks.push(week);
                week = {
                    days: []
                };
            }
            counter += 1;
            week.days.push(elem);
        });
        weeks.push(week);
        from.setHours(0);
        from.setMinutes(0);
        from.setSeconds(0);
        to.setHours(23);
        to.setMinutes(59);
        to.setSeconds(59);
        setValue(weeks);
        changeDataParams && changeDataParams({
            from: from,
            to: to
        });
    };
    return [
        value,
        handleChange
    ];
};
var $e9b79a3e75abb796$export$2e2bcd8739ae039 = $e9b79a3e75abb796$var$useDisplayCalendar;





const $26cfafc8afae0bc7$var$Calendar = (props)=>{
    const darkMode = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$3813fceac631a2fa));
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            paper: {
                width: '100%',
                marginTop: theme.spacing(0.8),
                padding: 0,
                overflow: 'hidden'
            },
            calendarDays: {},
            calendarDaysHeadline: {
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'nowrap',
                width: '100%',
                backgroundColor: darkMode ? theme.palette.primary.dark : theme.palette.primary.main
            },
            calendarDaysWeekday: {
                width: '15%',
                maxWidth: '15%',
                textAlign: 'center',
                verticalAlign: 'middle',
                height: '40px',
                textTransform: 'uppercase',
                borderRight: `1px solid ${darkMode ? '#8a8a8a' : '#f5f5f5'}`,
                padding: '5px',
                // color: darkMode ? theme.typography. : theme.palette.primary.contrastText,
                lineHeight: '33px',
                '&:last-child': {
                    borderRight: 'none'
                }
            },
            backgroundLayer: {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgb(255,255,255,0.6)'
            },
            preloader: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)'
            }
        }));
    const classes = useStyles();
    const theme = (0, $76d75229d7c83be5$export$5886efcb490847cc)();
    // const downSm = useMediaQuery(theme.breakpoints.down('sm'))
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const DaysOfWeek = [
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag',
        'Sonntag'
    ];
    const [selectedDate, setSelectedDate] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(props.selectedDate ? props.selectedDate : Date.now());
    const [completeCalendarWeeks, setCompleteCalendarWeeks] = (0, $e9b79a3e75abb796$export$2e2bcd8739ae039)();
    (0, $3OyDL.useEffect)(()=>{
        props.selectedDate && setSelectedDate(props.selectedDate);
    }, [
        props.selectedDate
    ]);
    (0, $3OyDL.useEffect)(()=>{
        setCompleteCalendarWeeks(selectedDate);
    }, [
        selectedDate
    ]);
    const handleSetSelectedDate = (selectedDate)=>{
        setSelectedDate(selectedDate);
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
        container: true,
        direction: "row",
        sx: {
            width: '100%'
        },
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
            container: true,
            item: true,
            xs: 12,
            sx: {
                width: '100%'
            },
            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
                className: classes.paper,
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    sx: {
                        width: '100%'
                    },
                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        className: classes.calendarDays,
                        component: "div",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                className: classes.calendarDaysHeadline,
                                component: "div",
                                children: DaysOfWeek.map((day, index)=>{
                                    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                        className: classes.calendarDaysWeekday,
                                        component: "div",
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            component: "span",
                                            variant: "body2",
                                            children: downMd ? day.charAt(0).toUpperCase() : day
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                component: "div",
                                children: completeCalendarWeeks && completeCalendarWeeks.map((week, index)=>{
                                    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a18d0d3ddbe8ec18$export$2e2bcd8739ae039), {
                                        index: index,
                                        week: week,
                                        setSelectedDate: handleSetSelectedDate,
                                        calendarData: props.calendarData
                                    }, index);
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
var $26cfafc8afae0bc7$export$2e2bcd8739ae039 = $26cfafc8afae0bc7$var$Calendar;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");




var $0baf7edb365b10ef$exports = {};
"use strict";
"use client";

Object.defineProperty($0baf7edb365b10ef$exports, "__esModule", {
    value: true
});
$0baf7edb365b10ef$exports.default = void 0;

var $0baf7edb365b10ef$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $0baf7edb365b10ef$var$_default = (0, $0baf7edb365b10ef$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M19 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H8V2c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H6c-.55 0-1-.45-1-1V8h14v10c0 .55-.45 1-1 1zM8 10h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1z"
}), 'TodayRounded');
$0baf7edb365b10ef$exports.default = $0baf7edb365b10ef$var$_default;






const $0215a0f38700da84$var$FamilyCalendarNav = ({ ...props })=>{
    const theme = (0, $76d75229d7c83be5$export$5886efcb490847cc)();
    const downXs = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('xs'));
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            barContainer: {
                width: '100%',
                display: 'flex',
                position: 'relative',
                justifyContent: 'space-between'
            },
            dateNav: {
                position: 'absolute',
                left: downXs ? 0 : downMd ? 'calc(50% - 120px)' : 'calc(50% - 70px)',
                marginTop: theme.spacing(1.5)
            },
            tabsNav: {
                marginTop: theme.spacing(2),
                marginLeft: 'auto'
            },
            pagination: {
                margin: '0',
                display: 'flex',
                padding: 0,
                flexWrap: 'wrap',
                listStyle: 'none',
                alignItems: 'center'
            },
            navItem: {
                fontSize: '1rem',
                lineHeight: '17px'
            },
            navLink: {
                margin: '0 1px'
            },
            disabled: {
                opacity: 0.38,
                pointerEvents: 'none',
                cursor: 'default'
            },
            loader: {
                display: 'flex',
                alignItems: 'center',
                marginTop: theme.spacing(2),
                width: '30px'
            }
        }));
    const classes = useStyles();
    const { t: t } = (0, $ead5e217b39556c6$export$9fc83ad70ead8663)();
    const Months = [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ];
    const selectedDateObj = props.selectedDate && new Date(props.selectedDate);
    const today = new Date(Date.now());
    const onNext = ()=>{
        if (selectedDateObj) return props.changeSelectedDate && props.changeSelectedDate(selectedDateObj.setMonth(selectedDateObj.getMonth() + 1));
    };
    const onPrevious = ()=>{
        if (selectedDateObj) return props.changeSelectedDate && props.changeSelectedDate(selectedDateObj.setMonth(selectedDateObj.getMonth() - 1));
    };
    const setToday = ()=>{
        props.changeSelectedDate && props.changeSelectedDate(Date.now());
    };
    const disabled = ()=>{
        if (selectedDateObj) return (0, $91cb650f319bae77$export$3fbef843a041402e)(selectedDateObj, today);
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
        className: classes.barContainer,
        component: "div",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("nav", {
                className: classes.dateNav,
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("ul", {
                    className: classes.pagination,
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                            className: `${classes.navItem}`,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                className: `${classes.navLink}`,
                                component: "div",
                                onClick: onPrevious,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($068d9311976b63b5$exports))), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                            className: `${classes.navItem}`,
                            children: selectedDateObj && `${Months[selectedDateObj.getMonth()]} ${selectedDateObj.getUTCFullYear()}`
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                            className: `${classes.navItem}`,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                className: `${classes.navLink}`,
                                component: "div",
                                onClick: onNext,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acf14657a0db239b$exports))), {})
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                className: classes.tabsNav,
                component: "div",
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a55b2c6a514356c8$export$2e2bcd8739ae039), {
                    variant: "text",
                    size: "small",
                    sx: {
                        textTransform: 'capitalize',
                        '& .MuiButton-iconSizeSmall': {
                            mr: '5px',
                            '& .MuiSvgIcon-root': {
                                fontSize: '24px'
                            }
                        }
                    },
                    disabled: disabled(),
                    startIcon: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0baf7edb365b10ef$exports))), {}),
                    onClick: setToday,
                    children: t('coreCalendar:today')
                })
            })
        ]
    });
};
var $0215a0f38700da84$export$2e2bcd8739ae039 = $0215a0f38700da84$var$FamilyCalendarNav;



const $85eedd1553a74c10$var$FamilyCalendar = ()=>{
    const theme = (0, $76d75229d7c83be5$export$5886efcb490847cc)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const [selectedDate, setSelectedDate] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(Date.now());
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "h1",
                children: "Geburtstage"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                container: true,
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        container: true,
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0215a0f38700da84$export$2e2bcd8739ae039), {
                            selectedDate: selectedDate,
                            changeSelectedDate: (date)=>setSelectedDate(date)
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                        container: true,
                        item: true,
                        xs: 12,
                        style: {
                            marginBottom: theme.spacing(8)
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sx: {
                                width: '100%'
                            },
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $26cfafc8afae0bc7$export$2e2bcd8739ae039), {
                                selectedDate: selectedDate,
                                calendarData: [],
                                changeSelectedDate: (date)=>setSelectedDate(date)
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $85eedd1553a74c10$export$2e2bcd8739ae039 = $85eedd1553a74c10$var$FamilyCalendar;



var $2M70Q = parcelRequire("2M70Q");


var $3OyDL = parcelRequire("3OyDL");





const $eb3d1a4aee4abd5b$var$FamilyMap = ()=>{
    const theme = (0, $76d75229d7c83be5$export$5886efcb490847cc)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const members = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$f4931e6f9feb30c5));
    const [positions, setPositions] = (0, $3OyDL.useState)([]);
    const [labels, setLabels] = (0, $3OyDL.useState)([]);
    (0, $3OyDL.useEffect)(()=>{
        const newPos = [];
        const newLabel = [];
        members?.results.map((member)=>{
            const stringCoords = member.coordinates?.split(',');
            const coordinates = [];
            stringCoords && stringCoords[0] && coordinates.push(parseFloat(stringCoords[0]));
            stringCoords && stringCoords[1] && coordinates.push(parseFloat(stringCoords[1]));
            const newLatLong = member.coordinates && new (0, $ad5a22b7e45eeb01$exports.LatLng)(coordinates[0], coordinates[1]);
            if (member.showDetails && newLatLong) {
                if (newPos.findIndex((elem)=>JSON.stringify(elem) === JSON.stringify(newLatLong)) === -1) {
                    newPos.push(newLatLong);
                    newLabel.push(`<b>${member.dead ? "Ruhest\xe4tte " : ''}${member.city}</b><br />${member.firstname} ${member.lastname}`);
                } else {
                    const index = newPos.findIndex((elem)=>JSON.stringify(elem) === JSON.stringify(newLatLong));
                    newLabel[index] = newLabel[index] + `<br />${member.firstname} ${member.lastname}`;
                }
            }
        });
        setPositions(newPos);
        setLabels(newLabel);
    }, [
        members
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "h1",
                children: "Karte der Wohnorte"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: "Begib dich auf eine virtuelle Reise durch die Wohnorte unserer Familie und lerne die Vielfalt unserer Herkunft kennen."
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7801af78bc29c2a9$export$2e2bcd8739ae039), {
                height: 500,
                positions: positions,
                mapZoom: 6,
                label: labels
            })
        ]
    });
};
var $eb3d1a4aee4abd5b$export$2e2bcd8739ae039 = $eb3d1a4aee4abd5b$var$FamilyMap;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");



var $ba0aafeac57dbd7b$exports = {};
"use strict";
"use client";

Object.defineProperty($ba0aafeac57dbd7b$exports, "__esModule", {
    value: true
});
$ba0aafeac57dbd7b$exports.default = void 0;

var $ba0aafeac57dbd7b$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $ba0aafeac57dbd7b$var$_default = (0, $ba0aafeac57dbd7b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');
$ba0aafeac57dbd7b$exports.default = $ba0aafeac57dbd7b$var$_default;


var $3e5eaf6bd9d17d25$exports = {};
"use strict";
"use client";

Object.defineProperty($3e5eaf6bd9d17d25$exports, "__esModule", {
    value: true
});
$3e5eaf6bd9d17d25$exports.default = void 0;

var $3e5eaf6bd9d17d25$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $3e5eaf6bd9d17d25$var$_default = (0, $3e5eaf6bd9d17d25$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
        d: "m12 12.9-2.13 2.09c-.56.56-.87 1.29-.87 2.07C9 18.68 10.35 20 12 20s3-1.32 3-2.94c0-.78-.31-1.52-.87-2.07L12 12.9z"
    }, "0"),
    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
        d: "m16 6-.44.55C14.38 8.02 12 7.19 12 5.3V2S4 6 4 13c0 2.92 1.56 5.47 3.89 6.86-.56-.79-.89-1.76-.89-2.8 0-1.32.52-2.56 1.47-3.5L12 10.1l3.53 3.47c.95.93 1.47 2.17 1.47 3.5 0 1.02-.31 1.96-.85 2.75 1.89-1.15 3.29-3.06 3.71-5.3.66-3.55-1.07-6.9-3.86-8.52z"
    }, "1")
], 'LocalFireDepartment');
$3e5eaf6bd9d17d25$exports.default = $3e5eaf6bd9d17d25$var$_default;






var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

var $3OyDL = parcelRequire("3OyDL");
/*!
 * Chart.js v4.2.1
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.2.1
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $b4460b24eea3ae4d$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $b4460b24eea3ae4d$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $b4460b24eea3ae4d$export$bcc6e673dfa14d36(v) {
    return $b4460b24eea3ae4d$export$837ba5c449269406($b4460b24eea3ae4d$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $b4460b24eea3ae4d$export$869b26d4e1bbdb63(v) {
    return $b4460b24eea3ae4d$export$837ba5c449269406($b4460b24eea3ae4d$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $b4460b24eea3ae4d$export$ed9bd8dcaeba14f6(v) {
    return $b4460b24eea3ae4d$export$837ba5c449269406($b4460b24eea3ae4d$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $b4460b24eea3ae4d$export$dbf961a8d278dbef(v) {
    return $b4460b24eea3ae4d$export$837ba5c449269406($b4460b24eea3ae4d$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $b4460b24eea3ae4d$export$aa35ef1f24408ab9(v) {
    return $b4460b24eea3ae4d$export$837ba5c449269406($b4460b24eea3ae4d$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $b4460b24eea3ae4d$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $b4460b24eea3ae4d$var$hex = [
    ...'0123456789ABCDEF'
];
const $b4460b24eea3ae4d$var$h1 = (b)=>$b4460b24eea3ae4d$var$hex[b & 0xF];
const $b4460b24eea3ae4d$var$h2 = (b)=>$b4460b24eea3ae4d$var$hex[(b & 0xF0) >> 4] + $b4460b24eea3ae4d$var$hex[b & 0xF];
const $b4460b24eea3ae4d$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $b4460b24eea3ae4d$var$isShort = (v)=>$b4460b24eea3ae4d$var$eq(v.r) && $b4460b24eea3ae4d$var$eq(v.g) && $b4460b24eea3ae4d$var$eq(v.b) && $b4460b24eea3ae4d$var$eq(v.a);
function $b4460b24eea3ae4d$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $b4460b24eea3ae4d$var$map$1[str[1]] * 17,
            g: 255 & $b4460b24eea3ae4d$var$map$1[str[2]] * 17,
            b: 255 & $b4460b24eea3ae4d$var$map$1[str[3]] * 17,
            a: len === 5 ? $b4460b24eea3ae4d$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $b4460b24eea3ae4d$var$map$1[str[1]] << 4 | $b4460b24eea3ae4d$var$map$1[str[2]],
            g: $b4460b24eea3ae4d$var$map$1[str[3]] << 4 | $b4460b24eea3ae4d$var$map$1[str[4]],
            b: $b4460b24eea3ae4d$var$map$1[str[5]] << 4 | $b4460b24eea3ae4d$var$map$1[str[6]],
            a: len === 9 ? $b4460b24eea3ae4d$var$map$1[str[7]] << 4 | $b4460b24eea3ae4d$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $b4460b24eea3ae4d$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $b4460b24eea3ae4d$export$1b06654353ef9f67(v) {
    var f = $b4460b24eea3ae4d$var$isShort(v) ? $b4460b24eea3ae4d$var$h1 : $b4460b24eea3ae4d$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $b4460b24eea3ae4d$var$alpha(v.a, f) : undefined;
}
const $b4460b24eea3ae4d$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $b4460b24eea3ae4d$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $b4460b24eea3ae4d$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $b4460b24eea3ae4d$var$hwb2rgbn(h, w, b) {
    const rgb = $b4460b24eea3ae4d$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $b4460b24eea3ae4d$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $b4460b24eea3ae4d$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $b4460b24eea3ae4d$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $b4460b24eea3ae4d$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($b4460b24eea3ae4d$export$ed9bd8dcaeba14f6);
}
function $b4460b24eea3ae4d$export$4c15bd42559b811d(h, s, l) {
    return $b4460b24eea3ae4d$var$calln($b4460b24eea3ae4d$var$hsl2rgbn, h, s, l);
}
function $b4460b24eea3ae4d$export$e2710022c70fc9ee(h, w, b) {
    return $b4460b24eea3ae4d$var$calln($b4460b24eea3ae4d$var$hwb2rgbn, h, w, b);
}
function $b4460b24eea3ae4d$export$b785a357c84e4a04(h, s, v) {
    return $b4460b24eea3ae4d$var$calln($b4460b24eea3ae4d$var$hsv2rgbn, h, s, v);
}
function $b4460b24eea3ae4d$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $b4460b24eea3ae4d$export$5e91288c399be4f9(str) {
    const m = $b4460b24eea3ae4d$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $b4460b24eea3ae4d$export$bcc6e673dfa14d36(+m[5]) : $b4460b24eea3ae4d$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $b4460b24eea3ae4d$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $b4460b24eea3ae4d$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $b4460b24eea3ae4d$export$b785a357c84e4a04(h, p1, p2);
    else v = $b4460b24eea3ae4d$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $b4460b24eea3ae4d$export$bb628a54ab399bc9(v, deg) {
    var h = $b4460b24eea3ae4d$export$b5ba70b240f8f7f(v);
    h[0] = $b4460b24eea3ae4d$var$hue(h[0] + deg);
    h = $b4460b24eea3ae4d$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $b4460b24eea3ae4d$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $b4460b24eea3ae4d$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $b4460b24eea3ae4d$export$aa35ef1f24408ab9(a[1]);
    const l = $b4460b24eea3ae4d$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$b4460b24eea3ae4d$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $b4460b24eea3ae4d$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $b4460b24eea3ae4d$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $b4460b24eea3ae4d$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($b4460b24eea3ae4d$var$names$1);
    const tkeys = Object.keys($b4460b24eea3ae4d$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $b4460b24eea3ae4d$var$map[k]);
        }
        k = parseInt($b4460b24eea3ae4d$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $b4460b24eea3ae4d$var$names;
function $b4460b24eea3ae4d$export$b2f06b640faad956(str) {
    if (!$b4460b24eea3ae4d$var$names) {
        $b4460b24eea3ae4d$var$names = $b4460b24eea3ae4d$var$unpack();
        $b4460b24eea3ae4d$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $b4460b24eea3ae4d$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $b4460b24eea3ae4d$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $b4460b24eea3ae4d$export$91aedb20f296e541(str) {
    const m = $b4460b24eea3ae4d$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $b4460b24eea3ae4d$export$bcc6e673dfa14d36(v) : $b4460b24eea3ae4d$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $b4460b24eea3ae4d$export$bcc6e673dfa14d36(r) : $b4460b24eea3ae4d$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $b4460b24eea3ae4d$export$bcc6e673dfa14d36(g) : $b4460b24eea3ae4d$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $b4460b24eea3ae4d$export$bcc6e673dfa14d36(b) : $b4460b24eea3ae4d$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $b4460b24eea3ae4d$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$b4460b24eea3ae4d$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $b4460b24eea3ae4d$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $b4460b24eea3ae4d$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $b4460b24eea3ae4d$var$interpolate(rgb1, rgb2, t) {
    const r = $b4460b24eea3ae4d$var$from($b4460b24eea3ae4d$export$dbf961a8d278dbef(rgb1.r));
    const g = $b4460b24eea3ae4d$var$from($b4460b24eea3ae4d$export$dbf961a8d278dbef(rgb1.g));
    const b = $b4460b24eea3ae4d$var$from($b4460b24eea3ae4d$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $b4460b24eea3ae4d$export$ed9bd8dcaeba14f6($b4460b24eea3ae4d$var$to(r + t * ($b4460b24eea3ae4d$var$from($b4460b24eea3ae4d$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $b4460b24eea3ae4d$export$ed9bd8dcaeba14f6($b4460b24eea3ae4d$var$to(g + t * ($b4460b24eea3ae4d$var$from($b4460b24eea3ae4d$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $b4460b24eea3ae4d$export$ed9bd8dcaeba14f6($b4460b24eea3ae4d$var$to(b + t * ($b4460b24eea3ae4d$var$from($b4460b24eea3ae4d$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $b4460b24eea3ae4d$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $b4460b24eea3ae4d$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $b4460b24eea3ae4d$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $b4460b24eea3ae4d$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $b4460b24eea3ae4d$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $b4460b24eea3ae4d$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $b4460b24eea3ae4d$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $b4460b24eea3ae4d$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $b4460b24eea3ae4d$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $b4460b24eea3ae4d$export$91aedb20f296e541(str);
    return $b4460b24eea3ae4d$export$5e91288c399be4f9(str);
}
class $b4460b24eea3ae4d$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $b4460b24eea3ae4d$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $b4460b24eea3ae4d$var$fromObject(input);
        else if (type === 'string') v = $b4460b24eea3ae4d$export$625a38b961e8b5e9(input) || $b4460b24eea3ae4d$export$b2f06b640faad956(input) || $b4460b24eea3ae4d$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $b4460b24eea3ae4d$var$clone(this._rgb);
        if (v) v.a = $b4460b24eea3ae4d$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $b4460b24eea3ae4d$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $b4460b24eea3ae4d$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $b4460b24eea3ae4d$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $b4460b24eea3ae4d$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $b4460b24eea3ae4d$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $b4460b24eea3ae4d$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $b4460b24eea3ae4d$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $b4460b24eea3ae4d$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $b4460b24eea3ae4d$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $b4460b24eea3ae4d$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $b4460b24eea3ae4d$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $b4460b24eea3ae4d$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $b4460b24eea3ae4d$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $b4460b24eea3ae4d$export$2e2bcd8739ae039(input) {
    return new $b4460b24eea3ae4d$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $b4325cd24db60028$export$cf2f7c5792f80b46() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $b4325cd24db60028$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $b4325cd24db60028$export$342063e11d6c3cad(value) {
    return value === null || typeof value === 'undefined';
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $b4325cd24db60028$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $b4325cd24db60028$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $b4325cd24db60028$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $b4325cd24db60028$export$c4ce752e73470fba(value, defaultValue) {
    return $b4325cd24db60028$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $b4325cd24db60028$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $b4325cd24db60028$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $b4325cd24db60028$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $b4325cd24db60028$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $b4325cd24db60028$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($b4325cd24db60028$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($b4325cd24db60028$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $b4325cd24db60028$export$995eb9fca571757(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $b4325cd24db60028$export$d377dcb2b61d6c4e(source) {
    if ($b4325cd24db60028$export$8b22cf2602fb60ce(source)) return source.map($b4325cd24db60028$export$d377dcb2b61d6c4e);
    if ($b4325cd24db60028$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $b4325cd24db60028$export$d377dcb2b61d6c4e(source[keys[k]]);
        return target;
    }
    return source;
}
function $b4325cd24db60028$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $b4325cd24db60028$export$667d3bf0c5f83305(key, target, source, options) {
    if (!$b4325cd24db60028$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($b4325cd24db60028$export$23f2a1d2818174ef(tval) && $b4325cd24db60028$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $b4325cd24db60028$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $b4325cd24db60028$export$d377dcb2b61d6c4e(sval);
}
function $b4325cd24db60028$export$efca4cbe5dd06740(target, source, options) {
    const sources = $b4325cd24db60028$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$b4325cd24db60028$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $b4325cd24db60028$export$667d3bf0c5f83305;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$b4325cd24db60028$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $b4325cd24db60028$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $b4325cd24db60028$export$efca4cbe5dd06740(target, source, {
        merger: $b4325cd24db60028$export$317a3d46287192d8
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $b4325cd24db60028$export$317a3d46287192d8(key, target, source) {
    if (!$b4325cd24db60028$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($b4325cd24db60028$export$23f2a1d2818174ef(tval) && $b4325cd24db60028$export$23f2a1d2818174ef(sval)) $b4325cd24db60028$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $b4325cd24db60028$export$d377dcb2b61d6c4e(sval);
}
/**
 * @private
 */ function $b4325cd24db60028$export$1ee57be6f6687d2c(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $b4325cd24db60028$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $b4325cd24db60028$export$9d0e2d13d04f7070(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $b4325cd24db60028$var$_getKeyResolver(key) {
    const keys = $b4325cd24db60028$export$9d0e2d13d04f7070(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $b4325cd24db60028$export$2d1720544b23b823(obj, key) {
    const resolver = $b4325cd24db60028$var$keyResolvers[key] || ($b4325cd24db60028$var$keyResolvers[key] = $b4325cd24db60028$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $b4325cd24db60028$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $b4325cd24db60028$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $b4325cd24db60028$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $b4325cd24db60028$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $b4325cd24db60028$export$f38c853ae54ed474(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $b4325cd24db60028$export$56c0d5a1e737357d = Math.PI;
const $b4325cd24db60028$export$971d5caa766a69d7 = 2 * $b4325cd24db60028$export$56c0d5a1e737357d;
const $b4325cd24db60028$export$d29e374196577086 = $b4325cd24db60028$export$971d5caa766a69d7 + $b4325cd24db60028$export$56c0d5a1e737357d;
const $b4325cd24db60028$export$2ec5befb9e6c97d4 = Number.POSITIVE_INFINITY;
const $b4325cd24db60028$export$53c86fa97d611818 = $b4325cd24db60028$export$56c0d5a1e737357d / 180;
const $b4325cd24db60028$export$7f8ddf7c7c20b3cd = $b4325cd24db60028$export$56c0d5a1e737357d / 2;
const $b4325cd24db60028$export$39c1cc7c062529d4 = $b4325cd24db60028$export$56c0d5a1e737357d / 4;
const $b4325cd24db60028$export$7a0bdf7d4a91ea88 = $b4325cd24db60028$export$56c0d5a1e737357d * 2 / 3;
const $b4325cd24db60028$export$9f4f30ee63539e24 = Math.log10;
const $b4325cd24db60028$export$2408f22a0fab9ae5 = Math.sign;
function $b4325cd24db60028$export$a05254e7c3aeba6e(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $b4325cd24db60028$export$a33b77bbdbb8366c(range) {
    const roundedRange = Math.round(range);
    range = $b4325cd24db60028$export$a05254e7c3aeba6e(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($b4325cd24db60028$export$9f4f30ee63539e24(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $b4325cd24db60028$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $b4325cd24db60028$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $b4325cd24db60028$export$b9a6b53f9be3734(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $b4325cd24db60028$export$53a70dd1ebbae346(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $b4325cd24db60028$export$625550452a3fa3ec(degrees) {
    return degrees * ($b4325cd24db60028$export$56c0d5a1e737357d / 180);
}
function $b4325cd24db60028$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $b4325cd24db60028$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $b4325cd24db60028$export$23ebac1979863676(x) {
    if (!$b4325cd24db60028$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $b4325cd24db60028$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $b4325cd24db60028$export$56c0d5a1e737357d) angle += $b4325cd24db60028$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $b4325cd24db60028$export$158acd800e1ef08b(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $b4325cd24db60028$export$c18d01048907ea92(a, b) {
    return (a - b + $b4325cd24db60028$export$d29e374196577086) % $b4325cd24db60028$export$971d5caa766a69d7 - $b4325cd24db60028$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $b4325cd24db60028$export$28f7fcd39efa255(a) {
    return (a % $b4325cd24db60028$export$971d5caa766a69d7 + $b4325cd24db60028$export$971d5caa766a69d7) % $b4325cd24db60028$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $b4325cd24db60028$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $b4325cd24db60028$export$28f7fcd39efa255(angle);
    const s = $b4325cd24db60028$export$28f7fcd39efa255(start);
    const e = $b4325cd24db60028$export$28f7fcd39efa255(end);
    const angleToStart = $b4325cd24db60028$export$28f7fcd39efa255(s - a);
    const angleToEnd = $b4325cd24db60028$export$28f7fcd39efa255(e - a);
    const startToAngle = $b4325cd24db60028$export$28f7fcd39efa255(a - s);
    const endToAngle = $b4325cd24db60028$export$28f7fcd39efa255(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $b4325cd24db60028$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $b4325cd24db60028$export$71cec2538cb2c617(value) {
    return $b4325cd24db60028$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $b4325cd24db60028$export$3b513254972cfc9c(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $b4325cd24db60028$export$2ed0fc6709e59212(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $b4325cd24db60028$export$ef35774e6d314e91 = (table, key, value, last)=>$b4325cd24db60028$export$2ed0fc6709e59212(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $b4325cd24db60028$export$ebd11618f299a286 = (table, key, value)=>$b4325cd24db60028$export$2ed0fc6709e59212(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $b4325cd24db60028$export$c03999cb2f36933f(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $b4325cd24db60028$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $b4325cd24db60028$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $b4325cd24db60028$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $b4325cd24db60028$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $b4325cd24db60028$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $b4325cd24db60028$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $b4325cd24db60028$export$71511d61b312f219(items) {
    const set = new Set();
    let i, ilen;
    for(i = 0, ilen = items.length; i < ilen; ++i)set.add(items[i]);
    if (set.size === ilen) return items;
    return Array.from(set);
}
function $b4325cd24db60028$export$fef3dfd9bad05307(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $b4325cd24db60028$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $b4325cd24db60028$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $b4325cd24db60028$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $b4325cd24db60028$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $b4325cd24db60028$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $b4325cd24db60028$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $b4325cd24db60028$export$9d398bebfec1c039 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $b4325cd24db60028$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $b4325cd24db60028$export$25ce5a424b770e84(Math.min($b4325cd24db60028$export$ef35774e6d314e91(_parsed, iScale.axis, min).lo, animationsDisabled ? pointCount : $b4325cd24db60028$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $b4325cd24db60028$export$25ce5a424b770e84(Math.max($b4325cd24db60028$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $b4325cd24db60028$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $b4325cd24db60028$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $b4325cd24db60028$var$atEdge = (t)=>t === 0 || t === 1;
const $b4325cd24db60028$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $b4325cd24db60028$export$971d5caa766a69d7 / p));
const $b4325cd24db60028$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $b4325cd24db60028$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $b4325cd24db60028$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $b4325cd24db60028$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $b4325cd24db60028$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($b4325cd24db60028$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$b4325cd24db60028$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$b4325cd24db60028$var$atEdge(t) ? t : $b4325cd24db60028$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$b4325cd24db60028$var$atEdge(t) ? t : $b4325cd24db60028$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $b4325cd24db60028$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $b4325cd24db60028$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $b4325cd24db60028$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $b4325cd24db60028$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $b4325cd24db60028$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $b4325cd24db60028$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $b4325cd24db60028$export$f96d196f7728bb5(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $b4325cd24db60028$export$db3b6bfb95261072(value) {
    return $b4325cd24db60028$export$f96d196f7728bb5(value) ? value : new (0, $b4460b24eea3ae4d$export$892596cec99bc70e)(value);
}
function $b4325cd24db60028$export$738ab4df8bf92ae9(value) {
    return $b4325cd24db60028$export$f96d196f7728bb5(value) ? value : new (0, $b4460b24eea3ae4d$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $b4325cd24db60028$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $b4325cd24db60028$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $b4325cd24db60028$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $b4325cd24db60028$var$colors
        },
        numbers: {
            type: 'number',
            properties: $b4325cd24db60028$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $b4325cd24db60028$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $b4325cd24db60028$var$intlCache = new Map();
function $b4325cd24db60028$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $b4325cd24db60028$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $b4325cd24db60028$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $b4325cd24db60028$export$ae1af26003f05816(num, locale, options) {
    return $b4325cd24db60028$var$getNumberFormat(locale, options).format(num);
}
const $b4325cd24db60028$var$formatters = {
    values (value) {
        return $b4325cd24db60028$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $b4325cd24db60028$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $b4325cd24db60028$export$9f4f30ee63539e24(Math.abs(delta));
        const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $b4325cd24db60028$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($b4325cd24db60028$export$9f4f30ee63539e24(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $b4325cd24db60028$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $b4325cd24db60028$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $b4325cd24db60028$export$91477dc880baac21 = {
    formatters: $b4325cd24db60028$var$formatters
};
function $b4325cd24db60028$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $b4325cd24db60028$export$91477dc880baac21.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $b4325cd24db60028$export$6559d589eb85fbb6 = Object.create(null);
const $b4325cd24db60028$export$2e2af4578d910ddf = Object.create(null);
function $b4325cd24db60028$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $b4325cd24db60028$var$set(root, scope, values) {
    if (typeof scope === 'string') return $b4325cd24db60028$export$efca4cbe5dd06740($b4325cd24db60028$var$getScope$1(root, scope), values);
    return $b4325cd24db60028$export$efca4cbe5dd06740($b4325cd24db60028$var$getScope$1(root, ''), scope);
}
class $b4325cd24db60028$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$b4325cd24db60028$export$738ab4df8bf92ae9(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$b4325cd24db60028$export$738ab4df8bf92ae9(options.borderColor);
        this.hoverColor = (ctx, options)=>$b4325cd24db60028$export$738ab4df8bf92ae9(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $b4325cd24db60028$var$set(this, scope, values);
    }
    get(scope) {
        return $b4325cd24db60028$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $b4325cd24db60028$var$set($b4325cd24db60028$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $b4325cd24db60028$var$set($b4325cd24db60028$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $b4325cd24db60028$var$getScope$1(this, scope);
        const targetScopeObject = $b4325cd24db60028$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($b4325cd24db60028$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $b4325cd24db60028$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $b4325cd24db60028$export$4368d992c4eafac0 = /* #__PURE__ */ new $b4325cd24db60028$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $b4325cd24db60028$var$applyAnimationsDefaults,
    $b4325cd24db60028$var$applyLayoutsDefaults,
    $b4325cd24db60028$var$applyScaleDefaults
]);
function $b4325cd24db60028$export$1a8f5705751d8277(font) {
    if (!font || $b4325cd24db60028$export$342063e11d6c3cad(font.size) || $b4325cd24db60028$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
function $b4325cd24db60028$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
function $b4325cd24db60028$export$faec65b429be379(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        if (thing !== undefined && thing !== null && $b4325cd24db60028$export$8b22cf2602fb60ce(thing) !== true) longest = $b4325cd24db60028$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($b4325cd24db60028$export$8b22cf2602fb60ce(thing)) for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            if (nestedThing !== undefined && nestedThing !== null && !$b4325cd24db60028$export$8b22cf2602fb60ce(nestedThing)) longest = $b4325cd24db60028$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
function $b4325cd24db60028$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function $b4325cd24db60028$export$c9170ad7d4cd7e57(canvas, ctx) {
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $b4325cd24db60028$export$493d36ec626b6698(ctx, options, x, y) {
    $b4325cd24db60028$export$24baa2b76016ce0e(ctx, options, x, y, null);
}
function $b4325cd24db60028$export$24baa2b76016ce0e(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $b4325cd24db60028$export$53c86fa97d611818;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $b4325cd24db60028$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $b4325cd24db60028$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $b4325cd24db60028$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $b4325cd24db60028$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $b4325cd24db60028$export$39c1cc7c062529d4) * size;
            xOffsetW = Math.cos(rad + $b4325cd24db60028$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $b4325cd24db60028$export$39c1cc7c062529d4) * size;
            yOffsetW = Math.sin(rad + $b4325cd24db60028$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $b4325cd24db60028$export$56c0d5a1e737357d, rad - $b4325cd24db60028$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $b4325cd24db60028$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $b4325cd24db60028$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $b4325cd24db60028$export$7f8ddf7c7c20b3cd, rad + $b4325cd24db60028$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $b4325cd24db60028$export$39c1cc7c062529d4;
        case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $b4325cd24db60028$export$39c1cc7c062529d4;
        case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $b4325cd24db60028$export$39c1cc7c062529d4;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
function $b4325cd24db60028$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5;
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $b4325cd24db60028$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $b4325cd24db60028$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
function $b4325cd24db60028$export$d24c54395ce0c509(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
function $b4325cd24db60028$export$6554612db691658e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $b4325cd24db60028$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $b4325cd24db60028$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $b4325cd24db60028$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $b4325cd24db60028$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$b4325cd24db60028$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $b4325cd24db60028$var$decorateText(ctx, x, y, line, opts);
        y += font.lineHeight;
    }
    ctx.restore();
}
function $b4325cd24db60028$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$b4325cd24db60028$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $b4325cd24db60028$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $b4325cd24db60028$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
function $b4325cd24db60028$export$1fbe638ecf81657e(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -$b4325cd24db60028$export$7f8ddf7c7c20b3cd, $b4325cd24db60028$export$56c0d5a1e737357d, true);
    ctx.lineTo(x, y + h - radius.bottomLeft);
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $b4325cd24db60028$export$56c0d5a1e737357d, $b4325cd24db60028$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $b4325cd24db60028$export$7f8ddf7c7c20b3cd, 0, true);
    ctx.lineTo(x + w, y + radius.topRight);
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$b4325cd24db60028$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + radius.topLeft, y);
}
const $b4325cd24db60028$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $b4325cd24db60028$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $b4325cd24db60028$export$8c78c7c36408ea29(value, size) {
    const matches = ('' + value).match($b4325cd24db60028$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $b4325cd24db60028$var$numberOrZero = (v)=>+v || 0;
function $b4325cd24db60028$export$21579262ef46735b(value, props) {
    const ret = {};
    const objProps = $b4325cd24db60028$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $b4325cd24db60028$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$b4325cd24db60028$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $b4325cd24db60028$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $b4325cd24db60028$export$d66dc83d8cfc8dd(value) {
    return $b4325cd24db60028$export$21579262ef46735b(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $b4325cd24db60028$export$92108d983e8ee699(value) {
    return $b4325cd24db60028$export$21579262ef46735b(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $b4325cd24db60028$export$a9c23c6ac3fc3eca(value) {
    const obj = $b4325cd24db60028$export$d66dc83d8cfc8dd(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $b4325cd24db60028$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $b4325cd24db60028$export$4368d992c4eafac0.font;
    let size = $b4325cd24db60028$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $b4325cd24db60028$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($b4325cd24db60028$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $b4325cd24db60028$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $b4325cd24db60028$export$8c78c7c36408ea29($b4325cd24db60028$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $b4325cd24db60028$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $b4325cd24db60028$export$1a8f5705751d8277(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $b4325cd24db60028$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $b4325cd24db60028$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $b4325cd24db60028$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $b4325cd24db60028$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $b4325cd24db60028$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
function $b4325cd24db60028$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes = scopes, fallback, getTarget = ()=>scopes[0]) {
    if (!$b4325cd24db60028$export$dda1d9f60106f0e9(fallback)) fallback = $b4325cd24db60028$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: rootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$b4325cd24db60028$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, rootScopes, fallback)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete target._keys;
            delete scopes[0][prop];
            return true;
        },
        get (target, prop) {
            return $b4325cd24db60028$var$_cached(target, prop, ()=>$b4325cd24db60028$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        has (target, prop) {
            return $b4325cd24db60028$var$getKeysFromAllScopes(target).includes(prop);
        },
        ownKeys (target) {
            return $b4325cd24db60028$var$getKeysFromAllScopes(target);
        },
        set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value;
            delete target._keys;
            return true;
        }
    });
}
function $b4325cd24db60028$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $b4325cd24db60028$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$b4325cd24db60028$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$b4325cd24db60028$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete proxy[prop];
            return true;
        },
        get (target, prop, receiver) {
            return $b4325cd24db60028$var$_cached(target, prop, ()=>$b4325cd24db60028$var$_resolveWithContext(target, prop, receiver));
        },
        getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        set (target, prop, value) {
            proxy[prop] = value;
            delete target[prop];
            return true;
        }
    });
}
function $b4325cd24db60028$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $b4325cd24db60028$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $b4325cd24db60028$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $b4325cd24db60028$var$readKey = (prefix, name)=>prefix ? prefix + $b4325cd24db60028$export$a8550f7dbe79f93a(name) : name;
const $b4325cd24db60028$var$needsSubResolver = (prop, value)=>$b4325cd24db60028$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $b4325cd24db60028$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve();
    target[prop] = value;
    return value;
}
function $b4325cd24db60028$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop];
    if ($b4325cd24db60028$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $b4325cd24db60028$var$_resolveScriptable(prop, value, target, receiver);
    if ($b4325cd24db60028$export$8b22cf2602fb60ce(value) && value.length) value = $b4325cd24db60028$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($b4325cd24db60028$var$needsSubResolver(prop, value)) value = $b4325cd24db60028$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $b4325cd24db60028$var$_resolveScriptable(prop, value, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    value = value(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($b4325cd24db60028$var$needsSubResolver(prop, value)) value = $b4325cd24db60028$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $b4325cd24db60028$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if ($b4325cd24db60028$export$dda1d9f60106f0e9(_context.index) && isIndexable(prop)) value = value[_context.index % value.length];
    else if ($b4325cd24db60028$export$23f2a1d2818174ef(value[0])) {
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $b4325cd24db60028$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($b4325cd24db60028$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $b4325cd24db60028$var$resolveFallback(fallback, prop, value) {
    return $b4325cd24db60028$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $b4325cd24db60028$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $b4325cd24db60028$export$2d1720544b23b823(parent, key) : undefined;
function $b4325cd24db60028$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $b4325cd24db60028$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $b4325cd24db60028$var$resolveFallback(scope._fallback, key, value);
            if ($b4325cd24db60028$export$dda1d9f60106f0e9(fallback) && fallback !== key && fallback !== parentFallback) return fallback;
        } else if (scope === false && $b4325cd24db60028$export$dda1d9f60106f0e9(parentFallback) && key !== parentFallback) return null;
    }
    return false;
}
function $b4325cd24db60028$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $b4325cd24db60028$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $b4325cd24db60028$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if ($b4325cd24db60028$export$dda1d9f60106f0e9(fallback) && fallback !== prop) {
        key = $b4325cd24db60028$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $b4325cd24db60028$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$b4325cd24db60028$var$subGetTarget(resolver, prop, value));
}
function $b4325cd24db60028$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $b4325cd24db60028$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $b4325cd24db60028$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($b4325cd24db60028$export$8b22cf2602fb60ce(target) && $b4325cd24db60028$export$23f2a1d2818174ef(value)) return value;
    return target || {};
}
function $b4325cd24db60028$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $b4325cd24db60028$var$_resolve($b4325cd24db60028$var$readKey(prefix, prop), scopes);
        if ($b4325cd24db60028$export$dda1d9f60106f0e9(value)) return $b4325cd24db60028$var$needsSubResolver(prop, value) ? $b4325cd24db60028$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $b4325cd24db60028$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if ($b4325cd24db60028$export$dda1d9f60106f0e9(value)) return value;
    }
}
function $b4325cd24db60028$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $b4325cd24db60028$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $b4325cd24db60028$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $b4325cd24db60028$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($b4325cd24db60028$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $b4325cd24db60028$var$EPSILON = Number.EPSILON || 1e-14;
const $b4325cd24db60028$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $b4325cd24db60028$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $b4325cd24db60028$export$e171bab687b50e0(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $b4325cd24db60028$export$158acd800e1ef08b(current, previous);
    const d12 = $b4325cd24db60028$export$158acd800e1ef08b(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $b4325cd24db60028$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $b4325cd24db60028$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $b4325cd24db60028$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($b4325cd24db60028$export$a05254e7c3aeba6e(deltaK[i], 0, $b4325cd24db60028$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $b4325cd24db60028$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $b4325cd24db60028$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $b4325cd24db60028$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $b4325cd24db60028$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $b4325cd24db60028$export$527e9aa3390079e9(points, indexAxis = 'x') {
    const valueAxis = $b4325cd24db60028$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $b4325cd24db60028$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $b4325cd24db60028$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $b4325cd24db60028$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $b4325cd24db60028$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $b4325cd24db60028$var$monotoneAdjust(points, deltaK, mK);
    $b4325cd24db60028$var$monotoneCompute(points, mK, indexAxis);
}
function $b4325cd24db60028$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $b4325cd24db60028$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $b4325cd24db60028$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $b4325cd24db60028$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $b4325cd24db60028$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $b4325cd24db60028$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $b4325cd24db60028$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $b4325cd24db60028$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $b4325cd24db60028$export$ab83b03e4111b1d0(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $b4325cd24db60028$export$527e9aa3390079e9(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $b4325cd24db60028$export$e171bab687b50e0(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $b4325cd24db60028$var$capBezierPoints(points, area);
}
/**
 * Note: typedefs are auto-exported, so use a made-up `dom` namespace where
 * necessary to avoid duplicates with `export * from './helpers`; see
 * https://github.com/microsoft/TypeScript/issues/46011
 * @typedef { import('../core/core.controller.js').default } dom.Chart
 * @typedef { import('../../types').ChartEvent } ChartEvent
 */ /**
 * @private
 */ function $b4325cd24db60028$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $b4325cd24db60028$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $b4325cd24db60028$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $b4325cd24db60028$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $b4325cd24db60028$export$a17c37559e1db147(el, property) {
    return $b4325cd24db60028$var$getComputedStyle(el).getPropertyValue(property);
}
const $b4325cd24db60028$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $b4325cd24db60028$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $b4325cd24db60028$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $b4325cd24db60028$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $b4325cd24db60028$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($b4325cd24db60028$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $b4325cd24db60028$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $b4325cd24db60028$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $b4325cd24db60028$var$getPositionedStyle(style, 'padding');
    const borders = $b4325cd24db60028$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $b4325cd24db60028$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $b4325cd24db60028$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $b4325cd24db60028$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $b4325cd24db60028$var$getComputedStyle(container);
            const containerBorder = $b4325cd24db60028$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $b4325cd24db60028$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $b4325cd24db60028$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $b4325cd24db60028$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $b4325cd24db60028$export$2ec5befb9e6c97d4,
        maxHeight: maxHeight || $b4325cd24db60028$export$2ec5befb9e6c97d4
    };
}
const $b4325cd24db60028$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $b4325cd24db60028$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $b4325cd24db60028$var$getComputedStyle(canvas);
    const margins = $b4325cd24db60028$var$getPositionedStyle(style, 'margin');
    const maxWidth = $b4325cd24db60028$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $b4325cd24db60028$export$2ec5befb9e6c97d4;
    const maxHeight = $b4325cd24db60028$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $b4325cd24db60028$export$2ec5befb9e6c97d4;
    const containerSize = $b4325cd24db60028$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $b4325cd24db60028$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $b4325cd24db60028$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $b4325cd24db60028$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $b4325cd24db60028$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $b4325cd24db60028$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $b4325cd24db60028$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $b4325cd24db60028$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $b4325cd24db60028$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        window.addEventListener('test', null, options);
        window.removeEventListener('test', null, options);
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $b4325cd24db60028$export$b4171a6734a65d42(element, property) {
    const value = $b4325cd24db60028$export$a17c37559e1db147(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $b4325cd24db60028$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $b4325cd24db60028$export$7a38258bbe170828(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $b4325cd24db60028$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $b4325cd24db60028$export$8a5498727ef6be21(p1, cp1, t);
    const b = $b4325cd24db60028$export$8a5498727ef6be21(cp1, cp2, t);
    const c = $b4325cd24db60028$export$8a5498727ef6be21(cp2, p2, t);
    const d = $b4325cd24db60028$export$8a5498727ef6be21(a, b, t);
    const e = $b4325cd24db60028$export$8a5498727ef6be21(b, c, t);
    return $b4325cd24db60028$export$8a5498727ef6be21(d, e, t);
}
const $b4325cd24db60028$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $b4325cd24db60028$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $b4325cd24db60028$export$3d12bd131bb975d1(rtl, rectX, width) {
    return rtl ? $b4325cd24db60028$var$getRightToLeftAdapter(rectX, width) : $b4325cd24db60028$var$getLeftToRightAdapter();
}
function $b4325cd24db60028$export$91c6e00c14e7e6fd(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $b4325cd24db60028$export$890c4ad488842ce7(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $b4325cd24db60028$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $b4325cd24db60028$export$ffb5f4729a158638,
        compare: $b4325cd24db60028$export$c18d01048907ea92,
        normalize: $b4325cd24db60028$export$28f7fcd39efa255
    };
    return {
        between: $b4325cd24db60028$export$3b513254972cfc9c,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $b4325cd24db60028$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $b4325cd24db60028$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $b4325cd24db60028$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $b4325cd24db60028$export$9fa96a7d116ea3ce(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $b4325cd24db60028$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $b4325cd24db60028$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($b4325cd24db60028$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($b4325cd24db60028$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $b4325cd24db60028$export$306ddfe3a8403e2(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $b4325cd24db60028$export$9fa96a7d116ea3ce(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $b4325cd24db60028$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $b4325cd24db60028$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $b4325cd24db60028$export$1a82df3d29112e01(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $b4325cd24db60028$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $b4325cd24db60028$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $b4325cd24db60028$var$splitByStyles(line, $b4325cd24db60028$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $b4325cd24db60028$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $b4325cd24db60028$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $b4325cd24db60028$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $b4325cd24db60028$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $b4325cd24db60028$var$readStyle(segmentOptions.setContext($b4325cd24db60028$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($b4325cd24db60028$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $b4325cd24db60028$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $b4325cd24db60028$var$styleChanged(style, prevStyle) {
    return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}



class $87f4fbac7cf060d6$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $b4325cd24db60028$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $87f4fbac7cf060d6$export$a424a0aa8f687495 = /* #__PURE__ */ new $87f4fbac7cf060d6$var$Animator();
const $87f4fbac7cf060d6$var$transparent = 'transparent';
const $87f4fbac7cf060d6$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $b4325cd24db60028$export$db3b6bfb95261072)(from || $87f4fbac7cf060d6$var$transparent);
        const c1 = c0.valid && (0, $b4325cd24db60028$export$db3b6bfb95261072)(to || $87f4fbac7cf060d6$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $87f4fbac7cf060d6$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $b4325cd24db60028$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $b4325cd24db60028$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $87f4fbac7cf060d6$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $b4325cd24db60028$export$f1e1789686576879)[cfg.easing] || (0, $b4325cd24db60028$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $b4325cd24db60028$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $b4325cd24db60028$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $87f4fbac7cf060d6$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $b4325cd24db60028$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $b4325cd24db60028$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $b4325cd24db60028$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $b4325cd24db60028$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $87f4fbac7cf060d6$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $87f4fbac7cf060d6$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $87f4fbac7cf060d6$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $87f4fbac7cf060d6$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $87f4fbac7cf060d6$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $87f4fbac7cf060d6$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $87f4fbac7cf060d6$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $87f4fbac7cf060d6$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $87f4fbac7cf060d6$var$scaleClip(xScale, allowedOverflow);
    const y = $87f4fbac7cf060d6$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $87f4fbac7cf060d6$var$toClip(value) {
    let t, r, b, l;
    if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $87f4fbac7cf060d6$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $87f4fbac7cf060d6$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $b4325cd24db60028$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $b4325cd24db60028$export$2408f22a0fab9ae5)(value) === (0, $b4325cd24db60028$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    return value;
}
function $87f4fbac7cf060d6$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $87f4fbac7cf060d6$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $87f4fbac7cf060d6$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $87f4fbac7cf060d6$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $87f4fbac7cf060d6$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $87f4fbac7cf060d6$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $87f4fbac7cf060d6$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $87f4fbac7cf060d6$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $87f4fbac7cf060d6$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $87f4fbac7cf060d6$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $87f4fbac7cf060d6$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $87f4fbac7cf060d6$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $87f4fbac7cf060d6$var$createDatasetContext(parent, index) {
    return (0, $b4325cd24db60028$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $87f4fbac7cf060d6$var$createDataContext(parent, index, element) {
    return (0, $b4325cd24db60028$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $87f4fbac7cf060d6$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $87f4fbac7cf060d6$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $87f4fbac7cf060d6$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $87f4fbac7cf060d6$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $87f4fbac7cf060d6$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $87f4fbac7cf060d6$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $87f4fbac7cf060d6$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $87f4fbac7cf060d6$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $b4325cd24db60028$export$90a7f3efeed30595)(dataset.xAxisID, $87f4fbac7cf060d6$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $b4325cd24db60028$export$90a7f3efeed30595)(dataset.yAxisID, $87f4fbac7cf060d6$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $b4325cd24db60028$export$90a7f3efeed30595)(dataset.rAxisID, $87f4fbac7cf060d6$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $b4325cd24db60028$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $87f4fbac7cf060d6$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(data)) this._data = $87f4fbac7cf060d6$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $b4325cd24db60028$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $87f4fbac7cf060d6$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $b4325cd24db60028$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $87f4fbac7cf060d6$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $87f4fbac7cf060d6$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $87f4fbac7cf060d6$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $b4325cd24db60028$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $87f4fbac7cf060d6$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $b4325cd24db60028$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $b4325cd24db60028$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $87f4fbac7cf060d6$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $87f4fbac7cf060d6$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $87f4fbac7cf060d6$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $87f4fbac7cf060d6$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $87f4fbac7cf060d6$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $b4325cd24db60028$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $b4325cd24db60028$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $87f4fbac7cf060d6$var$toClip((0, $b4325cd24db60028$export$90a7f3efeed30595)(this.options.clip, $87f4fbac7cf060d6$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $87f4fbac7cf060d6$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $87f4fbac7cf060d6$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $b4325cd24db60028$export$dda1d9f60106f0e9)(index);
        if (cached) return $87f4fbac7cf060d6$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $b4325cd24db60028$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($87f4fbac7cf060d6$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $87f4fbac7cf060d6$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $87f4fbac7cf060d6$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($87f4fbac7cf060d6$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$87f4fbac7cf060d6$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $87f4fbac7cf060d6$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $87f4fbac7cf060d6$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $b4325cd24db60028$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $87f4fbac7cf060d6$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $87f4fbac7cf060d6$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $b4325cd24db60028$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $87f4fbac7cf060d6$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $b4325cd24db60028$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $87f4fbac7cf060d6$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $87f4fbac7cf060d6$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $87f4fbac7cf060d6$var$parseValue(entry, item, vScale, i) {
    if ((0, $b4325cd24db60028$export$8b22cf2602fb60ce)(entry)) $87f4fbac7cf060d6$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $87f4fbac7cf060d6$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($87f4fbac7cf060d6$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $87f4fbac7cf060d6$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $87f4fbac7cf060d6$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $b4325cd24db60028$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $87f4fbac7cf060d6$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $87f4fbac7cf060d6$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $87f4fbac7cf060d6$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$87f4fbac7cf060d6$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$87f4fbac7cf060d6$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $87f4fbac7cf060d6$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $87f4fbac7cf060d6$var$swap(edge, a, b);
        edge = $87f4fbac7cf060d6$var$startEnd(edge, b, a);
    } else edge = $87f4fbac7cf060d6$var$startEnd(edge, a, b);
    return edge;
}
function $87f4fbac7cf060d6$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $87f4fbac7cf060d6$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $87f4fbac7cf060d6$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $87f4fbac7cf060d6$export$e97d5dc64e999004 extends $87f4fbac7cf060d6$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $87f4fbac7cf060d6$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $87f4fbac7cf060d6$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $b4325cd24db60028$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($87f4fbac7cf060d6$var$parseValue((0, $b4325cd24db60028$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $87f4fbac7cf060d6$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $b4325cd24db60028$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $87f4fbac7cf060d6$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $87f4fbac7cf060d6$var$setBorderSkipped(properties, options, stack, index);
            $87f4fbac7cf060d6$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $b4325cd24db60028$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name1, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name1 !== undefined ? stacks.indexOf(name1) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $87f4fbac7cf060d6$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $87f4fbac7cf060d6$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $b4325cd24db60028$export$2408f22a0fab9ae5)(value) !== (0, $b4325cd24db60028$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $b4325cd24db60028$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $87f4fbac7cf060d6$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $b4325cd24db60028$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $b4325cd24db60028$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $87f4fbac7cf060d6$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $87f4fbac7cf060d6$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
class $87f4fbac7cf060d6$export$19b5c4773f17abe extends $87f4fbac7cf060d6$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $b4325cd24db60028$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $b4325cd24db60028$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $b4325cd24db60028$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $87f4fbac7cf060d6$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $b4325cd24db60028$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $b4325cd24db60028$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $b4325cd24db60028$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $b4325cd24db60028$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $b4325cd24db60028$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $b4325cd24db60028$export$56c0d5a1e737357d) + (0, $b4325cd24db60028$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $87f4fbac7cf060d6$export$e04603e7d8b77172 extends $87f4fbac7cf060d6$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name1)=>name1 !== 'spacing',
        _indexable: (name1)=>name1 !== 'spacing'
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $b4325cd24db60028$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $b4325cd24db60028$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $b4325cd24db60028$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $b4325cd24db60028$export$971d5caa766a69d7);
        let max = -(0, $b4325cd24db60028$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $b4325cd24db60028$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $87f4fbac7cf060d6$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $b4325cd24db60028$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $b4325cd24db60028$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $b4325cd24db60028$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $b4325cd24db60028$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $b4325cd24db60028$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $87f4fbac7cf060d6$export$3c9b5d28c11cbfd0 extends $87f4fbac7cf060d6$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $b4325cd24db60028$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $b4325cd24db60028$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $b4325cd24db60028$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $b4325cd24db60028$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $87f4fbac7cf060d6$export$2a270b3a0d973c85 extends $87f4fbac7cf060d6$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $b4325cd24db60028$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $b4325cd24db60028$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $b4325cd24db60028$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $b4325cd24db60028$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $87f4fbac7cf060d6$export$b21a3f1286706191 extends $87f4fbac7cf060d6$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $87f4fbac7cf060d6$export$48dbc6ac651bf8be extends $87f4fbac7cf060d6$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $b4325cd24db60028$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $87f4fbac7cf060d6$export$b2f2bae6713db87 extends $87f4fbac7cf060d6$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $b4325cd24db60028$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $b4325cd24db60028$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $b4325cd24db60028$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $b4325cd24db60028$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $87f4fbac7cf060d6$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $87f4fbac7cf060d6$export$e97d5dc64e999004,
    BubbleController: $87f4fbac7cf060d6$export$19b5c4773f17abe,
    DoughnutController: $87f4fbac7cf060d6$export$e04603e7d8b77172,
    LineController: $87f4fbac7cf060d6$export$3c9b5d28c11cbfd0,
    PolarAreaController: $87f4fbac7cf060d6$export$2a270b3a0d973c85,
    PieController: $87f4fbac7cf060d6$export$b21a3f1286706191,
    RadarController: $87f4fbac7cf060d6$export$48dbc6ac651bf8be,
    ScatterController: $87f4fbac7cf060d6$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $87f4fbac7cf060d6$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $87f4fbac7cf060d6$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($87f4fbac7cf060d6$var$DateAdapterBase.prototype, members);
    }
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $87f4fbac7cf060d6$var$abstract();
    }
    parse() {
        return $87f4fbac7cf060d6$var$abstract();
    }
    format() {
        return $87f4fbac7cf060d6$var$abstract();
    }
    add() {
        return $87f4fbac7cf060d6$var$abstract();
    }
    diff() {
        return $87f4fbac7cf060d6$var$abstract();
    }
    startOf() {
        return $87f4fbac7cf060d6$var$abstract();
    }
    endOf() {
        return $87f4fbac7cf060d6$var$abstract();
    }
}
var $87f4fbac7cf060d6$export$f32766ea09ec8bc4 = {
    _date: $87f4fbac7cf060d6$var$DateAdapterBase
};
function $87f4fbac7cf060d6$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $b4325cd24db60028$export$ebd11618f299a286) : (0, $b4325cd24db60028$export$ef35774e6d314e91);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $87f4fbac7cf060d6$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $87f4fbac7cf060d6$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $87f4fbac7cf060d6$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $87f4fbac7cf060d6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $b4325cd24db60028$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $87f4fbac7cf060d6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $87f4fbac7cf060d6$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $b4325cd24db60028$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $b4325cd24db60028$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $87f4fbac7cf060d6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $87f4fbac7cf060d6$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $87f4fbac7cf060d6$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $87f4fbac7cf060d6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $87f4fbac7cf060d6$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $87f4fbac7cf060d6$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $87f4fbac7cf060d6$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $87f4fbac7cf060d6$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $87f4fbac7cf060d6$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $87f4fbac7cf060d6$export$a13296960cae0384 = {
    evaluateInteractionItems: $87f4fbac7cf060d6$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $b4325cd24db60028$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $87f4fbac7cf060d6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $87f4fbac7cf060d6$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $b4325cd24db60028$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $87f4fbac7cf060d6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $87f4fbac7cf060d6$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $b4325cd24db60028$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $87f4fbac7cf060d6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $b4325cd24db60028$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $87f4fbac7cf060d6$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $b4325cd24db60028$export$df995fae86a55f06)(e, chart);
            return $87f4fbac7cf060d6$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $b4325cd24db60028$export$df995fae86a55f06)(e, chart);
            return $87f4fbac7cf060d6$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $87f4fbac7cf060d6$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $87f4fbac7cf060d6$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $87f4fbac7cf060d6$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$87f4fbac7cf060d6$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $87f4fbac7cf060d6$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $87f4fbac7cf060d6$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $87f4fbac7cf060d6$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$87f4fbac7cf060d6$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $87f4fbac7cf060d6$var$setLayoutDims(layouts, params) {
    const stacks = $87f4fbac7cf060d6$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $87f4fbac7cf060d6$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $87f4fbac7cf060d6$var$wrapBoxes(boxes);
    const fullSize = $87f4fbac7cf060d6$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $87f4fbac7cf060d6$var$sortByWeight($87f4fbac7cf060d6$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $87f4fbac7cf060d6$var$sortByWeight($87f4fbac7cf060d6$var$filterByPosition(layoutBoxes, 'right'));
    const top = $87f4fbac7cf060d6$var$sortByWeight($87f4fbac7cf060d6$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $87f4fbac7cf060d6$var$sortByWeight($87f4fbac7cf060d6$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $87f4fbac7cf060d6$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $87f4fbac7cf060d6$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $87f4fbac7cf060d6$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $87f4fbac7cf060d6$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $87f4fbac7cf060d6$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $87f4fbac7cf060d6$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $b4325cd24db60028$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $87f4fbac7cf060d6$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $87f4fbac7cf060d6$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $87f4fbac7cf060d6$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $87f4fbac7cf060d6$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $87f4fbac7cf060d6$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $87f4fbac7cf060d6$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $87f4fbac7cf060d6$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $87f4fbac7cf060d6$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $87f4fbac7cf060d6$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $87f4fbac7cf060d6$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $87f4fbac7cf060d6$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $b4325cd24db60028$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $87f4fbac7cf060d6$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $87f4fbac7cf060d6$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height1 = chartArea.h * weight;
            const width1 = stack.size || box.width;
            if ((0, $b4325cd24db60028$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $87f4fbac7cf060d6$var$setBoxDims(box, x, userPadding.top, width1, params.outerHeight - userPadding.bottom - userPadding.top);
            else $87f4fbac7cf060d6$var$setBoxDims(box, x, chartArea.top + stack.placed, width1, height1);
            stack.start = x;
            stack.placed += height1;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $87f4fbac7cf060d6$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $87f4fbac7cf060d6$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $b4325cd24db60028$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $87f4fbac7cf060d6$var$updateMaxPadding(maxPadding, (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $87f4fbac7cf060d6$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $87f4fbac7cf060d6$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $87f4fbac7cf060d6$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($87f4fbac7cf060d6$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $87f4fbac7cf060d6$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $87f4fbac7cf060d6$var$handleMaxPadding(chartArea);
        $87f4fbac7cf060d6$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $87f4fbac7cf060d6$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $b4325cd24db60028$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $87f4fbac7cf060d6$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $87f4fbac7cf060d6$export$a40a96b24b46cf35 extends $87f4fbac7cf060d6$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $87f4fbac7cf060d6$var$EXPANDO_KEY = '$chartjs';
const $87f4fbac7cf060d6$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $87f4fbac7cf060d6$var$isNullOrEmpty = (value)=>value === null || value === '';
function $87f4fbac7cf060d6$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$87f4fbac7cf060d6$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($87f4fbac7cf060d6$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $b4325cd24db60028$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($87f4fbac7cf060d6$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $b4325cd24db60028$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $87f4fbac7cf060d6$var$eventListenerOptions = (0, $b4325cd24db60028$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $87f4fbac7cf060d6$var$addListener(node, type, listener) {
    node.addEventListener(type, listener, $87f4fbac7cf060d6$var$eventListenerOptions);
}
function $87f4fbac7cf060d6$var$removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, $87f4fbac7cf060d6$var$eventListenerOptions);
}
function $87f4fbac7cf060d6$var$fromNativeEvent(event, chart) {
    const type = $87f4fbac7cf060d6$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $b4325cd24db60028$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $87f4fbac7cf060d6$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $87f4fbac7cf060d6$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $87f4fbac7cf060d6$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$87f4fbac7cf060d6$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $87f4fbac7cf060d6$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $87f4fbac7cf060d6$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$87f4fbac7cf060d6$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $87f4fbac7cf060d6$var$drpListeningCharts = new Map();
let $87f4fbac7cf060d6$var$oldDevicePixelRatio = 0;
function $87f4fbac7cf060d6$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $87f4fbac7cf060d6$var$oldDevicePixelRatio) return;
    $87f4fbac7cf060d6$var$oldDevicePixelRatio = dpr;
    $87f4fbac7cf060d6$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $87f4fbac7cf060d6$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$87f4fbac7cf060d6$var$drpListeningCharts.size) window.addEventListener('resize', $87f4fbac7cf060d6$var$onWindowResize);
    $87f4fbac7cf060d6$var$drpListeningCharts.set(chart, resize);
}
function $87f4fbac7cf060d6$var$unlistenDevicePixelRatioChanges(chart) {
    $87f4fbac7cf060d6$var$drpListeningCharts.delete(chart);
    if (!$87f4fbac7cf060d6$var$drpListeningCharts.size) window.removeEventListener('resize', $87f4fbac7cf060d6$var$onWindowResize);
}
function $87f4fbac7cf060d6$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $b4325cd24db60028$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $b4325cd24db60028$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $87f4fbac7cf060d6$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $87f4fbac7cf060d6$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $87f4fbac7cf060d6$var$unlistenDevicePixelRatioChanges(chart);
}
function $87f4fbac7cf060d6$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $b4325cd24db60028$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($87f4fbac7cf060d6$var$fromNativeEvent(event, chart));
    }, chart);
    $87f4fbac7cf060d6$var$addListener(canvas, type, proxy);
    return proxy;
}
class $87f4fbac7cf060d6$export$f02da7f882cf6b2e extends $87f4fbac7cf060d6$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $87f4fbac7cf060d6$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$87f4fbac7cf060d6$var$EXPANDO_KEY]) return false;
        const initial = canvas[$87f4fbac7cf060d6$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $b4325cd24db60028$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$87f4fbac7cf060d6$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $87f4fbac7cf060d6$var$createAttachObserver,
            detach: $87f4fbac7cf060d6$var$createDetachObserver,
            resize: $87f4fbac7cf060d6$var$createResizeObserver
        };
        const handler = handlers[type] || $87f4fbac7cf060d6$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $87f4fbac7cf060d6$var$releaseObserver,
            detach: $87f4fbac7cf060d6$var$releaseObserver,
            resize: $87f4fbac7cf060d6$var$releaseObserver
        };
        const handler = handlers[type] || $87f4fbac7cf060d6$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $b4325cd24db60028$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $b4325cd24db60028$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $87f4fbac7cf060d6$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $b4325cd24db60028$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $87f4fbac7cf060d6$export$a40a96b24b46cf35;
    return $87f4fbac7cf060d6$export$f02da7f882cf6b2e;
}
class $87f4fbac7cf060d6$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    active = false;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $b4325cd24db60028$export$d141bba7fdc215a3)(this.x) && (0, $b4325cd24db60028$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $87f4fbac7cf060d6$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $87f4fbac7cf060d6$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $87f4fbac7cf060d6$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $87f4fbac7cf060d6$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $87f4fbac7cf060d6$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $87f4fbac7cf060d6$var$skip(ticks, newTicks, spacing, (0, $b4325cd24db60028$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$87f4fbac7cf060d6$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $87f4fbac7cf060d6$var$skip(ticks, newTicks, spacing, last, (0, $b4325cd24db60028$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $87f4fbac7cf060d6$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $87f4fbac7cf060d6$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $87f4fbac7cf060d6$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $87f4fbac7cf060d6$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $b4325cd24db60028$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $87f4fbac7cf060d6$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $87f4fbac7cf060d6$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $87f4fbac7cf060d6$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $b4325cd24db60028$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $b4325cd24db60028$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $87f4fbac7cf060d6$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $87f4fbac7cf060d6$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $87f4fbac7cf060d6$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $87f4fbac7cf060d6$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $87f4fbac7cf060d6$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $87f4fbac7cf060d6$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $87f4fbac7cf060d6$var$garbageCollect(caches, length) {
    (0, $b4325cd24db60028$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $87f4fbac7cf060d6$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $87f4fbac7cf060d6$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $b4325cd24db60028$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $b4325cd24db60028$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $87f4fbac7cf060d6$var$createScaleContext(parent, scale) {
    return (0, $b4325cd24db60028$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $87f4fbac7cf060d6$var$createTickContext(parent, index, tick) {
    return (0, $b4325cd24db60028$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $87f4fbac7cf060d6$var$titleAlign(align, position, reverse) {
    let ret = (0, $b4325cd24db60028$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $87f4fbac7cf060d6$var$reverseAlign(ret);
    return ret;
}
function $87f4fbac7cf060d6$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $b4325cd24db60028$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $87f4fbac7cf060d6$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(position)) {
            const positionAxisID1 = Object.keys(position)[0];
            const value1 = position[positionAxisID1];
            titleX = scales[positionAxisID1].getPixelForValue(value1) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $87f4fbac7cf060d6$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $b4325cd24db60028$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $b4325cd24db60028$export$7f8ddf7c7c20b3cd) : (0, $b4325cd24db60028$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $87f4fbac7cf060d6$export$d60cfc58d3c358b6 extends $87f4fbac7cf060d6$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $b4325cd24db60028$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $b4325cd24db60028$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $b4325cd24db60028$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $b4325cd24db60028$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $b4325cd24db60028$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $b4325cd24db60028$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $b4325cd24db60028$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $b4325cd24db60028$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $b4325cd24db60028$export$c4ce752e73470fba)(min, (0, $b4325cd24db60028$export$c4ce752e73470fba)(max, min)),
            max: (0, $b4325cd24db60028$export$c4ce752e73470fba)(max, (0, $b4325cd24db60028$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $b4325cd24db60028$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $87f4fbac7cf060d6$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $87f4fbac7cf060d6$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name1) {
        this.chart.notifyPlugins(name1, this.getContext());
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(this.options[name1], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $b4325cd24db60028$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $87f4fbac7cf060d6$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $b4325cd24db60028$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $87f4fbac7cf060d6$var$getTickMarkLength(options.grid) - tickOpts.padding - $87f4fbac7cf060d6$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $b4325cd24db60028$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $b4325cd24db60028$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $b4325cd24db60028$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $b4325cd24db60028$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $87f4fbac7cf060d6$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $87f4fbac7cf060d6$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $87f4fbac7cf060d6$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $b4325cd24db60028$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $b4325cd24db60028$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $87f4fbac7cf060d6$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $87f4fbac7cf060d6$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $b4325cd24db60028$export$342063e11d6c3cad)(label) && !(0, $b4325cd24db60028$export$8b22cf2602fb60ce)(label)) {
                width = (0, $b4325cd24db60028$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $b4325cd24db60028$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $b4325cd24db60028$export$342063e11d6c3cad)(nestedLabel) && !(0, $b4325cd24db60028$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $b4325cd24db60028$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $87f4fbac7cf060d6$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $b4325cd24db60028$export$71cec2538cb2c617)(this._alignToPixels ? (0, $b4325cd24db60028$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $87f4fbac7cf060d6$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $87f4fbac7cf060d6$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $b4325cd24db60028$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $87f4fbac7cf060d6$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $b4325cd24db60028$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(position)) {
                const positionAxisID1 = Object.keys(position)[0];
                const value1 = position[positionAxisID1];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID1].getPixelForValue(value1));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $b4325cd24db60028$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $87f4fbac7cf060d6$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $b4325cd24db60028$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $87f4fbac7cf060d6$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $b4325cd24db60028$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret1 = this._getYAxisLabelAlignment(tl);
            textAlign = ret1.textAlign;
            x = ret1.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(position)) {
                const positionAxisID1 = Object.keys(position)[0];
                const value1 = position[positionAxisID1];
                x = this.chart.scales[positionAxisID1].getPixelForValue(value1);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $b4325cd24db60028$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $b4325cd24db60028$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $b4325cd24db60028$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $b4325cd24db60028$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $b4325cd24db60028$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $b4325cd24db60028$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $b4325cd24db60028$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $b4325cd24db60028$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $b4325cd24db60028$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $b4325cd24db60028$export$34aec0b863436764)(title.font);
        const padding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $b4325cd24db60028$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $b4325cd24db60028$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $87f4fbac7cf060d6$var$titleArgs(this, offset, position, align);
        (0, $b4325cd24db60028$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $87f4fbac7cf060d6$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $b4325cd24db60028$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $b4325cd24db60028$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $87f4fbac7cf060d6$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $b4325cd24db60028$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $87f4fbac7cf060d6$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($87f4fbac7cf060d6$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $87f4fbac7cf060d6$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $b4325cd24db60028$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $b4325cd24db60028$export$4368d992c4eafac0)[scope]) {
            delete (0, $b4325cd24db60028$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $b4325cd24db60028$export$6559d589eb85fbb6)[id];
        }
    }
}
function $87f4fbac7cf060d6$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $b4325cd24db60028$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $b4325cd24db60028$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $b4325cd24db60028$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $b4325cd24db60028$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $87f4fbac7cf060d6$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $b4325cd24db60028$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $87f4fbac7cf060d6$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $b4325cd24db60028$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $87f4fbac7cf060d6$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $87f4fbac7cf060d6$var$Registry {
    constructor(){
        this.controllers = new $87f4fbac7cf060d6$var$TypedRegistry($87f4fbac7cf060d6$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $87f4fbac7cf060d6$var$TypedRegistry($87f4fbac7cf060d6$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $87f4fbac7cf060d6$var$TypedRegistry(Object, 'plugins');
        this.scales = new $87f4fbac7cf060d6$var$TypedRegistry($87f4fbac7cf060d6$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $b4325cd24db60028$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $b4325cd24db60028$export$a8550f7dbe79f93a)(method);
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $87f4fbac7cf060d6$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $87f4fbac7cf060d6$var$Registry();
class $87f4fbac7cf060d6$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $b4325cd24db60028$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $b4325cd24db60028$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $b4325cd24db60028$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $87f4fbac7cf060d6$var$allPlugins(config);
        return options === false && !all ? [] : $87f4fbac7cf060d6$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $87f4fbac7cf060d6$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($87f4fbac7cf060d6$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($87f4fbac7cf060d6$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i1 = 0; i1 < local.length; i1++){
        const plugin = local[i1];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $87f4fbac7cf060d6$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $87f4fbac7cf060d6$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $87f4fbac7cf060d6$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $87f4fbac7cf060d6$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $87f4fbac7cf060d6$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $87f4fbac7cf060d6$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $b4325cd24db60028$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $87f4fbac7cf060d6$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $87f4fbac7cf060d6$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $87f4fbac7cf060d6$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $87f4fbac7cf060d6$var$determineAxis(id, scaleOptions) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
    id = scaleOptions.axis || $87f4fbac7cf060d6$var$axisFromPosition(scaleOptions.position) || id.length > 1 && $87f4fbac7cf060d6$var$determineAxis(id[0].toLowerCase(), scaleOptions);
    if (id) return id;
    throw new Error(`Cannot determine type of '${name}' axis. Please provide 'axis' or 'position' option.`);
}
function $87f4fbac7cf060d6$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $b4325cd24db60028$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $87f4fbac7cf060d6$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $b4325cd24db60028$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $87f4fbac7cf060d6$var$determineAxis(id, scaleConf);
        const defaultId = $87f4fbac7cf060d6$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $b4325cd24db60028$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $87f4fbac7cf060d6$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $b4325cd24db60028$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $87f4fbac7cf060d6$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $b4325cd24db60028$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $b4325cd24db60028$export$555508cbc6add439)(scale, [
            (0, $b4325cd24db60028$export$4368d992c4eafac0).scales[scale.type],
            (0, $b4325cd24db60028$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $87f4fbac7cf060d6$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $b4325cd24db60028$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $87f4fbac7cf060d6$var$mergeScaleConfig(config, options);
}
function $87f4fbac7cf060d6$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $87f4fbac7cf060d6$var$initConfig(config) {
    config = config || {};
    config.data = $87f4fbac7cf060d6$var$initData(config.data);
    $87f4fbac7cf060d6$var$initOptions(config);
    return config;
}
const $87f4fbac7cf060d6$var$keyCache = new Map();
const $87f4fbac7cf060d6$var$keysCached = new Set();
function $87f4fbac7cf060d6$var$cachedKeys(cacheKey, generate) {
    let keys = $87f4fbac7cf060d6$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $87f4fbac7cf060d6$var$keyCache.set(cacheKey, keys);
        $87f4fbac7cf060d6$var$keysCached.add(keys);
    }
    return keys;
}
const $87f4fbac7cf060d6$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $b4325cd24db60028$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $87f4fbac7cf060d6$var$Config {
    constructor(config){
        this._config = $87f4fbac7cf060d6$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $87f4fbac7cf060d6$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $87f4fbac7cf060d6$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $87f4fbac7cf060d6$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $87f4fbac7cf060d6$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $87f4fbac7cf060d6$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $87f4fbac7cf060d6$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$87f4fbac7cf060d6$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$87f4fbac7cf060d6$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$87f4fbac7cf060d6$var$addIfFound(scopes, (0, $b4325cd24db60028$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$87f4fbac7cf060d6$var$addIfFound(scopes, (0, $b4325cd24db60028$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$87f4fbac7cf060d6$var$addIfFound(scopes, (0, $b4325cd24db60028$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($87f4fbac7cf060d6$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $b4325cd24db60028$export$6559d589eb85fbb6)[type] || {},
            (0, $b4325cd24db60028$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $b4325cd24db60028$export$4368d992c4eafac0),
            (0, $b4325cd24db60028$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $87f4fbac7cf060d6$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($87f4fbac7cf060d6$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $b4325cd24db60028$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $b4325cd24db60028$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $87f4fbac7cf060d6$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $b4325cd24db60028$export$23f2a1d2818174ef)(context) ? (0, $b4325cd24db60028$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $87f4fbac7cf060d6$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $b4325cd24db60028$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $87f4fbac7cf060d6$var$hasFunction = (value)=>(0, $b4325cd24db60028$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).reduce((acc, key)=>acc || (0, $b4325cd24db60028$export$a93c5207d687da10)(value[key]), false);
function $87f4fbac7cf060d6$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $b4325cd24db60028$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $b4325cd24db60028$export$a93c5207d687da10)(value) || $87f4fbac7cf060d6$var$hasFunction(value)) || indexable && (0, $b4325cd24db60028$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $87f4fbac7cf060d6$var$version = "4.2.1";
const $87f4fbac7cf060d6$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $87f4fbac7cf060d6$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $87f4fbac7cf060d6$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $87f4fbac7cf060d6$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $87f4fbac7cf060d6$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $b4325cd24db60028$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $87f4fbac7cf060d6$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $b4325cd24db60028$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $87f4fbac7cf060d6$var$getCanvas(item) {
    if ((0, $b4325cd24db60028$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $87f4fbac7cf060d6$var$instances = {};
const $87f4fbac7cf060d6$var$getChart = (key)=>{
    const canvas = $87f4fbac7cf060d6$var$getCanvas(key);
    return Object.values($87f4fbac7cf060d6$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $87f4fbac7cf060d6$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $87f4fbac7cf060d6$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
function $87f4fbac7cf060d6$var$getDatasetArea(meta) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: xScale.left,
        right: xScale.right,
        top: yScale.top,
        bottom: yScale.bottom
    };
}
class $87f4fbac7cf060d6$export$acaa6426d77a227e {
    static defaults = (0, $b4325cd24db60028$export$4368d992c4eafac0);
    static instances = $87f4fbac7cf060d6$var$instances;
    static overrides = (0, $b4325cd24db60028$export$6559d589eb85fbb6);
    static registry = $87f4fbac7cf060d6$export$4bb7493d241fd8a5;
    static version = $87f4fbac7cf060d6$var$version;
    static getChart = $87f4fbac7cf060d6$var$getChart;
    static register(...items) {
        $87f4fbac7cf060d6$export$4bb7493d241fd8a5.add(...items);
        $87f4fbac7cf060d6$var$invalidatePlugins();
    }
    static unregister(...items) {
        $87f4fbac7cf060d6$export$4bb7493d241fd8a5.remove(...items);
        $87f4fbac7cf060d6$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $87f4fbac7cf060d6$var$Config(userConfig);
        const initialCanvas = $87f4fbac7cf060d6$var$getCanvas(item);
        const existingChart = $87f4fbac7cf060d6$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $87f4fbac7cf060d6$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $b4325cd24db60028$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $87f4fbac7cf060d6$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $b4325cd24db60028$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $87f4fbac7cf060d6$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $87f4fbac7cf060d6$export$a424a0aa8f687495.listen(this, 'complete', $87f4fbac7cf060d6$var$onAnimationsComplete);
        $87f4fbac7cf060d6$export$a424a0aa8f687495.listen(this, 'progress', $87f4fbac7cf060d6$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $b4325cd24db60028$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $87f4fbac7cf060d6$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $b4325cd24db60028$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $b4325cd24db60028$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $87f4fbac7cf060d6$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$87f4fbac7cf060d6$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $b4325cd24db60028$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $b4325cd24db60028$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $b4325cd24db60028$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $87f4fbac7cf060d6$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $b4325cd24db60028$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $87f4fbac7cf060d6$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $b4325cd24db60028$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $87f4fbac7cf060d6$var$positionIsHorizontal(scaleOptions.position, axis) !== $87f4fbac7cf060d6$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $87f4fbac7cf060d6$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $b4325cd24db60028$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $b4325cd24db60028$export$d66501df72047452)(scales, (scale)=>{
            $87f4fbac7cf060d6$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $87f4fbac7cf060d6$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($87f4fbac7cf060d6$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $87f4fbac7cf060d6$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $87f4fbac7cf060d6$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $b4325cd24db60028$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $87f4fbac7cf060d6$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $87f4fbac7cf060d6$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $b4325cd24db60028$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $b4325cd24db60028$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($87f4fbac7cf060d6$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $b4325cd24db60028$export$d66501df72047452)(this.scales, (scale)=>{
            $87f4fbac7cf060d6$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $b4325cd24db60028$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $87f4fbac7cf060d6$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $b4325cd24db60028$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $87f4fbac7cf060d6$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $b4325cd24db60028$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i1 = 0, ilen1 = this.data.datasets.length; i1 < ilen1; ++i1)this._updateDataset(i1, (0, $b4325cd24db60028$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i1
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($87f4fbac7cf060d6$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$87f4fbac7cf060d6$export$a424a0aa8f687495.running(this)) $87f4fbac7cf060d6$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $87f4fbac7cf060d6$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = $87f4fbac7cf060d6$var$getDatasetArea(meta) || this.chartArea;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (useClip) (0, $b4325cd24db60028$export$8743009a87fcb00f)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $b4325cd24db60028$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $b4325cd24db60028$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $87f4fbac7cf060d6$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $b4325cd24db60028$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $b4325cd24db60028$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $87f4fbac7cf060d6$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $b4325cd24db60028$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $87f4fbac7cf060d6$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $b4325cd24db60028$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $b4325cd24db60028$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $b4325cd24db60028$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $b4325cd24db60028$export$995eb9fca571757)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $b4325cd24db60028$export$f38c853ae54ed474)(e);
        const lastEvent = $87f4fbac7cf060d6$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $b4325cd24db60028$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $b4325cd24db60028$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $b4325cd24db60028$export$995eb9fca571757)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $87f4fbac7cf060d6$var$invalidatePlugins() {
    return (0, $b4325cd24db60028$export$d66501df72047452)($87f4fbac7cf060d6$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $87f4fbac7cf060d6$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $b4325cd24db60028$export$7f8ddf7c7c20b3cd), startAngle - (0, $b4325cd24db60028$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $87f4fbac7cf060d6$var$toRadiusCorners(value) {
    return (0, $b4325cd24db60028$export$21579262ef46735b)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $87f4fbac7cf060d6$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $87f4fbac7cf060d6$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $b4325cd24db60028$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $b4325cd24db60028$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $b4325cd24db60028$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $87f4fbac7cf060d6$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $87f4fbac7cf060d6$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $b4325cd24db60028$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $87f4fbac7cf060d6$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $87f4fbac7cf060d6$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $b4325cd24db60028$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $87f4fbac7cf060d6$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter1 = $87f4fbac7cf060d6$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter1.x, pCenter1.y, innerEnd, endAngle + (0, $b4325cd24db60028$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter2 = $87f4fbac7cf060d6$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter2.x, pCenter2.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $b4325cd24db60028$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $87f4fbac7cf060d6$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter3 = $87f4fbac7cf060d6$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter3.x, pCenter3.y, outerStart, startAngle - (0, $b4325cd24db60028$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $87f4fbac7cf060d6$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $87f4fbac7cf060d6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $b4325cd24db60028$export$971d5caa766a69d7) || (0, $b4325cd24db60028$export$971d5caa766a69d7));
    }
    $87f4fbac7cf060d6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $87f4fbac7cf060d6$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $87f4fbac7cf060d6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $b4325cd24db60028$export$971d5caa766a69d7) || (0, $b4325cd24db60028$export$971d5caa766a69d7));
    }
    if (inner) $87f4fbac7cf060d6$var$clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        $87f4fbac7cf060d6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $87f4fbac7cf060d6$export$d48203c759d6a1fc extends $87f4fbac7cf060d6$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $b4325cd24db60028$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = this.options.spacing / 2;
        const _circumference = (0, $b4325cd24db60028$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $b4325cd24db60028$export$971d5caa766a69d7) || (0, $b4325cd24db60028$export$ffb5f4729a158638)(angle, startAngle, endAngle);
        const withinRadius = (0, $b4325cd24db60028$export$3b513254972cfc9c)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $b4325cd24db60028$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $b4325cd24db60028$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $b4325cd24db60028$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $87f4fbac7cf060d6$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $87f4fbac7cf060d6$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $87f4fbac7cf060d6$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $b4325cd24db60028$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $b4325cd24db60028$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $b4325cd24db60028$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $b4325cd24db60028$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $b4325cd24db60028$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $b4325cd24db60028$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $87f4fbac7cf060d6$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $87f4fbac7cf060d6$var$getLineMethod(options) {
    if (options.stepped) return 0, $b4325cd24db60028$export$d24c54395ce0c509;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $b4325cd24db60028$export$6554612db691658e;
    return $87f4fbac7cf060d6$var$lineTo;
}
function $87f4fbac7cf060d6$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $87f4fbac7cf060d6$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $87f4fbac7cf060d6$var$pathVars(points, segment, params);
    const lineMethod = $87f4fbac7cf060d6$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $87f4fbac7cf060d6$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $87f4fbac7cf060d6$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $87f4fbac7cf060d6$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $87f4fbac7cf060d6$var$fastPathSegment : $87f4fbac7cf060d6$var$pathSegment;
}
function $87f4fbac7cf060d6$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $b4325cd24db60028$export$7a38258bbe170828;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $b4325cd24db60028$export$2f6ca3d3b1f80bf5;
    return 0, $b4325cd24db60028$export$8a5498727ef6be21;
}
function $87f4fbac7cf060d6$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $87f4fbac7cf060d6$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $87f4fbac7cf060d6$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $87f4fbac7cf060d6$var$_getSegmentMethod(line);
    for (const segment of segments){
        $87f4fbac7cf060d6$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $87f4fbac7cf060d6$var$usePath2D = typeof Path2D === 'function';
function $87f4fbac7cf060d6$var$draw(ctx, line, start, count) {
    if ($87f4fbac7cf060d6$var$usePath2D && !line.options.segment) $87f4fbac7cf060d6$var$strokePathWithCache(ctx, line, start, count);
    else $87f4fbac7cf060d6$var$strokePathDirect(ctx, line, start, count);
}
class $87f4fbac7cf060d6$export$55e463fa7bcd3469 extends $87f4fbac7cf060d6$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name1)=>name1 !== 'borderDash' && name1 !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $b4325cd24db60028$export$ab83b03e4111b1d0)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $b4325cd24db60028$export$1a82df3d29112e01)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $b4325cd24db60028$export$306ddfe3a8403e2)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $87f4fbac7cf060d6$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $87f4fbac7cf060d6$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $87f4fbac7cf060d6$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $87f4fbac7cf060d6$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $87f4fbac7cf060d6$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $87f4fbac7cf060d6$export$bd159b522b230b7a extends $87f4fbac7cf060d6$export$db77ccec0bb4ccac {
    static id = 'point';
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $87f4fbac7cf060d6$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $87f4fbac7cf060d6$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $b4325cd24db60028$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $b4325cd24db60028$export$493d36ec626b6698)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $87f4fbac7cf060d6$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $87f4fbac7cf060d6$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $b4325cd24db60028$export$25ce5a424b770e84)(value, min, max);
}
function $87f4fbac7cf060d6$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $b4325cd24db60028$export$d66dc83d8cfc8dd)(value);
    return {
        t: $87f4fbac7cf060d6$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $87f4fbac7cf060d6$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $87f4fbac7cf060d6$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $87f4fbac7cf060d6$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $87f4fbac7cf060d6$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $b4325cd24db60028$export$92108d983e8ee699)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $b4325cd24db60028$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $87f4fbac7cf060d6$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $87f4fbac7cf060d6$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $87f4fbac7cf060d6$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $87f4fbac7cf060d6$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $87f4fbac7cf060d6$var$boundingRects(bar) {
    const bounds = $87f4fbac7cf060d6$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $87f4fbac7cf060d6$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $87f4fbac7cf060d6$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $87f4fbac7cf060d6$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $87f4fbac7cf060d6$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $b4325cd24db60028$export$3b513254972cfc9c)(x, bounds.left, bounds.right)) && (skipY || (0, $b4325cd24db60028$export$3b513254972cfc9c)(y, bounds.top, bounds.bottom));
}
function $87f4fbac7cf060d6$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $87f4fbac7cf060d6$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $87f4fbac7cf060d6$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $87f4fbac7cf060d6$export$a16ed71bf4b07672 extends $87f4fbac7cf060d6$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $87f4fbac7cf060d6$var$boundingRects(this);
        const addRectPath = $87f4fbac7cf060d6$var$hasRadius(outer.radius) ? (0, $b4325cd24db60028$export$1fbe638ecf81657e) : $87f4fbac7cf060d6$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $87f4fbac7cf060d6$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $87f4fbac7cf060d6$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $87f4fbac7cf060d6$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $87f4fbac7cf060d6$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $87f4fbac7cf060d6$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $87f4fbac7cf060d6$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $87f4fbac7cf060d6$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $87f4fbac7cf060d6$export$d48203c759d6a1fc,
    LineElement: $87f4fbac7cf060d6$export$55e463fa7bcd3469,
    PointElement: $87f4fbac7cf060d6$export$bd159b522b230b7a,
    BarElement: $87f4fbac7cf060d6$export$a16ed71bf4b07672
});
const $87f4fbac7cf060d6$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $87f4fbac7cf060d6$var$BACKGROUND_COLORS = /* #__PURE__ */ $87f4fbac7cf060d6$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $87f4fbac7cf060d6$var$getBorderColor(i) {
    return $87f4fbac7cf060d6$var$BORDER_COLORS[i % $87f4fbac7cf060d6$var$BORDER_COLORS.length];
}
function $87f4fbac7cf060d6$var$getBackgroundColor(i) {
    return $87f4fbac7cf060d6$var$BACKGROUND_COLORS[i % $87f4fbac7cf060d6$var$BACKGROUND_COLORS.length];
}
function $87f4fbac7cf060d6$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $87f4fbac7cf060d6$var$getBorderColor(i);
    dataset.backgroundColor = $87f4fbac7cf060d6$var$getBackgroundColor(i);
    return ++i;
}
function $87f4fbac7cf060d6$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$87f4fbac7cf060d6$var$getBorderColor(i++));
    return i;
}
function $87f4fbac7cf060d6$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$87f4fbac7cf060d6$var$getBackgroundColor(i++));
    return i;
}
function $87f4fbac7cf060d6$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $87f4fbac7cf060d6$export$e04603e7d8b77172) i = $87f4fbac7cf060d6$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $87f4fbac7cf060d6$export$2a270b3a0d973c85) i = $87f4fbac7cf060d6$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $87f4fbac7cf060d6$var$colorizeDefaultDataset(dataset, i);
    };
}
function $87f4fbac7cf060d6$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $87f4fbac7cf060d6$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
var $87f4fbac7cf060d6$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        if (!options.forceOverride && ($87f4fbac7cf060d6$var$containsColorsDefinitions(datasets) || $87f4fbac7cf060d6$var$containsColorsDefinition(chartOptions) || elements && $87f4fbac7cf060d6$var$containsColorsDefinitions(elements))) return;
        const colorizer = $87f4fbac7cf060d6$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $87f4fbac7cf060d6$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $87f4fbac7cf060d6$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $b4325cd24db60028$export$342063e11d6c3cad)(minIndex) && !(0, $b4325cd24db60028$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $87f4fbac7cf060d6$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $87f4fbac7cf060d6$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $87f4fbac7cf060d6$var$cleanDecimatedDataset(dataset);
    });
}
function $87f4fbac7cf060d6$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $b4325cd24db60028$export$25ce5a424b770e84)((0, $b4325cd24db60028$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $b4325cd24db60028$export$25ce5a424b770e84)((0, $b4325cd24db60028$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $87f4fbac7cf060d6$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $87f4fbac7cf060d6$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $b4325cd24db60028$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $87f4fbac7cf060d6$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $87f4fbac7cf060d6$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $b4325cd24db60028$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $87f4fbac7cf060d6$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $87f4fbac7cf060d6$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $87f4fbac7cf060d6$var$cleanDecimatedData(chart);
    }
};
function $87f4fbac7cf060d6$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $87f4fbac7cf060d6$var$_findSegmentEnd(start, end, points);
        const bounds = $87f4fbac7cf060d6$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $b4325cd24db60028$export$306ddfe3a8403e2)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $87f4fbac7cf060d6$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $b4325cd24db60028$export$9fa96a7d116ea3ce)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $87f4fbac7cf060d6$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $87f4fbac7cf060d6$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $87f4fbac7cf060d6$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $b4325cd24db60028$export$28f7fcd39efa255)(start);
        end = (0, $b4325cd24db60028$export$28f7fcd39efa255)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $87f4fbac7cf060d6$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $87f4fbac7cf060d6$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $87f4fbac7cf060d6$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $87f4fbac7cf060d6$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $87f4fbac7cf060d6$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $b4325cd24db60028$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $87f4fbac7cf060d6$var$_pointsFromSegments(boundary, line);
    return points.length ? new $87f4fbac7cf060d6$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $87f4fbac7cf060d6$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $87f4fbac7cf060d6$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $b4325cd24db60028$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $87f4fbac7cf060d6$var$_decodeFill(line, index, count) {
    const fill = $87f4fbac7cf060d6$var$parseFillOption(line);
    if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $b4325cd24db60028$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $87f4fbac7cf060d6$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $87f4fbac7cf060d6$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $87f4fbac7cf060d6$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $87f4fbac7cf060d6$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $87f4fbac7cf060d6$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $b4325cd24db60028$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $87f4fbac7cf060d6$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $87f4fbac7cf060d6$var$getLinesBelow(scale, index);
    linesBelow.push($87f4fbac7cf060d6$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$87f4fbac7cf060d6$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $87f4fbac7cf060d6$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $87f4fbac7cf060d6$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $87f4fbac7cf060d6$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $87f4fbac7cf060d6$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $87f4fbac7cf060d6$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $b4325cd24db60028$export$3b513254972cfc9c)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $87f4fbac7cf060d6$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $b4325cd24db60028$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $87f4fbac7cf060d6$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $b4325cd24db60028$export$39b482c5e57630a8)(fill)) return $87f4fbac7cf060d6$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $87f4fbac7cf060d6$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $87f4fbac7cf060d6$var$computeBoundary(source);
    if (boundary instanceof $87f4fbac7cf060d6$var$simpleArc) return boundary;
    return $87f4fbac7cf060d6$var$_createBoundaryLine(boundary, line);
}
function $87f4fbac7cf060d6$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $87f4fbac7cf060d6$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $87f4fbac7cf060d6$var$computeCircularBoundary(source);
    return $87f4fbac7cf060d6$var$computeLinearBoundary(source);
}
function $87f4fbac7cf060d6$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $87f4fbac7cf060d6$var$_getTargetPixel(fill, scale);
    if ((0, $b4325cd24db60028$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $87f4fbac7cf060d6$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $87f4fbac7cf060d6$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $87f4fbac7cf060d6$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $87f4fbac7cf060d6$var$_drawfill(ctx, source, area) {
    const target = $87f4fbac7cf060d6$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $b4325cd24db60028$export$8743009a87fcb00f)(ctx, area);
        $87f4fbac7cf060d6$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $b4325cd24db60028$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $87f4fbac7cf060d6$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        $87f4fbac7cf060d6$var$clipVertical(ctx, target, area.top);
        $87f4fbac7cf060d6$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $87f4fbac7cf060d6$var$clipVertical(ctx, target, area.bottom);
    }
    $87f4fbac7cf060d6$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $87f4fbac7cf060d6$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$87f4fbac7cf060d6$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $87f4fbac7cf060d6$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $87f4fbac7cf060d6$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $87f4fbac7cf060d6$var$clipBounds(ctx, scale, notShape && $87f4fbac7cf060d6$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $87f4fbac7cf060d6$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $87f4fbac7cf060d6$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $87f4fbac7cf060d6$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x') {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $87f4fbac7cf060d6$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $87f4fbac7cf060d6$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $87f4fbac7cf060d6$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $87f4fbac7cf060d6$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $87f4fbac7cf060d6$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $87f4fbac7cf060d6$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($87f4fbac7cf060d6$var$_shouldApplyFill(source)) $87f4fbac7cf060d6$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$87f4fbac7cf060d6$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $87f4fbac7cf060d6$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $87f4fbac7cf060d6$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $87f4fbac7cf060d6$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $87f4fbac7cf060d6$var$Legend extends $87f4fbac7cf060d6$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $b4325cd24db60028$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $b4325cd24db60028$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $87f4fbac7cf060d6$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $87f4fbac7cf060d6$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $b4325cd24db60028$export$3d12bd131bb975d1)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $b4325cd24db60028$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $b4325cd24db60028$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $b4325cd24db60028$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox1 of hitboxes){
                if (hitbox1.col !== col) {
                    col = hitbox1.col;
                    top = (0, $b4325cd24db60028$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox1.top = top;
                hitbox1.left += this.left + padding;
                hitbox1.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox1.left), hitbox1.width);
                top += hitbox1.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $b4325cd24db60028$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $b4325cd24db60028$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $b4325cd24db60028$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $b4325cd24db60028$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const labelFont = (0, $b4325cd24db60028$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $87f4fbac7cf060d6$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $b4325cd24db60028$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $b4325cd24db60028$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $b4325cd24db60028$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $b4325cd24db60028$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $b4325cd24db60028$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $b4325cd24db60028$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $b4325cd24db60028$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $b4325cd24db60028$export$24baa2b76016ce0e)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $b4325cd24db60028$export$92108d983e8ee699)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $b4325cd24db60028$export$1fbe638ecf81657e)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $b4325cd24db60028$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $b4325cd24db60028$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $b4325cd24db60028$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $b4325cd24db60028$export$91c6e00c14e7e6fd)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $b4325cd24db60028$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $b4325cd24db60028$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $b4325cd24db60028$export$9d398bebfec1c039)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $87f4fbac7cf060d6$var$calculateLegendItemHeight(legendItem, fontLineHeight);
            } else cursor.y += lineHeight;
        });
        (0, $b4325cd24db60028$export$890c4ad488842ce7)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $b4325cd24db60028$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $b4325cd24db60028$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $b4325cd24db60028$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $b4325cd24db60028$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $b4325cd24db60028$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $b4325cd24db60028$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $b4325cd24db60028$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $b4325cd24db60028$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $b4325cd24db60028$export$3b513254972cfc9c)(x, this.left, this.right) && (0, $b4325cd24db60028$export$3b513254972cfc9c)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $b4325cd24db60028$export$3b513254972cfc9c)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $b4325cd24db60028$export$3b513254972cfc9c)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$87f4fbac7cf060d6$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $87f4fbac7cf060d6$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $b4325cd24db60028$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $b4325cd24db60028$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $b4325cd24db60028$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $87f4fbac7cf060d6$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $87f4fbac7cf060d6$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $87f4fbac7cf060d6$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $87f4fbac7cf060d6$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $87f4fbac7cf060d6$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $87f4fbac7cf060d6$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $87f4fbac7cf060d6$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length + 0.5 : 0;
    return fontLineHeight * labelHeight;
}
function $87f4fbac7cf060d6$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $87f4fbac7cf060d6$export$ed247974535929c7 = {
    id: 'legend',
    _element: $87f4fbac7cf060d6$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $87f4fbac7cf060d6$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $87f4fbac7cf060d6$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $87f4fbac7cf060d6$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $87f4fbac7cf060d6$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $87f4fbac7cf060d6$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name1)=>!name1.startsWith('on'),
        labels: {
            _scriptable: (name1)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name1)
        }
    }
};
class $87f4fbac7cf060d6$var$Title extends $87f4fbac7cf060d6$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $b4325cd24db60028$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $b4325cd24db60028$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $b4325cd24db60028$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $b4325cd24db60028$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $b4325cd24db60028$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $b4325cd24db60028$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $b4325cd24db60028$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $b4325cd24db60028$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $b4325cd24db60028$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $b4325cd24db60028$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $87f4fbac7cf060d6$var$createTitle(chart, titleOpts) {
    const title = new $87f4fbac7cf060d6$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $87f4fbac7cf060d6$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $87f4fbac7cf060d6$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $87f4fbac7cf060d6$export$f99233281efd08a0 = {
    id: 'title',
    _element: $87f4fbac7cf060d6$var$Title,
    start (chart, _args, options) {
        $87f4fbac7cf060d6$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $87f4fbac7cf060d6$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $87f4fbac7cf060d6$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $87f4fbac7cf060d6$var$map = new WeakMap();
var $87f4fbac7cf060d6$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $87f4fbac7cf060d6$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $87f4fbac7cf060d6$export$1ecca0613f5e56d2.configure(chart, title, options);
        $87f4fbac7cf060d6$export$1ecca0613f5e56d2.addBox(chart, title);
        $87f4fbac7cf060d6$var$map.set(chart, title);
    },
    stop (chart) {
        $87f4fbac7cf060d6$export$1ecca0613f5e56d2.removeBox(chart, $87f4fbac7cf060d6$var$map.get(chart));
        $87f4fbac7cf060d6$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $87f4fbac7cf060d6$var$map.get(chart);
        $87f4fbac7cf060d6$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $87f4fbac7cf060d6$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $b4325cd24db60028$export$158acd800e1ef08b)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $87f4fbac7cf060d6$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $b4325cd24db60028$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $87f4fbac7cf060d6$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $87f4fbac7cf060d6$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $87f4fbac7cf060d6$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $b4325cd24db60028$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $b4325cd24db60028$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $b4325cd24db60028$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $b4325cd24db60028$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $b4325cd24db60028$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $b4325cd24db60028$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $b4325cd24db60028$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $b4325cd24db60028$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $b4325cd24db60028$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $b4325cd24db60028$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $87f4fbac7cf060d6$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $87f4fbac7cf060d6$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $87f4fbac7cf060d6$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($87f4fbac7cf060d6$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $87f4fbac7cf060d6$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $87f4fbac7cf060d6$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $87f4fbac7cf060d6$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $87f4fbac7cf060d6$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $87f4fbac7cf060d6$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $87f4fbac7cf060d6$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $b4325cd24db60028$export$92108d983e8ee699)(cornerRadius);
    let x = $87f4fbac7cf060d6$var$alignX(size, xAlign);
    const y = $87f4fbac7cf060d6$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $b4325cd24db60028$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $b4325cd24db60028$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $87f4fbac7cf060d6$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $87f4fbac7cf060d6$var$getBeforeAfterBodyLines(callback) {
    return $87f4fbac7cf060d6$var$pushOrConcat([], $87f4fbac7cf060d6$var$splitNewlines(callback));
}
function $87f4fbac7cf060d6$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $b4325cd24db60028$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $87f4fbac7cf060d6$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $87f4fbac7cf060d6$var$defaultCallbacks = {
    beforeTitle: (0, $b4325cd24db60028$export$cf2f7c5792f80b46),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $b4325cd24db60028$export$cf2f7c5792f80b46),
    beforeBody: (0, $b4325cd24db60028$export$cf2f7c5792f80b46),
    beforeLabel: (0, $b4325cd24db60028$export$cf2f7c5792f80b46),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $b4325cd24db60028$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $b4325cd24db60028$export$cf2f7c5792f80b46),
    afterBody: (0, $b4325cd24db60028$export$cf2f7c5792f80b46),
    beforeFooter: (0, $b4325cd24db60028$export$cf2f7c5792f80b46),
    footer: (0, $b4325cd24db60028$export$cf2f7c5792f80b46),
    afterFooter: (0, $b4325cd24db60028$export$cf2f7c5792f80b46)
};
function $87f4fbac7cf060d6$var$invokeCallbackWithFallback(callbacks, name1, ctx, arg) {
    const result = callbacks[name1].call(ctx, arg);
    if (typeof result === 'undefined') return $87f4fbac7cf060d6$var$defaultCallbacks[name1].call(ctx, arg);
    return result;
}
class $87f4fbac7cf060d6$var$Tooltip extends $87f4fbac7cf060d6$export$db77ccec0bb4ccac {
    static positioners = $87f4fbac7cf060d6$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $87f4fbac7cf060d6$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $87f4fbac7cf060d6$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $87f4fbac7cf060d6$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $87f4fbac7cf060d6$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $87f4fbac7cf060d6$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $87f4fbac7cf060d6$var$pushOrConcat(lines, $87f4fbac7cf060d6$var$splitNewlines(beforeTitle));
        lines = $87f4fbac7cf060d6$var$pushOrConcat(lines, $87f4fbac7cf060d6$var$splitNewlines(title));
        lines = $87f4fbac7cf060d6$var$pushOrConcat(lines, $87f4fbac7cf060d6$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $87f4fbac7cf060d6$var$getBeforeAfterBodyLines($87f4fbac7cf060d6$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $b4325cd24db60028$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $87f4fbac7cf060d6$var$overrideCallbacks(callbacks, context);
            $87f4fbac7cf060d6$var$pushOrConcat(bodyItem.before, $87f4fbac7cf060d6$var$splitNewlines($87f4fbac7cf060d6$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $87f4fbac7cf060d6$var$pushOrConcat(bodyItem.lines, $87f4fbac7cf060d6$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $87f4fbac7cf060d6$var$pushOrConcat(bodyItem.after, $87f4fbac7cf060d6$var$splitNewlines($87f4fbac7cf060d6$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $87f4fbac7cf060d6$var$getBeforeAfterBodyLines($87f4fbac7cf060d6$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $87f4fbac7cf060d6$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $87f4fbac7cf060d6$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $87f4fbac7cf060d6$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $87f4fbac7cf060d6$var$pushOrConcat(lines, $87f4fbac7cf060d6$var$splitNewlines(beforeFooter));
        lines = $87f4fbac7cf060d6$var$pushOrConcat(lines, $87f4fbac7cf060d6$var$splitNewlines(footer));
        lines = $87f4fbac7cf060d6$var$pushOrConcat(lines, $87f4fbac7cf060d6$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($87f4fbac7cf060d6$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $b4325cd24db60028$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $87f4fbac7cf060d6$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($87f4fbac7cf060d6$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($87f4fbac7cf060d6$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($87f4fbac7cf060d6$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $87f4fbac7cf060d6$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $87f4fbac7cf060d6$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $87f4fbac7cf060d6$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $87f4fbac7cf060d6$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $b4325cd24db60028$export$92108d983e8ee699)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $b4325cd24db60028$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $87f4fbac7cf060d6$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $b4325cd24db60028$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColors = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $b4325cd24db60028$export$34aec0b863436764)(options.bodyFont);
        const colorX = $87f4fbac7cf060d6$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $b4325cd24db60028$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColors.borderColor;
            ctx.fillStyle = labelColors.backgroundColor;
            (0, $b4325cd24db60028$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $b4325cd24db60028$export$23f2a1d2818174ef)(labelColors.borderWidth) ? Math.max(...Object.values(labelColors.borderWidth)) : labelColors.borderWidth || 1;
            ctx.strokeStyle = labelColors.borderColor;
            ctx.setLineDash(labelColors.borderDash || []);
            ctx.lineDashOffset = labelColors.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth - boxPadding);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - boxPadding - 2);
            const borderRadius = (0, $b4325cd24db60028$export$92108d983e8ee699)(labelColors.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $b4325cd24db60028$export$1fbe638ecf81657e)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.beginPath();
                (0, $b4325cd24db60028$export$1fbe638ecf81657e)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $b4325cd24db60028$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $b4325cd24db60028$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $87f4fbac7cf060d6$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $b4325cd24db60028$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $b4325cd24db60028$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $b4325cd24db60028$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $b4325cd24db60028$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $b4325cd24db60028$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $87f4fbac7cf060d6$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $b4325cd24db60028$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $b4325cd24db60028$export$92108d983e8ee699)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $87f4fbac7cf060d6$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $87f4fbac7cf060d6$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $87f4fbac7cf060d6$var$determineAlignment(chart, options, positionAndSize);
            const point = $87f4fbac7cf060d6$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $b4325cd24db60028$export$91c6e00c14e7e6fd)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $b4325cd24db60028$export$890c4ad488842ce7)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $b4325cd24db60028$export$995eb9fca571757)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $b4325cd24db60028$export$995eb9fca571757)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $87f4fbac7cf060d6$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $87f4fbac7cf060d6$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $87f4fbac7cf060d6$var$Tooltip,
    positioners: $87f4fbac7cf060d6$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $87f4fbac7cf060d6$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $87f4fbac7cf060d6$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name1)=>name1 !== 'filter' && name1 !== 'itemSort' && name1 !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $87f4fbac7cf060d6$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $87f4fbac7cf060d6$export$c537fa0d021d010b,
    Decimation: $87f4fbac7cf060d6$export$be17f937e9aa7533,
    Filler: $87f4fbac7cf060d6$export$d19ba4d812bed757,
    Legend: $87f4fbac7cf060d6$export$ed247974535929c7,
    SubTitle: $87f4fbac7cf060d6$export$d5c56664638992a4,
    Title: $87f4fbac7cf060d6$export$f99233281efd08a0,
    Tooltip: $87f4fbac7cf060d6$export$28c660c63b792dea
});
const $87f4fbac7cf060d6$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $87f4fbac7cf060d6$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $87f4fbac7cf060d6$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $87f4fbac7cf060d6$var$validIndex = (index, max)=>index === null ? null : (0, $b4325cd24db60028$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $87f4fbac7cf060d6$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $87f4fbac7cf060d6$export$29e663ba4d09fe7 extends $87f4fbac7cf060d6$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $87f4fbac7cf060d6$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $b4325cd24db60028$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $87f4fbac7cf060d6$var$findOrAddLabel(labels, raw, (0, $b4325cd24db60028$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $87f4fbac7cf060d6$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $87f4fbac7cf060d6$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $87f4fbac7cf060d6$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $b4325cd24db60028$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $b4325cd24db60028$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $b4325cd24db60028$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $b4325cd24db60028$export$a33b77bbdbb8366c)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $b4325cd24db60028$export$a33b77bbdbb8366c)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $b4325cd24db60028$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $b4325cd24db60028$export$b9a6b53f9be3734)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $b4325cd24db60028$export$a05254e7c3aeba6e)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $b4325cd24db60028$export$23ebac1979863676)(spacing), (0, $b4325cd24db60028$export$23ebac1979863676)(niceMin));
    factor = Math.pow(10, (0, $b4325cd24db60028$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $b4325cd24db60028$export$a05254e7c3aeba6e)(Math.round((niceMin + j * spacing) * factor) / factor, min, $87f4fbac7cf060d6$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j)ticks.push({
        value: Math.round((niceMin + j * spacing) * factor) / factor
    });
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $b4325cd24db60028$export$a05254e7c3aeba6e)(ticks[ticks.length - 1].value, max, $87f4fbac7cf060d6$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $87f4fbac7cf060d6$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $b4325cd24db60028$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $87f4fbac7cf060d6$var$LinearScaleBase extends $87f4fbac7cf060d6$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $b4325cd24db60028$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $b4325cd24db60028$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $b4325cd24db60028$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $87f4fbac7cf060d6$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $b4325cd24db60028$export$53a70dd1ebbae346)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $b4325cd24db60028$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $87f4fbac7cf060d6$export$e7f4e5e8656f0b93 extends $87f4fbac7cf060d6$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $b4325cd24db60028$export$91477dc880baac21).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $b4325cd24db60028$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $b4325cd24db60028$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $b4325cd24db60028$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $87f4fbac7cf060d6$var$log10Floor = (v)=>Math.floor((0, $b4325cd24db60028$export$9f4f30ee63539e24)(v));
const $87f4fbac7cf060d6$var$changeExponent = (v, m)=>Math.pow(10, $87f4fbac7cf060d6$var$log10Floor(v) + m);
function $87f4fbac7cf060d6$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $87f4fbac7cf060d6$var$log10Floor(tickVal));
    return remain === 1;
}
function $87f4fbac7cf060d6$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $87f4fbac7cf060d6$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $87f4fbac7cf060d6$var$log10Floor(range);
    while($87f4fbac7cf060d6$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($87f4fbac7cf060d6$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $87f4fbac7cf060d6$var$log10Floor(min));
}
function $87f4fbac7cf060d6$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $b4325cd24db60028$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $87f4fbac7cf060d6$var$log10Floor(min);
    let exp = $87f4fbac7cf060d6$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $b4325cd24db60028$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $87f4fbac7cf060d6$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $b4325cd24db60028$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $87f4fbac7cf060d6$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $87f4fbac7cf060d6$export$85295eaf7cb3ac3e extends $87f4fbac7cf060d6$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $b4325cd24db60028$export$91477dc880baac21).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $87f4fbac7cf060d6$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $b4325cd24db60028$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $b4325cd24db60028$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $b4325cd24db60028$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $b4325cd24db60028$export$39b482c5e57630a8)(this._userMin)) this.min = min === $87f4fbac7cf060d6$var$changeExponent(this.min, 0) ? $87f4fbac7cf060d6$var$changeExponent(this.min, -1) : $87f4fbac7cf060d6$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($87f4fbac7cf060d6$var$changeExponent(min, -1));
                setMax($87f4fbac7cf060d6$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($87f4fbac7cf060d6$var$changeExponent(max, -1));
        if (max <= 0) setMax($87f4fbac7cf060d6$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $87f4fbac7cf060d6$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $b4325cd24db60028$export$53a70dd1ebbae346)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $b4325cd24db60028$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $b4325cd24db60028$export$9f4f30ee63539e24)(start);
        this._valueRange = (0, $b4325cd24db60028$export$9f4f30ee63539e24)(this.max) - (0, $b4325cd24db60028$export$9f4f30ee63539e24)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $b4325cd24db60028$export$9f4f30ee63539e24)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $87f4fbac7cf060d6$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $b4325cd24db60028$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $b4325cd24db60028$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $87f4fbac7cf060d6$var$measureLabelSize(ctx, font, label) {
    label = (0, $b4325cd24db60028$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $b4325cd24db60028$export$faec65b429be379)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $87f4fbac7cf060d6$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $87f4fbac7cf060d6$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $b4325cd24db60028$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $b4325cd24db60028$export$34aec0b863436764)(opts.font);
        const textSize = $87f4fbac7cf060d6$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $b4325cd24db60028$export$28f7fcd39efa255)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $b4325cd24db60028$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $87f4fbac7cf060d6$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $87f4fbac7cf060d6$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $87f4fbac7cf060d6$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $87f4fbac7cf060d6$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $87f4fbac7cf060d6$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $87f4fbac7cf060d6$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const extra = $87f4fbac7cf060d6$var$getTickBackdropHeight(opts) / 2;
    const outerDistance = scale.drawingArea;
    const additionalAngle = opts.pointLabels.centerPointLabels ? (0, $b4325cd24db60028$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i], additionalAngle);
        const angle = Math.round((0, $b4325cd24db60028$export$3a6d5c9ae78a2c08)((0, $b4325cd24db60028$export$28f7fcd39efa255)(pointLabelPosition.angle + (0, $b4325cd24db60028$export$7f8ddf7c7c20b3cd))));
        const size = labelSizes[i];
        const y = $87f4fbac7cf060d6$var$yForAngle(pointLabelPosition.y, size.h, angle);
        const textAlign = $87f4fbac7cf060d6$var$getTextAlignForAngle(angle);
        const left = $87f4fbac7cf060d6$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
        items.push({
            x: pointLabelPosition.x,
            y: y,
            textAlign: textAlign,
            left: left,
            top: y,
            right: left + size.w,
            bottom: y + size.h
        });
    }
    return items;
}
function $87f4fbac7cf060d6$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $87f4fbac7cf060d6$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $87f4fbac7cf060d6$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $87f4fbac7cf060d6$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        const plFont = (0, $b4325cd24db60028$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign, left: left, top: top, right: right, bottom: bottom } = scale._pointLabelItems[i];
        const { backdropColor: backdropColor } = optsAtIndex;
        if (!(0, $b4325cd24db60028$export$342063e11d6c3cad)(backdropColor)) {
            const borderRadius = (0, $b4325cd24db60028$export$92108d983e8ee699)(optsAtIndex.borderRadius);
            const padding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
            ctx.fillStyle = backdropColor;
            const backdropLeft = left - padding.left;
            const backdropTop = top - padding.top;
            const backdropWidth = right - left + padding.width;
            const backdropHeight = bottom - top + padding.height;
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                (0, $b4325cd24db60028$export$1fbe638ecf81657e)(ctx, {
                    x: backdropLeft,
                    y: backdropTop,
                    w: backdropWidth,
                    h: backdropHeight,
                    radius: borderRadius
                });
                ctx.fill();
            } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
        }
        (0, $b4325cd24db60028$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $87f4fbac7cf060d6$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $b4325cd24db60028$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $87f4fbac7cf060d6$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $87f4fbac7cf060d6$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $87f4fbac7cf060d6$var$createPointLabelContext(parent, index, label) {
    return (0, $b4325cd24db60028$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $87f4fbac7cf060d6$export$cfafc36d95386d38 extends $87f4fbac7cf060d6$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $b4325cd24db60028$export$91477dc880baac21).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)($87f4fbac7cf060d6$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $b4325cd24db60028$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $b4325cd24db60028$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $87f4fbac7cf060d6$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $87f4fbac7cf060d6$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $b4325cd24db60028$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $87f4fbac7cf060d6$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $b4325cd24db60028$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $b4325cd24db60028$export$28f7fcd39efa255)(index * angleMultiplier + (0, $b4325cd24db60028$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $b4325cd24db60028$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $b4325cd24db60028$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $87f4fbac7cf060d6$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $b4325cd24db60028$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $87f4fbac7cf060d6$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $87f4fbac7cf060d6$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $87f4fbac7cf060d6$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $b4325cd24db60028$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $b4325cd24db60028$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $87f4fbac7cf060d6$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $87f4fbac7cf060d6$var$UNITS = /* #__PURE__ */ Object.keys($87f4fbac7cf060d6$var$INTERVALS);
function $87f4fbac7cf060d6$var$sorter(a, b) {
    return a - b;
}
function $87f4fbac7cf060d6$var$parse(scale, input) {
    if ((0, $b4325cd24db60028$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $b4325cd24db60028$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $b4325cd24db60028$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $87f4fbac7cf060d6$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $87f4fbac7cf060d6$var$UNITS.length;
    for(let i = $87f4fbac7cf060d6$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $87f4fbac7cf060d6$var$INTERVALS[$87f4fbac7cf060d6$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $87f4fbac7cf060d6$var$UNITS[i];
    }
    return $87f4fbac7cf060d6$var$UNITS[ilen - 1];
}
function $87f4fbac7cf060d6$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $87f4fbac7cf060d6$var$UNITS.length - 1; i >= $87f4fbac7cf060d6$var$UNITS.indexOf(minUnit); i--){
        const unit = $87f4fbac7cf060d6$var$UNITS[i];
        if ($87f4fbac7cf060d6$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $87f4fbac7cf060d6$var$UNITS[minUnit ? $87f4fbac7cf060d6$var$UNITS.indexOf(minUnit) : 0];
}
function $87f4fbac7cf060d6$var$determineMajorUnit(unit) {
    for(let i = $87f4fbac7cf060d6$var$UNITS.indexOf(unit) + 1, ilen = $87f4fbac7cf060d6$var$UNITS.length; i < ilen; ++i){
        if ($87f4fbac7cf060d6$var$INTERVALS[$87f4fbac7cf060d6$var$UNITS[i]].common) return $87f4fbac7cf060d6$var$UNITS[i];
    }
}
function $87f4fbac7cf060d6$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $b4325cd24db60028$export$2ed0fc6709e59212)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $87f4fbac7cf060d6$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $87f4fbac7cf060d6$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $87f4fbac7cf060d6$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $87f4fbac7cf060d6$export$a894c72689ff3ec extends $87f4fbac7cf060d6$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $87f4fbac7cf060d6$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $b4325cd24db60028$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $87f4fbac7cf060d6$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $b4325cd24db60028$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $b4325cd24db60028$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $b4325cd24db60028$export$c03999cb2f36933f)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $87f4fbac7cf060d6$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $87f4fbac7cf060d6$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $87f4fbac7cf060d6$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $87f4fbac7cf060d6$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $b4325cd24db60028$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $b4325cd24db60028$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $87f4fbac7cf060d6$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $b4325cd24db60028$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $b4325cd24db60028$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$87f4fbac7cf060d6$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $87f4fbac7cf060d6$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort((a, b)=>a - b).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $b4325cd24db60028$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $b4325cd24db60028$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $87f4fbac7cf060d6$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($87f4fbac7cf060d6$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $b4325cd24db60028$export$71511d61b312f219)(values.sort($87f4fbac7cf060d6$var$sorter));
    }
}
function $87f4fbac7cf060d6$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $b4325cd24db60028$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $b4325cd24db60028$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $87f4fbac7cf060d6$export$85df64a8eb6dc986 extends $87f4fbac7cf060d6$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $87f4fbac7cf060d6$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $87f4fbac7cf060d6$var$interpolate(table, this.min);
        this._tableRange = $87f4fbac7cf060d6$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($87f4fbac7cf060d6$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $87f4fbac7cf060d6$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $87f4fbac7cf060d6$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $87f4fbac7cf060d6$export$29e663ba4d09fe7,
    LinearScale: $87f4fbac7cf060d6$export$e7f4e5e8656f0b93,
    LogarithmicScale: $87f4fbac7cf060d6$export$85295eaf7cb3ac3e,
    RadialLinearScale: $87f4fbac7cf060d6$export$cfafc36d95386d38,
    TimeScale: $87f4fbac7cf060d6$export$a894c72689ff3ec,
    TimeSeriesScale: $87f4fbac7cf060d6$export$85df64a8eb6dc986
});
const $87f4fbac7cf060d6$export$e8959e79e3af550f = [
    $87f4fbac7cf060d6$export$a6506504f799c5d5,
    $87f4fbac7cf060d6$export$7a5d735b2ab6389d,
    $87f4fbac7cf060d6$export$8b3ca321c77fdea6,
    $87f4fbac7cf060d6$export$bcac1c16f1530ec2
];


const $0320e986bcdf7c3f$var$defaultDatasetIdKey = "label";
function $0320e986bcdf7c3f$var$reforwardRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $0320e986bcdf7c3f$var$setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function $0320e986bcdf7c3f$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $0320e986bcdf7c3f$var$setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $0320e986bcdf7c3f$var$defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $0320e986bcdf7c3f$var$cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $0320e986bcdf7c3f$var$defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    $0320e986bcdf7c3f$var$setLabels(nextData, data.labels);
    $0320e986bcdf7c3f$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $0320e986bcdf7c3f$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "dataset", {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $0320e986bcdf7c3f$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "nearest", {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $0320e986bcdf7c3f$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "index", {
        intersect: true
    }, false);
}
function $0320e986bcdf7c3f$var$ChartComponent(props, ref) {
    const { height: height = 150, width: width = 300, redraw: redraw = false, datasetIdKey: datasetIdKey, type: type, data: data, options: options, plugins: plugins = [], fallbackContent: fallbackContent, updateMode: updateMode, ...canvasProps } = props;
    const canvasRef = (0, $3OyDL.useRef)(null);
    const chartRef = (0, $3OyDL.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $87f4fbac7cf060d6$export$acaa6426d77a227e)(canvasRef.current, {
            type: type,
            data: $0320e986bcdf7c3f$var$cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins: plugins
        });
        $0320e986bcdf7c3f$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $0320e986bcdf7c3f$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $3OyDL.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $0320e986bcdf7c3f$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $3OyDL.useEffect)(()=>{
        if (!redraw && chartRef.current) $0320e986bcdf7c3f$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $3OyDL.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $0320e986bcdf7c3f$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $3OyDL.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $3OyDL.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $3OyDL.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, canvasProps), fallbackContent);
}
const $0320e986bcdf7c3f$export$acaa6426d77a227e = /*#__PURE__*/ (0, $3OyDL.forwardRef)($0320e986bcdf7c3f$var$ChartComponent);
function $0320e986bcdf7c3f$var$createTypedChart(type, registerables) {
    (0, $87f4fbac7cf060d6$export$acaa6426d77a227e).register(registerables);
    return /*#__PURE__*/ (0, $3OyDL.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createElement($0320e986bcdf7c3f$export$acaa6426d77a227e, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const $0320e986bcdf7c3f$export$17d680238e50603e = /* #__PURE__ */ $0320e986bcdf7c3f$var$createTypedChart("line", (0, $87f4fbac7cf060d6$export$3c9b5d28c11cbfd0));
const $0320e986bcdf7c3f$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $0320e986bcdf7c3f$var$createTypedChart("bar", (0, $87f4fbac7cf060d6$export$e97d5dc64e999004));
const $0320e986bcdf7c3f$export$bace472c466fdd25 = /* #__PURE__ */ $0320e986bcdf7c3f$var$createTypedChart("radar", (0, $87f4fbac7cf060d6$export$48dbc6ac651bf8be));
const $0320e986bcdf7c3f$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $0320e986bcdf7c3f$var$createTypedChart("doughnut", (0, $87f4fbac7cf060d6$export$e04603e7d8b77172));
const $0320e986bcdf7c3f$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $0320e986bcdf7c3f$var$createTypedChart("polarArea", (0, $87f4fbac7cf060d6$export$2a270b3a0d973c85));
const $0320e986bcdf7c3f$export$646feb54fbadbe06 = /* #__PURE__ */ $0320e986bcdf7c3f$var$createTypedChart("bubble", (0, $87f4fbac7cf060d6$export$19b5c4773f17abe));
const $0320e986bcdf7c3f$export$2ae8800cf67c848c = /* #__PURE__ */ $0320e986bcdf7c3f$var$createTypedChart("pie", (0, $87f4fbac7cf060d6$export$b21a3f1286706191));
const $0320e986bcdf7c3f$export$1c460fb4285edadc = /* #__PURE__ */ $0320e986bcdf7c3f$var$createTypedChart("scatter", (0, $87f4fbac7cf060d6$export$b2f2bae6713db87));


const $a6f287ae9ee8c48c$var$BarChart = (props)=>{
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0320e986bcdf7c3f$export$bbc6c6369b38e3d1), {
        data: props.chartData,
        options: props.chartOptions,
        height: props.height || 150
    });
};
var $a6f287ae9ee8c48c$export$2e2bcd8739ae039 = $a6f287ae9ee8c48c$var$BarChart;




var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $48f0e9d81c82a26c$var$GoodIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("svg", {
        height: props.width,
        viewBox: "0 0 16 16",
        width: props.width,
        fill: theme.palette.text.primary,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m0 1v8c0 .552246.447693 1 1 1h3v-10h-3c-.552307 0-1 .447693-1 1z",
                transform: "translate(0 5)"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m9.15332 5.02979h-2.9541c-.258301 0-.387695-.172363-.431152-.246582-.043457-.0737305-.131348-.270508-.0063477-.496094l1.0415-1.87549c.228516-.410645.251953-.893555.0649414-1.32471-.187012-.43164-.556152-.744629-1.0127-.858398l-.734375-.183594c-.178711-.0449219-.368164.0122071-.492676.150391l-3.9873 4.42969c-.413574.460449-.641113 1.0542-.641113 1.67236v5.23242c0 1.37842 1.12158 2.5 2.5 2.5l4.97412-.0004883c1.12305 0 2.11475-.756348 2.41113-1.83887l1.06738-4.89844c.03125-.13623.0473633-.275879.0473633-.415527 0-1.01807-.828613-1.84668-1.84668-1.84668z",
                transform: "translate(5 .97)"
            })
        ]
    });
};
var $48f0e9d81c82a26c$export$2e2bcd8739ae039 = $48f0e9d81c82a26c$var$GoodIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $0fa057fc54c651ae$var$BadIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("svg", {
        fill: theme.palette.text.primary,
        height: props.width,
        viewBox: "0 0 16 16",
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m0 9v-8c0-.552246.447693-1 1-1h3v10h-3c-.552307-.0000001-1-.447693-1-1z",
                transform: "translate(0 1)"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m9.15332 9.00007h-2.9541c-.258301 0-.387695.172363-.431152.246582-.043457.0737305-.131348.270508-.0063477.496094l1.0415 1.87549c.228516.410645.251953.893555.0649414 1.32471-.187012.431641-.556152.744629-1.0127.858398l-.734375.183594c-.178711.0449219-.368164-.012207-.492676-.150391l-3.9873-4.42969c-.413574-.460449-.641113-1.0542-.641113-1.67236v-5.2325c0-1.37842 1.12158-2.5 2.5-2.5l4.97412.0004883c1.12305 0 2.11475.756348 2.41113 1.83887l1.06738 4.89851c.03125.13623.0473633.275879.0473633.415527 0 1.01807-.828613 1.84668-1.84668 1.84668z",
                transform: "translate(5 1)"
            })
        ]
    });
};
var $0fa057fc54c651ae$export$2e2bcd8739ae039 = $0fa057fc54c651ae$var$BadIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $50991c90d6bad792$var$BestNewcomerIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("svg", {
        id: "Capa_1",
        enableBackground: "new 0 0 512 512",
        height: props.width,
        fill: theme.palette.text.primary,
        viewBox: "0 0 512 512",
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m488.207 256 21.219-36.418-30.61-28.997 10.043-40.953-37.563-19.13-1.907-42.089-41.392-7.83-13.599-39.88-41.95 4.087-24.309-34.458-39.091 15.813-33.048-26.145-33.046 26.145-39.09-15.814-24.31 34.458-41.95-4.087-13.599 39.881-41.392 7.829-1.906 42.089-37.564 19.13 10.043 40.953-30.61 28.997 21.217 36.419-21.219 36.418 30.61 28.997-10.043 40.953 37.564 19.13 1.906 42.089 41.392 7.83 13.599 39.88 41.95-4.087 24.31 34.458 39.09-15.813 33.048 26.145 33.046-26.145 39.09 15.814 24.31-34.458 41.95 4.087 13.599-39.881 41.392-7.83 1.907-42.089 37.564-19.13-10.043-40.953 30.61-28.997zm-232.207 183.478c-101.17 0-183.478-82.308-183.478-183.478s82.308-183.478 183.478-183.478 183.477 82.308 183.477 183.478-82.307 183.478-183.477 183.478z"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m256 102.556c-84.61 0-153.444 68.835-153.444 153.444s68.834 153.444 153.444 153.444c84.609 0 153.444-68.835 153.444-153.444s-68.836-153.444-153.444-153.444zm-73.44 204.461-32.003-25.028 6.511 30.475-22.041 4.709-14.332-67.083 18.591-3.972 32.003 25.029-6.511-30.475 22.041-4.71 14.332 67.083zm34.306-7.329-14.333-67.083 54.529-11.651 3.645 17.058-32.296 6.9 1.68 7.858 28.366-6.061 3.48 16.292-28.366 6.06 1.884 8.817 33.542-7.167 3.645 17.058zm156.014-33.335-24.246 5.18-18.487-33.527-3.746 38.277-24.246 5.181-35.8-62.496 23.288-4.975 19.841 35.643 4.213-40.782 20.796-4.443 19.944 36.122 4.11-41.262 21.466-4.587z"
            })
        ]
    });
};
var $50991c90d6bad792$export$2e2bcd8739ae039 = $50991c90d6bad792$var$BestNewcomerIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $6323b6fef031a38a$var$OldestGamerIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        id: "Layer_1",
        enableBackground: "new 0 0 511.35 511.35",
        fill: theme.palette.text.primary,
        height: props.width,
        viewBox: "0 0 511.35 511.35",
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m324.06 265.482c-.005.247-.019.493-.019.741v234.482c0 5.498 4.457 9.956 9.956 9.956s9.956-4.457 9.956-9.956v-230.955c-6.727.578-13.655-.79-19.893-4.268z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m375.808 236.375c-.256 6.816-2.5 13.63-6.938 19.558 2.63 2.64 4.259 6.278 4.259 10.29v31.494c0 5.498 4.457 9.956 9.956 9.956s9.956-4.457 9.956-9.956v-31.494c0-12.734-6.941-23.871-17.233-29.848z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m289.33 91.006c24.326 8.455 51.05-4.346 59.563-28.839 8.484-24.411-4.427-51.078-28.839-59.563-24.318-8.452-51.047 4.337-59.563 28.839-8.484 24.41 4.427 51.078 28.839 59.563z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m352.58 217.208-57.545-39.068-9.743-46.813 16.567 34.966 4.663 3.17 8.758-25.271c4.741-13.682 1.835-28.156-6.446-38.789-8.01.568-15.89-.496-23.426-3.114-12.474-4.335-22.884-12.552-29.95-23.461l-2.686-1.213c-14.03-6.338-30.4-4.515-42.692 4.754l-75.843 19.5c-10.885 2.798-17.696 13.604-15.526 24.631l19.932 101.295c1.076 5.469 4.175 10.017 8.357 13.052-.538 1.553-1.31 3.793-3.108 8.992-3.782 10.94-4.233 22.763-1.292 33.959l24.214 92.163-26.66 101.394c-3.805 14.472 4.842 29.288 19.314 33.093 14.44 3.799 29.281-4.814 33.093-19.313l28.471-108.284c1.188-4.516 1.188-9.263 0-13.779l-20.457-77.801 54.938 78.873-32.31 106.217c-4.355 14.316 3.72 29.452 18.036 33.807 14.406 4.384 29.481-3.815 33.806-18.036l36.137-118.798c2.417-7.944 1.057-16.557-3.689-23.371l-42.419-60.9 17.811-51.396-26.456-17.987c-1.781-1.793-14.886-6.83-14.522-21.716l1.862-57.994 11.491 55.215c1.121 5.39 4.295 10.132 8.849 13.224l65.063 44.172c9.86 6.694 23.387 3.976 29.84-6.221 6.167-9.74 3.103-22.679-6.432-29.152zm-181.702-45.261-6.688-33.988 20.273-5.212z"
                    })
                })
            ]
        })
    });
};
var $6323b6fef031a38a$export$2e2bcd8739ae039 = $6323b6fef031a38a$var$OldestGamerIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $2329768e9950cc40$var$YoungestGamerIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        version: "1.1",
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        height: props.width,
        width: props.width,
        fill: theme.palette.text.primary,
        viewBox: "0 0 478.646 478.646",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
            children: /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "M239.318,129.859c18.002,0,35.423-7.846,47.369-21.311c12.062-13.593,17.723-32.048,15.43-50.071c-2.248-17.677-12.144-33.861-26.781-44.006c-14.995-10.394-34.183-13.792-51.85-9.244c-17.153,4.415-31.95,16.163-40.21,31.822c-8.522,16.159-9.584,35.729-2.879,52.723c6.488,16.441,19.916,29.702,36.439,35.979C224.002,128.474,231.653,129.859,239.318,129.859z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "M396.377,3.368c-8.543-5.935-20.276-3.821-26.213,4.721c0,0-58.797,89.646-78.961,113.653c-15.046,17.913-29.379,22.915-50.979,19.929c-10.667-1.475-142.831-34.333-142.831-34.333c-9.274-2.24-19.01,3.081-22.171,12.073c-3.052,8.68,0.821,18.597,8.966,22.89c0.742,0.391,1.511,0.732,2.298,1.022l143.352,52.762c0.816,2.469,7.846,21.487,11.833,41.393c2.538,12.663,3.614,25.566,4.345,38.447c0.515,9.032,0.375,18.069,0.271,27.109c-0.107,9.317,1.421,18.433,5.113,27.023c-0.316,11.767-0.925,23.531-1.925,35.261c-1.095,12.834-3.107,25.591-5.204,38.309c-2.65,16.069-6.804,22.246-7.083,22.665c-5.144,1.946-11.37,1.279-16.696,0.58c-6.363-0.835-12.632-2.338-18.786-4.14c-5.408-1.584-10.743-3.417-16-5.444c-4.18-1.612-8.248-3.452-12.368-5.201c-1.917-0.813-3.822-1.714-5.931-2.171c-2.166-0.47-4.398-0.622-6.608-0.453c-4.376,0.335-8.627,1.935-12.134,4.572c-7.324,5.512-10.712,15.145-8.477,24.025c1.583,6.286,5.82,11.695,11.546,14.734c18.377,10.05,38.03,18.672,58.566,23.128c11.119,2.412,22.655,3.601,33.977,1.973c11.763-1.69,22.945-6.623,31.485-14.993c2.037-1.996,3.917-4.192,5.608-6.491c0,0.007-0.004,0.014-0.012,0.02c-0.021,0.029-0.044,0.061-0.064,0.093c0.928-1.544,2.104-2.964,3.082-4.479c1.666-2.574,3.203-5.23,4.625-7.947c2.847-5.436,5.281-11.085,7.445-16.823c4.344-11.519,7.706-23.4,10.591-35.36c1.895-7.852,3.583-15.753,5.111-23.684c3.197-0.14,6.364-0.512,9.504-1.126c5.679,11.608,10.942,23.428,15.409,35.56c-11.96,4.665-17.812,18.745-12.727,30.529c3.441,7.979,7.622,15.603,13.492,22.085c6.381,7.046,14.46,12.516,23.684,15.054c5.044,1.39,10.34,1.857,15.518,1.06c10.4-1.632,19.107-9.728,20.96-20.681c4.004-23.586,0.181-47.695-5.239-70.752c-2.937-12.491-6.513-24.835-10.503-37.028c-2.612-7.984-5.317-15.978-8.453-23.775c-0.622-1.547-1.216-3.106-1.878-4.638c0.774-5.185,0.839-10.385,0.409-15.602c-0.43-5.215-0.787-10.444-1.325-15.649c-1.272-12.316-2.989-24.617-5.307-36.781c-4.83-25.334-11.619-50.367-21.603-74.186c-2.712-6.47-5.625-12.848-8.872-19.067l67.023-125.525C406.696,19.392,404.308,8.879,396.377,3.368C387.834-2.567,404.308,8.879,396.377,3.368z"
                    })
                ]
            })
        })
    });
};
var $2329768e9950cc40$export$2e2bcd8739ae039 = $2329768e9950cc40$var$YoungestGamerIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $0a5b63ebd61cd73f$var$WorstTournamentIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("svg", {
        version: "1.1",
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        width: props.width,
        height: props.width,
        viewBox: "0 0 31.953 31.953",
        fill: theme.palette.text.primary,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)("rect", {
                            x: "5.174",
                            y: "19.758",
                            width: props.width,
                            height: props.width,
                            fill: theme.palette.text.primary
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("circle", {
                            cx: "22.557",
                            cy: "3.928",
                            r: "3.928"
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                            d: "M25.173,27.842V15.693L23.05,15.66l0.783-7.456l-1.97,0.119l-0.299,3.716l-1.854-4.52l-4.365-0.553l-1.632,11.739l8.21,0.102l0.037,9.035l0,0v1.506h4.818v-1.506H25.173z M20.336,15.674l-0.01,0.02h-0.795l0.074-3.43l1.193,3.41H20.336z"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {})
        ]
    });
};
var $0a5b63ebd61cd73f$export$2e2bcd8739ae039 = $0a5b63ebd61cd73f$var$WorstTournamentIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $8813d52d88ab87a1$var$BestTournamentIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("svg", {
        id: "Capa_1",
        enableBackground: "new 0 0 512.004 512.004",
        height: props.width,
        fill: theme.palette.text.primary,
        viewBox: "0 0 512.004 512.004",
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m381.361 452.004h-250.717c-8.284 0-15 6.716-15 15v30c0 8.284 6.716 15 15 15h250.717c8.284 0 15-6.716 15-15v-30c0-8.284-6.716-15-15-15z"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m314.764 379.14h-10.587c-3.354-8.977-5.68-23.612-5.89-42.569-13.255 3.469-27.406 5.228-42.399 5.228-13.081 0-27.383-1.382-41.99-5.163-.045 8.862-.558 18.645-2.041 27.688-.839 5.115-2.119 10.421-3.803 14.815h-10.814c-19.299 0-35 15.701-35 35v7.864h187.523v-7.864c.001-19.298-15.7-34.999-34.999-34.999z"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m486.909 60.267h-53.331c-.646 7.185-1.21 14.557-1.621 19.943-.249 3.262-.507 6.624-.776 10.057h40.173c-3.358 41.122-21.991 76.861-55.535 106.624-3.236 12.803-7.158 25.45-11.979 37.6-1.887 4.757-3.891 9.349-5.991 13.801l17.996-13.028c57.107-41.342 86.064-94.755 86.064-158.755v-1.243c0-8.284-6.716-14.999-15-14.999z"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m95.07 196.001c-32.87-29.6-51.129-65.041-54.429-105.735h39.032c-.34-4.349-.658-8.577-.965-12.663-.371-4.937-.84-11.166-1.369-17.337h-52.243c-8.284 0-15 6.716-15 15v1.352c0 63.921 28.905 117.297 85.913 158.646l17.221 12.49c-2.215-4.693-4.346-9.598-6.375-14.748-4.724-11.987-8.585-24.426-11.785-37.005z"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m89.727 30h14.014c2.158 9.113 3.646 28.914 4.882 45.355 3.147 41.878 7.457 99.232 26.142 146.654 23.475 59.58 64.227 89.79 121.122 89.79 56.407 0 96.803-29.733 120.066-88.372 18.549-46.753 22.907-103.828 26.089-145.503 1.339-17.534 2.958-38.723 5.395-47.926h14.839c8.284 0 15-6.716 15-15s-6.716-15-15-15h-332.549c-8.284 0-15 6.716-15 15 0 8.286 6.716 15.002 15 15.002zm142.035 76.642 21.12-12.8c1.28-.8 2.88-1.12 4.641-1.12 5.12 0 11.04 3.04 11.04 7.84v101.762c0 5.12-6.24 7.68-12.48 7.68s-12.481-2.56-12.481-7.68v-81.442l-4.64 2.88c-1.44.96-2.88 1.28-4 1.28-4.641 0-7.841-4.96-7.841-9.92 0-3.36 1.441-6.56 4.641-8.48z"
            })
        ]
    });
};
var $8813d52d88ab87a1$export$2e2bcd8739ae039 = $8813d52d88ab87a1$var$BestTournamentIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $aa853755a3ed534a$var$YoungestWinnerIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        id: "Layer_1",
        enableBackground: "new 0 0 110.771 234.616",
        fill: theme.palette.text.primary,
        height: props.width,
        viewBox: "0 0 110.771 234.616",
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m43.43 154.407v69.833c0 5.729 4.646 10.375 10.378 10.375 5.727 0 10.373-4.646 10.373-10.375v-49.417h4.113v49.417c0 5.729 4.646 10.375 10.377 10.375 5.729 0 10.375-4.646 10.375-10.375v-69.833z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m11.162 67.928 3.73 1.737c3.174 9.19 7.108 16.955 11.536 23.123 3.316 4.598 6.91 8.333 10.869 11.062 1.934 1.328 3.985 2.423 6.132 3.199v42.357h45.616v-34.725c1.492 2.732 2.976 6.449 4.169 11.188 2.177 8.463 3.56 20.066 3.556 34.772v.329c.044 3.838 3.17 6.92 6.998 6.92.027 0 .055 0 .082-.001 3.866-.045 6.965-3.215 6.92-7.08-.002-.005-.002-.058-.002-.168-.02-20.773-2.498-36.318-6.963-47.426-2.254-5.547-5.024-10.049-8.626-13.424-3.155-2.988-7.21-4.999-11.484-5.39-.214-.023-.43-.037-.65-.037h-.104c-.29-.014-.578-.044-.87-.042-.254 0-.506.016-.754.042h-30.162c-.246-.026-.496-.041-.75-.041-1.143.008-2.912-.455-5.178-2.012-3.383-2.295-7.533-6.976-11.26-13.812-3.748-6.827-7.135-15.759-9.508-26.444-.015-.064-.036-.124-.052-.187.855-.584 1.701-1.218 2.536-1.902.321-.263.643-.528.961-.804 21.698 1.951 31.32-25.416 31.32-25.416l-9.824-4.576c.647-1.27 1.111-2.227 1.362-2.754.091-.071.171-.172.227-.293.148-.319.084-.664-.144-.771l-30.781-14.338c-.227-.105-.533.066-.682.386-.057.122-.082.248-.08.362-.242.531-.677 1.501-1.231 2.814l-9.824-4.576s-14.764 24.975.694 40.33c-.043 2.587.144 5.069.619 7.364.303 1.47.728 2.859 1.291 4.15-.19.741-.259 1.519-.192 2.312-.286 1.385-.882 3.155-2.159 4.297-.612.547-1.373.956-2.343 1.094-.067-.025-3.881.799-3.881.799s-2.074 1.783-2.188 1.997c-.025.024-.046.053-.062.087-.065.142-.006.308.135.374zm43.133-42.223s-9.775 21.089-21.428 18.515c6.294-7.032 11.533-15.749 14.731-21.634zm-44.376-20.672 6.696 3.119c-2.447 6.234-5.75 15.855-7.083 25.198-9.467-7.262.387-28.317.387-28.317z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("ellipse", {
                    cx: "66.238",
                    cy: "68.323",
                    rx: "20.909",
                    ry: "20.912"
                })
            ]
        })
    });
};
var $aa853755a3ed534a$export$2e2bcd8739ae039 = $aa853755a3ed534a$var$YoungestWinnerIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $9c0647079d1d7751$var$OldestWinnerIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        id: "Layer_1",
        enableBackground: "new 0 0 191.248 235.71",
        fill: theme.palette.text.primary,
        height: props.width,
        viewBox: "0 0 191.248 235.71",
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m68.654 74.015h7.388c.301 4.859.948 11.53 2.328 18.284.736.332 1.43.761 2.059 1.284 1.848 1.541 2.984 3.706 3.201 6.101.21 2.313-.47 4.57-1.907 6.386.308.125.629.238.948.353 1.775 3.984 4.006 7.439 6.813 9.836-.063.107 2.721 6.191-1.22 8.76-.072.005-3.182 2.361-3.182 2.361s-1.127 2.494-1.141 2.734c-.012.033-.02.068-.02.106 0 .155.127.282.281.282h17.857c.154 0 .279-.127.279-.282 0-.038-.007-.073-.02-.106-.012-.24-1.14-2.734-1.14-2.734s-3.108-2.356-3.181-2.361c-3.941-2.568-1.158-8.652-1.222-8.76 1.989-1.699 3.688-3.932 5.142-6.505-1.042.087-2.093.166-3.163.228-.211.01-.406.018-.598.018-5.281 0-9.662-4.133-9.975-9.41-.159-2.665.73-5.233 2.504-7.232 1.773-1.997 4.219-3.185 6.887-3.342 3.797-.231 7.452-.657 10.979-1.254.936-5.503 1.419-10.74 1.667-14.746h7.388s.011 6.626-1.747 13.197c1.399-.359 2.778-.745 4.127-1.168 2-8.355 1.261-15.886 1.261-15.886h-10.838c.052-1.424.067-2.488.072-3.071.051-.104.08-.228.08-.362 0-.352-.203-.638-.454-.638h-33.954c-.253 0-.456.285-.456.638 0 .135.029.259.082.362.005.583.021 1.647.072 3.071h-10.84s-1.255 12.723 3.891 23.442c.921-.771 1.979-1.346 3.122-1.697-3.39-7.647-3.37-17.889-3.37-17.889z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("ellipse", {
                    cx: "142.385",
                    cy: "22.498",
                    rx: "22.495",
                    ry: "22.493",
                    transform: "matrix(.974 -.227 .227 .974 -1.392 32.876)"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m154.848 60.081c1.649-3.479 5.197-5.726 9.041-5.726 1.467 0 2.888.317 4.225.943 2.42 1.126 4.255 3.131 5.168 5.64.914 2.509.795 5.225-.333 7.647-.821 1.726-5.444 10.742-16.536 20.112-1.059.897-2.205 1.816-3.434 2.743 1.615 9.992 2.625 20.698 1.318 30.475-3.179 8.621-9.063 27.891-9.092 52.945-.003 15.706 2.36 33.698 9.32 52.482 1.867 5.041 6.643 8.16 11.723 8.161 1.442 0 2.908-.251 4.34-.782 6.474-2.397 9.779-9.59 7.381-16.063-5.788-15.628-7.762-30.579-7.764-43.798-.004-14.127 2.279-26.243 4.541-34.71.392-1.464.78-2.81 1.156-4.046 6.313-1.6 12.033-5.879 14.145-16.753 2.586-22.215 1.123-35.346-5.682-55.52-5.035-14.643-17.41-19.279-25.947-17.15-3.546.884-6.263 3.459-8.026 6.878-.033.025-.068.043-.095.085-2.042 3.21-4.251 10.732-6.065 19.153 7.433-6.474 10.481-12.449 10.616-12.716z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m140.4 99.892c1.747 3.664 3.652 7.19 5.702 10.574 1.122-3.762 2.422-7.393 3.877-10.879-.227-1.873-.392-3.752-.527-5.631-2.672 1.8-5.675 3.595-9.023 5.301-.011.212-.022.43-.029.635z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m97.692 92.012c-4.412.261-7.773 4.049-7.512 8.461.252 4.248 3.777 7.525 7.979 7.526.16 0 .32-.005.482-.015 26.93-1.567 45.227-11.276 56.48-20.816 11.287-9.536 15.666-18.696 16.014-19.429 1.867-4.005.136-8.765-3.867-10.631-3.99-1.862-8.729-.149-10.609 3.821s-.002.002-.024.048l.001.001c-.337.672-3.981 7.601-12.686 14.67-9.049 7.316-23.425 14.977-46.258 16.364z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m16.779 169.664c2.05 6.218 4.3 15.676 4.283 27.158 0 7.692-.987 16.308-3.692 25.612-1.6 5.501 1.563 11.26 7.065 12.86.968.281 1.944.416 2.903.416 4.496 0 8.639-2.945 9.959-7.481 3.291-11.315 4.52-21.932 4.517-31.407-.026-18.552-4.629-32.639-7.622-39.866-.026-.221-.051-.439-.081-.667-2.359-10.842-.783-23.536.809-34.06-6.908-.687-12.064-2.082-13.812-2.601l-.023-.008-.111-.034c-4.733-1.483-7.378-6.544-5.897-11.28 1.183-3.773 4.633-6.311 8.586-6.311.912 0 1.818.141 2.694.414l.173.052.097.026c.187.051.445.124.772.21.746.192 1.959.483 3.477.774 1.26.244 2.856.507 4.67.722-1.543-4.228-4.717-7.487-9.113-8.043-7.698-.973-18.445 3.82-22.138 16.023-4.97 16.805-5.571 27.487-2.089 45.123 2.616 9.112 8.466 11.867 14.573 12.368z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m26.895 104.632c-.412-.107-.721-.194-.914-.249-.098-.028-.164-.048-.201-.06l-.021-.006c-3.691-1.156-7.618.898-8.774 4.586-1.155 3.69.899 7.618 4.587 8.773.411.115 9.321 2.926 21.031 2.944 5.856-.004 12.449-.712 19.032-3.019 6.565-2.295 13.141-6.29 18.407-12.624 2.476-2.97 2.074-7.382-.896-9.858-2.969-2.475-7.384-2.074-9.859.896-3.482 4.166-7.657 6.733-12.295 8.376-4.621 1.63-9.684 2.234-14.389 2.23-4.701.002-9.025-.592-12.107-1.187-1.543-.295-2.778-.59-3.601-.802z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("ellipse", {
                    cx: "32.749",
                    cy: "73.49",
                    rx: "20.909",
                    ry: "20.91",
                    transform: "matrix(.997 -.082 .082 .997 -5.93 2.941)"
                })
            ]
        })
    });
};
var $9c0647079d1d7751$export$2e2bcd8739ae039 = $9c0647079d1d7751$var$OldestWinnerIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $4c05ca4987693bb3$var$StarsIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("svg", {
        version: "1.1",
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 512 512",
        height: props.width,
        width: props.width,
        fill: theme.palette.text.primary,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                children: /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "M298.138,136.665c-62.065-13.011-110.576-61.522-123.585-123.588C172.955,5.458,166.235,0,158.448,0s-14.507,5.458-16.104,13.078c-13.01,62.065-61.521,110.575-123.586,123.584c-7.62,1.597-13.079,8.318-13.079,16.104s5.458,14.507,13.079,16.104c62.064,13.011,110.573,61.521,123.583,123.586c1.597,7.62,8.317,13.079,16.104,13.079c7.786,0,14.507-5.458,16.104-13.079c13.011-62.065,61.523-110.575,123.588-123.583c7.62-1.597,13.079-8.317,13.079-16.104C311.215,144.983,305.757,138.262,298.138,136.665z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                children: /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "M270.938,408.484c-29.242-6.129-52.098-28.985-58.229-58.229c-1.597-7.62-8.317-13.079-16.104-13.079c-7.786,0-14.507,5.457-16.104,13.078c-6.131,29.243-28.988,52.099-58.23,58.229c-7.62,1.597-13.079,8.318-13.079,16.104c0,7.786,5.458,14.507,13.079,16.104c29.241,6.13,52.098,28.987,58.228,58.23c1.597,7.62,8.317,13.079,16.104,13.079c7.786,0,14.507-5.457,16.104-13.079c6.131-29.243,28.988-52.099,58.231-58.229c7.62-1.597,13.079-8.318,13.079-16.104C284.017,416.802,278.559,410.082,270.938,408.484z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                children: /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "M493.243,256.135c-39.526-8.286-70.419-39.18-78.704-78.705c-1.597-7.62-8.317-13.079-16.104-13.079c-7.786,0-14.507,5.457-16.104,13.078c-8.286,39.526-39.179,70.419-78.705,78.704c-7.62,1.597-13.079,8.318-13.079,16.104c0,7.786,5.458,14.506,13.079,16.104c39.525,8.286,70.418,39.179,78.703,78.705c1.597,7.62,8.317,13.079,16.104,13.079c7.786,0,14.507-5.457,16.104-13.079c8.287-39.526,39.18-70.419,78.705-78.703c7.62-1.598,13.079-8.318,13.079-16.104S500.863,257.732,493.243,256.135z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {})
        ]
    });
};
var $4c05ca4987693bb3$export$2e2bcd8739ae039 = $4c05ca4987693bb3$var$StarsIcon;




var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");


const $c537479af6c6f6eb$var$PieChart = (props)=>{
    (0, $87f4fbac7cf060d6$export$acaa6426d77a227e).register((0, $87f4fbac7cf060d6$export$d48203c759d6a1fc), (0, $87f4fbac7cf060d6$export$28c660c63b792dea), (0, $87f4fbac7cf060d6$export$ed247974535929c7));
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0320e986bcdf7c3f$export$2ae8800cf67c848c), {
        data: props.chartData,
        options: props.chartOptions,
        height: props.size,
        width: props.size
    });
};
var $c537479af6c6f6eb$export$2e2bcd8739ae039 = $c537479af6c6f6eb$var$PieChart;




var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $460a58cbb3cf2dc9$var$RoundIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        id: "Capa_1",
        fill: theme.palette.text.primary,
        enableBackground: "new 0 0 512.497 512.497",
        height: props.width,
        viewBox: "0 0 512.497 512.497",
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m73.208 198.877c18.753-59.701 65.967-106.916 125.669-125.669l-31.735-31.735c-9.809-9.809-22.849-15.21-36.721-15.21-5.348 0-10.57.811-15.534 2.36 4.744 23.255-1.871 48.388-19.874 66.39-13.804 13.804-32.157 21.406-51.679 21.406-5.005 0-9.932-.508-14.727-1.484-1.539 4.949-2.344 10.155-2.344 15.485 0 13.871 5.402 26.912 15.21 36.721z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m382.075 26.263c-13.872 0-26.912 5.401-36.721 15.21l-31.734 31.735c59.702 18.753 106.916 65.968 125.669 125.669l31.735-31.735c9.808-9.809 15.21-22.85 15.21-36.721 0-5.331-.805-10.536-2.344-15.485-4.795.976-9.721 1.484-14.727 1.484-19.522 0-37.875-7.602-51.679-21.406-18.003-18.003-24.618-43.135-19.874-66.39-4.964-1.55-10.186-2.361-15.535-2.361z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m130.421 486.234c13.872 0 26.912-5.401 36.721-15.21l31.735-31.735c-59.702-18.753-106.916-65.967-125.669-125.669l-31.735 31.735c-9.808 9.809-15.21 22.85-15.21 36.721 0 5.331.805 10.536 2.344 15.485 4.795-.976 9.721-1.484 14.727-1.484 19.522 0 37.875 7.602 51.679 21.406s21.406 32.157 21.406 51.679c0 5.006-.508 9.932-1.484 14.727 4.95 1.54 10.155 2.345 15.486 2.345z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m382.075 486.234c5.331 0 10.536-.805 15.485-2.344-.976-4.795-1.484-9.721-1.484-14.727 0-19.522 7.602-37.875 21.406-51.679s32.157-21.406 51.679-21.406c5.005 0 9.932.508 14.727 1.484 1.539-4.949 2.344-10.155 2.344-15.485 0-13.871-5.402-26.912-15.21-36.721l-31.735-31.734c-18.753 59.701-65.967 106.915-125.669 125.668l31.735 31.735c9.81 9.807 22.851 15.209 36.722 15.209z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m43.334 86.42c56.615-.912 56.604-85.269-.002-86.171-56.613.911-56.602 85.269.002 86.171z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m438.696 73.8c41.203 39.162 100.092-19.745 60.931-60.933-41.202-39.161-100.09 19.746-60.931 60.933z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m499.629 438.697c-41.203-39.163-100.092 19.745-60.931 60.933 41.202 39.161 100.09-19.746 60.931-60.933z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m73.8 438.697c-41.203-39.163-100.092 19.745-60.931 60.933 41.202 39.161 100.09-19.746 60.931-60.933z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("circle", {
                    cx: "256.248",
                    cy: "256.249",
                    r: "161.808"
                })
            ]
        })
    });
};
var $460a58cbb3cf2dc9$export$2e2bcd8739ae039 = $460a58cbb3cf2dc9$var$RoundIcon;











var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $866057e28c6b69af$var$HandIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        id: "fi_15759170",
        "enable-background": "new 0 0 100 100",
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
            d: "m84.7637787 19.9608517c-1.0133209-1.0159683-2.3701477-1.6128063-3.8038559-1.6724968-1.527916.0344849-2.9815445.6671238-4.0479736 1.762682-1.0664215 1.0955563-1.6618729 2.5651112-1.6552505 4.0931377v22.0951214c.009285.8249702-.5915375 1.5305748-1.4072113 1.653923-.4443207.0424423-.885994-.1034546-1.2162323-.4045296-.3289261-.301075-.5159225-.7268143-.5146027-1.1737823v-34.816268c-.0106049-1.4987535-.6127548-2.9338131-1.6725006-3.9936481-1.0040131-1.0252361-2.3688202-1.6181021-3.8038483-1.653923-1.5279236.0344844-2.9815521.6684818-4.0479736 1.7626815-1.0663528 1.0955524-1.6618729 2.5651112-1.6552505 4.0944948v30.423317-.0013237c.009285.8249702-.5915413 1.5318909-1.4072189 1.653923-.4416733.043766-.8793411-.1007996-1.2096024-.3979073-.3289299-.2970963-.5172577-.7175522-.5212555-1.1605415v-34.0149517c.0013237-1.5597696-.6353073-3.0531979-1.7640076-4.1315026-1.1273766-1.0769835-2.6473503-1.6459806-4.2058601-1.5730124-1.5305748.0305054-2.9868889.6618295-4.0544319 1.7573814-1.0676765 1.0968785-1.6605453 2.5690851-1.6499557 4.0982308v33.8265076c.009285.8249741-.5915375 1.5318909-1.4072151 1.653923-.4416771.0437698-.8793411-.1007996-1.2082787-.3979073-.3289375-.2971039-.5185814-.7175484-.522583-1.1605415v-27.076825c.0013275-1.4894543-.5822449-2.9205704-1.6233978-3.9868612-1.0411606-1.0650311-2.4576836-1.6817656-3.9471321-1.7162657-1.5305748.0291796-2.9868851.6605034-4.0544319 1.7573824-1.0676765 1.0955515-1.6605434 2.5677586-1.6499538 4.0982304v42.5339661l-5.7045822-7.7007294c-1.1087952-1.4616051-2.7521267-2.4231796-4.5691681-2.6765137-1.8170395-.2533379-3.6605644.2241478-5.1277103 1.3262978-1.3939753 1.0637131-2.3343267 2.6154976-2.6300964 4.3437157-.2957697 1.7295456.0729475 3.505394 1.0332155 4.9725342l10.3810431 16.6003693c.9204559 1.4509888 1.7281857 2.969635 2.4152412 4.5440369l.1896648.4376984c11.0669098 25.0609894 47.2501602 23.1588974 55.6163788-2.9285202 2.0558014-6.3968964 3.1009445-13.0749397 3.099617-19.7940636v-33.0652638c-.0066299-1.4960747-.6008148-2.9298439-1.653923-3.9936466z"
        })
    });
};
var $866057e28c6b69af$export$2e2bcd8739ae039 = $866057e28c6b69af$var$HandIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $a95e06d175b0c813$var$BadSmileyIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("svg", {
        id: "a",
        viewBox: "0 0 170 170",
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        "data-name": "svg",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m69.862 51.121c-1.953-1.953-5.118-1.953-7.071 0l-6.771 6.771-6.771-6.771c-1.953-1.952-5.118-1.953-7.071 0-1.953 1.952-1.953 5.118 0 7.07l6.771 6.771-6.771 6.771c-1.953 1.952-1.953 5.118 0 7.07.977.977 2.256 1.465 3.536 1.465s2.559-.488 3.536-1.465l6.771-6.771 6.771 6.771c.977.977 2.256 1.465 3.536 1.465s2.559-.488 3.536-1.465c1.953-1.952 1.953-5.118 0-7.07l-6.771-6.771 6.771-6.771c1.953-1.952 1.953-5.118 0-7.07z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m128.009 51.121c-1.953-1.953-5.118-1.953-7.071 0l-6.771 6.771-6.771-6.771c-1.953-1.953-5.118-1.953-7.071 0-1.953 1.952-1.953 5.118 0 7.07l6.771 6.771-6.771 6.771c-1.953 1.952-1.953 5.118 0 7.07.977.977 2.256 1.465 3.536 1.465s2.559-.488 3.536-1.465l6.771-6.771 6.771 6.771c.977.977 2.256 1.465 3.536 1.465s2.559-.488 3.536-1.465c1.953-1.952 1.953-5.118 0-7.07l-6.771-6.771 6.771-6.771c1.953-1.952 1.953-5.118 0-7.07z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m85 5c-44.112 0-80 35.888-80 80s35.888 80 80 80 80-35.888 80-80-35.888-80-80-80zm0 150c-38.598 0-70-31.402-70-70s31.402-70 70-70 70 31.402 70 70-31.402 70-70 70z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m125.413 126.441c-1.896 0-3.709-1.084-4.55-2.921-6.386-13.96-20.463-22.98-35.863-22.98s-29.477 9.021-35.863 22.98c-1.149 2.511-4.118 3.614-6.627 2.467-2.511-1.148-3.616-4.116-2.467-6.627 8.009-17.508 25.656-28.82 44.957-28.82s36.948 11.312 44.957 28.82c1.149 2.511.044 5.479-2.467 6.627-.674.309-1.381.454-2.077.454z"
            })
        ]
    });
};
var $a95e06d175b0c813$export$2e2bcd8739ae039 = $a95e06d175b0c813$var$BadSmileyIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $6ece8f7499eb03b4$var$CardsIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        id: "fi_5485099",
        "enable-background": "new 0 0 100 100",
        viewBox: "0 0 100 100",
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
            children: /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m51.4 80.4c-.3 0-.6.3-.6.6v2.4c0 .3.3.6.6.6s.6-.3.6-.6v-2.4c0-.3-.3-.6-.6-.6z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m49.5 84.6c.3-.2.4-.5.2-.8l-1.2-2.1c-.2-.3-.5-.4-.8-.2s-.4.5-.2.8l1.2 2.1c.1.2.5.3.8.2z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m45.8 83.9c-.3-.2-.7-.1-.8.2-.2.3-.1.7.2.8l2.1 1.2c.3.2.7.1.8-.2.2-.3.1-.7-.2-.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m47.6 87.8c0-.3-.3-.6-.6-.6h-2.4c-.3 0-.6.3-.6.6s.3.6.6.6h2.4c.3 0 .6-.3.6-.6z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m48.1 89.7c-.2-.3-.5-.4-.8-.2l-2.1 1.2c-.3.2-.4.5-.2.8s.5.4.8.2l2.1-1.2c.3-.1.4-.5.2-.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m49.5 91.1c-.3-.2-.7-.1-.8.2l-1.2 2.1c-.2.3-.1.7.2.8.3.2.7.1.8-.2l1.2-2.1c.2-.3.1-.7-.2-.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m51.4 91.6c-.3 0-.6.3-.6.6v2.4c0 .3.3.6.6.6s.6-.3.6-.6v-2.4c0-.4-.3-.6-.6-.6z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m54.1 91.3c-.2-.3-.5-.4-.8-.2s-.4.5-.2.8l1.2 2.1c.2.3.5.4.8.2s.4-.5.2-.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m57.6 90.7-2.1-1.2c-.3-.2-.7-.1-.8.2-.2.3-.1.7.2.8l2.1 1.2c.3.2.7.1.8-.2.2-.3.1-.7-.2-.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m58.2 87.2h-2.4c-.3 0-.6.3-.6.6s.3.6.6.6h2.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m54.6 85.9c.2.3.5.4.8.2l2.1-1.2c.3-.2.4-.5.2-.8s-.5-.4-.8-.2l-2.1 1.2c-.2.2-.3.5-.2.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m55.1 81.4c-.3-.2-.7-.1-.8.2l-1.3 2.1c-.2.3-.1.7.2.8.3.2.7.1.8-.2l1.2-2.1c.3-.2.2-.6-.1-.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m48.8 87.8c0 1.4 1.2 2.6 2.6 2.6s2.6-1.2 2.6-2.6-1.2-2.6-2.6-2.6-2.6 1.2-2.6 2.6zm4 0c0 .8-.6 1.4-1.4 1.4s-1.4-.6-1.4-1.4.6-1.4 1.4-1.4 1.4.6 1.4 1.4z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m67.3 5.6c.3 0 .6-.3.6-.6v-2.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6v2.4c0 .4.3.6.6.6z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m64.6 5.9c.2.3.5.4.8.2s.4-.5.2-.8l-1.2-2.1c-.2-.3-.5-.4-.8-.2s-.4.5-.2.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m61.1 6.5 2.1 1.2c.3.2.7.1.8-.2.2-.3.1-.7-.2-.8l-2.1-1.2c-.3-.2-.7-.1-.8.2-.2.3-.1.7.2.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m60.5 10h2.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6h-2.4c-.3 0-.6.3-.6.6s.3.6.6.6z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m64 11.3c-.2-.3-.5-.4-.8-.2l-2.1 1.2c-.3.2-.4.5-.2.8s.5.4.8.2l2.1-1.2c.3-.2.4-.5.2-.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m63.6 15.8c.3.2.7.1.8-.2l1.2-2.1c.2-.3.1-.7-.2-.8-.3-.2-.7-.1-.8.2l-1.2 2.1c-.2.3-.1.6.2.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m66.7 13.8v2.4c0 .3.3.6.6.6s.6-.3.6-.6v-2.4c0-.3-.3-.6-.6-.6s-.6.2-.6.6z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m70.2 15.6c.2.3.5.4.8.2s.4-.5.2-.8l-1.2-2.1c-.2-.3-.5-.4-.8-.2s-.4.5-.2.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m73.7 13.1c.2-.3.1-.7-.2-.8l-2.1-1.2c-.3-.2-.7-.1-.8.2-.2.3-.1.7.2.8l2.1 1.2c.3.2.6.1.8-.2z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m71.1 9.4c0 .3.3.6.6.6h2.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6h-2.4c-.4 0-.6.3-.6.6z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m70.6 7.5c.2.3.5.4.8.2l2.1-1.2c.3-.2.4-.5.2-.8s-.5-.4-.8-.2l-2.1 1.2c-.3.1-.4.5-.2.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m69.2 6.1c.3.2.7.1.8-.2l1.2-2.1c.2-.3.1-.6-.2-.8s-.7-.1-.8.2l-1.2 2.1c-.2.3-.1.7.2.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m69.9 9.4c0-1.4-1.2-2.6-2.6-2.6s-2.6 1.2-2.6 2.6 1.2 2.6 2.6 2.6 2.6-1.2 2.6-2.6zm-2.6 1.4c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.4.6 1.4 1.4-.6 1.4-1.4 1.4z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m4.5 75.7c-.3-.3-.7-.3-1 0s-.3.7 0 1l1.1 1.1c.3.3.7.3 1 0s.3-.7 0-1z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m9.5 81.7c.3-.3.3-.7 0-1l-1.1-1.1c-.3-.3-.7-.3-1 0s-.3.7 0 1l1.1 1.1c.2.3.7.3 1 0z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m8.3 77.8 1.1-1.1c.3-.3.3-.7 0-1s-.7-.3-1 0l-1.1 1.1c-.3.3-.3.7 0 1s.7.3 1 0z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m4.6 79.5-1.1 1.1c-.3.3-.3.7 0 1s.7.3 1 0l1.1-1.1c.3-.3.3-.7 0-1s-.7-.2-1 0z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m6 78.2c-.2.2-.2.6 0 .9.2.2.6.2.9 0 .2-.2.2-.6 0-.9-.3-.2-.6-.2-.9 0z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m3.9 28.2c.3.3.7.3 1 0s.3-.7 0-1l-1.1-1.1c-.3-.3-.7-.3-1 0s-.3.7 0 1z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m7.8 32.1c.3.3.7.3 1 0s.3-.7 0-1l-1.1-1.1c-.3-.3-.7-.3-1 0s-.3.7 0 1z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m7.7 28.2 1.1-1.1c.3-.3.3-.7 0-1s-.7-.3-1 0l-1.1 1.1c-.3.3-.3.7 0 1s.7.3 1 0z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m3.8 32.1 1.2-1.1c.3-.3.3-.7 0-1s-.7-.3-1 0l-1.1 1.1c-.3.3-.3.7 0 1 .2.3.6.3.9 0z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("circle", {
                        cx: "5.8",
                        cy: "29.1",
                        r: ".6"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m70 87.8c-.4 0-.7.3-.7.7v1.6c0 .4.3.7.7.7s.7-.3.7-.7v-1.6c.1-.4-.3-.7-.7-.7z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m70 93.3c-.4 0-.7.3-.7.7v1.6c0 .4.3.7.7.7s.7-.3.7-.7v-1.6c.1-.4-.3-.7-.7-.7z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m73.6 91.4h-1.6c-.4 0-.7.3-.7.7s.3.7.7.7h1.6c.4 0 .7-.3.7-.7s-.3-.7-.7-.7z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m68.1 91.4h-1.6c-.4 0-.7.3-.7.7s.3.7.7.7h1.6c.4 0 .7-.3.7-.7s-.3-.7-.7-.7z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("circle", {
                        cx: "70",
                        cy: "92.1",
                        r: ".6"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m45.8 7.8c.4 0 .7-.3.7-.7v-1.6c0-.4-.3-.7-.7-.7s-.7.3-.7.7v1.6c0 .4.3.7.7.7z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m45.8 13.3c.4 0 .7-.3.7-.7v-1.6c0-.4-.3-.7-.7-.7s-.7.3-.7.7v1.6c0 .4.3.7.7.7z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m47.7 9.8h1.6c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-1.6c-.4-.1-.7.2-.7.6s.3.8.7.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m42.3 9.8h1.6c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-1.6c-.4 0-.7.3-.7.7-.1.3.3.7.7.7z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m45.8 8.4c-.3 0-.6.3-.6.6s.3.6.6.6.6-.3.6-.6-.2-.6-.6-.6z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m30.1 87.8c-.3-.3-.7-.3-1 0s-.3.7 0 1l1.1 1.1c.3.3.7.3 1 0s.3-.7 0-1z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m33.9 91.7c-.3-.3-.7-.3-1 0s-.3.7 0 1l1.1 1.1c.3.3.7.3 1 0s.3-.7 0-1z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m34.1 87.8-1.1 1.1c-.3.3-.3.7 0 1s.7.3 1 0l1.1-1.1c.3-.3.3-.7 0-1s-.7-.3-1 0z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m30.2 91.7-1.1 1.1c-.3.3-.3.7 0 1s.7.3 1 0l1.1-1.1c.3-.3.3-.7 0-1s-.7-.3-1 0z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m31.6 90.4c-.2.2-.2.6 0 .9.2.2.6.2.9 0 .2-.2.2-.6 0-.9s-.6-.3-.9 0z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m32.2 17.5c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1-3.1 1.4-3.1 3.1 1.4 3.1 3.1 3.1zm0-4.8c.9 0 1.7.7 1.7 1.7 0 .9-.7 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7 0-.9.8-1.7 1.7-1.7z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m11.5 91.8c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1 3.1-1.4 3.1-3.1-1.4-3.1-3.1-3.1zm0 4.8c-.9 0-1.7-.7-1.7-1.7 0-.9.7-1.7 1.7-1.7s1.7.7 1.7 1.7c0 .9-.8 1.7-1.7 1.7z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m93 74.2c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1-3.1 1.4-3.1 3.1 1.4 3.1 3.1 3.1zm0-4.8c.9 0 1.7.7 1.7 1.7 0 .9-.7 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7s.8-1.7 1.7-1.7z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m91.6 33.4c0 1.7 1.4 3.1 3.1 3.1s3.1-1.4 3.1-3.1-1.4-3.1-3.1-3.1-3.1 1.4-3.1 3.1zm4.7 0c0 .9-.7 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7 0-.9.7-1.7 1.7-1.7s1.7.8 1.7 1.7z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m9.4 11.8c.2.2.3.5.2.7l-.6 2.8c-.2.7.5 1.2 1.2.9l2.6-1.2c.2-.1.5-.1.8 0l2.5 1.5c.6.4 1.3-.1 1.3-.8l-.3-2.9c0-.3.1-.5.3-.7l2.2-1.9c.3-.4.1-1.2-.6-1.3l-2.9-.6c-.3-.1-.5-.2-.6-.5l-1.2-2.7c-.3-.6-1.2-.7-1.5-.1l-1.4 2.5c-.1.3-.3.5-.6.5l-2.9.3c-.7.1-1 .9-.5 1.4z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m95.5 87.1-2.9-.6c-.3-.1-.5-.2-.6-.5l-1.2-2.7c-.3-.6-1.2-.7-1.5-.1l-1.4 2.5c-.1.2-.4.4-.7.4l-2.9.3c-.7.1-1 .9-.5 1.4l2 2.1c.2.2.3.5.2.7l-.6 2.8c-.2.7.5 1.2 1.2.9l2.6-1.2c.2-.1.5-.1.8 0l2.5 1.5c.6.4 1.3-.1 1.3-.8l-.3-2.9c0-.3.1-.5.3-.7l2.2-1.9c.4-.2.1-1-.5-1.2z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m87.6 25.9h.2c0-3.8 3.1-6.9 6.9-6.9v-.2c-2.2 0-4.7-1.2-6-3.4-.6-1-1-2.2-1-3.5h-.2c0 3.8-3.1 6.9-6.9 6.9v.2c1.2 0 2.3.3 3.3.9 1.7.6 3.7 3.3 3.7 6z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m96.3 45.3-21.8-13.1c-.2-.1-.5-.2-.7-.2-.1 0-.2 0-.3 0-.4.1-.7.3-.9.6l-21.5 36c-.4.7-.2 1.5.5 1.9l21.8 13.1c.3.2.7.3 1.1.2s.7-.3.9-.6l21.5-35.9c.3-.7.1-1.6-.6-2zm-15.6 17.4c-.7 1.7-1.9 2.9-3.8 3.3-1.4.3-2.5-.5-3.5-1.4-.5-.5-.8-1-1.2-1.6-.4.7-1.1 1.4-1 2.4.1.8.1 1.6.2 2.5-1.7-1-3.4-2-5.2-3.1.8-.4 1.6-.7 2.4-1.1.9-.4 1.2-1.2 1.7-2-.2 0-.3 0-.4 0-1.2 0-2.4-.3-3.4-1-1.3-.9-1.5-2.3-1.3-3.7.3-2.2 1.7-3.5 3.6-4.4 2.1-1.1 4.4-1.8 6.8-2.3 1.1-.3 2.3-.5 3.4-.8.8 2.7 1.6 5.3 1.9 8.1.2 1.7.4 3.4-.2 5.1z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m39.9 63 10.1 3.3 7.4-12.3c-.3.1-.6.2-.9.3s-.5.1-.7-.2c-1.9-2.6-3.5-5.4-4.5-8.5-.5-1.8-.8-3.5-.5-5.4.6-3.3 3.3-5 5.9-4.7 1.6.2 2.8 1.1 3.4 2.6.2.6.4 1.2.6 1.8.4-.3.8-.5 1.2-.8 1.4-1.2 3.1-1.2 4.6-.5l4.3-7.1c.5-.8 1.2-1.4 2.1-1.6s1.8-.1 2.6.4l2.7 1.6.6-1.8c.1-.4.1-.7-.1-1.1-.2-.3-.5-.6-.8-.7l-24.1-7.9c-.4-.1-.7-.1-1.1.1-.3.2-.6.5-.7.8l-13 39.9c-.2.8.2 1.6.9 1.8z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m46 70.7-12.6 3.3c-.3 0-.6 0-.9 0-1.5 0-3-1-3.4-2.6l-1.6-6c-3.7-1.6-7.4-3.3-11.1-4.9 1.1-4.3 2.1-8.6 3.2-13 1.2.6 2.5 1.1 3.7 1.7l-3.9-15.1-16.4 8.1c-.7.3-1 1.2-.7 1.9l18.4 37.6c.2.3.5.6.8.7.4.1.7.1 1.1-.1l22.8-11.2c.3 0 .4-.2.6-.4z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m31.1 70.9c.2.8 1 1.2 1.7 1l14-3.6h.1.1l1.3-.3-9-3c-1.8-.6-2.8-2.6-2.2-4.4l2.6-7.8c0-.1 0-.1-.1-.2-1.7 2.1-3.7 2.8-6.2 1.5-1.7-.9-2.6-2.7-2.3-4.6.4-2.4 1.9-3.6 4.3-4-1.2-1-1.8-2.2-1.8-3.7 0-1.1.3-2.1 1-3 1.3-1.8 3.7-2.3 5.7-1.4 2.2 1 3 3 2.5 5.9l5.8-17.7-.6-2.3c-.2-.8-1-1.2-1.7-1l-24.6 6.4c-.8.2-1.2 1-1 1.7z"
                    })
                ]
            })
        })
    });
};
var $6ece8f7499eb03b4$export$2e2bcd8739ae039 = $6ece8f7499eb03b4$var$CardsIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $346028208af2d3ae$var$CardsIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("svg", {
        "enable-background": "new 0 0 64 64",
        viewBox: "0 0 64 64",
        xmlns: "http://www.w3.org/2000/svg",
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Layer_1"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Badge"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Basketball_Trophy"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Certificate_00000155142465879896954940000007463677100507110064_"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Star_Badge"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Police_Badge"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Flag"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Medal_00000057864904577975597920000015771584254612611517_"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Tophy_Award"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Medal_00000142146757898845982370000005096811746825199502_"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Certificate"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Star_Trophy"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Award"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Third_Position"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
                id: "Second_Position",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m57.59 52.55-7.01-15.02c2.78-3.8 4.42-8.48 4.42-13.53 0-12.68-10.32-23-23-23s-23 10.32-23 23c0 5.05 1.64 9.73 4.42 13.53l-7.01 15.02c-.31.67-.23 1.45.22 2.04.44.59 1.17.89 1.9.78l9.37-1.43 4.93 8.1c.36.6 1.01.96 1.71.96h.11c.74-.04 1.39-.49 1.7-1.15l5.65-12.12 5.65 12.12c.31.66.96 1.11 1.7 1.15h.11c.7 0 1.35-.36 1.71-.96l4.93-8.1 9.37 1.43c.73.11 1.46-.19 1.9-.78.45-.59.53-1.37.22-2.04zm-44.59-28.55c0-10.48 8.52-19 19-19s19 8.52 19 19-8.52 19-19 19-19-8.52-19-19z"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                        d: "m32 9c-8.27 0-15 6.73-15 15s6.73 15 15 15 15-6.73 15-15-6.73-15-15-15zm4.25 23h-8.5c-.892 0-1.675-.591-1.922-1.448-.246-.857.105-1.774.861-2.248 2.96-1.855 7.061-5.425 7.061-7.305 0-1.103-.897-2-2-2s-2 .897-2 2c0 1.104-.896 2-2 2s-2-.896-2-2c0-3.309 2.691-6 6-6s6 2.691 6 6c0 2.506-1.978 5.022-4.1 7h2.6c1.104 0 2 .896 2 2s-.896 2.001-2 2.001z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Winner"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Diploma"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Trophy"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Medal_00000005238149921129290700000016698065652002176917_"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Medal_00000142871562636648070520000015215049010245528497_"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
                id: "Medal"
            })
        ]
    });
};
var $346028208af2d3ae$export$2e2bcd8739ae039 = $346028208af2d3ae$var$CardsIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $188209d9e3cafca9$var$PodiumIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        id: "Layer_1",
        "enable-background": "new 0 0 512 512",
        viewBox: "0 0 512 512",
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("g", {
            children: /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m96.677 422.31c-.794 4.054-4.734 6.718-8.788 5.925-4.053-.794-6.718-4.734-5.924-8.788 1.134-5.669 4.195-10.63 8.504-14.173 4.252-3.486 9.666-5.584 15.534-5.584 6.746 0 12.869 2.749 17.291 7.172 4.451 4.422 7.172 10.545 7.172 17.291 0 6.605-2.607 12.586-6.831 17.008 4.224 4.394 6.831 10.375 6.831 16.979 0 6.746-2.721 12.87-7.172 17.292-4.422 4.45-10.545 7.172-17.291 7.172-6.123 0-11.735-2.268-16.045-6.01-5.329-4.62-8.447-11.424-8.447-18.454 0-4.167 3.346-7.512 7.513-7.512 4.138 0 7.483 3.345 7.483 7.512 0 2.778 1.105 5.301 3.26 7.172 1.644 1.417 3.826 2.296 6.236 2.296 2.608 0 4.989-1.049 6.689-2.778 1.729-1.7 2.778-4.082 2.778-6.69 0-2.636-1.049-4.989-2.778-6.718-1.785-1.786-4.167-2.778-6.689-2.778-4.139 0-7.512-3.345-7.512-7.483 0-4.167 3.373-7.512 7.512-7.512 2.608 0 4.989-1.049 6.689-2.778 1.729-1.7 2.778-4.082 2.778-6.718 0-2.608-1.049-4.989-2.778-6.689-1.7-1.729-4.081-2.778-6.689-2.778-2.325 0-4.423.794-6.038 2.126-1.673 1.36-2.835 3.288-3.288 5.498zm169.74-353.824 9.213 14.995 17.093 4.11c3.26.794 5.896 2.835 7.513 5.471 1.615 2.665 2.211 5.925 1.445 9.185-.255.992-.567 1.871-.964 2.664-.425.822-.964 1.616-1.616 2.381l-11.395 13.38 1.36 17.633.028.255c.17 3.231-.964 6.265-2.977 8.589-2.013 2.354-4.932 3.94-8.277 4.195-1.105.085-2.183 0-3.203-.198-1.021-.198-2.013-.511-2.92-.964l-15.704-6.491-16.327 6.746c-3.118 1.276-6.434 1.191-9.269 0-2.892-1.219-5.301-3.515-6.577-6.604-.368-.879-.623-1.785-.765-2.693-.171-.963-.199-1.927-.142-2.834l1.36-17.633-11.395-13.38c-2.183-2.551-3.118-5.726-2.892-8.815.256-3.118 1.673-6.122 4.224-8.306.851-.708 1.701-1.275 2.58-1.729.198-.085.396-.17.595-.256.794-.312 1.559-.566 2.354-.736l.283-.028 16.356-3.969 9.24-15.023v-.028c1.758-2.863 4.508-4.734 7.541-5.471 3.032-.709 6.35-.283 9.212 1.474.228.142.454.312.652.481.595.398 1.134.879 1.615 1.39.682.679 1.277 1.415 1.759 2.209zm-1.956 25.455-8.476-13.776-8.447 13.748v-.028c-.992 1.643-2.607 2.892-4.62 3.373l-15.676 3.799 10.205 11.962c1.389 1.474 2.211 3.515 2.041 5.726l-1.248 16.131 14.911-6.18c1.757-.71 3.798-.767 5.697 0l14.939 6.18-1.275-16.131h.028c-.142-1.899.425-3.854 1.758-5.414l10.46-12.273-15.109-3.657c-2.07-.341-3.998-1.532-5.188-3.46zm44.477 41.67c1.672-3.77 6.094-5.471 9.865-3.77 3.77 1.672 5.471 6.094 3.77 9.864-4.733 10.602-9.894 20.126-15.081 28.347 4.082-.822 8.334-2.154 12.615-3.997 9.241-3.997 18.482-10.262 26.476-18.624 4.535-4.733 8.391-9.723 11.509-14.797 3.203-5.188 5.67-10.489 7.398-15.733 2.494-7.596 3.316-14.881 2.381-21.26-.85-5.612-3.061-10.459-6.803-14.003-3.176-3.032-6.86-4.79-10.829-5.641-2.636-.567-5.414-.737-8.249-.651-1.644 11.31-4.138 22.535-7.341 33.505-1.163 3.969-5.301 6.265-9.27 5.103-3.969-1.134-6.236-5.301-5.103-9.27 2.92-9.893 5.272-20.438 6.888-31.436 1.135-7.683 1.871-15.563 2.184-23.613h-146.667c.964 26.844 7.059 52.129 15.364 73.786 7.229 18.879 22.252 49.267 39.346 63.412 17.915 14.797 6.009 32.287-7.059 51.449-5.896 8.675-12.133 17.802-14.712 26.221h80.76c-2.58-8.419-8.787-17.546-14.712-26.221-13.04-19.162-24.974-36.652-7.059-51.449 5.159-4.252 11.197-11.254 17.405-20.438 5.811-8.617 11.651-19.047 16.924-30.784zm-12.728 50.287c-4.195 5.158-8.277 9.354-12.048 12.473-7.398 6.122.851 18.228 9.865 31.465 7.483 10.97 15.363 22.536 17.801 34.668h19.191c4.139 0 7.483 3.373 7.483 7.512v39.998h142.499c4.167 0 7.513 3.345 7.513 7.483v29.31c0 4.139-3.346 7.484-7.513 7.484-4.139 0-7.483-3.346-7.483-7.484v-21.798h-135.015v169.995h135.016v-114.237c0-4.139 3.345-7.483 7.483-7.483 4.167 0 7.513 3.345 7.513 7.483v121.75c0 4.138-3.346 7.483-7.513 7.483-149.983 0-299.994 0-450.005 0-4.139 0-7.512-3.346-7.512-7.483v-62.335c0-4.139 3.373-7.483 7.512-7.483s7.483 3.345 7.483 7.483v54.822h135.016v-111.714h-135.015v22.933c0 4.139-3.345 7.483-7.483 7.483-4.139 0-7.512-3.345-7.512-7.483v-30.445c0-4.139 3.373-7.483 7.512-7.483h142.499v-29.452c0-4.139 3.346-7.512 7.512-7.512 4.139 0 7.484 3.373 7.484 7.512v156.162h135.016v-217.478h-18.399-98.222-18.396v27.327c0 4.167-3.346 7.512-7.484 7.512-4.166 0-7.512-3.345-7.512-7.512v-34.839c0-4.139 3.346-7.512 7.512-7.512h19.163c2.466-12.132 10.347-23.698 17.802-34.668 9.042-13.237 17.264-25.343 9.893-31.465-3.741-3.09-7.823-7.285-12.019-12.473-9.326.425-19.645-1.673-29.878-6.066-10.97-4.734-21.912-12.189-31.408-22.082-13.408-14.06-21.884-30.474-24.689-45.667-3.033-16.242.311-31.295 10.743-41.301 5.357-5.103 11.509-8.022 18.057-9.411 3.146-.681 6.378-.992 9.609-1.021-.312-3.912-.538-7.852-.651-11.849-3.855-1.219-7.342-3.345-10.12-6.151-4.507-4.479-7.285-10.688-7.285-17.519 0-6.832 2.778-13.04 7.285-17.547 4.477-4.476 10.685-7.283 17.517-7.283h161.945c6.831 0 13.039 2.807 17.518 7.285 4.508 4.507 7.286 10.715 7.286 17.547 0 6.831-2.778 13.039-7.286 17.519-2.777 2.807-6.236 4.933-10.119 6.151-.113 3.997-.341 7.937-.652 11.849 3.231.028 6.463.34 9.609 1.021 6.548 1.39 12.7 4.309 18.058 9.411 6.265 6.01 9.978 13.833 11.31 22.705 1.276 8.646.228 18.284-2.976 28.035-2.041 6.293-5.046 12.7-8.901 18.965-3.713 5.981-8.164 11.792-13.38 17.263-9.468 9.893-20.438 17.348-31.408 22.054-10.206 4.421-20.524 6.518-29.821 6.093zm-91.674-15.817c-7.313-11.566-14.485-25.568-20.495-41.329-6.18-16.159-11.225-34.216-14.06-53.405-2.807-.086-5.584.084-8.221.651-3.968.851-7.653 2.608-10.828 5.641-6.52 6.236-8.476 16.385-6.379 27.751 2.325 12.473 9.469 26.108 20.864 38.042 7.993 8.362 17.234 14.627 26.476 18.624 4.309 1.842 8.561 3.203 12.643 4.025zm-29.509-135.441h161.945c2.692 0 5.131-1.105 6.916-2.892 1.786-1.785 2.892-4.224 2.892-6.916 0-2.693-1.105-5.159-2.892-6.945-1.785-1.785-4.224-2.891-6.916-2.891h-161.945c-2.693 0-5.131 1.106-6.917 2.891-1.785 1.786-2.891 4.252-2.891 6.945 0 2.692 1.105 5.131 2.891 6.916 1.786 1.786 4.224 2.892 6.917 2.892zm250.7 372.647c4.109-.028 7.512 3.26 7.54 7.398.057 4.11-3.26 7.512-7.37 7.54-.085 0-33.534.453-36.284-.482-5.442-1.814-7.143-5.754-4.564-10.97.708-1.53 1.983-3.203 4.28-6.208 3.486-4.563 9.836-12.897 20.154-27.639 1.673-2.409 2.977-4.592 3.969-6.576 2.183-4.478 3.288-8.787-.737-12.813-1.7-1.729-4.082-2.778-6.689-2.778-2.324 0-4.423.794-6.038 2.126-1.673 1.36-2.863 3.288-3.288 5.499-.794 4.054-4.734 6.719-8.788 5.925s-6.718-4.733-5.924-8.787c1.134-5.669 4.195-10.658 8.504-14.173 4.252-3.487 9.666-5.585 15.534-5.585 6.746 0 12.869 2.722 17.291 7.172 5.499 5.499 8.391 13.861 6.634 21.543-.596 2.58-1.588 5.386-3.09 8.447-1.305 2.665-3.005 5.529-5.131 8.562-7.115 10.148-12.218 17.149-15.874 22.025 8.928-.084 19.813-.226 19.871-.226zm-176.828-100.008c-4.139 0-7.484-3.373-7.484-7.512 0-4.14 3.346-7.513 7.484-7.513h14.201c4.139 0 7.483 3.373 7.483 7.513v66.359c0 9.864-14.995 9.864-14.995 0v-58.848h-6.689z"
            })
        })
    });
};
var $188209d9e3cafca9$export$2e2bcd8739ae039 = $188209d9e3cafca9$var$PodiumIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $24f8b7b112e438c9$var$BetterSecondSessionIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        viewBox: "0 0 48 48",
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
            id: "Icons",
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)("rect", {
                    height: "14",
                    rx: "1",
                    width: "12",
                    x: "4",
                    y: "28"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("rect", {
                    height: "20",
                    rx: "1",
                    width: "12",
                    x: "18",
                    y: "22"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("rect", {
                    height: "26",
                    rx: "1",
                    width: "12",
                    x: "32",
                    y: "16"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m45.788 2.385a1 1 0 0 0 -.788-.385h-8a1 1 0 0 0 0 2h5.371a75.166 75.166 0 0 1 -18.781 12.088 75.363 75.363 0 0 1 -20.725 5.921 1 1 0 0 0 .135 1.991 1.059 1.059 0 0 0 .136-.009 77.375 77.375 0 0 0 21.274-6.079 77.184 77.184 0 0 0 18.832-12l-1.212 4.85a1 1 0 0 0 .727 1.212 1.025 1.025 0 0 0 .243.026 1 1 0 0 0 .969-.758l2-8a1 1 0 0 0 -.181-.857z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m45 46h-42a1 1 0 0 1 0-2h42a1 1 0 0 1 0 2z"
                })
            ]
        })
    });
};
var $24f8b7b112e438c9$export$2e2bcd8739ae039 = $24f8b7b112e438c9$var$BetterSecondSessionIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $9d3689ac2dc83151$var$BetterTournamentIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        id: "fi_7089269",
        viewBox: "0 0 512 512",
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        "data-name": "Layer 1",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
            d: "m498.953 290.044a15.863 15.863 0 0 0 .465-22.146l-1.115-1.214a15.9 15.9 0 0 0 -21.374-1.929l-101.4 76.153a31.5 31.5 0 0 1 3.693 23.218l-.171.643a31.683 31.683 0 0 1 -37.34 23.931l-100.628-21.288a8.4 8.4 0 0 1 -6.4-9.93 8.23 8.23 0 0 1 9.851-6.358l100.628 21.289a15.028 15.028 0 0 0 17.681-11.288l.179-.714a14.887 14.887 0 0 0 -1.95-11.287 14.263 14.263 0 0 0 -9.33-6.573l-141.263-32.151c-18.867-4.286-36.463-.929-52.3 10.216l-68.788 48.225 53.743 80.868 36.076-27.432a8.007 8.007 0 0 1 6.173-1.644l145.717 20.289a27.717 27.717 0 0 0 24.2-8.073l143.662-142.8zm-346.282-52.507a8.311 8.311 0 0 1 -8.3-8.358v-55.865h-22.8a8.3 8.3 0 0 1 -6.715-13.216l50.314-68.866a8.276 8.276 0 0 1 13.416 0l50.324 68.868a8.3 8.3 0 0 1 -6.723 13.216h-22.787v55.865a8.323 8.323 0 0 1 -8.309 8.358zm255.934 0a8.319 8.319 0 0 1 -8.315-8.358v-55.865h-22.79a8.294 8.294 0 0 1 -6.708-13.216l50.3-68.866a8.289 8.289 0 0 1 13.43 0l50.308 68.868a8.294 8.294 0 0 1 -6.708 13.216h-22.789v55.865a8.323 8.323 0 0 1 -8.315 8.358zm-139.218 0h60.913a8.317 8.317 0 0 0 8.308-8.358v-103.3h41.013a8.316 8.316 0 0 0 6.708-13.216l-79.78-109.229a8.269 8.269 0 0 0 -13.409 0l-79.782 109.229a8.32 8.32 0 0 0 6.7 13.216h41.028v103.3a8.306 8.306 0 0 0 8.3 8.358zm-187.64 274.463-73.447-110.655 57.438-38.145 73.445 110.658z",
            "fill-rule": "evenodd"
        })
    });
};
var $9d3689ac2dc83151$export$2e2bcd8739ae039 = $9d3689ac2dc83151$var$BetterTournamentIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $589fe4a12c48f182$var$MostFollowingWinsIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        viewBox: "0 0 180 80",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
            stroke: "black",
            "stroke-width": "2",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)("circle", {
                    cx: "40",
                    cy: "50",
                    r: "14"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("circle", {
                    cx: "40",
                    cy: "50",
                    r: "11"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "M36 35 C35 28, 45 28, 44 35"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "M40 35 L35 15 M40 35 L45 15"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("text", {
                    x: "40",
                    y: "54",
                    "text-anchor": "middle",
                    "font-size": "9",
                    fill: "black",
                    "font-family": "sans-serif",
                    children: "1"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("circle", {
                    cx: "90",
                    cy: "50",
                    r: "14"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("circle", {
                    cx: "90",
                    cy: "50",
                    r: "11"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "M86 35 C85 28, 95 28, 94 35"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "M90 35 L85 15 M90 35 L95 15"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("text", {
                    x: "90",
                    y: "54",
                    "text-anchor": "middle",
                    "font-size": "9",
                    fill: "black",
                    "font-family": "sans-serif",
                    children: "1"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("circle", {
                    cx: "140",
                    cy: "50",
                    r: "14"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("circle", {
                    cx: "140",
                    cy: "50",
                    r: "11"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "M136 35 C135 28, 145 28, 144 35"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "M140 35 L135 15 M140 35 L145 15"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("text", {
                    x: "140",
                    y: "54",
                    "text-anchor": "middle",
                    "font-size": "9",
                    fill: "black",
                    "font-family": "sans-serif",
                    children: "1"
                })
            ]
        })
    });
};
var $589fe4a12c48f182$export$2e2bcd8739ae039 = $589fe4a12c48f182$var$MostFollowingWinsIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $d42598bf4fdd3eac$var$ScaleIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        id: "fi_2780188",
        "enable-background": "new 0 0 512 512",
        viewBox: "0 0 512 512",
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m420.35 133.783c-2.023-3.543-4.511-6.009-8.34-7.37l-111.02-40.41c.42-12.06-3.95-24.25-13.14-33.43-18.905-18.916-50.485-17.402-67.35 4.13l-110.85-40.34c-.01-.01-.02-.01-.02-.01-7.765-2.774-15.589 1.337-18.51 7.35l-70.25 139.5h33.59l50.13-99.56 50.74 99.56h33.67l-53.83-105.63 75.8 27.59c.311 19.272 12.623 35.58 30.03 41.74v291.34c0 8.28 6.72 15 15 15s15-6.72 15-15v-291.34c7.307-2.574 13.876-7.006 19.02-12.97l95.94 34.92-63.15 125.45h33.59l50.55-100.42 50.59 100.42h33.59zm-153.71-38.72c-5.87 5.87-15.41 5.87-21.28 0s-5.87-15.41 0-21.28 15.41-5.87 21.28 0c5.879 5.879 5.889 15.391 0 21.28z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m273.662 404.243h-35.323c-42.617 0-77.289 34.671-77.289 77.288 0 8.284 6.716 15 15 15h159.9c8.284 0 15-6.716 15-15 0-42.617-34.671-77.288-77.288-77.288z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m497 304.299h-180.05c-8.284 0-15 6.716-15 15 0 57.911 47.114 105.025 105.025 105.025s105.025-47.114 105.025-105.025c0-8.284-6.716-15-15-15z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m195.1 193.205h-180.1c-8.284 0-15 6.716-15 15 0 57.925 47.125 105.05 105.05 105.05s105.05-47.125 105.05-105.05c0-8.284-6.716-15-15-15z"
                })
            ]
        })
    });
};
var $d42598bf4fdd3eac$export$2e2bcd8739ae039 = $d42598bf4fdd3eac$var$ScaleIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $08cdd09982b4fa40$var$RocketIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("svg", {
        viewBox: "0 0 512.00034 512",
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        id: "fi_1420462",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m74.742188 328.078125c-2.898438 5.78125-1.769532 12.769531 2.796874 17.339844l3.667969 3.667969c10.597657-12.558594 22.949219-26.1875 37.929688-41.164063 1.058593-1.058594 2.148437-1.570313 3.210937-2.546875l-23.597656-23.601562c-13.71875 24.8125-21.71875 41.765624-24.007812 46.304687zm0 0"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m203.988281 392.773438c-15.015625 15.015624-28.609375 27.390624-41.097656 37.996093l4.96875 4.96875c4.609375 4.609375 11.664063 5.71875 17.464844 2.734375 7.769531-4.003906 19.988281-9.753906 45.925781-24.199218l-24.710938-24.710938c-.976562 1.066406-1.488281 2.152344-2.550781 3.210938zm0 0"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m195.992188 315.9375c-10.839844-10.839844-41.324219-1.121094-55.644532 13.195312-47.90625 47.90625-69.542968 81.871094-79.257812 101.925782-2.785156 5.746094-1.625 12.625 2.890625 17.140625 4.523437 4.527343 11.414062 5.675781 17.164062 2.890625 19.605469-9.519532 53.15625-31.054688 101.632813-79.527344 15.746094-15.753906 23.515625-45.320312 13.226562-55.613281zm0 0"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m46.820312 199.710938-42.425781 42.425781c-4.796875 4.796875-5.78125 12.222656-2.382812 18.105469 3.316406 5.804687 10.261719 8.761718 16.871093 6.992187 22.929688-6.148437 43.105469-8.746094 56.691407-5.261719 19.328125-34.363281 40.097656-65.996094 62.09375-94.730468-12.722657-8.15625-54.765625-3.613282-90.847657 32.46875zm0 0"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m253.894531 510.390625c5.777344 2.921875 12.773438 1.792969 17.347657-2.785156l42.429687-42.425781c32.847656-32.855469 38.628906-75.246094 31.175781-88.6875-32.046875 24.152343-64.511718 44.546874-94.800781 61.621093 2.089844 11.800781.699219 23.25-4.242187 56.6875-.964844 6.472657 2.378906 12.734375 8.089843 15.589844zm0 0"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m297.800781 150.46875c-17.542969 17.546875-17.542969 46.089844 0 63.636719 17.546875 17.546875 46.09375 17.546875 63.640625 0s17.546875-46.089844 0-63.636719-46.09375-17.546875-63.640625 0zm0 0"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m511.117188 14.632812c-.539063-7.417968-6.445313-13.28125-13.839844-13.835937-36.839844-2.773437-73.535156 1.757813-109.503906 12.757813 2.707031 24.710937 15.488281 51.453124 37.308593 73.273437 22.082031 22.078125 49.550781 34.855469 74.703125 37.246094 9.6875-33.949219 14.28125-70.308594 11.332032-109.441407zm0 0"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m403.871094 108.042969c-24.960938-24.960938-40.203125-54.898438-45.09375-84.046875-90.074219 36.941406-176.300782 117.613281-244.4375 230.941406l33.851562 33.851562c23.128906-9.390624 51.207032-11.871093 69.015625 5.933594 17.832031 17.835938 15.304688 45.902344 5.917969 69l34.964844 34.964844c87.195312-52.550781 188.710937-135.34375 231.878906-245.496094-29.859375-4.511718-60.730469-19.78125-86.097656-45.148437zm-21.21875 127.277343c-29.238282 29.238282-76.820313 29.238282-106.0625 0-29.242188-29.242187-29.242188-76.828124 0-106.066406 29.242187-29.238281 76.824218-29.238281 106.0625 0 29.242187 29.242188 29.242187 76.824219 0 106.066406zm0 0"
            })
        ]
    });
};
var $08cdd09982b4fa40$export$2e2bcd8739ae039 = $08cdd09982b4fa40$var$RocketIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $dd6452324580a904$var$PerfectIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("svg", {
        id: "fi_2165867",
        "enable-background": "new 0 0 496 496",
        viewBox: "0 0 496 496",
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m412.754 108.37c0 4.904 3.443-9.414-46.04 175.22-2.742-10.635-1.92 12.37-1.92-189.57 14.204-21.63 47.96-11.422 47.96 14.35z"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m348.794 30.4v217.62c-58.22-100.822-32.549-56.388-60.8-105.32v-112.3c0-16.76 13.64-30.4 30.4-30.4 17.021 0 30.4 13.796 30.4 30.4z"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m313.644 219.13-23.6-23.59c-20.547-20.556-47.57-32.34-79.78-32.34l-53.92-89.92c-8.319-14.455-3.452-33.047 11.15-41.48 14.687-8.469 33.219-3.253 41.53 11.13 82.258 136.705 40.162 64.55 104.62 176.2z"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: "m357.194 334.59c0 49.94-19.858 98.078-55.33 133.58-17.31 17.29-40.3 27.17-64.74 27.8-3.894 0 14.988.03-42.46.03-61.46 0-111.47-50-111.47-111.47v-153.6c0-5 4.07-9.06 9.07-9.06.784 0 1.428-.045 2.39-.31 2.491.989 24.983.646 40.2 22.67 9.828 13.131 9.14 28.427 9.14 37.9 0 34.23 14.78 66.78 40.53 89.33 27.886 24.409 71.51 4.393 71.51-32.45-.01-40.907 1.562-50.335-5.56-66.5-6.373-14.399-14.392-20.616-25.14-30.42-3.658-2.93.855-2.09-74.28-2.09-9.903-17.607-28.483-30.951-50.62-33.63.9-8.609 5.523-16.828 13.43-22.11 13.152-6.416-1.531-5.06 98.12-5.06 25.21 0 48.92 9.82 66.75 27.65l65.83 65.83 4.98 8.63c4.666 17.141 7.65 32.916 7.65 53.28z"
            })
        ]
    });
};
var $dd6452324580a904$export$2e2bcd8739ae039 = $dd6452324580a904$var$PerfectIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $0b44e5ed9ed13343$var$BestRoundResultIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        id: "fi_4375968",
        "enable-background": "new 0 0 52 52",
        viewBox: "0 0 52 52",
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
            id: "_x31_34",
            fill: "rgb(0,0,0)",
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m2.2212839 28.9155388c.5881348.8479004 1.4052734 1.0786133 1.8806152 1.4985352.4853516.4130859.8330078.9609375.9645996 1.564209.2883301 1.21875-.0056152 2.5205078.0112305 3.7346191-.0407715 1.2185059.357666 2.4445801 1.0930176 3.185791.7109375.7595215 1.4987793 1.1745605 2.1328125 1.5627441.6447754.3776855 1.1708984.7089844 1.5734863 1.0102539.7976074.6108398 1.1108398 1.0554199 1.1638184 1.0153809.0200195-.0141602-.0437012-.1335449-.190918-.3564453-.1469727-.222168-.4057617-.5273438-.7895508-.8806152-.3867188-.3486328-.9074707-.730957-1.5292969-1.1467285-.6115723-.4230957-1.3525391-.8762207-1.9431152-1.5715332-.6071777-.6870117-.8947754-1.6669922-.8300781-2.8081055.0090332-1.1376953.378418-2.416748.0861816-3.9243164-.1455078-.7526855-.5661621-1.4870605-1.1948242-2.0405273-.6367188-.5297852-1.3681641-.8256836-1.65625-1.3212891-.1350098-.2497559-.1936035-.5244141-.1347656-.8208008.0610352-.3000488.2255859-.6230469.4318848-.9445801.4106445-.6560059 1.003418-1.2734375 1.4538574-2.1450195.8723145-1.7880859.5961914-3.7941895.4658203-5.6325684-.0666504-.9143066-.0639648-1.8449707.1203613-2.7290039.1813965-.8796387.574707-1.697998 1.2529297-2.1928711.675293-.512207 1.7028809-.6948242 2.7600098-1.2822266.5266113-.2912598 1.0505371-.7915039 1.3330078-1.3918457.279541-.5900879.3835449-1.1831055.484375-1.7119141.1750488-1.0952148.4597168-1.8723145 1.2878418-2.3093262.8066406-.4482422 1.8718262-.5581055 2.956543-.5 1.1115732.0383301 2.3447275.2021484 3.6638193-.1269531 1.3666992-.3391113 2.375-1.3215332 3.2199707-2.1152344.8679199-.8173828 1.7026367-1.5285645 2.6853027-1.543457 1.010498-.0996094 2.0344238.395752 3.0625 1.0219727 1.0327148.6252441 2.1069336 1.4150391 3.4780273 1.8557129.6870098.2143555 1.4436016.277832 2.1799297.2097168 1.3450966-.162261 2.3789673-.7207255 3.3959961-.2197266.4467773.2131348.8547363.5944824 1.1674805 1.0476074.3164063.4621582.5319824.9841309.732666 1.6030273.1970215.5939941.4570313 1.4189453 1.104248 2.0153809.6252441.5893555 1.371582.8586426 2.0158691 1.0683594.6601563.2116699 1.2878418.3666992 1.8671875.5683594 1.1743164.3830566 2.0332031 1.0148926 2.1760254 2.0263672.0913086.5019531.0415039 1.0756836-.0727539 1.6552734-.1079102.5881348-.2990723 1.1523438-.4619141 1.8271484-.3061523 1.302002-.4174805 2.7282715-.0134277 4.0964355.2001953.6669922.5310059 1.3369141.965332 1.8769531.4191895.5415039.875.9772949 1.2446289 1.4118652.7683105.8505859 1.0910645 1.7421875.8139648 2.7233887-.2561035.9853516-.9553223 1.9541016-1.5043945 3.0722656-.5976563 1.1477051-.767334 2.4819336-.8154297 3.6313477-.0595703 1.1748047-.0529785 2.2626953-.3200684 3.2436523-.2512207.9814453-.7453613 1.8652344-1.4980469 2.2780762-.7209473.4509277-1.9169922.3916016-3.0302734 1.0698242-1.0856934.6643066-1.6748047 1.6838379-2.1975098 2.564209-.5129395.8955078-.9733887 1.7573242-1.5786133 2.3725586-.604248.6132813-1.348877.8916016-2.2097168.8618164-.8591309-.019043-1.7578125-.2434082-2.7028809-.357666-.9284649-.1203613-2.0183086-.0810547-2.8935528.4033203-.8613281.4528809-1.4958496 1.0668945-2.1213379 1.5656738-.6201172.5-1.2404785.9089355-1.8903809.9951172-1.8926735.2704811-3.4122791-1.8455811-5.4111328-2.6862793-.630127-.2751465-1.3483887-.3781738-1.9626465-.324707-.6176758.0405273-1.1662598.138916-1.6711426.1403809-.4997559-.0068359-.9726572-.0898438-1.4018564-.2468262-.8569336-.3261719-1.5273438-.8537598-2.0620117-1.3491211-.5368652-.498291-.947998-.9746094-1.2783203-1.3603516-.6564941-.7770996-.9963379-1.1975098-1.0395508-1.1657715-.0361328.0263672.2224121.4990234.8125 1.3422852.2978516.4194336.6799316.9338379 1.2075195 1.486084.5263672.5473633 1.2062988 1.1523438 2.15625 1.5637207.4755859.1987305 1.0197763.3203125 1.5969248.3486328.574707.0185547 1.1474609-.0637207 1.7097168-.0795898 1.1181641-.0856934 2.166748.5075684 3.2407227 1.3532715.543457.411377 1.1032715.8737793 1.776123 1.2775879.6677246.3898926 1.529541.71875 2.4460449.6005859.9243164-.1081543 1.7004395-.6306152 2.3657227-1.1418457.6694336-.5187988 1.2893066-1.0756836 1.9799805-1.4169922.6730957-.3530273 1.4492188-.373291 2.3073711-.2573242.8564453.1130371 1.7683105.3659668 2.8083496.4106445.5183105.0187988 1.0812988-.0378418 1.6191406-.2358398.5317383-.2028809 1.0292969-.5195313 1.4226074-.9138184.7897949-.7907715 1.28125-1.7270508 1.7954102-2.5876465.5097656-.8532715 1.0529785-1.6838379 1.8032227-2.1149902.6958008-.479248 1.8215332-.3964844 3.015625-1.0214844 1.189209-.6552734 1.8203125-1.8894043 2.1286621-3.041748.6242104-2.2538376.0325356-4.5953255 1.0959473-6.6159668.4758301-.9892578 1.2370605-1.967041 1.6193848-3.3181152.1853027-.6723633.2060547-1.4536133-.0195313-2.1601563-.4029236-1.3660355-1.5782585-2.2763557-2.2568359-3.1699219-.3405762-.4279785-.5625-.895752-.7246094-1.4221191-.3061523-1.043457-.2321777-2.21875.0449219-3.3762207.2819824-1.1459961.8103027-2.5100098.5598145-4.0544434-.1164551-.7727051-.5534668-1.5559082-1.1567383-2.0710449-1.6407013-1.4297266-4.2437859-1.3618221-5.3144531-2.3771973-.6828613-.5563965-.7453613-2.1572266-1.6501465-3.3967285-.4304199-.6179199-.9963379-1.1689453-1.7241211-1.5202637-.7260742-.3713379-1.625-.402832-2.3164063-.2744141-.7062988.1164551-1.3146973.3093262-1.8618164.3713379-.5385742.043457-1.0708008.0090332-1.6018047-.1530762-1.065918-.3322754-2.0710449-1.034668-3.1650391-1.7021484-1.0756836-.6472168-2.404541-1.3395996-3.8828125-1.2053223-.7236328.0244141-1.4699707.3193359-2.0356445.6940918-.574707.3798828-1.0439453.8190918-1.4858398 1.2336426-.8776855.8415527-1.6711426 1.5771484-2.6286621 1.8132324-.9768066.2612305-2.1035156.1518555-3.2731943.1096191-1.1889648-.0449219-2.4807129.0454102-3.6452637.6972656-.5766602.3227539-1.0927734.8398438-1.390625 1.4526367-.2966306.608887-.3957517 1.2133792-.4929197 1.7458499-.0930176.5380859-.1875 1.0187988-.3657227 1.4023438-.1787109.3730469-.4477539.6472168-.8366699.8769531-.7702637.4707031-1.8674316.6657715-2.8493652 1.3862305-.9829102.7399902-1.4692383 1.8798828-1.6650391 2.9128418-.2023926 1.0510254-.1816406 2.0744629-.0974121 3.0454102.1794434 1.8859863.3996582 3.6899414-.2749023 5.1013184-.5085294 1.0607872-1.66521 2.1082916-1.8977051 3.3640137-.0925293.4982908.0202637 1.043701.2817383 1.467285z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m13.6514597 39.8032341c1.4328613 1.2900391 3.0649424 2.2958984 4.7663584 3.0422363 6.4231339 2.7947426 14.0613422 1.9167252 19.3605938-1.9953613 2.4643555-1.7832031 4.1828613-4.1567383 5.197998-6.5117188.9821777-2.3830566 1.3117676-4.7216797 1.2753906-6.7353516-.0229492-2.0114746-.2956543-3.7321777-.6486816-5.0976563-.3527832-1.3676758-.7683105-2.3850098-1.0915527-3.0500488-.3242188-.6655273-.5493164-.9853516-.5876465-.9663086-.065918.0280762.1235352.4692383.3933105 1.2912598-.2363281-.1564941-.5969238-.2219238-.9890137-.1315918-.1289063.029541-.2436523.0778809-.3522949.1306152-.0588379-.215332-.1186523-.4291992-.1813965-.6345215-.6518555-2.0561523-1.5263672-3.5888672-2.2541504-4.5422363-.171875-.2246094-.3293457-.4140625-.4748535-.5800781.4462891.3769531.8588867.7529297 1.2006836 1.1142578 1.8977051 1.9807129 2.5231934 3.4287109 2.6577148 3.3522949.0441895-.0214844-.1003418-.3786621-.4216309-1.0480957-.1450195-.3449707-.3881836-.7331543-.6931152-1.1835938-.1523438-.2248535-.3046875-.4772949-.4924316-.7280273-.2009277-.2407227-.4150391-.4970703-.6416016-.7685547-1.7995605-2.1513672-5.2687988-4.7695313-10.2895489-5.8461914-2.489502-.5388184-5.3730469-.6091309-8.3166504.1748047-2.9562988.7436523-5.824708 2.6101074-8.0102549 5.2216797-2.1845703 2.6125488-3.7927246 5.9338379-4.416748 9.5881348-.0983887.9204102-.3022461 1.8405762-.2731934 2.7883301-.0085449.4719238-.0170898.9458008-.0256348 1.4216309.0458984.4746094.0917969.9509277.1379395 1.4291992.0400391.963623.3520508 1.8972168.5395508 2.8540039.1364746.46875.3276367.9245605.4909668 1.3891602.1655273.4650879.3310547.9316406.5895996 1.3601074l.7038574 1.310791c.2580566.4204102.578125.8010254.864502 1.2004395.5393067.8312988 1.3041993 1.4580078 1.9819337 2.1503906zm4.7099619 1.4619141c.5559082.1757813 1.25.277832 2.0488281.4453125.4162598.0983887.8728027.0957031 1.3525391.1491699.480957.0253906.9909668.1159668 1.5273438.081543.6308594.0158691 1.3032227-.0097656 2.0012207-.0715332.0214844.2370605.0871582.4985352.2265625.7619629.1027832.1938477.2277832.3508301.3588867.4865723-2.3063965-.0805664-4.6672363-.5683594-6.8955078-1.552002-.2097169-.0917969-.4133301-.2001954-.6198731-.3010254zm8.6157226 1.8596191c.0861816-.2990723.0297852-.730957-.197998-1.1611328-.0507813-.0959473-.1140137-.171875-.1730957-.2546387 1.0039063-.1572266 2.052002-.3955078 3.1254883-.7346191-.1074219.3303223-.0654297.8483887.2644043 1.3547363.1115723.1704102.2387695.3051758.369873.4189453-1.2276859.2496414-2.1109142.3485375-3.3886719.376709zm4.2141114-1.5754394c-.2348633-.3474121-.4887695-.659668-.751709-.8161621.0908203-.0322266.1806641-.0593262.2719727-.0927734.8513184-.3222656 1.7197247-.7224121 2.5766582-1.1928711-.2077637.3032227.0615234 1.0559082.7714844 1.6816406.1254883.1113281.2539063.2038574.3818359.2878418-.8933105.4155273-1.8413086.760498-2.8290997 1.032959-.0651855-.2780763-.2253417-.5898438-.4211425-.9006348zm4.4770488-.767334c-.1669922-.2348633-.3952637-.4836426-.6638184-.722168-.5244141-.4606934-1.0698242-.7739258-1.4299316-.7683105 1.0454102-.5976563 2.0671387-1.3112793 3.0078125-2.1672363.2693596.7273216 1.3298454 1.5350418 1.9968262 1.5634766-.4638672.4250487-1.8097801 1.4700393-2.9108887 2.0942382zm3.3735352-2.5432129c-.0227051-.348877-.2912598-.8337402-.782959-1.236084-.3466797-.2849121-.7163086-.4584961-1.0256348-.5197754.3659668-.3754883.7219238-.7658691 1.0527344-1.1896973.1608887-.2004395.3039551-.4091797.4523926-.6154785.4867783.4611816 1.4477921.9923401 2.2253418 1.1970215-.5415039.8251953-1.1813965 1.6223145-1.921875 2.3640137zm3.010498-4.3061524c-.152832.3293457-.324707.6577148-.5063477.984375-.5451279-.5698586-1.4193077-1.0240936-2.2055664-1.1425781.3190918-.5185547.6137695-1.0461426.8640137-1.5859375.1655273.1149902.3562012.222168.5686035.3127441.869873.3720703 1.697998.2993164 1.8156738-.0749512.1191406-.3774414-.4567871-.8952637-1.2556152-1.2375488-.2167969-.092041-.4287109-.1589355-.6303711-.2070313.2463379-.6721191.4414063-1.3496094.5908203-2.0231934.6468964.3111725 1.5410423.3388443 2.0639648.1052246-.1694335 1.5461427-.56958 3.2050783-1.3051757 4.8688966zm.0568848-9.2675781c.4855957.0698242.9589844.0461426 1.2211914-.1728516.0986328.9399414.1540527 1.9707031.1235352 3.1047363-.0036621.1796875-.0266113.3720703-.0366211.5561523-.4552841-.3173199-1.2512665-.4718952-1.9104004-.3527832.0561523-.3920898.0991211-.78125.1240234-1.1643066.0632324-.7080078.0817871-1.3972168.065918-2.0651855.1313477.0388184.2707519.0698242.4123535.0942383zm-.4611816-3.6254883c.4240723-.0976563.7453613-.340332.8708496-.6091309.3215218 1.0824871.5643883 2.162817.7197266 3.2587891-.3751755-.3683796-1.0209236-.5546818-1.6208496-.4025879-.0717773-.7744141-.1865234-1.5126953-.3317871-2.2116699.1171874-.0007324.2373046-.0065918.3620605-.0354004zm-30.8049307 12.2299805c-.1484375-.4250488-.3261719-.8391113-.4521484-1.2685547-.1672363-.8818359-.465332-1.7331543-.4997559-2.6271973l-.1335449-1.3208007c.0070801-.4418945.013916-.8820801.0209961-1.3205566-.0349121-.8798828.1582031-1.7392578.2416992-2.5981445.5625-3.4150391 2.0471191-6.5336914 4.046875-8.9794922 2.0058603-2.4465332 4.6049814-4.1923828 7.3210459-4.9260254 2.7102051-.7736816 5.4279785-.776123 7.8046875-.3237305 3.3967266.6364746 6.0874004 2.0119629 8.0375957 3.4577637.0461426.3549805 1.6633301 2.314209 2.5930176 6.0566406.4750977 1.9731445.810791 4.4418945.4973145 7.1020508-.2438965 2.6467285-1.2355957 5.4887695-3.1474609 7.8779297-1.8835449 2.4204102-4.4736328 4.0068359-6.9384747 5.0153809-2.4914551.989502-4.9191895 1.4445801-6.9658203 1.517334-3.2502441.1611328-5.4921875-.3554688-6.3266602-.4448242-2.3144541-1.4274902-4.3173838-3.4472656-5.5622568-5.9785156-.237793-.3867189-.3867188-.8142092-.5371094-1.239258z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m17.7403278 28.6767693c.7714844.2653809 2.3308105.4790039 4.1633301.4238281 1.7180176-.0478516 3.1848145-.3173828 3.9851074-.6057129.1738281.4592285.3417969.9033203.4992676 1.3193359 1.0942383 2.9301758 1.7875977 4.746582 1.982666 4.6899414.1833496-.0529785-.168457-1.9736328-1.0236816-5.0041504-.4287109-1.5144043-.9846191-3.3054199-1.6669922-5.2722168-.7341251-2.1136932-1.200695-3.2882576-1.7419434-4.6806641-.1101074-.2937012-.28125-.6345215-.4904785-.9267578-.2219238-.2946777-.4804688-.6074219-.9616699-.8261719-.5141602-.2434082-1.2353516-.0864258-1.6015625.3181152-.3630371.3842773-.4626465.7468262-.5749512 1.0009766-1.3004036 3.2436829-2.6130638 6.5669708-3.7739258 9.779541-1.0664072 2.9516602-1.6347666 4.8144531-1.4523935 4.888916.3091164.1262132 2.5247469-4.8117331 2.6572275-5.1049803zm3.8833008-9.0263672c.1091309-.279541.2138672-.4868164.2683105-.5300293.0441895-.0258789.0036621-.0136719.0410156-.010498.0703125.026123.2321777.1645508.357666.3425293.1325684.1896973.2331543.3737793.3303223.6245117.8373222 2.0772762.3541698.8600178 1.8244629 4.6032715.4108887 1.0861816.7956543 2.1030273 1.1550293 3.0524902-.8547363-.0957031-2.2094727-.1005859-3.7380371-.0585938-1.567627.0476074-2.9562988.1330566-3.7983398.2849121 1.2451725-2.7835045 2.3941135-5.5056476 3.5595703-8.3085937z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m29.4400349 20.3679314c0 .0031738 0 .0061035.0002441.0092773.0932617 1.8188477.3515625 3.3093262.7485352 3.3256836.3903809.017334.7731934-1.505127.6767578-3.3969727-.0021973-.0473633-.0080566-.0908203-.0109863-.1374512 1.0480957-.2736816 1.7189922-.7539063 1.6254864-1.0373535-.0910645-.2888184-.8134747-.3293457-1.7834454-.2770996-.2109375-1.1367188-.5639648-1.901123-.8430176-1.8605957-.2836914.0402832-.4172363.8410645-.4377441 1.9631348-1.3132324.1340332-2.3754883.3081055-2.4208984.6791992-.0480958.3525391 1.022705.7802735 2.4450683.7321778z"
                })
            ]
        })
    });
};
var $0b44e5ed9ed13343$export$2e2bcd8739ae039 = $0b44e5ed9ed13343$var$BestRoundResultIcon;




/*!
 * chartjs-plugin-datalabels v2.2.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2022 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */ 



var $28f7469a8cd9b709$var$devicePixelRatio = function() {
    if (typeof window !== 'undefined') {
        if (window.devicePixelRatio) return window.devicePixelRatio;
        // devicePixelRatio is undefined on IE10
        // https://stackoverflow.com/a/20204180/8837887
        // https://github.com/chartjs/chartjs-plugin-datalabels/issues/85
        var screen = window.screen;
        if (screen) return (screen.deviceXDPI || 1) / (screen.logicalXDPI || 1);
    }
    return 1;
}();
var $28f7469a8cd9b709$var$utils = {
    // @todo move this in Chart.helpers.toTextLines
    toTextLines: function(inputs) {
        var lines = [];
        var input;
        inputs = [].concat(inputs);
        while(inputs.length){
            input = inputs.pop();
            if (typeof input === 'string') lines.unshift.apply(lines, input.split('\n'));
            else if (Array.isArray(input)) inputs.push.apply(inputs, input);
            else if (!(0, $b4325cd24db60028$export$342063e11d6c3cad)(inputs)) lines.unshift('' + input);
        }
        return lines;
    },
    // @todo move this in Chart.helpers.canvas.textSize
    // @todo cache calls of measureText if font doesn't change?!
    textSize: function(ctx, lines, font) {
        var items = [].concat(lines);
        var ilen = items.length;
        var prev = ctx.font;
        var width = 0;
        var i;
        ctx.font = font.string;
        for(i = 0; i < ilen; ++i)width = Math.max(ctx.measureText(items[i]).width, width);
        ctx.font = prev;
        return {
            height: ilen * font.lineHeight,
            width: width
        };
    },
    /**
   * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
   * @todo move this method in Chart.helpers.bound
   * https://doc.qt.io/qt-5/qtglobal.html#qBound
   */ bound: function(min, value, max) {
        return Math.max(min, Math.min(value, max));
    },
    /**
   * Returns an array of pair [value, state] where state is:
   * * -1: value is only in a0 (removed)
   * *  1: value is only in a1 (added)
   */ arrayDiff: function(a0, a1) {
        var prev = a0.slice();
        var updates = [];
        var i, j, ilen, v;
        for(i = 0, ilen = a1.length; i < ilen; ++i){
            v = a1[i];
            j = prev.indexOf(v);
            if (j === -1) updates.push([
                v,
                1
            ]);
            else prev.splice(j, 1);
        }
        for(i = 0, ilen = prev.length; i < ilen; ++i)updates.push([
            prev[i],
            -1
        ]);
        return updates;
    },
    /**
   * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
   */ rasterize: function(v) {
        return Math.round(v * $28f7469a8cd9b709$var$devicePixelRatio) / $28f7469a8cd9b709$var$devicePixelRatio;
    }
};
function $28f7469a8cd9b709$var$orient(point, origin) {
    var x0 = origin.x;
    var y0 = origin.y;
    if (x0 === null) return {
        x: 0,
        y: -1
    };
    if (y0 === null) return {
        x: 1,
        y: 0
    };
    var dx = point.x - x0;
    var dy = point.y - y0;
    var ln = Math.sqrt(dx * dx + dy * dy);
    return {
        x: ln ? dx / ln : 0,
        y: ln ? dy / ln : -1
    };
}
function $28f7469a8cd9b709$var$aligned(x, y, vx, vy, align) {
    switch(align){
        case 'center':
            vx = vy = 0;
            break;
        case 'bottom':
            vx = 0;
            vy = 1;
            break;
        case 'right':
            vx = 1;
            vy = 0;
            break;
        case 'left':
            vx = -1;
            vy = 0;
            break;
        case 'top':
            vx = 0;
            vy = -1;
            break;
        case 'start':
            vx = -vx;
            vy = -vy;
            break;
        case 'end':
            break;
        default:
            // clockwise rotation (in degree)
            align *= Math.PI / 180;
            vx = Math.cos(align);
            vy = Math.sin(align);
            break;
    }
    return {
        x: x,
        y: y,
        vx: vx,
        vy: vy
    };
}
// Line clipping (Cohen–Sutherland algorithm)
// https://en.wikipedia.org/wiki/Cohen–Sutherland_algorithm
var $28f7469a8cd9b709$var$R_INSIDE = 0;
var $28f7469a8cd9b709$var$R_LEFT = 1;
var $28f7469a8cd9b709$var$R_RIGHT = 2;
var $28f7469a8cd9b709$var$R_BOTTOM = 4;
var $28f7469a8cd9b709$var$R_TOP = 8;
function $28f7469a8cd9b709$var$region(x, y, rect) {
    var res = $28f7469a8cd9b709$var$R_INSIDE;
    if (x < rect.left) res |= $28f7469a8cd9b709$var$R_LEFT;
    else if (x > rect.right) res |= $28f7469a8cd9b709$var$R_RIGHT;
    if (y < rect.top) res |= $28f7469a8cd9b709$var$R_TOP;
    else if (y > rect.bottom) res |= $28f7469a8cd9b709$var$R_BOTTOM;
    return res;
}
function $28f7469a8cd9b709$var$clipped(segment, area) {
    var x0 = segment.x0;
    var y0 = segment.y0;
    var x1 = segment.x1;
    var y1 = segment.y1;
    var r0 = $28f7469a8cd9b709$var$region(x0, y0, area);
    var r1 = $28f7469a8cd9b709$var$region(x1, y1, area);
    var r, x, y;
    // eslint-disable-next-line no-constant-condition
    while(true){
        if (!(r0 | r1) || r0 & r1) break;
        // at least one point is outside
        r = r0 || r1;
        if (r & $28f7469a8cd9b709$var$R_TOP) {
            x = x0 + (x1 - x0) * (area.top - y0) / (y1 - y0);
            y = area.top;
        } else if (r & $28f7469a8cd9b709$var$R_BOTTOM) {
            x = x0 + (x1 - x0) * (area.bottom - y0) / (y1 - y0);
            y = area.bottom;
        } else if (r & $28f7469a8cd9b709$var$R_RIGHT) {
            y = y0 + (y1 - y0) * (area.right - x0) / (x1 - x0);
            x = area.right;
        } else if (r & $28f7469a8cd9b709$var$R_LEFT) {
            y = y0 + (y1 - y0) * (area.left - x0) / (x1 - x0);
            x = area.left;
        }
        if (r === r0) {
            x0 = x;
            y0 = y;
            r0 = $28f7469a8cd9b709$var$region(x0, y0, area);
        } else {
            x1 = x;
            y1 = y;
            r1 = $28f7469a8cd9b709$var$region(x1, y1, area);
        }
    }
    return {
        x0: x0,
        x1: x1,
        y0: y0,
        y1: y1
    };
}
function $28f7469a8cd9b709$var$compute$1(range, config) {
    var anchor = config.anchor;
    var segment = range;
    var x, y;
    if (config.clamp) segment = $28f7469a8cd9b709$var$clipped(segment, config.area);
    if (anchor === 'start') {
        x = segment.x0;
        y = segment.y0;
    } else if (anchor === 'end') {
        x = segment.x1;
        y = segment.y1;
    } else {
        x = (segment.x0 + segment.x1) / 2;
        y = (segment.y0 + segment.y1) / 2;
    }
    return $28f7469a8cd9b709$var$aligned(x, y, range.vx, range.vy, config.align);
}
var $28f7469a8cd9b709$var$positioners = {
    arc: function(el, config) {
        var angle = (el.startAngle + el.endAngle) / 2;
        var vx = Math.cos(angle);
        var vy = Math.sin(angle);
        var r0 = el.innerRadius;
        var r1 = el.outerRadius;
        return $28f7469a8cd9b709$var$compute$1({
            x0: el.x + vx * r0,
            y0: el.y + vy * r0,
            x1: el.x + vx * r1,
            y1: el.y + vy * r1,
            vx: vx,
            vy: vy
        }, config);
    },
    point: function(el, config) {
        var v = $28f7469a8cd9b709$var$orient(el, config.origin);
        var rx = v.x * el.options.radius;
        var ry = v.y * el.options.radius;
        return $28f7469a8cd9b709$var$compute$1({
            x0: el.x - rx,
            y0: el.y - ry,
            x1: el.x + rx,
            y1: el.y + ry,
            vx: v.x,
            vy: v.y
        }, config);
    },
    bar: function(el, config) {
        var v = $28f7469a8cd9b709$var$orient(el, config.origin);
        var x = el.x;
        var y = el.y;
        var sx = 0;
        var sy = 0;
        if (el.horizontal) {
            x = Math.min(el.x, el.base);
            sx = Math.abs(el.base - el.x);
        } else {
            y = Math.min(el.y, el.base);
            sy = Math.abs(el.base - el.y);
        }
        return $28f7469a8cd9b709$var$compute$1({
            x0: x,
            y0: y + sy,
            x1: x + sx,
            y1: y,
            vx: v.x,
            vy: v.y
        }, config);
    },
    fallback: function(el, config) {
        var v = $28f7469a8cd9b709$var$orient(el, config.origin);
        return $28f7469a8cd9b709$var$compute$1({
            x0: el.x,
            y0: el.y,
            x1: el.x + (el.width || 0),
            y1: el.y + (el.height || 0),
            vx: v.x,
            vy: v.y
        }, config);
    }
};
var $28f7469a8cd9b709$var$rasterize = $28f7469a8cd9b709$var$utils.rasterize;
function $28f7469a8cd9b709$var$boundingRects(model) {
    var borderWidth = model.borderWidth || 0;
    var padding = model.padding;
    var th = model.size.height;
    var tw = model.size.width;
    var tx = -tw / 2;
    var ty = -th / 2;
    return {
        frame: {
            x: tx - padding.left - borderWidth,
            y: ty - padding.top - borderWidth,
            w: tw + padding.width + borderWidth * 2,
            h: th + padding.height + borderWidth * 2
        },
        text: {
            x: tx,
            y: ty,
            w: tw,
            h: th
        }
    };
}
function $28f7469a8cd9b709$var$getScaleOrigin(el, context) {
    var scale = context.chart.getDatasetMeta(context.datasetIndex).vScale;
    if (!scale) return null;
    if (scale.xCenter !== undefined && scale.yCenter !== undefined) return {
        x: scale.xCenter,
        y: scale.yCenter
    };
    var pixel = scale.getBasePixel();
    return el.horizontal ? {
        x: pixel,
        y: null
    } : {
        x: null,
        y: pixel
    };
}
function $28f7469a8cd9b709$var$getPositioner(el) {
    if (el instanceof (0, $87f4fbac7cf060d6$export$d48203c759d6a1fc)) return $28f7469a8cd9b709$var$positioners.arc;
    if (el instanceof (0, $87f4fbac7cf060d6$export$bd159b522b230b7a)) return $28f7469a8cd9b709$var$positioners.point;
    if (el instanceof (0, $87f4fbac7cf060d6$export$a16ed71bf4b07672)) return $28f7469a8cd9b709$var$positioners.bar;
    return $28f7469a8cd9b709$var$positioners.fallback;
}
function $28f7469a8cd9b709$var$drawRoundedRect(ctx, x, y, w, h, radius) {
    var HALF_PI = Math.PI / 2;
    if (radius) {
        var r = Math.min(radius, h / 2, w / 2);
        var left = x + r;
        var top = y + r;
        var right = x + w - r;
        var bottom = y + h - r;
        ctx.moveTo(x, top);
        if (left < right && top < bottom) {
            ctx.arc(left, top, r, -Math.PI, -HALF_PI);
            ctx.arc(right, top, r, -HALF_PI, 0);
            ctx.arc(right, bottom, r, 0, HALF_PI);
            ctx.arc(left, bottom, r, HALF_PI, Math.PI);
        } else if (left < right) {
            ctx.moveTo(left, y);
            ctx.arc(right, top, r, -HALF_PI, HALF_PI);
            ctx.arc(left, top, r, HALF_PI, Math.PI + HALF_PI);
        } else if (top < bottom) {
            ctx.arc(left, top, r, -Math.PI, 0);
            ctx.arc(left, bottom, r, 0, Math.PI);
        } else ctx.arc(left, top, r, -Math.PI, Math.PI);
        ctx.closePath();
        ctx.moveTo(x, y);
    } else ctx.rect(x, y, w, h);
}
function $28f7469a8cd9b709$var$drawFrame(ctx, rect, model) {
    var bgColor = model.backgroundColor;
    var borderColor = model.borderColor;
    var borderWidth = model.borderWidth;
    if (!bgColor && (!borderColor || !borderWidth)) return;
    ctx.beginPath();
    $28f7469a8cd9b709$var$drawRoundedRect(ctx, $28f7469a8cd9b709$var$rasterize(rect.x) + borderWidth / 2, $28f7469a8cd9b709$var$rasterize(rect.y) + borderWidth / 2, $28f7469a8cd9b709$var$rasterize(rect.w) - borderWidth, $28f7469a8cd9b709$var$rasterize(rect.h) - borderWidth, model.borderRadius);
    ctx.closePath();
    if (bgColor) {
        ctx.fillStyle = bgColor;
        ctx.fill();
    }
    if (borderColor && borderWidth) {
        ctx.strokeStyle = borderColor;
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = 'miter';
        ctx.stroke();
    }
}
function $28f7469a8cd9b709$var$textGeometry(rect, align, font) {
    var h = font.lineHeight;
    var w = rect.w;
    var x = rect.x;
    var y = rect.y + h / 2;
    if (align === 'center') x += w / 2;
    else if (align === 'end' || align === 'right') x += w;
    return {
        h: h,
        w: w,
        x: x,
        y: y
    };
}
function $28f7469a8cd9b709$var$drawTextLine(ctx, text, cfg) {
    var shadow = ctx.shadowBlur;
    var stroked = cfg.stroked;
    var x = $28f7469a8cd9b709$var$rasterize(cfg.x);
    var y = $28f7469a8cd9b709$var$rasterize(cfg.y);
    var w = $28f7469a8cd9b709$var$rasterize(cfg.w);
    if (stroked) ctx.strokeText(text, x, y, w);
    if (cfg.filled) {
        if (shadow && stroked) // Prevent drawing shadow on both the text stroke and fill, so
        // if the text is stroked, remove the shadow for the text fill.
        ctx.shadowBlur = 0;
        ctx.fillText(text, x, y, w);
        if (shadow && stroked) ctx.shadowBlur = shadow;
    }
}
function $28f7469a8cd9b709$var$drawText(ctx, lines, rect, model) {
    var align = model.textAlign;
    var color = model.color;
    var filled = !!color;
    var font = model.font;
    var ilen = lines.length;
    var strokeColor = model.textStrokeColor;
    var strokeWidth = model.textStrokeWidth;
    var stroked = strokeColor && strokeWidth;
    var i;
    if (!ilen || !filled && !stroked) return;
    // Adjust coordinates based on text alignment and line height
    rect = $28f7469a8cd9b709$var$textGeometry(rect, align, font);
    ctx.font = font.string;
    ctx.textAlign = align;
    ctx.textBaseline = 'middle';
    ctx.shadowBlur = model.textShadowBlur;
    ctx.shadowColor = model.textShadowColor;
    if (filled) ctx.fillStyle = color;
    if (stroked) {
        ctx.lineJoin = 'round';
        ctx.lineWidth = strokeWidth;
        ctx.strokeStyle = strokeColor;
    }
    for(i = 0, ilen = lines.length; i < ilen; ++i)$28f7469a8cd9b709$var$drawTextLine(ctx, lines[i], {
        stroked: stroked,
        filled: filled,
        w: rect.w,
        x: rect.x,
        y: rect.y + rect.h * i
    });
}
var $28f7469a8cd9b709$var$Label = function(config, ctx, el, index) {
    var me = this;
    me._config = config;
    me._index = index;
    me._model = null;
    me._rects = null;
    me._ctx = ctx;
    me._el = el;
};
(0, $b4325cd24db60028$export$efca4cbe5dd06740)($28f7469a8cd9b709$var$Label.prototype, {
    /**
   * @private
   */ _modelize: function(display, lines, config, context) {
        var me = this;
        var index = me._index;
        var font = (0, $b4325cd24db60028$export$34aec0b863436764)((0, $b4325cd24db60028$export$407448d2b89b1813)([
            config.font,
            {}
        ], context, index));
        var color = (0, $b4325cd24db60028$export$407448d2b89b1813)([
            config.color,
            (0, $b4325cd24db60028$export$4368d992c4eafac0).color
        ], context, index);
        return {
            align: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.align,
                'center'
            ], context, index),
            anchor: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.anchor,
                'center'
            ], context, index),
            area: context.chart.chartArea,
            backgroundColor: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.backgroundColor,
                null
            ], context, index),
            borderColor: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.borderColor,
                null
            ], context, index),
            borderRadius: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.borderRadius,
                0
            ], context, index),
            borderWidth: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.borderWidth,
                0
            ], context, index),
            clamp: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.clamp,
                false
            ], context, index),
            clip: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.clip,
                false
            ], context, index),
            color: color,
            display: display,
            font: font,
            lines: lines,
            offset: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.offset,
                4
            ], context, index),
            opacity: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.opacity,
                1
            ], context, index),
            origin: $28f7469a8cd9b709$var$getScaleOrigin(me._el, context),
            padding: (0, $b4325cd24db60028$export$a9c23c6ac3fc3eca)((0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.padding,
                4
            ], context, index)),
            positioner: $28f7469a8cd9b709$var$getPositioner(me._el),
            rotation: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.rotation,
                0
            ], context, index) * (Math.PI / 180),
            size: $28f7469a8cd9b709$var$utils.textSize(me._ctx, lines, font),
            textAlign: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.textAlign,
                'start'
            ], context, index),
            textShadowBlur: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.textShadowBlur,
                0
            ], context, index),
            textShadowColor: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.textShadowColor,
                color
            ], context, index),
            textStrokeColor: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.textStrokeColor,
                color
            ], context, index),
            textStrokeWidth: (0, $b4325cd24db60028$export$407448d2b89b1813)([
                config.textStrokeWidth,
                0
            ], context, index)
        };
    },
    update: function(context) {
        var me = this;
        var model = null;
        var rects = null;
        var index = me._index;
        var config = me._config;
        var value, label, lines;
        // We first resolve the display option (separately) to avoid computing
        // other options in case the label is hidden (i.e. display: false).
        var display = (0, $b4325cd24db60028$export$407448d2b89b1813)([
            config.display,
            true
        ], context, index);
        if (display) {
            value = context.dataset.data[index];
            label = (0, $b4325cd24db60028$export$90a7f3efeed30595)((0, $b4325cd24db60028$export$3722cfe417b6ed86)(config.formatter, [
                value,
                context
            ]), value);
            lines = (0, $b4325cd24db60028$export$342063e11d6c3cad)(label) ? [] : $28f7469a8cd9b709$var$utils.toTextLines(label);
            if (lines.length) {
                model = me._modelize(display, lines, config, context);
                rects = $28f7469a8cd9b709$var$boundingRects(model);
            }
        }
        me._model = model;
        me._rects = rects;
    },
    geometry: function() {
        return this._rects ? this._rects.frame : {};
    },
    rotation: function() {
        return this._model ? this._model.rotation : 0;
    },
    visible: function() {
        return this._model && this._model.opacity;
    },
    model: function() {
        return this._model;
    },
    draw: function(chart, center) {
        var me = this;
        var ctx = chart.ctx;
        var model = me._model;
        var rects = me._rects;
        var area;
        if (!this.visible()) return;
        ctx.save();
        if (model.clip) {
            area = model.area;
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        }
        ctx.globalAlpha = $28f7469a8cd9b709$var$utils.bound(0, model.opacity, 1);
        ctx.translate($28f7469a8cd9b709$var$rasterize(center.x), $28f7469a8cd9b709$var$rasterize(center.y));
        ctx.rotate(model.rotation);
        $28f7469a8cd9b709$var$drawFrame(ctx, rects.frame, model);
        $28f7469a8cd9b709$var$drawText(ctx, model.lines, rects.text, model);
        ctx.restore();
    }
});
var $28f7469a8cd9b709$var$MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991; // eslint-disable-line es/no-number-minsafeinteger
var $28f7469a8cd9b709$var$MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991; // eslint-disable-line es/no-number-maxsafeinteger
function $28f7469a8cd9b709$var$rotated(point, center, angle) {
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var cx = center.x;
    var cy = center.y;
    return {
        x: cx + cos * (point.x - cx) - sin * (point.y - cy),
        y: cy + sin * (point.x - cx) + cos * (point.y - cy)
    };
}
function $28f7469a8cd9b709$var$projected(points, axis) {
    var min = $28f7469a8cd9b709$var$MAX_INTEGER;
    var max = $28f7469a8cd9b709$var$MIN_INTEGER;
    var origin = axis.origin;
    var i, pt, vx, vy, dp;
    for(i = 0; i < points.length; ++i){
        pt = points[i];
        vx = pt.x - origin.x;
        vy = pt.y - origin.y;
        dp = axis.vx * vx + axis.vy * vy;
        min = Math.min(min, dp);
        max = Math.max(max, dp);
    }
    return {
        min: min,
        max: max
    };
}
function $28f7469a8cd9b709$var$toAxis(p0, p1) {
    var vx = p1.x - p0.x;
    var vy = p1.y - p0.y;
    var ln = Math.sqrt(vx * vx + vy * vy);
    return {
        vx: (p1.x - p0.x) / ln,
        vy: (p1.y - p0.y) / ln,
        origin: p0,
        ln: ln
    };
}
var $28f7469a8cd9b709$var$HitBox = function() {
    this._rotation = 0;
    this._rect = {
        x: 0,
        y: 0,
        w: 0,
        h: 0
    };
};
(0, $b4325cd24db60028$export$efca4cbe5dd06740)($28f7469a8cd9b709$var$HitBox.prototype, {
    center: function() {
        var r = this._rect;
        return {
            x: r.x + r.w / 2,
            y: r.y + r.h / 2
        };
    },
    update: function(center, rect, rotation) {
        this._rotation = rotation;
        this._rect = {
            x: rect.x + center.x,
            y: rect.y + center.y,
            w: rect.w,
            h: rect.h
        };
    },
    contains: function(point) {
        var me = this;
        var margin = 1;
        var rect = me._rect;
        point = $28f7469a8cd9b709$var$rotated(point, me.center(), -me._rotation);
        return !(point.x < rect.x - margin || point.y < rect.y - margin || point.x > rect.x + rect.w + margin * 2 || point.y > rect.y + rect.h + margin * 2);
    },
    // Separating Axis Theorem
    // https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
    intersects: function(other) {
        var r0 = this._points();
        var r1 = other._points();
        var axes = [
            $28f7469a8cd9b709$var$toAxis(r0[0], r0[1]),
            $28f7469a8cd9b709$var$toAxis(r0[0], r0[3])
        ];
        var i, pr0, pr1;
        if (this._rotation !== other._rotation) // Only separate with r1 axis if the rotation is different,
        // else it's enough to separate r0 and r1 with r0 axis only!
        axes.push($28f7469a8cd9b709$var$toAxis(r1[0], r1[1]), $28f7469a8cd9b709$var$toAxis(r1[0], r1[3]));
        for(i = 0; i < axes.length; ++i){
            pr0 = $28f7469a8cd9b709$var$projected(r0, axes[i]);
            pr1 = $28f7469a8cd9b709$var$projected(r1, axes[i]);
            if (pr0.max < pr1.min || pr1.max < pr0.min) return false;
        }
        return true;
    },
    /**
   * @private
   */ _points: function() {
        var me = this;
        var rect = me._rect;
        var angle = me._rotation;
        var center = me.center();
        return [
            $28f7469a8cd9b709$var$rotated({
                x: rect.x,
                y: rect.y
            }, center, angle),
            $28f7469a8cd9b709$var$rotated({
                x: rect.x + rect.w,
                y: rect.y
            }, center, angle),
            $28f7469a8cd9b709$var$rotated({
                x: rect.x + rect.w,
                y: rect.y + rect.h
            }, center, angle),
            $28f7469a8cd9b709$var$rotated({
                x: rect.x,
                y: rect.y + rect.h
            }, center, angle)
        ];
    }
});
function $28f7469a8cd9b709$var$coordinates(el, model, geometry) {
    var point = model.positioner(el, model);
    var vx = point.vx;
    var vy = point.vy;
    if (!vx && !vy) // if aligned center, we don't want to offset the center point
    return {
        x: point.x,
        y: point.y
    };
    var w = geometry.w;
    var h = geometry.h;
    // take in account the label rotation
    var rotation = model.rotation;
    var dx = Math.abs(w / 2 * Math.cos(rotation)) + Math.abs(h / 2 * Math.sin(rotation));
    var dy = Math.abs(w / 2 * Math.sin(rotation)) + Math.abs(h / 2 * Math.cos(rotation));
    // scale the unit vector (vx, vy) to get at least dx or dy equal to
    // w or h respectively (else we would calculate the distance to the
    // ellipse inscribed in the bounding rect)
    var vs = 1 / Math.max(Math.abs(vx), Math.abs(vy));
    dx *= vx * vs;
    dy *= vy * vs;
    // finally, include the explicit offset
    dx += model.offset * vx;
    dy += model.offset * vy;
    return {
        x: point.x + dx,
        y: point.y + dy
    };
}
function $28f7469a8cd9b709$var$collide(labels, collider) {
    var i, j, s0, s1;
    // IMPORTANT Iterate in the reverse order since items at the end of the
    // list have an higher weight/priority and thus should be less impacted
    // by the overlapping strategy.
    for(i = labels.length - 1; i >= 0; --i){
        s0 = labels[i].$layout;
        for(j = i - 1; j >= 0 && s0._visible; --j){
            s1 = labels[j].$layout;
            if (s1._visible && s0._box.intersects(s1._box)) collider(s0, s1);
        }
    }
    return labels;
}
function $28f7469a8cd9b709$var$compute(labels) {
    var i, ilen, label, state, geometry, center, proxy;
    // Initialize labels for overlap detection
    for(i = 0, ilen = labels.length; i < ilen; ++i){
        label = labels[i];
        state = label.$layout;
        if (state._visible) {
            // Chart.js 3 removed el._model in favor of getProps(), making harder to
            // abstract reading values in positioners. Also, using string arrays to
            // read values (i.e. var {a,b,c} = el.getProps(["a","b","c"])) would make
            // positioners inefficient in the normal case (i.e. not the final values)
            // and the code a bit ugly, so let's use a Proxy instead.
            proxy = new Proxy(label._el, {
                get: (el, p)=>el.getProps([
                        p
                    ], true)[p]
            });
            geometry = label.geometry();
            center = $28f7469a8cd9b709$var$coordinates(proxy, label.model(), geometry);
            state._box.update(center, geometry, label.rotation());
        }
    }
    // Auto hide overlapping labels
    return $28f7469a8cd9b709$var$collide(labels, function(s0, s1) {
        var h0 = s0._hidable;
        var h1 = s1._hidable;
        if (h0 && h1 || h1) s1._visible = false;
        else if (h0) s0._visible = false;
    });
}
var $28f7469a8cd9b709$var$layout = {
    prepare: function(datasets) {
        var labels = [];
        var i, j, ilen, jlen, label;
        for(i = 0, ilen = datasets.length; i < ilen; ++i)for(j = 0, jlen = datasets[i].length; j < jlen; ++j){
            label = datasets[i][j];
            labels.push(label);
            label.$layout = {
                _box: new $28f7469a8cd9b709$var$HitBox(),
                _hidable: false,
                _visible: true,
                _set: i,
                _idx: label._index
            };
        }
        // TODO New `z` option: labels with a higher z-index are drawn
        // of top of the ones with a lower index. Lowest z-index labels
        // are also discarded first when hiding overlapping labels.
        labels.sort(function(a, b) {
            var sa = a.$layout;
            var sb = b.$layout;
            return sa._idx === sb._idx ? sb._set - sa._set : sb._idx - sa._idx;
        });
        this.update(labels);
        return labels;
    },
    update: function(labels) {
        var dirty = false;
        var i, ilen, label, model, state;
        for(i = 0, ilen = labels.length; i < ilen; ++i){
            label = labels[i];
            model = label.model();
            state = label.$layout;
            state._hidable = model && model.display === 'auto';
            state._visible = label.visible();
            dirty |= state._hidable;
        }
        if (dirty) $28f7469a8cd9b709$var$compute(labels);
    },
    lookup: function(labels, point) {
        var i, state;
        // IMPORTANT Iterate in the reverse order since items at the end of
        // the list have an higher z-index, thus should be picked first.
        for(i = labels.length - 1; i >= 0; --i){
            state = labels[i].$layout;
            if (state && state._visible && state._box.contains(point)) return labels[i];
        }
        return null;
    },
    draw: function(chart, labels) {
        var i, ilen, label, state, geometry, center;
        for(i = 0, ilen = labels.length; i < ilen; ++i){
            label = labels[i];
            state = label.$layout;
            if (state._visible) {
                geometry = label.geometry();
                center = $28f7469a8cd9b709$var$coordinates(label._el, label.model(), geometry);
                state._box.update(center, geometry, label.rotation());
                label.draw(chart, center);
            }
        }
    }
};
var $28f7469a8cd9b709$var$formatter = function(value) {
    if ((0, $b4325cd24db60028$export$342063e11d6c3cad)(value)) return null;
    var label = value;
    var keys, klen, k;
    if ((0, $b4325cd24db60028$export$23f2a1d2818174ef)(value)) {
        if (!(0, $b4325cd24db60028$export$342063e11d6c3cad)(value.label)) label = value.label;
        else if (!(0, $b4325cd24db60028$export$342063e11d6c3cad)(value.r)) label = value.r;
        else {
            label = '';
            keys = Object.keys(value);
            for(k = 0, klen = keys.length; k < klen; ++k)label += (k !== 0 ? ', ' : '') + keys[k] + ': ' + value[keys[k]];
        }
    }
    return '' + label;
};
/**
 * IMPORTANT: make sure to also update tests and TypeScript definition
 * files (`/test/specs/defaults.spec.js` and `/types/options.d.ts`)
 */ var $28f7469a8cd9b709$var$defaults = {
    align: 'center',
    anchor: 'center',
    backgroundColor: null,
    borderColor: null,
    borderRadius: 0,
    borderWidth: 0,
    clamp: false,
    clip: false,
    color: undefined,
    display: true,
    font: {
        family: undefined,
        lineHeight: 1.2,
        size: undefined,
        style: undefined,
        weight: null
    },
    formatter: $28f7469a8cd9b709$var$formatter,
    labels: undefined,
    listeners: {},
    offset: 4,
    opacity: 1,
    padding: {
        top: 4,
        right: 4,
        bottom: 4,
        left: 4
    },
    rotation: 0,
    textAlign: 'start',
    textStrokeColor: undefined,
    textStrokeWidth: 0,
    textShadowBlur: 0,
    textShadowColor: undefined
};
/**
 * @see https://github.com/chartjs/Chart.js/issues/4176
 */ var $28f7469a8cd9b709$var$EXPANDO_KEY = '$datalabels';
var $28f7469a8cd9b709$var$DEFAULT_KEY = '$default';
function $28f7469a8cd9b709$var$configure(dataset, options) {
    var override = dataset.datalabels;
    var listeners = {};
    var configs = [];
    var labels, keys;
    if (override === false) return null;
    if (override === true) override = {};
    options = (0, $b4325cd24db60028$export$efca4cbe5dd06740)({}, [
        options,
        override
    ]);
    labels = options.labels || {};
    keys = Object.keys(labels);
    delete options.labels;
    if (keys.length) keys.forEach(function(key) {
        if (labels[key]) configs.push((0, $b4325cd24db60028$export$efca4cbe5dd06740)({}, [
            options,
            labels[key],
            {
                _key: key
            }
        ]));
    });
    else // Default label if no "named" label defined.
    configs.push(options);
    // listeners: {<event-type>: {<label-key>: <fn>}}
    listeners = configs.reduce(function(target, config) {
        (0, $b4325cd24db60028$export$d66501df72047452)(config.listeners || {}, function(fn, event) {
            target[event] = target[event] || {};
            target[event][config._key || $28f7469a8cd9b709$var$DEFAULT_KEY] = fn;
        });
        delete config.listeners;
        return target;
    }, {});
    return {
        labels: configs,
        listeners: listeners
    };
}
function $28f7469a8cd9b709$var$dispatchEvent(chart, listeners, label, event) {
    if (!listeners) return;
    var context = label.$context;
    var groups = label.$groups;
    var callback$1;
    if (!listeners[groups._set]) return;
    callback$1 = listeners[groups._set][groups._key];
    if (!callback$1) return;
    if ((0, $b4325cd24db60028$export$3722cfe417b6ed86)(callback$1, [
        context,
        event
    ]) === true) {
        // Users are allowed to tweak the given context by injecting values that can be
        // used in scriptable options to display labels differently based on the current
        // event (e.g. highlight an hovered label). That's why we update the label with
        // the output context and schedule a new chart render by setting it dirty.
        chart[$28f7469a8cd9b709$var$EXPANDO_KEY]._dirty = true;
        label.update(context);
    }
}
function $28f7469a8cd9b709$var$dispatchMoveEvents(chart, listeners, previous, label, event) {
    var enter, leave;
    if (!previous && !label) return;
    if (!previous) enter = true;
    else if (!label) leave = true;
    else if (previous !== label) leave = enter = true;
    if (leave) $28f7469a8cd9b709$var$dispatchEvent(chart, listeners.leave, previous, event);
    if (enter) $28f7469a8cd9b709$var$dispatchEvent(chart, listeners.enter, label, event);
}
function $28f7469a8cd9b709$var$handleMoveEvents(chart, event) {
    var expando = chart[$28f7469a8cd9b709$var$EXPANDO_KEY];
    var listeners = expando._listeners;
    var previous, label;
    if (!listeners.enter && !listeners.leave) return;
    if (event.type === 'mousemove') label = $28f7469a8cd9b709$var$layout.lookup(expando._labels, event);
    else if (event.type !== 'mouseout') return;
    previous = expando._hovered;
    expando._hovered = label;
    $28f7469a8cd9b709$var$dispatchMoveEvents(chart, listeners, previous, label, event);
}
function $28f7469a8cd9b709$var$handleClickEvents(chart, event) {
    var expando = chart[$28f7469a8cd9b709$var$EXPANDO_KEY];
    var handlers = expando._listeners.click;
    var label = handlers && $28f7469a8cd9b709$var$layout.lookup(expando._labels, event);
    if (label) $28f7469a8cd9b709$var$dispatchEvent(chart, handlers, label, event);
}
var $28f7469a8cd9b709$export$2e2bcd8739ae039 = {
    id: 'datalabels',
    defaults: $28f7469a8cd9b709$var$defaults,
    beforeInit: function(chart) {
        chart[$28f7469a8cd9b709$var$EXPANDO_KEY] = {
            _actives: []
        };
    },
    beforeUpdate: function(chart) {
        var expando = chart[$28f7469a8cd9b709$var$EXPANDO_KEY];
        expando._listened = false;
        expando._listeners = {}; // {<event-type>: {<dataset-index>: {<label-key>: <fn>}}}
        expando._datasets = []; // per dataset labels: [Label[]]
        expando._labels = []; // layouted labels: Label[]
    },
    afterDatasetUpdate: function(chart, args, options) {
        var datasetIndex = args.index;
        var expando = chart[$28f7469a8cd9b709$var$EXPANDO_KEY];
        var labels = expando._datasets[datasetIndex] = [];
        var visible = chart.isDatasetVisible(datasetIndex);
        var dataset = chart.data.datasets[datasetIndex];
        var config = $28f7469a8cd9b709$var$configure(dataset, options);
        var elements = args.meta.data || [];
        var ctx = chart.ctx;
        var i, j, ilen, jlen, cfg, key, el, label;
        ctx.save();
        for(i = 0, ilen = elements.length; i < ilen; ++i){
            el = elements[i];
            el[$28f7469a8cd9b709$var$EXPANDO_KEY] = [];
            if (visible && el && chart.getDataVisibility(i) && !el.skip) for(j = 0, jlen = config.labels.length; j < jlen; ++j){
                cfg = config.labels[j];
                key = cfg._key;
                label = new $28f7469a8cd9b709$var$Label(cfg, ctx, el, i);
                label.$groups = {
                    _set: datasetIndex,
                    _key: key || $28f7469a8cd9b709$var$DEFAULT_KEY
                };
                label.$context = {
                    active: false,
                    chart: chart,
                    dataIndex: i,
                    dataset: dataset,
                    datasetIndex: datasetIndex
                };
                label.update(label.$context);
                el[$28f7469a8cd9b709$var$EXPANDO_KEY].push(label);
                labels.push(label);
            }
        }
        ctx.restore();
        // Store listeners at the chart level and per event type to optimize
        // cases where no listeners are registered for a specific event.
        (0, $b4325cd24db60028$export$efca4cbe5dd06740)(expando._listeners, config.listeners, {
            merger: function(event, target, source) {
                target[event] = target[event] || {};
                target[event][args.index] = source[event];
                expando._listened = true;
            }
        });
    },
    afterUpdate: function(chart) {
        chart[$28f7469a8cd9b709$var$EXPANDO_KEY]._labels = $28f7469a8cd9b709$var$layout.prepare(chart[$28f7469a8cd9b709$var$EXPANDO_KEY]._datasets);
    },
    // Draw labels on top of all dataset elements
    // https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
    // https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
    afterDatasetsDraw: function(chart) {
        $28f7469a8cd9b709$var$layout.draw(chart, chart[$28f7469a8cd9b709$var$EXPANDO_KEY]._labels);
    },
    beforeEvent: function(chart, args) {
        // If there is no listener registered for this chart, `listened` will be false,
        // meaning we can immediately ignore the incoming event and avoid useless extra
        // computation for users who don't implement label interactions.
        if (chart[$28f7469a8cd9b709$var$EXPANDO_KEY]._listened) {
            var event = args.event;
            switch(event.type){
                case 'mousemove':
                case 'mouseout':
                    $28f7469a8cd9b709$var$handleMoveEvents(chart, event);
                    break;
                case 'click':
                    $28f7469a8cd9b709$var$handleClickEvents(chart, event);
                    break;
            }
        }
    },
    afterEvent: function(chart) {
        var expando = chart[$28f7469a8cd9b709$var$EXPANDO_KEY];
        var previous = expando._actives;
        var actives = expando._actives = chart.getActiveElements();
        var updates = $28f7469a8cd9b709$var$utils.arrayDiff(previous, actives);
        var i, ilen, j, jlen, update, label, labels;
        for(i = 0, ilen = updates.length; i < ilen; ++i){
            update = updates[i];
            if (update[1]) {
                labels = update[0].element[$28f7469a8cd9b709$var$EXPANDO_KEY] || [];
                for(j = 0, jlen = labels.length; j < jlen; ++j){
                    label = labels[j];
                    label.$context.active = update[1] === 1;
                    label.update(label.$context);
                }
            }
        }
        if (expando._dirty || updates.length) {
            $28f7469a8cd9b709$var$layout.update(expando._labels);
            chart.render();
        }
        delete expando._dirty;
    }
};



(0, $87f4fbac7cf060d6$export$acaa6426d77a227e).register(...(0, $87f4fbac7cf060d6$export$e8959e79e3af550f));
var $ed16e842d7a1e1e6$export$2e2bcd8739ae039 = (0, $87f4fbac7cf060d6$export$acaa6426d77a227e);



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $19d7c92a8d22615b$var$AverageIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("svg", {
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "8",
                stroke: "black",
                "stroke-width": "2"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("line", {
                x1: "19",
                y1: "5",
                x2: "5",
                y2: "19",
                stroke: "black",
                "stroke-width": "2"
            })
        ]
    });
};
var $19d7c92a8d22615b$export$2e2bcd8739ae039 = $19d7c92a8d22615b$var$AverageIcon;



var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");

const $c6ba6dadbd9f2ddc$var$BetterFirstSessionIcon = (props)=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: theme.palette.text.primary,
        height: props.width,
        width: props.width,
        xmlns: "http://www.w3.org/2000/svg",
        id: "fi_4212269",
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("g", {
            id: "_14-Loss",
            "data-name": "14-Loss",
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                    d: "m27.38 11.08a1 1 0 0 0 -1.09.21l-1.79 1.8-5.79-5.8a1 1 0 0 0 -1.42 0l-3.29 3.3-8.29-8.3a1 1 0 0 0 -1.42 1.42l9 9a1 1 0 0 0 1.42 0l3.29-3.3 5.09 5.09-1.8 1.79a1 1 0 0 0 -.21 1.09 1 1 0 0 0 .92.62h5a1 1 0 0 0 1-1v-5a1 1 0 0 0 -.62-.92z"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("rect", {
                    height: "9",
                    rx: "1",
                    width: "6",
                    x: "22",
                    y: "21"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("rect", {
                    height: "13",
                    rx: "1",
                    width: "6",
                    x: "13",
                    y: "17"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("rect", {
                    height: "17",
                    rx: "1",
                    width: "6",
                    x: "4",
                    y: "13"
                })
            ]
        })
    });
};
var $c6ba6dadbd9f2ddc$export$2e2bcd8739ae039 = $c6ba6dadbd9f2ddc$var$BetterFirstSessionIcon;


const $eec6a47b73d638da$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        recordName: {
            marginLeft: '10px',
            width: '170px'
        },
        icon: {
            width: '20px'
        },
        recordElement: {},
        cell: {
            padding: '8px'
        }
    }));
const $eec6a47b73d638da$var$Statistics = ()=>{
    const classes = $eec6a47b73d638da$var$useStyles();
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const statisticColors = [
        '#1c7899',
        '#6093a4',
        '#8baab6',
        '#a9c3ce',
        '#a0a8ad',
        '#4e5a60',
        '#d0e0e5',
        '#6ba5a1',
        '#517e8c',
        '#aac7b3',
        '#6c7a80',
        '#2d3e49'
    ];
    const basePath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
    const fetchHeaders = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).fetchHeaders;
    (0, $58718165e7ed8d4a$export$bacd26fe3052ded6)(fetchHeaders);
    const theme = (0, $76d75229d7c83be5$export$5886efcb490847cc)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const members = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$f4931e6f9feb30c5));
    const statistics = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$115663dc807a2e95));
    const eventResults = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$79c726a1641bb9ad));
    const events = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$3f41ece7d7128238));
    (0, $87f4fbac7cf060d6$export$acaa6426d77a227e).register((0, $87f4fbac7cf060d6$export$29e663ba4d09fe7), (0, $87f4fbac7cf060d6$export$e7f4e5e8656f0b93), (0, $87f4fbac7cf060d6$export$a16ed71bf4b07672), (0, $87f4fbac7cf060d6$export$f99233281efd08a0), (0, $87f4fbac7cf060d6$export$28c660c63b792dea), (0, $87f4fbac7cf060d6$export$ed247974535929c7), (0, $28f7469a8cd9b709$export$2e2bcd8739ae039), (0, $87f4fbac7cf060d6$export$85295eaf7cb3ac3e));
    const pieOptions = {
        responsive: true,
        borderColor: theme.palette.background.paper,
        plugins: {
            legend: {
                position: 'top',
                display: true
            },
            datalabels: {
                color: theme.palette.text.primary,
                formatter: (value, context)=>{
                    const sum = context.chart.data.datasets[0].data.reduce((s, val)=>s + val, 0);
                    const percentage = Math.round(value / sum * 100);
                    return percentage > 5 ? `${value} (${percentage}%)` : '' // Nur Labels anzeigen, wenn der Prozentsatz > 5% ist
                    ;
                },
                font: {
                    weight: 'bold',
                    size: 12
                },
                display: function(context) {
                    return context.dataset.data[context.dataIndex] > 0 // Zeige nur Werte > 0
                    ;
                },
                textAlign: 'center',
                anchor: 'center',
                align: 'center',
                offset: 0
            }
        }
    };
    const stackedOptions = {
        responsive: true,
        scales: {
            x: {
                stacked: true
            },
            y: {
                stacked: true
            }
        },
        plugins: {
            legend: {
                position: 'top',
                display: true
            },
            datalabels: {
                color: theme.palette.text.primary,
                anchor: 'end',
                align: 'bottom',
                offset: 4,
                clamp: true,
                formatter: (value)=>value || '',
                font: {
                    weight: 'bold',
                    size: 12
                },
                display: function(context) {
                    return context.dataset.data[context.dataIndex] > 0;
                }
            }
        }
    };
    const nonStackedOptions = {
        responsive: true,
        scales: {
            y: {
                type: 'logarithmic',
                beginAtZero: true,
                ticks: {
                    callback: function(value) {
                        return Number(value).toLocaleString() // Formatierung
                        ;
                    }
                }
            }
        },
        plugins: {
            legend: {
                position: 'top',
                display: false
            },
            datalabels: {
                color: theme.palette.text.primary,
                anchor: 'end',
                align: 'bottom',
                offset: 4,
                clamp: true,
                formatter: (value, context)=>{
                    // Für Pie/Doughnut-Charts ist die Berechnung einfacher
                    const dataset = context.chart.data.datasets[context.datasetIndex];
                    const total = dataset.data.reduce((sum, val)=>sum + (val || 0), 0);
                    const percentage = total ? (value / total * 100).toFixed(1) : '0';
                    // Entferne die Dezimalstelle, wenn sie .0 ist
                    const displayPercentage = percentage.endsWith('.0') ? percentage.slice(0, -2) : percentage;
                    // Gib sowohl absoluten Wert als auch Prozentsatz zurück
                    return value ? `${value} (${displayPercentage}%)` : '';
                },
                font: {
                    weight: 'bold',
                    size: 12
                },
                display: function(context) {
                    return context.dataset.data[context.dataIndex] > 0;
                }
            }
        }
    };
    const getPlayerName = (id)=>{
        const member = id && members?.results.find((member)=>member.originId === id);
        return member ? `${member.firstname} ${member.lastname}` : null;
    };
    const getEventOptions = ()=>{
        const options = [];
        events?.results.map((event)=>{
            event.id && options.push({
                key: event.id,
                value: event.title
            });
        });
        return options;
    };
    const getMemberOptions = ()=>{
        const options = [];
        statistics?.memberOpponents.map((member)=>{
            member.memberId && options.push({
                key: member.memberId,
                value: `${getMember(member.memberId)?.firstname} ${getMember(member.memberId)?.lastname}`
            });
        });
        return options;
    };
    const getMember = (id)=>{
        if (id) return members?.results.find((item)=>item.originId === id);
    };
    const getMemberWinLooseRoundsData = (member)=>{
        return {
            datasets: [
                {
                    hoverOffset: 4,
                    label: 'Runden',
                    data: [
                        statistics?.memberStatistics[member].totalRoundWon || 0,
                        statistics?.memberStatistics[member].totalRoundLoose || 0
                    ],
                    backgroundColor: [
                        theme.palette.primary.light,
                        theme.palette.primary.dark
                    ]
                }
            ],
            labels: [
                'Gewonnen',
                'Verloren'
            ]
        };
    };
    const getMemberTableData = (member)=>{
        return {
            datasets: [
                {
                    hoverOffset: 4,
                    label: 'Anzahl',
                    data: [
                        statistics?.memberStatistics[member].tableOfThree || 0,
                        statistics?.memberStatistics[member].tableOfFour || 0
                    ],
                    backgroundColor: [
                        theme.palette.primary.light,
                        theme.palette.primary.dark
                    ]
                }
            ],
            labels: [
                '3er Tische',
                '4er Tische'
            ]
        };
    };
    const getMemberWinLooseGameData = (member)=>{
        return {
            datasets: [
                {
                    hoverOffset: 4,
                    label: 'Spiele',
                    data: [
                        statistics?.memberStatistics[member].totalGameWon || 0,
                        statistics?.memberStatistics[member].totalGameLoose || 0,
                        statistics?.memberStatistics[member].totalMixedIn || 0
                    ],
                    backgroundColor: [
                        theme.palette.primary.light,
                        theme.palette.primary.dark,
                        theme.palette.grey.A400
                    ]
                }
            ],
            labels: [
                'Gewonnen',
                'Verloren',
                'Eingemischt'
            ]
        };
    };
    const getCompleteWinLooseGameData = ()=>{
        return {
            datasets: [
                {
                    hoverOffset: 4,
                    label: 'Spiele',
                    data: [
                        statistics?.globalGameStatistics.wonGames - statistics?.globalGameStatistics.byType['eingemischt'] || 0,
                        statistics?.globalGameStatistics.totalGames - statistics?.globalGameStatistics.wonGames || 0,
                        statistics?.globalGameStatistics.byType['eingemischt'] || 0
                    ],
                    backgroundColor: [
                        theme.palette.primary.light,
                        theme.palette.primary.dark,
                        theme.palette.grey.A400
                    ]
                }
            ],
            labels: [
                'Gewonnen',
                'Verloren',
                'Eingemischt'
            ]
        };
    };
    const getMemberOpponentData = (member)=>{
        const labels = [];
        const count = [];
        const opponents = statistics?.memberOpponents.find((element)=>element.memberId === member)?.opponents;
        opponents && Object.keys(opponents).map((opponent)=>{
            if (member !== opponent) {
                labels.push(`${getMember(opponent)?.firstname} ${getMember(opponent)?.lastname.slice(0, 1)}.`);
                count.push(opponents[opponent]);
            }
        });
        const datasets = [
            {
                label: 'Anzahl',
                data: count,
                backgroundColor: theme.palette.primary.dark,
                borderRadius: 4,
                borderSkipped: false,
                barPercentage: 0.8
            }
        ];
        return {
            labels: labels,
            datasets: datasets
        };
    };
    const getMemberRoundData = (member)=>{
        const labels = [];
        const first = [];
        const second = [];
        const complete = [];
        statistics?.memberStatistics[member].rounds.map((element)=>{
            labels.push(element.year.toString());
            first.push(element.first);
            second.push(element.second);
            complete.push(element.first + element.second);
        });
        const datasets = [
            {
                label: 'Erste Runde',
                data: first,
                backgroundColor: theme.palette.primary.dark,
                stack: 'Runden',
                borderRadius: {
                    topLeft: 0,
                    topRight: 0,
                    bottomLeft: 4,
                    bottomRight: 4
                },
                borderSkipped: false
            },
            {
                label: 'Zweite Runde',
                data: second,
                backgroundColor: theme.palette.primary.light,
                stack: 'Runden',
                borderRadius: {
                    topLeft: 4,
                    topRight: 4,
                    bottomLeft: 0,
                    bottomRight: 0
                },
                borderSkipped: false
            },
            {
                label: 'Gesamt',
                data: complete,
                backgroundColor: theme.palette.grey.A400,
                stack: 'Gesamt',
                borderRadius: 4,
                borderSkipped: false
            }
        ];
        return {
            labels: labels,
            datasets: datasets
        };
    };
    const getParticipationData = ()=>{
        const labels = [];
        const male = [];
        const female = [];
        statistics?.participation.map((element)=>{
            labels.push(element.year.toString());
            male.push(element.male);
            female.push(element.female);
        });
        const datasets = [
            {
                label: "M\xe4nner",
                data: male,
                backgroundColor: theme.palette.primary.dark,
                borderRadius: {
                    topLeft: 0,
                    topRight: 0,
                    bottomLeft: 4,
                    bottomRight: 4
                },
                borderSkipped: false
            },
            {
                label: 'Frauen',
                data: female,
                backgroundColor: theme.palette.primary.light,
                borderRadius: {
                    topLeft: 4,
                    topRight: 4,
                    bottomLeft: 0,
                    bottomRight: 0
                },
                borderSkipped: false
            }
        ];
        return {
            labels: labels,
            datasets: datasets
        };
    };
    const getGameTypeData = (event)=>{
        let globalGameStats = statistics?.globalGameStatistics;
        if (event) globalGameStats = statistics?.eventStatistic[event].gameStatistics;
        return {
            labels: [
                'Grand',
                'Eichel',
                "Gr\xfcn",
                'Rot',
                'Schell',
                'Null'
            ],
            datasets: [
                {
                    data: [
                        globalGameStats?.byType.grand || 0,
                        globalGameStats?.byType.eichel || 0,
                        globalGameStats?.byType.gruen || 0,
                        globalGameStats?.byType.rot || 0,
                        globalGameStats?.byType.schell || 0,
                        globalGameStats?.byType.zero || 0
                    ],
                    backgroundColor: [
                        '#1c7899',
                        '#a0a8ad',
                        '#a9c3ce',
                        '#6093a4',
                        '#4e5a60',
                        '#8baab6'
                    ],
                    label: '',
                    barPercentage: 0.7,
                    borderRadius: 4
                }
            ]
        };
    };
    const getGamePropertyData = (event)=>{
        let globalGameStats = statistics?.globalGameStatistics;
        if (event) globalGameStats = statistics?.eventStatistic[event].gameStatistics;
        return {
            labels: [
                'Einfach',
                'Schneider',
                'Schwarz',
                'Hand',
                'Ouvert',
                'Hand-Schneider',
                'Hand-Schwarz',
                'Hand-Schneider-angesagt',
                'Hand-Schwarz-angesagt',
                'Hand-Schneider-angesagt-Schwarz',
                'Hand-Ouvert'
            ],
            datasets: [
                {
                    data: [
                        globalGameStats?.byProperty['einfach'] || 0,
                        globalGameStats?.byProperty['schneider'] || 0,
                        globalGameStats?.byProperty['schwarz'] || 0,
                        globalGameStats?.byProperty['hand'] || 0,
                        globalGameStats?.byProperty['ouvert'] || 0,
                        globalGameStats?.byProperty['handSchneider'] || 0,
                        globalGameStats?.byProperty['handSchwarz'] || 0,
                        globalGameStats?.byProperty['handSchneiderAngesagt'] || 0,
                        globalGameStats?.byProperty['handSchwarzAngesagt'] || 0,
                        globalGameStats?.byProperty['handSchneiderAngesagtSchwarz'] || 0,
                        globalGameStats?.byProperty['handOuvert'] || 0
                    ],
                    backgroundColor: [
                        statisticColors[0],
                        statisticColors[9],
                        statisticColors[2],
                        statisticColors[8],
                        statisticColors[4],
                        statisticColors[5],
                        statisticColors[6],
                        statisticColors[7],
                        statisticColors[1],
                        statisticColors[3],
                        statisticColors[10]
                    ],
                    borderRadius: 4,
                    barPercentage: 0.8
                }
            ]
        };
    };
    const getMemberGameTypeData = (memberId)=>{
        const globalGameStats = statistics?.memberStatistics[memberId].gameStatistics;
        return {
            labels: [
                'Grand',
                'Eichel',
                "Gr\xfcn",
                'Rot',
                'Schell',
                'Null'
            ],
            datasets: [
                {
                    data: [
                        globalGameStats?.byType.grand || 0,
                        globalGameStats?.byType.eichel || 0,
                        globalGameStats?.byType.gruen || 0,
                        globalGameStats?.byType.rot || 0,
                        globalGameStats?.byType.schell || 0,
                        globalGameStats?.byType.zero || 0
                    ],
                    backgroundColor: [
                        '#1c7899',
                        '#a0a8ad',
                        '#a9c3ce',
                        '#6093a4',
                        '#4e5a60',
                        '#8baab6'
                    ],
                    label: '',
                    barPercentage: 0.7,
                    borderRadius: 4
                }
            ]
        };
    };
    const getMemberGamePropertyData = (memberId)=>{
        const globalGameStats = statistics?.memberStatistics[memberId].gameStatistics;
        return {
            labels: [
                'Einfach',
                'Schneider',
                'Schwarz',
                'Hand',
                'Ouvert',
                'Hand-Schneider',
                'Hand-Schwarz',
                'Hand-Schneider-angesagt',
                'Hand-Schwarz-angesagt',
                'Hand-Schneider-angesagt-Schwarz',
                'Hand-Ouvert'
            ],
            datasets: [
                {
                    data: [
                        globalGameStats?.byProperty['einfach'] || 0,
                        globalGameStats?.byProperty['schneider'] || 0,
                        globalGameStats?.byProperty['schwarz'] || 0,
                        globalGameStats?.byProperty['hand'] || 0,
                        globalGameStats?.byProperty['ouvert'] || 0,
                        globalGameStats?.byProperty['handSchneider'] || 0,
                        globalGameStats?.byProperty['handSchwarz'] || 0,
                        globalGameStats?.byProperty['handSchneiderAngesagt'] || 0,
                        globalGameStats?.byProperty['handSchwarzAngesagt'] || 0,
                        globalGameStats?.byProperty['handSchneiderAngesagtSchwarz'] || 0,
                        globalGameStats?.byProperty['handOuvert'] || 0
                    ],
                    backgroundColor: [
                        statisticColors[0],
                        statisticColors[9],
                        statisticColors[2],
                        statisticColors[8],
                        statisticColors[4],
                        statisticColors[5],
                        statisticColors[6],
                        statisticColors[7],
                        statisticColors[1],
                        statisticColors[3],
                        statisticColors[10]
                    ],
                    borderRadius: 4,
                    barPercentage: 0.8
                }
            ]
        };
    };
    let TabEnum = /*#__PURE__*/ function(TabEnum) {
        TabEnum["complete"] = "complete";
        TabEnum["event"] = "event";
        TabEnum["member"] = "member";
        return TabEnum;
    }({});
    const [activeTab, setActiveTab] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState("complete");
    const [activeGamer, setActiveGamer] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [activeEvent, setActiveEvent] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [stars, setStars] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState([]);
    const setEventResults = (res)=>{
        dispatch($5993246da723f2dd$export$32f26ecd1d16cf({
            ...eventResults,
            [activeEvent]: res.results
        }));
    };
    (0, $3OyDL.useEffect)(()=>{
        activeEvent && !eventResults[activeEvent] && (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventResults, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).GET, activeEvent, undefined, setEventResults, null);
    }, [
        activeEvent
    ]);
    (0, $3OyDL.useEffect)(()=>{
        const newStarArray = [];
        statistics?.stars && Object.keys(statistics?.stars).map((memberId)=>{
            newStarArray.push({
                memberId: memberId,
                count: statistics?.stars[memberId]
            });
        });
        setStars(newStarArray.sort((a, b)=>b.count - a.count));
    }, [
        statistics
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: statistics ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    variant: "h1",
                    children: "Skatstatistiken"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $300390f560fe3d4d$export$2e2bcd8739ae039), {
                    sx: {
                        marginBottom: '20px'
                    },
                    value: activeTab,
                    onChange: (e, newValue)=>setActiveTab(newValue),
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                            value: "complete",
                            label: "Gesamtstatistik"
                        }, "complete"),
                        !downSm && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                            value: "event",
                            label: "Turnierstatistik"
                        }, "event"),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d43daa6ddaf4aee6$export$2e2bcd8739ae039), {
                            value: "member",
                            label: "Einzelstatistiken"
                        }, "member")
                    ]
                }),
                activeTab === "event" && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                width: '400px',
                                marginBottom: '20px'
                            },
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                size: "small",
                                options: getEventOptions(),
                                label: "Skatturnier",
                                multiple: false,
                                onChange: (value)=>{
                                    setActiveEvent(value?.key);
                                }
                            })
                        }),
                        activeEvent && eventResults[activeEvent] ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "subtitle1",
                                            children: "Platzierung"
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                                            size: "small",
                                            sx: {
                                                width: '100%'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                align: "center",
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                    children: "Platzierung"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                    children: "Name"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                align: "center",
                                                                sx: {
                                                                    whiteSpace: 'nowrap'
                                                                },
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                    children: "Runde 1"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                align: "center",
                                                                sx: {
                                                                    whiteSpace: 'nowrap'
                                                                },
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                    children: "Runde 2"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                align: "center",
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                    children: "Gesamtpunkte"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                                                    children: (0, $07e0544037b0637a$export$2e2bcd8739ae039)(eventResults[activeEvent], (0, $46668510321f1f9f$export$19fbfcba8fe44d89).complete).map((element, index)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                    align: "center",
                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                        children: index + 1
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        whiteSpace: 'nowrap'
                                                                    },
                                                                    children: getPlayerName(element.memberId)
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                    align: "center",
                                                                    children: eventResults[activeEvent].find((result)=>result.session === 1 && result.players.find((player)=>player === element.memberId))?.results[element.memberId].completeResult
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                    align: "center",
                                                                    children: eventResults[activeEvent].find((result)=>result.session === 2 && result.players.find((player)=>player === element.memberId))?.results[element.memberId].completeResult
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                    align: "center",
                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                        children: element.completeResult
                                                                    })
                                                                })
                                                            ]
                                                        }, index))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 6,
                                    children: statistics?.eventStatistic[activeEvent] ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                variant: "subtitle1",
                                                children: "Rekorde"
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fd36c5cfeb020481$exports))), {
                                                        width: "20px"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginLeft: '10px'
                                                        },
                                                        variant: "body1",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Spielerinnen:\xa0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "body1",
                                                        children: statistics?.eventStatistic[activeEvent].women
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e5059b1b086b52db$exports))), {
                                                        width: "20px"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginLeft: '10px'
                                                        },
                                                        variant: "body1",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Spieler:\xa0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "body1",
                                                        children: statistics?.eventStatistic[activeEvent].men
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $21c840b7db424828$export$2e2bcd8739ae039), {
                                                        width: "20px"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginLeft: '10px'
                                                        },
                                                        variant: "body1",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Spiele gesamt:\xa0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "body1",
                                                        children: statistics?.eventStatistic[activeEvent].totalGames
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $19d7c92a8d22615b$export$2e2bcd8739ae039), {
                                                        width: "20px"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginLeft: '10px'
                                                        },
                                                        variant: "body1",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Durchschnittl. Spiele pro Spieler:\xa0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "body1",
                                                        children: statistics?.eventStatistic[activeEvent].averageGamesPerPlayer
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $48f0e9d81c82a26c$export$2e2bcd8739ae039), {
                                                        width: "20px"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginLeft: '10px'
                                                        },
                                                        variant: "body1",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Bestes Spiel:\xa0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "body1",
                                                        children: `${statistics?.eventStatistic[activeEvent].bestGame && getMember(statistics?.eventStatistic[activeEvent].bestGame.memberId)?.firstname} ${statistics?.eventStatistic[activeEvent].bestGame && getMember(statistics?.eventStatistic[activeEvent].bestGame.memberId)?.lastname} mit ${statistics?.eventStatistic[activeEvent].bestGame && statistics?.eventStatistic[activeEvent].bestGame.count} Punkten`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0fa057fc54c651ae$export$2e2bcd8739ae039), {
                                                        width: "20px"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginLeft: '10px'
                                                        },
                                                        variant: "body1",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Schlechtestes Spiel:\xa0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "body1",
                                                        children: `${statistics?.eventStatistic[activeEvent].worstGame && getMember(statistics?.eventStatistic[activeEvent].worstGame.memberId)?.firstname} ${statistics?.eventStatistic[activeEvent].worstGame && getMember(statistics?.eventStatistic[activeEvent].worstGame.memberId)?.lastname} mit ${statistics?.eventStatistic[activeEvent].worstGame && statistics?.eventStatistic[activeEvent].worstGame.count} Punkten`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6323b6fef031a38a$export$2e2bcd8739ae039), {
                                                        width: "20px"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginLeft: '10px'
                                                        },
                                                        variant: "body1",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "\xc4ltester Spieler:\xa0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "body1",
                                                        children: `${statistics?.eventStatistic[activeEvent].oldestGamer && getMember(statistics?.eventStatistic[activeEvent].oldestGamer.memberId)?.firstname} ${statistics?.eventStatistic[activeEvent].oldestGamer && getMember(statistics?.eventStatistic[activeEvent].oldestGamer.memberId)?.lastname} mit ${statistics?.eventStatistic[activeEvent].oldestGamer && statistics?.eventStatistic[activeEvent].oldestGamer.count} Jahren`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2329768e9950cc40$export$2e2bcd8739ae039), {
                                                        width: "20px"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginLeft: '10px'
                                                        },
                                                        variant: "body1",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "J\xfcngster Spieler:\xa0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "body1",
                                                        children: `${statistics?.eventStatistic[activeEvent].youngestGamer && getMember(statistics?.eventStatistic[activeEvent].youngestGamer.memberId)?.firstname} ${statistics?.eventStatistic[activeEvent].youngestGamer && getMember(statistics?.eventStatistic[activeEvent].youngestGamer.memberId)?.lastname} mit ${statistics?.eventStatistic[activeEvent].youngestGamer && statistics?.eventStatistic[activeEvent].youngestGamer.count} Jahren`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $24f8b7b112e438c9$export$2e2bcd8739ae039), {
                                                        width: "20px"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginLeft: '10px'
                                                        },
                                                        variant: "body1",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Gr\xf6\xdfte Aufholjagd:\xa0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "body1",
                                                        children: `${statistics?.eventStatistic[activeEvent].biggestSessionImprovement && getMember(statistics?.eventStatistic[activeEvent].biggestSessionImprovement.memberId)?.firstname} ${statistics?.eventStatistic[activeEvent].youngestGamer && getMember(statistics?.eventStatistic[activeEvent].biggestSessionImprovement.memberId)?.lastname} mit ${statistics?.eventStatistic[activeEvent].biggestSessionImprovement && statistics?.eventStatistic[activeEvent].biggestSessionImprovement.count} Punkten`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c6ba6dadbd9f2ddc$export$2e2bcd8739ae039), {
                                                        width: "20px"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginLeft: '10px'
                                                        },
                                                        variant: "body1",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Gr\xf6\xdfter Abfall nach Runde 1:\xa0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "body1",
                                                        children: `${statistics?.eventStatistic[activeEvent].worstSessionDrop && getMember(statistics?.eventStatistic[activeEvent].worstSessionDrop.memberId)?.firstname} ${statistics?.eventStatistic[activeEvent].worstSessionDrop && getMember(statistics?.eventStatistic[activeEvent].worstSessionDrop.memberId)?.lastname} mit ${statistics?.eventStatistic[activeEvent].worstSessionDrop && statistics?.eventStatistic[activeEvent].worstSessionDrop.count} Punkten`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d42598bf4fdd3eac$export$2e2bcd8739ae039), {
                                                        width: "20px"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginLeft: '10px'
                                                        },
                                                        variant: "body1",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Geringste Abweichung in Runden:\xa0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "body1",
                                                        children: `${statistics?.eventStatistic[activeEvent].mostConsistentPlayer && getMember(statistics?.eventStatistic[activeEvent].mostConsistentPlayer.memberId)?.firstname} ${statistics?.eventStatistic[activeEvent].mostConsistentPlayer && getMember(statistics?.eventStatistic[activeEvent].mostConsistentPlayer.memberId)?.lastname} mit ${statistics?.eventStatistic[activeEvent].mostConsistentPlayer && statistics?.eventStatistic[activeEvent].mostConsistentPlayer.count} Punkten`
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "body1",
                                            children: "F\xfcr dieses Turnier liegen noch keine Statistiken vor."
                                        })
                                    })
                                }),
                                !downMd && events?.results.find((elem)=>elem.id === activeEvent).eventTo.year > 2023 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                variant: "subtitle1",
                                                children: "Spiele"
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a6f287ae9ee8c48c$export$2e2bcd8739ae039), {
                                                    chartData: getGameTypeData(activeEvent),
                                                    height: 100,
                                                    chartOptions: nonStackedOptions
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a6f287ae9ee8c48c$export$2e2bcd8739ae039), {
                                                    chartData: getGamePropertyData(activeEvent),
                                                    height: 100,
                                                    chartOptions: nonStackedOptions
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                            children: activeEvent ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: "F\xfcr dieses Skatturnier liegen noch keine Ergebnisse vor."
                            }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: "Bitte w\xe4hle zun\xe4chst ein Skatturnier aus."
                            })
                        })
                    ]
                }),
                activeTab === "member" && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            sx: {
                                width: '300px',
                                marginBottom: '20px'
                            },
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $71ca7bea65a3d5d9$export$2e2bcd8739ae039), {
                                size: "small",
                                options: getMemberOptions(),
                                label: "Spieler",
                                multiple: false,
                                onChange: (value)=>{
                                    setActiveGamer(value?.key);
                                }
                            })
                        }),
                        activeGamer && statistics?.memberStatistics[activeGamer] ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    xs: downMd ? 12 : 4,
                                    item: true,
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "subtitle1",
                                            children: "Rekorde"
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $21c840b7db424828$export$2e2bcd8739ae039), {
                                                    width: "20px"
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        marginLeft: '10px'
                                                    },
                                                    variant: "body1",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                        children: "Spiele Gesamt:\xa0"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    variant: "body1",
                                                    children: `${statistics?.memberStatistics[activeGamer].totalGameWon + statistics?.memberStatistics[activeGamer].totalGameLoose + statistics?.memberStatistics[activeGamer].totalMixedIn} Spiele`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $48f0e9d81c82a26c$export$2e2bcd8739ae039), {
                                                    width: "20px"
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        marginLeft: '10px'
                                                    },
                                                    variant: "body1",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                        children: "Bestes Spiel:\xa0"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    variant: "body1",
                                                    children: `${statistics?.memberStatistics[activeGamer].bestGame} Punkte`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0fa057fc54c651ae$export$2e2bcd8739ae039), {
                                                    width: "20px"
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        marginLeft: '10px'
                                                    },
                                                    variant: "body1",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                        children: "Schlechtestes Spiel:\xa0"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    variant: "body1",
                                                    children: `${statistics?.memberStatistics[activeGamer].worstGame} Punkte`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $460a58cbb3cf2dc9$export$2e2bcd8739ae039), {
                                                    width: "20px"
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        marginLeft: '10px'
                                                    },
                                                    variant: "body1",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                        children: "Runden Gesamt:\xa0"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    variant: "body1",
                                                    children: `${statistics?.memberStatistics[activeGamer].totalRoundWon + statistics?.memberStatistics[activeGamer].totalRoundLoose} Runden`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8813d52d88ab87a1$export$2e2bcd8739ae039), {
                                                    width: "20px"
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        marginLeft: '10px'
                                                    },
                                                    variant: "body1",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                        children: "Bestes Turnier:\xa0"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    variant: "body1",
                                                    children: `${statistics?.memberStatistics[activeGamer].bestTournament} Punkte`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0a5b63ebd61cd73f$export$2e2bcd8739ae039), {
                                                    width: "20px"
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        marginLeft: '10px'
                                                    },
                                                    variant: "body1",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                        children: "Schechtestes Turnier:\xa0"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    variant: "body1",
                                                    children: `${statistics?.memberStatistics[activeGamer].worstTournament} Punkte`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4c05ca4987693bb3$export$2e2bcd8739ae039), {
                                                    width: "20px"
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        marginLeft: '10px'
                                                    },
                                                    variant: "body1",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                        children: "Turniersiege:\xa0"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    variant: "body1",
                                                    children: `${statistics?.memberStatistics[activeGamer].tournamentsWon} Siege`
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !downMd && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: downMd ? 12 : 8,
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "subtitle1",
                                            children: "Turnierrunden"
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a6f287ae9ee8c48c$export$2e2bcd8739ae039), {
                                            chartData: getMemberRoundData(activeGamer),
                                            height: 100,
                                            chartOptions: stackedOptions
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: downMd ? 12 : 4,
                                    sx: {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        flexWrap: 'wrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "subtitle1",
                                            children: "Gewonnene\xa0/\xa0verlorene\xa0Spiele"
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                maxWidth: '300px'
                                            },
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c537479af6c6f6eb$export$2e2bcd8739ae039), {
                                                chartOptions: pieOptions,
                                                chartData: getMemberWinLooseGameData(activeGamer),
                                                size: 400
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: downMd ? 12 : 4,
                                    sx: {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        flexWrap: 'wrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "subtitle1",
                                            children: "3er / 4er Tische"
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                maxWidth: '300px'
                                            },
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c537479af6c6f6eb$export$2e2bcd8739ae039), {
                                                chartOptions: pieOptions,
                                                chartData: getMemberTableData(activeGamer),
                                                size: 400
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: downMd ? 12 : 4,
                                    sx: {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        flexWrap: 'wrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "subtitle1",
                                            children: "Gewonnene / verlorene Runden"
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            sx: {
                                                maxWidth: '300px'
                                            },
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c537479af6c6f6eb$export$2e2bcd8739ae039), {
                                                chartOptions: pieOptions,
                                                chartData: getMemberWinLooseRoundsData(activeGamer),
                                                size: 400
                                            })
                                        })
                                    ]
                                }),
                                !downMd && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                            variant: "subtitle1",
                                            children: "Gegner"
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a6f287ae9ee8c48c$export$2e2bcd8739ae039), {
                                            chartData: getMemberOpponentData(activeGamer),
                                            height: 100,
                                            chartOptions: stackedOptions
                                        })
                                    ]
                                }),
                                !downMd && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                variant: "body1",
                                                children: "Die folgenden Spielstatistiken beziehen sich ausschlie\xdflich auf Spiele ab dem Jahr 2024, da erst seit diesem Zeitpunkt spezifische Spieldaten erfasst wurden."
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                    variant: "subtitle1",
                                                    children: "Spiele"
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a6f287ae9ee8c48c$export$2e2bcd8739ae039), {
                                                        chartData: getMemberGameTypeData(activeGamer),
                                                        height: 100,
                                                        chartOptions: nonStackedOptions
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a6f287ae9ee8c48c$export$2e2bcd8739ae039), {
                                                        chartData: getMemberGamePropertyData(activeGamer),
                                                        height: 100,
                                                        chartOptions: nonStackedOptions
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                            children: activeGamer ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: "F\xfcr diesen Spieler liegen noch keine Statistiken vor."
                            }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: "Bitte w\xe4hle zun\xe4chst einen Spieler aus."
                            })
                        })
                    ]
                }),
                activeTab === "complete" && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: downMd ? 12 : 6,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "subtitle1",
                                    children: "Ewige Skatliste"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                                    size: "small",
                                    sx: {
                                        width: '100%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        align: "center",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Nr."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Name"
                                                        })
                                                    }),
                                                    !downSm && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        align: "center",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Teilnahmen"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        align: "center",
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Gesamtpunkte"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                                            children: statistics?.eternalList.map((element, index)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            align: "center",
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: index + 1
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                whiteSpace: 'nowrap'
                                                            },
                                                            children: getPlayerName(element.memberId)
                                                        }),
                                                        !downSm && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            align: "center",
                                                            children: element.participations
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            align: "center",
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: element.points
                                                            })
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: downMd ? 12 : 6,
                            container: true,
                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                        variant: "subtitle1",
                                        children: "Rekorde"
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                                        size: "small",
                                        width: "100%",
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $48f0e9d81c82a26c$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Bestes Spiel:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.bestGame.memberId)?.firstname} ${getMember(statistics?.records.bestGame.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.bestGame.count} P.` : `mit ${statistics?.records.bestGame.count} Punkten`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0fa057fc54c651ae$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Schlechtestes Spiel:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.worstGame.memberId)?.firstname} ${getMember(statistics?.records.worstGame.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.worstGame.count} P.` : `mit ${statistics?.records.worstGame.count} Punkten`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6323b6fef031a38a$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "\xc4ltester Spieler:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.oldestGamer.memberId)?.firstname} ${getMember(statistics?.records.oldestGamer.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.oldestGamer.count} J.` : `mit ${statistics?.records.oldestGamer.count} Jahren`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2329768e9950cc40$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "J\xfcngster Spieler:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.youngestGamer.memberId)?.firstname} ${getMember(statistics?.records.youngestGamer.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.youngestGamer.count} J.` : `mit ${statistics?.records.youngestGamer.count} Jahren`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8813d52d88ab87a1$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Bestes Turnier:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.bestTournament.memberId)?.firstname} ${getMember(statistics?.records.bestTournament.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.bestTournament.count} P.` : `mit ${statistics?.records.bestTournament.count} Punkten`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0a5b63ebd61cd73f$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Schechtestes Turnier:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.worstTournament.memberId)?.firstname} ${getMember(statistics?.records.worstTournament.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.worstTournament.count} P.` : `mit ${statistics?.records.worstTournament.count} Punkten`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9c0647079d1d7751$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "\xc4ltester Gewinner:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.oldestWinner.memberId)?.firstname} ${getMember(statistics?.records.oldestWinner.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.oldestWinner.count} J.` : `mit ${statistics?.records.oldestWinner.count} Jahren`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $aa853755a3ed534a$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "J\xfcngster Gewinner:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.youngestWinner.memberId)?.firstname} ${getMember(statistics?.records.youngestWinner.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.youngestWinner.count} J.` : `mit ${statistics?.records.youngestWinner.count} Jahren`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $50991c90d6bad792$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Bester Neueinstieg:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.bestNewcomer.memberId)?.firstname} ${getMember(statistics?.records.bestNewcomer.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.bestNewcomer.count} P.` : `mit ${statistics?.records.bestNewcomer.count} Punkten`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4c05ca4987693bb3$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Meisten Turniersiege:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.mostTournamentsWon.memberId)?.firstname} ${getMember(statistics?.records.mostTournamentsWon.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.mostTournamentsWon.count} S.` : `mit ${statistics?.records.mostTournamentsWon.count} Siegen`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3e5eaf6bd9d17d25$exports))), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "L\xe4ngste Siegesserie:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.highestWinStreak.memberId)?.firstname} ${getMember(statistics?.records.highestWinStreak.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.highestWinStreak.count} S.` : `mit ${statistics?.records.highestWinStreak.count} Spielen in Folge`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a95e06d175b0c813$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "L\xe4ngste Verlustserie:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.longestLosingStreak.memberId)?.firstname} ${getMember(statistics?.records.longestLosingStreak.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.longestLosingStreak.count} S.` : `mit ${statistics?.records.longestLosingStreak.count} verlorenen Spielen in Folge`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $866057e28c6b69af$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Meiste gew. Handspiele:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.mostHandGamesWon.memberId)?.firstname} ${getMember(statistics?.records.mostHandGamesWon.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.mostHandGamesWon.count} S.` : `mit ${statistics?.records.mostHandGamesWon.count} gewonnenen Handspielen`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6ece8f7499eb03b4$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Meiste gew. Grands:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.mostGrandGamesWon.memberId)?.firstname} ${getMember(statistics?.records.mostGrandGamesWon.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.mostGrandGamesWon.count} S.` : `mit ${statistics?.records.mostGrandGamesWon.count} gewonnenen Grands`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0b44e5ed9ed13343$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "H\xf6chste Rundenpunktzahl:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.highestSingleSession.memberId)?.firstname} ${getMember(statistics?.records.highestSingleSession.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.highestSingleSession.count} P.` : `mit ${statistics?.records.highestSingleSession.count} Punkten`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $589fe4a12c48f182$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Meiste Turniersiege in Folge:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.mostConsecutiveTournamentWins.memberId)?.firstname} ${getMember(statistics?.records.mostConsecutiveTournamentWins.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.mostConsecutiveTournamentWins.count} S.` : `mit ${statistics?.records.mostConsecutiveTournamentWins.count} Siegen in Folge`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $346028208af2d3ae$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "H\xe4ufigster zweiter Platz:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.mostSecondPlaces.memberId)?.firstname} ${getMember(statistics?.records.mostSecondPlaces.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.mostSecondPlaces.count}` : `mit ${statistics?.records.mostSecondPlaces.count} Zweit-Platzierungen`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $188209d9e3cafca9$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Am h\xe4ufigsten in den Top 3:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.mostTopThree.memberId)?.firstname} ${getMember(statistics?.records.mostTopThree.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.mostTopThree.count}` : `mit ${statistics?.records.mostTopThree.count} Top-3-Platzierungen`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $24f8b7b112e438c9$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Gr\xf6\xdfte Aufholjagd:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.biggestComeback.memberId)?.firstname} ${getMember(statistics?.records.biggestComeback.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.biggestComeback.count} P.` : `mit ${statistics?.records.biggestComeback.count} Punkten`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $08cdd09982b4fa40$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Gr\xf6\xdfter Vorsprung nach Runde 1:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.biggestLead.memberId)?.firstname} ${getMember(statistics?.records.biggestLead.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.biggestLead.count} P.` : `mit ${statistics?.records.biggestLead.count} Punkten`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $dd6452324580a904$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Bestes perfektes Turnier:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.perfectTournament.memberId)?.firstname} ${getMember(statistics?.records.perfectTournament.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.perfectTournament.count} P.` : `mit ${statistics?.records.perfectTournament.count} Punkten`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9d3689ac2dc83151$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Gr\xf6\xdfte Verbesserung zw. 2 Turnieren:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.mostImprovedPlayer.memberId)?.firstname} ${getMember(statistics?.records.mostImprovedPlayer.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.mostImprovedPlayer.count} P.` : `mit ${statistics?.records.mostImprovedPlayer.count} Punkten Unterschied`}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d42598bf4fdd3eac$export$2e2bcd8739ae039), {
                                                                width: "20px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                                children: "Geringste Abweichung in den Platzierungen:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            className: classes.cell,
                                                            children: `${getMember(statistics?.records.mostConsistentPlayer.memberId)?.firstname} ${getMember(statistics?.records.mostConsistentPlayer.memberId)?.lastname.charAt(0).toUpperCase()}. ${downSm ? ` ${statistics?.records.mostConsistentPlayer.count} P.` : `mit ${statistics?.records.mostConsistentPlayer.count} Pl\xe4tzen Unterschied`}`
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "subtitle1",
                                    children: "Siege"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                                    size: "small",
                                    width: "100%",
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                                        children: stars && stars.sort((a, b)=>b.count - a.count).map((elem, index)=>{
                                            const member = getMember(elem.memberId);
                                            return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.cell,
                                                        children: `${member?.firstname} ${member?.lastname.charAt(0).toUpperCase()}.`
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.cell,
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                alignItems: 'center'
                                                            },
                                                            children: Array.from({
                                                                length: elem.count
                                                            }, (_, i)=>{
                                                                // Einheitliche Farbe für bessere Optik bei maximal 5 Sternen
                                                                const baseColor = theme.palette.primary.main // Gold für alle Sterne
                                                                ;
                                                                return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        position: 'relative',
                                                                        marginRight: '6px',
                                                                        transition: 'transform 0.2s ease',
                                                                        '&:hover': {
                                                                            transform: 'rotate(10deg)'
                                                                        }
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba0aafeac57dbd7b$exports))), {
                                                                            sx: {
                                                                                color: baseColor,
                                                                                fontSize: '1.4rem',
                                                                                filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.2))'
                                                                            }
                                                                        }),
                                                                        i === 0 && elem.count >= 3 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                position: 'absolute',
                                                                                top: '15%',
                                                                                left: '15%',
                                                                                width: '30%',
                                                                                height: '30%',
                                                                                borderRadius: '50%',
                                                                                background: 'white',
                                                                                opacity: 0.5
                                                                            }
                                                                        })
                                                                    ]
                                                                }, i);
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, elem.memberId);
                                        })
                                    })
                                })
                            ]
                        }),
                        !downMd && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "subtitle1",
                                    children: "Turnierteilnahmen"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a6f287ae9ee8c48c$export$2e2bcd8739ae039), {
                                    chartData: getParticipationData(),
                                    height: 100,
                                    chartOptions: stackedOptions
                                })
                            ]
                        }),
                        !downMd && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "subtitle1",
                                    children: "Wer gegen wen?"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                                    size: "small",
                                    sx: {
                                        marginTop: '100px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e688dee05635481c$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {}),
                                                    statistics?.memberOpponents.map((member, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                position: 'relative',
                                                                overflow: 'visible'
                                                            },
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                sx: {
                                                                    transform: 'rotate(-90deg)',
                                                                    position: 'absolute',
                                                                    bottom: 60,
                                                                    left: -40,
                                                                    width: 200,
                                                                    height: 100
                                                                },
                                                                children: `${getMember(member.memberId)?.firstname} ${getMember(member.memberId)?.lastname}`
                                                            })
                                                        }, index))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                                            children: statistics?.memberOpponents.map((member, memberIndex)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        // Jede zweite Zeile einfärben
                                                        '&:nth-of-type(even)': {
                                                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                            children: `${getMember(member.memberId)?.firstname} ${getMember(member.memberId)?.lastname}`
                                                        }),
                                                        statistics?.memberOpponents.map((element, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                                align: "center",
                                                                sx: {
                                                                    position: 'relative',
                                                                    overflow: 'visible',
                                                                    bgcolor: 'background.paper',
                                                                    // Jede zweite Spalte einfärben
                                                                    '&:nth-of-type(even)': {
                                                                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                                                    }
                                                                },
                                                                children: index === memberIndex ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                    variant: "body1"
                                                                }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
                                                                    children: (()=>{
                                                                        const value = element.opponents[statistics?.memberOpponents[memberIndex].memberId] || 0;
                                                                        // Styling basierend auf Wert
                                                                        let color = theme.palette.primary.light;
                                                                        let fontWeight = 'normal';
                                                                        let fontSize = '1em';
                                                                        // Korrigierte Abstufung der Farben und Styles
                                                                        if (value === 1) {
                                                                            color = theme.palette.primary.light;
                                                                            fontWeight = 'normal';
                                                                        } else if (value === 2) {
                                                                            color = theme.palette.primary.main;
                                                                            fontWeight = 'medium';
                                                                        } else if (value === 3) {
                                                                            color = theme.palette.primary.dark;
                                                                            fontWeight = 'bold';
                                                                        } else if (value === 4) {
                                                                            color = theme.palette.primary[700];
                                                                            fontWeight = 'bold';
                                                                            fontSize = '1.1em';
                                                                        } else if (value >= 5) {
                                                                            color = theme.palette.primary[900];
                                                                            fontWeight = 'bold';
                                                                            fontSize = '1.2em';
                                                                        }
                                                                        return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                color: color,
                                                                                fontWeight: fontWeight,
                                                                                fontSize: fontSize,
                                                                                ...value >= 4 && {
                                                                                    backgroundColor: `${theme.palette.primary.light}30`,
                                                                                    borderRadius: '4px',
                                                                                    padding: '2px 4px'
                                                                                },
                                                                                transition: 'all 0.2s ease-in-out',
                                                                                '&:hover': {
                                                                                    transform: value >= 3 ? 'scale(1.15)' : 'none',
                                                                                    cursor: value >= 3 ? 'pointer' : 'default'
                                                                                }
                                                                            },
                                                                            children: value
                                                                        });
                                                                    })()
                                                                })
                                                            }, index))
                                                    ]
                                                }, memberIndex))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: "Die folgenden Spielstatistiken beziehen sich ausschlie\xdflich auf Spiele ab dem Jahr 2024, da erst seit diesem Zeitpunkt spezifische Spieldaten erfasst wurden."
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: downMd ? 12 : 6,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "subtitle1",
                                    children: "Gewonnene\xa0/\xa0verlorene\xa0Spiele"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        maxWidth: '300px'
                                    },
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c537479af6c6f6eb$export$2e2bcd8739ae039), {
                                        chartOptions: pieOptions,
                                        chartData: getCompleteWinLooseGameData(),
                                        size: 400
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: downMd ? 12 : 6,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "subtitle1",
                                    children: "Spiele gesamt"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e490cf7770112412$export$2e2bcd8739ae039), {
                                    size: "small",
                                    width: "100%",
                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $9cd8fb6cfe32623d$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.cell,
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $21c840b7db424828$export$2e2bcd8739ae039), {
                                                            width: "20px"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.cell,
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Anzahl Spiele gesamt:"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.cell,
                                                        align: "right",
                                                        children: statistics.globalGameStatistics.totalGames
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.cell,
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $21c840b7db424828$export$2e2bcd8739ae039), {
                                                            width: "20px"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.cell,
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Anzahl Punkte gesamt:"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.cell,
                                                        align: "right",
                                                        children: statistics.globalGameStatistics.totalValue
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1a28739087e1cb55$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.cell,
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $21c840b7db424828$export$2e2bcd8739ae039), {
                                                            width: "20px"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.cell,
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                                            children: "Durchschnittliche Punktzahl:"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c13abfcb1085f546$export$2e2bcd8739ae039), {
                                                        className: classes.cell,
                                                        align: "right",
                                                        children: Math.round(statistics.globalGameStatistics.averageValue)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        !downMd && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                    variant: "subtitle1",
                                    children: "Spiele"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a6f287ae9ee8c48c$export$2e2bcd8739ae039), {
                                        chartData: getGameTypeData(),
                                        height: 100,
                                        chartOptions: nonStackedOptions
                                    })
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a6f287ae9ee8c48c$export$2e2bcd8739ae039), {
                                        chartData: getGamePropertyData(),
                                        height: 100,
                                        chartOptions: nonStackedOptions
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f17f03f9390e11c7$export$2e2bcd8739ae039), {})
        })
    });
};
var $eec6a47b73d638da$export$2e2bcd8739ae039 = $eec6a47b73d638da$var$Statistics;



// eslint-disable-next-line no-unused-vars

var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");

var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");

var $g4LX8 = parcelRequire("g4LX8");


var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $457f55eeb7136afd$export$69aecd24bc2cf7e3(slot) {
    return (0, $6AMoU.default)('MuiAlert', slot);
}
const $457f55eeb7136afd$var$alertClasses = (0, $ithJf.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $457f55eeb7136afd$export$2e2bcd8739ae039 = $457f55eeb7136afd$var$alertClasses;



parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $79d33ee6be1d0005$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $3a6f61c3cdae3ba2$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $31c91960d4e527f5$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("3OyDL");

var $agWwT = parcelRequire("agWwT");

var $2M70Q = parcelRequire("2M70Q");
'use client';
var $ef0964d85c4d83a3$export$2e2bcd8739ae039 = (0, $agWwT.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');




var $2M70Q = parcelRequire("2M70Q");
'use client';
const $1ebb3611e7b79eca$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $1ebb3611e7b79eca$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${variant}${(0, $g4LX8.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $457f55eeb7136afd$export$69aecd24bc2cf7e3), classes);
};
const $1ebb3611e7b79eca$var$AlertRoot = (0, $jH1k7.default)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $g4LX8.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $7m2iU.darken) : (0, $7m2iU.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $7m2iU.lighten) : (0, $7m2iU.darken);
    const color = ownerState.color || ownerState.severity;
    return (0, $gOPoC.default)({}, theme.typography.body2, {
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px'
    }, color && ownerState.variant === 'standard' && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
        [`& .${(0, $457f55eeb7136afd$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === 'outlined' && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
        [`& .${(0, $457f55eeb7136afd$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === 'filled' && (0, $gOPoC.default)({
        fontWeight: theme.typography.fontWeightMedium
    }, theme.vars ? {
        color: theme.vars.palette.Alert[`${color}FilledColor`],
        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
    } : {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
        color: theme.palette.getContrastText(theme.palette[color].main)
    }));
});
const $1ebb3611e7b79eca$var$AlertIcon = (0, $jH1k7.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $1ebb3611e7b79eca$var$AlertMessage = (0, $jH1k7.default)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $1ebb3611e7b79eca$var$AlertAction = (0, $jH1k7.default)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $1ebb3611e7b79eca$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $79d33ee6be1d0005$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3a6f61c3cdae3ba2$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $31c91960d4e527f5$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ef0964d85c4d83a3$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $1ebb3611e7b79eca$var$Alert = /*#__PURE__*/ $3OyDL.forwardRef(function Alert(inProps, ref) {
    var _ref, _slots$closeButton, _ref2, _slots$closeIcon, _slotProps$closeButto, _slotProps$closeIcon;
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $1ebb3611e7b79eca$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard' } = props, other = (0, $aBenZ.default)(props, $1ebb3611e7b79eca$var$_excluded);
    const ownerState = (0, $gOPoC.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant
    });
    const classes = $1ebb3611e7b79eca$var$useUtilityClasses(ownerState);
    const AlertCloseButton = (_ref = (_slots$closeButton = slots.closeButton) != null ? _slots$closeButton : components.CloseButton) != null ? _ref : (0, $90c0807a34b52605$export$2e2bcd8739ae039);
    const AlertCloseIcon = (_ref2 = (_slots$closeIcon = slots.closeIcon) != null ? _slots$closeIcon : components.CloseIcon) != null ? _ref2 : (0, $ffbce2540bf8a072$export$2e2bcd8739ae039);
    const closeButtonProps = (_slotProps$closeButto = slotProps.closeButton) != null ? _slotProps$closeButto : componentsProps.closeButton;
    const closeIconProps = (_slotProps$closeIcon = slotProps.closeIcon) != null ? _slotProps$closeIcon : componentsProps.closeIcon;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($1ebb3611e7b79eca$var$AlertRoot, (0, $gOPoC.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $3DmQB.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $2M70Q.jsx)($1ebb3611e7b79eca$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $1ebb3611e7b79eca$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $2M70Q.jsx)($1ebb3611e7b79eca$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $2M70Q.jsx)($1ebb3611e7b79eca$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $2M70Q.jsx)($1ebb3611e7b79eca$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $2M70Q.jsx)(AlertCloseButton, (0, $gOPoC.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)(AlertCloseIcon, (0, $gOPoC.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $1ebb3611e7b79eca$export$2e2bcd8739ae039 = $1ebb3611e7b79eca$var$Alert;


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $5jsOu = parcelRequire("5jsOu");

var $3OyDL = parcelRequire("3OyDL");



var $2M70Q = parcelRequire("2M70Q");
'use client';
function $c7cabeaa6f4229ee$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $c7cabeaa6f4229ee$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base-ui/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base-ui/react-click-away-listener/components-api/#click-away-listener)
 */ function $c7cabeaa6f4229ee$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $3OyDL.useRef(false);
    const nodeRef = $3OyDL.useRef(null);
    const activatedRef = $3OyDL.useRef(false);
    const syntheticEventRef = $3OyDL.useRef(false);
    $3OyDL.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $c9f4324d1af2c9eb$export$2e2bcd8739ae039)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $fc6260e66a3c9db4$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $35fb2c86e44ba0e8$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $c7cabeaa6f4229ee$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $3OyDL.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $c7cabeaa6f4229ee$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $35fb2c86e44ba0e8$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $3OyDL.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $c7cabeaa6f4229ee$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $35fb2c86e44ba0e8$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($3OyDL.Fragment, {
        children: /*#__PURE__*/ $3OyDL.cloneElement(children, childrenProps)
    });
}



var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


'use client';
function $325f024906b0197c$export$1c97ac2c9a6e7c09(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = $3OyDL.useRef();
    $3OyDL.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $fc6260e66a3c9db4$export$2e2bcd8739ae039)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $fc6260e66a3c9db4$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(()=>{
            handleClose(null, 'timeout');
        }, autoHideDurationParam);
    });
    $3OyDL.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return ()=>{
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = ()=>{
        clearTimeout(timerAutoHide.current);
    };
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $3OyDL.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $3OyDL.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $gOPoC.default)({}, (0, $490c663e21a90948$export$24d5698b57eff81c)(parameters), (0, $490c663e21a90948$export$24d5698b57eff81c)(externalProps));
        return (0, $gOPoC.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation'
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}



var $jH1k7 = parcelRequire("jH1k7");


var $jFgmT = parcelRequire("jFgmT");

var $g4LX8 = parcelRequire("g4LX8");


var $aBenZ = parcelRequire("aBenZ");

var $gOPoC = parcelRequire("gOPoC");

var $3OyDL = parcelRequire("3OyDL");


var $3DmQB = parcelRequire("3DmQB");

var $5jsOu = parcelRequire("5jsOu");

var $7m2iU = parcelRequire("7m2iU");

var $jH1k7 = parcelRequire("jH1k7");

var $jFgmT = parcelRequire("jFgmT");


var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $6292390fc6d1c421$export$def81488db1a3216(slot) {
    return (0, $6AMoU.default)('MuiSnackbarContent', slot);
}
const $6292390fc6d1c421$var$snackbarContentClasses = (0, $ithJf.default)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $6292390fc6d1c421$export$2e2bcd8739ae039 = $6292390fc6d1c421$var$snackbarContentClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $d6b4deb65fc56e31$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $d6b4deb65fc56e31$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $6292390fc6d1c421$export$def81488db1a3216), classes);
};
const $d6b4deb65fc56e31$var$SnackbarContentRoot = (0, $jH1k7.default)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
    name: 'MuiSnackbarContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    const backgroundColor = (0, $7m2iU.emphasize)(theme.palette.background.default, emphasis);
    return (0, $gOPoC.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    });
});
const $d6b4deb65fc56e31$var$SnackbarContentMessage = (0, $jH1k7.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0'
});
const $d6b4deb65fc56e31$var$SnackbarContentAction = (0, $jH1k7.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $d6b4deb65fc56e31$var$SnackbarContent = /*#__PURE__*/ $3OyDL.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert' } = props, other = (0, $aBenZ.default)(props, $d6b4deb65fc56e31$var$_excluded);
    const ownerState = props;
    const classes = $d6b4deb65fc56e31$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($d6b4deb65fc56e31$var$SnackbarContentRoot, (0, $gOPoC.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $3DmQB.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)($d6b4deb65fc56e31$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $2M70Q.jsx)($d6b4deb65fc56e31$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $d6b4deb65fc56e31$export$2e2bcd8739ae039 = $d6b4deb65fc56e31$var$SnackbarContent;



var $ithJf = parcelRequire("ithJf");

var $6AMoU = parcelRequire("6AMoU");
function $d1a986e01a27bb1c$export$6cb096457f5926f4(slot) {
    return (0, $6AMoU.default)('MuiSnackbar', slot);
}
const $d1a986e01a27bb1c$var$snackbarClasses = (0, $ithJf.default)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $d1a986e01a27bb1c$export$2e2bcd8739ae039 = $d1a986e01a27bb1c$var$snackbarClasses;



var $2M70Q = parcelRequire("2M70Q");
'use client';
const $84fa13e068ebc6f7$var$_excluded = [
    "onEnter",
    "onExited"
], $84fa13e068ebc6f7$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $84fa13e068ebc6f7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $g4LX8.default)(anchorOrigin.vertical)}${(0, $g4LX8.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $5jsOu.default)(slots, (0, $d1a986e01a27bb1c$export$6cb096457f5926f4), classes);
};
const $84fa13e068ebc6f7$var$SnackbarRoot = (0, $jH1k7.default)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $g4LX8.default)(ownerState.anchorOrigin.vertical)}${(0, $g4LX8.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)'
    };
    return (0, $gOPoC.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.anchorOrigin.vertical === 'top' ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === 'left' && {
        justifyContent: 'flex-start'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
        justifyContent: 'flex-end'
    }, {
        [theme.breakpoints.up('sm')]: (0, $gOPoC.default)({}, ownerState.anchorOrigin.vertical === 'top' ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
            left: 24,
            right: 'auto'
        }, ownerState.anchorOrigin.horizontal === 'right' && {
            right: 24,
            left: 'auto'
        })
    });
});
const $84fa13e068ebc6f7$var$Snackbar = /*#__PURE__*/ $3OyDL.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $jFgmT.default)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $a144ebfc440ec800$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $aBenZ.default)(props.TransitionProps, $84fa13e068ebc6f7$var$_excluded), other = (0, $aBenZ.default)(props, $84fa13e068ebc6f7$var$_excluded2);
    const ownerState = (0, $gOPoC.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $84fa13e068ebc6f7$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $325f024906b0197c$export$1c97ac2c9a6e7c09)((0, $gOPoC.default)({}, ownerState));
    const [exited, setExited] = $3OyDL.useState(true);
    const rootProps = (0, $9be467578d9a8fea$export$1e5c9e6e4e15efe3)({
        elementType: $84fa13e068ebc6f7$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c7cabeaa6f4229ee$export$58385c17fee43f89), (0, $gOPoC.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($84fa13e068ebc6f7$var$SnackbarRoot, (0, $gOPoC.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $2M70Q.jsx)(TransitionComponent, (0, $gOPoC.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === 'top' ? 'down' : 'up',
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d6b4deb65fc56e31$export$2e2bcd8739ae039), (0, $gOPoC.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $84fa13e068ebc6f7$export$2e2bcd8739ae039 = $84fa13e068ebc6f7$var$Snackbar;





const $e0c639b53d4cb03b$var$SnackbarComponent = ()=>{
    const storedMessage = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$2e51780da3c3a61));
    const defaultHideDuration = 3;
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const [message, setMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState();
    const [hideDuration, setHideDuration] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(defaultHideDuration);
    const handleClose = ()=>{
        setOpen(false);
    };
    (0, $3OyDL.useEffect)(()=>{
        if (storedMessage) {
            setMessage(storedMessage);
            setOpen(true);
            setHideDuration(message && message.severity === (0, $c7fa01100a96d1f7$export$918a9776c0a3cf27).error ? null : defaultHideDuration);
        }
    }, [
        storedMessage
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $84fa13e068ebc6f7$export$2e2bcd8739ae039), {
        open: open,
        autoHideDuration: hideDuration,
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1ebb3611e7b79eca$export$2e2bcd8739ae039), {
            variant: "filled",
            onClose: handleClose,
            severity: message && message.severity,
            sx: {
                width: '100%'
            },
            children: message && message.message
        })
    });
};
var $e0c639b53d4cb03b$export$2e2bcd8739ae039 = $e0c639b53d4cb03b$var$SnackbarComponent;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");











var $248cf301019c705e$export$3d7f2c5ba42a2a8a = /*#__PURE__*/ function(MainSource) {
    MainSource["member"] = "member";
    MainSource["event"] = "event";
    MainSource["relation"] = "relation";
    MainSource["ottoMeissner"] = "ottoMeissner";
    MainSource["leipzig"] = "leipzig";
    MainSource["niederstaucha"] = "niederstaucha";
    return MainSource;
}({});
const $248cf301019c705e$var$useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
        link: {
            cursor: 'pointer',
            color: theme.palette.secondary.dark
        }
    }));
const $248cf301019c705e$var$SearchResults = ()=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const history = (0, $4e1a33337564f167$export$3420e1dc2c4a518c)();
    const classes = $248cf301019c705e$var$useStyles();
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const darkMode = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$3813fceac631a2fa));
    const searchResult = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$2fa22ca814667ff4));
    const members = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$f4931e6f9feb30c5));
    const events = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$3f41ece7d7128238));
    const eventMembers = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$a1da1323b0778446));
    const locations = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$503e5e11c8cc005e));
    const relations = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$b8e54fb0b8f14b48));
    const [data, setData] = (0, $3OyDL.useState)();
    const [regEx, setRegEx] = (0, $3OyDL.useState)([]);
    const memberTermArray = [
        'city',
        'zip',
        'lastname',
        'firstname',
        'address',
        'birthname',
        'country',
        'dietType',
        'email',
        'gender',
        'middlenames',
        'nickname',
        'gender',
        'phone',
        'placeOfBirth',
        'placeOfDeath',
        'title'
    ];
    const eventTermArray = [
        'title',
        'signature'
    ];
    (0, $3OyDL.useEffect)(()=>{
        const searchResultArray = searchResult?.split(' ');
        const regExArray = [];
        searchResultArray?.map((elem)=>{
            elem && regExArray.push(new RegExp(elem.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss'), 'gim'));
        });
        setRegEx(regExArray);
        const temp = {};
        if (regExArray.length > 0) {
            regExArray.map((regEx, index)=>{
                temp[index] = [];
                // member
                members?.results.map((member)=>{
                    memberTermArray.map((term)=>{
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        if (member[term] && member[term]?.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1) {
                            if (!temp[index].find((elem)=>elem.element === member.id && elem.mainSource === "member")) temp[index].push({
                                mainSource: "member",
                                element: member.id
                            });
                        }
                    });
                });
                // events
                events?.results.map((event)=>{
                    eventTermArray.map((term)=>{
                        const location = locations?.results.find((loc)=>loc.id === event.locationId);
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        if (event[term] && event[term]?.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1 || event.from?.year && event.from.year.toString().search(regEx) > -1 || location?.caption && location?.caption?.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1 || location?.name && location?.name?.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1 || location?.linkUrl && location?.linkUrl?.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1) {
                            if (!temp[index].find((elem)=>elem.element === event.id && elem.mainSource === "event")) temp[index].push({
                                mainSource: "event",
                                element: event.id
                            });
                        }
                    });
                });
                // eventMember
                eventMembers?.results.map((eventMember)=>{
                    const member = members?.results.find((mem)=>mem.id === eventMember.memberId);
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    if (member?.firstname && member?.firstname?.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1 || member?.lastname && member?.lastname?.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1) {
                        if (!temp[index].find((elem)=>elem.element === eventMember.eventId && elem.mainSource === "event")) temp[index].push({
                            mainSource: "event",
                            element: eventMember.eventId
                        });
                    }
                });
                // relations
                relations?.results.map((relation)=>{
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    if (relation?.id && relation.id.search(regEx) > -1 || relation.parents.find((parent)=>parent.id.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1) || relation.siblings.find((sibling)=>sibling.id.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1) || relation.spouses.find((spouse)=>spouse.id.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1) || relation.children.find((child)=>child.id.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx) > -1)) {
                        if (!temp[index].find((elem)=>elem.element === relation.id && elem.mainSource === "relation")) temp[index].push({
                            mainSource: "relation",
                            element: relation.id
                        });
                    }
                });
                const biographyOttoMeissner = (0, $d110d5d3929fb6a5$export$2e2bcd8739ae039)('ottoMeissner');
                biographyOttoMeissner.map((cap, id)=>{
                    if (cap.description && cap.description.search(regEx) > -1 || cap.title.search(regEx) > -1) temp[index].push({
                        mainSource: "ottoMeissner",
                        element: id
                    });
                });
                const geographyLeipzig = (0, $00ae4bfadb56f2f5$export$2e2bcd8739ae039)('leipzig');
                geographyLeipzig.map((cap, id)=>{
                    if (cap && cap.search(regEx) > -1) temp[index].push({
                        mainSource: "leipzig",
                        element: id
                    });
                });
                const geographyNiederstaucha = (0, $00ae4bfadb56f2f5$export$2e2bcd8739ae039)('niederstaucha');
                geographyNiederstaucha.map((cap, id)=>{
                    if (cap && cap.search(regEx) > -1) temp[index].push({
                        mainSource: "niederstaucha",
                        element: id
                    });
                });
            });
            // AND Verknüfung aller Suchergebnisse
            temp[0].map((element, index)=>{
                for(let n = 1; n < Object.keys(temp).length; n += 1)if (!temp[n].find((reference)=>JSON.stringify(reference) === JSON.stringify(element))) delete temp[0][index];
            });
            const searchObject = {
                event: [],
                member: [],
                relation: [],
                fullText: []
            };
            temp[0].map((acceptedResult)=>{
                if (acceptedResult.mainSource === "member") {
                    const el = members?.results.find((elem)=>elem.id === acceptedResult.element);
                    el && searchObject.member.push(el);
                }
                if (acceptedResult.mainSource === "event") {
                    const el = events?.results.find((elem)=>elem.id === acceptedResult.element);
                    el && searchObject.event.push(el);
                }
                if (acceptedResult.mainSource === "relation") {
                    const el = relations?.results.find((elem)=>elem.id === acceptedResult.element);
                    el && searchObject.relation.push(el);
                }
                if (acceptedResult.mainSource === "ottoMeissner") searchObject.fullText.push(acceptedResult);
                if (acceptedResult.mainSource === "leipzig") searchObject.fullText.push(acceptedResult);
                if (acceptedResult.mainSource === "niederstaucha") searchObject.fullText.push(acceptedResult);
            });
            setData(searchObject);
        }
    }, [
        searchResult
    ]);
    const cleanText = (rawText)=>{
        const cleanedText = rawText.replace('<br />', '');
        const index = cleanedText.search(regEx[0]);
        const from = index < 100 ? 0 : index - 100;
        const to = index + 100 > cleanedText.length ? cleanedText.length : index + 100;
        const cap = cleanedText.slice(from, to);
        const newSearchtermArray = cap.split(' ');
        let newOutput = '';
        const highlightColor = darkMode ? theme.palette.primary.dark : theme.palette.primary.light;
        newSearchtermArray.map((element)=>{
            if (element.replace("\xe4", 'ae').replace("\xc4", 'Ae').replace("\xf6", 'oe').replace("\xd6", 'Oe').replace("\xfc", 'ue').replace("\xdc", 'Ue').replace("\xdf", 'ss').search(regEx[0]) > -1) newOutput += `<span style="background-color: ${highlightColor}; color: #000000;">${element}</span> `;
            else newOutput += `${element} `;
        });
        return `...${newOutput}...`;
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: searchResult ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    variant: "h1",
                    children: [
                        '"',
                        searchResult,
                        '"'
                    ]
                }),
                data?.fullText && data.fullText.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    variant: "h2",
                    children: "Suchergebnisse"
                }),
                data?.fullText.map((text)=>{
                    if (text.mainSource === "leipzig") return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        className: classes.link,
                        onClick: ()=>{
                            dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
                                'family',
                                'leipzig'
                            ]));
                            history.replace('/family/leipzig');
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            dangerouslySetInnerHTML: {
                                __html: `${(0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize(cleanText((0, $00ae4bfadb56f2f5$export$2e2bcd8739ae039)('leipzig')[text.element]))}`
                            }
                        })
                    });
                    if (text.mainSource === "niederstaucha") return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        className: classes.link,
                        onClick: ()=>{
                            dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
                                'family',
                                'niederstaucha'
                            ]));
                            history.replace('/family/niederstaucha');
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            dangerouslySetInnerHTML: {
                                __html: `${(0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize(cleanText((0, $00ae4bfadb56f2f5$export$2e2bcd8739ae039)('niederstaucha')[text.element]))}`
                            }
                        })
                    });
                    if (text.mainSource === "ottoMeissner") return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        className: classes.link,
                        onClick: ()=>{
                            dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
                                'family',
                                'ottoMeissner'
                            ]));
                            history.replace('/family/ottoMeissner');
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            dangerouslySetInnerHTML: {
                                __html: `${(0, (/*@__PURE__*/$parcel$interopDefault($3b290aa680817c09$exports))).sanitize(cleanText((0, $d110d5d3929fb6a5$export$2e2bcd8739ae039)('ottoMeissner')[text.element].description))}`
                            }
                        })
                    });
                }),
                data?.member && data?.member.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    variant: "h2",
                    children: "Familienmitglieder"
                }),
                data?.member.map((mem)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        className: classes.link,
                        onClick: ()=>{
                            dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
                                'familyMember'
                            ]));
                            history.replace('/familyMember/table');
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            variant: "body1",
                            children: `${mem.firstname} ${mem.middlenames ? mem.middlenames : ''} ${mem.lastname} ${(0, $32481be2fe498df5$export$2e2bcd8739ae039)(mem.birthday)}${mem.deathday.year ? ` - ${(0, $32481be2fe498df5$export$2e2bcd8739ae039)(mem.deathday)}` : ''}`
                        })
                    }, mem.id)),
                data?.relation && data?.relation.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    variant: "h2",
                    children: "Nahe Verwandte"
                }),
                data?.relation.map((rel, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                        children: `${members?.results.find((elem)=>elem.id === rel.id)?.firstname} ${members?.results.find((elem)=>elem.id === rel.id)?.lastname}`
                    }, index)),
                data?.event && data?.event.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    variant: "h2",
                    children: "Skatturniere"
                }),
                data?.event.map((ev)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                        className: classes.link,
                        onClick: ()=>{
                            dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
                                'events'
                            ]));
                            history.replace('/events');
                        },
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                            children: events?.results.find((elem)=>elem.id === ev.id)?.title
                        })
                    }, ev.id))
            ]
        }) : /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    variant: "h2",
                    children: "Keine Suchergebnisse"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    variant: "body1",
                    children: "Bitte trage zun\xe4chst etwas in die Suchmaske oben links ein. Wir versuchen dann alle relevanten Ergebnisse anzuzeigen. Neben Texten kann man hier die Daten der Familienmitglieder, ihrer Angeh\xf6rigen, sowie alle Skatturiere durchsuchen."
                })
            ]
        })
    });
};
var $248cf301019c705e$export$2e2bcd8739ae039 = $248cf301019c705e$var$SearchResults;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");


var $991ed477abe22d2b$exports = {};
"use strict";
"use client";

Object.defineProperty($991ed477abe22d2b$exports, "__esModule", {
    value: true
});
$991ed477abe22d2b$exports.default = void 0;

var $991ed477abe22d2b$var$_createSvgIcon = $4cb0592c905e8c88$exports((parcelRequire("5Vniy")));

var $2M70Q = parcelRequire("2M70Q");
var $991ed477abe22d2b$var$_default = (0, $991ed477abe22d2b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2M70Q.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');
$991ed477abe22d2b$exports.default = $991ed477abe22d2b$var$_default;



















const $e351b7790ffa46ab$var$LocationComponent = ()=>{
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const downMd = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('md'));
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const basePath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
    const fetchHeaders = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).fetchHeaders;
    (0, $58718165e7ed8d4a$export$bacd26fe3052ded6)(fetchHeaders);
    const eventLocations = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $ce5483b24fb77199$export$503e5e11c8cc005e));
    const [showLocationDialog, setShowLocationDialog] = (0, $3OyDL.useState)(false);
    const [showLocationDeleteRequestDialog, setShowLocationDeleteRequestDialog] = (0, $3OyDL.useState)(false);
    const [position, setPosition] = (0, $3OyDL.useState)(new (0, $ad5a22b7e45eeb01$exports.LatLng)(51.0834196, 10.4234469));
    const [selectedLocation, setSelectedLocation] = (0, $3OyDL.useState)();
    const [newLocation, setNewLocation] = (0, $3OyDL.useState)();
    const [deleteLocation, setDeleteLocation] = (0, $3OyDL.useState)();
    const useStyles = (0, $1527019e4f1136b9$export$2e2bcd8739ae039)((theme)=>({
            locationContainer: {
                display: 'flex',
                width: '100%',
                flexWrap: 'wrap',
                justifyContent: 'flex-start',
                alignItems: 'flex-start'
            },
            locationBox: {
                margin: '10px',
                width: '200px',
                height: '200px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                filter: 'grayscale(100%)',
                '&:hover': {
                    filter: 'grayscale(0%)'
                }
            },
            newLocationBox: {
                '&:hover': {
                    backgroundColor: theme.palette.grey['500']
                }
            },
            locationName: {
                color: '#fff',
                fontWeight: 'bold',
                cursor: 'pointer',
                textAlign: 'center'
            },
            icon: {
                cursor: 'pointer',
                color: '#fff',
                '&:hover': {
                    color: theme.palette.primary.main
                }
            },
            baseBox: {
                position: 'relative'
            }
        }));
    const classes = useStyles();
    const setEventLocations = (data)=>{
        dispatch($5993246da723f2dd$export$af0d9692e57c37e3({
            count: data.count,
            results: data.results
        }));
    };
    const setMessage = (message)=>{
        dispatch(setMessage(message));
    };
    const sortLocation = ()=>{
        return [
            ...eventLocations?.results || []
        ].sort((a, b)=>(a.name || '').localeCompare(b.name || ''));
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
            sx: {
                margin: downSm ? '0px' : '32px',
                padding: downSm ? '8px' : '32px'
            },
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    variant: "h1",
                    children: "Veranstaltungsorte"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                    variant: "subtitle1"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                    className: classes.locationContainer,
                    children: [
                        sortLocation().map((location, index)=>{
                            const img = new Image();
                            let backgroundSize = 'auto 200px';
                            if (location.imageUrls && location.imageUrls[0]) {
                                img.onload = function() {
                                    const height = img.height;
                                    const width = img.width;
                                    const ratio = width / height;
                                    if (ratio < 1) backgroundSize = '200px auto';
                                };
                                img.src = location.imageUrls && location.imageUrls[0] || '/images/dummyEvent.jpg';
                            }
                            return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                className: classes.locationBox,
                                sx: {
                                    position: 'relative',
                                    backgroundImage: `url("${location.imageUrls && location.imageUrls[0] ? location.imageUrls[0] : '/images/dummyEvent.jpg'}")`,
                                    backgroundSize: backgroundSize
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            setSelectedLocation(location.id);
                                            setShowLocationDialog(true);
                                            setNewLocation(location);
                                            const latLngArray = location.coordinates?.split(',');
                                            latLngArray && latLngArray.length === 2 && setPosition(new (0, $ad5a22b7e45eeb01$exports.LatLng)(latLngArray[0], latLngArray[1]));
                                        },
                                        variant: "body1",
                                        className: classes.locationName,
                                        children: location.name
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            setDeleteLocation(location.id);
                                            setShowLocationDeleteRequestDialog(true);
                                        },
                                        sx: {
                                            position: 'absolute',
                                            top: '5px',
                                            right: '5px',
                                            zIndex: 100
                                        },
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c677c753a54bdfd8$exports))), {
                                            className: classes.icon
                                        })
                                    })
                                ]
                            }, index);
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                            className: `${classes.locationBox} ${classes.newLocationBox}`,
                            sx: {
                                position: 'relative',
                                backgroundColor: theme.palette.grey.A400,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            },
                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    setSelectedLocation('new');
                                    setShowLocationDialog(true);
                                    setNewLocation({
                                        name: ''
                                    });
                                },
                                variant: "body1",
                                className: classes.locationName,
                                children: [
                                    "Neuen",
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                                    "Veranstaltungsort",
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                                    "anlegen"
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $ee30f4276828974b$export$2e2bcd8739ae039), {
                    open: showLocationDialog,
                    onClose: ()=>setShowLocationDialog(false),
                    sx: {
                        '& .MuiDialog-paper': {
                            borderRadius: 0,
                            minWidth: '80%',
                            maxWidth: '80%'
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                            sx: {
                                p: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                    direction: "row",
                                    spacing: 3,
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    className: classes.baseBox,
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $286e44e498de27a0$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontWeight: 600,
                                            p: 0,
                                            fontSize: '16px',
                                            marginBottom: '20px'
                                        },
                                        children: "Veranstaltungsort bearbeiten"
                                    })
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b9097f1d6e2a4efc$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 0,
                                        overflow: 'visible'
                                    },
                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: downMd ? 12 : 6,
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "Name",
                                                    value: selectedLocation && eventLocations?.results.find((elem)=>elem.id === selectedLocation)?.name,
                                                    required: true,
                                                    fullWidth: true,
                                                    onChange: (value)=>{
                                                        const newValue = value || '';
                                                        newLocation && setNewLocation({
                                                            ...newLocation,
                                                            name: newValue
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: downMd ? 12 : 6,
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "Signatur",
                                                    value: selectedLocation && eventLocations?.results.find((elem)=>elem.id === selectedLocation)?.signature,
                                                    required: true,
                                                    fullWidth: true,
                                                    onChange: (value)=>{
                                                        const newValue = value || '';
                                                        newLocation && setNewLocation({
                                                            ...newLocation,
                                                            signature: newValue
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $20c6b651fc290466$export$2e2bcd8739ae039), {
                                                    label: "Beschreibung",
                                                    height: "330px",
                                                    tooltip: "Bitte eine Beschreibung der Location eingeben.",
                                                    value: selectedLocation && eventLocations?.results.find((elem)=>elem.id === selectedLocation)?.description,
                                                    onChange: (value)=>{
                                                        let newValue = value;
                                                        if (newValue === '' || newValue === ' ') newValue = undefined;
                                                        newLocation && setNewLocation({
                                                            ...newLocation,
                                                            description: newValue
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: downMd ? 12 : 6,
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "Linktitel",
                                                    value: selectedLocation && eventLocations?.results.find((elem)=>elem.id === selectedLocation)?.caption,
                                                    fullWidth: true,
                                                    onChange: (value)=>{
                                                        const newValue = value || '';
                                                        newLocation && setNewLocation({
                                                            ...newLocation,
                                                            caption: newValue
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: downMd ? 12 : 6,
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                                                    label: "Linkurl",
                                                    value: selectedLocation && eventLocations?.results.find((elem)=>elem.id === selectedLocation)?.linkUrl,
                                                    fullWidth: true,
                                                    onChange: (value)=>{
                                                        const newValue = value || '';
                                                        newLocation && setNewLocation({
                                                            ...newLocation,
                                                            linkUrl: newValue
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: downMd ? 12 : 6,
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ae5314790b38ab46$export$2e2bcd8739ae039), {
                                                        destination: selectedLocation && eventLocations?.results.find((elem)=>elem.id === selectedLocation)?.name,
                                                        setPosition: (obj)=>{
                                                            setPosition(new (0, $ad5a22b7e45eeb01$exports.LatLng)(obj.lat, obj.long));
                                                            newLocation && setNewLocation({
                                                                ...newLocation,
                                                                coordinates: `${obj.lat},${obj.long}`
                                                            });
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7801af78bc29c2a9$export$2e2bcd8739ae039), {
                                                        mapZoom: 12,
                                                        positions: [
                                                            position
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a48a6bd1d1605299$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: downMd ? 12 : 6,
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $25c2ff9358099864$export$2e2bcd8739ae039), {
                                                    allowVideoUpload: false,
                                                    file: undefined,
                                                    setMediaFile: (file)=>// TODO save file
                                                        file && newLocation && setNewLocation({
                                                            ...newLocation,
                                                            imageUrls: [
                                                                file
                                                            ]
                                                        })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $08e4970efe955928$export$2e2bcd8739ae039), {
                            sx: {
                                p: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    variant: "text",
                                    text: "Verwerfen",
                                    onClick: ()=>{
                                        setShowLocationDialog(false);
                                    }
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    variant: "contained",
                                    text: "Speichern",
                                    onClick: ()=>{
                                        if (selectedLocation === 'new') (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventLocations, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).POST, undefined, {
                                            location: newLocation
                                        }, setEventLocations, setMessage);
                                        else (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventLocations, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).PUT, selectedLocation, {
                                            location: newLocation
                                        }, setEventLocations, setMessage);
                                        setShowLocationDialog(false);
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $ee30f4276828974b$export$2e2bcd8739ae039), {
                    open: showLocationDeleteRequestDialog,
                    onClose: ()=>setShowLocationDeleteRequestDialog(false),
                    sx: {
                        '& .MuiDialog-paper': {
                            borderRadius: 0
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                            sx: {
                                p: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                    direction: "row",
                                    spacing: 3,
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    className: classes.baseBox,
                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $286e44e498de27a0$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontWeight: 600,
                                            p: 0,
                                            fontSize: '16px',
                                            marginBottom: '20px',
                                            display: 'flex',
                                            flexWrap: 'nowrap',
                                            alignItems: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($991ed477abe22d2b$exports))), {
                                                sx: {
                                                    color: theme.palette.warning.main,
                                                    marginRight: '5px'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                variant: "body1",
                                                sx: {
                                                    color: theme.palette.warning.main,
                                                    marginTop: '16px'
                                                },
                                                children: "Veranstaltungsort l\xf6schen"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b9097f1d6e2a4efc$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 0,
                                        overflow: 'visible'
                                    },
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                        variant: "body1",
                                        children: "Wollen Sie den Veranstaltungsort wirklich l\xf6schen? Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden!"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $08e4970efe955928$export$2e2bcd8739ae039), {
                            sx: {
                                p: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    variant: "text",
                                    text: "Abrechen",
                                    onClick: ()=>{
                                        setShowLocationDeleteRequestDialog(false);
                                    }
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    variant: "contained",
                                    text: "L\xf6schen",
                                    onClick: ()=>{
                                        if (deleteLocation) (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventLocations, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).DELETE, deleteLocation, undefined, setEventLocations, setMessage);
                                        setShowLocationDeleteRequestDialog(false);
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $e351b7790ffa46ab$export$2e2bcd8739ae039 = $e351b7790ffa46ab$var$LocationComponent;



var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");







const $b9e02433588c9003$var$ForgotPassword = (props)=>{
    const { token: token } = (0, $4e1a33337564f167$export$99eaa27ddbbb95ef)();
    const theme = (0, $a973137ee63d871f$export$2e2bcd8739ae039)();
    const history = (0, $4e1a33337564f167$export$3420e1dc2c4a518c)();
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const [newPassword, setNewPassword] = (0, $3OyDL.useState)();
    const [confirmPassword, setConfirmPassword] = (0, $3OyDL.useState)();
    const [showHint, setShowHint] = (0, $3OyDL.useState)(false);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $38f1a2d6fcf2073b$export$2e2bcd8739ae039), {
        sx: {
            margin: downSm ? '0px' : '32px',
            padding: downSm ? '8px' : '32px'
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "h1",
                children: "Passwort zur\xfccksetzen"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                variant: "body1",
                children: [
                    "Bitte gib nachfolgend dein neues Passwort ein und wiederhole es.",
                    /*#__PURE__*/ (0, $2M70Q.jsx)("br", {}),
                    "Dein neues Passwort muss:"
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                        children: "mindestens aus 8 Zeichen bestehen,"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                        children: "mindestens einen Buchstaben enthalten,"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                        children: "mindestens eine Zahl enthalten"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                        children: "und mindestens ein Sonderzeichen (@$!%*#?&) enthalten."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                sx: {
                    width: '300px'
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                    helperText: "Das Passwort entspricht nicht den Richtlinien!",
                    showError: showHint,
                    size: "small",
                    type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).password,
                    label: "Neues Passwort",
                    value: newPassword,
                    required: true,
                    onChange: (value)=>setNewPassword(value)
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                sx: {
                    width: '300px'
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b4ce4bf716fba2b0$export$2e2bcd8739ae039), {
                    helperText: "Das wiederholte Passwort stimmt nicht \xfcberein.",
                    showError: !!(newPassword && newPassword !== confirmPassword),
                    size: "small",
                    type: (0, $b4ce4bf716fba2b0$export$f1dd0e7fe1bbaedf).password,
                    label: "Neues Password wiederholen",
                    value: confirmPassword,
                    required: true,
                    onChange: (value)=>setConfirmPassword(value)
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                sx: {
                    width: '300px'
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                    size: "medium",
                    fullWidth: true,
                    disabled: !newPassword || !confirmPassword || newPassword !== confirmPassword,
                    text: "Neues Passwort setzen",
                    onClick: ()=>{
                        // checkPassword
                        if (newPassword?.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/)) {
                            setShowHint(false);
                            const fetchHeaders = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).fetchHeaders;
                            const basePath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
                            const restUrl = `${basePath}/api/session/resetPassword`;
                            fetch(restUrl, {
                                method: 'POST',
                                credentials: 'include',
                                headers: fetchHeaders,
                                body: JSON.stringify({
                                    token: token,
                                    newPassword: newPassword
                                })
                            }).then((res)=>{
                                (0, $7173820326fb9f6c$export$706cdae1b5419ef8)({
                                    message: "Passwort wurde zur\xfcckgesetzt",
                                    severity: (0, $c7fa01100a96d1f7$export$918a9776c0a3cf27).success
                                });
                                setNewPassword(undefined);
                                setConfirmPassword(undefined);
                                history.push('/login');
                            }).catch(()=>{
                                (0, $7173820326fb9f6c$export$706cdae1b5419ef8)({
                                    message: 'Ein unerwarteter Fehler. Bitte erneut versuchen.',
                                    severity: (0, $c7fa01100a96d1f7$export$918a9776c0a3cf27).error
                                });
                            });
                        } else setShowHint(true);
                    }
                })
            })
        ]
    });
};
var $b9e02433588c9003$export$2e2bcd8739ae039 = $b9e02433588c9003$var$ForgotPassword;



var $47cf5ffcc30e4a77$export$2ce376c2cc3355c8 = /*#__PURE__*/ function(MenuItem) {
    MenuItem["family"] = "family";
    MenuItem["events"] = "events";
    MenuItem["gallery"] = "gallery";
    MenuItem["locations"] = "locations";
    MenuItem["familyMember"] = "familyMember";
    MenuItem["statistics"] = "statistics";
    MenuItem["imprint"] = "imprint";
    MenuItem["security"] = "security";
    MenuItem["userProfile"] = "userProfile";
    MenuItem["searchResult"] = "searchResult";
    return MenuItem;
}({});
const $47cf5ffcc30e4a77$var$App = ()=>{
    const { t: t } = (0, $ead5e217b39556c6$export$9fc83ad70ead8663)();
    const history = (0, $4e1a33337564f167$export$3420e1dc2c4a518c)();
    const dispatch = (0, $40700d9745177b04$export$8ad76b76a4c905f8)();
    const user = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$7cbf767827cd68ba));
    const darkMode = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$3813fceac631a2fa));
    const navPoint = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$1759e81b1d90346));
    const redirectPath = (0, $2f56bfc833fc72e6$export$2105062e25df4afe)((0, $09fe4dd5fa74c93e$export$e3e51f7b74509850));
    const [theme, setTheme] = (0, $3OyDL.useState)((0, $76d75229d7c83be5$export$5886efcb490847cc)(darkMode));
    const downSm = (0, $978a5d21e044c57f$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const basePath = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).restBase;
    const fetchHeaders = (0, $19493b1888c07ad7$export$2e2bcd8739ae039).fetchHeaders;
    (0, $58718165e7ed8d4a$export$bacd26fe3052ded6)(fetchHeaders);
    const [token, setToken] = (0, $3OyDL.useState)(null);
    const [showCookieDialog, setShowCookieDialog] = (0, $3OyDL.useState)(false);
    const [showMoreInfo, setShowMoreInfo] = (0, $3OyDL.useState)(false);
    /* const importRelations = () => {
    const mockData = getMockDataRelations()
    const array = []
    mockData.results.map(mock => {
      // children
      mock.children.map(child => {
        const newRelation = {
          notes: undefined,
          relationFrom: undefined,
          relationTo: undefined,
          relationType: child.type,
          parent: mock.id,
          child: child.id,
        }
        // fetchData(basePath, getApiVersion(), fetchHeaders, Entity.relations, Method.POST, undefined, { relation: newRelation }, undefined, setMessage)
      })
      mock.parents.map(parent => {
        const newRelation = {
          notes: undefined,
          relationFrom: undefined,
          relationTo: undefined,
          relationType: parent.type,
          parent: parent.id,
          child: mock.id,
        }
        // fetchData(basePath, getApiVersion(), fetchHeaders, Entity.relations, Method.POST, undefined, { relation: newRelation }, undefined, setMessage)
      })
      mock.spouses.map(spouse => {
        const newRelation = {
          notes: undefined,
          relationFrom: undefined,
          relationTo: undefined,
          relationType: spouse.type,
          parent: mock.id,
          child: spouse.id,
        }
        if (array.findIndex(elem => (elem.parent === mock.id && elem.child === spouse.id) || (elem.parent === spouse.id && elem.child === mock.id)) === -1) {
          array.push(newRelation)
        }
      })
    })
    array.map(obj => {
      // fetchData(basePath, getApiVersion(), fetchHeaders, Entity.relations, Method.POST, undefined, { relation: obj }, undefined, setMessage)
    },
    )
  } */ (0, $3OyDL.useEffect)(()=>{
        const restUrl = `${basePath}/api/session/user`;
        fetch(restUrl, {
            method: 'GET',
            credentials: 'include',
            headers: fetchHeaders
        }).then((res)=>res.json()).then((json)=>{
            !json.error && dispatch((0, $7173820326fb9f6c$export$8b6bb3dd62a01be2)(json));
        }).catch((err)=>console.log(err));
        const pathname = window.location.pathname.split('/');
        if (pathname[1] === 'family') {
            if (pathname[2] === 'ottoMeissner') dispatch($7173820326fb9f6c$export$38eb4755744c35e0('ottoMeissner'));
            if (pathname[2] === 'niederstaucha') dispatch($7173820326fb9f6c$export$3f718a5018550532('niederstaucha'));
        }
    // importRelations()
    }, []);
    (0, $3OyDL.useEffect)(()=>{
        setTheme((0, $76d75229d7c83be5$export$5886efcb490847cc)(darkMode));
    }, [
        darkMode
    ]);
    (0, $3OyDL.useEffect)(()=>{
        const actualPath = history.location.pathname;
        setToken(null);
        let pathname = '/';
        if (actualPath.search('forgotPassword') !== -1) pathname = 'forgotPassword';
        else {
            if (!user) pathname = 'login';
            else if (redirectPath) history.push(redirectPath);
        }
        switch(pathname){
            case 'login':
                history.push('/login');
                break;
            case 'forgotPassword':
                setToken(history.location.pathname.replace('forgotPassword/', '').replace('/', ''));
                break;
            default:
                history.push('/family');
                break;
        }
    }, [
        history,
        user
    ]);
    const settings = [
        {
            title: t(`labels:${"family"}`),
            path: '/family',
            value: "family"
        },
        {
            title: t(`labels:${"familyMember"}`),
            path: '/familyMember',
            value: "familyMember"
        },
        {
            title: t(`labels:${"events"}`),
            path: '/events',
            value: "events"
        }
    ];
    if (user?.userRole !== (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).user) settings.push({
        title: t(`labels:${"locations"}`),
        path: '/locations',
        value: "locations"
    });
    settings.push({
        title: t(`labels:${"statistics"}`),
        path: '/statistics',
        value: "statistics"
    });
    settings.push({
        title: t(`labels:${"gallery"}`),
        path: '/gallery',
        value: "gallery"
    });
    const [message, setMessage] = (0, $3OyDL.useState)();
    const setMemberData = (data)=>{
        const activeMember = data?.results.find((member)=>member.originId === user?.memberId);
        activeMember && dispatch($7173820326fb9f6c$export$c879816e1d08940b(activeMember));
        dispatch($5993246da723f2dd$export$3e5f62cfeebace10({
            count: data.count,
            results: data.results
        }));
    };
    const setRelationData = (data)=>{
        dispatch($5993246da723f2dd$export$b36d0489da17a330({
            count: data.count,
            results: data.results
        }));
    };
    const setEventData = (data)=>{
        dispatch($5993246da723f2dd$export$60e96fb0202719e5({
            count: data.count,
            results: data.results
        }));
    };
    const setEventMemberData = (data)=>{
        dispatch($5993246da723f2dd$export$ad62873327949bc6({
            count: data.count,
            results: data.results
        }));
    };
    const setEventPriceCategoryData = (data)=>{
        dispatch($5993246da723f2dd$export$d70f6b01a5244300({
            count: data.count,
            results: data.results
        }));
    };
    const setEventLocations = (data)=>{
        dispatch($5993246da723f2dd$export$af0d9692e57c37e3({
            count: data.count,
            results: data.results
        }));
    };
    (0, $3OyDL.useEffect)(()=>{
        message && dispatch($7173820326fb9f6c$export$706cdae1b5419ef8(message));
    }, [
        message
    ]);
    (0, $3OyDL.useEffect)(()=>{
        if (user) {
            const isAdmin = user?.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).admin;
            const isJury = user?.userRole === (0, $c7fa01100a96d1f7$export$eb3485a690c2f0b8).jury;
            const permissions = {
                events: [
                    (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read
                ],
                relations: [
                    (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read
                ],
                members: [
                    (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read
                ],
                eventResults: [
                    (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read
                ],
                user: [],
                eventPriceCategories: [
                    (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read
                ],
                eventLocations: [
                    (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read
                ],
                eventMember: [
                    (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read
                ]
            };
            if (isJury) {
                permissions.eventResults.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).update);
                permissions.eventResults.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).delete);
                permissions.eventResults.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).create);
            }
            if (isAdmin) {
                permissions.events.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).update);
                permissions.events.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).delete);
                permissions.events.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).create);
                permissions.members.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).update);
                permissions.members.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).delete);
                permissions.members.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).create);
                permissions.relations.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).update);
                permissions.relations.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).delete);
                permissions.relations.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).create);
                permissions.eventPriceCategories.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).update);
                permissions.eventPriceCategories.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).delete);
                permissions.eventPriceCategories.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).create);
                permissions.eventLocations.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).update);
                permissions.eventLocations.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).delete);
                permissions.eventLocations.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).create);
                permissions.eventResults.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).update);
                permissions.eventResults.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).delete);
                permissions.eventResults.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).create);
                permissions.eventMember.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).update);
                permissions.eventMember.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).delete);
                permissions.eventMember.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).create);
                permissions.user.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).update);
                permissions.user.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).delete);
                permissions.user.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).create);
                permissions.user.push((0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read);
            }
            permissions.members.find((elem)=>elem === (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read) && (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).members, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).GET, undefined, undefined, setMemberData, setMessage);
            permissions.relations.find((elem)=>elem === (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read) && (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).relations, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).GET, undefined, undefined, setRelationData, setMessage);
            permissions.events.find((elem)=>elem === (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read) && (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).events, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).GET, undefined, undefined, setEventData, setMessage);
            permissions.eventMember.find((elem)=>elem === (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read) && (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventMembers, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).GET, undefined, undefined, setEventMemberData, setMessage);
            permissions.eventPriceCategories.find((elem)=>elem === (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read) && (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventPriceCategories, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).GET, undefined, undefined, setEventPriceCategoryData, setMessage);
            permissions.eventLocations.find((elem)=>elem === (0, $c7fa01100a96d1f7$export$af2022a36dc13b47).read) && (0, $eb2357c3a13424e5$export$2e2bcd8739ae039)(basePath, (0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)(), fetchHeaders, (0, $c7fa01100a96d1f7$export$bc644a473284d944).eventLocations, (0, $c7fa01100a96d1f7$export$31bb55db0b3e4187).GET, undefined, undefined, setEventLocations, setMessage);
            dispatch($7173820326fb9f6c$export$a1f268530c5060ed(permissions));
            const restUrl = `${basePath}/api/${(0, $d5fc91037e1fb59a$export$36de249ab5dcbcd5)()}/statistics`;
            fetch(restUrl, {
                method: 'GET',
                credentials: 'include',
                headers: fetchHeaders
            }).then((res)=>res.json()).then((json)=>{
                !json.error && dispatch((0, $5993246da723f2dd$export$822ee8c4fcfb573b)(json));
            }).catch((err)=>console.log(err));
        }
    }, [
        user
    ]);
    const LoginApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $06f2b11196bc0bcc$export$2e2bcd8739ae039), {});
    const DashboardApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $3b5b3d1a00a962e4$export$2e2bcd8739ae039), {});
    const EventApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $80c2b55805160fce$export$2e2bcd8739ae039), {});
    const LocationApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $e351b7790ffa46ab$export$2e2bcd8739ae039), {});
    const GalleryApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $e975925df8bfad2e$export$2e2bcd8739ae039), {});
    const FamilyTreeApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $1afdd3d01d3a8d5a$export$2e2bcd8739ae039), {});
    const FamilyMapApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $eb3d1a4aee4abd5b$export$2e2bcd8739ae039), {});
    const FamilyMemberApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $0ccbc7d1c1bf5013$export$2e2bcd8739ae039), {});
    const FamilyMemberTableApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $0deb024e8c643fd4$export$2e2bcd8739ae039), {});
    const FamilyCalendarApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $85eedd1553a74c10$export$2e2bcd8739ae039), {});
    const StatisticApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $eec6a47b73d638da$export$2e2bcd8739ae039), {});
    const BiographyApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $b46b669b41923313$export$2e2bcd8739ae039), {});
    const GeographyApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $33d18e2f0d017bdf$export$2e2bcd8739ae039), {});
    const SecurityApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $4a1dc75f8bce665a$export$2e2bcd8739ae039), {});
    const ImprintApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $6a201568c54db451$export$2e2bcd8739ae039), {});
    const UserProfileApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $742cedbf5d25d362$export$2e2bcd8739ae039), {});
    const SearchResultApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $248cf301019c705e$export$2e2bcd8739ae039), {});
    const ForgotPasswordApp = ()=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $b9e02433588c9003$export$2e2bcd8739ae039), {});
    const [breadcrumbs, setBreadcrumbs] = (0, $3OyDL.useState)([]);
    const onLogout = ()=>{
        const restUrl = `${basePath}/api/session/logout`;
        fetch(restUrl, {
            method: 'POST',
            credentials: 'include',
            headers: fetchHeaders
        }).then(()=>dispatch((0, $7173820326fb9f6c$export$8b6bb3dd62a01be2)(undefined))).catch((err)=>console.log(err));
    };
    (0, $3OyDL.useEffect)(()=>{
        const array = [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                sx: {
                    cursor: 'pointer'
                },
                underline: "hover",
                color: theme.palette.primary.main,
                onClick: ()=>{
                    history.replace('/');
                    dispatch($7173820326fb9f6c$export$8f827b63222d82c5([]));
                },
                children: "Startseite"
            }, "dashboard")
        ];
        navPoint[0] && navPoint[1] && array.push(/*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
            sx: {
                cursor: 'pointer'
            },
            underline: "hover",
            color: theme.palette.primary.main,
            onClick: ()=>{
                history.replace(`/${navPoint[0]}`);
                dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
                    navPoint[0]
                ]));
            },
            children: t(`labels:${navPoint[0]}`)
        }, navPoint[0]));
        navPoint[0] && !navPoint[1] && array.push(/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
            color: "text.primary",
            sx: {
                fontSize: '16px'
            },
            children: t(`labels:${navPoint[0]}`)
        }, "3"));
        navPoint[1] && array.push(/*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
            color: "text.primary",
            sx: {
                fontSize: '16px'
            },
            children: t(`labels:${navPoint[1]}`)
        }, "3"));
        setBreadcrumbs(array);
    }, [
        navPoint
    ]);
    const changeSearchInput = (value)=>{
        const actualPath = history.location.pathname;
        value && actualPath !== '/searchResults' && history.push('/searchResults');
        dispatch($7173820326fb9f6c$export$5cbff2416b95c79c(value));
        dispatch($7173820326fb9f6c$export$8f827b63222d82c5([]));
    };
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2M70Q.Fragment), {
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $ead356dc16e3cc23$export$2e2bcd8739ae039), {
            theme: theme,
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9a68738520314e8a$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $4e1a33337564f167$export$b5d5cf8927ab7262), {
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                            path: "/forgotPassword/:token?",
                            component: ForgotPasswordApp
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                            path: "/login",
                            component: LoginApp
                        }),
                        user && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $22eed9cacb4508d6$export$2e2bcd8739ae039), {
                                    items: settings,
                                    onLogout: onLogout,
                                    changeSearch: (value)=>changeSearchInput(value)
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                    sx: {
                                        height: '100%',
                                        width: '100%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ecd6c8d84b4b7e2d$export$2e2bcd8739ae039), {
                                            maxItems: downSm ? 2 : 10,
                                            sx: {
                                                fontSize: '16px',
                                                padding: downSm ? '30px 8px 0 8px' : '30px 32px 0 32px'
                                            },
                                            separator: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ee1843d167ed9f75$exports))), {
                                                fontSize: "small"
                                            }),
                                            "aria-label": "breadcrumb",
                                            children: breadcrumbs
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/",
                                            component: DashboardApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/family",
                                            component: DashboardApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/family/niederstaucha",
                                            component: GeographyApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/family/leipzig",
                                            component: GeographyApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/family/ottoMeissner",
                                            component: BiographyApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/gallery",
                                            component: GalleryApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/events",
                                            component: EventApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/locations",
                                            component: LocationApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/statistics",
                                            component: StatisticApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/familyMember",
                                            component: FamilyMemberApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/familyMember/table",
                                            component: FamilyMemberTableApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/familyMember/calendar",
                                            component: FamilyCalendarApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/familyMember/tree",
                                            component: FamilyTreeApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/familyMember/maAp",
                                            component: FamilyMapApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/searchResults",
                                            component: SearchResultApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/userProfile",
                                            component: UserProfileApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/imprint",
                                            component: ImprintApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e1a33337564f167$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/security",
                                            component: SecurityApp
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e0c639b53d4cb03b$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                            onClick: ()=>setShowCookieDialog(true),
                                            sx: {
                                                position: 'fixed',
                                                bottom: 20,
                                                left: 20,
                                                backgroundColor: theme.palette.primary.dark,
                                                opacity: 0.8,
                                                borderRadius: 50,
                                                height: 50,
                                                width: 50,
                                                cursor: 'pointer'
                                            },
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d8698a584d579689$exports))), {
                                                sx: {
                                                    color: '#fff',
                                                    width: 30,
                                                    height: 30,
                                                    margin: '10px'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $ee30f4276828974b$export$2e2bcd8739ae039), {
                                            open: showCookieDialog,
                                            onClose: ()=>{
                                                setShowMoreInfo(false);
                                                setShowCookieDialog(false);
                                            },
                                            sx: {
                                                '& .MuiDialog-paper': {
                                                    borderRadius: 0,
                                                    maxWidth: '80%'
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $286e44e498de27a0$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                        variant: "h2",
                                                        children: "Wir nutzen Cookies und andere Technologien."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $b9097f1d6e2a4efc$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                            variant: "body1",
                                                            children: "Diese Website nutzt Cookies und vergleichbare Funktionen zur Verarbeitung von Endger\xe4teinformationen und personenbezogenen Daten. Die Verarbeitung dient der Einbindung von Inhalten, externen Diensten und Elementen Dritter, der statistischen Analyse/Messung, der personalisierten Werbung oder des Remarketings sowie der Einbindung sozialer Medien. Je nach Funktion werden dabei Daten an Dritte weitergegeben innerhalb der EU. Ihre Einwilligung ist stets freiwillig, f\xfcr die Nutzung unserer Website nicht erforderlich und kann jederzeit \xfcber das Icon unten links abgelehnt oder widerrufen werden."
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                margin: '20px 0'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        width: '30%'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                                                        fullWidth: true,
                                                                        size: "large",
                                                                        text: "Abbrechen",
                                                                        onClick: ()=>{
                                                                            setShowMoreInfo(false);
                                                                            setShowCookieDialog(false);
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        width: '30%'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                                                        fullWidth: true,
                                                                        size: "large",
                                                                        text: "Informationen",
                                                                        onClick: ()=>setShowMoreInfo(!showMoreInfo)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        width: '30%'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $959f967bf942d924$export$2e2bcd8739ae039), {
                                                                        fullWidth: true,
                                                                        size: "large",
                                                                        text: "Akzeptieren",
                                                                        onClick: ()=>{
                                                                            setShowMoreInfo(false);
                                                                            setShowCookieDialog(false);
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                display: showMoreInfo ? 'block' : 'none'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        width: '100%',
                                                                        display: 'flex'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                                                            marginTop: "3px",
                                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                                value: true,
                                                                                disabled: true
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                                    sx: {
                                                                                        display: 'flex',
                                                                                        justifyContent: 'flex-start',
                                                                                        alignItems: 'center'
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                                            variant: "subtitle1",
                                                                                            children: "Essentiell (3)"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a0c8194f99ad3309$export$2e2bcd8739ae039), {
                                                                                            title: "hallo",
                                                                                            placement: "right",
                                                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3ed52aa8e90b7939$exports))), {})
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                                    variant: "body1",
                                                                                    children: "Hier sind alle technisch notwendigen Skripte, Cookies und sonstige Elemente zu finden die f\xfcr den Betrieb der Webseite notwendig sind oder der Betreiber ein berechtiges Interesse nach DSGVO Art6, Abs. 1 hat."
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        width: '100%',
                                                                        display: 'flex'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                                                            marginTop: "3px",
                                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                                value: true
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                                    sx: {
                                                                                        display: 'flex',
                                                                                        justifyContent: 'flex-start',
                                                                                        alignItems: 'center'
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                                            variant: "subtitle1",
                                                                                            children: "Funktionell (1)"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a0c8194f99ad3309$export$2e2bcd8739ae039), {
                                                                                            title: "hallo",
                                                                                            placement: "right",
                                                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3ed52aa8e90b7939$exports))), {})
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                                    variant: "body1",
                                                                                    children: "Hier sind alle technisch notwendigen Skripte, Cookies und sonstige Elemente zu finden die f\xfcr den Betrieb der Webseite notwendig sind oder der Betreiber ein berechtiges Interesse nach DSGVO Art6, Abs. 1 hat."
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        width: '100%',
                                                                        display: 'flex'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                                                            marginTop: "3px",
                                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052636c3663f28c2$export$2e2bcd8739ae039), {
                                                                                value: true
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $1733cc38690c208f$export$2e2bcd8739ae039), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2daf4a960b0a0c38$export$2e2bcd8739ae039), {
                                                                                    sx: {
                                                                                        display: 'flex',
                                                                                        justifyContent: 'flex-start',
                                                                                        alignItems: 'center'
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                                            variant: "subtitle1",
                                                                                            children: "Personalisierung (2)"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a0c8194f99ad3309$export$2e2bcd8739ae039), {
                                                                                            title: "hallo",
                                                                                            placement: "right",
                                                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $90c0807a34b52605$export$2e2bcd8739ae039), {
                                                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3ed52aa8e90b7939$exports))), {})
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                                                    variant: "body1",
                                                                                    children: "Um die Webseite besser auf Sie abzustimmen laufen hier Skripte und es werden Cookies gesetzt. Ziel ist eine bessere Nutzererfahrung f\xfcr Sie."
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $c015ac4126046deb$export$2e2bcd8739ae039), {
                                                            variant: "body1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        cursor: 'pointer'
                                                                    },
                                                                    underline: "hover",
                                                                    color: theme.palette.primary.main,
                                                                    onClick: ()=>{
                                                                        setShowCookieDialog(false);
                                                                        setShowMoreInfo(false);
                                                                        history.replace('/imprint');
                                                                        dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
                                                                            'imprint'
                                                                        ]));
                                                                    },
                                                                    children: "Impressum"
                                                                }, "imprint"),
                                                                "\xa0\xa0\xa0\xa0",
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f7f3118c741d399b$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        cursor: 'pointer'
                                                                    },
                                                                    underline: "hover",
                                                                    color: theme.palette.primary.main,
                                                                    onClick: ()=>{
                                                                        setShowCookieDialog(false);
                                                                        setShowMoreInfo(false);
                                                                        history.replace('/security');
                                                                        dispatch($7173820326fb9f6c$export$8f827b63222d82c5([
                                                                            'security'
                                                                        ]));
                                                                    },
                                                                    children: "Datenschutzerkl\xe4rung"
                                                                }, "security")
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $fa47515f33a4af6c$export$2e2bcd8739ae039), {})
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $47cf5ffcc30e4a77$export$2e2bcd8739ae039 = $47cf5ffcc30e4a77$var$App;



var $1898cbf7b376a91b$exports = {};
"use strict";
var $1898cbf7b376a91b$var$__assign = $1898cbf7b376a91b$exports && $1898cbf7b376a91b$exports.__assign || function() {
    $1898cbf7b376a91b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1898cbf7b376a91b$var$__assign.apply(this, arguments);
};
Object.defineProperty($1898cbf7b376a91b$exports, "__esModule", {
    value: true
});
function $1898cbf7b376a91b$var$reducerWithInitialState(initialState) {
    return $1898cbf7b376a91b$var$makeReducer(initialState);
}
$1898cbf7b376a91b$exports.reducerWithInitialState = $1898cbf7b376a91b$var$reducerWithInitialState;
function $1898cbf7b376a91b$var$reducerWithoutInitialState() {
    return $1898cbf7b376a91b$var$makeReducer();
}
$1898cbf7b376a91b$exports.reducerWithoutInitialState = $1898cbf7b376a91b$var$reducerWithoutInitialState;
function $1898cbf7b376a91b$var$upcastingReducer() {
    return $1898cbf7b376a91b$var$makeReducer();
}
$1898cbf7b376a91b$exports.upcastingReducer = $1898cbf7b376a91b$var$upcastingReducer;
function $1898cbf7b376a91b$var$makeReducer(initialState) {
    var handlersByActionType = {};
    var reducer = $1898cbf7b376a91b$var$getReducerFunction(initialState, handlersByActionType);
    reducer.caseWithAction = function(actionCreator, handler) {
        handlersByActionType[actionCreator.type] = handler;
        return reducer;
    };
    reducer.case = function(actionCreator, handler) {
        return reducer.caseWithAction(actionCreator, function(state, action) {
            return handler(state, action.payload);
        });
    };
    reducer.casesWithAction = function(actionCreators, handler) {
        for(var _i = 0, actionCreators_1 = actionCreators; _i < actionCreators_1.length; _i++){
            var actionCreator = actionCreators_1[_i];
            reducer.caseWithAction(actionCreator, handler);
        }
        return reducer;
    };
    reducer.cases = function(actionCreators, handler) {
        return reducer.casesWithAction(actionCreators, function(state, action) {
            return handler(state, action.payload);
        });
    };
    reducer.withHandling = function(updateBuilder) {
        return updateBuilder(reducer);
    };
    reducer.default = function(defaultHandler) {
        return $1898cbf7b376a91b$var$getReducerFunction(initialState, $1898cbf7b376a91b$var$__assign({}, handlersByActionType), defaultHandler);
    };
    reducer.build = function() {
        return $1898cbf7b376a91b$var$getReducerFunction(initialState, $1898cbf7b376a91b$var$__assign({}, handlersByActionType));
    };
    return reducer;
}
function $1898cbf7b376a91b$var$getReducerFunction(initialState, handlersByActionType, defaultHandler) {
    return function(passedState, action) {
        var state = passedState !== undefined ? passedState : initialState;
        var handler = handlersByActionType[action.type] || defaultHandler;
        return handler ? handler(state, action) : state;
    };
}




const $b7e91d5b3dc99ee5$var$initialDarkMode = localStorage.getItem('darkMode') === 'true';
const $b7e91d5b3dc99ee5$var$INITIAL_SETTINGS_STATE = {
    prefersDarkMode: $b7e91d5b3dc99ee5$var$initialDarkMode,
    theme: (0, $76d75229d7c83be5$export$5886efcb490847cc)($b7e91d5b3dc99ee5$var$initialDarkMode),
    navPoint: window.location.href.replace(`${window.location.origin}/`, '').split('/'),
    userPermissions: {
        events: [],
        members: [],
        eventResults: [],
        user: [],
        eventLocations: [],
        eventMember: [],
        relations: [],
        eventPriceCategories: []
    }
};
const $b7e91d5b3dc99ee5$export$e990be4b7286453e = (0, $1898cbf7b376a91b$exports.reducerWithInitialState)($b7e91d5b3dc99ee5$var$INITIAL_SETTINGS_STATE).case((0, $7173820326fb9f6c$export$f371be8ef3fc4263), (state, prefersDarkMode)=>{
    return {
        ...state,
        prefersDarkMode: prefersDarkMode
    };
}).case((0, $7173820326fb9f6c$export$2e49b867b7a0847c), (state, theme)=>{
    return {
        ...state,
        theme: theme
    };
}).case((0, $7173820326fb9f6c$export$706cdae1b5419ef8), (state, message)=>{
    return {
        ...state,
        message: message
    };
}).case((0, $7173820326fb9f6c$export$5cbff2416b95c79c), (state, searchInput)=>{
    return {
        ...state,
        searchInput: searchInput
    };
}).case((0, $7173820326fb9f6c$export$a1f268530c5060ed), (state, userPermissions)=>{
    return {
        ...state,
        userPermissions: userPermissions
    };
}).case((0, $7173820326fb9f6c$export$8f827b63222d82c5), (state, navPoint)=>{
    return {
        ...state,
        navPoint: navPoint
    };
}).case((0, $7173820326fb9f6c$export$38eb4755744c35e0), (state, biography)=>{
    return {
        ...state,
        biography: biography
    };
}).case((0, $7173820326fb9f6c$export$3f718a5018550532), (state, geography)=>{
    return {
        ...state,
        geography: geography
    };
}).case((0, $7173820326fb9f6c$export$8b6bb3dd62a01be2), (state, user)=>{
    return {
        ...state,
        user: user
    };
}).case((0, $7173820326fb9f6c$export$c879816e1d08940b), (state, activeMember)=>{
    return {
        ...state,
        activeMember: activeMember
    };
}).case((0, $7173820326fb9f6c$export$5fe35dca4873f8c4), (state, redirectPath)=>{
    return {
        ...state,
        redirectPath: redirectPath
    };
});




const $71277a962c652a82$var$INITIAL_DATA_STATE = {
    // statistics: getMockDataStatistics(),
    eventResults: {}
};
const $71277a962c652a82$export$bf88e4eb61addc81 = (0, $1898cbf7b376a91b$exports.reducerWithInitialState)($71277a962c652a82$var$INITIAL_DATA_STATE).case((0, $5993246da723f2dd$export$3e5f62cfeebace10), (state, member)=>{
    return {
        ...state,
        member: member
    };
}).case((0, $5993246da723f2dd$export$b36d0489da17a330), (state, relations)=>{
    return {
        ...state,
        relations: relations
    };
}).case((0, $5993246da723f2dd$export$822ee8c4fcfb573b), (state, statistics)=>{
    return {
        ...state,
        statistics: statistics
    };
}).case((0, $5993246da723f2dd$export$60e96fb0202719e5), (state, events)=>{
    // sortieren nach Jahr
    const sortedEvents = {
        ...events
    };
    sortedEvents.results.sort((a, b)=>{
        const yearA = a.eventFrom?.year;
        const yearB = b.eventFrom?.year;
        if (yearA && yearB && yearA > yearB) return -1;
        if (yearA && yearB && yearA < yearB) return 1;
        return 0;
    });
    return {
        ...state,
        events: events
    };
}).case((0, $5993246da723f2dd$export$ad62873327949bc6), (state, eventMember)=>{
    return {
        ...state,
        eventMember: eventMember
    };
}).case((0, $5993246da723f2dd$export$d70f6b01a5244300), (state, eventPriceCategories)=>{
    return {
        ...state,
        eventPriceCategories: eventPriceCategories
    };
}).case((0, $5993246da723f2dd$export$af0d9692e57c37e3), (state, eventLocations)=>{
    return {
        ...state,
        eventLocations: eventLocations
    };
}).case((0, $5993246da723f2dd$export$32f26ecd1d16cf), (state, eventResults)=>{
    return {
        ...state,
        eventResults: eventResults
    };
}).case((0, $5993246da723f2dd$export$822ee8c4fcfb573b), (state, statistics)=>{
    return {
        ...state,
        statistics: statistics
    };
});


const $cfb6375ed66cb7cd$export$a8a69c316169e623 = (0, $46555720e4c9b283$export$66e4520cdb265d18)({
    settingsStore: (0, $b7e91d5b3dc99ee5$export$e990be4b7286453e),
    dataStore: (0, $71277a962c652a82$export$bf88e4eb61addc81)
});


window.React = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL)));
const $eb9218dbf3a73cb2$var$store = (0, $46555720e4c9b283$export$f51a9068ac82ea43)((0, $cfb6375ed66cb7cd$export$a8a69c316169e623));
function $eb9218dbf3a73cb2$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $248d245009f22637$export$2e2bcd8739ae039), {
        store: $eb9218dbf3a73cb2$var$store,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bd8e9bc1f452c97a$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $47cf5ffcc30e4a77$export$2e2bcd8739ae039), {})
        })
    });
}
(0, (/*@__PURE__*/$parcel$interopDefault($dy6Cj))).render(/*#__PURE__*/ (0, $2M70Q.jsx)($eb9218dbf3a73cb2$export$2e2bcd8739ae039, {}), window.document.getElementById('root'));


//# sourceMappingURL=app.d2398653.js.map
